var Hy = Object.defineProperty;
var zy = (e, l, n) => l in e ? Hy(e, l, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[l] = n;
var S = (e, l, n) => (zy(e, typeof l != "symbol" ? l + "" : l, n), n);
import { pushScopeId as Vy, popScopeId as jy, defineComponent as K, nextTick as rl, openBlock as y, createBlock as L, createElementBlock as O, normalizeClass as z, renderSlot as V, normalizeProps as Rl, guardReactiveProps as jl, withScopeId as Uy, resolveComponent as Bl, normalizeStyle as Wl, withKeys as Fn, createElementVNode as A, Fragment as hl, createCommentVNode as I, mergeProps as ml, withCtx as U, createVNode as R, ref as J, createApp as Wy, h as ye, toDisplayString as B, reactive as fl, isRef as Gy, unref as c, isReactive as Ky, toRaw as Yy, inject as Tn, computed as wu, provide as De, watch as Pl, getCurrentInstance as Wg, onBeforeMount as qy, onMounted as xi, onBeforeUpdate as Jy, onUpdated as Zy, onUnmounted as Ao, useAttrs as Xy, createStaticVNode as Ps, watchEffect as xo, Transition as Gg, withDirectives as vl, vShow as cn, withModifiers as kl, render as fi, Teleport as Wp, resolveDynamicComponent as Vn, resolveDirective as Ei, useSlots as Bs, renderList as Sl, createTextVNode as $l, defineAsyncComponent as hu, vModelDynamic as Kg, vModelText as cs, TransitionGroup as Yg, onBeforeUnmount as Eo, shallowRef as Qy, markRaw as l5, customRef as n5, createSlots as e5, vModelRadio as t5, vModelCheckbox as u5 } from "vue";
const i5 = ["top", "right", "bottom", "left"], M1 = ["start", "end"], A1 = /* @__PURE__ */ i5.reduce((e, l) => e.concat(l, l + "-" + M1[0], l + "-" + M1[1]), []), hs = Math.min, gu = Math.max, s5 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, r5 = {
  start: "end",
  end: "start"
};
function kc(e, l, n) {
  return gu(e, hs(l, n));
}
function zu(e, l) {
  return typeof e == "function" ? e(l) : e;
}
function ht(e) {
  return e.split("-")[0];
}
function Ne(e) {
  return e.split("-")[1];
}
function qg(e) {
  return e === "x" ? "y" : "x";
}
function Gp(e) {
  return e === "y" ? "height" : "width";
}
function Fs(e) {
  return ["top", "bottom"].includes(ht(e)) ? "y" : "x";
}
function Kp(e) {
  return qg(Fs(e));
}
function Jg(e, l, n) {
  n === void 0 && (n = !1);
  const t = Ne(e), u = Kp(e), i = Gp(u);
  let s = u === "x" ? t === (n ? "end" : "start") ? "right" : "left" : t === "start" ? "bottom" : "top";
  return l.reference[i] > l.floating[i] && (s = Or(s)), [s, Or(s)];
}
function o5(e) {
  const l = Or(e);
  return [Tr(e), l, Tr(l)];
}
function Tr(e) {
  return e.replace(/start|end/g, (l) => r5[l]);
}
function a5(e, l, n) {
  const t = ["left", "right"], u = ["right", "left"], i = ["top", "bottom"], s = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? l ? u : t : l ? t : u;
    case "left":
    case "right":
      return l ? i : s;
    default:
      return [];
  }
}
function d5(e, l, n, t) {
  const u = Ne(e);
  let i = a5(ht(e), n === "start", t);
  return u && (i = i.map((s) => s + "-" + u), l && (i = i.concat(i.map(Tr)))), i;
}
function Or(e) {
  return e.replace(/left|right|bottom|top/g, (l) => s5[l]);
}
function c5(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Zg(e) {
  return typeof e != "number" ? c5(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Wi(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function x1(e, l, n) {
  let {
    reference: t,
    floating: u
  } = e;
  const i = Fs(l), s = Kp(l), r = Gp(s), o = ht(l), a = i === "y", d = t.x + t.width / 2 - u.width / 2, h = t.y + t.height / 2 - u.height / 2, p = t[r] / 2 - u[r] / 2;
  let f;
  switch (o) {
    case "top":
      f = {
        x: d,
        y: t.y - u.height
      };
      break;
    case "bottom":
      f = {
        x: d,
        y: t.y + t.height
      };
      break;
    case "right":
      f = {
        x: t.x + t.width,
        y: h
      };
      break;
    case "left":
      f = {
        x: t.x - u.width,
        y: h
      };
      break;
    default:
      f = {
        x: t.x,
        y: t.y
      };
  }
  switch (Ne(l)) {
    case "start":
      f[s] -= p * (n && a ? -1 : 1);
      break;
    case "end":
      f[s] += p * (n && a ? -1 : 1);
      break;
  }
  return f;
}
const h5 = async (e, l, n) => {
  const {
    placement: t = "bottom",
    strategy: u = "absolute",
    middleware: i = [],
    platform: s
  } = n, r = i.filter(Boolean), o = await (s.isRTL == null ? void 0 : s.isRTL(l));
  let a = await s.getElementRects({
    reference: e,
    floating: l,
    strategy: u
  }), {
    x: d,
    y: h
  } = x1(a, t, o), p = t, f = {}, m = 0;
  for (let g = 0; g < r.length; g++) {
    const {
      name: v,
      fn: w
    } = r[g], {
      x: $,
      y: _,
      data: b,
      reset: k
    } = await w({
      x: d,
      y: h,
      initialPlacement: t,
      placement: p,
      strategy: u,
      middlewareData: f,
      rects: a,
      platform: s,
      elements: {
        reference: e,
        floating: l
      }
    });
    d = $ ?? d, h = _ ?? h, f = {
      ...f,
      [v]: {
        ...f[v],
        ...b
      }
    }, k && m <= 50 && (m++, typeof k == "object" && (k.placement && (p = k.placement), k.rects && (a = k.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: l,
      strategy: u
    }) : k.rects), {
      x: d,
      y: h
    } = x1(a, p, o)), g = -1);
  }
  return {
    x: d,
    y: h,
    placement: p,
    strategy: u,
    middlewareData: f
  };
};
async function Io(e, l) {
  var n;
  l === void 0 && (l = {});
  const {
    x: t,
    y: u,
    platform: i,
    rects: s,
    elements: r,
    strategy: o
  } = e, {
    boundary: a = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: h = "floating",
    altBoundary: p = !1,
    padding: f = 0
  } = zu(l, e), m = Zg(f), v = r[p ? h === "floating" ? "reference" : "floating" : h], w = Wi(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(v))) == null || n ? v : v.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(r.floating)),
    boundary: a,
    rootBoundary: d,
    strategy: o
  })), $ = h === "floating" ? {
    ...s.floating,
    x: t,
    y: u
  } : s.reference, _ = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(r.floating)), b = await (i.isElement == null ? void 0 : i.isElement(_)) ? await (i.getScale == null ? void 0 : i.getScale(_)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, k = Wi(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: r,
    rect: $,
    offsetParent: _,
    strategy: o
  }) : $);
  return {
    top: (w.top - k.top + m.top) / b.y,
    bottom: (k.bottom - w.bottom + m.bottom) / b.y,
    left: (w.left - k.left + m.left) / b.x,
    right: (k.right - w.right + m.right) / b.x
  };
}
const Xg = (e) => ({
  name: "arrow",
  options: e,
  async fn(l) {
    const {
      x: n,
      y: t,
      placement: u,
      rects: i,
      platform: s,
      elements: r,
      middlewareData: o
    } = l, {
      element: a,
      padding: d = 0
    } = zu(e, l) || {};
    if (a == null)
      return {};
    const h = Zg(d), p = {
      x: n,
      y: t
    }, f = Kp(u), m = Gp(f), g = await s.getDimensions(a), v = f === "y", w = v ? "top" : "left", $ = v ? "bottom" : "right", _ = v ? "clientHeight" : "clientWidth", b = i.reference[m] + i.reference[f] - p[f] - i.floating[m], k = p[f] - i.reference[f], T = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(a));
    let M = T ? T[_] : 0;
    (!M || !await (s.isElement == null ? void 0 : s.isElement(T))) && (M = r.floating[_] || i.floating[m]);
    const H = b / 2 - k / 2, x = M / 2 - g[m] / 2 - 1, P = hs(h[w], x), Z = hs(h[$], x), F = P, el = M - g[m] - Z, al = M / 2 - g[m] / 2 + H, ll = kc(F, al, el), Y = !o.arrow && Ne(u) != null && al !== ll && i.reference[m] / 2 - (al < F ? P : Z) - g[m] / 2 < 0, Q = Y ? al < F ? al - F : al - el : 0;
    return {
      [f]: p[f] + Q,
      data: {
        [f]: ll,
        centerOffset: al - ll - Q,
        ...Y && {
          alignmentOffset: Q
        }
      },
      reset: Y
    };
  }
});
function p5(e, l, n) {
  return (e ? [...n.filter((u) => Ne(u) === e), ...n.filter((u) => Ne(u) !== e)] : n.filter((u) => ht(u) === u)).filter((u) => e ? Ne(u) === e || (l ? Tr(u) !== u : !1) : !0);
}
const Qg = function(e) {
  return e === void 0 && (e = {}), {
    name: "autoPlacement",
    options: e,
    async fn(l) {
      var n, t, u;
      const {
        rects: i,
        middlewareData: s,
        placement: r,
        platform: o,
        elements: a
      } = l, {
        crossAxis: d = !1,
        alignment: h,
        allowedPlacements: p = A1,
        autoAlignment: f = !0,
        ...m
      } = zu(e, l), g = h !== void 0 || p === A1 ? p5(h || null, f, p) : p, v = await Io(l, m), w = ((n = s.autoPlacement) == null ? void 0 : n.index) || 0, $ = g[w];
      if ($ == null)
        return {};
      const _ = Jg($, i, await (o.isRTL == null ? void 0 : o.isRTL(a.floating)));
      if (r !== $)
        return {
          reset: {
            placement: g[0]
          }
        };
      const b = [v[ht($)], v[_[0]], v[_[1]]], k = [...((t = s.autoPlacement) == null ? void 0 : t.overflows) || [], {
        placement: $,
        overflows: b
      }], T = g[w + 1];
      if (T)
        return {
          data: {
            index: w + 1,
            overflows: k
          },
          reset: {
            placement: T
          }
        };
      const M = k.map((P) => {
        const Z = Ne(P.placement);
        return [P.placement, Z && d ? (
          // Check along the mainAxis and main crossAxis side.
          P.overflows.slice(0, 2).reduce((F, el) => F + el, 0)
        ) : (
          // Check only the mainAxis.
          P.overflows[0]
        ), P.overflows];
      }).sort((P, Z) => P[1] - Z[1]), x = ((u = M.filter((P) => P[2].slice(
        0,
        // Aligned placements should not check their opposite crossAxis
        // side.
        Ne(P[0]) ? 2 : 3
      ).every((Z) => Z <= 0))[0]) == null ? void 0 : u[0]) || M[0][0];
      return x !== r ? {
        data: {
          index: w + 1,
          overflows: k
        },
        reset: {
          placement: x
        }
      } : {};
    }
  };
}, f5 = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(l) {
      var n, t;
      const {
        placement: u,
        middlewareData: i,
        rects: s,
        initialPlacement: r,
        platform: o,
        elements: a
      } = l, {
        mainAxis: d = !0,
        crossAxis: h = !0,
        fallbackPlacements: p,
        fallbackStrategy: f = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: g = !0,
        ...v
      } = zu(e, l);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const w = ht(u), $ = ht(r) === r, _ = await (o.isRTL == null ? void 0 : o.isRTL(a.floating)), b = p || ($ || !g ? [Or(r)] : o5(r));
      !p && m !== "none" && b.push(...d5(r, g, m, _));
      const k = [r, ...b], T = await Io(l, v), M = [];
      let H = ((t = i.flip) == null ? void 0 : t.overflows) || [];
      if (d && M.push(T[w]), h) {
        const F = Jg(u, s, _);
        M.push(T[F[0]], T[F[1]]);
      }
      if (H = [...H, {
        placement: u,
        overflows: M
      }], !M.every((F) => F <= 0)) {
        var x, P;
        const F = (((x = i.flip) == null ? void 0 : x.index) || 0) + 1, el = k[F];
        if (el)
          return {
            data: {
              index: F,
              overflows: H
            },
            reset: {
              placement: el
            }
          };
        let al = (P = H.filter((ll) => ll.overflows[0] <= 0).sort((ll, Y) => ll.overflows[1] - Y.overflows[1])[0]) == null ? void 0 : P.placement;
        if (!al)
          switch (f) {
            case "bestFit": {
              var Z;
              const ll = (Z = H.map((Y) => [Y.placement, Y.overflows.filter((Q) => Q > 0).reduce((Q, dl) => Q + dl, 0)]).sort((Y, Q) => Y[1] - Q[1])[0]) == null ? void 0 : Z[0];
              ll && (al = ll);
              break;
            }
            case "initialPlacement":
              al = r;
              break;
          }
        if (u !== al)
          return {
            reset: {
              placement: al
            }
          };
      }
      return {};
    }
  };
};
async function m5(e, l) {
  const {
    placement: n,
    platform: t,
    elements: u
  } = e, i = await (t.isRTL == null ? void 0 : t.isRTL(u.floating)), s = ht(n), r = Ne(n), o = Fs(n) === "y", a = ["left", "top"].includes(s) ? -1 : 1, d = i && o ? -1 : 1, h = zu(l, e);
  let {
    mainAxis: p,
    crossAxis: f,
    alignmentAxis: m
  } = typeof h == "number" ? {
    mainAxis: h,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...h
  };
  return r && typeof m == "number" && (f = r === "end" ? m * -1 : m), o ? {
    x: f * d,
    y: p * a
  } : {
    x: p * a,
    y: f * d
  };
}
const l2 = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(l) {
      var n, t;
      const {
        x: u,
        y: i,
        placement: s,
        middlewareData: r
      } = l, o = await m5(l, e);
      return s === ((n = r.offset) == null ? void 0 : n.placement) && (t = r.arrow) != null && t.alignmentOffset ? {} : {
        x: u + o.x,
        y: i + o.y,
        data: {
          ...o,
          placement: s
        }
      };
    }
  };
}, n2 = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(l) {
      const {
        x: n,
        y: t,
        placement: u
      } = l, {
        mainAxis: i = !0,
        crossAxis: s = !1,
        limiter: r = {
          fn: (v) => {
            let {
              x: w,
              y: $
            } = v;
            return {
              x: w,
              y: $
            };
          }
        },
        ...o
      } = zu(e, l), a = {
        x: n,
        y: t
      }, d = await Io(l, o), h = Fs(ht(u)), p = qg(h);
      let f = a[p], m = a[h];
      if (i) {
        const v = p === "y" ? "top" : "left", w = p === "y" ? "bottom" : "right", $ = f + d[v], _ = f - d[w];
        f = kc($, f, _);
      }
      if (s) {
        const v = h === "y" ? "top" : "left", w = h === "y" ? "bottom" : "right", $ = m + d[v], _ = m - d[w];
        m = kc($, m, _);
      }
      const g = r.fn({
        ...l,
        [p]: f,
        [h]: m
      });
      return {
        ...g,
        data: {
          x: g.x - n,
          y: g.y - t
        }
      };
    }
  };
}, g5 = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(l) {
      const {
        placement: n,
        rects: t,
        platform: u,
        elements: i
      } = l, {
        apply: s = () => {
        },
        ...r
      } = zu(e, l), o = await Io(l, r), a = ht(n), d = Ne(n), h = Fs(n) === "y", {
        width: p,
        height: f
      } = t.floating;
      let m, g;
      a === "top" || a === "bottom" ? (m = a, g = d === (await (u.isRTL == null ? void 0 : u.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (g = a, m = d === "end" ? "top" : "bottom");
      const v = f - o[m], w = p - o[g], $ = !l.middlewareData.shift;
      let _ = v, b = w;
      if (h) {
        const T = p - o.left - o.right;
        b = d || $ ? hs(w, T) : T;
      } else {
        const T = f - o.top - o.bottom;
        _ = d || $ ? hs(v, T) : T;
      }
      if ($ && !d) {
        const T = gu(o.left, 0), M = gu(o.right, 0), H = gu(o.top, 0), x = gu(o.bottom, 0);
        h ? b = p - 2 * (T !== 0 || M !== 0 ? T + M : gu(o.left, o.right)) : _ = f - 2 * (H !== 0 || x !== 0 ? H + x : gu(o.top, o.bottom));
      }
      await s({
        ...l,
        availableWidth: b,
        availableHeight: _
      });
      const k = await u.getDimensions(i.floating);
      return p !== k.width || f !== k.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function me(e) {
  var l;
  return ((l = e.ownerDocument) == null ? void 0 : l.defaultView) || window;
}
function ot(e) {
  return me(e).getComputedStyle(e);
}
const E1 = Math.min, Gi = Math.max, kr = Math.round;
function e2(e) {
  const l = ot(e);
  let n = parseFloat(l.width), t = parseFloat(l.height);
  const u = e.offsetWidth, i = e.offsetHeight, s = kr(n) !== u || kr(t) !== i;
  return s && (n = u, t = i), { width: n, height: t, fallback: s };
}
function eu(e) {
  return u2(e) ? (e.nodeName || "").toLowerCase() : "";
}
let Ks;
function t2() {
  if (Ks)
    return Ks;
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? (Ks = e.brands.map((l) => l.brand + "/" + l.version).join(" "), Ks) : navigator.userAgent;
}
function at(e) {
  return e instanceof me(e).HTMLElement;
}
function Le(e) {
  return e instanceof me(e).Element;
}
function u2(e) {
  return e instanceof me(e).Node;
}
function I1(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof me(e).ShadowRoot || e instanceof ShadowRoot;
}
function Ro(e) {
  const { overflow: l, overflowX: n, overflowY: t, display: u } = ot(e);
  return /auto|scroll|overlay|hidden|clip/.test(l + t + n) && !["inline", "contents"].includes(u);
}
function v5(e) {
  return ["table", "td", "th"].includes(eu(e));
}
function Mc(e) {
  const l = /firefox/i.test(t2()), n = ot(e), t = n.backdropFilter || n.WebkitBackdropFilter;
  return n.transform !== "none" || n.perspective !== "none" || !!t && t !== "none" || l && n.willChange === "filter" || l && !!n.filter && n.filter !== "none" || ["transform", "perspective"].some((u) => n.willChange.includes(u)) || ["paint", "layout", "strict", "content"].some((u) => {
    const i = n.contain;
    return i != null && i.includes(u);
  });
}
function i2() {
  return !/^((?!chrome|android).)*safari/i.test(t2());
}
function Yp(e) {
  return ["html", "body", "#document"].includes(eu(e));
}
function s2(e) {
  return Le(e) ? e : e.contextElement;
}
const r2 = { x: 1, y: 1 };
function ii(e) {
  const l = s2(e);
  if (!at(l))
    return r2;
  const n = l.getBoundingClientRect(), { width: t, height: u, fallback: i } = e2(l);
  let s = (i ? kr(n.width) : n.width) / t, r = (i ? kr(n.height) : n.height) / u;
  return s && Number.isFinite(s) || (s = 1), r && Number.isFinite(r) || (r = 1), { x: s, y: r };
}
function Ru(e, l, n, t) {
  var u, i;
  l === void 0 && (l = !1), n === void 0 && (n = !1);
  const s = e.getBoundingClientRect(), r = s2(e);
  let o = r2;
  l && (t ? Le(t) && (o = ii(t)) : o = ii(e));
  const a = r ? me(r) : window, d = !i2() && n;
  let h = (s.left + (d && ((u = a.visualViewport) == null ? void 0 : u.offsetLeft) || 0)) / o.x, p = (s.top + (d && ((i = a.visualViewport) == null ? void 0 : i.offsetTop) || 0)) / o.y, f = s.width / o.x, m = s.height / o.y;
  if (r) {
    const g = me(r), v = t && Le(t) ? me(t) : t;
    let w = g.frameElement;
    for (; w && t && v !== g; ) {
      const $ = ii(w), _ = w.getBoundingClientRect(), b = getComputedStyle(w);
      _.x += (w.clientLeft + parseFloat(b.paddingLeft)) * $.x, _.y += (w.clientTop + parseFloat(b.paddingTop)) * $.y, h *= $.x, p *= $.y, f *= $.x, m *= $.y, h += _.x, p += _.y, w = me(w).frameElement;
    }
  }
  return { width: f, height: m, top: p, right: h + f, bottom: p + m, left: h, x: h, y: p };
}
function Zt(e) {
  return ((u2(e) ? e.ownerDocument : e.document) || window.document).documentElement;
}
function Do(e) {
  return Le(e) ? { scrollLeft: e.scrollLeft, scrollTop: e.scrollTop } : { scrollLeft: e.pageXOffset, scrollTop: e.pageYOffset };
}
function o2(e) {
  return Ru(Zt(e)).left + Do(e).scrollLeft;
}
function ps(e) {
  if (eu(e) === "html")
    return e;
  const l = e.assignedSlot || e.parentNode || I1(e) && e.host || Zt(e);
  return I1(l) ? l.host : l;
}
function a2(e) {
  const l = ps(e);
  return Yp(l) ? l.ownerDocument.body : at(l) && Ro(l) ? l : a2(l);
}
function Ou(e, l) {
  var n;
  l === void 0 && (l = []);
  const t = a2(e), u = t === ((n = e.ownerDocument) == null ? void 0 : n.body), i = me(t);
  return u ? l.concat(i, i.visualViewport || [], Ro(t) ? t : []) : l.concat(t, Ou(t));
}
function R1(e, l, n) {
  return l === "viewport" ? Wi(function(t, u) {
    const i = me(t), s = Zt(t), r = i.visualViewport;
    let o = s.clientWidth, a = s.clientHeight, d = 0, h = 0;
    if (r) {
      o = r.width, a = r.height;
      const p = i2();
      (p || !p && u === "fixed") && (d = r.offsetLeft, h = r.offsetTop);
    }
    return { width: o, height: a, x: d, y: h };
  }(e, n)) : Le(l) ? Wi(function(t, u) {
    const i = Ru(t, !0, u === "fixed"), s = i.top + t.clientTop, r = i.left + t.clientLeft, o = at(t) ? ii(t) : { x: 1, y: 1 };
    return { width: t.clientWidth * o.x, height: t.clientHeight * o.y, x: r * o.x, y: s * o.y };
  }(l, n)) : Wi(function(t) {
    const u = Zt(t), i = Do(t), s = t.ownerDocument.body, r = Gi(u.scrollWidth, u.clientWidth, s.scrollWidth, s.clientWidth), o = Gi(u.scrollHeight, u.clientHeight, s.scrollHeight, s.clientHeight);
    let a = -i.scrollLeft + o2(t);
    const d = -i.scrollTop;
    return ot(s).direction === "rtl" && (a += Gi(u.clientWidth, s.clientWidth) - r), { width: r, height: o, x: a, y: d };
  }(Zt(e)));
}
function D1(e) {
  return at(e) && ot(e).position !== "fixed" ? e.offsetParent : null;
}
function N1(e) {
  const l = me(e);
  let n = D1(e);
  for (; n && v5(n) && ot(n).position === "static"; )
    n = D1(n);
  return n && (eu(n) === "html" || eu(n) === "body" && ot(n).position === "static" && !Mc(n)) ? l : n || function(t) {
    let u = ps(t);
    for (; at(u) && !Yp(u); ) {
      if (Mc(u))
        return u;
      u = ps(u);
    }
    return null;
  }(e) || l;
}
function y5(e, l, n) {
  const t = at(l), u = Zt(l), i = Ru(e, !0, n === "fixed", l);
  let s = { scrollLeft: 0, scrollTop: 0 };
  const r = { x: 0, y: 0 };
  if (t || !t && n !== "fixed")
    if ((eu(l) !== "body" || Ro(u)) && (s = Do(l)), at(l)) {
      const o = Ru(l, !0);
      r.x = o.x + l.clientLeft, r.y = o.y + l.clientTop;
    } else
      u && (r.x = o2(u));
  return { x: i.left + s.scrollLeft - r.x, y: i.top + s.scrollTop - r.y, width: i.width, height: i.height };
}
const $5 = { getClippingRect: function(e) {
  let { element: l, boundary: n, rootBoundary: t, strategy: u } = e;
  const i = n === "clippingAncestors" ? function(a, d) {
    const h = d.get(a);
    if (h)
      return h;
    let p = Ou(a).filter((v) => Le(v) && eu(v) !== "body"), f = null;
    const m = ot(a).position === "fixed";
    let g = m ? ps(a) : a;
    for (; Le(g) && !Yp(g); ) {
      const v = ot(g), w = Mc(g);
      (m ? w || f : w || v.position !== "static" || !f || !["absolute", "fixed"].includes(f.position)) ? f = v : p = p.filter(($) => $ !== g), g = ps(g);
    }
    return d.set(a, p), p;
  }(l, this._c) : [].concat(n), s = [...i, t], r = s[0], o = s.reduce((a, d) => {
    const h = R1(l, d, u);
    return a.top = Gi(h.top, a.top), a.right = E1(h.right, a.right), a.bottom = E1(h.bottom, a.bottom), a.left = Gi(h.left, a.left), a;
  }, R1(l, r, u));
  return { width: o.right - o.left, height: o.bottom - o.top, x: o.left, y: o.top };
}, convertOffsetParentRelativeRectToViewportRelativeRect: function(e) {
  let { rect: l, offsetParent: n, strategy: t } = e;
  const u = at(n), i = Zt(n);
  if (n === i)
    return l;
  let s = { scrollLeft: 0, scrollTop: 0 }, r = { x: 1, y: 1 };
  const o = { x: 0, y: 0 };
  if ((u || !u && t !== "fixed") && ((eu(n) !== "body" || Ro(i)) && (s = Do(n)), at(n))) {
    const a = Ru(n);
    r = ii(n), o.x = a.x + n.clientLeft, o.y = a.y + n.clientTop;
  }
  return { width: l.width * r.x, height: l.height * r.y, x: l.x * r.x - s.scrollLeft * r.x + o.x, y: l.y * r.y - s.scrollTop * r.y + o.y };
}, isElement: Le, getDimensions: function(e) {
  return at(e) ? e2(e) : e.getBoundingClientRect();
}, getOffsetParent: N1, getDocumentElement: Zt, getScale: ii, async getElementRects(e) {
  let { reference: l, floating: n, strategy: t } = e;
  const u = this.getOffsetParent || N1, i = this.getDimensions;
  return { reference: y5(l, await u(n), t), floating: { x: 0, y: 0, ...await i(n) } };
}, getClientRects: (e) => Array.from(e.getClientRects()), isRTL: (e) => ot(e).direction === "rtl" };
function b5(e, l, n, t) {
  t === void 0 && (t = {});
  const { ancestorScroll: u = !0, ancestorResize: i = !0, elementResize: s = !0, animationFrame: r = !1 } = t, o = u && !r, a = o || i ? [...Le(e) ? Ou(e) : e.contextElement ? Ou(e.contextElement) : [], ...Ou(l)] : [];
  a.forEach((f) => {
    o && f.addEventListener("scroll", n, { passive: !0 }), i && f.addEventListener("resize", n);
  });
  let d, h = null;
  if (s) {
    let f = !0;
    h = new ResizeObserver(() => {
      f || n(), f = !1;
    }), Le(e) && !r && h.observe(e), Le(e) || !e.contextElement || r || h.observe(e.contextElement), h.observe(l);
  }
  let p = r ? Ru(e) : null;
  return r && function f() {
    const m = Ru(e);
    !p || m.x === p.x && m.y === p.y && m.width === p.width && m.height === p.height || n(), p = m, d = requestAnimationFrame(f);
  }(), n(), () => {
    var f;
    a.forEach((m) => {
      o && m.removeEventListener("scroll", n), i && m.removeEventListener("resize", n);
    }), (f = h) == null || f.disconnect(), h = null, r && cancelAnimationFrame(d);
  };
}
const d2 = (e, l, n) => {
  const t = /* @__PURE__ */ new Map(), u = { platform: $5, ...n }, i = { ...u.platform, _c: t };
  return h5(e, l, { ...u, platform: i });
};
function c2(e, l) {
  for (const n in l)
    Object.prototype.hasOwnProperty.call(l, n) && (typeof l[n] == "object" && e[n] ? c2(e[n], l[n]) : e[n] = l[n]);
}
const Pe = {
  // Disable popper components
  disabled: !1,
  // Default position offset along main axis (px)
  distance: 5,
  // Default position offset along cross axis (px)
  skidding: 0,
  // Default container where the tooltip will be appended
  container: "body",
  // Element used to compute position and size boundaries
  boundary: void 0,
  // Skip delay & CSS transitions when another popper is shown, so that the popper appear to instanly move to the new position.
  instantMove: !1,
  // Auto destroy tooltip DOM nodes (ms)
  disposeTimeout: 150,
  // Triggers on the popper itself
  popperTriggers: [],
  // Positioning strategy
  strategy: "absolute",
  // Prevent overflow
  preventOverflow: !0,
  // Flip to the opposite placement if needed
  flip: !0,
  // Shift on the cross axis to prevent the popper from overflowing
  shift: !0,
  // Overflow padding (px)
  overflowPadding: 0,
  // Arrow padding (px)
  arrowPadding: 0,
  // Compute arrow overflow (useful to hide it)
  arrowOverflow: !0,
  /**
   * By default, compute autohide on 'click'.
   */
  autoHideOnMousedown: !1,
  // Themes
  themes: {
    tooltip: {
      // Default tooltip placement relative to target element
      placement: "top",
      // Default events that trigger the tooltip
      triggers: ["hover", "focus", "touch"],
      // Close tooltip on click on tooltip target
      hideTriggers: (e) => [...e, "click"],
      // Delay (ms)
      delay: {
        show: 200,
        hide: 0
      },
      // Update popper on content resize
      handleResize: !1,
      // Enable HTML content in directive
      html: !1,
      // Displayed when tooltip content is loading
      loadingContent: "..."
    },
    dropdown: {
      // Default dropdown placement relative to target element
      placement: "bottom",
      // Default events that trigger the dropdown
      triggers: ["click"],
      // Delay (ms)
      delay: 0,
      // Update popper on content resize
      handleResize: !0,
      // Hide on clock outside
      autoHide: !0
    },
    menu: {
      $extend: "dropdown",
      triggers: ["hover", "focus"],
      popperTriggers: ["hover"],
      delay: {
        show: 0,
        hide: 400
      }
    }
  }
};
function fs(e, l) {
  let n = Pe.themes[e] || {}, t;
  do
    t = n[l], typeof t > "u" ? n.$extend ? n = Pe.themes[n.$extend] || {} : (n = null, t = Pe[l]) : n = null;
  while (n);
  return t;
}
function w5(e) {
  const l = [e];
  let n = Pe.themes[e] || {};
  do
    n.$extend && !n.$resetCss ? (l.push(n.$extend), n = Pe.themes[n.$extend] || {}) : n = null;
  while (n);
  return l.map((t) => `v-popper--theme-${t}`);
}
function L1(e) {
  const l = [e];
  let n = Pe.themes[e] || {};
  do
    n.$extend ? (l.push(n.$extend), n = Pe.themes[n.$extend] || {}) : n = null;
  while (n);
  return l;
}
let mi = !1;
if (typeof window < "u") {
  mi = !1;
  try {
    const e = Object.defineProperty({}, "passive", {
      get() {
        mi = !0;
      }
    });
    window.addEventListener("test", null, e);
  } catch {
  }
}
let h2 = !1;
typeof window < "u" && typeof navigator < "u" && (h2 = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream);
const p2 = ["auto", "top", "bottom", "left", "right"].reduce((e, l) => e.concat([
  l,
  `${l}-start`,
  `${l}-end`
]), []), P1 = {
  hover: "mouseenter",
  focus: "focus",
  click: "click",
  touch: "touchstart",
  pointer: "pointerdown"
}, B1 = {
  hover: "mouseleave",
  focus: "blur",
  click: "click",
  touch: "touchend",
  pointer: "pointerup"
};
function F1(e, l) {
  const n = e.indexOf(l);
  n !== -1 && e.splice(n, 1);
}
function wa() {
  return new Promise((e) => requestAnimationFrame(() => {
    requestAnimationFrame(e);
  }));
}
const Ee = [];
let pu = null;
const H1 = {};
function z1(e) {
  let l = H1[e];
  return l || (l = H1[e] = []), l;
}
let Ac = function() {
};
typeof window < "u" && (Ac = window.Element);
function Dl(e) {
  return function(l) {
    return fs(l.theme, e);
  };
}
const _a = "__floating-vue__popper", f2 = () => K({
  name: "VPopper",
  provide() {
    return {
      [_a]: {
        parentPopper: this
      }
    };
  },
  inject: {
    [_a]: { default: null }
  },
  props: {
    theme: {
      type: String,
      required: !0
    },
    targetNodes: {
      type: Function,
      required: !0
    },
    referenceNode: {
      type: Function,
      default: null
    },
    popperNode: {
      type: Function,
      required: !0
    },
    shown: {
      type: Boolean,
      default: !1
    },
    showGroup: {
      type: String,
      default: null
    },
    // eslint-disable-next-line vue/require-prop-types
    ariaId: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: Dl("disabled")
    },
    positioningDisabled: {
      type: Boolean,
      default: Dl("positioningDisabled")
    },
    placement: {
      type: String,
      default: Dl("placement"),
      validator: (e) => p2.includes(e)
    },
    delay: {
      type: [String, Number, Object],
      default: Dl("delay")
    },
    distance: {
      type: [Number, String],
      default: Dl("distance")
    },
    skidding: {
      type: [Number, String],
      default: Dl("skidding")
    },
    triggers: {
      type: Array,
      default: Dl("triggers")
    },
    showTriggers: {
      type: [Array, Function],
      default: Dl("showTriggers")
    },
    hideTriggers: {
      type: [Array, Function],
      default: Dl("hideTriggers")
    },
    popperTriggers: {
      type: Array,
      default: Dl("popperTriggers")
    },
    popperShowTriggers: {
      type: [Array, Function],
      default: Dl("popperShowTriggers")
    },
    popperHideTriggers: {
      type: [Array, Function],
      default: Dl("popperHideTriggers")
    },
    container: {
      type: [String, Object, Ac, Boolean],
      default: Dl("container")
    },
    boundary: {
      type: [String, Ac],
      default: Dl("boundary")
    },
    strategy: {
      type: String,
      validator: (e) => ["absolute", "fixed"].includes(e),
      default: Dl("strategy")
    },
    autoHide: {
      type: [Boolean, Function],
      default: Dl("autoHide")
    },
    handleResize: {
      type: Boolean,
      default: Dl("handleResize")
    },
    instantMove: {
      type: Boolean,
      default: Dl("instantMove")
    },
    eagerMount: {
      type: Boolean,
      default: Dl("eagerMount")
    },
    popperClass: {
      type: [String, Array, Object],
      default: Dl("popperClass")
    },
    computeTransformOrigin: {
      type: Boolean,
      default: Dl("computeTransformOrigin")
    },
    /**
     * @deprecated
     */
    autoMinSize: {
      type: Boolean,
      default: Dl("autoMinSize")
    },
    autoSize: {
      type: [Boolean, String],
      default: Dl("autoSize")
    },
    /**
     * @deprecated
     */
    autoMaxSize: {
      type: Boolean,
      default: Dl("autoMaxSize")
    },
    autoBoundaryMaxSize: {
      type: Boolean,
      default: Dl("autoBoundaryMaxSize")
    },
    preventOverflow: {
      type: Boolean,
      default: Dl("preventOverflow")
    },
    overflowPadding: {
      type: [Number, String],
      default: Dl("overflowPadding")
    },
    arrowPadding: {
      type: [Number, String],
      default: Dl("arrowPadding")
    },
    arrowOverflow: {
      type: Boolean,
      default: Dl("arrowOverflow")
    },
    flip: {
      type: Boolean,
      default: Dl("flip")
    },
    shift: {
      type: Boolean,
      default: Dl("shift")
    },
    shiftCrossAxis: {
      type: Boolean,
      default: Dl("shiftCrossAxis")
    },
    noAutoFocus: {
      type: Boolean,
      default: Dl("noAutoFocus")
    },
    disposeTimeout: {
      type: Number,
      default: Dl("disposeTimeout")
    }
  },
  emits: {
    show: () => !0,
    hide: () => !0,
    "update:shown": (e) => !0,
    "apply-show": () => !0,
    "apply-hide": () => !0,
    "close-group": () => !0,
    "close-directive": () => !0,
    "auto-hide": () => !0,
    resize: () => !0
  },
  data() {
    return {
      isShown: !1,
      isMounted: !1,
      skipTransition: !1,
      classes: {
        showFrom: !1,
        showTo: !1,
        hideFrom: !1,
        hideTo: !0
      },
      result: {
        x: 0,
        y: 0,
        placement: "",
        strategy: this.strategy,
        arrow: {
          x: 0,
          y: 0,
          centerOffset: 0
        },
        transformOrigin: null
      },
      randomId: `popper_${[Math.random(), Date.now()].map((e) => e.toString(36).substring(2, 10)).join("_")}`,
      shownChildren: /* @__PURE__ */ new Set(),
      lastAutoHide: !0,
      pendingHide: !1,
      containsGlobalTarget: !1,
      isDisposed: !0,
      mouseDownContains: !1
    };
  },
  computed: {
    popperId() {
      return this.ariaId != null ? this.ariaId : this.randomId;
    },
    shouldMountContent() {
      return this.eagerMount || this.isMounted;
    },
    slotData() {
      return {
        popperId: this.popperId,
        isShown: this.isShown,
        shouldMountContent: this.shouldMountContent,
        skipTransition: this.skipTransition,
        autoHide: typeof this.autoHide == "function" ? this.lastAutoHide : this.autoHide,
        show: this.show,
        hide: this.hide,
        handleResize: this.handleResize,
        onResize: this.onResize,
        classes: {
          ...this.classes,
          popperClass: this.popperClass
        },
        result: this.positioningDisabled ? null : this.result,
        attrs: this.$attrs
      };
    },
    parentPopper() {
      var e;
      return (e = this[_a]) == null ? void 0 : e.parentPopper;
    },
    hasPopperShowTriggerHover() {
      var e, l;
      return ((e = this.popperTriggers) == null ? void 0 : e.includes("hover")) || ((l = this.popperShowTriggers) == null ? void 0 : l.includes("hover"));
    }
  },
  watch: {
    shown: "$_autoShowHide",
    disabled(e) {
      e ? this.dispose() : this.init();
    },
    async container() {
      this.isShown && (this.$_ensureTeleport(), await this.$_computePosition());
    },
    triggers: {
      handler: "$_refreshListeners",
      deep: !0
    },
    positioningDisabled: "$_refreshListeners",
    ...[
      "placement",
      "distance",
      "skidding",
      "boundary",
      "strategy",
      "overflowPadding",
      "arrowPadding",
      "preventOverflow",
      "shift",
      "shiftCrossAxis",
      "flip"
    ].reduce((e, l) => (e[l] = "$_computePosition", e), {})
  },
  created() {
    this.autoMinSize && console.warn('[floating-vue] `autoMinSize` option is deprecated. Use `autoSize="min"` instead.'), this.autoMaxSize && console.warn("[floating-vue] `autoMaxSize` option is deprecated. Use `autoBoundaryMaxSize` instead.");
  },
  mounted() {
    this.init(), this.$_detachPopperNode();
  },
  activated() {
    this.$_autoShowHide();
  },
  deactivated() {
    this.hide();
  },
  beforeUnmount() {
    this.dispose();
  },
  methods: {
    show({ event: e = null, skipDelay: l = !1, force: n = !1 } = {}) {
      var t, u;
      (t = this.parentPopper) != null && t.lockedChild && this.parentPopper.lockedChild !== this || (this.pendingHide = !1, (n || !this.disabled) && (((u = this.parentPopper) == null ? void 0 : u.lockedChild) === this && (this.parentPopper.lockedChild = null), this.$_scheduleShow(e, l), this.$emit("show"), this.$_showFrameLocked = !0, requestAnimationFrame(() => {
        this.$_showFrameLocked = !1;
      })), this.$emit("update:shown", !0));
    },
    hide({ event: e = null, skipDelay: l = !1 } = {}) {
      var n;
      if (!this.$_hideInProgress) {
        if (this.shownChildren.size > 0) {
          this.pendingHide = !0;
          return;
        }
        if (this.hasPopperShowTriggerHover && this.$_isAimingPopper()) {
          this.parentPopper && (this.parentPopper.lockedChild = this, clearTimeout(this.parentPopper.lockedChildTimer), this.parentPopper.lockedChildTimer = setTimeout(() => {
            this.parentPopper.lockedChild === this && (this.parentPopper.lockedChild.hide({ skipDelay: l }), this.parentPopper.lockedChild = null);
          }, 1e3));
          return;
        }
        ((n = this.parentPopper) == null ? void 0 : n.lockedChild) === this && (this.parentPopper.lockedChild = null), this.pendingHide = !1, this.$_scheduleHide(e, l), this.$emit("hide"), this.$emit("update:shown", !1);
      }
    },
    init() {
      var e;
      this.isDisposed && (this.isDisposed = !1, this.isMounted = !1, this.$_events = [], this.$_preventShow = !1, this.$_referenceNode = ((e = this.referenceNode) == null ? void 0 : e.call(this)) ?? this.$el, this.$_targetNodes = this.targetNodes().filter((l) => l.nodeType === l.ELEMENT_NODE), this.$_popperNode = this.popperNode(), this.$_innerNode = this.$_popperNode.querySelector(".v-popper__inner"), this.$_arrowNode = this.$_popperNode.querySelector(".v-popper__arrow-container"), this.$_swapTargetAttrs("title", "data-original-title"), this.$_detachPopperNode(), this.triggers.length && this.$_addEventListeners(), this.shown && this.show());
    },
    dispose() {
      this.isDisposed || (this.isDisposed = !0, this.$_removeEventListeners(), this.hide({ skipDelay: !0 }), this.$_detachPopperNode(), this.isMounted = !1, this.isShown = !1, this.$_updateParentShownChildren(!1), this.$_swapTargetAttrs("data-original-title", "title"));
    },
    async onResize() {
      this.isShown && (await this.$_computePosition(), this.$emit("resize"));
    },
    async $_computePosition() {
      if (this.isDisposed || this.positioningDisabled)
        return;
      const e = {
        strategy: this.strategy,
        middleware: []
      };
      (this.distance || this.skidding) && e.middleware.push(l2({
        mainAxis: this.distance,
        crossAxis: this.skidding
      }));
      const l = this.placement.startsWith("auto");
      if (l ? e.middleware.push(Qg({
        alignment: this.placement.split("-")[1] ?? ""
      })) : e.placement = this.placement, this.preventOverflow && (this.shift && e.middleware.push(n2({
        padding: this.overflowPadding,
        boundary: this.boundary,
        crossAxis: this.shiftCrossAxis
      })), !l && this.flip && e.middleware.push(f5({
        padding: this.overflowPadding,
        boundary: this.boundary
      }))), e.middleware.push(Xg({
        element: this.$_arrowNode,
        padding: this.arrowPadding
      })), this.arrowOverflow && e.middleware.push({
        name: "arrowOverflow",
        fn: ({ placement: t, rects: u, middlewareData: i }) => {
          let s;
          const { centerOffset: r } = i.arrow;
          return t.startsWith("top") || t.startsWith("bottom") ? s = Math.abs(r) > u.reference.width / 2 : s = Math.abs(r) > u.reference.height / 2, {
            data: {
              overflow: s
            }
          };
        }
      }), this.autoMinSize || this.autoSize) {
        const t = this.autoSize ? this.autoSize : this.autoMinSize ? "min" : null;
        e.middleware.push({
          name: "autoSize",
          fn: ({ rects: u, placement: i, middlewareData: s }) => {
            var r;
            if ((r = s.autoSize) != null && r.skip)
              return {};
            let o, a;
            return i.startsWith("top") || i.startsWith("bottom") ? o = u.reference.width : a = u.reference.height, this.$_innerNode.style[t === "min" ? "minWidth" : t === "max" ? "maxWidth" : "width"] = o != null ? `${o}px` : null, this.$_innerNode.style[t === "min" ? "minHeight" : t === "max" ? "maxHeight" : "height"] = a != null ? `${a}px` : null, {
              data: {
                skip: !0
              },
              reset: {
                rects: !0
              }
            };
          }
        });
      }
      (this.autoMaxSize || this.autoBoundaryMaxSize) && (this.$_innerNode.style.maxWidth = null, this.$_innerNode.style.maxHeight = null, e.middleware.push(g5({
        boundary: this.boundary,
        padding: this.overflowPadding,
        apply: ({ availableWidth: t, availableHeight: u }) => {
          this.$_innerNode.style.maxWidth = t != null ? `${t}px` : null, this.$_innerNode.style.maxHeight = u != null ? `${u}px` : null;
        }
      })));
      const n = await d2(this.$_referenceNode, this.$_popperNode, e);
      Object.assign(this.result, {
        x: n.x,
        y: n.y,
        placement: n.placement,
        strategy: n.strategy,
        arrow: {
          ...n.middlewareData.arrow,
          ...n.middlewareData.arrowOverflow
        }
      });
    },
    $_scheduleShow(e, l = !1) {
      if (this.$_updateParentShownChildren(!0), this.$_hideInProgress = !1, clearTimeout(this.$_scheduleTimer), pu && this.instantMove && pu.instantMove && pu !== this.parentPopper) {
        pu.$_applyHide(!0), this.$_applyShow(!0);
        return;
      }
      l ? this.$_applyShow() : this.$_scheduleTimer = setTimeout(this.$_applyShow.bind(this), this.$_computeDelay("show"));
    },
    $_scheduleHide(e, l = !1) {
      if (this.shownChildren.size > 0) {
        this.pendingHide = !0;
        return;
      }
      this.$_updateParentShownChildren(!1), this.$_hideInProgress = !0, clearTimeout(this.$_scheduleTimer), this.isShown && (pu = this), l ? this.$_applyHide() : this.$_scheduleTimer = setTimeout(this.$_applyHide.bind(this), this.$_computeDelay("hide"));
    },
    $_computeDelay(e) {
      const l = this.delay;
      return parseInt(l && l[e] || l || 0);
    },
    async $_applyShow(e = !1) {
      clearTimeout(this.$_disposeTimer), clearTimeout(this.$_scheduleTimer), this.skipTransition = e, !this.isShown && (this.$_ensureTeleport(), await wa(), await this.$_computePosition(), await this.$_applyShowEffect(), this.positioningDisabled || this.$_registerEventListeners([
        ...Ou(this.$_referenceNode),
        ...Ou(this.$_popperNode)
      ], "scroll", () => {
        this.$_computePosition();
      }));
    },
    async $_applyShowEffect() {
      if (this.$_hideInProgress)
        return;
      if (this.computeTransformOrigin) {
        const l = this.$_referenceNode.getBoundingClientRect(), n = this.$_popperNode.querySelector(".v-popper__wrapper"), t = n.parentNode.getBoundingClientRect(), u = l.x + l.width / 2 - (t.left + n.offsetLeft), i = l.y + l.height / 2 - (t.top + n.offsetTop);
        this.result.transformOrigin = `${u}px ${i}px`;
      }
      this.isShown = !0, this.$_applyAttrsToTarget({
        "aria-describedby": this.popperId,
        "data-popper-shown": ""
      });
      const e = this.showGroup;
      if (e) {
        let l;
        for (let n = 0; n < Ee.length; n++)
          l = Ee[n], l.showGroup !== e && (l.hide(), l.$emit("close-group"));
      }
      Ee.push(this), document.body.classList.add("v-popper--some-open");
      for (const l of L1(this.theme))
        z1(l).push(this), document.body.classList.add(`v-popper--some-open--${l}`);
      this.$emit("apply-show"), this.classes.showFrom = !0, this.classes.showTo = !1, this.classes.hideFrom = !1, this.classes.hideTo = !1, await wa(), this.classes.showFrom = !1, this.classes.showTo = !0, this.noAutoFocus || this.$_popperNode.focus();
    },
    async $_applyHide(e = !1) {
      if (this.shownChildren.size > 0) {
        this.pendingHide = !0, this.$_hideInProgress = !1;
        return;
      }
      if (clearTimeout(this.$_scheduleTimer), !this.isShown)
        return;
      this.skipTransition = e, F1(Ee, this), Ee.length === 0 && document.body.classList.remove("v-popper--some-open");
      for (const n of L1(this.theme)) {
        const t = z1(n);
        F1(t, this), t.length === 0 && document.body.classList.remove(`v-popper--some-open--${n}`);
      }
      pu === this && (pu = null), this.isShown = !1, this.$_applyAttrsToTarget({
        "aria-describedby": void 0,
        "data-popper-shown": void 0
      }), clearTimeout(this.$_disposeTimer);
      const l = this.disposeTimeout;
      l !== null && (this.$_disposeTimer = setTimeout(() => {
        this.$_popperNode && (this.$_detachPopperNode(), this.isMounted = !1);
      }, l)), this.$_removeEventListeners("scroll"), this.$emit("apply-hide"), this.classes.showFrom = !1, this.classes.showTo = !1, this.classes.hideFrom = !0, this.classes.hideTo = !1, await wa(), this.classes.hideFrom = !1, this.classes.hideTo = !0;
    },
    $_autoShowHide() {
      this.shown ? this.show() : this.hide();
    },
    $_ensureTeleport() {
      if (this.isDisposed)
        return;
      let e = this.container;
      if (typeof e == "string" ? e = window.document.querySelector(e) : e === !1 && (e = this.$_targetNodes[0].parentNode), !e)
        throw new Error("No container for popover: " + this.container);
      e.appendChild(this.$_popperNode), this.isMounted = !0;
    },
    $_addEventListeners() {
      const e = (n) => {
        this.isShown && !this.$_hideInProgress || (n.usedByTooltip = !0, !this.$_preventShow && this.show({ event: n }));
      };
      this.$_registerTriggerListeners(this.$_targetNodes, P1, this.triggers, this.showTriggers, e), this.$_registerTriggerListeners([this.$_popperNode], P1, this.popperTriggers, this.popperShowTriggers, e);
      const l = (n) => {
        n.usedByTooltip || this.hide({ event: n });
      };
      this.$_registerTriggerListeners(this.$_targetNodes, B1, this.triggers, this.hideTriggers, l), this.$_registerTriggerListeners([this.$_popperNode], B1, this.popperTriggers, this.popperHideTriggers, l);
    },
    $_registerEventListeners(e, l, n) {
      this.$_events.push({ targetNodes: e, eventType: l, handler: n }), e.forEach((t) => t.addEventListener(l, n, mi ? {
        passive: !0
      } : void 0));
    },
    $_registerTriggerListeners(e, l, n, t, u) {
      let i = n;
      t != null && (i = typeof t == "function" ? t(i) : t), i.forEach((s) => {
        const r = l[s];
        r && this.$_registerEventListeners(e, r, u);
      });
    },
    $_removeEventListeners(e) {
      const l = [];
      this.$_events.forEach((n) => {
        const { targetNodes: t, eventType: u, handler: i } = n;
        !e || e === u ? t.forEach((s) => s.removeEventListener(u, i)) : l.push(n);
      }), this.$_events = l;
    },
    $_refreshListeners() {
      this.isDisposed || (this.$_removeEventListeners(), this.$_addEventListeners());
    },
    $_handleGlobalClose(e, l = !1) {
      this.$_showFrameLocked || (this.hide({ event: e }), e.closePopover ? this.$emit("close-directive") : this.$emit("auto-hide"), l && (this.$_preventShow = !0, setTimeout(() => {
        this.$_preventShow = !1;
      }, 300)));
    },
    $_detachPopperNode() {
      this.$_popperNode.parentNode && this.$_popperNode.parentNode.removeChild(this.$_popperNode);
    },
    $_swapTargetAttrs(e, l) {
      for (const n of this.$_targetNodes) {
        const t = n.getAttribute(e);
        t && (n.removeAttribute(e), n.setAttribute(l, t));
      }
    },
    $_applyAttrsToTarget(e) {
      for (const l of this.$_targetNodes)
        for (const n in e) {
          const t = e[n];
          t == null ? l.removeAttribute(n) : l.setAttribute(n, t);
        }
    },
    $_updateParentShownChildren(e) {
      let l = this.parentPopper;
      for (; l; )
        e ? l.shownChildren.add(this.randomId) : (l.shownChildren.delete(this.randomId), l.pendingHide && l.hide()), l = l.parentPopper;
    },
    $_isAimingPopper() {
      const e = this.$_referenceNode.getBoundingClientRect();
      if (Ki >= e.left && Ki <= e.right && Yi >= e.top && Yi <= e.bottom) {
        const l = this.$_popperNode.getBoundingClientRect(), n = Ki - Pt, t = Yi - Bt, u = l.left + l.width / 2 - Pt + (l.top + l.height / 2) - Bt + l.width + l.height, i = Pt + n * u, s = Bt + t * u;
        return Ys(Pt, Bt, i, s, l.left, l.top, l.left, l.bottom) || // Left edge
        Ys(Pt, Bt, i, s, l.left, l.top, l.right, l.top) || // Top edge
        Ys(Pt, Bt, i, s, l.right, l.top, l.right, l.bottom) || // Right edge
        Ys(Pt, Bt, i, s, l.left, l.bottom, l.right, l.bottom);
      }
      return !1;
    }
  },
  render() {
    return this.$slots.default(this.slotData);
  }
});
if (typeof document < "u" && typeof window < "u") {
  if (h2) {
    const e = mi ? {
      passive: !0,
      capture: !0
    } : !0;
    document.addEventListener("touchstart", (l) => V1(l, !0), e), document.addEventListener("touchend", (l) => j1(l, !0), e);
  } else
    window.addEventListener("mousedown", (e) => V1(e, !1), !0), window.addEventListener("click", (e) => j1(e, !1), !0);
  window.addEventListener("resize", S5);
}
function V1(e, l) {
  if (Pe.autoHideOnMousedown)
    m2(e, l);
  else
    for (let n = 0; n < Ee.length; n++) {
      const t = Ee[n];
      try {
        t.mouseDownContains = t.popperNode().contains(e.target);
      } catch {
      }
    }
}
function j1(e, l) {
  Pe.autoHideOnMousedown || m2(e, l);
}
function m2(e, l) {
  const n = {};
  for (let t = Ee.length - 1; t >= 0; t--) {
    const u = Ee[t];
    try {
      const i = u.containsGlobalTarget = u.mouseDownContains || u.popperNode().contains(e.target);
      u.pendingHide = !1, requestAnimationFrame(() => {
        if (u.pendingHide = !1, !n[u.randomId] && U1(u, i, e)) {
          if (u.$_handleGlobalClose(e, l), !e.closeAllPopover && e.closePopover && i) {
            let r = u.parentPopper;
            for (; r; )
              n[r.randomId] = !0, r = r.parentPopper;
            return;
          }
          let s = u.parentPopper;
          for (; s && U1(s, s.containsGlobalTarget, e); )
            s.$_handleGlobalClose(e, l), s = s.parentPopper;
        }
      });
    } catch {
    }
  }
}
function U1(e, l, n) {
  return n.closeAllPopover || n.closePopover && l || _5(e, n) && !l;
}
function _5(e, l) {
  if (typeof e.autoHide == "function") {
    const n = e.autoHide(l);
    return e.lastAutoHide = n, n;
  }
  return e.autoHide;
}
function S5() {
  for (let e = 0; e < Ee.length; e++)
    Ee[e].$_computePosition();
}
let Pt = 0, Bt = 0, Ki = 0, Yi = 0;
typeof window < "u" && window.addEventListener("mousemove", (e) => {
  Pt = Ki, Bt = Yi, Ki = e.clientX, Yi = e.clientY;
}, mi ? {
  passive: !0
} : void 0);
function Ys(e, l, n, t, u, i, s, r) {
  const o = ((s - u) * (l - i) - (r - i) * (e - u)) / ((r - i) * (n - e) - (s - u) * (t - l)), a = ((n - e) * (l - i) - (t - l) * (e - u)) / ((r - i) * (n - e) - (s - u) * (t - l));
  return o >= 0 && o <= 1 && a >= 0 && a <= 1;
}
const C5 = {
  extends: f2()
}, No = (e, l) => {
  const n = e.__vccOpts || e;
  for (const [t, u] of l)
    n[t] = u;
  return n;
};
function T5(e, l, n, t, u, i) {
  return y(), O("div", {
    ref: "reference",
    class: z(["v-popper", {
      "v-popper--shown": e.slotData.isShown
    }])
  }, [
    V(e.$slots, "default", Rl(jl(e.slotData)))
  ], 2);
}
const O5 = /* @__PURE__ */ No(C5, [["render", T5]]);
function k5() {
  var e = window.navigator.userAgent, l = e.indexOf("MSIE ");
  if (l > 0)
    return parseInt(e.substring(l + 5, e.indexOf(".", l)), 10);
  var n = e.indexOf("Trident/");
  if (n > 0) {
    var t = e.indexOf("rv:");
    return parseInt(e.substring(t + 3, e.indexOf(".", t)), 10);
  }
  var u = e.indexOf("Edge/");
  return u > 0 ? parseInt(e.substring(u + 5, e.indexOf(".", u)), 10) : -1;
}
let fr;
function xc() {
  xc.init || (xc.init = !0, fr = k5() !== -1);
}
var Lo = {
  name: "ResizeObserver",
  props: {
    emitOnMount: {
      type: Boolean,
      default: !1
    },
    ignoreWidth: {
      type: Boolean,
      default: !1
    },
    ignoreHeight: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "notify"
  ],
  mounted() {
    xc(), rl(() => {
      this._w = this.$el.offsetWidth, this._h = this.$el.offsetHeight, this.emitOnMount && this.emitSize();
    });
    const e = document.createElement("object");
    this._resizeObject = e, e.setAttribute("aria-hidden", "true"), e.setAttribute("tabindex", -1), e.onload = this.addResizeHandlers, e.type = "text/html", fr && this.$el.appendChild(e), e.data = "about:blank", fr || this.$el.appendChild(e);
  },
  beforeUnmount() {
    this.removeResizeHandlers();
  },
  methods: {
    compareAndNotify() {
      (!this.ignoreWidth && this._w !== this.$el.offsetWidth || !this.ignoreHeight && this._h !== this.$el.offsetHeight) && (this._w = this.$el.offsetWidth, this._h = this.$el.offsetHeight, this.emitSize());
    },
    emitSize() {
      this.$emit("notify", {
        width: this._w,
        height: this._h
      });
    },
    addResizeHandlers() {
      this._resizeObject.contentDocument.defaultView.addEventListener("resize", this.compareAndNotify), this.compareAndNotify();
    },
    removeResizeHandlers() {
      this._resizeObject && this._resizeObject.onload && (!fr && this._resizeObject.contentDocument && this._resizeObject.contentDocument.defaultView.removeEventListener("resize", this.compareAndNotify), this.$el.removeChild(this._resizeObject), this._resizeObject.onload = null, this._resizeObject = null);
    }
  }
};
const M5 = /* @__PURE__ */ Uy("data-v-b329ee4c");
Vy("data-v-b329ee4c");
const A5 = {
  class: "resize-observer",
  tabindex: "-1"
};
jy();
const x5 = /* @__PURE__ */ M5((e, l, n, t, u, i) => (y(), L("div", A5)));
Lo.render = x5;
Lo.__scopeId = "data-v-b329ee4c";
Lo.__file = "src/components/ResizeObserver.vue";
const g2 = (e = "theme") => ({
  computed: {
    themeClass() {
      return w5(this[e]);
    }
  }
}), E5 = K({
  name: "VPopperContent",
  components: {
    ResizeObserver: Lo
  },
  mixins: [
    g2()
  ],
  props: {
    popperId: String,
    theme: String,
    shown: Boolean,
    mounted: Boolean,
    skipTransition: Boolean,
    autoHide: Boolean,
    handleResize: Boolean,
    classes: Object,
    result: Object
  },
  emits: [
    "hide",
    "resize"
  ],
  methods: {
    toPx(e) {
      return e != null && !isNaN(e) ? `${e}px` : null;
    }
  }
}), I5 = ["id", "aria-hidden", "tabindex", "data-popper-placement"], R5 = {
  ref: "inner",
  class: "v-popper__inner"
}, D5 = /* @__PURE__ */ A("div", { class: "v-popper__arrow-outer" }, null, -1), N5 = /* @__PURE__ */ A("div", { class: "v-popper__arrow-inner" }, null, -1), L5 = [
  D5,
  N5
];
function P5(e, l, n, t, u, i) {
  const s = Bl("ResizeObserver");
  return y(), O("div", {
    id: e.popperId,
    ref: "popover",
    class: z(["v-popper__popper", [
      e.themeClass,
      e.classes.popperClass,
      {
        "v-popper__popper--shown": e.shown,
        "v-popper__popper--hidden": !e.shown,
        "v-popper__popper--show-from": e.classes.showFrom,
        "v-popper__popper--show-to": e.classes.showTo,
        "v-popper__popper--hide-from": e.classes.hideFrom,
        "v-popper__popper--hide-to": e.classes.hideTo,
        "v-popper__popper--skip-transition": e.skipTransition,
        "v-popper__popper--arrow-overflow": e.result && e.result.arrow.overflow,
        "v-popper__popper--no-positioning": !e.result
      }
    ]]),
    style: Wl(e.result ? {
      position: e.result.strategy,
      transform: `translate3d(${Math.round(e.result.x)}px,${Math.round(e.result.y)}px,0)`
    } : void 0),
    "aria-hidden": e.shown ? "false" : "true",
    tabindex: e.autoHide ? 0 : void 0,
    "data-popper-placement": e.result ? e.result.placement : void 0,
    onKeyup: l[2] || (l[2] = Fn((r) => e.autoHide && e.$emit("hide"), ["esc"]))
  }, [
    A("div", {
      class: "v-popper__backdrop",
      onClick: l[0] || (l[0] = (r) => e.autoHide && e.$emit("hide"))
    }),
    A("div", {
      class: "v-popper__wrapper",
      style: Wl(e.result ? {
        transformOrigin: e.result.transformOrigin
      } : void 0)
    }, [
      A("div", R5, [
        e.mounted ? (y(), O(hl, { key: 0 }, [
          A("div", null, [
            V(e.$slots, "default")
          ]),
          e.handleResize ? (y(), L(s, {
            key: 0,
            onNotify: l[1] || (l[1] = (r) => e.$emit("resize", r))
          })) : I("", !0)
        ], 64)) : I("", !0)
      ], 512),
      A("div", {
        ref: "arrow",
        class: "v-popper__arrow-container",
        style: Wl(e.result ? {
          left: e.toPx(e.result.arrow.x),
          top: e.toPx(e.result.arrow.y)
        } : void 0)
      }, L5, 4)
    ], 4)
  ], 46, I5);
}
const v2 = /* @__PURE__ */ No(E5, [["render", P5]]), y2 = {
  methods: {
    show(...e) {
      return this.$refs.popper.show(...e);
    },
    hide(...e) {
      return this.$refs.popper.hide(...e);
    },
    dispose(...e) {
      return this.$refs.popper.dispose(...e);
    },
    onResize(...e) {
      return this.$refs.popper.onResize(...e);
    }
  }
};
let Ec = function() {
};
typeof window < "u" && (Ec = window.Element);
const B5 = K({
  name: "VPopperWrapper",
  components: {
    Popper: O5,
    PopperContent: v2
  },
  mixins: [
    y2,
    g2("finalTheme")
  ],
  props: {
    theme: {
      type: String,
      default: null
    },
    referenceNode: {
      type: Function,
      default: null
    },
    shown: {
      type: Boolean,
      default: !1
    },
    showGroup: {
      type: String,
      default: null
    },
    // eslint-disable-next-line vue/require-prop-types
    ariaId: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    positioningDisabled: {
      type: Boolean,
      default: void 0
    },
    placement: {
      type: String,
      default: void 0
    },
    delay: {
      type: [String, Number, Object],
      default: void 0
    },
    distance: {
      type: [Number, String],
      default: void 0
    },
    skidding: {
      type: [Number, String],
      default: void 0
    },
    triggers: {
      type: Array,
      default: void 0
    },
    showTriggers: {
      type: [Array, Function],
      default: void 0
    },
    hideTriggers: {
      type: [Array, Function],
      default: void 0
    },
    popperTriggers: {
      type: Array,
      default: void 0
    },
    popperShowTriggers: {
      type: [Array, Function],
      default: void 0
    },
    popperHideTriggers: {
      type: [Array, Function],
      default: void 0
    },
    container: {
      type: [String, Object, Ec, Boolean],
      default: void 0
    },
    boundary: {
      type: [String, Ec],
      default: void 0
    },
    strategy: {
      type: String,
      default: void 0
    },
    autoHide: {
      type: [Boolean, Function],
      default: void 0
    },
    handleResize: {
      type: Boolean,
      default: void 0
    },
    instantMove: {
      type: Boolean,
      default: void 0
    },
    eagerMount: {
      type: Boolean,
      default: void 0
    },
    popperClass: {
      type: [String, Array, Object],
      default: void 0
    },
    computeTransformOrigin: {
      type: Boolean,
      default: void 0
    },
    /**
     * @deprecated
     */
    autoMinSize: {
      type: Boolean,
      default: void 0
    },
    autoSize: {
      type: [Boolean, String],
      default: void 0
    },
    /**
     * @deprecated
     */
    autoMaxSize: {
      type: Boolean,
      default: void 0
    },
    autoBoundaryMaxSize: {
      type: Boolean,
      default: void 0
    },
    preventOverflow: {
      type: Boolean,
      default: void 0
    },
    overflowPadding: {
      type: [Number, String],
      default: void 0
    },
    arrowPadding: {
      type: [Number, String],
      default: void 0
    },
    arrowOverflow: {
      type: Boolean,
      default: void 0
    },
    flip: {
      type: Boolean,
      default: void 0
    },
    shift: {
      type: Boolean,
      default: void 0
    },
    shiftCrossAxis: {
      type: Boolean,
      default: void 0
    },
    noAutoFocus: {
      type: Boolean,
      default: void 0
    },
    disposeTimeout: {
      type: Number,
      default: void 0
    }
  },
  emits: {
    show: () => !0,
    hide: () => !0,
    "update:shown": (e) => !0,
    "apply-show": () => !0,
    "apply-hide": () => !0,
    "close-group": () => !0,
    "close-directive": () => !0,
    "auto-hide": () => !0,
    resize: () => !0
  },
  computed: {
    finalTheme() {
      return this.theme ?? this.$options.vPopperTheme;
    }
  },
  methods: {
    getTargetNodes() {
      return Array.from(this.$el.children).filter((e) => e !== this.$refs.popperContent.$el);
    }
  }
});
function F5(e, l, n, t, u, i) {
  const s = Bl("PopperContent"), r = Bl("Popper");
  return y(), L(r, ml({ ref: "popper" }, e.$props, {
    theme: e.finalTheme,
    "target-nodes": e.getTargetNodes,
    "popper-node": () => e.$refs.popperContent.$el,
    class: [
      e.themeClass
    ],
    onShow: l[0] || (l[0] = () => e.$emit("show")),
    onHide: l[1] || (l[1] = () => e.$emit("hide")),
    "onUpdate:shown": l[2] || (l[2] = (o) => e.$emit("update:shown", o)),
    onApplyShow: l[3] || (l[3] = () => e.$emit("apply-show")),
    onApplyHide: l[4] || (l[4] = () => e.$emit("apply-hide")),
    onCloseGroup: l[5] || (l[5] = () => e.$emit("close-group")),
    onCloseDirective: l[6] || (l[6] = () => e.$emit("close-directive")),
    onAutoHide: l[7] || (l[7] = () => e.$emit("auto-hide")),
    onResize: l[8] || (l[8] = () => e.$emit("resize"))
  }), {
    default: U(({
      popperId: o,
      isShown: a,
      shouldMountContent: d,
      skipTransition: h,
      autoHide: p,
      show: f,
      hide: m,
      handleResize: g,
      onResize: v,
      classes: w,
      result: $
    }) => [
      V(e.$slots, "default", {
        shown: a,
        show: f,
        hide: m
      }),
      R(s, {
        ref: "popperContent",
        "popper-id": o,
        theme: e.finalTheme,
        shown: a,
        mounted: d,
        "skip-transition": h,
        "auto-hide": p,
        "handle-resize": g,
        classes: w,
        result: $,
        onHide: m,
        onResize: v
      }, {
        default: U(() => [
          V(e.$slots, "popper", {
            shown: a,
            hide: m
          })
        ]),
        _: 2
      }, 1032, ["popper-id", "theme", "shown", "mounted", "skip-transition", "auto-hide", "handle-resize", "classes", "result", "onHide", "onResize"])
    ]),
    _: 3
  }, 16, ["theme", "target-nodes", "popper-node", "class"]);
}
const qp = /* @__PURE__ */ No(B5, [["render", F5]]), H5 = {
  ...qp,
  name: "VDropdown",
  vPopperTheme: "dropdown"
}, z5 = {
  ...qp,
  name: "VMenu",
  vPopperTheme: "menu"
}, V5 = {
  ...qp,
  name: "VTooltip",
  vPopperTheme: "tooltip"
}, j5 = K({
  name: "VTooltipDirective",
  components: {
    Popper: f2(),
    PopperContent: v2
  },
  mixins: [
    y2
  ],
  inheritAttrs: !1,
  props: {
    theme: {
      type: String,
      default: "tooltip"
    },
    html: {
      type: Boolean,
      default: (e) => fs(e.theme, "html")
    },
    content: {
      type: [String, Number, Function],
      default: null
    },
    loadingContent: {
      type: String,
      default: (e) => fs(e.theme, "loadingContent")
    },
    targetNodes: {
      type: Function,
      required: !0
    }
  },
  data() {
    return {
      asyncContent: null
    };
  },
  computed: {
    isContentAsync() {
      return typeof this.content == "function";
    },
    loading() {
      return this.isContentAsync && this.asyncContent == null;
    },
    finalContent() {
      return this.isContentAsync ? this.loading ? this.loadingContent : this.asyncContent : this.content;
    }
  },
  watch: {
    content: {
      handler() {
        this.fetchContent(!0);
      },
      immediate: !0
    },
    async finalContent() {
      await this.$nextTick(), this.$refs.popper.onResize();
    }
  },
  created() {
    this.$_fetchId = 0;
  },
  methods: {
    fetchContent(e) {
      if (typeof this.content == "function" && this.$_isShown && (e || !this.$_loading && this.asyncContent == null)) {
        this.asyncContent = null, this.$_loading = !0;
        const l = ++this.$_fetchId, n = this.content(this);
        n.then ? n.then((t) => this.onResult(l, t)) : this.onResult(l, n);
      }
    },
    onResult(e, l) {
      e === this.$_fetchId && (this.$_loading = !1, this.asyncContent = l);
    },
    onShow() {
      this.$_isShown = !0, this.fetchContent();
    },
    onHide() {
      this.$_isShown = !1;
    }
  }
}), U5 = ["innerHTML"], W5 = ["textContent"];
function G5(e, l, n, t, u, i) {
  const s = Bl("PopperContent"), r = Bl("Popper");
  return y(), L(r, ml({ ref: "popper" }, e.$attrs, {
    theme: e.theme,
    "target-nodes": e.targetNodes,
    "popper-node": () => e.$refs.popperContent.$el,
    onApplyShow: e.onShow,
    onApplyHide: e.onHide
  }), {
    default: U(({
      popperId: o,
      isShown: a,
      shouldMountContent: d,
      skipTransition: h,
      autoHide: p,
      hide: f,
      handleResize: m,
      onResize: g,
      classes: v,
      result: w
    }) => [
      R(s, {
        ref: "popperContent",
        class: z({
          "v-popper--tooltip-loading": e.loading
        }),
        "popper-id": o,
        theme: e.theme,
        shown: a,
        mounted: d,
        "skip-transition": h,
        "auto-hide": p,
        "handle-resize": m,
        classes: v,
        result: w,
        onHide: f,
        onResize: g
      }, {
        default: U(() => [
          e.html ? (y(), O("div", {
            key: 0,
            innerHTML: e.finalContent
          }, null, 8, U5)) : (y(), O("div", {
            key: 1,
            textContent: B(e.finalContent)
          }, null, 8, W5))
        ]),
        _: 2
      }, 1032, ["class", "popper-id", "theme", "shown", "mounted", "skip-transition", "auto-hide", "handle-resize", "classes", "result", "onHide", "onResize"])
    ]),
    _: 1
  }, 16, ["theme", "target-nodes", "popper-node", "onApplyShow", "onApplyHide"]);
}
const K5 = /* @__PURE__ */ No(j5, [["render", G5]]), $2 = "v-popper--has-tooltip";
function Y5(e, l) {
  let n = e.placement;
  if (!n && l)
    for (const t of p2)
      l[t] && (n = t);
  return n || (n = fs(e.theme || "tooltip", "placement")), n;
}
function b2(e, l, n) {
  let t;
  const u = typeof l;
  return u === "string" ? t = { content: l } : l && u === "object" ? t = l : t = { content: !1 }, t.placement = Y5(t, n), t.targetNodes = () => [e], t.referenceNode = () => e, t;
}
let Sa, ms, q5 = 0;
function J5() {
  if (Sa)
    return;
  ms = J([]), Sa = Wy({
    name: "VTooltipDirectiveApp",
    setup() {
      return {
        directives: ms
      };
    },
    render() {
      return this.directives.map((l) => ye(K5, {
        ...l.options,
        shown: l.shown || l.options.shown,
        key: l.id
      }));
    },
    devtools: {
      hide: !0
    }
  });
  const e = document.createElement("div");
  document.body.appendChild(e), Sa.mount(e);
}
function Z5(e, l, n) {
  J5();
  const t = J(b2(e, l, n)), u = J(!1), i = {
    id: q5++,
    options: t,
    shown: u
  };
  return ms.value.push(i), e.classList && e.classList.add($2), e.$_popper = {
    options: t,
    item: i,
    show() {
      u.value = !0;
    },
    hide() {
      u.value = !1;
    }
  };
}
function w2(e) {
  if (e.$_popper) {
    const l = ms.value.indexOf(e.$_popper.item);
    l !== -1 && ms.value.splice(l, 1), delete e.$_popper, delete e.$_popperOldShown, delete e.$_popperMountTarget;
  }
  e.classList && e.classList.remove($2);
}
function W1(e, { value: l, modifiers: n }) {
  const t = b2(e, l, n);
  if (!t.content || fs(t.theme || "tooltip", "disabled"))
    w2(e);
  else {
    let u;
    e.$_popper ? (u = e.$_popper, u.options.value = t) : u = Z5(e, l, n), typeof l.shown < "u" && l.shown !== e.$_popperOldShown && (e.$_popperOldShown = l.shown, l.shown ? u.show() : u.hide());
  }
}
const X5 = {
  beforeMount: W1,
  updated: W1,
  beforeUnmount(e) {
    w2(e);
  }
};
function G1(e) {
  e.addEventListener("mousedown", Mr), e.addEventListener("click", Mr), e.addEventListener("touchstart", _2, mi ? {
    passive: !0
  } : !1);
}
function K1(e) {
  e.removeEventListener("mousedown", Mr), e.removeEventListener("click", Mr), e.removeEventListener("touchstart", _2), e.removeEventListener("touchend", S2), e.removeEventListener("touchcancel", C2);
}
function Mr(e) {
  const l = e.currentTarget;
  e.closePopover = !l.$_vclosepopover_touch, e.closeAllPopover = l.$_closePopoverModifiers && !!l.$_closePopoverModifiers.all;
}
function _2(e) {
  if (e.changedTouches.length === 1) {
    const l = e.currentTarget;
    l.$_vclosepopover_touch = !0;
    const n = e.changedTouches[0];
    l.$_vclosepopover_touchPoint = n, l.addEventListener("touchend", S2), l.addEventListener("touchcancel", C2);
  }
}
function S2(e) {
  const l = e.currentTarget;
  if (l.$_vclosepopover_touch = !1, e.changedTouches.length === 1) {
    const n = e.changedTouches[0], t = l.$_vclosepopover_touchPoint;
    e.closePopover = Math.abs(n.screenY - t.screenY) < 20 && Math.abs(n.screenX - t.screenX) < 20, e.closeAllPopover = l.$_closePopoverModifiers && !!l.$_closePopoverModifiers.all;
  }
}
function C2(e) {
  const l = e.currentTarget;
  l.$_vclosepopover_touch = !1;
}
const Q5 = {
  beforeMount(e, { value: l, modifiers: n }) {
    e.$_closePopoverModifiers = n, (typeof l > "u" || l) && G1(e);
  },
  updated(e, { value: l, oldValue: n, modifiers: t }) {
    e.$_closePopoverModifiers = t, l !== n && (typeof l > "u" || l ? G1(e) : K1(e));
  },
  beforeUnmount(e) {
    K1(e);
  }
};
function l6(e, l = {}) {
  e.$_vTooltipInstalled || (e.$_vTooltipInstalled = !0, c2(Pe, l), e.directive("tooltip", X5), e.directive("close-popper", Q5), e.component("VTooltip", V5), e.component("VDropdown", H5), e.component("VMenu", z5));
}
const n6 = {
  // eslint-disable-next-line no-undef
  version: "5.2.2",
  install: l6,
  options: Pe
};
function e6() {
  return T2().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function T2() {
  return typeof navigator < "u" && typeof window < "u" ? window : typeof global < "u" ? global : {};
}
const t6 = typeof Proxy == "function", u6 = "devtools-plugin:setup", i6 = "plugin:settings:set";
let Gu, Ic;
function s6() {
  var e;
  return Gu !== void 0 || (typeof window < "u" && window.performance ? (Gu = !0, Ic = window.performance) : typeof global < "u" && (!((e = global.perf_hooks) === null || e === void 0) && e.performance) ? (Gu = !0, Ic = global.perf_hooks.performance) : Gu = !1), Gu;
}
function r6() {
  return s6() ? Ic.now() : Date.now();
}
class o6 {
  constructor(l, n) {
    this.target = null, this.targetQueue = [], this.onQueue = [], this.plugin = l, this.hook = n;
    const t = {};
    if (l.settings)
      for (const s in l.settings) {
        const r = l.settings[s];
        t[s] = r.defaultValue;
      }
    const u = `__vue-devtools-plugin-settings__${l.id}`;
    let i = Object.assign({}, t);
    try {
      const s = localStorage.getItem(u), r = JSON.parse(s);
      Object.assign(i, r);
    } catch {
    }
    this.fallbacks = {
      getSettings() {
        return i;
      },
      setSettings(s) {
        try {
          localStorage.setItem(u, JSON.stringify(s));
        } catch {
        }
        i = s;
      },
      now() {
        return r6();
      }
    }, n && n.on(i6, (s, r) => {
      s === this.plugin.id && this.fallbacks.setSettings(r);
    }), this.proxiedOn = new Proxy({}, {
      get: (s, r) => this.target ? this.target.on[r] : (...o) => {
        this.onQueue.push({
          method: r,
          args: o
        });
      }
    }), this.proxiedTarget = new Proxy({}, {
      get: (s, r) => this.target ? this.target[r] : r === "on" ? this.proxiedOn : Object.keys(this.fallbacks).includes(r) ? (...o) => (this.targetQueue.push({
        method: r,
        args: o,
        resolve: () => {
        }
      }), this.fallbacks[r](...o)) : (...o) => new Promise((a) => {
        this.targetQueue.push({
          method: r,
          args: o,
          resolve: a
        });
      })
    });
  }
  async setRealTarget(l) {
    this.target = l;
    for (const n of this.onQueue)
      this.target.on[n.method](...n.args);
    for (const n of this.targetQueue)
      n.resolve(await this.target[n.method](...n.args));
  }
}
function a6(e, l) {
  const n = e, t = T2(), u = e6(), i = t6 && n.enableEarlyProxy;
  if (u && (t.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !i))
    u.emit(u6, e, l);
  else {
    const s = i ? new o6(n, u) : null;
    (t.__VUE_DEVTOOLS_PLUGINS__ = t.__VUE_DEVTOOLS_PLUGINS__ || []).push({
      pluginDescriptor: n,
      setupFn: l,
      proxy: s
    }), s && l(s.proxiedTarget);
  }
}
const d6 = [{
  code: "AD",
  name: "Andorra",
  areaCode: "376"
}, {
  code: "AE",
  name: "United Arab Emirates",
  areaCode: "971"
}, {
  code: "AF",
  name: "Afghanistan",
  areaCode: "93"
}, {
  code: "AG",
  name: "Antigua and Barbuda",
  areaCode: "1-268"
}, {
  code: "AI",
  name: "Anguilla",
  areaCode: "1-264"
}, {
  code: "AL",
  name: "Albania",
  areaCode: "355"
}, {
  code: "AM",
  name: "Armenia",
  areaCode: "374"
}, {
  code: "AN",
  name: "Netherlands Antilles",
  areaCode: "599"
}, {
  code: "AO",
  name: "Angola",
  areaCode: "244"
}, {
  code: "AQ",
  name: "Antarctica",
  areaCode: "672"
}, {
  code: "AR",
  name: "Argentina",
  areaCode: "54"
}, {
  code: "AS",
  name: "American Samoa",
  areaCode: "1-684"
}, {
  code: "AT",
  name: "Austria",
  areaCode: "43"
}, {
  code: "AU",
  name: "Australia",
  areaCode: "61"
}, {
  code: "AW",
  name: "Aruba",
  areaCode: "297"
}, {
  code: "AZ",
  name: "Azerbaijan",
  areaCode: "994"
}, {
  code: "BA",
  name: "Bosnia and Herzegovina",
  areaCode: "387"
}, {
  code: "BB",
  name: "Barbados",
  areaCode: "1-246"
}, {
  code: "BD",
  name: "Bangladesh",
  areaCode: "880"
}, {
  code: "BE",
  name: "Belgium",
  areaCode: "32"
}, {
  code: "BF",
  name: "Burkina Faso",
  areaCode: "226"
}, {
  code: "BG",
  name: "Bulgaria",
  areaCode: "359"
}, {
  code: "BH",
  name: "Bahrain",
  areaCode: "973"
}, {
  code: "BI",
  name: "Burundi",
  areaCode: "257"
}, {
  code: "BJ",
  name: "Benin",
  areaCode: "229"
}, {
  code: "BL",
  name: "Saint Barthelemy",
  areaCode: "590"
}, {
  code: "BM",
  name: "Bermuda",
  areaCode: "1-441"
}, {
  code: "BN",
  name: "Brunei",
  areaCode: "673"
}, {
  code: "BO",
  name: "Bolivia",
  areaCode: "591"
}, {
  code: "BR",
  name: "Brazil",
  areaCode: "55"
}, {
  code: "BS",
  name: "Bahamas",
  areaCode: "1-242"
}, {
  code: "BT",
  name: "Bhutan",
  areaCode: "975"
}, {
  code: "BW",
  name: "Botswana",
  areaCode: "267"
}, {
  code: "BY",
  name: "Belarus",
  areaCode: "375"
}, {
  code: "BZ",
  name: "Belize",
  areaCode: "501"
}, {
  code: "CA",
  name: "Canada",
  areaCode: "1"
}, {
  code: "CC",
  name: "Cocos Islands",
  areaCode: "61"
}, {
  code: "CD",
  name: "Democratic Republic of the Congo",
  areaCode: "243"
}, {
  code: "CF",
  name: "Central African Republic",
  areaCode: "236"
}, {
  code: "CG",
  name: "Republic of the Congo",
  areaCode: "242"
}, {
  code: "CH",
  name: "Switzerland",
  areaCode: "41"
}, {
  code: "CI",
  name: "Ivory Coast",
  areaCode: "225"
}, {
  code: "CK",
  name: "Cook Islands",
  areaCode: "682"
}, {
  code: "CL",
  name: "Chile",
  areaCode: "56"
}, {
  code: "CM",
  name: "Cameroon",
  areaCode: "237"
}, {
  code: "CN",
  name: "China",
  areaCode: "86"
}, {
  code: "CO",
  name: "Colombia",
  areaCode: "57"
}, {
  code: "CR",
  name: "Costa Rica",
  areaCode: "506"
}, {
  code: "CU",
  name: "Cuba",
  areaCode: "53"
}, {
  code: "CV",
  name: "Cape Verde",
  areaCode: "238"
}, {
  code: "CW",
  name: "Curacao",
  areaCode: "599"
}, {
  code: "CX",
  name: "Christmas Island",
  areaCode: "61"
}, {
  code: "CY",
  name: "Cyprus",
  areaCode: "357"
}, {
  code: "CZ",
  name: "Czech Republic",
  areaCode: "420"
}, {
  code: "DE",
  name: "Germany",
  areaCode: "49"
}, {
  code: "DJ",
  name: "Djibouti",
  areaCode: "253"
}, {
  code: "DK",
  name: "Denmark",
  areaCode: "45"
}, {
  code: "DM",
  name: "Dominica",
  areaCode: "1-767"
}, {
  code: "DO",
  name: "Dominican Republic",
  areaCode: "1-809"
}, {
  code: "DO",
  name: "Dominican Republic",
  areaCode: "1-829"
}, {
  code: "DO",
  name: "Dominican Republic",
  areaCode: "1-849"
}, {
  code: "DZ",
  name: "Algeria",
  areaCode: "213"
}, {
  code: "EC",
  name: "Ecuador",
  areaCode: "593"
}, {
  code: "EE",
  name: "Estonia",
  areaCode: "372"
}, {
  code: "EG",
  name: "Egypt",
  areaCode: "20"
}, {
  code: "EH",
  name: "Western Sahara",
  areaCode: "212"
}, {
  code: "ER",
  name: "Eritrea",
  areaCode: "291"
}, {
  code: "ES",
  name: "Spain",
  areaCode: "34"
}, {
  code: "ET",
  name: "Ethiopia",
  areaCode: "251"
}, {
  code: "FI",
  name: "Finland",
  areaCode: "358"
}, {
  code: "FJ",
  name: "Fiji",
  areaCode: "679"
}, {
  code: "FK",
  name: "Falkland Islands",
  areaCode: "500"
}, {
  code: "FM",
  name: "Micronesia",
  areaCode: "691"
}, {
  code: "FO",
  name: "Faroe Islands",
  areaCode: "298"
}, {
  code: "FR",
  name: "France",
  areaCode: "33"
}, {
  code: "GA",
  name: "Gabon",
  areaCode: "241"
}, {
  code: "GB",
  name: "United Kingdom",
  areaCode: "44"
}, {
  code: "GD",
  name: "Grenada",
  areaCode: "1-473"
}, {
  code: "GE",
  name: "Georgia",
  areaCode: "995"
}, {
  code: "GF",
  name: "French Guyana",
  areaCode: "594"
}, {
  code: "GG",
  name: "Guernsey",
  areaCode: "44-1481"
}, {
  code: "GH",
  name: "Ghana",
  areaCode: "233"
}, {
  code: "GI",
  name: "Gibraltar",
  areaCode: "350"
}, {
  code: "GL",
  name: "Greenland",
  areaCode: "299"
}, {
  code: "GM",
  name: "Gambia",
  areaCode: "220"
}, {
  code: "GN",
  name: "Guinea",
  areaCode: "224"
}, {
  code: "GP",
  name: "Guadeloupe",
  areaCode: "590"
}, {
  code: "GQ",
  name: "Equatorial Guinea",
  areaCode: "240"
}, {
  code: "GR",
  name: "Greece",
  areaCode: "30"
}, {
  code: "GT",
  name: "Guatemala",
  areaCode: "502"
}, {
  code: "GU",
  name: "Guam",
  areaCode: "1-671"
}, {
  code: "GW",
  name: "Guinea-Bissau",
  areaCode: "245"
}, {
  code: "GY",
  name: "Guyana",
  areaCode: "592"
}, {
  code: "HK",
  name: "Hong Kong",
  areaCode: "852"
}, {
  code: "HN",
  name: "Honduras",
  areaCode: "504"
}, {
  code: "HR",
  name: "Croatia",
  areaCode: "385"
}, {
  code: "HT",
  name: "Haiti",
  areaCode: "509"
}, {
  code: "HU",
  name: "Hungary",
  areaCode: "36"
}, {
  code: "ID",
  name: "Indonesia",
  areaCode: "62"
}, {
  code: "IE",
  name: "Ireland",
  areaCode: "353"
}, {
  code: "IL",
  name: "Israel",
  areaCode: "972"
}, {
  code: "IM",
  name: "Isle of Man",
  areaCode: "44-1624"
}, {
  code: "IN",
  name: "India",
  areaCode: "91"
}, {
  code: "IO",
  name: "British Indian Ocean Territory",
  areaCode: "246"
}, {
  code: "IQ",
  name: "Iraq",
  areaCode: "964"
}, {
  code: "IR",
  name: "Iran",
  areaCode: "98"
}, {
  code: "IS",
  name: "Iceland",
  areaCode: "354"
}, {
  code: "IT",
  name: "Italy",
  areaCode: "39"
}, {
  code: "JE",
  name: "Jersey",
  areaCode: "44-1534"
}, {
  code: "JM",
  name: "Jamaica",
  areaCode: "1-876"
}, {
  code: "JO",
  name: "Jordan",
  areaCode: "962"
}, {
  code: "JP",
  name: "Japan",
  areaCode: "81"
}, {
  code: "KE",
  name: "Kenya",
  areaCode: "254"
}, {
  code: "KG",
  name: "Kyrgyzstan",
  areaCode: "996"
}, {
  code: "KH",
  name: "Cambodia",
  areaCode: "855"
}, {
  code: "KI",
  name: "Kiribati",
  areaCode: "686"
}, {
  code: "KM",
  name: "Comoros",
  areaCode: "269"
}, {
  code: "KN",
  name: "Saint Kitts and Nevis",
  areaCode: "1-869"
}, {
  code: "KP",
  name: "North Korea",
  areaCode: "850"
}, {
  code: "KR",
  name: "South Korea",
  areaCode: "82"
}, {
  code: "KW",
  name: "Kuwait",
  areaCode: "965"
}, {
  code: "KY",
  name: "Cayman Islands",
  areaCode: "1-345"
}, {
  code: "KZ",
  name: "Kazakhstan",
  areaCode: "7"
}, {
  code: "LA",
  name: "Laos",
  areaCode: "856"
}, {
  code: "LB",
  name: "Lebanon",
  areaCode: "961"
}, {
  code: "LC",
  name: "Saint Lucia",
  areaCode: "1-758"
}, {
  code: "LI",
  name: "Liechtenstein",
  areaCode: "423"
}, {
  code: "LK",
  name: "Sri Lanka",
  areaCode: "94"
}, {
  code: "LR",
  name: "Liberia",
  areaCode: "231"
}, {
  code: "LS",
  name: "Lesotho",
  areaCode: "266"
}, {
  code: "LT",
  name: "Lithuania",
  areaCode: "370"
}, {
  code: "LU",
  name: "Luxembourg",
  areaCode: "352"
}, {
  code: "LV",
  name: "Latvia",
  areaCode: "371"
}, {
  code: "LY",
  name: "Libya",
  areaCode: "218"
}, {
  code: "MA",
  name: "Morocco",
  areaCode: "212"
}, {
  code: "MC",
  name: "Monaco",
  areaCode: "377"
}, {
  code: "MD",
  name: "Moldova",
  areaCode: "373"
}, {
  code: "ME",
  name: "Montenegro",
  areaCode: "382"
}, {
  code: "MF",
  name: "Saint Martin",
  areaCode: "590"
}, {
  code: "MG",
  name: "Madagascar",
  areaCode: "261"
}, {
  code: "MH",
  name: "Marshall Islands",
  areaCode: "692"
}, {
  code: "MK",
  name: "Macedonia",
  areaCode: "389"
}, {
  code: "ML",
  name: "Mali",
  areaCode: "223"
}, {
  code: "MM",
  name: "Myanmar",
  areaCode: "95"
}, {
  code: "MN",
  name: "Mongolia",
  areaCode: "976"
}, {
  code: "MO",
  name: "Macau",
  areaCode: "853"
}, {
  code: "MP",
  name: "Northern Mariana Islands",
  areaCode: "1-670"
}, {
  code: "MQ",
  name: "Martinique",
  areaCode: "596"
}, {
  code: "MR",
  name: "Mauritania",
  areaCode: "222"
}, {
  code: "MS",
  name: "Montserrat",
  areaCode: "1-664"
}, {
  code: "MT",
  name: "Malta",
  areaCode: "356"
}, {
  code: "MU",
  name: "Mauritius",
  areaCode: "230"
}, {
  code: "MV",
  name: "Maldives",
  areaCode: "960"
}, {
  code: "MW",
  name: "Malawi",
  areaCode: "265"
}, {
  code: "MX",
  name: "Mexico",
  areaCode: "52"
}, {
  code: "MY",
  name: "Malaysia",
  areaCode: "60"
}, {
  code: "MZ",
  name: "Mozambique",
  areaCode: "258"
}, {
  code: "NA",
  name: "Namibia",
  areaCode: "264"
}, {
  code: "NC",
  name: "New Caledonia",
  areaCode: "687"
}, {
  code: "NE",
  name: "Niger",
  areaCode: "227"
}, {
  code: "NG",
  name: "Nigeria",
  areaCode: "234"
}, {
  code: "NI",
  name: "Nicaragua",
  areaCode: "505"
}, {
  code: "NL",
  name: "Netherlands",
  areaCode: "31"
}, {
  code: "NO",
  name: "Norway",
  areaCode: "47"
}, {
  code: "NP",
  name: "Nepal",
  areaCode: "977"
}, {
  code: "NR",
  name: "Nauru",
  areaCode: "674"
}, {
  code: "NU",
  name: "Niue",
  areaCode: "683"
}, {
  code: "NZ",
  name: "New Zealand",
  areaCode: "64"
}, {
  code: "OM",
  name: "Oman",
  areaCode: "968"
}, {
  code: "PA",
  name: "Panama",
  areaCode: "507"
}, {
  code: "PE",
  name: "Peru",
  areaCode: "51"
}, {
  code: "PF",
  name: "French Polynesia",
  areaCode: "689"
}, {
  code: "PG",
  name: "Papua New Guinea",
  areaCode: "675"
}, {
  code: "PH",
  name: "Philippines",
  areaCode: "63"
}, {
  code: "PK",
  name: "Pakistan",
  areaCode: "92"
}, {
  code: "PL",
  name: "Poland",
  areaCode: "48"
}, {
  code: "PM",
  name: "Saint Pierre and Miquelon",
  areaCode: "508"
}, {
  code: "PN",
  name: "Pitcairn",
  areaCode: "64"
}, {
  code: "PR",
  name: "Puerto Rico",
  areaCode: "1-787"
}, {
  code: "PR",
  name: "Puerto Rico",
  areaCode: "1-939"
}, {
  code: "PS",
  name: "Palestine",
  areaCode: "970"
}, {
  code: "PT",
  name: "Portugal",
  areaCode: "351"
}, {
  code: "PW",
  name: "Palau",
  areaCode: "680"
}, {
  code: "PY",
  name: "Paraguay",
  areaCode: "595"
}, {
  code: "QA",
  name: "Qatar",
  areaCode: "974"
}, {
  code: "RE",
  name: "Reunion",
  areaCode: "262"
}, {
  code: "RO",
  name: "Romania",
  areaCode: "40"
}, {
  code: "RS",
  name: "Serbia",
  areaCode: "381"
}, {
  code: "RU",
  name: "Russia",
  areaCode: "7"
}, {
  code: "RW",
  name: "Rwanda",
  areaCode: "250"
}, {
  code: "SA",
  name: "Saudi Arabia",
  areaCode: "966"
}, {
  code: "SB",
  name: "Solomon Islands",
  areaCode: "677"
}, {
  code: "SC",
  name: "Seychelles",
  areaCode: "248"
}, {
  code: "SD",
  name: "Sudan",
  areaCode: "249"
}, {
  code: "SE",
  name: "Sweden",
  areaCode: "46"
}, {
  code: "SG",
  name: "Singapore",
  areaCode: "65"
}, {
  code: "SH",
  name: "Saint Helena",
  areaCode: "290"
}, {
  code: "SI",
  name: "Slovenia",
  areaCode: "386"
}, {
  code: "SJ",
  name: "Svalbard and Jan Mayen",
  areaCode: "47"
}, {
  code: "SK",
  name: "Slovakia",
  areaCode: "421"
}, {
  code: "SL",
  name: "Sierra Leone",
  areaCode: "232"
}, {
  code: "SM",
  name: "San Marino",
  areaCode: "378"
}, {
  code: "SN",
  name: "Senegal",
  areaCode: "221"
}, {
  code: "SO",
  name: "Somalia",
  areaCode: "252"
}, {
  code: "SR",
  name: "Suriname",
  areaCode: "597"
}, {
  code: "SS",
  name: "South Sudan",
  areaCode: "211"
}, {
  code: "ST",
  name: "Sao Tome and Principe",
  areaCode: "239"
}, {
  code: "SV",
  name: "El Salvador",
  areaCode: "503"
}, {
  code: "SX",
  name: "Sint Maarten",
  areaCode: "1-721"
}, {
  code: "SY",
  name: "Syria",
  areaCode: "963"
}, {
  code: "SZ",
  name: "Swaziland",
  areaCode: "268"
}, {
  code: "TC",
  name: "Turks and Caicos Islands",
  areaCode: "1-649"
}, {
  code: "TD",
  name: "Chad",
  areaCode: "235"
}, {
  code: "TG",
  name: "Togo",
  areaCode: "228"
}, {
  code: "TH",
  name: "Thailand",
  areaCode: "66"
}, {
  code: "TJ",
  name: "Tajikistan",
  areaCode: "992"
}, {
  code: "TK",
  name: "Tokelau",
  areaCode: "690"
}, {
  code: "TL",
  name: "East Timor",
  areaCode: "670"
}, {
  code: "TM",
  name: "Turkmenistan",
  areaCode: "993"
}, {
  code: "TN",
  name: "Tunisia",
  areaCode: "216"
}, {
  code: "TO",
  name: "Tonga",
  areaCode: "676"
}, {
  code: "TR",
  name: "Turkey",
  areaCode: "90"
}, {
  code: "TT",
  name: "Trinidad and Tobago",
  areaCode: "1-868"
}, {
  code: "TV",
  name: "Tuvalu",
  areaCode: "688"
}, {
  code: "TW",
  name: "Taiwan",
  areaCode: "886"
}, {
  code: "TZ",
  name: "Tanzania",
  areaCode: "255"
}, {
  code: "UA",
  name: "Ukraine",
  areaCode: "380"
}, {
  code: "UG",
  name: "Uganda",
  areaCode: "256"
}, {
  code: "US",
  name: "United States",
  areaCode: "1"
}, {
  code: "UY",
  name: "Uruguay",
  areaCode: "598"
}, {
  code: "UZ",
  name: "Uzbekistan",
  areaCode: "998"
}, {
  code: "VA",
  name: "Vatican",
  areaCode: "379"
}, {
  code: "VC",
  name: "Saint Vincent and the Grenadines",
  areaCode: "1-784"
}, {
  code: "VE",
  name: "Venezuela",
  areaCode: "58"
}, {
  code: "VG",
  name: "British Virgin Islands",
  areaCode: "1-284"
}, {
  code: "VI",
  name: "U.S. Virgin Islands",
  areaCode: "1-340"
}, {
  code: "VN",
  name: "Vietnam",
  areaCode: "84"
}, {
  code: "VU",
  name: "Vanuatu",
  areaCode: "678"
}, {
  code: "WF",
  name: "Wallis and Futuna",
  areaCode: "681"
}, {
  code: "WS",
  name: "Samoa",
  areaCode: "685"
}, {
  code: "XK",
  name: "Kosovo",
  areaCode: "383"
}, {
  code: "YE",
  name: "Yemen",
  areaCode: "967"
}, {
  code: "YT",
  name: "Mayotte",
  areaCode: "262"
}, {
  code: "ZA",
  name: "South Africa",
  areaCode: "27"
}, {
  code: "ZM",
  name: "Zambia",
  areaCode: "260"
}, {
  code: "ZW",
  name: "Zimbabwe",
  areaCode: "263"
}], c6 = d6;
var mr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function h6(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function p6(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var O2 = { exports: {} };
(function(e, l) {
  (function(n, t) {
    typeof p6 == "function" ? e.exports = t() : n.pluralize = t();
  })(mr, function() {
    var n = [], t = [], u = {}, i = {}, s = {};
    function r(g) {
      return typeof g == "string" ? new RegExp("^" + g + "$", "i") : g;
    }
    function o(g, v) {
      return g === v ? v : g === g.toLowerCase() ? v.toLowerCase() : g === g.toUpperCase() ? v.toUpperCase() : g[0] === g[0].toUpperCase() ? v.charAt(0).toUpperCase() + v.substr(1).toLowerCase() : v.toLowerCase();
    }
    function a(g, v) {
      return g.replace(/\$(\d{1,2})/g, function(w, $) {
        return v[$] || "";
      });
    }
    function d(g, v) {
      return g.replace(v[0], function(w, $) {
        var _ = a(v[1], arguments);
        return o(w === "" ? g[$ - 1] : w, _);
      });
    }
    function h(g, v, w) {
      if (!g.length || u.hasOwnProperty(g))
        return v;
      for (var $ = w.length; $--; ) {
        var _ = w[$];
        if (_[0].test(v))
          return d(v, _);
      }
      return v;
    }
    function p(g, v, w) {
      return function($) {
        var _ = $.toLowerCase();
        return v.hasOwnProperty(_) ? o($, _) : g.hasOwnProperty(_) ? o($, g[_]) : h(_, $, w);
      };
    }
    function f(g, v, w, $) {
      return function(_) {
        var b = _.toLowerCase();
        return v.hasOwnProperty(b) ? !0 : g.hasOwnProperty(b) ? !1 : h(b, b, w) === b;
      };
    }
    function m(g, v, w) {
      var $ = v === 1 ? m.singular(g) : m.plural(g);
      return (w ? v + " " : "") + $;
    }
    return m.plural = p(
      s,
      i,
      n
    ), m.isPlural = f(
      s,
      i,
      n
    ), m.singular = p(
      i,
      s,
      t
    ), m.isSingular = f(
      i,
      s,
      t
    ), m.addPluralRule = function(g, v) {
      n.push([r(g), v]);
    }, m.addSingularRule = function(g, v) {
      t.push([r(g), v]);
    }, m.addUncountableRule = function(g) {
      if (typeof g == "string") {
        u[g.toLowerCase()] = !0;
        return;
      }
      m.addPluralRule(g, "$0"), m.addSingularRule(g, "$0");
    }, m.addIrregularRule = function(g, v) {
      v = v.toLowerCase(), g = g.toLowerCase(), s[g] = v, i[v] = g;
    }, [
      // Pronouns.
      ["I", "we"],
      ["me", "us"],
      ["he", "they"],
      ["she", "they"],
      ["them", "them"],
      ["myself", "ourselves"],
      ["yourself", "yourselves"],
      ["itself", "themselves"],
      ["herself", "themselves"],
      ["himself", "themselves"],
      ["themself", "themselves"],
      ["is", "are"],
      ["was", "were"],
      ["has", "have"],
      ["this", "these"],
      ["that", "those"],
      // Words ending in with a consonant and `o`.
      ["echo", "echoes"],
      ["dingo", "dingoes"],
      ["volcano", "volcanoes"],
      ["tornado", "tornadoes"],
      ["torpedo", "torpedoes"],
      // Ends with `us`.
      ["genus", "genera"],
      ["viscus", "viscera"],
      // Ends with `ma`.
      ["stigma", "stigmata"],
      ["stoma", "stomata"],
      ["dogma", "dogmata"],
      ["lemma", "lemmata"],
      ["schema", "schemata"],
      ["anathema", "anathemata"],
      // Other irregular rules.
      ["ox", "oxen"],
      ["axe", "axes"],
      ["die", "dice"],
      ["yes", "yeses"],
      ["foot", "feet"],
      ["eave", "eaves"],
      ["goose", "geese"],
      ["tooth", "teeth"],
      ["quiz", "quizzes"],
      ["human", "humans"],
      ["proof", "proofs"],
      ["carve", "carves"],
      ["valve", "valves"],
      ["looey", "looies"],
      ["thief", "thieves"],
      ["groove", "grooves"],
      ["pickaxe", "pickaxes"],
      ["passerby", "passersby"]
    ].forEach(function(g) {
      return m.addIrregularRule(g[0], g[1]);
    }), [
      [/s?$/i, "s"],
      [/[^\u0000-\u007F]$/i, "$0"],
      [/([^aeiou]ese)$/i, "$1"],
      [/(ax|test)is$/i, "$1es"],
      [/(alias|[^aou]us|t[lm]as|gas|ris)$/i, "$1es"],
      [/(e[mn]u)s?$/i, "$1s"],
      [/([^l]ias|[aeiou]las|[ejzr]as|[iu]am)$/i, "$1"],
      [/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, "$1i"],
      [/(alumn|alg|vertebr)(?:a|ae)$/i, "$1ae"],
      [/(seraph|cherub)(?:im)?$/i, "$1im"],
      [/(her|at|gr)o$/i, "$1oes"],
      [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|automat|quor)(?:a|um)$/i, "$1a"],
      [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)(?:a|on)$/i, "$1a"],
      [/sis$/i, "ses"],
      [/(?:(kni|wi|li)fe|(ar|l|ea|eo|oa|hoo)f)$/i, "$1$2ves"],
      [/([^aeiouy]|qu)y$/i, "$1ies"],
      [/([^ch][ieo][ln])ey$/i, "$1ies"],
      [/(x|ch|ss|sh|zz)$/i, "$1es"],
      [/(matr|cod|mur|sil|vert|ind|append)(?:ix|ex)$/i, "$1ices"],
      [/\b((?:tit)?m|l)(?:ice|ouse)$/i, "$1ice"],
      [/(pe)(?:rson|ople)$/i, "$1ople"],
      [/(child)(?:ren)?$/i, "$1ren"],
      [/eaux$/i, "$0"],
      [/m[ae]n$/i, "men"],
      ["thou", "you"]
    ].forEach(function(g) {
      return m.addPluralRule(g[0], g[1]);
    }), [
      [/s$/i, ""],
      [/(ss)$/i, "$1"],
      [/(wi|kni|(?:after|half|high|low|mid|non|night|[^\w]|^)li)ves$/i, "$1fe"],
      [/(ar|(?:wo|[ae])l|[eo][ao])ves$/i, "$1f"],
      [/ies$/i, "y"],
      [/\b([pl]|zomb|(?:neck|cross)?t|coll|faer|food|gen|goon|group|lass|talk|goal|cut)ies$/i, "$1ie"],
      [/\b(mon|smil)ies$/i, "$1ey"],
      [/\b((?:tit)?m|l)ice$/i, "$1ouse"],
      [/(seraph|cherub)im$/i, "$1"],
      [/(x|ch|ss|sh|zz|tto|go|cho|alias|[^aou]us|t[lm]as|gas|(?:her|at|gr)o|[aeiou]ris)(?:es)?$/i, "$1"],
      [/(analy|diagno|parenthe|progno|synop|the|empha|cri|ne)(?:sis|ses)$/i, "$1sis"],
      [/(movie|twelve|abuse|e[mn]u)s$/i, "$1"],
      [/(test)(?:is|es)$/i, "$1is"],
      [/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, "$1us"],
      [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|quor)a$/i, "$1um"],
      [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)a$/i, "$1on"],
      [/(alumn|alg|vertebr)ae$/i, "$1a"],
      [/(cod|mur|sil|vert|ind)ices$/i, "$1ex"],
      [/(matr|append)ices$/i, "$1ix"],
      [/(pe)(rson|ople)$/i, "$1rson"],
      [/(child)ren$/i, "$1"],
      [/(eau)x?$/i, "$1"],
      [/men$/i, "man"]
    ].forEach(function(g) {
      return m.addSingularRule(g[0], g[1]);
    }), [
      // Singular words with no plurals.
      "adulthood",
      "advice",
      "agenda",
      "aid",
      "aircraft",
      "alcohol",
      "ammo",
      "analytics",
      "anime",
      "athletics",
      "audio",
      "bison",
      "blood",
      "bream",
      "buffalo",
      "butter",
      "carp",
      "cash",
      "chassis",
      "chess",
      "clothing",
      "cod",
      "commerce",
      "cooperation",
      "corps",
      "debris",
      "diabetes",
      "digestion",
      "elk",
      "energy",
      "equipment",
      "excretion",
      "expertise",
      "firmware",
      "flounder",
      "fun",
      "gallows",
      "garbage",
      "graffiti",
      "hardware",
      "headquarters",
      "health",
      "herpes",
      "highjinks",
      "homework",
      "housework",
      "information",
      "jeans",
      "justice",
      "kudos",
      "labour",
      "literature",
      "machinery",
      "mackerel",
      "mail",
      "media",
      "mews",
      "moose",
      "music",
      "mud",
      "manga",
      "news",
      "only",
      "personnel",
      "pike",
      "plankton",
      "pliers",
      "police",
      "pollution",
      "premises",
      "rain",
      "research",
      "rice",
      "salmon",
      "scissors",
      "series",
      "sewage",
      "shambles",
      "shrimp",
      "software",
      "species",
      "staff",
      "swine",
      "tennis",
      "traffic",
      "transportation",
      "trout",
      "tuna",
      "wealth",
      "welfare",
      "whiting",
      "wildebeest",
      "wildlife",
      "you",
      /pok[eé]mon$/i,
      // Regexes.
      /[^aeiou]ese$/i,
      // "chinese", "japanese"
      /deer$/i,
      // "deer", "reindeer"
      /fish$/i,
      // "fish", "blowfish", "angelfish"
      /measles$/i,
      /o[iu]s$/i,
      // "carnivorous"
      /pox$/i,
      // "chickpox", "smallpox"
      /sheep$/i
    ].forEach(m.addUncountableRule), m;
  });
})(O2);
var f6 = O2.exports;
const m6 = /* @__PURE__ */ h6(f6), g6 = {
  pluralize: m6,
  countries: c6,
  ACTIVATE: "Activate",
  BACK: "Back",
  CANCEL: "Cancel",
  CHARACTER: "character",
  CLOSE_ACTION: "Close",
  CLOSE_MENU: "Close menu",
  CONFIRM: "Confirm",
  COPIED: "Copied",
  COPY: "Copy",
  COUNTRY: "Country",
  DATE_FORMAT: "$MM$DATE_SEPARATOR$DD$DATE_SEPARATOR$YYYY",
  DATE_FROM_TO: "From $start to $end",
  DATETIME_SEPARATOR: " - ",
  DATE_SEPARATOR: "-",
  DAY: "Day",
  DAY_NAME: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
  DEACTIVATE: "Deactivate",
  ENTER_YOUR_SEARCH_TERM: "Enter your seach term...",
  ERROR: "Error",
  FINISH: "Finish",
  HOUR: "Hour",
  HOUR_FORMAT: "$hh$TIME_SEPARATOR$mm",
  HOUR_FROM_TO: "From $start to $end",
  IN: "In",
  LOADING: "Loading...",
  LOADING_CALENDAR: "Loading calendar...",
  LOADING_RESULTS: "Loading results...",
  MENU: "Menu",
  MINUTE: "Minute",
  MONTH: "Month",
  MONTH_NAME: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  NEXT: "Next",
  NO_RESULT: "No result",
  OR: "or",
  RESET: "Reset",
  REDO: "Redo",
  PREVIOUS: "Previous",
  SEARCH: "Search",
  SECOND: "Second",
  TIME_SEPARATOR: ":",
  THERE_IS: "Ago",
  UNDO: "Cancel",
  VALIDATE: "Validate",
  WEEK: "Week",
  YEAR: "Year",
  get DAY_NAME_SHORT() {
    return this.DAY_NAME.map((e) => e.toLowerCase().slice(0, 3));
  },
  get MONTH_NAME_SHORT() {
    return this.MONTH_NAME.map((e) => e.toLowerCase().slice(0, 3));
  },
  get DATE_PATTERN() {
    return this.DATE_FORMAT.replaceAll("$DATE_SEPARATOR", this.DATE_SEPARATOR);
  },
  ORION_AVATAR__TOOLTIP: "Update avatar",
  ORION_CHAT__ENTER_TO_SEND: "Enter to send",
  ORION_CHAT__LOADING_CONVERSATION: "Loading conversation...",
  ORION_CHAT__LOADING_MESSAGES: "Loading messages...",
  ORION_CHAT__NEW_MESSAGE: "New message",
  ORION_CHAT__START_CONVERSATION: "Start a new conversation",
  ORION_CHAT__UNREAD_MESSAGE: "Unread message",
  ORION_CHAT_DISCUSSION__LIST_NEW_CONVERSATION: "New conversation",
  ORION_CHAT_DISCUSSION__LIST_NO_CONVERSATION: "No conversation",
  ORION_CHAT_MESSAGE__READ: "Read",
  ORION_CHAT_MESSAGE__DELIVERED: "Delivered",
  ORION_EDITOR__ADD_PICTURE: "Add picture",
  ORION_EDITOR__ADD_PICTURE_LABEL: "Picture link",
  ORION_EDITOR__ADD_YOUTUBE_LABEL: "Video link",
  ORION_EDITOR__ALIGN: "Align",
  ORION_EDITOR__ALIGN_CENTER: "Align center",
  ORION_EDITOR__ALIGN_LEFT: "Align left",
  ORION_EDITOR__ALIGN_RIGHT: "Align right",
  ORION_EDITOR__BACKGROUND_COLOR: "Background color",
  ORION_EDITOR__BOLD: "Bold",
  ORION_EDITOR__FONT_SIZE: "Font size",
  ORION_EDITOR__ITALIC: "Italic",
  ORION_EDITOR__LINK: "Link",
  ORION_EDITOR__LINK_URL: "Link url",
  ORION_EDITOR__PICTURE: "Picture",
  ORION_EDITOR__PICTURE_URL: "Picture from URL",
  ORION_EDITOR__PICTURE_TOO_HEAVY: "The picture $fileName is too heavy, max size allowed is $imgMaxSize Ko.",
  ORION_EDITOR__REGULAR_TEXT: "Regular text",
  ORION_EDITOR__TEXT_COLOR: "Text color",
  ORION_EDITOR__TITLE_1: "Title 1",
  ORION_EDITOR__TITLE_2: "Title 2",
  ORION_EDITOR__TITLE_3: "Title 3",
  ORION_EDITOR__UNDERLINE: "Underline",
  ORION_EDITOR__UNLINK: "Unlink",
  ORION_EDITOR__UNORDERED_LIST: "Unordered list",
  ORION_EDITOR__YOUTUBE: "Insert YouTube video",
  ORION_HORIZONTAL_SCROLL__LEFT: "Slide to the left",
  ORION_HORIZONTAL_SCROLL__RIGHT: "Slide to the right",
  ORION_HORIZONTAL_SCROLL__VISIBLE: "Visible elements",
  ORION_LIST__ITEM_ADJECTIVE: "selected",
  ORION_LIST__ITEM_TYPE: "item",
  ORION_PASSWORD__VALIDATION_PASWWORD_CONFIRMATION: "The passwords must match",
  ORION_PASSWORD__VALIDATION_HAS_LOWERCASE: "At least 1 lowercase",
  ORION_PASSWORD__VALIDATION_HAS_UPPERCASE: "At least 1 uppercase",
  ORION_PASSWORD__VALIDATION_HAS_NUMBER: "At least 1 number",
  ORION_PASSWORD__VALIDATION_LENGTH: "Between 8 and 60 characters",
  ORION_PHONE__DEFAULT_COUNTRY_CODE: "US",
  ORION_POP_CONFIRM__TITLE: "Do you confirm this action ?",
  ORION_SELECT__REMOVE_VALUE_ERROR: "The value couldn't be removed",
  ORION_TOUR__ELEMENT_NOT_FOUND_MESSAGE: "Could not go to next step, do you want to retry ?",
  ORION_UPLOAD__BUTTON: "Select file",
  ORION_UPLOAD__FILE_TOO_HEAVY: "This file is too heavy, max size allowed : $fileMaxSize Mo",
  ORION_UPLOAD__INVALID_FILE_TYPE: "This file type is not allowed",
  ORION_UPLOAD__LABEL: "Drag and drop a file here, $format ($fileMaxSize Mo max)",
  ORION_UPLOAD__PROCESSING: "Processing...",
  USE_CONFIRM__TITLE: "Confirmation",
  VALIDATOR_ERROR_REQUIRED: "Required",
  VALIDATOR_ERROR_HAS_LOWERCASE: "Missing lowercase character",
  VALIDATOR_ERROR_HAS_UPPERCASE: "Missing uppercase character",
  VALIDATOR_ERROR_HAS_NUMBER: "Missing number character",
  VALIDATOR_ERROR_HAS_SPECIAL_CHAR: "Missing special character",
  VALIDATOR_ERROR_HAS_MIN_LENGTH: "Minimum length of $charLength required",
  VALIDATOR_ERROR_HAS_MAX_LENGTH: "Maximum length of $charLength required",
  VALIDATOR_ERROR_LENGTH: "Characters length must be between $min and $max",
  VALIDATOR_ERROR_PHONE: "Invalid phone number",
  VALIDATOR_ERROR_PASSWORD: "Invalid password",
  VALIDATOR_ERROR_PASSWORD_CONFIRM: "Invalid password confirmation",
  VALIDATOR_ERROR_EMAIL: "Invalid email"
}, v6 = [{
  code: "AD",
  name: "Andorre",
  areaCode: "376"
}, {
  code: "AE",
  name: "Émirats Arabes Unis",
  areaCode: "971"
}, {
  code: "AF",
  name: "Afghanistan",
  areaCode: "93"
}, {
  code: "AG",
  name: "Antigua-et-Barbuda",
  areaCode: "1-268"
}, {
  code: "AI",
  name: "Anguilla",
  areaCode: "1-264"
}, {
  code: "AL",
  name: "Albanie",
  areaCode: "355"
}, {
  code: "AM",
  name: "Arménie",
  areaCode: "374"
}, {
  code: "AN",
  name: "Antilles néerlandaises",
  areaCode: "599"
}, {
  code: "AO",
  name: "Angola",
  areaCode: "244"
}, {
  code: "AQ",
  name: "Antarctique",
  areaCode: "672"
}, {
  code: "AR",
  name: "Argentine",
  areaCode: "54"
}, {
  code: "AS",
  name: "American Samoa",
  areaCode: "1-684"
}, {
  code: "AT",
  name: "Autriche",
  areaCode: "43"
}, {
  code: "AU",
  name: "Australie",
  areaCode: "61"
}, {
  code: "AW",
  name: "Aruba",
  areaCode: "297"
}, {
  code: "AZ",
  name: "Azerbaïdjan",
  areaCode: "994"
}, {
  code: "BA",
  name: "Bosnie-Herzégovine",
  areaCode: "387"
}, {
  code: "BB",
  name: "Barbade",
  areaCode: "1-246"
}, {
  code: "BD",
  name: "Bangladesh",
  areaCode: "880"
}, {
  code: "BE",
  name: "Belgique",
  areaCode: "32"
}, {
  code: "BF",
  name: "Burkina Faso",
  areaCode: "226"
}, {
  code: "BG",
  name: "Bulgarie",
  areaCode: "359"
}, {
  code: "BH",
  name: "Bahreïn",
  areaCode: "973"
}, {
  code: "BI",
  name: "Burundi",
  areaCode: "257"
}, {
  code: "BJ",
  name: "Bénin",
  areaCode: "229"
}, {
  code: "BL",
  name: "Saint Barthelemy",
  areaCode: "590"
}, {
  code: "BM",
  name: "Bermudes",
  areaCode: "1-441"
}, {
  code: "BN",
  name: "Brunéi Darussalam",
  areaCode: "673"
}, {
  code: "BO",
  name: "Bolivie",
  areaCode: "591"
}, {
  code: "BR",
  name: "Brésil",
  areaCode: "55"
}, {
  code: "BS",
  name: "Bahamas",
  areaCode: "1-242"
}, {
  code: "BT",
  name: "Bhoutan",
  areaCode: "975"
}, {
  code: "BW",
  name: "Botswana",
  areaCode: "267"
}, {
  code: "BY",
  name: "Biélorussie",
  areaCode: "375"
}, {
  code: "BZ",
  name: "Bélize",
  areaCode: "501"
}, {
  code: "CA",
  name: "Canada",
  areaCode: "1"
}, {
  code: "CC",
  name: "Cocos Islands",
  areaCode: "61"
}, {
  code: "CD",
  name: "Congo, République démocratique du",
  areaCode: "243"
}, {
  code: "CF",
  name: "République centrafricaine",
  areaCode: "236"
}, {
  code: "CG",
  name: "Congo, République du",
  areaCode: "242"
}, {
  code: "CH",
  name: "Suisse",
  areaCode: "41"
}, {
  code: "CI",
  name: "Côte d'ivoire",
  areaCode: "225"
}, {
  code: "CK",
  name: "Îles Cook",
  areaCode: "682"
}, {
  code: "CL",
  name: "Chili",
  areaCode: "56"
}, {
  code: "CM",
  name: "Cameroun",
  areaCode: "237"
}, {
  code: "CN",
  name: "Chine",
  areaCode: "86"
}, {
  code: "CO",
  name: "Colombie",
  areaCode: "57"
}, {
  code: "CR",
  name: "Costa Rica",
  areaCode: "506"
}, {
  code: "CU",
  name: "Cuba",
  areaCode: "53"
}, {
  code: "CV",
  name: "Cap Vert",
  areaCode: "238"
}, {
  code: "CW",
  name: "Curacao",
  areaCode: "599"
}, {
  code: "CX",
  name: "Christmas Island",
  areaCode: "61"
}, {
  code: "CY",
  name: "Chypre",
  areaCode: "357"
}, {
  code: "CZ",
  name: "République Tchèque",
  areaCode: "420"
}, {
  code: "DE",
  name: "Allemagne",
  areaCode: "49"
}, {
  code: "DJ",
  name: "Djibouti",
  areaCode: "253"
}, {
  code: "DK",
  name: "Danemark",
  areaCode: "45"
}, {
  code: "DM",
  name: "Dominique",
  areaCode: "1-767"
}, {
  code: "DO",
  name: "République dominicaine",
  areaCode: "1-809"
}, {
  code: "DO",
  name: "République dominicaine",
  areaCode: "1-829"
}, {
  code: "DO",
  name: "République dominicaine",
  areaCode: "1-849"
}, {
  code: "DZ",
  name: "Algérie",
  areaCode: "213"
}, {
  code: "EC",
  name: "Équateur",
  areaCode: "593"
}, {
  code: "EE",
  name: "Estonie",
  areaCode: "372"
}, {
  code: "EG",
  name: "Égypte",
  areaCode: "20"
}, {
  code: "EH",
  name: "Western Sahara",
  areaCode: "212"
}, {
  code: "ER",
  name: "Érythrée",
  areaCode: "291"
}, {
  code: "ES",
  name: "Espagne",
  areaCode: "34"
}, {
  code: "ET",
  name: "Ethiopie",
  areaCode: "251"
}, {
  code: "FI",
  name: "Finlande",
  areaCode: "358"
}, {
  code: "FJ",
  name: "Fidji",
  areaCode: "679"
}, {
  code: "FK",
  name: "Îles Falkland (Malouines)",
  areaCode: "500"
}, {
  code: "FM",
  name: "Micronésie",
  areaCode: "691"
}, {
  code: "FO",
  name: "Îles Féroé",
  areaCode: "298"
}, {
  code: "FR",
  name: "France",
  areaCode: "33"
}, {
  code: "GA",
  name: "Gabon",
  areaCode: "241"
}, {
  code: "GB",
  name: "Royaume-Uni",
  areaCode: "44"
}, {
  code: "GD",
  name: "Grenade",
  areaCode: "1-473"
}, {
  code: "GE",
  name: "Géorgie",
  areaCode: "995"
}, {
  code: "GF",
  name: "Guyane Française",
  areaCode: "594"
}, {
  code: "GG",
  name: "Guernsey",
  areaCode: "44-1481"
}, {
  code: "GH",
  name: "Ghana",
  areaCode: "233"
}, {
  code: "GI",
  name: "Gibraltar",
  areaCode: "350"
}, {
  code: "GL",
  name: "Groenland",
  areaCode: "299"
}, {
  code: "GM",
  name: "Gambie",
  areaCode: "220"
}, {
  code: "GN",
  name: "Guinée",
  areaCode: "224"
}, {
  code: "GP",
  name: "Guadeloupe",
  areaCode: "590"
}, {
  code: "GQ",
  name: "Guinée équatoriale",
  areaCode: "240"
}, {
  code: "GR",
  name: "Grèce",
  areaCode: "30"
}, {
  code: "GT",
  name: "Guatemala",
  areaCode: "502"
}, {
  code: "GU",
  name: "Guam",
  areaCode: "1-671"
}, {
  code: "GW",
  name: "Guinée-Bissau",
  areaCode: "245"
}, {
  code: "GY",
  name: "Guyane",
  areaCode: "592"
}, {
  code: "HK",
  name: "Hong Kong",
  areaCode: "852"
}, {
  code: "HN",
  name: "Honduras",
  areaCode: "504"
}, {
  code: "HR",
  name: "Croatie",
  areaCode: "385"
}, {
  code: "HT",
  name: "Haïti",
  areaCode: "509"
}, {
  code: "HU",
  name: "Hongrie",
  areaCode: "36"
}, {
  code: "ID",
  name: "Indonésie",
  areaCode: "62"
}, {
  code: "IE",
  name: "Irlande",
  areaCode: "353"
}, {
  code: "IL",
  name: "Israël",
  areaCode: "972"
}, {
  code: "IM",
  name: "Île de Man",
  areaCode: "44-1624"
}, {
  code: "IN",
  name: "Inde",
  areaCode: "91"
}, {
  code: "IO",
  name: "British Indian Ocean Territory",
  areaCode: "246"
}, {
  code: "IQ",
  name: "Irak",
  areaCode: "964"
}, {
  code: "IR",
  name: "Iran",
  areaCode: "98"
}, {
  code: "IS",
  name: "Islande",
  areaCode: "354"
}, {
  code: "IT",
  name: "Italie",
  areaCode: "39"
}, {
  code: "JE",
  name: "Jersey",
  areaCode: "44-1534"
}, {
  code: "JM",
  name: "Jamaïque",
  areaCode: "1-876"
}, {
  code: "JO",
  name: "Jordanie",
  areaCode: "962"
}, {
  code: "JP",
  name: "Japon",
  areaCode: "81"
}, {
  code: "KE",
  name: "Kenya",
  areaCode: "254"
}, {
  code: "KG",
  name: "Kirghizistan",
  areaCode: "996"
}, {
  code: "KH",
  name: "Cambodge",
  areaCode: "855"
}, {
  code: "KI",
  name: "Kiribati",
  areaCode: "686"
}, {
  code: "KM",
  name: "Comores",
  areaCode: "269"
}, {
  code: "KN",
  name: "Saint-Kitts-et-Nevis",
  areaCode: "1-869"
}, {
  code: "KP",
  name: "Corée du Nord",
  areaCode: "850"
}, {
  code: "KR",
  name: "Corée du Sud",
  areaCode: "82"
}, {
  code: "KW",
  name: "Koweït",
  areaCode: "965"
}, {
  code: "KY",
  name: "Îles Caïmans",
  areaCode: "1-345"
}, {
  code: "KZ",
  name: "Kazakhstan",
  areaCode: "7"
}, {
  code: "LA",
  name: "Laos",
  areaCode: "856"
}, {
  code: "LB",
  name: "Liban",
  areaCode: "961"
}, {
  code: "LC",
  name: "Sainte-Lucie",
  areaCode: "1-758"
}, {
  code: "LI",
  name: "Liechtenstein",
  areaCode: "423"
}, {
  code: "LK",
  name: "Sri Lanka",
  areaCode: "94"
}, {
  code: "LR",
  name: "Liberia",
  areaCode: "231"
}, {
  code: "LS",
  name: "Lesotho",
  areaCode: "266"
}, {
  code: "LT",
  name: "Lituanie",
  areaCode: "370"
}, {
  code: "LU",
  name: "Luxembourg",
  areaCode: "352"
}, {
  code: "LV",
  name: "Lettonie",
  areaCode: "371"
}, {
  code: "LY",
  name: "Libye",
  areaCode: "218"
}, {
  code: "MA",
  name: "Maroc",
  areaCode: "212"
}, {
  code: "MC",
  name: "Monaco",
  areaCode: "377"
}, {
  code: "MD",
  name: "Moldavie",
  areaCode: "373"
}, {
  code: "ME",
  name: "Montenegro",
  areaCode: "382"
}, {
  code: "MF",
  name: "Saint Martin",
  areaCode: "590"
}, {
  code: "MG",
  name: "Madagascar",
  areaCode: "261"
}, {
  code: "MH",
  name: "Îles Marshall",
  areaCode: "692"
}, {
  code: "MK",
  name: "Macédoine",
  areaCode: "389"
}, {
  code: "ML",
  name: "Mali",
  areaCode: "223"
}, {
  code: "MM",
  name: "Myanmar",
  areaCode: "95"
}, {
  code: "MN",
  name: "Mongolie",
  areaCode: "976"
}, {
  code: "MO",
  name: "Macao",
  areaCode: "853"
}, {
  code: "MP",
  name: "Northern Mariana Islands",
  areaCode: "1-670"
}, {
  code: "MQ",
  name: "Martinique",
  areaCode: "596"
}, {
  code: "MR",
  name: "Mauritanie",
  areaCode: "222"
}, {
  code: "MS",
  name: "Montserrat",
  areaCode: "1-664"
}, {
  code: "MT",
  name: "Malte",
  areaCode: "356"
}, {
  code: "MU",
  name: "Maurice",
  areaCode: "230"
}, {
  code: "MV",
  name: "Maldives",
  areaCode: "960"
}, {
  code: "MW",
  name: "Malawi",
  areaCode: "265"
}, {
  code: "MX",
  name: "Mexique",
  areaCode: "52"
}, {
  code: "MY",
  name: "Malaisie",
  areaCode: "60"
}, {
  code: "MZ",
  name: "Mozambique",
  areaCode: "258"
}, {
  code: "NA",
  name: "Namibie",
  areaCode: "264"
}, {
  code: "NC",
  name: "Nouvelle-Calédonie",
  areaCode: "687"
}, {
  code: "NE",
  name: "Niger",
  areaCode: "227"
}, {
  code: "NG",
  name: "Nigeria",
  areaCode: "234"
}, {
  code: "NI",
  name: "Nicaragua",
  areaCode: "505"
}, {
  code: "NL",
  name: "Pays-Bas",
  areaCode: "31"
}, {
  code: "NO",
  name: "Norvège",
  areaCode: "47"
}, {
  code: "NP",
  name: "Népal",
  areaCode: "977"
}, {
  code: "NR",
  name: "Nauru",
  areaCode: "674"
}, {
  code: "NU",
  name: "Niué",
  areaCode: "683"
}, {
  code: "NZ",
  name: "Nouvelle-Zélande",
  areaCode: "64"
}, {
  code: "OM",
  name: "Oman",
  areaCode: "968"
}, {
  code: "PA",
  name: "Panama",
  areaCode: "507"
}, {
  code: "PE",
  name: "Pérou",
  areaCode: "51"
}, {
  code: "PF",
  name: "Polynésie française",
  areaCode: "689"
}, {
  code: "PG",
  name: "Papouasie-Nouvelle-Guinée",
  areaCode: "675"
}, {
  code: "PH",
  name: "Philippines",
  areaCode: "63"
}, {
  code: "PK",
  name: "Pakistan",
  areaCode: "92"
}, {
  code: "PL",
  name: "Pologne",
  areaCode: "48"
}, {
  code: "PM",
  name: "Saint-Pierre-et-Miquelon",
  areaCode: "508"
}, {
  code: "PN",
  name: "Pitcairn",
  areaCode: "64"
}, {
  code: "PR",
  name: "Porto Rico",
  areaCode: "1-787"
}, {
  code: "PR",
  name: "Porto Rico",
  areaCode: "1-939"
}, {
  code: "PS",
  name: "Palestine",
  areaCode: "970"
}, {
  code: "PT",
  name: "Portugal",
  areaCode: "351"
}, {
  code: "PW",
  name: "Palaos",
  areaCode: "680"
}, {
  code: "PY",
  name: "Paraguay",
  areaCode: "595"
}, {
  code: "QA",
  name: "Qatar",
  areaCode: "974"
}, {
  code: "RE",
  name: "Réunion",
  areaCode: "262"
}, {
  code: "RO",
  name: "Roumanie",
  areaCode: "40"
}, {
  code: "RS",
  name: "Serbie",
  areaCode: "381"
}, {
  code: "RU",
  name: "Russie",
  areaCode: "7"
}, {
  code: "RW",
  name: "Rwanda",
  areaCode: "250"
}, {
  code: "SA",
  name: "Arabie Saoudite",
  areaCode: "966"
}, {
  code: "SB",
  name: "Îles Salomon",
  areaCode: "677"
}, {
  code: "SC",
  name: "Seychelles",
  areaCode: "248"
}, {
  code: "SD",
  name: "Soudan",
  areaCode: "249"
}, {
  code: "SE",
  name: "Suède",
  areaCode: "46"
}, {
  code: "SG",
  name: "Singapour",
  areaCode: "65"
}, {
  code: "SH",
  name: "Saint Helena",
  areaCode: "290"
}, {
  code: "SI",
  name: "Slovénie",
  areaCode: "386"
}, {
  code: "SJ",
  name: "Svalbard and Jan Mayen",
  areaCode: "47"
}, {
  code: "SK",
  name: "Slovaquie",
  areaCode: "421"
}, {
  code: "SL",
  name: "Sierra Leone",
  areaCode: "232"
}, {
  code: "SM",
  name: "Saint-Marin",
  areaCode: "378"
}, {
  code: "SN",
  name: "Sénégal",
  areaCode: "221"
}, {
  code: "SO",
  name: "Somalie",
  areaCode: "252"
}, {
  code: "SR",
  name: "Surinam",
  areaCode: "597"
}, {
  code: "SS",
  name: "Soudan du Sud",
  areaCode: "211"
}, {
  code: "ST",
  name: "Sao-Tomé-et-Principe",
  areaCode: "239"
}, {
  code: "SV",
  name: "El Salvador",
  areaCode: "503"
}, {
  code: "SX",
  name: "Sint Maarten",
  areaCode: "1-721"
}, {
  code: "SY",
  name: "Syrie",
  areaCode: "963"
}, {
  code: "SZ",
  name: "Swaziland",
  areaCode: "268"
}, {
  code: "TC",
  name: "Îles Turques-et-Caïques",
  areaCode: "1-649"
}, {
  code: "TD",
  name: "Tchad",
  areaCode: "235"
}, {
  code: "TG",
  name: "Togo",
  areaCode: "228"
}, {
  code: "TH",
  name: "Thaïlande",
  areaCode: "66"
}, {
  code: "TJ",
  name: "Tadjikistan",
  areaCode: "992"
}, {
  code: "TK",
  name: "Tokelau",
  areaCode: "690"
}, {
  code: "TL",
  name: "Timor-leste",
  areaCode: "670"
}, {
  code: "TM",
  name: "Turkménistan",
  areaCode: "993"
}, {
  code: "TN",
  name: "Tunisie",
  areaCode: "216"
}, {
  code: "TO",
  name: "Tonga",
  areaCode: "676"
}, {
  code: "TR",
  name: "Turquie",
  areaCode: "90"
}, {
  code: "TT",
  name: "Trinité-et-Tobago",
  areaCode: "1-868"
}, {
  code: "TV",
  name: "Tuvalu",
  areaCode: "688"
}, {
  code: "TW",
  name: "Taïwan",
  areaCode: "886"
}, {
  code: "TZ",
  name: "Tanzanie",
  areaCode: "255"
}, {
  code: "UA",
  name: "Ukraine",
  areaCode: "380"
}, {
  code: "UG",
  name: "Ouganda",
  areaCode: "256"
}, {
  code: "US",
  name: "États-Unis",
  areaCode: "1"
}, {
  code: "UY",
  name: "Uruguay",
  areaCode: "598"
}, {
  code: "UZ",
  name: "Ouzbékistan",
  areaCode: "998"
}, {
  code: "VA",
  name: "Vatican",
  areaCode: "379"
}, {
  code: "VC",
  name: "Saint-Vincent-et-les-Grenadines",
  areaCode: "1-784"
}, {
  code: "VE",
  name: "Venezuela",
  areaCode: "58"
}, {
  code: "VG",
  name: "Îles Vierges britanniques",
  areaCode: "1-284"
}, {
  code: "VI",
  name: "Îles Vierges américaines",
  areaCode: "1-340"
}, {
  code: "VN",
  name: "Vietnam",
  areaCode: "84"
}, {
  code: "VU",
  name: "Vanuatu",
  areaCode: "678"
}, {
  code: "WF",
  name: "Wallis and Futuna",
  areaCode: "681"
}, {
  code: "WS",
  name: "Samoa",
  areaCode: "685"
}, {
  code: "XK",
  name: "Kosovo",
  areaCode: "383"
}, {
  code: "YE",
  name: "Yémen",
  areaCode: "967"
}, {
  code: "YT",
  name: "Mayotte",
  areaCode: "262"
}, {
  code: "ZA",
  name: "Afrique du Sud",
  areaCode: "27"
}, {
  code: "ZM",
  name: "Zambie",
  areaCode: "260"
}, {
  code: "ZW",
  name: "Zimbabwe",
  areaCode: "263"
}], y6 = v6;
class Ar {
  static pluralize(l, n, t = !0) {
    const u = t ? `${n} ` : "";
    return n >= 2 || n <= -2 ? u + Ar.pluralizeWords(l) : u + l;
  }
  static pluralizeWords(l) {
    let n = "";
    return l.split(" ").forEach((t, u) => {
      u > 0 && (n += " "), n += Ar.pluralizeSingleWord(t);
    }), n.replace(/l'/g, Nn.get("l'"));
  }
  static pluralizeSingleWord(l) {
    const n = Nn.get(l);
    if (n)
      return n;
    const t = l.length < 4 ? l.length + 1 : 5;
    for (let u = 1; u < t; u++) {
      const i = l.substr(l.length - u), s = Te.get(i);
      if (s)
        return s(l);
    }
    return `${l}s`;
  }
}
const Nn = /* @__PURE__ */ new Map();
Nn.set("l'", "les ");
Nn.set("le", "les");
Nn.set("la", "les");
Nn.set("un", "des");
Nn.set("une", "des");
Nn.set("mon", "mes");
Nn.set("ton", "tes");
Nn.set("son", "ses");
Nn.set("notre", "nos");
Nn.set("votre", "vos");
Nn.set("leur", "leurs");
Nn.set("ce", "ces");
Nn.set("cet", "ces");
Nn.set("cette", "ces");
const $6 = ["bijou", "caillou", "chou", "genou", "hibou", "joujou", "pou"], b6 = ["astronaval", "aéronaval", "aval", "bal", "banal", "bancal", "carnaval", "cérémonial", "chacal", "choral", "étal", "fatal", "festival", "final", "mistral", "natal", "naval", "récital", "régal"], w6 = ["aspirail", "bail", "corail", "émail", "fermail", "gemmail", "soupirail", "travail", "vantail", "ventail", "vitrail"], Jp = (e) => e, k2 = (e) => `${e}x`, _6 = () => "cieux", M2 = () => "yeux", S6 = (e) => $6.includes(e) ? `${e}x` : `${e}s`, C6 = (e) => {
  const l = e.substr(0, e.length - 1);
  return b6.includes(e) ? `${e}s` : `${l}ux`;
}, T6 = (e) => {
  const l = e.substr(0, e.length - 2);
  return w6.includes(e) ? `${l}ux` : `${e}s`;
}, Te = /* @__PURE__ */ new Map();
Te.set("s", Jp);
Te.set("x", Jp);
Te.set("z", Jp);
Te.set("au", k2);
Te.set("eu", k2);
Te.set("ou", S6);
Te.set("al", C6);
Te.set("ail", T6);
Te.set("ciel", _6);
Te.set("oeil", M2);
Te.set("œil", M2);
const O6 = Ar, k6 = {
  pluralize: O6.pluralize,
  countries: y6,
  ACTIVATE: "Activer",
  BACK: "Retour",
  CANCEL: "Annuler",
  CHARACTER: "caractère",
  CLOSE_ACTION: "Fermer",
  CLOSE_MENU: "Fermer le menu",
  CONFIRM: "Confirmer",
  COPIED: "Copié",
  COPY: "Copier",
  COUNTRY: "Pays",
  DATE_FORMAT: "$DD$DATE_SEPARATOR$MM$DATE_SEPARATOR$YYYY",
  DATE_FROM_TO: "Du $start au $end",
  DATETIME_SEPARATOR: " - ",
  DATE_SEPARATOR: "/",
  DAY: "Jour",
  DAY_NAME: ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"],
  DEACTIVATE: "Désactiver",
  ENTER_YOUR_SEARCH_TERM: "Entrez votre recherche...",
  ERROR: "Erreur",
  FINISH: "Terminer",
  HOUR: "Heure",
  HOUR_FORMAT: "$hh$TIME_SEPARATOR$mm",
  HOUR_FROM_TO: "De $start à $end",
  IN: "Dans",
  LOADING: "Chargement...",
  LOADING_CALENDAR: "Chargement du calendrier...",
  LOADING_RESULTS: "Chargement des résultats...",
  MENU: "Menu",
  MINUTE: "Minute",
  MONTH: "Mois",
  MONTH_NAME: ["Janvier", "Fevrier", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
  NEXT: "Suivant",
  NO_RESULT: "Aucun résultat",
  OR: "ou",
  RESET: "Réinitiliser",
  REDO: "Rétablir",
  PREVIOUS: "Précédent",
  SEARCH: "Rechercher",
  SECOND: "Seconde",
  TIME_SEPARATOR: ":",
  THERE_IS: "Il y a",
  UNDO: "Annuler",
  VALIDATE: "Valider",
  WEEK: "Semaine",
  YEAR: "An",
  get DAY_NAME_SHORT() {
    return this.DAY_NAME.map((e) => e.toLowerCase().slice(0, 3));
  },
  get MONTH_NAME_SHORT() {
    return this.MONTH_NAME.map((e) => e.toLowerCase().slice(0, 3));
  },
  get DATE_PATTERN() {
    return this.DATE_FORMAT.replaceAll("$DATE_SEPARATOR", this.DATE_SEPARATOR);
  },
  ORION_AVATAR__TOOLTIP: "Modifier mon avatar",
  ORION_CHAT__ENTER_TO_SEND: "Entrée pour envoyer",
  ORION_CHAT__LOADING_CONVERSATION: "Chargement de la conversation...",
  ORION_CHAT__LOADING_MESSAGES: "Chargement des messages...",
  ORION_CHAT__NEW_MESSAGE: "Nouveau message",
  ORION_CHAT__START_CONVERSATION: "Débutez une nouvelle conversation",
  ORION_CHAT__UNREAD_MESSAGE: "Message non-lu",
  ORION_CHAT_DISCUSSION__LIST_NEW_CONVERSATION: "Nouvelle discussion",
  ORION_CHAT_DISCUSSION__LIST_NO_CONVERSATION: "Aucune discussion",
  ORION_CHAT_MESSAGE__READ: "Lu",
  ORION_CHAT_MESSAGE__DELIVERED: "Distribué",
  ORION_EDITOR__ADD_PICTURE: "Ajout d'une image",
  ORION_EDITOR__ADD_PICTURE_LABEL: "Lien de l'image",
  ORION_EDITOR__ADD_YOUTUBE_LABEL: "Lien de la vidéo",
  ORION_EDITOR__ALIGN: "Alignement",
  ORION_EDITOR__ALIGN_CENTER: "Aligner au centre",
  ORION_EDITOR__ALIGN_LEFT: "Aligner à gauche",
  ORION_EDITOR__ALIGN_RIGHT: "Aligner à droite",
  ORION_EDITOR__BACKGROUND_COLOR: "Couleur de fond",
  ORION_EDITOR__BOLD: "Gras",
  ORION_EDITOR__FONT_SIZE: "Taille de police",
  ORION_EDITOR__ITALIC: "Italique",
  ORION_EDITOR__LINK: "Lien",
  ORION_EDITOR__LINK_URL: "Adresse du lien",
  ORION_EDITOR__PICTURE: "Image",
  ORION_EDITOR__PICTURE_URL: "Image depuis URL",
  ORION_EDITOR__PICTURE_TOO_HEAVY: "L'image $fileName est trop lourde, la taille maximale autorisée est de $imgMaxSize Ko.",
  ORION_EDITOR__REGULAR_TEXT: "Texte normal",
  ORION_EDITOR__TEXT_COLOR: "Couleur de texte",
  ORION_EDITOR__TITLE_1: "Titre 1",
  ORION_EDITOR__TITLE_2: "Titre 2",
  ORION_EDITOR__TITLE_3: "Titre 3",
  ORION_EDITOR__UNDERLINE: "Souligné",
  ORION_EDITOR__UNLINK: "Supprimer le lien",
  ORION_EDITOR__UNORDERED_LIST: "Liste à puces",
  ORION_EDITOR__YOUTUBE: "Insérer une vidéo YouTube",
  ORION_HORIZONTAL_SCROLL__LEFT: "Glisser vers la gauche",
  ORION_HORIZONTAL_SCROLL__RIGHT: "Glisser vers la droite",
  ORION_HORIZONTAL_SCROLL__VISIBLE: "Éléments visibles",
  ORION_LIST__ITEM_ADJECTIVE: "sélectionné",
  ORION_LIST__ITEM_TYPE: "élément",
  ORION_PASSWORD__VALIDATION_PASWWORD_CONFIRMATION: "Les mots de passe doivent correspondre",
  ORION_PASSWORD__VALIDATION_HAS_LOWERCASE: "Au moins 1 minuscule",
  ORION_PASSWORD__VALIDATION_HAS_UPPERCASE: "Au moins 1 majuscule",
  ORION_PASSWORD__VALIDATION_HAS_NUMBER: "Au moins 1 chiffre",
  ORION_PASSWORD__VALIDATION_LENGTH: "Entre 8 et 60 caractères",
  ORION_PHONE__DEFAULT_COUNTRY_CODE: "FR",
  ORION_POP_CONFIRM__TITLE: "Confirmez-vous cette action ?",
  ORION_SELECT__REMOVE_VALUE_ERROR: "La valeur n'a pu être supprimée",
  ORION_TOUR__ELEMENT_NOT_FOUND_MESSAGE: "Impossible de passer à l'étape suivante, souhaitez-vous réessayer ?",
  ORION_UPLOAD__BUTTON: "Sélectionnez un fichier",
  ORION_UPLOAD__FILE_TOO_HEAVY: "Ce fichier est trop lourd, taille maximale autorisée : $fileMaxSize Mo",
  ORION_UPLOAD__INVALID_FILE_TYPE: "Ce type de fichier n'est pas autorisé",
  ORION_UPLOAD__LABEL: "Glissez et déposez un fichier ici au format $format ($fileMaxSize Mo max)",
  ORION_UPLOAD__PROCESSING: "Traîtement en cours...",
  USE_CONFIRM__TITLE: "Confirmation",
  VALIDATOR_ERROR_REQUIRED: "Requis",
  VALIDATOR_ERROR_HAS_LOWERCASE: "Caractère minuscule manquant",
  VALIDATOR_ERROR_HAS_UPPERCASE: "Caractère majuscule manquant",
  VALIDATOR_ERROR_HAS_NUMBER: "Caractère numérique manquant",
  VALIDATOR_ERROR_HAS_SPECIAL_CHAR: "Caractère spécial manquant",
  VALIDATOR_ERROR_HAS_MIN_LENGTH: "Longueur minimale de $charLength requise",
  VALIDATOR_ERROR_HAS_MAX_LENGTH: "Longueur maximale de $charLength requise",
  VALIDATOR_ERROR_LENGTH: "La longueur des caractères doit être comprise entre $min et $max",
  VALIDATOR_ERROR_PHONE: "Numéro de téléphone invalide",
  VALIDATOR_ERROR_PASSWORD: "Mot de passe invalide",
  VALIDATOR_ERROR_PASSWORD_CONFIRM: "Confirmation de mot de passe invalide",
  VALIDATOR_ERROR_EMAIL: "Email non valide"
}, M6 = {
  en: {
    ...g6
  },
  fr: {
    ...k6
  }
}, Zp = fl({
  selectedLang: "en"
});
function ul() {
  return M6[Zp.selectedLang];
}
function jt() {
  return Zp.selectedLang;
}
function A6(e) {
  Zp.selectedLang = e;
}
class Dn {
  static info(l, n) {
    console.log(`%c${n ?? "INFO"} ➤`, "color:#198CFF; font-weight:600", this.convertData(l));
  }
  static success(l, n) {
    console.log(`%c${n ?? "SUCCESS"} ➤`, "color:#00d883; font-weight:600", this.convertData(l));
  }
  static warn(l, n) {
    console.log(`%c${n ?? "WARN"} ➤`, "color:#ff7043; font-weight:600", this.convertData(l));
  }
  static error(l, n) {
    console.log(`%c${n ?? "ERROR"} ➤`, "color:#ff0033; font-weight:600", this.convertData(l));
  }
  static orion(l) {
  }
  static convertData(l) {
    return Gy(l) ? c(l) : Ky(l) && typeof l == "object" ? Yy(l) : l;
  }
}
var A2 = typeof global == "object" && global && global.Object === Object && global, x6 = typeof self == "object" && self && self.Object === Object && self, ze = A2 || x6 || Function("return this")(), _e = ze.Symbol, x2 = Object.prototype, E6 = x2.hasOwnProperty, I6 = x2.toString, Pi = _e ? _e.toStringTag : void 0;
function R6(e) {
  var l = E6.call(e, Pi), n = e[Pi];
  try {
    e[Pi] = void 0;
    var t = !0;
  } catch {
  }
  var u = I6.call(e);
  return t && (l ? e[Pi] = n : delete e[Pi]), u;
}
var D6 = Object.prototype, N6 = D6.toString;
function L6(e) {
  return N6.call(e);
}
var P6 = "[object Null]", B6 = "[object Undefined]", Y1 = _e ? _e.toStringTag : void 0;
function su(e) {
  return e == null ? e === void 0 ? B6 : P6 : Y1 && Y1 in Object(e) ? R6(e) : L6(e);
}
function pt(e) {
  return e != null && typeof e == "object";
}
var F6 = "[object Symbol]";
function Po(e) {
  return typeof e == "symbol" || pt(e) && su(e) == F6;
}
function H6(e, l) {
  for (var n = -1, t = e == null ? 0 : e.length, u = Array(t); ++n < t; )
    u[n] = l(e[n], n, e);
  return u;
}
var Il = Array.isArray, z6 = 1 / 0, q1 = _e ? _e.prototype : void 0, J1 = q1 ? q1.toString : void 0;
function E2(e) {
  if (typeof e == "string")
    return e;
  if (Il(e))
    return H6(e, E2) + "";
  if (Po(e))
    return J1 ? J1.call(e) : "";
  var l = e + "";
  return l == "0" && 1 / e == -z6 ? "-0" : l;
}
var V6 = /\s/;
function j6(e) {
  for (var l = e.length; l-- && V6.test(e.charAt(l)); )
    ;
  return l;
}
var U6 = /^\s+/;
function W6(e) {
  return e && e.slice(0, j6(e) + 1).replace(U6, "");
}
function En(e) {
  var l = typeof e;
  return e != null && (l == "object" || l == "function");
}
var Z1 = NaN, G6 = /^[-+]0x[0-9a-f]+$/i, K6 = /^0b[01]+$/i, Y6 = /^0o[0-7]+$/i, q6 = parseInt;
function X1(e) {
  if (typeof e == "number")
    return e;
  if (Po(e))
    return Z1;
  if (En(e)) {
    var l = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = En(l) ? l + "" : l;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = W6(e);
  var n = K6.test(e);
  return n || Y6.test(e) ? q6(e.slice(2), n ? 2 : 8) : G6.test(e) ? Z1 : +e;
}
function I2(e) {
  return e;
}
var J6 = "[object AsyncFunction]", Z6 = "[object Function]", X6 = "[object GeneratorFunction]", Q6 = "[object Proxy]";
function R2(e) {
  if (!En(e))
    return !1;
  var l = su(e);
  return l == Z6 || l == X6 || l == J6 || l == Q6;
}
var Ca = ze["__core-js_shared__"], Q1 = function() {
  var e = /[^.]+$/.exec(Ca && Ca.keys && Ca.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function l8(e) {
  return !!Q1 && Q1 in e;
}
var n8 = Function.prototype, e8 = n8.toString;
function Vu(e) {
  if (e != null) {
    try {
      return e8.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var t8 = /[\\^$.*+?()[\]{}|]/g, u8 = /^\[object .+?Constructor\]$/, i8 = Function.prototype, s8 = Object.prototype, r8 = i8.toString, o8 = s8.hasOwnProperty, a8 = RegExp(
  "^" + r8.call(o8).replace(t8, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function d8(e) {
  if (!En(e) || l8(e))
    return !1;
  var l = R2(e) ? a8 : u8;
  return l.test(Vu(e));
}
function c8(e, l) {
  return e == null ? void 0 : e[l];
}
function ju(e, l) {
  var n = c8(e, l);
  return d8(n) ? n : void 0;
}
var Rc = ju(ze, "WeakMap"), l0 = Object.create, h8 = /* @__PURE__ */ function() {
  function e() {
  }
  return function(l) {
    if (!En(l))
      return {};
    if (l0)
      return l0(l);
    e.prototype = l;
    var n = new e();
    return e.prototype = void 0, n;
  };
}();
function p8() {
}
function D2(e, l) {
  var n = -1, t = e.length;
  for (l || (l = Array(t)); ++n < t; )
    l[n] = e[n];
  return l;
}
var n0 = function() {
  try {
    var e = ju(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}();
function N2(e, l) {
  for (var n = -1, t = e == null ? 0 : e.length; ++n < t && l(e[n], n, e) !== !1; )
    ;
  return e;
}
function f8(e, l, n, t) {
  for (var u = e.length, i = n + (t ? 1 : -1); t ? i-- : ++i < u; )
    if (l(e[i], i, e))
      return i;
  return -1;
}
function m8(e) {
  return e !== e;
}
function g8(e, l, n) {
  for (var t = n - 1, u = e.length; ++t < u; )
    if (e[t] === l)
      return t;
  return -1;
}
function v8(e, l, n) {
  return l === l ? g8(e, l, n) : f8(e, m8, n);
}
function y8(e, l) {
  var n = e == null ? 0 : e.length;
  return !!n && v8(e, l, 0) > -1;
}
var $8 = 9007199254740991, b8 = /^(?:0|[1-9]\d*)$/;
function L2(e, l) {
  var n = typeof e;
  return l = l ?? $8, !!l && (n == "number" || n != "symbol" && b8.test(e)) && e > -1 && e % 1 == 0 && e < l;
}
function Xp(e, l, n) {
  l == "__proto__" && n0 ? n0(e, l, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[l] = n;
}
function Qp(e, l) {
  return e === l || e !== e && l !== l;
}
var w8 = Object.prototype, _8 = w8.hasOwnProperty;
function P2(e, l, n) {
  var t = e[l];
  (!(_8.call(e, l) && Qp(t, n)) || n === void 0 && !(l in e)) && Xp(e, l, n);
}
function Bo(e, l, n, t) {
  var u = !n;
  n || (n = {});
  for (var i = -1, s = l.length; ++i < s; ) {
    var r = l[i], o = t ? t(n[r], e[r], r, n, e) : void 0;
    o === void 0 && (o = e[r]), u ? Xp(n, r, o) : P2(n, r, o);
  }
  return n;
}
var S8 = 9007199254740991;
function lf(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= S8;
}
function Fo(e) {
  return e != null && lf(e.length) && !R2(e);
}
var C8 = Object.prototype;
function Ho(e) {
  var l = e && e.constructor, n = typeof l == "function" && l.prototype || C8;
  return e === n;
}
function T8(e, l) {
  for (var n = -1, t = Array(e); ++n < e; )
    t[n] = l(n);
  return t;
}
var O8 = "[object Arguments]";
function e0(e) {
  return pt(e) && su(e) == O8;
}
var B2 = Object.prototype, k8 = B2.hasOwnProperty, M8 = B2.propertyIsEnumerable, A8 = e0(/* @__PURE__ */ function() {
  return arguments;
}()) ? e0 : function(e) {
  return pt(e) && k8.call(e, "callee") && !M8.call(e, "callee");
};
const zo = A8;
function x8() {
  return !1;
}
var F2 = typeof exports == "object" && exports && !exports.nodeType && exports, t0 = F2 && typeof module == "object" && module && !module.nodeType && module, E8 = t0 && t0.exports === F2, u0 = E8 ? ze.Buffer : void 0, I8 = u0 ? u0.isBuffer : void 0, R8 = I8 || x8;
const gs = R8;
var D8 = "[object Arguments]", N8 = "[object Array]", L8 = "[object Boolean]", P8 = "[object Date]", B8 = "[object Error]", F8 = "[object Function]", H8 = "[object Map]", z8 = "[object Number]", V8 = "[object Object]", j8 = "[object RegExp]", U8 = "[object Set]", W8 = "[object String]", G8 = "[object WeakMap]", K8 = "[object ArrayBuffer]", Y8 = "[object DataView]", q8 = "[object Float32Array]", J8 = "[object Float64Array]", Z8 = "[object Int8Array]", X8 = "[object Int16Array]", Q8 = "[object Int32Array]", l9 = "[object Uint8Array]", n9 = "[object Uint8ClampedArray]", e9 = "[object Uint16Array]", t9 = "[object Uint32Array]", Yl = {};
Yl[q8] = Yl[J8] = Yl[Z8] = Yl[X8] = Yl[Q8] = Yl[l9] = Yl[n9] = Yl[e9] = Yl[t9] = !0;
Yl[D8] = Yl[N8] = Yl[K8] = Yl[L8] = Yl[Y8] = Yl[P8] = Yl[B8] = Yl[F8] = Yl[H8] = Yl[z8] = Yl[V8] = Yl[j8] = Yl[U8] = Yl[W8] = Yl[G8] = !1;
function u9(e) {
  return pt(e) && lf(e.length) && !!Yl[su(e)];
}
function Vo(e) {
  return function(l) {
    return e(l);
  };
}
var H2 = typeof exports == "object" && exports && !exports.nodeType && exports, qi = H2 && typeof module == "object" && module && !module.nodeType && module, i9 = qi && qi.exports === H2, Ta = i9 && A2.process, tu = function() {
  try {
    var e = qi && qi.require && qi.require("util").types;
    return e || Ta && Ta.binding && Ta.binding("util");
  } catch {
  }
}(), i0 = tu && tu.isTypedArray, s9 = i0 ? Vo(i0) : u9;
const nf = s9;
var r9 = Object.prototype, o9 = r9.hasOwnProperty;
function z2(e, l) {
  var n = Il(e), t = !n && zo(e), u = !n && !t && gs(e), i = !n && !t && !u && nf(e), s = n || t || u || i, r = s ? T8(e.length, String) : [], o = r.length;
  for (var a in e)
    (l || o9.call(e, a)) && !(s && // Safari 9 has enumerable `arguments.length` in strict mode.
    (a == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    u && (a == "offset" || a == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (a == "buffer" || a == "byteLength" || a == "byteOffset") || // Skip index properties.
    L2(a, o))) && r.push(a);
  return r;
}
function V2(e, l) {
  return function(n) {
    return e(l(n));
  };
}
var a9 = V2(Object.keys, Object), d9 = Object.prototype, c9 = d9.hasOwnProperty;
function j2(e) {
  if (!Ho(e))
    return a9(e);
  var l = [];
  for (var n in Object(e))
    c9.call(e, n) && n != "constructor" && l.push(n);
  return l;
}
function Ii(e) {
  return Fo(e) ? z2(e) : j2(e);
}
function h9(e) {
  var l = [];
  if (e != null)
    for (var n in Object(e))
      l.push(n);
  return l;
}
var p9 = Object.prototype, f9 = p9.hasOwnProperty;
function m9(e) {
  if (!En(e))
    return h9(e);
  var l = Ho(e), n = [];
  for (var t in e)
    t == "constructor" && (l || !f9.call(e, t)) || n.push(t);
  return n;
}
function ef(e) {
  return Fo(e) ? z2(e, !0) : m9(e);
}
var g9 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, v9 = /^\w*$/;
function tf(e, l) {
  if (Il(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || Po(e) ? !0 : v9.test(e) || !g9.test(e) || l != null && e in Object(l);
}
var vs = ju(Object, "create");
function y9() {
  this.__data__ = vs ? vs(null) : {}, this.size = 0;
}
function $9(e) {
  var l = this.has(e) && delete this.__data__[e];
  return this.size -= l ? 1 : 0, l;
}
var b9 = "__lodash_hash_undefined__", w9 = Object.prototype, _9 = w9.hasOwnProperty;
function S9(e) {
  var l = this.__data__;
  if (vs) {
    var n = l[e];
    return n === b9 ? void 0 : n;
  }
  return _9.call(l, e) ? l[e] : void 0;
}
var C9 = Object.prototype, T9 = C9.hasOwnProperty;
function O9(e) {
  var l = this.__data__;
  return vs ? l[e] !== void 0 : T9.call(l, e);
}
var k9 = "__lodash_hash_undefined__";
function M9(e, l) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = vs && l === void 0 ? k9 : l, this;
}
function Du(e) {
  var l = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++l < n; ) {
    var t = e[l];
    this.set(t[0], t[1]);
  }
}
Du.prototype.clear = y9;
Du.prototype.delete = $9;
Du.prototype.get = S9;
Du.prototype.has = O9;
Du.prototype.set = M9;
function A9() {
  this.__data__ = [], this.size = 0;
}
function jo(e, l) {
  for (var n = e.length; n--; )
    if (Qp(e[n][0], l))
      return n;
  return -1;
}
var x9 = Array.prototype, E9 = x9.splice;
function I9(e) {
  var l = this.__data__, n = jo(l, e);
  if (n < 0)
    return !1;
  var t = l.length - 1;
  return n == t ? l.pop() : E9.call(l, n, 1), --this.size, !0;
}
function R9(e) {
  var l = this.__data__, n = jo(l, e);
  return n < 0 ? void 0 : l[n][1];
}
function D9(e) {
  return jo(this.__data__, e) > -1;
}
function N9(e, l) {
  var n = this.__data__, t = jo(n, e);
  return t < 0 ? (++this.size, n.push([e, l])) : n[t][1] = l, this;
}
function It(e) {
  var l = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++l < n; ) {
    var t = e[l];
    this.set(t[0], t[1]);
  }
}
It.prototype.clear = A9;
It.prototype.delete = I9;
It.prototype.get = R9;
It.prototype.has = D9;
It.prototype.set = N9;
var ys = ju(ze, "Map");
function L9() {
  this.size = 0, this.__data__ = {
    hash: new Du(),
    map: new (ys || It)(),
    string: new Du()
  };
}
function P9(e) {
  var l = typeof e;
  return l == "string" || l == "number" || l == "symbol" || l == "boolean" ? e !== "__proto__" : e === null;
}
function Uo(e, l) {
  var n = e.__data__;
  return P9(l) ? n[typeof l == "string" ? "string" : "hash"] : n.map;
}
function B9(e) {
  var l = Uo(this, e).delete(e);
  return this.size -= l ? 1 : 0, l;
}
function F9(e) {
  return Uo(this, e).get(e);
}
function H9(e) {
  return Uo(this, e).has(e);
}
function z9(e, l) {
  var n = Uo(this, e), t = n.size;
  return n.set(e, l), this.size += n.size == t ? 0 : 1, this;
}
function Rt(e) {
  var l = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++l < n; ) {
    var t = e[l];
    this.set(t[0], t[1]);
  }
}
Rt.prototype.clear = L9;
Rt.prototype.delete = B9;
Rt.prototype.get = F9;
Rt.prototype.has = H9;
Rt.prototype.set = z9;
var V9 = "Expected a function";
function uf(e, l) {
  if (typeof e != "function" || l != null && typeof l != "function")
    throw new TypeError(V9);
  var n = function() {
    var t = arguments, u = l ? l.apply(this, t) : t[0], i = n.cache;
    if (i.has(u))
      return i.get(u);
    var s = e.apply(this, t);
    return n.cache = i.set(u, s) || i, s;
  };
  return n.cache = new (uf.Cache || Rt)(), n;
}
uf.Cache = Rt;
var j9 = 500;
function U9(e) {
  var l = uf(e, function(t) {
    return n.size === j9 && n.clear(), t;
  }), n = l.cache;
  return l;
}
var W9 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, G9 = /\\(\\)?/g, K9 = U9(function(e) {
  var l = [];
  return e.charCodeAt(0) === 46 && l.push(""), e.replace(W9, function(n, t, u, i) {
    l.push(u ? i.replace(G9, "$1") : t || n);
  }), l;
});
function sf(e) {
  return e == null ? "" : E2(e);
}
function U2(e, l) {
  return Il(e) ? e : tf(e, l) ? [e] : K9(sf(e));
}
var Y9 = 1 / 0;
function Wo(e) {
  if (typeof e == "string" || Po(e))
    return e;
  var l = e + "";
  return l == "0" && 1 / e == -Y9 ? "-0" : l;
}
function W2(e, l) {
  l = U2(l, e);
  for (var n = 0, t = l.length; e != null && n < t; )
    e = e[Wo(l[n++])];
  return n && n == t ? e : void 0;
}
function $s(e, l, n) {
  var t = e == null ? void 0 : W2(e, l);
  return t === void 0 ? n : t;
}
function Go(e, l) {
  for (var n = -1, t = l.length, u = e.length; ++n < t; )
    e[u + n] = l[n];
  return e;
}
var s0 = _e ? _e.isConcatSpreadable : void 0;
function q9(e) {
  return Il(e) || zo(e) || !!(s0 && e && e[s0]);
}
function G2(e, l, n, t, u) {
  var i = -1, s = e.length;
  for (n || (n = q9), u || (u = []); ++i < s; ) {
    var r = e[i];
    l > 0 && n(r) ? l > 1 ? G2(r, l - 1, n, t, u) : Go(u, r) : t || (u[u.length] = r);
  }
  return u;
}
var J9 = V2(Object.getPrototypeOf, Object);
const K2 = J9;
function Z9(e, l, n) {
  var t = -1, u = e.length;
  l < 0 && (l = -l > u ? 0 : u + l), n = n > u ? u : n, n < 0 && (n += u), u = l > n ? 0 : n - l >>> 0, l >>>= 0;
  for (var i = Array(u); ++t < u; )
    i[t] = e[t + l];
  return i;
}
function X9(e, l, n) {
  var t = e.length;
  return n = n === void 0 ? t : n, !l && n >= t ? e : Z9(e, l, n);
}
var Q9 = "\\ud800-\\udfff", l7 = "\\u0300-\\u036f", n7 = "\\ufe20-\\ufe2f", e7 = "\\u20d0-\\u20ff", t7 = l7 + n7 + e7, u7 = "\\ufe0e\\ufe0f", i7 = "\\u200d", s7 = RegExp("[" + i7 + Q9 + t7 + u7 + "]");
function Y2(e) {
  return s7.test(e);
}
function r7(e) {
  return e.split("");
}
var q2 = "\\ud800-\\udfff", o7 = "\\u0300-\\u036f", a7 = "\\ufe20-\\ufe2f", d7 = "\\u20d0-\\u20ff", c7 = o7 + a7 + d7, h7 = "\\ufe0e\\ufe0f", p7 = "[" + q2 + "]", Dc = "[" + c7 + "]", Nc = "\\ud83c[\\udffb-\\udfff]", f7 = "(?:" + Dc + "|" + Nc + ")", J2 = "[^" + q2 + "]", Z2 = "(?:\\ud83c[\\udde6-\\uddff]){2}", X2 = "[\\ud800-\\udbff][\\udc00-\\udfff]", m7 = "\\u200d", Q2 = f7 + "?", l3 = "[" + h7 + "]?", g7 = "(?:" + m7 + "(?:" + [J2, Z2, X2].join("|") + ")" + l3 + Q2 + ")*", v7 = l3 + Q2 + g7, y7 = "(?:" + [J2 + Dc + "?", Dc, Z2, X2, p7].join("|") + ")", $7 = RegExp(Nc + "(?=" + Nc + ")|" + y7 + v7, "g");
function b7(e) {
  return e.match($7) || [];
}
function w7(e) {
  return Y2(e) ? b7(e) : r7(e);
}
function _7(e) {
  return function(l) {
    l = sf(l);
    var n = Y2(l) ? w7(l) : void 0, t = n ? n[0] : l.charAt(0), u = n ? X9(n, 1).join("") : l.slice(1);
    return t[e]() + u;
  };
}
var tl = _7("toUpperCase");
function S7() {
  this.__data__ = new It(), this.size = 0;
}
function C7(e) {
  var l = this.__data__, n = l.delete(e);
  return this.size = l.size, n;
}
function T7(e) {
  return this.__data__.get(e);
}
function O7(e) {
  return this.__data__.has(e);
}
var k7 = 200;
function M7(e, l) {
  var n = this.__data__;
  if (n instanceof It) {
    var t = n.__data__;
    if (!ys || t.length < k7 - 1)
      return t.push([e, l]), this.size = ++n.size, this;
    n = this.__data__ = new Rt(t);
  }
  return n.set(e, l), this.size = n.size, this;
}
function dt(e) {
  var l = this.__data__ = new It(e);
  this.size = l.size;
}
dt.prototype.clear = S7;
dt.prototype.delete = C7;
dt.prototype.get = T7;
dt.prototype.has = O7;
dt.prototype.set = M7;
function A7(e, l) {
  return e && Bo(l, Ii(l), e);
}
function x7(e, l) {
  return e && Bo(l, ef(l), e);
}
var n3 = typeof exports == "object" && exports && !exports.nodeType && exports, r0 = n3 && typeof module == "object" && module && !module.nodeType && module, E7 = r0 && r0.exports === n3, o0 = E7 ? ze.Buffer : void 0, a0 = o0 ? o0.allocUnsafe : void 0;
function I7(e, l) {
  if (l)
    return e.slice();
  var n = e.length, t = a0 ? a0(n) : new e.constructor(n);
  return e.copy(t), t;
}
function R7(e, l) {
  for (var n = -1, t = e == null ? 0 : e.length, u = 0, i = []; ++n < t; ) {
    var s = e[n];
    l(s, n, e) && (i[u++] = s);
  }
  return i;
}
function e3() {
  return [];
}
var D7 = Object.prototype, N7 = D7.propertyIsEnumerable, d0 = Object.getOwnPropertySymbols, rf = d0 ? function(e) {
  return e == null ? [] : (e = Object(e), R7(d0(e), function(l) {
    return N7.call(e, l);
  }));
} : e3;
function L7(e, l) {
  return Bo(e, rf(e), l);
}
var P7 = Object.getOwnPropertySymbols, t3 = P7 ? function(e) {
  for (var l = []; e; )
    Go(l, rf(e)), e = K2(e);
  return l;
} : e3;
function B7(e, l) {
  return Bo(e, t3(e), l);
}
function u3(e, l, n) {
  var t = l(e);
  return Il(e) ? t : Go(t, n(e));
}
function Lc(e) {
  return u3(e, Ii, rf);
}
function F7(e) {
  return u3(e, ef, t3);
}
var Pc = ju(ze, "DataView"), Bc = ju(ze, "Promise"), si = ju(ze, "Set"), c0 = "[object Map]", H7 = "[object Object]", h0 = "[object Promise]", p0 = "[object Set]", f0 = "[object WeakMap]", m0 = "[object DataView]", z7 = Vu(Pc), V7 = Vu(ys), j7 = Vu(Bc), U7 = Vu(si), W7 = Vu(Rc), vu = su;
(Pc && vu(new Pc(new ArrayBuffer(1))) != m0 || ys && vu(new ys()) != c0 || Bc && vu(Bc.resolve()) != h0 || si && vu(new si()) != p0 || Rc && vu(new Rc()) != f0) && (vu = function(e) {
  var l = su(e), n = l == H7 ? e.constructor : void 0, t = n ? Vu(n) : "";
  if (t)
    switch (t) {
      case z7:
        return m0;
      case V7:
        return c0;
      case j7:
        return h0;
      case U7:
        return p0;
      case W7:
        return f0;
    }
  return l;
});
const gi = vu;
var G7 = Object.prototype, K7 = G7.hasOwnProperty;
function Y7(e) {
  var l = e.length, n = new e.constructor(l);
  return l && typeof e[0] == "string" && K7.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
var xr = ze.Uint8Array;
function of(e) {
  var l = new e.constructor(e.byteLength);
  return new xr(l).set(new xr(e)), l;
}
function q7(e, l) {
  var n = l ? of(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.byteLength);
}
var J7 = /\w*$/;
function Z7(e) {
  var l = new e.constructor(e.source, J7.exec(e));
  return l.lastIndex = e.lastIndex, l;
}
var g0 = _e ? _e.prototype : void 0, v0 = g0 ? g0.valueOf : void 0;
function X7(e) {
  return v0 ? Object(v0.call(e)) : {};
}
function Q7(e, l) {
  var n = l ? of(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.length);
}
var l$ = "[object Boolean]", n$ = "[object Date]", e$ = "[object Map]", t$ = "[object Number]", u$ = "[object RegExp]", i$ = "[object Set]", s$ = "[object String]", r$ = "[object Symbol]", o$ = "[object ArrayBuffer]", a$ = "[object DataView]", d$ = "[object Float32Array]", c$ = "[object Float64Array]", h$ = "[object Int8Array]", p$ = "[object Int16Array]", f$ = "[object Int32Array]", m$ = "[object Uint8Array]", g$ = "[object Uint8ClampedArray]", v$ = "[object Uint16Array]", y$ = "[object Uint32Array]";
function $$(e, l, n) {
  var t = e.constructor;
  switch (l) {
    case o$:
      return of(e);
    case l$:
    case n$:
      return new t(+e);
    case a$:
      return q7(e, n);
    case d$:
    case c$:
    case h$:
    case p$:
    case f$:
    case m$:
    case g$:
    case v$:
    case y$:
      return Q7(e, n);
    case e$:
      return new t();
    case t$:
    case s$:
      return new t(e);
    case u$:
      return Z7(e);
    case i$:
      return new t();
    case r$:
      return X7(e);
  }
}
function b$(e) {
  return typeof e.constructor == "function" && !Ho(e) ? h8(K2(e)) : {};
}
var w$ = "[object Map]";
function _$(e) {
  return pt(e) && gi(e) == w$;
}
var y0 = tu && tu.isMap, S$ = y0 ? Vo(y0) : _$, C$ = "[object Set]";
function T$(e) {
  return pt(e) && gi(e) == C$;
}
var $0 = tu && tu.isSet, O$ = $0 ? Vo($0) : T$, k$ = 1, M$ = 2, A$ = 4, i3 = "[object Arguments]", x$ = "[object Array]", E$ = "[object Boolean]", I$ = "[object Date]", R$ = "[object Error]", s3 = "[object Function]", D$ = "[object GeneratorFunction]", N$ = "[object Map]", L$ = "[object Number]", r3 = "[object Object]", P$ = "[object RegExp]", B$ = "[object Set]", F$ = "[object String]", H$ = "[object Symbol]", z$ = "[object WeakMap]", V$ = "[object ArrayBuffer]", j$ = "[object DataView]", U$ = "[object Float32Array]", W$ = "[object Float64Array]", G$ = "[object Int8Array]", K$ = "[object Int16Array]", Y$ = "[object Int32Array]", q$ = "[object Uint8Array]", J$ = "[object Uint8ClampedArray]", Z$ = "[object Uint16Array]", X$ = "[object Uint32Array]", Kl = {};
Kl[i3] = Kl[x$] = Kl[V$] = Kl[j$] = Kl[E$] = Kl[I$] = Kl[U$] = Kl[W$] = Kl[G$] = Kl[K$] = Kl[Y$] = Kl[N$] = Kl[L$] = Kl[r3] = Kl[P$] = Kl[B$] = Kl[F$] = Kl[H$] = Kl[q$] = Kl[J$] = Kl[Z$] = Kl[X$] = !0;
Kl[R$] = Kl[s3] = Kl[z$] = !1;
function gr(e, l, n, t, u, i) {
  var s, r = l & k$, o = l & M$, a = l & A$;
  if (n && (s = u ? n(e, t, u, i) : n(e)), s !== void 0)
    return s;
  if (!En(e))
    return e;
  var d = Il(e);
  if (d) {
    if (s = Y7(e), !r)
      return D2(e, s);
  } else {
    var h = gi(e), p = h == s3 || h == D$;
    if (gs(e))
      return I7(e, r);
    if (h == r3 || h == i3 || p && !u) {
      if (s = o || p ? {} : b$(e), !r)
        return o ? B7(e, x7(s, e)) : L7(e, A7(s, e));
    } else {
      if (!Kl[h])
        return u ? e : {};
      s = $$(e, h, r);
    }
  }
  i || (i = new dt());
  var f = i.get(e);
  if (f)
    return f;
  i.set(e, s), O$(e) ? e.forEach(function(v) {
    s.add(gr(v, l, n, v, e, i));
  }) : S$(e) && e.forEach(function(v, w) {
    s.set(w, gr(v, l, n, w, e, i));
  });
  var m = a ? o ? F7 : Lc : o ? ef : Ii, g = d ? void 0 : m(e);
  return N2(g || e, function(v, w) {
    g && (w = v, v = e[w]), P2(s, w, gr(v, l, n, w, e, i));
  }), s;
}
var Q$ = 1, lb = 4;
function Er(e) {
  return gr(e, Q$ | lb);
}
function nb() {
  var e = arguments.length;
  if (!e)
    return [];
  for (var l = Array(e - 1), n = arguments[0], t = e; t--; )
    l[t - 1] = arguments[t];
  return Go(Il(n) ? D2(n) : [n], G2(l, 1));
}
var eb = "__lodash_hash_undefined__";
function tb(e) {
  return this.__data__.set(e, eb), this;
}
function ub(e) {
  return this.__data__.has(e);
}
function bs(e) {
  var l = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new Rt(); ++l < n; )
    this.add(e[l]);
}
bs.prototype.add = bs.prototype.push = tb;
bs.prototype.has = ub;
function ib(e, l) {
  for (var n = -1, t = e == null ? 0 : e.length; ++n < t; )
    if (l(e[n], n, e))
      return !0;
  return !1;
}
function o3(e, l) {
  return e.has(l);
}
var sb = 1, rb = 2;
function a3(e, l, n, t, u, i) {
  var s = n & sb, r = e.length, o = l.length;
  if (r != o && !(s && o > r))
    return !1;
  var a = i.get(e), d = i.get(l);
  if (a && d)
    return a == l && d == e;
  var h = -1, p = !0, f = n & rb ? new bs() : void 0;
  for (i.set(e, l), i.set(l, e); ++h < r; ) {
    var m = e[h], g = l[h];
    if (t)
      var v = s ? t(g, m, h, l, e, i) : t(m, g, h, e, l, i);
    if (v !== void 0) {
      if (v)
        continue;
      p = !1;
      break;
    }
    if (f) {
      if (!ib(l, function(w, $) {
        if (!o3(f, $) && (m === w || u(m, w, n, t, i)))
          return f.push($);
      })) {
        p = !1;
        break;
      }
    } else if (!(m === g || u(m, g, n, t, i))) {
      p = !1;
      break;
    }
  }
  return i.delete(e), i.delete(l), p;
}
function ob(e) {
  var l = -1, n = Array(e.size);
  return e.forEach(function(t, u) {
    n[++l] = [u, t];
  }), n;
}
function af(e) {
  var l = -1, n = Array(e.size);
  return e.forEach(function(t) {
    n[++l] = t;
  }), n;
}
var ab = 1, db = 2, cb = "[object Boolean]", hb = "[object Date]", pb = "[object Error]", fb = "[object Map]", mb = "[object Number]", gb = "[object RegExp]", vb = "[object Set]", yb = "[object String]", $b = "[object Symbol]", bb = "[object ArrayBuffer]", wb = "[object DataView]", b0 = _e ? _e.prototype : void 0, Oa = b0 ? b0.valueOf : void 0;
function _b(e, l, n, t, u, i, s) {
  switch (n) {
    case wb:
      if (e.byteLength != l.byteLength || e.byteOffset != l.byteOffset)
        return !1;
      e = e.buffer, l = l.buffer;
    case bb:
      return !(e.byteLength != l.byteLength || !i(new xr(e), new xr(l)));
    case cb:
    case hb:
    case mb:
      return Qp(+e, +l);
    case pb:
      return e.name == l.name && e.message == l.message;
    case gb:
    case yb:
      return e == l + "";
    case fb:
      var r = ob;
    case vb:
      var o = t & ab;
      if (r || (r = af), e.size != l.size && !o)
        return !1;
      var a = s.get(e);
      if (a)
        return a == l;
      t |= db, s.set(e, l);
      var d = a3(r(e), r(l), t, u, i, s);
      return s.delete(e), d;
    case $b:
      if (Oa)
        return Oa.call(e) == Oa.call(l);
  }
  return !1;
}
var Sb = 1, Cb = Object.prototype, Tb = Cb.hasOwnProperty;
function Ob(e, l, n, t, u, i) {
  var s = n & Sb, r = Lc(e), o = r.length, a = Lc(l), d = a.length;
  if (o != d && !s)
    return !1;
  for (var h = o; h--; ) {
    var p = r[h];
    if (!(s ? p in l : Tb.call(l, p)))
      return !1;
  }
  var f = i.get(e), m = i.get(l);
  if (f && m)
    return f == l && m == e;
  var g = !0;
  i.set(e, l), i.set(l, e);
  for (var v = s; ++h < o; ) {
    p = r[h];
    var w = e[p], $ = l[p];
    if (t)
      var _ = s ? t($, w, p, l, e, i) : t(w, $, p, e, l, i);
    if (!(_ === void 0 ? w === $ || u(w, $, n, t, i) : _)) {
      g = !1;
      break;
    }
    v || (v = p == "constructor");
  }
  if (g && !v) {
    var b = e.constructor, k = l.constructor;
    b != k && "constructor" in e && "constructor" in l && !(typeof b == "function" && b instanceof b && typeof k == "function" && k instanceof k) && (g = !1);
  }
  return i.delete(e), i.delete(l), g;
}
var kb = 1, w0 = "[object Arguments]", _0 = "[object Array]", qs = "[object Object]", Mb = Object.prototype, S0 = Mb.hasOwnProperty;
function Ab(e, l, n, t, u, i) {
  var s = Il(e), r = Il(l), o = s ? _0 : gi(e), a = r ? _0 : gi(l);
  o = o == w0 ? qs : o, a = a == w0 ? qs : a;
  var d = o == qs, h = a == qs, p = o == a;
  if (p && gs(e)) {
    if (!gs(l))
      return !1;
    s = !0, d = !1;
  }
  if (p && !d)
    return i || (i = new dt()), s || nf(e) ? a3(e, l, n, t, u, i) : _b(e, l, o, n, t, u, i);
  if (!(n & kb)) {
    var f = d && S0.call(e, "__wrapped__"), m = h && S0.call(l, "__wrapped__");
    if (f || m) {
      var g = f ? e.value() : e, v = m ? l.value() : l;
      return i || (i = new dt()), u(g, v, n, t, i);
    }
  }
  return p ? (i || (i = new dt()), Ob(e, l, n, t, u, i)) : !1;
}
function df(e, l, n, t, u) {
  return e === l ? !0 : e == null || l == null || !pt(e) && !pt(l) ? e !== e && l !== l : Ab(e, l, n, t, df, u);
}
var xb = 1, Eb = 2;
function Ib(e, l, n, t) {
  var u = n.length, i = u, s = !t;
  if (e == null)
    return !i;
  for (e = Object(e); u--; ) {
    var r = n[u];
    if (s && r[2] ? r[1] !== e[r[0]] : !(r[0] in e))
      return !1;
  }
  for (; ++u < i; ) {
    r = n[u];
    var o = r[0], a = e[o], d = r[1];
    if (s && r[2]) {
      if (a === void 0 && !(o in e))
        return !1;
    } else {
      var h = new dt();
      if (t)
        var p = t(a, d, o, e, l, h);
      if (!(p === void 0 ? df(d, a, xb | Eb, t, h) : p))
        return !1;
    }
  }
  return !0;
}
function d3(e) {
  return e === e && !En(e);
}
function Rb(e) {
  for (var l = Ii(e), n = l.length; n--; ) {
    var t = l[n], u = e[t];
    l[n] = [t, u, d3(u)];
  }
  return l;
}
function c3(e, l) {
  return function(n) {
    return n == null ? !1 : n[e] === l && (l !== void 0 || e in Object(n));
  };
}
function Db(e) {
  var l = Rb(e);
  return l.length == 1 && l[0][2] ? c3(l[0][0], l[0][1]) : function(n) {
    return n === e || Ib(n, e, l);
  };
}
function Nb(e, l) {
  return e != null && l in Object(e);
}
function Lb(e, l, n) {
  l = U2(l, e);
  for (var t = -1, u = l.length, i = !1; ++t < u; ) {
    var s = Wo(l[t]);
    if (!(i = e != null && n(e, s)))
      break;
    e = e[s];
  }
  return i || ++t != u ? i : (u = e == null ? 0 : e.length, !!u && lf(u) && L2(s, u) && (Il(e) || zo(e)));
}
function Pb(e, l) {
  return e != null && Lb(e, l, Nb);
}
var Bb = 1, Fb = 2;
function Hb(e, l) {
  return tf(e) && d3(l) ? c3(Wo(e), l) : function(n) {
    var t = $s(n, e);
    return t === void 0 && t === l ? Pb(n, e) : df(l, t, Bb | Fb);
  };
}
function zb(e) {
  return function(l) {
    return l == null ? void 0 : l[e];
  };
}
function Vb(e) {
  return function(l) {
    return W2(l, e);
  };
}
function jb(e) {
  return tf(e) ? zb(Wo(e)) : Vb(e);
}
function h3(e) {
  return typeof e == "function" ? e : e == null ? I2 : typeof e == "object" ? Il(e) ? Hb(e[0], e[1]) : Db(e) : jb(e);
}
function Ub(e, l, n, t) {
  for (var u = -1, i = e == null ? 0 : e.length; ++u < i; ) {
    var s = e[u];
    l(t, s, n(s), e);
  }
  return t;
}
function p3(e) {
  return function(l, n, t) {
    for (var u = -1, i = Object(l), s = t(l), r = s.length; r--; ) {
      var o = s[e ? r : ++u];
      if (n(i[o], o, i) === !1)
        break;
    }
    return l;
  };
}
var Wb = p3();
const Gb = Wb;
function Kb(e, l) {
  return e && Gb(e, l, Ii);
}
function f3(e, l) {
  return function(n, t) {
    if (n == null)
      return n;
    if (!Fo(n))
      return e(n, t);
    for (var u = n.length, i = l ? u : -1, s = Object(n); (l ? i-- : ++i < u) && t(s[i], i, s) !== !1; )
      ;
    return n;
  };
}
var Yb = f3(Kb);
const m3 = Yb;
function qb(e, l, n, t) {
  return m3(e, function(u, i, s) {
    l(t, u, n(u), s);
  }), t;
}
function Jb(e, l) {
  return function(n, t) {
    var u = Il(n) ? Ub : qb, i = l ? l() : {};
    return u(n, e, h3(t), i);
  };
}
var ka = function() {
  return ze.Date.now();
}, Zb = "Expected a function", Xb = Math.max, Qb = Math.min;
function Be(e, l, n) {
  var t, u, i, s, r, o, a = 0, d = !1, h = !1, p = !0;
  if (typeof e != "function")
    throw new TypeError(Zb);
  l = X1(l) || 0, En(n) && (d = !!n.leading, h = "maxWait" in n, i = h ? Xb(X1(n.maxWait) || 0, l) : i, p = "trailing" in n ? !!n.trailing : p);
  function f(T) {
    var M = t, H = u;
    return t = u = void 0, a = T, s = e.apply(H, M), s;
  }
  function m(T) {
    return a = T, r = setTimeout(w, l), d ? f(T) : s;
  }
  function g(T) {
    var M = T - o, H = T - a, x = l - M;
    return h ? Qb(x, i - H) : x;
  }
  function v(T) {
    var M = T - o, H = T - a;
    return o === void 0 || M >= l || M < 0 || h && H >= i;
  }
  function w() {
    var T = ka();
    if (v(T))
      return $(T);
    r = setTimeout(w, g(T));
  }
  function $(T) {
    return r = void 0, p && t ? f(T) : (t = u = void 0, s);
  }
  function _() {
    r !== void 0 && clearTimeout(r), a = 0, t = o = u = r = void 0;
  }
  function b() {
    return r === void 0 ? s : $(ka());
  }
  function k() {
    var T = ka(), M = v(T);
    if (t = arguments, u = this, o = T, M) {
      if (r === void 0)
        return m(o);
      if (h)
        return clearTimeout(r), r = setTimeout(w, l), f(o);
    }
    return r === void 0 && (r = setTimeout(w, l)), s;
  }
  return k.cancel = _, k.flush = b, k;
}
function lw(e, l, n) {
  for (var t = -1, u = e == null ? 0 : e.length; ++t < u; )
    if (n(l, e[t]))
      return !0;
  return !1;
}
function g3(e) {
  return typeof e == "function" ? e : I2;
}
function nw(e, l) {
  var n = Il(e) ? N2 : m3;
  return n(e, g3(l));
}
function ew(e, l) {
  for (var n = e == null ? 0 : e.length; n-- && l(e[n], n, e) !== !1; )
    ;
  return e;
}
var tw = p3(!0);
const uw = tw;
function iw(e, l) {
  return e && uw(e, l, Ii);
}
var sw = f3(iw, !0);
const rw = sw;
function ow(e, l) {
  var n = Il(e) ? ew : rw;
  return n(e, g3(l));
}
var v3 = /[\\^$.*+?()[\]{}|]/g, aw = RegExp(v3.source);
function dw(e) {
  return e = sf(e), e && aw.test(e) ? e.replace(v3, "\\$&") : e;
}
var cw = Object.prototype, hw = cw.hasOwnProperty, y3 = Jb(function(e, l, n) {
  hw.call(e, n) ? e[n].push(l) : Xp(e, n, [l]);
}), pw = "[object String]";
function $3(e) {
  return typeof e == "string" || !Il(e) && pt(e) && su(e) == pw;
}
var fw = "[object Date]";
function mw(e) {
  return pt(e) && su(e) == fw;
}
var C0 = tu && tu.isDate, gw = C0 ? Vo(C0) : mw, vw = "[object Map]", yw = "[object Set]", $w = Object.prototype, bw = $w.hasOwnProperty;
function Fc(e) {
  if (e == null)
    return !0;
  if (Fo(e) && (Il(e) || typeof e == "string" || typeof e.splice == "function" || gs(e) || nf(e) || zo(e)))
    return !e.length;
  var l = gi(e);
  if (l == vw || l == yw)
    return !e.size;
  if (Ho(e))
    return !j2(e).length;
  for (var n in e)
    if (bw.call(e, n))
      return !1;
  return !0;
}
function In(e) {
  return e == null;
}
var ww = "Expected a function";
function ws(e, l, n) {
  var t = !0, u = !0;
  if (typeof e != "function")
    throw new TypeError(ww);
  return En(n) && (t = "leading" in n ? !!n.leading : t, u = "trailing" in n ? !!n.trailing : u), Be(e, l, {
    leading: t,
    maxWait: l,
    trailing: u
  });
}
var _w = 1 / 0, Sw = si && 1 / af(new si([, -0]))[1] == _w ? function(e) {
  return new si(e);
} : p8, Cw = 200;
function Tw(e, l, n) {
  var t = -1, u = y8, i = e.length, s = !0, r = [], o = r;
  if (n)
    s = !1, u = lw;
  else if (i >= Cw) {
    var a = l ? null : Sw(e);
    if (a)
      return af(a);
    s = !1, u = o3, o = new bs();
  } else
    o = l ? [] : r;
  l:
    for (; ++t < i; ) {
      var d = e[t], h = l ? l(d) : d;
      if (d = n || d !== 0 ? d : 0, s && h === h) {
        for (var p = o.length; p--; )
          if (o[p] === h)
            continue l;
        l && o.push(h), r.push(d);
      } else
        u(o, h, n) || (o !== r && o.push(h), r.push(d));
    }
  return r;
}
function Ow(e, l) {
  return e && e.length ? Tw(e, h3(l)) : [];
}
function qn() {
  if (typeof window < "u")
    return window;
}
class kw {
  constructor(l) {
    S(this, "BPtablet", 768);
    S(this, "BPtabletLandscape", 1024);
    S(this, "BPdesktop", 1280);
    S(this, "BPdesktopXL", 1536);
    S(this, "state", fl({
      windowSize: {
        width: 0,
        height: 0
      }
    }));
    var n;
    Dn.orion("ResponsiveService activated"), l && Object.assign(this, l), this.setWindowSize(), (n = qn()) == null || n.addEventListener("resize", Be(() => {
      this.setWindowSize();
    }, 50));
  }
  get ww() {
    return this.state.windowSize.width;
  }
  get wh() {
    return this.state.windowSize.height;
  }
  get onPhone() {
    return this.ww < this.BPtablet;
  }
  get onTablet() {
    return this.ww >= this.BPtablet;
  }
  get onTabletOnly() {
    return this.ww >= this.BPtablet && this.ww < this.BPdesktop;
  }
  get onTabletPortrait() {
    return this.ww >= this.BPtablet;
  }
  get onTabletPortraitOnly() {
    return this.ww >= this.BPtablet && this.ww < this.BPtabletLandscape;
  }
  get onTabletLandscape() {
    return this.ww >= this.BPtabletLandscape;
  }
  get onTabletLandscapeOnly() {
    return this.ww >= this.BPtabletLandscape && this.ww < this.BPdesktop;
  }
  get onDesktop() {
    return this.ww >= this.BPdesktop;
  }
  get onDesktopOnly() {
    return this.ww >= this.BPdesktop && this.ww < this.BPdesktopXL;
  }
  get onDesktopXL() {
    return this.ww >= this.BPdesktopXL;
  }
  setWindowSize() {
    var l, n;
    this.state.windowSize.width = ((l = qn()) == null ? void 0 : l.innerWidth) ?? 0, this.state.windowSize.height = ((n = qn()) == null ? void 0 : n.innerHeight) ?? 0;
  }
}
const Mw = new kw();
function b3() {
  return Mw;
}
const Hc = "orion-devtool";
let xn;
const T0 = "SetupService", Aw = ["Bus", "bus", "props", "responsive", "ui", "window", "document", "defaultRouter", "getUid", "emits"];
function xw(e, l) {
  a6({
    id: "orion-devtool-plugin",
    label: "Orion DevTool Plugin",
    packageName: "orion-devtool-plugin",
    homepage: "https://orion-dev.armado.fr/",
    componentStateTypes: [T0],
    app: e
  }, (n) => {
    Dn.orion("Orion DevTool Plugin enabled"), xn = n, n.addInspector({
      id: Hc,
      label: "Orion UI",
      icon: "radio_button_checked"
    }), n.on.getInspectorTree((t) => {
      t.inspectorId === Hc && (t.rootNodes = [{
        id: "configuration",
        label: "Configuration"
      }, {
        id: "localization",
        label: "Localization"
      }]);
    }), n.on.getInspectorState((t) => {
      if (t.nodeId === "configuration")
        t.state = {
          "Initialization configuration": Object.keys(l.appConfig).sort().map((u) => ({
            key: u,
            value: l.appConfig[u]
          })),
          "Runtime configuration": [{
            key: "theme",
            value: C3()
          }, {
            key: "isIpad",
            value: Iw()
          }, {
            key: "isTouch",
            value: w3()
          }, {
            key: "isMac",
            value: _3()
          }, {
            key: "isWindows",
            value: Rw()
          }],
          Responsive: ["ww", "wh", "onPhone", "onTablet", "onTabletOnly", "onTabletPortrait", "onTabletPortraitOnly", "onTabletLandscape", "onTabletLandscapeOnly", "onDesktop", "onDesktopOnly", "onDesktopXL"].map((u) => ({
            key: u,
            value: b3()[u]
          }))
        };
      else if (t.nodeId === "localization") {
        const u = ul();
        t.state = {
          "01 - Global": Object.keys(u).filter((i) => !/^(ORION_|USE_)/.test(i) && !["countries", "pluralize"].includes(i)).sort().map((i) => ({
            key: i,
            value: u[i]
          })),
          "02 - Components": Object.keys(u).filter((i) => /^(ORION_)/.test(i) && !["countries", "pluralize"].includes(i)).sort().map((i) => ({
            key: i,
            value: u[i]
          })),
          "03 - Services": Object.keys(u).filter((i) => /^(USE_)/.test(i) && !["countries", "pluralize"].includes(i)).sort().map((i) => ({
            key: i,
            value: u[i]
          })),
          "04 - Countries": u.countries.map((i) => ({
            key: i.code,
            value: i
          }))
        };
      }
    }), n.on.visitComponentTree((t) => {
      /^Orion/.test(t.componentInstance.type.__name) && t.treeNode.tags.push({
        label: "Orion",
        textColor: 16777215,
        backgroundColor: 7350266
      });
    }), n.on.inspectComponent((t) => {
      var u;
      if (/^Orion/.test(t.componentInstance.type.__name)) {
        const i = t.instanceData, s = ((u = t.componentInstance.devtoolsRawSetupState) == null ? void 0 : u.setup) ?? t.componentInstance.exposed;
        for (let r = i.state.length - 1; r > -1; r--) {
          const o = i.state[r];
          (o.type === "setup" || o.type === "setup (other)") && i.state.splice(r, 1);
        }
        i.state.unshift(...Object.entries(s).filter(([r]) => !Aw.includes(r) && !Object.keys(s.publicInstance ?? {}).includes(r)).map(([r, o]) => ({
          type: T0,
          key: r,
          value: typeof o != "function" ? o : O0(o),
          editable: typeof o != "function"
        }))), i.state.unshift(...Object.entries(s.publicInstance ?? {}).map(([r, o]) => ({
          type: "Setup.publicInstance",
          key: r,
          value: typeof o != "function" ? o : O0(o)
        })));
      }
    });
  });
}
function O0(e) {
  return {
    _custom: {
      type: Function,
      readOnly: !0,
      display: "Function",
      tooltip: "Click the icon to trigger",
      // value: 'value',
      actions: [{
        icon: "input",
        tooltip: "Trigger function",
        action: async () => {
          console.log(await e());
        }
      }]
    }
  };
}
function Ul() {
  if (typeof document < "u")
    return document;
}
function zc() {
  if (typeof localStorage < "u")
    return localStorage;
}
const Ew = function* () {
  let e = 1;
  for (; ; )
    yield e++;
}(), ft = () => Ew.next().value, pB = /^([a-zA-Z0-9_-]+([+.]{1}[a-zA-Z0-9_-]+)*)@([a-zA-Z0-9_-]+([.]{1}[a-zA-Z0-9_-]+)*)([.]{1}[a-z]{2,12})$/, fB = !!qn() && !!Ul();
function Bi(e, l = 2) {
  return e || (e = 0), String(e).padStart(l, "0");
}
function Ma(e, l = ":") {
  var r;
  const n = e.split(l), t = Number(n[0]), u = ((r = n[1]) == null ? void 0 : r.slice(0, 2).padEnd(2, "0")) ?? "00", i = Number(u) / 60, s = t + i;
  return isNaN(s) ? 0 : s;
}
async function mB(e) {
  return new Promise((l) => setTimeout(l, e));
}
function tt(e) {
  return e != null && e !== !1;
}
function gB(e, l) {
  return new Date(l, e, 0).getDate();
}
function vB(e, l, n = "De $start à $end", t = "h") {
  const u = e.getHours().toString().padStart(2, "0"), i = e.getMinutes().toString().padStart(2, "0"), s = l.getHours().toString().padStart(2, "0"), r = l.getMinutes().toString().padStart(2, "0");
  return n.replace("$start", u.concat(t, i)).replace("$end", s.concat(t, r));
}
function Iw() {
  var l, n;
  const e = (l = qn()) == null ? void 0 : l.navigator.userAgent;
  if (e) {
    if (e.indexOf("iPad") > -1)
      return !0;
    if (e.indexOf("Macintosh") > -1)
      try {
        return (n = Ul()) == null || n.createEvent("TouchEvent"), !0;
      } catch {
      }
    return !1;
  }
}
function w3() {
  var e;
  return !((e = qn()) != null && e.matchMedia("(any-hover: hover) and (pointer: fine)").matches);
}
function _3() {
  return typeof navigator < "u" && navigator.platform.toUpperCase().includes("MAC");
}
function Rw() {
  return typeof navigator < "u" && navigator.platform.toUpperCase().includes("WIN");
}
function yB(e, l) {
  var i, s, r;
  const n = Ul();
  if (!n || (typeof e == "string" && (e = n.getElementById(e)), !e))
    return;
  const t = {
    padding: 3,
    delay: 1e3,
    event: void 0,
    ...l ?? {}
  }, u = n.createElement("canvas");
  u.classList.add("orion-highlighter"), u.style.top = e.offsetTop - t.padding + "px", u.style.left = e.offsetLeft - t.padding + "px", u.style.height = e.offsetHeight + t.padding * 2 + "px", u.style.width = e.offsetWidth + t.padding * 2 + "px", e.parentElement && e.parentElement.append && e.parentElement.append(u), setTimeout(() => {
    u.classList.add("orion-highlighter--visible");
  }, 50), ((i = t.event) == null ? void 0 : i.type) === "mouseenter" ? (s = t.event.target) == null || s.addEventListener("mouseleave", () => {
    u.addEventListener("transitionend", () => u.remove()), u.classList.remove("orion-highlighter--visible");
  }, {
    once: !0
  }) : (((r = t.event) == null ? void 0 : r.type) === "click" || !t.event) && setTimeout(() => {
    u.addEventListener("transitionend", () => u.remove()), u.classList.remove("orion-highlighter--visible");
  }, t.delay);
}
function Dw() {
  var e, l;
  w3() ? (e = Ul()) == null || e.body.classList.add("istouch") : (l = Ul()) == null || l.body.classList.remove("istouch");
}
function $B(e, l) {
  return l in e;
}
function bB(e, ...l) {
  return l.filter((n) => n in e).length === l.length;
}
function wB(e, l) {
  const n = {};
  return l.forEach((t) => {
    n[t] = e[t];
  }), n;
}
function S3(e, l) {
  var t, u, i;
  const n = (u = ((t = e.value) == null ? void 0 : t.getTargetNodes())[0]) == null ? void 0 : u.getAttribute("aria-describedby");
  if (n) {
    const s = (i = document.getElementById(n)) == null ? void 0 : i.querySelector(".v-popper__backdrop");
    s == null || s.addEventListener("click", () => {
      var r;
      (r = e.value) == null || r.hide(), rl(() => l == null ? void 0 : l());
    }, {
      once: !0
    });
  }
}
const fu = {};
function nn(e, l, n) {
  var i, s, r, o;
  const t = (n == null ? void 0 : n.uid) ?? ft(), u = (n == null ? void 0 : n.target) ?? "document";
  if (typeof e == "string" && l)
    return fu[t] = {
      type: e,
      callback: l,
      target: u
    }, u === "document" ? (i = Ul()) == null || i.addEventListener(e, l, n) : (s = qn()) == null || s.addEventListener(e, l, n), t;
  if (typeof e == "number")
    return fu[e] ? (fu[e].target === "document" ? (r = Ul()) == null || r.removeEventListener(fu[e].type, fu[e].callback) : (o = qn()) == null || o.removeEventListener(fu[e].type, fu[e].callback), e) : void 0;
}
var Vg, jg;
const _B = ((Vg = qn()) == null ? void 0 : Vg.matchMedia) && ((jg = qn()) == null ? void 0 : jg.matchMedia("(prefers-color-scheme: dark)").matches);
var Ug;
const Bn = (Ug = qn()) == null ? void 0 : Ug.matchMedia("(prefers-color-scheme: dark)"), k0 = (e) => {
  var n;
  const l = e.matches ? "dark" : "light";
  (n = Ul()) == null || n.documentElement.setAttribute("data-orion-theme", l);
};
function C3() {
  var e;
  return ((e = zc()) == null ? void 0 : e.getItem("orion-theme")) ?? "auto";
}
function Nw(e) {
  var l, n, t, u, i;
  e === "dark" || e === "light" ? ((l = zc()) == null || l.setItem("orion-theme", e), (n = Ul()) == null || n.documentElement.setAttribute("data-orion-theme", e), typeof (Bn == null ? void 0 : Bn.removeEventListener) == "function" && (Bn == null || Bn.removeEventListener("change", k0))) : ((t = zc()) == null || t.removeItem("orion-theme"), Bn != null && Bn.matches ? (u = Ul()) == null || u.documentElement.setAttribute("data-orion-theme", "dark") : (i = Ul()) == null || i.documentElement.setAttribute("data-orion-theme", "light"), typeof (Bn == null ? void 0 : Bn.addEventListener) == "function" && (Bn == null || Bn.addEventListener("change", k0))), xn == null || xn.sendInspectorState(Hc);
}
function Lw() {
  Nw(C3());
}
/*!
  * vue-router v4.2.5
  * (c) 2023 Eduardo San Martin Morote
  * @license MIT
  */
const Pw = typeof window < "u", Bw = Object.assign, Fw = Array.isArray;
function Hw(e) {
  const l = Array.from(arguments).slice(1);
  console.warn.apply(console, ["[Vue Router warn]: " + e].concat(l));
}
function zw(e, l) {
  return (e.aliasOf || e) === (l.aliasOf || l);
}
var M0;
(function(e) {
  e.pop = "pop", e.push = "push";
})(M0 || (M0 = {}));
var A0;
(function(e) {
  e.back = "back", e.forward = "forward", e.unknown = "";
})(A0 || (A0 = {}));
Symbol(process.env.NODE_ENV !== "production" ? "navigation failure" : "");
var x0;
(function(e) {
  e[e.aborted = 4] = "aborted", e[e.cancelled = 8] = "cancelled", e[e.duplicated = 16] = "duplicated";
})(x0 || (x0 = {}));
const Vw = Symbol(process.env.NODE_ENV !== "production" ? "router view location matched" : ""), E0 = Symbol(process.env.NODE_ENV !== "production" ? "router view depth" : ""), jw = Symbol(process.env.NODE_ENV !== "production" ? "router" : ""), Uw = Symbol(process.env.NODE_ENV !== "production" ? "route location" : ""), I0 = Symbol(process.env.NODE_ENV !== "production" ? "router view location" : ""), Ww = /* @__PURE__ */ K({
  name: "RouterView",
  // #674 we manually inherit them
  inheritAttrs: !1,
  props: {
    name: {
      type: String,
      default: "default"
    },
    route: Object
  },
  // Better compat for @vue/compat users
  // https://github.com/vuejs/router/issues/1315
  compatConfig: { MODE: 3 },
  setup(e, { attrs: l, slots: n }) {
    process.env.NODE_ENV !== "production" && Kw();
    const t = Tn(I0), u = wu(() => e.route || t.value), i = Tn(E0, 0), s = wu(() => {
      let a = c(i);
      const { matched: d } = u.value;
      let h;
      for (; (h = d[a]) && !h.components; )
        a++;
      return a;
    }), r = wu(() => u.value.matched[s.value]);
    De(E0, wu(() => s.value + 1)), De(Vw, r), De(I0, u);
    const o = J();
    return Pl(() => [o.value, r.value, e.name], ([a, d, h], [p, f, m]) => {
      d && (d.instances[h] = a, f && f !== d && a && a === p && (d.leaveGuards.size || (d.leaveGuards = f.leaveGuards), d.updateGuards.size || (d.updateGuards = f.updateGuards))), a && d && // if there is no instance but to and from are the same this might be
      // the first visit
      (!f || !zw(d, f) || !p) && (d.enterCallbacks[h] || []).forEach((g) => g(a));
    }, { flush: "post" }), () => {
      const a = u.value, d = e.name, h = r.value, p = h && h.components[d];
      if (!p)
        return R0(n.default, { Component: p, route: a });
      const f = h.props[d], m = f ? f === !0 ? a.params : typeof f == "function" ? f(a) : f : null, v = ye(p, Bw({}, m, l, {
        onVnodeUnmounted: (w) => {
          w.component.isUnmounted && (h.instances[d] = null);
        },
        ref: o
      }));
      if (process.env.NODE_ENV !== "production" && Pw && v.ref) {
        const w = {
          depth: s.value,
          name: h.name,
          path: h.path,
          meta: h.meta
        };
        (Fw(v.ref) ? v.ref.map((_) => _.i) : [v.ref.i]).forEach((_) => {
          _.__vrv_devtools = w;
        });
      }
      return (
        // pass the vnode to the slot as a prop.
        // h and <component :is="..."> both accept vnodes
        R0(n.default, { Component: v, route: a }) || v
      );
    };
  }
});
function R0(e, l) {
  if (!e)
    return null;
  const n = e(l);
  return n.length === 1 ? n[0] : n;
}
const Gw = Ww;
function Kw() {
  const e = Wg(), l = e.parent && e.parent.type.name, n = e.parent && e.parent.subTree && e.parent.subTree.type;
  if (l && (l === "KeepAlive" || l.includes("Transition")) && typeof n == "object" && n.name === "RouterView") {
    const t = l === "KeepAlive" ? "keep-alive" : "transition";
    Hw(`<router-view> can no longer be used directly inside <transition> or <keep-alive>.
Use slot props instead:

<router-view v-slot="{ Component }">
  <${t}>
    <component :is="Component" />
  </${t}>
</router-view>`);
  }
}
function Yw() {
  return Tn(jw);
}
function qw() {
  return Tn(Uw);
}
function Ri(e) {
  return { all: e = e || /* @__PURE__ */ new Map(), on: function(l, n) {
    var t = e.get(l);
    t ? t.push(n) : e.set(l, [n]);
  }, off: function(l, n) {
    var t = e.get(l);
    t && (n ? t.splice(t.indexOf(n) >>> 0, 1) : e.set(l, []));
  }, emit: function(l, n) {
    var t = e.get(l);
    t && t.slice().map(function(u) {
      u(n);
    }), (t = e.get("*")) && t.slice().map(function(u) {
      u(l, n);
    });
  } };
}
const T3 = Ri();
function SB() {
  T3.on("*", (e, l) => {
    Dn.info(l, `Bus ~ ${e}`);
  });
}
class Jw {
  constructor() {
    S(this, "state", fl({
      token: ft()
    }));
  }
  get token() {
    return this.state.token;
  }
  update() {
    this.state.token = ft();
  }
}
const Zw = new Jw();
function Xw() {
  return Zw;
}
class gl {
  constructor(l) {
    S(this, "props", {});
    S(this, "defaultRouter", Yw());
    S(this, "responsive", b3());
    S(this, "window", qn());
    S(this, "document", Ul());
    S(this, "ui", Xw());
    S(this, "Bus", T3);
    S(this, "getUid", ft);
    S(this, "_el", J());
    this.props = l ?? {}, qy(() => {
      this.onBeforeMount();
    }), xi(() => {
      this.onMounted();
    }), Jy(() => {
      this.onBeforeUpdate();
    }), Zy(() => {
      this.onUpdated();
    }), Ao(() => {
      this.onUnmounted();
    });
  }
  get router() {
    return Fl.appRouter ?? this.defaultRouter;
  }
  get publicInstance() {
    return {
      _el: () => this._el.value
    };
  }
  get lang() {
    return ul();
  }
  async onBeforeMount() {
  }
  onMounted() {
  }
  onBeforeUpdate() {
  }
  onUpdated() {
  }
  onUnmounted() {
  }
}
class Qw {
  constructor() {
    Dn.orion("OverlayService activated");
  }
  /**
   * @desc adds a global overlay on the application. Used by **Orion** to set the main overlay
   * @param {object} overlayInstance instance of the orion overlay
   * @return void
   */
  setGlobalOverlay(l) {
    if (this.globalOverlay)
      throw "Orion global overlay already set";
    this.globalOverlay = l;
  }
  guard() {
    if (!this.globalOverlay)
      throw "Orion global overlay not set";
  }
  /**
   * @desc if the global overlay is set, shows the overlay
   * @return void
   */
  show() {
    var l;
    this.guard(), (l = this.globalOverlay) == null || l.show();
  }
  /**
   * @desc if the global overlay is set, hides the overlay
   * @return void
   */
  hide() {
    var l;
    this.guard(), (l = this.globalOverlay) == null || l.hide();
  }
}
const l_ = new Qw();
function Xu() {
  return l_;
}
class n_ {
  constructor() {
    S(this, "_popables", {});
    S(this, "_queue", fl({
      OrionAside: [],
      OrionModal: [],
      OrionNotif: [],
      ids: []
    }));
  }
  get queue() {
    return this._queue;
  }
  get queueIds() {
    return this._queue.ids;
  }
  get asideQueue() {
    return this._queue.OrionAside;
  }
  get modalQueue() {
    return this._queue.OrionModal;
  }
  get notifQueue() {
    return this._queue.OrionNotif;
  }
  register(l, n) {
    this._popables[l] = n;
  }
  unregister(l) {
    delete this._popables[l];
  }
  getInstance(l) {
    return this._popables[l];
  }
}
const e_ = new n_();
function an() {
  return e_;
}
class Vc extends gl {
  constructor(n) {
    super(n);
    S(this, "state", fl({
      visible: !1,
      parentOverflowStyle: void 0
    }));
    this.props.global && Xu().setGlobalOverlay(this.publicInstance);
  }
  get activeModalUsingOverlay() {
    return an().modalQueue.filter((n) => n.state.visible && n.options.overlay);
  }
  get activeAsideUsingOverlay() {
    return an().asideQueue.filter((n) => n.state.visible && n.options.overlay);
  }
  get visible() {
    return this.state.visible;
  }
  get zIndex() {
    const n = an().queueIds.length;
    return this.props.global && n ? 99 + n : 100;
  }
  get publicInstance() {
    return {
      ...super.publicInstance,
      show: this.show.bind(this),
      hide: this.hide.bind(this)
    };
  }
  show() {
    this.state.visible = !0;
  }
  hide() {
    this.activeModalUsingOverlay.length || this.activeAsideUsingOverlay.length || (this.state.visible = !1);
  }
  handleClick() {
    this.props.global && (this.hide(), nw([...an().asideQueue, ...an().modalQueue], (n) => {
      n.state.visible && n.options.hideOnOverlayClick && n.isLastOpenedPopable() && n.close();
    }));
  }
}
S(Vc, "props", {
  // @doc props/global defines if the overlay is fullpage
  // @doc props/global définit si le contraste doit être sur toute la page
  global: Boolean
});
const t_ = /* @__PURE__ */ A("div", {
  class: "orion-overlay__overscroll-behavior"
}, null, -1), u_ = [t_], O3 = /* @__PURE__ */ K({
  __name: "OrionOverlay",
  props: Vc.props,
  setup(e, {
    expose: l
  }) {
    const n = e, t = new Vc(n);
    return l(t.publicInstance), (u, i) => (y(), O("div", {
      ref: c(t)._el,
      style: Wl({
        zIndex: c(t).zIndex
      }),
      class: z(["orion-overlay", {
        "orion-overlay--global": c(t).props.global,
        "orion-overlay--visible": c(t).visible
      }]),
      onClick: i[0] || (i[0] = (s) => c(t).handleClick())
    }, u_, 6));
  }
}), Aa = {
  install(e, l = "o") {
    e.component(`${tl(l)}Overlay`, O3);
  }
};
class _l {
}
S(_l, "vModel", (l) => ({
  // @doc props/modelValue modelValue of the component
  // @doc/fr props/modelValue modelValue du composant
  modelValue: {
    type: [String, Number, Array, Object, Date],
    default: l
  }
})), S(_l, "color", (l = "default") => ({
  // @doc props/color defines the color
  // @doc/fr props/color définit la couleur
  color: {
    type: String,
    default: l
  }
})), S(_l, "colorExtended", (l = "default") => ({
  // @doc props/color defines the color
  // @doc/fr props/color définit la couleur
  color: {
    type: String,
    default: l
  }
})), S(_l, "colorExtendedAndGreys", (l = "default") => ({
  // @doc props/color defines the color
  // @doc/fr props/color définit la couleur
  color: {
    type: String,
    default: l
  }
})), S(_l, "size", (l = "md") => ({
  // @doc props/size define the size
  // @doc/fr props/size définit la taille
  size: {
    type: String,
    default: l
  }
})), S(_l, "icon", (l) => ({
  // @doc props/icon the icon of the component
  // @doc/fr props/icon définit l'icône
  icon: {
    type: String,
    default: l
  },
  // @doc props/fontIcon the icon of the component, from the imported font library
  // @doc/fr props/fontIcon l'icône du composant, de la librairie de police importée
  fontIcon: {
    type: String,
    default: void 0
  }
})), S(_l, "prefixIcon", (l) => ({
  // @doc props/prefixIcon the prefix icon
  // @doc/fr props/prefixIcon définit l'icône de préfixe
  prefixIcon: {
    type: String,
    default: l
  },
  // @doc props/prefixFontIcon the prefix icon from the imported font library
  // @doc/fr props/prefixFontIcon définit l'icône de préfixe à partir de la librairie de police importée
  prefixFontIcon: {
    type: String,
    default: void 0
  }
})), S(_l, "suffixIcon", (l) => ({
  // @doc props/suffixIcon the suffix icon
  // @doc/fr props/suffixIcon définit l'icône de suffixe
  suffixIcon: {
    type: String,
    default: l
  },
  // @doc props/suffixFontIcon the suffix icon from the imported font library
  // @doc props/suffixFontIcon définit l'icône de suffixe à partir de la librairie de police importée
  suffixFontIcon: {
    type: String,
    default: void 0
  }
})), S(_l, "nav", () => ({
  items: {
    type: Array,
    default: () => []
  }
}));
var k3 = {
  update: null,
  begin: null,
  loopBegin: null,
  changeBegin: null,
  change: null,
  changeComplete: null,
  loopComplete: null,
  complete: null,
  loop: 1,
  direction: "normal",
  autoplay: !0,
  timelineOffset: 0
}, cf = {
  duration: 1e3,
  delay: 0,
  endDelay: 0,
  easing: "easeOutElastic(1, .5)",
  round: 0
}, i_ = ["translateX", "translateY", "translateZ", "rotate", "rotateX", "rotateY", "rotateZ", "scale", "scaleX", "scaleY", "scaleZ", "skew", "skewX", "skewY", "perspective", "matrix", "matrix3d"], Ir = {
  CSS: {},
  springs: {}
};
function ut(e, l, n) {
  return Math.min(Math.max(e, l), n);
}
function Ji(e, l) {
  return e.indexOf(l) > -1;
}
function xa(e, l) {
  return e.apply(null, l);
}
var ol = {
  arr: function(e) {
    return Array.isArray(e);
  },
  obj: function(e) {
    return Ji(Object.prototype.toString.call(e), "Object");
  },
  pth: function(e) {
    return ol.obj(e) && e.hasOwnProperty("totalLength");
  },
  svg: function(e) {
    return e instanceof SVGElement;
  },
  inp: function(e) {
    return e instanceof HTMLInputElement;
  },
  dom: function(e) {
    return e.nodeType || ol.svg(e);
  },
  str: function(e) {
    return typeof e == "string";
  },
  fnc: function(e) {
    return typeof e == "function";
  },
  und: function(e) {
    return typeof e > "u";
  },
  nil: function(e) {
    return ol.und(e) || e === null;
  },
  hex: function(e) {
    return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(e);
  },
  rgb: function(e) {
    return /^rgb/.test(e);
  },
  hsl: function(e) {
    return /^hsl/.test(e);
  },
  col: function(e) {
    return ol.hex(e) || ol.rgb(e) || ol.hsl(e);
  },
  key: function(e) {
    return !k3.hasOwnProperty(e) && !cf.hasOwnProperty(e) && e !== "targets" && e !== "keyframes";
  }
};
function M3(e) {
  var l = /\(([^)]+)\)/.exec(e);
  return l ? l[1].split(",").map(function(n) {
    return parseFloat(n);
  }) : [];
}
function A3(e, l) {
  var n = M3(e), t = ut(ol.und(n[0]) ? 1 : n[0], 0.1, 100), u = ut(ol.und(n[1]) ? 100 : n[1], 0.1, 100), i = ut(ol.und(n[2]) ? 10 : n[2], 0.1, 100), s = ut(ol.und(n[3]) ? 0 : n[3], 0.1, 100), r = Math.sqrt(u / t), o = i / (2 * Math.sqrt(u * t)), a = o < 1 ? r * Math.sqrt(1 - o * o) : 0, d = 1, h = o < 1 ? (o * r + -s) / a : -s + r;
  function p(m) {
    var g = l ? l * m / 1e3 : m;
    return o < 1 ? g = Math.exp(-g * o * r) * (d * Math.cos(a * g) + h * Math.sin(a * g)) : g = (d + h * g) * Math.exp(-g * r), m === 0 || m === 1 ? m : 1 - g;
  }
  function f() {
    var m = Ir.springs[e];
    if (m)
      return m;
    for (var g = 1 / 6, v = 0, w = 0; ; )
      if (v += g, p(v) === 1) {
        if (w++, w >= 16)
          break;
      } else
        w = 0;
    var $ = v * g * 1e3;
    return Ir.springs[e] = $, $;
  }
  return l ? p : f;
}
function s_(e) {
  return e === void 0 && (e = 10), function(l) {
    return Math.ceil(ut(l, 1e-6, 1) * e) * (1 / e);
  };
}
var r_ = function() {
  var e = 11, l = 1 / (e - 1);
  function n(d, h) {
    return 1 - 3 * h + 3 * d;
  }
  function t(d, h) {
    return 3 * h - 6 * d;
  }
  function u(d) {
    return 3 * d;
  }
  function i(d, h, p) {
    return ((n(h, p) * d + t(h, p)) * d + u(h)) * d;
  }
  function s(d, h, p) {
    return 3 * n(h, p) * d * d + 2 * t(h, p) * d + u(h);
  }
  function r(d, h, p, f, m) {
    var g, v, w = 0;
    do
      v = h + (p - h) / 2, g = i(v, f, m) - d, g > 0 ? p = v : h = v;
    while (Math.abs(g) > 1e-7 && ++w < 10);
    return v;
  }
  function o(d, h, p, f) {
    for (var m = 0; m < 4; ++m) {
      var g = s(h, p, f);
      if (g === 0)
        return h;
      var v = i(h, p, f) - d;
      h -= v / g;
    }
    return h;
  }
  function a(d, h, p, f) {
    if (!(0 <= d && d <= 1 && 0 <= p && p <= 1))
      return;
    var m = new Float32Array(e);
    if (d !== h || p !== f)
      for (var g = 0; g < e; ++g)
        m[g] = i(g * l, d, p);
    function v(w) {
      for (var $ = 0, _ = 1, b = e - 1; _ !== b && m[_] <= w; ++_)
        $ += l;
      --_;
      var k = (w - m[_]) / (m[_ + 1] - m[_]), T = $ + k * l, M = s(T, d, p);
      return M >= 1e-3 ? o(w, T, d, p) : M === 0 ? T : r(w, $, $ + l, d, p);
    }
    return function(w) {
      return d === h && p === f || w === 0 || w === 1 ? w : i(v(w), h, f);
    };
  }
  return a;
}(), x3 = function() {
  var e = { linear: function() {
    return function(t) {
      return t;
    };
  } }, l = {
    Sine: function() {
      return function(t) {
        return 1 - Math.cos(t * Math.PI / 2);
      };
    },
    Expo: function() {
      return function(t) {
        return t ? Math.pow(2, 10 * t - 10) : 0;
      };
    },
    Circ: function() {
      return function(t) {
        return 1 - Math.sqrt(1 - t * t);
      };
    },
    Back: function() {
      return function(t) {
        return t * t * (3 * t - 2);
      };
    },
    Bounce: function() {
      return function(t) {
        for (var u, i = 4; t < ((u = Math.pow(2, --i)) - 1) / 11; )
          ;
        return 1 / Math.pow(4, 3 - i) - 7.5625 * Math.pow((u * 3 - 2) / 22 - t, 2);
      };
    },
    Elastic: function(t, u) {
      t === void 0 && (t = 1), u === void 0 && (u = 0.5);
      var i = ut(t, 1, 10), s = ut(u, 0.1, 2);
      return function(r) {
        return r === 0 || r === 1 ? r : -i * Math.pow(2, 10 * (r - 1)) * Math.sin((r - 1 - s / (Math.PI * 2) * Math.asin(1 / i)) * (Math.PI * 2) / s);
      };
    }
  }, n = ["Quad", "Cubic", "Quart", "Quint"];
  return n.forEach(function(t, u) {
    l[t] = function() {
      return function(i) {
        return Math.pow(i, u + 2);
      };
    };
  }), Object.keys(l).forEach(function(t) {
    var u = l[t];
    e["easeIn" + t] = u, e["easeOut" + t] = function(i, s) {
      return function(r) {
        return 1 - u(i, s)(1 - r);
      };
    }, e["easeInOut" + t] = function(i, s) {
      return function(r) {
        return r < 0.5 ? u(i, s)(r * 2) / 2 : 1 - u(i, s)(r * -2 + 2) / 2;
      };
    }, e["easeOutIn" + t] = function(i, s) {
      return function(r) {
        return r < 0.5 ? (1 - u(i, s)(1 - r * 2)) / 2 : (u(i, s)(r * 2 - 1) + 1) / 2;
      };
    };
  }), e;
}();
function hf(e, l) {
  if (ol.fnc(e))
    return e;
  var n = e.split("(")[0], t = x3[n], u = M3(e);
  switch (n) {
    case "spring":
      return A3(e, l);
    case "cubicBezier":
      return xa(r_, u);
    case "steps":
      return xa(s_, u);
    default:
      return xa(t, u);
  }
}
function E3(e) {
  try {
    var l = document.querySelectorAll(e);
    return l;
  } catch {
    return;
  }
}
function Ko(e, l) {
  for (var n = e.length, t = arguments.length >= 2 ? arguments[1] : void 0, u = [], i = 0; i < n; i++)
    if (i in e) {
      var s = e[i];
      l.call(t, s, i, e) && u.push(s);
    }
  return u;
}
function Yo(e) {
  return e.reduce(function(l, n) {
    return l.concat(ol.arr(n) ? Yo(n) : n);
  }, []);
}
function D0(e) {
  return ol.arr(e) ? e : (ol.str(e) && (e = E3(e) || e), e instanceof NodeList || e instanceof HTMLCollection ? [].slice.call(e) : [e]);
}
function pf(e, l) {
  return e.some(function(n) {
    return n === l;
  });
}
function ff(e) {
  var l = {};
  for (var n in e)
    l[n] = e[n];
  return l;
}
function jc(e, l) {
  var n = ff(e);
  for (var t in e)
    n[t] = l.hasOwnProperty(t) ? l[t] : e[t];
  return n;
}
function qo(e, l) {
  var n = ff(e);
  for (var t in l)
    n[t] = ol.und(e[t]) ? l[t] : e[t];
  return n;
}
function o_(e) {
  var l = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(e);
  return l ? "rgba(" + l[1] + ",1)" : e;
}
function a_(e) {
  var l = /^#?([a-f\d])([a-f\d])([a-f\d])$/i, n = e.replace(l, function(r, o, a, d) {
    return o + o + a + a + d + d;
  }), t = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(n), u = parseInt(t[1], 16), i = parseInt(t[2], 16), s = parseInt(t[3], 16);
  return "rgba(" + u + "," + i + "," + s + ",1)";
}
function d_(e) {
  var l = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(e) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(e), n = parseInt(l[1], 10) / 360, t = parseInt(l[2], 10) / 100, u = parseInt(l[3], 10) / 100, i = l[4] || 1;
  function s(p, f, m) {
    return m < 0 && (m += 1), m > 1 && (m -= 1), m < 1 / 6 ? p + (f - p) * 6 * m : m < 1 / 2 ? f : m < 2 / 3 ? p + (f - p) * (2 / 3 - m) * 6 : p;
  }
  var r, o, a;
  if (t == 0)
    r = o = a = u;
  else {
    var d = u < 0.5 ? u * (1 + t) : u + t - u * t, h = 2 * u - d;
    r = s(h, d, n + 1 / 3), o = s(h, d, n), a = s(h, d, n - 1 / 3);
  }
  return "rgba(" + r * 255 + "," + o * 255 + "," + a * 255 + "," + i + ")";
}
function c_(e) {
  if (ol.rgb(e))
    return o_(e);
  if (ol.hex(e))
    return a_(e);
  if (ol.hsl(e))
    return d_(e);
}
function At(e) {
  var l = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(e);
  if (l)
    return l[1];
}
function h_(e) {
  if (Ji(e, "translate") || e === "perspective")
    return "px";
  if (Ji(e, "rotate") || Ji(e, "skew"))
    return "deg";
}
function Uc(e, l) {
  return ol.fnc(e) ? e(l.target, l.id, l.total) : e;
}
function it(e, l) {
  return e.getAttribute(l);
}
function mf(e, l, n) {
  var t = At(l);
  if (pf([n, "deg", "rad", "turn"], t))
    return l;
  var u = Ir.CSS[l + n];
  if (!ol.und(u))
    return u;
  var i = 100, s = document.createElement(e.tagName), r = e.parentNode && e.parentNode !== document ? e.parentNode : document.body;
  r.appendChild(s), s.style.position = "absolute", s.style.width = i + n;
  var o = i / s.offsetWidth;
  r.removeChild(s);
  var a = o * parseFloat(l);
  return Ir.CSS[l + n] = a, a;
}
function I3(e, l, n) {
  if (l in e.style) {
    var t = l.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(), u = e.style[l] || getComputedStyle(e).getPropertyValue(t) || "0";
    return n ? mf(e, u, n) : u;
  }
}
function gf(e, l) {
  if (ol.dom(e) && !ol.inp(e) && (!ol.nil(it(e, l)) || ol.svg(e) && e[l]))
    return "attribute";
  if (ol.dom(e) && pf(i_, l))
    return "transform";
  if (ol.dom(e) && l !== "transform" && I3(e, l))
    return "css";
  if (e[l] != null)
    return "object";
}
function R3(e) {
  if (ol.dom(e)) {
    for (var l = e.style.transform || "", n = /(\w+)\(([^)]*)\)/g, t = /* @__PURE__ */ new Map(), u; u = n.exec(l); )
      t.set(u[1], u[2]);
    return t;
  }
}
function p_(e, l, n, t) {
  var u = Ji(l, "scale") ? 1 : 0 + h_(l), i = R3(e).get(l) || u;
  return n && (n.transforms.list.set(l, i), n.transforms.last = l), t ? mf(e, i, t) : i;
}
function vf(e, l, n, t) {
  switch (gf(e, l)) {
    case "transform":
      return p_(e, l, t, n);
    case "css":
      return I3(e, l, n);
    case "attribute":
      return it(e, l);
    default:
      return e[l] || 0;
  }
}
function yf(e, l) {
  var n = /^(\*=|\+=|-=)/.exec(e);
  if (!n)
    return e;
  var t = At(e) || 0, u = parseFloat(l), i = parseFloat(e.replace(n[0], ""));
  switch (n[0][0]) {
    case "+":
      return u + i + t;
    case "-":
      return u - i + t;
    case "*":
      return u * i + t;
  }
}
function D3(e, l) {
  if (ol.col(e))
    return c_(e);
  if (/\s/g.test(e))
    return e;
  var n = At(e), t = n ? e.substr(0, e.length - n.length) : e;
  return l ? t + l : t;
}
function $f(e, l) {
  return Math.sqrt(Math.pow(l.x - e.x, 2) + Math.pow(l.y - e.y, 2));
}
function f_(e) {
  return Math.PI * 2 * it(e, "r");
}
function m_(e) {
  return it(e, "width") * 2 + it(e, "height") * 2;
}
function g_(e) {
  return $f(
    { x: it(e, "x1"), y: it(e, "y1") },
    { x: it(e, "x2"), y: it(e, "y2") }
  );
}
function N3(e) {
  for (var l = e.points, n = 0, t, u = 0; u < l.numberOfItems; u++) {
    var i = l.getItem(u);
    u > 0 && (n += $f(t, i)), t = i;
  }
  return n;
}
function v_(e) {
  var l = e.points;
  return N3(e) + $f(l.getItem(l.numberOfItems - 1), l.getItem(0));
}
function L3(e) {
  if (e.getTotalLength)
    return e.getTotalLength();
  switch (e.tagName.toLowerCase()) {
    case "circle":
      return f_(e);
    case "rect":
      return m_(e);
    case "line":
      return g_(e);
    case "polyline":
      return N3(e);
    case "polygon":
      return v_(e);
  }
}
function y_(e) {
  var l = L3(e);
  return e.setAttribute("stroke-dasharray", l), l;
}
function $_(e) {
  for (var l = e.parentNode; ol.svg(l) && ol.svg(l.parentNode); )
    l = l.parentNode;
  return l;
}
function P3(e, l) {
  var n = l || {}, t = n.el || $_(e), u = t.getBoundingClientRect(), i = it(t, "viewBox"), s = u.width, r = u.height, o = n.viewBox || (i ? i.split(" ") : [0, 0, s, r]);
  return {
    el: t,
    viewBox: o,
    x: o[0] / 1,
    y: o[1] / 1,
    w: s,
    h: r,
    vW: o[2],
    vH: o[3]
  };
}
function b_(e, l) {
  var n = ol.str(e) ? E3(e)[0] : e, t = l || 100;
  return function(u) {
    return {
      property: u,
      el: n,
      svg: P3(n),
      totalLength: L3(n) * (t / 100)
    };
  };
}
function w_(e, l, n) {
  function t(d) {
    d === void 0 && (d = 0);
    var h = l + d >= 1 ? l + d : 0;
    return e.el.getPointAtLength(h);
  }
  var u = P3(e.el, e.svg), i = t(), s = t(-1), r = t(1), o = n ? 1 : u.w / u.vW, a = n ? 1 : u.h / u.vH;
  switch (e.property) {
    case "x":
      return (i.x - u.x) * o;
    case "y":
      return (i.y - u.y) * a;
    case "angle":
      return Math.atan2(r.y - s.y, r.x - s.x) * 180 / Math.PI;
  }
}
function N0(e, l) {
  var n = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g, t = D3(ol.pth(e) ? e.totalLength : e, l) + "";
  return {
    original: t,
    numbers: t.match(n) ? t.match(n).map(Number) : [0],
    strings: ol.str(e) || l ? t.split(n) : []
  };
}
function bf(e) {
  var l = e ? Yo(ol.arr(e) ? e.map(D0) : D0(e)) : [];
  return Ko(l, function(n, t, u) {
    return u.indexOf(n) === t;
  });
}
function B3(e) {
  var l = bf(e);
  return l.map(function(n, t) {
    return { target: n, id: t, total: l.length, transforms: { list: R3(n) } };
  });
}
function __(e, l) {
  var n = ff(l);
  if (/^spring/.test(n.easing) && (n.duration = A3(n.easing)), ol.arr(e)) {
    var t = e.length, u = t === 2 && !ol.obj(e[0]);
    u ? e = { value: e } : ol.fnc(l.duration) || (n.duration = l.duration / t);
  }
  var i = ol.arr(e) ? e : [e];
  return i.map(function(s, r) {
    var o = ol.obj(s) && !ol.pth(s) ? s : { value: s };
    return ol.und(o.delay) && (o.delay = r ? 0 : l.delay), ol.und(o.endDelay) && (o.endDelay = r === i.length - 1 ? l.endDelay : 0), o;
  }).map(function(s) {
    return qo(s, n);
  });
}
function S_(e) {
  for (var l = Ko(Yo(e.map(function(i) {
    return Object.keys(i);
  })), function(i) {
    return ol.key(i);
  }).reduce(function(i, s) {
    return i.indexOf(s) < 0 && i.push(s), i;
  }, []), n = {}, t = function(i) {
    var s = l[i];
    n[s] = e.map(function(r) {
      var o = {};
      for (var a in r)
        ol.key(a) ? a == s && (o.value = r[a]) : o[a] = r[a];
      return o;
    });
  }, u = 0; u < l.length; u++)
    t(u);
  return n;
}
function C_(e, l) {
  var n = [], t = l.keyframes;
  t && (l = qo(S_(t), l));
  for (var u in l)
    ol.key(u) && n.push({
      name: u,
      tweens: __(l[u], e)
    });
  return n;
}
function T_(e, l) {
  var n = {};
  for (var t in e) {
    var u = Uc(e[t], l);
    ol.arr(u) && (u = u.map(function(i) {
      return Uc(i, l);
    }), u.length === 1 && (u = u[0])), n[t] = u;
  }
  return n.duration = parseFloat(n.duration), n.delay = parseFloat(n.delay), n;
}
function O_(e, l) {
  var n;
  return e.tweens.map(function(t) {
    var u = T_(t, l), i = u.value, s = ol.arr(i) ? i[1] : i, r = At(s), o = vf(l.target, e.name, r, l), a = n ? n.to.original : o, d = ol.arr(i) ? i[0] : a, h = At(d) || At(o), p = r || h;
    return ol.und(s) && (s = a), u.from = N0(d, p), u.to = N0(yf(s, d), p), u.start = n ? n.end : 0, u.end = u.start + u.delay + u.duration + u.endDelay, u.easing = hf(u.easing, u.duration), u.isPath = ol.pth(i), u.isPathTargetInsideSVG = u.isPath && ol.svg(l.target), u.isColor = ol.col(u.from.original), u.isColor && (u.round = 1), n = u, u;
  });
}
var F3 = {
  css: function(e, l, n) {
    return e.style[l] = n;
  },
  attribute: function(e, l, n) {
    return e.setAttribute(l, n);
  },
  object: function(e, l, n) {
    return e[l] = n;
  },
  transform: function(e, l, n, t, u) {
    if (t.list.set(l, n), l === t.last || u) {
      var i = "";
      t.list.forEach(function(s, r) {
        i += r + "(" + s + ") ";
      }), e.style.transform = i;
    }
  }
};
function H3(e, l) {
  var n = B3(e);
  n.forEach(function(t) {
    for (var u in l) {
      var i = Uc(l[u], t), s = t.target, r = At(i), o = vf(s, u, r, t), a = r || At(o), d = yf(D3(i, a), o), h = gf(s, u);
      F3[h](s, u, d, t.transforms, !0);
    }
  });
}
function k_(e, l) {
  var n = gf(e.target, l.name);
  if (n) {
    var t = O_(l, e), u = t[t.length - 1];
    return {
      type: n,
      property: l.name,
      animatable: e,
      tweens: t,
      duration: u.end,
      delay: t[0].delay,
      endDelay: u.endDelay
    };
  }
}
function M_(e, l) {
  return Ko(Yo(e.map(function(n) {
    return l.map(function(t) {
      return k_(n, t);
    });
  })), function(n) {
    return !ol.und(n);
  });
}
function z3(e, l) {
  var n = e.length, t = function(i) {
    return i.timelineOffset ? i.timelineOffset : 0;
  }, u = {};
  return u.duration = n ? Math.max.apply(Math, e.map(function(i) {
    return t(i) + i.duration;
  })) : l.duration, u.delay = n ? Math.min.apply(Math, e.map(function(i) {
    return t(i) + i.delay;
  })) : l.delay, u.endDelay = n ? u.duration - Math.max.apply(Math, e.map(function(i) {
    return t(i) + i.duration - i.endDelay;
  })) : l.endDelay, u;
}
var L0 = 0;
function A_(e) {
  var l = jc(k3, e), n = jc(cf, e), t = C_(n, e), u = B3(e.targets), i = M_(u, t), s = z3(i, n), r = L0;
  return L0++, qo(l, {
    id: r,
    children: [],
    animatables: u,
    animations: i,
    duration: s.duration,
    delay: s.delay,
    endDelay: s.endDelay
  });
}
var Ie = [], V3 = function() {
  var e;
  function l() {
    !e && (!P0() || !El.suspendWhenDocumentHidden) && Ie.length > 0 && (e = requestAnimationFrame(n));
  }
  function n(u) {
    for (var i = Ie.length, s = 0; s < i; ) {
      var r = Ie[s];
      r.paused ? (Ie.splice(s, 1), i--) : (r.tick(u), s++);
    }
    e = s > 0 ? requestAnimationFrame(n) : void 0;
  }
  function t() {
    El.suspendWhenDocumentHidden && (P0() ? e = cancelAnimationFrame(e) : (Ie.forEach(
      function(u) {
        return u._onDocumentVisibility();
      }
    ), V3()));
  }
  return typeof document < "u" && document.addEventListener("visibilitychange", t), l;
}();
function P0() {
  return !!document && document.hidden;
}
function El(e) {
  e === void 0 && (e = {});
  var l = 0, n = 0, t = 0, u, i = 0, s = null;
  function r($) {
    var _ = window.Promise && new Promise(function(b) {
      return s = b;
    });
    return $.finished = _, _;
  }
  var o = A_(e);
  r(o);
  function a() {
    var $ = o.direction;
    $ !== "alternate" && (o.direction = $ !== "normal" ? "normal" : "reverse"), o.reversed = !o.reversed, u.forEach(function(_) {
      return _.reversed = o.reversed;
    });
  }
  function d($) {
    return o.reversed ? o.duration - $ : $;
  }
  function h() {
    l = 0, n = d(o.currentTime) * (1 / El.speed);
  }
  function p($, _) {
    _ && _.seek($ - _.timelineOffset);
  }
  function f($) {
    if (o.reversePlayback)
      for (var b = i; b--; )
        p($, u[b]);
    else
      for (var _ = 0; _ < i; _++)
        p($, u[_]);
  }
  function m($) {
    for (var _ = 0, b = o.animations, k = b.length; _ < k; ) {
      var T = b[_], M = T.animatable, H = T.tweens, x = H.length - 1, P = H[x];
      x && (P = Ko(H, function(kn) {
        return $ < kn.end;
      })[0] || P);
      for (var Z = ut($ - P.start - P.delay, 0, P.duration) / P.duration, F = isNaN(Z) ? 1 : P.easing(Z), el = P.to.strings, al = P.round, ll = [], Y = P.to.numbers.length, Q = void 0, dl = 0; dl < Y; dl++) {
        var zl = void 0, Xl = P.to.numbers[dl], sn = P.from.numbers[dl] || 0;
        P.isPath ? zl = w_(P.value, F * Xl, P.isPathTargetInsideSVG) : zl = sn + F * (Xl - sn), al && (P.isColor && dl > 2 || (zl = Math.round(zl * al) / al)), ll.push(zl);
      }
      var Jl = el.length;
      if (!Jl)
        Q = ll[0];
      else {
        Q = el[0];
        for (var rn = 0; rn < Jl; rn++) {
          el[rn];
          var vn = el[rn + 1], en = ll[rn];
          isNaN(en) || (vn ? Q += en + vn : Q += en + " ");
        }
      }
      F3[T.type](M.target, T.property, Q, M.transforms), T.currentValue = Q, _++;
    }
  }
  function g($) {
    o[$] && !o.passThrough && o[$](o);
  }
  function v() {
    o.remaining && o.remaining !== !0 && o.remaining--;
  }
  function w($) {
    var _ = o.duration, b = o.delay, k = _ - o.endDelay, T = d($);
    o.progress = ut(T / _ * 100, 0, 100), o.reversePlayback = T < o.currentTime, u && f(T), !o.began && o.currentTime > 0 && (o.began = !0, g("begin")), !o.loopBegan && o.currentTime > 0 && (o.loopBegan = !0, g("loopBegin")), T <= b && o.currentTime !== 0 && m(0), (T >= k && o.currentTime !== _ || !_) && m(_), T > b && T < k ? (o.changeBegan || (o.changeBegan = !0, o.changeCompleted = !1, g("changeBegin")), g("change"), m(T)) : o.changeBegan && (o.changeCompleted = !0, o.changeBegan = !1, g("changeComplete")), o.currentTime = ut(T, 0, _), o.began && g("update"), $ >= _ && (n = 0, v(), o.remaining ? (l = t, g("loopComplete"), o.loopBegan = !1, o.direction === "alternate" && a()) : (o.paused = !0, o.completed || (o.completed = !0, g("loopComplete"), g("complete"), !o.passThrough && "Promise" in window && (s(), r(o)))));
  }
  return o.reset = function() {
    var $ = o.direction;
    o.passThrough = !1, o.currentTime = 0, o.progress = 0, o.paused = !0, o.began = !1, o.loopBegan = !1, o.changeBegan = !1, o.completed = !1, o.changeCompleted = !1, o.reversePlayback = !1, o.reversed = $ === "reverse", o.remaining = o.loop, u = o.children, i = u.length;
    for (var _ = i; _--; )
      o.children[_].reset();
    (o.reversed && o.loop !== !0 || $ === "alternate" && o.loop === 1) && o.remaining++, m(o.reversed ? o.duration : 0);
  }, o._onDocumentVisibility = h, o.set = function($, _) {
    return H3($, _), o;
  }, o.tick = function($) {
    t = $, l || (l = t), w((t + (n - l)) * El.speed);
  }, o.seek = function($) {
    w(d($));
  }, o.pause = function() {
    o.paused = !0, h();
  }, o.play = function() {
    o.paused && (o.completed && o.reset(), o.paused = !1, Ie.push(o), h(), V3());
  }, o.reverse = function() {
    a(), o.completed = !o.reversed, h();
  }, o.restart = function() {
    o.reset(), o.play();
  }, o.remove = function($) {
    var _ = bf($);
    j3(_, o);
  }, o.reset(), o.autoplay && o.play(), o;
}
function B0(e, l) {
  for (var n = l.length; n--; )
    pf(e, l[n].animatable.target) && l.splice(n, 1);
}
function j3(e, l) {
  var n = l.animations, t = l.children;
  B0(e, n);
  for (var u = t.length; u--; ) {
    var i = t[u], s = i.animations;
    B0(e, s), !s.length && !i.children.length && t.splice(u, 1);
  }
  !n.length && !t.length && l.pause();
}
function x_(e) {
  for (var l = bf(e), n = Ie.length; n--; ) {
    var t = Ie[n];
    j3(l, t);
  }
}
function E_(e, l) {
  l === void 0 && (l = {});
  var n = l.direction || "normal", t = l.easing ? hf(l.easing) : null, u = l.grid, i = l.axis, s = l.from || 0, r = s === "first", o = s === "center", a = s === "last", d = ol.arr(e), h = parseFloat(d ? e[0] : e), p = d ? parseFloat(e[1]) : 0, f = At(d ? e[1] : e) || 0, m = l.start || 0 + (d ? h : 0), g = [], v = 0;
  return function(w, $, _) {
    if (r && (s = 0), o && (s = (_ - 1) / 2), a && (s = _ - 1), !g.length) {
      for (var b = 0; b < _; b++) {
        if (!u)
          g.push(Math.abs(s - b));
        else {
          var k = o ? (u[0] - 1) / 2 : s % u[0], T = o ? (u[1] - 1) / 2 : Math.floor(s / u[0]), M = b % u[0], H = Math.floor(b / u[0]), x = k - M, P = T - H, Z = Math.sqrt(x * x + P * P);
          i === "x" && (Z = -x), i === "y" && (Z = -P), g.push(Z);
        }
        v = Math.max.apply(Math, g);
      }
      t && (g = g.map(function(el) {
        return t(el / v) * v;
      })), n === "reverse" && (g = g.map(function(el) {
        return i ? el < 0 ? el * -1 : -el : Math.abs(v - el);
      }));
    }
    var F = d ? (p - h) / v : h;
    return m + F * (Math.round(g[$] * 100) / 100) + f;
  };
}
function I_(e) {
  e === void 0 && (e = {});
  var l = El(e);
  return l.duration = 0, l.add = function(n, t) {
    var u = Ie.indexOf(l), i = l.children;
    u > -1 && Ie.splice(u, 1);
    function s(p) {
      p.passThrough = !0;
    }
    for (var r = 0; r < i.length; r++)
      s(i[r]);
    var o = qo(n, jc(cf, e));
    o.targets = o.targets || e.targets;
    var a = l.duration;
    o.autoplay = !1, o.direction = l.direction, o.timelineOffset = ol.und(t) ? a : yf(t, a), s(l), l.seek(o.timelineOffset);
    var d = El(o);
    s(d), i.push(d);
    var h = z3(i, e);
    return l.delay = h.delay, l.endDelay = h.endDelay, l.duration = h.duration, l.seek(0), l.reset(), l.autoplay && l.play(), l;
  }, l;
}
El.version = "3.2.1";
El.speed = 1;
El.suspendWhenDocumentHidden = !0;
El.running = Ie;
El.remove = x_;
El.get = vf;
El.set = H3;
El.convertPx = mf;
El.path = b_;
El.setDashoffset = y_;
El.stagger = E_;
El.timeline = I_;
El.easing = hf;
El.penner = x3;
El.random = function(e, l) {
  return Math.floor(Math.random() * (l - e + 1)) + e;
};
class Wc extends gl {
  constructor(n, t) {
    super(n);
    S(this, "_el", J());
    S(this, "_elRipple", J());
    S(this, "_elSpinner", J());
    this.attrs = t, Pl(() => this.props.loading, () => this.setSpinnerDimensions());
  }
  get isClickable() {
    return !!this.attrs.onClick;
  }
  //get isMarkerClickable () { return !!this.attrs.onMarkerClick; }
  get isMarkerClickable() {
    return !!this.props.onMarkerClick;
  }
  get onMarkerClick() {
    return this.attrs.onMarkerClick;
  }
  get positionClass() {
    return this.props.markerPosition.split(" ").map((u) => `orion-icon__marker--${u}`);
  }
  handleClick(n) {
    this.props.loading || (this.props.ripple && this._elRipple.value && El({
      targets: this._elRipple.value.lastElementChild,
      opacity: [1, 0],
      scale: [1, 3],
      duration: 600,
      easing: "easeOutSine"
    }), this.isClickable && n.stopPropagation());
  }
  handleMarkerClick(n) {
    var t, u;
    this.isMarkerClickable && (n.stopPropagation(), (u = (t = this.props).onMarkerClick) == null || u.call(t, n));
  }
  setSpinnerDimensions() {
    if (this._el.value) {
      const {
        fontSize: n,
        color: t
      } = getComputedStyle(this._el.value);
      rl(() => {
        this._elSpinner.value && (this._elSpinner.value.style.width = n, this._elSpinner.value.style.height = n, this._elSpinner.value.style.stroke = t);
      });
    }
  }
}
S(Wc, "props", {
  ..._l.icon(),
  // @doc props/loading if set, blocks the click on the icon
  // @doc/fr props/loading si défini, bloque le click sur l'icône
  loading: Boolean,
  // @doc props/marker adds a visual marker, can be used as a notification marker
  // @doc/fr props/marker ajoute un marqueur visuel, qui peut être utilisé comme un marqueur de notification
  marker: {
    type: [Boolean, Number],
    default: void 0
  },
  // @doc props/markerColor the color of the marker
  // @doc/fr props/markerColor couleur du marqueur
  markerColor: {
    type: String,
    default: "danger",
    validator: (n) => ["default", "brand", "info", "success", "warning", "danger", "pink"].includes(n)
  },
  // @doc props/markerPosition the position of the marker
  // @doc/fr props/markerPosition position du marqueur
  markerPosition: {
    type: String,
    default: "top right"
  },
  // @doc props/ripple emits a wave on the click and adds an hover color
  // @doc/fr props/ripple émet une onde au moment du click et ajoute un style au moment du survol
  ripple: {
    type: String,
    default: void 0,
    validator: (n) => ["default", "brand", "info", "success", "warning", "danger", "pink"].includes(n)
  },
  // @doc props/button adds a background color
  // @doc/fr props/button ajouter une couleur en arrière plan
  button: {
    type: String,
    default: void 0,
    validator: (n) => ["default", "brand", "info", "success", "warning", "danger", "pink"].includes(n)
  },
  onMarkerClick: {
    type: Function,
    default: void 0
  }
});
const R_ = /* @__PURE__ */ Ps('<g><path d="M 16.5,22.038c-5.544,2.485-12.052,0.005-14.537-5.539S1.959,4.447,7.503,1.962C8.917,1.328,10.45,1,12,1 " fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path><path d="M 18.684,3.262c0.246,0.187,0.483,0.386,0.712,0.593c0.229,0.207,0.449,0.426,0.659,0.652 " fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path><path d="M 21.75,6.905 c0.143,0.274,0.275,0.554,0.394,0.839c0.119,0.285,0.227,0.575,0.322,0.869 " fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path><path d="M 22.989,11.5c0.014,0.309,0.014,0.618,0,0.927 c-0.013,0.308-0.038,0.617-0.076,0.923 " fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path><path d="M 22.169,16.193c-0.118,0.286-0.248,0.566-0.39,0.841c-0.142,0.275-0.295,0.543-0.458,0.806 " fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path><path d="M 15.286,1.5c0.321,0.1,0.635,0.214,0.943,0.343 " fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path><path d="M 19.725,19.829c-0.237,0.234-0.485,0.458-0.743,0.669 " fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path><path class="orion-icon__loading-inner" d="M 12,4c4.418,0,8,3.582,8,8 s-3.582,8-8,8s-8-3.582-8-8" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></g>', 1), D_ = [R_], N_ = /* @__PURE__ */ A("span", {
  class: "ripple__wave"
}, null, -1), L_ = [N_], P_ = {
  key: 2,
  class: "orion-icon__button"
}, Ml = /* @__PURE__ */ K({
  __name: "OrionIcon",
  props: Wc.props,
  emits: ["marker-click"],
  setup(e, {
    expose: l
  }) {
    const n = Xy(), t = e, u = new Wc(t, n);
    return l(u.publicInstance), (i, s) => (y(), O("i", {
      ref: c(u)._el,
      class: z(["orion-icon icon", [c(u).props.loading ? null : `${c(u).props.icon ? `ci-${c(u).props.icon}` : ""} ${c(u).props.fontIcon ?? ""}`, c(u).props.ripple ? `orion-icon--ripple orion-icon--ripple-${c(u).props.ripple}` : "", c(u).props.button ? `orion-icon--button orion-icon--button-${c(u).props.button}` : "", {
        "orion-icon--clickable": c(u).isClickable
      }]]),
      onClick: s[1] || (s[1] = (r) => c(u).handleClick(r)),
      onTouchend: s[2] || (s[2] = (r) => c(u).handleClick(r))
    }, [c(u).props.loading ? (y(), O("svg", {
      key: 0,
      ref: c(u)._elSpinner,
      class: "orion-icon__loading",
      xmlns: "http://www.w3.org/2000/svg",
      version: "1.1",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "xmlns:svgjs": "http://svgjs.com/svgjs",
      viewBox: "0 0 24 24"
    }, D_, 512)) : I("", !0), c(u).props.ripple ? (y(), O("span", {
      key: 1,
      ref: c(u)._elRipple,
      class: "orion-icon__ripple"
    }, L_, 512)) : I("", !0), c(u).props.button ? (y(), O("span", P_)) : I("", !0), c(u).props.marker ? (y(), O("span", {
      key: 3,
      class: z(["orion-icon__marker", [`orion-icon__marker--${c(u).props.markerColor}`, {
        "orion-icon__marker--number": typeof c(u).props.marker == "number"
      }, {
        "orion-icon__marker--clickable": !!c(u).onMarkerClick
      }, c(u).positionClass]]),
      onClick: s[0] || (s[0] = (r) => c(u).handleMarkerClick(r))
    }, B(typeof c(u).props.marker == "number" ? c(u).props.marker : null), 3)) : I("", !0)], 34));
  }
}), Ea = {
  install(e, l = "o") {
    e.component(`${tl(l)}Icon`, Ml);
  }
};
class B_ {
  constructor() {
    Dn.orion("LoaderService activated");
  }
  /**
   * @desc adds a global loader on the application
   * @param {object} loaderInstance instance of the orion loader
   * @return void
   */
  setGlobalLoader(l) {
    if (this.globalLoader)
      throw "Orion global loader already set";
    this.globalLoader = l;
  }
  guard() {
    if (!this.globalLoader)
      throw "Orion global loader not set";
  }
  /**
   * @desc if the global loader is set, shows the loader
   * @return void
   */
  show(l) {
    var n;
    this.guard(), (n = this.globalLoader) == null || n.show(l);
  }
  /**
   * @desc if the global loader is set, hides the loader
   * @return void
   */
  hide() {
    var l;
    this.guard(), (l = this.globalLoader) == null || l.hide();
  }
}
const F_ = new B_();
function vr() {
  return F_;
}
class Gc extends gl {
  constructor(n) {
    super(n);
    S(this, "state", fl({
      text: void 0,
      forceVisible: !1
    }));
    xo(() => {
      this.state.text = this.props.message;
    }), this.props.global && vr().setGlobalLoader(this.publicInstance);
  }
  get text() {
    return this.state.text;
  }
  get forceVisible() {
    return this.state.forceVisible;
  }
  get publicInstance() {
    return {
      ...super.publicInstance,
      show: this.show.bind(this),
      hide: this.hide.bind(this)
    };
  }
  show(n) {
    this.state.forceVisible = !0, this.state.text = n ?? this.props.message ?? void 0;
  }
  hide() {
    this.state.forceVisible = !1;
  }
}
S(Gc, "props", {
  ..._l.color("brand"),
  ..._l.size(),
  // @doc props/global displays a fullpage loader
  // @doc/fr props/global affiche un loader sur toute la page
  global: Boolean,
  // @doc props/visible if set, shows the loader
  // @doc/fr props/visible si défini, affiche le loader
  visible: Boolean,
  // @doc props/message message under the loader
  // @doc/fr props/message message qui apparaît sous l'icône de chargement
  message: {
    type: String,
    default: void 0
  }
});
const H_ = {
  class: "orion-loader__spinner"
}, z_ = {
  key: 0,
  class: "orion-loader__text"
}, te = /* @__PURE__ */ K({
  __name: "OrionLoader",
  props: Gc.props,
  setup(e, {
    expose: l
  }) {
    const n = e, t = new Gc(n);
    return l(t.publicInstance), (u, i) => (y(), L(Gg, {
      name: "fade"
    }, {
      default: U(() => [vl(A("div", {
        class: z(["orion-loader", [`orion-loader--${c(t).props.size}`, `orion-loader--${c(t).props.color}`, {
          "orion-loader--main": c(t).props.global
        }]])
      }, [A("div", H_, [R(c(Ml), {
        loading: ""
      })]), c(t).text ? (y(), O("div", z_, B(c(t).text), 1)) : I("", !0)], 2), [[cn, c(t).props.visible || c(t).forceVisible]])]),
      _: 1
    }));
  }
}), Ia = {
  install(e, l = "o") {
    e.component(`${tl(l)}Loader`, te);
  }
};
class Kc extends gl {
  constructor(l) {
    super(l);
  }
}
S(Kc, "props", {
  ..._l.color(),
  // @doc props/center Defines if the content must be centered in the component
  // @doc/fr props/center Défini si le contenu doit être centré dans le composant
  center: Boolean,
  // @doc props/close Defines if the alert can be closed
  // @doc/fr props/close Si défini, une croix permet de fermer l'alert
  close: Boolean,
  // @doc props/title Title of the alert
  // @doc/fr props/title Titre de l'alert
  title: {
    type: String,
    default: void 0
  }
});
const V_ = {
  key: 0,
  class: "orion-alert__title"
}, j_ = {
  class: "orion-alert__contrast"
}, U_ = /* @__PURE__ */ K({
  __name: "OrionAlert",
  props: Kc.props,
  emits: ["close"],
  setup(e, {
    expose: l
  }) {
    const n = e, t = new Kc(n);
    return l(t.publicInstance), (u, i) => (y(), O("div", {
      ref: c(t)._el,
      class: z(["orion-alert", [`orion-alert--${c(t).props.color}`, {
        "orion-alert--center": c(t).props.center
      }]])
    }, [c(t).props.title ? (y(), O("h5", V_, B(c(t).props.title), 1)) : I("", !0), c(t).props.close ? (y(), O("span", {
      key: 1,
      class: "orion-alert__close",
      onClick: i[0] || (i[0] = (s) => u.$emit("close")),
      onTouchend: i[1] || (i[1] = kl((s) => u.$emit("close"), ["prevent", "stop"]))
    }, null, 32)) : I("", !0), A("div", j_, [V(u.$slots, "default")])], 2));
  }
}), Ra = {
  install(e, l = "o") {
    e.component(`${tl(l)}Alert`, U_);
  }
};
function wf(e, l) {
  if (l.kind === "field")
    return function(n) {
      return fl({
        ...n
      });
    };
}
var F0;
function W_() {
  function e(a, d) {
    return function(h) {
      (function(p, f) {
        if (p.v)
          throw new Error("attempted to call addInitializer after decoration was finished");
      })(d), t(h, "An initializer"), a.push(h);
    };
  }
  function l(a, d) {
    if (!a(d))
      throw new TypeError("Attempted to access private element on non-instance");
  }
  function n(a, d, h, p, f, m, g, v, w) {
    var $;
    switch (f) {
      case 1:
        $ = "accessor";
        break;
      case 2:
        $ = "method";
        break;
      case 3:
        $ = "getter";
        break;
      case 4:
        $ = "setter";
        break;
      default:
        $ = "field";
    }
    var _, b, k = { kind: $, name: g ? "#" + d : G_(d), static: m, private: g }, T = { v: !1 };
    if (f !== 0 && (k.addInitializer = e(p, T)), g || f !== 0 && f !== 2)
      if (f === 2)
        _ = function(x) {
          return l(w, x), h.value;
        };
      else {
        var M = f === 0 || f === 1;
        (M || f === 3) && (_ = g ? function(x) {
          return l(w, x), h.get.call(x);
        } : function(x) {
          return h.get.call(x);
        }), (M || f === 4) && (b = g ? function(x, P) {
          l(w, x), h.set.call(x, P);
        } : function(x, P) {
          h.set.call(x, P);
        });
      }
    else
      _ = function(x) {
        return x[d];
      }, f === 0 && (b = function(x, P) {
        x[d] = P;
      });
    var H = g ? w.bind() : function(x) {
      return d in x;
    };
    k.access = _ && b ? { get: _, set: b, has: H } : _ ? { get: _, has: H } : { set: b, has: H };
    try {
      return a(v, k);
    } finally {
      T.v = !0;
    }
  }
  function t(a, d) {
    if (typeof a != "function")
      throw new TypeError(d + " must be a function");
  }
  function u(a, d) {
    var h = typeof d;
    if (a === 1) {
      if (h !== "object" || d === null)
        throw new TypeError("accessor decorators must return an object with get, set, or init properties or void 0");
      d.get !== void 0 && t(d.get, "accessor.get"), d.set !== void 0 && t(d.set, "accessor.set"), d.init !== void 0 && t(d.init, "accessor.init");
    } else if (h !== "function")
      throw new TypeError((a === 0 ? "field" : a === 10 ? "class" : "method") + " decorators must return a function or void 0");
  }
  function i(a) {
    return function(d) {
      a(this, d);
    };
  }
  function s(a, d, h, p, f, m, g, v, w) {
    var $, _, b, k, T, M, H, x, P = h[0];
    if (g ? (f === 0 || f === 1 ? ($ = { get: (T = h[3], function() {
      return T(this);
    }), set: i(h[4]) }, b = "get") : f === 3 ? ($ = { get: h[3] }, b = "get") : f === 4 ? ($ = { set: h[3] }, b = "set") : $ = { value: h[3] }, f !== 0 && (f === 1 && H0($.set, "#" + p, "set"), H0($[b || "value"], "#" + p, b))) : f !== 0 && ($ = Object.getOwnPropertyDescriptor(d, p)), f === 1 ? k = { get: $.get, set: $.set } : f === 2 ? k = $.value : f === 3 ? k = $.get : f === 4 && (k = $.set), typeof P == "function")
      (M = n(P, p, $, v, f, m, g, k, w)) !== void 0 && (u(f, M), f === 0 ? _ = M : f === 1 ? (_ = M.init, H = M.get || k.get, x = M.set || k.set, k = { get: H, set: x }) : k = M);
    else
      for (var Z = P.length - 1; Z >= 0; Z--) {
        var F;
        (M = n(P[Z], p, $, v, f, m, g, k, w)) !== void 0 && (u(f, M), f === 0 ? F = M : f === 1 ? (F = M.init, H = M.get || k.get, x = M.set || k.set, k = { get: H, set: x }) : k = M, F !== void 0 && (_ === void 0 ? _ = F : typeof _ == "function" ? _ = [_, F] : _.push(F)));
      }
    if (f === 0 || f === 1) {
      if (_ === void 0)
        _ = function(ll, Y) {
          return Y;
        };
      else if (typeof _ != "function") {
        var el = _;
        _ = function(ll, Y) {
          for (var Q = Y, dl = 0; dl < el.length; dl++)
            Q = el[dl].call(ll, Q);
          return Q;
        };
      } else {
        var al = _;
        _ = function(ll, Y) {
          return al.call(ll, Y);
        };
      }
      a.push(_);
    }
    f !== 0 && (f === 1 ? ($.get = k.get, $.set = k.set) : f === 2 ? $.value = k : f === 3 ? $.get = k : f === 4 && ($.set = k), g ? f === 1 ? (a.push(function(ll, Y) {
      return k.get.call(ll, Y);
    }), a.push(function(ll, Y) {
      return k.set.call(ll, Y);
    })) : f === 2 ? a.push(k) : a.push(function(ll, Y) {
      return k.call(ll, Y);
    }) : Object.defineProperty(d, p, $));
  }
  function r(a, d, h) {
    for (var p, f, m, g = [], v = /* @__PURE__ */ new Map(), w = /* @__PURE__ */ new Map(), $ = 0; $ < d.length; $++) {
      var _ = d[$];
      if (Array.isArray(_)) {
        var b, k, T = _[1], M = _[2], H = _.length > 3, x = T >= 5, P = h;
        if (x ? (b = a, (T -= 5) != 0 && (k = f = f || []), H && !m && (m = function(el) {
          return Y_(el) === a;
        }), P = m) : (b = a.prototype, T !== 0 && (k = p = p || [])), T !== 0 && !H) {
          var Z = x ? w : v, F = Z.get(M) || 0;
          if (F === !0 || F === 3 && T !== 4 || F === 4 && T !== 3)
            throw new Error("Attempted to decorate a public method/accessor that has the same name as a previously decorated public method/accessor. This is not currently supported by the decorators plugin. Property name was: " + M);
          !F && T > 2 ? Z.set(M, T) : Z.set(M, !0);
        }
        s(g, b, _, M, T, x, H, k, P);
      }
    }
    return o(g, p), o(g, f), g;
  }
  function o(a, d) {
    d && a.push(function(h) {
      for (var p = 0; p < d.length; p++)
        d[p].call(h);
      return h;
    });
  }
  return function(a, d, h, p) {
    return { e: r(a, d, p), get c() {
      return function(f, m) {
        if (m.length > 0) {
          for (var g = [], v = f, w = f.name, $ = m.length - 1; $ >= 0; $--) {
            var _ = { v: !1 };
            try {
              var b = m[$](v, { kind: "class", name: w, addInitializer: e(g, _) });
            } finally {
              _.v = !0;
            }
            b !== void 0 && (u(10, b), v = b);
          }
          return [v, function() {
            for (var k = 0; k < g.length; k++)
              g[k].call(v);
          }];
        }
      }(a, h);
    } };
  };
}
function U3(e, l, n, t) {
  return (U3 = W_())(e, l, n, t);
}
function G_(e) {
  var l = K_(e, "string");
  return typeof l == "symbol" ? l : String(l);
}
function K_(e, l) {
  if (typeof e != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var t = n.call(e, l || "default");
    if (typeof t != "object")
      return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (l === "string" ? String : Number)(e);
}
function H0(e, l, n) {
  typeof l == "symbol" && (l = (l = l.description) ? "[" + l + "]" : "");
  try {
    Object.defineProperty(e, "name", { configurable: !0, value: n ? n + " " + l : l });
  } catch {
  }
  return e;
}
function Y_(e) {
  if (Object(e) !== e)
    throw TypeError("right-hand side of 'in' should be an object, got " + (e !== null ? typeof e : "null"));
  return e;
}
const Mo = class Mo extends gl {
  constructor(n) {
    super(n);
    S(this, "_el", J());
    S(this, "_loader", J());
    S(this, "bus", Ri());
    S(this, "state", F0(this, {
      isClosing: !1,
      isOpening: !1,
      isMounted: !1,
      visible: !1
    }));
    S(this, "baseOptions", {
      uid: this.getUid(),
      Nested: null,
      NestedProps: {},
      customClass: "",
      programmatic: !1,
      openauto: !1,
      message: null,
      size: "md",
      hideClose: !1,
      hideOnOverlayClick: !0,
      hideOnEsc: !0,
      overlay: !0,
      zIndex: 0
    });
    S(this, "options", fl({
      ...this.baseOptions
    }));
    Object.assign(this.options, n.options), an().register(this.options.uid, this.publicInstance), Pl(() => this.props.display, (t) => {
      t ? this.open() : this.close();
    });
  }
  get pendingQueue() {
    return an().queue[this.name];
  }
  get uid() {
    return this.options.uid;
  }
  get visible() {
    return this.state.visible;
  }
  get isMounted() {
    return this.state.isMounted;
  }
  get isLastOpenedPopable() {
    return an().queueIds.slice(-1)[0] === this.uid;
  }
  get zIndexBumper() {
    return an().queueIds.findIndex((n) => n === this.uid);
  }
  get domStyle() {
    return {
      zIndex: 101 + this.zIndexBumper + this.options.zIndex
    };
  }
  get publicInstance() {
    return {
      ...super.publicInstance,
      _loader: () => this._loader.value,
      uid: this.uid,
      bus: this.bus,
      state: this.state,
      options: this.options,
      open: this.open.bind(this),
      close: this.close.bind(this),
      trigger: this.trigger.bind(this),
      animateAsync: this.animateAsync.bind(this),
      removeProgrammatic: this.removeProgrammatic.bind(this),
      isLastOpenedPopable: () => this.isLastOpenedPopable
    };
  }
  onMounted() {
    this.name !== "OrionNotif" && this.bus.on("enter-start", () => {
      var n;
      (n = this._el.value) == null || n.setAttribute("tabindex", "-1"), rl(() => {
        var t;
        (t = this._el.value) == null || t.focus();
      });
    }), (this.options.openauto || this.props.display) && setTimeout(() => {
      rl(() => this.open());
    }, 50);
    for (const n in this.options.events)
      this.bus.on(n, (t) => {
        this.options.events && this.options.events[n] && this.options.events[n](this.publicInstance, t);
      });
    this.state.isMounted = !0, this.Bus.on(`flush.${name}`, () => {
      this.options.programmatic && this.state.visible && this.close({
        flush: !0
      });
    }), this.options.hideOnEsc && this.setGlobalEventListener();
  }
  onUnmounted() {
    this.close(), nn(this.uid), this.options.programmatic && (xn == null || xn.on.visitComponentTree((n) => {
      var t;
      if (n.treeNode.uid === ((t = Fl.appInstance) == null ? void 0 : t.uid)) {
        const u = n.treeNode.children.findIndex((i) => i.orionUid === this.uid);
        u > -1 && n.treeNode.children.splice(u, 1);
      }
    }));
  }
  setGlobalEventListener() {
    nn("keydown", (n) => {
      n.key === "Escape" && this.visible && this.isLastOpenedPopable && this.close();
    }, {
      uid: this.uid
    });
  }
  async open(n = !0) {
    this.state.isOpening || (this.state.isOpening = !0, this.pendingQueue.length && this.name !== "OrionNotif" && this.pendingQueue[0].uid !== this.uid && await this.pendingQueue[0].close({
      keepInQueue: n,
      handleQueue: !1
    }), this.queue(), await this.handleQueue(), this.state.isOpening = !1);
  }
  async close(n) {
    if (this.state.isClosing || !this.state.visible)
      return;
    n = {
      keepInQueue: !1,
      handleQueue: !0,
      flush: !1,
      ...n
    }, this.trigger("close"), this.state.isClosing = !0;
    const {
      flush: t
    } = n;
    await this.animateAsync(!1), (!n.keepInQueue || t) && this.unqueue(), typeof t == "number" && isFinite(t) ? this.pendingQueue.splice(0, t).forEach((i) => i.removeProgrammatic()) : t && this.pendingQueue.splice(0, this.pendingQueue.length).forEach((i) => i.removeProgrammatic()), n.handleQueue && await this.handleQueue(), this.state.isClosing = !1, rl(() => {
      this.bus.emit("queueHandled");
    });
  }
  queue() {
    this.pendingQueue.findIndex((t) => t.uid === this.uid) > -1 && this.unqueue(), this.pendingQueue.unshift(this.publicInstance), this.name !== "OrionNotif" && an().queueIds.push(this.uid);
  }
  unqueue() {
    const n = this.pendingQueue.findIndex((t) => t.uid === this.uid);
    this.pendingQueue.splice(n, 1), this.removeFromQueueIds(this.uid), this.options.programmatic && setTimeout(() => {
      this.removeProgrammatic();
    }, 400);
  }
  async handleQueue() {
    if (this.pendingQueue.length) {
      if (this.options.overlay ? Xu().show() : Xu().hide(), this.name === "OrionNotif") {
        let t = 0;
        rl(() => {
          this.pendingQueue.forEach((u) => {
            rl(() => {
              var s;
              if (!this.document)
                return;
              const i = this.document.getElementById(`OrionNotif-${u.uid}`);
              t += 30, El({
                targets: i,
                bottom: t,
                duration: 300,
                easing: "easeOutCubic"
              }), t += ((s = this.document.getElementById(`OrionNotif-${u.uid}`)) == null ? void 0 : s.offsetHeight) ?? 0;
            });
          });
        });
      }
      const n = this.pendingQueue[0];
      n.options.overlay ? Xu().show() : Xu().hide(), await n.animateAsync(!0);
    }
    !an().asideQueue.length && !an().modalQueue.length && Xu().hide();
  }
  removeProgrammatic() {
    if (!this.document)
      return;
    const n = this.document.getElementById(`${this.name}-wrapper-${this.options.uid}`);
    n && fi(null, n), n == null || n.remove(), an().unregister(this.uid), this.removeFromQueueIds(this.uid);
  }
  removeFromQueueIds(n) {
    const t = an().queueIds.findIndex((u) => u === n);
    t > -1 && an().queueIds.splice(t, 1);
  }
  trigger(n, t) {
    this.bus.emit(n, t);
  }
};
[F0] = U3(Mo, [[wf, 0, "state"]], []).e, S(Mo, "props", {
  // @doc props/display if set, displays the component
  display: Boolean,
  // @doc props/options options of the component
  options: {
    type: Object,
    default: () => {
    }
  }
});
let uu = Mo;
class Yc extends uu {
  constructor(n, t) {
    super(n);
    S(this, "name", "OrionAside");
    S(this, "_actions", J());
    this.emit = t;
  }
  get slotPoster() {
    return `#OrionAside-${this.uid}__poster`;
  }
  get slotFooter() {
    return `#OrionAside-${this.uid}__footer`;
  }
  get slotActions() {
    return `#OrionAside-${this.uid}__actions`;
  }
  get slotHeader() {
    return `#OrionAside-${this.uid}__header`;
  }
  get publicInstance() {
    return {
      ...super.publicInstance,
      slotPoster: this.slotPoster,
      slotFooter: this.slotFooter,
      slotActions: this.slotActions,
      slotHeader: this.slotHeader
    };
  }
  async animateAsync(n) {
    return new Promise(async (t) => {
      var u, i, s, r;
      n ? (this.state.visible = !0, await ((i = (u = Fl.popableAnimationHooks).asideEnterBefore) == null ? void 0 : i.call(u, this.publicInstance)), El({
        targets: this._el.value,
        opacity: [0, 1],
        translateX: ["100%", 0],
        scale: [1.3, 1],
        duration: 400,
        easing: "easeOutQuad",
        begin: async () => {
          var o, a;
          await ((a = (o = Fl.popableAnimationHooks).asideEnterStart) == null ? void 0 : a.call(o, this.publicInstance)), this.emit("enter-start"), this.trigger("enter-start"), this.animateActions();
        },
        complete: async () => {
          var o, a;
          await ((a = (o = Fl.popableAnimationHooks).asideEnterEnd) == null ? void 0 : a.call(o, this.publicInstance)), t(), this.emit("enter-end"), this.trigger("enter-end");
        }
      })) : (await ((r = (s = Fl.popableAnimationHooks).asideLeaveBefore) == null ? void 0 : r.call(s, this.publicInstance)), El({
        targets: this._el.value,
        opacity: 0,
        translateX: ["30%"],
        duration: 200,
        easing: "linear",
        begin: async () => {
          var o, a;
          await ((a = (o = Fl.popableAnimationHooks).asideLeaveStart) == null ? void 0 : a.call(o, this.publicInstance)), this.emit("leave-start"), this.trigger("leave-start");
        },
        complete: async () => {
          var o, a;
          this.state.visible = !1, await ((a = (o = Fl.popableAnimationHooks).asideLeaveEnd) == null ? void 0 : a.call(o, this.publicInstance)), t(), this.emit("leave-end"), this.trigger("leave-end");
        }
      }));
    });
  }
  animateActions() {
    var t;
    const n = (t = this._actions.value) == null ? void 0 : t.children;
    n && El({
      targets: n,
      opacity: [0, 1],
      right: ["-3rem", 0],
      duration: 300,
      easing: "easeOutCubic",
      delay: El.stagger(300 / n.length, {
        start: 100
      })
    });
  }
}
S(Yc, "props", {
  ...uu.props,
  // @doc props/options options of the aside
  // @doc/fr props/options options de l'aside
  options: {
    type: Object,
    default: () => {
    }
  }
});
const q_ = ["id"], J_ = {
  class: "orion-aside__poster"
}, Z_ = {
  key: 0
}, X_ = ["id"], Q_ = {
  class: "orion-aside__header"
}, lS = {
  key: 0,
  class: "orion-aside__logo"
}, nS = ["id"], eS = ["id"], tS = ["id"], uS = {
  class: "orion-aside__body"
}, _f = /* @__PURE__ */ K({
  __name: "OrionAside",
  props: Yc.props,
  emits: ["enter-start", "enter-end", "leave-start", "leave-end"],
  setup(e, {
    expose: l,
    emit: n
  }) {
    const t = n, u = e, i = new Yc(u, t);
    return De("_aside", i.publicInstance), l(i.publicInstance), (s, r) => (y(), L(Wp, {
      to: "#orion-popable-wrapper",
      disabled: c(i).options.programmatic
    }, [A("aside", {
      id: `OrionAside-${c(i).uid}`,
      ref: c(i)._el,
      style: Wl(c(i).domStyle),
      class: z(["orion-aside", [c(i).options.customClass, `orion-aside--${c(i).options.size}`, {
        "orion-aside--visible": c(i).visible
      }]])
    }, [A("div", J_, [s.$slots.poster ? (y(), O("div", Z_, [V(s.$slots, "poster")])) : (y(), O("div", {
      key: 1,
      id: `OrionAside-${c(i).uid}__poster`
    }, null, 8, X_))]), A("div", Q_, [s.$slots.header ? (y(), O("div", lS, [V(s.$slots, "header")])) : (y(), O("div", {
      key: 1,
      id: `OrionAside-${c(i).uid}__header`
    }, null, 8, nS)), A("div", {
      id: `OrionAside-${c(i).uid}__actions`,
      ref: c(i)._actions,
      class: "orion-aside__actions"
    }, [V(s.$slots, "actions", {
      close: c(i).close.bind(c(i))
    })], 8, eS)]), A("div", {
      id: `OrionAside-${c(i).uid}__footer`,
      class: "orion-aside__footer"
    }, [V(s.$slots, "footer", {
      close: c(i).close.bind(c(i))
    })], 8, tS), A("div", uS, [c(i).options.Nested && c(i).isMounted ? (y(), L(Vn(c(i).options.Nested), Rl(ml({
      key: 0
    }, c(i).options.NestedProps)), null, 16)) : I("", !0), V(s.$slots, "default", {
      close: c(i).close.bind(c(i))
    })]), c(i).options.hideClose ? I("", !0) : (y(), O("span", {
      key: 0,
      class: "orion-aside__close",
      onClick: r[0] || (r[0] = (o) => c(i).close({
        keepInQueue: !1
      })),
      onTouchend: r[1] || (r[1] = kl((o) => c(i).close({
        keepInQueue: !1
      }), ["prevent", "stop"]))
    }, null, 32)), R(c(te), {
      ref: c(i)._loader
    }, null, 512)], 14, q_)], 8, ["disabled"]));
  }
}), Da = {
  install(e, l = "o") {
    e.component(`${tl(l)}Aside`, _f);
  }
};
class qc extends gl {
  constructor(n) {
    super(n);
    S(this, "state", fl({
      error: !1
    }));
    Pl(() => this.props.nbAvatarUpdates, (t, u) => {
      this.state.error = t === u;
    });
  }
  set error(n) {
    this.state.error = n;
  }
  get tooltip() {
    return this.props.tooltip ?? this.lang.ORION_AVATAR__TOOLTIP;
  }
  get additionalClass() {
    const n = [];
    return $3(this.props.size) && n.push(`orion-avatar--${this.props.size.toLowerCase()}`), this.props.square && n.push("orion-avatar--square"), this.props.contain && n.push("orion-avatar--contain"), n;
  }
  get internalAvatarId() {
    var n;
    return typeof this.props.avatar == "number" && isFinite(this.props.avatar) ? this.props.avatar : En(this.props.avatar) && isFinite((n = this.props.avatar) == null ? void 0 : n.id) ? this.props.avatar.id : 0;
  }
  get formatedName() {
    return this.props.name.trim().charAt(0);
  }
  get showInitial() {
    return this.state.error || typeof this.props.avatar != "string" && (!isFinite(this.internalAvatarId) || this.internalAvatarId === 0);
  }
  get updateTrick() {
    return this.props.nbAvatarUpdates ? `?update=${this.props.nbAvatarUpdates}` : "";
  }
  get avatarSrc() {
    return typeof this.props.avatar == "string" ? this.props.avatar : `${this.props.rootUrl}${this.internalAvatarId}${this.updateTrick}`;
  }
  get avatarStyle() {
    return typeof this.props.size == "number" ? {
      width: `calc(${this.props.size}rem / 16)`,
      height: `calc(${this.props.size}rem / 16)`,
      fontSize: `calc(${this.props.size / 2}rem / 16)`
    } : {};
  }
}
S(qc, "props", {
  ..._l.color("brand"),
  // @doc props/square defines if the avatar is square-shaped (circle otherwise)
  // @doc/fr props/square Définit la forme de l'avatar (ronde par défaut)
  square: Boolean,
  // @doc props/contain adapts the size of the image to fit into the container
  // @doc/fr props/contain adapte la taille de l'image pour s'adapter à son conteneur
  contain: Boolean,
  // @doc props/size the size of the avatar
  // @doc/fr props/size taille de l'avatar
  size: {
    type: [Number, String],
    default: "md"
  },
  // @doc props/rootUrl the root url when the `avatar` prop is a number or JSON object
  // @doc/fr props/rootUrl url de l'avatar si la prop `avatar` est un nombre ou un objet JSON
  rootUrl: {
    type: String,
    default: "/avatar/"
  },
  // @doc props/name displays first letter of the name if there is no image
  // @doc/fr props/name affiche la première lettre de la prop `name` s'il n'y a pas d'image
  name: {
    type: String,
    default: ""
  },
  // @doc props/avatar the url of the image or an id (combined with root-url prop). More info in [Edges cases](#edge-cases) section.
  // @doc/fr props/avatar url de l'image ou id (combiné avec la prop `root-url`). Plus d'infos dans la section [Cas complexes](#cas-complexes).
  avatar: {
    type: [Object, Number, String],
    default: void 0
  },
  // @doc props/updateFunction function to call to update the avatar
  // @doc/fr props/updateFunction fonction à appeler pour modifier l'avatar
  updateFunction: {
    type: Function,
    default: void 0
  },
  // @doc props/nbAvatarUpdates number to increment on each update to refresh the image
  // @doc/fr props/nbAvatarUpdates nombre à incrémenter à chaque mise à jour de l'image pour la rafraîchir
  nbAvatarUpdates: {
    type: Number,
    default: 0
  },
  // @doc props/tooltip the tooltip text displayed to update the avatar
  // @doc/fr props/tooltip le texte qui sera affiché dans la tooltip au survol de l'icône de modification
  tooltip: {
    type: String,
    default: void 0
  }
});
const iS = {
  key: 0,
  class: "orion-avatar__initial"
}, sS = ["src"], rS = {
  key: 2,
  class: "orion-avatar__picto"
}, Jo = /* @__PURE__ */ K({
  __name: "OrionAvatar",
  props: qc.props,
  setup(e, {
    expose: l
  }) {
    const n = e, t = new qc(n);
    return l(t.publicInstance), (u, i) => {
      const s = Ei("tooltip");
      return y(), O("div", {
        ref: c(t)._el,
        class: z(["orion-avatar", [`orion-avatar--${c(t).props.color}`, ...c(t).additionalClass]]),
        style: Wl(c(t).avatarStyle)
      }, [c(t).showInitial ? (y(), O("span", iS, B(c(t).formatedName), 1)) : (y(), O("img", {
        key: 1,
        class: "orion-avatar__image",
        src: c(t).avatarSrc,
        onError: i[0] || (i[0] = (r) => c(t).error = !0)
      }, null, 40, sS)), u.updateFunction ? (y(), O("div", rS, [vl(R(c(Ml), {
        icon: "cloud_upload",
        ripple: "info",
        onClick: i[1] || (i[1] = (r) => {
          var o, a;
          return (a = (o = c(t).props).updateFunction) == null ? void 0 : a.call(o);
        })
      }, null, 512), [[s, c(t).tooltip]])])) : I("", !0)], 6);
    };
  }
}), Na = {
  install(e, l = "o") {
    e.component(`${tl(l)}Avatar`, Jo);
  }
};
class Jc extends gl {
  constructor(n) {
    super(n);
    S(this, "_el", J());
    S(this, "uid", this.getUid());
  }
  onMounted() {
    this.props.autofocus && setTimeout(() => {
      var n;
      return (n = this._el.value) == null ? void 0 : n.focus();
    }, 100);
  }
  visualClick(n) {
    var s, r;
    const t = n, u = (s = this.document) == null ? void 0 : s.createElement("div");
    if (!u)
      return;
    (r = this._el.value) == null || r.appendChild(u), u.classList.add("orion-button__ripple");
    const i = u.getBoundingClientRect().width / 2;
    u.style.left = `${t.layerX - i}px`, u.style.top = `${t.layerY - i}px`, u.onanimationend = () => {
      var o;
      (o = this._el.value) == null || o.removeChild(u), u.remove();
    };
  }
}
S(Jc, "props", {
  ..._l.size(),
  ..._l.color(),
  ..._l.prefixIcon(),
  ..._l.suffixIcon(),
  // @doc props/autofocus if set, focus the button
  // @doc/fr props/autofocus si défini, le focus sera placé sur le bouton
  autofocus: Boolean,
  // @doc props/disabled determines if the button is disabled
  // @doc/fr props/disabled désactive le bouton
  disabled: Boolean,
  // @doc props/loading adds a loading icon and disables the button
  // @doc/fr props/loading ajoute une icône de chargement et désactive le bouton
  loading: Boolean,
  // @doc props/outline adds an outline on the button
  // @doc/fr props/outline ajoute un contraste sur le bouton
  outline: Boolean,
  // @doc props/nude removes the background color
  // @doc/fr props/nude masque la couleur en arrière plan
  nude: Boolean,
  // @doc props/block defines the button's width to 100%
  // @doc/fr props/block définie la largeur du bouton à 100%
  block: Boolean
});
const oS = ["tabindex", "disabled", "autofocus"], aS = {
  key: 1,
  class: "orion-button__text"
}, bl = /* @__PURE__ */ K({
  __name: "OrionButton",
  props: Jc.props,
  emits: ["click"],
  setup(e, {
    expose: l
  }) {
    const n = e, t = new Jc(n);
    return l(t.publicInstance), (u, i) => (y(), O("button", {
      ref: c(t)._el,
      class: z(["orion-button", [`orion-button--${u.color}`, `orion-button--${u.size}`, {
        "orion-button--prefix-icon": u.prefixIcon
      }, {
        "orion-button--suffix-icon": u.suffixIcon
      }, {
        "orion-button--icon-only": !u.$slots.default
      }, {
        "orion-button--outline": u.outline
      }, {
        "orion-button--disabled": u.disabled || u.loading
      }, {
        "orion-button--loading": u.loading
      }, {
        "orion-button--nude": u.nude
      }, {
        "orion-button--block": u.block
      }]]),
      tabindex: u.disabled || u.loading ? void 0 : c(t).uid,
      disabled: u.disabled || u.loading,
      autofocus: u.autofocus,
      onClick: [i[2] || (i[2] = kl((s) => c(t).visualClick(s), ["left"])), i[3] || (i[3] = (s) => u.$emit("click"))]
    }, [u.prefixIcon || u.prefixFontIcon || u.loading ? (y(), L(c(Ml), {
      key: 0,
      class: "orion-button__icon orion-button__icon--prefix",
      icon: u.prefixIcon,
      "font-icon": u.prefixFontIcon,
      loading: u.loading,
      onClick: i[0] || (i[0] = kl((s) => {
        var r;
        return (r = c(t)._el.value) == null ? void 0 : r.click();
      }, ["prevent", "stop"]))
    }, null, 8, ["icon", "font-icon", "loading"])) : I("", !0), u.$slots.default ? (y(), O("span", aS, [V(u.$slots, "default")])) : I("", !0), u.suffixIcon || u.suffixFontIcon ? (y(), L(c(Ml), {
      key: 2,
      class: "orion-button__icon orion-button__icon--suffix",
      icon: u.suffixIcon,
      "font-icon": u.suffixFontIcon,
      onClick: i[1] || (i[1] = kl((s) => {
        var r;
        return (r = c(t)._el.value) == null ? void 0 : r.click();
      }, ["prevent", "stop"]))
    }, null, 8, ["icon", "font-icon"])) : I("", !0)], 10, oS));
  }
}), La = {
  install(e, l = "o") {
    e.component(`${tl(l)}Button`, bl);
  }
};
class Zc extends gl {
  constructor(l) {
    super(l);
  }
}
S(Zc, "props", {
  ..._l.size(),
  // @doc props/headerLine displays a line between the header and the body of the card
  // @doc/fr props/headerLine affiche une line de sépération entre les slots `header` et `default` de la carte
  headerLine: {
    type: Boolean,
    default: !1
  },
  // @doc props/actionsLine displays a line between the body and the actions of the card
  // @doc/fr props/actionsLine affiche une line de sépération entre les slots `default` et `actions` de la carte
  actionsLine: {
    type: Boolean,
    default: !1
  },
  // @doc props/selected adds a selected style on the card
  // @doc/fr props/selected ajoute le style `selected` sur la carte
  selected: {
    type: Boolean,
    default: !1
  },
  // @doc props/gradient adds a gradient in the backgroung of the card
  // @doc/fr props/gradient ajoute un dégradé sur l'arrière plan de la carte
  gradient: {
    type: String,
    default: void 0,
    validator: (l) => ["info", "success", "warning", "pink", "brand"].includes(l)
  },
  // @doc props/selectedColor changes the color of the selected style
  // @doc/fr props/selectedColor définit la couleur du style `selected`
  selectedColor: {
    type: String,
    default: "info",
    validator: (l) => ["brand", "info", "success", "warning", "danger"].includes(l)
  },
  // @doc props/title the title of the card
  // @doc/fr props/title titre de la carte
  title: {
    type: String,
    default: void 0
  },
  // @doc props/hoverElevation elevation level on mouse hover
  // @doc/fr props/hoverElevation niveau d'élévation au survol de la souris
  hoverElevation: {
    type: Number,
    default: 1
  }
});
const dS = {
  key: 0,
  class: "orion-card__poster"
}, cS = {
  key: 0,
  class: "orion-card__title"
}, hS = /* @__PURE__ */ Ps('<div class="orion-card__selected"><svg class="marker" viewBox="0 0 90 90"><circle cx="105" cy="105" r="45"></circle></svg><svg class="check" viewBox="0 0 12 12"><polyline points="1.5 6 4.5 9 10.5 1"></polyline></svg></div>', 1), W3 = /* @__PURE__ */ K({
  __name: "OrionCard",
  props: Zc.props,
  emits: ["header-click", "body-click"],
  setup(e, {
    expose: l
  }) {
    const n = e, t = new Zc(n);
    return l(t.publicInstance), (u, i) => (y(), O("div", {
      ref: c(t)._el,
      class: z(["orion-card", [`orion-card--${c(t).props.size}`, `orion-card--selected-${c(t).props.selectedColor}`, {
        "orion-card--clickable": !!u.$attrs.onClick
      }, {
        "orion-card--selected": c(t).props.selected
      }, {
        "orion-card--no-elevation": u.hoverElevation <= 0
      }, c(t).props.gradient ? `orion-card--gradient-${c(t).props.gradient}` : ""]]),
      style: Wl(`--hoverElevation: ${u.hoverElevation}`)
    }, [u.$slots.poster ? (y(), O("div", dS, [V(u.$slots, "poster")])) : I("", !0), u.$slots.header || c(t).props.title ? (y(), O("div", {
      key: 1,
      class: z(["orion-card__header", [{
        "orion-card__header--lined": c(t).props.headerLine
      }]]),
      onClick: i[0] || (i[0] = (s) => u.$emit("header-click"))
    }, [c(t).props.title ? (y(), O("h4", cS, B(c(t).props.title), 1)) : I("", !0), V(u.$slots, "header")], 2)) : I("", !0), A("div", {
      class: "orion-card__body",
      onClick: i[1] || (i[1] = (s) => u.$emit("body-click"))
    }, [V(u.$slots, "default")]), u.$slots.actions ? (y(), O("div", {
      key: 2,
      class: z(["orion-card__actions", [{
        "orion-card__actions--lined": c(t).props.actionsLine
      }]])
    }, [V(u.$slots, "actions")], 2)) : I("", !0), hS], 6));
  }
}), Pa = {
  install(e, l = "o") {
    e.component(`${tl(l)}Card`, W3);
  }
};
class Xc extends gl {
  constructor(n, t, u) {
    super(n);
    S(this, "state", fl({
      timerStart: (/* @__PURE__ */ new Date()).valueOf(),
      timerRemaining: 0,
      mouseIsOver: !1
    }));
    S(this, "uid", this.getUid());
    this.emits = t, this.slots = u;
  }
  get step() {
    return this.props.modelValue;
  }
  set step(n) {
    this.emits("update:modelValue", n), this.props.stepTimer && (this.state.timerRemaining = this.props.stepTimer, this.state.timerStart = (/* @__PURE__ */ new Date()).valueOf(), this.props.pauseOnHover && this.state.mouseIsOver || this.startTimer());
  }
  get rgbColor() {
    return `var(--rgb-${this.props.color})`;
  }
  get stepTimerForCss() {
    return this.props.stepTimer + "ms";
  }
  get shouldLoop() {
    return !!this.props.stepTimer || this.props.loop;
  }
  get stepIndex() {
    return this.steps.findIndex((n) => n.name === this.props.modelValue);
  }
  get stepsLength() {
    return this.steps.length;
  }
  get steps() {
    var i, s;
    const n = (s = (i = this.slots).default) == null ? void 0 : s.call(i);
    if (!n || !n.length)
      return [];
    const t = n[0];
    return (typeof t.type == "symbol" && t.type.description === "v-fgt" ? t.children : n).filter((r) => !(typeof r.type == "symbol" && r.type.description === "v-cmt")).map((r) => {
      var o;
      return {
        ...r.props,
        name: (o = r.props) == null ? void 0 : o.name,
        uid: ft()
      };
    }) ?? [];
  }
  get publicInstance() {
    return {
      ...super.publicInstance,
      step: () => this.step,
      stepsLength: () => this.stepsLength,
      stepIndex: () => this.stepIndex,
      shouldLoop: () => this.shouldLoop,
      goToStep: this.goToStep.bind(this),
      goToStepIndex: this.goToStepIndex.bind(this),
      goPreviousStep: this.goPreviousStep.bind(this),
      goNextStep: this.goNextStep.bind(this)
    };
  }
  onMounted() {
    this.props.stepTimer && this.startTimer();
  }
  startTimer() {
    this.props.stepTimer && (clearTimeout(this.timer), this.timer = setTimeout(() => this.goNextStep(), this.props.stepTimer), this.state.timerStart = (/* @__PURE__ */ new Date()).valueOf());
  }
  stopTimer() {
    this.props.stepTimer && (this.state.timerRemaining = (this.state.timerRemaining || this.props.stepTimer) - ((/* @__PURE__ */ new Date()).valueOf() - this.state.timerStart), clearTimeout(this.timer));
  }
  restartTimer() {
    this.props.stepTimer && (this.timer = setTimeout(() => this.goNextStep(), this.state.timerRemaining), this.state.timerStart = (/* @__PURE__ */ new Date()).valueOf());
  }
  handleMouseEnter() {
    var n;
    this.state.mouseIsOver || (this.state.mouseIsOver = !0, this.props.stepTimer && this.props.pauseOnHover && (this.stopTimer(), Array.from(((n = this.document) == null ? void 0 : n.querySelectorAll(`#orion-carousel-${this.uid} .orion-carousel__dot-loader`)) ?? []).forEach((t) => t.style.animationPlayState = "paused")));
  }
  handleMouseLeave() {
    var n;
    this.state.mouseIsOver && (this.state.mouseIsOver = !1, this.props.stepTimer && this.props.pauseOnHover && (Array.from(((n = this.document) == null ? void 0 : n.querySelectorAll(`#orion-carousel-${this.uid} .orion-carousel__dot-loader`)) ?? []).forEach((t) => t.style.animationPlayState = "running"), this.restartTimer()));
  }
  goToStep(n) {
    this.step = n.name;
  }
  goToStepIndex(n) {
    var t;
    this.step = (t = this.steps[n]) == null ? void 0 : t.name;
  }
  goPreviousStep() {
    var t;
    const n = this.steps[this.stepIndex - 1];
    n ? this.step = n.name : this.shouldLoop && (this.step = (t = this.steps[this.stepsLength - 1]) == null ? void 0 : t.name);
  }
  goNextStep() {
    var t;
    const n = this.steps[this.stepIndex + 1];
    n ? this.step = n.name : this.shouldLoop && (this.step = (t = this.steps[0]) == null ? void 0 : t.name);
  }
}
S(Xc, "props", {
  // @doc props/loop enable the "loop" mode
  // @doc/fr props/loop active le mode "en boucle"
  loop: Boolean,
  // @doc props/pauseOnHover pause timer when hovering the carousel
  // @doc/fr props/pauseOnHover met au pause le minuteur lors du survol du carrousel
  pauseOnHover: Boolean,
  // @doc props/hideNavigationButtons hide the navigation buttons around the dots
  // @doc/fr props/hideNavigationButtons masque les boutons de navigation autour des points
  hideNavigationButtons: Boolean,
  // @doc props/hideNavigationDots hide the navigation dots
  // @doc/fr props/hideNavigationDots masque les points de navigation
  hideNavigationDots: Boolean,
  // @doc props/modelValue refers to the active step's **name** prop
  // @doc/fr props/modelValue correspond à la prop **name** de l'élément actif
  modelValue: {
    type: [Number, String],
    default: void 0
  },
  // @doc props/stepTimer apply a timer to automatically switch to the next item
  // @doc/fr props/stepTimer applique un minuteur pour passer automatiquement à l'élément suivant
  stepTimer: {
    type: Number,
    default: void 0
  },
  // @doc props/color color of the dots at the carousel's bottom
  // @doc/fr props/color couleur des points au bas du carrousel
  color: {
    type: String,
    default: "brand"
  }
});
const pS = ["id"], fS = {
  key: 0,
  class: "orion-carousel__poster"
}, mS = {
  key: 1,
  class: "orion-carousel__steps-wrapper"
}, gS = {
  key: 2,
  class: "orion-carousel__navigation"
}, vS = {
  key: 0,
  class: "orion-carousel__dot-section"
}, yS = ["onClick"], $S = {
  key: 3,
  class: "orion-carousel__actions"
}, bS = /* @__PURE__ */ K({
  __name: "OrionCarousel",
  props: Xc.props,
  emits: ["update:modelValue"],
  setup(e, {
    expose: l,
    emit: n
  }) {
    const t = Bs(), u = n, i = e, s = new Xc(i, u, t);
    return De("_carousel", s.publicInstance), l(s.publicInstance), (r, o) => (y(), O("div", {
      id: `orion-carousel-${c(s).uid}`,
      class: z(["orion-carousel", {
        "orion-carousel--timer": !!r.stepTimer
      }]),
      onMouseenter: o[2] || (o[2] = (a) => c(s).handleMouseEnter()),
      onMouseleave: o[3] || (o[3] = (a) => c(s).handleMouseLeave())
    }, [r.$slots.poster ? (y(), O("div", fS, [V(r.$slots, "poster", Rl(jl({
      step: c(s).step,
      stepIndex: c(s).stepIndex
    })))])) : I("", !0), r.$slots.default ? (y(), O("div", mS, [A("div", {
      class: "orion-carousel__steps",
      style: Wl({
        transform: `translate3d(${c(s).stepIndex * -100}%, 0, 0)`
      })
    }, [V(r.$slots, "default", Rl(jl({
      step: c(s).step,
      stepIndex: c(s).stepIndex,
      goPreviousStep: () => c(s).goPreviousStep(),
      goNextStep: () => c(s).goNextStep()
    })))], 4)])) : I("", !0), !r.hideNavigationButtons || !r.hideNavigationDots ? (y(), O("div", gS, [V(r.$slots, "navigation", Rl(jl({
      step: c(s).step,
      stepIndex: c(s).stepIndex,
      goPreviousStep: () => c(s).goPreviousStep(),
      goNextStep: () => c(s).goNextStep()
    })), () => [R(bl, {
      class: "orion-carousel__navigation-previous",
      disabled: r.hideNavigationButtons || !c(s).shouldLoop && c(s).stepIndex === 0,
      outline: "",
      size: "sm",
      "prefix-icon": "chevron_left",
      onClick: o[0] || (o[0] = (a) => c(s).goPreviousStep())
    }, null, 8, ["disabled"]), R(bl, {
      class: "orion-carousel__navigation-next",
      disabled: r.hideNavigationButtons || !c(s).shouldLoop && c(s).stepIndex === c(s).stepsLength - 1,
      outline: "",
      size: "sm",
      "suffix-icon": "chevron_right",
      onClick: o[1] || (o[1] = (a) => c(s).goNextStep())
    }, null, 8, ["disabled"])]), !r.hideNavigationDots && c(s).stepIndex <= c(s).stepsLength ? (y(), O("div", vS, [(y(!0), O(hl, null, Sl(c(s).stepsLength, (a) => (y(), O("div", {
      key: a,
      class: z(["orion-carousel__dot", [{
        "orion-carousel__dot--active": a - 1 === c(s).stepIndex
      }, {
        "orion-carousel__dot--past": a - 1 < c(s).stepIndex
      }]]),
      style: Wl({
        "--color": c(s).rgbColor
      }),
      onClick: (d) => c(s).goToStepIndex(a - 1)
    }, [A("div", {
      class: "orion-carousel__dot-loader",
      style: Wl({
        "animation-duration": c(s).stepTimerForCss
      })
    }, null, 4)], 14, yS))), 128))])) : I("", !0)])) : I("", !0), r.$slots.actions ? (y(), O("div", $S, [V(r.$slots, "actions", Rl(jl({
      step: c(s).step,
      stepIndex: c(s).stepIndex,
      goPreviousStep: () => c(s).goPreviousStep(),
      goNextStep: () => c(s).goNextStep(),
      goToStep: (a) => c(s).goToStep(a),
      goToStepIndex: (a) => c(s).goToStepIndex(a)
    })))])) : I("", !0)], 42, pS));
  }
}), Ba = {
  install(e, l = "o") {
    e.component(`${tl(l)}Carousel`, bS);
  }
};
class Qc extends gl {
  constructor(n, t) {
    super(n);
    S(this, "state", fl({
      hasBeenActive: !1
    }));
    this._carousel = t, Pl(() => this.isActive, (u) => {
      u ? this.state.hasBeenActive = u : this.props.lazy && (this.state.hasBeenActive = u);
    });
  }
  get stepsLength() {
    var n;
    return (n = this._carousel) == null ? void 0 : n.stepsLength;
  }
  get isActive() {
    var n;
    return ((n = this._carousel) == null ? void 0 : n.step()) === this.props.name;
  }
  get shouldBeInDom() {
    return this.props.lazy || this.props.lazyOnce ? this.state.hasBeenActive : !0;
  }
  onMounted() {
    var n;
    this.state.hasBeenActive = ((n = this._carousel) == null ? void 0 : n.step()) === this.props.name;
  }
}
S(Qc, "props", {
  // @doc props/lazy the content of the item is mounted each time the item becomes active
  // @doc/fr props/lazy le contenu de l'élément est monté à chaque fois qu'il devient actif
  lazy: Boolean,
  // @doc props/lazyOnce the content of the item is only mounted once, the first time the item is active
  // @doc/fr props/lazyOnce le contenu de l'élément est uniquement monté une fois, la première fois qu'il est actif
  lazyOnce: Boolean,
  // @doc props/name step identifier
  // @doc/fr props/name identifiant de l'élément
  name: {
    type: [Number, String],
    required: !0
  }
});
const wS = {
  class: "orion-carousel-item"
}, _S = {
  class: "orion-carousel-item__content"
}, SS = /* @__PURE__ */ K({
  __name: "OrionCarouselItem",
  props: Qc.props,
  setup(e, {
    expose: l
  }) {
    const n = Tn("_carousel"), t = e, u = new Qc(t, n);
    return l(u.publicInstance), (i, s) => (y(), O("div", wS, [A("div", _S, [c(u).shouldBeInDom ? V(i.$slots, "default", Rl(ml({
      key: 0
    }, {
      isActive: c(u).isActive
    }))) : I("", !0)])]));
  }
}), Fa = {
  install(e, l = "o") {
    e.component(`${tl(l)}CarouselItem`, SS);
  }
};
class lh extends gl {
  constructor(n) {
    super(n);
    S(this, "_el", J());
    S(this, "_suffixPictos", J());
  }
  get baseClass() {
    return `orion-${this.props.inputType}`;
  }
  get additionalClass() {
    const n = [`${this.baseClass}--${this.props.size}`];
    return this.props.showError && n.push(`${this.baseClass}--error`), this.props.showWarning && n.push(`${this.baseClass}--warning`), this.props.showSuccess && n.push(`${this.baseClass}--success`), (this.props.prefixIcon || this.props.prefixFontIcon) && n.push(`${this.baseClass}--prefix-icon`), (this.props.suffixIcon || this.props.suffixFontIcon) && n.push(`${this.baseClass}--suffix-icon`), this.props.clearable && n.push(`${this.baseClass}--clearable`), this.props.isFocus && n.push(`${this.baseClass}--focused`), this.props.disabled && n.push(`${this.baseClass}--disabled`), this.props.required && n.push(`${this.baseClass}--required`), this.props.readonly && n.push(`${this.baseClass}--readonly`), n;
  }
  get labelClass() {
    const n = [`${this.baseClass}__label`];
    return this.props.labelIsFloating && n.push(`${this.baseClass}__label--floating`), n;
  }
  get validationClass() {
    return [`${this.baseClass}__validation`, {
      "ci-check": this.props.showSuccess
    }, {
      "orion-input__validation--success": this.props.showSuccess
    }, {
      "ci-triangle_warning": this.props.showError
    }, {
      "orion-input__validation--error": this.props.showError
    }, {
      "ci-triangle_warning": this.props.showWarning
    }, {
      "orion-input__validation--warning": this.props.showWarning
    }];
  }
  onUpdated() {
    var n;
    if (this._suffixPictos.value && this._suffixPictos.value.childElementCount > 0) {
      const t = (n = this._el.value) == null ? void 0 : n.querySelectorAll(":scope > .orion-input__input")[0];
      t && (t.style.paddingRight = this._suffixPictos.value.offsetWidth + "px");
    }
  }
}
S(lh, "props", {
  ..._l.prefixIcon(),
  ..._l.suffixIcon(),
  ..._l.size(),
  readonly: Boolean,
  disabled: Boolean,
  required: Boolean,
  clearable: Boolean,
  isFocus: Boolean,
  hasValue: Boolean,
  labelIsFloating: Boolean,
  showError: Boolean,
  showWarning: Boolean,
  showSuccess: Boolean,
  inputType: {
    type: String,
    default: "input"
  },
  label: {
    type: String,
    default: void 0
  }
});
const CS = ["innerHTML"], Dt = /* @__PURE__ */ K({
  __name: "OrionField",
  props: lh.props,
  emits: ["clear"],
  setup(e, {
    expose: l
  }) {
    const n = e, t = new lh(n);
    return l(t.publicInstance), (u, i) => (y(), O("div", {
      ref: c(t)._el,
      class: z([c(t).baseClass, c(t).additionalClass])
    }, [c(t).props.label ? (y(), O("label", {
      key: 0,
      class: z(c(t).labelClass),
      innerHTML: c(t).props.label
    }, null, 10, CS)) : I("", !0), V(u.$slots, "default"), c(t).props.prefixIcon || c(t).props.prefixFontIcon ? (y(), L(c(Ml), {
      key: 1,
      icon: c(t).props.prefixIcon,
      "font-icon": c(t).props.prefixFontIcon,
      class: z([`${c(t).baseClass}__icon`, `${c(t).baseClass}__icon--prefix`])
    }, null, 8, ["icon", "font-icon", "class"])) : I("", !0), A("span", {
      ref: c(t)._suffixPictos,
      class: z(`${c(t).baseClass}__pictos`)
    }, [(c(t).props.showError || c(t).props.showWarning || c(t).props.showSuccess) && !["checkbox", "radio", "toggle"].includes(c(t).props.inputType) ? (y(), L(c(Ml), {
      key: 0,
      class: z(c(t).validationClass)
    }, null, 8, ["class"])) : I("", !0), c(t).props.clearable && c(t).props.hasValue && !c(t).props.readonly && !c(t).props.disabled ? (y(), O("span", {
      key: 1,
      class: z(`${c(t).baseClass}__clearable`),
      onClick: i[0] || (i[0] = (s) => u.$emit("clear"))
    }, null, 2)) : I("", !0), c(t).props.suffixIcon || c(t).props.suffixFontIcon ? (y(), L(c(Ml), {
      key: 2,
      icon: c(t).props.suffixIcon,
      "font-icon": c(t).props.suffixFontIcon,
      class: z([`${c(t).baseClass}__icon`, `${c(t).baseClass}__icon--suffix`])
    }, null, 8, ["icon", "font-icon", "class"])) : I("", !0), V(u.$slots, "icon-suffix")], 2)], 2));
  }
}), Ha = {
  install(e, l = "o") {
    e.component(`${tl(l)}Field`, Dt);
  }
};
var ri = typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, _u = function(e, l, n, t, u, i, s, r, o, a) {
  var d = this;
  d.numeralDecimalMark = e || ".", d.numeralIntegerScale = l > 0 ? l : 0, d.numeralDecimalScale = n >= 0 ? n : 2, d.numeralThousandsGroupStyle = t || _u.groupStyle.thousand, d.numeralPositiveOnly = !!u, d.stripLeadingZeroes = i !== !1, d.prefix = s || s === "" ? s : "", d.signBeforePrefix = !!r, d.tailPrefix = !!o, d.delimiter = a || a === "" ? a : ",", d.delimiterRE = a ? new RegExp("\\" + a, "g") : "";
};
_u.groupStyle = {
  thousand: "thousand",
  lakh: "lakh",
  wan: "wan",
  none: "none"
};
_u.prototype = {
  getRawValue: function(e) {
    return e.replace(this.delimiterRE, "").replace(this.numeralDecimalMark, ".");
  },
  format: function(e) {
    var l = this, n, t, u, i, s = "";
    switch (e = e.replace(/[A-Za-z]/g, "").replace(l.numeralDecimalMark, "M").replace(/[^\dM-]/g, "").replace(/^\-/, "N").replace(/\-/g, "").replace("N", l.numeralPositiveOnly ? "" : "-").replace("M", l.numeralDecimalMark), l.stripLeadingZeroes && (e = e.replace(/^(-)?0+(?=\d)/, "$1")), t = e.slice(0, 1) === "-" ? "-" : "", typeof l.prefix < "u" ? l.signBeforePrefix ? u = t + l.prefix : u = l.prefix + t : u = t, i = e, e.indexOf(l.numeralDecimalMark) >= 0 && (n = e.split(l.numeralDecimalMark), i = n[0], s = l.numeralDecimalMark + n[1].slice(0, l.numeralDecimalScale)), t === "-" && (i = i.slice(1)), l.numeralIntegerScale > 0 && (i = i.slice(0, l.numeralIntegerScale)), l.numeralThousandsGroupStyle) {
      case _u.groupStyle.lakh:
        i = i.replace(/(\d)(?=(\d\d)+\d$)/g, "$1" + l.delimiter);
        break;
      case _u.groupStyle.wan:
        i = i.replace(/(\d)(?=(\d{4})+$)/g, "$1" + l.delimiter);
        break;
      case _u.groupStyle.thousand:
        i = i.replace(/(\d)(?=(\d{3})+$)/g, "$1" + l.delimiter);
        break;
    }
    return l.tailPrefix ? t + i.toString() + (l.numeralDecimalScale > 0 ? s.toString() : "") + l.prefix : u + i.toString() + (l.numeralDecimalScale > 0 ? s.toString() : "");
  }
};
var TS = _u, G3 = function(e, l, n) {
  var t = this;
  t.date = [], t.blocks = [], t.datePattern = e, t.dateMin = l.split("-").reverse().map(function(u) {
    return parseInt(u, 10);
  }), t.dateMin.length === 2 && t.dateMin.unshift(0), t.dateMax = n.split("-").reverse().map(function(u) {
    return parseInt(u, 10);
  }), t.dateMax.length === 2 && t.dateMax.unshift(0), t.initBlocks();
};
G3.prototype = {
  initBlocks: function() {
    var e = this;
    e.datePattern.forEach(function(l) {
      l === "Y" ? e.blocks.push(4) : e.blocks.push(2);
    });
  },
  getISOFormatDate: function() {
    var e = this, l = e.date;
    return l[2] ? l[2] + "-" + e.addLeadingZero(l[1]) + "-" + e.addLeadingZero(l[0]) : "";
  },
  getBlocks: function() {
    return this.blocks;
  },
  getValidatedDate: function(e) {
    var l = this, n = "";
    return e = e.replace(/[^\d]/g, ""), l.blocks.forEach(function(t, u) {
      if (e.length > 0) {
        var i = e.slice(0, t), s = i.slice(0, 1), r = e.slice(t);
        switch (l.datePattern[u]) {
          case "d":
            i === "00" ? i = "01" : parseInt(s, 10) > 3 ? i = "0" + s : parseInt(i, 10) > 31 && (i = "31");
            break;
          case "m":
            i === "00" ? i = "01" : parseInt(s, 10) > 1 ? i = "0" + s : parseInt(i, 10) > 12 && (i = "12");
            break;
        }
        n += i, e = r;
      }
    }), this.getFixedDateString(n);
  },
  getFixedDateString: function(e) {
    var l = this, n = l.datePattern, t = [], u = 0, i = 0, s = 0, r = 0, o = 0, a = 0, d, h, p, f = !1;
    e.length === 4 && n[0].toLowerCase() !== "y" && n[1].toLowerCase() !== "y" && (r = n[0] === "d" ? 0 : 2, o = 2 - r, d = parseInt(e.slice(r, r + 2), 10), h = parseInt(e.slice(o, o + 2), 10), t = this.getFixedDate(d, h, 0)), e.length === 8 && (n.forEach(function(g, v) {
      switch (g) {
        case "d":
          u = v;
          break;
        case "m":
          i = v;
          break;
        default:
          s = v;
          break;
      }
    }), a = s * 2, r = u <= s ? u * 2 : u * 2 + 2, o = i <= s ? i * 2 : i * 2 + 2, d = parseInt(e.slice(r, r + 2), 10), h = parseInt(e.slice(o, o + 2), 10), p = parseInt(e.slice(a, a + 4), 10), f = e.slice(a, a + 4).length === 4, t = this.getFixedDate(d, h, p)), e.length === 4 && (n[0] === "y" || n[1] === "y") && (o = n[0] === "m" ? 0 : 2, a = 2 - o, h = parseInt(e.slice(o, o + 2), 10), p = parseInt(e.slice(a, a + 2), 10), f = e.slice(a, a + 2).length === 2, t = [0, h, p]), e.length === 6 && (n[0] === "Y" || n[1] === "Y") && (o = n[0] === "m" ? 0 : 4, a = 2 - 0.5 * o, h = parseInt(e.slice(o, o + 2), 10), p = parseInt(e.slice(a, a + 4), 10), f = e.slice(a, a + 4).length === 4, t = [0, h, p]), t = l.getRangeFixedDate(t), l.date = t;
    var m = t.length === 0 ? e : n.reduce(function(g, v) {
      switch (v) {
        case "d":
          return g + (t[0] === 0 ? "" : l.addLeadingZero(t[0]));
        case "m":
          return g + (t[1] === 0 ? "" : l.addLeadingZero(t[1]));
        case "y":
          return g + (f ? l.addLeadingZeroForYear(t[2], !1) : "");
        case "Y":
          return g + (f ? l.addLeadingZeroForYear(t[2], !0) : "");
      }
    }, "");
    return m;
  },
  getRangeFixedDate: function(e) {
    var l = this, n = l.datePattern, t = l.dateMin || [], u = l.dateMax || [];
    return !e.length || t.length < 3 && u.length < 3 || n.find(function(i) {
      return i.toLowerCase() === "y";
    }) && e[2] === 0 ? e : u.length && (u[2] < e[2] || u[2] === e[2] && (u[1] < e[1] || u[1] === e[1] && u[0] < e[0])) ? u : t.length && (t[2] > e[2] || t[2] === e[2] && (t[1] > e[1] || t[1] === e[1] && t[0] > e[0])) ? t : e;
  },
  getFixedDate: function(e, l, n) {
    return e = Math.min(e, 31), l = Math.min(l, 12), n = parseInt(n || 0, 10), (l < 7 && l % 2 === 0 || l > 8 && l % 2 === 1) && (e = Math.min(e, l === 2 ? this.isLeapYear(n) ? 29 : 28 : 30)), [e, l, n];
  },
  isLeapYear: function(e) {
    return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
  },
  addLeadingZero: function(e) {
    return (e < 10 ? "0" : "") + e;
  },
  addLeadingZeroForYear: function(e, l) {
    return l ? (e < 10 ? "000" : e < 100 ? "00" : e < 1e3 ? "0" : "") + e : (e < 10 ? "0" : "") + e;
  }
};
var OS = G3, K3 = function(e, l) {
  var n = this;
  n.time = [], n.blocks = [], n.timePattern = e, n.timeFormat = l, n.initBlocks();
};
K3.prototype = {
  initBlocks: function() {
    var e = this;
    e.timePattern.forEach(function() {
      e.blocks.push(2);
    });
  },
  getISOFormatTime: function() {
    var e = this, l = e.time;
    return l[2] ? e.addLeadingZero(l[0]) + ":" + e.addLeadingZero(l[1]) + ":" + e.addLeadingZero(l[2]) : "";
  },
  getBlocks: function() {
    return this.blocks;
  },
  getTimeFormatOptions: function() {
    var e = this;
    return String(e.timeFormat) === "12" ? {
      maxHourFirstDigit: 1,
      maxHours: 12,
      maxMinutesFirstDigit: 5,
      maxMinutes: 60
    } : {
      maxHourFirstDigit: 2,
      maxHours: 23,
      maxMinutesFirstDigit: 5,
      maxMinutes: 60
    };
  },
  getValidatedTime: function(e) {
    var l = this, n = "";
    e = e.replace(/[^\d]/g, "");
    var t = l.getTimeFormatOptions();
    return l.blocks.forEach(function(u, i) {
      if (e.length > 0) {
        var s = e.slice(0, u), r = s.slice(0, 1), o = e.slice(u);
        switch (l.timePattern[i]) {
          case "h":
            parseInt(r, 10) > t.maxHourFirstDigit ? s = "0" + r : parseInt(s, 10) > t.maxHours && (s = t.maxHours + "");
            break;
          case "m":
          case "s":
            parseInt(r, 10) > t.maxMinutesFirstDigit ? s = "0" + r : parseInt(s, 10) > t.maxMinutes && (s = t.maxMinutes + "");
            break;
        }
        n += s, e = o;
      }
    }), this.getFixedTimeString(n);
  },
  getFixedTimeString: function(e) {
    var l = this, n = l.timePattern, t = [], u = 0, i = 0, s = 0, r = 0, o = 0, a = 0, d, h, p;
    return e.length === 6 && (n.forEach(function(f, m) {
      switch (f) {
        case "s":
          u = m * 2;
          break;
        case "m":
          i = m * 2;
          break;
        case "h":
          s = m * 2;
          break;
      }
    }), a = s, o = i, r = u, d = parseInt(e.slice(r, r + 2), 10), h = parseInt(e.slice(o, o + 2), 10), p = parseInt(e.slice(a, a + 2), 10), t = this.getFixedTime(p, h, d)), e.length === 4 && l.timePattern.indexOf("s") < 0 && (n.forEach(function(f, m) {
      switch (f) {
        case "m":
          i = m * 2;
          break;
        case "h":
          s = m * 2;
          break;
      }
    }), a = s, o = i, d = 0, h = parseInt(e.slice(o, o + 2), 10), p = parseInt(e.slice(a, a + 2), 10), t = this.getFixedTime(p, h, d)), l.time = t, t.length === 0 ? e : n.reduce(function(f, m) {
      switch (m) {
        case "s":
          return f + l.addLeadingZero(t[2]);
        case "m":
          return f + l.addLeadingZero(t[1]);
        case "h":
          return f + l.addLeadingZero(t[0]);
      }
    }, "");
  },
  getFixedTime: function(e, l, n) {
    return n = Math.min(parseInt(n || 0, 10), 60), l = Math.min(l, 60), e = Math.min(e, 60), [e, l, n];
  },
  addLeadingZero: function(e) {
    return (e < 10 ? "0" : "") + e;
  }
};
var kS = K3, Y3 = function(e, l) {
  var n = this;
  n.delimiter = l || l === "" ? l : " ", n.delimiterRE = l ? new RegExp("\\" + l, "g") : "", n.formatter = e;
};
Y3.prototype = {
  setFormatter: function(e) {
    this.formatter = e;
  },
  format: function(e) {
    var l = this;
    l.formatter.clear(), e = e.replace(/[^\d+]/g, ""), e = e.replace(/^\+/, "B").replace(/\+/g, "").replace("B", "+"), e = e.replace(l.delimiterRE, "");
    for (var n = "", t, u = !1, i = 0, s = e.length; i < s; i++)
      t = l.formatter.inputDigit(e.charAt(i)), /[\s()-]/g.test(t) ? (n = t, u = !0) : u || (n = t);
    return n = n.replace(/[()]/g, ""), n = n.replace(/[\s-]/g, l.delimiter), n;
  }
};
var MS = Y3, nh = {
  blocks: {
    uatp: [4, 5, 6],
    amex: [4, 6, 5],
    diners: [4, 6, 4],
    discover: [4, 4, 4, 4],
    mastercard: [4, 4, 4, 4],
    dankort: [4, 4, 4, 4],
    instapayment: [4, 4, 4, 4],
    jcb15: [4, 6, 5],
    jcb: [4, 4, 4, 4],
    maestro: [4, 4, 4, 4],
    visa: [4, 4, 4, 4],
    mir: [4, 4, 4, 4],
    unionPay: [4, 4, 4, 4],
    general: [4, 4, 4, 4]
  },
  re: {
    // starts with 1; 15 digits, not starts with 1800 (jcb card)
    uatp: /^(?!1800)1\d{0,14}/,
    // starts with 34/37; 15 digits
    amex: /^3[47]\d{0,13}/,
    // starts with 6011/65/644-649; 16 digits
    discover: /^(?:6011|65\d{0,2}|64[4-9]\d?)\d{0,12}/,
    // starts with 300-305/309 or 36/38/39; 14 digits
    diners: /^3(?:0([0-5]|9)|[689]\d?)\d{0,11}/,
    // starts with 51-55/2221–2720; 16 digits
    mastercard: /^(5[1-5]\d{0,2}|22[2-9]\d{0,1}|2[3-7]\d{0,2})\d{0,12}/,
    // starts with 5019/4175/4571; 16 digits
    dankort: /^(5019|4175|4571)\d{0,12}/,
    // starts with 637-639; 16 digits
    instapayment: /^63[7-9]\d{0,13}/,
    // starts with 2131/1800; 15 digits
    jcb15: /^(?:2131|1800)\d{0,11}/,
    // starts with 2131/1800/35; 16 digits
    jcb: /^(?:35\d{0,2})\d{0,12}/,
    // starts with 50/56-58/6304/67; 16 digits
    maestro: /^(?:5[0678]\d{0,2}|6304|67\d{0,2})\d{0,12}/,
    // starts with 22; 16 digits
    mir: /^220[0-4]\d{0,12}/,
    // starts with 4; 16 digits
    visa: /^4\d{0,15}/,
    // starts with 62/81; 16 digits
    unionPay: /^(62|81)\d{0,14}/
  },
  getStrictBlocks: function(e) {
    var l = e.reduce(function(n, t) {
      return n + t;
    }, 0);
    return e.concat(19 - l);
  },
  getInfo: function(e, l) {
    var n = nh.blocks, t = nh.re;
    l = !!l;
    for (var u in t)
      if (t[u].test(e)) {
        var i = n[u];
        return {
          type: u,
          blocks: l ? this.getStrictBlocks(i) : i
        };
      }
    return {
      type: "unknown",
      blocks: l ? this.getStrictBlocks(n.general) : n.general
    };
  }
}, AS = nh, xS = {
  noop: function() {
  },
  strip: function(e, l) {
    return e.replace(l, "");
  },
  getPostDelimiter: function(e, l, n) {
    if (n.length === 0)
      return e.slice(-l.length) === l ? l : "";
    var t = "";
    return n.forEach(function(u) {
      e.slice(-u.length) === u && (t = u);
    }), t;
  },
  getDelimiterREByDelimiter: function(e) {
    return new RegExp(e.replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1"), "g");
  },
  getNextCursorPosition: function(e, l, n, t, u) {
    return l.length === e ? n.length : e + this.getPositionOffset(e, l, n, t, u);
  },
  getPositionOffset: function(e, l, n, t, u) {
    var i, s, r;
    return i = this.stripDelimiters(l.slice(0, e), t, u), s = this.stripDelimiters(n.slice(0, e), t, u), r = i.length - s.length, r !== 0 ? r / Math.abs(r) : 0;
  },
  stripDelimiters: function(e, l, n) {
    var t = this;
    if (n.length === 0) {
      var u = l ? t.getDelimiterREByDelimiter(l) : "";
      return e.replace(u, "");
    }
    return n.forEach(function(i) {
      i.split("").forEach(function(s) {
        e = e.replace(t.getDelimiterREByDelimiter(s), "");
      });
    }), e;
  },
  headStr: function(e, l) {
    return e.slice(0, l);
  },
  getMaxLength: function(e) {
    return e.reduce(function(l, n) {
      return l + n;
    }, 0);
  },
  // strip prefix
  // Before type  |   After type    |     Return value
  // PEFIX-...    |   PEFIX-...     |     ''
  // PREFIX-123   |   PEFIX-123     |     123
  // PREFIX-123   |   PREFIX-23     |     23
  // PREFIX-123   |   PREFIX-1234   |     1234
  getPrefixStrippedValue: function(e, l, n, t, u, i, s, r, o) {
    if (n === 0)
      return e;
    if (e === l && e !== "")
      return "";
    if (o && e.slice(0, 1) == "-") {
      var a = t.slice(0, 1) == "-" ? t.slice(1) : t;
      return "-" + this.getPrefixStrippedValue(e.slice(1), l, n, a, u, i, s, r, o);
    }
    if (t.slice(0, n) !== l && !r)
      return s && !t && e ? e : "";
    if (t.slice(-n) !== l && r)
      return s && !t && e ? e : "";
    var d = this.stripDelimiters(t, u, i);
    return e.slice(0, n) !== l && !r ? d.slice(n) : e.slice(-n) !== l && r ? d.slice(0, -n - 1) : r ? e.slice(0, -n) : e.slice(n);
  },
  getFirstDiffIndex: function(e, l) {
    for (var n = 0; e.charAt(n) === l.charAt(n); )
      if (e.charAt(n++) === "")
        return -1;
    return n;
  },
  getFormattedValue: function(e, l, n, t, u, i) {
    var s = "", r = u.length > 0, o = "";
    return n === 0 ? e : (l.forEach(function(a, d) {
      if (e.length > 0) {
        var h = e.slice(0, a), p = e.slice(a);
        r ? o = u[i ? d - 1 : d] || o : o = t, i ? (d > 0 && (s += o), s += h) : (s += h, h.length === a && d < n - 1 && (s += o)), e = p;
      }
    }), s);
  },
  // move cursor to the end
  // the first time user focuses on an input with prefix
  fixPrefixCursor: function(e, l, n, t) {
    if (e) {
      var u = e.value, i = n || t[0] || " ";
      if (!(!e.setSelectionRange || !l || l.length + i.length <= u.length)) {
        var s = u.length * 2;
        setTimeout(function() {
          e.setSelectionRange(s, s);
        }, 1);
      }
    }
  },
  // Check if input field is fully selected
  checkFullSelection: function(e) {
    try {
      var l = window.getSelection() || document.getSelection() || {};
      return l.toString().length === e.length;
    } catch {
    }
    return !1;
  },
  setSelection: function(e, l, n) {
    if (e === this.getActiveElement(n) && !(e && e.value.length <= l))
      if (e.createTextRange) {
        var t = e.createTextRange();
        t.move("character", l), t.select();
      } else
        try {
          e.setSelectionRange(l, l);
        } catch {
          console.warn("The input element type does not support selection");
        }
  },
  getActiveElement: function(e) {
    var l = e.activeElement;
    return l && l.shadowRoot ? this.getActiveElement(l.shadowRoot) : l;
  },
  isAndroid: function() {
    return navigator && /android/i.test(navigator.userAgent);
  },
  // On Android chrome, the keyup and keydown events
  // always return key code 229 as a composition that
  // buffers the user’s keystrokes
  // see https://github.com/nosir/cleave.js/issues/147
  isAndroidBackspaceKeydown: function(e, l) {
    return !this.isAndroid() || !e || !l ? !1 : l === e.slice(0, -1);
  }
}, ES = xS, IS = {
  // Maybe change to object-assign
  // for now just keep it as simple
  assign: function(e, l) {
    return e = e || {}, l = l || {}, e.creditCard = !!l.creditCard, e.creditCardStrictMode = !!l.creditCardStrictMode, e.creditCardType = "", e.onCreditCardTypeChanged = l.onCreditCardTypeChanged || function() {
    }, e.phone = !!l.phone, e.phoneRegionCode = l.phoneRegionCode || "AU", e.phoneFormatter = {}, e.time = !!l.time, e.timePattern = l.timePattern || ["h", "m", "s"], e.timeFormat = l.timeFormat || "24", e.timeFormatter = {}, e.date = !!l.date, e.datePattern = l.datePattern || ["d", "m", "Y"], e.dateMin = l.dateMin || "", e.dateMax = l.dateMax || "", e.dateFormatter = {}, e.numeral = !!l.numeral, e.numeralIntegerScale = l.numeralIntegerScale > 0 ? l.numeralIntegerScale : 0, e.numeralDecimalScale = l.numeralDecimalScale >= 0 ? l.numeralDecimalScale : 2, e.numeralDecimalMark = l.numeralDecimalMark || ".", e.numeralThousandsGroupStyle = l.numeralThousandsGroupStyle || "thousand", e.numeralPositiveOnly = !!l.numeralPositiveOnly, e.stripLeadingZeroes = l.stripLeadingZeroes !== !1, e.signBeforePrefix = !!l.signBeforePrefix, e.tailPrefix = !!l.tailPrefix, e.swapHiddenInput = !!l.swapHiddenInput, e.numericOnly = e.creditCard || e.date || !!l.numericOnly, e.uppercase = !!l.uppercase, e.lowercase = !!l.lowercase, e.prefix = e.creditCard || e.date ? "" : l.prefix || "", e.noImmediatePrefix = !!l.noImmediatePrefix, e.prefixLength = e.prefix.length, e.rawValueTrimPrefix = !!l.rawValueTrimPrefix, e.copyDelimiter = !!l.copyDelimiter, e.initValue = l.initValue !== void 0 && l.initValue !== null ? l.initValue.toString() : "", e.delimiter = l.delimiter || l.delimiter === "" ? l.delimiter : l.date ? "/" : l.time ? ":" : l.numeral ? "," : (l.phone, " "), e.delimiterLength = e.delimiter.length, e.delimiterLazyShow = !!l.delimiterLazyShow, e.delimiters = l.delimiters || [], e.blocks = l.blocks || [], e.blocksLength = e.blocks.length, e.root = typeof ri == "object" && ri ? ri : window, e.document = l.document || e.root.document, e.maxLength = 0, e.backspace = !1, e.result = "", e.onValueChanged = l.onValueChanged || function() {
    }, e;
  }
}, RS = IS, Hl = function(e, l) {
  var n = this, t = !1;
  if (typeof e == "string" ? (n.element = document.querySelector(e), t = document.querySelectorAll(e).length > 1) : typeof e.length < "u" && e.length > 0 ? (n.element = e[0], t = e.length > 1) : n.element = e, !n.element)
    throw new Error("[cleave.js] Please check the element");
  if (t)
    try {
      console.warn("[cleave.js] Multiple input fields matched, cleave.js will only take the first one.");
    } catch {
    }
  l.initValue = n.element.value, n.properties = Hl.DefaultProperties.assign({}, l), n.init();
};
Hl.prototype = {
  init: function() {
    var e = this, l = e.properties;
    if (!l.numeral && !l.phone && !l.creditCard && !l.time && !l.date && l.blocksLength === 0 && !l.prefix) {
      e.onInput(l.initValue);
      return;
    }
    l.maxLength = Hl.Util.getMaxLength(l.blocks), e.isAndroid = Hl.Util.isAndroid(), e.lastInputValue = "", e.isBackward = "", e.onChangeListener = e.onChange.bind(e), e.onKeyDownListener = e.onKeyDown.bind(e), e.onFocusListener = e.onFocus.bind(e), e.onCutListener = e.onCut.bind(e), e.onCopyListener = e.onCopy.bind(e), e.initSwapHiddenInput(), e.element.addEventListener("input", e.onChangeListener), e.element.addEventListener("keydown", e.onKeyDownListener), e.element.addEventListener("focus", e.onFocusListener), e.element.addEventListener("cut", e.onCutListener), e.element.addEventListener("copy", e.onCopyListener), e.initPhoneFormatter(), e.initDateFormatter(), e.initTimeFormatter(), e.initNumeralFormatter(), (l.initValue || l.prefix && !l.noImmediatePrefix) && e.onInput(l.initValue);
  },
  initSwapHiddenInput: function() {
    var e = this, l = e.properties;
    if (l.swapHiddenInput) {
      var n = e.element.cloneNode(!0);
      e.element.parentNode.insertBefore(n, e.element), e.elementSwapHidden = e.element, e.elementSwapHidden.type = "hidden", e.element = n, e.element.id = "";
    }
  },
  initNumeralFormatter: function() {
    var e = this, l = e.properties;
    l.numeral && (l.numeralFormatter = new Hl.NumeralFormatter(
      l.numeralDecimalMark,
      l.numeralIntegerScale,
      l.numeralDecimalScale,
      l.numeralThousandsGroupStyle,
      l.numeralPositiveOnly,
      l.stripLeadingZeroes,
      l.prefix,
      l.signBeforePrefix,
      l.tailPrefix,
      l.delimiter
    ));
  },
  initTimeFormatter: function() {
    var e = this, l = e.properties;
    l.time && (l.timeFormatter = new Hl.TimeFormatter(l.timePattern, l.timeFormat), l.blocks = l.timeFormatter.getBlocks(), l.blocksLength = l.blocks.length, l.maxLength = Hl.Util.getMaxLength(l.blocks));
  },
  initDateFormatter: function() {
    var e = this, l = e.properties;
    l.date && (l.dateFormatter = new Hl.DateFormatter(l.datePattern, l.dateMin, l.dateMax), l.blocks = l.dateFormatter.getBlocks(), l.blocksLength = l.blocks.length, l.maxLength = Hl.Util.getMaxLength(l.blocks));
  },
  initPhoneFormatter: function() {
    var e = this, l = e.properties;
    if (l.phone)
      try {
        l.phoneFormatter = new Hl.PhoneFormatter(
          new l.root.Cleave.AsYouTypeFormatter(l.phoneRegionCode),
          l.delimiter
        );
      } catch {
        throw new Error("[cleave.js] Please include phone-type-formatter.{country}.js lib");
      }
  },
  onKeyDown: function(e) {
    var l = this, n = e.which || e.keyCode;
    l.lastInputValue = l.element.value, l.isBackward = n === 8;
  },
  onChange: function(e) {
    var l = this, n = l.properties, t = Hl.Util;
    l.isBackward = l.isBackward || e.inputType === "deleteContentBackward";
    var u = t.getPostDelimiter(l.lastInputValue, n.delimiter, n.delimiters);
    l.isBackward && u ? n.postDelimiterBackspace = u : n.postDelimiterBackspace = !1, this.onInput(this.element.value);
  },
  onFocus: function() {
    var e = this, l = e.properties;
    e.lastInputValue = e.element.value, l.prefix && l.noImmediatePrefix && !e.element.value && this.onInput(l.prefix), Hl.Util.fixPrefixCursor(e.element, l.prefix, l.delimiter, l.delimiters);
  },
  onCut: function(e) {
    Hl.Util.checkFullSelection(this.element.value) && (this.copyClipboardData(e), this.onInput(""));
  },
  onCopy: function(e) {
    Hl.Util.checkFullSelection(this.element.value) && this.copyClipboardData(e);
  },
  copyClipboardData: function(e) {
    var l = this, n = l.properties, t = Hl.Util, u = l.element.value, i = "";
    n.copyDelimiter ? i = u : i = t.stripDelimiters(u, n.delimiter, n.delimiters);
    try {
      e.clipboardData ? e.clipboardData.setData("Text", i) : window.clipboardData.setData("Text", i), e.preventDefault();
    } catch {
    }
  },
  onInput: function(e) {
    var l = this, n = l.properties, t = Hl.Util, u = t.getPostDelimiter(e, n.delimiter, n.delimiters);
    if (!n.numeral && n.postDelimiterBackspace && !u && (e = t.headStr(e, e.length - n.postDelimiterBackspace.length)), n.phone) {
      n.prefix && (!n.noImmediatePrefix || e.length) ? n.result = n.prefix + n.phoneFormatter.format(e).slice(n.prefix.length) : n.result = n.phoneFormatter.format(e), l.updateValueState();
      return;
    }
    if (n.numeral) {
      n.prefix && n.noImmediatePrefix && e.length === 0 ? n.result = "" : n.result = n.numeralFormatter.format(e), l.updateValueState();
      return;
    }
    if (n.date && (e = n.dateFormatter.getValidatedDate(e)), n.time && (e = n.timeFormatter.getValidatedTime(e)), e = t.stripDelimiters(e, n.delimiter, n.delimiters), e = t.getPrefixStrippedValue(e, n.prefix, n.prefixLength, n.result, n.delimiter, n.delimiters, n.noImmediatePrefix, n.tailPrefix, n.signBeforePrefix), e = n.numericOnly ? t.strip(e, /[^\d]/g) : e, e = n.uppercase ? e.toUpperCase() : e, e = n.lowercase ? e.toLowerCase() : e, n.prefix && (n.tailPrefix ? e = e + n.prefix : e = n.prefix + e, n.blocksLength === 0)) {
      n.result = e, l.updateValueState();
      return;
    }
    n.creditCard && l.updateCreditCardPropsByValue(e), e = t.headStr(e, n.maxLength), n.result = t.getFormattedValue(
      e,
      n.blocks,
      n.blocksLength,
      n.delimiter,
      n.delimiters,
      n.delimiterLazyShow
    ), l.updateValueState();
  },
  updateCreditCardPropsByValue: function(e) {
    var l = this, n = l.properties, t = Hl.Util, u;
    t.headStr(n.result, 4) !== t.headStr(e, 4) && (u = Hl.CreditCardDetector.getInfo(e, n.creditCardStrictMode), n.blocks = u.blocks, n.blocksLength = n.blocks.length, n.maxLength = t.getMaxLength(n.blocks), n.creditCardType !== u.type && (n.creditCardType = u.type, n.onCreditCardTypeChanged.call(l, n.creditCardType)));
  },
  updateValueState: function() {
    var e = this, l = Hl.Util, n = e.properties;
    if (e.element) {
      var t = e.element.selectionEnd, u = e.element.value, i = n.result;
      if (t = l.getNextCursorPosition(t, u, i, n.delimiter, n.delimiters), e.isAndroid) {
        window.setTimeout(function() {
          e.element.value = i, l.setSelection(e.element, t, n.document, !1), e.callOnValueChanged();
        }, 1);
        return;
      }
      e.element.value = i, n.swapHiddenInput && (e.elementSwapHidden.value = e.getRawValue()), l.setSelection(e.element, t, n.document, !1), e.callOnValueChanged();
    }
  },
  callOnValueChanged: function() {
    var e = this, l = e.properties;
    l.onValueChanged.call(e, {
      target: {
        name: e.element.name,
        value: l.result,
        rawValue: e.getRawValue()
      }
    });
  },
  setPhoneRegionCode: function(e) {
    var l = this, n = l.properties;
    n.phoneRegionCode = e, l.initPhoneFormatter(), l.onChange();
  },
  setRawValue: function(e) {
    var l = this, n = l.properties;
    e = e != null ? e.toString() : "", n.numeral && (e = e.replace(".", n.numeralDecimalMark)), n.postDelimiterBackspace = !1, l.element.value = e, l.onInput(e);
  },
  getRawValue: function() {
    var e = this, l = e.properties, n = Hl.Util, t = e.element.value;
    return l.rawValueTrimPrefix && (t = n.getPrefixStrippedValue(t, l.prefix, l.prefixLength, l.result, l.delimiter, l.delimiters, l.noImmediatePrefix, l.tailPrefix, l.signBeforePrefix)), l.numeral ? t = l.numeralFormatter.getRawValue(t) : t = n.stripDelimiters(t, l.delimiter, l.delimiters), t;
  },
  getISOFormatDate: function() {
    var e = this, l = e.properties;
    return l.date ? l.dateFormatter.getISOFormatDate() : "";
  },
  getISOFormatTime: function() {
    var e = this, l = e.properties;
    return l.time ? l.timeFormatter.getISOFormatTime() : "";
  },
  getFormattedValue: function() {
    return this.element.value;
  },
  destroy: function() {
    var e = this;
    e.element.removeEventListener("input", e.onChangeListener), e.element.removeEventListener("keydown", e.onKeyDownListener), e.element.removeEventListener("focus", e.onFocusListener), e.element.removeEventListener("cut", e.onCutListener), e.element.removeEventListener("copy", e.onCopyListener);
  },
  toString: function() {
    return "[Cleave Object]";
  }
};
Hl.NumeralFormatter = TS;
Hl.DateFormatter = OS;
Hl.TimeFormatter = kS;
Hl.PhoneFormatter = MS;
Hl.CreditCardDetector = AS;
Hl.Util = ES;
Hl.DefaultProperties = RS;
(typeof ri == "object" && ri ? ri : window).Cleave = Hl;
var z0 = Hl;
class Sf {
  constructor(l) {
    this.options = {
      openauto: !0,
      ...l,
      programmatic: !0,
      uid: ft()
    };
  }
  registerComponentInstanceInDevtool(l) {
    var n;
    (n = l.component) != null && n.uid && Fl.appInstance && (l.component.parent = Fl.appInstance, l.component.root = Fl.appInstance, xn == null || xn.on.visitComponentTree((t) => {
      var u, i, s;
      t.treeNode.uid === ((u = Fl.appInstance) == null ? void 0 : u.uid) && ((i = l.component) != null && i.uid) && (t.treeNode.children.push({
        autoOpen: !1,
        children: [],
        hasChildren: !1,
        id: `${t.app.__VUE_DEVTOOLS_APP_RECORD_ID__}:${l.component.uid}`,
        inactive: !1,
        isFragment: !1,
        name: this.nameForDevtool,
        renderKey: void 0,
        tags: [],
        uid: (s = l.component) == null ? void 0 : s.uid,
        orionUid: this.options.uid
      }), setTimeout(() => {
        var r;
        this.notifyPopableUpdate(((r = l.component) == null ? void 0 : r.uid) ?? 0);
      }, 100));
    }));
  }
  async notifyPopableUpdate(l) {
    const n = await (xn == null ? void 0 : xn.getComponentInstances(Fl.app)), t = n == null ? void 0 : n.find((u) => u.uid === l);
    xn == null || xn.notifyComponentUpdate(t);
  }
}
class DS extends Sf {
  constructor(n) {
    super(n);
    S(this, "nameForDevtool", "OrionAside");
  }
  createVNode() {
    var i, s, r;
    const n = ye(_f, {
      options: this.options
    });
    n.appContext = Fl.appContext;
    const t = (i = Ul()) == null ? void 0 : i.createElement("div");
    if (t) {
      t.id = `OrionAside-wrapper-${this.options.uid}`;
      const o = (s = Ul()) == null ? void 0 : s.getElementById("orion-popable-wrapper");
      o ? o.appendChild(t) : (r = Ul()) == null || r.body.appendChild(t), fi(n, t), this.registerComponentInstanceInDevtool(n);
    }
    return an().getInstance(this.options.uid);
  }
}
function CB(e) {
  return new DS(e).createVNode();
}
class NS {
  static get pluralize() {
    return ul().pluralize;
  }
}
function Ae(e, l, n) {
  return NS.pluralize(e, l, n);
}
class q3 extends Array {
  constructor(...l) {
    super(), this.push(...l);
  }
  /**
   * @desc returns an array with distinct values for the key specified in parameter
   * @param {keyof T} distinctBy key of the array where the filter will be applied
   * @return T[]
   */
  distinct(l) {
    if (l) {
      const n = [], t = /* @__PURE__ */ new Map();
      for (const u of this)
        l in u && (t.has(u[l]) || (t.set(u[l], !0), n.push(u)));
      return n;
    } else
      return [...new Set(this)];
  }
  /**
   * @desc returns the last item of the array, or undefined if the array is empty
   * @return T | undefined
   */
  last() {
    return this ? this[this.length - 1] : void 0;
  }
  /**
   * @desc returns the first item of the array, or undefined if the array is empty
   * @return T | undefined
   */
  first() {
    return this ? this[0] : void 0;
  }
  /**
   * @desc deletes an item from the array, based on the key given in parameters
   * @param {any} target item or object to delete from the array
   * @param {keyof T} [key='id'] key on which the research will be based
   * @param {number} [deleteCount=1] numbers of elements to remove after the item index
   * @return T[]
   */
  delete(l, n = "id", t = 1) {
    let u;
    return typeof l == "object" && !In(l == null ? void 0 : l[n]) ? u = this.findIndex((i) => i[n] === (l == null ? void 0 : l[n])) : u = this.findIndex((i) => i === l), u >= 0 && this.splice(u, t), this;
  }
  /**
   * @desc deletes an item from the array if the pair key/ValueKey is found or if the key function is verified
   * @param {any} keyValue value of the object to remove
   * @param {K | ((x: T) => boolean)} key key on which the research will be based, or the function to verify
   * @return T[]
   */
  deleteWhere(l, n) {
    if (typeof l == "string") {
      const t = this.filter((u) => u[l] !== n);
      this.length = 0, this.push(...t);
    } else if (typeof l == "function") {
      const t = this.filter((u) => !l(u));
      this.length = 0, this.push(...t);
    }
    return this;
  }
  /**
   * @desc clears the array
   * @return Array
   */
  empty() {
    return this.length = 0, this;
  }
  /**
   * @desc adds the target element in the array if it is not already present, removes it otherwise
   * @param {T} target item or object to toggle in the array
   * @param {keyof T} [key='id'] key on which the research will be based
   * @return T[]
   */
  toggle(l, n = "id") {
    let t;
    return typeof l == "object" && !In(l == null ? void 0 : l[n]) ? t = this.findIndex((u) => u[n] === (l == null ? void 0 : l[n])) : t = this.findIndex((u) => u === l), t >= 0 ? this.splice(t, 1) : this.push(l), this;
  }
  /**
   * @desc maps all values of the key given in parameter
   * @param {K} [keyPath='id']
   * @return T[K][]
   */
  mapKey(l = "id") {
    return this.map((n) => $s(n, l));
  }
  /**
   * @desc checks if the arrays contains the key/value pair given in parameters and returns it if found, undefined otherwise
   * @param {T[K]} keyValue value of the key
   * @param {K} [key='id'] key on which the research will be based
   * @return T | undefined
   */
  findByKey(l, n = "id") {
    return this.find((t) => $s(t, n) === l);
  }
  /**
   * @desc adds the item if the array does not contain it already
   * @param {any} item item to add
   * @return Array
   */
  pushUniq(l) {
    return this.includes(l) || this.push(l), this;
  }
  /**
   * @desc return the array without null or undefined items
   * @return {*}  {T[]}
   */
  filterNil() {
    return this.filter((l) => l != null);
  }
}
class Zo extends Date {
  constructor(l) {
    super(l);
  }
  /**
   * @desc returns the date to the format YYYY-MM-DD, or YYYY-MM-DDTHH-MM-SS if the param withTime is set to true
   * @param {boolean} [withTime=false] adds the time to the date
   * @return string
   */
  toPost(l = !1) {
    const n = Bi(this.getMonth() + 1), t = Bi(this.getDate());
    let u = `${this.getFullYear()}-${n}-${t}`;
    if (l) {
      const i = Bi(this.getHours()), s = Bi(this.getMinutes()), r = Bi(this.getSeconds());
      u = u + `T${i}:${s}:${r}`;
    }
    return u;
  }
  /**
   * @desc returns the date to to current timezone, at the YYYY-MM-DDTHH-MM-SS format
   * @return string
   */
  toOffset() {
    const l = -this.getTimezoneOffset(), n = l >= 0 ? "+" : "-", t = function(u) {
      const i = Math.floor(Math.abs(u));
      return (i < 10 ? "0" : "") + i;
    };
    return this.getFullYear() + "-" + t(this.getMonth() + 1) + "-" + t(this.getDate()) + "T" + t(this.getHours()) + ":" + t(this.getMinutes()) + ":" + t(this.getSeconds()) + n + t(l / 60) + ":" + t(l % 60);
  }
  /**
   * @desc checks if the date is bissextile
   * @return boolean
   */
  isBissextile() {
    const l = this.getFullYear();
    return l % 4 === 0 && l % 100 !== 0 || l % 400 === 0;
  }
  /**
   * @desc returns the date to the YYYY-DDD format
   * @return number
   */
  getOrdinalDate() {
    const l = this.getMonth() + 1, n = this.isBissextile() ? 2 : 3;
    let t = 30 * (l - 1) + Math.floor(0.6 * (l + 1)) - n;
    return l === 1 && (t = 0), l === 2 && (t = 31), t + this.getDate();
  }
  /**
   * @desc returns a string which indicates the elapsed time between the current date or the date given in parameter
   * @param {string} pattern pattern of the result string (can contain $year, $month ...)
   * @param {date} date optionnal date to compare
   * @return string
   */
  getTimeBetween(l, n) {
    const t = new Date(this), u = n ? new Date(n) : /* @__PURE__ */ new Date();
    function i() {
      l != null && l.includes("$year") || d > 0 && (h += 12 * d);
    }
    const s = () => {
      if (!(l != null && l.includes("$month")) && h > 0) {
        const w = u, $ = u.getDate() - t.getDate() < 0;
        for (let _ = $ ? 1 : 0; _ < ($ ? h + 1 : h); _++)
          w.getMonth() - _ > 0 ? p += new Date(w.getFullYear(), w.getMonth() - _, 0).getDate() : p += new Date(w.getFullYear() - 1, w.getMonth() + 12 - _, 0).getDate();
      }
    };
    function r() {
      l != null && l.includes("$day") || p > 0 && (f += p * 24);
    }
    function o() {
      l != null && l.includes("$hour") || f > 0 && (m += f * 60);
    }
    function a() {
      l != null && l.includes("$min") || m > 0 && (g += m * 60);
    }
    let d = u.getFullYear() - t.getFullYear(), h = u.getMonth() - t.getMonth(), p = u.getDate() - t.getDate(), f = u.getHours() - t.getHours(), m = u.getMinutes() - t.getMinutes(), g = u.getSeconds() - t.getSeconds();
    if (g < 0 && (m--, g = 60 + g), m < 0 && (f--, m = 60 + m), f < 0 && (p--, f = 24 + f), p < 0 && (h--, p = new Date(u.getFullYear(), u.getMonth(), 0).getDate() + p), h < 0 && (d--, h = 12 + h), l)
      i(), s(), r(), o(), a();
    else {
      let w = function($) {
        return d === 0 && h === 0 && p === 0 && f === 0 && m === 0 ? $ += " $sec" : d === 0 && h === 0 && p === 0 && f === 0 ? $ += " $min" : d === 0 && h === 0 && p === 0 ? $ += " $hour" : d === 0 && h === 0 ? $ += " $day" : d === 0 ? $ += " $month" : $ += " $year", $;
      };
      n ? l = ul().IN.toLowerCase() : jt() === "fr" ? (l = ul().THERE_IS.toLowerCase(), l = w(l)) : (l = w(""), l += " " + ul().THERE_IS.toLowerCase());
    }
    return l.replace("$year", `${Ae(ul().YEAR, d, !0).toLowerCase()}`).replace("$month", `${Ae(ul().MONTH, h, !0).toLowerCase()}`).replace("$day", `${Ae(ul().DAY, p, !0).toLowerCase()}`).replace("$hour", `${Ae(ul().HOUR, f, !0).toLowerCase()}`).replace("$min", `${Ae(ul().MINUTE, m, !0).toLowerCase()}`).replace("$sec", `${Ae(ul().SECOND, g, !0).toLowerCase()}`);
  }
  /**
   * @desc returns the weeknumber of the date
   * @return number
   */
  getWeekNumber() {
    const l = this.getOrdinalDate();
    let n = this.getDay();
    n = n === 0 ? 7 : n;
    let t = Math.floor((l - n + 10) / 7);
    return t === 53 && !this.hasFiftyThreeWeeks() && (t = 1), t === 0 && (X(/* @__PURE__ */ new Date(`1-1-${this.getFullYear() - 1}`)).hasFiftyThreeWeeks() ? t = 53 : t = 52), t;
  }
  /**
   * @desc returns an object with the weekdays as keys, and their associated dates as values
   * @return object
   */
  getWeekDays() {
    const n = new Zo(this).setDateToFirstDow(), t = n.getDate(), u = n.getMonth(), i = n.getFullYear();
    return {
      monday: new Date(i, u, t),
      tuesday: new Date(i, u, t + 1),
      wednesday: new Date(i, u, t + 2),
      thursday: new Date(i, u, t + 3),
      friday: new Date(i, u, t + 4),
      saturday: new Date(i, u, t + 5),
      sunday: new Date(i, u, t + 6)
    };
  }
  /**
   * @desc returns an object with the first and the last day of the week number given in parameter
   * @param {string} [startKey = 'start'] key for the first day of the week
   * @param {string} [endKey = 'end'] key for the last day of the week
   * @return object
   */
  getWeekDates(l = "start", n = "end") {
    return {
      [l]: this.getWeekDays().monday,
      [n]: this.getWeekDays().sunday
    };
  }
  /**
   * @desc checks if the year of the date has 53 weeks
   * @return boolean
   */
  hasFiftyThreeWeeks() {
    let l = !1;
    const n = new Date(this.getFullYear(), 0, 1);
    return X(n).isBissextile() ? (n.getDay() === 4 || n.getDay() === 3) && (l = !0) : n.getDay() === 4 && (l = !0), l;
  }
  /**
   * @desc sets the date to the first day of the week
   * @return Date
   */
  setDateToFirstDow() {
    let l = this.getDay();
    return l = l === 0 ? 6 : l - 1, this.setDate(this.getDate() - l), this;
  }
  /**
   * @desc sets the date to the last day of the week
   * @return Date
   */
  setDateToLastDow() {
    let l = this.getDay();
    return l = l === 0 ? 0 : 7 - l, this.setDate(this.getDate() + l), this;
  }
  /**
   * @desc returns the date to a string formatted according to the given pattern
   * @param {string} [pattern=language.DATE_PATTERN] pattern of the string
   * @param { } Example `new Date().toReadable('Meeting date : $dddd, $YYYY-$MM-$DD')`
   * @param { } PatternKeywords ```\n$DD - date\n$dddd - day name\n$ddd - day name short\n$MMMM - month name\n$MMM - month name short\n$MM - month number\n$YYYY - full year\n$YY - short year\n$hh - hours\n$mm - minutes\n$ss - seconds\n```
   * @return string
   */
  toReadable(l) {
    l || (l = ul().DATE_PATTERN);
    let n = "";
    switch (this.getDay()) {
      case 1:
        n = ul().DAY_NAME[0];
        break;
      case 2:
        n = ul().DAY_NAME[1];
        break;
      case 3:
        n = ul().DAY_NAME[2];
        break;
      case 4:
        n = ul().DAY_NAME[3];
        break;
      case 5:
        n = ul().DAY_NAME[4];
        break;
      case 6:
        n = ul().DAY_NAME[5];
        break;
      case 0:
        n = ul().DAY_NAME[6];
        break;
    }
    const t = n.slice(0, 3) + ".", u = this.getMonth() + 1;
    let i = "", s = "";
    switch (u) {
      case 1:
        i = ul().MONTH_NAME[0], s = ul().MONTH_NAME_SHORT[0];
        break;
      case 2:
        i = ul().MONTH_NAME[1], s = ul().MONTH_NAME_SHORT[1];
        break;
      case 3:
        i = ul().MONTH_NAME[2], s = ul().MONTH_NAME_SHORT[2];
        break;
      case 4:
        i = ul().MONTH_NAME[3], s = ul().MONTH_NAME_SHORT[3];
        break;
      case 5:
        i = ul().MONTH_NAME[4], s = ul().MONTH_NAME_SHORT[4];
        break;
      case 6:
        i = ul().MONTH_NAME[5], s = ul().MONTH_NAME_SHORT[5];
        break;
      case 7:
        i = ul().MONTH_NAME[6], s = ul().MONTH_NAME_SHORT[6];
        break;
      case 8:
        i = ul().MONTH_NAME[7], s = ul().MONTH_NAME_SHORT[7];
        break;
      case 9:
        i = ul().MONTH_NAME[8], s = ul().MONTH_NAME_SHORT[8];
        break;
      case 10:
        i = ul().MONTH_NAME[9], s = ul().MONTH_NAME_SHORT[9];
        break;
      case 11:
        i = ul().MONTH_NAME[10], s = ul().MONTH_NAME_SHORT[10];
        break;
      case 12:
        i = ul().MONTH_NAME[11], s = ul().MONTH_NAME_SHORT[11];
        break;
    }
    return l.replace("$DD", this.getDate().toString().padStart(2, "0")).replace("$D", this.getDate().toString()).replace("$dddd", n).replace("$ddd", t).replace("$MMMM", l.indexOf("$MMMM") > 0 ? i.toLowerCase() : i).replace("$MMM", l.indexOf("$MMM") > 0 ? s.toLowerCase() : s).replace("$MM", u.toString().padStart(2, "0")).replace("$M", u.toString()).replace("$YYYY", this.getFullYear().toString()).replace("$YY", this.getFullYear().toString().slice(-2)).replace("$hh", jt() === "en" ? this.toLocaleTimeString("en").split(":")[0].toString().padStart(2, "0") : this.getHours().toString().padStart(2, "0")).replace("$h", jt() === "en" ? this.toLocaleTimeString("en").split(":")[0].toString() : this.getHours().toString()).replace("$mm", this.getMinutes().toString().padStart(2, "0")).replace("$m", this.getMinutes().toString()).replace("$ss", this.getSeconds().toString().padStart(2, "0")).replace("$s", this.getSeconds().toString()).replace("$A", jt() === "en" ? this.getHours() >= 12 ? "PM" : "AM" : "").replace("$a", jt() === "en" ? this.getHours() >= 12 ? "pm" : "am" : "");
  }
  /**
   * @desc returns the date, with the time set to midnight
   * @desc/fr returns the date, with the time set to midnight
   * @return Date
   */
  toMidnight() {
    const l = new Date(this);
    return l.setHours(0, 0, 0, 0), l;
  }
  /**
   * @desc returns the date with the time set to 23:59:999
   * @return Date
   */
  toEndOfDay() {
    const l = new Date(this);
    return l.setHours(23, 59, 59, 999), l;
  }
}
class J3 extends Number {
  constructor(l) {
    super(l);
  }
  /**
   * @desc converts the number to hours and minutes
   * @param {string} [separator=':'] separator between hours and minutes
   * @return string
   */
  toHoursMinutes(l = ":") {
    const n = this % 1;
    return `${String(this - n).padStart(2, "0")}${l}${String(Math.round(n * 60)).padStart(2, "0")}`;
  }
  /**
   * @desc converts the number to a string with separator between thousands and decimals
   * @param {string} [thousands=' '] pattern of the string
   * @param {string} [decimal=','] pattern of the string
   * @return string
   */
  withDelimiters(l = " ", n = ",") {
    const t = this.toString().split(".");
    return t[0] = t[0].replace(/\B(?=(\d{3})+(?!\d))/g, l), t.join(n);
  }
  /**
   * @desc returns the number with two numbers of digits after the decimal point and with the currency
   * @param {string} [currency=' €'] currency symbol
   * @return string
   */
  toCurrency(l = " €") {
    const n = X(Number(this.toFixed(2))).withDelimiters().split(",");
    return n[1] && n[1].length === 1 ? n[1] += "0" : n.length === 1 && n.push("00"), n.join(",") + l;
  }
  /**
   * @desc return a decimal value of the number with the precision given in parameter
   * @param {number} [precision=2] precision
   * @return number
   */
  decimal(l = 2) {
    return Number(this.toFixed(l));
  }
}
class Z3 extends String {
  constructor(l) {
    super(l);
  }
  /**
   * @desc convertst the string to a JSON value
   * @return string
   */
  toPost() {
    return JSON.stringify(this);
  }
  /**
   * @desc convert the string to a new Date and return its .toReadable(pattern)
   * @param {string} pattern pattern of the date string
   * @param { } MoreInfos check the Date.toReadable() method above
   * @return string
   */
  toReadableDate(l) {
    return isNaN(new Date(this).getDate()) ? (console.error(`String.toReadableDate()
Invalid date string detected : ${this}`), this) : X(new Date(this)).toReadable(l);
  }
  /**
   * @desc insert the string given in parameters into the original string
   * @param {string} string string to insert
   * @param {number} [index=0] index when the string will be inserted
   * @param {boolean} [replace=false] if set, the character on the original string at the position of the given index will be replaced by the inserted string
   * @return string
   */
  insert(l, n = 0, t = !1) {
    const u = t ? 1 : 0;
    return n > 0 ? this.substring(0, n) + l + this.substr(n + u) : n < 0 ? this.substr(0, this.length + n - u) + l + this.substring(this.length, this.length + n) : l + this;
  }
  /**
   * @desc adds the plural to the string if the quantity is greater than 1
   * @param {number} quantity quantity of the word
   * @param {boolean} [quantityIncluded=true] if set to true, the quantity will be added at the begining of the string
   * @return string
   */
  pluralize(l, n = !0) {
    return l >= 2 || l <= -2 ? Ae(this, l, n) : n ? `${l} ${this}` : this;
  }
  /**
   * @desc returns a hashCode of the string
   * @return number
   */
  hashCode() {
    return [...this].reduce((l, n) => Math.imul(31, l) + n.charCodeAt(0) | 0, 0);
  }
  /**
   * @desc highlights in the string, the term given in parameter
   * @param {string} valueToMark the term to mark
   * @return string
   */
  mark(l) {
    if (!l || !(l != null && l.length))
      return this;
    const n = "<mark>$1</mark>", t = new RegExp(`(${dw(l)})`, "gmi");
    return this.replace(t, n);
  }
  /**
   * @desc return a preview of the string with the given character length and an ellipsis if necessary
   * @param {number} charLength the length of the preview
   * @param {string} [ellipsis='...'] the ellipsis
   * @return string
   */
  preview(l, n = "...") {
    return this.length <= l ? this.toString() : this.slice(0, l - n.length) + n;
  }
}
class Js {
  static Array(...l) {
    return new q3(...l);
  }
  static Date(l) {
    return new Zo(l);
  }
  static Number(l) {
    return new J3(l);
  }
  static String(l) {
    return new Z3(l);
  }
}
function X(e) {
  if (Il(e))
    return Js.Array(...e);
  if (gw(e))
    return Js.Date(e);
  if (typeof e == "number")
    return Js.Number(e);
  if (typeof e == "string")
    return Js.String(e);
}
function LS() {
  const e = Object.getPrototypeOf(new q3());
  Object.getOwnPropertyNames(e).filter((o) => o !== "constructor").forEach((o) => {
    Object.defineProperty(Array.prototype, o, {
      value: e[o]
    });
  });
  const n = Object.getPrototypeOf(new Zo(/* @__PURE__ */ new Date()));
  Object.getOwnPropertyNames(n).filter((o) => o !== "constructor").forEach((o) => {
    Object.defineProperty(Date.prototype, o, {
      value: n[o]
    });
  });
  const u = Object.getPrototypeOf(new J3(0));
  Object.getOwnPropertyNames(u).filter((o) => o !== "constructor").forEach((o) => {
    Object.defineProperty(Number.prototype, o, {
      value: u[o]
    });
  });
  const s = Object.getPrototypeOf(new Z3(""));
  Object.getOwnPropertyNames(s).filter((o) => o !== "constructor").forEach((o) => {
    Object.defineProperty(String.prototype, o, {
      value: s[o]
    });
  }), Dn.orion("MonkeyPatching activated");
}
class X3 {
  constructor(l) {
    S(this, "entity", fl({}));
    l && this.assignData(l);
  }
  assignData(l) {
    Object.assign(this.entity, l);
  }
  resetData() {
    this.entity = fl({});
  }
}
class Zi extends X3 {
  get isRead() {
    return this.entity.isRead;
  }
  set isRead(l) {
    this.entity.isRead = l;
  }
  get id() {
    return this.entity.id;
  }
  get isFromUser() {
    return this.entity.author.id === this.discussion.chat.userId;
  }
  get isReadByUser() {
    return this.isFromUser ? !0 : this.isRead;
  }
  get author() {
    return this.entity.author;
  }
  get createdDate() {
    return this.entity.createdDate;
  }
  get createdReadableDate() {
    return X(this.entity.createdDate).toReadable("$hh:$mm");
  }
  get content() {
    return this.entity.content;
  }
  get isLastRead() {
    var l, n;
    if (this.discussion.messages)
      return ((n = X((l = this.discussion) == null ? void 0 : l.messages.filter((t) => t.isRead).sort((t, u) => t.id - u.id)).last()) == null ? void 0 : n.id) === this.id;
  }
  constructor(l, n, t = !0) {
    super(l), this.discussion = n, t && this.discussion.registerChatMessageEntity(this);
  }
  setId(l) {
    this.entity.id = l;
  }
  read() {
    this.entity.isRead = !0;
  }
}
var V0;
function PS() {
  function e(a, d) {
    return function(h) {
      (function(p, f) {
        if (p.v)
          throw new Error("attempted to call addInitializer after decoration was finished");
      })(d), t(h, "An initializer"), a.push(h);
    };
  }
  function l(a, d) {
    if (!a(d))
      throw new TypeError("Attempted to access private element on non-instance");
  }
  function n(a, d, h, p, f, m, g, v, w) {
    var $;
    switch (f) {
      case 1:
        $ = "accessor";
        break;
      case 2:
        $ = "method";
        break;
      case 3:
        $ = "getter";
        break;
      case 4:
        $ = "setter";
        break;
      default:
        $ = "field";
    }
    var _, b, k = { kind: $, name: g ? "#" + d : BS(d), static: m, private: g }, T = { v: !1 };
    if (f !== 0 && (k.addInitializer = e(p, T)), g || f !== 0 && f !== 2)
      if (f === 2)
        _ = function(x) {
          return l(w, x), h.value;
        };
      else {
        var M = f === 0 || f === 1;
        (M || f === 3) && (_ = g ? function(x) {
          return l(w, x), h.get.call(x);
        } : function(x) {
          return h.get.call(x);
        }), (M || f === 4) && (b = g ? function(x, P) {
          l(w, x), h.set.call(x, P);
        } : function(x, P) {
          h.set.call(x, P);
        });
      }
    else
      _ = function(x) {
        return x[d];
      }, f === 0 && (b = function(x, P) {
        x[d] = P;
      });
    var H = g ? w.bind() : function(x) {
      return d in x;
    };
    k.access = _ && b ? { get: _, set: b, has: H } : _ ? { get: _, has: H } : { set: b, has: H };
    try {
      return a(v, k);
    } finally {
      T.v = !0;
    }
  }
  function t(a, d) {
    if (typeof a != "function")
      throw new TypeError(d + " must be a function");
  }
  function u(a, d) {
    var h = typeof d;
    if (a === 1) {
      if (h !== "object" || d === null)
        throw new TypeError("accessor decorators must return an object with get, set, or init properties or void 0");
      d.get !== void 0 && t(d.get, "accessor.get"), d.set !== void 0 && t(d.set, "accessor.set"), d.init !== void 0 && t(d.init, "accessor.init");
    } else if (h !== "function")
      throw new TypeError((a === 0 ? "field" : a === 10 ? "class" : "method") + " decorators must return a function or void 0");
  }
  function i(a) {
    return function(d) {
      a(this, d);
    };
  }
  function s(a, d, h, p, f, m, g, v, w) {
    var $, _, b, k, T, M, H, x, P = h[0];
    if (g ? (f === 0 || f === 1 ? ($ = { get: (T = h[3], function() {
      return T(this);
    }), set: i(h[4]) }, b = "get") : f === 3 ? ($ = { get: h[3] }, b = "get") : f === 4 ? ($ = { set: h[3] }, b = "set") : $ = { value: h[3] }, f !== 0 && (f === 1 && j0($.set, "#" + p, "set"), j0($[b || "value"], "#" + p, b))) : f !== 0 && ($ = Object.getOwnPropertyDescriptor(d, p)), f === 1 ? k = { get: $.get, set: $.set } : f === 2 ? k = $.value : f === 3 ? k = $.get : f === 4 && (k = $.set), typeof P == "function")
      (M = n(P, p, $, v, f, m, g, k, w)) !== void 0 && (u(f, M), f === 0 ? _ = M : f === 1 ? (_ = M.init, H = M.get || k.get, x = M.set || k.set, k = { get: H, set: x }) : k = M);
    else
      for (var Z = P.length - 1; Z >= 0; Z--) {
        var F;
        (M = n(P[Z], p, $, v, f, m, g, k, w)) !== void 0 && (u(f, M), f === 0 ? F = M : f === 1 ? (F = M.init, H = M.get || k.get, x = M.set || k.set, k = { get: H, set: x }) : k = M, F !== void 0 && (_ === void 0 ? _ = F : typeof _ == "function" ? _ = [_, F] : _.push(F)));
      }
    if (f === 0 || f === 1) {
      if (_ === void 0)
        _ = function(ll, Y) {
          return Y;
        };
      else if (typeof _ != "function") {
        var el = _;
        _ = function(ll, Y) {
          for (var Q = Y, dl = 0; dl < el.length; dl++)
            Q = el[dl].call(ll, Q);
          return Q;
        };
      } else {
        var al = _;
        _ = function(ll, Y) {
          return al.call(ll, Y);
        };
      }
      a.push(_);
    }
    f !== 0 && (f === 1 ? ($.get = k.get, $.set = k.set) : f === 2 ? $.value = k : f === 3 ? $.get = k : f === 4 && ($.set = k), g ? f === 1 ? (a.push(function(ll, Y) {
      return k.get.call(ll, Y);
    }), a.push(function(ll, Y) {
      return k.set.call(ll, Y);
    })) : f === 2 ? a.push(k) : a.push(function(ll, Y) {
      return k.call(ll, Y);
    }) : Object.defineProperty(d, p, $));
  }
  function r(a, d, h) {
    for (var p, f, m, g = [], v = /* @__PURE__ */ new Map(), w = /* @__PURE__ */ new Map(), $ = 0; $ < d.length; $++) {
      var _ = d[$];
      if (Array.isArray(_)) {
        var b, k, T = _[1], M = _[2], H = _.length > 3, x = T >= 5, P = h;
        if (x ? (b = a, (T -= 5) != 0 && (k = f = f || []), H && !m && (m = function(el) {
          return HS(el) === a;
        }), P = m) : (b = a.prototype, T !== 0 && (k = p = p || [])), T !== 0 && !H) {
          var Z = x ? w : v, F = Z.get(M) || 0;
          if (F === !0 || F === 3 && T !== 4 || F === 4 && T !== 3)
            throw new Error("Attempted to decorate a public method/accessor that has the same name as a previously decorated public method/accessor. This is not currently supported by the decorators plugin. Property name was: " + M);
          !F && T > 2 ? Z.set(M, T) : Z.set(M, !0);
        }
        s(g, b, _, M, T, x, H, k, P);
      }
    }
    return o(g, p), o(g, f), g;
  }
  function o(a, d) {
    d && a.push(function(h) {
      for (var p = 0; p < d.length; p++)
        d[p].call(h);
      return h;
    });
  }
  return function(a, d, h, p) {
    return { e: r(a, d, p), get c() {
      return function(f, m) {
        if (m.length > 0) {
          for (var g = [], v = f, w = f.name, $ = m.length - 1; $ >= 0; $--) {
            var _ = { v: !1 };
            try {
              var b = m[$](v, { kind: "class", name: w, addInitializer: e(g, _) });
            } finally {
              _.v = !0;
            }
            b !== void 0 && (u(10, b), v = b);
          }
          return [v, function() {
            for (var k = 0; k < g.length; k++)
              g[k].call(v);
          }];
        }
      }(a, h);
    } };
  };
}
function Q3(e, l, n, t) {
  return (Q3 = PS())(e, l, n, t);
}
function BS(e) {
  var l = FS(e, "string");
  return typeof l == "symbol" ? l : String(l);
}
function FS(e, l) {
  if (typeof e != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var t = n.call(e, l || "default");
    if (typeof t != "object")
      return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (l === "string" ? String : Number)(e);
}
function j0(e, l, n) {
  typeof l == "symbol" && (l = (l = l.description) ? "[" + l + "]" : "");
  try {
    Object.defineProperty(e, "name", { configurable: !0, value: n ? n + " " + l : l });
  } catch {
  }
  return e;
}
function HS(e) {
  if (Object(e) !== e)
    throw TypeError("right-hand side of 'in' should be an object, got " + (e !== null ? typeof e : "null"));
  return e;
}
const T1 = class T1 extends X3 {
  constructor(n, t) {
    var u;
    super(n);
    S(this, "state", V0(this, {
      hidden: !1,
      initialLoad: !1,
      fullyLoaded: !1,
      messages: /* @__PURE__ */ new Map(),
      lastMessage: void 0
    }));
    this.chat = t, (u = n.messages) == null || u.forEach((i) => this.registerChatMessageEntity(new Zi(i, this))), n.lastMessage && (this.state.lastMessage = new Zi(n.lastMessage, this));
  }
  get initialLoad() {
    return this.state.initialLoad;
  }
  set initialLoad(n) {
    this.state.initialLoad = n;
  }
  get fullyLoaded() {
    return this.state.fullyLoaded;
  }
  set fullyLoaded(n) {
    this.state.fullyLoaded = n;
  }
  get hidden() {
    return this.state.hidden;
  }
  set hidden(n) {
    this.state.hidden = n;
  }
  get id() {
    return this.entity.id;
  }
  get messages() {
    return [...this.state.messages.values()];
  }
  get title() {
    return this.chat.config.discussionTitleFormatter ? this.chat.config.discussionTitleFormatter(this) : this.interlocutors.map((n) => n.name).join(", ");
  }
  get interlocutors() {
    return this.chat.config.discussionInterlocutorsFormatter ? this.chat.config.discussionInterlocutorsFormatter(this) : this.entity.participants.filter((n) => n.id !== this.chat.userId).slice(0, 3);
  }
  get participants() {
    return this.entity.participants;
  }
  get lastMessage() {
    return this.state.lastMessage;
  }
  get unreadMessagesCount() {
    return this.chat.config.discussionUnreadMessagesCounter ? this.chat.config.discussionUnreadMessagesCounter({
      discussion: this,
      discussionId: this.id,
      messages: this.messages
    }) : this.messages.length ? this.messages.filter((n) => !n.isReadByUser).length : this.lastMessage ? this.lastMessage.isReadByUser ? 0 : 1 : 0;
  }
  get createdDate() {
    return this.entity.createdDate;
  }
  get updatedDate() {
    return this.entity.updatedDate;
  }
  async fetchMessagesAsync() {
    await this.chat.fetchMessagesAsync(this.id);
  }
  addMessages(n) {
    this.chat.addMessagesToDiscussions(n);
  }
  getMessageEntity(n) {
    return this.state.messages.get(n);
  }
  setLastMessage(n) {
    this.state.lastMessage = n;
  }
  setLastMessageFromRegistered() {
    const n = X(this.messages.sort((t, u) => t.createdDate.valueOf() - u.createdDate.valueOf())).last();
    n && this.setLastMessage(n);
  }
  getDiscussionDays(n) {
    return y3(this.messages.filter((t) => {
      var u;
      return n ? (u = t.content) == null ? void 0 : u.toLowerCase().includes(n) : !0;
    }).sort((t, u) => t.id - u.id), (t) => X(t.createdDate).toMidnight().valueOf());
  }
  registerChatMessageEntity(n) {
    this.state.messages.set(n.id, n);
  }
  async addNewMessageAsync(n) {
    await this.chat.addNewMessageAsync(this.id, n);
  }
};
[V0] = Q3(T1, [[wf, 0, "state"]], []).e;
let Rr = T1;
var U0;
function zS() {
  function e(a, d) {
    return function(h) {
      (function(p, f) {
        if (p.v)
          throw new Error("attempted to call addInitializer after decoration was finished");
      })(d), t(h, "An initializer"), a.push(h);
    };
  }
  function l(a, d) {
    if (!a(d))
      throw new TypeError("Attempted to access private element on non-instance");
  }
  function n(a, d, h, p, f, m, g, v, w) {
    var $;
    switch (f) {
      case 1:
        $ = "accessor";
        break;
      case 2:
        $ = "method";
        break;
      case 3:
        $ = "getter";
        break;
      case 4:
        $ = "setter";
        break;
      default:
        $ = "field";
    }
    var _, b, k = { kind: $, name: g ? "#" + d : VS(d), static: m, private: g }, T = { v: !1 };
    if (f !== 0 && (k.addInitializer = e(p, T)), g || f !== 0 && f !== 2)
      if (f === 2)
        _ = function(x) {
          return l(w, x), h.value;
        };
      else {
        var M = f === 0 || f === 1;
        (M || f === 3) && (_ = g ? function(x) {
          return l(w, x), h.get.call(x);
        } : function(x) {
          return h.get.call(x);
        }), (M || f === 4) && (b = g ? function(x, P) {
          l(w, x), h.set.call(x, P);
        } : function(x, P) {
          h.set.call(x, P);
        });
      }
    else
      _ = function(x) {
        return x[d];
      }, f === 0 && (b = function(x, P) {
        x[d] = P;
      });
    var H = g ? w.bind() : function(x) {
      return d in x;
    };
    k.access = _ && b ? { get: _, set: b, has: H } : _ ? { get: _, has: H } : { set: b, has: H };
    try {
      return a(v, k);
    } finally {
      T.v = !0;
    }
  }
  function t(a, d) {
    if (typeof a != "function")
      throw new TypeError(d + " must be a function");
  }
  function u(a, d) {
    var h = typeof d;
    if (a === 1) {
      if (h !== "object" || d === null)
        throw new TypeError("accessor decorators must return an object with get, set, or init properties or void 0");
      d.get !== void 0 && t(d.get, "accessor.get"), d.set !== void 0 && t(d.set, "accessor.set"), d.init !== void 0 && t(d.init, "accessor.init");
    } else if (h !== "function")
      throw new TypeError((a === 0 ? "field" : a === 10 ? "class" : "method") + " decorators must return a function or void 0");
  }
  function i(a) {
    return function(d) {
      a(this, d);
    };
  }
  function s(a, d, h, p, f, m, g, v, w) {
    var $, _, b, k, T, M, H, x, P = h[0];
    if (g ? (f === 0 || f === 1 ? ($ = { get: (T = h[3], function() {
      return T(this);
    }), set: i(h[4]) }, b = "get") : f === 3 ? ($ = { get: h[3] }, b = "get") : f === 4 ? ($ = { set: h[3] }, b = "set") : $ = { value: h[3] }, f !== 0 && (f === 1 && W0($.set, "#" + p, "set"), W0($[b || "value"], "#" + p, b))) : f !== 0 && ($ = Object.getOwnPropertyDescriptor(d, p)), f === 1 ? k = { get: $.get, set: $.set } : f === 2 ? k = $.value : f === 3 ? k = $.get : f === 4 && (k = $.set), typeof P == "function")
      (M = n(P, p, $, v, f, m, g, k, w)) !== void 0 && (u(f, M), f === 0 ? _ = M : f === 1 ? (_ = M.init, H = M.get || k.get, x = M.set || k.set, k = { get: H, set: x }) : k = M);
    else
      for (var Z = P.length - 1; Z >= 0; Z--) {
        var F;
        (M = n(P[Z], p, $, v, f, m, g, k, w)) !== void 0 && (u(f, M), f === 0 ? F = M : f === 1 ? (F = M.init, H = M.get || k.get, x = M.set || k.set, k = { get: H, set: x }) : k = M, F !== void 0 && (_ === void 0 ? _ = F : typeof _ == "function" ? _ = [_, F] : _.push(F)));
      }
    if (f === 0 || f === 1) {
      if (_ === void 0)
        _ = function(ll, Y) {
          return Y;
        };
      else if (typeof _ != "function") {
        var el = _;
        _ = function(ll, Y) {
          for (var Q = Y, dl = 0; dl < el.length; dl++)
            Q = el[dl].call(ll, Q);
          return Q;
        };
      } else {
        var al = _;
        _ = function(ll, Y) {
          return al.call(ll, Y);
        };
      }
      a.push(_);
    }
    f !== 0 && (f === 1 ? ($.get = k.get, $.set = k.set) : f === 2 ? $.value = k : f === 3 ? $.get = k : f === 4 && ($.set = k), g ? f === 1 ? (a.push(function(ll, Y) {
      return k.get.call(ll, Y);
    }), a.push(function(ll, Y) {
      return k.set.call(ll, Y);
    })) : f === 2 ? a.push(k) : a.push(function(ll, Y) {
      return k.call(ll, Y);
    }) : Object.defineProperty(d, p, $));
  }
  function r(a, d, h) {
    for (var p, f, m, g = [], v = /* @__PURE__ */ new Map(), w = /* @__PURE__ */ new Map(), $ = 0; $ < d.length; $++) {
      var _ = d[$];
      if (Array.isArray(_)) {
        var b, k, T = _[1], M = _[2], H = _.length > 3, x = T >= 5, P = h;
        if (x ? (b = a, (T -= 5) != 0 && (k = f = f || []), H && !m && (m = function(el) {
          return US(el) === a;
        }), P = m) : (b = a.prototype, T !== 0 && (k = p = p || [])), T !== 0 && !H) {
          var Z = x ? w : v, F = Z.get(M) || 0;
          if (F === !0 || F === 3 && T !== 4 || F === 4 && T !== 3)
            throw new Error("Attempted to decorate a public method/accessor that has the same name as a previously decorated public method/accessor. This is not currently supported by the decorators plugin. Property name was: " + M);
          !F && T > 2 ? Z.set(M, T) : Z.set(M, !0);
        }
        s(g, b, _, M, T, x, H, k, P);
      }
    }
    return o(g, p), o(g, f), g;
  }
  function o(a, d) {
    d && a.push(function(h) {
      for (var p = 0; p < d.length; p++)
        d[p].call(h);
      return h;
    });
  }
  return function(a, d, h, p) {
    return { e: r(a, d, p), get c() {
      return function(f, m) {
        if (m.length > 0) {
          for (var g = [], v = f, w = f.name, $ = m.length - 1; $ >= 0; $--) {
            var _ = { v: !1 };
            try {
              var b = m[$](v, { kind: "class", name: w, addInitializer: e(g, _) });
            } finally {
              _.v = !0;
            }
            b !== void 0 && (u(10, b), v = b);
          }
          return [v, function() {
            for (var k = 0; k < g.length; k++)
              g[k].call(v);
          }];
        }
      }(a, h);
    } };
  };
}
function lv(e, l, n, t) {
  return (lv = zS())(e, l, n, t);
}
function VS(e) {
  var l = jS(e, "string");
  return typeof l == "symbol" ? l : String(l);
}
function jS(e, l) {
  if (typeof e != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var t = n.call(e, l || "default");
    if (typeof t != "object")
      return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (l === "string" ? String : Number)(e);
}
function W0(e, l, n) {
  typeof l == "symbol" && (l = (l = l.description) ? "[" + l + "]" : "");
  try {
    Object.defineProperty(e, "name", { configurable: !0, value: n ? n + " " + l : l });
  } catch {
  }
  return e;
}
function US(e) {
  if (Object(e) !== e)
    throw TypeError("right-hand side of 'in' should be an object, got " + (e !== null ? typeof e : "null"));
  return e;
}
const WS = {
  user: void 0,
  allowDiscussionSearch: !0,
  discussionSearchTimer: 500,
  allowDiscussionCreation: !0,
  allowMessageStatus: !0,
  messageFetcherAsync: async () => [],
  onActiveDiscussionChange: () => null,
  onMessageReadAsync: () => null,
  onNewMessageAsync: () => null
}, O1 = class O1 {
  constructor(l) {
    S(this, "id", ft());
    S(this, "bus", Ri());
    S(this, "state", U0(this, {
      activeDiscussionId: void 0,
      discussionsFullyLoaded: !1,
      registry: /* @__PURE__ */ new Map()
    }));
    this.config = {
      ...WS,
      ...l
    };
  }
  get activeDiscussionId() {
    return this.state.activeDiscussionId;
  }
  set activeDiscussionId(l) {
    const n = this.state.activeDiscussionId;
    this.state.activeDiscussionId = l, this.config.onActiveDiscussionChange(l, n);
  }
  get discussionsFullyLoaded() {
    return this.state.discussionsFullyLoaded;
  }
  set discussionsFullyLoaded(l) {
    this.state.discussionsFullyLoaded = l;
  }
  get userId() {
    return this.config.user.id;
  }
  get discussions() {
    return [...this.registry.values()].filter((l) => !l.hidden);
  }
  get registry() {
    return this.state.registry;
  }
  // #region Discussions
  async fetchDiscussionsAsync(l, n) {
    var r, o;
    if (!this.config.discussionFetcherAsync)
      return;
    const t = X(this.discussions).mapKey("id"), u = (r = X([...this.discussions].sort((a, d) => a.id - d.id)).first()) == null ? void 0 : r.id, i = (o = X([...this.discussions].sort((a, d) => (a.updatedDate ?? 0).valueOf() - (d.updatedDate ?? 0).valueOf())).first()) == null ? void 0 : o.updatedDate, s = await this.config.discussionFetcherAsync({
      oldestDiscussionId: u,
      oldestDiscussionUpdatedDate: i,
      searchTerm: l,
      searchTermHasChanged: n
    });
    n ? (this.discussions.forEach((a) => a.hidden = !!(l != null && l.length)), s.forEach((a) => {
      const d = this.registry.get(a.id);
      d ? d.hidden = !1 : this.addDiscussion(a);
    })) : s.filter((a) => !t.includes(a.id)).forEach((a) => this.addDiscussion(a));
  }
  getDiscussion(l) {
    return this.registry.get(l);
  }
  deleteDiscussion(l) {
    this.state.registry.delete(l);
  }
  getActiveDiscussion() {
    if (this.state.activeDiscussionId)
      return this.getDiscussion(this.state.activeDiscussionId);
  }
  setDiscussions(l) {
    l.forEach((n) => this.registerDiscussionEntity(new Rr(n, this)));
  }
  addDiscussion(l) {
    this.registerDiscussionEntity(new Rr(l, this));
  }
  registerDiscussionEntity(l) {
    this.state.registry.set(l.id, l);
  }
  registerBubbleEntity(l, n) {
    var t;
    (t = this.registry.get(n)) == null || t.registerChatMessageEntity(l);
  }
  setDiscussionsFullyLoaded(l) {
    this.discussionsFullyLoaded = l;
  }
  // #endregion
  // #region Messages
  async fetchMessagesAsync(l) {
    var t;
    const n = this.getDiscussion(l);
    if (n && !n.fullyLoaded) {
      const u = (t = X(n.messages.sort((s, r) => s.id - r.id)).first()) == null ? void 0 : t.id, i = await this.config.messageFetcherAsync({
        discussion: n,
        discussionId: l,
        oldestMessageId: u
      });
      i != null && i.length ? i.filter((s) => !X(n.messages).mapKey().includes(s.id)).forEach((s) => new Zi(s, n)) : n.fullyLoaded = !0;
    }
  }
  getMessage(l, n) {
    var t;
    return (t = this.getDiscussion(l)) == null ? void 0 : t.getMessageEntity(n);
  }
  setMessageRead(l, n) {
    const t = this.getMessage(l, n);
    t && (t.read(), this.config.onMessageReadAsync(t));
  }
  addMessagesToDiscussions(l) {
    const n = y3(l, "discussionId");
    Object.keys(n).forEach((t) => {
      const u = this.getDiscussion(+t);
      u && (l.forEach((i) => new Zi(i, u)), u.setLastMessageFromRegistered(), this.bus.emit("message-added", u.id));
    });
  }
  async addNewMessageAsync(l, n) {
    if (!(n != null && n.trim().length))
      return;
    const t = this.getDiscussion(l);
    if (!t)
      return;
    const u = new Zi({
      id: ft(),
      discussionId: l,
      isRead: !1,
      content: n,
      createdDate: /* @__PURE__ */ new Date(),
      author: this.config.user
    }, t, !1);
    await this.config.onNewMessageAsync(u, () => t.registerChatMessageEntity(u)), t.setLastMessage(u);
  }
  // #endregion
};
[U0] = lv(O1, [[wf, 0, "state"]], []).e;
let eh = O1;
function TB(e) {
  return new eh(e);
}
class th extends gl {
  constructor(n, t) {
    super(n);
    S(this, "state", fl({
      isCollapsed: !1
    }));
    S(this, "_content", J());
    S(this, "_details", J());
    this.emits = t;
  }
  get isCollapsed() {
    return this.state.isCollapsed;
  }
  onMounted() {
    var n;
    this.state.isCollapsed = this.props.collapsed, (n = this._details.value) == null || n.addEventListener("toggle", () => {
      var t, u;
      this.state.isCollapsed = !((t = this._details.value) != null && t.open), this.emits("update:collapsed", !((u = this._details.value) != null && u.open)), rl(() => {
        var i;
        return (i = this._content.value) == null ? void 0 : i.classList.toggle("orion-section__content--collasped");
      });
    });
  }
}
S(th, "props", {
  // @doc props/gap define the space with the previous sibling `<o-section>`
  // @doc/fr props/gap définit l'écart avec la `<o-section>` voisine précédente
  gap: {
    type: String,
    default: "md"
  },
  // @doc props/align alignment of inside elements (convenient for buttons)
  // @doc/fr props/align alignement des éléments à l'intérieur (pratique pour les boutons)
  align: {
    type: String,
    default: void 0,
    validator: (n) => ["left", "center", "right", "stretch"].includes(n)
  },
  // @doc props/title title of the section
  // @doc/fr props/title titre de la section
  title: {
    type: String,
    default: void 0
  },
  // @doc props/subtitle subtitle of the section
  // @doc/fr props/subtitle sous-titre de la section
  subtitle: {
    type: String,
    default: void 0
  },
  // @doc props/collapsible defines if the section can be collapsed
  // @doc/fr props/collapsible définit si la section peut se rétracter
  collapsible: {
    type: Boolean,
    default: !1
  },
  // @doc props/collapsed if the prop `collapsible` is set to `true`, defines this initial state
  // @doc/fr props/collapsed si la prop `collapsible` est à `true`, déinit l'état initial
  collapsed: {
    type: Boolean,
    default: !1
  }
});
const GS = {
  key: 0,
  class: "orion-section__title"
}, KS = {
  key: 1,
  class: "orion-section__subtitle"
}, YS = {
  key: 0,
  class: "orion-section__actions"
}, nv = /* @__PURE__ */ K({
  __name: "OrionSection",
  props: th.props,
  emits: ["update:collapsed"],
  setup(e, {
    expose: l,
    emit: n
  }) {
    const t = n, u = e, i = new th(u, t);
    return l(i.publicInstance), (s, r) => (y(), L(Vn(s.collapsible ? "details" : "section"), {
      ref: c(i)._details,
      open: !s.collapsed,
      class: z(["orion-section", `orion-section--${c(i).props.gap}`])
    }, {
      default: U(() => [c(i).props.title || c(i).props.subtitle || s.$slots.actions ? (y(), L(Vn(s.collapsible ? "summary" : "div"), {
        key: 0,
        class: z(["orion-section__header", [c(i).props.collapsible ? "orion-section__header--collapsible" : null]])
      }, {
        default: U(() => [A("div", null, [c(i).props.title ? (y(), O("h3", GS, [$l(B(c(i).props.title) + " ", 1), s.collapsible ? (y(), L(Ml, {
          key: 0,
          icon: c(i).isCollapsed ? "chevron_down" : "chevron_up",
          class: "orion-section__title-chevron"
        }, null, 8, ["icon"])) : I("", !0)])) : I("", !0), c(i).props.subtitle ? (y(), O("h4", KS, B(c(i).props.subtitle), 1)) : I("", !0)]), s.$slots.actions ? (y(), O("div", YS, [V(s.$slots, "actions")])) : I("", !0)]),
        _: 3
      }, 8, ["class"])) : I("", !0), A("div", {
        ref: c(i)._content,
        class: z(["orion-section__content", [c(i).props.align ? "orion-section__content--align" : void 0, c(i).props.align ? `orion-section__content--align-${c(i).props.align}` : void 0]])
      }, [V(s.$slots, "default")], 2)]),
      _: 3
    }, 8, ["open", "class"]));
  }
}), za = {
  install(e, l = "o") {
    e.component(`${tl(l)}Section`, nv);
  }
};
class uh extends uu {
  constructor(n, t) {
    super(n);
    S(this, "name", "OrionModal");
    S(this, "_prompt", J());
    S(this, "options", fl({
      ...this.baseOptions,
      title: null
    }));
    this.emit = t, Object.assign(this.options, n.options);
  }
  get promptFieldComponent() {
    if (this.prompt)
      return `orion-${this.prompt.type}`;
  }
  get prompt() {
    return this.options.prompt;
  }
  get slotFooter() {
    return `#OrionModal-${this.uid}__footer`;
  }
  get publicInstance() {
    return {
      ...super.publicInstance,
      slotFooter: this.slotFooter
    };
  }
  async animateAsync(n) {
    return new Promise(async (t) => {
      var u, i, s, r;
      n ? (console.log("🚀  enter:", n), console.log(this.visible), this.state.visible = !0, console.log(this.visible), await ((i = (u = Fl.popableAnimationHooks).modalEnterBefore) == null ? void 0 : i.call(u, this.publicInstance)), El({
        targets: this._el.value,
        opacity: [0, 1],
        translateY: [-300, 0],
        duration: 600,
        easing: "easeOutCubic",
        begin: async () => {
          var o, a;
          await ((a = (o = Fl.popableAnimationHooks).modalEnterStart) == null ? void 0 : a.call(o, this.publicInstance)), this.emit("enter-start"), this.trigger("enter-start");
        },
        complete: async () => {
          var o, a;
          await ((a = (o = Fl.popableAnimationHooks).modalEnterEnd) == null ? void 0 : a.call(o, this.publicInstance)), t(), this.promptAutoFocus(), this.emit("enter-end"), this.trigger("enter-end");
        }
      })) : (await ((r = (s = Fl.popableAnimationHooks).modalLeaveBefore) == null ? void 0 : r.call(s, this.publicInstance)), El({
        targets: this._el.value,
        opacity: 0,
        translateY: 300,
        duration: 300,
        easing: "easeOutCubic",
        begin: async () => {
          var o, a;
          await ((a = (o = Fl.popableAnimationHooks).modalLeaveStart) == null ? void 0 : a.call(o, this.publicInstance)), this.emit("leave-start"), this.trigger("leave-start");
        },
        complete: async () => {
          var o, a;
          this.state.visible = !1, await ((a = (o = Fl.popableAnimationHooks).modalLeaveEnd) == null ? void 0 : a.call(o, this.publicInstance)), t(), this.emit("leave-end"), this.trigger("leave-end");
        }
      }));
    });
  }
  handlePromptEnter(n) {
    var t, u;
    (((t = this.prompt) == null ? void 0 : t.type) === "input" || ((u = this.prompt) == null ? void 0 : u.type) === "password") && (n.preventDefault(), this.emit("confirm"), this.trigger("confirm"));
  }
  actionCallback(n) {
    typeof n.callback == "function" && (this.prompt ? n.callback(this.publicInstance, this.prompt) : n.callback(this.publicInstance));
  }
  promptAutoFocus() {
    var n, t;
    this._prompt.value && ((n = this.prompt) != null && n.type) && ((t = this._prompt.value) == null || t.focus());
  }
}
S(uh, "props", {
  ...uu.props,
  // @doc props/options options of the modal
  // @doc/fr props/options options de la modal
  options: {
    type: Object,
    default: () => {
    }
  }
});
const qS = ["id", "open"], JS = ["id"], ZS = {
  key: 0,
  class: "orion-modal__actions"
}, XS = {
  class: "orion-modal__body"
}, QS = ["innerHTML"], lC = {
  components: {
    OrionInput: hu(() => import("./OrionInput-zUx8aWF-.js")),
    OrionTextarea: hu(() => import("./OrionTextarea-Cw97hZi1.js")),
    OrionPassword: hu(() => import("./OrionPassword-RmJD_2BC.js")),
    OrionDatepicker: hu(() => import("./OrionDatepicker-DPhnZqeE.js")),
    OrionSelect: hu(() => import("./OrionSelect-U4_EylZT.js")),
    OrionPhone: hu(() => import("./OrionPhone-O0489bqt.js")),
    OrionUpload: hu(() => import("./OrionUpload-Be-GqAov.js"))
  }
}, ev = /* @__PURE__ */ K({
  ...lC,
  __name: "OrionModal",
  props: uh.props,
  emits: ["enter-start", "enter-end", "leave-start", "leave-end", "cancel", "confirm"],
  setup(e, {
    expose: l,
    emit: n
  }) {
    const t = n, u = e, i = new uh(u, t);
    return De("_modal", i.publicInstance), l(i.publicInstance), (s, r) => {
      var o, a;
      return y(), L(Wp, {
        to: "#orion-popable-wrapper",
        disabled: c(i).options.programmatic
      }, [A("dialog", {
        id: `OrionModal-${c(i).uid}`,
        ref: c(i)._el,
        style: Wl(c(i).domStyle),
        class: z(["orion-modal", [c(i).options.customClass, `orion-modal--${c(i).options.size}`, {
          "orion-modal--visible": c(i).visible
        }]]),
        open: c(i).visible
      }, [A("div", {
        id: `OrionModal-${c(i).uid}__footer`,
        class: "orion-modal__footer"
      }, [(a = (o = s.options) == null ? void 0 : o.actions) != null && a.length ? (y(), O("div", ZS, [(y(!0), O(hl, null, Sl(s.options.actions, (d, h) => (y(), L(c(bl), ml({
        key: h
      }, d, {
        onClick: (p) => c(i).actionCallback(d)
      }), {
        default: U(() => [$l(B(d.label), 1)]),
        _: 2
      }, 1040, ["onClick"]))), 128))])) : I("", !0), V(s.$slots, "footer", {
        close: c(i).close.bind(c(i))
      })], 8, JS), A("div", XS, [R(c(nv), {
        title: c(i).options.title
      }, {
        default: U(() => {
          var d;
          return [c(i).options.message ? (y(), O("div", {
            key: 0,
            class: "orion-modal__message",
            innerHTML: c(i).options.message
          }, null, 8, QS)) : I("", !0), (d = c(i).prompt) != null && d.type ? (y(), L(Vn(c(i).promptFieldComponent), ml({
            key: 1,
            ref: c(i)._prompt,
            modelValue: c(i).prompt.value,
            "onUpdate:modelValue": r[0] || (r[0] = (h) => c(i).prompt.value = h)
          }, c(i).prompt.fieldProps, {
            onSubmit: r[1] || (r[1] = (h) => c(i).trigger("confirm")),
            onKeydown: r[2] || (r[2] = Fn(kl((h) => c(i).handlePromptEnter(h), ["stop"]), ["enter"]))
          }), null, 16, ["modelValue"])) : I("", !0), c(i).options.Nested && c(i).isMounted ? (y(), L(Vn(c(i).options.Nested), ml({
            key: 2,
            class: "orion-modal__nested"
          }, c(i).options.NestedProps), null, 16)) : I("", !0), V(s.$slots, "default", {
            close: c(i).close.bind(c(i))
          })];
        }),
        _: 3
      }, 8, ["title"])]), c(i).options.hideClose ? I("", !0) : (y(), O("span", {
        key: 0,
        class: "orion-modal__close",
        onClick: r[3] || (r[3] = (d) => c(i).close({
          keepInQueue: !1
        })),
        onTouchend: r[4] || (r[4] = kl((d) => c(i).close({
          keepInQueue: !1
        }), ["prevent", "stop"]))
      }, null, 32)), R(c(te), {
        ref: c(i)._loader
      }, null, 512)], 14, qS)], 8, ["disabled"]);
    };
  }
}), Va = {
  install(e, l = "o") {
    e.component(`${tl(l)}Modal`, ev);
  }
};
class nC extends Sf {
  constructor(n) {
    super(n);
    S(this, "nameForDevtool", "OrionModal");
  }
  createVNode() {
    var i, s, r;
    const n = ye(ev, {
      options: this.options
    });
    n.appContext = Fl.appContext;
    const t = (i = Ul()) == null ? void 0 : i.createElement("div");
    if (t) {
      t.id = `OrionModal-wrapper-${this.options.uid}`;
      const o = (s = Ul()) == null ? void 0 : s.getElementById("orion-popable-wrapper");
      o ? o.appendChild(t) : (r = Ul()) == null || r.body.appendChild(t), fi(n, t), this.registerComponentInstanceInDevtool(n);
    }
    return an().getInstance(this.options.uid);
  }
}
function tv(e) {
  return new nC(e).createVNode();
}
class eC {
  constructor(l, n) {
    S(this, "escapeEventUid", ft());
    this.message = l, this.options = n, this.setGlobalEventListener();
  }
  setGlobalEventListener() {
    nn("keydown", (l) => {
      l.key === "Escape" ? (this.modal.close(), this.resolve(!1), nn(this.escapeEventUid)) : l.key === "Enter" && (this.modal.close(), this.resolve(!0), nn(this.escapeEventUid));
    }, {
      uid: this.escapeEventUid
    });
  }
  async openConfirmModalAsync() {
    return new Promise((l) => {
      this.resolve = l, this.modal = tv({
        title: ul().USE_CONFIRM__TITLE,
        message: this.message,
        hideClose: !0,
        hideOnOverlayClick: !1,
        hideOnEsc: !1,
        size: "xs",
        actions: [{
          color: "success",
          label: ul().CONFIRM,
          autofocus: !0,
          callback: (n) => {
            n.close(), l(!0), nn(this.escapeEventUid);
          }
        }, {
          color: "danger",
          label: ul().CANCEL,
          outline: !0,
          callback: (n) => {
            n.close(), l(!1), nn(this.escapeEventUid);
          }
        }],
        ...this.options
      });
    });
  }
}
function tC(e, l) {
  return new eC(e, l).openConfirmModalAsync();
}
class uC {
  /**
   * @desc returns all the countries objects
   * @type {object}
   * @return Orion.Country[]
   */
  get countries() {
    return ul().countries;
  }
  /**
  * @desc returns the country related to the code given in parameter
  * @param {string} code  the code of the country
  * @return Orion.Country | undefined
  */
  getCountryByCode(l) {
    return this.countries.find((n) => n.code === l);
  }
  /**
  * @desc returns the country related to the area code given in parameter
  * @param {string} areaCode the areaCode of the country
  * @return Orion.Country | undefined
  */
  getCountryByAreaCode(l) {
    return this.countries.find((n) => n.areaCode === l);
  }
}
const iC = new uC();
function Fi() {
  return iC;
}
class sC {
  constructor() {
    S(this, "bus", Ri());
    S(this, "registry", fl({
      get isDragging() {
        return this.cursor.x !== null && this.cursor.y !== null;
      },
      cursor: {
        x: null,
        y: null
      },
      items: []
    }));
  }
  registerDrag(l) {
    this.registry.items.push(l);
  }
  emitDrop() {
    this.bus.emit("drop", X(this.registry.items).last());
  }
  emitDragStart() {
    this.bus.emit("dragStart", X(this.registry.items).last());
  }
  emitDragEnd() {
    this.bus.emit("dragEnd", X(this.registry.items).last());
  }
  emitDragLeave() {
    this.bus.emit("dragLeave", X(this.registry.items).last());
  }
  cleanRegistry() {
    this.registry.cursor.x = null, this.registry.cursor.y = null, ow(this.registry.items, (l, n) => {
      l.to === null && this.registry.items.splice(n, 1);
    });
  }
}
const rC = new sC();
function Cf() {
  return rC;
}
class oC {
  constructor() {
    S(this, "state", fl({
      eventListenerAdded: !1,
      lastClickPosition: {
        x: 0,
        y: 0
      }
    }));
    var l;
    Dn.orion("MouseService activated"), (l = qn()) == null || l.addEventListener("mousedown", (n) => {
      this.setLastClickPosition(n.clientX, n.clientY);
    });
  }
  get lastClickPosition() {
    return this.state.lastClickPosition;
  }
  setLastClickPosition(l, n) {
    this.state.lastClickPosition.x = l, this.state.lastClickPosition.y = n;
  }
}
const aC = new oC();
function OB() {
  return aC;
}
class ih extends uu {
  constructor(n, t) {
    super(n);
    S(this, "name", "OrionNotif");
    S(this, "_timerProgress", J());
    S(this, "options", fl({
      ...this.baseOptions,
      overlay: !1,
      title: null
    }));
    S(this, "timerValue", J());
    this.emit = t, Object.assign(this.options, n.options);
  }
  get timer() {
    return this.timerValue.value;
  }
  get publicInstance() {
    return {
      ...super.publicInstance,
      resetTimer: this.resetTimer.bind(this)
    };
  }
  onMounted() {
    super.onMounted(), this.handleTimer();
  }
  async animateAsync(n) {
    return new Promise(async (t) => {
      var u, i, s, r;
      if (n === this.state.visible) {
        t();
        return;
      }
      n ? (this.state.visible = !0, await ((i = (u = Fl.popableAnimationHooks).notifEnterBefore) == null ? void 0 : i.call(u, this.publicInstance)), El({
        targets: this._el.value,
        opacity: [0, 1],
        translateY: [200, 0],
        duration: 600,
        easing: "easeOutCubic",
        begin: async () => {
          var o, a;
          await ((a = (o = Fl.popableAnimationHooks).notifEnterStart) == null ? void 0 : a.call(o, this.publicInstance)), this.emit("enter-start"), this.trigger("enter-start"), this.props.options.duration && (this.timerInterval = setInterval(() => {
            this.timerValue.value && (this.timerValue.value--, this.timerValue.value || (setTimeout(() => this.close(), 500), this.timerInterval && clearInterval(this.timerInterval)));
          }, 1e3));
        },
        complete: async () => {
          var o, a;
          await ((a = (o = Fl.popableAnimationHooks).notifEnterEnd) == null ? void 0 : a.call(o, this.publicInstance)), t(), this.emit("enter-end"), this.trigger("enter-end");
        }
      })) : (await ((r = (s = Fl.popableAnimationHooks).notifLeaveBefore) == null ? void 0 : r.call(s, this.publicInstance)), El({
        targets: this._el.value,
        opacity: 0,
        translateY: 200,
        duration: 500,
        easing: "easeOutCubic",
        begin: async () => {
          var o, a;
          await ((a = (o = Fl.popableAnimationHooks).notifLeaveStart) == null ? void 0 : a.call(o, this.publicInstance)), this.emit("leave-start"), this.trigger("leave-start");
        },
        complete: async () => {
          var o, a;
          this.state.visible = !1, await ((a = (o = Fl.popableAnimationHooks).notifLeaveEnd) == null ? void 0 : a.call(o, this.publicInstance)), t(), this.emit("leave-end"), this.trigger("leave-end");
        }
      }));
    });
  }
  handleTimer() {
    this.props.options.duration && (this.timerValue.value = this.props.options.duration);
  }
  showTimer() {
    return !In(this.timer);
  }
  resetTimer() {
    this._timerProgress.value && (this._timerProgress.value.style.animationName = "none"), this.timerValue.value = this.props.options.duration, setTimeout(() => {
      this._timerProgress.value && (this._timerProgress.value.style.animationName = "scaleXtoZero");
    }, 0);
  }
}
S(ih, "props", {
  ...uu.props,
  // @doc props/options options of the notification
  options: {
    type: Object,
    default: () => {
    }
  }
});
const dC = ["id"], cC = {
  class: "orion-notif__content"
}, hC = {
  key: 0,
  class: "orion-notif__title"
}, pC = ["innerHTML"], fC = /* @__PURE__ */ A("span", {
  class: "orion-notif__timer-circle"
}, null, -1), uv = /* @__PURE__ */ K({
  __name: "OrionNotif",
  props: ih.props,
  emits: ["enter-start", "enter-end", "leave-start", "leave-end"],
  setup(e, {
    expose: l,
    emit: n
  }) {
    const t = n, u = e, i = new ih(u, t);
    return De("_notif", i.publicInstance), l(i.publicInstance), (s, r) => vl((y(), O("div", {
      id: `OrionNotif-${c(i).uid}`,
      ref: c(i)._el,
      class: z(["orion-notif", [c(i).options.customClass, `orion-notif--${c(i).options.color}`]])
    }, [R(c(Ml), ml({
      class: "orion-notif__icon"
    }, {
      icon: c(i).options.icon,
      fontIcon: c(i).options.fontIcon
    }), null, 16), A("div", cC, [c(i).options.title ? (y(), O("h5", hC, B(c(i).options.title), 1)) : I("", !0), c(i).options.Nested && c(i).isMounted ? (y(), L(Vn(c(i).options.Nested), ml({
      key: 1,
      class: "orion-modal__nested"
    }, c(i).options.NestedProps), null, 16)) : I("", !0), c(i).options.message ? (y(), O("div", {
      key: 2,
      class: "orion-notif__message",
      innerHTML: c(i).options.message
    }, null, 8, pC)) : I("", !0)]), c(i).showTimer() ? (y(), O(hl, {
      key: 0
    }, [A("span", {
      class: "orion-notif__timer",
      onClick: r[0] || (r[0] = (o) => c(i).close({
        keepInQueue: !1
      })),
      onTouchend: r[1] || (r[1] = kl((o) => c(i).close({
        keepInQueue: !1
      }), ["prevent", "stop"]))
    }, [fC, $l(" " + B(c(i).timer), 1)], 32), A("span", {
      ref: c(i)._timerProgress,
      class: "orion-notif__timer-progress orion-notif__timer-progress--animated",
      style: Wl({
        animationDuration: s.options.duration + "s"
      })
    }, null, 4)], 64)) : c(i).options.hideClose ? I("", !0) : (y(), O("span", {
      key: 1,
      class: "orion-notif__close",
      onClick: r[2] || (r[2] = (o) => c(i).close({
        keepInQueue: !1
      })),
      onTouchend: r[3] || (r[3] = kl((o) => c(i).close({
        keepInQueue: !1
      }), ["prevent", "stop"]))
    }, null, 32)), R(c(te), {
      ref: c(i)._loader
    }, null, 512)], 10, dC)), [[cn, c(i).visible]]);
  }
}), ja = {
  install(e, l = "o") {
    e.component(`${tl(l)}Notif`, uv);
  }
};
class Nt extends Sf {
  constructor(n) {
    super({
      duration: 5,
      ...n
    });
    S(this, "nameForDevtool", "OrionNotif");
  }
  createVNode() {
    var i, s, r;
    const n = ye(uv, {
      options: this.options
    });
    n.appContext = Fl.appContext;
    const t = (i = Ul()) == null ? void 0 : i.createElement("div");
    if (t) {
      t.id = `OrionNotif-wrapper-${this.options.uid}`;
      const o = (s = Ul()) == null ? void 0 : s.getElementById("orion-popable-wrapper");
      o ? o.appendChild(t) : (r = Ul()) == null || r.body.appendChild(t), fi(n, t), this.registerComponentInstanceInDevtool(n);
    }
    return an().getInstance(this.options.uid);
  }
  static sanitizeOptions(n, t) {
    return typeof n == "string" ? {
      title: n,
      message: t
    } : {
      ...n,
      message: t ?? c(n.message)
    };
  }
}
const mC = {
  info: (e, l) => new Nt({
    icon: "info",
    ...Nt.sanitizeOptions(e, l),
    color: "info"
  }).createVNode(),
  success: (e, l) => new Nt({
    icon: "check_big",
    ...Nt.sanitizeOptions(e, l),
    color: "success"
  }).createVNode(),
  warning: (e, l) => new Nt({
    icon: "triangle_warning",
    ...Nt.sanitizeOptions(e, l),
    color: "warning"
  }).createVNode(),
  danger: (e, l) => new Nt({
    icon: "stop_sign",
    ...Nt.sanitizeOptions(e, l),
    color: "danger"
  }).createVNode()
}, Dr = mC;
class gC {
  constructor(l) {
    S(this, "escapeEventUid", ft());
    S(this, "prompt", fl({
      type: "input",
      value: void 0,
      fieldProps: {},
      confirm: () => this.successCallback(),
      cancel: () => this.cancelCallback()
    }));
    var n;
    this.options = l, Object.assign(this.prompt, l == null ? void 0 : l.prompt), ((n = l == null ? void 0 : l.prompt) == null ? void 0 : n.type) === "upload" && (this.prompt.value = []), this.setGlobalEventListener();
  }
  successCallback() {
    var l, n, t;
    (n = (l = this.prompt) == null ? void 0 : l.fieldProps) != null && n.required && !((t = this.prompt) != null && t.value) || (this.modal.close(), this.resolve({
      confirm: !0,
      value: this.prompt.value,
      modal: this.modal
    }), nn(this.escapeEventUid));
  }
  cancelCallback() {
    this.modal.close(), this.resolve({
      confirm: !1,
      value: this.prompt.value,
      modal: this.modal
    }), nn(this.escapeEventUid);
  }
  setGlobalEventListener() {
    nn("keydown", (l) => {
      l.key === "Escape" && (this.modal.close(), this.cancelCallback(), nn(this.escapeEventUid));
    }, {
      uid: this.escapeEventUid
    });
  }
  async openPromptModalAsync() {
    return new Promise((l) => {
      var n;
      this.resolve = l, this.modal = tv({
        hideClose: !0,
        hideOnOverlayClick: !1,
        hideOnEsc: !1,
        customClass: "orion-modal--prompt",
        size: "xs",
        actions: [{
          color: "success",
          label: "OK",
          callback: this.successCallback.bind(this)
        }, {
          color: "danger",
          outline: !0,
          label: ul().CANCEL,
          callback: this.cancelCallback.bind(this)
        }],
        ...this.options,
        events: {
          confirm: this.successCallback.bind(this),
          cancel: this.cancelCallback.bind(this),
          ...(n = this.options) == null ? void 0 : n.events
        },
        prompt: this.prompt
      });
    });
  }
}
function Zs(e) {
  return new gC(e).openPromptModalAsync();
}
class vC {
  constructor() {
    S(this, "state", {});
    Dn.orion("TourService activated");
  }
  /**
   * @desc registers the tour in the instance
   * @param {string} name name of the tour
   * @param {Component} [tour] tour to register
   * @return object
   */
  register(l, n) {
    if (n)
      return this.state[l] = n, n;
  }
  /**
   * @desc starts the tour at the position given in parameter (0 by default)
   * @param {number} [index=0] index of the step to target
   * @return void
   */
  start(l = 0) {
    var n;
    (n = this.tour) == null || n.start(l);
  }
  /**
   * @desc stops the tour
   * @return void
   */
  stop() {
    var l;
    (l = this.tour) == null || l.stop();
  }
}
const Xs = new vC();
function kB(e, l) {
  return Xs.tour = Xs.state[e] ?? Xs.register(e, l), Xs;
}
const bn = class bn {
  constructor(l) {
    S(this, "state", fl({
      rules: []
    }));
    this.handleConstructorRules(l);
  }
  static convertToValidatorResult(l) {
    return typeof l == "object" ? l : {
      result: l,
      level: "error"
    };
  }
  handleConstructorRules(l) {
    var n;
    if (typeof l == "string") {
      const t = l == null ? void 0 : l.split("|");
      for (let u = 0; u < (t == null ? void 0 : t.length); u++) {
        const i = t[u], s = i.split(":")[0], r = ((n = i.split(":")[1]) == null ? void 0 : n.split(",")) ?? [];
        if (["passwordConfirm"].includes(s))
          throw [`
`, `"${s}" should only be used via Validator.rules.${s}().`, "Check https://orion-ui.org/services/Validation.html for more infos."].join(`
`);
        bn.rules[s] && this.state.rules.push(bn.rules[s](...r));
      }
    } else
      l && this.state.rules.push(...l);
  }
  validate(l) {
    return this.state.rules.map((n) => bn.convertToValidatorResult(n(l)));
  }
};
S(bn, "regex", {
  password: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,60}$/,
  hasLowercase: /[a-z]/,
  hasUppercase: /[A-Z]/,
  hasNumber: /[0-9]/,
  hasSpecialChar: /[^A-Za-z0-9]/,
  email: /^([a-zA-Z0-9_-]+([+.]{1}[a-zA-Z0-9_-]+)*)@([a-zA-Z0-9_-]+([.]{1}[a-zA-Z0-9_-]+)*)([.]{1}[a-zA-Z]{2,12})$/,
  phone: {
    FR: {
      default: /^([+]33|0)\d{9}$/,
      landline: /^([+]33|0)[^67]\d{8}$/,
      mobile: /^([+]33|0)[67]\d{8}$/
    }
    // @contribution Put other country validation RegExp here
  }
}), S(bn, "rules", {
  required: (l = ul().VALIDATOR_ERROR_REQUIRED) => (n) => {
    var t;
    return typeof n == "object" && "phoneCountryCode" in n && "phoneNumber" in n ? {
      result: !!((t = n == null ? void 0 : n.phoneNumber) != null && t.length),
      message: l,
      level: "error"
    } : {
      result: !!(n != null && n.toString().trim().length),
      message: l,
      level: "error"
    };
  },
  hasLowercase: (l = ul().VALIDATOR_ERROR_HAS_LOWERCASE) => (n) => ({
    result: !!(n != null && n.length) && bn.regex.hasLowercase.test(n),
    message: l,
    level: "error"
  }),
  hasUppercase: (l = ul().VALIDATOR_ERROR_HAS_UPPERCASE) => (n) => ({
    result: !!(n != null && n.length) && bn.regex.hasUppercase.test(n),
    message: l,
    level: "error"
  }),
  hasNumber: (l = ul().VALIDATOR_ERROR_HAS_NUMBER) => (n) => ({
    result: !!(n != null && n.length) && bn.regex.hasNumber.test(n),
    message: l,
    level: "error"
  }),
  hasSpecialChar: (l = ul().VALIDATOR_ERROR_HAS_SPECIAL_CHAR) => (n) => ({
    result: !!(n != null && n.length) && bn.regex.hasSpecialChar.test(n),
    message: l,
    level: "error"
  }),
  hasMinLength: (l, n = ul().VALIDATOR_ERROR_HAS_MIN_LENGTH) => (t) => ({
    result: ((t == null ? void 0 : t.length) ?? 0) >= l,
    message: n.replace("$charLength", X(ul().CHARACTER).pluralize(l)),
    level: "error"
  }),
  hasMaxLength: (l, n = ul().VALIDATOR_ERROR_HAS_MAX_LENGTH) => (t) => ({
    result: ((t == null ? void 0 : t.length) ?? 0) <= l,
    message: n.replace("$charLength", X(ul().CHARACTER).pluralize(l)),
    level: "error"
  }),
  length: (l, n, t = ul().VALIDATOR_ERROR_LENGTH) => (u) => {
    const i = l ?? 0, s = n ?? 1 / 0;
    return {
      result: ((u == null ? void 0 : u.length) ?? 0) >= i && ((u == null ? void 0 : u.length) ?? 0) <= s,
      message: s !== 1 / 0 ? t.replace("$min", i.toString()).replace("$max", s.toString()) : ul().VALIDATOR_ERROR_HAS_MIN_LENGTH.replace("$charLength", X(ul().CHARACTER).pluralize(i)),
      level: "error"
    };
  },
  phone: (l, n = ul().VALIDATOR_ERROR_PHONE) => (t) => {
    const u = t == null ? void 0 : t.phoneCountryCode;
    return u && (t != null && t.phoneNumber) && bn.regex.phone[u] ? {
      result: l === void 0 ? bn.regex.phone[u].default.test(t.phoneNumber) : l ? bn.regex.phone[u].mobile.test(t.phoneNumber) : bn.regex.phone[u].landline.test(t.phoneNumber),
      message: n,
      level: "error"
    } : {
      result: !0,
      message: n,
      level: "error"
    };
  },
  password: (l = ul().VALIDATOR_ERROR_PASSWORD) => (n) => ({
    result: !!(n != null && n.toString().trim().length) && bn.regex.password.test(n),
    message: l,
    level: "error"
  }),
  passwordConfirm: (l = "", n = ul().VALIDATOR_ERROR_PASSWORD_CONFIRM) => (t) => {
    const u = typeof l == "string" ? l : l == null ? void 0 : l();
    return {
      result: !!(u != null && u.trim().length) && !!(t != null && t.trim().length) && u === t,
      message: n,
      level: "error"
    };
  },
  email: (l = ul().VALIDATOR_ERROR_EMAIL) => (n) => ({
    result: !(n != null && n.length) || !!(n != null && n.length) && bn.regex.email.test(n),
    message: l,
    level: "error"
  })
});
let Hn = bn;
class yC {
  constructor(l, n) {
    S(this, "state", fl({
      showStatus: !1,
      componentFocusState: []
    }));
    this.objectToValidate = l, this.validatorRules = n;
  }
  checkObjectPropRule(l) {
    return typeof this.objectToValidate != "object" ? (Dn.warn("useValidation() first parameter is undefined or not an object."), !1) : !this.objectToValidate || !(l in this.objectToValidate) ? (Dn.warn(`useValidation() first parameter does not contain the property "${l.toString()}"`), !1) : this.check(this.objectToValidate[l], this.validatorRules[l]);
  }
  /**
   * @desc checks if the value verifies the rule given in parameter
   * @param {T} value value to check
   * @param {Orion.Validation.RuleResult<T>} ruleParams rule which must verify the value to pass the verification
   * @return boolean
   */
  check(l, n) {
    return typeof n == "function" ? new Hn([n]).validate(l)[0].result : typeof n == "string" ? new Hn(n).validate(l).filter((t) => t.result === !1).length === 0 : n instanceof Hn ? n.validate(l).filter((t) => t.result === !1).length === 0 : !0;
  }
  /**
   * @desc checks if the value verifies the rule given in parameter
   * @param {any} value value to check
   * @param {Orion.Validation.RuleResult<any>} ruleParams rule which must verify the value to pass the verification
   * @return boolean
   * @deprecated Use "check" method instead
   */
  checkRuleParams(l, n) {
    return this.check(l, n);
  }
  /**
   * @desc checks if the object to validate verifies all the rules.
   * @return boolean
   */
  validate() {
    for (const l in this.validatorRules)
      if (!this.checkObjectPropRule(l))
        return !1;
    return !0;
  }
  getResultForObjectPropRule(l) {
    return typeof this.objectToValidate != "object" ? [Hn.convertToValidatorResult(!1)] : !this.objectToValidate || !(l in this.objectToValidate) ? [Hn.convertToValidatorResult(!1)] : this.getResult(this.objectToValidate[l], this.validatorRules[l]);
  }
  /**
   * @desc checks if the value verifies the rule given in parameter and return its full result.
   * @param {T} value value to check
   * @param {Orion.Validation.RuleResult<T>} ruleParams rule which must verify the value to pass the verification
   * @return Orion.Validator.RuleResult[]
   */
  getResult(l, n) {
    return typeof n == "function" ? new Hn([n]).validate(l) : typeof n == "string" ? new Hn(n).validate(l) : n instanceof Hn ? n.validate(l) : [Hn.convertToValidatorResult(!0)];
  }
  /**
   * @desc checks each rule and return its result.
   * @return Orion.Validator.RuleResult[]
   */
  getResults() {
    var l;
    return this.validatorRules ? Object.fromEntries((l = Object.keys(this.validatorRules)) == null ? void 0 : l.map((n) => [n, this.getResultForObjectPropRule(n)])) : {};
  }
  /**
   * @param {string} ruleName name of the rule
   */
  rule(l) {
    var n;
    return {
      registerComponentFocusStateSetter: this.registerComponentFocusStateSetter.bind(this),
      showStatus: this.state.showStatus,
      definition: (n = this.validatorRules) == null ? void 0 : n[l],
      validate: () => this.checkObjectPropRule(l)
    };
  }
  /**
   * @desc displays the validation state
   * @return void
   */
  showValidationState() {
    this.state.showStatus = !0;
  }
  /**
   * @desc hides the validation state
   * @return void
   */
  hideValidationState() {
    this.state.showStatus = !1;
  }
  /**
   * @desc resets the validation state
   * @return void
   */
  resetValidationState() {
    this.state.showStatus = !1, this.state.componentFocusState.forEach((l) => {
      l.setHasBeenFocus(!1);
    });
  }
  /**
   * @desc this method allows the ValidationService instance to set the component's focus state, to display validation status on it
   * @param {FieldHasBeenFocusSetter} setter
   * @return void
   */
  registerComponentFocusStateSetter(l) {
    this.state.componentFocusState.push(l);
  }
}
function Ut(e, l) {
  return new yC(e, l);
}
class Gl extends gl {
  constructor(n, t) {
    super(n);
    S(this, "_input", J());
    S(this, "inputType", "input");
    S(this, "handleInputDebounce", Be((n) => {
      typeof n == "function" && n();
    }, this.props.donetyping));
    S(this, "sharedState", {
      hasBeenFocus: !1,
      isFocus: !1,
      isAutoFilled: !1
    });
    S(this, "state", fl({
      ...this.sharedState
    }));
    S(this, "isValid", wu(() => this.isValidDefault));
    S(this, "validationResults", wu(() => {
      if (typeof this.props.validation == "object") {
        if (this.props.validation.definition instanceof Hn)
          return this.props.validation.definition.validate(this.props.modelValue);
        if (typeof this.props.validation.definition == "function")
          return [Hn.convertToValidatorResult(this.props.validation.definition(this.props.modelValue))];
      } else if (typeof this.props.validation == "function")
        return [Hn.convertToValidatorResult(this.props.validation(this.props.modelValue))];
      return [];
    }));
    S(this, "blur", Be(() => {
      var n;
      this.emit("blur", new FocusEvent("blur")), (n = this._input.value) == null || n.blur();
    }, 50, {
      leading: !0,
      trailing: !1
    }));
    this.emit = t, this.props.validation && typeof this.props.validation == "object" && this.props.validation.registerComponentFocusStateSetter(this.publicInstance);
  }
  get hasValue() {
    return this.props.modelValue !== null && this.props.modelValue !== void 0 && this.props.modelValue !== "";
  }
  get isValidDefault() {
    if (In(this.props.validation))
      if (In(this.isValidCustom)) {
        if (this.props.required)
          return this.hasValue;
      } else
        return this.isValidCustom;
    else {
      if (typeof this.props.validation == "object")
        return this.props.validation.validate();
      if (typeof this.props.validation == "function")
        return Hn.convertToValidatorResult(this.props.validation(this.props.modelValue)).result;
      if (typeof this.props.validation == "string")
        return Ut().check(this.props.modelValue, this.props.validation);
      if (typeof this.props.validation == "boolean")
        return this.props.validation;
    }
    return !0;
  }
  get isValidCustom() {
  }
  get labelIsFloating() {
    return this.state.isFocus || this.hasValue || this.props.forceLabelFloating || this.state.isAutoFilled;
  }
  get validationHtmlMessages() {
    const n = this.validationResults.value.length ? this.validationResults.value.filter((t) => !t.result).filter((t) => !!t.message).map((t) => t.level === "error" ? `<div class="text--danger">${t.message}</div>` : `<div class="text--warning">${t.message}</div>`) : [];
    return this.props.validationErrorMessage && n.push(`<div class="text--danger">${this.props.validationErrorMessage}</div>`), n.join(`
`);
  }
  get showError() {
    return this.showState ? this.validationResults.value.length ? !!this.validationResults.value.filter((n) => n.level === "error" && n.result === !1).length : this.isValid.value === !1 : !1;
  }
  get showWarning() {
    return !this.showState || this.showError || this.showSuccess ? !1 : this.validationResults.value.length ? !this.showError && !!this.validationResults.value.filter((n) => n.level === "warning" && n.result === !1).length : !1;
  }
  get showSuccess() {
    return this.isValid.value && this.showState;
  }
  get showState() {
    const n = this.props.validation;
    return this.props.inheritValidationState !== void 0 ? this.props.inheritValidationState : this.state.hasBeenFocus ? !!n || this.isRequired && !this.hasValue : (n == null ? void 0 : n.showStatus) ?? !1;
  }
  get vModel() {
    return this.props.modelValue;
  }
  set vModel(n) {
    this.emit("update:modelValue", n), this.emit("input", n);
  }
  get isFocus() {
    return this.state.isFocus;
  }
  get isRequired() {
    return this.props.required || !!(typeof this.props.validation == "string" && this.props.validation.includes("required"));
  }
  get orionFieldBinding() {
    return {
      clearable: this.props.clearable,
      disabled: this.props.disabled,
      hasValue: this.hasValue,
      inputType: this.inputType,
      isFocus: this.state.isFocus,
      labelIsFloating: this.labelIsFloating,
      prefixIcon: this.props.prefixIcon,
      readonly: this.props.readonly,
      required: this.isRequired,
      showError: this.showError,
      showWarning: this.showWarning,
      showSuccess: this.showSuccess,
      size: this.props.size,
      suffixIcon: this.props.suffixIcon,
      label: this.props.label,
      prefixFontIcon: this.props.prefixFontIcon,
      suffixFontIcon: this.props.suffixFontIcon
    };
  }
  get publicInstance() {
    return {
      ...super.publicInstance,
      hasBeenFocus: () => this.state.hasBeenFocus,
      isFocus: () => this.state.isFocus,
      focus: this.focus.bind(this),
      blur: this.blur.bind(this),
      clear: this.clear.bind(this),
      setHasBeenFocus: this.setHasBeenFocus.bind(this),
      isValid: () => this.isValid.value
    };
  }
  onMounted() {
    var n;
    this.props.autofocus && this.handleAutoFocus(), (n = qn()) != null && n.chrome && setTimeout(() => {
      var t, u;
      ((u = (t = this._input.value) == null ? void 0 : t.parentElement) == null ? void 0 : u.querySelector("input:-webkit-autofill")) === this._input.value && (this.state.isAutoFilled = !0);
    }, 400);
  }
  handleAutoFocus() {
    var t, u;
    const n = (u = (t = this._input.value) == null ? void 0 : t.closest) != null && u.call(t, ".orion-aside, .orion-modal") ? 600 : 100;
    setTimeout(() => {
      this.focus();
    }, n);
  }
  focus() {
    var n;
    (n = this._input.value) == null || n.focus(), this.emit("focus", new FocusEvent("focus"));
  }
  handleFocus(n) {
    this.props.disabled || this.props.readonly || (this.state.isFocus = !0, this.props.selectOnFocus && this._input.value && this._input.value.select(), this.emit("focus", n));
  }
  handleInput(n) {
    const t = n == null ? void 0 : n.target;
    this.emit("input", t == null ? void 0 : t.value);
  }
  handleChange() {
    this.emit("change");
  }
  handleBlur(n) {
    var t, u;
    this.state.hasBeenFocus = !0, this.state.isFocus = !1, (u = (t = this._input) == null ? void 0 : t.value) == null || u.blur(), this.emit("blur", n), this.props.donetyping && this.handleInputDebounce.flush();
  }
  clear() {
    this.props.disabled || this.props.readonly || (this.emit("update:modelValue", this.props.clearToNull ? null : void 0), this.emit("input", this.props.clearToNull ? null : void 0), this.emit("change", this.props.clearToNull ? null : void 0), this.emit("clear"));
  }
  setHasBeenFocus(n) {
    this.state.hasBeenFocus = n;
  }
}
S(Gl, "props", {
  ..._l.vModel(),
  ..._l.prefixIcon(),
  ..._l.suffixIcon(),
  ..._l.size(),
  // @doc props/autofocus autofocus the field when mounted.
  // @doc/fr props/autofocus focus automatiquement le champ lorsqu'il est monté.
  autofocus: Boolean,
  // @doc props/clearable defines if the field can be cleared.
  // @doc/fr props/clearable définit si le champ peut être vidé.
  clearable: Boolean,
  // @doc props/readonly sets the field to read-only mode
  // @doc/fr props/readonly définit le champ comme étant en lecture seule
  readonly: Boolean,
  // @doc props/required sets the field required
  // @doc/fr props/required indique que le champ est obligatoire
  required: Boolean,
  // @doc props/disabled disables the field
  // @doc/fr props/disabled désactive le champ
  disabled: Boolean,
  // @doc props/selectOnFocus select the field content when focused.
  // @doc/fr props/selectOnFocus sélectionne le contenu du champ lorsqu'il est focus.
  selectOnFocus: Boolean,
  // @doc props/forceLabelFloating allows floating label
  // @doc/fr props/forceLabelFloating permet au label de se placer au dessus du champ lorsqu'il possède une valeur
  forceLabelFloating: Boolean,
  // @doc props/clearToNull sets the value to null when the field is cleared
  // @doc/fr props/clearToNull lorsque que le champ est vidé, sa valeur vaut `null`
  clearToNull: Boolean,
  // @doc props/label label of the field
  // @doc/fr props/label le label du champ
  label: {
    type: String,
    default: void 0
  },
  // @doc props/type type of the input
  // @doc/fr props/type type of the input
  type: {
    type: String,
    default: "text"
  },
  // @doc props/donetyping define the debounce duration before updating the value (useful for search field)
  // @doc/fr props/donetyping défini la durée du debounce avant de mettre à jour la valeur (utile pour les champs de recherche)
  donetyping: {
    type: Number,
    default: 0
  },
  // @doc props/validation the validation for the field
  // @doc/fr props/validation la validation du champ
  validation: {
    type: [String, Function, Object, Boolean],
    default: void 0
  },
  // @doc props/validationErrorMessage the error message displayed after input's validation.
  // @doc/fr props/validationErrorMessage le message d'erreur affiché en cas d'erreur lors de la validation
  validationErrorMessage: {
    type: String,
    default: void 0
  },
  // @doc props/inheritValidationState defines if the validation comes from its parent
  // @doc/fr props/inheritValidationState définit si la validation provient du parent
  inheritValidationState: {
    type: Boolean,
    default: void 0
  }
});
class Xi extends Gl {
  get isValidCustom() {
    if (this.props.type === "email")
      return Ut().check(this.vModel, "email");
  }
  get vModel() {
    var n, t, u;
    const l = this.props.modelValue;
    if (this.props.mask) {
      if (typeof this.props.mask == "object")
        return this.props.mask.display(l);
      if (this.props.mask === "integer" && l)
        return Math.round(Number(l));
      if (this.props.mask === "hour" && Number.isFinite(l)) {
        const i = X(Number(l)).toHoursMinutes(this.props.maskHourSeparator), s = ((n = this._input.value) == null ? void 0 : n.selectionStart) ?? 0, r = (t = this._input.value) == null ? void 0 : t.value.charAt(0), o = (u = this._input.value) == null ? void 0 : u.value.charAt(s), a = i.indexOf(this.props.maskHourSeparator), d = this.props.maskHourFormat === "24h" && Number(i.split(this.props.maskHourSeparator)[0]) > 2 && s - a <= 1;
        return s && rl(() => {
          var h, p, f, m;
          d ? (h = this._input.value) == null || h.setSelectionRange(3, 3) : o === "" && s === 1 ? (p = this._input.value) == null || p.setSelectionRange(2, 2) : r === "0" && o === this.props.maskHourSeparator || s === 2 && r === "0" && o === "0" ? (f = this._input.value) == null || f.setSelectionRange(s - 1, s - 1) : (m = this._input.value) == null || m.setSelectionRange(s, s);
        }), i;
      }
    }
    return $3(l) && this.props.maxLength ? l.slice(0, this.props.maxLength) : l;
  }
  set vModel(l) {
    this.handleInputDebounce(() => {
      var n;
      if (l = l == null ? void 0 : l.toString(), l) {
        if ((n = this.props.cleave) != null && n.phone && (l = l.replace(/\s*/g, "")), this.props.type === "email")
          l = l.normalize("NFD").replace(/[\u0300-\u036f ]/g, "");
        else if (typeof this.props.mask == "string" && ["integer", "decimal"].includes(this.props.mask) && l !== "-")
          l = l.length ? Number(l) : null;
        else if (this.props.mask === "hour") {
          if (l = Ma(l, this.props.maskHourSeparator), this.props.maskHourFormat === "24h") {
            const t = Ma("23:59");
            l = l > t ? t : l;
          }
        } else
          typeof this.props.mask == "object" && this.props.mask && (this._input.value && (this._input.value.value = String(this.props.mask.display(l))), l = typeof this.props.mask.value == "function" ? this.props.mask.value(l) : this.props.mask.display(l));
        l && this.props.maxValue && Number(l) > this.props.maxValue && (l = this.props.maxValue, this._input.value && (this._input.value.value = String(l)));
      }
      l !== this.vModel && (this.emit("update:modelValue", l), this.emit("input", l));
    });
  }
  get publicInstance() {
    return {
      ...super.publicInstance
    };
  }
  constructor(l, n) {
    super(l, n), Pl(() => l.cleave, (t) => {
      const u = this._input.value;
      u.cleave.destroy(), u.cleave = new z0(u, t ?? {});
    });
  }
  handleBlurCustom(l) {
    var n;
    (n = this._input.value) != null && n.value && this.props.minValue && Ma(this._input.value.value, this.props.maskHourSeparator) < this.props.minValue && (this.emit("update:modelValue", this.props.minValue), this.emit("input", this.props.minValue)), this.handleBlur(l);
  }
  handleKeydownGuard(l) {
    var n, t;
    if (this.props.mask) {
      const u = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"], i = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], s = ["Backspace", "Delete", "Tab"], r = [...u, ...i, ...s];
      if (l.metaKey || l.ctrlKey)
        return;
      if (this.props.mask === "integer" && (r.includes(l.key) || l.preventDefault()), this.props.mask === "decimal" && ([...r, "."].includes(l.key) || l.preventDefault(), l.key === "." && ((n = this._input.value) != null && n.value.includes(".")) && l.preventDefault(), l.key === "," && this._input.value && !this._input.value.value.includes(".") && (this._input.value.value += ".")), this.props.mask === "hour") {
        [...r, this.props.maskHourSeparator].includes(l.key) || l.preventDefault();
        const o = l.target, a = o.selectionStart ?? 0, d = o.value.indexOf(this.props.maskHourSeparator), h = o.value.split(this.props.maskHourSeparator)[0], p = o.value.split(this.props.maskHourSeparator)[1], f = (p == null ? void 0 : p.length) === 2;
        d > -1 && (l.key === this.props.maskHourSeparator && (l.preventDefault(), o.setSelectionRange(d + 1, d + 1)), u.includes(l.key) && (a - d > 2 && l.preventDefault(), a > d && (f && o.setSelectionRange(a, a + 1), a === d + 1 && (o.setSelectionRange(a, a + 2), Number(l.key) > 5 && (o.value = h + this.props.maskHourSeparator + 0, o.setSelectionRange(d + 2, d + 2))))));
      }
    }
    this.props.type === "email" && (/[.+@a-zA-Z0-9_-]/.test(l.key) || l.preventDefault(), l.key === "@" && typeof this.vModel == "string" && ((t = this.vModel) != null && t.includes("@")) && l.preventDefault());
  }
}
S(Xi, "props", {
  ...Gl.props,
  allowNegative: Boolean,
  selectOnFocus: Boolean,
  // @doc props/autocomplete provides automated assistance in filling out form field values from native html input
  // @doc/fr props/autocomplete fournit une assitance automatique de remplissage du champ
  autocomplete: {
    type: String,
    default: void 0
  },
  // @doc props/mask the mask applied on the input
  // @doc/fr props/mask masque appliqué sur le champ
  mask: {
    type: [String, Object],
    default: void 0
  },
  maskFormat: {
    type: String,
    default: void 0
  },
  // @doc props/maskHourFormat the hour format
  // @doc/fr props/maskHourFormat format de l'heure
  maskHourFormat: {
    type: String,
    default: "24h"
  },
  // @doc props/maskHourSeparator hour separator
  // @doc/fr props/maskHourSeparator sépérateur d'heures
  maskHourSeparator: {
    type: String,
    default: ":"
  },
  // @doc props/maxLength maximum length of the input
  // @doc/fr props/maxLength longueur maximum du champ
  maxLength: {
    type: Number,
    default: void 0
  },
  // @doc props/maxValue maximum value of the input
  // @doc/fr props/maxValue valeur maximale du champ
  maxValue: {
    type: Number,
    default: void 0
  },
  // @doc props/minValue minimum value of the input
  // @doc/fr props/minValue valeur minimale du champ
  minValue: {
    type: Number,
    default: void 0
  },
  cleave: {
    type: Object,
    default: void 0
  }
}), S(Xi, "cleaveDirective", {
  mounted: (l, n) => {
    n.value && (l.cleave = new z0(l, n.value ?? {}));
  },
  updated: (l) => {
    if (!l.cleave)
      return;
    const n = new Event("input", {
      bubbles: !0
    });
    l.cleave.setRawValue(l.value), l.value = l.cleave.properties.result, l.dispatchEvent(n);
  }
});
const $C = ["maxlength"], bC = ["innerHTML"], Di = /* @__PURE__ */ K({
  __name: "OrionInput",
  props: Xi.props,
  emits: ["focus", "blur", "input", "change", "update:modelValue", "clear"],
  setup(e, {
    expose: l,
    emit: n
  }) {
    const t = n, u = e, i = new Xi(u, t), s = Xi.cleaveDirective;
    return l(i.publicInstance), (r, o) => (y(), L(c(Dt), ml(c(i).orionFieldBinding, {
      onClear: o[5] || (o[5] = (a) => c(i).clear())
    }), {
      default: U(() => {
        var a;
        return [vl(A("input", ml({
          ref: c(i)._input,
          "onUpdate:modelValue": o[0] || (o[0] = (d) => c(i).vModel = d),
          class: "orion-input__input",
          maxlength: c(i).props.maxLength
        }, {
          ...r.$attrs,
          type: c(i).props.type,
          disabled: c(i).props.disabled,
          readonly: c(i).props.readonly,
          autocomplete: r.autocomplete
        }, {
          onKeydown: o[1] || (o[1] = (d) => c(i).handleKeydownGuard(d)),
          onChange: o[2] || (o[2] = (d) => c(i).handleChange()),
          onFocus: o[3] || (o[3] = (d) => c(i).handleFocus(d)),
          onBlur: o[4] || (o[4] = (d) => c(i).handleBlurCustom(d))
        }), null, 16, $C), [[Kg, c(i).vModel], [c(s), c(i).props.cleave]]), c(i).showState && (c(i).showError || c(i).showWarning) && ((a = c(i).validationHtmlMessages) != null && a.length) ? (y(), O("div", {
          key: 0,
          class: "orion-input__error-message",
          innerHTML: c(i).validationHtmlMessages
        }, null, 8, bC)) : I("", !0)];
      }),
      _: 1
    }, 16));
  }
}), Ua = {
  install(e, l = "o") {
    e.component(`${tl(l)}Input`, Di);
  }
};
class sh extends Gl {
  constructor(n, t, u, i) {
    super(n, t);
    S(this, "_input", J());
    this._modal = u, this._aside = i;
  }
  get vModel() {
    var n;
    return this.props.maxLength ? (n = this.props.modelValue) == null ? void 0 : n.slice(0, this.props.maxLength) : this.props.modelValue;
  }
  set vModel(n) {
    this.handleInputDebounce(() => {
      this.emit("update:modelValue", n), this.emit("input", n);
    });
  }
  onMounted() {
    super.onMounted(), this.setTextareaHeight(), this.Bus.on("Orion.setTextareaHeight", this.setTextareaHeight.bind(this)), rl(() => {
      this._aside && this._aside.bus.on("enter-start", this.setTextareaHeight.bind(this)), this._modal && this._modal.bus.on("enter-start", this.setTextareaHeight.bind(this));
    });
  }
  onUpdated() {
    this.setTextareaHeight();
  }
  setTextareaHeight() {
    rl(() => {
      const n = this._input.value;
      if (n) {
        n.rows = 1;
        const u = n.scrollHeight, i = Math.ceil((u - 40) / 20);
        n.rows = 1 + i;
      }
    });
  }
}
S(sh, "props", {
  ...Gl.props,
  // @doc props/showLength show input's value length
  // @doc/fr props/showLength affiche le nombre de caractères
  showLength: Boolean,
  // @doc props/maxLength maximal length of the input
  // @doc/fr props/maxLength taille maximale de l'entrée
  maxLength: {
    type: Number,
    default: void 0
  }
});
const wC = ["maxlength"], _C = {
  key: 0,
  class: "orion-input__textarea-counter"
}, SC = {
  key: 1,
  class: "orion-input__textarea-counter"
}, CC = ["innerHTML"], iv = /* @__PURE__ */ K({
  __name: "OrionTextarea",
  props: sh.props,
  emits: ["focus", "blur", "submit", "input", "change", "update:modelValue", "clear"],
  setup(e, {
    expose: l,
    emit: n
  }) {
    const t = n, u = Tn("_aside"), i = Tn("_modal"), s = e, r = new sh(s, t, i, u);
    return l(r.publicInstance), (o, a) => (y(), L(c(Dt), ml(c(r).orionFieldBinding, {
      class: ["orion-textarea", {
        "orion-textarea-max-length": c(r).props.maxLength
      }],
      onClear: a[5] || (a[5] = (d) => c(r).clear())
    }), {
      default: U(() => {
        var d, h, p;
        return [vl(A("textarea", ml({
          ref: c(r)._input,
          "onUpdate:modelValue": a[0] || (a[0] = (f) => c(r).vModel = f),
          style: {
            resize: "none"
          },
          class: "orion-input__input",
          maxlength: c(r).props.maxLength
        }, {
          ...o.$attrs,
          disabled: c(r).props.disabled,
          readonly: c(r).props.readonly
        }, {
          onKeydown: [a[1] || (a[1] = Fn(kl((f) => o.$emit("submit", c(r).vModel), ["meta"]), ["enter"])), a[2] || (a[2] = Fn(kl((f) => o.$emit("submit", c(r).vModel), ["ctrl"]), ["enter"]))],
          onFocus: a[3] || (a[3] = (f) => c(r).handleFocus(f)),
          onBlur: a[4] || (a[4] = (f) => c(r).handleBlur(f))
        }), null, 16, wC), [[cs, c(r).vModel]]), o.maxLength ? (y(), O("span", _C, B(((d = c(r).vModel) == null ? void 0 : d.length) ?? 0) + "/" + B(o.maxLength), 1)) : c(r).props.showLength ? (y(), O("span", SC, B(((h = c(r).vModel) == null ? void 0 : h.length) ?? 0), 1)) : I("", !0), c(r).showState && (c(r).showError || c(r).showWarning) && ((p = c(r).validationHtmlMessages) != null && p.length) ? (y(), O("div", {
          key: 2,
          class: "orion-input__error-message",
          innerHTML: c(r).validationHtmlMessages
        }, null, 8, CC)) : I("", !0)];
      }),
      _: 1
    }, 16, ["class"]));
  }
}), Wa = {
  install(e, l = "o") {
    e.component(`${tl(l)}Textarea`, iv);
  }
};
class rh extends gl {
  get message() {
    return this.props.message;
  }
  get messageStatusEnabled() {
    return this.props.chat.config.allowMessageStatus;
  }
  constructor(l) {
    super(l);
  }
}
S(rh, "props", {
  // @doc props/message message object
  // @doc/fr props/message Objet représentant le message
  message: {
    type: Object,
    required: !0
  },
  // @doc props/discussion the discussion related to the message
  // @doc/fr props/discussion discussion relative au message
  discussion: {
    type: Object,
    required: !0
  },
  // @doc props/chat instance of the chat
  // @doc/fr props/chat instance du service `chat`
  chat: {
    type: Object,
    required: !0
  }
});
const TC = ["data-chat-message-id", "data-chat-message-author-id"], OC = {
  class: "orion-chat-message__wrapper"
}, kC = {
  class: "orion-chat-message__data"
}, MC = {
  key: 0,
  class: "orion-chat-message__author"
}, AC = {
  key: 1,
  class: "orion-chat-message__author"
}, xC = {
  class: "orion-chat-message__message"
}, EC = {
  key: 0,
  class: "orion-chat-message__status"
}, sv = /* @__PURE__ */ K({
  __name: "OrionChatMessage",
  props: rh.props,
  setup(e, {
    expose: l
  }) {
    const n = e, t = new rh(n);
    return l(t.publicInstance), (u, i) => {
      var s, r, o, a, d;
      return c(t).message ? (y(), O("div", {
        key: 0,
        class: z(["orion-chat-message", {
          "orion-chat-message--from-user": c(t).message.isFromUser,
          "orion-chat-message--from-interlocutor": !c(t).message.isFromUser,
          "orion-chat-message--is-read": !!c(t).message.isReadByUser,
          "orion-chat-message--is-unread": !c(t).message.isReadByUser
        }]),
        "data-chat-message-id": c(t).message.id,
        "data-chat-message-author-id": c(t).message.author.id
      }, [A("div", OC, [R(c(Jo), ml({
        class: "orion-chat-message__avatar"
      }, {
        ...(s = c(t).message) == null ? void 0 : s.author,
        ...(r = c(t).message) == null ? void 0 : r.author.avatarProps
      }, {
        size: "sm"
      }), null, 16), A("div", kC, [(o = c(t).message) != null && o.isFromUser ? (y(), O("div", AC, B(c(t).message.createdReadableDate), 1)) : (y(), O("div", MC, B((a = c(t).message) == null ? void 0 : a.author.name) + " • " + B(c(t).message.createdReadableDate), 1)), A("div", xC, B((d = c(t).message) == null ? void 0 : d.content), 1)])]), c(t).messageStatusEnabled && c(t).message.isFromUser && (c(t).message.isLastRead && c(t).message.isRead || !u.message.isRead) ? (y(), O("div", EC, B(c(t).message.isRead ? c(t).lang.ORION_CHAT_MESSAGE__READ : c(t).lang.ORION_CHAT_MESSAGE__DELIVERED), 1)) : I("", !0)], 10, TC)) : I("", !0);
    };
  }
}), Ga = {
  install(e, l = "o") {
    e.component(`${tl(l)}ChatMessage`, sv);
  }
};
class oh extends gl {
  constructor(n, t) {
    super(n);
    S(this, "observer", null);
    S(this, "state", fl({
      preventScroll: !1,
      isLoading: !1,
      searchTerm: void 0,
      unreadTop: 0,
      unreadBottom: 0,
      newMessage: null,
      showSearch: !1
    }));
    S(this, "_input", J());
    S(this, "_content", J());
    S(this, "_lazyLoader", J());
    S(this, "_sectionsWrapper", J());
    S(this, "_search", J());
    this.emit = t, Pl(() => this.props.discussionId, () => {
      rl(() => {
        var u;
        this.scrollToBottom(), this.fetchMessagesAsync(), this.props.focusOnOpen && ((u = this._input.value) == null || u.focus());
      });
    });
  }
  get chat() {
    return this.props.chat;
  }
  get discussion() {
    return this.chat.getDiscussion(this.props.discussionId);
  }
  get hideSearch() {
    return this.props.hideSearch;
  }
  get showSearch() {
    return this.state.showSearch;
  }
  get unreadMessageLabel() {
    return Ae(this.lang.ORION_CHAT__UNREAD_MESSAGE, this.state.unreadTop, !0);
  }
  get newMessageLabel() {
    return Ae(this.lang.ORION_CHAT__NEW_MESSAGE, this.state.unreadBottom, !0);
  }
  get unreadTop() {
    return this.state.unreadTop;
  }
  get unreadBottom() {
    return this.state.unreadBottom;
  }
  get isLoading() {
    return this.state.isLoading;
  }
  get textareaLabel() {
    var n;
    return (n = this._input.value) != null && n.isFocus() ? this.sendTooltip : this.lang.ORION_CHAT__NEW_MESSAGE;
  }
  get showLazyLoader() {
    return this.discussion ? !this.discussion.fullyLoaded : !1;
  }
  get sendTooltip() {
    return _3() ? `⌘ + ${this.lang.ORION_CHAT__ENTER_TO_SEND}` : `CTRL + ${this.lang.ORION_CHAT__ENTER_TO_SEND}`;
  }
  get searchTerm() {
    return this.state.searchTerm;
  }
  set searchTerm(n) {
    this.state.searchTerm = n;
  }
  get newMessage() {
    return this.state.newMessage;
  }
  set newMessage(n) {
    this.state.newMessage = n;
  }
  get publicInstance() {
    return {
      ...super.publicInstance,
      checkUnreadMessagesInDom: this.checkUnreadMessagesInDom.bind(this),
      getDiscussionId: () => {
        var n;
        return (n = this.discussion) == null ? void 0 : n.id;
      }
    };
  }
  async onMounted() {
    var n;
    this.observer = new IntersectionObserver(this.intersectionObserverCallback.bind(this), {
      root: this._content.value,
      threshold: 0
    }), this.chat.bus.on("message-added", (t) => {
      t === this.props.discussionId && this.handleMessageAdded();
    }), await this.fetchMessagesAsync(), this.props.focusOnOpen && ((n = this._input.value) == null || n.focus());
  }
  getSectionTitle(n) {
    return X(new Date(Number(n))).toReadable();
  }
  async fetchMessagesAsync() {
    var t;
    const n = this.discussion;
    n && (this.state.isLoading = !0, (!n.messages.length || !n.initialLoad) && (await ((t = this.discussion) == null ? void 0 : t.fetchMessagesAsync()), n.initialLoad = !0), await this.resetIntersectionObserver(), this.scrollToLastRead(), await this.checkUnreadMessagesInDom(), this.state.isLoading = !1);
  }
  initIntersectionObserver() {
    var u, i;
    const n = (u = this._content.value) == null ? void 0 : u.querySelectorAll(".orion-chat-message--is-unread.orion-chat-message--from-interlocutor");
    n != null && n.length && [...n].forEach((s) => {
      var r;
      (r = this.observer) == null || r.observe(s);
    });
    const t = this._lazyLoader.value;
    t && ((i = this.observer) == null || i.observe(t));
  }
  intersectionObserverCallback(n, t) {
    n.forEach(async (u) => {
      var i, s;
      if (u.isIntersecting)
        if (u.target.classList.contains("orion-chat__lazy-loader")) {
          if (typeof this.chat.config.messageFetcherAsync == "function") {
            this.state.preventScroll = !0;
            const r = ((i = this._content.value) == null ? void 0 : i.scrollHeight) ?? 0, o = ((s = this._content.value) == null ? void 0 : s.scrollTop) ?? 0;
            await this.chat.fetchMessagesAsync(this.props.discussionId), rl(() => {
              setTimeout(() => {
                var h, p, f;
                const a = ((h = this._content.value) == null ? void 0 : h.scrollHeight) ?? 0, d = o + (a - r) - (((p = this._content.value) == null ? void 0 : p.offsetHeight) ?? 0) / 3;
                (f = this._content.value) == null || f.scrollTo({
                  top: d
                }), this.state.preventScroll = !1, this.initIntersectionObserver();
              }, 100);
            });
          }
        } else {
          const r = u.target, o = Number(r.dataset.chatMessageId);
          setTimeout(() => {
            this.chat.setMessageRead(this.props.discussionId, o), t.unobserve(r), this.checkUnreadMessagesInDom();
          }, 600);
        }
    });
  }
  resetIntersectionObserver() {
    return new Promise((n) => {
      var t;
      (t = this.observer) == null || t.disconnect(), rl(() => {
        this.initIntersectionObserver(), n(!0);
      });
    });
  }
  scrollToLastRead() {
    var t, u;
    if (this.state.preventScroll)
      return;
    const n = (t = this._content.value) == null ? void 0 : t.querySelectorAll(".orion-chat-message--is-unread.orion-chat-message--from-interlocutor").item(0);
    n ? (u = this._content.value) == null || u.scrollTo({
      top: n.offsetTop - 90,
      left: 0
      // behavior: 'smooth',
    }) : this.scrollToBottom();
  }
  scrollToBottom(n = !1) {
    if (this.state.preventScroll)
      return;
    const t = this._content.value, u = this._sectionsWrapper.value;
    t && u && rl(() => {
      t.scrollTo({
        top: u.offsetHeight,
        left: 0,
        behavior: n ? "smooth" : "auto"
      });
    });
  }
  checkIfShouldScroll() {
    const n = this._content.value;
    return n && n.offsetHeight + n.scrollTop > n.scrollHeight - 30;
  }
  async sendNewMessageAsync() {
    if (this.state.newMessage && this.discussion) {
      const {
        discussion: n
      } = this, t = this.state.newMessage;
      this.state.newMessage = null;
      const u = this.checkIfShouldScroll();
      await n.addNewMessageAsync(t), this.emit("new-message", {
        message: t,
        discussionId: n.id
      }), u && this.scrollToLastRead();
    }
  }
  toggleSearch() {
    this.state.showSearch ? (this.state.showSearch = !1, this.searchTerm = void 0) : (this.state.showSearch = !0, rl(() => {
      var n;
      (n = this._search.value) == null || n.focus();
    }));
  }
  handleSearchBlur() {
    var n;
    (n = this.searchTerm) != null && n.trim().length || this.toggleSearch();
  }
  handleMessageAdded() {
    this.resetIntersectionObserver(), this.checkIfShouldScroll() && this.scrollToLastRead(), this.checkUnreadMessagesInDom();
  }
  checkUnreadMessagesInDom() {
    return new Promise((n) => {
      rl(() => {
        var a, d;
        if (((a = this.discussion) == null ? void 0 : a.unreadMessagesCount) === 0) {
          this.state.unreadBottom = 0, this.state.unreadTop = 0, n();
          return;
        }
        const t = this._content.value, u = this._sectionsWrapper.value;
        if (!t || !u) {
          this.state.unreadBottom = 0, n();
          return;
        }
        const i = 30, {
          bottom: s,
          top: r
        } = t.getBoundingClientRect();
        this.state.unreadBottom = Array.from(u.querySelectorAll(".orion-chat-message--from-interlocutor.orion-chat-message--is-unread")).filter((h) => {
          const {
            top: p
          } = h.getBoundingClientRect();
          return p > s - i;
        }).length;
        const o = Array.from(u.querySelectorAll(".orion-chat-message--from-interlocutor.orion-chat-message--is-unread")).filter((h) => {
          const {
            top: p,
            bottom: f
          } = h.getBoundingClientRect();
          return p <= s - i && p >= r - i && f <= s + i && f >= r + i;
        }).length;
        this.state.unreadTop = (((d = this.discussion) == null ? void 0 : d.unreadMessagesCount) ?? 0) - o - this.state.unreadBottom, n();
      });
    });
  }
}
S(oh, "props", {
  // @doc props/hideSearch hides the research field on the top of the chat
  // @doc/fr props/hideSearch masque le champ de recherche en haut du chat
  hideSearch: Boolean,
  // @doc props/focusOnOpen focused the input field chat the chat opens
  // @doc/fr props/focusOnOpen place le focus sur la zone de texte quand le chat s'ouvre
  focusOnOpen: Boolean,
  // @doc props/chat instance of the chat service
  // @doc/fr props/chat instance du service `chat`
  chat: {
    type: Object,
    required: !0
  },
  // @doc props/discussionId id of the discussion
  // @doc/fr props/discussionId id de la discussion
  discussionId: {
    type: Number,
    required: !0
  }
});
const IC = {
  key: 0,
  class: "orion-chat"
}, RC = {
  class: "orion-chat__header"
}, DC = {
  key: 0,
  class: "orion-chat__title"
}, NC = {
  class: "orion-chat__avatars"
}, LC = {
  class: "orion-chat__interlocutors"
}, PC = {
  class: "orion-chat__actions"
}, BC = {
  key: 0,
  class: "orion-chat__unread-top"
}, FC = /* @__PURE__ */ A("span", {
  class: "arrow"
}, "➜", -1), HC = {
  class: "orion-chat__section-title"
}, zC = {
  key: 1,
  class: "orion-chat__unread-bottom"
}, VC = /* @__PURE__ */ A("span", {
  class: "arrow"
}, "➜", -1), jC = {
  key: 2,
  class: "orion-chat__content-empty"
}, UC = /* @__PURE__ */ Ps('<svg width="246px" height="170px" viewBox="0 0 246 170" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-912.000000, -388.000000)"><g transform="translate(880.000000, 388.000000)"><g transform="translate(32.000000, 0.000000)"><circle id="Oval" stroke="#717A8E" cx="138" cy="4" r="3.5"></circle><circle id="Oval-Copy-14" stroke="#2BB9A6" cx="6" cy="56" r="5.5"></circle><circle id="Oval-Copy-20" stroke="#D8D8D8" cx="33" cy="16" r="2.5"></circle><circle id="Oval-Copy-16" stroke="#717A8E" cx="244" cy="84" r="1.5"></circle><circle id="Oval-Copy-6" fill="#2BB9A6" cx="206" cy="147" r="4"></circle><circle id="Oval-Copy-18" fill="#2BB9A6" cx="206" cy="16" r="4"></circle><circle id="Oval-Copy-17" fill="#D8D8D8" cx="99" cy="22.5" r="2.5"></circle><circle id="Oval-Copy-19" stroke="#CFD4E0" cx="14" cy="126.5" r="2"></circle><rect id="Rectangle-Copy" fill="#DCDFE6" opacity="0.559593023" x="59.1944444" y="34" width="150.805556" height="92" rx="7"></rect><rect id="Rectangle-Copy" fill="#F6F7F9" x="27" y="78" width="150.805556" height="92" rx="7"></rect><rect id="Rectangle-Copy-9" fill="#2BB9A6" x="42" y="103" width="80" height="11" rx="5.5"></rect><rect id="Rectangle-Copy-12" fill="#CFD4E0" x="80" y="53" width="59" height="11" rx="5.5"></rect><rect id="Rectangle-Copy-11" fill="#DCDFE6" x="42" y="124" width="105" height="15" rx="7.5"></rect></g></g></g></g></svg>', 1), WC = {
  key: 0
}, GC = {
  key: 1
}, KC = {
  class: "orion-chat__footer"
}, YC = /* @__PURE__ */ K({
  __name: "OrionChat",
  props: oh.props,
  emits: ["new-message"],
  setup(e, {
    expose: l,
    emit: n
  }) {
    const t = e, u = n, i = new oh(t, u);
    return l(i.publicInstance), (s, r) => {
      const o = Ei("tooltip");
      return c(i).discussion ? (y(), O("div", IC, [A("div", RC, [c(i).showSearch ? I("", !0) : (y(), O("div", DC, [V(s.$slots, "discussion-title", Rl(jl({
        discussion: c(i).discussion
      })), () => [A("div", NC, [(y(!0), O(hl, null, Sl(c(i).discussion.interlocutors, (a) => (y(), L(c(Jo), ml({
        key: a.id,
        size: "sm"
      }, {
        ...a,
        ...a.avatarProps
      }), null, 16))), 128))]), A("div", LC, B(c(i).discussion.title), 1)])])), A("div", PC, [V(s.$slots, "prepend-discussion-actions", Rl(jl({
        discussion: c(i).discussion,
        showSearch: c(i).showSearch
      }))), c(i).hideSearch ? I("", !0) : (y(), O(hl, {
        key: 0
      }, [c(i).showSearch ? (y(), L(c(Di), {
        key: 0,
        ref: c(i)._search,
        modelValue: c(i).searchTerm,
        "onUpdate:modelValue": r[0] || (r[0] = (a) => c(i).searchTerm = a),
        class: "orion-chat__search",
        label: "Rechercher",
        donetyping: 300,
        clearable: "",
        onKeydownEsc: r[1] || (r[1] = (a) => c(i).toggleSearch()),
        onBlur: r[2] || (r[2] = (a) => c(i).handleSearchBlur())
      }, null, 8, ["modelValue"])) : (y(), L(c(Ml), {
        key: 1,
        icon: "search_magnifying_glass",
        ripple: "info",
        onClick: r[3] || (r[3] = (a) => c(i).toggleSearch())
      }))], 64)), V(s.$slots, "append-discussion-actions", Rl(jl({
        discussion: c(i).discussion,
        showSearch: c(i).showSearch
      })))])]), A("div", {
        ref: c(i)._content,
        class: "orion-chat__content"
      }, [c(i).showLazyLoader ? (y(), O("div", {
        key: 0,
        ref: c(i)._lazyLoader,
        class: "orion-chat__lazy-loader"
      }, [R(c(te), {
        visible: "",
        color: "info",
        size: "sm"
      })], 512)) : I("", !0), c(i).discussion.messages.length ? (y(), O("div", {
        key: 1,
        ref: c(i)._sectionsWrapper,
        class: "orion-chat__sections-wrapper"
      }, [c(i).unreadTop ? (y(), O("div", BC, [FC, $l(" " + B(c(i).unreadMessageLabel), 1)])) : I("", !0), (y(!0), O(hl, null, Sl(c(i).discussion.getDiscussionDays(c(i).searchTerm), (a, d) => (y(), O("section", {
        key: d,
        class: "orion-chat__section"
      }, [A("h4", HC, [A("span", null, B(c(i).getSectionTitle(+d)), 1)]), R(Yg, {
        name: "chat-message",
        appear: "",
        duration: 1e3
      }, {
        default: U(() => [(y(!0), O(hl, null, Sl(a, (h) => (y(), L(c(sv), ml({
          key: h.id
        }, {
          chat: c(i).props.chat,
          discussion: c(i).discussion,
          message: h
        }), null, 16))), 128))]),
        _: 2
      }, 1024)]))), 128)), c(i).unreadBottom ? (y(), O("div", zC, [VC, $l(" " + B(c(i).newMessageLabel), 1)])) : I("", !0)], 512)) : (y(), O("div", jC, [UC, c(i).isLoading ? (y(), O("h4", WC, B(c(i).lang.ORION_CHAT__LOADING_CONVERSATION), 1)) : (y(), O("h4", GC, B(c(i).lang.ORION_CHAT__START_CONVERSATION), 1))]))], 512), A("div", KC, [R(c(iv), {
        ref: c(i)._input,
        modelValue: c(i).newMessage,
        "onUpdate:modelValue": r[4] || (r[4] = (a) => c(i).newMessage = a),
        label: c(i).textareaLabel,
        class: "orion-chat__textarea",
        onSubmit: r[5] || (r[5] = (a) => c(i).sendNewMessageAsync())
      }, null, 8, ["modelValue", "label"]), vl(R(c(Ml), {
        class: "orion-chat__send",
        icon: "chat_add",
        ripple: "info",
        onClick: r[6] || (r[6] = (a) => c(i).sendNewMessageAsync())
      }, null, 512), [[o, c(i).sendTooltip]])]), R(c(te), {
        visible: c(i).isLoading,
        message: c(i).lang.ORION_CHAT__LOADING_MESSAGES
      }, null, 8, ["visible", "message"])])) : I("", !0);
    };
  }
}), Ka = {
  install(e, l = "o") {
    e.component(`${tl(l)}Chat`, YC);
  }
};
class ah extends gl {
  constructor(n, t) {
    super(n);
    S(this, "intersectionObserver");
    S(this, "state", fl({
      searchTerm: void 0,
      contentHasScroll: !0
    }));
    S(this, "_el", J());
    S(this, "_lazyLoader", J());
    S(this, "_content", J());
    this.emits = t, Pl(() => this.discussions.length, () => {
      setTimeout(this.checkContentScroll, 300), this.resetObservers();
    }), Pl(() => this.searchTerm, () => {
      this.fetchDiscussionsAsync(!0);
    });
  }
  get searchTerm() {
    return this.state.searchTerm;
  }
  set searchTerm(n) {
    this.state.searchTerm = n;
  }
  get chat() {
    return this.props.chat;
  }
  get discussions() {
    return [...this.chat.discussions].filter((n) => this.searchTerm && !this.chat.config.discussionFetcherAsync ? n.title.toLowerCase().includes(this.searchTerm.toLowerCase()) : !0).sort((n, t) => t.lastMessage && n.lastMessage ? t.lastMessage.createdDate.valueOf() - n.lastMessage.createdDate.valueOf() : 0);
  }
  get showLazyLoader() {
    return !this.discussions.length || !this.chat.config.discussionFetcherAsync ? !1 : !this.chat.discussionsFullyLoaded && this.state.contentHasScroll;
  }
  async onMounted() {
    this.chat.config.discussionFetcherAsync && (this.intersectionObserver = new IntersectionObserver(this.intersectionObserverCallback.bind(this), {
      root: this._el.value,
      threshold: 1
    }), this.initObservers());
  }
  async fetchDiscussionsAsync(n = !1) {
    this.chat.config.discussionFetcherAsync && await this.chat.fetchDiscussionsAsync(this.searchTerm, n);
  }
  intersectionObserverCallback(n) {
    n.forEach(async (t) => {
      t.isIntersecting && this.chat.config.discussionFetcherAsync && this.fetchDiscussionsAsync();
    });
  }
  initObservers() {
    var t;
    const n = this._lazyLoader.value;
    n && ((t = this.intersectionObserver) == null || t.observe(n));
  }
  resetObservers() {
    var n;
    (n = this.intersectionObserver) == null || n.disconnect(), rl(() => this.initObservers());
  }
  checkContentScroll() {
    rl(() => {
      var i, s, r, o, a, d;
      const n = ((s = (i = this._content) == null ? void 0 : i.value) == null ? void 0 : s.offsetHeight) ?? 0, t = ((o = (r = this._content) == null ? void 0 : r.value) == null ? void 0 : o.scrollHeight) ?? 0, u = (d = (a = this._lazyLoader) == null ? void 0 : a.value) == null ? void 0 : d.offsetHeight;
      u && (this.state.contentHasScroll = t - n > u);
    });
  }
  formatLastMessageDateTime(n) {
    return n.valueOf() < X(/* @__PURE__ */ new Date()).toMidnight().valueOf() ? X(n).toReadable() : X(n).toReadable("$hh:$mm");
  }
  selectDiscussion(n) {
    this.chat.activeDiscussionId = n, this.emits("select-discussion", n), this.chat.bus.emit("select-discussion", n);
  }
  createNewDiscussion() {
    this.emits("new-discussion"), this.chat.bus.emit("new-discussion");
  }
}
S(ah, "props", {
  // @doc props/chat instance of the chat service
  // @doc/fr props/chat instance du service `chat`
  chat: {
    type: Object,
    required: !0
  }
});
const qC = {
  class: "orion-chat-discussion-list"
}, JC = {
  class: "orion-chat-discussion-list__header"
}, ZC = {
  class: "orion-chat-discussion-list__subheader"
}, XC = ["onClick"], QC = {
  class: "orion-chat-discussion-list__item-content"
}, lT = ["data-count"], nT = {
  class: "orion-chat-discussion-list__item-header"
}, eT = {
  class: "orion-chat-discussion-list__item-interlocutor"
}, tT = {
  key: 0,
  class: "orion-chat-discussion-list__item-last-message-datetime"
}, uT = {
  class: "orion-chat-discussion-list__item-preview-wrapper"
}, iT = {
  key: 0,
  class: "orion-chat-discussion-list__item-preview"
}, sT = {
  key: 1,
  class: "orion-chat-discussion-list__item-unread-count"
}, rT = {
  key: 1,
  class: "orion-chat-discussion-list__content"
}, oT = {
  class: "orion-chat-discussion-list__no-discussion"
}, aT = /* @__PURE__ */ Ps('<svg width="246px" height="170px" viewBox="0 0 246 170" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-912.000000, -388.000000)"><g transform="translate(880.000000, 388.000000)"><g transform="translate(32.000000, 0.000000)"><circle id="Oval" stroke="#717A8E" cx="138" cy="4" r="3.5"></circle><circle id="Oval-Copy-14" stroke="#2BB9A6" cx="6" cy="56" r="5.5"></circle><circle id="Oval-Copy-20" stroke="#D8D8D8" cx="33" cy="16" r="2.5"></circle><circle id="Oval-Copy-16" stroke="#717A8E" cx="244" cy="84" r="1.5"></circle><circle id="Oval-Copy-6" fill="#2BB9A6" cx="206" cy="147" r="4"></circle><circle id="Oval-Copy-18" fill="#2BB9A6" cx="206" cy="16" r="4"></circle><circle id="Oval-Copy-17" fill="#D8D8D8" cx="99" cy="22.5" r="2.5"></circle><circle id="Oval-Copy-19" stroke="#CFD4E0" cx="14" cy="126.5" r="2"></circle><rect id="Rectangle-Copy" fill="#DCDFE6" opacity="0.559593023" x="59.1944444" y="34" width="150.805556" height="92" rx="7"></rect><rect id="Rectangle-Copy" fill="#F6F7F9" x="27" y="78" width="150.805556" height="92" rx="7"></rect><rect id="Rectangle-Copy-9" fill="#2BB9A6" x="42" y="103" width="80" height="11" rx="5.5"></rect><rect id="Rectangle-Copy-12" fill="#CFD4E0" x="80" y="53" width="59" height="11" rx="5.5"></rect><rect id="Rectangle-Copy-11" fill="#DCDFE6" x="42" y="124" width="105" height="15" rx="7.5"></rect></g></g></g></g></svg>', 1), dT = {
  class: "orion-chat-discussion-list__no-discussion-label"
}, cT = /* @__PURE__ */ K({
  __name: "OrionChatDiscussionList",
  props: ah.props,
  emits: ["new-discussion", "select-discussion"],
  setup(e, {
    expose: l,
    emit: n
  }) {
    const t = n, u = e, i = new ah(u, t);
    return l(i.publicInstance), (s, r) => {
      const o = Ei("tooltip");
      return y(), O("div", qC, [A("div", JC, [A("div", ZC, [(c(i).discussions.length || c(i).searchTerm) && c(i).chat.config.allowDiscussionSearch ? (y(), L(c(Di), {
        key: 0,
        modelValue: c(i).searchTerm,
        "onUpdate:modelValue": r[0] || (r[0] = (a) => c(i).searchTerm = a),
        class: "orion-chat-discussion-list__search",
        label: c(i).lang.SEARCH,
        "suffix-icon": "search_magnifying_glass",
        donetyping: c(i).chat.config.discussionSearchTimer,
        clearable: ""
      }, null, 8, ["modelValue", "label", "donetyping"])) : I("", !0), c(i).discussions.length && c(i).chat.config.allowDiscussionCreation ? vl((y(), L(c(bl), {
        key: 1,
        class: "orion-chat-discussion-list__new-discussion",
        color: "info",
        outline: "",
        "prefix-icon": "chat_conversation",
        onClick: r[1] || (r[1] = (a) => c(i).createNewDiscussion())
      }, null, 512)), [[o, c(i).lang.ORION_CHAT_DISCUSSION__LIST_NEW_CONVERSATION]]) : I("", !0)]), V(s.$slots, "append-discussion-list-header")]), V(s.$slots, "before-discussion-list"), c(i).discussions.length || c(i).searchTerm ? (y(), L(Yg, {
        key: 0,
        ref: "content",
        class: "orion-chat-discussion-list__content",
        name: "list-transitions",
        tag: "div"
      }, {
        default: U(() => [(y(!0), O(hl, null, Sl(c(i).discussions, (a) => (y(), O("div", {
          key: a.id,
          ref_for: !0,
          ref: "discussionListItem",
          class: z(["orion-chat-discussion-list__item", {
            "orion-chat-discussion-list__item--active": a.id === c(i).chat.activeDiscussionId,
            "orion-chat-discussion-list__item--unread": a.unreadMessagesCount
          }]),
          onClick: (d) => c(i).selectDiscussion(a.id)
        }, [V(s.$slots, "discussion-item", Rl(jl({
          discussion: a
        })), () => [A("div", QC, [A("div", {
          class: "orion-chat-discussion-list__item-avatars",
          "data-count": a.interlocutors.length
        }, [(y(!0), O(hl, null, Sl(a.interlocutors, (d) => (y(), L(c(Jo), ml({
          key: d.id,
          size: "sm"
        }, {
          ...d,
          ...d.avatarProps
        }), null, 16))), 128))], 8, lT), A("div", null, [A("h5", nT, [A("span", eT, B(a.title), 1), a.lastMessage ? (y(), O("span", tT, B(c(i).formatLastMessageDateTime(a.lastMessage.createdDate)), 1)) : I("", !0)]), A("div", uT, [a.lastMessage ? (y(), O("div", iT, B(a.lastMessage.content), 1)) : I("", !0), a.unreadMessagesCount ? (y(), O("span", sT, B(a.unreadMessagesCount), 1)) : I("", !0)])])])]), V(s.$slots, "append-discussion-item", Rl(jl({
          discussion: a
        })))], 10, XC))), 128)), vl(A("div", {
          ref: c(i)._lazyLoader,
          key: "lazyLoader",
          class: "orion-chat-discussion-list__lazy-loader"
        }, [R(c(te), {
          visible: "",
          color: "info",
          size: "sm"
        })], 512), [[cn, c(i).showLazyLoader]])]),
        _: 3
      }, 512)) : (y(), O("div", rT, [A("div", oT, [aT, A("div", dT, B(c(i).lang.ORION_CHAT_DISCUSSION__LIST_NO_CONVERSATION), 1), c(i).chat.config.allowDiscussionCreation ? (y(), L(c(bl), {
        key: 0,
        color: "info",
        "prefix-icon": "chat_conversation",
        onClick: r[2] || (r[2] = (a) => c(i).createNewDiscussion())
      }, {
        default: U(() => [$l(B(c(i).lang.ORION_CHAT_DISCUSSION__LIST_NEW_CONVERSATION), 1)]),
        _: 1
      })) : I("", !0)])]))]);
    };
  }
}), Ya = {
  install(e, l = "o") {
    e.component(`${tl(l)}ChatDiscussionList`, cT);
  }
};
class dh extends Gl {
  constructor(n, t) {
    super(n, t);
    S(this, "inputType", "checkbox");
  }
  get isValidCustom() {
    return this.props.required ? !!this.props.modelValue : !0;
  }
  get hasValue() {
    return Il(this.vModel) ? !!this.vModel.length : !!this.vModel;
  }
  get isChecked() {
    return this.props.multiple ? Il(this.vModel) && this.vModel.includes(this.props.inputValue) : !!this.vModel;
  }
  handleClick() {
    !this.props.disabled && !this.props.readonly && (this.state.hasBeenFocus = !0, this.props.multiple && Il(this.vModel) ? this.vModel.includes(this.props.inputValue) ? this.vModel.splice(this.vModel.indexOf(this.props.inputValue), 1) : this.vModel.push(this.props.inputValue) : this.vModel = !this.vModel, this.emit("input", this.vModel));
  }
}
S(dh, "props", {
  ...Gl.props,
  ..._l.color(),
  // @doc props/inline set the property `display` on `inline-flex` instead of `flex`
  // @doc/fr props/inline défini la propriété `display` à `inline-flex` à la place `flex`
  inline: Boolean,
  // @doc props/reverse displays the label first
  // @doc/fr props/reverse affiche d'abord le label puis la case à cocher
  reverse: Boolean,
  // @doc props/multiple allows to select multiples checkbox values, related to v-model array
  // @doc/fr props/multiple permet de selectionner plusieurs cases à cocher, dans le cas où le v-model est un tableau
  multiple: Boolean,
  // @doc props/inputValue the value of the checkbox
  // @doc/fr props/inputValue valeur de la case à cocher
  inputValue: {
    // eslint-disable-next-line max-len
    type: [String, Boolean, Number, Object, Array, Date],
    default: void 0
  },
  // @doc props/iconCheck the icon when the checkbox is checked
  // @doc/fr props/iconCheck l'icône lorsque la case est cochée
  iconCheck: {
    type: String,
    default: void 0
  },
  // @doc props/type the type of the input
  // @doc/fr props/type type du champ
  type: {
    type: String,
    default: "checkbox"
  }
});
const hT = ["value", "checked"], pT = {
  class: "orion-checkbox__check-container"
}, fT = {
  key: 1,
  viewBox: "0 0 12 10"
}, mT = /* @__PURE__ */ A("polyline", {
  points: "1.5 6 4.5 9 10.5 1"
}, null, -1), gT = [mT], vT = /* @__PURE__ */ K({
  __name: "OrionCheckbox",
  props: dh.props,
  emits: ["focus", "blur", "input", "change", "update:modelValue", "clear"],
  setup(e, {
    expose: l,
    emit: n
  }) {
    const t = n, u = e, i = new dh(u, t);
    return l(i.publicInstance), (s, r) => (y(), L(c(Dt), ml(c(i).orionFieldBinding, {
      "label-is-floating": !1,
      class: [`orion-checkbox--${c(i).props.color}`, {
        "orion-checkbox--checked": c(i).isChecked
      }, {
        "orion-checkbox--reverse": c(i).props.reverse
      }, {
        "orion-checkbox--inline": c(i).props.inline
      }],
      "input-type": "checkbox",
      onClick: r[1] || (r[1] = (o) => c(i).handleClick())
    }), {
      default: U(() => [s.label === void 0 ? V(s.$slots, "default", {
        key: 0
      }) : I("", !0), A("input", ml({
        ref: c(i)._input,
        class: "orion-checkbox__input",
        type: "checkbox",
        value: c(i).props.inputValue,
        checked: c(i).isChecked
      }, {
        ...s.$attrs,
        disabled: c(i).props.disabled
      }), null, 16, hT), A("span", pT, [c(i).props.iconCheck ? (y(), L(c(Ml), {
        key: 0,
        icon: c(i).props.iconCheck,
        onClick: r[0] || (r[0] = (o) => c(i).handleClick())
      }, null, 8, ["icon"])) : (y(), O("svg", fT, gT))])]),
      _: 3
    }, 16, ["class"]));
  }
}), qa = {
  install(e, l = "o") {
    e.component(`${tl(l)}Checkbox`, vT);
  }
};
class ch extends gl {
  constructor(l) {
    super(l);
  }
}
S(ch, "props", {
  ..._l.size(),
  ..._l.colorExtendedAndGreys(),
  // @doc props/outline Adds an outline style on the chips
  // @doc/fr props/outline modifie le style en ajoutant un contraste
  outline: Boolean,
  // @doc props/close Defines if the chips can be closed
  // @doc/fr props/close définit si le chips peut être fermée
  close: Boolean
});
const yT = {
  class: "orion-chips__main"
}, $T = {
  key: 0,
  class: "orion-chips__dual"
}, bT = {
  class: "orion-chips__dual-content"
}, wT = /* @__PURE__ */ K({
  __name: "OrionChips",
  props: ch.props,
  emits: ["close"],
  setup(e, {
    expose: l
  }) {
    const n = e, t = new ch(n);
    return l(t.publicInstance), (u, i) => (y(), O("span", {
      ref: c(t)._el,
      class: z(["orion-chips", [`orion-chips--${c(t).props.color}`, `orion-chips--${c(t).props.size}`, {
        "orion-chips--outline": c(t).props.outline
      }, {
        "orion-chips--closable": c(t).props.close
      }, {
        "orion-chips--dual": !!u.$slots.dual
      }]])
    }, [A("span", yT, [V(u.$slots, "default")]), u.$slots.dual ? (y(), O("span", $T, [A("div", bT, [V(u.$slots, "dual")])])) : I("", !0), c(t).props.close ? (y(), O("span", {
      key: 1,
      class: "orion-chips__close",
      onClick: i[0] || (i[0] = (s) => u.$emit("close")),
      onTouchend: i[1] || (i[1] = kl((s) => u.$emit("close"), ["prevent", "stop"]))
    }, null, 32)) : I("", !0)], 2));
  }
}), Ja = {
  install(e, l = "o") {
    e.component(`${tl(l)}Chips`, wT);
  }
};
/*!
  * vue-color-kit v1.0.6
  * (c) 2023 
  * @license MIT
  */
function mu(e) {
  let l = { r: 0, g: 0, b: 0, a: 1 };
  /#/.test(e) ? l = ST(e) : /rgb/.test(e) ? l = G0(e) : typeof e == "string" ? l = G0(`rgba(${e})`) : Object.prototype.toString.call(e) === "[object Object]" && (l = e);
  const { r: n, g: t, b: u, a: i } = l, { h: s, s: r, v: o } = CT(l);
  return { r: n, g: t, b: u, a: i === void 0 ? 1 : i, h: s, s: r, v: o };
}
function Tf(e) {
  const l = document.createElement("canvas"), n = l.getContext("2d"), t = e * 2;
  return l.width = t, l.height = t, n.fillStyle = "#ffffff", n.fillRect(0, 0, t, t), n.fillStyle = "#ccd5db", n.fillRect(0, 0, e, e), n.fillRect(e, e, e, e), l;
}
function hh(e, l, n, t, u, i) {
  const s = e === "l", r = l.createLinearGradient(0, 0, s ? n : 0, s ? 0 : t);
  r.addColorStop(0.01, u), r.addColorStop(0.99, i), l.fillStyle = r, l.fillRect(0, 0, n, t);
}
function _T({ r: e, g: l, b: n }, t) {
  const u = (s) => ("0" + Number(s).toString(16)).slice(-2), i = `#${u(e)}${u(l)}${u(n)}`;
  return t ? i.toUpperCase() : i;
}
function ST(e) {
  e = e.slice(1);
  const l = (n) => parseInt(n, 16) || 0;
  return {
    r: l(e.slice(0, 2)),
    g: l(e.slice(2, 4)),
    b: l(e.slice(4, 6))
  };
}
function G0(e) {
  return typeof e == "string" ? (e = (/rgba?\((.*?)\)/.exec(e) || ["", "0,0,0,1"])[1].split(","), {
    r: Number(e[0]) || 0,
    g: Number(e[1]) || 0,
    b: Number(e[2]) || 0,
    a: Number(e[3] ? e[3] : 1)
  }) : e;
}
function CT({ r: e, g: l, b: n }) {
  e = e / 255, l = l / 255, n = n / 255;
  const t = Math.max(e, l, n), u = Math.min(e, l, n), i = t - u;
  let s = 0;
  t === u ? s = 0 : t === e ? l >= n ? s = 60 * (l - n) / i : s = 60 * (l - n) / i + 360 : t === l ? s = 60 * (n - e) / i + 120 : t === n && (s = 60 * (e - l) / i + 240), s = Math.floor(s);
  let r = parseFloat((t === 0 ? 0 : 1 - u / t).toFixed(2)), o = parseFloat(t.toFixed(2));
  return { h: s, s: r, v: o };
}
var Of = K({
  props: {
    color: {
      type: String,
      default: "#000000"
    },
    hsv: {
      type: Object,
      default: null
    },
    size: {
      type: Number,
      default: 152
    }
  },
  emits: ["selectSaturation"],
  data() {
    return {
      slideSaturationStyle: {}
    };
  },
  // Can’t monitor, otherwise the color will change when you change yourself
  // watch: {
  //     color() {
  //         this.renderColor()
  //     }
  // },
  mounted() {
    this.renderColor(), this.renderSlide();
  },
  methods: {
    renderColor() {
      const e = this.$refs.canvasSaturation, l = this.size, n = e.getContext("2d");
      e.width = l, e.height = l, n.fillStyle = this.color, n.fillRect(0, 0, l, l), hh("l", n, l, l, "#FFFFFF", "rgba(255,255,255,0)"), hh("p", n, l, l, "rgba(0,0,0,0)", "#000000");
    },
    renderSlide() {
      this.slideSaturationStyle = {
        left: this.hsv.s * this.size - 5 + "px",
        top: (1 - this.hsv.v) * this.size - 5 + "px"
      };
    },
    selectSaturation(e) {
      const { top: l, left: n } = this.$el.getBoundingClientRect(), t = e.target.getContext("2d"), u = (s) => {
        let r = s.clientX - n, o = s.clientY - l;
        r < 0 && (r = 0), o < 0 && (o = 0), r > this.size && (r = this.size), o > this.size && (o = this.size), this.slideSaturationStyle = {
          left: r - 5 + "px",
          top: o - 5 + "px"
        };
        const a = t.getImageData(Math.min(r, this.size - 1), Math.min(o, this.size - 1), 1, 1), [d, h, p] = a.data;
        this.$emit("selectSaturation", { r: d, g: h, b: p });
      };
      u(e);
      const i = () => {
        document.removeEventListener("mousemove", u), document.removeEventListener("mouseup", i);
      };
      document.addEventListener("mousemove", u), document.addEventListener("mouseup", i);
    }
  }
});
const TT = { ref: "canvasSaturation" };
function OT(e, l, n, t, u, i) {
  return y(), L(
    "div",
    {
      class: "saturation",
      onMousedown: l[1] || (l[1] = kl((...s) => e.selectSaturation && e.selectSaturation(...s), ["prevent", "stop"]))
    },
    [
      R(
        "canvas",
        TT,
        null,
        512
        /* NEED_PATCH */
      ),
      R(
        "div",
        {
          style: e.slideSaturationStyle,
          class: "slide"
        },
        null,
        4
        /* STYLE */
      )
    ],
    32
    /* HYDRATE_EVENTS */
  );
}
Of.render = OT;
Of.__file = "src/color/Saturation.vue";
var kf = K({
  props: {
    hsv: {
      type: Object,
      default: null
    },
    width: {
      type: Number,
      default: 15
    },
    height: {
      type: Number,
      default: 152
    }
  },
  emits: ["selectHue"],
  data() {
    return {
      slideHueStyle: {}
    };
  },
  mounted() {
    this.renderColor(), this.renderSlide();
  },
  methods: {
    renderColor() {
      const e = this.$refs.canvasHue, l = this.width, n = this.height, t = e.getContext("2d");
      e.width = l, e.height = n;
      const u = t.createLinearGradient(0, 0, 0, n);
      u.addColorStop(0, "#FF0000"), u.addColorStop(0.17 * 1, "#FF00FF"), u.addColorStop(0.17 * 2, "#0000FF"), u.addColorStop(0.17 * 3, "#00FFFF"), u.addColorStop(0.17 * 4, "#00FF00"), u.addColorStop(0.17 * 5, "#FFFF00"), u.addColorStop(1, "#FF0000"), t.fillStyle = u, t.fillRect(0, 0, l, n);
    },
    renderSlide() {
      this.slideHueStyle = {
        top: (1 - this.hsv.h / 360) * this.height - 2 + "px"
      };
    },
    selectHue(e) {
      const { top: l } = this.$el.getBoundingClientRect(), n = e.target.getContext("2d"), t = (i) => {
        let s = i.clientY - l;
        s < 0 && (s = 0), s > this.height && (s = this.height), this.slideHueStyle = {
          top: s - 2 + "px"
        };
        const r = n.getImageData(0, Math.min(s, this.height - 1), 1, 1), [o, a, d] = r.data;
        this.$emit("selectHue", { r: o, g: a, b: d });
      };
      t(e);
      const u = () => {
        document.removeEventListener("mousemove", t), document.removeEventListener("mouseup", u);
      };
      document.addEventListener("mousemove", t), document.addEventListener("mouseup", u);
    }
  }
});
const kT = { ref: "canvasHue" };
function MT(e, l, n, t, u, i) {
  return y(), L(
    "div",
    {
      class: "hue",
      onMousedown: l[1] || (l[1] = kl((...s) => e.selectHue && e.selectHue(...s), ["prevent", "stop"]))
    },
    [
      R(
        "canvas",
        kT,
        null,
        512
        /* NEED_PATCH */
      ),
      R(
        "div",
        {
          style: e.slideHueStyle,
          class: "slide"
        },
        null,
        4
        /* STYLE */
      )
    ],
    32
    /* HYDRATE_EVENTS */
  );
}
kf.render = MT;
kf.__file = "src/color/Hue.vue";
var Mf = K({
  props: {
    color: {
      type: String,
      default: "#000000"
    },
    rgba: {
      type: Object,
      default: null
    },
    width: {
      type: Number,
      default: 15
    },
    height: {
      type: Number,
      default: 152
    }
  },
  emits: ["selectAlpha"],
  data() {
    return {
      slideAlphaStyle: {},
      alphaSize: 5
    };
  },
  watch: {
    color() {
      this.renderColor();
    },
    "rgba.a"() {
      this.renderSlide();
    }
  },
  mounted() {
    this.renderColor(), this.renderSlide();
  },
  methods: {
    renderColor() {
      const e = this.$refs.canvasAlpha, l = this.width, n = this.height, t = this.alphaSize, u = Tf(t), i = e.getContext("2d");
      e.width = l, e.height = n, i.fillStyle = i.createPattern(u, "repeat"), i.fillRect(0, 0, l, n), hh("p", i, l, n, "rgba(255,255,255,0)", this.color);
    },
    renderSlide() {
      this.slideAlphaStyle = {
        top: this.rgba.a * this.height - 2 + "px"
      };
    },
    selectAlpha(e) {
      const { top: l } = this.$el.getBoundingClientRect(), n = (u) => {
        let i = u.clientY - l;
        i < 0 && (i = 0), i > this.height && (i = this.height);
        let s = parseFloat((i / this.height).toFixed(2));
        this.$emit("selectAlpha", s);
      };
      n(e);
      const t = () => {
        document.removeEventListener("mousemove", n), document.removeEventListener("mouseup", t);
      };
      document.addEventListener("mousemove", n), document.addEventListener("mouseup", t);
    }
  }
});
const AT = { ref: "canvasAlpha" };
function xT(e, l, n, t, u, i) {
  return y(), L(
    "div",
    {
      class: "color-alpha",
      onMousedown: l[1] || (l[1] = kl((...s) => e.selectAlpha && e.selectAlpha(...s), ["prevent", "stop"]))
    },
    [
      R(
        "canvas",
        AT,
        null,
        512
        /* NEED_PATCH */
      ),
      R(
        "div",
        {
          style: e.slideAlphaStyle,
          class: "slide"
        },
        null,
        4
        /* STYLE */
      )
    ],
    32
    /* HYDRATE_EVENTS */
  );
}
Mf.render = xT;
Mf.__file = "src/color/Alpha.vue";
var Af = K({
  props: {
    color: {
      type: String,
      default: "#000000"
    },
    width: {
      type: Number,
      default: 100
    },
    height: {
      type: Number,
      default: 30
    }
  },
  data() {
    return {
      alphaSize: 5
    };
  },
  watch: {
    color() {
      this.renderColor();
    }
  },
  mounted() {
    this.renderColor();
  },
  methods: {
    renderColor() {
      const e = this.$el, l = this.width, n = this.height, t = this.alphaSize, u = Tf(t), i = e.getContext("2d");
      e.width = l, e.height = n, i.fillStyle = i.createPattern(u, "repeat"), i.fillRect(0, 0, l, n), i.fillStyle = this.color, i.fillRect(0, 0, l, n);
    }
  }
});
function ET(e, l, n, t, u, i) {
  return y(), L("canvas");
}
Af.render = ET;
Af.__file = "src/color/Preview.vue";
var xf = K({
  props: {
    suckerCanvas: {
      type: Object,
      default: null
    },
    suckerArea: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isOpenSucker: !1,
      suckerPreview: null,
      isSucking: !1
    };
  },
  watch: {
    suckerCanvas(e) {
      this.isSucking = !1, this.suckColor(e);
    }
  },
  methods: {
    openSucker() {
      this.isOpenSucker ? this.keydownHandler({ keyCode: 27 }) : (this.isOpenSucker = !0, this.isSucking = !0, this.$emit("openSucker", !0), document.addEventListener("keydown", this.keydownHandler));
    },
    keydownHandler(e) {
      e.keyCode === 27 && (this.isOpenSucker = !1, this.isSucking = !1, this.$emit("openSucker", !1), document.removeEventListener("keydown", this.keydownHandler), document.removeEventListener("mousemove", this.mousemoveHandler), document.removeEventListener("mouseup", this.mousemoveHandler), this.suckerPreview && (document.body.removeChild(this.suckerPreview), this.suckerPreview = null));
    },
    mousemoveHandler(e) {
      const { clientX: l, clientY: n } = e, { top: t, left: u, width: i, height: s } = this.suckerCanvas.getBoundingClientRect(), r = l - u, o = n - t, d = this.suckerCanvas.getContext("2d").getImageData(Math.min(r, i - 1), Math.min(o, s - 1), 1, 1);
      let [h, p, f, m] = d.data;
      m = parseFloat((m / 255).toFixed(2));
      const g = this.suckerPreview.style;
      Object.assign(g, {
        position: "absolute",
        left: l + 20 + "px",
        top: n - 36 + "px",
        width: "24px",
        height: "24px",
        borderRadius: "50%",
        border: "2px solid #fff",
        boxShadow: "0 0 8px 0 rgba(0, 0, 0, 0.16)",
        background: `rgba(${h}, ${p}, ${f}, ${m})`,
        zIndex: 95
      }), this.suckerArea.length && // @ts-ignore
      l >= this.suckerArea[0] && // @ts-ignore
      n >= this.suckerArea[1] && // @ts-ignore
      l <= this.suckerArea[2] && // @ts-ignore
      n <= this.suckerArea[3] ? g.display = "" : g.display = "none";
    },
    suckColor(e) {
      e && e.tagName !== "CANVAS" || (this.suckerPreview = document.createElement("div"), this.suckerPreview && document.body.appendChild(this.suckerPreview), document.addEventListener("mousemove", this.mousemoveHandler), document.addEventListener("mouseup", this.mousemoveHandler), e.addEventListener("click", (l) => {
        const { clientX: n, clientY: t } = l, { top: u, left: i, width: s, height: r } = e.getBoundingClientRect(), o = n - i, a = t - u, h = e.getContext("2d").getImageData(Math.min(o, s - 1), Math.min(a, r - 1), 1, 1);
        let [p, f, m, g] = h.data;
        g = parseFloat((g / 255).toFixed(2)), this.$emit("selectSucker", { r: p, g: f, b: m, a: g });
      }));
    }
  }
});
const IT = /* @__PURE__ */ R(
  "path",
  { d: "M13.1,8.2l5.6,5.6c0.4,0.4,0.5,1.1,0.1,1.5s-1.1,0.5-1.5,0.1c0,0-0.1,0-0.1-0.1l-1.4-1.4l-7.7,7.7C7.9,21.9,7.6,22,7.3,22H3.1C2.5,22,2,21.5,2,20.9l0,0v-4.2c0-0.3,0.1-0.6,0.3-0.8l5.8-5.8C8.5,9.7,9.2,9.6,9.7,10s0.5,1.1,0.1,1.5c0,0,0,0.1-0.1,0.1l-5.5,5.5v2.7h2.7l7.4-7.4L8.7,6.8c-0.5-0.4-0.5-1-0.1-1.5s1.1-0.5,1.5-0.1c0,0,0.1,0,0.1,0.1l1.4,1.4l3.5-3.5c1.6-1.6,4.1-1.6,5.8-0.1c1.6,1.6,1.6,4.1,0.1,5.8L20.9,9l-3.6,3.6c-0.4,0.4-1.1,0.5-1.5,0.1" },
  null,
  -1
  /* HOISTED */
), RT = {
  key: 1,
  class: "sucker",
  viewBox: "-16 -16 68 68",
  xmlns: "http://www.w3.org/2000/svg",
  stroke: "#9099a4"
}, DT = /* @__PURE__ */ R(
  "g",
  {
    fill: "none",
    "fill-rule": "evenodd"
  },
  [
    /* @__PURE__ */ R("g", {
      transform: "translate(1 1)",
      "stroke-width": "4"
    }, [
      /* @__PURE__ */ R("circle", {
        "stroke-opacity": ".5",
        cx: "18",
        cy: "18",
        r: "18"
      }),
      /* @__PURE__ */ R("path", { d: "M36 18c0-9.94-8.06-18-18-18" }, [
        /* @__PURE__ */ R("animateTransform", {
          attributeName: "transform",
          type: "rotate",
          from: "0 18 18",
          to: "360 18 18",
          dur: "1s",
          repeatCount: "indefinite"
        })
      ])
    ])
  ],
  -1
  /* HOISTED */
);
function NT(e, l, n, t, u, i) {
  return y(), L("div", null, [
    e.isSucking ? I("v-if", !0) : (y(), L(
      "svg",
      {
        key: 0,
        class: [{ active: e.isOpenSucker }, "sucker"],
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "-12 -12 48 48",
        onClick: l[1] || (l[1] = (...s) => e.openSucker && e.openSucker(...s))
      },
      [
        IT
      ],
      2
      /* CLASS */
    )),
    e.isSucking ? (y(), L("svg", RT, [
      DT
    ])) : I("v-if", !0)
  ]);
}
xf.render = NT;
xf.__file = "src/color/Sucker.vue";
var Ef = K({
  props: {
    name: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: ""
    }
  },
  emits: ["inputColor", "inputFocus", "inputBlur"],
  setup(e, { emit: l }) {
    return {
      modelColor: wu({
        get() {
          return e.color || "";
        },
        set(i) {
          l("inputColor", i);
        }
      }),
      handleFocus: (i) => {
        l("inputFocus", i);
      },
      handleBlur: (i) => {
        l("inputBlur", i);
      }
    };
  }
});
const LT = { class: "color-type" }, PT = { class: "name" };
function BT(e, l, n, t, u, i) {
  return y(), L("div", LT, [
    R(
      "span",
      PT,
      B(e.name),
      1
      /* TEXT */
    ),
    vl(R(
      "input",
      {
        "onUpdate:modelValue": l[1] || (l[1] = (s) => e.modelColor = s),
        class: "value",
        onFocus: l[2] || (l[2] = (...s) => e.handleFocus && e.handleFocus(...s)),
        onBlur: l[3] || (l[3] = (...s) => e.handleBlur && e.handleBlur(...s))
      },
      null,
      544
      /* HYDRATE_EVENTS, NEED_PATCH */
    ), [
      [cs, e.modelColor]
    ])
  ]);
}
Ef.render = BT;
Ef.__file = "src/color/Box.vue";
var If = K({
  name: "ColorPicker",
  props: {
    color: {
      type: String,
      default: "#000000"
    },
    colorsDefault: {
      type: Array,
      default: () => []
    },
    colorsHistoryKey: {
      type: String,
      default: ""
    }
  },
  emits: ["selectColor"],
  setup(e, { emit: l }) {
    const n = J(), t = J([]), u = J();
    e.colorsHistoryKey && localStorage && (t.value = JSON.parse(localStorage.getItem(e.colorsHistoryKey)) || []), u.value = Tf(4).toDataURL(), Ao(() => {
      i(n.value);
    });
    function i(r) {
      if (!r)
        return;
      const o = t.value || [], a = o.indexOf(r);
      a >= 0 && o.splice(a, 1), o.length >= 8 && (o.length = 7), o.unshift(r), t.value = o || [], localStorage && e.colorsHistoryKey && localStorage.setItem(e.colorsHistoryKey, JSON.stringify(o));
    }
    function s(r) {
      l("selectColor", r);
    }
    return {
      setColorsHistory: i,
      colorsHistory: t,
      color: n,
      imgAlphaBase64: u,
      selectColor: s
    };
  }
});
const FT = { class: "colors" }, HT = {
  key: 0,
  class: "colors history"
};
function zT(e, l, n, t, u, i) {
  return y(), L("div", null, [
    R("ul", FT, [
      (y(!0), L(
        hl,
        null,
        Sl(e.colorsDefault, (s) => (y(), L("li", {
          key: s,
          class: "item",
          onClick: (r) => e.selectColor(s)
        }, [
          R(
            "div",
            {
              style: { background: `url(${e.imgAlphaBase64})` },
              class: "alpha"
            },
            null,
            4
            /* STYLE */
          ),
          R(
            "div",
            {
              style: { background: s },
              class: "color"
            },
            null,
            4
            /* STYLE */
          )
        ], 8, ["onClick"]))),
        128
        /* KEYED_FRAGMENT */
      ))
    ]),
    e.colorsHistory.length ? (y(), L("ul", HT, [
      (y(!0), L(
        hl,
        null,
        Sl(e.colorsHistory, (s) => (y(), L("li", {
          key: s,
          class: "item",
          onClick: (r) => e.selectColor(s)
        }, [
          R(
            "div",
            {
              style: { background: `url(${e.imgAlphaBase64})` },
              class: "alpha"
            },
            null,
            4
            /* STYLE */
          ),
          R(
            "div",
            {
              style: { background: s },
              class: "color"
            },
            null,
            4
            /* STYLE */
          )
        ], 8, ["onClick"]))),
        128
        /* KEYED_FRAGMENT */
      ))
    ])) : I("v-if", !0)
  ]);
}
If.render = zT;
If.__file = "src/color/Colors.vue";
var oi = K({
  components: {
    Saturation: Of,
    Hue: kf,
    Alpha: Mf,
    Preview: Af,
    Sucker: xf,
    Box: Ef,
    Colors: If
  },
  emits: ["changeColor", "openSucker", "inputFocus", "inputBlur"],
  props: {
    color: {
      type: String,
      default: "#000000"
    },
    theme: {
      type: String,
      default: "dark"
    },
    suckerHide: {
      type: Boolean,
      default: !0
    },
    suckerCanvas: {
      type: null,
      default: null
    },
    suckerArea: {
      type: Array,
      default: () => []
    },
    colorsDefault: {
      type: Array,
      default: () => [
        "#000000",
        "#FFFFFF",
        "#FF1900",
        "#F47365",
        "#FFB243",
        "#FFE623",
        "#6EFF2A",
        "#1BC7B1",
        "#00BEFF",
        "#2E81FF",
        "#5D61FF",
        "#FF89CF",
        "#FC3CAD",
        "#BF3DCE",
        "#8E00A7",
        "rgba(0,0,0,0)"
      ]
    },
    colorsHistoryKey: {
      type: String,
      default: "vue-colorpicker-history"
    }
  },
  data() {
    return {
      hueWidth: 15,
      hueHeight: 152,
      previewHeight: 30,
      modelRgba: "",
      modelHex: "",
      r: 0,
      g: 0,
      b: 0,
      a: 1,
      h: 0,
      s: 0,
      v: 0
    };
  },
  computed: {
    isLightTheme() {
      return this.theme === "light";
    },
    totalWidth() {
      return this.hueHeight + (this.hueWidth + 8) * 2;
    },
    previewWidth() {
      return this.totalWidth - (this.suckerHide ? 0 : this.previewHeight);
    },
    rgba() {
      return {
        r: this.r,
        g: this.g,
        b: this.b,
        a: this.a
      };
    },
    hsv() {
      return {
        h: this.h,
        s: this.s,
        v: this.v
      };
    },
    rgbString() {
      return `rgb(${this.r}, ${this.g}, ${this.b})`;
    },
    rgbaStringShort() {
      return `${this.r}, ${this.g}, ${this.b}, ${this.a}`;
    },
    rgbaString() {
      return `rgba(${this.rgbaStringShort})`;
    },
    hexString() {
      return _T(this.rgba, !0);
    }
  },
  created() {
    Object.assign(this, mu(this.color)), this.setText(), this.$watch("rgba", () => {
      this.$emit("changeColor", {
        rgba: this.rgba,
        hsv: this.hsv,
        hex: this.modelHex
      });
    });
  },
  methods: {
    selectSaturation(e) {
      const { r: l, g: n, b: t, h: u, s: i, v: s } = mu(e);
      Object.assign(this, { r: l, g: n, b: t, h: u, s: i, v: s }), this.setText();
    },
    handleFocus(e) {
      this.$emit("inputFocus", e);
    },
    handleBlur(e) {
      this.$emit("inputBlur", e);
    },
    selectHue(e) {
      const { r: l, g: n, b: t, h: u, s: i, v: s } = mu(e);
      Object.assign(this, { r: l, g: n, b: t, h: u, s: i, v: s }), this.setText(), this.$nextTick(() => {
        this.$refs.saturation.renderColor(), this.$refs.saturation.renderSlide();
      });
    },
    selectAlpha(e) {
      this.a = e, this.setText();
    },
    inputHex(e) {
      const { r: l, g: n, b: t, a: u, h: i, s, v: r } = mu(e);
      Object.assign(this, { r: l, g: n, b: t, a: u, h: i, s, v: r }), this.modelHex = e, this.modelRgba = this.rgbaStringShort, this.$nextTick(() => {
        this.$refs.saturation.renderColor(), this.$refs.saturation.renderSlide(), this.$refs.hue.renderSlide();
      });
    },
    inputRgba(e) {
      const { r: l, g: n, b: t, a: u, h: i, s, v: r } = mu(e);
      Object.assign(this, { r: l, g: n, b: t, a: u, h: i, s, v: r }), this.modelHex = this.hexString, this.modelRgba = e, this.$nextTick(() => {
        this.$refs.saturation.renderColor(), this.$refs.saturation.renderSlide(), this.$refs.hue.renderSlide();
      });
    },
    setText() {
      this.modelHex = this.hexString, this.modelRgba = this.rgbaStringShort;
    },
    openSucker(e) {
      this.$emit("openSucker", e);
    },
    selectSucker(e) {
      const { r: l, g: n, b: t, a: u, h: i, s, v: r } = mu(e);
      Object.assign(this, { r: l, g: n, b: t, a: u, h: i, s, v: r }), this.setText(), this.$nextTick(() => {
        this.$refs.saturation.renderColor(), this.$refs.saturation.renderSlide(), this.$refs.hue.renderSlide();
      });
    },
    selectColor(e) {
      const { r: l, g: n, b: t, a: u, h: i, s, v: r } = mu(e);
      Object.assign(this, { r: l, g: n, b: t, a: u, h: i, s, v: r }), this.setText(), this.$nextTick(() => {
        this.$refs.saturation.renderColor(), this.$refs.saturation.renderSlide(), this.$refs.hue.renderSlide();
      });
    }
  }
});
const VT = { class: "color-set" };
function jT(e, l, n, t, u, i) {
  const s = Bl("Saturation"), r = Bl("Hue"), o = Bl("Alpha"), a = Bl("Preview"), d = Bl("Sucker"), h = Bl("Box"), p = Bl("Colors");
  return y(), L(
    "div",
    {
      class: ["hu-color-picker", { light: e.isLightTheme }],
      style: { width: e.totalWidth + "px" }
    },
    [
      R("div", VT, [
        R(s, {
          ref: "saturation",
          color: e.rgbString,
          hsv: e.hsv,
          size: e.hueHeight,
          onSelectSaturation: e.selectSaturation
        }, null, 8, ["color", "hsv", "size", "onSelectSaturation"]),
        R(r, {
          ref: "hue",
          hsv: e.hsv,
          width: e.hueWidth,
          height: e.hueHeight,
          onSelectHue: e.selectHue
        }, null, 8, ["hsv", "width", "height", "onSelectHue"]),
        R(o, {
          ref: "alpha",
          color: e.rgbString,
          rgba: e.rgba,
          width: e.hueWidth,
          height: e.hueHeight,
          onSelectAlpha: e.selectAlpha
        }, null, 8, ["color", "rgba", "width", "height", "onSelectAlpha"])
      ]),
      R(
        "div",
        {
          style: { height: e.previewHeight + "px" },
          class: "color-show"
        },
        [
          R(a, {
            color: e.rgbaString,
            width: e.previewWidth,
            height: e.previewHeight
          }, null, 8, ["color", "width", "height"]),
          e.suckerHide ? I("v-if", !0) : (y(), L(d, {
            key: 0,
            "sucker-canvas": e.suckerCanvas,
            "sucker-area": e.suckerArea,
            onOpenSucker: e.openSucker,
            onSelectSucker: e.selectSucker
          }, null, 8, ["sucker-canvas", "sucker-area", "onOpenSucker", "onSelectSucker"]))
        ],
        4
        /* STYLE */
      ),
      R(h, {
        name: "HEX",
        color: e.modelHex,
        onInputColor: e.inputHex,
        onInputFocus: e.handleFocus,
        onInputBlur: e.handleBlur
      }, null, 8, ["color", "onInputColor", "onInputFocus", "onInputBlur"]),
      R(h, {
        name: "RGBA",
        color: e.modelRgba,
        onInputColor: e.inputRgba,
        onInputFocus: e.handleFocus,
        onInputBlur: e.handleBlur
      }, null, 8, ["color", "onInputColor", "onInputFocus", "onInputBlur"]),
      R(p, {
        color: e.rgbaString,
        "colors-default": e.colorsDefault,
        "colors-history-key": e.colorsHistoryKey,
        onSelectColor: e.selectColor
      }, null, 8, ["color", "colors-default", "colors-history-key", "onSelectColor"]),
      I(" custom options "),
      V(e.$slots, "default")
    ],
    6
    /* CLASS, STYLE */
  );
}
oi.render = jT;
oi.__file = "src/color/ColorPicker.vue";
oi.install = (e) => {
  e.component(oi.name, oi);
};
class ph extends Gl {
  constructor(n, t) {
    super(n, t);
    S(this, "state", fl({
      ...this.sharedState,
      color: "",
      pickedColor: void 0
    }));
    this.emit = t, this.changeColor = this.init(), Pl(() => this.props.debounce, () => this.changeColor = this.init()), Pl(() => this.props.format, () => {
      this.changeColor = this.init(), this.changeColor(this.state.pickedColor);
    });
  }
  get color() {
    return this.state.color;
  }
  async onBeforeMount() {
    this.state.color = this.props.startValue ?? this.vModel ?? "";
  }
  init() {
    return Be((n) => {
      if (n) {
        if (this.state.pickedColor = n, this.props.format === "rgba") {
          const {
            r: t,
            g: u,
            b: i,
            a: s
          } = n.rgba;
          this.state.color = `rgba(${t}, ${u}, ${i}, ${s})`;
        } else if (this.props.format === "hsv") {
          const {
            h: t,
            s: u,
            v: i
          } = n.hsv;
          this.state.color = `hsv(${t}, ${u}, ${i})`;
        } else
          this.state.color = n.hex;
        this.vModel = this.state.color, this.emit("picked", n);
      }
    }, this.props.debounce);
  }
}
S(ph, "props", {
  ...Gl.props,
  // @doc props/hideHex hides the hexadecimal value
  // @doc/fr props/hideHex masque la valeur hexadécimale
  hideHex: Boolean,
  // @doc props/hideRgba hides the rgba value
  // @doc/fr props/hideRgba masque la valeur rgba
  hideRgba: Boolean,
  // @doc props/startValue the default value
  // @doc/fr props/startValue la valeur par défaut
  startValue: {
    type: String,
    default: void 0
  },
  // @doc props/format the format of the color definition
  // @doc/fr props/format format de la couleur
  format: {
    type: String,
    default: "hex",
    validator: (n) => ["hex", "rgba", "hsl"].includes(n)
  },
  // @doc props/debounce the debounce interval
  // @doc/fr props/debounce définits la durée selon laquelle la valeur va se mettre à jour
  debounce: {
    type: Number,
    default: 300
  }
});
const fh = /* @__PURE__ */ K({
  __name: "OrionColorPicker",
  props: ph.props,
  emits: ["focus", "blur", "input", "change", "update:modelValue", "clear", "picked"],
  setup(e, {
    expose: l,
    emit: n
  }) {
    const t = n, u = e, i = new ph(u, t);
    return l(i.publicInstance), (s, r) => (y(), L(c(oi), {
      class: z(["orion-color-picker", [{
        "orion-color-picker--hide-hex": c(i).props.hideHex
      }, {
        "orion-color-picker--hide-rgba": c(i).props.hideRgba
      }]]),
      theme: "light",
      color: c(i).color,
      "sucker-hide": "",
      onChangeColor: r[0] || (r[0] = (o) => c(i).changeColor(o))
    }, null, 8, ["class", "color"]));
  }
}), Za = {
  install(e, l = "o") {
    e.component(`${tl(l)}ColorPicker`, fh);
  }
};
class mh extends Gl {
  constructor(n, t) {
    super(n, t);
    S(this, "_minInput", J());
    S(this, "_maxInput", J());
    S(this, "circleSize", 20);
  }
  get multiple() {
    return typeof this.vModel != "number";
  }
  get leftAlign() {
    return this.circleSize / 2 * (100 / (this.props.maxValue - this.props.minValue) * (this.minFieldValue - this.props.minValue) / 100);
  }
  get rightAlign() {
    return this.circleSize / 2 - this.circleSize / 2 * (100 / (this.props.maxValue - this.props.minValue) * (this.maxFieldValue - this.minFieldValue) / 100);
  }
  get progressBarStyle() {
    return {
      width: `calc(100% / ${this.props.maxValue - this.props.minValue} * ${this.minFieldValue - this.props.minValue} + ${this.circleSize / 2 - this.leftAlign}px)`
    };
  }
  get inputRangeStyle() {
    return {
      width: `calc(100% / ${this.props.maxValue - this.props.minValue} * ${this.maxFieldValue - this.minFieldValue} + ${this.rightAlign}px)`,
      left: `calc(100% / ${this.props.maxValue - this.props.minValue} * ${this.minFieldValue - this.props.minValue} - ${this.leftAlign}px)`
    };
  }
  get minFieldValue() {
    return typeof this.vModel == "number" ? this.vModel : this.vModel[0];
  }
  set minFieldValue(n) {
    this.multiple ? this.vModel = [this.verifyMin(+n), this.maxFieldValue] : this.vModel = +n;
  }
  get maxFieldValue() {
    return typeof this.vModel == "number" ? this.vModel : this.vModel[1];
  }
  set maxFieldValue(n) {
    this.multiple ? this.vModel = [this.minFieldValue, this.verifyMax(+n)] : this.vModel = +n;
  }
  verifyMin(n) {
    return n < this.maxFieldValue ? n : this.maxFieldValue - this.props.step;
  }
  verifyMax(n) {
    return n > this.minFieldValue ? n : this.minFieldValue + this.props.step;
  }
}
S(mh, "props", {
  ...Gl.props,
  ..._l.color(),
  // @doc props/step step of the slider
  // @doc/fr props/step pas du curseur
  step: {
    type: Number,
    default: 1
  },
  // @doc props/minValue minimum value of the input range
  // @doc/fr props/minValue valeur minimale qui peut être sélectionnée
  minValue: {
    type: Number,
    default: 0
  },
  // @doc props/maxValue maximum value of the input range
  // @doc/fr props/maxValue valeur maximum qui peut être sélectionnée
  maxValue: {
    type: Number,
    default: 100
  }
});
const UT = /* @__PURE__ */ A("div", {
  class: "runnable-track"
}, null, -1), WT = ["min", "max"], GT = ["min", "max"], rv = /* @__PURE__ */ K({
  __name: "OrionInputRange",
  props: mh.props,
  emits: ["focus", "blur", "input", "change", "update:modelValue", "clear"],
  setup(e, {
    expose: l,
    emit: n
  }) {
    const t = n, u = e, i = new mh(u, t);
    return l(i.publicInstance), (s, r) => (y(), O("div", {
      class: z(["orion-input-range", {
        "orion-input-range--readonly": c(i).props.readonly,
        "orion-input-range--disabled": c(i).props.disabled
      }])
    }, [UT, c(i).multiple ? I("", !0) : (y(), O("div", {
      key: 0,
      class: z(["orion-input-range__progress-bar", `orion-input-range__progress-bar--${c(i).props.color}`]),
      style: Wl(c(i).progressBarStyle)
    }, null, 6)), c(i).multiple ? (y(), O("div", {
      key: 1,
      class: z(["orion-input-range__progress-bar", `orion-input-range__progress-bar--${c(i).props.color}`]),
      style: Wl(c(i).inputRangeStyle)
    }, null, 6)) : I("", !0), vl(A("input", ml({
      ref: c(i)._minInput,
      "onUpdate:modelValue": r[0] || (r[0] = (o) => c(i).minFieldValue = o),
      class: ["orion-input-range__input", `orion-input-range__input--${c(i).props.color}`],
      type: "range"
    }, {
      ...s.$attrs,
      step: c(i).props.step,
      readonly: c(i).props.readonly,
      disabled: c(i).props.disabled
    }, {
      min: s.minValue,
      max: s.maxValue
    }), null, 16, WT), [[cs, c(i).minFieldValue]]), c(i).multiple ? vl((y(), O("input", ml({
      key: 2,
      ref: c(i)._maxInput,
      "onUpdate:modelValue": r[1] || (r[1] = (o) => c(i).maxFieldValue = o),
      style: {
        position: "absolute",
        left: "0"
      },
      class: ["orion-input-range__input", `orion-input-range__input--${c(i).props.color}`],
      type: "range"
    }, {
      ...s.$attrs,
      step: c(i).props.step,
      readonly: c(i).props.readonly,
      disabled: c(i).props.disabled
    }, {
      min: c(i).props.minValue,
      max: c(i).props.maxValue
    }), null, 16, GT)), [[cs, c(i).maxFieldValue]]) : I("", !0)], 2));
  }
}), Xa = {
  install(e, l = "o") {
    e.component(`${tl(l)}InputRange`, rv);
  }
};
function K0(e, l) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(e);
    l && (t = t.filter(function(u) {
      return Object.getOwnPropertyDescriptor(e, u).enumerable;
    })), n.push.apply(n, t);
  }
  return n;
}
function Nl(e) {
  for (var l = 1; l < arguments.length; l++) {
    var n = arguments[l] != null ? arguments[l] : {};
    l % 2 ? K0(Object(n), !0).forEach(function(t) {
      ge(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : K0(Object(n)).forEach(function(t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return e;
}
function ge(e, l, n) {
  return l in e ? Object.defineProperty(e, l, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[l] = n, e;
}
function KT(e, l) {
  if (e == null)
    return {};
  var n, t, u = function(s, r) {
    if (s == null)
      return {};
    var o, a, d = {}, h = Object.keys(s);
    for (a = 0; a < h.length; a++)
      o = h[a], r.indexOf(o) >= 0 || (d[o] = s[o]);
    return d;
  }(e, l);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (t = 0; t < i.length; t++)
      n = i[t], l.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (u[n] = e[n]);
  }
  return u;
}
function Nu(e) {
  return function(l) {
    if (Array.isArray(l))
      return Qa(l);
  }(e) || function(l) {
    if (typeof Symbol < "u" && l[Symbol.iterator] != null || l["@@iterator"] != null)
      return Array.from(l);
  }(e) || function(l, n) {
    if (l) {
      if (typeof l == "string")
        return Qa(l, n);
      var t = Object.prototype.toString.call(l).slice(8, -1);
      if (t === "Object" && l.constructor && (t = l.constructor.name), t === "Map" || t === "Set")
        return Array.from(l);
      if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
        return Qa(l, n);
    }
  }(e) || function() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function Qa(e, l) {
  (l == null || l > e.length) && (l = e.length);
  for (var n = 0, t = new Array(l); n < l; n++)
    t[n] = e[n];
  return t;
}
var Y0, YT, Qs, Ql = (Y0 = function(e) {
  /*!
    Copyright (c) 2018 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
  */
  (function() {
    var l = {}.hasOwnProperty;
    function n() {
      for (var t = [], u = 0; u < arguments.length; u++) {
        var i = arguments[u];
        if (i) {
          var s = typeof i;
          if (s === "string" || s === "number")
            t.push(i);
          else if (Array.isArray(i)) {
            if (i.length) {
              var r = n.apply(null, i);
              r && t.push(r);
            }
          } else if (s === "object")
            if (i.toString === Object.prototype.toString)
              for (var o in i)
                l.call(i, o) && i[o] && t.push(o);
            else
              t.push(i.toString());
        }
      }
      return t.join(" ");
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
}, Y0(Qs = { path: YT, exports: {}, require: function(e, l) {
  return function() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
  }(l == null && Qs.path);
} }, Qs.exports), Qs.exports), Oe = function(e) {
  return function(l, n) {
    if (!l)
      return e;
    var t;
    typeof l == "string" ? t = l : n = l;
    var u = e;
    return t && (u += "__" + t), u + (n ? Object.keys(n).reduce(function(i, s) {
      var r = n[s];
      return r && (i += " " + (typeof r == "boolean" ? u + "--" + s : u + "--" + s + "_" + r)), i;
    }, "") : "");
  };
};
function gh(e, l, n) {
  var t, u, i, s, r;
  function o() {
    var d = Date.now() - s;
    d < l && d >= 0 ? t = setTimeout(o, l - d) : (t = null, n || (r = e.apply(i, u), i = u = null));
  }
  l == null && (l = 100);
  var a = function() {
    i = this, u = arguments, s = Date.now();
    var d = n && !t;
    return t || (t = setTimeout(o, l)), d && (r = e.apply(i, u), i = u = null), r;
  };
  return a.clear = function() {
    t && (clearTimeout(t), t = null);
  }, a.flush = function() {
    t && (r = e.apply(i, u), i = u = null, clearTimeout(t), t = null);
  }, a;
}
gh.debounce = gh;
var vh = gh, cl = function() {
  return cl = Object.assign || function(e) {
    for (var l, n = 1, t = arguments.length; n < t; n++)
      for (var u in l = arguments[n])
        Object.prototype.hasOwnProperty.call(l, u) && (e[u] = l[u]);
    return e;
  }, cl.apply(this, arguments);
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function ov(e, l) {
  var n, t;
  return e && l ? (n = "" + e + l[0].toUpperCase() + l.slice(1), t = e + "-" + l) : (n = e || l, t = e || l), { name: n, classname: t };
}
function av(e) {
  return /^blob:/.test(e);
}
function q0(e) {
  return av(e) || function(l) {
    return /^data:/.test(l);
  }(e);
}
function Ku(e) {
  return !!(e && e.constructor && e.call && e.apply);
}
function on(e) {
  return e === void 0;
}
function yr(e) {
  return typeof e == "object" && e !== null;
}
function yh(e, l, n) {
  var t = {};
  return yr(e) ? (Object.keys(l).forEach(function(u) {
    on(e[u]) ? t[u] = l[u] : yr(l[u]) ? yr(e[u]) ? t[u] = yh(e[u], l[u], n[u]) : t[u] = e[u] ? l[u] : n[u] : l[u] === !0 || l[u] === !1 ? t[u] = !!e[u] : t[u] = e[u];
  }), t) : e ? l : n;
}
function lr(e) {
  var l = Number(e);
  return Number.isNaN(l) ? e : l;
}
function J0(e) {
  return typeof (e == "number" || /* @__PURE__ */ function(l) {
    return typeof l == "object" && l !== null;
  }(e) && toString.call(e) == "[object Number]") && !dv(e);
}
function dv(e) {
  return e != e;
}
function cv(e, l) {
  return Math.sqrt(Math.pow(e.x - l.x, 2) + Math.pow(e.y - l.y, 2));
}
var Qi = function(e, l) {
  e === void 0 && (e = {}), l === void 0 && (l = {}), this.type = "manipulateImage", this.move = e, this.scale = l;
}, qT = function(e, l) {
  l === void 0 && (l = {}), this.type = "resize", this.directions = e, this.params = l;
}, Rf = function(e) {
  this.type = "move", this.directions = e;
}, JT = function() {
  function e(l, n, t, u, i) {
    this.type = "drag", this.nativeEvent = l, this.position = t, this.previousPosition = u, this.element = n, this.anchor = i;
  }
  return e.prototype.shift = function() {
    var l = this, n = l.element, t = l.anchor, u = l.position;
    if (n) {
      var i = n.getBoundingClientRect(), s = i.left, r = i.top;
      return { left: u.left - s - t.left, top: u.top - r - t.top };
    }
    return { left: 0, top: 0 };
  }, e;
}(), Df = { name: "DraggableElement", props: { classname: { type: String } }, beforeMount: function() {
  window.addEventListener("mouseup", this.onMouseUp, { passive: !1 }), window.addEventListener("mousemove", this.onMouseMove, { passive: !1 }), window.addEventListener("touchmove", this.onTouchMove, { passive: !1 }), window.addEventListener("touchend", this.onTouchEnd, { passive: !1 });
}, beforeUnmount: function() {
  window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onTouchMove), window.removeEventListener("touchend", this.onTouchEnd);
}, mounted: function() {
  if (!this.$refs.draggable)
    throw new Error('You should add ref "draggable" to your root element to use draggable mixin');
  this.touches = [], this.hovered = !1;
}, methods: { onMouseOver: function() {
  this.hovered || (this.hovered = !0, this.$emit("enter"));
}, onMouseLeave: function() {
  this.hovered && !this.touches.length && (this.hovered = !1, this.$emit("leave"));
}, onTouchStart: function(e) {
  e.cancelable && !this.disabled && e.touches.length === 1 && (this.touches = Nu(e.touches), this.hovered || (this.$emit("enter"), this.hovered = !0), e.touches.length && this.initAnchor(this.touches.reduce(function(l, n) {
    return { clientX: l.clientX + n.clientX / e.touches.length, clientY: l.clientY + n.clientY / e.touches.length };
  }, { clientX: 0, clientY: 0 })), e.preventDefault && e.preventDefault(), e.stopPropagation());
}, onTouchEnd: function() {
  this.processEnd();
}, onTouchMove: function(e) {
  this.touches.length && (this.processMove(e, e.touches), e.preventDefault && e.preventDefault(), e.stopPropagation && e.stopPropagation());
}, onMouseDown: function(e) {
  if (!this.disabled) {
    var l = { fake: !0, clientX: e.clientX, clientY: e.clientY };
    this.touches = [l], this.initAnchor(l), e.stopPropagation();
  }
}, onMouseMove: function(e) {
  this.touches.length && (this.processMove(e, [{ fake: !0, clientX: e.clientX, clientY: e.clientY }]), e.preventDefault && e.preventDefault());
}, onMouseUp: function() {
  this.processEnd();
}, initAnchor: function(e) {
  var l = this.$refs.draggable.getBoundingClientRect(), n = l.left, t = l.right, u = l.bottom, i = l.top;
  this.anchor = { left: e.clientX - n, top: e.clientY - i, bottom: u - e.clientY, right: t - e.clientX };
}, processMove: function(e, l) {
  var n = Nu(l);
  if (this.touches.length) {
    if (this.touches.length === 1 && n.length === 1) {
      var t = this.$refs.draggable;
      this.$emit("drag", new JT(e, t, { left: n[0].clientX, top: n[0].clientY }, { left: this.touches[0].clientX, top: this.touches[0].clientY }, this.anchor));
    }
    this.touches = n;
  }
}, processEnd: function() {
  this.touches.length && this.$emit("drag-end"), this.hovered && (this.$emit("leave"), this.hovered = !1), this.touches = [];
} }, emits: ["drag", "drag-end", "leave", "enter"] };
Df.render = function(e, l, n, t, u, i) {
  return y(), L("div", { ref: "draggable", class: n.classname, onTouchstart: l[1] || (l[1] = function() {
    return i.onTouchStart && i.onTouchStart.apply(i, arguments);
  }), onMousedown: l[2] || (l[2] = function() {
    return i.onMouseDown && i.onMouseDown.apply(i, arguments);
  }), onMouseover: l[3] || (l[3] = function() {
    return i.onMouseOver && i.onMouseOver.apply(i, arguments);
  }), onMouseleave: l[4] || (l[4] = function() {
    return i.onMouseLeave && i.onMouseLeave.apply(i, arguments);
  }) }, [V(e.$slots, "default")], 34);
};
var ld = Oe("vue-handler-wrapper"), hv = { name: "HandlerWrapper", components: { DraggableElement: Df }, props: { horizontalPosition: { type: String }, verticalPosition: { type: String }, disabled: { type: Boolean, default: !1 } }, computed: { classes: function() {
  var e;
  if (this.horizontalPosition || this.verticalPosition) {
    var l, n = ov(this.horizontalPosition, this.verticalPosition);
    e = ld((ge(l = {}, n.classname, !0), ge(l, "disabled", this.disabled), l));
  } else
    e = ld({ disabled: this.disabled });
  return { root: e, draggable: ld("draggable") };
} }, emits: ["leave", "enter", "drag", "drag-end"] };
hv.render = function(e, l, n, t, u, i) {
  var s = Bl("DraggableElement");
  return y(), L("div", { class: i.classes.root }, [R(s, { class: i.classes.draggable, onDrag: l[1] || (l[1] = function(r) {
    return e.$emit("drag", r);
  }), onDragEnd: l[2] || (l[2] = function(r) {
    return e.$emit("drag-end");
  }), onLeave: l[3] || (l[3] = function(r) {
    return e.$emit("leave");
  }), onEnter: l[4] || (l[4] = function(r) {
    return e.$emit("enter");
  }) }, { default: U(function() {
    return [V(e.$slots, "default")];
  }), _: 3 }, 8, ["class"])], 2);
};
var ZT = Oe("vue-line-wrapper"), pv = { name: "LineWrapper", components: { DraggableElement: Df }, props: { position: { type: String, required: !0 }, disabled: { type: Boolean, default: !1 } }, computed: { classname: function() {
  var e;
  return ZT((ge(e = {}, this.position, !0), ge(e, "disabled", this.disabled), e));
} }, emits: ["leave", "enter", "drag", "drag-end"] };
pv.render = function(e, l, n, t, u, i) {
  var s = Bl("DraggableElement");
  return y(), L(s, { class: i.classname, onDrag: l[1] || (l[1] = function(r) {
    return e.$emit("drag", r);
  }), onDragEnd: l[2] || (l[2] = function(r) {
    return e.$emit("drag-end");
  }), onLeave: l[3] || (l[3] = function(r) {
    return e.$emit("leave");
  }), onEnter: l[4] || (l[4] = function(r) {
    return e.$emit("enter");
  }) }, { default: U(function() {
    return [V(e.$slots, "default")];
  }), _: 3 }, 8, ["class"]);
};
var nt = ["left", "right", "top", "bottom"], XT = ["left", "right"], QT = ["top", "bottom"], lO = ["left", "top"], nO = ["fill-area", "fit-area", "stencil", "none"], Z0 = { left: 0, top: 0, width: 0, height: 0 };
function X0(e, l, n) {
  return !(n = n || ["width", "height", "left", "top"]).some(function(t) {
    return e[t] !== l[t];
  });
}
function mt(e) {
  return { left: e.left, top: e.top, right: e.left + e.width, bottom: e.top + e.height };
}
function vi(e, l) {
  return { left: e.left - l.left, top: e.top - l.top };
}
function Sn(e) {
  return { left: e.left + e.width / 2, top: e.top + e.height / 2 };
}
function _s(e, l) {
  var n = { left: 0, top: 0, right: 0, bottom: 0 };
  return nt.forEach(function(t) {
    var u = l[t], i = mt(e)[t];
    n[t] = u !== void 0 && i !== void 0 ? t === "left" || t === "top" ? Math.max(0, u - i) : Math.max(0, i - u) : 0;
  }), n;
}
function Qe(e, l) {
  return { left: e.left - l.left, top: e.top - l.top, width: e.width + l.left + l.right, height: e.height + l.top + l.bottom };
}
function Xo(e) {
  return { left: -e.left, top: -e.top };
}
function Jn(e, l) {
  return cl(cl({}, e), { left: e.left + l.left, top: e.top + l.top });
}
function $e(e, l, n, t) {
  if (l !== 1) {
    if (n) {
      var u = Sn(e);
      return { width: e.width * l, height: e.height * l, left: e.left + e.width * (1 - l) / 2 + (n.left - u.left) * (t || 1 - l), top: e.top + e.height * (1 - l) / 2 + (n.top - u.top) * (t || 1 - l) };
    }
    return { width: e.width * l, height: e.height * l, left: e.left + e.width * (1 - l) / 2, top: e.top + e.height * (1 - l) / 2 };
  }
  return e;
}
function Ll(e) {
  return e.width / e.height;
}
function yi(e, l) {
  return Math.min(l.right !== void 0 && l.left !== void 0 ? (l.right - l.left) / e.width : 1 / 0, l.bottom !== void 0 && l.top !== void 0 ? (l.bottom - l.top) / e.height : 1 / 0);
}
function $i(e, l) {
  var n = { left: 0, top: 0 }, t = _s(e, l);
  return t.left && t.left > 0 ? n.left = t.left : t.right && t.right > 0 && (n.left = -t.right), t.top && t.top > 0 ? n.top = t.top : t.bottom && t.bottom > 0 && (n.top = -t.bottom), n;
}
function nd(e, l) {
  var n;
  return l.minimum && e < l.minimum ? n = l.minimum : l.maximum && e > l.maximum && (n = l.maximum), n;
}
function fv(e, l) {
  var n = Ll(e), t = Ll(l);
  return l.width < 1 / 0 && l.height < 1 / 0 ? n > t ? { width: l.width, height: l.width / n } : { width: l.height * n, height: l.height } : l.width < 1 / 0 ? { width: l.width, height: l.width / n } : l.height < 1 / 0 ? { width: l.height * n, height: l.height } : e;
}
function mv(e, l) {
  var n = l * Math.PI / 180;
  return { width: Math.abs(e.width * Math.cos(n)) + Math.abs(e.height * Math.sin(n)), height: Math.abs(e.width * Math.sin(n)) + Math.abs(e.height * Math.cos(n)) };
}
function Wt(e, l) {
  var n = l * Math.PI / 180;
  return { left: e.left * Math.cos(n) - e.top * Math.sin(n), top: e.left * Math.sin(n) + e.top * Math.cos(n) };
}
function Qo(e, l) {
  var n = _s(Cn(e, l), l);
  return n.left + n.right + n.top + n.bottom ? n.left + n.right > n.top + n.bottom ? Math.min((e.width + n.left + n.right) / e.width, yi(e, l)) : Math.min((e.height + n.top + n.bottom) / e.height, yi(e, l)) : 1;
}
function Cn(e, l, n) {
  n === void 0 && (n = !1);
  var t = $i(e, l);
  return Jn(e, n ? Xo(t) : t);
}
function $h(e) {
  return { width: e.right !== void 0 && e.left !== void 0 ? e.right - e.left : 1 / 0, height: e.bottom !== void 0 && e.top !== void 0 ? e.bottom - e.top : 1 / 0 };
}
function eO(e, l) {
  return cl(cl({}, e), { minWidth: Math.min(l.width, e.minWidth), minHeight: Math.min(l.height, e.minHeight), maxWidth: Math.min(l.width, e.maxWidth), maxHeight: Math.min(l.height, e.maxHeight) });
}
function gv(e, l, n) {
  n === void 0 && (n = !0);
  var t = {};
  return nt.forEach(function(u) {
    var i = e[u], s = l[u];
    i !== void 0 && s !== void 0 ? t[u] = u === "left" || u === "top" ? n ? Math.max(i, s) : Math.min(i, s) : n ? Math.min(i, s) : Math.max(i, s) : s !== void 0 ? t[u] = s : i !== void 0 && (t[u] = i);
  }), t;
}
function la(e, l) {
  return gv(e, l, !0);
}
function Q0(e) {
  var l = e.size, n = e.aspectRatio, t = e.ignoreMinimum, u = e.sizeRestrictions;
  return !!((l.correctRatio || Ll(l) >= n.minimum && Ll(l) <= n.maximum) && l.height <= u.maxHeight && l.width <= u.maxWidth && l.width && l.height && (t || l.height >= u.minHeight && l.width >= u.minWidth));
}
function lm(e, l) {
  return Math.pow(e.width - l.width, 2) + Math.pow(e.height - l.height, 2);
}
function kt(e) {
  var l = e.width, n = e.height, t = e.sizeRestrictions, u = { minimum: e.aspectRatio && e.aspectRatio.minimum || 0, maximum: e.aspectRatio && e.aspectRatio.maximum || 1 / 0 }, i = { width: Math.max(t.minWidth, Math.min(t.maxWidth, l)), height: Math.max(t.minHeight, Math.min(t.maxHeight, n)) };
  function s(a, d) {
    return d === void 0 && (d = !1), a.reduce(function(h, p) {
      return Q0({ size: p, aspectRatio: u, sizeRestrictions: t, ignoreMinimum: d }) && (!h || lm(p, { width: l, height: n }) < lm(h, { width: l, height: n })) ? p : h;
    }, null);
  }
  var r = [];
  u && [u.minimum, u.maximum].forEach(function(a) {
    a && r.push({ width: i.width, height: i.width / a, correctRatio: !0 }, { width: i.height * a, height: i.height, correctRatio: !0 });
  }), Q0({ size: i, aspectRatio: u, sizeRestrictions: t }) && r.push(i);
  var o = s(r) || s(r, !0);
  return o && { width: o.width, height: o.height };
}
function bh(e) {
  var l = e.event, n = e.coordinates, t = e.positionRestrictions, u = t === void 0 ? {} : t, i = Jn(n, l.directions);
  return Jn(i, $i(i, u));
}
function tO(e) {
  var l = e.coordinates, n = e.transform, t = e.imageSize, u = e.sizeRestrictions, i = e.positionRestrictions, s = e.aspectRatio, r = e.visibleArea, o = function(d, h) {
    return bh({ coordinates: d, positionRestrictions: i, event: new Rf({ left: h.left - d.left, top: h.top - d.top }) });
  }, a = cl({}, l);
  return (Array.isArray(n) ? n : [n]).forEach(function(d) {
    var h = {};
    on((h = typeof d == "function" ? d({ coordinates: a, imageSize: t, visibleArea: r }) : d).width) && on(h.height) || (a = function(p, f) {
      var m = cl(cl(cl({}, p), kt({ width: f.width, height: f.height, sizeRestrictions: u, aspectRatio: s })), { left: 0, top: 0 });
      return o(m, { left: p.left, top: p.top });
    }(a, cl(cl({}, a), h))), on(h.left) && on(h.top) || (a = o(a, cl(cl({}, a), h)));
  }), a;
}
function uO(e) {
  e.event;
  var l = e.getAreaRestrictions, n = e.boundaries, t = e.coordinates, u = e.visibleArea;
  e.aspectRatio;
  var i = e.stencilSize, s = e.sizeRestrictions, r = e.positionRestrictions;
  e.stencilReference;
  var o, a, d, h = cl({}, t), p = cl({}, u), f = cl({}, i);
  o = Ll(f), a = Ll(h), d === void 0 && (d = 1e-3), (o === 0 || a === 0 ? Math.abs(a - o) < d : Math.abs(a / o) < 1 + d && Math.abs(a / o) > 1 - d) || (h = cl(cl({}, h), kt({ sizeRestrictions: s, width: h.width, height: h.height, aspectRatio: { minimum: Ll(f), maximum: Ll(f) } })));
  var m = Qo(p = $e(p, h.width * n.width / (p.width * f.width)), l({ visibleArea: p, type: "resize" }));
  return m !== 1 && (p = $e(p, m), h = $e(h, m)), p = Cn(p = Jn(p, vi(Sn(h), Sn(p))), l({ visibleArea: p, type: "move" })), { coordinates: h = Cn(h, la(mt(p), r)), visibleArea: p };
}
function iO(e) {
  var l = e.event, n = e.getAreaRestrictions, t = e.boundaries, u = e.coordinates, i = e.visibleArea;
  e.aspectRatio, e.stencilSize, e.sizeRestrictions;
  var s = e.positionRestrictions;
  e.stencilReference;
  var r = cl({}, u), o = cl({}, i);
  if (u && i && l.type !== "manipulateImage") {
    var a = { width: 0, height: 0 };
    o.width, t.width, Ll(t) > Ll(r) ? (a.height = 0.8 * t.height, a.width = a.height * Ll(r)) : (a.width = 0.8 * t.width, a.height = a.width * Ll(r));
    var d = Qo(o = $e(o, r.width * t.width / (o.width * a.width)), n({ visibleArea: o, type: "resize" }));
    o = $e(o, d), d !== 1 && (a.height /= d, a.width /= d), o = Cn(o = Jn(o, vi(Sn(r), Sn(o))), n({ visibleArea: o, type: "move" })), r = Cn(r, la(mt(o), s));
  }
  return { coordinates: r, visibleArea: o };
}
function sO(e) {
  var l = e.event, n = e.coordinates, t = e.visibleArea, u = e.getAreaRestrictions, i = cl({}, t), s = cl({}, n);
  if (l.type === "setCoordinates") {
    var r = Math.max(0, s.width - i.width), o = Math.max(0, s.height - i.height);
    r > o ? i = $e(i, Math.min(s.width / i.width, yi(i, u({ visibleArea: i, type: "resize" })))) : o > r && (i = $e(i, Math.min(s.height / i.height, yi(i, u({ visibleArea: i, type: "resize" }))))), i = Cn(i = Jn(i, Xo($i(s, mt(i)))), u({ visibleArea: i, type: "move" }));
  }
  return { visibleArea: i, coordinates: s };
}
function rO(e) {
  var l = e.imageSize, n = e.visibleArea, t = e.coordinates, u = n || l;
  return { left: (n ? n.left : 0) + u.width / 2 - t.width / 2, top: (n ? n.top : 0) + u.height / 2 - t.height / 2 };
}
function oO(e) {
  var l = e.imageSize, n = e.visibleArea, t = e.aspectRatio, u = e.sizeRestrictions, i = n || l, s = Math.min(t.maximum || 1 / 0, Math.max(t.minimum || 0, Ll(i))), r = i.width < i.height ? { width: 0.8 * i.width, height: 0.8 * i.width / s } : { height: 0.8 * i.height, width: 0.8 * i.height * s };
  return kt(cl(cl({}, r), { aspectRatio: t, sizeRestrictions: u }));
}
function aO(e) {
  var l, n, t = e.imageSize, u = e.visibleArea, i = e.boundaries, s = e.aspectRatio, r = e.sizeRestrictions, o = e.stencilSize, a = u || t;
  return Ll(a) > Ll(i) ? n = (l = o.height * a.height / i.height) * Ll(o) : l = (n = o.width * a.width / i.width) / Ll(o), kt({ width: n, height: l, aspectRatio: s, sizeRestrictions: r });
}
function dO(e) {
  var l = e.getAreaRestrictions, n = e.coordinates, t = e.imageSize, u = Ll(e.boundaries);
  if (n) {
    var i = { height: Math.max(n.height, t.height), width: Math.max(n.width, t.width) }, s = fv({ width: Ll(i) > u ? i.width : i.height * u, height: Ll(i) > u ? i.width / u : i.height }, $h(l())), r = { left: n.left + n.width / 2 - s.width / 2, top: n.top + n.height / 2 - s.height / 2, width: s.width, height: s.height }, o = _s(n, mt(cl({ left: 0, top: 0 }, t))), a = {};
    return !o.left && !o.right && r.width <= t.width && (a.left = 0, a.right = t.width), !o.top && !o.bottom && r.height <= t.height && (a.top = 0, a.bottom = t.height), Cn(r, a);
  }
  var d = Ll(t);
  return s = { height: d > u ? t.height : t.width / u, width: d > u ? t.height * u : t.width }, { left: t.width / 2 - s.width / 2, top: t.height / 2 - s.height / 2, width: s.width, height: s.height };
}
function nr(e, l) {
  return gv(e, mt(l));
}
function cO(e) {
  var l = e.event, n = e.coordinates, t = e.visibleArea, u = e.sizeRestrictions, i = e.getAreaRestrictions, s = e.positionRestrictions, r = e.adjustStencil, o = l.scale, a = l.move, d = cl({}, t), h = cl({}, n), p = 1, f = 1, m = o.factor && Math.abs(o.factor - 1) > 1e-3;
  d = Jn(d, { left: a.left || 0, top: a.top || 0 });
  var g = { stencil: { minimum: Math.max(u.minWidth ? u.minWidth / h.width : 0, u.minHeight ? u.minHeight / h.height : 0), maximum: Math.min(u.maxWidth ? u.maxWidth / h.width : 1 / 0, u.maxHeight ? u.maxHeight / h.height : 1 / 0, yi(h, s)) }, area: { maximum: yi(d, i({ visibleArea: d, type: "resize" })) } };
  o.factor && m && (o.factor < 1 ? (f = Math.max(o.factor, g.stencil.minimum)) > 1 && (f = 1) : o.factor > 1 && (f = Math.min(o.factor, Math.min(g.area.maximum, g.stencil.maximum))) < 1 && (f = 1)), f && (d = $e(d, f, o.center));
  var v = n.left - t.left, w = t.width + t.left - (n.width + n.left), $ = n.top - t.top, _ = t.height + t.top - (n.height + n.top);
  return d = Cn(d = Jn(d, $i(d, { left: s.left !== void 0 ? s.left - v * f : void 0, top: s.top !== void 0 ? s.top - $ * f : void 0, bottom: s.bottom !== void 0 ? s.bottom + _ * f : void 0, right: s.right !== void 0 ? s.right + w * f : void 0 })), i({ visibleArea: d, type: "move" })), h.width = h.width * f, h.height = h.height * f, h.left = d.left + v * f, h.top = d.top + $ * f, h = Cn(h, la(mt(d), s)), o.factor && m && r && (o.factor > 1 ? p = Math.min(g.area.maximum, o.factor) / f : o.factor < 1 && (p = Math.max(h.height / d.height, h.width / d.width, o.factor / f)), p !== 1 && (d = Jn(d = Cn(d = $e(d, p, o.factor > 1 ? o.center : Sn(h)), i({ visibleArea: d, type: "move" })), Xo($i(h, mt(d)))))), { coordinates: h, visibleArea: d };
}
function hO(e) {
  var l = e.aspectRatio, n = e.getAreaRestrictions, t = e.coordinates, u = e.visibleArea, i = e.sizeRestrictions, s = e.positionRestrictions, r = e.imageSize, o = e.previousImageSize, a = e.angle, d = cl({}, t), h = cl({}, u), p = Wt(Sn(cl({ left: 0, top: 0 }, o)), a);
  return (d = cl(cl({}, kt({ sizeRestrictions: i, aspectRatio: l, width: d.width, height: d.height })), Wt(Sn(d), a))).left -= p.left - r.width / 2 + d.width / 2, d.top -= p.top - r.height / 2 + d.height / 2, h = $e(h, Qo(h, n({ visibleArea: h, type: "resize" }))), { coordinates: d = Cn(d, s), visibleArea: h = Cn(h = Jn(h, vi(Sn(d), Sn(t))), n({ visibleArea: h, type: "move" })) };
}
function pO(e) {
  var l = e.flip, n = e.previousFlip, t = e.rotate;
  e.aspectRatio;
  var u = e.getAreaRestrictions, i = e.coordinates, s = e.visibleArea, r = e.imageSize, o = cl({}, i), a = cl({}, s), d = n.horizontal !== l.horizontal, h = n.vertical !== l.vertical;
  if (d || h) {
    var p = Wt({ left: r.width / 2, top: r.height / 2 }, -t), f = Wt(Sn(o), -t), m = Wt({ left: d ? p.left - (f.left - p.left) : f.left, top: h ? p.top - (f.top - p.top) : f.top }, t);
    o = Jn(o, vi(m, Sn(o))), f = Wt(Sn(a), -t), a = Cn(a = Jn(a, vi(m = Wt({ left: d ? p.left - (f.left - p.left) : f.left, top: h ? p.top - (f.top - p.top) : f.top }, t), Sn(a))), u({ visibleArea: a, type: "move" }));
  }
  return { coordinates: o, visibleArea: a };
}
function nm(e) {
  var l = e.directions, n = e.coordinates, t = e.positionRestrictions, u = t === void 0 ? {} : t, i = e.sizeRestrictions, s = e.preserveRatio, r = e.compensate, o = cl({}, l), a = Qe(n, o).width, d = Qe(n, o).height;
  a < 0 && (o.left < 0 && o.right < 0 ? (o.left = -(n.width - i.minWidth) / (o.left / o.right), o.right = -(n.width - i.minWidth) / (o.right / o.left)) : o.left < 0 ? o.left = -(n.width - i.minWidth) : o.right < 0 && (o.right = -(n.width - i.minWidth))), d < 0 && (o.top < 0 && o.bottom < 0 ? (o.top = -(n.height - i.minHeight) / (o.top / o.bottom), o.bottom = -(n.height - i.minHeight) / (o.bottom / o.top)) : o.top < 0 ? o.top = -(n.height - i.minHeight) : o.bottom < 0 && (o.bottom = -(n.height - i.minHeight)));
  var h = _s(Qe(n, o), u);
  r && (h.left && h.left > 0 && h.right === 0 ? (o.right += h.left, o.left -= h.left) : h.right && h.right > 0 && h.left === 0 && (o.left += h.right, o.right -= h.right), h.top && h.top > 0 && h.bottom === 0 ? (o.bottom += h.top, o.top -= h.top) : h.bottom && h.bottom > 0 && h.top === 0 && (o.top += h.bottom, o.bottom -= h.bottom), h = _s(Qe(n, o), u));
  var p = { width: 1 / 0, height: 1 / 0, left: 1 / 0, right: 1 / 0, top: 1 / 0, bottom: 1 / 0 };
  if (nt.forEach(function(g) {
    var v = h[g];
    v && o[g] && (p[g] = Math.max(0, 1 - v / o[g]));
  }), s) {
    var f = Math.min.apply(null, nt.map(function(g) {
      return p[g];
    }));
    f !== 1 / 0 && nt.forEach(function(g) {
      o[g] *= f;
    });
  } else
    nt.forEach(function(g) {
      p[g] !== 1 / 0 && (o[g] *= p[g]);
    });
  if (a = Qe(n, o).width, d = Qe(n, o).height, o.right + o.left && (a > i.maxWidth ? p.width = (i.maxWidth - n.width) / (o.right + o.left) : a < i.minWidth && (p.width = (i.minWidth - n.width) / (o.right + o.left))), o.bottom + o.top && (d > i.maxHeight ? p.height = (i.maxHeight - n.height) / (o.bottom + o.top) : d < i.minHeight && (p.height = (i.minHeight - n.height) / (o.bottom + o.top))), s) {
    var m = Math.min(p.width, p.height);
    m !== 1 / 0 && nt.forEach(function(g) {
      o[g] *= m;
    });
  } else
    p.width !== 1 / 0 && XT.forEach(function(g) {
      o[g] *= p.width;
    }), p.height !== 1 / 0 && QT.forEach(function(g) {
      o[g] *= p.height;
    });
  return o;
}
function er(e, l, n) {
  return l == 0 && n == 0 ? e / 2 : l == 0 ? 0 : n == 0 ? e : e * Math.abs(l / (l + n));
}
var fO = Oe("vue-simple-handler"), mO = Oe("vue-simple-handler-wrapper"), na = { name: "SimpleHandler", components: { HandlerWrapper: hv }, props: { defaultClass: { type: String }, hoverClass: { type: String }, wrapperClass: { type: String }, horizontalPosition: { type: String }, verticalPosition: { type: String }, disabled: { type: Boolean, default: !1 } }, data: function() {
  return { hover: !1 };
}, computed: { classes: function() {
  var e, l = (ge(e = {}, this.horizontalPosition, !!this.horizontalPosition), ge(e, this.verticalPosition, !!this.verticalPosition), ge(e, "".concat(this.horizontalPosition, "-").concat(this.verticalPosition), !!(this.verticalPosition && this.horizontalPosition)), ge(e, "hover", this.hover), e);
  return { default: Ql(fO(l), this.defaultClass, this.hover && this.hoverClass), wrapper: Ql(mO(l), this.wrapperClass) };
} }, methods: { onDrag: function(e) {
  this.$emit("drag", e);
}, onEnter: function() {
  this.hover = !0;
}, onLeave: function() {
  this.hover = !1;
}, onDragEnd: function() {
  this.$emit("drag-end");
} }, emits: ["drag", "drag-end"] };
na.render = function(e, l, n, t, u, i) {
  var s = Bl("HandlerWrapper");
  return y(), L(s, { class: i.classes.wrapper, "vertical-position": n.verticalPosition, "horizontal-position": n.horizontalPosition, disabled: n.disabled, onDrag: i.onDrag, onDragEnd: i.onDragEnd, onEnter: i.onEnter, onLeave: i.onLeave }, { default: U(function() {
    return [R("div", { class: i.classes.default }, null, 2)];
  }), _: 1 }, 8, ["class", "vertical-position", "horizontal-position", "disabled", "onDrag", "onDragEnd", "onEnter", "onLeave"]);
};
var gO = Oe("vue-simple-line"), vO = Oe("vue-simple-line-wrapper"), ea = { name: "SimpleLine", components: { LineWrapper: pv }, props: { defaultClass: { type: String }, hoverClass: { type: String }, wrapperClass: { type: String }, position: { type: String }, disabled: { type: Boolean, default: !1 } }, data: function() {
  return { hover: !1 };
}, computed: { classes: function() {
  return { root: Ql(gO(ge({}, this.position, !0)), this.defaultClass, this.hover && this.hoverClass), wrapper: Ql(vO(ge({}, this.position, !0)), this.wrapperClass) };
} }, methods: { onDrag: function(e) {
  this.$emit("drag", e);
}, onEnter: function() {
  this.hover = !0;
}, onLeave: function() {
  this.hover = !1;
}, onDragEnd: function() {
  this.$emit("drag-end");
} }, emits: ["drag", "drag-end"] };
ea.render = function(e, l, n, t, u, i) {
  var s = Bl("LineWrapper");
  return y(), L(s, { class: i.classes.wrapper, position: n.position, disabled: n.disabled, onDrag: i.onDrag, onDragEnd: i.onDragEnd, onEnter: i.onEnter, onLeave: i.onLeave }, { default: U(function() {
    return [R("div", { class: i.classes.root }, null, 2)];
  }), _: 1 }, 8, ["class", "position", "disabled", "onDrag", "onDragEnd", "onEnter", "onLeave"]);
};
var ed = Oe("vue-bounding-box"), yO = ["east", "west", null], $O = ["south", "north", null], Nf = { name: "BoundingBox", props: { width: { type: Number }, height: { type: Number }, transitions: { type: Object }, handlers: { type: Object, default: function() {
  return { eastNorth: !0, north: !0, westNorth: !0, west: !0, westSouth: !0, south: !0, eastSouth: !0, east: !0 };
} }, handlersComponent: { type: [Object, String], default: function() {
  return na;
} }, handlersClasses: { type: Object, default: function() {
  return {};
} }, handlersWrappersClasses: { type: Object, default: function() {
  return {};
} }, lines: { type: Object, default: function() {
  return { west: !0, north: !0, east: !0, south: !0 };
} }, linesComponent: { type: [Object, String], default: function() {
  return ea;
} }, linesClasses: { type: Object, default: function() {
  return {};
} }, linesWrappersClasses: { type: Object, default: function() {
  return {};
} }, resizable: { type: Boolean, default: !0 } }, data: function() {
  var e = [];
  return yO.forEach(function(l) {
    $O.forEach(function(n) {
      if (l !== n) {
        var t = ov(l, n), u = t.name, i = t.classname;
        e.push({ name: u, classname: i, verticalDirection: n, horizontalDirection: l });
      }
    });
  }), { points: e };
}, computed: { style: function() {
  var e = {};
  return this.width && this.height && (e.width = "".concat(this.width, "px"), e.height = "".concat(this.height, "px"), this.transitions && this.transitions.enabled && (e.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction))), e;
}, classes: function() {
  var e = this.handlersClasses, l = this.handlersWrappersClasses, n = this.linesClasses, t = this.linesWrappersClasses;
  return { root: ed(), handlers: e, handlersWrappers: l, lines: n, linesWrappers: t };
}, lineNodes: function() {
  var e = this, l = [];
  return this.points.forEach(function(n) {
    n.horizontalDirection && n.verticalDirection || !e.lines[n.name] || l.push({ name: n.name, component: e.linesComponent, class: Ql(e.classes.lines.default, e.classes.lines[n.name], !e.resizable && e.classes.lines.disabled), wrapperClass: Ql(e.classes.linesWrappers.default, e.classes.linesWrappers[n.name], !e.resizable && e.classes.linesWrappers.disabled), hoverClass: e.classes.lines.hover, verticalDirection: n.verticalDirection, horizontalDirection: n.horizontalDirection, disabled: !e.resizable });
  }), l;
}, handlerNodes: function() {
  var e = this, l = [], n = this.width, t = this.height;
  return this.points.forEach(function(u) {
    if (e.handlers[u.name]) {
      var i = { name: u.name, component: e.handlersComponent, class: Ql(e.classes.handlers.default, e.classes.handlers[u.name]), wrapperClass: Ql(e.classes.handlersWrappers.default, e.classes.handlersWrappers[u.name]), hoverClass: e.classes.handlers.hover, verticalDirection: u.verticalDirection, horizontalDirection: u.horizontalDirection, disabled: !e.resizable };
      if (n && t) {
        var s = u.horizontalDirection, r = u.verticalDirection, o = s === "east" ? n : s === "west" ? 0 : n / 2, a = r === "south" ? t : r === "north" ? 0 : t / 2;
        i.wrapperClass = ed("handler"), i.wrapperStyle = { transform: "translate(".concat(o, "px, ").concat(a, "px)") }, e.transitions && e.transitions.enabled && (i.wrapperStyle.transition = "".concat(e.transitions.time, "ms ").concat(e.transitions.timingFunction));
      } else
        i.wrapperClass = ed("handler", ge({}, u.classname, !0));
      l.push(i);
    }
  }), l;
} }, beforeMount: function() {
  window.addEventListener("mouseup", this.onMouseUp, { passive: !1 }), window.addEventListener("mousemove", this.onMouseMove, { passive: !1 }), window.addEventListener("touchmove", this.onTouchMove, { passive: !1 }), window.addEventListener("touchend", this.onTouchEnd, { passive: !1 });
}, beforeUnmount: function() {
  window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onTouchMove), window.removeEventListener("touchend", this.onTouchEnd);
}, mounted: function() {
  this.touches = [];
}, methods: { onEnd: function() {
  this.$emit("resize-end");
}, onHandlerDrag: function(e, l, n) {
  var t, u = e.shift(), i = u.left, s = u.top, r = { left: 0, right: 0, top: 0, bottom: 0 };
  l === "west" ? r.left -= i : l === "east" && (r.right += i), n === "north" ? r.top -= s : n === "south" && (r.bottom += s), !n && l ? t = "width" : n && !l && (t = "height"), this.resizable && this.$emit("resize", new qT(r, { allowedDirections: { left: l === "west" || !l, right: l === "east" || !l, bottom: n === "south" || !n, top: n === "north" || !n }, preserveAspectRatio: e.nativeEvent && e.nativeEvent.shiftKey, respectDirection: t }));
} }, emits: ["resize", "resize-end"] };
Nf.render = function(e, l, n, t, u, i) {
  return y(), L("div", { ref: "box", class: i.classes.root, style: i.style }, [V(e.$slots, "default"), R("div", null, [(y(!0), L(hl, null, Sl(i.lineNodes, function(s) {
    return y(), L(Vn(s.component), { key: s.name, "default-class": s.class, "hover-class": s.hoverClass, "wrapper-class": s.wrapperClass, position: s.name, disabled: s.disabled, onDrag: function(r) {
      return i.onHandlerDrag(r, s.horizontalDirection, s.verticalDirection);
    }, onDragEnd: l[1] || (l[1] = function(r) {
      return i.onEnd();
    }) }, null, 8, ["default-class", "hover-class", "wrapper-class", "position", "disabled", "onDrag"]);
  }), 128))]), (y(!0), L(hl, null, Sl(i.handlerNodes, function(s) {
    return y(), L("div", { key: s.name, style: s.wrapperStyle, class: s.wrapperClass }, [(y(), L(Vn(s.component), { "default-class": s.class, "hover-class": s.hoverClass, "wrapper-class": s.wrapperClass, "horizontal-position": s.horizontalDirection, "vertical-position": s.verticalDirection, disabled: s.disabled, onDrag: function(r) {
      return i.onHandlerDrag(r, s.horizontalDirection, s.verticalDirection);
    }, onDragEnd: l[2] || (l[2] = function(r) {
      return i.onEnd();
    }) }, null, 8, ["default-class", "hover-class", "wrapper-class", "horizontal-position", "vertical-position", "disabled", "onDrag"]))], 6);
  }), 128))], 6);
};
var bO = Oe("vue-draggable-area"), Lf = { name: "DraggableArea", props: { movable: { type: Boolean, default: !0 }, activationDistance: { type: Number, default: 20 } }, computed: { classnames: function() {
  return { default: bO() };
} }, beforeMount: function() {
  window.addEventListener("mouseup", this.onMouseUp, { passive: !1 }), window.addEventListener("mousemove", this.onMouseMove, { passive: !1 }), window.addEventListener("touchmove", this.onTouchMove, { passive: !1 }), window.addEventListener("touchend", this.onTouchEnd, { passive: !1 });
}, beforeUnmount: function() {
  window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onTouchMove), window.removeEventListener("touchend", this.onTouchEnd);
}, mounted: function() {
  this.touches = [], this.touchStarted = !1;
}, methods: { onTouchStart: function(e) {
  if (e.cancelable) {
    var l = this.movable && e.touches.length === 1;
    l && (this.touches = Nu(e.touches)), (this.touchStarted || l) && (e.preventDefault(), e.stopPropagation());
  }
}, onTouchEnd: function() {
  this.touchStarted = !1, this.processEnd();
}, onTouchMove: function(e) {
  this.touches.length >= 1 && (this.touchStarted ? (this.processMove(e, e.touches), e.preventDefault(), e.stopPropagation()) : cv({ x: this.touches[0].clientX, y: this.touches[0].clientY }, { x: e.touches[0].clientX, y: e.touches[0].clientY }) > this.activationDistance && (this.initAnchor({ clientX: e.touches[0].clientX, clientY: e.touches[0].clientY }), this.touchStarted = !0));
}, onMouseDown: function(e) {
  if (this.movable && e.button === 0) {
    var l = { fake: !0, clientX: e.clientX, clientY: e.clientY };
    this.touches = [l], this.initAnchor(l), e.stopPropagation();
  }
}, onMouseMove: function(e) {
  this.touches.length && (this.processMove(e, [{ fake: !0, clientX: e.clientX, clientY: e.clientY }]), e.preventDefault && e.cancelable && e.preventDefault(), e.stopPropagation());
}, onMouseUp: function() {
  this.processEnd();
}, initAnchor: function(e) {
  var l = this.$refs.container.getBoundingClientRect(), n = l.left, t = l.top;
  this.anchor = { x: e.clientX - n, y: e.clientY - t };
}, processMove: function(e, l) {
  var n = Nu(l);
  if (this.touches.length) {
    var t = this.$refs.container.getBoundingClientRect(), u = t.left, i = t.top;
    this.touches.length === 1 && n.length === 1 && this.$emit("move", new Rf({ left: n[0].clientX - (u + this.anchor.x), top: n[0].clientY - (i + this.anchor.y) }));
  }
}, processEnd: function() {
  this.touches.length && this.$emit("move-end"), this.touches = [];
} }, emits: ["move", "move-end"] };
Lf.render = function(e, l, n, t, u, i) {
  return y(), L("div", { ref: "container", onTouchstart: l[1] || (l[1] = function() {
    return i.onTouchStart && i.onTouchStart.apply(i, arguments);
  }), onMousedown: l[2] || (l[2] = function() {
    return i.onMouseDown && i.onMouseDown.apply(i, arguments);
  }) }, [V(e.$slots, "default")], 544);
};
function td(e) {
  var l, n;
  return { rotate: e.rotate || 0, flip: { horizontal: ((l = e == null ? void 0 : e.flip) === null || l === void 0 ? void 0 : l.horizontal) || !1, vertical: ((n = e == null ? void 0 : e.flip) === null || n === void 0 ? void 0 : n.vertical) || !1 } };
}
function wO(e) {
  return new Promise(function(l, n) {
    try {
      if (e)
        if (/^data:/i.test(e))
          l(function(o) {
            o = o.replace(/^data:([^;]+);base64,/gim, "");
            for (var a = atob(o), d = a.length, h = new ArrayBuffer(d), p = new Uint8Array(h), f = 0; f < d; f++)
              p[f] = a.charCodeAt(f);
            return h;
          }(e));
        else if (/^blob:/i.test(e)) {
          var t = new FileReader();
          t.onload = function(o) {
            l(o.target.result);
          }, i = e, s = function(o) {
            t.readAsArrayBuffer(o);
          }, (r = new XMLHttpRequest()).open("GET", i, !0), r.responseType = "blob", r.onload = function() {
            this.status != 200 && this.status !== 0 || s(this.response);
          }, r.send();
        } else {
          var u = new XMLHttpRequest();
          u.onreadystatechange = function() {
            u.readyState === 4 && (u.status === 200 || u.status === 0 ? l(u.response) : n("Warning: could not load an image to parse its orientation"), u = null);
          }, u.onprogress = function() {
            u.getResponseHeader("content-type") !== "image/jpeg" && u.abort();
          }, u.withCredentials = !1, u.open("GET", e, !0), u.responseType = "arraybuffer", u.send(null);
        }
      else
        n("Error: the image is empty");
    } catch (o) {
      n(o);
    }
    var i, s, r;
  });
}
function vv(e) {
  var l = e.rotate, n = e.flip, t = e.scaleX, u = e.scaleY, i = "";
  return i += " rotate(" + l + "deg) ", i += " scaleX(" + t * (n.horizontal ? -1 : 1) + ") ", i += " scaleY(" + u * (n.vertical ? -1 : 1) + ") ";
}
function _O(e) {
  try {
    var l, n = new DataView(e), t = void 0, u = void 0, i = void 0, s = void 0;
    if (n.getUint8(0) === 255 && n.getUint8(1) === 216)
      for (var r = n.byteLength, o = 2; o + 1 < r; ) {
        if (n.getUint8(o) === 255 && n.getUint8(o + 1) === 225) {
          i = o;
          break;
        }
        o++;
      }
    if (i && (t = i + 10, function(f, m, g) {
      var v, w = "";
      for (v = m, g += m; v < g; v++)
        w += String.fromCharCode(f.getUint8(v));
      return w;
    }(n, i + 4, 4) === "Exif")) {
      var a = n.getUint16(t);
      if (((u = a === 18761) || a === 19789) && n.getUint16(t + 2, u) === 42) {
        var d = n.getUint32(t + 4, u);
        d >= 8 && (s = t + d);
      }
    }
    if (s) {
      for (var h = n.getUint16(s, u), p = 0; p < h; p++)
        if (o = s + 12 * p + 2, n.getUint16(o, u) === 274) {
          o += 8, l = n.getUint16(o, u), n.setUint16(o, 1, u);
          break;
        }
    }
    return l;
  } catch {
    return null;
  }
}
function em(e, l) {
  var n = l.getBoundingClientRect(), t = n.left, u = n.top, i = { left: 0, top: 0 }, s = 0;
  return e.forEach(function(r) {
    i.left += (r.clientX - t) / e.length, i.top += (r.clientY - u) / e.length;
  }), e.forEach(function(r) {
    s += cv({ x: i.left, y: i.top }, { x: r.clientX - t, y: r.clientY - u });
  }), { centerMass: i, spread: s, count: e.length };
}
var yv = { props: { touchMove: { type: Boolean, required: !0 }, mouseMove: { type: Boolean, required: !0 }, touchResize: { type: Boolean, required: !0 }, wheelResize: { type: [Boolean, Object], required: !0 }, eventsFilter: { type: Function, required: !1 } }, beforeMount: function() {
  window.addEventListener("mouseup", this.onMouseUp, { passive: !1 }), window.addEventListener("mousemove", this.onMouseMove, { passive: !1 }), window.addEventListener("touchmove", this.onTouchMove, { passive: !1 }), window.addEventListener("touchend", this.onTouchEnd, { passive: !1 });
}, beforeUnmount: function() {
  window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onTouchMove), window.removeEventListener("touchend", this.onTouchEnd);
}, created: function() {
  this.transforming = !1, this.debouncedProcessEnd = vh(this.processEnd), this.touches = [];
}, methods: { processMove: function(e, l) {
  if (this.touches.length) {
    if (this.touches.length === 1 && l.length === 1)
      this.$emit("move", new Qi({ left: this.touches[0].clientX - l[0].clientX, top: this.touches[0].clientY - l[0].clientY }));
    else if (this.touches.length > 1 && this.touchResize) {
      var n = em(l, this.$refs.container), t = this.oldGeometricProperties;
      t.count === n.count && t.count > 1 && this.$emit("resize", new Qi({ left: t.centerMass.left - n.centerMass.left, top: t.centerMass.top - n.centerMass.top }, { factor: t.spread / n.spread, center: n.centerMass })), this.oldGeometricProperties = n;
    }
    this.touches = l;
  }
}, processEnd: function() {
  this.transforming && (this.transforming = !1, this.$emit("transform-end"));
}, processStart: function() {
  this.transforming = !0, this.debouncedProcessEnd.clear();
}, processEvent: function(e) {
  return this.eventsFilter ? this.eventsFilter(e, this.transforming) !== !1 : (e.preventDefault(), e.stopPropagation(), !0);
}, onTouchStart: function(e) {
  if (e.cancelable && (this.touchMove || this.touchResize && e.touches.length > 1) && this.processEvent(e)) {
    var l = this.$refs.container, n = l.getBoundingClientRect(), t = n.left, u = n.top, i = n.bottom, s = n.right;
    this.touches = Nu(e.touches).filter(function(r) {
      return r.clientX > t && r.clientX < s && r.clientY > u && r.clientY < i;
    }), this.oldGeometricProperties = em(this.touches, l);
  }
}, onTouchEnd: function(e) {
  e.touches.length === 0 && (this.touches = [], this.processEnd());
}, onTouchMove: function(e) {
  var l = this;
  if (this.touches.length) {
    var n = Nu(e.touches).filter(function(t) {
      return !t.identifier || l.touches.find(function(u) {
        return u.identifier === t.identifier;
      });
    });
    this.processEvent(e) && (this.processMove(e, n), this.processStart());
  }
}, onMouseDown: function(e) {
  if (this.mouseMove && "buttons" in e && e.buttons === 1 && this.processEvent(e)) {
    var l = { fake: !0, clientX: e.clientX, clientY: e.clientY };
    this.touches = [l], this.processStart();
  }
}, onMouseMove: function(e) {
  this.touches.length && this.processEvent(e) && this.processMove(e, [{ clientX: e.clientX, clientY: e.clientY }]);
}, onMouseUp: function() {
  this.touches = [], this.processEnd();
}, onWheel: function(e) {
  if (this.wheelResize && this.processEvent(e)) {
    var l = this.$refs.container.getBoundingClientRect(), n = l.left, t = l.top, u = 1 + this.wheelResize.ratio * (s = e.deltaY || e.detail || e.wheelDelta, (r = +s) == 0 || dv(r) ? r : r > 0 ? 1 : -1), i = { left: e.clientX - n, top: e.clientY - t };
    this.$emit("resize", new Qi({}, { factor: u, center: i })), this.touches.length || this.debouncedProcessEnd();
  }
  var s, r;
} }, emits: ["resize", "move", "transform-end"] };
yv.render = function(e, l, n, t, u, i) {
  return y(), L("div", { ref: "container", onTouchstart: l[1] || (l[1] = function() {
    return i.onTouchStart && i.onTouchStart.apply(i, arguments);
  }), onMousedown: l[2] || (l[2] = function() {
    return i.onMouseDown && i.onMouseDown.apply(i, arguments);
  }), onWheel: l[3] || (l[3] = function() {
    return i.onWheel && i.onWheel.apply(i, arguments);
  }) }, [V(e.$slots, "default")], 544);
};
var wh = { components: { TransformableImage: yv }, props: { touchMove: { type: Boolean, required: !0 }, mouseMove: { type: Boolean, required: !0 }, touchResize: { type: Boolean, required: !0 }, wheelResize: { type: [Boolean, Object], required: !0 } }, emits: ["resize", "move"] };
wh.render = function(e, l, n, t, u, i) {
  var s = Bl("transformable-image");
  return y(), L(s, { "touch-move": n.touchMove, "touch-resize": n.touchResize, "mouse-move": n.mouseMove, "wheel-resize": n.wheelResize, onMove: l[1] || (l[1] = function(r) {
    return e.$emit("move", r);
  }), onResize: l[2] || (l[2] = function(r) {
    return e.$emit("resize", r);
  }) }, { default: U(function() {
    return [V(e.$slots, "default")];
  }), _: 3 }, 8, ["touch-move", "touch-resize", "mouse-move", "wheel-resize"]);
};
var tr = Oe("vue-preview"), $v = { props: { coordinates: { type: Object }, transitions: { type: Object }, image: { type: Object, default: function() {
  return {};
} }, imageClass: { type: String }, width: { type: Number }, height: { type: Number }, fill: { type: Boolean } }, data: function() {
  return { calculatedImageSize: { width: 0, height: 0 }, calculatedSize: { width: 0, height: 0 } };
}, computed: { classes: function() {
  return { root: tr({ fill: this.fill }), wrapper: tr("wrapper"), imageWrapper: tr("image-wrapper"), image: Ql(tr("image"), this.imageClass) };
}, style: function() {
  if (this.fill)
    return {};
  var e = {};
  return this.width && (e.width = "".concat(this.size.width, "px")), this.height && (e.height = "".concat(this.size.height, "px")), this.transitions && this.transitions.enabled && (e.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction)), e;
}, wrapperStyle: function() {
  var e = { width: "".concat(this.size.width, "px"), height: "".concat(this.size.height, "px"), left: "calc(50% - ".concat(this.size.width / 2, "px)"), top: "calc(50% - ".concat(this.size.height / 2, "px)") };
  return this.transitions && this.transitions.enabled && (e.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction)), e;
}, imageStyle: function() {
  if (this.coordinates && this.image) {
    var e = this.coordinates.width / this.size.width, l = Nl(Nl({ rotate: 0, flip: { horizontal: !1, vertical: !1 } }, this.image.transforms), {}, { scaleX: 1 / e, scaleY: 1 / e }), n = this.imageSize.width, t = this.imageSize.height, u = mv({ width: n, height: t }, l.rotate), i = { width: "".concat(n, "px"), height: "".concat(t, "px"), left: "0px", top: "0px" }, s = { rotate: { left: (n - u.width) * l.scaleX / 2, top: (t - u.height) * l.scaleY / 2 }, scale: { left: (1 - l.scaleX) * n / 2, top: (1 - l.scaleY) * t / 2 } };
    return i.transform = `translate(
				`.concat(-this.coordinates.left / e - s.rotate.left - s.scale.left, "px,").concat(-this.coordinates.top / e - s.rotate.top - s.scale.top, "px) ") + vv(l), this.transitions && this.transitions.enabled && (i.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction)), i;
  }
  return {};
}, size: function() {
  return { width: this.width || this.calculatedSize.width, height: this.height || this.calculatedSize.height };
}, imageSize: function() {
  return { width: this.image.width || this.calculatedImageSize.width, height: this.image.height || this.calculatedImageSize.height };
} }, watch: { image: function(e) {
  (e.width || e.height) && this.onChangeImage();
} }, mounted: function() {
  var e = this;
  this.onChangeImage(), this.$refs.image.addEventListener("load", function() {
    e.refreshImage();
  }), window.addEventListener("resize", this.refresh), window.addEventListener("orientationchange", this.refresh);
}, unmounted: function() {
  window.removeEventListener("resize", this.refresh), window.removeEventListener("orientationchange", this.refresh);
}, methods: { refreshImage: function() {
  var e = this.$refs.image;
  this.calculatedImageSize.height = e.naturalHeight, this.calculatedImageSize.width = e.naturalWidth;
}, refresh: function() {
  var e = this.$refs.root;
  this.width || (this.calculatedSize.width = e.clientWidth), this.height || (this.calculatedSize.height = e.clientHeight);
}, onChangeImage: function() {
  var e = this.$refs.image;
  e && e.complete && this.refreshImage(), this.refresh();
} } };
$v.render = function(e, l, n, t, u, i) {
  return y(), L("div", { ref: "root", class: i.classes.root, style: i.style }, [R("div", { ref: "wrapper", class: i.classes.wrapper, style: i.wrapperStyle }, [vl(R("img", { ref: "image", src: n.image && n.image.src, class: i.classes.image, style: i.imageStyle }, null, 14, ["src"]), [[cn, n.image && n.image.src]])], 6)], 6);
};
var Pf = { components: { Preview: $v }, inheritAttrs: !1 };
Pf.render = function(e, l, n, t, u, i) {
  var s = Bl("preview");
  return y(), L(s, ml(e.$attrs, { fill: !0 }), null, 16);
};
var ud = Oe("vue-rectangle-stencil"), Bf = { name: "RectangleStencil", components: { StencilPreview: Pf, BoundingBox: Nf, DraggableArea: Lf }, props: { image: { type: Object }, coordinates: { type: Object }, stencilCoordinates: { type: Object }, handlers: { type: Object }, handlersComponent: { type: [Object, String], default: function() {
  return na;
} }, lines: { type: Object }, linesComponent: { type: [Object, String], default: function() {
  return ea;
} }, aspectRatio: { type: [Number, String] }, minAspectRatio: { type: [Number, String] }, maxAspectRatio: { type: [Number, String] }, movable: { type: Boolean, default: !0 }, resizable: { type: Boolean, default: !0 }, transitions: { type: Object }, movingClass: { type: String }, resizingClass: { type: String }, previewClass: { type: String }, boundingBoxClass: { type: String }, linesClasses: { type: Object, default: function() {
  return {};
} }, linesWrappersClasses: { type: Object, default: function() {
  return {};
} }, handlersClasses: { type: Object, default: function() {
  return {};
} }, handlersWrappersClasses: { type: Object, default: function() {
  return {};
} } }, data: function() {
  return { moving: !1, resizing: !1 };
}, computed: { classes: function() {
  return { stencil: Ql(ud({ movable: this.movable, moving: this.moving, resizing: this.resizing }), this.moving && this.movingClass, this.resizing && this.resizingClass), preview: Ql(ud("preview"), this.previewClass), boundingBox: Ql(ud("bounding-box"), this.boundingBoxClass) };
}, style: function() {
  var e = this.stencilCoordinates, l = e.height, n = e.width, t = e.left, u = e.top, i = { width: "".concat(n, "px"), height: "".concat(l, "px"), transform: "translate(".concat(t, "px, ").concat(u, "px)") };
  return this.transitions && this.transitions.enabled && (i.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction)), i;
} }, methods: { onMove: function(e) {
  this.$emit("move", e), this.moving = !0;
}, onMoveEnd: function() {
  this.$emit("move-end"), this.moving = !1;
}, onResize: function(e) {
  this.$emit("resize", e), this.resizing = !0;
}, onResizeEnd: function() {
  this.$emit("resize-end"), this.resizing = !1;
}, aspectRatios: function() {
  return { minimum: this.aspectRatio || this.minAspectRatio, maximum: this.aspectRatio || this.maxAspectRatio };
} }, emits: ["resize", "resize-end", "move", "move-end"] };
Bf.render = function(e, l, n, t, u, i) {
  var s = Bl("stencil-preview"), r = Bl("draggable-area"), o = Bl("bounding-box");
  return y(), L("div", { class: i.classes.stencil, style: i.style }, [R(o, { width: n.stencilCoordinates.width, height: n.stencilCoordinates.height, transitions: n.transitions, class: i.classes.boundingBox, handlers: n.handlers, "handlers-component": n.handlersComponent, "handlers-classes": n.handlersClasses, "handlers-wrappers-classes": n.handlersWrappersClasses, lines: n.lines, "lines-component": n.linesComponent, "lines-classes": n.linesClasses, "lines-wrappers-classes": n.linesWrappersClasses, resizable: n.resizable, onResize: i.onResize, onResizeEnd: i.onResizeEnd }, { default: U(function() {
    return [R(r, { movable: n.movable, onMove: i.onMove, onMoveEnd: i.onMoveEnd }, { default: U(function() {
      return [R(s, { image: n.image, coordinates: n.coordinates, width: n.stencilCoordinates.width, height: n.stencilCoordinates.height, class: i.classes.preview, transitions: n.transitions }, null, 8, ["image", "coordinates", "width", "height", "class", "transitions"])];
    }), _: 1 }, 8, ["movable", "onMove", "onMoveEnd"])];
  }), _: 1 }, 8, ["width", "height", "transitions", "class", "handlers", "handlers-component", "handlers-classes", "handlers-wrappers-classes", "lines", "lines-component", "lines-classes", "lines-wrappers-classes", "resizable", "onResize", "onResizeEnd"])], 6);
};
var id = Oe("vue-circle-stencil"), bv = { components: { StencilPreview: Pf, BoundingBox: Nf, DraggableArea: Lf }, props: { image: { type: Object }, coordinates: { type: Object }, stencilCoordinates: { type: Object }, handlers: { type: Object, default: function() {
  return { eastNorth: !0, westNorth: !0, westSouth: !0, eastSouth: !0 };
} }, handlersComponent: { type: [Object, String], default: function() {
  return na;
} }, handlersClasses: { type: Object, default: function() {
  return {};
} }, handlersWrappersClasses: { type: Object, default: function() {
  return {};
} }, lines: { type: Object }, linesComponent: { type: [Object, String], default: function() {
  return ea;
} }, linesClasses: { type: Object, default: function() {
  return {};
} }, linesWrappersClasses: { type: Object, default: function() {
  return {};
} }, movable: { type: Boolean, default: !0 }, resizable: { type: Boolean, default: !0 }, transitions: { type: Object }, movingClass: { type: String }, resizingClass: { type: String }, previewClass: { type: String }, boundingBoxClass: { type: String } }, data: function() {
  return { moving: !1, resizing: !1 };
}, computed: { classes: function() {
  return { stencil: Ql(id({ movable: this.movable, moving: this.moving, resizing: this.resizing }), this.moving && this.movingClass, this.resizing && this.resizingClass), preview: Ql(id("preview"), this.previewClass), boundingBox: Ql(id("bounding-box"), this.boundingBoxClass) };
}, style: function() {
  var e = this.stencilCoordinates, l = e.height, n = e.width, t = e.left, u = e.top, i = { width: "".concat(n, "px"), height: "".concat(l, "px"), transform: "translate(".concat(t, "px, ").concat(u, "px)") };
  return this.transitions && this.transitions.enabled && (i.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction)), i;
} }, methods: { onMove: function(e) {
  this.$emit("move", e), this.moving = !0;
}, onMoveEnd: function() {
  this.$emit("move-end"), this.moving = !1;
}, onResize: function(e) {
  this.$emit("resize", e), this.resizing = !0;
}, onResizeEnd: function() {
  this.$emit("resize-end"), this.resizing = !1;
}, aspectRatios: function() {
  return { minimum: 1, maximum: 1 };
} }, emits: ["resize", "resize-end", "move", "move-end"] };
bv.render = function(e, l, n, t, u, i) {
  var s = Bl("stencil-preview"), r = Bl("draggable-area"), o = Bl("bounding-box");
  return y(), L("div", { class: i.classes.stencil, style: i.style }, [R(o, { width: n.stencilCoordinates.width, height: n.stencilCoordinates.height, transitions: n.transitions, class: i.classes.boundingBox, handlers: n.handlers, "handlers-component": n.handlersComponent, "handlers-classes": n.handlersClasses, "handlers-wrappers-classes": n.handlersWrappersClasses, lines: n.lines, "lines-component": n.linesComponent, "lines-classes": n.linesClasses, "lines-wrappers-classes": n.linesWrappersClasses, resizable: n.resizable, onResize: i.onResize, onResizeEnd: i.onResizeEnd }, { default: U(function() {
    return [R(r, { movable: n.movable, onMove: i.onMove, onMoveEnd: i.onMoveEnd }, { default: U(function() {
      return [R(s, { image: n.image, coordinates: n.coordinates, width: n.stencilCoordinates.width, height: n.stencilCoordinates.height, class: i.classes.preview, transitions: n.transitions }, null, 8, ["image", "coordinates", "width", "height", "class", "transitions"])];
    }), _: 1 }, 8, ["movable", "onMove", "onMoveEnd"])];
  }), _: 1 }, 8, ["width", "height", "transitions", "class", "handlers", "handlers-component", "handlers-classes", "handlers-wrappers-classes", "lines", "lines-component", "lines-classes", "lines-wrappers-classes", "resizable", "onResize", "onResizeEnd"])], 6);
};
var SO = ["transitions"], _t = Oe("vue-advanced-cropper"), wv = { name: "Cropper", components: { BackgroundWrapper: wh }, props: { src: { type: String, default: null }, stencilComponent: { type: [Object, String], default: function() {
  return Bf;
} }, backgroundWrapperComponent: { type: [Object, String], default: function() {
  return wh;
} }, stencilProps: { type: Object, default: function() {
  return {};
} }, autoZoom: { type: Boolean, default: !1 }, imageClass: { type: String }, boundariesClass: { type: String }, backgroundClass: { type: String }, foregroundClass: { type: String }, minWidth: { type: [Number, String] }, minHeight: { type: [Number, String] }, maxWidth: { type: [Number, String] }, maxHeight: { type: [Number, String] }, debounce: { type: [Boolean, Number], default: 500 }, transitions: { type: Boolean, default: !0 }, checkOrientation: { type: Boolean, default: !0 }, canvas: { type: [Object, Boolean], default: !0 }, crossOrigin: { type: [Boolean, String], default: void 0 }, transitionTime: { type: Number, default: 300 }, imageRestriction: { type: String, default: "fit-area", validator: function(e) {
  return nO.indexOf(e) !== -1;
} }, roundResult: { type: Boolean, default: !0 }, defaultSize: { type: [Function, Object] }, defaultPosition: { type: [Function, Object] }, defaultVisibleArea: { type: [Function, Object] }, defaultTransforms: { type: [Function, Object] }, defaultBoundaries: { type: [Function, String], validator: function(e) {
  return !(typeof e == "string" && e !== "fill" && e !== "fit");
} }, priority: { type: String, default: "coordinates" }, stencilSize: { type: [Object, Function] }, resizeImage: { type: [Boolean, Object], default: !0 }, moveImage: { type: [Boolean, Object], default: !0 }, autoZoomAlgorithm: { type: Function }, resizeAlgorithm: { type: Function, default: function(e) {
  var l = e.event, n = e.coordinates, t = e.aspectRatio, u = e.positionRestrictions, i = e.sizeRestrictions, s = cl(cl({}, n), { right: n.left + n.width, bottom: n.top + n.height }), r = l.params || {}, o = cl({}, l.directions), a = r.allowedDirections || { left: !0, right: !0, bottom: !0, top: !0 };
  i.widthFrozen && (o.left = 0, o.right = 0), i.heightFrozen && (o.top = 0, o.bottom = 0), nt.forEach(function(b) {
    a[b] || (o[b] = 0);
  });
  var d = Qe(s, o = nm({ coordinates: s, directions: o, sizeRestrictions: i, positionRestrictions: u })).width, h = Qe(s, o).height, p = r.preserveRatio ? Ll(s) : nd(d / h, t);
  if (p) {
    var f = r.respectDirection;
    if (f || (f = s.width >= s.height || p === 1 ? "width" : "height"), f === "width") {
      var m = d / p - s.height;
      if (a.top && a.bottom) {
        var g = o.top, v = o.bottom;
        o.bottom = er(m, v, g), o.top = er(m, g, v);
      } else
        a.bottom ? o.bottom = m : a.top ? o.top = m : a.right ? o.right = 0 : a.left && (o.left = 0);
    } else if (f === "height") {
      var w = s.width - h * p;
      if (a.left && a.right) {
        var $ = o.left, _ = o.right;
        o.left = -er(w, $, _), o.right = -er(w, _, $);
      } else
        a.left ? o.left = -w : a.right ? o.right = -w : a.top ? o.top = 0 : a.bottom && (o.bottom = 0);
    }
    o = nm({ directions: o, coordinates: s, sizeRestrictions: i, positionRestrictions: u, preserveRatio: !0, compensate: r.compensate });
  }
  return d = Qe(s, o).width, h = Qe(s, o).height, (p = r.preserveRatio ? Ll(s) : nd(d / h, t)) && Math.abs(p - d / h) > 1e-3 && nt.forEach(function(b) {
    a[b] || (o[b] = 0);
  }), bh({ event: new Rf({ left: -o.left, top: -o.top }), coordinates: { width: n.width + o.right + o.left, height: n.height + o.top + o.bottom, left: n.left, top: n.top }, positionRestrictions: u });
} }, moveAlgorithm: { type: Function, default: bh }, initStretcher: { type: Function, default: function(e) {
  var l = e.stretcher, n = e.imageSize, t = Ll(n);
  l.style.width = n.width + "px", l.style.height = l.clientWidth / t + "px", l.style.width = l.clientWidth + "px";
} }, fitCoordinates: { type: Function, default: function(e) {
  var l = e.visibleArea, n = e.coordinates, t = e.aspectRatio, u = e.sizeRestrictions, i = e.positionRestrictions, s = cl(cl({}, n), kt({ width: n.width, height: n.height, aspectRatio: t, sizeRestrictions: { maxWidth: l.width, maxHeight: l.height, minHeight: Math.min(l.height, u.minHeight), minWidth: Math.min(l.width, u.minWidth) } }));
  return s = Cn(s = Jn(s, vi(Sn(n), Sn(s))), la(mt(l), i));
} }, fitVisibleArea: { type: Function, default: function(e) {
  var l = e.visibleArea, n = e.boundaries, t = e.getAreaRestrictions, u = e.coordinates, i = cl({}, l);
  i.height = i.width / Ll(n), i.top += (l.height - i.height) / 2, (u.height - i.height > 0 || u.width - i.width > 0) && (i = $e(i, Math.max(u.height / i.height, u.width / i.width)));
  var s = Xo($i(u, mt(i = $e(i, Qo(i, t({ visibleArea: i, type: "resize" }))))));
  return i.width < u.width && (s.left = 0), i.height < u.height && (s.top = 0), i = Cn(i = Jn(i, s), t({ visibleArea: i, type: "move" }));
} }, areaRestrictionsAlgorithm: { type: Function, default: function(e) {
  var l = e.visibleArea, n = e.boundaries, t = e.imageSize, u = e.imageRestriction, i = e.type, s = {};
  return u === "fill-area" ? s = { left: 0, top: 0, right: t.width, bottom: t.height } : u === "fit-area" && (Ll(n) > Ll(t) ? (s = { top: 0, bottom: t.height }, l && i === "move" && (l.width > t.width ? (s.left = -(l.width - t.width) / 2, s.right = t.width - s.left) : (s.left = 0, s.right = t.width))) : (s = { left: 0, right: t.width }, l && i === "move" && (l.height > t.height ? (s.top = -(l.height - t.height) / 2, s.bottom = t.height - s.top) : (s.top = 0, s.bottom = t.height)))), s;
} }, sizeRestrictionsAlgorithm: { type: Function, default: function(e) {
  return { minWidth: e.minWidth, minHeight: e.minHeight, maxWidth: e.maxWidth, maxHeight: e.maxHeight };
} }, positionRestrictionsAlgorithm: { type: Function, default: function(e) {
  var l = e.imageSize, n = {};
  return e.imageRestriction !== "none" && (n = { left: 0, top: 0, right: l.width, bottom: l.height }), n;
} } }, data: function() {
  return { transitionsActive: !1, imageLoaded: !1, imageAttributes: { width: null, height: null, crossOrigin: null, src: null }, defaultImageTransforms: { rotate: 0, flip: { horizontal: !1, vertical: !1 } }, appliedImageTransforms: { rotate: 0, flip: { horizontal: !1, vertical: !1 } }, boundaries: { width: 0, height: 0 }, visibleArea: null, coordinates: Nl({}, Z0) };
}, computed: { image: function() {
  return { src: this.imageAttributes.src, width: this.imageAttributes.width, height: this.imageAttributes.height, transforms: this.imageTransforms };
}, imageTransforms: function() {
  return { rotate: this.appliedImageTransforms.rotate, flip: { horizontal: this.appliedImageTransforms.flip.horizontal, vertical: this.appliedImageTransforms.flip.vertical }, translateX: this.visibleArea ? this.visibleArea.left / this.coefficient : 0, translateY: this.visibleArea ? this.visibleArea.top / this.coefficient : 0, scaleX: 1 / this.coefficient, scaleY: 1 / this.coefficient };
}, imageSize: function() {
  var e = function(l) {
    return l * Math.PI / 180;
  }(this.imageTransforms.rotate);
  return { width: Math.abs(this.imageAttributes.width * Math.cos(e)) + Math.abs(this.imageAttributes.height * Math.sin(e)), height: Math.abs(this.imageAttributes.width * Math.sin(e)) + Math.abs(this.imageAttributes.height * Math.cos(e)) };
}, initialized: function() {
  return !!(this.visibleArea && this.imageLoaded);
}, settings: function() {
  var e = yh(this.resizeImage, { touch: !0, wheel: { ratio: 0.1 }, adjustStencil: !0 }, { touch: !1, wheel: !1, adjustStencil: !1 });
  return { moveImage: yh(this.moveImage, { touch: !0, mouse: !0 }, { touch: !1, mouse: !1 }), resizeImage: e };
}, coefficient: function() {
  return this.visibleArea ? this.visibleArea.width / this.boundaries.width : 0;
}, areaRestrictions: function() {
  return this.imageLoaded ? this.areaRestrictionsAlgorithm({ imageSize: this.imageSize, imageRestriction: this.imageRestriction, boundaries: this.boundaries }) : {};
}, transitionsOptions: function() {
  return { enabled: this.transitionsActive, timingFunction: "ease-in-out", time: 350 };
}, sizeRestrictions: function() {
  if (this.boundaries.width && this.boundaries.height && this.imageSize.width && this.imageSize.height) {
    var e = this.sizeRestrictionsAlgorithm({ imageSize: this.imageSize, minWidth: on(this.minWidth) ? 0 : lr(this.minWidth), minHeight: on(this.minHeight) ? 0 : lr(this.minHeight), maxWidth: on(this.maxWidth) ? 1 / 0 : lr(this.maxWidth), maxHeight: on(this.maxHeight) ? 1 / 0 : lr(this.maxHeight) });
    if (e = function(t) {
      var u = t.areaRestrictions, i = t.sizeRestrictions;
      t.imageSize;
      var s = t.boundaries, r = t.positionRestrictions;
      t.imageRestriction;
      var o = cl(cl({}, i), { minWidth: i.minWidth !== void 0 ? i.minWidth : 0, minHeight: i.minHeight !== void 0 ? i.minHeight : 0, maxWidth: i.maxWidth !== void 0 ? i.maxWidth : 1 / 0, maxHeight: i.maxHeight !== void 0 ? i.maxHeight : 1 / 0 });
      r.left !== void 0 && r.right !== void 0 && (o.maxWidth = Math.min(o.maxWidth, r.right - r.left)), r.bottom !== void 0 && r.top !== void 0 && (o.maxHeight = Math.min(o.maxHeight, r.bottom - r.top));
      var a = $h(u), d = fv(s, a);
      return a.width < 1 / 0 && (!o.maxWidth || o.maxWidth > d.width) && (o.maxWidth = Math.min(o.maxWidth, d.width)), a.height < 1 / 0 && (!o.maxHeight || o.maxHeight > d.height) && (o.maxHeight = Math.min(o.maxHeight, d.height)), o.minWidth > o.maxWidth && (o.minWidth = o.maxWidth, o.widthFrozen = !0), o.minHeight > o.maxHeight && (o.minHeight = o.maxHeight, o.heightFrozen = !0), o;
    }({ sizeRestrictions: e, areaRestrictions: this.getAreaRestrictions({ visibleArea: this.visibleArea, type: "resize" }), imageSize: this.imageSize, boundaries: this.boundaries, positionRestrictions: this.positionRestrictions, imageRestriction: this.imageRestriction, visibleArea: this.visibleArea, stencilSize: this.getStencilSize() }), this.visibleArea && this.stencilSize) {
      var l = this.getStencilSize(), n = $h(this.getAreaRestrictions({ visibleArea: this.visibleArea, type: "resize" }));
      e.maxWidth = Math.min(e.maxWidth, n.width * l.width / this.boundaries.width), e.maxHeight = Math.min(e.maxHeight, n.height * l.height / this.boundaries.height), e.maxWidth < e.minWidth && (e.minWidth = e.maxWidth), e.maxHeight < e.minHeight && (e.minHeight = e.maxHeight);
    }
    return e;
  }
  return { minWidth: 0, minHeight: 0, maxWidth: 0, maxHeight: 0 };
}, positionRestrictions: function() {
  return this.positionRestrictionsAlgorithm({ imageSize: this.imageSize, imageRestriction: this.imageRestriction });
}, classes: function() {
  return { cropper: _t(), image: Ql(_t("image"), this.imageClass), stencil: _t("stencil"), boundaries: Ql(_t("boundaries"), this.boundariesClass), stretcher: Ql(_t("stretcher")), background: Ql(_t("background"), this.backgroundClass), foreground: Ql(_t("foreground"), this.foregroundClass), imageWrapper: Ql(_t("image-wrapper")), cropperWrapper: Ql(_t("cropper-wrapper")) };
}, stencilCoordinates: function() {
  if (this.initialized) {
    var e = this.coordinates, l = e.width, n = e.height, t = e.left, u = e.top;
    return { width: l / this.coefficient, height: n / this.coefficient, left: (t - this.visibleArea.left) / this.coefficient, top: (u - this.visibleArea.top) / this.coefficient };
  }
  return this.defaultCoordinates();
}, boundariesStyle: function() {
  var e = { width: this.boundaries.width ? "".concat(Math.round(this.boundaries.width), "px") : "auto", height: this.boundaries.height ? "".concat(Math.round(this.boundaries.height), "px") : "auto", transition: "opacity ".concat(this.transitionTime, "ms"), pointerEvents: this.imageLoaded ? "all" : "none" };
  return this.imageLoaded || (e.opacity = "0"), e;
}, imageStyle: function() {
  var e = this.imageAttributes.width > this.imageAttributes.height ? { width: Math.min(1024, this.imageAttributes.width), height: Math.min(1024, this.imageAttributes.width) / (this.imageAttributes.width / this.imageAttributes.height) } : { height: Math.min(1024, this.imageAttributes.height), width: Math.min(1024, this.imageAttributes.height) * (this.imageAttributes.width / this.imageAttributes.height) }, l = { left: (e.width - this.imageSize.width) / (2 * this.coefficient), top: (e.height - this.imageSize.height) / (2 * this.coefficient) }, n = { left: (1 - 1 / this.coefficient) * e.width / 2, top: (1 - 1 / this.coefficient) * e.height / 2 }, t = Nl(Nl({}, this.imageTransforms), {}, { scaleX: this.imageTransforms.scaleX * (this.imageAttributes.width / e.width), scaleY: this.imageTransforms.scaleY * (this.imageAttributes.height / e.height) }), u = { width: "".concat(e.width, "px"), height: "".concat(e.height, "px"), left: "0px", top: "0px", transform: "translate(".concat(-l.left - n.left - this.imageTransforms.translateX, "px, ").concat(-l.top - n.top - this.imageTransforms.translateY, "px)") + vv(t) };
  return this.transitionsOptions.enabled && (u.transition = "".concat(this.transitionsOptions.time, "ms ").concat(this.transitionsOptions.timingFunction)), u;
} }, watch: { src: function() {
  this.onChangeImage();
}, stencilComponent: function() {
  var e = this;
  this.$nextTick(function() {
    e.resetCoordinates(), e.runAutoZoom("setCoordinates"), e.onChange();
  });
}, minWidth: function() {
  this.onPropsChange();
}, maxWidth: function() {
  this.onPropsChange();
}, minHeight: function() {
  this.onPropsChange();
}, maxHeight: function() {
  this.onPropsChange();
}, imageRestriction: function() {
  this.reset();
}, stencilProps: function(e, l) {
  ["aspectRatio", "minAspectRatio", "maxAspectRatio"].find(function(n) {
    return e[n] !== l[n];
  }) && this.$nextTick(this.onPropsChange);
} }, created: function() {
  this.debouncedUpdate = vh(this.update, this.debounce), this.debouncedDisableTransitions = vh(this.disableTransitions, this.transitionsOptions.time), this.awaiting = !1;
}, mounted: function() {
  this.$refs.image.addEventListener("load", this.onSuccessLoadImage), this.$refs.image.addEventListener("error", this.onFailLoadImage), this.onChangeImage(), window.addEventListener("resize", this.refresh), window.addEventListener("orientationchange", this.refresh);
}, unmounted: function() {
  window.removeEventListener("resize", this.refresh), window.removeEventListener("orientationchange", this.refresh), this.imageAttributes.revoke && this.imageAttributes.src && URL.revokeObjectURL(this.imageAttributes.src), this.debouncedUpdate.clear(), this.debouncedDisableTransitions.clear();
}, methods: { getResult: function() {
  var e = this.initialized ? this.prepareResult(Nl({}, this.coordinates)) : this.defaultCoordinates(), l = { rotate: this.imageTransforms.rotate % 360, flip: Nl({}, this.imageTransforms.flip) };
  if (this.src && this.imageLoaded) {
    var n = this;
    return { image: this.image, coordinates: e, visibleArea: this.visibleArea ? Nl({}, this.visibleArea) : null, imageTransforms: l, get canvas() {
      return n.canvas ? n.getCanvas() : void 0;
    } };
  }
  return { image: this.image, coordinates: e, visibleArea: this.visibleArea ? Nl({}, this.visibleArea) : null, canvas: void 0, imageTransforms: l };
}, zoom: function(e, l) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, t = n.transitions, u = t === void 0 || t;
  this.onManipulateImage(new Qi({}, { factor: 1 / e, center: l }), { normalize: !1, transitions: u });
}, move: function(e, l) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, t = n.transitions, u = t === void 0 || t;
  this.onManipulateImage(new Qi({ left: e || 0, top: l || 0 }), { normalize: !1, transitions: u });
}, setCoordinates: function(e) {
  var l = this, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = n.autoZoom, u = t === void 0 || t, i = n.transitions, s = i === void 0 || i;
  this.$nextTick(function() {
    l.imageLoaded ? (l.transitionsActive || (s && l.enableTransitions(), l.coordinates = l.applyTransform(e), u && l.runAutoZoom("setCoordinates"), s && l.debouncedDisableTransitions()), l.onChange()) : l.delayedTransforms = e;
  });
}, refresh: function() {
  var e = this, l = this.$refs.image;
  if (this.src && l)
    return this.initialized ? this.updateVisibleArea().then(function() {
      e.onChange();
    }) : this.resetVisibleArea().then(function() {
      e.onChange();
    });
}, reset: function() {
  var e = this;
  return this.resetVisibleArea().then(function() {
    e.onChange(!1);
  });
}, awaitRender: function(e) {
  var l = this;
  this.awaiting || (this.awaiting = !0, this.$nextTick(function() {
    e(), l.awaiting = !1;
  }));
}, prepareResult: function(e) {
  return this.roundResult ? function(l) {
    var n = l.coordinates, t = l.sizeRestrictions, u = l.positionRestrictions, i = { width: Math.round(n.width), height: Math.round(n.height), left: Math.round(n.left), top: Math.round(n.top) };
    return i.width > t.maxWidth ? i.width = Math.floor(n.width) : i.width < t.minWidth && (i.width = Math.ceil(n.width)), i.height > t.maxHeight ? i.height = Math.floor(n.height) : i.height < t.minHeight && (i.height = Math.ceil(n.height)), Cn(i, u);
  }(Nl(Nl({}, this.getPublicProperties()), {}, { positionRestrictions: nr(this.positionRestrictions, this.visibleArea), coordinates: e })) : e;
}, processAutoZoom: function(e, l, n, t) {
  var u = this.autoZoomAlgorithm;
  u || (u = this.stencilSize ? uO : this.autoZoom ? iO : sO);
  var i = u({ event: { type: e, params: t }, visibleArea: l, coordinates: n, boundaries: this.boundaries, aspectRatio: this.getAspectRatio(), positionRestrictions: this.positionRestrictions, getAreaRestrictions: this.getAreaRestrictions, sizeRestrictions: this.sizeRestrictions, stencilSize: this.getStencilSize() });
  return Nl(Nl({}, i), {}, { changed: !X0(i.visibleArea, l) || !X0(i.coordinates, n) });
}, runAutoZoom: function(e) {
  var l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = l.transitions, t = n !== void 0 && n, u = KT(l, SO), i = this.processAutoZoom(e, this.visibleArea, this.coordinates, u), s = i.visibleArea, r = i.coordinates, o = i.changed;
  t && o && this.enableTransitions(), this.visibleArea = s, this.coordinates = r, t && o && this.debouncedDisableTransitions();
}, normalizeEvent: function(e) {
  return function(l) {
    var n = l.event, t = l.visibleArea, u = l.coefficient;
    if (n.type === "manipulateImage")
      return cl(cl({}, n), { move: { left: n.move && n.move.left ? u * n.move.left : 0, top: n.move && n.move.top ? u * n.move.top : 0 }, scale: { factor: n.scale && n.scale.factor ? n.scale.factor : 1, center: n.scale && n.scale.center ? { left: n.scale.center.left * u + t.left, top: n.scale.center.top * u + t.top } : null } });
    if (n.type === "resize") {
      var i = cl(cl({}, n), { directions: cl({}, n.directions) });
      return nt.forEach(function(r) {
        i.directions[r] *= u;
      }), i;
    }
    if (n.type === "move") {
      var s = cl(cl({}, n), { directions: cl({}, n.directions) });
      return lO.forEach(function(r) {
        s.directions[r] *= u;
      }), s;
    }
    return n;
  }(Nl(Nl({}, this.getPublicProperties()), {}, { event: e }));
}, getCanvas: function() {
  if (this.$refs.canvas) {
    var e = this.$refs.canvas, l = this.$refs.image, n = this.imageTransforms.rotate !== 0 || this.imageTransforms.flip.horizontal || this.imageTransforms.flip.vertical ? function(r, o, a) {
      var d = a.rotate, h = a.flip, p = { width: o.naturalWidth, height: o.naturalHeight }, f = mv(p, d), m = r.getContext("2d");
      r.height = f.height, r.width = f.width, m.save();
      var g = Wt(Sn(cl({ left: 0, top: 0 }, p)), d);
      return m.translate(-(g.left - f.width / 2), -(g.top - f.height / 2)), m.rotate(d * Math.PI / 180), m.translate(h.horizontal ? p.width : 0, h.vertical ? p.height : 0), m.scale(h.horizontal ? -1 : 1, h.vertical ? -1 : 1), m.drawImage(o, 0, 0, p.width, p.height), m.restore(), r;
    }(this.$refs.sourceCanvas, l, this.imageTransforms) : l, t = Nl({ minWidth: 0, minHeight: 0, maxWidth: 1 / 0, maxHeight: 1 / 0, maxArea: this.maxCanvasSize, imageSmoothingEnabled: !0, imageSmoothingQuality: "high", fillColor: "transparent" }, this.canvas), u = function(r) {
      return r.find(function(o) {
        return a = o, !Number.isNaN(parseFloat(a)) && isFinite(a);
        var a;
      });
    }, i = kt({ sizeRestrictions: { minWidth: u([t.width, t.minWidth]) || 0, minHeight: u([t.height, t.minHeight]) || 0, maxWidth: u([t.width, t.maxWidth]) || 1 / 0, maxHeight: u([t.height, t.maxHeight]) || 1 / 0 }, width: this.coordinates.width, height: this.coordinates.height, aspectRatio: { minimum: this.coordinates.width / this.coordinates.height, maximum: this.coordinates.width / this.coordinates.height } });
    if (t.maxArea && i.width * i.height > t.maxArea) {
      var s = Math.sqrt(t.maxArea / (i.width * i.height));
      i = { width: Math.round(s * i.width), height: Math.round(s * i.height) };
    }
    return function(r, o, a, d, h) {
      r.width = d ? d.width : a.width, r.height = d ? d.height : a.height;
      var p = r.getContext("2d");
      p.clearRect(0, 0, r.width, r.height), h && (h.imageSmoothingEnabled && (p.imageSmoothingEnabled = h.imageSmoothingEnabled), h.imageSmoothingQuality && (p.imageSmoothingQuality = h.imageSmoothingQuality), h.fillColor && (p.fillStyle = h.fillColor, p.fillRect(0, 0, r.width, r.height), p.save()));
      var f = a.left < 0 ? -a.left : 0, m = a.top < 0 ? -a.top : 0;
      p.drawImage(o, a.left + f, a.top + m, a.width, a.height, f, m, r.width, r.height);
    }(e, n, this.coordinates, i, t), e;
  }
}, update: function() {
  this.$emit("change", this.getResult());
}, applyTransform: function(e) {
  var l = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], n = this.visibleArea && l ? eO(this.sizeRestrictions, this.visibleArea) : this.sizeRestrictions, t = this.visibleArea && l ? nr(this.positionRestrictions, this.visibleArea) : this.positionRestrictions;
  return tO({ transform: e, coordinates: this.coordinates, imageSize: this.imageSize, sizeRestrictions: n, positionRestrictions: t, aspectRatio: this.getAspectRatio(), visibleArea: this.visibleArea });
}, resetCoordinates: function() {
  var e = this;
  if (this.$refs.image) {
    this.$refs.cropper, this.$refs.image;
    var l = this.defaultSize;
    l || (l = this.stencilSize ? aO : oO);
    var n = this.sizeRestrictions;
    n.minWidth, n.minHeight, n.maxWidth, n.maxHeight;
    var t = Ku(l) ? l({ boundaries: this.boundaries, imageSize: this.imageSize, aspectRatio: this.getAspectRatio(), sizeRestrictions: this.sizeRestrictions, stencilSize: this.getStencilSize(), visibleArea: this.visibleArea }) : l, u = this.defaultPosition || rO, i = [t, function(s) {
      var r = s.coordinates;
      return Nl({}, Ku(u) ? u({ coordinates: r, imageSize: e.imageSize, visibleArea: e.visibleArea }) : e.defaultPosition);
    }];
    this.delayedTransforms && i.push.apply(i, Nu(Array.isArray(this.delayedTransforms) ? this.delayedTransforms : [this.delayedTransforms])), this.coordinates = this.applyTransform(i, !0), this.delayedTransforms = null;
  }
}, clearImage: function() {
  var e = this;
  this.imageLoaded = !1, setTimeout(function() {
    var l = e.$refs.stretcher;
    l && (l.style.height = "auto", l.style.width = "auto"), e.coordinates = e.defaultCoordinates(), e.boundaries = { width: 0, height: 0 };
  }, this.transitionTime);
}, enableTransitions: function() {
  this.transitions && (this.transitionsActive = !0);
}, disableTransitions: function() {
  this.transitionsActive = !1;
}, updateBoundaries: function() {
  var e = this, l = this.$refs.stretcher, n = this.$refs.cropper;
  return this.initStretcher({ cropper: n, stretcher: l, imageSize: this.imageSize }), this.$nextTick().then(function() {
    var t = { cropper: n, imageSize: e.imageSize };
    if (Ku(e.defaultBoundaries) ? e.boundaries = e.defaultBoundaries(t) : e.defaultBoundaries === "fit" ? e.boundaries = function(u) {
      var i = u.cropper, s = u.imageSize, r = i.clientHeight, o = i.clientWidth, a = r, d = s.width * r / s.height;
      return d > o && (d = o, a = s.height * o / s.width), { width: d, height: a };
    }(t) : e.boundaries = function(u) {
      var i = u.cropper;
      return { width: i.clientWidth, height: i.clientHeight };
    }(t), !e.boundaries.width || !e.boundaries.height)
      throw new Error("It's impossible to fit the cropper in the current container");
  });
}, resetVisibleArea: function() {
  var e = this;
  return this.appliedImageTransforms = Nl(Nl({}, this.defaultImageTransforms), {}, { flip: Nl({}, this.defaultImageTransforms.flip) }), this.updateBoundaries().then(function() {
    e.priority !== "visible-area" && (e.visibleArea = null, e.resetCoordinates());
    var l, n, t, u, i, s, r = e.defaultVisibleArea || dO;
    e.visibleArea = Ku(r) ? r({ imageSize: e.imageSize, boundaries: e.boundaries, coordinates: e.priority !== "visible-area" ? e.coordinates : null, getAreaRestrictions: e.getAreaRestrictions, stencilSize: e.getStencilSize() }) : e.defaultVisibleArea, e.visibleArea = (l = { visibleArea: e.visibleArea, boundaries: e.boundaries, getAreaRestrictions: e.getAreaRestrictions }, n = l.visibleArea, t = l.boundaries, u = l.getAreaRestrictions, i = cl({}, n), s = Ll(t), i.width / i.height !== s && (i.height = i.width / s), Cn(i, u({ visibleArea: i, type: "move" }))), e.priority === "visible-area" ? e.resetCoordinates() : e.coordinates = e.fitCoordinates({ visibleArea: e.visibleArea, coordinates: e.coordinates, aspectRatio: e.getAspectRatio(), positionRestrictions: e.positionRestrictions, sizeRestrictions: e.sizeRestrictions }), e.runAutoZoom("resetVisibleArea");
  }).catch(function() {
    e.visibleArea = null;
  });
}, updateVisibleArea: function() {
  var e = this;
  return this.updateBoundaries().then(function() {
    e.visibleArea = e.fitVisibleArea({ imageSize: e.imageSize, boundaries: e.boundaries, visibleArea: e.visibleArea, coordinates: e.coordinates, getAreaRestrictions: e.getAreaRestrictions }), e.coordinates = e.fitCoordinates({ visibleArea: e.visibleArea, coordinates: e.coordinates, aspectRatio: e.getAspectRatio(), positionRestrictions: e.positionRestrictions, sizeRestrictions: e.sizeRestrictions }), e.runAutoZoom("updateVisibleArea");
  }).catch(function() {
    e.visibleArea = null;
  });
}, onChange: function() {
  var e = !(arguments.length > 0 && arguments[0] !== void 0) || arguments[0];
  e && this.debounce ? this.debouncedUpdate() : this.update();
}, onChangeImage: function() {
  var e, l = this;
  if (this.imageLoaded = !1, this.delayedTransforms = null, this.src) {
    if (function(u) {
      if (q0(u))
        return !1;
      var i = window.location, s = /(\w+:)?(?:\/\/)([\w.-]+)?(?::(\d+))?\/?/.exec(u) || [], r = { protocol: s[1] || "", host: s[2] || "", port: s[3] || "" }, o = function(a) {
        return a.port || ((a.protocol || i.protocol) === "http" ? 80 : 433);
      };
      return !(!r.protocol && !r.host && !r.port || r.protocol && r.protocol == i.protocol && r.host && r.host == i.host && r.host && o(r) == o(i));
    }(this.src)) {
      var n = on(this.crossOrigin) ? this.canvas : this.crossOrigin;
      n === !0 && (n = "anonymous"), this.imageAttributes.crossOrigin = n || null;
    }
    if (this.checkOrientation) {
      var t = (e = this.src, new Promise(function(u) {
        wO(e).then(function(i) {
          var s = _O(i);
          u(i ? { source: e, arrayBuffer: i, orientation: s } : { source: e, arrayBuffer: null, orientation: null });
        }).catch(function(i) {
          console.warn(i), u({ source: e, arrayBuffer: null, orientation: null });
        });
      }));
      setTimeout(function() {
        t.then(l.onParseImage);
      }, this.transitionTime);
    } else
      setTimeout(function() {
        l.onParseImage({ source: l.src });
      }, this.transitionTime);
  } else
    this.clearImage();
}, onFailLoadImage: function() {
  this.imageAttributes.src && (this.clearImage(), this.$emit("error"));
}, onSuccessLoadImage: function() {
  var e = this, l = this.$refs.image;
  l && !this.imageLoaded && (this.imageAttributes.height = l.naturalHeight, this.imageAttributes.width = l.naturalWidth, this.imageLoaded = !0, this.resetVisibleArea().then(function() {
    e.$emit("ready"), e.onChange(!1);
  }));
}, onParseImage: function(e) {
  var l = this, n = e.source, t = e.arrayBuffer, u = e.orientation;
  this.imageAttributes.revoke && this.imageAttributes.src && URL.revokeObjectURL(this.imageAttributes.src), this.imageAttributes.revoke = !1, t && u && u > 1 ? av(n) || !q0(n) ? (this.imageAttributes.src = URL.createObjectURL(new Blob([t])), this.imageAttributes.revoke = !0) : this.imageAttributes.src = function(i) {
    for (var s = [], r = new Uint8Array(i); r.length > 0; ) {
      var o = r.subarray(0, 8192);
      s.push(String.fromCharCode.apply(null, Array.from ? Array.from(o) : o.slice())), r = r.subarray(8192);
    }
    return "data:image/jpeg;base64," + btoa(s.join(""));
  }(t) : this.imageAttributes.src = n, Ku(this.defaultTransforms) ? this.appliedImageTransforms = td(this.defaultTransforms()) : yr(this.defaultTransforms) ? this.appliedImageTransforms = td(this.defaultTransforms) : this.appliedImageTransforms = function(i) {
    var s = td({});
    if (i)
      switch (i) {
        case 2:
          s.flip.horizontal = !0;
          break;
        case 3:
          s.rotate = -180;
          break;
        case 4:
          s.flip.vertical = !0;
          break;
        case 5:
          s.rotate = 90, s.flip.vertical = !0;
          break;
        case 6:
          s.rotate = 90;
          break;
        case 7:
          s.rotate = 90, s.flip.horizontal = !0;
          break;
        case 8:
          s.rotate = -90;
      }
    return s;
  }(u), this.defaultImageTransforms = Nl(Nl({}, this.appliedImageTransforms), {}, { flip: Nl({}, this.appliedImageTransforms.flip) }), this.$nextTick(function() {
    var i = l.$refs.image;
    i && i.complete && (function(s) {
      return !!s.naturalWidth;
    }(i) ? l.onSuccessLoadImage() : l.onFailLoadImage());
  });
}, onResizeEnd: function() {
  this.runAutoZoom("resize", { transitions: !0 });
}, onMoveEnd: function() {
  this.runAutoZoom("move", { transitions: !0 });
}, onMove: function(e) {
  var l = this;
  this.transitionsOptions.enabled || this.awaitRender(function() {
    l.coordinates = l.moveAlgorithm(Nl(Nl({}, l.getPublicProperties()), {}, { positionRestrictions: nr(l.positionRestrictions, l.visibleArea), coordinates: l.coordinates, event: l.normalizeEvent(e) })), l.onChange();
  });
}, onResize: function(e) {
  var l = this;
  this.transitionsOptions.enabled || this.stencilSize && !this.autoZoom || this.awaitRender(function() {
    var n = l.sizeRestrictions, t = Math.min(l.coordinates.width, l.coordinates.height, 20 * l.coefficient);
    l.coordinates = l.resizeAlgorithm(Nl(Nl({}, l.getPublicProperties()), {}, { positionRestrictions: nr(l.positionRestrictions, l.visibleArea), sizeRestrictions: { maxWidth: Math.min(n.maxWidth, l.visibleArea.width), maxHeight: Math.min(n.maxHeight, l.visibleArea.height), minWidth: Math.max(n.minWidth, t), minHeight: Math.max(n.minHeight, t) }, event: l.normalizeEvent(e) })), l.onChange(), l.ticking = !1;
  });
}, onManipulateImage: function(e) {
  var l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!this.transitionsOptions.enabled) {
    var n = l.transitions, t = n !== void 0 && n, u = l.normalize, i = u === void 0 || u;
    t && this.enableTransitions();
    var s = cO(Nl(Nl({}, this.getPublicProperties()), {}, { event: i ? this.normalizeEvent(e) : e, getAreaRestrictions: this.getAreaRestrictions, imageRestriction: this.imageRestriction, adjustStencil: !this.stencilSize && this.settings.resizeImage.adjustStencil })), r = s.visibleArea, o = s.coordinates;
    this.visibleArea = r, this.coordinates = o, this.runAutoZoom("manipulateImage"), this.onChange(), t && this.debouncedDisableTransitions();
  }
}, onPropsChange: function() {
  this.coordinates = this.applyTransform(this.coordinates, !0), this.onChange(!1);
}, getAreaRestrictions: function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, l = e.visibleArea, n = e.type, t = n === void 0 ? "move" : n;
  return this.areaRestrictionsAlgorithm({ boundaries: this.boundaries, imageSize: this.imageSize, imageRestriction: this.imageRestriction, visibleArea: l, type: t });
}, getAspectRatio: function(e) {
  var l, n, t = this.stencilProps, u = t.aspectRatio, i = t.minAspectRatio, s = t.maxAspectRatio;
  if (this.$refs.stencil && this.$refs.stencil.aspectRatios) {
    var r = this.$refs.stencil.aspectRatios();
    l = r.minimum, n = r.maximum;
  }
  if (on(l) && (l = on(u) ? i : u), on(n) && (n = on(u) ? s : u), !e && (on(l) || on(n))) {
    var o = this.getStencilSize(), a = o ? Ll(o) : null;
    on(l) && (l = J0(a) ? a : void 0), on(n) && (n = J0(a) ? a : void 0);
  }
  return { minimum: l, maximum: n };
}, getStencilSize: function() {
  if (this.stencilSize)
    return e = { currentStencilSize: { width: this.stencilCoordinates.width, height: this.stencilCoordinates.height }, stencilSize: this.stencilSize, boundaries: this.boundaries, coefficient: this.coefficient, coordinates: this.coordinates, aspectRatio: this.getAspectRatio(!0) }, l = e.boundaries, n = e.stencilSize, t = e.aspectRatio, nd(Ll(u = Ku(n) ? n({ boundaries: l, aspectRatio: t }) : n), t) && (u = kt({ sizeRestrictions: { maxWidth: l.width, maxHeight: l.height, minWidth: 0, minHeight: 0 }, width: u.width, height: u.height, aspectRatio: { minimum: t.minimum, maximum: t.maximum } })), (u.width > l.width || u.height > l.height) && (u = kt({ sizeRestrictions: { maxWidth: l.width, maxHeight: l.height, minWidth: 0, minHeight: 0 }, width: u.width, height: u.height, aspectRatio: { minimum: Ll(u), maximum: Ll(u) } })), u;
  var e, l, n, t, u;
}, getPublicProperties: function() {
  return { coefficient: this.coefficient, visibleArea: this.visibleArea, coordinates: this.coordinates, boundaries: this.boundaries, sizeRestrictions: this.sizeRestrictions, positionRestrictions: this.positionRestrictions, aspectRatio: this.getAspectRatio(), imageRestriction: this.imageRestriction };
}, defaultCoordinates: function() {
  return Nl({}, Z0);
}, flip: function(e, l) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, t = n.transitions, u = t === void 0 || t;
  if (!this.transitionsActive) {
    u && this.enableTransitions();
    var i = Nl({}, this.imageTransforms.flip), s = pO({ flip: { horizontal: e ? !i.horizontal : i.horizontal, vertical: l ? !i.vertical : i.vertical }, previousFlip: i, rotate: this.imageTransforms.rotate, visibleArea: this.visibleArea, coordinates: this.coordinates, imageSize: this.imageSize, positionRestrictions: this.positionRestrictions, sizeRestrictions: this.sizeRestrictions, getAreaRestrictions: this.getAreaRestrictions, aspectRatio: this.getAspectRatio() }), r = s.visibleArea, o = s.coordinates;
    e && (this.appliedImageTransforms.flip.horizontal = !this.appliedImageTransforms.flip.horizontal), l && (this.appliedImageTransforms.flip.vertical = !this.appliedImageTransforms.flip.vertical), this.visibleArea = r, this.coordinates = o, this.onChange(), u && this.debouncedDisableTransitions();
  }
}, rotate: function(e) {
  var l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = l.transitions, t = n === void 0 || n;
  if (!this.transitionsActive) {
    t && this.enableTransitions();
    var u = Nl({}, this.imageSize);
    this.appliedImageTransforms.rotate += e;
    var i = hO({ visibleArea: this.visibleArea, coordinates: this.coordinates, previousImageSize: u, imageSize: this.imageSize, angle: e, positionRestrictions: this.positionRestrictions, sizeRestrictions: this.sizeRestrictions, getAreaRestrictions: this.getAreaRestrictions, aspectRatio: this.getAspectRatio() }), s = i.visibleArea, r = i.coordinates, o = this.processAutoZoom("rotateImage", s, r);
    s = o.visibleArea, r = o.coordinates, this.visibleArea = s, this.coordinates = r, this.onChange(), t && this.debouncedDisableTransitions();
  }
} }, emits: ["change", "error", "ready"] }, CO = { key: 0, ref: "canvas", style: { display: "none" } }, TO = { key: 1, ref: "sourceCanvas", style: { display: "none" } };
wv.render = function(e, l, n, t, u, i) {
  return y(), L("div", { ref: "cropper", class: i.classes.cropper }, [R("div", { ref: "stretcher", class: i.classes.stretcher }, null, 2), R("div", { class: i.classes.boundaries, style: i.boundariesStyle }, [(y(), L(Vn(n.backgroundWrapperComponent), { class: i.classes.cropperWrapper, "wheel-resize": i.settings.resizeImage.wheel, "touch-resize": i.settings.resizeImage.touch, "touch-move": i.settings.moveImage.touch, "mouse-move": i.settings.moveImage.mouse, onMove: i.onManipulateImage, onResize: i.onManipulateImage }, { default: U(function() {
    return [R("div", { class: i.classes.background, style: i.boundariesStyle }, null, 6), R("div", { class: i.classes.imageWrapper }, [R("img", { ref: "image", crossorigin: u.imageAttributes.crossOrigin, src: u.imageAttributes.src, class: i.classes.image, style: i.imageStyle, onMousedown: l[1] || (l[1] = kl(function() {
    }, ["prevent"])) }, null, 46, ["crossorigin", "src"])], 2), R("div", { class: i.classes.foreground, style: i.boundariesStyle }, null, 6), vl((y(), L(Vn(n.stencilComponent), ml({ ref: "stencil", image: i.image, coordinates: u.coordinates, "stencil-coordinates": i.stencilCoordinates, transitions: i.transitionsOptions }, n.stencilProps, { onResize: i.onResize, onResizeEnd: i.onResizeEnd, onMove: i.onMove, onMoveEnd: i.onMoveEnd }), null, 16, ["image", "coordinates", "stencil-coordinates", "transitions", "onResize", "onResizeEnd", "onMove", "onMoveEnd"])), [[cn, u.imageLoaded]]), n.canvas ? (y(), L("canvas", CO, null, 512)) : I("", !0), n.canvas ? (y(), L("canvas", TO, null, 512)) : I("", !0)];
  }), _: 1 }, 8, ["class", "wheel-resize", "touch-resize", "touch-move", "mouse-move", "onMove", "onResize"]))], 6)], 2);
};
class _h extends gl {
  constructor(n) {
    super(n);
    S(this, "_cropper", J());
    S(this, "state", fl({
      zoom: 1,
      ready: !1,
      image: null
    }));
    S(this, "zoomThrottled", ws(() => {
      var n;
      (n = this._cropper.value) == null || n.zoom(this.state.zoom / this.currentZoom);
    }, 17));
  }
  get currentZoom() {
    var n;
    return this.state.ready ? 1 / (((n = this._cropper.value) == null ? void 0 : n.coefficient) ?? 1) : 1;
  }
  get cropperOptions() {
    return {
      imageRestriction: "none",
      transitions: !1,
      ...this.props.options
    };
  }
  get image() {
    return this.state.image;
  }
  get zoom() {
    return this.state.zoom;
  }
  set zoom(n) {
    this.state.zoom = n;
  }
  get publicInstance() {
    return {
      ...super.publicInstance,
      crop: this.crop.bind(this)
    };
  }
  async onBeforeMount() {
    this.readFile();
  }
  readFile() {
    if (this.props.file) {
      const n = new FileReader();
      n.addEventListener("load", () => {
        this.state.image = n.result;
      }, !1), n.readAsDataURL(this.props.file);
    }
  }
  crop() {
    return new Promise((n, t) => {
      var s;
      const u = (s = this._cropper.value) == null ? void 0 : s.getResult();
      if (!u)
        return;
      const i = (r, o, a) => {
        if (!u || !this.document)
          return;
        const d = this.document.createElement("canvas");
        d.width = o, d.height = a;
        const h = u.coordinates, p = h.width / h.height, f = o / a, m = f > p ? Math.round(h.width * o / h.height) * (a / o) : o, g = (o - m) / 2, v = f > p ? a : Math.round(h.height * a / h.width) * (o / a), w = (a - v) / 2, $ = d.getContext("2d");
        return $ == null || $.drawImage(r, 0, 0, h.width, h.height, g, w, m, v), d;
      };
      if (u.canvas) {
        const r = i(u.canvas, this.props.cropWidth, this.props.cropHeight);
        r == null || r.toBlob((o) => {
          var a;
          o ? n(new File([o], typeof this.props.file == "string" ? "cropped-img" : (a = this.props.file) == null ? void 0 : a.name, {
            type: o.type
          })) : t("No blob");
        });
      }
    });
  }
  onReady() {
    this.state.ready = !0, this.state.zoom = this.currentZoom;
  }
  zoomCropper() {
    this.zoomThrottled();
  }
  rotateCropper(n) {
    var t;
    (t = this._cropper.value) == null || t.rotate(n);
  }
}
S(_h, "props", {
  // @doc props/circle define if the shape of the cropper is a circle (otherwise a square)
  // @doc/fr props/circle définit si le recadrage prend la forme d'unn cercle (un rectangle sinon)
  circle: Boolean,
  // @doc props/file the file
  // @doc/fr props/file le fichier à recadrer
  file: {
    type: Object,
    default: void 0
  },
  // @doc props/zoomMin the minimal zoom
  // @doc/fr props/zoomMin le zoom minimum
  zoomMin: {
    type: Number,
    default: 0.01
  },
  // @doc props/zoomMax the maximum zoom
  // @doc/fr props/zoomMax le zoom maximum
  zoomMax: {
    type: Number,
    default: 3
  },
  // @doc props/zoomStep the step of the zoom
  // @doc/fr props/zoomStep le pas du zoom
  zoomStep: {
    type: Number,
    default: 0.01
  },
  // @doc props/options options of the cropper
  // @doc/fr props/options les options du cropper
  options: {
    type: Object,
    default: void 0
  },
  // @doc props/cropHeight the height of the cropped image
  // @doc/fr props/cropHeight la hauteur de l'image recadrée
  cropHeight: {
    type: Number,
    default: 300
  },
  // @doc props/cropWidth the width of the cropped image
  // @doc/fr props/cropWidth la largeur de l'image recadrée
  cropWidth: {
    type: Number,
    default: 300
  }
});
const OO = {
  key: 0,
  class: "orion-cropper"
}, kO = {
  class: "orion-cropper__actions"
}, MO = /* @__PURE__ */ K({
  __name: "OrionCropper",
  props: _h.props,
  setup(e, {
    expose: l
  }) {
    const n = e, t = new _h(n);
    return l(t.publicInstance), (u, i) => c(t).image ? (y(), O("div", OO, [R(c(wv), ml({
      ref: c(t)._cropper,
      class: "cropper",
      src: c(t).image,
      "stencil-component": u.circle ? c(bv) : c(Bf)
    }, c(t).cropperOptions, {
      onReady: i[0] || (i[0] = (s) => c(t).onReady())
    }), null, 16, ["src", "stencil-component"]), R(c(rv), {
      modelValue: c(t).zoom,
      "onUpdate:modelValue": i[1] || (i[1] = (s) => c(t).zoom = s),
      "min-value": u.zoomMin,
      "max-value": u.zoomMax,
      step: u.zoomStep,
      onInput: i[2] || (i[2] = (s) => c(t).zoomCropper())
    }, null, 8, ["modelValue", "min-value", "max-value", "step"]), A("div", kO, [R(c(bl), {
      nude: "",
      "prefix-icon": "undo",
      onClick: i[3] || (i[3] = (s) => c(t).rotateCropper(-90))
    }), R(c(bl), {
      nude: "",
      "prefix-icon": "redo",
      onClick: i[4] || (i[4] = (s) => c(t).rotateCropper(90))
    })])])) : I("", !0);
  }
}), sd = {
  install(e, l = "o") {
    e.component(`${tl(l)}Cropper`, MO);
  }
};
class Sh extends gl {
  constructor(n, t) {
    super(n);
    S(this, "_calendar", J());
    S(this, "uid", this.getUid());
    S(this, "state", fl({
      hourNow: null,
      calendarRange: [8, 18],
      elementsAreHidden: !1
    }));
    this.emit = t, Pl(() => this.taskOfTheDay, () => {
      rl(() => {
        this.elementsAreHidden = !1, this.setCalendarRange(), this.observeHiddenTasks();
      });
    }), Pl(() => this.props.range, () => {
      this.setCalendarRange(), this.scrollToRange();
    });
  }
  get date() {
    return this.props.date;
  }
  get hourNow() {
    return this.state.hourNow;
  }
  set hourNow(n) {
    this.state.hourNow = n;
  }
  get calendarRange() {
    return this.state.calendarRange;
  }
  set calendarRange(n) {
    this.state.calendarRange = n;
  }
  get elementsAreHidden() {
    return this.state.elementsAreHidden;
  }
  set elementsAreHidden(n) {
    this.state.elementsAreHidden = n;
  }
  get today() {
    const n = Er(this.props.date);
    return X(new Date(n)).toMidnight().valueOf() === X(/* @__PURE__ */ new Date()).toMidnight().valueOf();
  }
  get readableDate() {
    return X(this.date).toReadable();
  }
  get taskOfTheDay() {
    var r;
    const n = (r = this.props.dayTasks) == null ? void 0 : r.filter((o) => X(o.start).toReadable() === X(new Date(this.props.date)).toReadable()), t = [], u = [];
    function i(o, a) {
      return a.start.valueOf() >= o.start.valueOf() && a.start.valueOf() < o.end.valueOf() || a.end.valueOf() > o.start.valueOf() && a.start.valueOf() < o.end.valueOf();
    }
    function s(o, a) {
      return a.findIndex((d) => i(d, o)) > -1;
    }
    for (const o of n)
      if (!u.length)
        u.push([o]);
      else
        for (let a = 0; a < u.length; a++) {
          const d = u[a];
          if (s(o, d)) {
            if (u[a + 1] !== void 0)
              continue;
            u.push([o]);
            break;
          } else {
            d.push(o);
            break;
          }
        }
    return u.forEach((o, a) => {
      o.forEach((d) => {
        d.column = a, t.push(d);
      });
    }), t;
  }
  onMounted() {
    this.setCalendarRange(), this.observeHiddenTasks(), setInterval(() => {
      const n = /* @__PURE__ */ new Date(), t = n.getHours().toString().length < 2 ? `0${n.getHours()}` : n.getHours(), u = n.getMinutes().toString().length < 2 ? `0${n.getMinutes()}` : n.getMinutes();
      this.hourNow = `${t}:${u}`;
    }, 1e3), this.scrollToRange();
  }
  taskTooltip(n) {
    const t = X(n.start).toReadable("$hh:$mm $a"), u = X(n.end).toReadable("$hh:$mm $a");
    return {
      html: !0,
      content: `<b style="display: block; margin-bottom: 0.5rem;">${ul().HOUR_FROM_TO.replace("$start", t).replace("$end", u)}</b> 
			<div style="max-width: calc(200rem / 16);">${n == null ? void 0 : n.title}</div>`
    };
  }
  scrollToRange() {
    var t;
    const n = (t = this.document) == null ? void 0 : t.getElementById("calendar-" + this.uid);
    n && (n.scrollTop = (this.props.range[0] - this.calendarRange[0]) * 50);
  }
  setCalendarRange() {
    this.calendarRange = Er(this.props.range), this.props.dayTasks.forEach((n) => {
      const t = new Date(n.start).getHours(), u = new Date(n.end).getHours(), i = X(this.calendarRange).first(), s = X(this.calendarRange).last();
      i && t < i && (this.calendarRange[0] = t), s && u > s && (this.calendarRange[1] = u);
    });
  }
  scrollDown() {
    var t;
    const n = (t = this.document) == null ? void 0 : t.getElementById("calendar-" + this.uid);
    n.style.scrollBehavior = "smooth", n.scrollTop = n.scrollHeight, this.observeHiddenTasks();
  }
  observeHiddenTasks() {
    var i;
    if (!this.document)
      return;
    const n = this.document.querySelectorAll(`.orion-daily-calendar-${this.uid}__task`), t = (i = this.document) == null ? void 0 : i.getElementById("calendar-" + this.uid);
    let u = !1;
    for (const s of n) {
      if (s.getBoundingClientRect().top > t.getBoundingClientRect().bottom) {
        u = !0;
        break;
      }
      u = !1;
    }
    this.elementsAreHidden = u;
  }
  handleTaskClick(n) {
    n.callback && n.callback(n);
  }
  getNextDay() {
    const n = new Date(this.props.date);
    this.emit("update:date", new Date(n.setDate(n.getDate() + 1)));
  }
  getPreviousDay() {
    const n = new Date(this.props.date);
    this.emit("update:date", new Date(n.setDate(n.getDate() - 1)));
  }
  isNearFromNow(n) {
    if (!this.today)
      return;
    const t = this.toHourDisplay(n + this.calendarRange[0] - 1), u = this.hourToDecimal(t) - this.hourToDecimal(this.hourNow);
    return u < 0.2 && u > -0.2 ? "opacity: 0;" : "opacity: 1;";
  }
  toHourDisplay(n) {
    const t = n.toString();
    return t.length > 1 ? `${t}:00` : `0${t}:00`;
  }
  taskStyle(n) {
    const t = new Date(n.start).getHours().toString().padStart(2, "0") + ":" + new Date(n.start).getMinutes().toString().padStart(2, "0"), u = n.column ?? 0, i = (n.end.valueOf() - n.start.valueOf()) / (60 * 60 * 1e3), s = X(this.taskOfTheDay).last();
    let r = 0;
    return s && (r = (s.column ?? 0) + 1), {
      left: `${100 / r * u}%`,
      width: `${100 / r}%`,
      height: `calc(${i * 51}rem / 16)`,
      top: `calc((${(this.hourToDecimal(t) - this.calendarRange[0]) * 51}rem / 16) + (25rem / 16))`,
      overflow: "hidden"
    };
  }
  taskParagraphStyle(n) {
    const t = ((n.end.valueOf() - n.start.valueOf()) / 36e5 * 50 - 10) / 14;
    return {
      textOverflow: "ellipsis",
      display: "-webkit-box",
      webkitBoxOrient: "vertical",
      webkitLineClamp: Math.round(t),
      overflow: "hidden"
    };
  }
  hourToDecimal(n) {
    if (!n)
      return 0;
    const t = {
      heure: n.split(":")[0],
      min: n.split(":")[1]
    }, u = Math.floor(Number(t.min ?? 0) / 60 * 100), i = `${parseInt(t.heure)}.${u.toString().padStart(2, "0")}`;
    return parseFloat(i);
  }
}
S(Sh, "props", {
  // @doc props/date the selected date.
  // @doc/fr props/date la date sélectionnée.
  date: {
    type: Date,
    default: null
  },
  // @doc props/range hour range displayed.
  // @doc/fr props/range la plage horaire affichée.
  range: {
    type: Array,
    default: () => [8, 18]
  },
  // @doc props/dayTasks tasks array
  // @doc/fr props/dayTasks le tableau de qui contient les tâches du jour
  dayTasks: {
    type: Array,
    default: null
  }
});
const AO = {
  class: "orion-daily-calendar"
}, xO = {
  class: "orion-daily-calendar__header"
}, EO = {
  class: "orion-daily-calendar__title"
}, IO = {
  class: "orion-daily-calendar__other-days"
}, RO = {
  class: "orion-daily-calendar__background"
}, DO = {
  class: "orion-daily-calendar__hour-number orion-daily-calendar__hour-number--now"
}, NO = /* @__PURE__ */ A("div", {
  class: "orion-daily-calendar__hour-line orion-daily-calendar__hour-line--now"
}, null, -1), LO = /* @__PURE__ */ A("div", {
  class: "orion-daily-calendar__hour-line"
}, null, -1), PO = {
  class: "orion-daily-calendar__task-wrapper"
}, BO = ["onClick"], FO = {
  key: 0,
  class: "orion-daily-calendar__hidden-task-indicator"
}, HO = /* @__PURE__ */ K({
  __name: "OrionDailyCalendar",
  props: Sh.props,
  emits: ["update:date"],
  setup(e, {
    expose: l,
    emit: n
  }) {
    const t = n, u = e, i = new Sh(u, t);
    return l(i.publicInstance), (s, r) => {
      const o = Ei("tooltip");
      return y(), L(c(W3), {
        id: "calendar-" + c(i).uid,
        ref: c(i)._calendar,
        class: "calendar",
        style: Wl(`max-height: calc(${(c(i).props.range[1] - c(i).props.range[0] + 1) * 50 + 60}rem / 16); overflow-y: scroll; overflow-x: hidden`),
        onScroll: r[3] || (r[3] = (a) => c(i).observeHiddenTasks())
      }, {
        default: U(() => [A("div", AO, [A("div", xO, [A("h4", EO, B(c(i).readableDate), 1), A("div", IO, [R(c(Ml), {
          icon: "chevron_left",
          class: z(["orion-daily-calendar__icon", c(i).today ? "disabled" : null]),
          ripple: c(i).today ? void 0 : "info",
          disabled: !0,
          onClick: r[0] || (r[0] = (a) => c(i).getPreviousDay())
        }, null, 8, ["class", "ripple"]), R(c(Ml), {
          ripple: "info",
          class: "orion-daily-calendar__icon",
          icon: "chevron_right",
          onClick: r[1] || (r[1] = (a) => c(i).getNextDay())
        })])]), A("div", RO, [vl(A("div", {
          class: "orion-daily-calendar__hour orion-daily-calendar__hour--now",
          style: Wl(`top:calc(${(c(i).hourToDecimal(c(i).hourNow) - c(i).calendarRange[0]) * 50}rem / 16);`)
        }, [A("span", DO, B(c(i).hourNow), 1), NO], 4), [[cn, c(i).today]]), (y(!0), O(hl, null, Sl(c(i).calendarRange[1] - c(i).calendarRange[0] + 1, (a) => (y(), O("div", {
          key: a,
          class: "orion-daily-calendar__hour"
        }, [A("span", {
          style: Wl(c(i).isNearFromNow(a)),
          class: "orion-daily-calendar__hour-number"
        }, B(c(i).toHourDisplay(a + c(i).calendarRange[0] - 1)), 5), LO]))), 128)), vl(A("div", PO, [(y(!0), O(hl, null, Sl(c(i).taskOfTheDay, (a) => vl((y(), O("div", {
          key: a.id,
          style: Wl(c(i).taskStyle(a)),
          class: z(["orion-daily-calendar__task", [`orion-daily-calendar__task--${a.color}`, `orion-daily-calendar-${c(i).uid}__task`]]),
          onClick: (d) => c(i).handleTaskClick(a)
        }, [A("p", {
          style: Wl(c(i).taskParagraphStyle(a))
        }, B(a.title), 5)], 14, BO)), [[o, c(i).taskTooltip(a)]])), 128))], 512), [[cn, c(i).taskStyle]])])]), c(i).elementsAreHidden ? (y(), O("div", FO, [R(c(bl), {
          "prefix-icon": "chevron_down",
          onClick: r[2] || (r[2] = (a) => c(i).scrollDown())
        })])) : I("", !0), R(c(te), {
          visible: !c(i).hourNow,
          message: c(i).lang.LOADING_CALENDAR
        }, null, 8, ["visible", "message"])]),
        _: 1
      }, 8, ["id", "style"]);
    };
  }
}), rd = {
  install(e, l = "o") {
    e.component(`${tl(l)}DailyCalendar`, HO);
  }
};
class Ch extends gl {
  constructor(n, t) {
    super(n);
    S(this, "state", fl({
      currentDate: /* @__PURE__ */ new Date(),
      viewMonth: !1,
      viewYears: !1,
      filter: [],
      filterHover: void 0,
      colorArray: [],
      dayHover: void 0,
      selectedDates: []
    }));
    S(this, "_options", J());
    this.emit = t, xo(() => this.state.currentDate = this.vModel ?? /* @__PURE__ */ new Date());
  }
  get periodsToFilter() {
    var n;
    return this.state.filter.length ? (n = this.props.periods) == null ? void 0 : n.filter((t) => !this.state.filter.includes(t.color)) : this.props.periods;
  }
  get currentMonth() {
    return this.state.currentDate.getMonth();
  }
  get firstDayOfCurrentMonth() {
    return new Date(this.currentYear, this.currentMonth, 1).getDay();
  }
  get lastDayOfCurrentMonth() {
    return new Date(this.currentYear, this.currentMonth + 1, 0).getDate();
  }
  get rangeStartValue() {
    var n;
    if ((n = this.range) != null && n.start)
      return X(this.range.start).toMidnight().valueOf();
  }
  get rangeEndValue() {
    var n;
    if ((n = this.range) != null && n.end)
      return X(this.range.end).toMidnight().valueOf();
  }
  get vModel() {
    return this.props.modelValue;
  }
  set vModel(n) {
    this.emit("update:modelValue", n);
  }
  get range() {
    return this.props.range;
  }
  set range(n) {
    this.emit("update:range", n);
  }
  get dayHover() {
    return this.props.dayHover ?? this.state.dayHover;
  }
  set dayHover(n) {
    this.state.dayHover = n, this.emit("update:dayHover", n);
  }
  get daysToDisplay() {
    var r, o;
    const n = new Date(this.currentYear, this.currentMonth, 0).getDate(), t = [];
    let u = 1, i = 1, s = this.firstDayOfCurrentMonth;
    s === 0 && (s = 7);
    for (let a = 1; a <= 6; a++) {
      const d = [];
      for (let h = 7; h >= 1; h--) {
        const p = a * 7 - h;
        let f = {
          isStart: !1,
          isEnd: !1,
          isSelected: !1,
          exclude: !1,
          number: u,
          month: this.currentMonth,
          year: this.currentYear,
          date: new Date(this.currentYear, this.currentMonth, u),
          period: []
        };
        if (a === 1 && p < s - 1 ? (f.number = n - (s - 1) + (p + 1), f.month = this.currentMonth === 0 ? 11 : this.currentMonth - 1, f.year = this.currentMonth === 0 ? this.currentYear - 1 : this.currentYear) : u > this.lastDayOfCurrentMonth ? (f.number = i, f.month = this.currentMonth === 11 ? 0 : this.currentMonth + 1, f.year = this.currentMonth === 11 ? this.currentYear + 1 : this.currentYear, i++) : u++, f.date = new Date(f.year, f.month, f.number), (r = this.props.periods) != null && r.length) {
          const m = f.date, g = new Date(f.year, f.month, f.number + 1), v = new Date(f.year, f.month, f.number - 1);
          this.props.dateSelected && X(this.props.dateSelected).toMidnight().valueOf() === m.valueOf() && (f.isSelected = !0), (o = this.periodsToFilter) == null || o.forEach((w) => {
            var b, k, T;
            const $ = (((b = w.specific) == null ? void 0 : b.findIndex((M) => X(M.date).toMidnight().valueOf() === g.valueOf() && M.exclude)) ?? -1) > -1, _ = (((k = w.specific) == null ? void 0 : k.findIndex((M) => X(M.date).toMidnight().valueOf() === v.valueOf() && M.exclude)) ?? -1) > -1;
            if (m >= X(w.start).toMidnight() && m <= X(w.end).toMidnight()) {
              const M = m.valueOf() === X(w.start).toMidnight().valueOf() || _, H = m.valueOf() === X(w.end).toMidnight().valueOf() || $;
              if ((T = w.specific) != null && T.map((x) => X(x.date).toMidnight().valueOf()).includes(m.valueOf())) {
                const x = w.specific.find((P) => X(P.date).toMidnight().valueOf() === m.valueOf());
                f = {
                  ...f,
                  ...x,
                  isStart: !0,
                  isEnd: !0
                };
              }
              f.exclude || (f = this.addPeriodToDay(w, f, M, H));
            }
          });
        }
        d.push(f);
      }
      t.push(d);
    }
    return t;
  }
  get rangeYears() {
    const n = this.currentYear - this.currentYear % 10, t = [];
    for (let u = 0; u < 10; u++)
      t.push(n + u);
    return t;
  }
  get monthName() {
    return this.lang.MONTH_NAME[this.currentMonth];
  }
  get currentYear() {
    return this.state.currentDate.getFullYear();
  }
  get viewMonth() {
    return this.state.viewMonth;
  }
  get viewYears() {
    return this.state.viewYears;
  }
  get filter() {
    return this.state.filter;
  }
  get selectedDates() {
    return this.state.selectedDates;
  }
  get labels() {
    var n;
    return (n = this.props.periods) != null && n.length ? Ow(this.props.periods.map((t) => ({
      label: t.label,
      color: t.color
    })), "label") : [];
  }
  get publicInstance() {
    return {
      ...super.publicInstance,
      getCurrentDate: () => this.state.currentDate,
      getCurrentMonth: () => this.currentMonth,
      getCurrentYear: () => this.currentYear,
      selectMonth: this.selectMonth.bind(this),
      selectYear: this.selectYear.bind(this)
    };
  }
  async onBeforeMount() {
    this.setDateCalendar(), this.createColorsArrayFromPeriods(), this.props.month && (this.state.viewMonth = !0);
  }
  onUpdated() {
    this.triggerSelectPeriod(), this.props.month && (this.state.viewMonth = !0);
  }
  triggerSelectPeriod() {
    this.daysToDisplay.forEach((n) => {
      const t = n.find((u) => u.isSelected === !0);
      t && this.selectPeriod(t == null ? void 0 : t.period);
    });
  }
  addPeriodToDay(n, t, u = !1, i = !1) {
    const s = {
      ...n
    };
    return s.isStart = u, s.isEnd = i, t.period.push(s), t;
  }
  createColorsArrayFromPeriods() {
    var n;
    if ((n = this.props.periods) != null && n.length) {
      const t = new Set(this.props.periods.map((u) => u.color));
      this.state.colorArray = [...t];
    }
  }
  filterColorOnClick(n) {
    this.state.filter.includes(n) ? this.state.filter.splice(this.state.filter.indexOf(n), 1) : this.state.filter.push(n), this.state.filterHover = void 0;
  }
  filterColorOnHover(n, t = !1) {
    this.state.filter.includes(n) || (this.state.filterHover = t ? void 0 : n);
  }
  getClassForBackground(n) {
    if (!n)
      return;
    const t = ["emphasis", `emphasis--${n.color}`];
    return this.state.filterHover && this.state.filterHover !== n.color && t.push("emphasis--opacity"), n.isEnd && n.isStart && t.push("emphasis--circle"), n.isStart && n.isEnd === !1 && t.push("emphasis-border-radius--left", "emphasis-border-radius"), n.isEnd && n.isStart === !1 && t.push("emphasis-border-radius--right", "emphasis-border-radius"), t;
  }
  getClassForNotification(n) {
    var t;
    if (((t = this.vModel) == null ? void 0 : t.getDate()) === n.number)
      return "notification--white";
    if (n.month !== this.currentMonth)
      return "notification--lighter";
  }
  showMonths() {
    this.props.disableMonthAndYear || (this.state.viewMonth = !0);
  }
  showYears() {
    this.props.disableMonthAndYear || (this.state.viewMonth = !1, this.state.viewYears = !0);
  }
  switchPeriod(n) {
    if (this.state.viewMonth)
      this.state.currentDate = new Date(this.currentYear + n, this.currentMonth, 1);
    else if (this.state.viewYears) {
      const t = n === -1 ? this.rangeYears[0] : this.rangeYears[this.rangeYears.length - 1];
      this.state.currentDate = new Date(t + n, this.currentMonth, 1);
    } else
      (n === -1 && this.props.canGoPrevMonth || n === 1 && this.props.canGoNextMonth) && (this.state.currentDate = new Date(this.currentYear, this.currentMonth + n, 1), this.emit("change-month", {
        month: this.currentMonth,
        year: this.currentYear
      }));
  }
  selectPeriod(n) {
    n.forEach((t) => {
      t.callback && t.callback();
    }), this.emit("select-period", n);
  }
  selectDate(n) {
    var u, i, s;
    let t = n.date;
    if (this.props.minDate && t < this.props.minDate) {
      if (this.props.type === "multiple")
        return;
      t = this.props.minDate;
    }
    if (this.props.maxDate && t > this.props.maxDate) {
      if (this.props.type === "multiple")
        return;
      t = this.props.maxDate;
    }
    if (this.props.type === "range")
      (u = this.range) != null && u.selecting ? (i = this.range) != null && i.start && t >= this.range.start ? this.range = {
        ...this.range,
        end: t,
        selecting: !1
      } : this.range = {
        start: t,
        end: (s = this.range) == null ? void 0 : s.start,
        selecting: !1
      } : this.range = {
        start: t,
        end: void 0,
        selecting: !0
      };
    else if (this.props.type === "multiple") {
      const r = this.props.multiple.findIndex((o) => o.valueOf() === t.valueOf());
      r >= 0 ? this.props.multiple.splice(r, 1) : this.props.multiple.push(t);
    } else
      this.vModel = t;
  }
  getCssClassForDayInRange(n) {
    var s;
    if (this.props.type === "date" || !this.rangeStartValue)
      return;
    const t = n.date.valueOf(), u = (s = this.dayHover) == null ? void 0 : s.valueOf(), i = [];
    return !this.rangeEndValue && u ? ((t >= this.rangeStartValue && t <= u || t <= this.rangeStartValue && t >= u) && i.push("in-range"), (t >= this.rangeStartValue && t === u || t === this.rangeStartValue && t >= u) && i.push("in-range--border-right-radius"), (t <= this.rangeStartValue && t === u || t === this.rangeStartValue && t <= u) && i.push("in-range--border-left-radius")) : this.rangeEndValue && (t >= this.rangeStartValue && t <= this.rangeEndValue && i.push("in-range"), t === this.rangeStartValue && i.push("in-range--border-left-radius"), t === this.rangeEndValue && i.push("in-range--border-right-radius")), i;
  }
  getClassForDay(n) {
    var d, h, p, f, m, g, v;
    const t = n.date, u = n.month === this.currentMonth, i = n.month > this.currentMonth, s = n.month < this.currentMonth, r = i || s, o = [];
    n.color ? o.push(`day--${n.color}`) : u && ((d = n.period) == null || d.forEach((w) => {
      o.push(`day--${w.color}`);
    }));
    const a = [];
    if (n.isSelected && (n.color || (h = n.period) != null && h.length)) {
      const w = n.color ?? ((p = X(n.period).last()) == null ? void 0 : p.color);
      a.push(`selected--${w}`);
    }
    return r && a.push("orion-date-table-row__cell-display--grey"), !this.props.maxDate && this.props.minDate && t < X(this.props.minDate).toMidnight() && a.push("disable"), !this.props.minDate && this.props.maxDate && t > X(this.props.maxDate).toMidnight() && a.push("disable"), (this.props.maxDate && t > X(this.props.maxDate).toMidnight() || this.props.minDate && t < X(this.props.minDate).toMidnight()) && a.push("disable"), r || (t.valueOf() === X(/* @__PURE__ */ new Date()).toMidnight().valueOf() && a.push("today"), this.props.type === "range" ? ((f = this.range) != null && f.start && X((m = this.range) == null ? void 0 : m.start).toMidnight().valueOf() === t.valueOf() || (g = this.range) != null && g.end && X((v = this.range) == null ? void 0 : v.end).toMidnight().valueOf() === t.valueOf()) && a.push("selected") : this.props.multiple.length ? t && this.props.multiple.find((w) => w.getTime() === t.getTime()) && a.push("selected") : this.vModel && X(this.vModel).toMidnight().valueOf() === t.valueOf() && a.push("selected")), [...o, ...a];
  }
  getCssClassForMonth(n) {
    var u, i;
    const t = ["orion-date-table-row__cell orion-date-table-row__cell--month"];
    return this.props.month && (((u = this.range) == null ? void 0 : u.monthNumber) === n && ((i = this.range) == null ? void 0 : i.year) === this.currentYear && t.push("selected"), (this.props.minDate && new Date(this.currentYear, n, 1) < this.props.minDate || this.props.maxDate && new Date(this.currentYear, n, new Date(this.currentYear, n + 1, 0).getDate()) > this.props.maxDate) && t.push("disabled")), t;
  }
  selectMonth(n) {
    if (this.state.currentDate = new Date(this.currentYear, n, 1), this.state.viewMonth = !1, this.props.month) {
      if (this.props.minDate && this.state.currentDate < this.props.minDate || this.props.maxDate && new Date(this.currentYear, n, new Date(this.currentYear, n + 1, 0).getDate()) > this.props.maxDate)
        return;
      this.range = {
        start: this.state.currentDate,
        end: new Date(this.currentYear, n, new Date(this.currentYear, n + 1, 0).getDate()),
        monthNumber: n,
        year: this.currentYear
      };
    }
  }
  selectYear(n) {
    this.state.currentDate = new Date(n, this.currentMonth, 1), this.state.viewYears = !1;
  }
  setDateCalendar() {
    var t, u, i;
    const n = /* @__PURE__ */ new Date();
    this.props.type === "date" && (this.state.currentDate = this.vModel ?? /* @__PURE__ */ new Date()), this.props.type === "range" && (this.props.rangeStart && (this.state.currentDate = (t = this.range) != null && t.start ? new Date(this.range.start) : /* @__PURE__ */ new Date()), this.props.rangeEnd && (this.state.currentDate = (u = this.range) != null && u.end ? new Date(this.range.end) : new Date(n.getFullYear(), n.getMonth() + 1, 1)), this.props.month && (this.state.currentDate = (i = this.range) != null && i.start ? new Date(this.range.start) : /* @__PURE__ */ new Date()));
  }
  handleSpecificDayCallback(n) {
    n.callback && (n.callback(), this.emit("select-specific", n)), this.emit("select-day", n);
  }
  handleMouseOverDay(n) {
    this.props.type === "range" && (this.dayHover = n.date);
  }
}
S(Ch, "props", {
  // @doc props/month if set, displays only months
  // @doc/fr props/month si défini, affiche uniquement les mois
  month: Boolean,
  // @doc props/modelValue of the dateTable
  // @doc/fr props/modelValue du composant
  modelValue: {
    type: Date,
    default: void 0
  },
  // @doc props/range the modelValue if the type is set to `range`
  // @doc/fr props/range modelValue du composant si la prop `type` est `range`
  range: {
    type: Object,
    default: void 0
  },
  // @doc props/multiple the modelValue if the type is set to `multiple`
  // @doc/fr props/multiple modelValue du composant si la prop `type` est `multiple`
  multiple: {
    type: Array,
    default: () => []
  },
  // @doc props/dayHover the value of the hovered day
  // @doc/fr props/dayHover valeur du jour survolé
  dayHover: {
    type: Object,
    default: void 0
  },
  // @doc props/rangeStart if set, defines the range start value as the current value
  // @doc/fr props/rangeStart si définie, la date sélectionnée est le début de la période
  rangeStart: Boolean,
  // @doc props/rangeEnd if set, defines the range end value as the current value
  // @doc/fr props/rangeEnd si définie, la date selectionnée est la fin de la période
  rangeEnd: Boolean,
  // @doc props/disableMonthAndYear disabled month and year selection on top
  // @doc/fr props/disableMonthAndYear désactive la sélection du mois et de l'année en haut du calendrier
  disableMonthAndYear: Boolean,
  // @doc props/minDate the minimum date which can be selected
  // @doc/fr props/minDate la date minimum qui peut être selectionée
  minDate: {
    type: Date,
    default: void 0
  },
  // @doc props/maxDate the maximum date which can be selected
  // @doc/fr props/maxDate la date maximum qui peut être sélectionnée
  maxDate: {
    type: Date,
    default: void 0
  },
  // @doc props/dateSelected the selected date
  // @doc/fr props/dateSelected la date selectionée
  dateSelected: {
    type: Date,
    default: void 0
  },
  // @doc props/type the type of the model value
  // @doc/fr props/type le type de modelValue
  type: {
    type: String,
    default: "date",
    validator: (n) => ["date", "range", "multiple", "month"].includes(n)
  },
  // @doc props/canGoNextMonth allows the navigation to the next month
  // @doc/fr props/canGoNextMonth permet la navigation vers le mois suivant
  canGoNextMonth: {
    type: Boolean,
    default: !0
  },
  // @doc props/canGoPrevMonth allows the navigation to the previous month
  // @doc/fr props/canGoPrevMonth permet la navigation vers le mois précédent
  canGoPrevMonth: {
    type: Boolean,
    default: !0
  },
  // @doc props/periods periods to display on the table
  // @doc/fr props/periods périodes à afficher
  periods: {
    type: Array,
    default: void 0
  }
});
const zO = {
  class: "orion-date-table__header"
}, VO = {
  class: "orion-date-table__header-current-display"
}, jO = {
  key: 1,
  class: "orion-date-table__header-current-range-years"
}, UO = {
  class: "orion-date-table__body"
}, WO = {
  class: "orion-date-table__body-dow"
}, GO = {
  class: "orion-date-table__body"
}, KO = ["onClick", "onMouseover"], YO = {
  key: 1,
  class: "orion-date-table-row__cell-notification"
}, qO = ["onClick"], JO = {
  class: "orion-date-table-row__cell-display-contrast"
}, ZO = {
  key: 0,
  class: "orion-date-table__footer"
}, XO = ["onClick", "onMouseenter", "onMouseleave"], QO = {
  class: "orion-date-table__body__months"
}, lk = ["onClick"], nk = {
  class: "orion-date-table__body__years"
}, ek = ["onClick"], ai = /* @__PURE__ */ K({
  __name: "OrionDateTable",
  props: Ch.props,
  emits: ["update:modelValue", "update:range", "update:multiple", "update:dayHover", "change-month", "select-specific", "select-period", "select-day"],
  setup(e, {
    expose: l,
    emit: n
  }) {
    const t = n, u = e, i = new Ch(u, t);
    return l(i.publicInstance), (s, r) => {
      const o = Ei("tooltip");
      return y(), O("div", {
        ref: c(i)._options,
        class: "orion-date-table",
        onMousedown: r[4] || (r[4] = kl(() => {
        }, ["prevent"]))
      }, [A("div", zO, [R(c(Ml), {
        class: z(["orion-date-table__header-carret", {
          disable: !c(i).props.canGoPrevMonth
        }]),
        icon: "chevron_left",
        onClick: r[0] || (r[0] = (a) => c(i).switchPeriod(-1))
      }, null, 8, ["class"]), A("div", VO, [vl(A("span", {
        class: z(["orion-date-table__header-current-month", {
          disable: c(i).props.disableMonthAndYear
        }]),
        onClick: r[1] || (r[1] = //@ts-ignore
        (...a) => c(i).showMonths && c(i).showMonths(...a))
      }, B(c(i).monthName), 3), [[cn, !c(i).viewMonth && !c(i).viewYears && !s.month]]), c(i).viewYears ? (y(), O("span", jO, B(`${c(i).rangeYears[0]} - ${c(i).rangeYears[c(i).rangeYears.length - 1]}`), 1)) : (y(), O("span", {
        key: 0,
        class: z(["orion-date-table__header-current-year", {
          disable: c(i).props.disableMonthAndYear
        }]),
        onClick: r[2] || (r[2] = //@ts-ignore
        (...a) => c(i).showYears && c(i).showYears(...a))
      }, B(c(i).currentYear), 3))]), R(c(Ml), {
        class: z(["orion-date-table__header-carret", {
          disable: !c(i).props.canGoNextMonth
        }]),
        icon: "chevron_right",
        onClick: r[3] || (r[3] = (a) => c(i).switchPeriod(1))
      }, null, 8, ["class"])]), A("div", UO, [vl(A("div", WO, [A("span", null, B(c(i).lang.DAY_NAME_SHORT[0]), 1), A("span", null, B(c(i).lang.DAY_NAME_SHORT[1]), 1), A("span", null, B(c(i).lang.DAY_NAME_SHORT[2]), 1), A("span", null, B(c(i).lang.DAY_NAME_SHORT[3]), 1), A("span", null, B(c(i).lang.DAY_NAME_SHORT[4]), 1), A("span", null, B(c(i).lang.DAY_NAME_SHORT[5]), 1), A("span", null, B(c(i).lang.DAY_NAME_SHORT[6]), 1)], 512), [[cn, !c(i).viewMonth && !c(i).viewYears && !s.month]]), vl(A("div", GO, [(y(), O(hl, null, Sl(6, (a) => A("div", {
        key: a,
        class: "orion-date-table-row"
      }, [(y(!0), O(hl, null, Sl(c(i).daysToDisplay[a - 1], (d) => (y(), O("span", {
        key: `day-${d.number}`,
        class: z(["orion-date-table-row__cell", c(i).getCssClassForDayInRange(d)]),
        onClick: (h) => c(i).selectDate(d),
        onMouseover: (h) => c(i).handleMouseOverDay(d)
      }, [(y(!0), O(hl, null, Sl(d.period, (h, p) => (y(), O("span", {
        key: p,
        class: z(c(i).getClassForBackground(h))
      }, null, 2))), 128)), d.color ? (y(), O("span", {
        key: 0,
        class: z(c(i).getClassForBackground(d))
      }, null, 2)) : I("", !0), d.period.length > 1 ? (y(), O("div", YO, [A("span", {
        class: z(["notification", c(i).getClassForNotification(d)])
      }, null, 2)])) : I("", !0), A("span", {
        class: z(["orion-date-table-row__cell-display", c(i).getClassForDay(d)]),
        onClick: (h) => c(i).handleSpecificDayCallback(d)
      }, [A("span", JO, B(d.number), 1)], 10, qO)], 42, KO))), 128))])), 64)), c(i).labels.length ? (y(), O("div", ZO, [(y(!0), O(hl, null, Sl(c(i).labels, (a, d) => vl((y(), O("div", {
        key: d,
        class: z(["orion-date-table__legend", c(i).filter.includes(a.color) ? `text--${a.color} orion-date-table__legend--opacity` : `text--${a.color} background`]),
        onClick: kl((h) => c(i).filterColorOnClick(a.color), ["prevent"]),
        onMouseenter: (h) => c(i).filterColorOnHover(a.color),
        onMouseleave: (h) => c(i).filterColorOnHover(a.color, !0)
      }, [A("div", {
        class: z(`legend legend--${a.color}`)
      }, null, 2), $l(" " + B(a.label), 1)], 42, XO)), [[o, c(i).filter.includes(a.color) ? c(i).lang.ACTIVATE : c(i).lang.DEACTIVATE]])), 128))])) : I("", !0)], 512), [[cn, !c(i).viewMonth && !c(i).viewYears && !s.month]]), vl(A("div", QO, [(y(), O(hl, null, Sl(3, (a) => A("div", {
        key: a,
        class: "orion-date-table-row"
      }, [(y(!0), O(hl, null, Sl(c(i).lang.MONTH_NAME.slice((a - 1) * 4, a * 4), (d, h) => (y(), O("span", {
        key: `month-${d}`,
        class: z(c(i).getCssClassForMonth(h + (a - 1) * 4)),
        onClick: (p) => c(i).selectMonth(h + (a - 1) * 4)
      }, B(d), 11, lk))), 128))])), 64))], 512), [[cn, (c(i).viewMonth || s.month) && !c(i).viewYears]]), vl(A("div", nk, [(y(), O(hl, null, Sl(3, (a) => A("div", {
        key: a,
        class: "orion-date-table-row"
      }, [(y(!0), O(hl, null, Sl(c(i).rangeYears.slice((a - 1) * 4, a * 4), (d) => (y(), O("span", {
        key: `year-${d}`,
        class: "orion-date-table-row__cell orion-date-table-row__cell--year",
        onClick: (h) => c(i).selectYear(d)
      }, B(d), 9, ek))), 128))])), 64))], 512), [[cn, c(i).viewYears]])])], 544);
    };
  }
}), od = {
  install(e, l = "o") {
    e.component(`${tl(l)}DateTable`, ai);
  }
};
class Th extends gl {
  constructor(n, t) {
    super(n);
    S(this, "state", fl({
      selecting: !1,
      dayHover: /* @__PURE__ */ new Date()
    }));
    S(this, "_start", J());
    S(this, "_end", J());
    this.emit = t;
  }
  get dayHover() {
    return this.state.dayHover;
  }
  set dayHover(n) {
    this.state.dayHover = n;
  }
  get allowMiddleNextOrPrevMonth() {
    if (!this._start.value || !this._end.value)
      return !1;
    const n = new Date(this._start.value.getCurrentDate());
    n.setDate(1);
    const t = new Date(this._end.value.getCurrentDate());
    return t.setDate(1), n.getFullYear() < t.getFullYear() || n.getMonth() < t.getMonth() - 1;
  }
  get canGoNextMonth() {
    var n, t;
    return !((n = this._start) != null && n.value) || !((t = this.vModel) != null && t.start) ? this.allowMiddleNextOrPrevMonth : this.allowMiddleNextOrPrevMonth && (this._start.value.getCurrentMonth() < this.vModel.start.getMonth() || this._start.value.getCurrentYear() < this.vModel.start.getFullYear());
  }
  get canGoPrevMonth() {
    var n, t;
    return !((n = this._end) != null && n.value) || !((t = this.vModel) != null && t.start) ? this.allowMiddleNextOrPrevMonth : this.allowMiddleNextOrPrevMonth && (this._end.value.getCurrentMonth() > this.vModel.start.getMonth() || this._end.value.getCurrentYear() > this.vModel.start.getFullYear());
  }
  get vModel() {
    return this.props.modelValue;
  }
  set vModel(n) {
    this.emit("update:modelValue", n), n != null && n.start && n.end ? this.emit("select-range", n) : rl(() => {
      var t, u;
      if (n != null && n.start && !n.end && this._end.value && this._end.value.getCurrentDate().valueOf() <= n.start.valueOf()) {
        const i = new Date(n.start);
        i.setMonth(i.getMonth() + 1), (t = this._end.value) == null || t.selectYear(i.getFullYear()), (u = this._end.value) == null || u.selectMonth(i.getMonth());
      }
    });
  }
  async onBeforeMount() {
    this.vModel || (this.vModel = {});
  }
  handleChangeMonth(n) {
    rl(() => {
      var t, u;
      !this._start.value || !this._end.value || (t = this.vModel) != null && t.selecting && this.vModel.start && this.vModel.start.valueOf() > ((u = this._start.value) == null ? void 0 : u.getCurrentDate().valueOf()) && (n === "start" ? (this._end.value.selectYear(this.vModel.start.getFullYear()), this._end.value.selectMonth(this.vModel.start.getMonth())) : n === "end" && (this._start.value.selectYear(this.vModel.start.getFullYear()), this._start.value.selectMonth(this.vModel.start.getMonth())));
    });
  }
}
S(Th, "props", {
  modelValue: {
    type: Object,
    default: void 0
  },
  minDate: {
    type: Date,
    default: void 0
  },
  maxDate: {
    type: Date,
    default: void 0
  }
});
const tk = {
  key: 0,
  class: "orion-date-range"
}, uk = /* @__PURE__ */ A("div", {
  class: "orion-date-range__separator"
}, null, -1), _v = /* @__PURE__ */ K({
  __name: "OrionDateRange",
  props: Th.props,
  emits: ["update:modelValue", "select-range"],
  setup(e, {
    expose: l,
    emit: n
  }) {
    const t = n, u = e, i = new Th(u, t);
    return l(i.publicInstance), (s, r) => c(i).vModel ? (y(), O("div", tk, [R(c(ai), {
      ref: c(i)._start,
      modelValue: c(i).vModel.start,
      "onUpdate:modelValue": r[0] || (r[0] = (o) => c(i).vModel.start = o),
      range: c(i).vModel,
      "onUpdate:range": r[1] || (r[1] = (o) => c(i).vModel = o),
      dayHover: c(i).dayHover,
      "onUpdate:dayHover": r[2] || (r[2] = (o) => c(i).dayHover = o),
      type: "range",
      "range-start": "",
      "disable-month-and-year": "",
      "min-date": s.minDate,
      "max-date": s.maxDate,
      "can-go-next-month": c(i).canGoNextMonth,
      onChangeMonth: r[3] || (r[3] = (o) => c(i).handleChangeMonth("start"))
    }, null, 8, ["modelValue", "range", "dayHover", "min-date", "max-date", "can-go-next-month"]), uk, R(c(ai), {
      ref: c(i)._end,
      modelValue: c(i).vModel.end,
      "onUpdate:modelValue": r[4] || (r[4] = (o) => c(i).vModel.end = o),
      range: c(i).vModel,
      "onUpdate:range": r[5] || (r[5] = (o) => c(i).vModel = o),
      dayHover: c(i).dayHover,
      "onUpdate:dayHover": r[6] || (r[6] = (o) => c(i).dayHover = o),
      type: "range",
      "range-end": "",
      "disable-month-and-year": "",
      "min-date": s.minDate,
      "max-date": s.maxDate,
      "can-go-prev-month": c(i).canGoPrevMonth,
      onChangeMonth: r[7] || (r[7] = (o) => c(i).handleChangeMonth("end"))
    }, null, 8, ["modelValue", "range", "dayHover", "min-date", "max-date", "can-go-prev-month"])])) : I("", !0);
  }
}), ad = {
  install(e, l = "o") {
    e.component(`${tl(l)}DateRange`, _v);
  }
};
class Oh extends gl {
  constructor(n, t) {
    super(n);
    S(this, "state", fl({
      year: (/* @__PURE__ */ new Date()).getFullYear(),
      viewYears: !1
    }));
    S(this, "_weekPicker", J());
    this.emit = t;
  }
  get numberOfWeeksInYear() {
    return X(new Date(this.state.year, 0, 1)).hasFiftyThreeWeeks() ? 53 : 52;
  }
  get vModel() {
    return this.props.modelValue;
  }
  set vModel(n) {
    this.emit("update:modelValue", n);
  }
  get weekOptions() {
    const n = [];
    for (let t = 1; t <= this.numberOfWeeksInYear; t++)
      this.props.hideDisabled && this.weekIsDisabled(this.weekDates(t)) || n.push({
        ...this.weekDates(t),
        weekNumber: t,
        year: this.state.year
      });
    return n;
  }
  get rangeYears() {
    const n = this.state.year - this.state.year % 10, t = [];
    for (let u = 0; u < 10; u++)
      t.push(n + u);
    return t;
  }
  get year() {
    return this.state.year;
  }
  get viewYears() {
    return this.state.viewYears;
  }
  get publicInstance() {
    return {
      ...super.publicInstance,
      _weekPicker: () => this._weekPicker.value
    };
  }
  onMounted() {
    var n;
    (n = this.vModel) != null && n.year && (this.state.year = this.vModel.year), rl(() => {
      var u, i, s, r, o;
      const t = (u = this.vModel) != null && u.weekNumber && ((i = this.vModel) == null ? void 0 : i.year) === this.state.year ? (s = this._weekPicker.value) == null ? void 0 : s.getElementsByClassName("calendar__week-row--active").item(0) : (r = this._weekPicker.value) == null ? void 0 : r.querySelector("div.calendar__week-row:not(.calendar__week-row--disabled)");
      t && ((o = this._weekPicker.value) == null || o.scrollTo({
        top: t.offsetTop - 120,
        behavior: "smooth"
      }));
    });
  }
  weekDates(n) {
    return X(new Date(this.state.year, 0, n * 7)).getWeekDates();
  }
  showYears() {
    this.props.disableMonthAndYear || (this.state.viewYears = !0);
  }
  switchPeriod(n) {
    this.state.viewYears ? this.state.year += n * 10 : this.state.year += n;
  }
  selectYear(n) {
    this.state.year = n, this.state.viewYears = !1;
  }
  selectWeek(n) {
    this.props.minDate && n.start && n.start.valueOf() < this.props.minDate.valueOf() || this.props.maxDate && n.end && n.end.valueOf() > this.props.maxDate.valueOf() || (this.vModel = {
      ...n
    });
  }
  readableWeek(n) {
    if (n.start && n.end)
      return this.lang.DATE_FROM_TO.replace("$start", X(n.start).toReadable()).replace("$end", X(n.end).toReadable());
  }
  weekIsDisabled(n) {
    return this.props.minDate && n.start && n.start < this.props.minDate || this.props.maxDate && n.end && n.end > this.props.maxDate;
  }
  weekIsActive(n) {
    var t, u;
    return ((t = this.vModel) == null ? void 0 : t.weekNumber) === n.weekNumber && ((u = this.vModel) == null ? void 0 : u.year) === this.year;
  }
}
S(Oh, "props", {
  disableMonthAndYear: Boolean,
  hideDisabled: Boolean,
  modelValue: {
    type: Object,
    default: void 0
  },
  minDate: {
    type: Date,
    default: void 0
  },
  maxDate: {
    type: Date,
    default: void 0
  }
});
const ik = {
  class: "orion-date-week__header"
}, sk = {
  class: "orion-date-week__header-current-display"
}, rk = {
  key: 1,
  class: "orion-date-week__header-current-range-years"
}, ok = {
  class: "orion-date-week__body"
}, ak = ["onClick"], dk = {
  class: "orion-date-week__week-number"
}, ck = {
  class: "orion-date-week__week-readable-days"
}, hk = ["onClick"], Sv = /* @__PURE__ */ K({
  __name: "OrionDateWeek",
  props: Oh.props,
  emits: ["update:modelValue"],
  setup(e, {
    expose: l,
    emit: n
  }) {
    const t = n, u = e, i = new Oh(u, t);
    return l(i.publicInstance), (s, r) => (y(), O("div", {
      class: "orion-date-week",
      onMousedown: r[3] || (r[3] = kl(() => {
      }, ["prevent"]))
    }, [A("div", ik, [R(c(Ml), {
      class: "orion-date-week__header-carret",
      icon: "chevron_left",
      onClick: r[0] || (r[0] = (o) => c(i).switchPeriod(-1))
    }), A("span", sk, [c(i).viewYears ? (y(), O("span", rk, B(`${c(i).rangeYears[0]} - ${c(i).rangeYears[c(i).rangeYears.length - 1]}`), 1)) : (y(), O("span", {
      key: 0,
      class: z(["orion-date-week__header-current-year", {
        disable: c(i).props.disableMonthAndYear
      }]),
      onClick: r[1] || (r[1] = (o) => c(i).showYears())
    }, B(c(i).year), 3))]), R(c(Ml), {
      class: "orion-date-week__header-carret",
      icon: "chevron_right",
      onClick: r[2] || (r[2] = (o) => c(i).switchPeriod(1))
    })]), A("div", ok, [vl(A("div", {
      ref: c(i)._weekPicker,
      class: "orion-date-week__week-picker"
    }, [(y(!0), O(hl, null, Sl(c(i).weekOptions, (o) => (y(), O("div", {
      key: o.weekNumber,
      class: z(["orion-date-week__week-row", [{
        "orion-date-week__week-row--disabled": c(i).weekIsDisabled(o)
      }, {
        "orion-date-week__week-row--active": c(i).weekIsActive(o)
      }]]),
      onClick: (a) => c(i).selectWeek(o)
    }, [A("div", dk, B(c(i).lang.WEEK) + " " + B(o.weekNumber), 1), A("div", ck, B(c(i).readableWeek(o)), 1)], 10, ak))), 128))], 512), [[cn, !c(i).viewYears]]), vl(A("div", null, [(y(), O(hl, null, Sl(3, (o) => A("div", {
      key: o,
      class: "orion-date-week-row"
    }, [(y(!0), O(hl, null, Sl(c(i).rangeYears.slice((o - 1) * 4, o * 4), (a) => (y(), O("span", {
      key: `year-${a}`,
      class: "orion-date-week-row__cell orion-date-week-row__cell--year",
      onClick: (d) => c(i).selectYear(a)
    }, B(a), 9, hk))), 128))])), 64))], 512), [[cn, c(i).viewYears]])])], 32));
  }
}), dd = {
  install(e, l = "o") {
    e.component(`${tl(l)}DateWeek`, Sv);
  }
};
class kh extends gl {
  constructor(l) {
    super(l);
  }
}
S(kh, "props", {
  ..._l.size(),
  ..._l.colorExtendedAndGreys(),
  // @doc props/outline adds an outline style on the label
  // @doc/fr props/outline ajoute un contraste sur le label
  outline: Boolean
});
const pk = {
  class: "orion-label__content"
}, Cv = /* @__PURE__ */ K({
  __name: "OrionLabel",
  props: kh.props,
  setup(e, {
    expose: l
  }) {
    const n = e, t = new kh(n);
    return l(t.publicInstance), (u, i) => (y(), O("span", {
      class: z(["orion-label", [`orion-label--${c(t).props.color}`, `orion-label--${c(t).props.size}`, {
        "orion-label--outline": c(t).props.outline
      }]])
    }, [A("div", pk, [V(u.$slots, "default")])], 2));
  }
}), cd = {
  install(e, l = "o") {
    e.component(`${tl(l)}Label`, Cv);
  }
};
class Mh extends Gl {
  constructor(n, t) {
    super(n, t);
    S(this, "focusedWithMouse", !1);
    S(this, "_popover", J());
    S(this, "_options", J());
    S(this, "_hours", J());
    S(this, "_minutes", J());
    S(this, "state", fl({
      ...super.state,
      mobileHoursValue: 0,
      mobileMinutesValue: 0,
      selectionIsOn: void 0,
      rangeBuffer: void 0
    }));
    S(this, "handleTimeItemScrollThrottled", ws((n) => this.computeTimeItemsStyle(n), 16));
    S(this, "handleTimeScrollDebounced", Be(() => {
      const n = new Date(this.vModel ?? Date.now());
      n.setMinutes(this.state.mobileMinutesValue), this.appLang && this.isPm ? n.setHours(this.state.mobileHoursValue + 12) : n.setHours(this.state.mobileHoursValue), this.vModel = n;
    }, 200));
    this.emit = t, xo(() => this.state.rangeBuffer = {
      ...this.props.range
    }), this.props.clearToNull && this.props.type === "multiple" && console.warn('OrionDatepicker - props "clear-to-null" is not compatible with type "multiple"');
  }
  get dateSeparator() {
    return this.lang.DATE_SEPARATOR;
  }
  get timeSeparator() {
    return this.lang.TIME_SEPARATOR;
  }
  get dateTimeSeparator() {
    return this.lang.DATETIME_SEPARATOR;
  }
  get dateformat() {
    return this.setDateFormat();
  }
  get pattern() {
    return this.getPattern();
  }
  get appLang() {
    return jt();
  }
  get selectionIsOnHourMinute() {
    return !!this.state.selectionIsOn && ["hours", "minutes", "ampm"].includes(this.state.selectionIsOn);
  }
  get isFocus() {
    return this.state.isFocus;
  }
  get displayDateSelected() {
    var n, t, u, i, s;
    if (this.props.type === "range" || this.props.type === "week") {
      if (((n = this.range) == null ? void 0 : n.start) instanceof Date && ((t = this.range) == null ? void 0 : t.end) instanceof Date)
        return this.lang.DATE_FROM_TO.replace("$start", X(this.range.start).toReadable()).replace("$end", X(this.range.end).toReadable());
    } else if (this.props.type === "month") {
      if (((u = this.range) == null ? void 0 : u.start) instanceof Date)
        return (s = X((i = this.range) == null ? void 0 : i.start)) == null ? void 0 : s.toReadable("$MMMM");
    } else {
      if (this.vModel instanceof Date)
        return this.inputValueFormat(this.vModel);
      if (this.state.isFocus)
        return this.dateformat.replaceAll("$", "").toLowerCase();
    }
    return "";
  }
  get maxInput() {
    return this.props.time ? 16 : 10;
  }
  get hasValue() {
    return ["range", "week", "month"].includes(this.props.type) && this.props.range ? !!this.props.range.start && !!this.props.range.end : this.props.type === "multiple" ? this.props.multiple.length > 0 : !In(this.vModel);
  }
  get minDate() {
    return this.props.minDate ? X(this.props.minDate).toMidnight() : void 0;
  }
  get maxDate() {
    return this.props.maxDate ? X(this.props.maxDate).toEndOfDay() : void 0;
  }
  get isOnPhoneWithTimepicker() {
    return this.props.type === "date" && this.props.time && this.responsive.onPhone;
  }
  get isPm() {
    return this.displayDateSelected.includes("PM");
  }
  get vModel() {
    return this.props.modelValue;
  }
  set vModel(n) {
    const t = this.vModel, u = (n == null ? void 0 : n.getDate()) === (t == null ? void 0 : t.getDate()) && (n == null ? void 0 : n.getMonth()) === (t == null ? void 0 : t.getMonth()) && (n == null ? void 0 : n.getFullYear()) === (t == null ? void 0 : t.getFullYear());
    n && (t && (this.props.preserveTime || !u) && n.setHours(t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()), this.props.minDate && n.valueOf() < this.props.minDate.valueOf() && (n = this.props.minDate), this.props.maxDate && n.valueOf() > this.props.maxDate.valueOf() && (n = this.props.maxDate)), this.emit("update:modelValue", n), this.emit("input", n);
  }
  get range() {
    return this.props.range;
  }
  get rangeBuffer() {
    return this.state.rangeBuffer;
  }
  set rangeBuffer(n) {
    this.state.rangeBuffer = n, !(n != null && n.selecting) && (n != null && n.start && !n.end || this.emit("update:range", n));
  }
  get multiple() {
    return this.props.multiple;
  }
  set multiple(n) {
    this.emit("update:multiple", n);
  }
  inputValueFormat(n) {
    return this.props.time && this.props.type !== "multiple" ? X(n).toReadable() + this.dateTimeSeparator + X(n).toReadable(`$hh${this.timeSeparator}$mm${this.appLang === "en" ? " $A" : ""}`) : X(n).toReadable();
  }
  setDateFormat() {
    let n = this.lang.DATE_PATTERN;
    return this.props.time && this.props.type !== "multiple" && (n += this.dateTimeSeparator + this.lang.HOUR_FORMAT.replace("$TIME_SEPARATOR", this.timeSeparator)), this.appLang === "fr" && (n = n.replaceAll("D", "J").replaceAll("Y", "A")), n;
  }
  getPattern() {
    var s, r;
    const n = this.dateformat.toLocaleLowerCase().indexOf("$d"), t = this.dateformat.indexOf("$M");
    let u, i;
    return n < t ? (u = 0, i = 1) : (u = 1, i = 0), {
      day: this.dateformat.split(this.dateTimeSeparator)[0].split(this.dateSeparator)[u].toLocaleLowerCase(),
      month: this.dateformat.split(this.dateTimeSeparator)[0].split(this.dateSeparator)[i].toLocaleLowerCase(),
      year: this.dateformat.split(this.dateTimeSeparator)[0].split(this.dateSeparator)[2].toLocaleLowerCase(),
      hour: (s = this.dateformat.split(this.dateTimeSeparator)[1]) == null ? void 0 : s.split(this.timeSeparator)[0],
      minute: (r = this.dateformat.split(this.dateTimeSeparator)[1]) == null ? void 0 : r.split(this.timeSeparator)[1]
    };
  }
  getEventData() {
    var T, M, H;
    const n = this._input.value, t = /(PM$)/.test(n.value), u = /(AM|PM$)/.test(n.value), i = n.selectionStart !== null && n.selectionEnd !== null ? n.value.slice(n.selectionStart, n.selectionEnd) : "", s = i.length === n.value.length, r = n.value.indexOf(this.dateSeparator), o = n.value.indexOf(this.dateTimeSeparator), a = n.value.indexOf(this.dateSeparator, r + 1), d = n.value.indexOf(this.timeSeparator, o + 1), h = n.selectionStart ?? 0, p = this.dateformat.toLowerCase().indexOf("$d"), f = this.dateformat.toLowerCase().indexOf("$m");
    let m, g;
    p < f ? (m = 0, g = 1) : (m = 1, g = 0);
    let v, w;
    this.appLang === "fr" ? (v = h <= r, w = h > r && h <= a) : this.appLang === "en" && (w = h <= r, v = h > r && h <= a);
    const $ = h > a && (!this.props.time || this.props.time && h <= o), _ = this.props.time && h > o && h <= d, b = this.props.time && h > d && h <= d + 3, k = this.props.time && /(AM|PM)$/.test(n.value) && h >= n.value.length - 2;
    return {
      input: n,
      cursorPosition: h,
      firstSeparatorIndex: r,
      secondSeparatorIndex: a,
      dateTimeSeparatorIndex: o,
      timeSeparatorIndex: d,
      selection: i,
      selectionIsOnYear: $,
      selectionIsOnMonth: w,
      selectionIsOnDay: v,
      selectionIsOnHour: _,
      selectionIsOnMinute: b,
      selectionIsOnAmPm: k,
      isFullSelected: s,
      isPM: t,
      isTwelveHours: u,
      day: n.value.split(this.dateTimeSeparator)[0].split(this.dateSeparator)[m],
      month: n.value.split(this.dateTimeSeparator)[0].split(this.dateSeparator)[g],
      year: n.value.split(this.dateTimeSeparator)[0].split(this.dateSeparator)[2],
      hour: (T = n.value.split(this.dateTimeSeparator)[1]) == null ? void 0 : T.split(this.timeSeparator)[0],
      minute: (H = (M = n.value.split(this.dateTimeSeparator)[1]) == null ? void 0 : M.split(this.timeSeparator)[1]) == null ? void 0 : H.replace(/\s*(AM|PM)$/, "")
    };
  }
  setSelectionToYear() {
    this.state.selectionIsOn = "year";
    const {
      input: n,
      secondSeparatorIndex: t
    } = this.getEventData();
    n.setSelectionRange(t + 1, t + 5);
  }
  setSelectionToMonth() {
    this.state.selectionIsOn = "month";
    const {
      input: n,
      firstSeparatorIndex: t,
      secondSeparatorIndex: u
    } = this.getEventData();
    this.appLang === "fr" ? n.setSelectionRange(t + 1, u) : n.setSelectionRange(0, t);
  }
  setSelectionToDay() {
    this.state.selectionIsOn = "day";
    const {
      input: n,
      firstSeparatorIndex: t,
      secondSeparatorIndex: u
    } = this.getEventData();
    this.appLang === "fr" ? n.setSelectionRange(0, t) : n.setSelectionRange(t + 1, u);
  }
  setSelectionToHour() {
    if (!this.props.time)
      return;
    this.state.selectionIsOn = "hours";
    const {
      input: n,
      hour: t,
      timeSeparatorIndex: u
    } = this.getEventData();
    n.setSelectionRange(u - (t == null ? void 0 : t.length), u);
  }
  setSelectionToMinute() {
    if (!this.props.time)
      return;
    this.state.selectionIsOn = "minutes";
    const {
      input: n,
      timeSeparatorIndex: t
    } = this.getEventData();
    n.setSelectionRange(t + 1, t + 3);
  }
  setSelectionToAmPm() {
    if (!this.props.time || this.appLang !== "en")
      return;
    this.state.selectionIsOn = "ampm";
    const {
      input: n
    } = this.getEventData();
    n.setSelectionRange(n.value.length - 2, n.value.length);
  }
  toggleYear(n) {
    if (!this.vModel)
      return;
    const t = new Date(this.vModel);
    t.setFullYear(t.getFullYear() + (n === "ArrowUp" ? 1 : -1)), this.vModel = t;
  }
  toggleMonth(n) {
    if (!this.vModel)
      return;
    const t = new Date(this.vModel);
    t.setMonth(t.getMonth() + (n === "ArrowUp" ? 1 : -1)), this.vModel = t;
  }
  toggleDay(n) {
    if (!this.vModel)
      return;
    const t = new Date(this.vModel);
    t.setDate(t.getDate() + (n === "ArrowUp" ? 1 : -1)), this.vModel = t;
  }
  toggleHour(n) {
    if (!this.vModel)
      return;
    const t = new Date(this.vModel);
    t.setHours(t.getHours() + (n === "ArrowUp" ? 1 : -1)), this.vModel = t;
  }
  toggleMinute(n) {
    if (!this.vModel)
      return;
    const t = new Date(this.vModel);
    t.setMinutes(t.getMinutes() + (n === "ArrowUp" ? 1 : -1)), this.vModel = t;
  }
  toggleAmPm(n) {
    if (!this.vModel)
      return;
    const t = new Date(this.vModel);
    t.setHours(t.getHours() + (n === "ArrowUp" ? 12 : -12)), this.vModel = t;
  }
  setAmPm(n) {
    if (!this.vModel)
      return;
    const {
      isPM: t
    } = this.getEventData();
    if (t && ["P", "p"].includes(n) || !t && ["A", "a"].includes(n))
      return;
    const u = new Date(this.vModel);
    u.setHours(u.getHours() + (["P", "p"].includes(n) ? 12 : -12)), this.vModel = u;
  }
  setInputStringValue(n, t, u, i = "hh", s = "mm") {
    const {
      input: r,
      isPM: o,
      isTwelveHours: a
    } = this.getEventData(), d = /^\d{1,4}$/, p = (this.props.time ? d.test(n) && d.test(t) && d.test(u) && d.test(i) && d.test(s) : d.test(n) && d.test(t) && d.test(u)) ? this.props.time ? new Date(Number(n), Number(t) - 1, Number(u), Number(i), Number(s)) : new Date(Number(n), Number(t) - 1, Number(u)) : null;
    p ? (a && +i < 13 && o && i !== "12" && p.setHours(+i + 12), a && +i < 13 && !o && i === "12" && p.setHours(0), this.vModel = p) : (u = d.test(u) ? u.padStart(2, "0") : u, t = d.test(t) ? t.padStart(2, "0") : t, n = d.test(n) ? n.padEnd(4, "0") : n, i = d.test(i) ? i.padStart(2, "0") : i, s = d.test(s) ? s.padStart(2, "0") : s, this.props.time ? r.value = this.dateformat.toLowerCase().replace(this.pattern.day, u).replace(this.pattern.month, t).replace(this.pattern.year, n).replace(this.pattern.hour, i).replace(this.pattern.minute, s) + (this.appLang === "en" ? d.test(i) && +i > 12 ? " PM" : " AM" : "") : r.value = this.dateformat.toLowerCase().replace(this.pattern.day, u).replace(this.pattern.month, t).replace(this.pattern.year, n));
  }
  computeTimeItemsStyle(n) {
    if (!this._hours.value || !this._minutes.value)
      return;
    const t = n === "hours" ? this._hours.value.getBoundingClientRect() : this._minutes.value.getBoundingClientRect(), u = n === "hours" ? Array.from(this._hours.value.children) : Array.from(this._minutes.value.children), i = t.top + t.height / 2, s = t.height / 2;
    for (let r = 0; r < u.length; r++) {
      const o = u[r], a = o.getBoundingClientRect(), d = a.top + a.height / 2;
      let h;
      if (d < t.top || d > t.bottom) {
        o.setAttribute("style", "--factor: 0");
        continue;
      }
      d < i ? h = d - t.top : d > i ? h = t.bottom - d : h = s;
      const p = h * 100 / s / 100;
      o.setAttribute("style", `--factor: ${p}`), +p.toFixed(1) == 1 && (n === "hours" ? this.state.mobileHoursValue = +o.innerText : this.state.mobileMinutesValue = +o.innerText);
    }
  }
  scrollCurrentTimeItem(n, t) {
    var i;
    const u = n === "hours" ? this._hours.value : this._minutes.value;
    (i = Array.from((u == null ? void 0 : u.children) ?? []).find((s) => s.dataset.value === t.toString())) == null || i.scrollIntoView({
      block: "center"
    });
  }
  handleMouseup() {
    var o;
    if (this.responsive.onPhone) {
      (o = this._input.value) == null || o.blur();
      return;
    }
    const {
      selectionIsOnYear: n,
      selectionIsOnMonth: t,
      selectionIsOnDay: u,
      selectionIsOnHour: i,
      selectionIsOnMinute: s,
      selectionIsOnAmPm: r
    } = this.getEventData();
    setTimeout(() => {
      this.props.selectOnFocus && this.hasValue || (this.vModel ? (n && this.setSelectionToYear(), t && this.setSelectionToMonth(), u && this.setSelectionToDay(), i && this.setSelectionToHour(), s && this.setSelectionToMinute(), r && this.setSelectionToAmPm()) : this.appLang === "en" ? this.setSelectionToMonth() : this.setSelectionToDay());
    }, 25);
  }
  handleMousedown() {
    this.focusedWithMouse = !0;
  }
  handleFocus(n) {
    !this.focusedWithMouse && this.props.type === "date" && !this.responsive.onPhone && !this.props.selectOnFocus && setTimeout(() => {
      const {
        input: t,
        firstSeparatorIndex: u
      } = this.getEventData();
      t.setSelectionRange(0, u);
    }, 25), super.handleFocus(n);
  }
  handleBlur(n, t = !1) {
    this.responsive.onPhone && !t || (this.focusedWithMouse = !1, super.handleBlur(n));
  }
  handleClear() {
    const n = this.props.clearToNull ? null : void 0;
    this.props.disabled || this.props.readonly || (this.props.type === "range" || this.props.type === "week" || this.props.type === "month" ? this.emit("update:range", n) : this.props.type === "multiple" ? this.emit("update:multiple", []) : this.emit("update:modelValue", n), this.emit("input", n), this.emit("change", n), this.emit("clear"));
  }
  handleKeydownGuard(n) {
    var ll, Y;
    const {
      input: t,
      cursorPosition: u,
      day: i,
      month: s,
      year: r,
      hour: o,
      minute: a,
      isTwelveHours: d,
      isFullSelected: h,
      selection: p,
      selectionIsOnYear: f,
      selectionIsOnMonth: m,
      selectionIsOnDay: g,
      selectionIsOnHour: v,
      selectionIsOnMinute: w,
      selectionIsOnAmPm: $,
      firstSeparatorIndex: _,
      secondSeparatorIndex: b,
      dateTimeSeparatorIndex: k,
      timeSeparatorIndex: T
    } = this.getEventData();
    let {
      key: M
    } = n;
    const H = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"], x = ["A", "a", "P", "p"], P = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], Z = ["Backspace", "Delete"], F = ["Tab"], el = [...H, ...x, ...P, ...Z, ...F, this.dateSeparator, this.timeSeparator], al = this.dateSeparator.includes(M) || this.timeSeparator.includes(M) || this.dateTimeSeparator.includes(M);
    if (n.metaKey || n.ctrlKey || !(el.includes(M) || al)) {
      n.preventDefault();
      return;
    }
    if (al && (M = "ArrowRight"), [...F].includes(M) || n.preventDefault(), P.includes(M) && (M === "ArrowRight" && (this.setInputStringValue(r, s, i, o, a), rl(() => {
      g && (this.appLang === "fr" ? this.setSelectionToMonth() : this.setSelectionToYear()), m && (this.appLang === "fr" ? this.setSelectionToYear() : this.setSelectionToDay()), f && this.setSelectionToHour(), v && this.setSelectionToMinute(), w && this.setSelectionToAmPm();
    })), M === "ArrowLeft" && (this.setInputStringValue(r, s, i, o, a), rl(() => {
      g && this.appLang === "en" && this.setSelectionToMonth(), m && this.appLang === "fr" && this.setSelectionToDay(), f && (this.appLang === "fr" ? this.setSelectionToMonth() : this.setSelectionToDay()), v && this.setSelectionToYear(), w && this.setSelectionToHour(), $ && this.setSelectionToMinute();
    })), (M === "ArrowDown" || M === "ArrowUp") && (g && /\d{1,2}/.test(i) && (this.toggleDay(M), rl(() => this.setSelectionToDay())), m && /\d{1,2}/.test(s) && (this.toggleMonth(M), rl(() => this.setSelectionToMonth())), f && /\d{4}/.test(r) && (this.toggleYear(M), rl(() => this.setSelectionToYear())), v && /\d{1,2}/.test(o) && (this.toggleHour(M), rl(() => this.setSelectionToHour())), w && /\d{1,2}/.test(a) && (this.toggleMinute(M), rl(() => this.setSelectionToMinute())), $ && (this.toggleAmPm(M), rl(() => this.setSelectionToAmPm())))), H.includes(M)) {
      const Q = Number(M);
      if (g)
        if (i.length === 2 && Q >= 4)
          this.setInputStringValue(r, s, M, o, a), rl(() => this.appLang === "en" ? this.setSelectionToYear() : this.setSelectionToMonth());
        else if (i.length === 1) {
          if (i === "3" && Q > 1)
            return;
          this.setInputStringValue(r, s, i + M, o, a), rl(() => this.appLang === "en" ? this.setSelectionToYear() : this.setSelectionToMonth());
        } else
          this.appLang === "en" ? (t.value = t.value.slice(0, u) + Q + t.value.slice(b), t.setSelectionRange(_ + 2, _ + 2)) : (t.value = Q + t.value.slice(u + 2), t.setSelectionRange(1, 1));
      m && (s.length === 2 ? Q > 1 ? (this.setInputStringValue(r, M, i, o, a), rl(() => this.appLang === "en" ? this.setSelectionToDay() : this.setSelectionToYear())) : this.appLang === "en" ? (t.value = Q + t.value.slice(u + 2), t.setSelectionRange(1, 1)) : (t.value = t.value.slice(0, u) + Q + t.value.slice(b), t.setSelectionRange(u + 1, u + 1)) : s.length === 1 && (s === "1" && Q <= 2 || s === "0") && (this.setInputStringValue(r, s + M, i, o, a), rl(() => {
        this.appLang === "fr" ? this.setSelectionToYear() : this.setSelectionToDay();
      }))), f && (this.props.time ? (t.value = t.value.slice(0, u) + Q + t.value.slice(k), t.setSelectionRange(u + 1, u + 1), r.length === 3 && (this.setInputStringValue(r + M, s, i, o, a), rl(() => {
        this.setSelectionToHour();
      }))) : r.length === 3 ? this.setInputStringValue(r + M, s, i, o, a) : (r.length < 4 || p.length === 4) && (t.value = t.value.slice(0, u) + Q)), v && (o.length === 2 ? Q > 2 || this.appLang === "en" && Q > 1 ? (this.setInputStringValue(r, s, i, M, a), rl(() => this.setSelectionToMinute())) : (t.value = t.value.slice(0, u) + Q + t.value.slice(T), t.setSelectionRange(u + 1, u + 1)) : o.length === 1 && (o === "2" && Q <= 3 || o === "1" || o === "0") && (this.setInputStringValue(r, s, i, o + M, a), rl(() => this.setSelectionToMinute()))), w && (p.length === 2 ? Q > 5 ? (this.setInputStringValue(r, s, i, o, M), rl(() => this.setSelectionToAmPm())) : (t.value = t.value.slice(0, u) + M + (d ? t.value.slice(t.value.length - 3) : ""), t.setSelectionRange(u + 1, u + 1)) : a.length === 1 && (this.setInputStringValue(r, s, i, o, a + M), rl(() => this.setSelectionToAmPm())));
    }
    if (x.includes(M) && $ && (this.setAmPm(M), rl(() => this.setSelectionToAmPm())), Z.includes(M)) {
      if (h) {
        this.clear(), rl(() => this.setSelectionToDay());
        return;
      }
      const Q = this.pattern.day.replace("$", ""), dl = this.pattern.month.replace("$", ""), zl = this.pattern.year.replace("$", ""), Xl = (ll = this.pattern.hour) == null ? void 0 : ll.replace("$", ""), sn = (Y = this.pattern.minute) == null ? void 0 : Y.replace("$", "");
      g && (isNaN(+i) ? this.appLang === "en" ? (this.setInputStringValue(r, dl, i, o, a), this.setSelectionToMonth()) : (this.handleClear(), rl(() => this.setSelectionToDay())) : (this.setInputStringValue(r, s, Q, o, a), this.setSelectionToDay())), m && (isNaN(+s) ? this.appLang === "en" ? (this.handleClear(), this.setSelectionToMonth()) : (this.setInputStringValue(r, s, Q, o, a), this.setSelectionToDay()) : (this.setInputStringValue(r, dl, i, o, a), this.appLang === "en" ? this.setSelectionToMonth() : this.setSelectionToDay())), f && (isNaN(+r) ? this.appLang === "en" ? (this.setInputStringValue(r, s, Q, o, a), this.setSelectionToDay()) : (this.setInputStringValue(r, dl, i, o, a), this.setSelectionToMonth()) : (this.setInputStringValue(zl, s, i, o, a), this.setSelectionToYear())), v && (isNaN(+o) ? (this.setInputStringValue(zl, s, i, o, a), this.setSelectionToYear()) : (this.setInputStringValue(r, s, i, Xl, a), this.setSelectionToHour())), w && (isNaN(+a) ? (this.setInputStringValue(r, s, i, Xl, a), this.setSelectionToHour()) : (this.setInputStringValue(r, s, i, o, sn), this.setSelectionToMinute()));
    }
    M === "Tab" && this.setInputStringValue(r, s, i, o, a);
  }
  handlePopperShow() {
    var n, t;
    if (S3(this._popover, () => this.handleBlur(void 0, !0)), this.isOnPhoneWithTimepicker && (this.computeTimeItemsStyle("hours"), this.computeTimeItemsStyle("minutes"), rl(() => {
      this.vModel && (this.scrollCurrentTimeItem("minutes", this.vModel.getMinutes()), this.scrollCurrentTimeItem("hours", this.appLang === "en" && this.vModel.getHours() > 12 ? this.vModel.getHours() - 12 : this.vModel.getHours()));
    })), this.props.type === "range" && this.hasValue, this.props.type === "week" && this.hasValue) {
      const u = (n = this._options.value) == null ? void 0 : n._weekPicker();
      u == null || u.scrollTo({
        top: ((t = u.querySelector(".orion-date-week__week-row--active")) == null ? void 0 : t.offsetTop) - 90
      });
    }
  }
  handlePopperHide() {
    var n;
    this.props.type === "range" && !this.hasValue && this.handleClear(), this.props.type === "range" && ((n = this.state.rangeBuffer) != null && n.selecting) && (this.state.rangeBuffer = {
      ...this.props.range
    });
  }
  handleTimeScroll(n) {
    this.handleTimeItemScrollThrottled(n), this.handleTimeScrollDebounced();
  }
  removeDate(n) {
    this.multiple = X(this.multiple).toggle(n);
  }
}
S(Mh, "props", {
  ...Gl.props,
  // @doc props/preserveTime keep the current time value when changing date
  // @doc/fr props/preserveTime conserve la valeur actuelle de l'heure lors du changement de date
  preserveTime: Boolean,
  // @doc props/time displays also hours/minutes
  // @doc/fr props/time affiche aussi les heures/minutes
  time: Boolean,
  // @doc props/hideDisabled hide disabled dates (currently for type="week" only)
  // @doc/fr props/hideDisabled cache les dates désactivées (actuellement uniquement avec type="week")
  hideDisabled: Boolean,
  // @doc props/range the modelValue if the type is set to `range`
  // @doc/fr props/range le modelValue si le type est défini à `range`
  range: {
    type: Object,
    default: void 0
  },
  // @doc props/multiple the modelValue if the type is set to `multiple`
  // @doc/fr props/multiple le modelValue si le type est défini à `multiple`
  multiple: {
    type: Array,
    default: () => []
  },
  // @doc props/multipleLabelColor color of the displayed dates is the type is set to `multiple`
  // @doc/fr props/multipleLabelColor couleurs des dates affichées si le type est défini à `multiple`
  multipleLabelColor: {
    type: String,
    default: "default"
  },
  // @doc props/minDate the minimum date which can be selected
  // @doc/fr props/minDate la date minimum qui peut être sélectionnée
  minDate: {
    type: Date,
    default: void 0
  },
  // @doc props/maxDate the maximum date which can be selected
  // @doc/fr props/maxDate la date maximum qui peut être sélectionnée
  maxDate: {
    type: Date,
    default: void 0
  },
  // @doc props/type the type of the model value
  // @doc/fr props/type le type de modelValue
  type: {
    type: String,
    default: "date",
    validator: (n) => ["date", "range", "week", "multiple", "month"].includes(n)
  },
  // @doc props/valueDisplayFormat function to customize the display format
  // @doc/fr props/valueDisplayFormat fonction pour personnaliser l'affichage
  valueDisplayFormat: {
    type: Function,
    default: void 0
  }
});
const fk = ["value", "maxlength"], mk = {
  key: 0,
  class: "orion-datepicker-multiple__content"
}, gk = {
  class: "flex ai-c g-xs"
}, vk = ["onClick"], yk = {
  class: "orion-datepicker__multiple"
}, $k = {
  key: 0
}, bk = ["innerHTML"], wk = {
  key: 1
}, _k = ["innerHTML"], Sk = ["innerHTML"], Ck = {
  key: 5,
  class: "orion-datepicker__timepicker-wrapper"
}, Tk = {
  class: "orion-datepicker-timepicker"
}, Ok = /* @__PURE__ */ A("div", {
  class: "orion-datepicker-timepicker__scroll-filler"
}, null, -1), kk = {
  key: 0,
  class: "orion-datepicker-timepicker__scroll-item"
}, Mk = ["data-value"], Ak = /* @__PURE__ */ A("div", {
  class: "orion-datepicker-timepicker__scroll-filler"
}, null, -1), xk = {
  class: "orion-datepicker-timepicker__separator"
}, Ek = /* @__PURE__ */ A("div", {
  class: "orion-datepicker-timepicker__scroll-filler"
}, null, -1), Ik = /* @__PURE__ */ A("div", {
  class: "orion-datepicker-timepicker__scroll-item"
}, "00", -1), Rk = ["data-value"], Dk = /* @__PURE__ */ A("div", {
  class: "orion-datepicker-timepicker__scroll-filler"
}, null, -1), Nk = {
  key: 0,
  class: "orion-datepicker-timepicker__meridian"
}, Lk = {
  class: "orion-datepicker-timepicker-actions"
}, Pk = {
  class: "orion-input__input"
}, Bk = /* @__PURE__ */ K({
  __name: "OrionDatepicker",
  props: Mh.props,
  emits: ["focus", "blur", "input", "change", "update:modelValue", "clear", "update:range", "update:multiple"],
  setup(e, {
    expose: l,
    emit: n
  }) {
    const t = n, u = e, i = new Mh(u, t);
    return l(i.publicInstance), (s, r) => {
      const o = Bl("v-dropdown");
      return y(), L(o, {
        ref: c(i)._popover,
        placement: "bottom-start",
        "positioning-disabled": c(i).responsive.onPhone,
        triggers: [],
        shown: c(i).isFocus,
        "auto-hide": !1,
        onApplyShow: r[25] || (r[25] = (a) => c(i).handlePopperShow()),
        onApplyHide: r[26] || (r[26] = (a) => c(i).handlePopperHide())
      }, {
        popper: U(() => [c(i).props.type === "date" ? (y(), L(c(ai), {
          key: 0,
          ref: c(i)._options,
          modelValue: c(i).vModel,
          "onUpdate:modelValue": [r[10] || (r[10] = (a) => c(i).vModel = a), r[11] || (r[11] = (a) => s.time && !c(i).responsive.onPhone ? s.$nextTick(() => c(i).setSelectionToHour()) : c(i).handleBlur(void 0, c(i).responsive.onPhone && !s.time))],
          "min-date": c(i).minDate,
          "max-date": c(i).maxDate
        }, null, 8, ["modelValue", "min-date", "max-date"])) : I("", !0), c(i).props.type === "multiple" ? (y(), L(c(ai), {
          key: 1,
          ref: c(i)._options,
          multiple: c(i).multiple,
          "onUpdate:multiple": r[12] || (r[12] = (a) => c(i).multiple = a),
          type: s.type === "multiple" ? "multiple" : void 0,
          "min-date": c(i).minDate,
          "max-date": c(i).maxDate,
          "onUpdate:modelValue": r[13] || (r[13] = (a) => s.time && !c(i).responsive.onPhone ? s.$nextTick(() => c(i).setSelectionToHour()) : c(i).handleBlur(void 0, c(i).responsive.onPhone && !s.time))
        }, null, 8, ["multiple", "type", "min-date", "max-date"])) : c(i).props.type === "range" ? (y(), L(c(_v), {
          key: 2,
          ref: c(i)._options,
          modelValue: c(i).rangeBuffer,
          "onUpdate:modelValue": r[14] || (r[14] = (a) => c(i).rangeBuffer = a),
          "min-date": c(i).minDate,
          "max-date": c(i).maxDate,
          onSelectRange: r[15] || (r[15] = (a) => c(i).handleBlur(void 0, !0))
        }, null, 8, ["modelValue", "min-date", "max-date"])) : c(i).props.type === "week" ? (y(), L(c(Sv), {
          key: 3,
          ref: c(i)._options,
          modelValue: c(i).rangeBuffer,
          "onUpdate:modelValue": [r[16] || (r[16] = (a) => c(i).rangeBuffer = a), r[17] || (r[17] = (a) => c(i).handleBlur())],
          "min-date": c(i).minDate,
          "max-date": c(i).maxDate,
          "hide-disabled": s.hideDisabled
        }, null, 8, ["modelValue", "min-date", "max-date", "hide-disabled"])) : I("", !0), c(i).props.type === "month" ? (y(), L(c(ai), {
          key: 4,
          ref: c(i)._options,
          range: c(i).rangeBuffer,
          "onUpdate:range": [r[18] || (r[18] = (a) => c(i).rangeBuffer = a), r[19] || (r[19] = (a) => c(i).handleBlur(void 0, c(i).responsive.onPhone))],
          "min-date": c(i).minDate,
          "max-date": c(i).maxDate,
          type: "range",
          month: ""
        }, null, 8, ["range", "min-date", "max-date"])) : I("", !0), c(i).isOnPhoneWithTimepicker ? (y(), O("div", Ck, [A("div", Tk, [A("div", {
          ref: c(i)._hours,
          class: "orion-datepicker-timepicker__hours",
          onScroll: r[20] || (r[20] = (a) => c(i).handleTimeScroll("hours"))
        }, [Ok, c(i).appLang === "fr" ? (y(), O("div", kk, " 00 ")) : I("", !0), (y(!0), O(hl, null, Sl(c(i).appLang === "en" ? 12 : 23, (a) => (y(), O("div", {
          key: a,
          "data-value": a,
          class: "orion-datepicker-timepicker__scroll-item"
        }, B(a.toString().padStart(2, "0")), 9, Mk))), 128)), Ak], 544), A("div", xk, B(c(i).lang.TIME_SEPARATOR), 1), A("div", {
          ref: c(i)._minutes,
          class: "orion-datepicker-timepicker__minutes",
          onScroll: r[21] || (r[21] = (a) => c(i).handleTimeScroll("minutes"))
        }, [Ek, Ik, (y(), O(hl, null, Sl(59, (a) => A("div", {
          key: a,
          "data-value": a,
          class: "orion-datepicker-timepicker__scroll-item"
        }, B(a.toString().padStart(2, "0")), 9, Rk)), 64)), Dk], 544), c(i).appLang === "en" ? (y(), O("div", Nk, [A("div", {
          class: z({
            active: !c(i).isPm
          }),
          onClick: r[22] || (r[22] = (a) => c(i).setAmPm("a"))
        }, " AM ", 2), A("div", {
          class: z({
            active: c(i).isPm
          }),
          onClick: r[23] || (r[23] = (a) => c(i).setAmPm("p"))
        }, " PM ", 2)])) : I("", !0)]), A("div", Lk, [A("div", Pk, B(c(i).displayDateSelected), 1), R(c(bl), {
          block: "",
          outline: "",
          color: "brand",
          onClick: r[24] || (r[24] = (a) => c(i).handleBlur(void 0, !0))
        }, {
          default: U(() => [$l(B(c(i).lang.VALIDATE), 1)]),
          _: 1
        })])])) : I("", !0)]),
        default: U(() => [R(c(Dt), ml(c(i).orionFieldBinding, {
          class: ["orion-datepicker", [{
            "orion-datepicker--range": c(i).props.type === "range"
          }, {
            "orion-datepicker-multiple": c(i).props.type === "multiple"
          }]],
          "has-value": c(i).hasValue,
          "label-is-floating": c(i).hasValue || c(i).props.type === "date" && c(i).isFocus,
          onClear: r[9] || (r[9] = (a) => c(i).handleClear())
        }), {
          default: U(() => {
            var a, d;
            return [c(i).props.type === "date" ? (y(), O("input", ml({
              key: 0,
              ref: c(i)._input,
              class: "orion-input__input",
              value: c(i).displayDateSelected,
              maxlength: c(i).maxInput
            }, s.$attrs, {
              onKeydown: r[0] || (r[0] = (h) => c(i).handleKeydownGuard(h)),
              onFocus: r[1] || (r[1] = (h) => c(i).handleFocus(h)),
              onMouseup: r[2] || (r[2] = (h) => c(i).handleMouseup()),
              onMousedown: r[3] || (r[3] = (h) => c(i).handleMousedown()),
              onBlur: r[4] || (r[4] = (h) => c(i).handleBlur(h))
            }), null, 16, fk)) : s.type === "multiple" ? (y(), O("div", {
              key: 1,
              ref: c(i)._input,
              class: "orion-input__input",
              tabindex: "0",
              onFocus: r[5] || (r[5] = (h) => c(i).handleFocus(h)),
              onBlur: r[6] || (r[6] = (h) => c(i).handleBlur(h))
            }, [s.$slots.multipleDisplay ? I("", !0) : (y(), O("div", mk, [(y(!0), O(hl, null, Sl(s.multiple, (h) => (y(), L(c(Cv), {
              key: h.toString(),
              color: s.multipleLabelColor,
              size: "sm"
            }, {
              default: U(() => [A("div", gk, [$l(B(c(i).inputValueFormat(h)) + " ", 1), A("span", {
                class: z("orion-datepicker-multiple__clearable"),
                onClick: (p) => c(i).removeDate(h)
              }, null, 8, vk)])]),
              _: 2
            }, 1032, ["color"]))), 128))])), A("div", yk, [V(s.$slots, "multipleDisplay", {
              datas: s.multiple,
              close: c(i).removeDate.bind(c(i))
            })])], 544)) : (y(), O("div", {
              key: 2,
              ref: c(i)._input,
              class: "orion-input__input",
              tabindex: "0",
              onFocus: r[7] || (r[7] = (h) => c(i).handleFocus(h)),
              onBlur: r[8] || (r[8] = (h) => c(i).handleBlur(h))
            }, [c(i).props.type === "week" && ((a = c(i).range) != null && a.weekNumber) ? (y(), O("span", $k, [c(i).props.valueDisplayFormat ? (y(), O("div", {
              key: 0,
              innerHTML: c(i).props.valueDisplayFormat(c(i).range)
            }, null, 8, bk)) : (y(), O(hl, {
              key: 1
            }, [$l(B(`${c(i).lang.WEEK} ${c(i).range.weekNumber}`), 1)], 64))])) : (y(), O("span", wk, [c(i).props.valueDisplayFormat ? (y(), O("div", {
              key: 0,
              innerHTML: c(i).props.valueDisplayFormat(c(i).vModel ?? c(i).range)
            }, null, 8, _k)) : (y(), O(hl, {
              key: 1
            }, [$l(B(c(i).displayDateSelected), 1)], 64))]))], 544)), c(i).showState && (c(i).showError || c(i).showWarning) && ((d = c(i).validationHtmlMessages) != null && d.length) ? (y(), O("div", {
              key: 3,
              class: "orion-input__error-message",
              innerHTML: c(i).validationHtmlMessages
            }, null, 8, Sk)) : I("", !0)];
          }),
          _: 3
        }, 16, ["has-value", "label-is-floating", "class"])]),
        _: 3
      }, 8, ["positioning-disabled", "shown"]);
    };
  }
}), hd = {
  install(e, l = "o") {
    e.component(`${tl(l)}Datepicker`, Bk);
  }
};
class Ah extends gl {
  constructor(n, t, u, i, s) {
    super(n);
    S(this, "state", fl({
      isDragging: !1
    }));
    S(this, "relativeX", 0);
    S(this, "relativeY", 0);
    S(this, "ghost", null);
    S(this, "anchor", null);
    S(this, "dropZone", null);
    S(this, "globalMouseEventUid");
    S(this, "globalTouchEventUid");
    S(this, "uid", this.getUid());
    S(this, "__uid", this.getUid());
    S(this, "dnd", Cf());
    this._droppable = u, this._aside = i, this._modal = s, this.emit = t;
  }
  get disabled() {
    return this.props.disabled;
  }
  set disabled(n) {
    this.emit("update:disabled", n);
  }
  get tag() {
    return this.props.tag;
  }
  get isDragging() {
    return this.state.isDragging;
  }
  set isDragging(n) {
    this.state.isDragging = n;
  }
  get $el() {
    var n;
    return (n = this.document) == null ? void 0 : n.getElementById(`orion-draggable-${this.uid}`);
  }
  startGlobalEvent() {
    if (!this.document)
      return;
    const n = () => {
      var t, u, i, s, r;
      this.globalMouseEventUid && nn(this.globalMouseEventUid), this.globalTouchEventUid && nn(this.globalTouchEventUid), (t = this.document) == null || t.removeEventListener("mouseup", n), (u = this.document) == null || u.removeEventListener("touchend", n), (i = this.document) == null || i.removeEventListener("touchcancel", n), (s = this.document) == null || s.body.classList.remove("body--orion-dragging"), (r = this.document) == null || r.body.removeAttribute("style"), this.handleDragEnd();
    };
    this.document.addEventListener("mouseup", n, {
      once: !0
    }), this.document.addEventListener("touchend", n, {
      once: !0
    }), this.document.addEventListener("touchcancel", n, {
      once: !0
    }), this.globalMouseEventUid = nn("mousemove", (t) => {
      const {
        clientX: u,
        clientY: i
      } = t;
      this.handleDrag(u, i);
    }), this.globalTouchEventUid = nn("touchmove", (t) => {
      if (!this.document)
        return;
      this.document.body.style.overflow = "hidden";
      const {
        touches: u
      } = t, i = u.item(0);
      i && this.handleDrag(i.clientX, i.clientY);
    });
  }
  handleMouseDown(n) {
    !this.document || this.dnd.registry.isDragging || this.props.disabled || (this.document.body.classList.add("body--orion-dragging"), !this.props.disabled && (n instanceof MouseEvent ? this.document.addEventListener("mousemove", this.handleDragStart.bind(this), {
      once: !0,
      passive: !1
    }) : n instanceof TouchEvent && this.document.addEventListener("touchmove", this.handleDragStart.bind(this), {
      once: !0,
      passive: !1
    })));
  }
  handleMouseUp() {
    !this.document || this.props.disabled || (this.document.removeEventListener("mousemove", this.handleDragStart.bind(this)), this.document.removeEventListener("touchmove", this.handleDragStart.bind(this)), this.document.body.classList.remove("body--orion-dragging"));
  }
  async handleDragStart(n) {
    var u, i;
    if (this.dnd.registry.isDragging)
      return;
    this.dnd.bus.on("dragLeave", this.goToInitialPlace.bind(this, void 0)), n.preventDefault(), this.isDragging = !0;
    const t = this.$el;
    if (t != null && t.getBoundingClientRect().left && (t != null && t.getBoundingClientRect().top))
      if (n instanceof MouseEvent)
        this.relativeX = n.clientX - (t == null ? void 0 : t.getBoundingClientRect().left), this.relativeY = n.clientY - (t == null ? void 0 : t.getBoundingClientRect().top), this.createGhost(n.clientX, n.clientY);
      else {
        const s = n.touches.item(0);
        s && (this.relativeX = s.clientX - (t == null ? void 0 : t.getBoundingClientRect().left), this.relativeY = s.clientY - (t == null ? void 0 : t.getBoundingClientRect().top), this.createGhost(s.clientX, s.clientY));
      }
    this.startGlobalEvent(), this.dropZone = t == null ? void 0 : t.parentNode, this.anchor = t == null ? void 0 : t.nextSibling, this._droppable && this.dnd.registerDrag({
      data: this.props.data,
      from: this._droppable.uid,
      to: null,
      index: null,
      canDrop: !1,
      fromAsideOrModal: ((u = this._aside) == null ? void 0 : u.uid) ?? ((i = this._modal) == null ? void 0 : i.uid) ?? null
    }), this.dnd.emitDragStart();
  }
  createDragOrigin() {
    var t, u;
    if (!this.document)
      return;
    const n = this.document.createElement("div");
    n.id = `dragOrigin-${this.uid}`, n.style.display = "none", (u = (t = this.$el) == null ? void 0 : t.parentNode) == null || u.insertBefore(n, this.$el);
  }
  createGhost(n, t) {
    var i, s;
    if (!this.document)
      return;
    const u = (i = this.$el) == null ? void 0 : i.getBoundingClientRect();
    this.ghost = (s = this.$el) == null ? void 0 : s.cloneNode(!0), this.ghost.classList.add("orion-draggable-clone"), this.ghost.style.width = `${u == null ? void 0 : u.width}px`, this.ghost.style.height = `${u == null ? void 0 : u.height}px`, this.document.body.appendChild(this.ghost), this.handleDrag(n, t);
  }
  handleDrag(n, t) {
    this.ghost && (this.dnd.registry.cursor.x = n, this.dnd.registry.cursor.y = t, this.ghost.style.zIndex = "1000", this.ghost.style.transform = `translate3d(
				${n - this.relativeX}px,
				${t - this.relativeY}px,
				0
			)`);
  }
  async handleDragEnd() {
    const n = X(this.dnd.registry.items).last();
    n && (n.to && this.dnd.emitDrop(), (!n.canDrop || !n.to) && await this.animateGhostBack(), this.removeGhost(), this.dnd.bus.off("dragLeave", this.goToInitialPlace.bind(this, n)), this.dnd.cleanRegistry(), this.dnd.emitDragEnd());
  }
  animateGhostBack() {
    return new Promise((n) => {
      var t, u;
      if (this.ghost) {
        this.anchor && ((t = this.anchor.parentNode) == null || t.insertBefore(this.$el, this.anchor)), this.ghost.addEventListener("transitionend", () => n(!0), {
          once: !0
        });
        const i = (u = this.$el) == null ? void 0 : u.getBoundingClientRect();
        this.ghost.style.transition = "all 0.3s ease-in-out", i && this.window && (this.ghost.style.top = `${i.top + this.window.scrollY}px`, this.ghost.style.left = `${i.left + this.window.scrollX}px`, this.ghost.style.transform = `translate3d(
						${0 - this.window.scrollX}px,
						${0 - this.window.scrollY}px,
						0
					)`);
      } else
        n(!0);
    });
  }
  removeGhost() {
    var n;
    this.isDragging = !1, (n = this.ghost) == null || n.remove();
  }
  goToInitialPlace(n) {
    var t, u;
    if (n && n.data.__uid === this.props.data.__uid) {
      const i = document == null ? void 0 : document.querySelector(".orion-dragging:not(.orion-draggable-clone)");
      i && ((u = (t = this.anchor) == null ? void 0 : t.parentNode) == null || u.insertBefore(i, this.anchor));
    }
  }
}
S(Ah, "props", {
  // @doc props/disabled if set, the item will not be draggable
  // @doc/fr props/disabled si défini, l'élément ne sera pas déplaçable
  disabled: Boolean,
  // @doc props/tag the tag or component of the draggable item
  // @doc/fr props/tag tag ou composant qui réprésentera l'élément
  tag: {
    type: String,
    default: "div"
  },
  // @doc props/data datas of the draggable item
  // @doc/fr props/data données de l'élément
  data: {
    type: Object,
    default: null
  }
});
const Fk = /* @__PURE__ */ K({
  __name: "OrionDraggable",
  props: Ah.props,
  emits: ["update:disabled"],
  setup(e, {
    expose: l,
    emit: n
  }) {
    const t = e, u = Tn("_aside"), i = Tn("_modal"), s = Tn("_droppable"), r = n, o = new Ah(t, r, s, u, i);
    return l(o.publicInstance), (a, d) => (y(), L(Vn(c(o).tag), ml({
      id: `orion-draggable-${c(o).uid}`
    }, a.$attrs, {
      class: ["orion-draggable", {
        "orion-dragging": c(o).isDragging,
        "orion-draggable--disabled": c(o).disabled
      }],
      onTouchstart: d[0] || (d[0] = (h) => c(o).handleMouseDown(h)),
      onTouchend: d[1] || (d[1] = (h) => c(o).handleMouseUp()),
      onMouseup: d[2] || (d[2] = kl((h) => c(o).handleMouseUp(), ["left"])),
      onMousedown: d[3] || (d[3] = kl((h) => c(o).handleMouseDown(h), ["left"]))
    }), {
      default: U(() => [V(a.$slots, "default")]),
      _: 3
    }, 16, ["id", "class"]));
  }
}), pd = {
  install(e, l = "o") {
    e.component(`${tl(l)}Draggable`, Fk);
  }
};
class xh extends gl {
  constructor(n, t, u, i) {
    super(n);
    S(this, "isHovering", !1);
    S(this, "isMounted", !1);
    S(this, "validationState");
    S(this, "globalMouseEventUid");
    S(this, "globalTouchEventUid");
    S(this, "uid", this.getUid());
    S(this, "dnd", Cf());
    S(this, "bus", Ri());
    this.emit = t, this._modal = u, this._aside = i, this.bus.on("*", (s, r) => this.emit(s, r)), this.emit("update:datalist", this.datalist.map((s) => ({
      ...s,
      __uid: this.getUid()
    }))), Pl(() => this.isDraggingOver, (s) => {
      var o;
      const r = (o = X(this.dnd.registry.items)) == null ? void 0 : o.last();
      s && r ? (r.to = this.uid, this.bus.emit("dragOver")) : r && (r.to = null, this.bus.emit("dragLeave"), this.dnd.emitDragLeave());
    });
  }
  get datalist() {
    return this.props.datalist;
  }
  get publicInstance() {
    return {
      ...super.publicInstance,
      uid: this.uid
    };
  }
  get $el() {
    var n;
    return (n = this.document) == null ? void 0 : n.getElementById(`orion-droppable-${this.uid}`);
  }
  get canHandle() {
    var t, u, i, s;
    const n = (u = (t = X(this.dnd.registry.items)) == null ? void 0 : t.last()) == null ? void 0 : u.fromAsideOrModal;
    return n ? ((i = this._modal) == null ? void 0 : i.uid) === n || ((s = this._aside) == null ? void 0 : s.uid) === n : !0;
  }
  get tag() {
    return this.props.tag;
  }
  get canDrop() {
    var t, u, i, s;
    if (((i = (u = X((t = this.dnd.registry) == null ? void 0 : t.items)) == null ? void 0 : u.last()) == null ? void 0 : i.from) === this.uid)
      return !0;
    const n = X(this.dnd.registry.items).last();
    return n ? ((s = this.props.validation) == null ? void 0 : s.method(n)) ?? !0 : !1;
  }
  get isDragging() {
    return this.dnd.registry.isDragging;
  }
  get isDraggingOver() {
    var n;
    if (!this.canHandle)
      return !1;
    if (this.isMounted) {
      const {
        x: t,
        y: u
      } = this.dnd.registry.cursor;
      if (t !== null && u !== null && this.$el) {
        const {
          top: i,
          bottom: s,
          left: r,
          right: o
        } = (n = this.$el) == null ? void 0 : n.getBoundingClientRect();
        return t >= r && t <= o && u >= i && u <= s;
      }
    }
    return !1;
  }
  onMounted() {
    this.isMounted = !0, this.bus.on("dropIn", (n) => {
      var i, s;
      (s = (i = this.document) == null ? void 0 : i.querySelector(".orion-dragging")) == null || s.remove();
      const t = X(this.dnd.registry.items).last();
      if (!t)
        return;
      const {
        index: u
      } = t;
      if (typeof u == "number") {
        const r = this.datalist;
        r.splice(u, 0, n), this.emit("update:datalist", r);
      }
    }), this.bus.on("dropOut", (n) => {
      const t = X(this.datalist).delete(n);
      this.emit("update:datalist", t);
    }), this.bus.on("reorder", (n) => {
      const t = X(this.datalist).delete(n, "__uid"), u = X(this.dnd.registry.items).last();
      if (!u)
        return;
      const {
        index: i
      } = u;
      typeof i == "number" && (t.splice(i, 0, n), this.emit("update:datalist", t));
    }), this.dnd.bus.on("dragStart", () => {
      this.globalMouseEventUid = nn("mousemove", () => {
        this.isDraggingOver && this.handleDragOver();
      }), this.globalTouchEventUid = nn("touchmove", () => {
        this.isDraggingOver && this.handleDragOver();
      });
    }), this.dnd.bus.on("dragEnd", () => {
      nn(this.globalMouseEventUid), nn(this.globalTouchEventUid);
    }), this.dnd.bus.on("drop", async (n) => {
      var t;
      !n || n.index === null || (n.from === n.to && ((t = this.datalist) != null && t.find((u) => u.__uid === n.data.__uid)) ? this.bus.emit("reorder", n.data) : this.uid === n.to ? this.handleDrop(n) : this.uid === n.from && n.canDrop && rl(() => {
        this.bus.emit("dropOut", n.data);
      }));
    });
  }
  handleDrop(n) {
    var t, u;
    this.canDrop ? this.bus.emit("dropIn", n.data) : (u = this.props.validation) == null || u.notif((t = X(this.dnd.registry.items).last()) == null ? void 0 : t.data);
  }
  handleDragOver() {
    var o, a, d, h;
    if (!this.document)
      return;
    const n = X(this.dnd.registry.items).last();
    if (!n || this.dnd.registry.cursor.y === null || (n.canDrop = this.canDrop, !this.canDrop))
      return;
    n.to = this.uid;
    const {
      index: t,
      element: u,
      siblings: i
    } = this.getDraggedContext(this.$el, this.dnd.registry.cursor.y);
    this.dnd.registry.items.length && n && (n.index = t);
    const s = this.document.querySelector(".orion-dragging");
    if (!s)
      return;
    const r = (o = this.$el) == null ? void 0 : o.querySelector(".orion-droppable-dropzone");
    if (i != null && i.length) {
      const p = i[i.length - 1];
      u ? (a = p.parentNode) == null || a.insertBefore(s, u) : (d = p.parentNode) == null || d.insertBefore(s, p.nextSibling);
    } else
      (h = r == null ? void 0 : r.parentElement) == null || h.insertBefore(s, r);
  }
  getDraggedContext(n, t) {
    const u = [...n.querySelectorAll(".orion-draggable:not(.orion-dragging)")];
    let i = {
      offset: Number.NEGATIVE_INFINITY,
      index: null,
      element: null,
      siblings: null
    };
    return u.forEach((s, r) => {
      const {
        top: o,
        height: a
      } = s.getBoundingClientRect(), d = t - o - a / 2;
      d < 0 && d > i.offset && (i = {
        offset: d,
        index: r,
        element: s,
        siblings: u
      });
    }), i.index !== null || (i = {
      ...i,
      element: null,
      index: u.length,
      siblings: u
    }), i;
  }
}
S(xh, "props", {
  // @doc props/tag the tag or component of the droppable area
  // @doc/fr props/tag tag ou composant qui représentera la zone de drop
  tag: {
    type: String,
    default: "div"
  },
  // @doc props/datalist datas of the component
  // @doc/fr props/datalist liste d'objets du composant
  datalist: {
    type: Array,
    default: null
  },
  // @doc props/validation allows you to add a validation before the item drops
  // @doc/fr props/validation permet d'ajouter une validation avant de déposer un objet dans la zone
  validation: {
    type: Object,
    default: null
  }
});
const Hk = /* @__PURE__ */ A("div", {
  class: "orion-droppable-dropzone"
}, null, -1), zk = /* @__PURE__ */ K({
  __name: "OrionDroppable",
  props: xh.props,
  emits: ["dropIn", "dragOver", "dragLeave", "reorder", "dropOut", "update:datalist"],
  setup(e, {
    expose: l,
    emit: n
  }) {
    const t = e, u = n, i = Tn("_aside"), s = Tn("_modal"), r = new xh(t, u, i, s);
    return De("_droppable", r.publicInstance), l(r.publicInstance), (o, a) => (y(), L(Vn(c(r).tag), ml(o.$attrs, {
      id: `orion-droppable-${c(r).uid}`,
      class: ["orion-droppable", {
        "orion-droppable--allowed": c(r).isDragging && c(r).canDrop && c(r).canHandle,
        "orion-droppable--forbidden": c(r).isDragging && !c(r).canDrop,
        "orion-droppable--over": c(r).isDraggingOver && c(r).canDrop
      }]
    }), {
      default: U(() => [V(o.$slots, "default"), Hk]),
      _: 3
    }, 16, ["id", "class"]));
  }
}), fd = {
  install(e, l = "o") {
    e.component(`${tl(l)}Droppable`, zk);
  }
};
function wn(e) {
  this.content = e;
}
wn.prototype = {
  constructor: wn,
  find: function(e) {
    for (var l = 0; l < this.content.length; l += 2)
      if (this.content[l] === e)
        return l;
    return -1;
  },
  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(e) {
    var l = this.find(e);
    return l == -1 ? void 0 : this.content[l + 1];
  },
  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(e, l, n) {
    var t = n && n != e ? this.remove(n) : this, u = t.find(e), i = t.content.slice();
    return u == -1 ? i.push(n || e, l) : (i[u + 1] = l, n && (i[u] = n)), new wn(i);
  },
  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(e) {
    var l = this.find(e);
    if (l == -1)
      return this;
    var n = this.content.slice();
    return n.splice(l, 2), new wn(n);
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(e, l) {
    return new wn([e, l].concat(this.remove(e).content));
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(e, l) {
    var n = this.remove(e).content.slice();
    return n.push(e, l), new wn(n);
  },
  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(e, l, n) {
    var t = this.remove(l), u = t.content.slice(), i = t.find(e);
    return u.splice(i == -1 ? u.length : i, 0, l, n), new wn(u);
  },
  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(e) {
    for (var l = 0; l < this.content.length; l += 2)
      e(this.content[l], this.content[l + 1]);
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(e) {
    return e = wn.from(e), e.size ? new wn(e.content.concat(this.subtract(e).content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(e) {
    return e = wn.from(e), e.size ? new wn(this.subtract(e).content.concat(e.content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(e) {
    var l = this;
    e = wn.from(e);
    for (var n = 0; n < e.content.length; n += 2)
      l = l.remove(e.content[n]);
    return l;
  },
  // :: () → Object
  // Turn ordered map into a plain object.
  toObject: function() {
    var e = {};
    return this.forEach(function(l, n) {
      e[l] = n;
    }), e;
  },
  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1;
  }
};
wn.from = function(e) {
  if (e instanceof wn)
    return e;
  var l = [];
  if (e)
    for (var n in e)
      l.push(n, e[n]);
  return new wn(l);
};
function Tv(e, l, n) {
  for (let t = 0; ; t++) {
    if (t == e.childCount || t == l.childCount)
      return e.childCount == l.childCount ? null : n;
    let u = e.child(t), i = l.child(t);
    if (u == i) {
      n += u.nodeSize;
      continue;
    }
    if (!u.sameMarkup(i))
      return n;
    if (u.isText && u.text != i.text) {
      for (let s = 0; u.text[s] == i.text[s]; s++)
        n++;
      return n;
    }
    if (u.content.size || i.content.size) {
      let s = Tv(u.content, i.content, n + 1);
      if (s != null)
        return s;
    }
    n += u.nodeSize;
  }
}
function Ov(e, l, n, t) {
  for (let u = e.childCount, i = l.childCount; ; ) {
    if (u == 0 || i == 0)
      return u == i ? null : { a: n, b: t };
    let s = e.child(--u), r = l.child(--i), o = s.nodeSize;
    if (s == r) {
      n -= o, t -= o;
      continue;
    }
    if (!s.sameMarkup(r))
      return { a: n, b: t };
    if (s.isText && s.text != r.text) {
      let a = 0, d = Math.min(s.text.length, r.text.length);
      for (; a < d && s.text[s.text.length - a - 1] == r.text[r.text.length - a - 1]; )
        a++, n--, t--;
      return { a: n, b: t };
    }
    if (s.content.size || r.content.size) {
      let a = Ov(s.content, r.content, n - 1, t - 1);
      if (a)
        return a;
    }
    n -= o, t -= o;
  }
}
class j {
  /**
  @internal
  */
  constructor(l, n) {
    if (this.content = l, this.size = n || 0, n == null)
      for (let t = 0; t < l.length; t++)
        this.size += l[t].nodeSize;
  }
  /**
  Invoke a callback for all descendant nodes between the given two
  positions (relative to start of this fragment). Doesn't descend
  into a node when the callback returns `false`.
  */
  nodesBetween(l, n, t, u = 0, i) {
    for (let s = 0, r = 0; r < n; s++) {
      let o = this.content[s], a = r + o.nodeSize;
      if (a > l && t(o, u + r, i || null, s) !== !1 && o.content.size) {
        let d = r + 1;
        o.nodesBetween(Math.max(0, l - d), Math.min(o.content.size, n - d), t, u + d);
      }
      r = a;
    }
  }
  /**
  Call the given callback for every descendant node. `pos` will be
  relative to the start of the fragment. The callback may return
  `false` to prevent traversal of a given node's children.
  */
  descendants(l) {
    this.nodesBetween(0, this.size, l);
  }
  /**
  Extract the text between `from` and `to`. See the same method on
  [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
  */
  textBetween(l, n, t, u) {
    let i = "", s = !0;
    return this.nodesBetween(l, n, (r, o) => {
      let a = r.isText ? r.text.slice(Math.max(l, o) - o, n - o) : r.isLeaf ? u ? typeof u == "function" ? u(r) : u : r.type.spec.leafText ? r.type.spec.leafText(r) : "" : "";
      r.isBlock && (r.isLeaf && a || r.isTextblock) && t && (s ? s = !1 : i += t), i += a;
    }, 0), i;
  }
  /**
  Create a new fragment containing the combined content of this
  fragment and the other.
  */
  append(l) {
    if (!l.size)
      return this;
    if (!this.size)
      return l;
    let n = this.lastChild, t = l.firstChild, u = this.content.slice(), i = 0;
    for (n.isText && n.sameMarkup(t) && (u[u.length - 1] = n.withText(n.text + t.text), i = 1); i < l.content.length; i++)
      u.push(l.content[i]);
    return new j(u, this.size + l.size);
  }
  /**
  Cut out the sub-fragment between the two given positions.
  */
  cut(l, n = this.size) {
    if (l == 0 && n == this.size)
      return this;
    let t = [], u = 0;
    if (n > l)
      for (let i = 0, s = 0; s < n; i++) {
        let r = this.content[i], o = s + r.nodeSize;
        o > l && ((s < l || o > n) && (r.isText ? r = r.cut(Math.max(0, l - s), Math.min(r.text.length, n - s)) : r = r.cut(Math.max(0, l - s - 1), Math.min(r.content.size, n - s - 1))), t.push(r), u += r.nodeSize), s = o;
      }
    return new j(t, u);
  }
  /**
  @internal
  */
  cutByIndex(l, n) {
    return l == n ? j.empty : l == 0 && n == this.content.length ? this : new j(this.content.slice(l, n));
  }
  /**
  Create a new fragment in which the node at the given index is
  replaced by the given node.
  */
  replaceChild(l, n) {
    let t = this.content[l];
    if (t == n)
      return this;
    let u = this.content.slice(), i = this.size + n.nodeSize - t.nodeSize;
    return u[l] = n, new j(u, i);
  }
  /**
  Create a new fragment by prepending the given node to this
  fragment.
  */
  addToStart(l) {
    return new j([l].concat(this.content), this.size + l.nodeSize);
  }
  /**
  Create a new fragment by appending the given node to this
  fragment.
  */
  addToEnd(l) {
    return new j(this.content.concat(l), this.size + l.nodeSize);
  }
  /**
  Compare this fragment to another one.
  */
  eq(l) {
    if (this.content.length != l.content.length)
      return !1;
    for (let n = 0; n < this.content.length; n++)
      if (!this.content[n].eq(l.content[n]))
        return !1;
    return !0;
  }
  /**
  The first child of the fragment, or `null` if it is empty.
  */
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  /**
  The last child of the fragment, or `null` if it is empty.
  */
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  /**
  The number of child nodes in this fragment.
  */
  get childCount() {
    return this.content.length;
  }
  /**
  Get the child node at the given index. Raise an error when the
  index is out of range.
  */
  child(l) {
    let n = this.content[l];
    if (!n)
      throw new RangeError("Index " + l + " out of range for " + this);
    return n;
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(l) {
    return this.content[l] || null;
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(l) {
    for (let n = 0, t = 0; n < this.content.length; n++) {
      let u = this.content[n];
      l(u, t, n), t += u.nodeSize;
    }
  }
  /**
  Find the first position at which this fragment and another
  fragment differ, or `null` if they are the same.
  */
  findDiffStart(l, n = 0) {
    return Tv(this, l, n);
  }
  /**
  Find the first position, searching from the end, at which this
  fragment and the given fragment differ, or `null` if they are
  the same. Since this position will not be the same in both
  nodes, an object with two separate positions is returned.
  */
  findDiffEnd(l, n = this.size, t = l.size) {
    return Ov(this, l, n, t);
  }
  /**
  Find the index and inner offset corresponding to a given relative
  position in this fragment. The result object will be reused
  (overwritten) the next time the function is called. (Not public.)
  */
  findIndex(l, n = -1) {
    if (l == 0)
      return ur(0, l);
    if (l == this.size)
      return ur(this.content.length, l);
    if (l > this.size || l < 0)
      throw new RangeError(`Position ${l} outside of fragment (${this})`);
    for (let t = 0, u = 0; ; t++) {
      let i = this.child(t), s = u + i.nodeSize;
      if (s >= l)
        return s == l || n > 0 ? ur(t + 1, s) : ur(t, u);
      u = s;
    }
  }
  /**
  Return a debugging string that describes this fragment.
  */
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  /**
  @internal
  */
  toStringInner() {
    return this.content.join(", ");
  }
  /**
  Create a JSON-serializeable representation of this fragment.
  */
  toJSON() {
    return this.content.length ? this.content.map((l) => l.toJSON()) : null;
  }
  /**
  Deserialize a fragment from its JSON representation.
  */
  static fromJSON(l, n) {
    if (!n)
      return j.empty;
    if (!Array.isArray(n))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return new j(n.map(l.nodeFromJSON));
  }
  /**
  Build a fragment from an array of nodes. Ensures that adjacent
  text nodes with the same marks are joined together.
  */
  static fromArray(l) {
    if (!l.length)
      return j.empty;
    let n, t = 0;
    for (let u = 0; u < l.length; u++) {
      let i = l[u];
      t += i.nodeSize, u && i.isText && l[u - 1].sameMarkup(i) ? (n || (n = l.slice(0, u)), n[n.length - 1] = i.withText(n[n.length - 1].text + i.text)) : n && n.push(i);
    }
    return new j(n || l, t);
  }
  /**
  Create a fragment from something that can be interpreted as a
  set of nodes. For `null`, it returns the empty fragment. For a
  fragment, the fragment itself. For a node or array of nodes, a
  fragment containing those nodes.
  */
  static from(l) {
    if (!l)
      return j.empty;
    if (l instanceof j)
      return l;
    if (Array.isArray(l))
      return this.fromArray(l);
    if (l.attrs)
      return new j([l], l.nodeSize);
    throw new RangeError("Can not convert " + l + " to a Fragment" + (l.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
j.empty = new j([], 0);
const md = { index: 0, offset: 0 };
function ur(e, l) {
  return md.index = e, md.offset = l, md;
}
function Nr(e, l) {
  if (e === l)
    return !0;
  if (!(e && typeof e == "object") || !(l && typeof l == "object"))
    return !1;
  let n = Array.isArray(e);
  if (Array.isArray(l) != n)
    return !1;
  if (n) {
    if (e.length != l.length)
      return !1;
    for (let t = 0; t < e.length; t++)
      if (!Nr(e[t], l[t]))
        return !1;
  } else {
    for (let t in e)
      if (!(t in l) || !Nr(e[t], l[t]))
        return !1;
    for (let t in l)
      if (!(t in e))
        return !1;
  }
  return !0;
}
let Vl = class Eh {
  /**
  @internal
  */
  constructor(l, n) {
    this.type = l, this.attrs = n;
  }
  /**
  Given a set of marks, create a new set which contains this one as
  well, in the right position. If this mark is already in the set,
  the set itself is returned. If any marks that are set to be
  [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
  those are replaced by this one.
  */
  addToSet(l) {
    let n, t = !1;
    for (let u = 0; u < l.length; u++) {
      let i = l[u];
      if (this.eq(i))
        return l;
      if (this.type.excludes(i.type))
        n || (n = l.slice(0, u));
      else {
        if (i.type.excludes(this.type))
          return l;
        !t && i.type.rank > this.type.rank && (n || (n = l.slice(0, u)), n.push(this), t = !0), n && n.push(i);
      }
    }
    return n || (n = l.slice()), t || n.push(this), n;
  }
  /**
  Remove this mark from the given set, returning a new set. If this
  mark is not in the set, the set itself is returned.
  */
  removeFromSet(l) {
    for (let n = 0; n < l.length; n++)
      if (this.eq(l[n]))
        return l.slice(0, n).concat(l.slice(n + 1));
    return l;
  }
  /**
  Test whether this mark is in the given set of marks.
  */
  isInSet(l) {
    for (let n = 0; n < l.length; n++)
      if (this.eq(l[n]))
        return !0;
    return !1;
  }
  /**
  Test whether this mark has the same type and attributes as
  another mark.
  */
  eq(l) {
    return this == l || this.type == l.type && Nr(this.attrs, l.attrs);
  }
  /**
  Convert this mark to a JSON-serializeable representation.
  */
  toJSON() {
    let l = { type: this.type.name };
    for (let n in this.attrs) {
      l.attrs = this.attrs;
      break;
    }
    return l;
  }
  /**
  Deserialize a mark from JSON.
  */
  static fromJSON(l, n) {
    if (!n)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let t = l.marks[n.type];
    if (!t)
      throw new RangeError(`There is no mark type ${n.type} in this schema`);
    return t.create(n.attrs);
  }
  /**
  Test whether two sets of marks are identical.
  */
  static sameSet(l, n) {
    if (l == n)
      return !0;
    if (l.length != n.length)
      return !1;
    for (let t = 0; t < l.length; t++)
      if (!l[t].eq(n[t]))
        return !1;
    return !0;
  }
  /**
  Create a properly sorted mark set from null, a single mark, or an
  unsorted array of marks.
  */
  static setFrom(l) {
    if (!l || Array.isArray(l) && l.length == 0)
      return Eh.none;
    if (l instanceof Eh)
      return [l];
    let n = l.slice();
    return n.sort((t, u) => t.type.rank - u.type.rank), n;
  }
};
Vl.none = [];
class Lr extends Error {
}
class nl {
  /**
  Create a slice. When specifying a non-zero open depth, you must
  make sure that there are nodes of at least that depth at the
  appropriate side of the fragment—i.e. if the fragment is an
  empty paragraph node, `openStart` and `openEnd` can't be greater
  than 1.
  
  It is not necessary for the content of open nodes to conform to
  the schema's content constraints, though it should be a valid
  start/end/middle for such a node, depending on which sides are
  open.
  */
  constructor(l, n, t) {
    this.content = l, this.openStart = n, this.openEnd = t;
  }
  /**
  The size this slice would add when inserted into a document.
  */
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  /**
  @internal
  */
  insertAt(l, n) {
    let t = Mv(this.content, l + this.openStart, n);
    return t && new nl(t, this.openStart, this.openEnd);
  }
  /**
  @internal
  */
  removeBetween(l, n) {
    return new nl(kv(this.content, l + this.openStart, n + this.openStart), this.openStart, this.openEnd);
  }
  /**
  Tests whether this slice is equal to another slice.
  */
  eq(l) {
    return this.content.eq(l.content) && this.openStart == l.openStart && this.openEnd == l.openEnd;
  }
  /**
  @internal
  */
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  /**
  Convert a slice to a JSON-serializable representation.
  */
  toJSON() {
    if (!this.content.size)
      return null;
    let l = { content: this.content.toJSON() };
    return this.openStart > 0 && (l.openStart = this.openStart), this.openEnd > 0 && (l.openEnd = this.openEnd), l;
  }
  /**
  Deserialize a slice from its JSON representation.
  */
  static fromJSON(l, n) {
    if (!n)
      return nl.empty;
    let t = n.openStart || 0, u = n.openEnd || 0;
    if (typeof t != "number" || typeof u != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new nl(j.fromJSON(l, n.content), t, u);
  }
  /**
  Create a slice from a fragment by taking the maximum possible
  open value on both side of the fragment.
  */
  static maxOpen(l, n = !0) {
    let t = 0, u = 0;
    for (let i = l.firstChild; i && !i.isLeaf && (n || !i.type.spec.isolating); i = i.firstChild)
      t++;
    for (let i = l.lastChild; i && !i.isLeaf && (n || !i.type.spec.isolating); i = i.lastChild)
      u++;
    return new nl(l, t, u);
  }
}
nl.empty = new nl(j.empty, 0, 0);
function kv(e, l, n) {
  let { index: t, offset: u } = e.findIndex(l), i = e.maybeChild(t), { index: s, offset: r } = e.findIndex(n);
  if (u == l || i.isText) {
    if (r != n && !e.child(s).isText)
      throw new RangeError("Removing non-flat range");
    return e.cut(0, l).append(e.cut(n));
  }
  if (t != s)
    throw new RangeError("Removing non-flat range");
  return e.replaceChild(t, i.copy(kv(i.content, l - u - 1, n - u - 1)));
}
function Mv(e, l, n, t) {
  let { index: u, offset: i } = e.findIndex(l), s = e.maybeChild(u);
  if (i == l || s.isText)
    return t && !t.canReplace(u, u, n) ? null : e.cut(0, l).append(n).append(e.cut(l));
  let r = Mv(s.content, l - i - 1, n);
  return r && e.replaceChild(u, s.copy(r));
}
function Vk(e, l, n) {
  if (n.openStart > e.depth)
    throw new Lr("Inserted content deeper than insertion position");
  if (e.depth - n.openStart != l.depth - n.openEnd)
    throw new Lr("Inconsistent open depths");
  return Av(e, l, n, 0);
}
function Av(e, l, n, t) {
  let u = e.index(t), i = e.node(t);
  if (u == l.index(t) && t < e.depth - n.openStart) {
    let s = Av(e, l, n, t + 1);
    return i.copy(i.content.replaceChild(u, s));
  } else if (n.content.size)
    if (!n.openStart && !n.openEnd && e.depth == t && l.depth == t) {
      let s = e.parent, r = s.content;
      return Mu(s, r.cut(0, e.parentOffset).append(n.content).append(r.cut(l.parentOffset)));
    } else {
      let { start: s, end: r } = jk(n, e);
      return Mu(i, Ev(e, s, r, l, t));
    }
  else
    return Mu(i, Pr(e, l, t));
}
function xv(e, l) {
  if (!l.type.compatibleContent(e.type))
    throw new Lr("Cannot join " + l.type.name + " onto " + e.type.name);
}
function Ih(e, l, n) {
  let t = e.node(n);
  return xv(t, l.node(n)), t;
}
function ku(e, l) {
  let n = l.length - 1;
  n >= 0 && e.isText && e.sameMarkup(l[n]) ? l[n] = e.withText(l[n].text + e.text) : l.push(e);
}
function ls(e, l, n, t) {
  let u = (l || e).node(n), i = 0, s = l ? l.index(n) : u.childCount;
  e && (i = e.index(n), e.depth > n ? i++ : e.textOffset && (ku(e.nodeAfter, t), i++));
  for (let r = i; r < s; r++)
    ku(u.child(r), t);
  l && l.depth == n && l.textOffset && ku(l.nodeBefore, t);
}
function Mu(e, l) {
  return e.type.checkContent(l), e.copy(l);
}
function Ev(e, l, n, t, u) {
  let i = e.depth > u && Ih(e, l, u + 1), s = t.depth > u && Ih(n, t, u + 1), r = [];
  return ls(null, e, u, r), i && s && l.index(u) == n.index(u) ? (xv(i, s), ku(Mu(i, Ev(e, l, n, t, u + 1)), r)) : (i && ku(Mu(i, Pr(e, l, u + 1)), r), ls(l, n, u, r), s && ku(Mu(s, Pr(n, t, u + 1)), r)), ls(t, null, u, r), new j(r);
}
function Pr(e, l, n) {
  let t = [];
  if (ls(null, e, n, t), e.depth > n) {
    let u = Ih(e, l, n + 1);
    ku(Mu(u, Pr(e, l, n + 1)), t);
  }
  return ls(l, null, n, t), new j(t);
}
function jk(e, l) {
  let n = l.depth - e.openStart, u = l.node(n).copy(e.content);
  for (let i = n - 1; i >= 0; i--)
    u = l.node(i).copy(j.from(u));
  return {
    start: u.resolveNoCache(e.openStart + n),
    end: u.resolveNoCache(u.content.size - e.openEnd - n)
  };
}
class Ss {
  /**
  @internal
  */
  constructor(l, n, t) {
    this.pos = l, this.path = n, this.parentOffset = t, this.depth = n.length / 3 - 1;
  }
  /**
  @internal
  */
  resolveDepth(l) {
    return l == null ? this.depth : l < 0 ? this.depth + l : l;
  }
  /**
  The parent node that the position points into. Note that even if
  a position points into a text node, that node is not considered
  the parent—text nodes are ‘flat’ in this model, and have no content.
  */
  get parent() {
    return this.node(this.depth);
  }
  /**
  The root node in which the position was resolved.
  */
  get doc() {
    return this.node(0);
  }
  /**
  The ancestor node at the given level. `p.node(p.depth)` is the
  same as `p.parent`.
  */
  node(l) {
    return this.path[this.resolveDepth(l) * 3];
  }
  /**
  The index into the ancestor at the given level. If this points
  at the 3rd node in the 2nd paragraph on the top level, for
  example, `p.index(0)` is 1 and `p.index(1)` is 2.
  */
  index(l) {
    return this.path[this.resolveDepth(l) * 3 + 1];
  }
  /**
  The index pointing after this position into the ancestor at the
  given level.
  */
  indexAfter(l) {
    return l = this.resolveDepth(l), this.index(l) + (l == this.depth && !this.textOffset ? 0 : 1);
  }
  /**
  The (absolute) position at the start of the node at the given
  level.
  */
  start(l) {
    return l = this.resolveDepth(l), l == 0 ? 0 : this.path[l * 3 - 1] + 1;
  }
  /**
  The (absolute) position at the end of the node at the given
  level.
  */
  end(l) {
    return l = this.resolveDepth(l), this.start(l) + this.node(l).content.size;
  }
  /**
  The (absolute) position directly before the wrapping node at the
  given level, or, when `depth` is `this.depth + 1`, the original
  position.
  */
  before(l) {
    if (l = this.resolveDepth(l), !l)
      throw new RangeError("There is no position before the top-level node");
    return l == this.depth + 1 ? this.pos : this.path[l * 3 - 1];
  }
  /**
  The (absolute) position directly after the wrapping node at the
  given level, or the original position when `depth` is `this.depth + 1`.
  */
  after(l) {
    if (l = this.resolveDepth(l), !l)
      throw new RangeError("There is no position after the top-level node");
    return l == this.depth + 1 ? this.pos : this.path[l * 3 - 1] + this.path[l * 3].nodeSize;
  }
  /**
  When this position points into a text node, this returns the
  distance between the position and the start of the text node.
  Will be zero for positions that point between nodes.
  */
  get textOffset() {
    return this.pos - this.path[this.path.length - 1];
  }
  /**
  Get the node directly after the position, if any. If the position
  points into a text node, only the part of that node after the
  position is returned.
  */
  get nodeAfter() {
    let l = this.parent, n = this.index(this.depth);
    if (n == l.childCount)
      return null;
    let t = this.pos - this.path[this.path.length - 1], u = l.child(n);
    return t ? l.child(n).cut(t) : u;
  }
  /**
  Get the node directly before the position, if any. If the
  position points into a text node, only the part of that node
  before the position is returned.
  */
  get nodeBefore() {
    let l = this.index(this.depth), n = this.pos - this.path[this.path.length - 1];
    return n ? this.parent.child(l).cut(0, n) : l == 0 ? null : this.parent.child(l - 1);
  }
  /**
  Get the position at the given index in the parent node at the
  given depth (which defaults to `this.depth`).
  */
  posAtIndex(l, n) {
    n = this.resolveDepth(n);
    let t = this.path[n * 3], u = n == 0 ? 0 : this.path[n * 3 - 1] + 1;
    for (let i = 0; i < l; i++)
      u += t.child(i).nodeSize;
    return u;
  }
  /**
  Get the marks at this position, factoring in the surrounding
  marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
  position is at the start of a non-empty node, the marks of the
  node after it (if any) are returned.
  */
  marks() {
    let l = this.parent, n = this.index();
    if (l.content.size == 0)
      return Vl.none;
    if (this.textOffset)
      return l.child(n).marks;
    let t = l.maybeChild(n - 1), u = l.maybeChild(n);
    if (!t) {
      let r = t;
      t = u, u = r;
    }
    let i = t.marks;
    for (var s = 0; s < i.length; s++)
      i[s].type.spec.inclusive === !1 && (!u || !i[s].isInSet(u.marks)) && (i = i[s--].removeFromSet(i));
    return i;
  }
  /**
  Get the marks after the current position, if any, except those
  that are non-inclusive and not present at position `$end`. This
  is mostly useful for getting the set of marks to preserve after a
  deletion. Will return `null` if this position is at the end of
  its parent node or its parent node isn't a textblock (in which
  case no marks should be preserved).
  */
  marksAcross(l) {
    let n = this.parent.maybeChild(this.index());
    if (!n || !n.isInline)
      return null;
    let t = n.marks, u = l.parent.maybeChild(l.index());
    for (var i = 0; i < t.length; i++)
      t[i].type.spec.inclusive === !1 && (!u || !t[i].isInSet(u.marks)) && (t = t[i--].removeFromSet(t));
    return t;
  }
  /**
  The depth up to which this position and the given (non-resolved)
  position share the same parent nodes.
  */
  sharedDepth(l) {
    for (let n = this.depth; n > 0; n--)
      if (this.start(n) <= l && this.end(n) >= l)
        return n;
    return 0;
  }
  /**
  Returns a range based on the place where this position and the
  given position diverge around block content. If both point into
  the same textblock, for example, a range around that textblock
  will be returned. If they point into different blocks, the range
  around those blocks in their shared ancestor is returned. You can
  pass in an optional predicate that will be called with a parent
  node to see if a range into that parent is acceptable.
  */
  blockRange(l = this, n) {
    if (l.pos < this.pos)
      return l.blockRange(this);
    for (let t = this.depth - (this.parent.inlineContent || this.pos == l.pos ? 1 : 0); t >= 0; t--)
      if (l.pos <= this.end(t) && (!n || n(this.node(t))))
        return new Br(this, l, t);
    return null;
  }
  /**
  Query whether the given position shares the same parent node.
  */
  sameParent(l) {
    return this.pos - this.parentOffset == l.pos - l.parentOffset;
  }
  /**
  Return the greater of this and the given position.
  */
  max(l) {
    return l.pos > this.pos ? l : this;
  }
  /**
  Return the smaller of this and the given position.
  */
  min(l) {
    return l.pos < this.pos ? l : this;
  }
  /**
  @internal
  */
  toString() {
    let l = "";
    for (let n = 1; n <= this.depth; n++)
      l += (l ? "/" : "") + this.node(n).type.name + "_" + this.index(n - 1);
    return l + ":" + this.parentOffset;
  }
  /**
  @internal
  */
  static resolve(l, n) {
    if (!(n >= 0 && n <= l.content.size))
      throw new RangeError("Position " + n + " out of range");
    let t = [], u = 0, i = n;
    for (let s = l; ; ) {
      let { index: r, offset: o } = s.content.findIndex(i), a = i - o;
      if (t.push(s, r, u + o), !a || (s = s.child(r), s.isText))
        break;
      i = a - 1, u += o + 1;
    }
    return new Ss(n, t, i);
  }
  /**
  @internal
  */
  static resolveCached(l, n) {
    for (let u = 0; u < gd.length; u++) {
      let i = gd[u];
      if (i.pos == n && i.doc == l)
        return i;
    }
    let t = gd[vd] = Ss.resolve(l, n);
    return vd = (vd + 1) % Uk, t;
  }
}
let gd = [], vd = 0, Uk = 12;
class Br {
  /**
  Construct a node range. `$from` and `$to` should point into the
  same node until at least the given `depth`, since a node range
  denotes an adjacent set of nodes in a single parent node.
  */
  constructor(l, n, t) {
    this.$from = l, this.$to = n, this.depth = t;
  }
  /**
  The position at the start of the range.
  */
  get start() {
    return this.$from.before(this.depth + 1);
  }
  /**
  The position at the end of the range.
  */
  get end() {
    return this.$to.after(this.depth + 1);
  }
  /**
  The parent node that the range points into.
  */
  get parent() {
    return this.$from.node(this.depth);
  }
  /**
  The start index of the range in the parent node.
  */
  get startIndex() {
    return this.$from.index(this.depth);
  }
  /**
  The end index of the range in the parent node.
  */
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
const Wk = /* @__PURE__ */ Object.create(null);
let Au = class Rh {
  /**
  @internal
  */
  constructor(l, n, t, u = Vl.none) {
    this.type = l, this.attrs = n, this.marks = u, this.content = t || j.empty;
  }
  /**
  The size of this node, as defined by the integer-based [indexing
  scheme](/docs/guide/#doc.indexing). For text nodes, this is the
  amount of characters. For other leaf nodes, it is one. For
  non-leaf nodes, it is the size of the content plus two (the
  start and end token).
  */
  get nodeSize() {
    return this.isLeaf ? 1 : 2 + this.content.size;
  }
  /**
  The number of children that the node has.
  */
  get childCount() {
    return this.content.childCount;
  }
  /**
  Get the child node at the given index. Raises an error when the
  index is out of range.
  */
  child(l) {
    return this.content.child(l);
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(l) {
    return this.content.maybeChild(l);
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(l) {
    this.content.forEach(l);
  }
  /**
  Invoke a callback for all descendant nodes recursively between
  the given two positions that are relative to start of this
  node's content. The callback is invoked with the node, its
  position relative to the original node (method receiver),
  its parent node, and its child index. When the callback returns
  false for a given node, that node's children will not be
  recursed over. The last parameter can be used to specify a
  starting position to count from.
  */
  nodesBetween(l, n, t, u = 0) {
    this.content.nodesBetween(l, n, t, u, this);
  }
  /**
  Call the given callback for every descendant node. Doesn't
  descend into a node when the callback returns `false`.
  */
  descendants(l) {
    this.nodesBetween(0, this.content.size, l);
  }
  /**
  Concatenates all the text nodes found in this fragment and its
  children.
  */
  get textContent() {
    return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
  }
  /**
  Get all text between positions `from` and `to`. When
  `blockSeparator` is given, it will be inserted to separate text
  from different block nodes. If `leafText` is given, it'll be
  inserted for every non-text leaf node encountered, otherwise
  [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
  */
  textBetween(l, n, t, u) {
    return this.content.textBetween(l, n, t, u);
  }
  /**
  Returns this node's first child, or `null` if there are no
  children.
  */
  get firstChild() {
    return this.content.firstChild;
  }
  /**
  Returns this node's last child, or `null` if there are no
  children.
  */
  get lastChild() {
    return this.content.lastChild;
  }
  /**
  Test whether two nodes represent the same piece of document.
  */
  eq(l) {
    return this == l || this.sameMarkup(l) && this.content.eq(l.content);
  }
  /**
  Compare the markup (type, attributes, and marks) of this node to
  those of another. Returns `true` if both have the same markup.
  */
  sameMarkup(l) {
    return this.hasMarkup(l.type, l.attrs, l.marks);
  }
  /**
  Check whether this node's markup correspond to the given type,
  attributes, and marks.
  */
  hasMarkup(l, n, t) {
    return this.type == l && Nr(this.attrs, n || l.defaultAttrs || Wk) && Vl.sameSet(this.marks, t || Vl.none);
  }
  /**
  Create a new node with the same markup as this node, containing
  the given content (or empty, if no content is given).
  */
  copy(l = null) {
    return l == this.content ? this : new Rh(this.type, this.attrs, l, this.marks);
  }
  /**
  Create a copy of this node, with the given set of marks instead
  of the node's own marks.
  */
  mark(l) {
    return l == this.marks ? this : new Rh(this.type, this.attrs, this.content, l);
  }
  /**
  Create a copy of this node with only the content between the
  given positions. If `to` is not given, it defaults to the end of
  the node.
  */
  cut(l, n = this.content.size) {
    return l == 0 && n == this.content.size ? this : this.copy(this.content.cut(l, n));
  }
  /**
  Cut out the part of the document between the given positions, and
  return it as a `Slice` object.
  */
  slice(l, n = this.content.size, t = !1) {
    if (l == n)
      return nl.empty;
    let u = this.resolve(l), i = this.resolve(n), s = t ? 0 : u.sharedDepth(n), r = u.start(s), a = u.node(s).content.cut(u.pos - r, i.pos - r);
    return new nl(a, u.depth - s, i.depth - s);
  }
  /**
  Replace the part of the document between the given positions with
  the given slice. The slice must 'fit', meaning its open sides
  must be able to connect to the surrounding content, and its
  content nodes must be valid children for the node they are placed
  into. If any of this is violated, an error of type
  [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
  */
  replace(l, n, t) {
    return Vk(this.resolve(l), this.resolve(n), t);
  }
  /**
  Find the node directly after the given position.
  */
  nodeAt(l) {
    for (let n = this; ; ) {
      let { index: t, offset: u } = n.content.findIndex(l);
      if (n = n.maybeChild(t), !n)
        return null;
      if (u == l || n.isText)
        return n;
      l -= u + 1;
    }
  }
  /**
  Find the (direct) child node after the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childAfter(l) {
    let { index: n, offset: t } = this.content.findIndex(l);
    return { node: this.content.maybeChild(n), index: n, offset: t };
  }
  /**
  Find the (direct) child node before the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childBefore(l) {
    if (l == 0)
      return { node: null, index: 0, offset: 0 };
    let { index: n, offset: t } = this.content.findIndex(l);
    if (t < l)
      return { node: this.content.child(n), index: n, offset: t };
    let u = this.content.child(n - 1);
    return { node: u, index: n - 1, offset: t - u.nodeSize };
  }
  /**
  Resolve the given position in the document, returning an
  [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
  */
  resolve(l) {
    return Ss.resolveCached(this, l);
  }
  /**
  @internal
  */
  resolveNoCache(l) {
    return Ss.resolve(this, l);
  }
  /**
  Test whether a given mark or mark type occurs in this document
  between the two given positions.
  */
  rangeHasMark(l, n, t) {
    let u = !1;
    return n > l && this.nodesBetween(l, n, (i) => (t.isInSet(i.marks) && (u = !0), !u)), u;
  }
  /**
  True when this is a block (non-inline node)
  */
  get isBlock() {
    return this.type.isBlock;
  }
  /**
  True when this is a textblock node, a block node with inline
  content.
  */
  get isTextblock() {
    return this.type.isTextblock;
  }
  /**
  True when this node allows inline content.
  */
  get inlineContent() {
    return this.type.inlineContent;
  }
  /**
  True when this is an inline node (a text node or a node that can
  appear among text).
  */
  get isInline() {
    return this.type.isInline;
  }
  /**
  True when this is a text node.
  */
  get isText() {
    return this.type.isText;
  }
  /**
  True when this is a leaf node.
  */
  get isLeaf() {
    return this.type.isLeaf;
  }
  /**
  True when this is an atom, i.e. when it does not have directly
  editable content. This is usually the same as `isLeaf`, but can
  be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
  on a node's spec (typically used when the node is displayed as
  an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
  */
  get isAtom() {
    return this.type.isAtom;
  }
  /**
  Return a string representation of this node for debugging
  purposes.
  */
  toString() {
    if (this.type.spec.toDebugString)
      return this.type.spec.toDebugString(this);
    let l = this.type.name;
    return this.content.size && (l += "(" + this.content.toStringInner() + ")"), Iv(this.marks, l);
  }
  /**
  Get the content match in this node at the given index.
  */
  contentMatchAt(l) {
    let n = this.type.contentMatch.matchFragment(this.content, 0, l);
    if (!n)
      throw new Error("Called contentMatchAt on a node with invalid content");
    return n;
  }
  /**
  Test whether replacing the range between `from` and `to` (by
  child index) with the given replacement fragment (which defaults
  to the empty fragment) would leave the node's content valid. You
  can optionally pass `start` and `end` indices into the
  replacement fragment.
  */
  canReplace(l, n, t = j.empty, u = 0, i = t.childCount) {
    let s = this.contentMatchAt(l).matchFragment(t, u, i), r = s && s.matchFragment(this.content, n);
    if (!r || !r.validEnd)
      return !1;
    for (let o = u; o < i; o++)
      if (!this.type.allowsMarks(t.child(o).marks))
        return !1;
    return !0;
  }
  /**
  Test whether replacing the range `from` to `to` (by index) with
  a node of the given type would leave the node's content valid.
  */
  canReplaceWith(l, n, t, u) {
    if (u && !this.type.allowsMarks(u))
      return !1;
    let i = this.contentMatchAt(l).matchType(t), s = i && i.matchFragment(this.content, n);
    return s ? s.validEnd : !1;
  }
  /**
  Test whether the given node's content could be appended to this
  node. If that node is empty, this will only return true if there
  is at least one node type that can appear in both nodes (to avoid
  merging completely incompatible nodes).
  */
  canAppend(l) {
    return l.content.size ? this.canReplace(this.childCount, this.childCount, l.content) : this.type.compatibleContent(l.type);
  }
  /**
  Check whether this node and its descendants conform to the
  schema, and raise error when they do not.
  */
  check() {
    this.type.checkContent(this.content);
    let l = Vl.none;
    for (let n = 0; n < this.marks.length; n++)
      l = this.marks[n].addToSet(l);
    if (!Vl.sameSet(l, this.marks))
      throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((n) => n.type.name)}`);
    this.content.forEach((n) => n.check());
  }
  /**
  Return a JSON-serializeable representation of this node.
  */
  toJSON() {
    let l = { type: this.type.name };
    for (let n in this.attrs) {
      l.attrs = this.attrs;
      break;
    }
    return this.content.size && (l.content = this.content.toJSON()), this.marks.length && (l.marks = this.marks.map((n) => n.toJSON())), l;
  }
  /**
  Deserialize a node from its JSON representation.
  */
  static fromJSON(l, n) {
    if (!n)
      throw new RangeError("Invalid input for Node.fromJSON");
    let t = null;
    if (n.marks) {
      if (!Array.isArray(n.marks))
        throw new RangeError("Invalid mark data for Node.fromJSON");
      t = n.marks.map(l.markFromJSON);
    }
    if (n.type == "text") {
      if (typeof n.text != "string")
        throw new RangeError("Invalid text node in JSON");
      return l.text(n.text, t);
    }
    let u = j.fromJSON(l, n.content);
    return l.nodeType(n.type).create(n.attrs, u, t);
  }
};
Au.prototype.text = void 0;
class Fr extends Au {
  /**
  @internal
  */
  constructor(l, n, t, u) {
    if (super(l, n, null, u), !t)
      throw new RangeError("Empty text nodes are not allowed");
    this.text = t;
  }
  toString() {
    return this.type.spec.toDebugString ? this.type.spec.toDebugString(this) : Iv(this.marks, JSON.stringify(this.text));
  }
  get textContent() {
    return this.text;
  }
  textBetween(l, n) {
    return this.text.slice(l, n);
  }
  get nodeSize() {
    return this.text.length;
  }
  mark(l) {
    return l == this.marks ? this : new Fr(this.type, this.attrs, this.text, l);
  }
  withText(l) {
    return l == this.text ? this : new Fr(this.type, this.attrs, l, this.marks);
  }
  cut(l = 0, n = this.text.length) {
    return l == 0 && n == this.text.length ? this : this.withText(this.text.slice(l, n));
  }
  eq(l) {
    return this.sameMarkup(l) && this.text == l.text;
  }
  toJSON() {
    let l = super.toJSON();
    return l.text = this.text, l;
  }
}
function Iv(e, l) {
  for (let n = e.length - 1; n >= 0; n--)
    l = e[n].type.name + "(" + l + ")";
  return l;
}
class Lu {
  /**
  @internal
  */
  constructor(l) {
    this.validEnd = l, this.next = [], this.wrapCache = [];
  }
  /**
  @internal
  */
  static parse(l, n) {
    let t = new Gk(l, n);
    if (t.next == null)
      return Lu.empty;
    let u = Rv(t);
    t.next && t.err("Unexpected trailing text");
    let i = Qk(Xk(u));
    return lM(i, t), i;
  }
  /**
  Match a node type, returning a match after that node if
  successful.
  */
  matchType(l) {
    for (let n = 0; n < this.next.length; n++)
      if (this.next[n].type == l)
        return this.next[n].next;
    return null;
  }
  /**
  Try to match a fragment. Returns the resulting match when
  successful.
  */
  matchFragment(l, n = 0, t = l.childCount) {
    let u = this;
    for (let i = n; u && i < t; i++)
      u = u.matchType(l.child(i).type);
    return u;
  }
  /**
  @internal
  */
  get inlineContent() {
    return this.next.length != 0 && this.next[0].type.isInline;
  }
  /**
  Get the first matching node type at this match position that can
  be generated.
  */
  get defaultType() {
    for (let l = 0; l < this.next.length; l++) {
      let { type: n } = this.next[l];
      if (!(n.isText || n.hasRequiredAttrs()))
        return n;
    }
    return null;
  }
  /**
  @internal
  */
  compatible(l) {
    for (let n = 0; n < this.next.length; n++)
      for (let t = 0; t < l.next.length; t++)
        if (this.next[n].type == l.next[t].type)
          return !0;
    return !1;
  }
  /**
  Try to match the given fragment, and if that fails, see if it can
  be made to match by inserting nodes in front of it. When
  successful, return a fragment of inserted nodes (which may be
  empty if nothing had to be inserted). When `toEnd` is true, only
  return a fragment if the resulting match goes to the end of the
  content expression.
  */
  fillBefore(l, n = !1, t = 0) {
    let u = [this];
    function i(s, r) {
      let o = s.matchFragment(l, t);
      if (o && (!n || o.validEnd))
        return j.from(r.map((a) => a.createAndFill()));
      for (let a = 0; a < s.next.length; a++) {
        let { type: d, next: h } = s.next[a];
        if (!(d.isText || d.hasRequiredAttrs()) && u.indexOf(h) == -1) {
          u.push(h);
          let p = i(h, r.concat(d));
          if (p)
            return p;
        }
      }
      return null;
    }
    return i(this, []);
  }
  /**
  Find a set of wrapping node types that would allow a node of the
  given type to appear at this position. The result may be empty
  (when it fits directly) and will be null when no such wrapping
  exists.
  */
  findWrapping(l) {
    for (let t = 0; t < this.wrapCache.length; t += 2)
      if (this.wrapCache[t] == l)
        return this.wrapCache[t + 1];
    let n = this.computeWrapping(l);
    return this.wrapCache.push(l, n), n;
  }
  /**
  @internal
  */
  computeWrapping(l) {
    let n = /* @__PURE__ */ Object.create(null), t = [{ match: this, type: null, via: null }];
    for (; t.length; ) {
      let u = t.shift(), i = u.match;
      if (i.matchType(l)) {
        let s = [];
        for (let r = u; r.type; r = r.via)
          s.push(r.type);
        return s.reverse();
      }
      for (let s = 0; s < i.next.length; s++) {
        let { type: r, next: o } = i.next[s];
        !r.isLeaf && !r.hasRequiredAttrs() && !(r.name in n) && (!u.type || o.validEnd) && (t.push({ match: r.contentMatch, type: r, via: u }), n[r.name] = !0);
      }
    }
    return null;
  }
  /**
  The number of outgoing edges this node has in the finite
  automaton that describes the content expression.
  */
  get edgeCount() {
    return this.next.length;
  }
  /**
  Get the _n_​th outgoing edge from this node in the finite
  automaton that describes the content expression.
  */
  edge(l) {
    if (l >= this.next.length)
      throw new RangeError(`There's no ${l}th edge in this content match`);
    return this.next[l];
  }
  /**
  @internal
  */
  toString() {
    let l = [];
    function n(t) {
      l.push(t);
      for (let u = 0; u < t.next.length; u++)
        l.indexOf(t.next[u].next) == -1 && n(t.next[u].next);
    }
    return n(this), l.map((t, u) => {
      let i = u + (t.validEnd ? "*" : " ") + " ";
      for (let s = 0; s < t.next.length; s++)
        i += (s ? ", " : "") + t.next[s].type.name + "->" + l.indexOf(t.next[s].next);
      return i;
    }).join(`
`);
  }
}
Lu.empty = new Lu(!0);
class Gk {
  constructor(l, n) {
    this.string = l, this.nodeTypes = n, this.inline = null, this.pos = 0, this.tokens = l.split(/\s*(?=\b|\W|$)/), this.tokens[this.tokens.length - 1] == "" && this.tokens.pop(), this.tokens[0] == "" && this.tokens.shift();
  }
  get next() {
    return this.tokens[this.pos];
  }
  eat(l) {
    return this.next == l && (this.pos++ || !0);
  }
  err(l) {
    throw new SyntaxError(l + " (in content expression '" + this.string + "')");
  }
}
function Rv(e) {
  let l = [];
  do
    l.push(Kk(e));
  while (e.eat("|"));
  return l.length == 1 ? l[0] : { type: "choice", exprs: l };
}
function Kk(e) {
  let l = [];
  do
    l.push(Yk(e));
  while (e.next && e.next != ")" && e.next != "|");
  return l.length == 1 ? l[0] : { type: "seq", exprs: l };
}
function Yk(e) {
  let l = Zk(e);
  for (; ; )
    if (e.eat("+"))
      l = { type: "plus", expr: l };
    else if (e.eat("*"))
      l = { type: "star", expr: l };
    else if (e.eat("?"))
      l = { type: "opt", expr: l };
    else if (e.eat("{"))
      l = qk(e, l);
    else
      break;
  return l;
}
function tm(e) {
  /\D/.test(e.next) && e.err("Expected number, got '" + e.next + "'");
  let l = Number(e.next);
  return e.pos++, l;
}
function qk(e, l) {
  let n = tm(e), t = n;
  return e.eat(",") && (e.next != "}" ? t = tm(e) : t = -1), e.eat("}") || e.err("Unclosed braced range"), { type: "range", min: n, max: t, expr: l };
}
function Jk(e, l) {
  let n = e.nodeTypes, t = n[l];
  if (t)
    return [t];
  let u = [];
  for (let i in n) {
    let s = n[i];
    s.groups.indexOf(l) > -1 && u.push(s);
  }
  return u.length == 0 && e.err("No node type or group '" + l + "' found"), u;
}
function Zk(e) {
  if (e.eat("(")) {
    let l = Rv(e);
    return e.eat(")") || e.err("Missing closing paren"), l;
  } else if (/\W/.test(e.next))
    e.err("Unexpected token '" + e.next + "'");
  else {
    let l = Jk(e, e.next).map((n) => (e.inline == null ? e.inline = n.isInline : e.inline != n.isInline && e.err("Mixing inline and block content"), { type: "name", value: n }));
    return e.pos++, l.length == 1 ? l[0] : { type: "choice", exprs: l };
  }
}
function Xk(e) {
  let l = [[]];
  return u(i(e, 0), n()), l;
  function n() {
    return l.push([]) - 1;
  }
  function t(s, r, o) {
    let a = { term: o, to: r };
    return l[s].push(a), a;
  }
  function u(s, r) {
    s.forEach((o) => o.to = r);
  }
  function i(s, r) {
    if (s.type == "choice")
      return s.exprs.reduce((o, a) => o.concat(i(a, r)), []);
    if (s.type == "seq")
      for (let o = 0; ; o++) {
        let a = i(s.exprs[o], r);
        if (o == s.exprs.length - 1)
          return a;
        u(a, r = n());
      }
    else if (s.type == "star") {
      let o = n();
      return t(r, o), u(i(s.expr, o), o), [t(o)];
    } else if (s.type == "plus") {
      let o = n();
      return u(i(s.expr, r), o), u(i(s.expr, o), o), [t(o)];
    } else {
      if (s.type == "opt")
        return [t(r)].concat(i(s.expr, r));
      if (s.type == "range") {
        let o = r;
        for (let a = 0; a < s.min; a++) {
          let d = n();
          u(i(s.expr, o), d), o = d;
        }
        if (s.max == -1)
          u(i(s.expr, o), o);
        else
          for (let a = s.min; a < s.max; a++) {
            let d = n();
            t(o, d), u(i(s.expr, o), d), o = d;
          }
        return [t(o)];
      } else {
        if (s.type == "name")
          return [t(r, void 0, s.value)];
        throw new Error("Unknown expr type");
      }
    }
  }
}
function Dv(e, l) {
  return l - e;
}
function um(e, l) {
  let n = [];
  return t(l), n.sort(Dv);
  function t(u) {
    let i = e[u];
    if (i.length == 1 && !i[0].term)
      return t(i[0].to);
    n.push(u);
    for (let s = 0; s < i.length; s++) {
      let { term: r, to: o } = i[s];
      !r && n.indexOf(o) == -1 && t(o);
    }
  }
}
function Qk(e) {
  let l = /* @__PURE__ */ Object.create(null);
  return n(um(e, 0));
  function n(t) {
    let u = [];
    t.forEach((s) => {
      e[s].forEach(({ term: r, to: o }) => {
        if (!r)
          return;
        let a;
        for (let d = 0; d < u.length; d++)
          u[d][0] == r && (a = u[d][1]);
        um(e, o).forEach((d) => {
          a || u.push([r, a = []]), a.indexOf(d) == -1 && a.push(d);
        });
      });
    });
    let i = l[t.join(",")] = new Lu(t.indexOf(e.length - 1) > -1);
    for (let s = 0; s < u.length; s++) {
      let r = u[s][1].sort(Dv);
      i.next.push({ type: u[s][0], next: l[r.join(",")] || n(r) });
    }
    return i;
  }
}
function lM(e, l) {
  for (let n = 0, t = [e]; n < t.length; n++) {
    let u = t[n], i = !u.validEnd, s = [];
    for (let r = 0; r < u.next.length; r++) {
      let { type: o, next: a } = u.next[r];
      s.push(o.name), i && !(o.isText || o.hasRequiredAttrs()) && (i = !1), t.indexOf(a) == -1 && t.push(a);
    }
    i && l.err("Only non-generatable nodes (" + s.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
  }
}
function Nv(e) {
  let l = /* @__PURE__ */ Object.create(null);
  for (let n in e) {
    let t = e[n];
    if (!t.hasDefault)
      return null;
    l[n] = t.default;
  }
  return l;
}
function Lv(e, l) {
  let n = /* @__PURE__ */ Object.create(null);
  for (let t in e) {
    let u = l && l[t];
    if (u === void 0) {
      let i = e[t];
      if (i.hasDefault)
        u = i.default;
      else
        throw new RangeError("No value supplied for attribute " + t);
    }
    n[t] = u;
  }
  return n;
}
function Pv(e) {
  let l = /* @__PURE__ */ Object.create(null);
  if (e)
    for (let n in e)
      l[n] = new nM(e[n]);
  return l;
}
let im = class Bv {
  /**
  @internal
  */
  constructor(l, n, t) {
    this.name = l, this.schema = n, this.spec = t, this.markSet = null, this.groups = t.group ? t.group.split(" ") : [], this.attrs = Pv(t.attrs), this.defaultAttrs = Nv(this.attrs), this.contentMatch = null, this.inlineContent = null, this.isBlock = !(t.inline || l == "text"), this.isText = l == "text";
  }
  /**
  True if this is an inline type.
  */
  get isInline() {
    return !this.isBlock;
  }
  /**
  True if this is a textblock type, a block that contains inline
  content.
  */
  get isTextblock() {
    return this.isBlock && this.inlineContent;
  }
  /**
  True for node types that allow no content.
  */
  get isLeaf() {
    return this.contentMatch == Lu.empty;
  }
  /**
  True when this node is an atom, i.e. when it does not have
  directly editable content.
  */
  get isAtom() {
    return this.isLeaf || !!this.spec.atom;
  }
  /**
  The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
  */
  get whitespace() {
    return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
  }
  /**
  Tells you whether this node type has any required attributes.
  */
  hasRequiredAttrs() {
    for (let l in this.attrs)
      if (this.attrs[l].isRequired)
        return !0;
    return !1;
  }
  /**
  Indicates whether this node allows some of the same content as
  the given node type.
  */
  compatibleContent(l) {
    return this == l || this.contentMatch.compatible(l.contentMatch);
  }
  /**
  @internal
  */
  computeAttrs(l) {
    return !l && this.defaultAttrs ? this.defaultAttrs : Lv(this.attrs, l);
  }
  /**
  Create a `Node` of this type. The given attributes are
  checked and defaulted (you can pass `null` to use the type's
  defaults entirely, if no required attributes exist). `content`
  may be a `Fragment`, a node, an array of nodes, or
  `null`. Similarly `marks` may be `null` to default to the empty
  set of marks.
  */
  create(l = null, n, t) {
    if (this.isText)
      throw new Error("NodeType.create can't construct text nodes");
    return new Au(this, this.computeAttrs(l), j.from(n), Vl.setFrom(t));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
  against the node type's content restrictions, and throw an error
  if it doesn't match.
  */
  createChecked(l = null, n, t) {
    return n = j.from(n), this.checkContent(n), new Au(this, this.computeAttrs(l), n, Vl.setFrom(t));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
  necessary to add nodes to the start or end of the given fragment
  to make it fit the node. If no fitting wrapping can be found,
  return null. Note that, due to the fact that required nodes can
  always be created, this will always succeed if you pass null or
  `Fragment.empty` as content.
  */
  createAndFill(l = null, n, t) {
    if (l = this.computeAttrs(l), n = j.from(n), n.size) {
      let s = this.contentMatch.fillBefore(n);
      if (!s)
        return null;
      n = s.append(n);
    }
    let u = this.contentMatch.matchFragment(n), i = u && u.fillBefore(j.empty, !0);
    return i ? new Au(this, l, n.append(i), Vl.setFrom(t)) : null;
  }
  /**
  Returns true if the given fragment is valid content for this node
  type with the given attributes.
  */
  validContent(l) {
    let n = this.contentMatch.matchFragment(l);
    if (!n || !n.validEnd)
      return !1;
    for (let t = 0; t < l.childCount; t++)
      if (!this.allowsMarks(l.child(t).marks))
        return !1;
    return !0;
  }
  /**
  Throws a RangeError if the given fragment is not valid content for this
  node type.
  @internal
  */
  checkContent(l) {
    if (!this.validContent(l))
      throw new RangeError(`Invalid content for node ${this.name}: ${l.toString().slice(0, 50)}`);
  }
  /**
  Check whether the given mark type is allowed in this node.
  */
  allowsMarkType(l) {
    return this.markSet == null || this.markSet.indexOf(l) > -1;
  }
  /**
  Test whether the given set of marks are allowed in this node.
  */
  allowsMarks(l) {
    if (this.markSet == null)
      return !0;
    for (let n = 0; n < l.length; n++)
      if (!this.allowsMarkType(l[n].type))
        return !1;
    return !0;
  }
  /**
  Removes the marks that are not allowed in this node from the given set.
  */
  allowedMarks(l) {
    if (this.markSet == null)
      return l;
    let n;
    for (let t = 0; t < l.length; t++)
      this.allowsMarkType(l[t].type) ? n && n.push(l[t]) : n || (n = l.slice(0, t));
    return n ? n.length ? n : Vl.none : l;
  }
  /**
  @internal
  */
  static compile(l, n) {
    let t = /* @__PURE__ */ Object.create(null);
    l.forEach((i, s) => t[i] = new Bv(i, n, s));
    let u = n.spec.topNode || "doc";
    if (!t[u])
      throw new RangeError("Schema is missing its top node type ('" + u + "')");
    if (!t.text)
      throw new RangeError("Every schema needs a 'text' type");
    for (let i in t.text.attrs)
      throw new RangeError("The text node type should not have attributes");
    return t;
  }
};
class nM {
  constructor(l) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(l, "default"), this.default = l.default;
  }
  get isRequired() {
    return !this.hasDefault;
  }
}
class ta {
  /**
  @internal
  */
  constructor(l, n, t, u) {
    this.name = l, this.rank = n, this.schema = t, this.spec = u, this.attrs = Pv(u.attrs), this.excluded = null;
    let i = Nv(this.attrs);
    this.instance = i ? new Vl(this, i) : null;
  }
  /**
  Create a mark of this type. `attrs` may be `null` or an object
  containing only some of the mark's attributes. The others, if
  they have defaults, will be added.
  */
  create(l = null) {
    return !l && this.instance ? this.instance : new Vl(this, Lv(this.attrs, l));
  }
  /**
  @internal
  */
  static compile(l, n) {
    let t = /* @__PURE__ */ Object.create(null), u = 0;
    return l.forEach((i, s) => t[i] = new ta(i, u++, n, s)), t;
  }
  /**
  When there is a mark of this type in the given set, a new set
  without it is returned. Otherwise, the input set is returned.
  */
  removeFromSet(l) {
    for (var n = 0; n < l.length; n++)
      l[n].type == this && (l = l.slice(0, n).concat(l.slice(n + 1)), n--);
    return l;
  }
  /**
  Tests whether there is a mark of this type in the given set.
  */
  isInSet(l) {
    for (let n = 0; n < l.length; n++)
      if (l[n].type == this)
        return l[n];
  }
  /**
  Queries whether a given mark type is
  [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
  */
  excludes(l) {
    return this.excluded.indexOf(l) > -1;
  }
}
class eM {
  /**
  Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
  */
  constructor(l) {
    this.cached = /* @__PURE__ */ Object.create(null);
    let n = this.spec = {};
    for (let u in l)
      n[u] = l[u];
    n.nodes = wn.from(l.nodes), n.marks = wn.from(l.marks || {}), this.nodes = im.compile(this.spec.nodes, this), this.marks = ta.compile(this.spec.marks, this);
    let t = /* @__PURE__ */ Object.create(null);
    for (let u in this.nodes) {
      if (u in this.marks)
        throw new RangeError(u + " can not be both a node and a mark");
      let i = this.nodes[u], s = i.spec.content || "", r = i.spec.marks;
      i.contentMatch = t[s] || (t[s] = Lu.parse(s, this.nodes)), i.inlineContent = i.contentMatch.inlineContent, i.markSet = r == "_" ? null : r ? sm(this, r.split(" ")) : r == "" || !i.inlineContent ? [] : null;
    }
    for (let u in this.marks) {
      let i = this.marks[u], s = i.spec.excludes;
      i.excluded = s == null ? [i] : s == "" ? [] : sm(this, s.split(" "));
    }
    this.nodeFromJSON = this.nodeFromJSON.bind(this), this.markFromJSON = this.markFromJSON.bind(this), this.topNodeType = this.nodes[this.spec.topNode || "doc"], this.cached.wrappings = /* @__PURE__ */ Object.create(null);
  }
  /**
  Create a node in this schema. The `type` may be a string or a
  `NodeType` instance. Attributes will be extended with defaults,
  `content` may be a `Fragment`, `null`, a `Node`, or an array of
  nodes.
  */
  node(l, n = null, t, u) {
    if (typeof l == "string")
      l = this.nodeType(l);
    else if (l instanceof im) {
      if (l.schema != this)
        throw new RangeError("Node type from different schema used (" + l.name + ")");
    } else
      throw new RangeError("Invalid node type: " + l);
    return l.createChecked(n, t, u);
  }
  /**
  Create a text node in the schema. Empty text nodes are not
  allowed.
  */
  text(l, n) {
    let t = this.nodes.text;
    return new Fr(t, t.defaultAttrs, l, Vl.setFrom(n));
  }
  /**
  Create a mark with the given type and attributes.
  */
  mark(l, n) {
    return typeof l == "string" && (l = this.marks[l]), l.create(n);
  }
  /**
  Deserialize a node from its JSON representation. This method is
  bound.
  */
  nodeFromJSON(l) {
    return Au.fromJSON(this, l);
  }
  /**
  Deserialize a mark from its JSON representation. This method is
  bound.
  */
  markFromJSON(l) {
    return Vl.fromJSON(this, l);
  }
  /**
  @internal
  */
  nodeType(l) {
    let n = this.nodes[l];
    if (!n)
      throw new RangeError("Unknown node type: " + l);
    return n;
  }
}
function sm(e, l) {
  let n = [];
  for (let t = 0; t < l.length; t++) {
    let u = l[t], i = e.marks[u], s = i;
    if (i)
      n.push(i);
    else
      for (let r in e.marks) {
        let o = e.marks[r];
        (u == "_" || o.spec.group && o.spec.group.split(" ").indexOf(u) > -1) && n.push(s = o);
      }
    if (!s)
      throw new SyntaxError("Unknown mark type: '" + l[t] + "'");
  }
  return n;
}
let Ff = class Dh {
  /**
  Create a parser that targets the given schema, using the given
  parsing rules.
  */
  constructor(l, n) {
    this.schema = l, this.rules = n, this.tags = [], this.styles = [], n.forEach((t) => {
      t.tag ? this.tags.push(t) : t.style && this.styles.push(t);
    }), this.normalizeLists = !this.tags.some((t) => {
      if (!/^(ul|ol)\b/.test(t.tag) || !t.node)
        return !1;
      let u = l.nodes[t.node];
      return u.contentMatch.matchType(u);
    });
  }
  /**
  Parse a document from the content of a DOM node.
  */
  parse(l, n = {}) {
    let t = new om(this, n, !1);
    return t.addAll(l, n.from, n.to), t.finish();
  }
  /**
  Parses the content of the given DOM node, like
  [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
  options. But unlike that method, which produces a whole node,
  this one returns a slice that is open at the sides, meaning that
  the schema constraints aren't applied to the start of nodes to
  the left of the input and the end of nodes at the end.
  */
  parseSlice(l, n = {}) {
    let t = new om(this, n, !0);
    return t.addAll(l, n.from, n.to), nl.maxOpen(t.finish());
  }
  /**
  @internal
  */
  matchTag(l, n, t) {
    for (let u = t ? this.tags.indexOf(t) + 1 : 0; u < this.tags.length; u++) {
      let i = this.tags[u];
      if (iM(l, i.tag) && (i.namespace === void 0 || l.namespaceURI == i.namespace) && (!i.context || n.matchesContext(i.context))) {
        if (i.getAttrs) {
          let s = i.getAttrs(l);
          if (s === !1)
            continue;
          i.attrs = s || void 0;
        }
        return i;
      }
    }
  }
  /**
  @internal
  */
  matchStyle(l, n, t, u) {
    for (let i = u ? this.styles.indexOf(u) + 1 : 0; i < this.styles.length; i++) {
      let s = this.styles[i], r = s.style;
      if (!(r.indexOf(l) != 0 || s.context && !t.matchesContext(s.context) || // Test that the style string either precisely matches the prop,
      // or has an '=' sign after the prop, followed by the given
      // value.
      r.length > l.length && (r.charCodeAt(l.length) != 61 || r.slice(l.length + 1) != n))) {
        if (s.getAttrs) {
          let o = s.getAttrs(n);
          if (o === !1)
            continue;
          s.attrs = o || void 0;
        }
        return s;
      }
    }
  }
  /**
  @internal
  */
  static schemaRules(l) {
    let n = [];
    function t(u) {
      let i = u.priority == null ? 50 : u.priority, s = 0;
      for (; s < n.length; s++) {
        let r = n[s];
        if ((r.priority == null ? 50 : r.priority) < i)
          break;
      }
      n.splice(s, 0, u);
    }
    for (let u in l.marks) {
      let i = l.marks[u].spec.parseDOM;
      i && i.forEach((s) => {
        t(s = am(s)), s.mark || s.ignore || s.clearMark || (s.mark = u);
      });
    }
    for (let u in l.nodes) {
      let i = l.nodes[u].spec.parseDOM;
      i && i.forEach((s) => {
        t(s = am(s)), s.node || s.ignore || s.mark || (s.node = u);
      });
    }
    return n;
  }
  /**
  Construct a DOM parser using the parsing rules listed in a
  schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
  [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
  */
  static fromSchema(l) {
    return l.cached.domParser || (l.cached.domParser = new Dh(l, Dh.schemaRules(l)));
  }
};
const Fv = {
  address: !0,
  article: !0,
  aside: !0,
  blockquote: !0,
  canvas: !0,
  dd: !0,
  div: !0,
  dl: !0,
  fieldset: !0,
  figcaption: !0,
  figure: !0,
  footer: !0,
  form: !0,
  h1: !0,
  h2: !0,
  h3: !0,
  h4: !0,
  h5: !0,
  h6: !0,
  header: !0,
  hgroup: !0,
  hr: !0,
  li: !0,
  noscript: !0,
  ol: !0,
  output: !0,
  p: !0,
  pre: !0,
  section: !0,
  table: !0,
  tfoot: !0,
  ul: !0
}, tM = {
  head: !0,
  noscript: !0,
  object: !0,
  script: !0,
  style: !0,
  title: !0
}, Hv = { ol: !0, ul: !0 }, Hr = 1, zr = 2, ns = 4;
function rm(e, l, n) {
  return l != null ? (l ? Hr : 0) | (l === "full" ? zr : 0) : e && e.whitespace == "pre" ? Hr | zr : n & ~ns;
}
class ir {
  constructor(l, n, t, u, i, s, r) {
    this.type = l, this.attrs = n, this.marks = t, this.pendingMarks = u, this.solid = i, this.options = r, this.content = [], this.activeMarks = Vl.none, this.stashMarks = [], this.match = s || (r & ns ? null : l.contentMatch);
  }
  findWrapping(l) {
    if (!this.match) {
      if (!this.type)
        return [];
      let n = this.type.contentMatch.fillBefore(j.from(l));
      if (n)
        this.match = this.type.contentMatch.matchFragment(n);
      else {
        let t = this.type.contentMatch, u;
        return (u = t.findWrapping(l.type)) ? (this.match = t, u) : null;
      }
    }
    return this.match.findWrapping(l.type);
  }
  finish(l) {
    if (!(this.options & Hr)) {
      let t = this.content[this.content.length - 1], u;
      if (t && t.isText && (u = /[ \t\r\n\u000c]+$/.exec(t.text))) {
        let i = t;
        t.text.length == u[0].length ? this.content.pop() : this.content[this.content.length - 1] = i.withText(i.text.slice(0, i.text.length - u[0].length));
      }
    }
    let n = j.from(this.content);
    return !l && this.match && (n = n.append(this.match.fillBefore(j.empty, !0))), this.type ? this.type.create(this.attrs, n, this.marks) : n;
  }
  popFromStashMark(l) {
    for (let n = this.stashMarks.length - 1; n >= 0; n--)
      if (l.eq(this.stashMarks[n]))
        return this.stashMarks.splice(n, 1)[0];
  }
  applyPending(l) {
    for (let n = 0, t = this.pendingMarks; n < t.length; n++) {
      let u = t[n];
      (this.type ? this.type.allowsMarkType(u.type) : rM(u.type, l)) && !u.isInSet(this.activeMarks) && (this.activeMarks = u.addToSet(this.activeMarks), this.pendingMarks = u.removeFromSet(this.pendingMarks));
    }
  }
  inlineContext(l) {
    return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : l.parentNode && !Fv.hasOwnProperty(l.parentNode.nodeName.toLowerCase());
  }
}
class om {
  constructor(l, n, t) {
    this.parser = l, this.options = n, this.isOpen = t, this.open = 0;
    let u = n.topNode, i, s = rm(null, n.preserveWhitespace, 0) | (t ? ns : 0);
    u ? i = new ir(u.type, u.attrs, Vl.none, Vl.none, !0, n.topMatch || u.type.contentMatch, s) : t ? i = new ir(null, null, Vl.none, Vl.none, !0, null, s) : i = new ir(l.schema.topNodeType, null, Vl.none, Vl.none, !0, null, s), this.nodes = [i], this.find = n.findPositions, this.needsBlock = !1;
  }
  get top() {
    return this.nodes[this.open];
  }
  // Add a DOM node to the content. Text is inserted as text node,
  // otherwise, the node is passed to `addElement` or, if it has a
  // `style` attribute, `addElementWithStyles`.
  addDOM(l) {
    l.nodeType == 3 ? this.addTextNode(l) : l.nodeType == 1 && this.addElement(l);
  }
  withStyleRules(l, n) {
    let t = l.getAttribute("style");
    if (!t)
      return n();
    let u = this.readStyles(sM(t));
    if (!u)
      return;
    let [i, s] = u, r = this.top;
    for (let o = 0; o < s.length; o++)
      this.removePendingMark(s[o], r);
    for (let o = 0; o < i.length; o++)
      this.addPendingMark(i[o]);
    n();
    for (let o = 0; o < i.length; o++)
      this.removePendingMark(i[o], r);
    for (let o = 0; o < s.length; o++)
      this.addPendingMark(s[o]);
  }
  addTextNode(l) {
    let n = l.nodeValue, t = this.top;
    if (t.options & zr || t.inlineContext(l) || /[^ \t\r\n\u000c]/.test(n)) {
      if (t.options & Hr)
        t.options & zr ? n = n.replace(/\r\n?/g, `
`) : n = n.replace(/\r?\n|\r/g, " ");
      else if (n = n.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(n) && this.open == this.nodes.length - 1) {
        let u = t.content[t.content.length - 1], i = l.previousSibling;
        (!u || i && i.nodeName == "BR" || u.isText && /[ \t\r\n\u000c]$/.test(u.text)) && (n = n.slice(1));
      }
      n && this.insertNode(this.parser.schema.text(n)), this.findInText(l);
    } else
      this.findInside(l);
  }
  // Try to find a handler for the given tag and use that to parse. If
  // none is found, the element's content nodes are added directly.
  addElement(l, n) {
    let t = l.nodeName.toLowerCase(), u;
    Hv.hasOwnProperty(t) && this.parser.normalizeLists && uM(l);
    let i = this.options.ruleFromNode && this.options.ruleFromNode(l) || (u = this.parser.matchTag(l, this, n));
    if (i ? i.ignore : tM.hasOwnProperty(t))
      this.findInside(l), this.ignoreFallback(l);
    else if (!i || i.skip || i.closeParent) {
      i && i.closeParent ? this.open = Math.max(0, this.open - 1) : i && i.skip.nodeType && (l = i.skip);
      let s, r = this.top, o = this.needsBlock;
      if (Fv.hasOwnProperty(t))
        r.content.length && r.content[0].isInline && this.open && (this.open--, r = this.top), s = !0, r.type || (this.needsBlock = !0);
      else if (!l.firstChild) {
        this.leafFallback(l);
        return;
      }
      i && i.skip ? this.addAll(l) : this.withStyleRules(l, () => this.addAll(l)), s && this.sync(r), this.needsBlock = o;
    } else
      this.withStyleRules(l, () => {
        this.addElementByRule(l, i, i.consuming === !1 ? u : void 0);
      });
  }
  // Called for leaf DOM nodes that would otherwise be ignored
  leafFallback(l) {
    l.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(l.ownerDocument.createTextNode(`
`));
  }
  // Called for ignored nodes
  ignoreFallback(l) {
    l.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent) && this.findPlace(this.parser.schema.text("-"));
  }
  // Run any style parser associated with the node's styles. Either
  // return an array of marks, or null to indicate some of the styles
  // had a rule with `ignore` set.
  readStyles(l) {
    let n = Vl.none, t = Vl.none;
    for (let u = 0; u < l.length; u += 2)
      for (let i = void 0; ; ) {
        let s = this.parser.matchStyle(l[u], l[u + 1], this, i);
        if (!s)
          break;
        if (s.ignore)
          return null;
        if (s.clearMark ? this.top.pendingMarks.concat(this.top.activeMarks).forEach((r) => {
          s.clearMark(r) && (t = r.addToSet(t));
        }) : n = this.parser.schema.marks[s.mark].create(s.attrs).addToSet(n), s.consuming === !1)
          i = s;
        else
          break;
      }
    return [n, t];
  }
  // Look up a handler for the given node. If none are found, return
  // false. Otherwise, apply it, use its return value to drive the way
  // the node's content is wrapped, and return true.
  addElementByRule(l, n, t) {
    let u, i, s;
    n.node ? (i = this.parser.schema.nodes[n.node], i.isLeaf ? this.insertNode(i.create(n.attrs)) || this.leafFallback(l) : u = this.enter(i, n.attrs || null, n.preserveWhitespace)) : (s = this.parser.schema.marks[n.mark].create(n.attrs), this.addPendingMark(s));
    let r = this.top;
    if (i && i.isLeaf)
      this.findInside(l);
    else if (t)
      this.addElement(l, t);
    else if (n.getContent)
      this.findInside(l), n.getContent(l, this.parser.schema).forEach((o) => this.insertNode(o));
    else {
      let o = l;
      typeof n.contentElement == "string" ? o = l.querySelector(n.contentElement) : typeof n.contentElement == "function" ? o = n.contentElement(l) : n.contentElement && (o = n.contentElement), this.findAround(l, o, !0), this.addAll(o);
    }
    u && this.sync(r) && this.open--, s && this.removePendingMark(s, r);
  }
  // Add all child nodes between `startIndex` and `endIndex` (or the
  // whole node, if not given). If `sync` is passed, use it to
  // synchronize after every block element.
  addAll(l, n, t) {
    let u = n || 0;
    for (let i = n ? l.childNodes[n] : l.firstChild, s = t == null ? null : l.childNodes[t]; i != s; i = i.nextSibling, ++u)
      this.findAtPoint(l, u), this.addDOM(i);
    this.findAtPoint(l, u);
  }
  // Try to find a way to fit the given node type into the current
  // context. May add intermediate wrappers and/or leave non-solid
  // nodes that we're in.
  findPlace(l) {
    let n, t;
    for (let u = this.open; u >= 0; u--) {
      let i = this.nodes[u], s = i.findWrapping(l);
      if (s && (!n || n.length > s.length) && (n = s, t = i, !s.length) || i.solid)
        break;
    }
    if (!n)
      return !1;
    this.sync(t);
    for (let u = 0; u < n.length; u++)
      this.enterInner(n[u], null, !1);
    return !0;
  }
  // Try to insert the given node, adjusting the context when needed.
  insertNode(l) {
    if (l.isInline && this.needsBlock && !this.top.type) {
      let n = this.textblockFromContext();
      n && this.enterInner(n);
    }
    if (this.findPlace(l)) {
      this.closeExtra();
      let n = this.top;
      n.applyPending(l.type), n.match && (n.match = n.match.matchType(l.type));
      let t = n.activeMarks;
      for (let u = 0; u < l.marks.length; u++)
        (!n.type || n.type.allowsMarkType(l.marks[u].type)) && (t = l.marks[u].addToSet(t));
      return n.content.push(l.mark(t)), !0;
    }
    return !1;
  }
  // Try to start a node of the given type, adjusting the context when
  // necessary.
  enter(l, n, t) {
    let u = this.findPlace(l.create(n));
    return u && this.enterInner(l, n, !0, t), u;
  }
  // Open a node of the given type
  enterInner(l, n = null, t = !1, u) {
    this.closeExtra();
    let i = this.top;
    i.applyPending(l), i.match = i.match && i.match.matchType(l);
    let s = rm(l, u, i.options);
    i.options & ns && i.content.length == 0 && (s |= ns), this.nodes.push(new ir(l, n, i.activeMarks, i.pendingMarks, t, null, s)), this.open++;
  }
  // Make sure all nodes above this.open are finished and added to
  // their parents
  closeExtra(l = !1) {
    let n = this.nodes.length - 1;
    if (n > this.open) {
      for (; n > this.open; n--)
        this.nodes[n - 1].content.push(this.nodes[n].finish(l));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(this.isOpen || this.options.topOpen);
  }
  sync(l) {
    for (let n = this.open; n >= 0; n--)
      if (this.nodes[n] == l)
        return this.open = n, !0;
    return !1;
  }
  get currentPos() {
    this.closeExtra();
    let l = 0;
    for (let n = this.open; n >= 0; n--) {
      let t = this.nodes[n].content;
      for (let u = t.length - 1; u >= 0; u--)
        l += t[u].nodeSize;
      n && l++;
    }
    return l;
  }
  findAtPoint(l, n) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].node == l && this.find[t].offset == n && (this.find[t].pos = this.currentPos);
  }
  findInside(l) {
    if (this.find)
      for (let n = 0; n < this.find.length; n++)
        this.find[n].pos == null && l.nodeType == 1 && l.contains(this.find[n].node) && (this.find[n].pos = this.currentPos);
  }
  findAround(l, n, t) {
    if (l != n && this.find)
      for (let u = 0; u < this.find.length; u++)
        this.find[u].pos == null && l.nodeType == 1 && l.contains(this.find[u].node) && n.compareDocumentPosition(this.find[u].node) & (t ? 2 : 4) && (this.find[u].pos = this.currentPos);
  }
  findInText(l) {
    if (this.find)
      for (let n = 0; n < this.find.length; n++)
        this.find[n].node == l && (this.find[n].pos = this.currentPos - (l.nodeValue.length - this.find[n].offset));
  }
  // Determines whether the given context string matches this context.
  matchesContext(l) {
    if (l.indexOf("|") > -1)
      return l.split(/\s*\|\s*/).some(this.matchesContext, this);
    let n = l.split("/"), t = this.options.context, u = !this.isOpen && (!t || t.parent.type == this.nodes[0].type), i = -(t ? t.depth + 1 : 0) + (u ? 0 : 1), s = (r, o) => {
      for (; r >= 0; r--) {
        let a = n[r];
        if (a == "") {
          if (r == n.length - 1 || r == 0)
            continue;
          for (; o >= i; o--)
            if (s(r - 1, o))
              return !0;
          return !1;
        } else {
          let d = o > 0 || o == 0 && u ? this.nodes[o].type : t && o >= i ? t.node(o - i).type : null;
          if (!d || d.name != a && d.groups.indexOf(a) == -1)
            return !1;
          o--;
        }
      }
      return !0;
    };
    return s(n.length - 1, this.open);
  }
  textblockFromContext() {
    let l = this.options.context;
    if (l)
      for (let n = l.depth; n >= 0; n--) {
        let t = l.node(n).contentMatchAt(l.indexAfter(n)).defaultType;
        if (t && t.isTextblock && t.defaultAttrs)
          return t;
      }
    for (let n in this.parser.schema.nodes) {
      let t = this.parser.schema.nodes[n];
      if (t.isTextblock && t.defaultAttrs)
        return t;
    }
  }
  addPendingMark(l) {
    let n = oM(l, this.top.pendingMarks);
    n && this.top.stashMarks.push(n), this.top.pendingMarks = l.addToSet(this.top.pendingMarks);
  }
  removePendingMark(l, n) {
    for (let t = this.open; t >= 0; t--) {
      let u = this.nodes[t];
      if (u.pendingMarks.lastIndexOf(l) > -1)
        u.pendingMarks = l.removeFromSet(u.pendingMarks);
      else {
        u.activeMarks = l.removeFromSet(u.activeMarks);
        let s = u.popFromStashMark(l);
        s && u.type && u.type.allowsMarkType(s.type) && (u.activeMarks = s.addToSet(u.activeMarks));
      }
      if (u == n)
        break;
    }
  }
}
function uM(e) {
  for (let l = e.firstChild, n = null; l; l = l.nextSibling) {
    let t = l.nodeType == 1 ? l.nodeName.toLowerCase() : null;
    t && Hv.hasOwnProperty(t) && n ? (n.appendChild(l), l = n) : t == "li" ? n = l : t && (n = null);
  }
}
function iM(e, l) {
  return (e.matches || e.msMatchesSelector || e.webkitMatchesSelector || e.mozMatchesSelector).call(e, l);
}
function sM(e) {
  let l = /\s*([\w-]+)\s*:\s*([^;]+)/g, n, t = [];
  for (; n = l.exec(e); )
    t.push(n[1], n[2].trim());
  return t;
}
function am(e) {
  let l = {};
  for (let n in e)
    l[n] = e[n];
  return l;
}
function rM(e, l) {
  let n = l.schema.nodes;
  for (let t in n) {
    let u = n[t];
    if (!u.allowsMarkType(e))
      continue;
    let i = [], s = (r) => {
      i.push(r);
      for (let o = 0; o < r.edgeCount; o++) {
        let { type: a, next: d } = r.edge(o);
        if (a == l || i.indexOf(d) < 0 && s(d))
          return !0;
      }
    };
    if (s(u.contentMatch))
      return !0;
  }
}
function oM(e, l) {
  for (let n = 0; n < l.length; n++)
    if (e.eq(l[n]))
      return l[n];
}
class st {
  /**
  Create a serializer. `nodes` should map node names to functions
  that take a node and return a description of the corresponding
  DOM. `marks` does the same for mark names, but also gets an
  argument that tells it whether the mark's content is block or
  inline content (for typical use, it'll always be inline). A mark
  serializer may be `null` to indicate that marks of that type
  should not be serialized.
  */
  constructor(l, n) {
    this.nodes = l, this.marks = n;
  }
  /**
  Serialize the content of this fragment to a DOM fragment. When
  not in the browser, the `document` option, containing a DOM
  document, should be passed so that the serializer can create
  nodes.
  */
  serializeFragment(l, n = {}, t) {
    t || (t = yd(n).createDocumentFragment());
    let u = t, i = [];
    return l.forEach((s) => {
      if (i.length || s.marks.length) {
        let r = 0, o = 0;
        for (; r < i.length && o < s.marks.length; ) {
          let a = s.marks[o];
          if (!this.marks[a.type.name]) {
            o++;
            continue;
          }
          if (!a.eq(i[r][0]) || a.type.spec.spanning === !1)
            break;
          r++, o++;
        }
        for (; r < i.length; )
          u = i.pop()[1];
        for (; o < s.marks.length; ) {
          let a = s.marks[o++], d = this.serializeMark(a, s.isInline, n);
          d && (i.push([a, u]), u.appendChild(d.dom), u = d.contentDOM || d.dom);
        }
      }
      u.appendChild(this.serializeNodeInner(s, n));
    }), t;
  }
  /**
  @internal
  */
  serializeNodeInner(l, n) {
    let { dom: t, contentDOM: u } = st.renderSpec(yd(n), this.nodes[l.type.name](l));
    if (u) {
      if (l.isLeaf)
        throw new RangeError("Content hole not allowed in a leaf node spec");
      this.serializeFragment(l.content, n, u);
    }
    return t;
  }
  /**
  Serialize this node to a DOM node. This can be useful when you
  need to serialize a part of a document, as opposed to the whole
  document. To serialize a whole document, use
  [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
  its [content](https://prosemirror.net/docs/ref/#model.Node.content).
  */
  serializeNode(l, n = {}) {
    let t = this.serializeNodeInner(l, n);
    for (let u = l.marks.length - 1; u >= 0; u--) {
      let i = this.serializeMark(l.marks[u], l.isInline, n);
      i && ((i.contentDOM || i.dom).appendChild(t), t = i.dom);
    }
    return t;
  }
  /**
  @internal
  */
  serializeMark(l, n, t = {}) {
    let u = this.marks[l.type.name];
    return u && st.renderSpec(yd(t), u(l, n));
  }
  /**
  Render an [output spec](https://prosemirror.net/docs/ref/#model.DOMOutputSpec) to a DOM node. If
  the spec has a hole (zero) in it, `contentDOM` will point at the
  node with the hole.
  */
  static renderSpec(l, n, t = null) {
    if (typeof n == "string")
      return { dom: l.createTextNode(n) };
    if (n.nodeType != null)
      return { dom: n };
    if (n.dom && n.dom.nodeType != null)
      return n;
    let u = n[0], i = u.indexOf(" ");
    i > 0 && (t = u.slice(0, i), u = u.slice(i + 1));
    let s, r = t ? l.createElementNS(t, u) : l.createElement(u), o = n[1], a = 1;
    if (o && typeof o == "object" && o.nodeType == null && !Array.isArray(o)) {
      a = 2;
      for (let d in o)
        if (o[d] != null) {
          let h = d.indexOf(" ");
          h > 0 ? r.setAttributeNS(d.slice(0, h), d.slice(h + 1), o[d]) : r.setAttribute(d, o[d]);
        }
    }
    for (let d = a; d < n.length; d++) {
      let h = n[d];
      if (h === 0) {
        if (d < n.length - 1 || d > a)
          throw new RangeError("Content hole must be the only child of its parent node");
        return { dom: r, contentDOM: r };
      } else {
        let { dom: p, contentDOM: f } = st.renderSpec(l, h, t);
        if (r.appendChild(p), f) {
          if (s)
            throw new RangeError("Multiple content holes");
          s = f;
        }
      }
    }
    return { dom: r, contentDOM: s };
  }
  /**
  Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
  properties in a schema's node and mark specs.
  */
  static fromSchema(l) {
    return l.cached.domSerializer || (l.cached.domSerializer = new st(this.nodesFromSchema(l), this.marksFromSchema(l)));
  }
  /**
  Gather the serializers in a schema's node specs into an object.
  This can be useful as a base to build a custom serializer from.
  */
  static nodesFromSchema(l) {
    let n = dm(l.nodes);
    return n.text || (n.text = (t) => t.text), n;
  }
  /**
  Gather the serializers in a schema's mark specs into an object.
  */
  static marksFromSchema(l) {
    return dm(l.marks);
  }
}
function dm(e) {
  let l = {};
  for (let n in e) {
    let t = e[n].spec.toDOM;
    t && (l[n] = t);
  }
  return l;
}
function yd(e) {
  return e.document || window.document;
}
const zv = 65535, Vv = Math.pow(2, 16);
function aM(e, l) {
  return e + l * Vv;
}
function cm(e) {
  return e & zv;
}
function dM(e) {
  return (e - (e & zv)) / Vv;
}
const jv = 1, Uv = 2, $r = 4, Wv = 8;
class Nh {
  /**
  @internal
  */
  constructor(l, n, t) {
    this.pos = l, this.delInfo = n, this.recover = t;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & Wv) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & (jv | $r)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & (Uv | $r)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & $r) > 0;
  }
}
class ne {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(l, n = !1) {
    if (this.ranges = l, this.inverted = n, !l.length && ne.empty)
      return ne.empty;
  }
  /**
  @internal
  */
  recover(l) {
    let n = 0, t = cm(l);
    if (!this.inverted)
      for (let u = 0; u < t; u++)
        n += this.ranges[u * 3 + 2] - this.ranges[u * 3 + 1];
    return this.ranges[t * 3] + n + dM(l);
  }
  mapResult(l, n = 1) {
    return this._map(l, n, !1);
  }
  map(l, n = 1) {
    return this._map(l, n, !0);
  }
  /**
  @internal
  */
  _map(l, n, t) {
    let u = 0, i = this.inverted ? 2 : 1, s = this.inverted ? 1 : 2;
    for (let r = 0; r < this.ranges.length; r += 3) {
      let o = this.ranges[r] - (this.inverted ? u : 0);
      if (o > l)
        break;
      let a = this.ranges[r + i], d = this.ranges[r + s], h = o + a;
      if (l <= h) {
        let p = a ? l == o ? -1 : l == h ? 1 : n : n, f = o + u + (p < 0 ? 0 : d);
        if (t)
          return f;
        let m = l == (n < 0 ? o : h) ? null : aM(r / 3, l - o), g = l == o ? Uv : l == h ? jv : $r;
        return (n < 0 ? l != o : l != h) && (g |= Wv), new Nh(f, g, m);
      }
      u += d - a;
    }
    return t ? l + u : new Nh(l + u, 0, null);
  }
  /**
  @internal
  */
  touches(l, n) {
    let t = 0, u = cm(n), i = this.inverted ? 2 : 1, s = this.inverted ? 1 : 2;
    for (let r = 0; r < this.ranges.length; r += 3) {
      let o = this.ranges[r] - (this.inverted ? t : 0);
      if (o > l)
        break;
      let a = this.ranges[r + i], d = o + a;
      if (l <= d && r == u * 3)
        return !0;
      t += this.ranges[r + s] - a;
    }
    return !1;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(l) {
    let n = this.inverted ? 2 : 1, t = this.inverted ? 1 : 2;
    for (let u = 0, i = 0; u < this.ranges.length; u += 3) {
      let s = this.ranges[u], r = s - (this.inverted ? i : 0), o = s + (this.inverted ? 0 : i), a = this.ranges[u + n], d = this.ranges[u + t];
      l(r, r + a, o, o + d), i += d - a;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new ne(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(l) {
    return l == 0 ? ne.empty : new ne(l < 0 ? [0, -l, 0] : [0, 0, l]);
  }
}
ne.empty = new ne([]);
class di {
  /**
  Create a new mapping with the given position maps.
  */
  constructor(l = [], n, t = 0, u = l.length) {
    this.maps = l, this.mirror = n, this.from = t, this.to = u;
  }
  /**
  Create a mapping that maps only through a part of this one.
  */
  slice(l = 0, n = this.maps.length) {
    return new di(this.maps, this.mirror, l, n);
  }
  /**
  @internal
  */
  copy() {
    return new di(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
  }
  /**
  Add a step map to the end of this mapping. If `mirrors` is
  given, it should be the index of the step map that is the mirror
  image of this one.
  */
  appendMap(l, n) {
    this.to = this.maps.push(l), n != null && this.setMirror(this.maps.length - 1, n);
  }
  /**
  Add all the step maps in a given mapping to this one (preserving
  mirroring information).
  */
  appendMapping(l) {
    for (let n = 0, t = this.maps.length; n < l.maps.length; n++) {
      let u = l.getMirror(n);
      this.appendMap(l.maps[n], u != null && u < n ? t + u : void 0);
    }
  }
  /**
  Finds the offset of the step map that mirrors the map at the
  given offset, in this mapping (as per the second argument to
  `appendMap`).
  */
  getMirror(l) {
    if (this.mirror) {
      for (let n = 0; n < this.mirror.length; n++)
        if (this.mirror[n] == l)
          return this.mirror[n + (n % 2 ? -1 : 1)];
    }
  }
  /**
  @internal
  */
  setMirror(l, n) {
    this.mirror || (this.mirror = []), this.mirror.push(l, n);
  }
  /**
  Append the inverse of the given mapping to this one.
  */
  appendMappingInverted(l) {
    for (let n = l.maps.length - 1, t = this.maps.length + l.maps.length; n >= 0; n--) {
      let u = l.getMirror(n);
      this.appendMap(l.maps[n].invert(), u != null && u > n ? t - u - 1 : void 0);
    }
  }
  /**
  Create an inverted version of this mapping.
  */
  invert() {
    let l = new di();
    return l.appendMappingInverted(this), l;
  }
  /**
  Map a position through this mapping.
  */
  map(l, n = 1) {
    if (this.mirror)
      return this._map(l, n, !0);
    for (let t = this.from; t < this.to; t++)
      l = this.maps[t].map(l, n);
    return l;
  }
  /**
  Map a position through this mapping, returning a mapping
  result.
  */
  mapResult(l, n = 1) {
    return this._map(l, n, !1);
  }
  /**
  @internal
  */
  _map(l, n, t) {
    let u = 0;
    for (let i = this.from; i < this.to; i++) {
      let s = this.maps[i], r = s.mapResult(l, n);
      if (r.recover != null) {
        let o = this.getMirror(i);
        if (o != null && o > i && o < this.to) {
          i = o, l = this.maps[o].recover(r.recover);
          continue;
        }
      }
      u |= r.delInfo, l = r.pos;
    }
    return t ? l : new Nh(l, u, null);
  }
}
const $d = /* @__PURE__ */ Object.create(null);
class Ln {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return ne.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(l) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(l, n) {
    if (!n || !n.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let t = $d[n.stepType];
    if (!t)
      throw new RangeError(`No step type ${n.stepType} defined`);
    return t.fromJSON(l, n);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(l, n) {
    if (l in $d)
      throw new RangeError("Duplicate use of step JSON ID " + l);
    return $d[l] = n, n.prototype.jsonID = l, n;
  }
}
class tn {
  /**
  @internal
  */
  constructor(l, n) {
    this.doc = l, this.failed = n;
  }
  /**
  Create a successful step result.
  */
  static ok(l) {
    return new tn(l, null);
  }
  /**
  Create a failed step result.
  */
  static fail(l) {
    return new tn(null, l);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(l, n, t, u) {
    try {
      return tn.ok(l.replace(n, t, u));
    } catch (i) {
      if (i instanceof Lr)
        return tn.fail(i.message);
      throw i;
    }
  }
}
function Hf(e, l, n) {
  let t = [];
  for (let u = 0; u < e.childCount; u++) {
    let i = e.child(u);
    i.content.size && (i = i.copy(Hf(i.content, l, i))), i.isInline && (i = l(i, n, u)), t.push(i);
  }
  return j.fromArray(t);
}
class Yt extends Ln {
  /**
  Create a mark step.
  */
  constructor(l, n, t) {
    super(), this.from = l, this.to = n, this.mark = t;
  }
  apply(l) {
    let n = l.slice(this.from, this.to), t = l.resolve(this.from), u = t.node(t.sharedDepth(this.to)), i = new nl(Hf(n.content, (s, r) => !s.isAtom || !r.type.allowsMarkType(this.mark.type) ? s : s.mark(this.mark.addToSet(s.marks)), u), n.openStart, n.openEnd);
    return tn.fromReplace(l, this.from, this.to, i);
  }
  invert() {
    return new rt(this.from, this.to, this.mark);
  }
  map(l) {
    let n = l.mapResult(this.from, 1), t = l.mapResult(this.to, -1);
    return n.deleted && t.deleted || n.pos >= t.pos ? null : new Yt(n.pos, t.pos, this.mark);
  }
  merge(l) {
    return l instanceof Yt && l.mark.eq(this.mark) && this.from <= l.to && this.to >= l.from ? new Yt(Math.min(this.from, l.from), Math.max(this.to, l.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(l, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new Yt(n.from, n.to, l.markFromJSON(n.mark));
  }
}
Ln.jsonID("addMark", Yt);
class rt extends Ln {
  /**
  Create a mark-removing step.
  */
  constructor(l, n, t) {
    super(), this.from = l, this.to = n, this.mark = t;
  }
  apply(l) {
    let n = l.slice(this.from, this.to), t = new nl(Hf(n.content, (u) => u.mark(this.mark.removeFromSet(u.marks)), l), n.openStart, n.openEnd);
    return tn.fromReplace(l, this.from, this.to, t);
  }
  invert() {
    return new Yt(this.from, this.to, this.mark);
  }
  map(l) {
    let n = l.mapResult(this.from, 1), t = l.mapResult(this.to, -1);
    return n.deleted && t.deleted || n.pos >= t.pos ? null : new rt(n.pos, t.pos, this.mark);
  }
  merge(l) {
    return l instanceof rt && l.mark.eq(this.mark) && this.from <= l.to && this.to >= l.from ? new rt(Math.min(this.from, l.from), Math.max(this.to, l.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(l, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new rt(n.from, n.to, l.markFromJSON(n.mark));
  }
}
Ln.jsonID("removeMark", rt);
class qt extends Ln {
  /**
  Create a node mark step.
  */
  constructor(l, n) {
    super(), this.pos = l, this.mark = n;
  }
  apply(l) {
    let n = l.nodeAt(this.pos);
    if (!n)
      return tn.fail("No node at mark step's position");
    let t = n.type.create(n.attrs, null, this.mark.addToSet(n.marks));
    return tn.fromReplace(l, this.pos, this.pos + 1, new nl(j.from(t), 0, n.isLeaf ? 0 : 1));
  }
  invert(l) {
    let n = l.nodeAt(this.pos);
    if (n) {
      let t = this.mark.addToSet(n.marks);
      if (t.length == n.marks.length) {
        for (let u = 0; u < n.marks.length; u++)
          if (!n.marks[u].isInSet(t))
            return new qt(this.pos, n.marks[u]);
        return new qt(this.pos, this.mark);
      }
    }
    return new bi(this.pos, this.mark);
  }
  map(l) {
    let n = l.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new qt(n.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(l, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new qt(n.pos, l.markFromJSON(n.mark));
  }
}
Ln.jsonID("addNodeMark", qt);
class bi extends Ln {
  /**
  Create a mark-removing step.
  */
  constructor(l, n) {
    super(), this.pos = l, this.mark = n;
  }
  apply(l) {
    let n = l.nodeAt(this.pos);
    if (!n)
      return tn.fail("No node at mark step's position");
    let t = n.type.create(n.attrs, null, this.mark.removeFromSet(n.marks));
    return tn.fromReplace(l, this.pos, this.pos + 1, new nl(j.from(t), 0, n.isLeaf ? 0 : 1));
  }
  invert(l) {
    let n = l.nodeAt(this.pos);
    return !n || !this.mark.isInSet(n.marks) ? this : new qt(this.pos, this.mark);
  }
  map(l) {
    let n = l.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new bi(n.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(l, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new bi(n.pos, l.markFromJSON(n.mark));
  }
}
Ln.jsonID("removeNodeMark", bi);
class dn extends Ln {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(l, n, t, u = !1) {
    super(), this.from = l, this.to = n, this.slice = t, this.structure = u;
  }
  apply(l) {
    return this.structure && Lh(l, this.from, this.to) ? tn.fail("Structure replace would overwrite content") : tn.fromReplace(l, this.from, this.to, this.slice);
  }
  getMap() {
    return new ne([this.from, this.to - this.from, this.slice.size]);
  }
  invert(l) {
    return new dn(this.from, this.from + this.slice.size, l.slice(this.from, this.to));
  }
  map(l) {
    let n = l.mapResult(this.from, 1), t = l.mapResult(this.to, -1);
    return n.deletedAcross && t.deletedAcross ? null : new dn(n.pos, Math.max(n.pos, t.pos), this.slice);
  }
  merge(l) {
    if (!(l instanceof dn) || l.structure || this.structure)
      return null;
    if (this.from + this.slice.size == l.from && !this.slice.openEnd && !l.slice.openStart) {
      let n = this.slice.size + l.slice.size == 0 ? nl.empty : new nl(this.slice.content.append(l.slice.content), this.slice.openStart, l.slice.openEnd);
      return new dn(this.from, this.to + (l.to - l.from), n, this.structure);
    } else if (l.to == this.from && !this.slice.openStart && !l.slice.openEnd) {
      let n = this.slice.size + l.slice.size == 0 ? nl.empty : new nl(l.slice.content.append(this.slice.content), l.slice.openStart, this.slice.openEnd);
      return new dn(l.from, this.to, n, this.structure);
    } else
      return null;
  }
  toJSON() {
    let l = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (l.slice = this.slice.toJSON()), this.structure && (l.structure = !0), l;
  }
  /**
  @internal
  */
  static fromJSON(l, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new dn(n.from, n.to, nl.fromJSON(l, n.slice), !!n.structure);
  }
}
Ln.jsonID("replace", dn);
class hn extends Ln {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(l, n, t, u, i, s, r = !1) {
    super(), this.from = l, this.to = n, this.gapFrom = t, this.gapTo = u, this.slice = i, this.insert = s, this.structure = r;
  }
  apply(l) {
    if (this.structure && (Lh(l, this.from, this.gapFrom) || Lh(l, this.gapTo, this.to)))
      return tn.fail("Structure gap-replace would overwrite content");
    let n = l.slice(this.gapFrom, this.gapTo);
    if (n.openStart || n.openEnd)
      return tn.fail("Gap is not a flat range");
    let t = this.slice.insertAt(this.insert, n.content);
    return t ? tn.fromReplace(l, this.from, this.to, t) : tn.fail("Content does not fit in gap");
  }
  getMap() {
    return new ne([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(l) {
    let n = this.gapTo - this.gapFrom;
    return new hn(this.from, this.from + this.slice.size + n, this.from + this.insert, this.from + this.insert + n, l.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(l) {
    let n = l.mapResult(this.from, 1), t = l.mapResult(this.to, -1), u = l.map(this.gapFrom, -1), i = l.map(this.gapTo, 1);
    return n.deletedAcross && t.deletedAcross || u < n.pos || i > t.pos ? null : new hn(n.pos, t.pos, u, i, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let l = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (l.slice = this.slice.toJSON()), this.structure && (l.structure = !0), l;
  }
  /**
  @internal
  */
  static fromJSON(l, n) {
    if (typeof n.from != "number" || typeof n.to != "number" || typeof n.gapFrom != "number" || typeof n.gapTo != "number" || typeof n.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new hn(n.from, n.to, n.gapFrom, n.gapTo, nl.fromJSON(l, n.slice), n.insert, !!n.structure);
  }
}
Ln.jsonID("replaceAround", hn);
function Lh(e, l, n) {
  let t = e.resolve(l), u = n - l, i = t.depth;
  for (; u > 0 && i > 0 && t.indexAfter(i) == t.node(i).childCount; )
    i--, u--;
  if (u > 0) {
    let s = t.node(i).maybeChild(t.indexAfter(i));
    for (; u > 0; ) {
      if (!s || s.isLeaf)
        return !0;
      s = s.firstChild, u--;
    }
  }
  return !1;
}
function cM(e, l, n, t) {
  let u = [], i = [], s, r;
  e.doc.nodesBetween(l, n, (o, a, d) => {
    if (!o.isInline)
      return;
    let h = o.marks;
    if (!t.isInSet(h) && d.type.allowsMarkType(t.type)) {
      let p = Math.max(a, l), f = Math.min(a + o.nodeSize, n), m = t.addToSet(h);
      for (let g = 0; g < h.length; g++)
        h[g].isInSet(m) || (s && s.to == p && s.mark.eq(h[g]) ? s.to = f : u.push(s = new rt(p, f, h[g])));
      r && r.to == p ? r.to = f : i.push(r = new Yt(p, f, t));
    }
  }), u.forEach((o) => e.step(o)), i.forEach((o) => e.step(o));
}
function hM(e, l, n, t) {
  let u = [], i = 0;
  e.doc.nodesBetween(l, n, (s, r) => {
    if (!s.isInline)
      return;
    i++;
    let o = null;
    if (t instanceof ta) {
      let a = s.marks, d;
      for (; d = t.isInSet(a); )
        (o || (o = [])).push(d), a = d.removeFromSet(a);
    } else
      t ? t.isInSet(s.marks) && (o = [t]) : o = s.marks;
    if (o && o.length) {
      let a = Math.min(r + s.nodeSize, n);
      for (let d = 0; d < o.length; d++) {
        let h = o[d], p;
        for (let f = 0; f < u.length; f++) {
          let m = u[f];
          m.step == i - 1 && h.eq(u[f].style) && (p = m);
        }
        p ? (p.to = a, p.step = i) : u.push({ style: h, from: Math.max(r, l), to: a, step: i });
      }
    }
  }), u.forEach((s) => e.step(new rt(s.from, s.to, s.style)));
}
function pM(e, l, n, t = n.contentMatch) {
  let u = e.doc.nodeAt(l), i = [], s = l + 1;
  for (let r = 0; r < u.childCount; r++) {
    let o = u.child(r), a = s + o.nodeSize, d = t.matchType(o.type);
    if (!d)
      i.push(new dn(s, a, nl.empty));
    else {
      t = d;
      for (let h = 0; h < o.marks.length; h++)
        n.allowsMarkType(o.marks[h].type) || e.step(new rt(s, a, o.marks[h]));
      if (o.isText && !n.spec.code) {
        let h, p = /\r?\n|\r/g, f;
        for (; h = p.exec(o.text); )
          f || (f = new nl(j.from(n.schema.text(" ", n.allowedMarks(o.marks))), 0, 0)), i.push(new dn(s + h.index, s + h.index + h[0].length, f));
      }
    }
    s = a;
  }
  if (!t.validEnd) {
    let r = t.fillBefore(j.empty, !0);
    e.replace(s, s, new nl(r, 0, 0));
  }
  for (let r = i.length - 1; r >= 0; r--)
    e.step(i[r]);
}
function fM(e, l, n) {
  return (l == 0 || e.canReplace(l, e.childCount)) && (n == e.childCount || e.canReplace(0, n));
}
function Ni(e) {
  let n = e.parent.content.cutByIndex(e.startIndex, e.endIndex);
  for (let t = e.depth; ; --t) {
    let u = e.$from.node(t), i = e.$from.index(t), s = e.$to.indexAfter(t);
    if (t < e.depth && u.canReplace(i, s, n))
      return t;
    if (t == 0 || u.type.spec.isolating || !fM(u, i, s))
      break;
  }
  return null;
}
function mM(e, l, n) {
  let { $from: t, $to: u, depth: i } = l, s = t.before(i + 1), r = u.after(i + 1), o = s, a = r, d = j.empty, h = 0;
  for (let m = i, g = !1; m > n; m--)
    g || t.index(m) > 0 ? (g = !0, d = j.from(t.node(m).copy(d)), h++) : o--;
  let p = j.empty, f = 0;
  for (let m = i, g = !1; m > n; m--)
    g || u.after(m + 1) < u.end(m) ? (g = !0, p = j.from(u.node(m).copy(p)), f++) : a++;
  e.step(new hn(o, a, s, r, new nl(d.append(p), h, f), d.size - h, !0));
}
function zf(e, l, n = null, t = e) {
  let u = gM(e, l), i = u && vM(t, l);
  return i ? u.map(hm).concat({ type: l, attrs: n }).concat(i.map(hm)) : null;
}
function hm(e) {
  return { type: e, attrs: null };
}
function gM(e, l) {
  let { parent: n, startIndex: t, endIndex: u } = e, i = n.contentMatchAt(t).findWrapping(l);
  if (!i)
    return null;
  let s = i.length ? i[0] : l;
  return n.canReplaceWith(t, u, s) ? i : null;
}
function vM(e, l) {
  let { parent: n, startIndex: t, endIndex: u } = e, i = n.child(t), s = l.contentMatch.findWrapping(i.type);
  if (!s)
    return null;
  let o = (s.length ? s[s.length - 1] : l).contentMatch;
  for (let a = t; o && a < u; a++)
    o = o.matchType(n.child(a).type);
  return !o || !o.validEnd ? null : s;
}
function yM(e, l, n) {
  let t = j.empty;
  for (let s = n.length - 1; s >= 0; s--) {
    if (t.size) {
      let r = n[s].type.contentMatch.matchFragment(t);
      if (!r || !r.validEnd)
        throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
    }
    t = j.from(n[s].type.create(n[s].attrs, t));
  }
  let u = l.start, i = l.end;
  e.step(new hn(u, i, u, i, new nl(t, 0, 0), n.length, !0));
}
function $M(e, l, n, t, u) {
  if (!t.isTextblock)
    throw new RangeError("Type given to setBlockType should be a textblock");
  let i = e.steps.length;
  e.doc.nodesBetween(l, n, (s, r) => {
    if (s.isTextblock && !s.hasMarkup(t, u) && bM(e.doc, e.mapping.slice(i).map(r), t)) {
      e.clearIncompatible(e.mapping.slice(i).map(r, 1), t);
      let o = e.mapping.slice(i), a = o.map(r, 1), d = o.map(r + s.nodeSize, 1);
      return e.step(new hn(a, d, a + 1, d - 1, new nl(j.from(t.create(u, null, s.marks)), 0, 0), 1, !0)), !1;
    }
  });
}
function bM(e, l, n) {
  let t = e.resolve(l), u = t.index();
  return t.parent.canReplaceWith(u, u + 1, n);
}
function wM(e, l, n, t, u) {
  let i = e.doc.nodeAt(l);
  if (!i)
    throw new RangeError("No node at given position");
  n || (n = i.type);
  let s = n.create(t, null, u || i.marks);
  if (i.isLeaf)
    return e.replaceWith(l, l + i.nodeSize, s);
  if (!n.validContent(i.content))
    throw new RangeError("Invalid content for node type " + n.name);
  e.step(new hn(l, l + i.nodeSize, l + 1, l + i.nodeSize - 1, new nl(j.from(s), 0, 0), 1, !0));
}
function ci(e, l, n = 1, t) {
  let u = e.resolve(l), i = u.depth - n, s = t && t[t.length - 1] || u.parent;
  if (i < 0 || u.parent.type.spec.isolating || !u.parent.canReplace(u.index(), u.parent.childCount) || !s.type.validContent(u.parent.content.cutByIndex(u.index(), u.parent.childCount)))
    return !1;
  for (let a = u.depth - 1, d = n - 2; a > i; a--, d--) {
    let h = u.node(a), p = u.index(a);
    if (h.type.spec.isolating)
      return !1;
    let f = h.content.cutByIndex(p, h.childCount), m = t && t[d + 1];
    m && (f = f.replaceChild(0, m.type.create(m.attrs)));
    let g = t && t[d] || h;
    if (!h.canReplace(p + 1, h.childCount) || !g.type.validContent(f))
      return !1;
  }
  let r = u.indexAfter(i), o = t && t[0];
  return u.node(i).canReplaceWith(r, r, o ? o.type : u.node(i + 1).type);
}
function _M(e, l, n = 1, t) {
  let u = e.doc.resolve(l), i = j.empty, s = j.empty;
  for (let r = u.depth, o = u.depth - n, a = n - 1; r > o; r--, a--) {
    i = j.from(u.node(r).copy(i));
    let d = t && t[a];
    s = j.from(d ? d.type.create(d.attrs, s) : u.node(r).copy(s));
  }
  e.step(new dn(l, l, new nl(i.append(s), n, n), !0));
}
function ru(e, l) {
  let n = e.resolve(l), t = n.index();
  return Gv(n.nodeBefore, n.nodeAfter) && n.parent.canReplace(t, t + 1);
}
function Gv(e, l) {
  return !!(e && l && !e.isLeaf && e.canAppend(l));
}
function ua(e, l, n = -1) {
  let t = e.resolve(l);
  for (let u = t.depth; ; u--) {
    let i, s, r = t.index(u);
    if (u == t.depth ? (i = t.nodeBefore, s = t.nodeAfter) : n > 0 ? (i = t.node(u + 1), r++, s = t.node(u).maybeChild(r)) : (i = t.node(u).maybeChild(r - 1), s = t.node(u + 1)), i && !i.isTextblock && Gv(i, s) && t.node(u).canReplace(r, r + 1))
      return l;
    if (u == 0)
      break;
    l = n < 0 ? t.before(u) : t.after(u);
  }
}
function SM(e, l, n) {
  let t = new dn(l - n, l + n, nl.empty, !0);
  e.step(t);
}
function CM(e, l, n) {
  let t = e.resolve(l);
  if (t.parent.canReplaceWith(t.index(), t.index(), n))
    return l;
  if (t.parentOffset == 0)
    for (let u = t.depth - 1; u >= 0; u--) {
      let i = t.index(u);
      if (t.node(u).canReplaceWith(i, i, n))
        return t.before(u + 1);
      if (i > 0)
        return null;
    }
  if (t.parentOffset == t.parent.content.size)
    for (let u = t.depth - 1; u >= 0; u--) {
      let i = t.indexAfter(u);
      if (t.node(u).canReplaceWith(i, i, n))
        return t.after(u + 1);
      if (i < t.node(u).childCount)
        return null;
    }
  return null;
}
function Kv(e, l, n) {
  let t = e.resolve(l);
  if (!n.content.size)
    return l;
  let u = n.content;
  for (let i = 0; i < n.openStart; i++)
    u = u.firstChild.content;
  for (let i = 1; i <= (n.openStart == 0 && n.size ? 2 : 1); i++)
    for (let s = t.depth; s >= 0; s--) {
      let r = s == t.depth ? 0 : t.pos <= (t.start(s + 1) + t.end(s + 1)) / 2 ? -1 : 1, o = t.index(s) + (r > 0 ? 1 : 0), a = t.node(s), d = !1;
      if (i == 1)
        d = a.canReplace(o, o, u);
      else {
        let h = a.contentMatchAt(o).findWrapping(u.firstChild.type);
        d = h && a.canReplaceWith(o, o, h[0]);
      }
      if (d)
        return r == 0 ? t.pos : r < 0 ? t.before(s + 1) : t.after(s + 1);
    }
  return null;
}
function ia(e, l, n = l, t = nl.empty) {
  if (l == n && !t.size)
    return null;
  let u = e.resolve(l), i = e.resolve(n);
  return Yv(u, i, t) ? new dn(l, n, t) : new TM(u, i, t).fit();
}
function Yv(e, l, n) {
  return !n.openStart && !n.openEnd && e.start() == l.start() && e.parent.canReplace(e.index(), l.index(), n.content);
}
class TM {
  constructor(l, n, t) {
    this.$from = l, this.$to = n, this.unplaced = t, this.frontier = [], this.placed = j.empty;
    for (let u = 0; u <= l.depth; u++) {
      let i = l.node(u);
      this.frontier.push({
        type: i.type,
        match: i.contentMatchAt(l.indexAfter(u))
      });
    }
    for (let u = l.depth; u > 0; u--)
      this.placed = j.from(l.node(u).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size; ) {
      let a = this.findFittable();
      a ? this.placeNodes(a) : this.openMore() || this.dropNode();
    }
    let l = this.mustMoveInline(), n = this.placed.size - this.depth - this.$from.depth, t = this.$from, u = this.close(l < 0 ? this.$to : t.doc.resolve(l));
    if (!u)
      return null;
    let i = this.placed, s = t.depth, r = u.depth;
    for (; s && r && i.childCount == 1; )
      i = i.firstChild.content, s--, r--;
    let o = new nl(i, s, r);
    return l > -1 ? new hn(t.pos, l, this.$to.pos, this.$to.end(), o, n) : o.size || t.pos != this.$to.pos ? new dn(t.pos, u.pos, o) : null;
  }
  // Find a position on the start spine of `this.unplaced` that has
  // content that can be moved somewhere on the frontier. Returns two
  // depths, one for the slice and one for the frontier.
  findFittable() {
    let l = this.unplaced.openStart;
    for (let n = this.unplaced.content, t = 0, u = this.unplaced.openEnd; t < l; t++) {
      let i = n.firstChild;
      if (n.childCount > 1 && (u = 0), i.type.spec.isolating && u <= t) {
        l = t;
        break;
      }
      n = i.content;
    }
    for (let n = 1; n <= 2; n++)
      for (let t = n == 1 ? l : this.unplaced.openStart; t >= 0; t--) {
        let u, i = null;
        t ? (i = bd(this.unplaced.content, t - 1).firstChild, u = i.content) : u = this.unplaced.content;
        let s = u.firstChild;
        for (let r = this.depth; r >= 0; r--) {
          let { type: o, match: a } = this.frontier[r], d, h = null;
          if (n == 1 && (s ? a.matchType(s.type) || (h = a.fillBefore(j.from(s), !1)) : i && o.compatibleContent(i.type)))
            return { sliceDepth: t, frontierDepth: r, parent: i, inject: h };
          if (n == 2 && s && (d = a.findWrapping(s.type)))
            return { sliceDepth: t, frontierDepth: r, parent: i, wrap: d };
          if (i && a.matchType(i.type))
            break;
        }
      }
  }
  openMore() {
    let { content: l, openStart: n, openEnd: t } = this.unplaced, u = bd(l, n);
    return !u.childCount || u.firstChild.isLeaf ? !1 : (this.unplaced = new nl(l, n + 1, Math.max(t, u.size + n >= l.size - t ? n + 1 : 0)), !0);
  }
  dropNode() {
    let { content: l, openStart: n, openEnd: t } = this.unplaced, u = bd(l, n);
    if (u.childCount <= 1 && n > 0) {
      let i = l.size - n <= n + u.size;
      this.unplaced = new nl(Vi(l, n - 1, 1), n - 1, i ? n - 1 : t);
    } else
      this.unplaced = new nl(Vi(l, n, 1), n, t);
  }
  // Move content from the unplaced slice at `sliceDepth` to the
  // frontier node at `frontierDepth`. Close that frontier node when
  // applicable.
  placeNodes({ sliceDepth: l, frontierDepth: n, parent: t, inject: u, wrap: i }) {
    for (; this.depth > n; )
      this.closeFrontierNode();
    if (i)
      for (let g = 0; g < i.length; g++)
        this.openFrontierNode(i[g]);
    let s = this.unplaced, r = t ? t.content : s.content, o = s.openStart - l, a = 0, d = [], { match: h, type: p } = this.frontier[n];
    if (u) {
      for (let g = 0; g < u.childCount; g++)
        d.push(u.child(g));
      h = h.matchFragment(u);
    }
    let f = r.size + l - (s.content.size - s.openEnd);
    for (; a < r.childCount; ) {
      let g = r.child(a), v = h.matchType(g.type);
      if (!v)
        break;
      a++, (a > 1 || o == 0 || g.content.size) && (h = v, d.push(qv(g.mark(p.allowedMarks(g.marks)), a == 1 ? o : 0, a == r.childCount ? f : -1)));
    }
    let m = a == r.childCount;
    m || (f = -1), this.placed = ji(this.placed, n, j.from(d)), this.frontier[n].match = h, m && f < 0 && t && t.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let g = 0, v = r; g < f; g++) {
      let w = v.lastChild;
      this.frontier.push({ type: w.type, match: w.contentMatchAt(w.childCount) }), v = w.content;
    }
    this.unplaced = m ? l == 0 ? nl.empty : new nl(Vi(s.content, l - 1, 1), l - 1, f < 0 ? s.openEnd : l - 1) : new nl(Vi(s.content, l, a), s.openStart, s.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let l = this.frontier[this.depth], n;
    if (!l.type.isTextblock || !wd(this.$to, this.$to.depth, l.type, l.match, !1) || this.$to.depth == this.depth && (n = this.findCloseLevel(this.$to)) && n.depth == this.depth)
      return -1;
    let { depth: t } = this.$to, u = this.$to.after(t);
    for (; t > 1 && u == this.$to.end(--t); )
      ++u;
    return u;
  }
  findCloseLevel(l) {
    l:
      for (let n = Math.min(this.depth, l.depth); n >= 0; n--) {
        let { match: t, type: u } = this.frontier[n], i = n < l.depth && l.end(n + 1) == l.pos + (l.depth - (n + 1)), s = wd(l, n, u, t, i);
        if (s) {
          for (let r = n - 1; r >= 0; r--) {
            let { match: o, type: a } = this.frontier[r], d = wd(l, r, a, o, !0);
            if (!d || d.childCount)
              continue l;
          }
          return { depth: n, fit: s, move: i ? l.doc.resolve(l.after(n + 1)) : l };
        }
      }
  }
  close(l) {
    let n = this.findCloseLevel(l);
    if (!n)
      return null;
    for (; this.depth > n.depth; )
      this.closeFrontierNode();
    n.fit.childCount && (this.placed = ji(this.placed, n.depth, n.fit)), l = n.move;
    for (let t = n.depth + 1; t <= l.depth; t++) {
      let u = l.node(t), i = u.type.contentMatch.fillBefore(u.content, !0, l.index(t));
      this.openFrontierNode(u.type, u.attrs, i);
    }
    return l;
  }
  openFrontierNode(l, n = null, t) {
    let u = this.frontier[this.depth];
    u.match = u.match.matchType(l), this.placed = ji(this.placed, this.depth, j.from(l.create(n, t))), this.frontier.push({ type: l, match: l.contentMatch });
  }
  closeFrontierNode() {
    let n = this.frontier.pop().match.fillBefore(j.empty, !0);
    n.childCount && (this.placed = ji(this.placed, this.frontier.length, n));
  }
}
function Vi(e, l, n) {
  return l == 0 ? e.cutByIndex(n, e.childCount) : e.replaceChild(0, e.firstChild.copy(Vi(e.firstChild.content, l - 1, n)));
}
function ji(e, l, n) {
  return l == 0 ? e.append(n) : e.replaceChild(e.childCount - 1, e.lastChild.copy(ji(e.lastChild.content, l - 1, n)));
}
function bd(e, l) {
  for (let n = 0; n < l; n++)
    e = e.firstChild.content;
  return e;
}
function qv(e, l, n) {
  if (l <= 0)
    return e;
  let t = e.content;
  return l > 1 && (t = t.replaceChild(0, qv(t.firstChild, l - 1, t.childCount == 1 ? n - 1 : 0))), l > 0 && (t = e.type.contentMatch.fillBefore(t).append(t), n <= 0 && (t = t.append(e.type.contentMatch.matchFragment(t).fillBefore(j.empty, !0)))), e.copy(t);
}
function wd(e, l, n, t, u) {
  let i = e.node(l), s = u ? e.indexAfter(l) : e.index(l);
  if (s == i.childCount && !n.compatibleContent(i.type))
    return null;
  let r = t.fillBefore(i.content, !0, s);
  return r && !OM(n, i.content, s) ? r : null;
}
function OM(e, l, n) {
  for (let t = n; t < l.childCount; t++)
    if (!e.allowsMarks(l.child(t).marks))
      return !0;
  return !1;
}
function kM(e) {
  return e.spec.defining || e.spec.definingForContent;
}
function MM(e, l, n, t) {
  if (!t.size)
    return e.deleteRange(l, n);
  let u = e.doc.resolve(l), i = e.doc.resolve(n);
  if (Yv(u, i, t))
    return e.step(new dn(l, n, t));
  let s = Zv(u, e.doc.resolve(n));
  s[s.length - 1] == 0 && s.pop();
  let r = -(u.depth + 1);
  s.unshift(r);
  for (let p = u.depth, f = u.pos - 1; p > 0; p--, f--) {
    let m = u.node(p).type.spec;
    if (m.defining || m.definingAsContext || m.isolating)
      break;
    s.indexOf(p) > -1 ? r = p : u.before(p) == f && s.splice(1, 0, -p);
  }
  let o = s.indexOf(r), a = [], d = t.openStart;
  for (let p = t.content, f = 0; ; f++) {
    let m = p.firstChild;
    if (a.push(m), f == t.openStart)
      break;
    p = m.content;
  }
  for (let p = d - 1; p >= 0; p--) {
    let f = a[p], m = kM(f.type);
    if (m && !f.sameMarkup(u.node(Math.abs(r) - 1)))
      d = p;
    else if (m || !f.type.isTextblock)
      break;
  }
  for (let p = t.openStart; p >= 0; p--) {
    let f = (p + d + 1) % (t.openStart + 1), m = a[f];
    if (m)
      for (let g = 0; g < s.length; g++) {
        let v = s[(g + o) % s.length], w = !0;
        v < 0 && (w = !1, v = -v);
        let $ = u.node(v - 1), _ = u.index(v - 1);
        if ($.canReplaceWith(_, _, m.type, m.marks))
          return e.replace(u.before(v), w ? i.after(v) : n, new nl(Jv(t.content, 0, t.openStart, f), f, t.openEnd));
      }
  }
  let h = e.steps.length;
  for (let p = s.length - 1; p >= 0 && (e.replace(l, n, t), !(e.steps.length > h)); p--) {
    let f = s[p];
    f < 0 || (l = u.before(f), n = i.after(f));
  }
}
function Jv(e, l, n, t, u) {
  if (l < n) {
    let i = e.firstChild;
    e = e.replaceChild(0, i.copy(Jv(i.content, l + 1, n, t, i)));
  }
  if (l > t) {
    let i = u.contentMatchAt(0), s = i.fillBefore(e).append(e);
    e = s.append(i.matchFragment(s).fillBefore(j.empty, !0));
  }
  return e;
}
function AM(e, l, n, t) {
  if (!t.isInline && l == n && e.doc.resolve(l).parent.content.size) {
    let u = CM(e.doc, l, t.type);
    u != null && (l = n = u);
  }
  e.replaceRange(l, n, new nl(j.from(t), 0, 0));
}
function xM(e, l, n) {
  let t = e.doc.resolve(l), u = e.doc.resolve(n), i = Zv(t, u);
  for (let s = 0; s < i.length; s++) {
    let r = i[s], o = s == i.length - 1;
    if (o && r == 0 || t.node(r).type.contentMatch.validEnd)
      return e.delete(t.start(r), u.end(r));
    if (r > 0 && (o || t.node(r - 1).canReplace(t.index(r - 1), u.indexAfter(r - 1))))
      return e.delete(t.before(r), u.after(r));
  }
  for (let s = 1; s <= t.depth && s <= u.depth; s++)
    if (l - t.start(s) == t.depth - s && n > t.end(s) && u.end(s) - n != u.depth - s)
      return e.delete(t.before(s), n);
  e.delete(l, n);
}
function Zv(e, l) {
  let n = [], t = Math.min(e.depth, l.depth);
  for (let u = t; u >= 0; u--) {
    let i = e.start(u);
    if (i < e.pos - (e.depth - u) || l.end(u) > l.pos + (l.depth - u) || e.node(u).type.spec.isolating || l.node(u).type.spec.isolating)
      break;
    (i == l.start(u) || u == e.depth && u == l.depth && e.parent.inlineContent && l.parent.inlineContent && u && l.start(u - 1) == i - 1) && n.push(u);
  }
  return n;
}
class hi extends Ln {
  /**
  Construct an attribute step.
  */
  constructor(l, n, t) {
    super(), this.pos = l, this.attr = n, this.value = t;
  }
  apply(l) {
    let n = l.nodeAt(this.pos);
    if (!n)
      return tn.fail("No node at attribute step's position");
    let t = /* @__PURE__ */ Object.create(null);
    for (let i in n.attrs)
      t[i] = n.attrs[i];
    t[this.attr] = this.value;
    let u = n.type.create(t, null, n.marks);
    return tn.fromReplace(l, this.pos, this.pos + 1, new nl(j.from(u), 0, n.isLeaf ? 0 : 1));
  }
  getMap() {
    return ne.empty;
  }
  invert(l) {
    return new hi(this.pos, this.attr, l.nodeAt(this.pos).attrs[this.attr]);
  }
  map(l) {
    let n = l.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new hi(n.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(l, n) {
    if (typeof n.pos != "number" || typeof n.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new hi(n.pos, n.attr, n.value);
  }
}
Ln.jsonID("attr", hi);
class Cs extends Ln {
  /**
  Construct an attribute step.
  */
  constructor(l, n) {
    super(), this.attr = l, this.value = n;
  }
  apply(l) {
    let n = /* @__PURE__ */ Object.create(null);
    for (let u in l.attrs)
      n[u] = l.attrs[u];
    n[this.attr] = this.value;
    let t = l.type.create(n, l.content, l.marks);
    return tn.ok(t);
  }
  getMap() {
    return ne.empty;
  }
  invert(l) {
    return new Cs(this.attr, l.attrs[this.attr]);
  }
  map(l) {
    return this;
  }
  toJSON() {
    return { stepType: "docAttr", attr: this.attr, value: this.value };
  }
  static fromJSON(l, n) {
    if (typeof n.attr != "string")
      throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new Cs(n.attr, n.value);
  }
}
Ln.jsonID("docAttr", Cs);
let wi = class extends Error {
};
wi = function e(l) {
  let n = Error.call(this, l);
  return n.__proto__ = e.prototype, n;
};
wi.prototype = Object.create(Error.prototype);
wi.prototype.constructor = wi;
wi.prototype.name = "TransformError";
class Xv {
  /**
  Create a transform that starts with the given document.
  */
  constructor(l) {
    this.doc = l, this.steps = [], this.docs = [], this.mapping = new di();
  }
  /**
  The starting document.
  */
  get before() {
    return this.docs.length ? this.docs[0] : this.doc;
  }
  /**
  Apply a new step in this transform, saving the result. Throws an
  error when the step fails.
  */
  step(l) {
    let n = this.maybeStep(l);
    if (n.failed)
      throw new wi(n.failed);
    return this;
  }
  /**
  Try to apply a step in this transformation, ignoring it if it
  fails. Returns the step result.
  */
  maybeStep(l) {
    let n = l.apply(this.doc);
    return n.failed || this.addStep(l, n.doc), n;
  }
  /**
  True when the document has been changed (when there are any
  steps).
  */
  get docChanged() {
    return this.steps.length > 0;
  }
  /**
  @internal
  */
  addStep(l, n) {
    this.docs.push(this.doc), this.steps.push(l), this.mapping.appendMap(l.getMap()), this.doc = n;
  }
  /**
  Replace the part of the document between `from` and `to` with the
  given `slice`.
  */
  replace(l, n = l, t = nl.empty) {
    let u = ia(this.doc, l, n, t);
    return u && this.step(u), this;
  }
  /**
  Replace the given range with the given content, which may be a
  fragment, node, or array of nodes.
  */
  replaceWith(l, n, t) {
    return this.replace(l, n, new nl(j.from(t), 0, 0));
  }
  /**
  Delete the content between the given positions.
  */
  delete(l, n) {
    return this.replace(l, n, nl.empty);
  }
  /**
  Insert the given content at the given position.
  */
  insert(l, n) {
    return this.replaceWith(l, l, n);
  }
  /**
  Replace a range of the document with a given slice, using
  `from`, `to`, and the slice's
  [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
  than fixed start and end points. This method may grow the
  replaced area or close open nodes in the slice in order to get a
  fit that is more in line with WYSIWYG expectations, by dropping
  fully covered parent nodes of the replaced region when they are
  marked [non-defining as
  context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
  open parent node from the slice that _is_ marked as [defining
  its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
  
  This is the method, for example, to handle paste. The similar
  [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
  primitive tool which will _not_ move the start and end of its given
  range, and is useful in situations where you need more precise
  control over what happens.
  */
  replaceRange(l, n, t) {
    return MM(this, l, n, t), this;
  }
  /**
  Replace the given range with a node, but use `from` and `to` as
  hints, rather than precise positions. When from and to are the same
  and are at the start or end of a parent node in which the given
  node doesn't fit, this method may _move_ them out towards a parent
  that does allow the given node to be placed. When the given range
  completely covers a parent node, this method may completely replace
  that parent node.
  */
  replaceRangeWith(l, n, t) {
    return AM(this, l, n, t), this;
  }
  /**
  Delete the given range, expanding it to cover fully covered
  parent nodes until a valid replace is found.
  */
  deleteRange(l, n) {
    return xM(this, l, n), this;
  }
  /**
  Split the content in the given range off from its parent, if there
  is sibling content before or after it, and move it up the tree to
  the depth specified by `target`. You'll probably want to use
  [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
  sure the lift is valid.
  */
  lift(l, n) {
    return mM(this, l, n), this;
  }
  /**
  Join the blocks around the given position. If depth is 2, their
  last and first siblings are also joined, and so on.
  */
  join(l, n = 1) {
    return SM(this, l, n), this;
  }
  /**
  Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
  The wrappers are assumed to be valid in this position, and should
  probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
  */
  wrap(l, n) {
    return yM(this, l, n), this;
  }
  /**
  Set the type of all textblocks (partly) between `from` and `to` to
  the given node type with the given attributes.
  */
  setBlockType(l, n = l, t, u = null) {
    return $M(this, l, n, t, u), this;
  }
  /**
  Change the type, attributes, and/or marks of the node at `pos`.
  When `type` isn't given, the existing node type is preserved,
  */
  setNodeMarkup(l, n, t = null, u) {
    return wM(this, l, n, t, u), this;
  }
  /**
  Set a single attribute on a given node to a new value.
  The `pos` addresses the document content. Use `setDocAttribute`
  to set attributes on the document itself.
  */
  setNodeAttribute(l, n, t) {
    return this.step(new hi(l, n, t)), this;
  }
  /**
  Set a single attribute on the document to a new value.
  */
  setDocAttribute(l, n) {
    return this.step(new Cs(l, n)), this;
  }
  /**
  Add a mark to the node at position `pos`.
  */
  addNodeMark(l, n) {
    return this.step(new qt(l, n)), this;
  }
  /**
  Remove a mark (or a mark of the given type) from the node at
  position `pos`.
  */
  removeNodeMark(l, n) {
    if (!(n instanceof Vl)) {
      let t = this.doc.nodeAt(l);
      if (!t)
        throw new RangeError("No node at position " + l);
      if (n = n.isInSet(t.marks), !n)
        return this;
    }
    return this.step(new bi(l, n)), this;
  }
  /**
  Split the node at the given position, and optionally, if `depth` is
  greater than one, any number of nodes above that. By default, the
  parts split off will inherit the node type of the original node.
  This can be changed by passing an array of types and attributes to
  use after the split.
  */
  split(l, n = 1, t) {
    return _M(this, l, n, t), this;
  }
  /**
  Add the given mark to the inline content between `from` and `to`.
  */
  addMark(l, n, t) {
    return cM(this, l, n, t), this;
  }
  /**
  Remove marks from inline nodes between `from` and `to`. When
  `mark` is a single mark, remove precisely that mark. When it is
  a mark type, remove all marks of that type. When it is null,
  remove all marks of any type.
  */
  removeMark(l, n, t) {
    return hM(this, l, n, t), this;
  }
  /**
  Removes all marks and nodes from the content of the node at
  `pos` that don't match the given new parent node type. Accepts
  an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
  third argument.
  */
  clearIncompatible(l, n, t) {
    return pM(this, l, n, t), this;
  }
}
const _d = /* @__PURE__ */ Object.create(null);
class xl {
  /**
  Initialize a selection with the head and anchor and ranges. If no
  ranges are given, constructs a single range across `$anchor` and
  `$head`.
  */
  constructor(l, n, t) {
    this.$anchor = l, this.$head = n, this.ranges = t || [new EM(l.min(n), l.max(n))];
  }
  /**
  The selection's anchor, as an unresolved position.
  */
  get anchor() {
    return this.$anchor.pos;
  }
  /**
  The selection's head.
  */
  get head() {
    return this.$head.pos;
  }
  /**
  The lower bound of the selection's main range.
  */
  get from() {
    return this.$from.pos;
  }
  /**
  The upper bound of the selection's main range.
  */
  get to() {
    return this.$to.pos;
  }
  /**
  The resolved lower  bound of the selection's main range.
  */
  get $from() {
    return this.ranges[0].$from;
  }
  /**
  The resolved upper bound of the selection's main range.
  */
  get $to() {
    return this.ranges[0].$to;
  }
  /**
  Indicates whether the selection contains any content.
  */
  get empty() {
    let l = this.ranges;
    for (let n = 0; n < l.length; n++)
      if (l[n].$from.pos != l[n].$to.pos)
        return !1;
    return !0;
  }
  /**
  Get the content of this selection as a slice.
  */
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  /**
  Replace the selection with a slice or, if no slice is given,
  delete the selection. Will append to the given transaction.
  */
  replace(l, n = nl.empty) {
    let t = n.content.lastChild, u = null;
    for (let r = 0; r < n.openEnd; r++)
      u = t, t = t.lastChild;
    let i = l.steps.length, s = this.ranges;
    for (let r = 0; r < s.length; r++) {
      let { $from: o, $to: a } = s[r], d = l.mapping.slice(i);
      l.replaceRange(d.map(o.pos), d.map(a.pos), r ? nl.empty : n), r == 0 && mm(l, i, (t ? t.isInline : u && u.isTextblock) ? -1 : 1);
    }
  }
  /**
  Replace the selection with the given node, appending the changes
  to the given transaction.
  */
  replaceWith(l, n) {
    let t = l.steps.length, u = this.ranges;
    for (let i = 0; i < u.length; i++) {
      let { $from: s, $to: r } = u[i], o = l.mapping.slice(t), a = o.map(s.pos), d = o.map(r.pos);
      i ? l.deleteRange(a, d) : (l.replaceRangeWith(a, d, n), mm(l, t, n.isInline ? -1 : 1));
    }
  }
  /**
  Find a valid cursor or leaf node selection starting at the given
  position and searching back if `dir` is negative, and forward if
  positive. When `textOnly` is true, only consider cursor
  selections. Will return null when no valid selection position is
  found.
  */
  static findFrom(l, n, t = !1) {
    let u = l.parent.inlineContent ? new Cl(l) : Qu(l.node(0), l.parent, l.pos, l.index(), n, t);
    if (u)
      return u;
    for (let i = l.depth - 1; i >= 0; i--) {
      let s = n < 0 ? Qu(l.node(0), l.node(i), l.before(i + 1), l.index(i), n, t) : Qu(l.node(0), l.node(i), l.after(i + 1), l.index(i) + 1, n, t);
      if (s)
        return s;
    }
    return null;
  }
  /**
  Find a valid cursor or leaf node selection near the given
  position. Searches forward first by default, but if `bias` is
  negative, it will search backwards first.
  */
  static near(l, n = 1) {
    return this.findFrom(l, n) || this.findFrom(l, -n) || new Fe(l.node(0));
  }
  /**
  Find the cursor or leaf node selection closest to the start of
  the given document. Will return an
  [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
  exists.
  */
  static atStart(l) {
    return Qu(l, l, 0, 0, 1) || new Fe(l);
  }
  /**
  Find the cursor or leaf node selection closest to the end of the
  given document.
  */
  static atEnd(l) {
    return Qu(l, l, l.content.size, l.childCount, -1) || new Fe(l);
  }
  /**
  Deserialize the JSON representation of a selection. Must be
  implemented for custom classes (as a static class method).
  */
  static fromJSON(l, n) {
    if (!n || !n.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let t = _d[n.type];
    if (!t)
      throw new RangeError(`No selection type ${n.type} defined`);
    return t.fromJSON(l, n);
  }
  /**
  To be able to deserialize selections from JSON, custom selection
  classes must register themselves with an ID string, so that they
  can be disambiguated. Try to pick something that's unlikely to
  clash with classes from other modules.
  */
  static jsonID(l, n) {
    if (l in _d)
      throw new RangeError("Duplicate use of selection JSON ID " + l);
    return _d[l] = n, n.prototype.jsonID = l, n;
  }
  /**
  Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
  which is a value that can be mapped without having access to a
  current document, and later resolved to a real selection for a
  given document again. (This is used mostly by the history to
  track and restore old selections.) The default implementation of
  this method just converts the selection to a text selection and
  returns the bookmark for that.
  */
  getBookmark() {
    return Cl.between(this.$anchor, this.$head).getBookmark();
  }
}
xl.prototype.visible = !0;
class EM {
  /**
  Create a range.
  */
  constructor(l, n) {
    this.$from = l, this.$to = n;
  }
}
let pm = !1;
function fm(e) {
  !pm && !e.parent.inlineContent && (pm = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + e.parent.type.name + ")"));
}
class Cl extends xl {
  /**
  Construct a text selection between the given points.
  */
  constructor(l, n = l) {
    fm(l), fm(n), super(l, n);
  }
  /**
  Returns a resolved position if this is a cursor selection (an
  empty text selection), and null otherwise.
  */
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(l, n) {
    let t = l.resolve(n.map(this.head));
    if (!t.parent.inlineContent)
      return xl.near(t);
    let u = l.resolve(n.map(this.anchor));
    return new Cl(u.parent.inlineContent ? u : t, t);
  }
  replace(l, n = nl.empty) {
    if (super.replace(l, n), n == nl.empty) {
      let t = this.$from.marksAcross(this.$to);
      t && l.ensureMarks(t);
    }
  }
  eq(l) {
    return l instanceof Cl && l.anchor == this.anchor && l.head == this.head;
  }
  getBookmark() {
    return new sa(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  /**
  @internal
  */
  static fromJSON(l, n) {
    if (typeof n.anchor != "number" || typeof n.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new Cl(l.resolve(n.anchor), l.resolve(n.head));
  }
  /**
  Create a text selection from non-resolved positions.
  */
  static create(l, n, t = n) {
    let u = l.resolve(n);
    return new this(u, t == n ? u : l.resolve(t));
  }
  /**
  Return a text selection that spans the given positions or, if
  they aren't text positions, find a text selection near them.
  `bias` determines whether the method searches forward (default)
  or backwards (negative number) first. Will fall back to calling
  [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
  doesn't contain a valid text position.
  */
  static between(l, n, t) {
    let u = l.pos - n.pos;
    if ((!t || u) && (t = u >= 0 ? 1 : -1), !n.parent.inlineContent) {
      let i = xl.findFrom(n, t, !0) || xl.findFrom(n, -t, !0);
      if (i)
        n = i.$head;
      else
        return xl.near(n, t);
    }
    return l.parent.inlineContent || (u == 0 ? l = n : (l = (xl.findFrom(l, -t, !0) || xl.findFrom(l, t, !0)).$anchor, l.pos < n.pos != u < 0 && (l = n))), new Cl(l, n);
  }
}
xl.jsonID("text", Cl);
class sa {
  constructor(l, n) {
    this.anchor = l, this.head = n;
  }
  map(l) {
    return new sa(l.map(this.anchor), l.map(this.head));
  }
  resolve(l) {
    return Cl.between(l.resolve(this.anchor), l.resolve(this.head));
  }
}
class pl extends xl {
  /**
  Create a node selection. Does not verify the validity of its
  argument.
  */
  constructor(l) {
    let n = l.nodeAfter, t = l.node(0).resolve(l.pos + n.nodeSize);
    super(l, t), this.node = n;
  }
  map(l, n) {
    let { deleted: t, pos: u } = n.mapResult(this.anchor), i = l.resolve(u);
    return t ? xl.near(i) : new pl(i);
  }
  content() {
    return new nl(j.from(this.node), 0, 0);
  }
  eq(l) {
    return l instanceof pl && l.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new Vf(this.anchor);
  }
  /**
  @internal
  */
  static fromJSON(l, n) {
    if (typeof n.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new pl(l.resolve(n.anchor));
  }
  /**
  Create a node selection from non-resolved positions.
  */
  static create(l, n) {
    return new pl(l.resolve(n));
  }
  /**
  Determines whether the given node may be selected as a node
  selection.
  */
  static isSelectable(l) {
    return !l.isText && l.type.spec.selectable !== !1;
  }
}
pl.prototype.visible = !1;
xl.jsonID("node", pl);
class Vf {
  constructor(l) {
    this.anchor = l;
  }
  map(l) {
    let { deleted: n, pos: t } = l.mapResult(this.anchor);
    return n ? new sa(t, t) : new Vf(t);
  }
  resolve(l) {
    let n = l.resolve(this.anchor), t = n.nodeAfter;
    return t && pl.isSelectable(t) ? new pl(n) : xl.near(n);
  }
}
class Fe extends xl {
  /**
  Create an all-selection over the given document.
  */
  constructor(l) {
    super(l.resolve(0), l.resolve(l.content.size));
  }
  replace(l, n = nl.empty) {
    if (n == nl.empty) {
      l.delete(0, l.doc.content.size);
      let t = xl.atStart(l.doc);
      t.eq(l.selection) || l.setSelection(t);
    } else
      super.replace(l, n);
  }
  toJSON() {
    return { type: "all" };
  }
  /**
  @internal
  */
  static fromJSON(l) {
    return new Fe(l);
  }
  map(l) {
    return new Fe(l);
  }
  eq(l) {
    return l instanceof Fe;
  }
  getBookmark() {
    return IM;
  }
}
xl.jsonID("all", Fe);
const IM = {
  map() {
    return this;
  },
  resolve(e) {
    return new Fe(e);
  }
};
function Qu(e, l, n, t, u, i = !1) {
  if (l.inlineContent)
    return Cl.create(e, n);
  for (let s = t - (u > 0 ? 0 : 1); u > 0 ? s < l.childCount : s >= 0; s += u) {
    let r = l.child(s);
    if (r.isAtom) {
      if (!i && pl.isSelectable(r))
        return pl.create(e, n - (u < 0 ? r.nodeSize : 0));
    } else {
      let o = Qu(e, r, n + u, u < 0 ? r.childCount : 0, u, i);
      if (o)
        return o;
    }
    n += r.nodeSize * u;
  }
  return null;
}
function mm(e, l, n) {
  let t = e.steps.length - 1;
  if (t < l)
    return;
  let u = e.steps[t];
  if (!(u instanceof dn || u instanceof hn))
    return;
  let i = e.mapping.maps[t], s;
  i.forEach((r, o, a, d) => {
    s == null && (s = d);
  }), e.setSelection(xl.near(e.doc.resolve(s), n));
}
const gm = 1, sr = 2, vm = 4;
class RM extends Xv {
  /**
  @internal
  */
  constructor(l) {
    super(l.doc), this.curSelectionFor = 0, this.updated = 0, this.meta = /* @__PURE__ */ Object.create(null), this.time = Date.now(), this.curSelection = l.selection, this.storedMarks = l.storedMarks;
  }
  /**
  The transaction's current selection. This defaults to the editor
  selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
  transaction, but can be overwritten with
  [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
  */
  get selection() {
    return this.curSelectionFor < this.steps.length && (this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor)), this.curSelectionFor = this.steps.length), this.curSelection;
  }
  /**
  Update the transaction's current selection. Will determine the
  selection that the editor gets when the transaction is applied.
  */
  setSelection(l) {
    if (l.$from.doc != this.doc)
      throw new RangeError("Selection passed to setSelection must point at the current document");
    return this.curSelection = l, this.curSelectionFor = this.steps.length, this.updated = (this.updated | gm) & ~sr, this.storedMarks = null, this;
  }
  /**
  Whether the selection was explicitly updated by this transaction.
  */
  get selectionSet() {
    return (this.updated & gm) > 0;
  }
  /**
  Set the current stored marks.
  */
  setStoredMarks(l) {
    return this.storedMarks = l, this.updated |= sr, this;
  }
  /**
  Make sure the current stored marks or, if that is null, the marks
  at the selection, match the given set of marks. Does nothing if
  this is already the case.
  */
  ensureMarks(l) {
    return Vl.sameSet(this.storedMarks || this.selection.$from.marks(), l) || this.setStoredMarks(l), this;
  }
  /**
  Add a mark to the set of stored marks.
  */
  addStoredMark(l) {
    return this.ensureMarks(l.addToSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Remove a mark or mark type from the set of stored marks.
  */
  removeStoredMark(l) {
    return this.ensureMarks(l.removeFromSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Whether the stored marks were explicitly set for this transaction.
  */
  get storedMarksSet() {
    return (this.updated & sr) > 0;
  }
  /**
  @internal
  */
  addStep(l, n) {
    super.addStep(l, n), this.updated = this.updated & ~sr, this.storedMarks = null;
  }
  /**
  Update the timestamp for the transaction.
  */
  setTime(l) {
    return this.time = l, this;
  }
  /**
  Replace the current selection with the given slice.
  */
  replaceSelection(l) {
    return this.selection.replace(this, l), this;
  }
  /**
  Replace the selection with the given node. When `inheritMarks` is
  true and the content is inline, it inherits the marks from the
  place where it is inserted.
  */
  replaceSelectionWith(l, n = !0) {
    let t = this.selection;
    return n && (l = l.mark(this.storedMarks || (t.empty ? t.$from.marks() : t.$from.marksAcross(t.$to) || Vl.none))), t.replaceWith(this, l), this;
  }
  /**
  Delete the selection.
  */
  deleteSelection() {
    return this.selection.replace(this), this;
  }
  /**
  Replace the given range, or the selection if no range is given,
  with a text node containing the given string.
  */
  insertText(l, n, t) {
    let u = this.doc.type.schema;
    if (n == null)
      return l ? this.replaceSelectionWith(u.text(l), !0) : this.deleteSelection();
    {
      if (t == null && (t = n), t = t ?? n, !l)
        return this.deleteRange(n, t);
      let i = this.storedMarks;
      if (!i) {
        let s = this.doc.resolve(n);
        i = t == n ? s.marks() : s.marksAcross(this.doc.resolve(t));
      }
      return this.replaceRangeWith(n, t, u.text(l, i)), this.selection.empty || this.setSelection(xl.near(this.selection.$to)), this;
    }
  }
  /**
  Store a metadata property in this transaction, keyed either by
  name or by plugin.
  */
  setMeta(l, n) {
    return this.meta[typeof l == "string" ? l : l.key] = n, this;
  }
  /**
  Retrieve a metadata property for a given name or plugin.
  */
  getMeta(l) {
    return this.meta[typeof l == "string" ? l : l.key];
  }
  /**
  Returns true if this transaction doesn't contain any metadata,
  and can thus safely be extended.
  */
  get isGeneric() {
    for (let l in this.meta)
      return !1;
    return !0;
  }
  /**
  Indicate that the editor should scroll the selection into view
  when updated to the state produced by this transaction.
  */
  scrollIntoView() {
    return this.updated |= vm, this;
  }
  /**
  True when this transaction has had `scrollIntoView` called on it.
  */
  get scrolledIntoView() {
    return (this.updated & vm) > 0;
  }
}
function ym(e, l) {
  return !l || !e ? e : e.bind(l);
}
class Ui {
  constructor(l, n, t) {
    this.name = l, this.init = ym(n.init, t), this.apply = ym(n.apply, t);
  }
}
const DM = [
  new Ui("doc", {
    init(e) {
      return e.doc || e.schema.topNodeType.createAndFill();
    },
    apply(e) {
      return e.doc;
    }
  }),
  new Ui("selection", {
    init(e, l) {
      return e.selection || xl.atStart(l.doc);
    },
    apply(e) {
      return e.selection;
    }
  }),
  new Ui("storedMarks", {
    init(e) {
      return e.storedMarks || null;
    },
    apply(e, l, n, t) {
      return t.selection.$cursor ? e.storedMarks : null;
    }
  }),
  new Ui("scrollToSelection", {
    init() {
      return 0;
    },
    apply(e, l) {
      return e.scrolledIntoView ? l + 1 : l;
    }
  })
];
class Sd {
  constructor(l, n) {
    this.schema = l, this.plugins = [], this.pluginsByKey = /* @__PURE__ */ Object.create(null), this.fields = DM.slice(), n && n.forEach((t) => {
      if (this.pluginsByKey[t.key])
        throw new RangeError("Adding different instances of a keyed plugin (" + t.key + ")");
      this.plugins.push(t), this.pluginsByKey[t.key] = t, t.spec.state && this.fields.push(new Ui(t.key, t.spec.state, t));
    });
  }
}
class ti {
  /**
  @internal
  */
  constructor(l) {
    this.config = l;
  }
  /**
  The schema of the state's document.
  */
  get schema() {
    return this.config.schema;
  }
  /**
  The plugins that are active in this state.
  */
  get plugins() {
    return this.config.plugins;
  }
  /**
  Apply the given transaction to produce a new state.
  */
  apply(l) {
    return this.applyTransaction(l).state;
  }
  /**
  @internal
  */
  filterTransaction(l, n = -1) {
    for (let t = 0; t < this.config.plugins.length; t++)
      if (t != n) {
        let u = this.config.plugins[t];
        if (u.spec.filterTransaction && !u.spec.filterTransaction.call(u, l, this))
          return !1;
      }
    return !0;
  }
  /**
  Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
  returns the precise transactions that were applied (which might
  be influenced by the [transaction
  hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
  plugins) along with the new state.
  */
  applyTransaction(l) {
    if (!this.filterTransaction(l))
      return { state: this, transactions: [] };
    let n = [l], t = this.applyInner(l), u = null;
    for (; ; ) {
      let i = !1;
      for (let s = 0; s < this.config.plugins.length; s++) {
        let r = this.config.plugins[s];
        if (r.spec.appendTransaction) {
          let o = u ? u[s].n : 0, a = u ? u[s].state : this, d = o < n.length && r.spec.appendTransaction.call(r, o ? n.slice(o) : n, a, t);
          if (d && t.filterTransaction(d, s)) {
            if (d.setMeta("appendedTransaction", l), !u) {
              u = [];
              for (let h = 0; h < this.config.plugins.length; h++)
                u.push(h < s ? { state: t, n: n.length } : { state: this, n: 0 });
            }
            n.push(d), t = t.applyInner(d), i = !0;
          }
          u && (u[s] = { state: t, n: n.length });
        }
      }
      if (!i)
        return { state: t, transactions: n };
    }
  }
  /**
  @internal
  */
  applyInner(l) {
    if (!l.before.eq(this.doc))
      throw new RangeError("Applying a mismatched transaction");
    let n = new ti(this.config), t = this.config.fields;
    for (let u = 0; u < t.length; u++) {
      let i = t[u];
      n[i.name] = i.apply(l, this[i.name], this, n);
    }
    return n;
  }
  /**
  Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
  */
  get tr() {
    return new RM(this);
  }
  /**
  Create a new state.
  */
  static create(l) {
    let n = new Sd(l.doc ? l.doc.type.schema : l.schema, l.plugins), t = new ti(n);
    for (let u = 0; u < n.fields.length; u++)
      t[n.fields[u].name] = n.fields[u].init(l, t);
    return t;
  }
  /**
  Create a new state based on this one, but with an adjusted set
  of active plugins. State fields that exist in both sets of
  plugins are kept unchanged. Those that no longer exist are
  dropped, and those that are new are initialized using their
  [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
  configuration object..
  */
  reconfigure(l) {
    let n = new Sd(this.schema, l.plugins), t = n.fields, u = new ti(n);
    for (let i = 0; i < t.length; i++) {
      let s = t[i].name;
      u[s] = this.hasOwnProperty(s) ? this[s] : t[i].init(l, u);
    }
    return u;
  }
  /**
  Serialize this state to JSON. If you want to serialize the state
  of plugins, pass an object mapping property names to use in the
  resulting JSON object to plugin objects. The argument may also be
  a string or number, in which case it is ignored, to support the
  way `JSON.stringify` calls `toString` methods.
  */
  toJSON(l) {
    let n = { doc: this.doc.toJSON(), selection: this.selection.toJSON() };
    if (this.storedMarks && (n.storedMarks = this.storedMarks.map((t) => t.toJSON())), l && typeof l == "object")
      for (let t in l) {
        if (t == "doc" || t == "selection")
          throw new RangeError("The JSON fields `doc` and `selection` are reserved");
        let u = l[t], i = u.spec.state;
        i && i.toJSON && (n[t] = i.toJSON.call(u, this[u.key]));
      }
    return n;
  }
  /**
  Deserialize a JSON representation of a state. `config` should
  have at least a `schema` field, and should contain array of
  plugins to initialize the state with. `pluginFields` can be used
  to deserialize the state of plugins, by associating plugin
  instances with the property names they use in the JSON object.
  */
  static fromJSON(l, n, t) {
    if (!n)
      throw new RangeError("Invalid input for EditorState.fromJSON");
    if (!l.schema)
      throw new RangeError("Required config field 'schema' missing");
    let u = new Sd(l.schema, l.plugins), i = new ti(u);
    return u.fields.forEach((s) => {
      if (s.name == "doc")
        i.doc = Au.fromJSON(l.schema, n.doc);
      else if (s.name == "selection")
        i.selection = xl.fromJSON(i.doc, n.selection);
      else if (s.name == "storedMarks")
        n.storedMarks && (i.storedMarks = n.storedMarks.map(l.schema.markFromJSON));
      else {
        if (t)
          for (let r in t) {
            let o = t[r], a = o.spec.state;
            if (o.key == s.name && a && a.fromJSON && Object.prototype.hasOwnProperty.call(n, r)) {
              i[s.name] = a.fromJSON.call(o, l, n[r], i);
              return;
            }
          }
        i[s.name] = s.init(l, i);
      }
    }), i;
  }
}
function Qv(e, l, n) {
  for (let t in e) {
    let u = e[t];
    u instanceof Function ? u = u.bind(l) : t == "handleDOMEvents" && (u = Qv(u, l, {})), n[t] = u;
  }
  return n;
}
class On {
  /**
  Create a plugin.
  */
  constructor(l) {
    this.spec = l, this.props = {}, l.props && Qv(l.props, this, this.props), this.key = l.key ? l.key.key : l4("plugin");
  }
  /**
  Extract the plugin's state field from an editor state.
  */
  getState(l) {
    return l[this.key];
  }
}
const Cd = /* @__PURE__ */ Object.create(null);
function l4(e) {
  return e in Cd ? e + "$" + ++Cd[e] : (Cd[e] = 0, e + "$");
}
class se {
  /**
  Create a plugin key.
  */
  constructor(l = "key") {
    this.key = l4(l);
  }
  /**
  Get the active plugin with this key, if any, from an editor
  state.
  */
  get(l) {
    return l.config.pluginsByKey[this.key];
  }
  /**
  Get the plugin's state from an editor state.
  */
  getState(l) {
    return l[this.key];
  }
}
const zn = function(e) {
  for (var l = 0; ; l++)
    if (e = e.previousSibling, !e)
      return l;
}, Ts = function(e) {
  let l = e.assignedSlot || e.parentNode;
  return l && l.nodeType == 11 ? l.host : l;
};
let $m = null;
const Tt = function(e, l, n) {
  let t = $m || ($m = document.createRange());
  return t.setEnd(e, n ?? e.nodeValue.length), t.setStart(e, l || 0), t;
}, Pu = function(e, l, n, t) {
  return n && (bm(e, l, n, t, -1) || bm(e, l, n, t, 1));
}, NM = /^(img|br|input|textarea|hr)$/i;
function bm(e, l, n, t, u) {
  for (; ; ) {
    if (e == n && l == t)
      return !0;
    if (l == (u < 0 ? 0 : et(e))) {
      let i = e.parentNode;
      if (!i || i.nodeType != 1 || jf(e) || NM.test(e.nodeName) || e.contentEditable == "false")
        return !1;
      l = zn(e) + (u < 0 ? 0 : 1), e = i;
    } else if (e.nodeType == 1) {
      if (e = e.childNodes[l + (u < 0 ? -1 : 0)], e.contentEditable == "false")
        return !1;
      l = u < 0 ? et(e) : 0;
    } else
      return !1;
  }
}
function et(e) {
  return e.nodeType == 3 ? e.nodeValue.length : e.childNodes.length;
}
function LM(e, l, n) {
  for (let t = l == 0, u = l == et(e); t || u; ) {
    if (e == n)
      return !0;
    let i = zn(e);
    if (e = e.parentNode, !e)
      return !1;
    t = t && i == 0, u = u && i == et(e);
  }
}
function jf(e) {
  let l;
  for (let n = e; n && !(l = n.pmViewDesc); n = n.parentNode)
    ;
  return l && l.node && l.node.isBlock && (l.dom == e || l.contentDOM == e);
}
const ra = function(e) {
  return e.focusNode && Pu(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset);
};
function $u(e, l) {
  let n = document.createEvent("Event");
  return n.initEvent("keydown", !0, !0), n.keyCode = e, n.key = n.code = l, n;
}
function PM(e) {
  let l = e.activeElement;
  for (; l && l.shadowRoot; )
    l = l.shadowRoot.activeElement;
  return l;
}
function BM(e, l, n) {
  if (e.caretPositionFromPoint)
    try {
      let t = e.caretPositionFromPoint(l, n);
      if (t)
        return { node: t.offsetNode, offset: t.offset };
    } catch {
    }
  if (e.caretRangeFromPoint) {
    let t = e.caretRangeFromPoint(l, n);
    if (t)
      return { node: t.startContainer, offset: t.startOffset };
  }
}
const gt = typeof navigator < "u" ? navigator : null, wm = typeof document < "u" ? document : null, ou = gt && gt.userAgent || "", Ph = /Edge\/(\d+)/.exec(ou), n4 = /MSIE \d/.exec(ou), Bh = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(ou), Zn = !!(n4 || Bh || Ph), Xt = n4 ? document.documentMode : Bh ? +Bh[1] : Ph ? +Ph[1] : 0, He = !Zn && /gecko\/(\d+)/i.test(ou);
He && +(/Firefox\/(\d+)/.exec(ou) || [0, 0])[1];
const Fh = !Zn && /Chrome\/(\d+)/.exec(ou), Rn = !!Fh, FM = Fh ? +Fh[1] : 0, jn = !Zn && !!gt && /Apple Computer/.test(gt.vendor), _i = jn && (/Mobile\/\w+/.test(ou) || !!gt && gt.maxTouchPoints > 2), fe = _i || (gt ? /Mac/.test(gt.platform) : !1), HM = gt ? /Win/.test(gt.platform) : !1, xe = /Android \d/.test(ou), Hs = !!wm && "webkitFontSmoothing" in wm.documentElement.style, zM = Hs ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function VM(e) {
  return {
    left: 0,
    right: e.documentElement.clientWidth,
    top: 0,
    bottom: e.documentElement.clientHeight
  };
}
function St(e, l) {
  return typeof e == "number" ? e : e[l];
}
function jM(e) {
  let l = e.getBoundingClientRect(), n = l.width / e.offsetWidth || 1, t = l.height / e.offsetHeight || 1;
  return {
    left: l.left,
    right: l.left + e.clientWidth * n,
    top: l.top,
    bottom: l.top + e.clientHeight * t
  };
}
function _m(e, l, n) {
  let t = e.someProp("scrollThreshold") || 0, u = e.someProp("scrollMargin") || 5, i = e.dom.ownerDocument;
  for (let s = n || e.dom; s; s = Ts(s)) {
    if (s.nodeType != 1)
      continue;
    let r = s, o = r == i.body, a = o ? VM(i) : jM(r), d = 0, h = 0;
    if (l.top < a.top + St(t, "top") ? h = -(a.top - l.top + St(u, "top")) : l.bottom > a.bottom - St(t, "bottom") && (h = l.bottom - l.top > a.bottom - a.top ? l.top + St(u, "top") - a.top : l.bottom - a.bottom + St(u, "bottom")), l.left < a.left + St(t, "left") ? d = -(a.left - l.left + St(u, "left")) : l.right > a.right - St(t, "right") && (d = l.right - a.right + St(u, "right")), d || h)
      if (o)
        i.defaultView.scrollBy(d, h);
      else {
        let p = r.scrollLeft, f = r.scrollTop;
        h && (r.scrollTop += h), d && (r.scrollLeft += d);
        let m = r.scrollLeft - p, g = r.scrollTop - f;
        l = { left: l.left - m, top: l.top - g, right: l.right - m, bottom: l.bottom - g };
      }
    if (o || /^(fixed|sticky)$/.test(getComputedStyle(s).position))
      break;
  }
}
function UM(e) {
  let l = e.dom.getBoundingClientRect(), n = Math.max(0, l.top), t, u;
  for (let i = (l.left + l.right) / 2, s = n + 1; s < Math.min(innerHeight, l.bottom); s += 5) {
    let r = e.root.elementFromPoint(i, s);
    if (!r || r == e.dom || !e.dom.contains(r))
      continue;
    let o = r.getBoundingClientRect();
    if (o.top >= n - 20) {
      t = r, u = o.top;
      break;
    }
  }
  return { refDOM: t, refTop: u, stack: e4(e.dom) };
}
function e4(e) {
  let l = [], n = e.ownerDocument;
  for (let t = e; t && (l.push({ dom: t, top: t.scrollTop, left: t.scrollLeft }), e != n); t = Ts(t))
    ;
  return l;
}
function WM({ refDOM: e, refTop: l, stack: n }) {
  let t = e ? e.getBoundingClientRect().top : 0;
  t4(n, t == 0 ? 0 : t - l);
}
function t4(e, l) {
  for (let n = 0; n < e.length; n++) {
    let { dom: t, top: u, left: i } = e[n];
    t.scrollTop != u + l && (t.scrollTop = u + l), t.scrollLeft != i && (t.scrollLeft = i);
  }
}
let Yu = null;
function GM(e) {
  if (e.setActive)
    return e.setActive();
  if (Yu)
    return e.focus(Yu);
  let l = e4(e);
  e.focus(Yu == null ? {
    get preventScroll() {
      return Yu = { preventScroll: !0 }, !0;
    }
  } : void 0), Yu || (Yu = !1, t4(l, 0));
}
function u4(e, l) {
  let n, t = 2e8, u, i = 0, s = l.top, r = l.top, o, a;
  for (let d = e.firstChild, h = 0; d; d = d.nextSibling, h++) {
    let p;
    if (d.nodeType == 1)
      p = d.getClientRects();
    else if (d.nodeType == 3)
      p = Tt(d).getClientRects();
    else
      continue;
    for (let f = 0; f < p.length; f++) {
      let m = p[f];
      if (m.top <= s && m.bottom >= r) {
        s = Math.max(m.bottom, s), r = Math.min(m.top, r);
        let g = m.left > l.left ? m.left - l.left : m.right < l.left ? l.left - m.right : 0;
        if (g < t) {
          n = d, t = g, u = g && n.nodeType == 3 ? {
            left: m.right < l.left ? m.right : m.left,
            top: l.top
          } : l, d.nodeType == 1 && g && (i = h + (l.left >= (m.left + m.right) / 2 ? 1 : 0));
          continue;
        }
      } else
        m.top > l.top && !o && m.left <= l.left && m.right >= l.left && (o = d, a = { left: Math.max(m.left, Math.min(m.right, l.left)), top: m.top });
      !n && (l.left >= m.right && l.top >= m.top || l.left >= m.left && l.top >= m.bottom) && (i = h + 1);
    }
  }
  return !n && o && (n = o, u = a, t = 0), n && n.nodeType == 3 ? KM(n, u) : !n || t && n.nodeType == 1 ? { node: e, offset: i } : u4(n, u);
}
function KM(e, l) {
  let n = e.nodeValue.length, t = document.createRange();
  for (let u = 0; u < n; u++) {
    t.setEnd(e, u + 1), t.setStart(e, u);
    let i = Ft(t, 1);
    if (i.top != i.bottom && Uf(l, i))
      return { node: e, offset: u + (l.left >= (i.left + i.right) / 2 ? 1 : 0) };
  }
  return { node: e, offset: 0 };
}
function Uf(e, l) {
  return e.left >= l.left - 1 && e.left <= l.right + 1 && e.top >= l.top - 1 && e.top <= l.bottom + 1;
}
function YM(e, l) {
  let n = e.parentNode;
  return n && /^li$/i.test(n.nodeName) && l.left < e.getBoundingClientRect().left ? n : e;
}
function qM(e, l, n) {
  let { node: t, offset: u } = u4(l, n), i = -1;
  if (t.nodeType == 1 && !t.firstChild) {
    let s = t.getBoundingClientRect();
    i = s.left != s.right && n.left > (s.left + s.right) / 2 ? 1 : -1;
  }
  return e.docView.posFromDOM(t, u, i);
}
function JM(e, l, n, t) {
  let u = -1;
  for (let i = l, s = !1; i != e.dom; ) {
    let r = e.docView.nearestDesc(i, !0);
    if (!r)
      return null;
    if (r.dom.nodeType == 1 && (r.node.isBlock && r.parent && !s || !r.contentDOM)) {
      let o = r.dom.getBoundingClientRect();
      if (r.node.isBlock && r.parent && !s && (s = !0, o.left > t.left || o.top > t.top ? u = r.posBefore : (o.right < t.left || o.bottom < t.top) && (u = r.posAfter)), !r.contentDOM && u < 0 && !r.node.isText)
        return (r.node.isBlock ? t.top < (o.top + o.bottom) / 2 : t.left < (o.left + o.right) / 2) ? r.posBefore : r.posAfter;
    }
    i = r.dom.parentNode;
  }
  return u > -1 ? u : e.docView.posFromDOM(l, n, -1);
}
function i4(e, l, n) {
  let t = e.childNodes.length;
  if (t && n.top < n.bottom)
    for (let u = Math.max(0, Math.min(t - 1, Math.floor(t * (l.top - n.top) / (n.bottom - n.top)) - 2)), i = u; ; ) {
      let s = e.childNodes[i];
      if (s.nodeType == 1) {
        let r = s.getClientRects();
        for (let o = 0; o < r.length; o++) {
          let a = r[o];
          if (Uf(l, a))
            return i4(s, l, a);
        }
      }
      if ((i = (i + 1) % t) == u)
        break;
    }
  return e;
}
function ZM(e, l) {
  let n = e.dom.ownerDocument, t, u = 0, i = BM(n, l.left, l.top);
  i && ({ node: t, offset: u } = i);
  let s = (e.root.elementFromPoint ? e.root : n).elementFromPoint(l.left, l.top), r;
  if (!s || !e.dom.contains(s.nodeType != 1 ? s.parentNode : s)) {
    let a = e.dom.getBoundingClientRect();
    if (!Uf(l, a) || (s = i4(e.dom, l, a), !s))
      return null;
  }
  if (jn)
    for (let a = s; t && a; a = Ts(a))
      a.draggable && (t = void 0);
  if (s = YM(s, l), t) {
    if (He && t.nodeType == 1 && (u = Math.min(u, t.childNodes.length), u < t.childNodes.length)) {
      let d = t.childNodes[u], h;
      d.nodeName == "IMG" && (h = d.getBoundingClientRect()).right <= l.left && h.bottom > l.top && u++;
    }
    let a;
    Hs && u && t.nodeType == 1 && (a = t.childNodes[u - 1]).nodeType == 1 && a.contentEditable == "false" && a.getBoundingClientRect().top >= l.top && u--, t == e.dom && u == t.childNodes.length - 1 && t.lastChild.nodeType == 1 && l.top > t.lastChild.getBoundingClientRect().bottom ? r = e.state.doc.content.size : (u == 0 || t.nodeType != 1 || t.childNodes[u - 1].nodeName != "BR") && (r = JM(e, t, u, l));
  }
  r == null && (r = qM(e, s, l));
  let o = e.docView.nearestDesc(s, !0);
  return { pos: r, inside: o ? o.posAtStart - o.border : -1 };
}
function Sm(e) {
  return e.top < e.bottom || e.left < e.right;
}
function Ft(e, l) {
  let n = e.getClientRects();
  if (n.length) {
    let t = n[l < 0 ? 0 : n.length - 1];
    if (Sm(t))
      return t;
  }
  return Array.prototype.find.call(n, Sm) || e.getBoundingClientRect();
}
const XM = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function s4(e, l, n) {
  let { node: t, offset: u, atom: i } = e.docView.domFromPos(l, n < 0 ? -1 : 1), s = Hs || He;
  if (t.nodeType == 3)
    if (s && (XM.test(t.nodeValue) || (n < 0 ? !u : u == t.nodeValue.length))) {
      let o = Ft(Tt(t, u, u), n);
      if (He && u && /\s/.test(t.nodeValue[u - 1]) && u < t.nodeValue.length) {
        let a = Ft(Tt(t, u - 1, u - 1), -1);
        if (a.top == o.top) {
          let d = Ft(Tt(t, u, u + 1), -1);
          if (d.top != o.top)
            return Hi(d, d.left < a.left);
        }
      }
      return o;
    } else {
      let o = u, a = u, d = n < 0 ? 1 : -1;
      return n < 0 && !u ? (a++, d = -1) : n >= 0 && u == t.nodeValue.length ? (o--, d = 1) : n < 0 ? o-- : a++, Hi(Ft(Tt(t, o, a), d), d < 0);
    }
  if (!e.state.doc.resolve(l - (i || 0)).parent.inlineContent) {
    if (i == null && u && (n < 0 || u == et(t))) {
      let o = t.childNodes[u - 1];
      if (o.nodeType == 1)
        return Td(o.getBoundingClientRect(), !1);
    }
    if (i == null && u < et(t)) {
      let o = t.childNodes[u];
      if (o.nodeType == 1)
        return Td(o.getBoundingClientRect(), !0);
    }
    return Td(t.getBoundingClientRect(), n >= 0);
  }
  if (i == null && u && (n < 0 || u == et(t))) {
    let o = t.childNodes[u - 1], a = o.nodeType == 3 ? Tt(o, et(o) - (s ? 0 : 1)) : o.nodeType == 1 && (o.nodeName != "BR" || !o.nextSibling) ? o : null;
    if (a)
      return Hi(Ft(a, 1), !1);
  }
  if (i == null && u < et(t)) {
    let o = t.childNodes[u];
    for (; o.pmViewDesc && o.pmViewDesc.ignoreForCoords; )
      o = o.nextSibling;
    let a = o ? o.nodeType == 3 ? Tt(o, 0, s ? 0 : 1) : o.nodeType == 1 ? o : null : null;
    if (a)
      return Hi(Ft(a, -1), !0);
  }
  return Hi(Ft(t.nodeType == 3 ? Tt(t) : t, -n), n >= 0);
}
function Hi(e, l) {
  if (e.width == 0)
    return e;
  let n = l ? e.left : e.right;
  return { top: e.top, bottom: e.bottom, left: n, right: n };
}
function Td(e, l) {
  if (e.height == 0)
    return e;
  let n = l ? e.top : e.bottom;
  return { top: n, bottom: n, left: e.left, right: e.right };
}
function r4(e, l, n) {
  let t = e.state, u = e.root.activeElement;
  t != l && e.updateState(l), u != e.dom && e.focus();
  try {
    return n();
  } finally {
    t != l && e.updateState(t), u != e.dom && u && u.focus();
  }
}
function QM(e, l, n) {
  let t = l.selection, u = n == "up" ? t.$from : t.$to;
  return r4(e, l, () => {
    let { node: i } = e.docView.domFromPos(u.pos, n == "up" ? -1 : 1);
    for (; ; ) {
      let r = e.docView.nearestDesc(i, !0);
      if (!r)
        break;
      if (r.node.isBlock) {
        i = r.contentDOM || r.dom;
        break;
      }
      i = r.dom.parentNode;
    }
    let s = s4(e, u.pos, 1);
    for (let r = i.firstChild; r; r = r.nextSibling) {
      let o;
      if (r.nodeType == 1)
        o = r.getClientRects();
      else if (r.nodeType == 3)
        o = Tt(r, 0, r.nodeValue.length).getClientRects();
      else
        continue;
      for (let a = 0; a < o.length; a++) {
        let d = o[a];
        if (d.bottom > d.top + 1 && (n == "up" ? s.top - d.top > (d.bottom - s.top) * 2 : d.bottom - s.bottom > (s.bottom - d.top) * 2))
          return !1;
      }
    }
    return !0;
  });
}
const lA = /[\u0590-\u08ac]/;
function nA(e, l, n) {
  let { $head: t } = l.selection;
  if (!t.parent.isTextblock)
    return !1;
  let u = t.parentOffset, i = !u, s = u == t.parent.content.size, r = e.domSelection();
  return !lA.test(t.parent.textContent) || !r.modify ? n == "left" || n == "backward" ? i : s : r4(e, l, () => {
    let { focusNode: o, focusOffset: a, anchorNode: d, anchorOffset: h } = e.domSelectionRange(), p = r.caretBidiLevel;
    r.modify("move", n, "character");
    let f = t.depth ? e.docView.domAfterPos(t.before()) : e.dom, { focusNode: m, focusOffset: g } = e.domSelectionRange(), v = m && !f.contains(m.nodeType == 1 ? m : m.parentNode) || o == m && a == g;
    try {
      r.collapse(d, h), o && (o != d || a != h) && r.extend && r.extend(o, a);
    } catch {
    }
    return p != null && (r.caretBidiLevel = p), v;
  });
}
let Cm = null, Tm = null, Om = !1;
function eA(e, l, n) {
  return Cm == l && Tm == n ? Om : (Cm = l, Tm = n, Om = n == "up" || n == "down" ? QM(e, l, n) : nA(e, l, n));
}
const be = 0, km = 1, Su = 2, vt = 3;
class zs {
  constructor(l, n, t, u) {
    this.parent = l, this.children = n, this.dom = t, this.contentDOM = u, this.dirty = be, t.pmViewDesc = this;
  }
  // Used to check whether a given description corresponds to a
  // widget/mark/node.
  matchesWidget(l) {
    return !1;
  }
  matchesMark(l) {
    return !1;
  }
  matchesNode(l, n, t) {
    return !1;
  }
  matchesHack(l) {
    return !1;
  }
  // When parsing in-editor content (in domchange.js), we allow
  // descriptions to determine the parse rules that should be used to
  // parse them.
  parseRule() {
    return null;
  }
  // Used by the editor's event handler to ignore events that come
  // from certain descs.
  stopEvent(l) {
    return !1;
  }
  // The size of the content represented by this desc.
  get size() {
    let l = 0;
    for (let n = 0; n < this.children.length; n++)
      l += this.children[n].size;
    return l;
  }
  // For block nodes, this represents the space taken up by their
  // start/end tokens.
  get border() {
    return 0;
  }
  destroy() {
    this.parent = void 0, this.dom.pmViewDesc == this && (this.dom.pmViewDesc = void 0);
    for (let l = 0; l < this.children.length; l++)
      this.children[l].destroy();
  }
  posBeforeChild(l) {
    for (let n = 0, t = this.posAtStart; ; n++) {
      let u = this.children[n];
      if (u == l)
        return t;
      t += u.size;
    }
  }
  get posBefore() {
    return this.parent.posBeforeChild(this);
  }
  get posAtStart() {
    return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
  }
  get posAfter() {
    return this.posBefore + this.size;
  }
  get posAtEnd() {
    return this.posAtStart + this.size - 2 * this.border;
  }
  localPosFromDOM(l, n, t) {
    if (this.contentDOM && this.contentDOM.contains(l.nodeType == 1 ? l : l.parentNode))
      if (t < 0) {
        let i, s;
        if (l == this.contentDOM)
          i = l.childNodes[n - 1];
        else {
          for (; l.parentNode != this.contentDOM; )
            l = l.parentNode;
          i = l.previousSibling;
        }
        for (; i && !((s = i.pmViewDesc) && s.parent == this); )
          i = i.previousSibling;
        return i ? this.posBeforeChild(s) + s.size : this.posAtStart;
      } else {
        let i, s;
        if (l == this.contentDOM)
          i = l.childNodes[n];
        else {
          for (; l.parentNode != this.contentDOM; )
            l = l.parentNode;
          i = l.nextSibling;
        }
        for (; i && !((s = i.pmViewDesc) && s.parent == this); )
          i = i.nextSibling;
        return i ? this.posBeforeChild(s) : this.posAtEnd;
      }
    let u;
    if (l == this.dom && this.contentDOM)
      u = n > zn(this.contentDOM);
    else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM))
      u = l.compareDocumentPosition(this.contentDOM) & 2;
    else if (this.dom.firstChild) {
      if (n == 0)
        for (let i = l; ; i = i.parentNode) {
          if (i == this.dom) {
            u = !1;
            break;
          }
          if (i.previousSibling)
            break;
        }
      if (u == null && n == l.childNodes.length)
        for (let i = l; ; i = i.parentNode) {
          if (i == this.dom) {
            u = !0;
            break;
          }
          if (i.nextSibling)
            break;
        }
    }
    return u ?? t > 0 ? this.posAtEnd : this.posAtStart;
  }
  nearestDesc(l, n = !1) {
    for (let t = !0, u = l; u; u = u.parentNode) {
      let i = this.getDesc(u), s;
      if (i && (!n || i.node))
        if (t && (s = i.nodeDOM) && !(s.nodeType == 1 ? s.contains(l.nodeType == 1 ? l : l.parentNode) : s == l))
          t = !1;
        else
          return i;
    }
  }
  getDesc(l) {
    let n = l.pmViewDesc;
    for (let t = n; t; t = t.parent)
      if (t == this)
        return n;
  }
  posFromDOM(l, n, t) {
    for (let u = l; u; u = u.parentNode) {
      let i = this.getDesc(u);
      if (i)
        return i.localPosFromDOM(l, n, t);
    }
    return -1;
  }
  // Find the desc for the node after the given pos, if any. (When a
  // parent node overrode rendering, there might not be one.)
  descAt(l) {
    for (let n = 0, t = 0; n < this.children.length; n++) {
      let u = this.children[n], i = t + u.size;
      if (t == l && i != t) {
        for (; !u.border && u.children.length; )
          u = u.children[0];
        return u;
      }
      if (l < i)
        return u.descAt(l - t - u.border);
      t = i;
    }
  }
  domFromPos(l, n) {
    if (!this.contentDOM)
      return { node: this.dom, offset: 0, atom: l + 1 };
    let t = 0, u = 0;
    for (let i = 0; t < this.children.length; t++) {
      let s = this.children[t], r = i + s.size;
      if (r > l || s instanceof a4) {
        u = l - i;
        break;
      }
      i = r;
    }
    if (u)
      return this.children[t].domFromPos(u - this.children[t].border, n);
    for (let i; t && !(i = this.children[t - 1]).size && i instanceof o4 && i.side >= 0; t--)
      ;
    if (n <= 0) {
      let i, s = !0;
      for (; i = t ? this.children[t - 1] : null, !(!i || i.dom.parentNode == this.contentDOM); t--, s = !1)
        ;
      return i && n && s && !i.border && !i.domAtom ? i.domFromPos(i.size, n) : { node: this.contentDOM, offset: i ? zn(i.dom) + 1 : 0 };
    } else {
      let i, s = !0;
      for (; i = t < this.children.length ? this.children[t] : null, !(!i || i.dom.parentNode == this.contentDOM); t++, s = !1)
        ;
      return i && s && !i.border && !i.domAtom ? i.domFromPos(0, n) : { node: this.contentDOM, offset: i ? zn(i.dom) : this.contentDOM.childNodes.length };
    }
  }
  // Used to find a DOM range in a single parent for a given changed
  // range.
  parseRange(l, n, t = 0) {
    if (this.children.length == 0)
      return { node: this.contentDOM, from: l, to: n, fromOffset: 0, toOffset: this.contentDOM.childNodes.length };
    let u = -1, i = -1;
    for (let s = t, r = 0; ; r++) {
      let o = this.children[r], a = s + o.size;
      if (u == -1 && l <= a) {
        let d = s + o.border;
        if (l >= d && n <= a - o.border && o.node && o.contentDOM && this.contentDOM.contains(o.contentDOM))
          return o.parseRange(l, n, d);
        l = s;
        for (let h = r; h > 0; h--) {
          let p = this.children[h - 1];
          if (p.size && p.dom.parentNode == this.contentDOM && !p.emptyChildAt(1)) {
            u = zn(p.dom) + 1;
            break;
          }
          l -= p.size;
        }
        u == -1 && (u = 0);
      }
      if (u > -1 && (a > n || r == this.children.length - 1)) {
        n = a;
        for (let d = r + 1; d < this.children.length; d++) {
          let h = this.children[d];
          if (h.size && h.dom.parentNode == this.contentDOM && !h.emptyChildAt(-1)) {
            i = zn(h.dom);
            break;
          }
          n += h.size;
        }
        i == -1 && (i = this.contentDOM.childNodes.length);
        break;
      }
      s = a;
    }
    return { node: this.contentDOM, from: l, to: n, fromOffset: u, toOffset: i };
  }
  emptyChildAt(l) {
    if (this.border || !this.contentDOM || !this.children.length)
      return !1;
    let n = this.children[l < 0 ? 0 : this.children.length - 1];
    return n.size == 0 || n.emptyChildAt(l);
  }
  domAfterPos(l) {
    let { node: n, offset: t } = this.domFromPos(l, 0);
    if (n.nodeType != 1 || t == n.childNodes.length)
      throw new RangeError("No node after pos " + l);
    return n.childNodes[t];
  }
  // View descs are responsible for setting any selection that falls
  // entirely inside of them, so that custom implementations can do
  // custom things with the selection. Note that this falls apart when
  // a selection starts in such a node and ends in another, in which
  // case we just use whatever domFromPos produces as a best effort.
  setSelection(l, n, t, u = !1) {
    let i = Math.min(l, n), s = Math.max(l, n);
    for (let p = 0, f = 0; p < this.children.length; p++) {
      let m = this.children[p], g = f + m.size;
      if (i > f && s < g)
        return m.setSelection(l - f - m.border, n - f - m.border, t, u);
      f = g;
    }
    let r = this.domFromPos(l, l ? -1 : 1), o = n == l ? r : this.domFromPos(n, n ? -1 : 1), a = t.getSelection(), d = !1;
    if ((He || jn) && l == n) {
      let { node: p, offset: f } = r;
      if (p.nodeType == 3) {
        if (d = !!(f && p.nodeValue[f - 1] == `
`), d && f == p.nodeValue.length)
          for (let m = p, g; m; m = m.parentNode) {
            if (g = m.nextSibling) {
              g.nodeName == "BR" && (r = o = { node: g.parentNode, offset: zn(g) + 1 });
              break;
            }
            let v = m.pmViewDesc;
            if (v && v.node && v.node.isBlock)
              break;
          }
      } else {
        let m = p.childNodes[f - 1];
        d = m && (m.nodeName == "BR" || m.contentEditable == "false");
      }
    }
    if (He && a.focusNode && a.focusNode != o.node && a.focusNode.nodeType == 1) {
      let p = a.focusNode.childNodes[a.focusOffset];
      p && p.contentEditable == "false" && (u = !0);
    }
    if (!(u || d && jn) && Pu(r.node, r.offset, a.anchorNode, a.anchorOffset) && Pu(o.node, o.offset, a.focusNode, a.focusOffset))
      return;
    let h = !1;
    if ((a.extend || l == n) && !d) {
      a.collapse(r.node, r.offset);
      try {
        l != n && a.extend(o.node, o.offset), h = !0;
      } catch {
      }
    }
    if (!h) {
      if (l > n) {
        let f = r;
        r = o, o = f;
      }
      let p = document.createRange();
      p.setEnd(o.node, o.offset), p.setStart(r.node, r.offset), a.removeAllRanges(), a.addRange(p);
    }
  }
  ignoreMutation(l) {
    return !this.contentDOM && l.type != "selection";
  }
  get contentLost() {
    return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
  }
  // Remove a subtree of the element tree that has been touched
  // by a DOM change, so that the next update will redraw it.
  markDirty(l, n) {
    for (let t = 0, u = 0; u < this.children.length; u++) {
      let i = this.children[u], s = t + i.size;
      if (t == s ? l <= s && n >= t : l < s && n > t) {
        let r = t + i.border, o = s - i.border;
        if (l >= r && n <= o) {
          this.dirty = l == t || n == s ? Su : km, l == r && n == o && (i.contentLost || i.dom.parentNode != this.contentDOM) ? i.dirty = vt : i.markDirty(l - r, n - r);
          return;
        } else
          i.dirty = i.dom == i.contentDOM && i.dom.parentNode == this.contentDOM && !i.children.length ? Su : vt;
      }
      t = s;
    }
    this.dirty = Su;
  }
  markParentsDirty() {
    let l = 1;
    for (let n = this.parent; n; n = n.parent, l++) {
      let t = l == 1 ? Su : km;
      n.dirty < t && (n.dirty = t);
    }
  }
  get domAtom() {
    return !1;
  }
  get ignoreForCoords() {
    return !1;
  }
}
class o4 extends zs {
  constructor(l, n, t, u) {
    let i, s = n.type.toDOM;
    if (typeof s == "function" && (s = s(t, () => {
      if (!i)
        return u;
      if (i.parent)
        return i.parent.posBeforeChild(i);
    })), !n.type.spec.raw) {
      if (s.nodeType != 1) {
        let r = document.createElement("span");
        r.appendChild(s), s = r;
      }
      s.contentEditable = "false", s.classList.add("ProseMirror-widget");
    }
    super(l, [], s, null), this.widget = n, this.widget = n, i = this;
  }
  matchesWidget(l) {
    return this.dirty == be && l.type.eq(this.widget.type);
  }
  parseRule() {
    return { ignore: !0 };
  }
  stopEvent(l) {
    let n = this.widget.spec.stopEvent;
    return n ? n(l) : !1;
  }
  ignoreMutation(l) {
    return l.type != "selection" || this.widget.spec.ignoreSelection;
  }
  destroy() {
    this.widget.type.destroy(this.dom), super.destroy();
  }
  get domAtom() {
    return !0;
  }
  get side() {
    return this.widget.type.side;
  }
}
class tA extends zs {
  constructor(l, n, t, u) {
    super(l, [], n, null), this.textDOM = t, this.text = u;
  }
  get size() {
    return this.text.length;
  }
  localPosFromDOM(l, n) {
    return l != this.textDOM ? this.posAtStart + (n ? this.size : 0) : this.posAtStart + n;
  }
  domFromPos(l) {
    return { node: this.textDOM, offset: l };
  }
  ignoreMutation(l) {
    return l.type === "characterData" && l.target.nodeValue == l.oldValue;
  }
}
class Bu extends zs {
  constructor(l, n, t, u) {
    super(l, [], t, u), this.mark = n;
  }
  static create(l, n, t, u) {
    let i = u.nodeViews[n.type.name], s = i && i(n, u, t);
    return (!s || !s.dom) && (s = st.renderSpec(document, n.type.spec.toDOM(n, t))), new Bu(l, n, s.dom, s.contentDOM || s.dom);
  }
  parseRule() {
    return this.dirty & vt || this.mark.type.spec.reparseInView ? null : { mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM };
  }
  matchesMark(l) {
    return this.dirty != vt && this.mark.eq(l);
  }
  markDirty(l, n) {
    if (super.markDirty(l, n), this.dirty != be) {
      let t = this.parent;
      for (; !t.node; )
        t = t.parent;
      t.dirty < this.dirty && (t.dirty = this.dirty), this.dirty = be;
    }
  }
  slice(l, n, t) {
    let u = Bu.create(this.parent, this.mark, !0, t), i = this.children, s = this.size;
    n < s && (i = Vh(i, n, s, t)), l > 0 && (i = Vh(i, 0, l, t));
    for (let r = 0; r < i.length; r++)
      i[r].parent = u;
    return u.children = i, u;
  }
}
class Qt extends zs {
  constructor(l, n, t, u, i, s, r, o, a) {
    super(l, [], i, s), this.node = n, this.outerDeco = t, this.innerDeco = u, this.nodeDOM = r;
  }
  // By default, a node is rendered using the `toDOM` method from the
  // node type spec. But client code can use the `nodeViews` spec to
  // supply a custom node view, which can influence various aspects of
  // the way the node works.
  //
  // (Using subclassing for this was intentionally decided against,
  // since it'd require exposing a whole slew of finicky
  // implementation details to the user code that they probably will
  // never need.)
  static create(l, n, t, u, i, s) {
    let r = i.nodeViews[n.type.name], o, a = r && r(n, i, () => {
      if (!o)
        return s;
      if (o.parent)
        return o.parent.posBeforeChild(o);
    }, t, u), d = a && a.dom, h = a && a.contentDOM;
    if (n.isText) {
      if (!d)
        d = document.createTextNode(n.text);
      else if (d.nodeType != 3)
        throw new RangeError("Text must be rendered as a DOM text node");
    } else
      d || ({ dom: d, contentDOM: h } = st.renderSpec(document, n.type.spec.toDOM(n)));
    !h && !n.isText && d.nodeName != "BR" && (d.hasAttribute("contenteditable") || (d.contentEditable = "false"), n.type.spec.draggable && (d.draggable = !0));
    let p = d;
    return d = h4(d, t, n), a ? o = new uA(l, n, t, u, d, h || null, p, a, i, s + 1) : n.isText ? new oa(l, n, t, u, d, p, i) : new Qt(l, n, t, u, d, h || null, p, i, s + 1);
  }
  parseRule() {
    if (this.node.type.spec.reparseInView)
      return null;
    let l = { node: this.node.type.name, attrs: this.node.attrs };
    if (this.node.type.whitespace == "pre" && (l.preserveWhitespace = "full"), !this.contentDOM)
      l.getContent = () => this.node.content;
    else if (!this.contentLost)
      l.contentElement = this.contentDOM;
    else {
      for (let n = this.children.length - 1; n >= 0; n--) {
        let t = this.children[n];
        if (this.dom.contains(t.dom.parentNode)) {
          l.contentElement = t.dom.parentNode;
          break;
        }
      }
      l.contentElement || (l.getContent = () => j.empty);
    }
    return l;
  }
  matchesNode(l, n, t) {
    return this.dirty == be && l.eq(this.node) && zh(n, this.outerDeco) && t.eq(this.innerDeco);
  }
  get size() {
    return this.node.nodeSize;
  }
  get border() {
    return this.node.isLeaf ? 0 : 1;
  }
  // Syncs `this.children` to match `this.node.content` and the local
  // decorations, possibly introducing nesting for marks. Then, in a
  // separate step, syncs the DOM inside `this.contentDOM` to
  // `this.children`.
  updateChildren(l, n) {
    let t = this.node.inlineContent, u = n, i = l.composing ? this.localCompositionInfo(l, n) : null, s = i && i.pos > -1 ? i : null, r = i && i.pos < 0, o = new sA(this, s && s.node, l);
    aA(this.node, this.innerDeco, (a, d, h) => {
      a.spec.marks ? o.syncToMarks(a.spec.marks, t, l) : a.type.side >= 0 && !h && o.syncToMarks(d == this.node.childCount ? Vl.none : this.node.child(d).marks, t, l), o.placeWidget(a, l, u);
    }, (a, d, h, p) => {
      o.syncToMarks(a.marks, t, l);
      let f;
      o.findNodeMatch(a, d, h, p) || r && l.state.selection.from > u && l.state.selection.to < u + a.nodeSize && (f = o.findIndexWithChild(i.node)) > -1 && o.updateNodeAt(a, d, h, f, l) || o.updateNextNode(a, d, h, l, p, u) || o.addNode(a, d, h, l, u), u += a.nodeSize;
    }), o.syncToMarks([], t, l), this.node.isTextblock && o.addTextblockHacks(), o.destroyRest(), (o.changed || this.dirty == Su) && (s && this.protectLocalComposition(l, s), d4(this.contentDOM, this.children, l), _i && dA(this.dom));
  }
  localCompositionInfo(l, n) {
    let { from: t, to: u } = l.state.selection;
    if (!(l.state.selection instanceof Cl) || t < n || u > n + this.node.content.size)
      return null;
    let i = l.domSelectionRange(), s = cA(i.focusNode, i.focusOffset);
    if (!s || !this.dom.contains(s.parentNode))
      return null;
    if (this.node.inlineContent) {
      let r = s.nodeValue, o = hA(this.node.content, r, t - n, u - n);
      return o < 0 ? null : { node: s, pos: o, text: r };
    } else
      return { node: s, pos: -1, text: "" };
  }
  protectLocalComposition(l, { node: n, pos: t, text: u }) {
    if (this.getDesc(n))
      return;
    let i = n;
    for (; i.parentNode != this.contentDOM; i = i.parentNode) {
      for (; i.previousSibling; )
        i.parentNode.removeChild(i.previousSibling);
      for (; i.nextSibling; )
        i.parentNode.removeChild(i.nextSibling);
      i.pmViewDesc && (i.pmViewDesc = void 0);
    }
    let s = new tA(this, i, n, u);
    l.input.compositionNodes.push(s), this.children = Vh(this.children, t, t + u.length, l, s);
  }
  // If this desc must be updated to match the given node decoration,
  // do so and return true.
  update(l, n, t, u) {
    return this.dirty == vt || !l.sameMarkup(this.node) ? !1 : (this.updateInner(l, n, t, u), !0);
  }
  updateInner(l, n, t, u) {
    this.updateOuterDeco(n), this.node = l, this.innerDeco = t, this.contentDOM && this.updateChildren(u, this.posAtStart), this.dirty = be;
  }
  updateOuterDeco(l) {
    if (zh(l, this.outerDeco))
      return;
    let n = this.nodeDOM.nodeType != 1, t = this.dom;
    this.dom = c4(this.dom, this.nodeDOM, Hh(this.outerDeco, this.node, n), Hh(l, this.node, n)), this.dom != t && (t.pmViewDesc = void 0, this.dom.pmViewDesc = this), this.outerDeco = l;
  }
  // Mark this node as being the selected node.
  selectNode() {
    this.nodeDOM.nodeType == 1 && this.nodeDOM.classList.add("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && (this.dom.draggable = !0);
  }
  // Remove selected node marking from this node.
  deselectNode() {
    this.nodeDOM.nodeType == 1 && this.nodeDOM.classList.remove("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && this.dom.removeAttribute("draggable");
  }
  get domAtom() {
    return this.node.isAtom;
  }
}
function Mm(e, l, n, t, u) {
  h4(t, l, e);
  let i = new Qt(void 0, e, l, n, t, t, t, u, 0);
  return i.contentDOM && i.updateChildren(u, 0), i;
}
class oa extends Qt {
  constructor(l, n, t, u, i, s, r) {
    super(l, n, t, u, i, null, s, r, 0);
  }
  parseRule() {
    let l = this.nodeDOM.parentNode;
    for (; l && l != this.dom && !l.pmIsDeco; )
      l = l.parentNode;
    return { skip: l || !0 };
  }
  update(l, n, t, u) {
    return this.dirty == vt || this.dirty != be && !this.inParent() || !l.sameMarkup(this.node) ? !1 : (this.updateOuterDeco(n), (this.dirty != be || l.text != this.node.text) && l.text != this.nodeDOM.nodeValue && (this.nodeDOM.nodeValue = l.text, u.trackWrites == this.nodeDOM && (u.trackWrites = null)), this.node = l, this.dirty = be, !0);
  }
  inParent() {
    let l = this.parent.contentDOM;
    for (let n = this.nodeDOM; n; n = n.parentNode)
      if (n == l)
        return !0;
    return !1;
  }
  domFromPos(l) {
    return { node: this.nodeDOM, offset: l };
  }
  localPosFromDOM(l, n, t) {
    return l == this.nodeDOM ? this.posAtStart + Math.min(n, this.node.text.length) : super.localPosFromDOM(l, n, t);
  }
  ignoreMutation(l) {
    return l.type != "characterData" && l.type != "selection";
  }
  slice(l, n, t) {
    let u = this.node.cut(l, n), i = document.createTextNode(u.text);
    return new oa(this.parent, u, this.outerDeco, this.innerDeco, i, i, t);
  }
  markDirty(l, n) {
    super.markDirty(l, n), this.dom != this.nodeDOM && (l == 0 || n == this.nodeDOM.nodeValue.length) && (this.dirty = vt);
  }
  get domAtom() {
    return !1;
  }
}
class a4 extends zs {
  parseRule() {
    return { ignore: !0 };
  }
  matchesHack(l) {
    return this.dirty == be && this.dom.nodeName == l;
  }
  get domAtom() {
    return !0;
  }
  get ignoreForCoords() {
    return this.dom.nodeName == "IMG";
  }
}
class uA extends Qt {
  constructor(l, n, t, u, i, s, r, o, a, d) {
    super(l, n, t, u, i, s, r, a, d), this.spec = o;
  }
  // A custom `update` method gets to decide whether the update goes
  // through. If it does, and there's a `contentDOM` node, our logic
  // updates the children.
  update(l, n, t, u) {
    if (this.dirty == vt)
      return !1;
    if (this.spec.update) {
      let i = this.spec.update(l, n, t);
      return i && this.updateInner(l, n, t, u), i;
    } else
      return !this.contentDOM && !l.isLeaf ? !1 : super.update(l, n, t, u);
  }
  selectNode() {
    this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
  }
  deselectNode() {
    this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
  }
  setSelection(l, n, t, u) {
    this.spec.setSelection ? this.spec.setSelection(l, n, t) : super.setSelection(l, n, t, u);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
  stopEvent(l) {
    return this.spec.stopEvent ? this.spec.stopEvent(l) : !1;
  }
  ignoreMutation(l) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(l) : super.ignoreMutation(l);
  }
}
function d4(e, l, n) {
  let t = e.firstChild, u = !1;
  for (let i = 0; i < l.length; i++) {
    let s = l[i], r = s.dom;
    if (r.parentNode == e) {
      for (; r != t; )
        t = Am(t), u = !0;
      t = t.nextSibling;
    } else
      u = !0, e.insertBefore(r, t);
    if (s instanceof Bu) {
      let o = t ? t.previousSibling : e.lastChild;
      d4(s.contentDOM, s.children, n), t = o ? o.nextSibling : e.firstChild;
    }
  }
  for (; t; )
    t = Am(t), u = !0;
  u && n.trackWrites == e && (n.trackWrites = null);
}
const es = function(e) {
  e && (this.nodeName = e);
};
es.prototype = /* @__PURE__ */ Object.create(null);
const Cu = [new es()];
function Hh(e, l, n) {
  if (e.length == 0)
    return Cu;
  let t = n ? Cu[0] : new es(), u = [t];
  for (let i = 0; i < e.length; i++) {
    let s = e[i].type.attrs;
    if (s) {
      s.nodeName && u.push(t = new es(s.nodeName));
      for (let r in s) {
        let o = s[r];
        o != null && (n && u.length == 1 && u.push(t = new es(l.isInline ? "span" : "div")), r == "class" ? t.class = (t.class ? t.class + " " : "") + o : r == "style" ? t.style = (t.style ? t.style + ";" : "") + o : r != "nodeName" && (t[r] = o));
      }
    }
  }
  return u;
}
function c4(e, l, n, t) {
  if (n == Cu && t == Cu)
    return l;
  let u = l;
  for (let i = 0; i < t.length; i++) {
    let s = t[i], r = n[i];
    if (i) {
      let o;
      r && r.nodeName == s.nodeName && u != e && (o = u.parentNode) && o.nodeName.toLowerCase() == s.nodeName || (o = document.createElement(s.nodeName), o.pmIsDeco = !0, o.appendChild(u), r = Cu[0]), u = o;
    }
    iA(u, r || Cu[0], s);
  }
  return u;
}
function iA(e, l, n) {
  for (let t in l)
    t != "class" && t != "style" && t != "nodeName" && !(t in n) && e.removeAttribute(t);
  for (let t in n)
    t != "class" && t != "style" && t != "nodeName" && n[t] != l[t] && e.setAttribute(t, n[t]);
  if (l.class != n.class) {
    let t = l.class ? l.class.split(" ").filter(Boolean) : [], u = n.class ? n.class.split(" ").filter(Boolean) : [];
    for (let i = 0; i < t.length; i++)
      u.indexOf(t[i]) == -1 && e.classList.remove(t[i]);
    for (let i = 0; i < u.length; i++)
      t.indexOf(u[i]) == -1 && e.classList.add(u[i]);
    e.classList.length == 0 && e.removeAttribute("class");
  }
  if (l.style != n.style) {
    if (l.style) {
      let t = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, u;
      for (; u = t.exec(l.style); )
        e.style.removeProperty(u[1]);
    }
    n.style && (e.style.cssText += n.style);
  }
}
function h4(e, l, n) {
  return c4(e, e, Cu, Hh(l, n, e.nodeType != 1));
}
function zh(e, l) {
  if (e.length != l.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (!e[n].type.eq(l[n].type))
      return !1;
  return !0;
}
function Am(e) {
  let l = e.nextSibling;
  return e.parentNode.removeChild(e), l;
}
class sA {
  constructor(l, n, t) {
    this.lock = n, this.view = t, this.index = 0, this.stack = [], this.changed = !1, this.top = l, this.preMatch = rA(l.node.content, l);
  }
  // Destroy and remove the children between the given indices in
  // `this.top`.
  destroyBetween(l, n) {
    if (l != n) {
      for (let t = l; t < n; t++)
        this.top.children[t].destroy();
      this.top.children.splice(l, n - l), this.changed = !0;
    }
  }
  // Destroy all remaining children in `this.top`.
  destroyRest() {
    this.destroyBetween(this.index, this.top.children.length);
  }
  // Sync the current stack of mark descs with the given array of
  // marks, reusing existing mark descs when possible.
  syncToMarks(l, n, t) {
    let u = 0, i = this.stack.length >> 1, s = Math.min(i, l.length);
    for (; u < s && (u == i - 1 ? this.top : this.stack[u + 1 << 1]).matchesMark(l[u]) && l[u].type.spec.spanning !== !1; )
      u++;
    for (; u < i; )
      this.destroyRest(), this.top.dirty = be, this.index = this.stack.pop(), this.top = this.stack.pop(), i--;
    for (; i < l.length; ) {
      this.stack.push(this.top, this.index + 1);
      let r = -1;
      for (let o = this.index; o < Math.min(this.index + 3, this.top.children.length); o++) {
        let a = this.top.children[o];
        if (a.matchesMark(l[i]) && !this.isLocked(a.dom)) {
          r = o;
          break;
        }
      }
      if (r > -1)
        r > this.index && (this.changed = !0, this.destroyBetween(this.index, r)), this.top = this.top.children[this.index];
      else {
        let o = Bu.create(this.top, l[i], n, t);
        this.top.children.splice(this.index, 0, o), this.top = o, this.changed = !0;
      }
      this.index = 0, i++;
    }
  }
  // Try to find a node desc matching the given data. Skip over it and
  // return true when successful.
  findNodeMatch(l, n, t, u) {
    let i = -1, s;
    if (u >= this.preMatch.index && (s = this.preMatch.matches[u - this.preMatch.index]).parent == this.top && s.matchesNode(l, n, t))
      i = this.top.children.indexOf(s, this.index);
    else
      for (let r = this.index, o = Math.min(this.top.children.length, r + 5); r < o; r++) {
        let a = this.top.children[r];
        if (a.matchesNode(l, n, t) && !this.preMatch.matched.has(a)) {
          i = r;
          break;
        }
      }
    return i < 0 ? !1 : (this.destroyBetween(this.index, i), this.index++, !0);
  }
  updateNodeAt(l, n, t, u, i) {
    let s = this.top.children[u];
    return s.dirty == vt && s.dom == s.contentDOM && (s.dirty = Su), s.update(l, n, t, i) ? (this.destroyBetween(this.index, u), this.index++, !0) : !1;
  }
  findIndexWithChild(l) {
    for (; ; ) {
      let n = l.parentNode;
      if (!n)
        return -1;
      if (n == this.top.contentDOM) {
        let t = l.pmViewDesc;
        if (t) {
          for (let u = this.index; u < this.top.children.length; u++)
            if (this.top.children[u] == t)
              return u;
        }
        return -1;
      }
      l = n;
    }
  }
  // Try to update the next node, if any, to the given data. Checks
  // pre-matches to avoid overwriting nodes that could still be used.
  updateNextNode(l, n, t, u, i, s) {
    for (let r = this.index; r < this.top.children.length; r++) {
      let o = this.top.children[r];
      if (o instanceof Qt) {
        let a = this.preMatch.matched.get(o);
        if (a != null && a != i)
          return !1;
        let d = o.dom, h, p = this.isLocked(d) && !(l.isText && o.node && o.node.isText && o.nodeDOM.nodeValue == l.text && o.dirty != vt && zh(n, o.outerDeco));
        if (!p && o.update(l, n, t, u))
          return this.destroyBetween(this.index, r), o.dom != d && (this.changed = !0), this.index++, !0;
        if (!p && (h = this.recreateWrapper(o, l, n, t, u, s)))
          return this.top.children[this.index] = h, h.contentDOM && (h.dirty = Su, h.updateChildren(u, s + 1), h.dirty = be), this.changed = !0, this.index++, !0;
        break;
      }
    }
    return !1;
  }
  // When a node with content is replaced by a different node with
  // identical content, move over its children.
  recreateWrapper(l, n, t, u, i, s) {
    if (l.dirty || n.isAtom || !l.children.length || !l.node.content.eq(n.content))
      return null;
    let r = Qt.create(this.top, n, t, u, i, s);
    if (r.contentDOM) {
      r.children = l.children, l.children = [];
      for (let o of r.children)
        o.parent = r;
    }
    return l.destroy(), r;
  }
  // Insert the node as a newly created node desc.
  addNode(l, n, t, u, i) {
    let s = Qt.create(this.top, l, n, t, u, i);
    s.contentDOM && s.updateChildren(u, i + 1), this.top.children.splice(this.index++, 0, s), this.changed = !0;
  }
  placeWidget(l, n, t) {
    let u = this.index < this.top.children.length ? this.top.children[this.index] : null;
    if (u && u.matchesWidget(l) && (l == u.widget || !u.widget.type.toDOM.parentNode))
      this.index++;
    else {
      let i = new o4(this.top, l, n, t);
      this.top.children.splice(this.index++, 0, i), this.changed = !0;
    }
  }
  // Make sure a textblock looks and behaves correctly in
  // contentEditable.
  addTextblockHacks() {
    let l = this.top.children[this.index - 1], n = this.top;
    for (; l instanceof Bu; )
      n = l, l = n.children[n.children.length - 1];
    (!l || // Empty textblock
    !(l instanceof oa) || /\n$/.test(l.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(l.node.text)) && ((jn || Rn) && l && l.dom.contentEditable == "false" && this.addHackNode("IMG", n), this.addHackNode("BR", this.top));
  }
  addHackNode(l, n) {
    if (n == this.top && this.index < n.children.length && n.children[this.index].matchesHack(l))
      this.index++;
    else {
      let t = document.createElement(l);
      l == "IMG" && (t.className = "ProseMirror-separator", t.alt = ""), l == "BR" && (t.className = "ProseMirror-trailingBreak");
      let u = new a4(this.top, [], t, null);
      n != this.top ? n.children.push(u) : n.children.splice(this.index++, 0, u), this.changed = !0;
    }
  }
  isLocked(l) {
    return this.lock && (l == this.lock || l.nodeType == 1 && l.contains(this.lock.parentNode));
  }
}
function rA(e, l) {
  let n = l, t = n.children.length, u = e.childCount, i = /* @__PURE__ */ new Map(), s = [];
  l:
    for (; u > 0; ) {
      let r;
      for (; ; )
        if (t) {
          let a = n.children[t - 1];
          if (a instanceof Bu)
            n = a, t = a.children.length;
          else {
            r = a, t--;
            break;
          }
        } else {
          if (n == l)
            break l;
          t = n.parent.children.indexOf(n), n = n.parent;
        }
      let o = r.node;
      if (o) {
        if (o != e.child(u - 1))
          break;
        --u, i.set(r, u), s.push(r);
      }
    }
  return { index: u, matched: i, matches: s.reverse() };
}
function oA(e, l) {
  return e.type.side - l.type.side;
}
function aA(e, l, n, t) {
  let u = l.locals(e), i = 0;
  if (u.length == 0) {
    for (let a = 0; a < e.childCount; a++) {
      let d = e.child(a);
      t(d, u, l.forChild(i, d), a), i += d.nodeSize;
    }
    return;
  }
  let s = 0, r = [], o = null;
  for (let a = 0; ; ) {
    let d, h;
    for (; s < u.length && u[s].to == i; ) {
      let v = u[s++];
      v.widget && (d ? (h || (h = [d])).push(v) : d = v);
    }
    if (d)
      if (h) {
        h.sort(oA);
        for (let v = 0; v < h.length; v++)
          n(h[v], a, !!o);
      } else
        n(d, a, !!o);
    let p, f;
    if (o)
      f = -1, p = o, o = null;
    else if (a < e.childCount)
      f = a, p = e.child(a++);
    else
      break;
    for (let v = 0; v < r.length; v++)
      r[v].to <= i && r.splice(v--, 1);
    for (; s < u.length && u[s].from <= i && u[s].to > i; )
      r.push(u[s++]);
    let m = i + p.nodeSize;
    if (p.isText) {
      let v = m;
      s < u.length && u[s].from < v && (v = u[s].from);
      for (let w = 0; w < r.length; w++)
        r[w].to < v && (v = r[w].to);
      v < m && (o = p.cut(v - i), p = p.cut(0, v - i), m = v, f = -1);
    } else
      for (; s < u.length && u[s].to < m; )
        s++;
    let g = p.isInline && !p.isLeaf ? r.filter((v) => !v.inline) : r.slice();
    t(p, g, l.forChild(i, p), f), i = m;
  }
}
function dA(e) {
  if (e.nodeName == "UL" || e.nodeName == "OL") {
    let l = e.style.cssText;
    e.style.cssText = l + "; list-style: square !important", window.getComputedStyle(e).listStyle, e.style.cssText = l;
  }
}
function cA(e, l) {
  for (; ; ) {
    if (e.nodeType == 3)
      return e;
    if (e.nodeType == 1 && l > 0) {
      if (e.childNodes.length > l && e.childNodes[l].nodeType == 3)
        return e.childNodes[l];
      e = e.childNodes[l - 1], l = et(e);
    } else if (e.nodeType == 1 && l < e.childNodes.length)
      e = e.childNodes[l], l = 0;
    else
      return null;
  }
}
function hA(e, l, n, t) {
  for (let u = 0, i = 0; u < e.childCount && i <= t; ) {
    let s = e.child(u++), r = i;
    if (i += s.nodeSize, !s.isText)
      continue;
    let o = s.text;
    for (; u < e.childCount; ) {
      let a = e.child(u++);
      if (i += a.nodeSize, !a.isText)
        break;
      o += a.text;
    }
    if (i >= n) {
      if (i >= t && o.slice(t - l.length - r, t - r) == l)
        return t - l.length;
      let a = r < t ? o.lastIndexOf(l, t - r - 1) : -1;
      if (a >= 0 && a + l.length + r >= n)
        return r + a;
      if (n == t && o.length >= t + l.length - r && o.slice(t - r, t - r + l.length) == l)
        return t;
    }
  }
  return -1;
}
function Vh(e, l, n, t, u) {
  let i = [];
  for (let s = 0, r = 0; s < e.length; s++) {
    let o = e[s], a = r, d = r += o.size;
    a >= n || d <= l ? i.push(o) : (a < l && i.push(o.slice(0, l - a, t)), u && (i.push(u), u = void 0), d > n && i.push(o.slice(n - a, o.size, t)));
  }
  return i;
}
function Wf(e, l = null) {
  let n = e.domSelectionRange(), t = e.state.doc;
  if (!n.focusNode)
    return null;
  let u = e.docView.nearestDesc(n.focusNode), i = u && u.size == 0, s = e.docView.posFromDOM(n.focusNode, n.focusOffset, 1);
  if (s < 0)
    return null;
  let r = t.resolve(s), o, a;
  if (ra(n)) {
    for (o = r; u && !u.node; )
      u = u.parent;
    let d = u.node;
    if (u && d.isAtom && pl.isSelectable(d) && u.parent && !(d.isInline && LM(n.focusNode, n.focusOffset, u.dom))) {
      let h = u.posBefore;
      a = new pl(s == h ? r : t.resolve(h));
    }
  } else {
    let d = e.docView.posFromDOM(n.anchorNode, n.anchorOffset, 1);
    if (d < 0)
      return null;
    o = t.resolve(d);
  }
  if (!a) {
    let d = l == "pointer" || e.state.selection.head < r.pos && !i ? 1 : -1;
    a = Gf(e, o, r, d);
  }
  return a;
}
function p4(e) {
  return e.editable ? e.hasFocus() : m4(e) && document.activeElement && document.activeElement.contains(e.dom);
}
function xt(e, l = !1) {
  let n = e.state.selection;
  if (f4(e, n), !!p4(e)) {
    if (!l && e.input.mouseDown && e.input.mouseDown.allowDefault && Rn) {
      let t = e.domSelectionRange(), u = e.domObserver.currentSelection;
      if (t.anchorNode && u.anchorNode && Pu(t.anchorNode, t.anchorOffset, u.anchorNode, u.anchorOffset)) {
        e.input.mouseDown.delayedSelectionSync = !0, e.domObserver.setCurSelection();
        return;
      }
    }
    if (e.domObserver.disconnectSelection(), e.cursorWrapper)
      fA(e);
    else {
      let { anchor: t, head: u } = n, i, s;
      xm && !(n instanceof Cl) && (n.$from.parent.inlineContent || (i = Em(e, n.from)), !n.empty && !n.$from.parent.inlineContent && (s = Em(e, n.to))), e.docView.setSelection(t, u, e.root, l), xm && (i && Im(i), s && Im(s)), n.visible ? e.dom.classList.remove("ProseMirror-hideselection") : (e.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && pA(e));
    }
    e.domObserver.setCurSelection(), e.domObserver.connectSelection();
  }
}
const xm = jn || Rn && FM < 63;
function Em(e, l) {
  let { node: n, offset: t } = e.docView.domFromPos(l, 0), u = t < n.childNodes.length ? n.childNodes[t] : null, i = t ? n.childNodes[t - 1] : null;
  if (jn && u && u.contentEditable == "false")
    return Od(u);
  if ((!u || u.contentEditable == "false") && (!i || i.contentEditable == "false")) {
    if (u)
      return Od(u);
    if (i)
      return Od(i);
  }
}
function Od(e) {
  return e.contentEditable = "true", jn && e.draggable && (e.draggable = !1, e.wasDraggable = !0), e;
}
function Im(e) {
  e.contentEditable = "false", e.wasDraggable && (e.draggable = !0, e.wasDraggable = null);
}
function pA(e) {
  let l = e.dom.ownerDocument;
  l.removeEventListener("selectionchange", e.input.hideSelectionGuard);
  let n = e.domSelectionRange(), t = n.anchorNode, u = n.anchorOffset;
  l.addEventListener("selectionchange", e.input.hideSelectionGuard = () => {
    (n.anchorNode != t || n.anchorOffset != u) && (l.removeEventListener("selectionchange", e.input.hideSelectionGuard), setTimeout(() => {
      (!p4(e) || e.state.selection.visible) && e.dom.classList.remove("ProseMirror-hideselection");
    }, 20));
  });
}
function fA(e) {
  let l = e.domSelection(), n = document.createRange(), t = e.cursorWrapper.dom, u = t.nodeName == "IMG";
  u ? n.setEnd(t.parentNode, zn(t) + 1) : n.setEnd(t, 0), n.collapse(!1), l.removeAllRanges(), l.addRange(n), !u && !e.state.selection.visible && Zn && Xt <= 11 && (t.disabled = !0, t.disabled = !1);
}
function f4(e, l) {
  if (l instanceof pl) {
    let n = e.docView.descAt(l.from);
    n != e.lastSelectedViewDesc && (Rm(e), n && n.selectNode(), e.lastSelectedViewDesc = n);
  } else
    Rm(e);
}
function Rm(e) {
  e.lastSelectedViewDesc && (e.lastSelectedViewDesc.parent && e.lastSelectedViewDesc.deselectNode(), e.lastSelectedViewDesc = void 0);
}
function Gf(e, l, n, t) {
  return e.someProp("createSelectionBetween", (u) => u(e, l, n)) || Cl.between(l, n, t);
}
function Dm(e) {
  return e.editable && !e.hasFocus() ? !1 : m4(e);
}
function m4(e) {
  let l = e.domSelectionRange();
  if (!l.anchorNode)
    return !1;
  try {
    return e.dom.contains(l.anchorNode.nodeType == 3 ? l.anchorNode.parentNode : l.anchorNode) && (e.editable || e.dom.contains(l.focusNode.nodeType == 3 ? l.focusNode.parentNode : l.focusNode));
  } catch {
    return !1;
  }
}
function mA(e) {
  let l = e.docView.domFromPos(e.state.selection.anchor, 0), n = e.domSelectionRange();
  return Pu(l.node, l.offset, n.anchorNode, n.anchorOffset);
}
function jh(e, l) {
  let { $anchor: n, $head: t } = e.selection, u = l > 0 ? n.max(t) : n.min(t), i = u.parent.inlineContent ? u.depth ? e.doc.resolve(l > 0 ? u.after() : u.before()) : null : u;
  return i && xl.findFrom(i, l);
}
function Ht(e, l) {
  return e.dispatch(e.state.tr.setSelection(l).scrollIntoView()), !0;
}
function Nm(e, l, n) {
  let t = e.state.selection;
  if (t instanceof Cl)
    if (n.indexOf("s") > -1) {
      let { $head: u } = t, i = u.textOffset ? null : l < 0 ? u.nodeBefore : u.nodeAfter;
      if (!i || i.isText || !i.isLeaf)
        return !1;
      let s = e.state.doc.resolve(u.pos + i.nodeSize * (l < 0 ? -1 : 1));
      return Ht(e, new Cl(t.$anchor, s));
    } else if (t.empty) {
      if (e.endOfTextblock(l > 0 ? "forward" : "backward")) {
        let u = jh(e.state, l);
        return u && u instanceof pl ? Ht(e, u) : !1;
      } else if (!(fe && n.indexOf("m") > -1)) {
        let u = t.$head, i = u.textOffset ? null : l < 0 ? u.nodeBefore : u.nodeAfter, s;
        if (!i || i.isText)
          return !1;
        let r = l < 0 ? u.pos - i.nodeSize : u.pos;
        return i.isAtom || (s = e.docView.descAt(r)) && !s.contentDOM ? pl.isSelectable(i) ? Ht(e, new pl(l < 0 ? e.state.doc.resolve(u.pos - i.nodeSize) : u)) : Hs ? Ht(e, new Cl(e.state.doc.resolve(l < 0 ? r : r + i.nodeSize))) : !1 : !1;
      }
    } else
      return !1;
  else {
    if (t instanceof pl && t.node.isInline)
      return Ht(e, new Cl(l > 0 ? t.$to : t.$from));
    {
      let u = jh(e.state, l);
      return u ? Ht(e, u) : !1;
    }
  }
}
function Vr(e) {
  return e.nodeType == 3 ? e.nodeValue.length : e.childNodes.length;
}
function ts(e, l) {
  let n = e.pmViewDesc;
  return n && n.size == 0 && (l < 0 || e.nextSibling || e.nodeName != "BR");
}
function qu(e, l) {
  return l < 0 ? gA(e) : vA(e);
}
function gA(e) {
  let l = e.domSelectionRange(), n = l.focusNode, t = l.focusOffset;
  if (!n)
    return;
  let u, i, s = !1;
  for (He && n.nodeType == 1 && t < Vr(n) && ts(n.childNodes[t], -1) && (s = !0); ; )
    if (t > 0) {
      if (n.nodeType != 1)
        break;
      {
        let r = n.childNodes[t - 1];
        if (ts(r, -1))
          u = n, i = --t;
        else if (r.nodeType == 3)
          n = r, t = n.nodeValue.length;
        else
          break;
      }
    } else {
      if (g4(n))
        break;
      {
        let r = n.previousSibling;
        for (; r && ts(r, -1); )
          u = n.parentNode, i = zn(r), r = r.previousSibling;
        if (r)
          n = r, t = Vr(n);
        else {
          if (n = n.parentNode, n == e.dom)
            break;
          t = 0;
        }
      }
    }
  s ? Uh(e, n, t) : u && Uh(e, u, i);
}
function vA(e) {
  let l = e.domSelectionRange(), n = l.focusNode, t = l.focusOffset;
  if (!n)
    return;
  let u = Vr(n), i, s;
  for (; ; )
    if (t < u) {
      if (n.nodeType != 1)
        break;
      let r = n.childNodes[t];
      if (ts(r, 1))
        i = n, s = ++t;
      else
        break;
    } else {
      if (g4(n))
        break;
      {
        let r = n.nextSibling;
        for (; r && ts(r, 1); )
          i = r.parentNode, s = zn(r) + 1, r = r.nextSibling;
        if (r)
          n = r, t = 0, u = Vr(n);
        else {
          if (n = n.parentNode, n == e.dom)
            break;
          t = u = 0;
        }
      }
    }
  i && Uh(e, i, s);
}
function g4(e) {
  let l = e.pmViewDesc;
  return l && l.node && l.node.isBlock;
}
function yA(e, l) {
  for (; e && l == e.childNodes.length && !jf(e); )
    l = zn(e) + 1, e = e.parentNode;
  for (; e && l < e.childNodes.length; ) {
    let n = e.childNodes[l];
    if (n.nodeType == 3)
      return n;
    if (n.nodeType == 1 && n.contentEditable == "false")
      break;
    e = n, l = 0;
  }
}
function $A(e, l) {
  for (; e && !l && !jf(e); )
    l = zn(e), e = e.parentNode;
  for (; e && l; ) {
    let n = e.childNodes[l - 1];
    if (n.nodeType == 3)
      return n;
    if (n.nodeType == 1 && n.contentEditable == "false")
      break;
    e = n, l = e.childNodes.length;
  }
}
function Uh(e, l, n) {
  if (l.nodeType != 3) {
    let i, s;
    (s = yA(l, n)) ? (l = s, n = 0) : (i = $A(l, n)) && (l = i, n = i.nodeValue.length);
  }
  let t = e.domSelection();
  if (ra(t)) {
    let i = document.createRange();
    i.setEnd(l, n), i.setStart(l, n), t.removeAllRanges(), t.addRange(i);
  } else
    t.extend && t.extend(l, n);
  e.domObserver.setCurSelection();
  let { state: u } = e;
  setTimeout(() => {
    e.state == u && xt(e);
  }, 50);
}
function Lm(e, l) {
  let n = e.state.doc.resolve(l);
  if (!(Rn || HM) && n.parent.inlineContent) {
    let u = e.coordsAtPos(l);
    if (l > n.start()) {
      let i = e.coordsAtPos(l - 1), s = (i.top + i.bottom) / 2;
      if (s > u.top && s < u.bottom && Math.abs(i.left - u.left) > 1)
        return i.left < u.left ? "ltr" : "rtl";
    }
    if (l < n.end()) {
      let i = e.coordsAtPos(l + 1), s = (i.top + i.bottom) / 2;
      if (s > u.top && s < u.bottom && Math.abs(i.left - u.left) > 1)
        return i.left > u.left ? "ltr" : "rtl";
    }
  }
  return getComputedStyle(e.dom).direction == "rtl" ? "rtl" : "ltr";
}
function Pm(e, l, n) {
  let t = e.state.selection;
  if (t instanceof Cl && !t.empty || n.indexOf("s") > -1 || fe && n.indexOf("m") > -1)
    return !1;
  let { $from: u, $to: i } = t;
  if (!u.parent.inlineContent || e.endOfTextblock(l < 0 ? "up" : "down")) {
    let s = jh(e.state, l);
    if (s && s instanceof pl)
      return Ht(e, s);
  }
  if (!u.parent.inlineContent) {
    let s = l < 0 ? u : i, r = t instanceof Fe ? xl.near(s, l) : xl.findFrom(s, l);
    return r ? Ht(e, r) : !1;
  }
  return !1;
}
function Bm(e, l) {
  if (!(e.state.selection instanceof Cl))
    return !0;
  let { $head: n, $anchor: t, empty: u } = e.state.selection;
  if (!n.sameParent(t))
    return !0;
  if (!u)
    return !1;
  if (e.endOfTextblock(l > 0 ? "forward" : "backward"))
    return !0;
  let i = !n.textOffset && (l < 0 ? n.nodeBefore : n.nodeAfter);
  if (i && !i.isText) {
    let s = e.state.tr;
    return l < 0 ? s.delete(n.pos - i.nodeSize, n.pos) : s.delete(n.pos, n.pos + i.nodeSize), e.dispatch(s), !0;
  }
  return !1;
}
function Fm(e, l, n) {
  e.domObserver.stop(), l.contentEditable = n, e.domObserver.start();
}
function bA(e) {
  if (!jn || e.state.selection.$head.parentOffset > 0)
    return !1;
  let { focusNode: l, focusOffset: n } = e.domSelectionRange();
  if (l && l.nodeType == 1 && n == 0 && l.firstChild && l.firstChild.contentEditable == "false") {
    let t = l.firstChild;
    Fm(e, t, "true"), setTimeout(() => Fm(e, t, "false"), 20);
  }
  return !1;
}
function wA(e) {
  let l = "";
  return e.ctrlKey && (l += "c"), e.metaKey && (l += "m"), e.altKey && (l += "a"), e.shiftKey && (l += "s"), l;
}
function _A(e, l) {
  let n = l.keyCode, t = wA(l);
  if (n == 8 || fe && n == 72 && t == "c")
    return Bm(e, -1) || qu(e, -1);
  if (n == 46 && !l.shiftKey || fe && n == 68 && t == "c")
    return Bm(e, 1) || qu(e, 1);
  if (n == 13 || n == 27)
    return !0;
  if (n == 37 || fe && n == 66 && t == "c") {
    let u = n == 37 ? Lm(e, e.state.selection.from) == "ltr" ? -1 : 1 : -1;
    return Nm(e, u, t) || qu(e, u);
  } else if (n == 39 || fe && n == 70 && t == "c") {
    let u = n == 39 ? Lm(e, e.state.selection.from) == "ltr" ? 1 : -1 : 1;
    return Nm(e, u, t) || qu(e, u);
  } else {
    if (n == 38 || fe && n == 80 && t == "c")
      return Pm(e, -1, t) || qu(e, -1);
    if (n == 40 || fe && n == 78 && t == "c")
      return bA(e) || Pm(e, 1, t) || qu(e, 1);
    if (t == (fe ? "m" : "c") && (n == 66 || n == 73 || n == 89 || n == 90))
      return !0;
  }
  return !1;
}
function v4(e, l) {
  e.someProp("transformCopied", (f) => {
    l = f(l, e);
  });
  let n = [], { content: t, openStart: u, openEnd: i } = l;
  for (; u > 1 && i > 1 && t.childCount == 1 && t.firstChild.childCount == 1; ) {
    u--, i--;
    let f = t.firstChild;
    n.push(f.type.name, f.attrs != f.type.defaultAttrs ? f.attrs : null), t = f.content;
  }
  let s = e.someProp("clipboardSerializer") || st.fromSchema(e.state.schema), r = S4(), o = r.createElement("div");
  o.appendChild(s.serializeFragment(t, { document: r }));
  let a = o.firstChild, d, h = 0;
  for (; a && a.nodeType == 1 && (d = _4[a.nodeName.toLowerCase()]); ) {
    for (let f = d.length - 1; f >= 0; f--) {
      let m = r.createElement(d[f]);
      for (; o.firstChild; )
        m.appendChild(o.firstChild);
      o.appendChild(m), h++;
    }
    a = o.firstChild;
  }
  a && a.nodeType == 1 && a.setAttribute("data-pm-slice", `${u} ${i}${h ? ` -${h}` : ""} ${JSON.stringify(n)}`);
  let p = e.someProp("clipboardTextSerializer", (f) => f(l, e)) || l.content.textBetween(0, l.content.size, `

`);
  return { dom: o, text: p };
}
function y4(e, l, n, t, u) {
  let i = u.parent.type.spec.code, s, r;
  if (!n && !l)
    return null;
  let o = l && (t || i || !n);
  if (o) {
    if (e.someProp("transformPastedText", (p) => {
      l = p(l, i || t, e);
    }), i)
      return l ? new nl(j.from(e.state.schema.text(l.replace(/\r\n?/g, `
`))), 0, 0) : nl.empty;
    let h = e.someProp("clipboardTextParser", (p) => p(l, u, t, e));
    if (h)
      r = h;
    else {
      let p = u.marks(), { schema: f } = e.state, m = st.fromSchema(f);
      s = document.createElement("div"), l.split(/(?:\r\n?|\n)+/).forEach((g) => {
        let v = s.appendChild(document.createElement("p"));
        g && v.appendChild(m.serializeNode(f.text(g, p)));
      });
    }
  } else
    e.someProp("transformPastedHTML", (h) => {
      n = h(n, e);
    }), s = TA(n), Hs && OA(s);
  let a = s && s.querySelector("[data-pm-slice]"), d = a && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(a.getAttribute("data-pm-slice") || "");
  if (d && d[3])
    for (let h = +d[3]; h > 0; h--) {
      let p = s.firstChild;
      for (; p && p.nodeType != 1; )
        p = p.nextSibling;
      if (!p)
        break;
      s = p;
    }
  if (r || (r = (e.someProp("clipboardParser") || e.someProp("domParser") || Ff.fromSchema(e.state.schema)).parseSlice(s, {
    preserveWhitespace: !!(o || d),
    context: u,
    ruleFromNode(p) {
      return p.nodeName == "BR" && !p.nextSibling && p.parentNode && !SA.test(p.parentNode.nodeName) ? { ignore: !0 } : null;
    }
  })), d)
    r = kA(Hm(r, +d[1], +d[2]), d[4]);
  else if (r = nl.maxOpen(CA(r.content, u), !0), r.openStart || r.openEnd) {
    let h = 0, p = 0;
    for (let f = r.content.firstChild; h < r.openStart && !f.type.spec.isolating; h++, f = f.firstChild)
      ;
    for (let f = r.content.lastChild; p < r.openEnd && !f.type.spec.isolating; p++, f = f.lastChild)
      ;
    r = Hm(r, h, p);
  }
  return e.someProp("transformPasted", (h) => {
    r = h(r, e);
  }), r;
}
const SA = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function CA(e, l) {
  if (e.childCount < 2)
    return e;
  for (let n = l.depth; n >= 0; n--) {
    let u = l.node(n).contentMatchAt(l.index(n)), i, s = [];
    if (e.forEach((r) => {
      if (!s)
        return;
      let o = u.findWrapping(r.type), a;
      if (!o)
        return s = null;
      if (a = s.length && i.length && b4(o, i, r, s[s.length - 1], 0))
        s[s.length - 1] = a;
      else {
        s.length && (s[s.length - 1] = w4(s[s.length - 1], i.length));
        let d = $4(r, o);
        s.push(d), u = u.matchType(d.type), i = o;
      }
    }), s)
      return j.from(s);
  }
  return e;
}
function $4(e, l, n = 0) {
  for (let t = l.length - 1; t >= n; t--)
    e = l[t].create(null, j.from(e));
  return e;
}
function b4(e, l, n, t, u) {
  if (u < e.length && u < l.length && e[u] == l[u]) {
    let i = b4(e, l, n, t.lastChild, u + 1);
    if (i)
      return t.copy(t.content.replaceChild(t.childCount - 1, i));
    if (t.contentMatchAt(t.childCount).matchType(u == e.length - 1 ? n.type : e[u + 1]))
      return t.copy(t.content.append(j.from($4(n, e, u + 1))));
  }
}
function w4(e, l) {
  if (l == 0)
    return e;
  let n = e.content.replaceChild(e.childCount - 1, w4(e.lastChild, l - 1)), t = e.contentMatchAt(e.childCount).fillBefore(j.empty, !0);
  return e.copy(n.append(t));
}
function Wh(e, l, n, t, u, i) {
  let s = l < 0 ? e.firstChild : e.lastChild, r = s.content;
  return e.childCount > 1 && (i = 0), u < t - 1 && (r = Wh(r, l, n, t, u + 1, i)), u >= n && (r = l < 0 ? s.contentMatchAt(0).fillBefore(r, i <= u).append(r) : r.append(s.contentMatchAt(s.childCount).fillBefore(j.empty, !0))), e.replaceChild(l < 0 ? 0 : e.childCount - 1, s.copy(r));
}
function Hm(e, l, n) {
  return l < e.openStart && (e = new nl(Wh(e.content, -1, l, e.openStart, 0, e.openEnd), l, e.openEnd)), n < e.openEnd && (e = new nl(Wh(e.content, 1, n, e.openEnd, 0, 0), e.openStart, n)), e;
}
const _4 = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
let zm = null;
function S4() {
  return zm || (zm = document.implementation.createHTMLDocument("title"));
}
function TA(e) {
  let l = /^(\s*<meta [^>]*>)*/.exec(e);
  l && (e = e.slice(l[0].length));
  let n = S4().createElement("div"), t = /<([a-z][^>\s]+)/i.exec(e), u;
  if ((u = t && _4[t[1].toLowerCase()]) && (e = u.map((i) => "<" + i + ">").join("") + e + u.map((i) => "</" + i + ">").reverse().join("")), n.innerHTML = e, u)
    for (let i = 0; i < u.length; i++)
      n = n.querySelector(u[i]) || n;
  return n;
}
function OA(e) {
  let l = e.querySelectorAll(Rn ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (let n = 0; n < l.length; n++) {
    let t = l[n];
    t.childNodes.length == 1 && t.textContent == " " && t.parentNode && t.parentNode.replaceChild(e.ownerDocument.createTextNode(" "), t);
  }
}
function kA(e, l) {
  if (!e.size)
    return e;
  let n = e.content.firstChild.type.schema, t;
  try {
    t = JSON.parse(l);
  } catch {
    return e;
  }
  let { content: u, openStart: i, openEnd: s } = e;
  for (let r = t.length - 2; r >= 0; r -= 2) {
    let o = n.nodes[t[r]];
    if (!o || o.hasRequiredAttrs())
      break;
    u = j.from(o.create(t[r + 1], u)), i++, s++;
  }
  return new nl(u, i, s);
}
const Un = {}, Wn = {}, MA = { touchstart: !0, touchmove: !0 };
class AA {
  constructor() {
    this.shiftKey = !1, this.mouseDown = null, this.lastKeyCode = null, this.lastKeyCodeTime = 0, this.lastClick = { time: 0, x: 0, y: 0, type: "" }, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastIOSEnter = 0, this.lastIOSEnterFallbackTimeout = -1, this.lastFocus = 0, this.lastTouch = 0, this.lastAndroidDelete = 0, this.composing = !1, this.composingTimeout = -1, this.compositionNodes = [], this.compositionEndedAt = -2e8, this.compositionID = 1, this.compositionPendingChanges = 0, this.domChangeCount = 0, this.eventHandlers = /* @__PURE__ */ Object.create(null), this.hideSelectionGuard = null;
  }
}
function xA(e) {
  for (let l in Un) {
    let n = Un[l];
    e.dom.addEventListener(l, e.input.eventHandlers[l] = (t) => {
      IA(e, t) && !Kf(e, t) && (e.editable || !(t.type in Wn)) && n(e, t);
    }, MA[l] ? { passive: !0 } : void 0);
  }
  jn && e.dom.addEventListener("input", () => null), Gh(e);
}
function Jt(e, l) {
  e.input.lastSelectionOrigin = l, e.input.lastSelectionTime = Date.now();
}
function EA(e) {
  e.domObserver.stop();
  for (let l in e.input.eventHandlers)
    e.dom.removeEventListener(l, e.input.eventHandlers[l]);
  clearTimeout(e.input.composingTimeout), clearTimeout(e.input.lastIOSEnterFallbackTimeout);
}
function Gh(e) {
  e.someProp("handleDOMEvents", (l) => {
    for (let n in l)
      e.input.eventHandlers[n] || e.dom.addEventListener(n, e.input.eventHandlers[n] = (t) => Kf(e, t));
  });
}
function Kf(e, l) {
  return e.someProp("handleDOMEvents", (n) => {
    let t = n[l.type];
    return t ? t(e, l) || l.defaultPrevented : !1;
  });
}
function IA(e, l) {
  if (!l.bubbles)
    return !0;
  if (l.defaultPrevented)
    return !1;
  for (let n = l.target; n != e.dom; n = n.parentNode)
    if (!n || n.nodeType == 11 || n.pmViewDesc && n.pmViewDesc.stopEvent(l))
      return !1;
  return !0;
}
function RA(e, l) {
  !Kf(e, l) && Un[l.type] && (e.editable || !(l.type in Wn)) && Un[l.type](e, l);
}
Wn.keydown = (e, l) => {
  let n = l;
  if (e.input.shiftKey = n.keyCode == 16 || n.shiftKey, !T4(e, n) && (e.input.lastKeyCode = n.keyCode, e.input.lastKeyCodeTime = Date.now(), !(xe && Rn && n.keyCode == 13)))
    if (n.keyCode != 229 && e.domObserver.forceFlush(), _i && n.keyCode == 13 && !n.ctrlKey && !n.altKey && !n.metaKey) {
      let t = Date.now();
      e.input.lastIOSEnter = t, e.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
        e.input.lastIOSEnter == t && (e.someProp("handleKeyDown", (u) => u(e, $u(13, "Enter"))), e.input.lastIOSEnter = 0);
      }, 200);
    } else
      e.someProp("handleKeyDown", (t) => t(e, n)) || _A(e, n) ? n.preventDefault() : Jt(e, "key");
};
Wn.keyup = (e, l) => {
  l.keyCode == 16 && (e.input.shiftKey = !1);
};
Wn.keypress = (e, l) => {
  let n = l;
  if (T4(e, n) || !n.charCode || n.ctrlKey && !n.altKey || fe && n.metaKey)
    return;
  if (e.someProp("handleKeyPress", (u) => u(e, n))) {
    n.preventDefault();
    return;
  }
  let t = e.state.selection;
  if (!(t instanceof Cl) || !t.$from.sameParent(t.$to)) {
    let u = String.fromCharCode(n.charCode);
    !/[\r\n]/.test(u) && !e.someProp("handleTextInput", (i) => i(e, t.$from.pos, t.$to.pos, u)) && e.dispatch(e.state.tr.insertText(u).scrollIntoView()), n.preventDefault();
  }
};
function aa(e) {
  return { left: e.clientX, top: e.clientY };
}
function DA(e, l) {
  let n = l.x - e.clientX, t = l.y - e.clientY;
  return n * n + t * t < 100;
}
function Yf(e, l, n, t, u) {
  if (t == -1)
    return !1;
  let i = e.state.doc.resolve(t);
  for (let s = i.depth + 1; s > 0; s--)
    if (e.someProp(l, (r) => s > i.depth ? r(e, n, i.nodeAfter, i.before(s), u, !0) : r(e, n, i.node(s), i.before(s), u, !1)))
      return !0;
  return !1;
}
function pi(e, l, n) {
  e.focused || e.focus();
  let t = e.state.tr.setSelection(l);
  n == "pointer" && t.setMeta("pointer", !0), e.dispatch(t);
}
function NA(e, l) {
  if (l == -1)
    return !1;
  let n = e.state.doc.resolve(l), t = n.nodeAfter;
  return t && t.isAtom && pl.isSelectable(t) ? (pi(e, new pl(n), "pointer"), !0) : !1;
}
function LA(e, l) {
  if (l == -1)
    return !1;
  let n = e.state.selection, t, u;
  n instanceof pl && (t = n.node);
  let i = e.state.doc.resolve(l);
  for (let s = i.depth + 1; s > 0; s--) {
    let r = s > i.depth ? i.nodeAfter : i.node(s);
    if (pl.isSelectable(r)) {
      t && n.$from.depth > 0 && s >= n.$from.depth && i.before(n.$from.depth + 1) == n.$from.pos ? u = i.before(n.$from.depth) : u = i.before(s);
      break;
    }
  }
  return u != null ? (pi(e, pl.create(e.state.doc, u), "pointer"), !0) : !1;
}
function PA(e, l, n, t, u) {
  return Yf(e, "handleClickOn", l, n, t) || e.someProp("handleClick", (i) => i(e, l, t)) || (u ? LA(e, n) : NA(e, n));
}
function BA(e, l, n, t) {
  return Yf(e, "handleDoubleClickOn", l, n, t) || e.someProp("handleDoubleClick", (u) => u(e, l, t));
}
function FA(e, l, n, t) {
  return Yf(e, "handleTripleClickOn", l, n, t) || e.someProp("handleTripleClick", (u) => u(e, l, t)) || HA(e, n, t);
}
function HA(e, l, n) {
  if (n.button != 0)
    return !1;
  let t = e.state.doc;
  if (l == -1)
    return t.inlineContent ? (pi(e, Cl.create(t, 0, t.content.size), "pointer"), !0) : !1;
  let u = t.resolve(l);
  for (let i = u.depth + 1; i > 0; i--) {
    let s = i > u.depth ? u.nodeAfter : u.node(i), r = u.before(i);
    if (s.inlineContent)
      pi(e, Cl.create(t, r + 1, r + 1 + s.content.size), "pointer");
    else if (pl.isSelectable(s))
      pi(e, pl.create(t, r), "pointer");
    else
      continue;
    return !0;
  }
}
function qf(e) {
  return jr(e);
}
const C4 = fe ? "metaKey" : "ctrlKey";
Un.mousedown = (e, l) => {
  let n = l;
  e.input.shiftKey = n.shiftKey;
  let t = qf(e), u = Date.now(), i = "singleClick";
  u - e.input.lastClick.time < 500 && DA(n, e.input.lastClick) && !n[C4] && (e.input.lastClick.type == "singleClick" ? i = "doubleClick" : e.input.lastClick.type == "doubleClick" && (i = "tripleClick")), e.input.lastClick = { time: u, x: n.clientX, y: n.clientY, type: i };
  let s = e.posAtCoords(aa(n));
  s && (i == "singleClick" ? (e.input.mouseDown && e.input.mouseDown.done(), e.input.mouseDown = new zA(e, s, n, !!t)) : (i == "doubleClick" ? BA : FA)(e, s.pos, s.inside, n) ? n.preventDefault() : Jt(e, "pointer"));
};
class zA {
  constructor(l, n, t, u) {
    this.view = l, this.pos = n, this.event = t, this.flushed = u, this.delayedSelectionSync = !1, this.mightDrag = null, this.startDoc = l.state.doc, this.selectNode = !!t[C4], this.allowDefault = t.shiftKey;
    let i, s;
    if (n.inside > -1)
      i = l.state.doc.nodeAt(n.inside), s = n.inside;
    else {
      let d = l.state.doc.resolve(n.pos);
      i = d.parent, s = d.depth ? d.before() : 0;
    }
    const r = u ? null : t.target, o = r ? l.docView.nearestDesc(r, !0) : null;
    this.target = o ? o.dom : null;
    let { selection: a } = l.state;
    (t.button == 0 && i.type.spec.draggable && i.type.spec.selectable !== !1 || a instanceof pl && a.from <= s && a.to > s) && (this.mightDrag = {
      node: i,
      pos: s,
      addAttr: !!(this.target && !this.target.draggable),
      setUneditable: !!(this.target && He && !this.target.hasAttribute("contentEditable"))
    }), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(() => {
      this.view.input.mouseDown == this && this.target.setAttribute("contentEditable", "false");
    }, 20), this.view.domObserver.start()), l.root.addEventListener("mouseup", this.up = this.up.bind(this)), l.root.addEventListener("mousemove", this.move = this.move.bind(this)), Jt(l, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.delayedSelectionSync && setTimeout(() => xt(this.view)), this.view.input.mouseDown = null;
  }
  up(l) {
    if (this.done(), !this.view.dom.contains(l.target))
      return;
    let n = this.pos;
    this.view.state.doc != this.startDoc && (n = this.view.posAtCoords(aa(l))), this.updateAllowDefault(l), this.allowDefault || !n ? Jt(this.view, "pointer") : PA(this.view, n.pos, n.inside, l, this.selectNode) ? l.preventDefault() : l.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
    jn && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
    // cursor, but still report that the node is selected
    // when asked through getSelection. You'll then get a
    // situation where clicking at the point where that
    // (hidden) cursor is doesn't change the selection, and
    // thus doesn't get a reaction from ProseMirror. This
    // works around that.
    Rn && !this.view.state.selection.visible && Math.min(Math.abs(n.pos - this.view.state.selection.from), Math.abs(n.pos - this.view.state.selection.to)) <= 2) ? (pi(this.view, xl.near(this.view.state.doc.resolve(n.pos)), "pointer"), l.preventDefault()) : Jt(this.view, "pointer");
  }
  move(l) {
    this.updateAllowDefault(l), Jt(this.view, "pointer"), l.buttons == 0 && this.done();
  }
  updateAllowDefault(l) {
    !this.allowDefault && (Math.abs(this.event.x - l.clientX) > 4 || Math.abs(this.event.y - l.clientY) > 4) && (this.allowDefault = !0);
  }
}
Un.touchstart = (e) => {
  e.input.lastTouch = Date.now(), qf(e), Jt(e, "pointer");
};
Un.touchmove = (e) => {
  e.input.lastTouch = Date.now(), Jt(e, "pointer");
};
Un.contextmenu = (e) => qf(e);
function T4(e, l) {
  return e.composing ? !0 : jn && Math.abs(l.timeStamp - e.input.compositionEndedAt) < 500 ? (e.input.compositionEndedAt = -2e8, !0) : !1;
}
const VA = xe ? 5e3 : -1;
Wn.compositionstart = Wn.compositionupdate = (e) => {
  if (!e.composing) {
    e.domObserver.flush();
    let { state: l } = e, n = l.selection.$from;
    if (l.selection.empty && (l.storedMarks || !n.textOffset && n.parentOffset && n.nodeBefore.marks.some((t) => t.type.spec.inclusive === !1)))
      e.markCursor = e.state.storedMarks || n.marks(), jr(e, !0), e.markCursor = null;
    else if (jr(e), He && l.selection.empty && n.parentOffset && !n.textOffset && n.nodeBefore.marks.length) {
      let t = e.domSelectionRange();
      for (let u = t.focusNode, i = t.focusOffset; u && u.nodeType == 1 && i != 0; ) {
        let s = i < 0 ? u.lastChild : u.childNodes[i - 1];
        if (!s)
          break;
        if (s.nodeType == 3) {
          e.domSelection().collapse(s, s.nodeValue.length);
          break;
        } else
          u = s, i = -1;
      }
    }
    e.input.composing = !0;
  }
  O4(e, VA);
};
Wn.compositionend = (e, l) => {
  e.composing && (e.input.composing = !1, e.input.compositionEndedAt = l.timeStamp, e.input.compositionPendingChanges = e.domObserver.pendingRecords().length ? e.input.compositionID : 0, e.input.compositionPendingChanges && Promise.resolve().then(() => e.domObserver.flush()), e.input.compositionID++, O4(e, 20));
};
function O4(e, l) {
  clearTimeout(e.input.composingTimeout), l > -1 && (e.input.composingTimeout = setTimeout(() => jr(e), l));
}
function k4(e) {
  for (e.composing && (e.input.composing = !1, e.input.compositionEndedAt = jA()); e.input.compositionNodes.length > 0; )
    e.input.compositionNodes.pop().markParentsDirty();
}
function jA() {
  let e = document.createEvent("Event");
  return e.initEvent("event", !0, !0), e.timeStamp;
}
function jr(e, l = !1) {
  if (!(xe && e.domObserver.flushingSoon >= 0)) {
    if (e.domObserver.forceFlush(), k4(e), l || e.docView && e.docView.dirty) {
      let n = Wf(e);
      return n && !n.eq(e.state.selection) ? e.dispatch(e.state.tr.setSelection(n)) : e.updateState(e.state), !0;
    }
    return !1;
  }
}
function UA(e, l) {
  if (!e.dom.parentNode)
    return;
  let n = e.dom.parentNode.appendChild(document.createElement("div"));
  n.appendChild(l), n.style.cssText = "position: fixed; left: -10000px; top: 10px";
  let t = getSelection(), u = document.createRange();
  u.selectNodeContents(l), e.dom.blur(), t.removeAllRanges(), t.addRange(u), setTimeout(() => {
    n.parentNode && n.parentNode.removeChild(n), e.focus();
  }, 50);
}
const Os = Zn && Xt < 15 || _i && zM < 604;
Un.copy = Wn.cut = (e, l) => {
  let n = l, t = e.state.selection, u = n.type == "cut";
  if (t.empty)
    return;
  let i = Os ? null : n.clipboardData, s = t.content(), { dom: r, text: o } = v4(e, s);
  i ? (n.preventDefault(), i.clearData(), i.setData("text/html", r.innerHTML), i.setData("text/plain", o)) : UA(e, r), u && e.dispatch(e.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function WA(e) {
  return e.openStart == 0 && e.openEnd == 0 && e.content.childCount == 1 ? e.content.firstChild : null;
}
function GA(e, l) {
  if (!e.dom.parentNode)
    return;
  let n = e.input.shiftKey || e.state.selection.$from.parent.type.spec.code, t = e.dom.parentNode.appendChild(document.createElement(n ? "textarea" : "div"));
  n || (t.contentEditable = "true"), t.style.cssText = "position: fixed; left: -10000px; top: 10px", t.focus();
  let u = e.input.shiftKey && e.input.lastKeyCode != 45;
  setTimeout(() => {
    e.focus(), t.parentNode && t.parentNode.removeChild(t), n ? ks(e, t.value, null, u, l) : ks(e, t.textContent, t.innerHTML, u, l);
  }, 50);
}
function ks(e, l, n, t, u) {
  let i = y4(e, l, n, t, e.state.selection.$from);
  if (e.someProp("handlePaste", (o) => o(e, u, i || nl.empty)))
    return !0;
  if (!i)
    return !1;
  let s = WA(i), r = s ? e.state.tr.replaceSelectionWith(s, t) : e.state.tr.replaceSelection(i);
  return e.dispatch(r.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
function M4(e) {
  let l = e.getData("text/plain") || e.getData("Text");
  if (l)
    return l;
  let n = e.getData("text/uri-list");
  return n ? n.replace(/\r?\n/g, " ") : "";
}
Wn.paste = (e, l) => {
  let n = l;
  if (e.composing && !xe)
    return;
  let t = Os ? null : n.clipboardData, u = e.input.shiftKey && e.input.lastKeyCode != 45;
  t && ks(e, M4(t), t.getData("text/html"), u, n) ? n.preventDefault() : GA(e, n);
};
class A4 {
  constructor(l, n, t) {
    this.slice = l, this.move = n, this.node = t;
  }
}
const x4 = fe ? "altKey" : "ctrlKey";
Un.dragstart = (e, l) => {
  let n = l, t = e.input.mouseDown;
  if (t && t.done(), !n.dataTransfer)
    return;
  let u = e.state.selection, i = u.empty ? null : e.posAtCoords(aa(n)), s;
  if (!(i && i.pos >= u.from && i.pos <= (u instanceof pl ? u.to - 1 : u.to))) {
    if (t && t.mightDrag)
      s = pl.create(e.state.doc, t.mightDrag.pos);
    else if (n.target && n.target.nodeType == 1) {
      let d = e.docView.nearestDesc(n.target, !0);
      d && d.node.type.spec.draggable && d != e.docView && (s = pl.create(e.state.doc, d.posBefore));
    }
  }
  let r = (s || e.state.selection).content(), { dom: o, text: a } = v4(e, r);
  n.dataTransfer.clearData(), n.dataTransfer.setData(Os ? "Text" : "text/html", o.innerHTML), n.dataTransfer.effectAllowed = "copyMove", Os || n.dataTransfer.setData("text/plain", a), e.dragging = new A4(r, !n[x4], s);
};
Un.dragend = (e) => {
  let l = e.dragging;
  window.setTimeout(() => {
    e.dragging == l && (e.dragging = null);
  }, 50);
};
Wn.dragover = Wn.dragenter = (e, l) => l.preventDefault();
Wn.drop = (e, l) => {
  let n = l, t = e.dragging;
  if (e.dragging = null, !n.dataTransfer)
    return;
  let u = e.posAtCoords(aa(n));
  if (!u)
    return;
  let i = e.state.doc.resolve(u.pos), s = t && t.slice;
  s ? e.someProp("transformPasted", (m) => {
    s = m(s, e);
  }) : s = y4(e, M4(n.dataTransfer), Os ? null : n.dataTransfer.getData("text/html"), !1, i);
  let r = !!(t && !n[x4]);
  if (e.someProp("handleDrop", (m) => m(e, n, s || nl.empty, r))) {
    n.preventDefault();
    return;
  }
  if (!s)
    return;
  n.preventDefault();
  let o = s ? Kv(e.state.doc, i.pos, s) : i.pos;
  o == null && (o = i.pos);
  let a = e.state.tr;
  if (r) {
    let { node: m } = t;
    m ? m.replace(a) : a.deleteSelection();
  }
  let d = a.mapping.map(o), h = s.openStart == 0 && s.openEnd == 0 && s.content.childCount == 1, p = a.doc;
  if (h ? a.replaceRangeWith(d, d, s.content.firstChild) : a.replaceRange(d, d, s), a.doc.eq(p))
    return;
  let f = a.doc.resolve(d);
  if (h && pl.isSelectable(s.content.firstChild) && f.nodeAfter && f.nodeAfter.sameMarkup(s.content.firstChild))
    a.setSelection(new pl(f));
  else {
    let m = a.mapping.map(o);
    a.mapping.maps[a.mapping.maps.length - 1].forEach((g, v, w, $) => m = $), a.setSelection(Gf(e, f, a.doc.resolve(m)));
  }
  e.focus(), e.dispatch(a.setMeta("uiEvent", "drop"));
};
Un.focus = (e) => {
  e.input.lastFocus = Date.now(), e.focused || (e.domObserver.stop(), e.dom.classList.add("ProseMirror-focused"), e.domObserver.start(), e.focused = !0, setTimeout(() => {
    e.docView && e.hasFocus() && !e.domObserver.currentSelection.eq(e.domSelectionRange()) && xt(e);
  }, 20));
};
Un.blur = (e, l) => {
  let n = l;
  e.focused && (e.domObserver.stop(), e.dom.classList.remove("ProseMirror-focused"), e.domObserver.start(), n.relatedTarget && e.dom.contains(n.relatedTarget) && e.domObserver.currentSelection.clear(), e.focused = !1);
};
Un.beforeinput = (e, l) => {
  if (Rn && xe && l.inputType == "deleteContentBackward") {
    e.domObserver.flushSoon();
    let { domChangeCount: t } = e.input;
    setTimeout(() => {
      if (e.input.domChangeCount != t || (e.dom.blur(), e.focus(), e.someProp("handleKeyDown", (i) => i(e, $u(8, "Backspace")))))
        return;
      let { $cursor: u } = e.state.selection;
      u && u.pos > 0 && e.dispatch(e.state.tr.delete(u.pos - 1, u.pos).scrollIntoView());
    }, 50);
  }
};
for (let e in Wn)
  Un[e] = Wn[e];
function Ms(e, l) {
  if (e == l)
    return !0;
  for (let n in e)
    if (e[n] !== l[n])
      return !1;
  for (let n in l)
    if (!(n in e))
      return !1;
  return !0;
}
class Ur {
  constructor(l, n) {
    this.toDOM = l, this.spec = n || xu, this.side = this.spec.side || 0;
  }
  map(l, n, t, u) {
    let { pos: i, deleted: s } = l.mapResult(n.from + u, this.side < 0 ? -1 : 1);
    return s ? null : new ve(i - t, i - t, this);
  }
  valid() {
    return !0;
  }
  eq(l) {
    return this == l || l instanceof Ur && (this.spec.key && this.spec.key == l.spec.key || this.toDOM == l.toDOM && Ms(this.spec, l.spec));
  }
  destroy(l) {
    this.spec.destroy && this.spec.destroy(l);
  }
}
class lu {
  constructor(l, n) {
    this.attrs = l, this.spec = n || xu;
  }
  map(l, n, t, u) {
    let i = l.map(n.from + u, this.spec.inclusiveStart ? -1 : 1) - t, s = l.map(n.to + u, this.spec.inclusiveEnd ? 1 : -1) - t;
    return i >= s ? null : new ve(i, s, this);
  }
  valid(l, n) {
    return n.from < n.to;
  }
  eq(l) {
    return this == l || l instanceof lu && Ms(this.attrs, l.attrs) && Ms(this.spec, l.spec);
  }
  static is(l) {
    return l.type instanceof lu;
  }
  destroy() {
  }
}
class Jf {
  constructor(l, n) {
    this.attrs = l, this.spec = n || xu;
  }
  map(l, n, t, u) {
    let i = l.mapResult(n.from + u, 1);
    if (i.deleted)
      return null;
    let s = l.mapResult(n.to + u, -1);
    return s.deleted || s.pos <= i.pos ? null : new ve(i.pos - t, s.pos - t, this);
  }
  valid(l, n) {
    let { index: t, offset: u } = l.content.findIndex(n.from), i;
    return u == n.from && !(i = l.child(t)).isText && u + i.nodeSize == n.to;
  }
  eq(l) {
    return this == l || l instanceof Jf && Ms(this.attrs, l.attrs) && Ms(this.spec, l.spec);
  }
  destroy() {
  }
}
class ve {
  /**
  @internal
  */
  constructor(l, n, t) {
    this.from = l, this.to = n, this.type = t;
  }
  /**
  @internal
  */
  copy(l, n) {
    return new ve(l, n, this.type);
  }
  /**
  @internal
  */
  eq(l, n = 0) {
    return this.type.eq(l.type) && this.from + n == l.from && this.to + n == l.to;
  }
  /**
  @internal
  */
  map(l, n, t) {
    return this.type.map(l, this, n, t);
  }
  /**
  Creates a widget decoration, which is a DOM node that's shown in
  the document at the given position. It is recommended that you
  delay rendering the widget by passing a function that will be
  called when the widget is actually drawn in a view, but you can
  also directly pass a DOM node. `getPos` can be used to find the
  widget's current document position.
  */
  static widget(l, n, t) {
    return new ve(l, l, new Ur(n, t));
  }
  /**
  Creates an inline decoration, which adds the given attributes to
  each inline node between `from` and `to`.
  */
  static inline(l, n, t, u) {
    return new ve(l, n, new lu(t, u));
  }
  /**
  Creates a node decoration. `from` and `to` should point precisely
  before and after a node in the document. That node, and only that
  node, will receive the given attributes.
  */
  static node(l, n, t, u) {
    return new ve(l, n, new Jf(t, u));
  }
  /**
  The spec provided when creating this decoration. Can be useful
  if you've stored extra information in that object.
  */
  get spec() {
    return this.type.spec;
  }
  /**
  @internal
  */
  get inline() {
    return this.type instanceof lu;
  }
  /**
  @internal
  */
  get widget() {
    return this.type instanceof Ur;
  }
}
const li = [], xu = {};
class un {
  /**
  @internal
  */
  constructor(l, n) {
    this.local = l.length ? l : li, this.children = n.length ? n : li;
  }
  /**
  Create a set of decorations, using the structure of the given
  document. This will consume (modify) the `decorations` array, so
  you must make a copy if you want need to preserve that.
  */
  static create(l, n) {
    return n.length ? Wr(n, l, 0, xu) : An;
  }
  /**
  Find all decorations in this set which touch the given range
  (including decorations that start or end directly at the
  boundaries) and match the given predicate on their spec. When
  `start` and `end` are omitted, all decorations in the set are
  considered. When `predicate` isn't given, all decorations are
  assumed to match.
  */
  find(l, n, t) {
    let u = [];
    return this.findInner(l ?? 0, n ?? 1e9, u, 0, t), u;
  }
  findInner(l, n, t, u, i) {
    for (let s = 0; s < this.local.length; s++) {
      let r = this.local[s];
      r.from <= n && r.to >= l && (!i || i(r.spec)) && t.push(r.copy(r.from + u, r.to + u));
    }
    for (let s = 0; s < this.children.length; s += 3)
      if (this.children[s] < n && this.children[s + 1] > l) {
        let r = this.children[s] + 1;
        this.children[s + 2].findInner(l - r, n - r, t, u + r, i);
      }
  }
  /**
  Map the set of decorations in response to a change in the
  document.
  */
  map(l, n, t) {
    return this == An || l.maps.length == 0 ? this : this.mapInner(l, n, 0, 0, t || xu);
  }
  /**
  @internal
  */
  mapInner(l, n, t, u, i) {
    let s;
    for (let r = 0; r < this.local.length; r++) {
      let o = this.local[r].map(l, t, u);
      o && o.type.valid(n, o) ? (s || (s = [])).push(o) : i.onRemove && i.onRemove(this.local[r].spec);
    }
    return this.children.length ? KA(this.children, s || [], l, n, t, u, i) : s ? new un(s.sort(Eu), li) : An;
  }
  /**
  Add the given array of decorations to the ones in the set,
  producing a new set. Consumes the `decorations` array. Needs
  access to the current document to create the appropriate tree
  structure.
  */
  add(l, n) {
    return n.length ? this == An ? un.create(l, n) : this.addInner(l, n, 0) : this;
  }
  addInner(l, n, t) {
    let u, i = 0;
    l.forEach((r, o) => {
      let a = o + t, d;
      if (d = I4(n, r, a)) {
        for (u || (u = this.children.slice()); i < u.length && u[i] < o; )
          i += 3;
        u[i] == o ? u[i + 2] = u[i + 2].addInner(r, d, a + 1) : u.splice(i, 0, o, o + r.nodeSize, Wr(d, r, a + 1, xu)), i += 3;
      }
    });
    let s = E4(i ? R4(n) : n, -t);
    for (let r = 0; r < s.length; r++)
      s[r].type.valid(l, s[r]) || s.splice(r--, 1);
    return new un(s.length ? this.local.concat(s).sort(Eu) : this.local, u || this.children);
  }
  /**
  Create a new set that contains the decorations in this set, minus
  the ones in the given array.
  */
  remove(l) {
    return l.length == 0 || this == An ? this : this.removeInner(l, 0);
  }
  removeInner(l, n) {
    let t = this.children, u = this.local;
    for (let i = 0; i < t.length; i += 3) {
      let s, r = t[i] + n, o = t[i + 1] + n;
      for (let d = 0, h; d < l.length; d++)
        (h = l[d]) && h.from > r && h.to < o && (l[d] = null, (s || (s = [])).push(h));
      if (!s)
        continue;
      t == this.children && (t = this.children.slice());
      let a = t[i + 2].removeInner(s, r + 1);
      a != An ? t[i + 2] = a : (t.splice(i, 3), i -= 3);
    }
    if (u.length) {
      for (let i = 0, s; i < l.length; i++)
        if (s = l[i])
          for (let r = 0; r < u.length; r++)
            u[r].eq(s, n) && (u == this.local && (u = this.local.slice()), u.splice(r--, 1));
    }
    return t == this.children && u == this.local ? this : u.length || t.length ? new un(u, t) : An;
  }
  /**
  @internal
  */
  forChild(l, n) {
    if (this == An)
      return this;
    if (n.isLeaf)
      return un.empty;
    let t, u;
    for (let r = 0; r < this.children.length; r += 3)
      if (this.children[r] >= l) {
        this.children[r] == l && (t = this.children[r + 2]);
        break;
      }
    let i = l + 1, s = i + n.content.size;
    for (let r = 0; r < this.local.length; r++) {
      let o = this.local[r];
      if (o.from < s && o.to > i && o.type instanceof lu) {
        let a = Math.max(i, o.from) - i, d = Math.min(s, o.to) - i;
        a < d && (u || (u = [])).push(o.copy(a, d));
      }
    }
    if (u) {
      let r = new un(u.sort(Eu), li);
      return t ? new Gt([r, t]) : r;
    }
    return t || An;
  }
  /**
  @internal
  */
  eq(l) {
    if (this == l)
      return !0;
    if (!(l instanceof un) || this.local.length != l.local.length || this.children.length != l.children.length)
      return !1;
    for (let n = 0; n < this.local.length; n++)
      if (!this.local[n].eq(l.local[n]))
        return !1;
    for (let n = 0; n < this.children.length; n += 3)
      if (this.children[n] != l.children[n] || this.children[n + 1] != l.children[n + 1] || !this.children[n + 2].eq(l.children[n + 2]))
        return !1;
    return !0;
  }
  /**
  @internal
  */
  locals(l) {
    return Zf(this.localsInner(l));
  }
  /**
  @internal
  */
  localsInner(l) {
    if (this == An)
      return li;
    if (l.inlineContent || !this.local.some(lu.is))
      return this.local;
    let n = [];
    for (let t = 0; t < this.local.length; t++)
      this.local[t].type instanceof lu || n.push(this.local[t]);
    return n;
  }
}
un.empty = new un([], []);
un.removeOverlap = Zf;
const An = un.empty;
class Gt {
  constructor(l) {
    this.members = l;
  }
  map(l, n) {
    const t = this.members.map((u) => u.map(l, n, xu));
    return Gt.from(t);
  }
  forChild(l, n) {
    if (n.isLeaf)
      return un.empty;
    let t = [];
    for (let u = 0; u < this.members.length; u++) {
      let i = this.members[u].forChild(l, n);
      i != An && (i instanceof Gt ? t = t.concat(i.members) : t.push(i));
    }
    return Gt.from(t);
  }
  eq(l) {
    if (!(l instanceof Gt) || l.members.length != this.members.length)
      return !1;
    for (let n = 0; n < this.members.length; n++)
      if (!this.members[n].eq(l.members[n]))
        return !1;
    return !0;
  }
  locals(l) {
    let n, t = !0;
    for (let u = 0; u < this.members.length; u++) {
      let i = this.members[u].localsInner(l);
      if (i.length)
        if (!n)
          n = i;
        else {
          t && (n = n.slice(), t = !1);
          for (let s = 0; s < i.length; s++)
            n.push(i[s]);
        }
    }
    return n ? Zf(t ? n : n.sort(Eu)) : li;
  }
  // Create a group for the given array of decoration sets, or return
  // a single set when possible.
  static from(l) {
    switch (l.length) {
      case 0:
        return An;
      case 1:
        return l[0];
      default:
        return new Gt(l.every((n) => n instanceof un) ? l : l.reduce((n, t) => n.concat(t instanceof un ? t : t.members), []));
    }
  }
}
function KA(e, l, n, t, u, i, s) {
  let r = e.slice();
  for (let a = 0, d = i; a < n.maps.length; a++) {
    let h = 0;
    n.maps[a].forEach((p, f, m, g) => {
      let v = g - m - (f - p);
      for (let w = 0; w < r.length; w += 3) {
        let $ = r[w + 1];
        if ($ < 0 || p > $ + d - h)
          continue;
        let _ = r[w] + d - h;
        f >= _ ? r[w + 1] = p <= _ ? -2 : -1 : p >= d && v && (r[w] += v, r[w + 1] += v);
      }
      h += v;
    }), d = n.maps[a].map(d, -1);
  }
  let o = !1;
  for (let a = 0; a < r.length; a += 3)
    if (r[a + 1] < 0) {
      if (r[a + 1] == -2) {
        o = !0, r[a + 1] = -1;
        continue;
      }
      let d = n.map(e[a] + i), h = d - u;
      if (h < 0 || h >= t.content.size) {
        o = !0;
        continue;
      }
      let p = n.map(e[a + 1] + i, -1), f = p - u, { index: m, offset: g } = t.content.findIndex(h), v = t.maybeChild(m);
      if (v && g == h && g + v.nodeSize == f) {
        let w = r[a + 2].mapInner(n, v, d + 1, e[a] + i + 1, s);
        w != An ? (r[a] = h, r[a + 1] = f, r[a + 2] = w) : (r[a + 1] = -2, o = !0);
      } else
        o = !0;
    }
  if (o) {
    let a = YA(r, e, l, n, u, i, s), d = Wr(a, t, 0, s);
    l = d.local;
    for (let h = 0; h < r.length; h += 3)
      r[h + 1] < 0 && (r.splice(h, 3), h -= 3);
    for (let h = 0, p = 0; h < d.children.length; h += 3) {
      let f = d.children[h];
      for (; p < r.length && r[p] < f; )
        p += 3;
      r.splice(p, 0, d.children[h], d.children[h + 1], d.children[h + 2]);
    }
  }
  return new un(l.sort(Eu), r);
}
function E4(e, l) {
  if (!l || !e.length)
    return e;
  let n = [];
  for (let t = 0; t < e.length; t++) {
    let u = e[t];
    n.push(new ve(u.from + l, u.to + l, u.type));
  }
  return n;
}
function YA(e, l, n, t, u, i, s) {
  function r(o, a) {
    for (let d = 0; d < o.local.length; d++) {
      let h = o.local[d].map(t, u, a);
      h ? n.push(h) : s.onRemove && s.onRemove(o.local[d].spec);
    }
    for (let d = 0; d < o.children.length; d += 3)
      r(o.children[d + 2], o.children[d] + a + 1);
  }
  for (let o = 0; o < e.length; o += 3)
    e[o + 1] == -1 && r(e[o + 2], l[o] + i + 1);
  return n;
}
function I4(e, l, n) {
  if (l.isLeaf)
    return null;
  let t = n + l.nodeSize, u = null;
  for (let i = 0, s; i < e.length; i++)
    (s = e[i]) && s.from > n && s.to < t && ((u || (u = [])).push(s), e[i] = null);
  return u;
}
function R4(e) {
  let l = [];
  for (let n = 0; n < e.length; n++)
    e[n] != null && l.push(e[n]);
  return l;
}
function Wr(e, l, n, t) {
  let u = [], i = !1;
  l.forEach((r, o) => {
    let a = I4(e, r, o + n);
    if (a) {
      i = !0;
      let d = Wr(a, r, n + o + 1, t);
      d != An && u.push(o, o + r.nodeSize, d);
    }
  });
  let s = E4(i ? R4(e) : e, -n).sort(Eu);
  for (let r = 0; r < s.length; r++)
    s[r].type.valid(l, s[r]) || (t.onRemove && t.onRemove(s[r].spec), s.splice(r--, 1));
  return s.length || u.length ? new un(s, u) : An;
}
function Eu(e, l) {
  return e.from - l.from || e.to - l.to;
}
function Zf(e) {
  let l = e;
  for (let n = 0; n < l.length - 1; n++) {
    let t = l[n];
    if (t.from != t.to)
      for (let u = n + 1; u < l.length; u++) {
        let i = l[u];
        if (i.from == t.from) {
          i.to != t.to && (l == e && (l = e.slice()), l[u] = i.copy(i.from, t.to), Vm(l, u + 1, i.copy(t.to, i.to)));
          continue;
        } else {
          i.from < t.to && (l == e && (l = e.slice()), l[n] = t.copy(t.from, i.from), Vm(l, u, t.copy(i.from, t.to)));
          break;
        }
      }
  }
  return l;
}
function Vm(e, l, n) {
  for (; l < e.length && Eu(n, e[l]) > 0; )
    l++;
  e.splice(l, 0, n);
}
function kd(e) {
  let l = [];
  return e.someProp("decorations", (n) => {
    let t = n(e.state);
    t && t != An && l.push(t);
  }), e.cursorWrapper && l.push(un.create(e.state.doc, [e.cursorWrapper.deco])), Gt.from(l);
}
const qA = {
  childList: !0,
  characterData: !0,
  characterDataOldValue: !0,
  attributes: !0,
  attributeOldValue: !0,
  subtree: !0
}, JA = Zn && Xt <= 11;
class ZA {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  set(l) {
    this.anchorNode = l.anchorNode, this.anchorOffset = l.anchorOffset, this.focusNode = l.focusNode, this.focusOffset = l.focusOffset;
  }
  clear() {
    this.anchorNode = this.focusNode = null;
  }
  eq(l) {
    return l.anchorNode == this.anchorNode && l.anchorOffset == this.anchorOffset && l.focusNode == this.focusNode && l.focusOffset == this.focusOffset;
  }
}
class XA {
  constructor(l, n) {
    this.view = l, this.handleDOMChange = n, this.queue = [], this.flushingSoon = -1, this.observer = null, this.currentSelection = new ZA(), this.onCharData = null, this.suppressingSelectionUpdates = !1, this.observer = window.MutationObserver && new window.MutationObserver((t) => {
      for (let u = 0; u < t.length; u++)
        this.queue.push(t[u]);
      Zn && Xt <= 11 && t.some((u) => u.type == "childList" && u.removedNodes.length || u.type == "characterData" && u.oldValue.length > u.target.nodeValue.length) ? this.flushSoon() : this.flush();
    }), JA && (this.onCharData = (t) => {
      this.queue.push({ target: t.target, type: "characterData", oldValue: t.prevValue }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this);
  }
  flushSoon() {
    this.flushingSoon < 0 && (this.flushingSoon = window.setTimeout(() => {
      this.flushingSoon = -1, this.flush();
    }, 20));
  }
  forceFlush() {
    this.flushingSoon > -1 && (window.clearTimeout(this.flushingSoon), this.flushingSoon = -1, this.flush());
  }
  start() {
    this.observer && (this.observer.takeRecords(), this.observer.observe(this.view.dom, qA)), this.onCharData && this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.connectSelection();
  }
  stop() {
    if (this.observer) {
      let l = this.observer.takeRecords();
      if (l.length) {
        for (let n = 0; n < l.length; n++)
          this.queue.push(l[n]);
        window.setTimeout(() => this.flush(), 20);
      }
      this.observer.disconnect();
    }
    this.onCharData && this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData), this.disconnectSelection();
  }
  connectSelection() {
    this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
  }
  disconnectSelection() {
    this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
  }
  suppressSelectionUpdates() {
    this.suppressingSelectionUpdates = !0, setTimeout(() => this.suppressingSelectionUpdates = !1, 50);
  }
  onSelectionChange() {
    if (Dm(this.view)) {
      if (this.suppressingSelectionUpdates)
        return xt(this.view);
      if (Zn && Xt <= 11 && !this.view.state.selection.empty) {
        let l = this.view.domSelectionRange();
        if (l.focusNode && Pu(l.focusNode, l.focusOffset, l.anchorNode, l.anchorOffset))
          return this.flushSoon();
      }
      this.flush();
    }
  }
  setCurSelection() {
    this.currentSelection.set(this.view.domSelectionRange());
  }
  ignoreSelectionChange(l) {
    if (!l.focusNode)
      return !0;
    let n = /* @__PURE__ */ new Set(), t;
    for (let i = l.focusNode; i; i = Ts(i))
      n.add(i);
    for (let i = l.anchorNode; i; i = Ts(i))
      if (n.has(i)) {
        t = i;
        break;
      }
    let u = t && this.view.docView.nearestDesc(t);
    if (u && u.ignoreMutation({
      type: "selection",
      target: t.nodeType == 3 ? t.parentNode : t
    }))
      return this.setCurSelection(), !0;
  }
  pendingRecords() {
    if (this.observer)
      for (let l of this.observer.takeRecords())
        this.queue.push(l);
    return this.queue;
  }
  flush() {
    let { view: l } = this;
    if (!l.docView || this.flushingSoon > -1)
      return;
    let n = this.pendingRecords();
    n.length && (this.queue = []);
    let t = l.domSelectionRange(), u = !this.suppressingSelectionUpdates && !this.currentSelection.eq(t) && Dm(l) && !this.ignoreSelectionChange(t), i = -1, s = -1, r = !1, o = [];
    if (l.editable)
      for (let d = 0; d < n.length; d++) {
        let h = this.registerMutation(n[d], o);
        h && (i = i < 0 ? h.from : Math.min(h.from, i), s = s < 0 ? h.to : Math.max(h.to, s), h.typeOver && (r = !0));
      }
    if (He && o.length > 1) {
      let d = o.filter((h) => h.nodeName == "BR");
      if (d.length == 2) {
        let h = d[0], p = d[1];
        h.parentNode && h.parentNode.parentNode == p.parentNode ? p.remove() : h.remove();
      }
    }
    let a = null;
    i < 0 && u && l.input.lastFocus > Date.now() - 200 && Math.max(l.input.lastTouch, l.input.lastClick.time) < Date.now() - 300 && ra(t) && (a = Wf(l)) && a.eq(xl.near(l.state.doc.resolve(0), 1)) ? (l.input.lastFocus = 0, xt(l), this.currentSelection.set(t), l.scrollToSelection()) : (i > -1 || u) && (i > -1 && (l.docView.markDirty(i, s), QA(l)), this.handleDOMChange(i, s, r, o), l.docView && l.docView.dirty ? l.updateState(l.state) : this.currentSelection.eq(t) || xt(l), this.currentSelection.set(t));
  }
  registerMutation(l, n) {
    if (n.indexOf(l.target) > -1)
      return null;
    let t = this.view.docView.nearestDesc(l.target);
    if (l.type == "attributes" && (t == this.view.docView || l.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
    l.attributeName == "style" && !l.oldValue && !l.target.getAttribute("style")) || !t || t.ignoreMutation(l))
      return null;
    if (l.type == "childList") {
      for (let d = 0; d < l.addedNodes.length; d++)
        n.push(l.addedNodes[d]);
      if (t.contentDOM && t.contentDOM != t.dom && !t.contentDOM.contains(l.target))
        return { from: t.posBefore, to: t.posAfter };
      let u = l.previousSibling, i = l.nextSibling;
      if (Zn && Xt <= 11 && l.addedNodes.length)
        for (let d = 0; d < l.addedNodes.length; d++) {
          let { previousSibling: h, nextSibling: p } = l.addedNodes[d];
          (!h || Array.prototype.indexOf.call(l.addedNodes, h) < 0) && (u = h), (!p || Array.prototype.indexOf.call(l.addedNodes, p) < 0) && (i = p);
        }
      let s = u && u.parentNode == l.target ? zn(u) + 1 : 0, r = t.localPosFromDOM(l.target, s, -1), o = i && i.parentNode == l.target ? zn(i) : l.target.childNodes.length, a = t.localPosFromDOM(l.target, o, 1);
      return { from: r, to: a };
    } else
      return l.type == "attributes" ? { from: t.posAtStart - t.border, to: t.posAtEnd + t.border } : {
        from: t.posAtStart,
        to: t.posAtEnd,
        // An event was generated for a text change that didn't change
        // any text. Mark the dom change to fall back to assuming the
        // selection was typed over with an identical value if it can't
        // find another change.
        typeOver: l.target.nodeValue == l.oldValue
      };
  }
}
let jm = /* @__PURE__ */ new WeakMap(), Um = !1;
function QA(e) {
  if (!jm.has(e) && (jm.set(e, null), ["normal", "nowrap", "pre-line"].indexOf(getComputedStyle(e.dom).whiteSpace) !== -1)) {
    if (e.requiresGeckoHackNode = He, Um)
      return;
    console.warn("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package."), Um = !0;
  }
}
function lx(e) {
  let l;
  function n(o) {
    o.preventDefault(), o.stopImmediatePropagation(), l = o.getTargetRanges()[0];
  }
  e.dom.addEventListener("beforeinput", n, !0), document.execCommand("indent"), e.dom.removeEventListener("beforeinput", n, !0);
  let t = l.startContainer, u = l.startOffset, i = l.endContainer, s = l.endOffset, r = e.domAtPos(e.state.selection.anchor);
  return Pu(r.node, r.offset, i, s) && ([t, u, i, s] = [i, s, t, u]), { anchorNode: t, anchorOffset: u, focusNode: i, focusOffset: s };
}
function nx(e, l, n) {
  let { node: t, fromOffset: u, toOffset: i, from: s, to: r } = e.docView.parseRange(l, n), o = e.domSelectionRange(), a, d = o.anchorNode;
  if (d && e.dom.contains(d.nodeType == 1 ? d : d.parentNode) && (a = [{ node: d, offset: o.anchorOffset }], ra(o) || a.push({ node: o.focusNode, offset: o.focusOffset })), Rn && e.input.lastKeyCode === 8)
    for (let v = i; v > u; v--) {
      let w = t.childNodes[v - 1], $ = w.pmViewDesc;
      if (w.nodeName == "BR" && !$) {
        i = v;
        break;
      }
      if (!$ || $.size)
        break;
    }
  let h = e.state.doc, p = e.someProp("domParser") || Ff.fromSchema(e.state.schema), f = h.resolve(s), m = null, g = p.parse(t, {
    topNode: f.parent,
    topMatch: f.parent.contentMatchAt(f.index()),
    topOpen: !0,
    from: u,
    to: i,
    preserveWhitespace: f.parent.type.whitespace == "pre" ? "full" : !0,
    findPositions: a,
    ruleFromNode: ex,
    context: f
  });
  if (a && a[0].pos != null) {
    let v = a[0].pos, w = a[1] && a[1].pos;
    w == null && (w = v), m = { anchor: v + s, head: w + s };
  }
  return { doc: g, sel: m, from: s, to: r };
}
function ex(e) {
  let l = e.pmViewDesc;
  if (l)
    return l.parseRule();
  if (e.nodeName == "BR" && e.parentNode) {
    if (jn && /^(ul|ol)$/i.test(e.parentNode.nodeName)) {
      let n = document.createElement("div");
      return n.appendChild(document.createElement("li")), { skip: n };
    } else if (e.parentNode.lastChild == e || jn && /^(tr|table)$/i.test(e.parentNode.nodeName))
      return { ignore: !0 };
  } else if (e.nodeName == "IMG" && e.getAttribute("mark-placeholder"))
    return { ignore: !0 };
  return null;
}
const tx = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function ux(e, l, n, t, u) {
  let i = e.input.compositionPendingChanges || (e.composing ? e.input.compositionID : 0);
  if (e.input.compositionPendingChanges = 0, l < 0) {
    let x = e.input.lastSelectionTime > Date.now() - 50 ? e.input.lastSelectionOrigin : null, P = Wf(e, x);
    if (P && !e.state.selection.eq(P)) {
      if (Rn && xe && e.input.lastKeyCode === 13 && Date.now() - 100 < e.input.lastKeyCodeTime && e.someProp("handleKeyDown", (F) => F(e, $u(13, "Enter"))))
        return;
      let Z = e.state.tr.setSelection(P);
      x == "pointer" ? Z.setMeta("pointer", !0) : x == "key" && Z.scrollIntoView(), i && Z.setMeta("composition", i), e.dispatch(Z);
    }
    return;
  }
  let s = e.state.doc.resolve(l), r = s.sharedDepth(n);
  l = s.before(r + 1), n = e.state.doc.resolve(n).after(r + 1);
  let o = e.state.selection, a = nx(e, l, n), d = e.state.doc, h = d.slice(a.from, a.to), p, f;
  e.input.lastKeyCode === 8 && Date.now() - 100 < e.input.lastKeyCodeTime ? (p = e.state.selection.to, f = "end") : (p = e.state.selection.from, f = "start"), e.input.lastKeyCode = null;
  let m = rx(h.content, a.doc.content, a.from, p, f);
  if ((_i && e.input.lastIOSEnter > Date.now() - 225 || xe) && u.some((x) => x.nodeType == 1 && !tx.test(x.nodeName)) && (!m || m.endA >= m.endB) && e.someProp("handleKeyDown", (x) => x(e, $u(13, "Enter")))) {
    e.input.lastIOSEnter = 0;
    return;
  }
  if (!m)
    if (t && o instanceof Cl && !o.empty && o.$head.sameParent(o.$anchor) && !e.composing && !(a.sel && a.sel.anchor != a.sel.head))
      m = { start: o.from, endA: o.to, endB: o.to };
    else {
      if (a.sel) {
        let x = Wm(e, e.state.doc, a.sel);
        if (x && !x.eq(e.state.selection)) {
          let P = e.state.tr.setSelection(x);
          i && P.setMeta("composition", i), e.dispatch(P);
        }
      }
      return;
    }
  if (Rn && e.cursorWrapper && a.sel && a.sel.anchor == e.cursorWrapper.deco.from && a.sel.head == a.sel.anchor) {
    let x = m.endB - m.start;
    a.sel = { anchor: a.sel.anchor + x, head: a.sel.anchor + x };
  }
  e.input.domChangeCount++, e.state.selection.from < e.state.selection.to && m.start == m.endB && e.state.selection instanceof Cl && (m.start > e.state.selection.from && m.start <= e.state.selection.from + 2 && e.state.selection.from >= a.from ? m.start = e.state.selection.from : m.endA < e.state.selection.to && m.endA >= e.state.selection.to - 2 && e.state.selection.to <= a.to && (m.endB += e.state.selection.to - m.endA, m.endA = e.state.selection.to)), Zn && Xt <= 11 && m.endB == m.start + 1 && m.endA == m.start && m.start > a.from && a.doc.textBetween(m.start - a.from - 1, m.start - a.from + 1) == "  " && (m.start--, m.endA--, m.endB--);
  let g = a.doc.resolveNoCache(m.start - a.from), v = a.doc.resolveNoCache(m.endB - a.from), w = d.resolve(m.start), $ = g.sameParent(v) && g.parent.inlineContent && w.end() >= m.endA, _;
  if ((_i && e.input.lastIOSEnter > Date.now() - 225 && (!$ || u.some((x) => x.nodeName == "DIV" || x.nodeName == "P")) || !$ && g.pos < a.doc.content.size && !g.sameParent(v) && (_ = xl.findFrom(a.doc.resolve(g.pos + 1), 1, !0)) && _.head == v.pos) && e.someProp("handleKeyDown", (x) => x(e, $u(13, "Enter")))) {
    e.input.lastIOSEnter = 0;
    return;
  }
  if (e.state.selection.anchor > m.start && sx(d, m.start, m.endA, g, v) && e.someProp("handleKeyDown", (x) => x(e, $u(8, "Backspace")))) {
    xe && Rn && e.domObserver.suppressSelectionUpdates();
    return;
  }
  Rn && xe && m.endB == m.start && (e.input.lastAndroidDelete = Date.now()), xe && !$ && g.start() != v.start() && v.parentOffset == 0 && g.depth == v.depth && a.sel && a.sel.anchor == a.sel.head && a.sel.head == m.endA && (m.endB -= 2, v = a.doc.resolveNoCache(m.endB - a.from), setTimeout(() => {
    e.someProp("handleKeyDown", function(x) {
      return x(e, $u(13, "Enter"));
    });
  }, 20));
  let b = m.start, k = m.endA, T, M, H;
  if ($) {
    if (g.pos == v.pos)
      Zn && Xt <= 11 && g.parentOffset == 0 && (e.domObserver.suppressSelectionUpdates(), setTimeout(() => xt(e), 20)), T = e.state.tr.delete(b, k), M = d.resolve(m.start).marksAcross(d.resolve(m.endA));
    else if (
      // Adding or removing a mark
      m.endA == m.endB && (H = ix(g.parent.content.cut(g.parentOffset, v.parentOffset), w.parent.content.cut(w.parentOffset, m.endA - w.start())))
    )
      T = e.state.tr, H.type == "add" ? T.addMark(b, k, H.mark) : T.removeMark(b, k, H.mark);
    else if (g.parent.child(g.index()).isText && g.index() == v.index() - (v.textOffset ? 0 : 1)) {
      let x = g.parent.textBetween(g.parentOffset, v.parentOffset);
      if (e.someProp("handleTextInput", (P) => P(e, b, k, x)))
        return;
      T = e.state.tr.insertText(x, b, k);
    }
  }
  if (T || (T = e.state.tr.replace(b, k, a.doc.slice(m.start - a.from, m.endB - a.from))), a.sel) {
    let x = Wm(e, T.doc, a.sel);
    x && !(Rn && xe && e.composing && x.empty && (m.start != m.endB || e.input.lastAndroidDelete < Date.now() - 100) && (x.head == b || x.head == T.mapping.map(k) - 1) || Zn && x.empty && x.head == b) && T.setSelection(x);
  }
  M && T.ensureMarks(M), i && T.setMeta("composition", i), e.dispatch(T.scrollIntoView());
}
function Wm(e, l, n) {
  return Math.max(n.anchor, n.head) > l.content.size ? null : Gf(e, l.resolve(n.anchor), l.resolve(n.head));
}
function ix(e, l) {
  let n = e.firstChild.marks, t = l.firstChild.marks, u = n, i = t, s, r, o;
  for (let d = 0; d < t.length; d++)
    u = t[d].removeFromSet(u);
  for (let d = 0; d < n.length; d++)
    i = n[d].removeFromSet(i);
  if (u.length == 1 && i.length == 0)
    r = u[0], s = "add", o = (d) => d.mark(r.addToSet(d.marks));
  else if (u.length == 0 && i.length == 1)
    r = i[0], s = "remove", o = (d) => d.mark(r.removeFromSet(d.marks));
  else
    return null;
  let a = [];
  for (let d = 0; d < l.childCount; d++)
    a.push(o(l.child(d)));
  if (j.from(a).eq(e))
    return { mark: r, type: s };
}
function sx(e, l, n, t, u) {
  if (!t.parent.isTextblock || // The content must have shrunk
  n - l <= u.pos - t.pos || // newEnd must point directly at or after the end of the block that newStart points into
  Md(t, !0, !1) < u.pos)
    return !1;
  let i = e.resolve(l);
  if (i.parentOffset < i.parent.content.size || !i.parent.isTextblock)
    return !1;
  let s = e.resolve(Md(i, !0, !0));
  return !s.parent.isTextblock || s.pos > n || Md(s, !0, !1) < n ? !1 : t.parent.content.cut(t.parentOffset).eq(s.parent.content);
}
function Md(e, l, n) {
  let t = e.depth, u = l ? e.end() : e.pos;
  for (; t > 0 && (l || e.indexAfter(t) == e.node(t).childCount); )
    t--, u++, l = !1;
  if (n) {
    let i = e.node(t).maybeChild(e.indexAfter(t));
    for (; i && !i.isLeaf; )
      i = i.firstChild, u++;
  }
  return u;
}
function rx(e, l, n, t, u) {
  let i = e.findDiffStart(l, n);
  if (i == null)
    return null;
  let { a: s, b: r } = e.findDiffEnd(l, n + e.size, n + l.size);
  if (u == "end") {
    let o = Math.max(0, i - Math.min(s, r));
    t -= s + o - i;
  }
  if (s < i && e.size < l.size) {
    let o = t <= i && t >= s ? i - t : 0;
    i -= o, i && i < l.size && Gm(l.textBetween(i - 1, i + 1)) && (i += o ? 1 : -1), r = i + (r - s), s = i;
  } else if (r < i) {
    let o = t <= i && t >= r ? i - t : 0;
    i -= o, i && i < e.size && Gm(e.textBetween(i - 1, i + 1)) && (i += o ? 1 : -1), s = i + (s - r), r = i;
  }
  return { start: i, endA: s, endB: r };
}
function Gm(e) {
  if (e.length != 2)
    return !1;
  let l = e.charCodeAt(0), n = e.charCodeAt(1);
  return l >= 56320 && l <= 57343 && n >= 55296 && n <= 56319;
}
class ox {
  /**
  Create a view. `place` may be a DOM node that the editor should
  be appended to, a function that will place it into the document,
  or an object whose `mount` property holds the node to use as the
  document container. If it is `null`, the editor will not be
  added to the document.
  */
  constructor(l, n) {
    this._root = null, this.focused = !1, this.trackWrites = null, this.mounted = !1, this.markCursor = null, this.cursorWrapper = null, this.lastSelectedViewDesc = void 0, this.input = new AA(), this.prevDirectPlugins = [], this.pluginViews = [], this.requiresGeckoHackNode = !1, this.dragging = null, this._props = n, this.state = n.state, this.directPlugins = n.plugins || [], this.directPlugins.forEach(Zm), this.dispatch = this.dispatch.bind(this), this.dom = l && l.mount || document.createElement("div"), l && (l.appendChild ? l.appendChild(this.dom) : typeof l == "function" ? l(this.dom) : l.mount && (this.mounted = !0)), this.editable = qm(this), Ym(this), this.nodeViews = Jm(this), this.docView = Mm(this.state.doc, Km(this), kd(this), this.dom, this), this.domObserver = new XA(this, (t, u, i, s) => ux(this, t, u, i, s)), this.domObserver.start(), xA(this), this.updatePluginViews();
  }
  /**
  Holds `true` when a
  [composition](https://w3c.github.io/uievents/#events-compositionevents)
  is active.
  */
  get composing() {
    return this.input.composing;
  }
  /**
  The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
  */
  get props() {
    if (this._props.state != this.state) {
      let l = this._props;
      this._props = {};
      for (let n in l)
        this._props[n] = l[n];
      this._props.state = this.state;
    }
    return this._props;
  }
  /**
  Update the view's props. Will immediately cause an update to
  the DOM.
  */
  update(l) {
    l.handleDOMEvents != this._props.handleDOMEvents && Gh(this);
    let n = this._props;
    this._props = l, l.plugins && (l.plugins.forEach(Zm), this.directPlugins = l.plugins), this.updateStateInner(l.state, n);
  }
  /**
  Update the view by updating existing props object with the object
  given as argument. Equivalent to `view.update(Object.assign({},
  view.props, props))`.
  */
  setProps(l) {
    let n = {};
    for (let t in this._props)
      n[t] = this._props[t];
    n.state = this.state;
    for (let t in l)
      n[t] = l[t];
    this.update(n);
  }
  /**
  Update the editor's `state` prop, without touching any of the
  other props.
  */
  updateState(l) {
    this.updateStateInner(l, this._props);
  }
  updateStateInner(l, n) {
    var t;
    let u = this.state, i = !1, s = !1;
    l.storedMarks && this.composing && (k4(this), s = !0), this.state = l;
    let r = u.plugins != l.plugins || this._props.plugins != n.plugins;
    if (r || this._props.plugins != n.plugins || this._props.nodeViews != n.nodeViews) {
      let f = Jm(this);
      dx(f, this.nodeViews) && (this.nodeViews = f, i = !0);
    }
    (r || n.handleDOMEvents != this._props.handleDOMEvents) && Gh(this), this.editable = qm(this), Ym(this);
    let o = kd(this), a = Km(this), d = u.plugins != l.plugins && !u.doc.eq(l.doc) ? "reset" : l.scrollToSelection > u.scrollToSelection ? "to selection" : "preserve", h = i || !this.docView.matchesNode(l.doc, a, o);
    (h || !l.selection.eq(u.selection)) && (s = !0);
    let p = d == "preserve" && s && this.dom.style.overflowAnchor == null && UM(this);
    if (s) {
      this.domObserver.stop();
      let f = h && (Zn || Rn) && !this.composing && !u.selection.empty && !l.selection.empty && ax(u.selection, l.selection);
      if (h) {
        let m = Rn ? this.trackWrites = this.domSelectionRange().focusNode : null;
        (i || !this.docView.update(l.doc, a, o, this)) && (this.docView.updateOuterDeco([]), this.docView.destroy(), this.docView = Mm(l.doc, a, o, this.dom, this)), m && !this.trackWrites && (f = !0);
      }
      f || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && mA(this)) ? xt(this, f) : (f4(this, l.selection), this.domObserver.setCurSelection()), this.domObserver.start();
    }
    this.updatePluginViews(u), !((t = this.dragging) === null || t === void 0) && t.node && !u.doc.eq(l.doc) && this.updateDraggedNode(this.dragging, u), d == "reset" ? this.dom.scrollTop = 0 : d == "to selection" ? this.scrollToSelection() : p && WM(p);
  }
  /**
  @internal
  */
  scrollToSelection() {
    let l = this.domSelectionRange().focusNode;
    if (!this.someProp("handleScrollToSelection", (n) => n(this)))
      if (this.state.selection instanceof pl) {
        let n = this.docView.domAfterPos(this.state.selection.from);
        n.nodeType == 1 && _m(this, n.getBoundingClientRect(), l);
      } else
        _m(this, this.coordsAtPos(this.state.selection.head, 1), l);
  }
  destroyPluginViews() {
    let l;
    for (; l = this.pluginViews.pop(); )
      l.destroy && l.destroy();
  }
  updatePluginViews(l) {
    if (!l || l.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
      this.prevDirectPlugins = this.directPlugins, this.destroyPluginViews();
      for (let n = 0; n < this.directPlugins.length; n++) {
        let t = this.directPlugins[n];
        t.spec.view && this.pluginViews.push(t.spec.view(this));
      }
      for (let n = 0; n < this.state.plugins.length; n++) {
        let t = this.state.plugins[n];
        t.spec.view && this.pluginViews.push(t.spec.view(this));
      }
    } else
      for (let n = 0; n < this.pluginViews.length; n++) {
        let t = this.pluginViews[n];
        t.update && t.update(this, l);
      }
  }
  updateDraggedNode(l, n) {
    let t = l.node, u = -1;
    if (this.state.doc.nodeAt(t.from) == t.node)
      u = t.from;
    else {
      let i = t.from + (this.state.doc.content.size - n.doc.content.size);
      (i > 0 && this.state.doc.nodeAt(i)) == t.node && (u = i);
    }
    this.dragging = new A4(l.slice, l.move, u < 0 ? void 0 : pl.create(this.state.doc, u));
  }
  someProp(l, n) {
    let t = this._props && this._props[l], u;
    if (t != null && (u = n ? n(t) : t))
      return u;
    for (let s = 0; s < this.directPlugins.length; s++) {
      let r = this.directPlugins[s].props[l];
      if (r != null && (u = n ? n(r) : r))
        return u;
    }
    let i = this.state.plugins;
    if (i)
      for (let s = 0; s < i.length; s++) {
        let r = i[s].props[l];
        if (r != null && (u = n ? n(r) : r))
          return u;
      }
  }
  /**
  Query whether the view has focus.
  */
  hasFocus() {
    if (Zn) {
      let l = this.root.activeElement;
      if (l == this.dom)
        return !0;
      if (!l || !this.dom.contains(l))
        return !1;
      for (; l && this.dom != l && this.dom.contains(l); ) {
        if (l.contentEditable == "false")
          return !1;
        l = l.parentElement;
      }
      return !0;
    }
    return this.root.activeElement == this.dom;
  }
  /**
  Focus the editor.
  */
  focus() {
    this.domObserver.stop(), this.editable && GM(this.dom), xt(this), this.domObserver.start();
  }
  /**
  Get the document root in which the editor exists. This will
  usually be the top-level `document`, but might be a [shadow
  DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
  root if the editor is inside one.
  */
  get root() {
    let l = this._root;
    if (l == null) {
      for (let n = this.dom.parentNode; n; n = n.parentNode)
        if (n.nodeType == 9 || n.nodeType == 11 && n.host)
          return n.getSelection || (Object.getPrototypeOf(n).getSelection = () => n.ownerDocument.getSelection()), this._root = n;
    }
    return l || document;
  }
  /**
  When an existing editor view is moved to a new document or
  shadow tree, call this to make it recompute its root.
  */
  updateRoot() {
    this._root = null;
  }
  /**
  Given a pair of viewport coordinates, return the document
  position that corresponds to them. May return null if the given
  coordinates aren't inside of the editor. When an object is
  returned, its `pos` property is the position nearest to the
  coordinates, and its `inside` property holds the position of the
  inner node that the position falls inside of, or -1 if it is at
  the top level, not in any node.
  */
  posAtCoords(l) {
    return ZM(this, l);
  }
  /**
  Returns the viewport rectangle at a given document position.
  `left` and `right` will be the same number, as this returns a
  flat cursor-ish rectangle. If the position is between two things
  that aren't directly adjacent, `side` determines which element
  is used. When < 0, the element before the position is used,
  otherwise the element after.
  */
  coordsAtPos(l, n = 1) {
    return s4(this, l, n);
  }
  /**
  Find the DOM position that corresponds to the given document
  position. When `side` is negative, find the position as close as
  possible to the content before the position. When positive,
  prefer positions close to the content after the position. When
  zero, prefer as shallow a position as possible.
  
  Note that you should **not** mutate the editor's internal DOM,
  only inspect it (and even that is usually not necessary).
  */
  domAtPos(l, n = 0) {
    return this.docView.domFromPos(l, n);
  }
  /**
  Find the DOM node that represents the document node after the
  given position. May return `null` when the position doesn't point
  in front of a node or if the node is inside an opaque node view.
  
  This is intended to be able to call things like
  `getBoundingClientRect` on that DOM node. Do **not** mutate the
  editor DOM directly, or add styling this way, since that will be
  immediately overriden by the editor as it redraws the node.
  */
  nodeDOM(l) {
    let n = this.docView.descAt(l);
    return n ? n.nodeDOM : null;
  }
  /**
  Find the document position that corresponds to a given DOM
  position. (Whenever possible, it is preferable to inspect the
  document structure directly, rather than poking around in the
  DOM, but sometimes—for example when interpreting an event
  target—you don't have a choice.)
  
  The `bias` parameter can be used to influence which side of a DOM
  node to use when the position is inside a leaf node.
  */
  posAtDOM(l, n, t = -1) {
    let u = this.docView.posFromDOM(l, n, t);
    if (u == null)
      throw new RangeError("DOM position not inside the editor");
    return u;
  }
  /**
  Find out whether the selection is at the end of a textblock when
  moving in a given direction. When, for example, given `"left"`,
  it will return true if moving left from the current cursor
  position would leave that position's parent textblock. Will apply
  to the view's current state by default, but it is possible to
  pass a different state.
  */
  endOfTextblock(l, n) {
    return eA(this, n || this.state, l);
  }
  /**
  Run the editor's paste logic with the given HTML string. The
  `event`, if given, will be passed to the
  [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
  */
  pasteHTML(l, n) {
    return ks(this, "", l, !1, n || new ClipboardEvent("paste"));
  }
  /**
  Run the editor's paste logic with the given plain-text input.
  */
  pasteText(l, n) {
    return ks(this, l, null, !0, n || new ClipboardEvent("paste"));
  }
  /**
  Removes the editor from the DOM and destroys all [node
  views](https://prosemirror.net/docs/ref/#view.NodeView).
  */
  destroy() {
    this.docView && (EA(this), this.destroyPluginViews(), this.mounted ? (this.docView.update(this.state.doc, [], kd(this), this), this.dom.textContent = "") : this.dom.parentNode && this.dom.parentNode.removeChild(this.dom), this.docView.destroy(), this.docView = null);
  }
  /**
  This is true when the view has been
  [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
  used anymore).
  */
  get isDestroyed() {
    return this.docView == null;
  }
  /**
  Used for testing.
  */
  dispatchEvent(l) {
    return RA(this, l);
  }
  /**
  Dispatch a transaction. Will call
  [`dispatchTransaction`](https://prosemirror.net/docs/ref/#view.DirectEditorProps.dispatchTransaction)
  when given, and otherwise defaults to applying the transaction to
  the current state and calling
  [`updateState`](https://prosemirror.net/docs/ref/#view.EditorView.updateState) with the result.
  This method is bound to the view instance, so that it can be
  easily passed around.
  */
  dispatch(l) {
    let n = this._props.dispatchTransaction;
    n ? n.call(this, l) : this.updateState(this.state.apply(l));
  }
  /**
  @internal
  */
  domSelectionRange() {
    return jn && this.root.nodeType === 11 && PM(this.dom.ownerDocument) == this.dom ? lx(this) : this.domSelection();
  }
  /**
  @internal
  */
  domSelection() {
    return this.root.getSelection();
  }
}
function Km(e) {
  let l = /* @__PURE__ */ Object.create(null);
  return l.class = "ProseMirror", l.contenteditable = String(e.editable), e.someProp("attributes", (n) => {
    if (typeof n == "function" && (n = n(e.state)), n)
      for (let t in n)
        t == "class" ? l.class += " " + n[t] : t == "style" ? l.style = (l.style ? l.style + ";" : "") + n[t] : !l[t] && t != "contenteditable" && t != "nodeName" && (l[t] = String(n[t]));
  }), l.translate || (l.translate = "no"), [ve.node(0, e.state.doc.content.size, l)];
}
function Ym(e) {
  if (e.markCursor) {
    let l = document.createElement("img");
    l.className = "ProseMirror-separator", l.setAttribute("mark-placeholder", "true"), l.setAttribute("alt", ""), e.cursorWrapper = { dom: l, deco: ve.widget(e.state.selection.head, l, { raw: !0, marks: e.markCursor }) };
  } else
    e.cursorWrapper = null;
}
function qm(e) {
  return !e.someProp("editable", (l) => l(e.state) === !1);
}
function ax(e, l) {
  let n = Math.min(e.$anchor.sharedDepth(e.head), l.$anchor.sharedDepth(l.head));
  return e.$anchor.start(n) != l.$anchor.start(n);
}
function Jm(e) {
  let l = /* @__PURE__ */ Object.create(null);
  function n(t) {
    for (let u in t)
      Object.prototype.hasOwnProperty.call(l, u) || (l[u] = t[u]);
  }
  return e.someProp("nodeViews", n), e.someProp("markViews", n), l;
}
function dx(e, l) {
  let n = 0, t = 0;
  for (let u in e) {
    if (e[u] != l[u])
      return !0;
    n++;
  }
  for (let u in l)
    t++;
  return n != t;
}
function Zm(e) {
  if (e.spec.state || e.spec.filterTransaction || e.spec.appendTransaction)
    throw new RangeError("Plugins passed directly to the view must not have a state component");
}
var iu = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, Gr = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, cx = typeof navigator < "u" && /Mac/.test(navigator.platform), hx = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var _n = 0; _n < 10; _n++)
  iu[48 + _n] = iu[96 + _n] = String(_n);
for (var _n = 1; _n <= 24; _n++)
  iu[_n + 111] = "F" + _n;
for (var _n = 65; _n <= 90; _n++)
  iu[_n] = String.fromCharCode(_n + 32), Gr[_n] = String.fromCharCode(_n);
for (var Ad in iu)
  Gr.hasOwnProperty(Ad) || (Gr[Ad] = iu[Ad]);
function px(e) {
  var l = cx && e.metaKey && e.shiftKey && !e.ctrlKey && !e.altKey || hx && e.shiftKey && e.key && e.key.length == 1 || e.key == "Unidentified", n = !l && e.key || (e.shiftKey ? Gr : iu)[e.keyCode] || e.key || "Unidentified";
  return n == "Esc" && (n = "Escape"), n == "Del" && (n = "Delete"), n == "Left" && (n = "ArrowLeft"), n == "Up" && (n = "ArrowUp"), n == "Right" && (n = "ArrowRight"), n == "Down" && (n = "ArrowDown"), n;
}
const fx = typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : !1;
function mx(e) {
  let l = e.split(/-(?!$)/), n = l[l.length - 1];
  n == "Space" && (n = " ");
  let t, u, i, s;
  for (let r = 0; r < l.length - 1; r++) {
    let o = l[r];
    if (/^(cmd|meta|m)$/i.test(o))
      s = !0;
    else if (/^a(lt)?$/i.test(o))
      t = !0;
    else if (/^(c|ctrl|control)$/i.test(o))
      u = !0;
    else if (/^s(hift)?$/i.test(o))
      i = !0;
    else if (/^mod$/i.test(o))
      fx ? s = !0 : u = !0;
    else
      throw new Error("Unrecognized modifier name: " + o);
  }
  return t && (n = "Alt-" + n), u && (n = "Ctrl-" + n), s && (n = "Meta-" + n), i && (n = "Shift-" + n), n;
}
function gx(e) {
  let l = /* @__PURE__ */ Object.create(null);
  for (let n in e)
    l[mx(n)] = e[n];
  return l;
}
function xd(e, l, n = !0) {
  return l.altKey && (e = "Alt-" + e), l.ctrlKey && (e = "Ctrl-" + e), l.metaKey && (e = "Meta-" + e), n && l.shiftKey && (e = "Shift-" + e), e;
}
function vx(e) {
  return new On({ props: { handleKeyDown: D4(e) } });
}
function D4(e) {
  let l = gx(e);
  return function(n, t) {
    let u = px(t), i, s = l[xd(u, t)];
    if (s && s(n.state, n.dispatch, n))
      return !0;
    if (u.length == 1 && u != " ") {
      if (t.shiftKey) {
        let r = l[xd(u, t, !1)];
        if (r && r(n.state, n.dispatch, n))
          return !0;
      }
      if ((t.shiftKey || t.altKey || t.metaKey || u.charCodeAt(0) > 127) && (i = iu[t.keyCode]) && i != u) {
        let r = l[xd(i, t)];
        if (r && r(n.state, n.dispatch, n))
          return !0;
      }
    }
    return !1;
  };
}
const yx = (e, l) => e.selection.empty ? !1 : (l && l(e.tr.deleteSelection().scrollIntoView()), !0);
function N4(e, l) {
  let { $cursor: n } = e.selection;
  return !n || (l ? !l.endOfTextblock("backward", e) : n.parentOffset > 0) ? null : n;
}
const $x = (e, l, n) => {
  let t = N4(e, n);
  if (!t)
    return !1;
  let u = Xf(t);
  if (!u) {
    let s = t.blockRange(), r = s && Ni(s);
    return r == null ? !1 : (l && l(e.tr.lift(s, r).scrollIntoView()), !0);
  }
  let i = u.nodeBefore;
  if (!i.type.spec.isolating && F4(e, u, l))
    return !0;
  if (t.parent.content.size == 0 && (Si(i, "end") || pl.isSelectable(i))) {
    let s = ia(e.doc, t.before(), t.after(), nl.empty);
    if (s && s.slice.size < s.to - s.from) {
      if (l) {
        let r = e.tr.step(s);
        r.setSelection(Si(i, "end") ? xl.findFrom(r.doc.resolve(r.mapping.map(u.pos, -1)), -1) : pl.create(r.doc, u.pos - i.nodeSize)), l(r.scrollIntoView());
      }
      return !0;
    }
  }
  return i.isAtom && u.depth == t.depth - 1 ? (l && l(e.tr.delete(u.pos - i.nodeSize, u.pos).scrollIntoView()), !0) : !1;
}, bx = (e, l, n) => {
  let t = N4(e, n);
  if (!t)
    return !1;
  let u = Xf(t);
  return u ? L4(e, u, l) : !1;
}, wx = (e, l, n) => {
  let t = P4(e, n);
  if (!t)
    return !1;
  let u = Qf(t);
  return u ? L4(e, u, l) : !1;
};
function L4(e, l, n) {
  let t = l.nodeBefore, u = t, i = l.pos - 1;
  for (; !u.isTextblock; i--) {
    if (u.type.spec.isolating)
      return !1;
    let d = u.lastChild;
    if (!d)
      return !1;
    u = d;
  }
  let s = l.nodeAfter, r = s, o = l.pos + 1;
  for (; !r.isTextblock; o++) {
    if (r.type.spec.isolating)
      return !1;
    let d = r.firstChild;
    if (!d)
      return !1;
    r = d;
  }
  let a = ia(e.doc, i, o, nl.empty);
  if (!a || a.from != i || a instanceof dn && a.slice.size >= o - i)
    return !1;
  if (n) {
    let d = e.tr.step(a);
    d.setSelection(Cl.create(d.doc, i)), n(d.scrollIntoView());
  }
  return !0;
}
function Si(e, l, n = !1) {
  for (let t = e; t; t = l == "start" ? t.firstChild : t.lastChild) {
    if (t.isTextblock)
      return !0;
    if (n && t.childCount != 1)
      return !1;
  }
  return !1;
}
const _x = (e, l, n) => {
  let { $head: t, empty: u } = e.selection, i = t;
  if (!u)
    return !1;
  if (t.parent.isTextblock) {
    if (n ? !n.endOfTextblock("backward", e) : t.parentOffset > 0)
      return !1;
    i = Xf(t);
  }
  let s = i && i.nodeBefore;
  return !s || !pl.isSelectable(s) ? !1 : (l && l(e.tr.setSelection(pl.create(e.doc, i.pos - s.nodeSize)).scrollIntoView()), !0);
};
function Xf(e) {
  if (!e.parent.type.spec.isolating)
    for (let l = e.depth - 1; l >= 0; l--) {
      if (e.index(l) > 0)
        return e.doc.resolve(e.before(l + 1));
      if (e.node(l).type.spec.isolating)
        break;
    }
  return null;
}
function P4(e, l) {
  let { $cursor: n } = e.selection;
  return !n || (l ? !l.endOfTextblock("forward", e) : n.parentOffset < n.parent.content.size) ? null : n;
}
const Sx = (e, l, n) => {
  let t = P4(e, n);
  if (!t)
    return !1;
  let u = Qf(t);
  if (!u)
    return !1;
  let i = u.nodeAfter;
  if (F4(e, u, l))
    return !0;
  if (t.parent.content.size == 0 && (Si(i, "start") || pl.isSelectable(i))) {
    let s = ia(e.doc, t.before(), t.after(), nl.empty);
    if (s && s.slice.size < s.to - s.from) {
      if (l) {
        let r = e.tr.step(s);
        r.setSelection(Si(i, "start") ? xl.findFrom(r.doc.resolve(r.mapping.map(u.pos)), 1) : pl.create(r.doc, r.mapping.map(u.pos))), l(r.scrollIntoView());
      }
      return !0;
    }
  }
  return i.isAtom && u.depth == t.depth - 1 ? (l && l(e.tr.delete(u.pos, u.pos + i.nodeSize).scrollIntoView()), !0) : !1;
}, Cx = (e, l, n) => {
  let { $head: t, empty: u } = e.selection, i = t;
  if (!u)
    return !1;
  if (t.parent.isTextblock) {
    if (n ? !n.endOfTextblock("forward", e) : t.parentOffset < t.parent.content.size)
      return !1;
    i = Qf(t);
  }
  let s = i && i.nodeAfter;
  return !s || !pl.isSelectable(s) ? !1 : (l && l(e.tr.setSelection(pl.create(e.doc, i.pos)).scrollIntoView()), !0);
};
function Qf(e) {
  if (!e.parent.type.spec.isolating)
    for (let l = e.depth - 1; l >= 0; l--) {
      let n = e.node(l);
      if (e.index(l) + 1 < n.childCount)
        return e.doc.resolve(e.after(l + 1));
      if (n.type.spec.isolating)
        break;
    }
  return null;
}
const Tx = (e, l) => {
  let n = e.selection, t = n instanceof pl, u;
  if (t) {
    if (n.node.isTextblock || !ru(e.doc, n.from))
      return !1;
    u = n.from;
  } else if (u = ua(e.doc, n.from, -1), u == null)
    return !1;
  if (l) {
    let i = e.tr.join(u);
    t && i.setSelection(pl.create(i.doc, u - e.doc.resolve(u).nodeBefore.nodeSize)), l(i.scrollIntoView());
  }
  return !0;
}, Ox = (e, l) => {
  let n = e.selection, t;
  if (n instanceof pl) {
    if (n.node.isTextblock || !ru(e.doc, n.to))
      return !1;
    t = n.to;
  } else if (t = ua(e.doc, n.to, 1), t == null)
    return !1;
  return l && l(e.tr.join(t).scrollIntoView()), !0;
}, kx = (e, l) => {
  let { $from: n, $to: t } = e.selection, u = n.blockRange(t), i = u && Ni(u);
  return i == null ? !1 : (l && l(e.tr.lift(u, i).scrollIntoView()), !0);
}, Mx = (e, l) => {
  let { $head: n, $anchor: t } = e.selection;
  return !n.parent.type.spec.code || !n.sameParent(t) ? !1 : (l && l(e.tr.insertText(`
`).scrollIntoView()), !0);
};
function B4(e) {
  for (let l = 0; l < e.edgeCount; l++) {
    let { type: n } = e.edge(l);
    if (n.isTextblock && !n.hasRequiredAttrs())
      return n;
  }
  return null;
}
const Ax = (e, l) => {
  let { $head: n, $anchor: t } = e.selection;
  if (!n.parent.type.spec.code || !n.sameParent(t))
    return !1;
  let u = n.node(-1), i = n.indexAfter(-1), s = B4(u.contentMatchAt(i));
  if (!s || !u.canReplaceWith(i, i, s))
    return !1;
  if (l) {
    let r = n.after(), o = e.tr.replaceWith(r, r, s.createAndFill());
    o.setSelection(xl.near(o.doc.resolve(r), 1)), l(o.scrollIntoView());
  }
  return !0;
}, xx = (e, l) => {
  let n = e.selection, { $from: t, $to: u } = n;
  if (n instanceof Fe || t.parent.inlineContent || u.parent.inlineContent)
    return !1;
  let i = B4(u.parent.contentMatchAt(u.indexAfter()));
  if (!i || !i.isTextblock)
    return !1;
  if (l) {
    let s = (!t.parentOffset && u.index() < u.parent.childCount ? t : u).pos, r = e.tr.insert(s, i.createAndFill());
    r.setSelection(Cl.create(r.doc, s + 1)), l(r.scrollIntoView());
  }
  return !0;
}, Ex = (e, l) => {
  let { $cursor: n } = e.selection;
  if (!n || n.parent.content.size)
    return !1;
  if (n.depth > 1 && n.after() != n.end(-1)) {
    let i = n.before();
    if (ci(e.doc, i))
      return l && l(e.tr.split(i).scrollIntoView()), !0;
  }
  let t = n.blockRange(), u = t && Ni(t);
  return u == null ? !1 : (l && l(e.tr.lift(t, u).scrollIntoView()), !0);
}, Ix = (e, l) => {
  let { $from: n, to: t } = e.selection, u, i = n.sharedDepth(t);
  return i == 0 ? !1 : (u = n.before(i), l && l(e.tr.setSelection(pl.create(e.doc, u))), !0);
};
function Rx(e, l, n) {
  let t = l.nodeBefore, u = l.nodeAfter, i = l.index();
  return !t || !u || !t.type.compatibleContent(u.type) ? !1 : !t.content.size && l.parent.canReplace(i - 1, i) ? (n && n(e.tr.delete(l.pos - t.nodeSize, l.pos).scrollIntoView()), !0) : !l.parent.canReplace(i, i + 1) || !(u.isTextblock || ru(e.doc, l.pos)) ? !1 : (n && n(e.tr.clearIncompatible(l.pos, t.type, t.contentMatchAt(t.childCount)).join(l.pos).scrollIntoView()), !0);
}
function F4(e, l, n) {
  let t = l.nodeBefore, u = l.nodeAfter, i, s;
  if (t.type.spec.isolating || u.type.spec.isolating)
    return !1;
  if (Rx(e, l, n))
    return !0;
  let r = l.parent.canReplace(l.index(), l.index() + 1);
  if (r && (i = (s = t.contentMatchAt(t.childCount)).findWrapping(u.type)) && s.matchType(i[0] || u.type).validEnd) {
    if (n) {
      let h = l.pos + u.nodeSize, p = j.empty;
      for (let g = i.length - 1; g >= 0; g--)
        p = j.from(i[g].create(null, p));
      p = j.from(t.copy(p));
      let f = e.tr.step(new hn(l.pos - 1, h, l.pos, h, new nl(p, 1, 0), i.length, !0)), m = h + 2 * i.length;
      ru(f.doc, m) && f.join(m), n(f.scrollIntoView());
    }
    return !0;
  }
  let o = xl.findFrom(l, 1), a = o && o.$from.blockRange(o.$to), d = a && Ni(a);
  if (d != null && d >= l.depth)
    return n && n(e.tr.lift(a, d).scrollIntoView()), !0;
  if (r && Si(u, "start", !0) && Si(t, "end")) {
    let h = t, p = [];
    for (; p.push(h), !h.isTextblock; )
      h = h.lastChild;
    let f = u, m = 1;
    for (; !f.isTextblock; f = f.firstChild)
      m++;
    if (h.canReplace(h.childCount, h.childCount, f.content)) {
      if (n) {
        let g = j.empty;
        for (let w = p.length - 1; w >= 0; w--)
          g = j.from(p[w].copy(g));
        let v = e.tr.step(new hn(l.pos - p.length, l.pos + u.nodeSize, l.pos + m, l.pos + u.nodeSize - m, new nl(g, p.length, 0), 0, !0));
        n(v.scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function H4(e) {
  return function(l, n) {
    let t = l.selection, u = e < 0 ? t.$from : t.$to, i = u.depth;
    for (; u.node(i).isInline; ) {
      if (!i)
        return !1;
      i--;
    }
    return u.node(i).isTextblock ? (n && n(l.tr.setSelection(Cl.create(l.doc, e < 0 ? u.start(i) : u.end(i)))), !0) : !1;
  };
}
const Dx = H4(-1), Nx = H4(1);
function Lx(e, l = null) {
  return function(n, t) {
    let { $from: u, $to: i } = n.selection, s = u.blockRange(i), r = s && zf(s, e, l);
    return r ? (t && t(n.tr.wrap(s, r).scrollIntoView()), !0) : !1;
  };
}
function Xm(e, l = null) {
  return function(n, t) {
    let u = !1;
    for (let i = 0; i < n.selection.ranges.length && !u; i++) {
      let { $from: { pos: s }, $to: { pos: r } } = n.selection.ranges[i];
      n.doc.nodesBetween(s, r, (o, a) => {
        if (u)
          return !1;
        if (!(!o.isTextblock || o.hasMarkup(e, l)))
          if (o.type == e)
            u = !0;
          else {
            let d = n.doc.resolve(a), h = d.index();
            u = d.parent.canReplaceWith(h, h + 1, e);
          }
      });
    }
    if (!u)
      return !1;
    if (t) {
      let i = n.tr;
      for (let s = 0; s < n.selection.ranges.length; s++) {
        let { $from: { pos: r }, $to: { pos: o } } = n.selection.ranges[s];
        i.setBlockType(r, o, e, l);
      }
      t(i.scrollIntoView());
    }
    return !0;
  };
}
typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os < "u" && os.platform && os.platform() == "darwin";
function Px(e, l = null) {
  return function(n, t) {
    let { $from: u, $to: i } = n.selection, s = u.blockRange(i), r = !1, o = s;
    if (!s)
      return !1;
    if (s.depth >= 2 && u.node(s.depth - 1).type.compatibleContent(e) && s.startIndex == 0) {
      if (u.index(s.depth - 1) == 0)
        return !1;
      let d = n.doc.resolve(s.start - 2);
      o = new Br(d, d, s.depth), s.endIndex < s.parent.childCount && (s = new Br(u, n.doc.resolve(i.end(s.depth)), s.depth)), r = !0;
    }
    let a = zf(o, e, l, s);
    return a ? (t && t(Bx(n.tr, s, a, r, e).scrollIntoView()), !0) : !1;
  };
}
function Bx(e, l, n, t, u) {
  let i = j.empty;
  for (let d = n.length - 1; d >= 0; d--)
    i = j.from(n[d].type.create(n[d].attrs, i));
  e.step(new hn(l.start - (t ? 2 : 0), l.end, l.start, l.end, new nl(i, 0, 0), n.length, !0));
  let s = 0;
  for (let d = 0; d < n.length; d++)
    n[d].type == u && (s = d + 1);
  let r = n.length - s, o = l.start + n.length - (t ? 2 : 0), a = l.parent;
  for (let d = l.startIndex, h = l.endIndex, p = !0; d < h; d++, p = !1)
    !p && ci(e.doc, o, r) && (e.split(o, r), o += 2 * r), o += a.child(d).nodeSize;
  return e;
}
function Fx(e) {
  return function(l, n) {
    let { $from: t, $to: u } = l.selection, i = t.blockRange(u, (s) => s.childCount > 0 && s.firstChild.type == e);
    return i ? n ? t.node(i.depth - 1).type == e ? Hx(l, n, e, i) : zx(l, n, i) : !0 : !1;
  };
}
function Hx(e, l, n, t) {
  let u = e.tr, i = t.end, s = t.$to.end(t.depth);
  i < s && (u.step(new hn(i - 1, s, i, s, new nl(j.from(n.create(null, t.parent.copy())), 1, 0), 1, !0)), t = new Br(u.doc.resolve(t.$from.pos), u.doc.resolve(s), t.depth));
  const r = Ni(t);
  if (r == null)
    return !1;
  u.lift(t, r);
  let o = u.mapping.map(i, -1) - 1;
  return ru(u.doc, o) && u.join(o), l(u.scrollIntoView()), !0;
}
function zx(e, l, n) {
  let t = e.tr, u = n.parent;
  for (let f = n.end, m = n.endIndex - 1, g = n.startIndex; m > g; m--)
    f -= u.child(m).nodeSize, t.delete(f - 1, f + 1);
  let i = t.doc.resolve(n.start), s = i.nodeAfter;
  if (t.mapping.map(n.end) != n.start + i.nodeAfter.nodeSize)
    return !1;
  let r = n.startIndex == 0, o = n.endIndex == u.childCount, a = i.node(-1), d = i.index(-1);
  if (!a.canReplace(d + (r ? 0 : 1), d + 1, s.content.append(o ? j.empty : j.from(u))))
    return !1;
  let h = i.pos, p = h + s.nodeSize;
  return t.step(new hn(h - (r ? 1 : 0), p + (o ? 1 : 0), h + 1, p - 1, new nl((r ? j.empty : j.from(u.copy(j.empty))).append(o ? j.empty : j.from(u.copy(j.empty))), r ? 0 : 1, o ? 0 : 1), r ? 0 : 1)), l(t.scrollIntoView()), !0;
}
function Vx(e) {
  return function(l, n) {
    let { $from: t, $to: u } = l.selection, i = t.blockRange(u, (a) => a.childCount > 0 && a.firstChild.type == e);
    if (!i)
      return !1;
    let s = i.startIndex;
    if (s == 0)
      return !1;
    let r = i.parent, o = r.child(s - 1);
    if (o.type != e)
      return !1;
    if (n) {
      let a = o.lastChild && o.lastChild.type == r.type, d = j.from(a ? e.create() : null), h = new nl(j.from(e.create(null, j.from(r.type.create(null, d)))), a ? 3 : 1, 0), p = i.start, f = i.end;
      n(l.tr.step(new hn(p - (a ? 3 : 1), f, p, f, h, 1, !0)).scrollIntoView());
    }
    return !0;
  };
}
function da(e) {
  const { state: l, transaction: n } = e;
  let { selection: t } = n, { doc: u } = n, { storedMarks: i } = n;
  return {
    ...l,
    apply: l.apply.bind(l),
    applyTransaction: l.applyTransaction.bind(l),
    plugins: l.plugins,
    schema: l.schema,
    reconfigure: l.reconfigure.bind(l),
    toJSON: l.toJSON.bind(l),
    get storedMarks() {
      return i;
    },
    get selection() {
      return t;
    },
    get doc() {
      return u;
    },
    get tr() {
      return t = n.selection, u = n.doc, i = n.storedMarks, n;
    }
  };
}
class ca {
  constructor(l) {
    this.editor = l.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = l.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands: l, editor: n, state: t } = this, { view: u } = n, { tr: i } = t, s = this.buildProps(i);
    return Object.fromEntries(Object.entries(l).map(([r, o]) => [r, (...d) => {
      const h = o(...d)(s);
      return !i.getMeta("preventDispatch") && !this.hasCustomState && u.dispatch(i), h;
    }]));
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(l, n = !0) {
    const { rawCommands: t, editor: u, state: i } = this, { view: s } = u, r = [], o = !!l, a = l || i.tr, d = () => (!o && n && !a.getMeta("preventDispatch") && !this.hasCustomState && s.dispatch(a), r.every((p) => p === !0)), h = {
      ...Object.fromEntries(Object.entries(t).map(([p, f]) => [p, (...g) => {
        const v = this.buildProps(a, n), w = f(...g)(v);
        return r.push(w), h;
      }])),
      run: d
    };
    return h;
  }
  createCan(l) {
    const { rawCommands: n, state: t } = this, u = !1, i = l || t.tr, s = this.buildProps(i, u);
    return {
      ...Object.fromEntries(Object.entries(n).map(([o, a]) => [o, (...d) => a(...d)({ ...s, dispatch: void 0 })])),
      chain: () => this.createChain(i, u)
    };
  }
  buildProps(l, n = !0) {
    const { rawCommands: t, editor: u, state: i } = this, { view: s } = u, r = {
      tr: l,
      editor: u,
      view: s,
      state: da({
        state: i,
        transaction: l
      }),
      dispatch: n ? () => {
      } : void 0,
      chain: () => this.createChain(l, n),
      can: () => this.createCan(l),
      get commands() {
        return Object.fromEntries(Object.entries(t).map(([o, a]) => [o, (...d) => a(...d)(r)]));
      }
    };
    return r;
  }
}
class jx {
  constructor() {
    this.callbacks = {};
  }
  on(l, n) {
    return this.callbacks[l] || (this.callbacks[l] = []), this.callbacks[l].push(n), this;
  }
  emit(l, ...n) {
    const t = this.callbacks[l];
    return t && t.forEach((u) => u.apply(this, n)), this;
  }
  off(l, n) {
    const t = this.callbacks[l];
    return t && (n ? this.callbacks[l] = t.filter((u) => u !== n) : delete this.callbacks[l]), this;
  }
  removeAllListeners() {
    this.callbacks = {};
  }
}
function sl(e, l, n) {
  return e.config[l] === void 0 && e.parent ? sl(e.parent, l, n) : typeof e.config[l] == "function" ? e.config[l].bind({
    ...n,
    parent: e.parent ? sl(e.parent, l, n) : null
  }) : e.config[l];
}
function ha(e) {
  const l = e.filter((u) => u.type === "extension"), n = e.filter((u) => u.type === "node"), t = e.filter((u) => u.type === "mark");
  return {
    baseExtensions: l,
    nodeExtensions: n,
    markExtensions: t
  };
}
function z4(e) {
  const l = [], { nodeExtensions: n, markExtensions: t } = ha(e), u = [...n, ...t], i = {
    default: null,
    rendered: !0,
    renderHTML: null,
    parseHTML: null,
    keepOnSplit: !0,
    isRequired: !1
  };
  return e.forEach((s) => {
    const r = {
      name: s.name,
      options: s.options,
      storage: s.storage
    }, o = sl(s, "addGlobalAttributes", r);
    if (!o)
      return;
    o().forEach((d) => {
      d.types.forEach((h) => {
        Object.entries(d.attributes).forEach(([p, f]) => {
          l.push({
            type: h,
            name: p,
            attribute: {
              ...i,
              ...f
            }
          });
        });
      });
    });
  }), u.forEach((s) => {
    const r = {
      name: s.name,
      options: s.options,
      storage: s.storage
    }, o = sl(s, "addAttributes", r);
    if (!o)
      return;
    const a = o();
    Object.entries(a).forEach(([d, h]) => {
      const p = {
        ...i,
        ...h
      };
      typeof (p == null ? void 0 : p.default) == "function" && (p.default = p.default()), p != null && p.isRequired && (p == null ? void 0 : p.default) === void 0 && delete p.default, l.push({
        type: s.name,
        name: d,
        attribute: p
      });
    });
  }), l;
}
function fn(e, l) {
  if (typeof e == "string") {
    if (!l.nodes[e])
      throw Error(`There is no node type named '${e}'. Maybe you forgot to add the extension?`);
    return l.nodes[e];
  }
  return e;
}
function ql(...e) {
  return e.filter((l) => !!l).reduce((l, n) => {
    const t = { ...l };
    return Object.entries(n).forEach(([u, i]) => {
      if (!t[u]) {
        t[u] = i;
        return;
      }
      if (u === "class") {
        const r = i ? i.split(" ") : [], o = t[u] ? t[u].split(" ") : [], a = r.filter((d) => !o.includes(d));
        t[u] = [...o, ...a].join(" ");
      } else
        u === "style" ? t[u] = [t[u], i].join("; ") : t[u] = i;
    }), t;
  }, {});
}
function Kh(e, l) {
  return l.filter((n) => n.attribute.rendered).map((n) => n.attribute.renderHTML ? n.attribute.renderHTML(e.attrs) || {} : {
    [n.name]: e.attrs[n.name]
  }).reduce((n, t) => ql(n, t), {});
}
function V4(e) {
  return typeof e == "function";
}
function Ol(e, l = void 0, ...n) {
  return V4(e) ? l ? e.bind(l)(...n) : e(...n) : e;
}
function Ux(e = {}) {
  return Object.keys(e).length === 0 && e.constructor === Object;
}
function Wx(e) {
  return typeof e != "string" ? e : e.match(/^[+-]?(?:\d*\.)?\d+$/) ? Number(e) : e === "true" ? !0 : e === "false" ? !1 : e;
}
function Qm(e, l) {
  return e.style ? e : {
    ...e,
    getAttrs: (n) => {
      const t = e.getAttrs ? e.getAttrs(n) : e.attrs;
      if (t === !1)
        return !1;
      const u = l.reduce((i, s) => {
        const r = s.attribute.parseHTML ? s.attribute.parseHTML(n) : Wx(n.getAttribute(s.name));
        return r == null ? i : {
          ...i,
          [s.name]: r
        };
      }, {});
      return { ...t, ...u };
    }
  };
}
function lg(e) {
  return Object.fromEntries(
    // @ts-ignore
    Object.entries(e).filter(([l, n]) => l === "attrs" && Ux(n) ? !1 : n != null)
  );
}
function Gx(e, l) {
  var n;
  const t = z4(e), { nodeExtensions: u, markExtensions: i } = ha(e), s = (n = u.find((a) => sl(a, "topNode"))) === null || n === void 0 ? void 0 : n.name, r = Object.fromEntries(u.map((a) => {
    const d = t.filter((w) => w.type === a.name), h = {
      name: a.name,
      options: a.options,
      storage: a.storage,
      editor: l
    }, p = e.reduce((w, $) => {
      const _ = sl($, "extendNodeSchema", h);
      return {
        ...w,
        ..._ ? _(a) : {}
      };
    }, {}), f = lg({
      ...p,
      content: Ol(sl(a, "content", h)),
      marks: Ol(sl(a, "marks", h)),
      group: Ol(sl(a, "group", h)),
      inline: Ol(sl(a, "inline", h)),
      atom: Ol(sl(a, "atom", h)),
      selectable: Ol(sl(a, "selectable", h)),
      draggable: Ol(sl(a, "draggable", h)),
      code: Ol(sl(a, "code", h)),
      defining: Ol(sl(a, "defining", h)),
      isolating: Ol(sl(a, "isolating", h)),
      attrs: Object.fromEntries(d.map((w) => {
        var $;
        return [w.name, { default: ($ = w == null ? void 0 : w.attribute) === null || $ === void 0 ? void 0 : $.default }];
      }))
    }), m = Ol(sl(a, "parseHTML", h));
    m && (f.parseDOM = m.map((w) => Qm(w, d)));
    const g = sl(a, "renderHTML", h);
    g && (f.toDOM = (w) => g({
      node: w,
      HTMLAttributes: Kh(w, d)
    }));
    const v = sl(a, "renderText", h);
    return v && (f.toText = v), [a.name, f];
  })), o = Object.fromEntries(i.map((a) => {
    const d = t.filter((v) => v.type === a.name), h = {
      name: a.name,
      options: a.options,
      storage: a.storage,
      editor: l
    }, p = e.reduce((v, w) => {
      const $ = sl(w, "extendMarkSchema", h);
      return {
        ...v,
        ...$ ? $(a) : {}
      };
    }, {}), f = lg({
      ...p,
      inclusive: Ol(sl(a, "inclusive", h)),
      excludes: Ol(sl(a, "excludes", h)),
      group: Ol(sl(a, "group", h)),
      spanning: Ol(sl(a, "spanning", h)),
      code: Ol(sl(a, "code", h)),
      attrs: Object.fromEntries(d.map((v) => {
        var w;
        return [v.name, { default: (w = v == null ? void 0 : v.attribute) === null || w === void 0 ? void 0 : w.default }];
      }))
    }), m = Ol(sl(a, "parseHTML", h));
    m && (f.parseDOM = m.map((v) => Qm(v, d)));
    const g = sl(a, "renderHTML", h);
    return g && (f.toDOM = (v) => g({
      mark: v,
      HTMLAttributes: Kh(v, d)
    })), [a.name, f];
  }));
  return new eM({
    topNode: s,
    nodes: r,
    marks: o
  });
}
function Ed(e, l) {
  return l.nodes[e] || l.marks[e] || null;
}
function ng(e, l) {
  return Array.isArray(l) ? l.some((n) => (typeof n == "string" ? n : n.name) === e.name) : l;
}
const Kx = (e, l = 500) => {
  let n = "";
  const t = e.parentOffset;
  return e.parent.nodesBetween(Math.max(0, t - l), t, (u, i, s, r) => {
    var o, a;
    const d = ((a = (o = u.type.spec).toText) === null || a === void 0 ? void 0 : a.call(o, {
      node: u,
      pos: i,
      parent: s,
      index: r
    })) || u.textContent || "%leaf%";
    n += d.slice(0, Math.max(0, t - i));
  }), n;
};
function l1(e) {
  return Object.prototype.toString.call(e) === "[object RegExp]";
}
class pa {
  constructor(l) {
    this.find = l.find, this.handler = l.handler;
  }
}
const Yx = (e, l) => {
  if (l1(l))
    return l.exec(e);
  const n = l(e);
  if (!n)
    return null;
  const t = [n.text];
  return t.index = n.index, t.input = e, t.data = n.data, n.replaceWith && (n.text.includes(n.replaceWith) || console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".'), t.push(n.replaceWith)), t;
};
function Id(e) {
  var l;
  const { editor: n, from: t, to: u, text: i, rules: s, plugin: r } = e, { view: o } = n;
  if (o.composing)
    return !1;
  const a = o.state.doc.resolve(t);
  if (
    // check for code node
    a.parent.type.spec.code || !((l = a.nodeBefore || a.nodeAfter) === null || l === void 0) && l.marks.find((p) => p.type.spec.code)
  )
    return !1;
  let d = !1;
  const h = Kx(a) + i;
  return s.forEach((p) => {
    if (d)
      return;
    const f = Yx(h, p.find);
    if (!f)
      return;
    const m = o.state.tr, g = da({
      state: o.state,
      transaction: m
    }), v = {
      from: t - (f[0].length - i.length),
      to: u
    }, { commands: w, chain: $, can: _ } = new ca({
      editor: n,
      state: g
    });
    p.handler({
      state: g,
      range: v,
      match: f,
      commands: w,
      chain: $,
      can: _
    }) === null || !m.steps.length || (m.setMeta(r, {
      transform: m,
      from: t,
      to: u,
      text: i
    }), o.dispatch(m), d = !0);
  }), d;
}
function qx(e) {
  const { editor: l, rules: n } = e, t = new On({
    state: {
      init() {
        return null;
      },
      apply(u, i) {
        const s = u.getMeta(t);
        return s || (u.selectionSet || u.docChanged ? null : i);
      }
    },
    props: {
      handleTextInput(u, i, s, r) {
        return Id({
          editor: l,
          from: i,
          to: s,
          text: r,
          rules: n,
          plugin: t
        });
      },
      handleDOMEvents: {
        compositionend: (u) => (setTimeout(() => {
          const { $cursor: i } = u.state.selection;
          i && Id({
            editor: l,
            from: i.pos,
            to: i.pos,
            text: "",
            rules: n,
            plugin: t
          });
        }), !1)
      },
      // add support for input rules to trigger on enter
      // this is useful for example for code blocks
      handleKeyDown(u, i) {
        if (i.key !== "Enter")
          return !1;
        const { $cursor: s } = u.state.selection;
        return s ? Id({
          editor: l,
          from: s.pos,
          to: s.pos,
          text: `
`,
          rules: n,
          plugin: t
        }) : !1;
      }
    },
    // @ts-ignore
    isInputRules: !0
  });
  return t;
}
function Jx(e) {
  return typeof e == "number";
}
class j4 {
  constructor(l) {
    this.find = l.find, this.handler = l.handler;
  }
}
const Zx = (e, l, n) => {
  if (l1(l))
    return [...e.matchAll(l)];
  const t = l(e, n);
  return t ? t.map((u) => {
    const i = [u.text];
    return i.index = u.index, i.input = e, i.data = u.data, u.replaceWith && (u.text.includes(u.replaceWith) || console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".'), i.push(u.replaceWith)), i;
  }) : [];
};
function Xx(e) {
  const { editor: l, state: n, from: t, to: u, rule: i, pasteEvent: s, dropEvent: r } = e, { commands: o, chain: a, can: d } = new ca({
    editor: l,
    state: n
  }), h = [];
  return n.doc.nodesBetween(t, u, (f, m) => {
    if (!f.isTextblock || f.type.spec.code)
      return;
    const g = Math.max(t, m), v = Math.min(u, m + f.content.size), w = f.textBetween(g - m, v - m, void 0, "￼");
    Zx(w, i.find, s).forEach((_) => {
      if (_.index === void 0)
        return;
      const b = g + _.index + 1, k = b + _[0].length, T = {
        from: n.tr.mapping.map(b),
        to: n.tr.mapping.map(k)
      }, M = i.handler({
        state: n,
        range: T,
        match: _,
        commands: o,
        chain: a,
        can: d,
        pasteEvent: s,
        dropEvent: r
      });
      h.push(M);
    });
  }), h.every((f) => f !== null);
}
function Qx(e) {
  const { editor: l, rules: n } = e;
  let t = null, u = !1, i = !1, s = new ClipboardEvent("paste"), r = new DragEvent("drop");
  return n.map((a) => new On({
    // we register a global drag handler to track the current drag source element
    view(d) {
      const h = (p) => {
        var f;
        t = !((f = d.dom.parentElement) === null || f === void 0) && f.contains(p.target) ? d.dom.parentElement : null;
      };
      return window.addEventListener("dragstart", h), {
        destroy() {
          window.removeEventListener("dragstart", h);
        }
      };
    },
    props: {
      handleDOMEvents: {
        drop: (d, h) => (i = t === d.dom.parentElement, r = h, !1),
        paste: (d, h) => {
          var p;
          const f = (p = h.clipboardData) === null || p === void 0 ? void 0 : p.getData("text/html");
          return s = h, u = !!(f != null && f.includes("data-pm-slice")), !1;
        }
      }
    },
    appendTransaction: (d, h, p) => {
      const f = d[0], m = f.getMeta("uiEvent") === "paste" && !u, g = f.getMeta("uiEvent") === "drop" && !i;
      if (!m && !g)
        return;
      const v = h.doc.content.findDiffStart(p.doc.content), w = h.doc.content.findDiffEnd(p.doc.content);
      if (!Jx(v) || !w || v === w.b)
        return;
      const $ = p.tr, _ = da({
        state: p,
        transaction: $
      });
      if (!(!Xx({
        editor: l,
        state: _,
        from: Math.max(v - 1, 0),
        to: w.b - 1,
        rule: a,
        pasteEvent: s,
        dropEvent: r
      }) || !$.steps.length))
        return r = new DragEvent("drop"), s = new ClipboardEvent("paste"), $;
    }
  }));
}
function lE(e) {
  const l = e.filter((n, t) => e.indexOf(n) !== t);
  return [...new Set(l)];
}
class ui {
  constructor(l, n) {
    this.splittableMarks = [], this.editor = n, this.extensions = ui.resolve(l), this.schema = Gx(this.extensions, n), this.extensions.forEach((t) => {
      var u;
      this.editor.extensionStorage[t.name] = t.storage;
      const i = {
        name: t.name,
        options: t.options,
        storage: t.storage,
        editor: this.editor,
        type: Ed(t.name, this.schema)
      };
      t.type === "mark" && (!((u = Ol(sl(t, "keepOnSplit", i))) !== null && u !== void 0) || u) && this.splittableMarks.push(t.name);
      const s = sl(t, "onBeforeCreate", i);
      s && this.editor.on("beforeCreate", s);
      const r = sl(t, "onCreate", i);
      r && this.editor.on("create", r);
      const o = sl(t, "onUpdate", i);
      o && this.editor.on("update", o);
      const a = sl(t, "onSelectionUpdate", i);
      a && this.editor.on("selectionUpdate", a);
      const d = sl(t, "onTransaction", i);
      d && this.editor.on("transaction", d);
      const h = sl(t, "onFocus", i);
      h && this.editor.on("focus", h);
      const p = sl(t, "onBlur", i);
      p && this.editor.on("blur", p);
      const f = sl(t, "onDestroy", i);
      f && this.editor.on("destroy", f);
    });
  }
  static resolve(l) {
    const n = ui.sort(ui.flatten(l)), t = lE(n.map((u) => u.name));
    return t.length && console.warn(`[tiptap warn]: Duplicate extension names found: [${t.map((u) => `'${u}'`).join(", ")}]. This can lead to issues.`), n;
  }
  static flatten(l) {
    return l.map((n) => {
      const t = {
        name: n.name,
        options: n.options,
        storage: n.storage
      }, u = sl(n, "addExtensions", t);
      return u ? [n, ...this.flatten(u())] : n;
    }).flat(10);
  }
  static sort(l) {
    return l.sort((t, u) => {
      const i = sl(t, "priority") || 100, s = sl(u, "priority") || 100;
      return i > s ? -1 : i < s ? 1 : 0;
    });
  }
  get commands() {
    return this.extensions.reduce((l, n) => {
      const t = {
        name: n.name,
        options: n.options,
        storage: n.storage,
        editor: this.editor,
        type: Ed(n.name, this.schema)
      }, u = sl(n, "addCommands", t);
      return u ? {
        ...l,
        ...u()
      } : l;
    }, {});
  }
  get plugins() {
    const { editor: l } = this, n = ui.sort([...this.extensions].reverse()), t = [], u = [], i = n.map((s) => {
      const r = {
        name: s.name,
        options: s.options,
        storage: s.storage,
        editor: l,
        type: Ed(s.name, this.schema)
      }, o = [], a = sl(s, "addKeyboardShortcuts", r);
      let d = {};
      if (s.type === "mark" && s.config.exitable && (d.ArrowRight = () => ue.handleExit({ editor: l, mark: s })), a) {
        const g = Object.fromEntries(Object.entries(a()).map(([v, w]) => [v, () => w({ editor: l })]));
        d = { ...d, ...g };
      }
      const h = vx(d);
      o.push(h);
      const p = sl(s, "addInputRules", r);
      ng(s, l.options.enableInputRules) && p && t.push(...p());
      const f = sl(s, "addPasteRules", r);
      ng(s, l.options.enablePasteRules) && f && u.push(...f());
      const m = sl(s, "addProseMirrorPlugins", r);
      if (m) {
        const g = m();
        o.push(...g);
      }
      return o;
    }).flat();
    return [
      qx({
        editor: l,
        rules: t
      }),
      ...Qx({
        editor: l,
        rules: u
      }),
      ...i
    ];
  }
  get attributes() {
    return z4(this.extensions);
  }
  get nodeViews() {
    const { editor: l } = this, { nodeExtensions: n } = ha(this.extensions);
    return Object.fromEntries(n.filter((t) => !!sl(t, "addNodeView")).map((t) => {
      const u = this.attributes.filter((o) => o.type === t.name), i = {
        name: t.name,
        options: t.options,
        storage: t.storage,
        editor: l,
        type: fn(t.name, this.schema)
      }, s = sl(t, "addNodeView", i);
      if (!s)
        return [];
      const r = (o, a, d, h) => {
        const p = Kh(o, u);
        return s()({
          editor: l,
          node: o,
          getPos: d,
          decorations: h,
          HTMLAttributes: p,
          extension: t
        });
      };
      return [t.name, r];
    }));
  }
}
function nE(e) {
  return Object.prototype.toString.call(e).slice(8, -1);
}
function Rd(e) {
  return nE(e) !== "Object" ? !1 : e.constructor === Object && Object.getPrototypeOf(e) === Object.prototype;
}
function fa(e, l) {
  const n = { ...e };
  return Rd(e) && Rd(l) && Object.keys(l).forEach((t) => {
    Rd(l[t]) ? t in e ? n[t] = fa(e[t], l[t]) : Object.assign(n, { [t]: l[t] }) : Object.assign(n, { [t]: l[t] });
  }), n;
}
class mn {
  constructor(l = {}) {
    this.type = "extension", this.name = "extension", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...l
    }, this.name = this.config.name, l.defaultOptions && Object.keys(l.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Ol(sl(this, "addOptions", {
      name: this.name
    }))), this.storage = Ol(sl(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(l = {}) {
    return new mn(l);
  }
  configure(l = {}) {
    const n = this.extend();
    return n.options = fa(this.options, l), n.storage = Ol(sl(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
  extend(l = {}) {
    const n = new mn({ ...this.config, ...l });
    return n.parent = this, this.child = n, n.name = l.name ? l.name : n.parent.name, l.defaultOptions && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${n.name}".`), n.options = Ol(sl(n, "addOptions", {
      name: n.name
    })), n.storage = Ol(sl(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
}
function U4(e, l, n) {
  const { from: t, to: u } = l, { blockSeparator: i = `

`, textSerializers: s = {} } = n || {};
  let r = "", o = !0;
  return e.nodesBetween(t, u, (a, d, h, p) => {
    var f;
    const m = s == null ? void 0 : s[a.type.name];
    m ? (a.isBlock && !o && (r += i, o = !0), h && (r += m({
      node: a,
      pos: d,
      parent: h,
      index: p,
      range: l
    }))) : a.isText ? (r += (f = a == null ? void 0 : a.text) === null || f === void 0 ? void 0 : f.slice(Math.max(t, d) - d, u - d), o = !1) : a.isBlock && !o && (r += i, o = !0);
  }), r;
}
function W4(e) {
  return Object.fromEntries(Object.entries(e.nodes).filter(([, l]) => l.spec.toText).map(([l, n]) => [l, n.spec.toText]));
}
const eE = mn.create({
  name: "clipboardTextSerializer",
  addProseMirrorPlugins() {
    return [
      new On({
        key: new se("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor: e } = this, { state: l, schema: n } = e, { doc: t, selection: u } = l, { ranges: i } = u, s = Math.min(...i.map((d) => d.$from.pos)), r = Math.max(...i.map((d) => d.$to.pos)), o = W4(n);
            return U4(t, { from: s, to: r }, {
              textSerializers: o
            });
          }
        }
      })
    ];
  }
}), tE = () => ({ editor: e, view: l }) => (requestAnimationFrame(() => {
  var n;
  e.isDestroyed || (l.dom.blur(), (n = window == null ? void 0 : window.getSelection()) === null || n === void 0 || n.removeAllRanges());
}), !0), uE = (e = !1) => ({ commands: l }) => l.setContent("", e), iE = () => ({ state: e, tr: l, dispatch: n }) => {
  const { selection: t } = l, { ranges: u } = t;
  return n && u.forEach(({ $from: i, $to: s }) => {
    e.doc.nodesBetween(i.pos, s.pos, (r, o) => {
      if (r.type.isText)
        return;
      const { doc: a, mapping: d } = l, h = a.resolve(d.map(o)), p = a.resolve(d.map(o + r.nodeSize)), f = h.blockRange(p);
      if (!f)
        return;
      const m = Ni(f);
      if (r.type.isTextblock) {
        const { defaultType: g } = h.parent.contentMatchAt(h.index());
        l.setNodeMarkup(f.start, g);
      }
      (m || m === 0) && l.lift(f, m);
    });
  }), !0;
}, sE = (e) => (l) => e(l), rE = () => ({ state: e, dispatch: l }) => xx(e, l), oE = (e, l) => ({ editor: n, tr: t }) => {
  const { state: u } = n, i = u.doc.slice(e.from, e.to);
  t.deleteRange(e.from, e.to);
  const s = t.mapping.map(l);
  return t.insert(s, i.content), t.setSelection(new Cl(t.doc.resolve(s - 1))), !0;
}, aE = () => ({ tr: e, dispatch: l }) => {
  const { selection: n } = e, t = n.$anchor.node();
  if (t.content.size > 0)
    return !1;
  const u = e.selection.$anchor;
  for (let i = u.depth; i > 0; i -= 1)
    if (u.node(i).type === t.type) {
      if (l) {
        const r = u.before(i), o = u.after(i);
        e.delete(r, o).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, dE = (e) => ({ tr: l, state: n, dispatch: t }) => {
  const u = fn(e, n.schema), i = l.selection.$anchor;
  for (let s = i.depth; s > 0; s -= 1)
    if (i.node(s).type === u) {
      if (t) {
        const o = i.before(s), a = i.after(s);
        l.delete(o, a).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, cE = (e) => ({ tr: l, dispatch: n }) => {
  const { from: t, to: u } = e;
  return n && l.delete(t, u), !0;
}, hE = () => ({ state: e, dispatch: l }) => yx(e, l), pE = () => ({ commands: e }) => e.keyboardShortcut("Enter"), fE = () => ({ state: e, dispatch: l }) => Ax(e, l);
function Kr(e, l, n = { strict: !0 }) {
  const t = Object.keys(l);
  return t.length ? t.every((u) => n.strict ? l[u] === e[u] : l1(l[u]) ? l[u].test(e[u]) : l[u] === e[u]) : !0;
}
function Yh(e, l, n = {}) {
  return e.find((t) => t.type === l && Kr(t.attrs, n));
}
function mE(e, l, n = {}) {
  return !!Yh(e, l, n);
}
function n1(e, l, n = {}) {
  if (!e || !l)
    return;
  let t = e.parent.childAfter(e.parentOffset);
  if (e.parentOffset === t.offset && t.offset !== 0 && (t = e.parent.childBefore(e.parentOffset)), !t.node)
    return;
  const u = Yh([...t.node.marks], l, n);
  if (!u)
    return;
  let i = t.index, s = e.start() + t.offset, r = i + 1, o = s + t.node.nodeSize;
  for (Yh([...t.node.marks], l, n); i > 0 && u.isInSet(e.parent.child(i - 1).marks); )
    i -= 1, s -= e.parent.child(i).nodeSize;
  for (; r < e.parent.childCount && mE([...e.parent.child(r).marks], l, n); )
    o += e.parent.child(r).nodeSize, r += 1;
  return {
    from: s,
    to: o
  };
}
function au(e, l) {
  if (typeof e == "string") {
    if (!l.marks[e])
      throw Error(`There is no mark type named '${e}'. Maybe you forgot to add the extension?`);
    return l.marks[e];
  }
  return e;
}
const gE = (e, l = {}) => ({ tr: n, state: t, dispatch: u }) => {
  const i = au(e, t.schema), { doc: s, selection: r } = n, { $from: o, from: a, to: d } = r;
  if (u) {
    const h = n1(o, i, l);
    if (h && h.from <= a && h.to >= d) {
      const p = Cl.create(s, h.from, h.to);
      n.setSelection(p);
    }
  }
  return !0;
}, vE = (e) => (l) => {
  const n = typeof e == "function" ? e(l) : e;
  for (let t = 0; t < n.length; t += 1)
    if (n[t](l))
      return !0;
  return !1;
};
function e1(e) {
  return e instanceof Cl;
}
function Mt(e = 0, l = 0, n = 0) {
  return Math.min(Math.max(e, l), n);
}
function G4(e, l = null) {
  if (!l)
    return null;
  const n = xl.atStart(e), t = xl.atEnd(e);
  if (l === "start" || l === !0)
    return n;
  if (l === "end")
    return t;
  const u = n.from, i = t.to;
  return l === "all" ? Cl.create(e, Mt(0, u, i), Mt(e.content.size, u, i)) : Cl.create(e, Mt(l, u, i), Mt(l, u, i));
}
function t1() {
  return [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod"
  ].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
const yE = (e = null, l = {}) => ({ editor: n, view: t, tr: u, dispatch: i }) => {
  l = {
    scrollIntoView: !0,
    ...l
  };
  const s = () => {
    t1() && t.dom.focus(), requestAnimationFrame(() => {
      n.isDestroyed || (t.focus(), l != null && l.scrollIntoView && n.commands.scrollIntoView());
    });
  };
  if (t.hasFocus() && e === null || e === !1)
    return !0;
  if (i && e === null && !e1(n.state.selection))
    return s(), !0;
  const r = G4(u.doc, e) || n.state.selection, o = n.state.selection.eq(r);
  return i && (o || u.setSelection(r), o && u.storedMarks && u.setStoredMarks(u.storedMarks), s()), !0;
}, $E = (e, l) => (n) => e.every((t, u) => l(t, { ...n, index: u })), bE = (e, l) => ({ tr: n, commands: t }) => t.insertContentAt({ from: n.selection.from, to: n.selection.to }, e, l), K4 = (e) => {
  const l = e.childNodes;
  for (let n = l.length - 1; n >= 0; n -= 1) {
    const t = l[n];
    t.nodeType === 3 && t.nodeValue && /^(\n\s\s|\n)$/.test(t.nodeValue) ? e.removeChild(t) : t.nodeType === 1 && K4(t);
  }
  return e;
};
function eg(e) {
  const l = `<body>${e}</body>`, n = new window.DOMParser().parseFromString(l, "text/html").body;
  return K4(n);
}
function Yr(e, l, n) {
  if (n = {
    slice: !0,
    parseOptions: {},
    ...n
  }, typeof e == "object" && e !== null)
    try {
      return Array.isArray(e) && e.length > 0 ? j.fromArray(e.map((t) => l.nodeFromJSON(t))) : l.nodeFromJSON(e);
    } catch (t) {
      return console.warn("[tiptap warn]: Invalid content.", "Passed value:", e, "Error:", t), Yr("", l, n);
    }
  if (typeof e == "string") {
    const t = Ff.fromSchema(l);
    return n.slice ? t.parseSlice(eg(e), n.parseOptions).content : t.parse(eg(e), n.parseOptions);
  }
  return Yr("", l, n);
}
function wE(e, l, n) {
  const t = e.steps.length - 1;
  if (t < l)
    return;
  const u = e.steps[t];
  if (!(u instanceof dn || u instanceof hn))
    return;
  const i = e.mapping.maps[t];
  let s = 0;
  i.forEach((r, o, a, d) => {
    s === 0 && (s = d);
  }), e.setSelection(xl.near(e.doc.resolve(s), n));
}
const _E = (e) => e.toString().startsWith("<"), SE = (e, l, n) => ({ tr: t, dispatch: u, editor: i }) => {
  if (u) {
    n = {
      parseOptions: {},
      updateSelection: !0,
      ...n
    };
    const s = Yr(l, i.schema, {
      parseOptions: {
        preserveWhitespace: "full",
        ...n.parseOptions
      }
    });
    if (s.toString() === "<>")
      return !0;
    let { from: r, to: o } = typeof e == "number" ? { from: e, to: e } : { from: e.from, to: e.to }, a = !0, d = !0;
    if ((_E(s) ? s : [s]).forEach((p) => {
      p.check(), a = a ? p.isText && p.marks.length === 0 : !1, d = d ? p.isBlock : !1;
    }), r === o && d) {
      const { parent: p } = t.doc.resolve(r);
      p.isTextblock && !p.type.spec.code && !p.childCount && (r -= 1, o += 1);
    }
    a ? Array.isArray(l) ? t.insertText(l.map((p) => p.text || "").join(""), r, o) : typeof l == "object" && l && l.text ? t.insertText(l.text, r, o) : t.insertText(l, r, o) : t.replaceWith(r, o, s), n.updateSelection && wE(t, t.steps.length - 1, -1);
  }
  return !0;
}, CE = () => ({ state: e, dispatch: l }) => Tx(e, l), TE = () => ({ state: e, dispatch: l }) => Ox(e, l), OE = () => ({ state: e, dispatch: l }) => $x(e, l), kE = () => ({ state: e, dispatch: l }) => Sx(e, l), ME = () => ({ tr: e, state: l, dispatch: n }) => {
  try {
    const t = ua(l.doc, l.selection.$from.pos, -1);
    return t == null ? !1 : (e.join(t, 2), n && n(e), !0);
  } catch {
    return !1;
  }
}, AE = () => ({ state: e, dispatch: l, tr: n }) => {
  try {
    const t = ua(e.doc, e.selection.$from.pos, 1);
    return t == null ? !1 : (n.join(t, 2), l && l(n), !0);
  } catch {
    return !1;
  }
}, xE = () => ({ state: e, dispatch: l }) => bx(e, l), EE = () => ({ state: e, dispatch: l }) => wx(e, l);
function u1() {
  return typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1;
}
function IE(e) {
  const l = e.split(/-(?!$)/);
  let n = l[l.length - 1];
  n === "Space" && (n = " ");
  let t, u, i, s;
  for (let r = 0; r < l.length - 1; r += 1) {
    const o = l[r];
    if (/^(cmd|meta|m)$/i.test(o))
      s = !0;
    else if (/^a(lt)?$/i.test(o))
      t = !0;
    else if (/^(c|ctrl|control)$/i.test(o))
      u = !0;
    else if (/^s(hift)?$/i.test(o))
      i = !0;
    else if (/^mod$/i.test(o))
      t1() || u1() ? s = !0 : u = !0;
    else
      throw new Error(`Unrecognized modifier name: ${o}`);
  }
  return t && (n = `Alt-${n}`), u && (n = `Ctrl-${n}`), s && (n = `Meta-${n}`), i && (n = `Shift-${n}`), n;
}
const RE = (e) => ({ editor: l, view: n, tr: t, dispatch: u }) => {
  const i = IE(e).split(/-(?!$)/), s = i.find((a) => !["Alt", "Ctrl", "Meta", "Shift"].includes(a)), r = new KeyboardEvent("keydown", {
    key: s === "Space" ? " " : s,
    altKey: i.includes("Alt"),
    ctrlKey: i.includes("Ctrl"),
    metaKey: i.includes("Meta"),
    shiftKey: i.includes("Shift"),
    bubbles: !0,
    cancelable: !0
  }), o = l.captureTransaction(() => {
    n.someProp("handleKeyDown", (a) => a(n, r));
  });
  return o == null || o.steps.forEach((a) => {
    const d = a.map(t.mapping);
    d && u && t.maybeStep(d);
  }), !0;
};
function As(e, l, n = {}) {
  const { from: t, to: u, empty: i } = e.selection, s = l ? fn(l, e.schema) : null, r = [];
  e.doc.nodesBetween(t, u, (h, p) => {
    if (h.isText)
      return;
    const f = Math.max(t, p), m = Math.min(u, p + h.nodeSize);
    r.push({
      node: h,
      from: f,
      to: m
    });
  });
  const o = u - t, a = r.filter((h) => s ? s.name === h.node.type.name : !0).filter((h) => Kr(h.node.attrs, n, { strict: !1 }));
  return i ? !!a.length : a.reduce((h, p) => h + p.to - p.from, 0) >= o;
}
const DE = (e, l = {}) => ({ state: n, dispatch: t }) => {
  const u = fn(e, n.schema);
  return As(n, u, l) ? kx(n, t) : !1;
}, NE = () => ({ state: e, dispatch: l }) => Ex(e, l), LE = (e) => ({ state: l, dispatch: n }) => {
  const t = fn(e, l.schema);
  return Fx(t)(l, n);
}, PE = () => ({ state: e, dispatch: l }) => Mx(e, l);
function ma(e, l) {
  return l.nodes[e] ? "node" : l.marks[e] ? "mark" : null;
}
function tg(e, l) {
  const n = typeof l == "string" ? [l] : l;
  return Object.keys(e).reduce((t, u) => (n.includes(u) || (t[u] = e[u]), t), {});
}
const BE = (e, l) => ({ tr: n, state: t, dispatch: u }) => {
  let i = null, s = null;
  const r = ma(typeof e == "string" ? e : e.name, t.schema);
  return r ? (r === "node" && (i = fn(e, t.schema)), r === "mark" && (s = au(e, t.schema)), u && n.selection.ranges.forEach((o) => {
    t.doc.nodesBetween(o.$from.pos, o.$to.pos, (a, d) => {
      i && i === a.type && n.setNodeMarkup(d, void 0, tg(a.attrs, l)), s && a.marks.length && a.marks.forEach((h) => {
        s === h.type && n.addMark(d, d + a.nodeSize, s.create(tg(h.attrs, l)));
      });
    });
  }), !0) : !1;
}, FE = () => ({ tr: e, dispatch: l }) => (l && e.scrollIntoView(), !0), HE = () => ({ tr: e, commands: l }) => l.setTextSelection({
  from: 0,
  to: e.doc.content.size
}), zE = () => ({ state: e, dispatch: l }) => _x(e, l), VE = () => ({ state: e, dispatch: l }) => Cx(e, l), jE = () => ({ state: e, dispatch: l }) => Ix(e, l), UE = () => ({ state: e, dispatch: l }) => Nx(e, l), WE = () => ({ state: e, dispatch: l }) => Dx(e, l);
function Y4(e, l, n = {}) {
  return Yr(e, l, { slice: !1, parseOptions: n });
}
const GE = (e, l = !1, n = {}) => ({ tr: t, editor: u, dispatch: i }) => {
  const { doc: s } = t, r = Y4(e, u.schema, n);
  return i && t.replaceWith(0, s.content.size, r).setMeta("preventUpdate", !l), !0;
};
function Vs(e, l) {
  const n = au(l, e.schema), { from: t, to: u, empty: i } = e.selection, s = [];
  i ? (e.storedMarks && s.push(...e.storedMarks), s.push(...e.selection.$head.marks())) : e.doc.nodesBetween(t, u, (o) => {
    s.push(...o.marks);
  });
  const r = s.find((o) => o.type.name === n.name);
  return r ? { ...r.attrs } : {};
}
function KE(e, l) {
  const n = new Xv(e);
  return l.forEach((t) => {
    t.steps.forEach((u) => {
      n.step(u);
    });
  }), n;
}
function YE(e) {
  for (let l = 0; l < e.edgeCount; l += 1) {
    const { type: n } = e.edge(l);
    if (n.isTextblock && !n.hasRequiredAttrs())
      return n;
  }
  return null;
}
function qE(e, l, n) {
  const t = [];
  return e.nodesBetween(l.from, l.to, (u, i) => {
    n(u) && t.push({
      node: u,
      pos: i
    });
  }), t;
}
function JE(e, l) {
  for (let n = e.depth; n > 0; n -= 1) {
    const t = e.node(n);
    if (l(t))
      return {
        pos: n > 0 ? e.before(n) : 0,
        start: e.start(n),
        depth: n,
        node: t
      };
  }
}
function i1(e) {
  return (l) => JE(l.$from, e);
}
function ZE(e, l) {
  const n = st.fromSchema(l).serializeFragment(e), u = document.implementation.createHTMLDocument().createElement("div");
  return u.appendChild(n), u.innerHTML;
}
function XE(e, l) {
  const n = {
    from: 0,
    to: e.content.size
  };
  return U4(e, n, l);
}
function QE(e, l) {
  const n = fn(l, e.schema), { from: t, to: u } = e.selection, i = [];
  e.doc.nodesBetween(t, u, (r) => {
    i.push(r);
  });
  const s = i.reverse().find((r) => r.type.name === n.name);
  return s ? { ...s.attrs } : {};
}
function q4(e, l) {
  const n = ma(typeof l == "string" ? l : l.name, e.schema);
  return n === "node" ? QE(e, l) : n === "mark" ? Vs(e, l) : {};
}
function lI(e, l = JSON.stringify) {
  const n = {};
  return e.filter((t) => {
    const u = l(t);
    return Object.prototype.hasOwnProperty.call(n, u) ? !1 : n[u] = !0;
  });
}
function nI(e) {
  const l = lI(e);
  return l.length === 1 ? l : l.filter((n, t) => !l.filter((i, s) => s !== t).some((i) => n.oldRange.from >= i.oldRange.from && n.oldRange.to <= i.oldRange.to && n.newRange.from >= i.newRange.from && n.newRange.to <= i.newRange.to));
}
function eI(e) {
  const { mapping: l, steps: n } = e, t = [];
  return l.maps.forEach((u, i) => {
    const s = [];
    if (u.ranges.length)
      u.forEach((r, o) => {
        s.push({ from: r, to: o });
      });
    else {
      const { from: r, to: o } = n[i];
      if (r === void 0 || o === void 0)
        return;
      s.push({ from: r, to: o });
    }
    s.forEach(({ from: r, to: o }) => {
      const a = l.slice(i).map(r, -1), d = l.slice(i).map(o), h = l.invert().map(a, -1), p = l.invert().map(d);
      t.push({
        oldRange: {
          from: h,
          to: p
        },
        newRange: {
          from: a,
          to: d
        }
      });
    });
  }), nI(t);
}
function s1(e, l, n) {
  const t = [];
  return e === l ? n.resolve(e).marks().forEach((u) => {
    const i = n.resolve(e - 1), s = n1(i, u.type);
    s && t.push({
      mark: u,
      ...s
    });
  }) : n.nodesBetween(e, l, (u, i) => {
    !u || (u == null ? void 0 : u.nodeSize) === void 0 || t.push(...u.marks.map((s) => ({
      from: i,
      to: i + u.nodeSize,
      mark: s
    })));
  }), t;
}
function br(e, l, n) {
  return Object.fromEntries(Object.entries(n).filter(([t]) => {
    const u = e.find((i) => i.type === l && i.name === t);
    return u ? u.attribute.keepOnSplit : !1;
  }));
}
function qh(e, l, n = {}) {
  const { empty: t, ranges: u } = e.selection, i = l ? au(l, e.schema) : null;
  if (t)
    return !!(e.storedMarks || e.selection.$from.marks()).filter((h) => i ? i.name === h.type.name : !0).find((h) => Kr(h.attrs, n, { strict: !1 }));
  let s = 0;
  const r = [];
  if (u.forEach(({ $from: h, $to: p }) => {
    const f = h.pos, m = p.pos;
    e.doc.nodesBetween(f, m, (g, v) => {
      if (!g.isText && !g.marks.length)
        return;
      const w = Math.max(f, v), $ = Math.min(m, v + g.nodeSize), _ = $ - w;
      s += _, r.push(...g.marks.map((b) => ({
        mark: b,
        from: w,
        to: $
      })));
    });
  }), s === 0)
    return !1;
  const o = r.filter((h) => i ? i.name === h.mark.type.name : !0).filter((h) => Kr(h.mark.attrs, n, { strict: !1 })).reduce((h, p) => h + p.to - p.from, 0), a = r.filter((h) => i ? h.mark.type !== i && h.mark.type.excludes(i) : !0).reduce((h, p) => h + p.to - p.from, 0);
  return (o > 0 ? o + a : o) >= s;
}
function tI(e, l, n = {}) {
  if (!l)
    return As(e, null, n) || qh(e, null, n);
  const t = ma(l, e.schema);
  return t === "node" ? As(e, l, n) : t === "mark" ? qh(e, l, n) : !1;
}
function ug(e, l) {
  const { nodeExtensions: n } = ha(l), t = n.find((s) => s.name === e);
  if (!t)
    return !1;
  const u = {
    name: t.name,
    options: t.options,
    storage: t.storage
  }, i = Ol(sl(t, "group", u));
  return typeof i != "string" ? !1 : i.split(" ").includes("list");
}
function uI(e) {
  var l;
  const n = (l = e.type.createAndFill()) === null || l === void 0 ? void 0 : l.toJSON(), t = e.toJSON();
  return JSON.stringify(n) === JSON.stringify(t);
}
function iI(e) {
  return e instanceof pl;
}
function J4(e, l, n) {
  const u = e.state.doc.content.size, i = Mt(l, 0, u), s = Mt(n, 0, u), r = e.coordsAtPos(i), o = e.coordsAtPos(s, -1), a = Math.min(r.top, o.top), d = Math.max(r.bottom, o.bottom), h = Math.min(r.left, o.left), p = Math.max(r.right, o.right), f = p - h, m = d - a, w = {
    top: a,
    bottom: d,
    left: h,
    right: p,
    width: f,
    height: m,
    x: h,
    y: a
  };
  return {
    ...w,
    toJSON: () => w
  };
}
function sI(e, l, n) {
  var t;
  const { selection: u } = l;
  let i = null;
  if (e1(u) && (i = u.$cursor), i) {
    const r = (t = e.storedMarks) !== null && t !== void 0 ? t : i.marks();
    return !!n.isInSet(r) || !r.some((o) => o.type.excludes(n));
  }
  const { ranges: s } = u;
  return s.some(({ $from: r, $to: o }) => {
    let a = r.depth === 0 ? e.doc.inlineContent && e.doc.type.allowsMarkType(n) : !1;
    return e.doc.nodesBetween(r.pos, o.pos, (d, h, p) => {
      if (a)
        return !1;
      if (d.isInline) {
        const f = !p || p.type.allowsMarkType(n), m = !!n.isInSet(d.marks) || !d.marks.some((g) => g.type.excludes(n));
        a = f && m;
      }
      return !a;
    }), a;
  });
}
const rI = (e, l = {}) => ({ tr: n, state: t, dispatch: u }) => {
  const { selection: i } = n, { empty: s, ranges: r } = i, o = au(e, t.schema);
  if (u)
    if (s) {
      const a = Vs(t, o);
      n.addStoredMark(o.create({
        ...a,
        ...l
      }));
    } else
      r.forEach((a) => {
        const d = a.$from.pos, h = a.$to.pos;
        t.doc.nodesBetween(d, h, (p, f) => {
          const m = Math.max(f, d), g = Math.min(f + p.nodeSize, h);
          p.marks.find((w) => w.type === o) ? p.marks.forEach((w) => {
            o === w.type && n.addMark(m, g, o.create({
              ...w.attrs,
              ...l
            }));
          }) : n.addMark(m, g, o.create(l));
        });
      });
  return sI(t, n, o);
}, oI = (e, l) => ({ tr: n }) => (n.setMeta(e, l), !0), aI = (e, l = {}) => ({ state: n, dispatch: t, chain: u }) => {
  const i = fn(e, n.schema);
  return i.isTextblock ? u().command(({ commands: s }) => Xm(i, l)(n) ? !0 : s.clearNodes()).command(({ state: s }) => Xm(i, l)(s, t)).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
}, dI = (e) => ({ tr: l, dispatch: n }) => {
  if (n) {
    const { doc: t } = l, u = Mt(e, 0, t.content.size), i = pl.create(t, u);
    l.setSelection(i);
  }
  return !0;
}, cI = (e) => ({ tr: l, dispatch: n }) => {
  if (n) {
    const { doc: t } = l, { from: u, to: i } = typeof e == "number" ? { from: e, to: e } : e, s = Cl.atStart(t).from, r = Cl.atEnd(t).to, o = Mt(u, s, r), a = Mt(i, s, r), d = Cl.create(t, o, a);
    l.setSelection(d);
  }
  return !0;
}, hI = (e) => ({ state: l, dispatch: n }) => {
  const t = fn(e, l.schema);
  return Vx(t)(l, n);
};
function ig(e, l) {
  const n = e.storedMarks || e.selection.$to.parentOffset && e.selection.$from.marks();
  if (n) {
    const t = n.filter((u) => l == null ? void 0 : l.includes(u.type.name));
    e.tr.ensureMarks(t);
  }
}
const pI = ({ keepMarks: e = !0 } = {}) => ({ tr: l, state: n, dispatch: t, editor: u }) => {
  const { selection: i, doc: s } = l, { $from: r, $to: o } = i, a = u.extensionManager.attributes, d = br(a, r.node().type.name, r.node().attrs);
  if (i instanceof pl && i.node.isBlock)
    return !r.parentOffset || !ci(s, r.pos) ? !1 : (t && (e && ig(n, u.extensionManager.splittableMarks), l.split(r.pos).scrollIntoView()), !0);
  if (!r.parent.isBlock)
    return !1;
  if (t) {
    const h = o.parentOffset === o.parent.content.size;
    i instanceof Cl && l.deleteSelection();
    const p = r.depth === 0 ? void 0 : YE(r.node(-1).contentMatchAt(r.indexAfter(-1)));
    let f = h && p ? [
      {
        type: p,
        attrs: d
      }
    ] : void 0, m = ci(l.doc, l.mapping.map(r.pos), 1, f);
    if (!f && !m && ci(l.doc, l.mapping.map(r.pos), 1, p ? [{ type: p }] : void 0) && (m = !0, f = p ? [
      {
        type: p,
        attrs: d
      }
    ] : void 0), m && (l.split(l.mapping.map(r.pos), 1, f), p && !h && !r.parentOffset && r.parent.type !== p)) {
      const g = l.mapping.map(r.before()), v = l.doc.resolve(g);
      r.node(-1).canReplaceWith(v.index(), v.index() + 1, p) && l.setNodeMarkup(l.mapping.map(r.before()), p);
    }
    e && ig(n, u.extensionManager.splittableMarks), l.scrollIntoView();
  }
  return !0;
}, fI = (e) => ({ tr: l, state: n, dispatch: t, editor: u }) => {
  var i;
  const s = fn(e, n.schema), { $from: r, $to: o } = n.selection, a = n.selection.node;
  if (a && a.isBlock || r.depth < 2 || !r.sameParent(o))
    return !1;
  const d = r.node(-1);
  if (d.type !== s)
    return !1;
  const h = u.extensionManager.attributes;
  if (r.parent.content.size === 0 && r.node(-1).childCount === r.indexAfter(-1)) {
    if (r.depth === 2 || r.node(-3).type !== s || r.index(-2) !== r.node(-2).childCount - 1)
      return !1;
    if (t) {
      let v = j.empty;
      const w = r.index(-1) ? 1 : r.index(-2) ? 2 : 3;
      for (let M = r.depth - w; M >= r.depth - 3; M -= 1)
        v = j.from(r.node(M).copy(v));
      const $ = r.indexAfter(-1) < r.node(-2).childCount ? 1 : r.indexAfter(-2) < r.node(-3).childCount ? 2 : 3, _ = br(h, r.node().type.name, r.node().attrs), b = ((i = s.contentMatch.defaultType) === null || i === void 0 ? void 0 : i.createAndFill(_)) || void 0;
      v = v.append(j.from(s.createAndFill(null, b) || void 0));
      const k = r.before(r.depth - (w - 1));
      l.replace(k, r.after(-$), new nl(v, 4 - w, 0));
      let T = -1;
      l.doc.nodesBetween(k, l.doc.content.size, (M, H) => {
        if (T > -1)
          return !1;
        M.isTextblock && M.content.size === 0 && (T = H + 1);
      }), T > -1 && l.setSelection(Cl.near(l.doc.resolve(T))), l.scrollIntoView();
    }
    return !0;
  }
  const p = o.pos === r.end() ? d.contentMatchAt(0).defaultType : null, f = br(h, d.type.name, d.attrs), m = br(h, r.node().type.name, r.node().attrs);
  l.delete(r.pos, o.pos);
  const g = p ? [
    { type: s, attrs: f },
    { type: p, attrs: m }
  ] : [{ type: s, attrs: f }];
  if (!ci(l.doc, r.pos, 2))
    return !1;
  if (t) {
    const { selection: v, storedMarks: w } = n, { splittableMarks: $ } = u.extensionManager, _ = w || v.$to.parentOffset && v.$from.marks();
    if (l.split(r.pos, 2, g).scrollIntoView(), !_ || !t)
      return !0;
    const b = _.filter((k) => $.includes(k.type.name));
    l.ensureMarks(b);
  }
  return !0;
}, Dd = (e, l) => {
  const n = i1((s) => s.type === l)(e.selection);
  if (!n)
    return !0;
  const t = e.doc.resolve(Math.max(0, n.pos - 1)).before(n.depth);
  if (t === void 0)
    return !0;
  const u = e.doc.nodeAt(t);
  return n.node.type === (u == null ? void 0 : u.type) && ru(e.doc, n.pos) && e.join(n.pos), !0;
}, Nd = (e, l) => {
  const n = i1((s) => s.type === l)(e.selection);
  if (!n)
    return !0;
  const t = e.doc.resolve(n.start).after(n.depth);
  if (t === void 0)
    return !0;
  const u = e.doc.nodeAt(t);
  return n.node.type === (u == null ? void 0 : u.type) && ru(e.doc, t) && e.join(t), !0;
}, mI = (e, l, n, t = {}) => ({ editor: u, tr: i, state: s, dispatch: r, chain: o, commands: a, can: d }) => {
  const { extensions: h, splittableMarks: p } = u.extensionManager, f = fn(e, s.schema), m = fn(l, s.schema), { selection: g, storedMarks: v } = s, { $from: w, $to: $ } = g, _ = w.blockRange($), b = v || g.$to.parentOffset && g.$from.marks();
  if (!_)
    return !1;
  const k = i1((T) => ug(T.type.name, h))(g);
  if (_.depth >= 1 && k && _.depth - k.depth <= 1) {
    if (k.node.type === f)
      return a.liftListItem(m);
    if (ug(k.node.type.name, h) && f.validContent(k.node.content) && r)
      return o().command(() => (i.setNodeMarkup(k.pos, f), !0)).command(() => Dd(i, f)).command(() => Nd(i, f)).run();
  }
  return !n || !b || !r ? o().command(() => d().wrapInList(f, t) ? !0 : a.clearNodes()).wrapInList(f, t).command(() => Dd(i, f)).command(() => Nd(i, f)).run() : o().command(() => {
    const T = d().wrapInList(f, t), M = b.filter((H) => p.includes(H.type.name));
    return i.ensureMarks(M), T ? !0 : a.clearNodes();
  }).wrapInList(f, t).command(() => Dd(i, f)).command(() => Nd(i, f)).run();
}, gI = (e, l = {}, n = {}) => ({ state: t, commands: u }) => {
  const { extendEmptyMarkRange: i = !1 } = n, s = au(e, t.schema);
  return qh(t, s, l) ? u.unsetMark(s, { extendEmptyMarkRange: i }) : u.setMark(s, l);
}, vI = (e, l, n = {}) => ({ state: t, commands: u }) => {
  const i = fn(e, t.schema), s = fn(l, t.schema);
  return As(t, i, n) ? u.setNode(s) : u.setNode(i, n);
}, yI = (e, l = {}) => ({ state: n, commands: t }) => {
  const u = fn(e, n.schema);
  return As(n, u, l) ? t.lift(u) : t.wrapIn(u, l);
}, $I = () => ({ state: e, dispatch: l }) => {
  const n = e.plugins;
  for (let t = 0; t < n.length; t += 1) {
    const u = n[t];
    let i;
    if (u.spec.isInputRules && (i = u.getState(e))) {
      if (l) {
        const s = e.tr, r = i.transform;
        for (let o = r.steps.length - 1; o >= 0; o -= 1)
          s.step(r.steps[o].invert(r.docs[o]));
        if (i.text) {
          const o = s.doc.resolve(i.from).marks();
          s.replaceWith(i.from, i.to, e.schema.text(i.text, o));
        } else
          s.delete(i.from, i.to);
      }
      return !0;
    }
  }
  return !1;
}, bI = () => ({ tr: e, dispatch: l }) => {
  const { selection: n } = e, { empty: t, ranges: u } = n;
  return t || l && u.forEach((i) => {
    e.removeMark(i.$from.pos, i.$to.pos);
  }), !0;
}, wI = (e, l = {}) => ({ tr: n, state: t, dispatch: u }) => {
  var i;
  const { extendEmptyMarkRange: s = !1 } = l, { selection: r } = n, o = au(e, t.schema), { $from: a, empty: d, ranges: h } = r;
  if (!u)
    return !0;
  if (d && s) {
    let { from: p, to: f } = r;
    const m = (i = a.marks().find((v) => v.type === o)) === null || i === void 0 ? void 0 : i.attrs, g = n1(a, o, m);
    g && (p = g.from, f = g.to), n.removeMark(p, f, o);
  } else
    h.forEach((p) => {
      n.removeMark(p.$from.pos, p.$to.pos, o);
    });
  return n.removeStoredMark(o), !0;
}, _I = (e, l = {}) => ({ tr: n, state: t, dispatch: u }) => {
  let i = null, s = null;
  const r = ma(typeof e == "string" ? e : e.name, t.schema);
  return r ? (r === "node" && (i = fn(e, t.schema)), r === "mark" && (s = au(e, t.schema)), u && n.selection.ranges.forEach((o) => {
    const a = o.$from.pos, d = o.$to.pos;
    t.doc.nodesBetween(a, d, (h, p) => {
      i && i === h.type && n.setNodeMarkup(p, void 0, {
        ...h.attrs,
        ...l
      }), s && h.marks.length && h.marks.forEach((f) => {
        if (s === f.type) {
          const m = Math.max(p, a), g = Math.min(p + h.nodeSize, d);
          n.addMark(m, g, s.create({
            ...f.attrs,
            ...l
          }));
        }
      });
    });
  }), !0) : !1;
}, SI = (e, l = {}) => ({ state: n, dispatch: t }) => {
  const u = fn(e, n.schema);
  return Lx(u, l)(n, t);
}, CI = (e, l = {}) => ({ state: n, dispatch: t }) => {
  const u = fn(e, n.schema);
  return Px(u, l)(n, t);
};
var TI = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  blur: tE,
  clearContent: uE,
  clearNodes: iE,
  command: sE,
  createParagraphNear: rE,
  cut: oE,
  deleteCurrentNode: aE,
  deleteNode: dE,
  deleteRange: cE,
  deleteSelection: hE,
  enter: pE,
  exitCode: fE,
  extendMarkRange: gE,
  first: vE,
  focus: yE,
  forEach: $E,
  insertContent: bE,
  insertContentAt: SE,
  joinUp: CE,
  joinDown: TE,
  joinBackward: OE,
  joinForward: kE,
  joinItemBackward: ME,
  joinItemForward: AE,
  joinTextblockBackward: xE,
  joinTextblockForward: EE,
  keyboardShortcut: RE,
  lift: DE,
  liftEmptyBlock: NE,
  liftListItem: LE,
  newlineInCode: PE,
  resetAttributes: BE,
  scrollIntoView: FE,
  selectAll: HE,
  selectNodeBackward: zE,
  selectNodeForward: VE,
  selectParentNode: jE,
  selectTextblockEnd: UE,
  selectTextblockStart: WE,
  setContent: GE,
  setMark: rI,
  setMeta: oI,
  setNode: aI,
  setNodeSelection: dI,
  setTextSelection: cI,
  sinkListItem: hI,
  splitBlock: pI,
  splitListItem: fI,
  toggleList: mI,
  toggleMark: gI,
  toggleNode: vI,
  toggleWrap: yI,
  undoInputRule: $I,
  unsetAllMarks: bI,
  unsetMark: wI,
  updateAttributes: _I,
  wrapIn: SI,
  wrapInList: CI
});
const OI = mn.create({
  name: "commands",
  addCommands() {
    return {
      ...TI
    };
  }
}), kI = mn.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new On({
        key: new se("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
}), MI = mn.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor: e } = this;
    return [
      new On({
        key: new se("focusEvents"),
        props: {
          handleDOMEvents: {
            focus: (l, n) => {
              e.isFocused = !0;
              const t = e.state.tr.setMeta("focus", { event: n }).setMeta("addToHistory", !1);
              return l.dispatch(t), !1;
            },
            blur: (l, n) => {
              e.isFocused = !1;
              const t = e.state.tr.setMeta("blur", { event: n }).setMeta("addToHistory", !1);
              return l.dispatch(t), !1;
            }
          }
        }
      })
    ];
  }
}), AI = mn.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const e = () => this.editor.commands.first(({ commands: s }) => [
      () => s.undoInputRule(),
      // maybe convert first text block node to default node
      () => s.command(({ tr: r }) => {
        const { selection: o, doc: a } = r, { empty: d, $anchor: h } = o, { pos: p, parent: f } = h, m = h.parent.isTextblock ? r.doc.resolve(p - 1) : h, g = m.parent.type.spec.isolating, v = h.pos - h.parentOffset, w = g && m.parent.childCount === 1 ? v === h.pos : xl.atStart(a).from === p;
        return !d || !w || !f.type.isTextblock || f.textContent.length ? !1 : s.clearNodes();
      }),
      () => s.deleteSelection(),
      () => s.joinBackward(),
      () => s.selectNodeBackward()
    ]), l = () => this.editor.commands.first(({ commands: s }) => [
      () => s.deleteSelection(),
      () => s.deleteCurrentNode(),
      () => s.joinForward(),
      () => s.selectNodeForward()
    ]), t = {
      Enter: () => this.editor.commands.first(({ commands: s }) => [
        () => s.newlineInCode(),
        () => s.createParagraphNear(),
        () => s.liftEmptyBlock(),
        () => s.splitBlock()
      ]),
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: e,
      "Mod-Backspace": e,
      "Shift-Backspace": e,
      Delete: l,
      "Mod-Delete": l,
      "Mod-a": () => this.editor.commands.selectAll()
    }, u = {
      ...t
    }, i = {
      ...t,
      "Ctrl-h": e,
      "Alt-Backspace": e,
      "Ctrl-d": l,
      "Ctrl-Alt-Backspace": l,
      "Alt-Delete": l,
      "Alt-d": l,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    return t1() || u1() ? i : u;
  },
  addProseMirrorPlugins() {
    return [
      // With this plugin we check if the whole document was selected and deleted.
      // In this case we will additionally call `clearNodes()` to convert e.g. a heading
      // to a paragraph if necessary.
      // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
      // with many other commands.
      new On({
        key: new se("clearDocument"),
        appendTransaction: (e, l, n) => {
          if (!(e.some((m) => m.docChanged) && !l.doc.eq(n.doc)))
            return;
          const { empty: u, from: i, to: s } = l.selection, r = xl.atStart(l.doc).from, o = xl.atEnd(l.doc).to;
          if (u || !(i === r && s === o) || !(n.doc.textBetween(0, n.doc.content.size, " ", " ").length === 0))
            return;
          const h = n.tr, p = da({
            state: n,
            transaction: h
          }), { commands: f } = new ca({
            editor: this.editor,
            state: p
          });
          if (f.clearNodes(), !!h.steps.length)
            return h;
        }
      })
    ];
  }
}), xI = mn.create({
  name: "tabindex",
  addProseMirrorPlugins() {
    return [
      new On({
        key: new se("tabindex"),
        props: {
          attributes: this.editor.isEditable ? { tabindex: "0" } : {}
        }
      })
    ];
  }
});
var EI = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ClipboardTextSerializer: eE,
  Commands: OI,
  Editable: kI,
  FocusEvents: MI,
  Keymap: AI,
  Tabindex: xI
});
class bu {
  constructor(l, n, t = !1, u = null) {
    this.currentNode = null, this.actualDepth = null, this.isBlock = t, this.resolvedPos = l, this.editor = n, this.currentNode = u;
  }
  get name() {
    return this.node.type.name;
  }
  get node() {
    return this.currentNode || this.resolvedPos.node();
  }
  get element() {
    return this.editor.view.domAtPos(this.pos).node;
  }
  get depth() {
    var l;
    return (l = this.actualDepth) !== null && l !== void 0 ? l : this.resolvedPos.depth;
  }
  get pos() {
    return this.resolvedPos.pos;
  }
  get content() {
    return this.node.content;
  }
  set content(l) {
    let n = this.from, t = this.to;
    if (this.isBlock) {
      if (this.content.size === 0) {
        console.error(`You can’t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
        return;
      }
      n = this.from + 1, t = this.to - 1;
    }
    this.editor.commands.insertContentAt({ from: n, to: t }, l);
  }
  get attributes() {
    return this.node.attrs;
  }
  get textContent() {
    return this.node.textContent;
  }
  get size() {
    return this.node.nodeSize;
  }
  get from() {
    return this.isBlock ? this.pos : this.resolvedPos.start(this.resolvedPos.depth);
  }
  get range() {
    return {
      from: this.from,
      to: this.to
    };
  }
  get to() {
    return this.isBlock ? this.pos + this.size : this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
  }
  get parent() {
    if (this.depth === 0)
      return null;
    const l = this.resolvedPos.start(this.resolvedPos.depth - 1), n = this.resolvedPos.doc.resolve(l);
    return new bu(n, this.editor);
  }
  get before() {
    let l = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
    return l.depth !== this.depth && (l = this.resolvedPos.doc.resolve(this.from - 3)), new bu(l, this.editor);
  }
  get after() {
    let l = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
    return l.depth !== this.depth && (l = this.resolvedPos.doc.resolve(this.to + 3)), new bu(l, this.editor);
  }
  get children() {
    const l = [];
    return this.node.content.forEach((n, t) => {
      const u = n.isBlock && !n.isTextblock, i = this.pos + t + (u ? 0 : 1), s = this.resolvedPos.doc.resolve(i);
      if (!u && s.depth <= this.depth)
        return;
      const r = new bu(s, this.editor, u, u ? n : null);
      u && (r.actualDepth = this.depth + 1), l.push(new bu(s, this.editor, u, u ? n : null));
    }), l;
  }
  get firstChild() {
    return this.children[0] || null;
  }
  get lastChild() {
    const l = this.children;
    return l[l.length - 1] || null;
  }
  closest(l, n = {}) {
    let t = null, u = this.parent;
    for (; u && !t; ) {
      if (u.node.type.name === l)
        if (Object.keys(n).length > 0) {
          const i = u.node.attrs, s = Object.keys(n);
          for (let r = 0; r < s.length; r += 1) {
            const o = s[r];
            if (i[o] !== n[o])
              break;
          }
        } else
          t = u;
      u = u.parent;
    }
    return t;
  }
  querySelector(l, n = {}) {
    return this.querySelectorAll(l, n, !0)[0] || null;
  }
  querySelectorAll(l, n = {}, t = !1) {
    let u = [];
    return this.isBlock || !this.children || this.children.length === 0 || this.children.forEach((i) => {
      if (i.node.type.name === l) {
        if (Object.keys(n).length > 0) {
          const s = i.node.attrs, r = Object.keys(n);
          for (let o = 0; o < r.length; o += 1) {
            const a = r[o];
            if (s[a] !== n[a])
              return;
          }
        }
        if (u.push(i), t)
          return;
      }
      u = u.concat(i.querySelectorAll(l));
    }), u;
  }
  setAttribute(l) {
    const n = this.editor.state.selection;
    this.editor.chain().setTextSelection(this.from).updateAttributes(this.node.type.name, l).setTextSelection(n.from).run();
  }
}
const II = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 1px !important;
  height: 1px !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}

.tippy-box[data-animation=fade][data-state=hidden] {
  opacity: 0
}`;
function RI(e, l, n) {
  const t = document.querySelector(`style[data-tiptap-style${n ? `-${n}` : ""}]`);
  if (t !== null)
    return t;
  const u = document.createElement("style");
  return l && u.setAttribute("nonce", l), u.setAttribute(`data-tiptap-style${n ? `-${n}` : ""}`, ""), u.innerHTML = e, document.getElementsByTagName("head")[0].appendChild(u), u;
}
let DI = class extends jx {
  constructor(l = {}) {
    super(), this.isFocused = !1, this.extensionStorage = {}, this.options = {
      element: document.createElement("div"),
      content: "",
      injectCSS: !0,
      injectNonce: void 0,
      extensions: [],
      autofocus: !1,
      editable: !0,
      editorProps: {},
      parseOptions: {},
      enableInputRules: !0,
      enablePasteRules: !0,
      enableCoreExtensions: !0,
      onBeforeCreate: () => null,
      onCreate: () => null,
      onUpdate: () => null,
      onSelectionUpdate: () => null,
      onTransaction: () => null,
      onFocus: () => null,
      onBlur: () => null,
      onDestroy: () => null
    }, this.isCapturingTransaction = !1, this.capturedTransaction = null, this.setOptions(l), this.createExtensionManager(), this.createCommandManager(), this.createSchema(), this.on("beforeCreate", this.options.onBeforeCreate), this.emit("beforeCreate", { editor: this }), this.createView(), this.injectCSS(), this.on("create", this.options.onCreate), this.on("update", this.options.onUpdate), this.on("selectionUpdate", this.options.onSelectionUpdate), this.on("transaction", this.options.onTransaction), this.on("focus", this.options.onFocus), this.on("blur", this.options.onBlur), this.on("destroy", this.options.onDestroy), window.setTimeout(() => {
      this.isDestroyed || (this.commands.focus(this.options.autofocus), this.emit("create", { editor: this }));
    }, 0);
  }
  /**
   * Returns the editor storage.
   */
  get storage() {
    return this.extensionStorage;
  }
  /**
   * An object of all registered commands.
   */
  get commands() {
    return this.commandManager.commands;
  }
  /**
   * Create a command chain to call multiple commands at once.
   */
  chain() {
    return this.commandManager.chain();
  }
  /**
   * Check if a command or a command chain can be executed. Without executing it.
   */
  can() {
    return this.commandManager.can();
  }
  /**
   * Inject CSS styles.
   */
  injectCSS() {
    this.options.injectCSS && document && (this.css = RI(II, this.options.injectNonce));
  }
  /**
   * Update editor options.
   *
   * @param options A list of options
   */
  setOptions(l = {}) {
    this.options = {
      ...this.options,
      ...l
    }, !(!this.view || !this.state || this.isDestroyed) && (this.options.editorProps && this.view.setProps(this.options.editorProps), this.view.updateState(this.state));
  }
  /**
   * Update editable state of the editor.
   */
  setEditable(l, n = !0) {
    this.setOptions({ editable: l }), n && this.emit("update", { editor: this, transaction: this.state.tr });
  }
  /**
   * Returns whether the editor is editable.
   */
  get isEditable() {
    return this.options.editable && this.view && this.view.editable;
  }
  /**
   * Returns the editor state.
   */
  get state() {
    return this.view.state;
  }
  /**
   * Register a ProseMirror plugin.
   *
   * @param plugin A ProseMirror plugin
   * @param handlePlugins Control how to merge the plugin into the existing plugins.
   */
  registerPlugin(l, n) {
    const t = V4(n) ? n(l, [...this.state.plugins]) : [...this.state.plugins, l], u = this.state.reconfigure({ plugins: t });
    this.view.updateState(u);
  }
  /**
   * Unregister a ProseMirror plugin.
   *
   * @param nameOrPluginKey The plugins name
   */
  unregisterPlugin(l) {
    if (this.isDestroyed)
      return;
    const n = typeof l == "string" ? `${l}$` : l.key, t = this.state.reconfigure({
      // @ts-ignore
      plugins: this.state.plugins.filter((u) => !u.key.startsWith(n))
    });
    this.view.updateState(t);
  }
  /**
   * Creates an extension manager.
   */
  createExtensionManager() {
    const n = [...this.options.enableCoreExtensions ? Object.values(EI) : [], ...this.options.extensions].filter((t) => ["extension", "node", "mark"].includes(t == null ? void 0 : t.type));
    this.extensionManager = new ui(n, this);
  }
  /**
   * Creates an command manager.
   */
  createCommandManager() {
    this.commandManager = new ca({
      editor: this
    });
  }
  /**
   * Creates a ProseMirror schema.
   */
  createSchema() {
    this.schema = this.extensionManager.schema;
  }
  /**
   * Creates a ProseMirror view.
   */
  createView() {
    const l = Y4(this.options.content, this.schema, this.options.parseOptions), n = G4(l, this.options.autofocus);
    this.view = new ox(this.options.element, {
      ...this.options.editorProps,
      dispatchTransaction: this.dispatchTransaction.bind(this),
      state: ti.create({
        doc: l,
        selection: n || void 0
      })
    });
    const t = this.state.reconfigure({
      plugins: this.extensionManager.plugins
    });
    this.view.updateState(t), this.createNodeViews(), this.prependClass();
    const u = this.view.dom;
    u.editor = this;
  }
  /**
   * Creates all node views.
   */
  createNodeViews() {
    this.view.setProps({
      nodeViews: this.extensionManager.nodeViews
    });
  }
  /**
   * Prepend class name to element.
   */
  prependClass() {
    this.view.dom.className = `tiptap ${this.view.dom.className}`;
  }
  captureTransaction(l) {
    this.isCapturingTransaction = !0, l(), this.isCapturingTransaction = !1;
    const n = this.capturedTransaction;
    return this.capturedTransaction = null, n;
  }
  /**
   * The callback over which to send transactions (state updates) produced by the view.
   *
   * @param transaction An editor state transaction
   */
  dispatchTransaction(l) {
    if (this.view.isDestroyed)
      return;
    if (this.isCapturingTransaction) {
      if (!this.capturedTransaction) {
        this.capturedTransaction = l;
        return;
      }
      l.steps.forEach((s) => {
        var r;
        return (r = this.capturedTransaction) === null || r === void 0 ? void 0 : r.step(s);
      });
      return;
    }
    const n = this.state.apply(l), t = !this.state.selection.eq(n.selection);
    this.view.updateState(n), this.emit("transaction", {
      editor: this,
      transaction: l
    }), t && this.emit("selectionUpdate", {
      editor: this,
      transaction: l
    });
    const u = l.getMeta("focus"), i = l.getMeta("blur");
    u && this.emit("focus", {
      editor: this,
      event: u.event,
      transaction: l
    }), i && this.emit("blur", {
      editor: this,
      event: i.event,
      transaction: l
    }), !(!l.docChanged || l.getMeta("preventUpdate")) && this.emit("update", {
      editor: this,
      transaction: l
    });
  }
  /**
   * Get attributes of the currently selected node or mark.
   */
  getAttributes(l) {
    return q4(this.state, l);
  }
  isActive(l, n) {
    const t = typeof l == "string" ? l : null, u = typeof l == "string" ? n : l;
    return tI(this.state, t, u);
  }
  /**
   * Get the document as JSON.
   */
  getJSON() {
    return this.state.doc.toJSON();
  }
  /**
   * Get the document as HTML.
   */
  getHTML() {
    return ZE(this.state.doc.content, this.schema);
  }
  /**
   * Get the document as text.
   */
  getText(l) {
    const { blockSeparator: n = `

`, textSerializers: t = {} } = l || {};
    return XE(this.state.doc, {
      blockSeparator: n,
      textSerializers: {
        ...W4(this.schema),
        ...t
      }
    });
  }
  /**
   * Check if there is no content.
   */
  get isEmpty() {
    return uI(this.state.doc);
  }
  /**
   * Get the number of characters for the current document.
   *
   * @deprecated
   */
  getCharacterCount() {
    return console.warn('[tiptap warn]: "editor.getCharacterCount()" is deprecated. Please use "editor.storage.characterCount.characters()" instead.'), this.state.doc.content.size - 2;
  }
  /**
   * Destroy the editor.
   */
  destroy() {
    this.emit("destroy"), this.view && this.view.destroy(), this.removeAllListeners();
  }
  /**
   * Check if the editor is already destroyed.
   */
  get isDestroyed() {
    var l;
    return !(!((l = this.view) === null || l === void 0) && l.docView);
  }
  $node(l, n) {
    var t;
    return ((t = this.$doc) === null || t === void 0 ? void 0 : t.querySelector(l, n)) || null;
  }
  $nodes(l, n) {
    var t;
    return ((t = this.$doc) === null || t === void 0 ? void 0 : t.querySelectorAll(l, n)) || null;
  }
  $pos(l) {
    const n = this.state.doc.resolve(l);
    return new bu(n, this);
  }
  get $doc() {
    return this.$pos(0);
  }
};
function Ci(e) {
  return new pa({
    find: e.find,
    handler: ({ state: l, range: n, match: t }) => {
      const u = Ol(e.getAttributes, void 0, t);
      if (u === !1 || u === null)
        return null;
      const { tr: i } = l, s = t[t.length - 1], r = t[0];
      if (s) {
        const o = r.search(/\S/), a = n.from + r.indexOf(s), d = a + s.length;
        if (s1(n.from, n.to, l.doc).filter((f) => f.mark.type.excluded.find((g) => g === e.type && g !== f.mark.type)).filter((f) => f.to > a).length)
          return null;
        d < n.to && i.delete(d, n.to), a > n.from && i.delete(n.from + o, a);
        const p = n.from + o + s.length;
        i.addMark(n.from + o, p, e.type.create(u || {})), i.removeStoredMark(e.type);
      }
    }
  });
}
function Z4(e) {
  return new pa({
    find: e.find,
    handler: ({ state: l, range: n, match: t }) => {
      const u = Ol(e.getAttributes, void 0, t) || {}, { tr: i } = l, s = n.from;
      let r = n.to;
      const o = e.type.create(u);
      if (t[1]) {
        const a = t[0].lastIndexOf(t[1]);
        let d = s + a;
        d > r ? d = r : r = d + t[1].length;
        const h = t[0][t[0].length - 1];
        i.insertText(h, s + t[0].length - 1), i.replaceWith(d, r, o);
      } else
        t[0] && i.insert(s - 1, e.type.create(u)).delete(i.mapping.map(s), i.mapping.map(r));
      i.scrollIntoView();
    }
  });
}
function Jh(e) {
  return new pa({
    find: e.find,
    handler: ({ state: l, range: n, match: t }) => {
      const u = l.doc.resolve(n.from), i = Ol(e.getAttributes, void 0, t) || {};
      if (!u.node(-1).canReplaceWith(u.index(-1), u.indexAfter(-1), e.type))
        return null;
      l.tr.delete(n.from, n.to).setBlockType(n.from, n.from, e.type, i);
    }
  });
}
function xs(e) {
  return new pa({
    find: e.find,
    handler: ({ state: l, range: n, match: t, chain: u }) => {
      const i = Ol(e.getAttributes, void 0, t) || {}, s = l.tr.delete(n.from, n.to), o = s.doc.resolve(n.from).blockRange(), a = o && zf(o, e.type, i);
      if (!a)
        return null;
      if (s.wrap(o, a), e.keepMarks && e.editor) {
        const { selection: h, storedMarks: p } = l, { splittableMarks: f } = e.editor.extensionManager, m = p || h.$to.parentOffset && h.$from.marks();
        if (m) {
          const g = m.filter((v) => f.includes(v.type.name));
          s.ensureMarks(g);
        }
      }
      if (e.keepAttributes) {
        const h = e.type.name === "bulletList" || e.type.name === "orderedList" ? "listItem" : "taskList";
        u().updateAttributes(h, i).run();
      }
      const d = s.doc.resolve(n.from - 1).nodeBefore;
      d && d.type === e.type && ru(s.doc, n.from - 1) && (!e.joinPredicate || e.joinPredicate(t, d)) && s.join(n.from - 1);
    }
  });
}
class ue {
  constructor(l = {}) {
    this.type = "mark", this.name = "mark", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...l
    }, this.name = this.config.name, l.defaultOptions && Object.keys(l.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Ol(sl(this, "addOptions", {
      name: this.name
    }))), this.storage = Ol(sl(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(l = {}) {
    return new ue(l);
  }
  configure(l = {}) {
    const n = this.extend();
    return n.options = fa(this.options, l), n.storage = Ol(sl(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
  extend(l = {}) {
    const n = new ue({ ...this.config, ...l });
    return n.parent = this, this.child = n, n.name = l.name ? l.name : n.parent.name, l.defaultOptions && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${n.name}".`), n.options = Ol(sl(n, "addOptions", {
      name: n.name
    })), n.storage = Ol(sl(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
  static handleExit({ editor: l, mark: n }) {
    const { tr: t } = l.state, u = l.state.selection.$from;
    if (u.pos === u.end()) {
      const s = u.marks();
      if (!!!s.find((a) => (a == null ? void 0 : a.type.name) === n.name))
        return !1;
      const o = s.find((a) => (a == null ? void 0 : a.type.name) === n.name);
      return o && t.removeStoredMark(o), t.insertText(" ", u.pos), l.view.dispatch(t), !0;
    }
    return !1;
  }
}
class gn {
  constructor(l = {}) {
    this.type = "node", this.name = "node", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...l
    }, this.name = this.config.name, l.defaultOptions && Object.keys(l.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Ol(sl(this, "addOptions", {
      name: this.name
    }))), this.storage = Ol(sl(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(l = {}) {
    return new gn(l);
  }
  configure(l = {}) {
    const n = this.extend();
    return n.options = fa(this.options, l), n.storage = Ol(sl(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
  extend(l = {}) {
    const n = new gn({ ...this.config, ...l });
    return n.parent = this, this.child = n, n.name = l.name ? l.name : n.parent.name, l.defaultOptions && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${n.name}".`), n.options = Ol(sl(n, "addOptions", {
      name: n.name
    })), n.storage = Ol(sl(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
}
function Fu(e) {
  return new j4({
    find: e.find,
    handler: ({ state: l, range: n, match: t, pasteEvent: u }) => {
      const i = Ol(e.getAttributes, void 0, t, u);
      if (i === !1 || i === null)
        return null;
      const { tr: s } = l, r = t[t.length - 1], o = t[0];
      let a = n.to;
      if (r) {
        const d = o.search(/\S/), h = n.from + o.indexOf(r), p = h + r.length;
        if (s1(n.from, n.to, l.doc).filter((m) => m.mark.type.excluded.find((v) => v === e.type && v !== m.mark.type)).filter((m) => m.to > h).length)
          return null;
        p < n.to && s.delete(p, n.to), h > n.from && s.delete(n.from + d, h), a = n.from + d + r.length, s.addMark(n.from + d, a, e.type.create(i || {})), s.removeStoredMark(e.type);
      }
    }
  });
}
function NI(e) {
  return new j4({
    find: e.find,
    handler({ match: l, chain: n, range: t, pasteEvent: u }) {
      const i = Ol(e.getAttributes, void 0, l, u);
      if (i === !1 || i === null)
        return null;
      l.input && n().deleteRange(t).insertContentAt(t.from, {
        type: e.type.name,
        attrs: i
      });
    }
  });
}
var Xn = "top", Se = "bottom", Ce = "right", Qn = "left", r1 = "auto", js = [Xn, Se, Ce, Qn], Ti = "start", Es = "end", LI = "clippingParents", X4 = "viewport", zi = "popper", PI = "reference", sg = /* @__PURE__ */ js.reduce(function(e, l) {
  return e.concat([l + "-" + Ti, l + "-" + Es]);
}, []), Q4 = /* @__PURE__ */ [].concat(js, [r1]).reduce(function(e, l) {
  return e.concat([l, l + "-" + Ti, l + "-" + Es]);
}, []), BI = "beforeRead", FI = "read", HI = "afterRead", zI = "beforeMain", VI = "main", jI = "afterMain", UI = "beforeWrite", WI = "write", GI = "afterWrite", KI = [BI, FI, HI, zI, VI, jI, UI, WI, GI];
function yt(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function ie(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var l = e.ownerDocument;
    return l && l.defaultView || window;
  }
  return e;
}
function Hu(e) {
  var l = ie(e).Element;
  return e instanceof l || e instanceof Element;
}
function we(e) {
  var l = ie(e).HTMLElement;
  return e instanceof l || e instanceof HTMLElement;
}
function o1(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var l = ie(e).ShadowRoot;
  return e instanceof l || e instanceof ShadowRoot;
}
function YI(e) {
  var l = e.state;
  Object.keys(l.elements).forEach(function(n) {
    var t = l.styles[n] || {}, u = l.attributes[n] || {}, i = l.elements[n];
    !we(i) || !yt(i) || (Object.assign(i.style, t), Object.keys(u).forEach(function(s) {
      var r = u[s];
      r === !1 ? i.removeAttribute(s) : i.setAttribute(s, r === !0 ? "" : r);
    }));
  });
}
function qI(e) {
  var l = e.state, n = {
    popper: {
      position: l.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(l.elements.popper.style, n.popper), l.styles = n, l.elements.arrow && Object.assign(l.elements.arrow.style, n.arrow), function() {
    Object.keys(l.elements).forEach(function(t) {
      var u = l.elements[t], i = l.attributes[t] || {}, s = Object.keys(l.styles.hasOwnProperty(t) ? l.styles[t] : n[t]), r = s.reduce(function(o, a) {
        return o[a] = "", o;
      }, {});
      !we(u) || !yt(u) || (Object.assign(u.style, r), Object.keys(i).forEach(function(o) {
        u.removeAttribute(o);
      }));
    });
  };
}
const ly = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: YI,
  effect: qI,
  requires: ["computeStyles"]
};
function ct(e) {
  return e.split("-")[0];
}
var Iu = Math.max, qr = Math.min, Oi = Math.round;
function Zh() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(l) {
    return l.brand + "/" + l.version;
  }).join(" ") : navigator.userAgent;
}
function ny() {
  return !/^((?!chrome|android).)*safari/i.test(Zh());
}
function ki(e, l, n) {
  l === void 0 && (l = !1), n === void 0 && (n = !1);
  var t = e.getBoundingClientRect(), u = 1, i = 1;
  l && we(e) && (u = e.offsetWidth > 0 && Oi(t.width) / e.offsetWidth || 1, i = e.offsetHeight > 0 && Oi(t.height) / e.offsetHeight || 1);
  var s = Hu(e) ? ie(e) : window, r = s.visualViewport, o = !ny() && n, a = (t.left + (o && r ? r.offsetLeft : 0)) / u, d = (t.top + (o && r ? r.offsetTop : 0)) / i, h = t.width / u, p = t.height / i;
  return {
    width: h,
    height: p,
    top: d,
    right: a + h,
    bottom: d + p,
    left: a,
    x: a,
    y: d
  };
}
function a1(e) {
  var l = ki(e), n = e.offsetWidth, t = e.offsetHeight;
  return Math.abs(l.width - n) <= 1 && (n = l.width), Math.abs(l.height - t) <= 1 && (t = l.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: t
  };
}
function ey(e, l) {
  var n = l.getRootNode && l.getRootNode();
  if (e.contains(l))
    return !0;
  if (n && o1(n)) {
    var t = l;
    do {
      if (t && e.isSameNode(t))
        return !0;
      t = t.parentNode || t.host;
    } while (t);
  }
  return !1;
}
function Et(e) {
  return ie(e).getComputedStyle(e);
}
function JI(e) {
  return ["table", "td", "th"].indexOf(yt(e)) >= 0;
}
function du(e) {
  return ((Hu(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function ga(e) {
  return yt(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (o1(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    du(e)
  );
}
function rg(e) {
  return !we(e) || // https://github.com/popperjs/popper-core/issues/837
  Et(e).position === "fixed" ? null : e.offsetParent;
}
function ZI(e) {
  var l = /firefox/i.test(Zh()), n = /Trident/i.test(Zh());
  if (n && we(e)) {
    var t = Et(e);
    if (t.position === "fixed")
      return null;
  }
  var u = ga(e);
  for (o1(u) && (u = u.host); we(u) && ["html", "body"].indexOf(yt(u)) < 0; ) {
    var i = Et(u);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || l && i.willChange === "filter" || l && i.filter && i.filter !== "none")
      return u;
    u = u.parentNode;
  }
  return null;
}
function Us(e) {
  for (var l = ie(e), n = rg(e); n && JI(n) && Et(n).position === "static"; )
    n = rg(n);
  return n && (yt(n) === "html" || yt(n) === "body" && Et(n).position === "static") ? l : n || ZI(e) || l;
}
function d1(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function us(e, l, n) {
  return Iu(e, qr(l, n));
}
function XI(e, l, n) {
  var t = us(e, l, n);
  return t > n ? n : t;
}
function ty() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function uy(e) {
  return Object.assign({}, ty(), e);
}
function iy(e, l) {
  return l.reduce(function(n, t) {
    return n[t] = e, n;
  }, {});
}
var QI = function(l, n) {
  return l = typeof l == "function" ? l(Object.assign({}, n.rects, {
    placement: n.placement
  })) : l, uy(typeof l != "number" ? l : iy(l, js));
};
function lR(e) {
  var l, n = e.state, t = e.name, u = e.options, i = n.elements.arrow, s = n.modifiersData.popperOffsets, r = ct(n.placement), o = d1(r), a = [Qn, Ce].indexOf(r) >= 0, d = a ? "height" : "width";
  if (!(!i || !s)) {
    var h = QI(u.padding, n), p = a1(i), f = o === "y" ? Xn : Qn, m = o === "y" ? Se : Ce, g = n.rects.reference[d] + n.rects.reference[o] - s[o] - n.rects.popper[d], v = s[o] - n.rects.reference[o], w = Us(i), $ = w ? o === "y" ? w.clientHeight || 0 : w.clientWidth || 0 : 0, _ = g / 2 - v / 2, b = h[f], k = $ - p[d] - h[m], T = $ / 2 - p[d] / 2 + _, M = us(b, T, k), H = o;
    n.modifiersData[t] = (l = {}, l[H] = M, l.centerOffset = M - T, l);
  }
}
function nR(e) {
  var l = e.state, n = e.options, t = n.element, u = t === void 0 ? "[data-popper-arrow]" : t;
  u != null && (typeof u == "string" && (u = l.elements.popper.querySelector(u), !u) || ey(l.elements.popper, u) && (l.elements.arrow = u));
}
const eR = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: lR,
  effect: nR,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Mi(e) {
  return e.split("-")[1];
}
var tR = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function uR(e, l) {
  var n = e.x, t = e.y, u = l.devicePixelRatio || 1;
  return {
    x: Oi(n * u) / u || 0,
    y: Oi(t * u) / u || 0
  };
}
function og(e) {
  var l, n = e.popper, t = e.popperRect, u = e.placement, i = e.variation, s = e.offsets, r = e.position, o = e.gpuAcceleration, a = e.adaptive, d = e.roundOffsets, h = e.isFixed, p = s.x, f = p === void 0 ? 0 : p, m = s.y, g = m === void 0 ? 0 : m, v = typeof d == "function" ? d({
    x: f,
    y: g
  }) : {
    x: f,
    y: g
  };
  f = v.x, g = v.y;
  var w = s.hasOwnProperty("x"), $ = s.hasOwnProperty("y"), _ = Qn, b = Xn, k = window;
  if (a) {
    var T = Us(n), M = "clientHeight", H = "clientWidth";
    if (T === ie(n) && (T = du(n), Et(T).position !== "static" && r === "absolute" && (M = "scrollHeight", H = "scrollWidth")), T = T, u === Xn || (u === Qn || u === Ce) && i === Es) {
      b = Se;
      var x = h && T === k && k.visualViewport ? k.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        T[M]
      );
      g -= x - t.height, g *= o ? 1 : -1;
    }
    if (u === Qn || (u === Xn || u === Se) && i === Es) {
      _ = Ce;
      var P = h && T === k && k.visualViewport ? k.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        T[H]
      );
      f -= P - t.width, f *= o ? 1 : -1;
    }
  }
  var Z = Object.assign({
    position: r
  }, a && tR), F = d === !0 ? uR({
    x: f,
    y: g
  }, ie(n)) : {
    x: f,
    y: g
  };
  if (f = F.x, g = F.y, o) {
    var el;
    return Object.assign({}, Z, (el = {}, el[b] = $ ? "0" : "", el[_] = w ? "0" : "", el.transform = (k.devicePixelRatio || 1) <= 1 ? "translate(" + f + "px, " + g + "px)" : "translate3d(" + f + "px, " + g + "px, 0)", el));
  }
  return Object.assign({}, Z, (l = {}, l[b] = $ ? g + "px" : "", l[_] = w ? f + "px" : "", l.transform = "", l));
}
function iR(e) {
  var l = e.state, n = e.options, t = n.gpuAcceleration, u = t === void 0 ? !0 : t, i = n.adaptive, s = i === void 0 ? !0 : i, r = n.roundOffsets, o = r === void 0 ? !0 : r, a = {
    placement: ct(l.placement),
    variation: Mi(l.placement),
    popper: l.elements.popper,
    popperRect: l.rects.popper,
    gpuAcceleration: u,
    isFixed: l.options.strategy === "fixed"
  };
  l.modifiersData.popperOffsets != null && (l.styles.popper = Object.assign({}, l.styles.popper, og(Object.assign({}, a, {
    offsets: l.modifiersData.popperOffsets,
    position: l.options.strategy,
    adaptive: s,
    roundOffsets: o
  })))), l.modifiersData.arrow != null && (l.styles.arrow = Object.assign({}, l.styles.arrow, og(Object.assign({}, a, {
    offsets: l.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: o
  })))), l.attributes.popper = Object.assign({}, l.attributes.popper, {
    "data-popper-placement": l.placement
  });
}
const sR = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: iR,
  data: {}
};
var rr = {
  passive: !0
};
function rR(e) {
  var l = e.state, n = e.instance, t = e.options, u = t.scroll, i = u === void 0 ? !0 : u, s = t.resize, r = s === void 0 ? !0 : s, o = ie(l.elements.popper), a = [].concat(l.scrollParents.reference, l.scrollParents.popper);
  return i && a.forEach(function(d) {
    d.addEventListener("scroll", n.update, rr);
  }), r && o.addEventListener("resize", n.update, rr), function() {
    i && a.forEach(function(d) {
      d.removeEventListener("scroll", n.update, rr);
    }), r && o.removeEventListener("resize", n.update, rr);
  };
}
const oR = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: rR,
  data: {}
};
var aR = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function wr(e) {
  return e.replace(/left|right|bottom|top/g, function(l) {
    return aR[l];
  });
}
var dR = {
  start: "end",
  end: "start"
};
function ag(e) {
  return e.replace(/start|end/g, function(l) {
    return dR[l];
  });
}
function c1(e) {
  var l = ie(e), n = l.pageXOffset, t = l.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: t
  };
}
function h1(e) {
  return ki(du(e)).left + c1(e).scrollLeft;
}
function cR(e, l) {
  var n = ie(e), t = du(e), u = n.visualViewport, i = t.clientWidth, s = t.clientHeight, r = 0, o = 0;
  if (u) {
    i = u.width, s = u.height;
    var a = ny();
    (a || !a && l === "fixed") && (r = u.offsetLeft, o = u.offsetTop);
  }
  return {
    width: i,
    height: s,
    x: r + h1(e),
    y: o
  };
}
function hR(e) {
  var l, n = du(e), t = c1(e), u = (l = e.ownerDocument) == null ? void 0 : l.body, i = Iu(n.scrollWidth, n.clientWidth, u ? u.scrollWidth : 0, u ? u.clientWidth : 0), s = Iu(n.scrollHeight, n.clientHeight, u ? u.scrollHeight : 0, u ? u.clientHeight : 0), r = -t.scrollLeft + h1(e), o = -t.scrollTop;
  return Et(u || n).direction === "rtl" && (r += Iu(n.clientWidth, u ? u.clientWidth : 0) - i), {
    width: i,
    height: s,
    x: r,
    y: o
  };
}
function p1(e) {
  var l = Et(e), n = l.overflow, t = l.overflowX, u = l.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + u + t);
}
function sy(e) {
  return ["html", "body", "#document"].indexOf(yt(e)) >= 0 ? e.ownerDocument.body : we(e) && p1(e) ? e : sy(ga(e));
}
function is(e, l) {
  var n;
  l === void 0 && (l = []);
  var t = sy(e), u = t === ((n = e.ownerDocument) == null ? void 0 : n.body), i = ie(t), s = u ? [i].concat(i.visualViewport || [], p1(t) ? t : []) : t, r = l.concat(s);
  return u ? r : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    r.concat(is(ga(s)))
  );
}
function Xh(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function pR(e, l) {
  var n = ki(e, !1, l === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function dg(e, l, n) {
  return l === X4 ? Xh(cR(e, n)) : Hu(l) ? pR(l, n) : Xh(hR(du(e)));
}
function fR(e) {
  var l = is(ga(e)), n = ["absolute", "fixed"].indexOf(Et(e).position) >= 0, t = n && we(e) ? Us(e) : e;
  return Hu(t) ? l.filter(function(u) {
    return Hu(u) && ey(u, t) && yt(u) !== "body";
  }) : [];
}
function mR(e, l, n, t) {
  var u = l === "clippingParents" ? fR(e) : [].concat(l), i = [].concat(u, [n]), s = i[0], r = i.reduce(function(o, a) {
    var d = dg(e, a, t);
    return o.top = Iu(d.top, o.top), o.right = qr(d.right, o.right), o.bottom = qr(d.bottom, o.bottom), o.left = Iu(d.left, o.left), o;
  }, dg(e, s, t));
  return r.width = r.right - r.left, r.height = r.bottom - r.top, r.x = r.left, r.y = r.top, r;
}
function ry(e) {
  var l = e.reference, n = e.element, t = e.placement, u = t ? ct(t) : null, i = t ? Mi(t) : null, s = l.x + l.width / 2 - n.width / 2, r = l.y + l.height / 2 - n.height / 2, o;
  switch (u) {
    case Xn:
      o = {
        x: s,
        y: l.y - n.height
      };
      break;
    case Se:
      o = {
        x: s,
        y: l.y + l.height
      };
      break;
    case Ce:
      o = {
        x: l.x + l.width,
        y: r
      };
      break;
    case Qn:
      o = {
        x: l.x - n.width,
        y: r
      };
      break;
    default:
      o = {
        x: l.x,
        y: l.y
      };
  }
  var a = u ? d1(u) : null;
  if (a != null) {
    var d = a === "y" ? "height" : "width";
    switch (i) {
      case Ti:
        o[a] = o[a] - (l[d] / 2 - n[d] / 2);
        break;
      case Es:
        o[a] = o[a] + (l[d] / 2 - n[d] / 2);
        break;
    }
  }
  return o;
}
function Is(e, l) {
  l === void 0 && (l = {});
  var n = l, t = n.placement, u = t === void 0 ? e.placement : t, i = n.strategy, s = i === void 0 ? e.strategy : i, r = n.boundary, o = r === void 0 ? LI : r, a = n.rootBoundary, d = a === void 0 ? X4 : a, h = n.elementContext, p = h === void 0 ? zi : h, f = n.altBoundary, m = f === void 0 ? !1 : f, g = n.padding, v = g === void 0 ? 0 : g, w = uy(typeof v != "number" ? v : iy(v, js)), $ = p === zi ? PI : zi, _ = e.rects.popper, b = e.elements[m ? $ : p], k = mR(Hu(b) ? b : b.contextElement || du(e.elements.popper), o, d, s), T = ki(e.elements.reference), M = ry({
    reference: T,
    element: _,
    strategy: "absolute",
    placement: u
  }), H = Xh(Object.assign({}, _, M)), x = p === zi ? H : T, P = {
    top: k.top - x.top + w.top,
    bottom: x.bottom - k.bottom + w.bottom,
    left: k.left - x.left + w.left,
    right: x.right - k.right + w.right
  }, Z = e.modifiersData.offset;
  if (p === zi && Z) {
    var F = Z[u];
    Object.keys(P).forEach(function(el) {
      var al = [Ce, Se].indexOf(el) >= 0 ? 1 : -1, ll = [Xn, Se].indexOf(el) >= 0 ? "y" : "x";
      P[el] += F[ll] * al;
    });
  }
  return P;
}
function gR(e, l) {
  l === void 0 && (l = {});
  var n = l, t = n.placement, u = n.boundary, i = n.rootBoundary, s = n.padding, r = n.flipVariations, o = n.allowedAutoPlacements, a = o === void 0 ? Q4 : o, d = Mi(t), h = d ? r ? sg : sg.filter(function(m) {
    return Mi(m) === d;
  }) : js, p = h.filter(function(m) {
    return a.indexOf(m) >= 0;
  });
  p.length === 0 && (p = h);
  var f = p.reduce(function(m, g) {
    return m[g] = Is(e, {
      placement: g,
      boundary: u,
      rootBoundary: i,
      padding: s
    })[ct(g)], m;
  }, {});
  return Object.keys(f).sort(function(m, g) {
    return f[m] - f[g];
  });
}
function vR(e) {
  if (ct(e) === r1)
    return [];
  var l = wr(e);
  return [ag(e), l, ag(l)];
}
function yR(e) {
  var l = e.state, n = e.options, t = e.name;
  if (!l.modifiersData[t]._skip) {
    for (var u = n.mainAxis, i = u === void 0 ? !0 : u, s = n.altAxis, r = s === void 0 ? !0 : s, o = n.fallbackPlacements, a = n.padding, d = n.boundary, h = n.rootBoundary, p = n.altBoundary, f = n.flipVariations, m = f === void 0 ? !0 : f, g = n.allowedAutoPlacements, v = l.options.placement, w = ct(v), $ = w === v, _ = o || ($ || !m ? [wr(v)] : vR(v)), b = [v].concat(_).reduce(function(vn, en) {
      return vn.concat(ct(en) === r1 ? gR(l, {
        placement: en,
        boundary: d,
        rootBoundary: h,
        padding: a,
        flipVariations: m,
        allowedAutoPlacements: g
      }) : en);
    }, []), k = l.rects.reference, T = l.rects.popper, M = /* @__PURE__ */ new Map(), H = !0, x = b[0], P = 0; P < b.length; P++) {
      var Z = b[P], F = ct(Z), el = Mi(Z) === Ti, al = [Xn, Se].indexOf(F) >= 0, ll = al ? "width" : "height", Y = Is(l, {
        placement: Z,
        boundary: d,
        rootBoundary: h,
        altBoundary: p,
        padding: a
      }), Q = al ? el ? Ce : Qn : el ? Se : Xn;
      k[ll] > T[ll] && (Q = wr(Q));
      var dl = wr(Q), zl = [];
      if (i && zl.push(Y[F] <= 0), r && zl.push(Y[Q] <= 0, Y[dl] <= 0), zl.every(function(vn) {
        return vn;
      })) {
        x = Z, H = !1;
        break;
      }
      M.set(Z, zl);
    }
    if (H)
      for (var Xl = m ? 3 : 1, sn = function(en) {
        var kn = b.find(function(re) {
          var Mn = M.get(re);
          if (Mn)
            return Mn.slice(0, en).every(function(oe) {
              return oe;
            });
        });
        if (kn)
          return x = kn, "break";
      }, Jl = Xl; Jl > 0; Jl--) {
        var rn = sn(Jl);
        if (rn === "break")
          break;
      }
    l.placement !== x && (l.modifiersData[t]._skip = !0, l.placement = x, l.reset = !0);
  }
}
const $R = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: yR,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function cg(e, l, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - l.height - n.y,
    right: e.right - l.width + n.x,
    bottom: e.bottom - l.height + n.y,
    left: e.left - l.width - n.x
  };
}
function hg(e) {
  return [Xn, Ce, Se, Qn].some(function(l) {
    return e[l] >= 0;
  });
}
function bR(e) {
  var l = e.state, n = e.name, t = l.rects.reference, u = l.rects.popper, i = l.modifiersData.preventOverflow, s = Is(l, {
    elementContext: "reference"
  }), r = Is(l, {
    altBoundary: !0
  }), o = cg(s, t), a = cg(r, u, i), d = hg(o), h = hg(a);
  l.modifiersData[n] = {
    referenceClippingOffsets: o,
    popperEscapeOffsets: a,
    isReferenceHidden: d,
    hasPopperEscaped: h
  }, l.attributes.popper = Object.assign({}, l.attributes.popper, {
    "data-popper-reference-hidden": d,
    "data-popper-escaped": h
  });
}
const wR = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: bR
};
function _R(e, l, n) {
  var t = ct(e), u = [Qn, Xn].indexOf(t) >= 0 ? -1 : 1, i = typeof n == "function" ? n(Object.assign({}, l, {
    placement: e
  })) : n, s = i[0], r = i[1];
  return s = s || 0, r = (r || 0) * u, [Qn, Ce].indexOf(t) >= 0 ? {
    x: r,
    y: s
  } : {
    x: s,
    y: r
  };
}
function SR(e) {
  var l = e.state, n = e.options, t = e.name, u = n.offset, i = u === void 0 ? [0, 0] : u, s = Q4.reduce(function(d, h) {
    return d[h] = _R(h, l.rects, i), d;
  }, {}), r = s[l.placement], o = r.x, a = r.y;
  l.modifiersData.popperOffsets != null && (l.modifiersData.popperOffsets.x += o, l.modifiersData.popperOffsets.y += a), l.modifiersData[t] = s;
}
const CR = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: SR
};
function TR(e) {
  var l = e.state, n = e.name;
  l.modifiersData[n] = ry({
    reference: l.rects.reference,
    element: l.rects.popper,
    strategy: "absolute",
    placement: l.placement
  });
}
const OR = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: TR,
  data: {}
};
function kR(e) {
  return e === "x" ? "y" : "x";
}
function MR(e) {
  var l = e.state, n = e.options, t = e.name, u = n.mainAxis, i = u === void 0 ? !0 : u, s = n.altAxis, r = s === void 0 ? !1 : s, o = n.boundary, a = n.rootBoundary, d = n.altBoundary, h = n.padding, p = n.tether, f = p === void 0 ? !0 : p, m = n.tetherOffset, g = m === void 0 ? 0 : m, v = Is(l, {
    boundary: o,
    rootBoundary: a,
    padding: h,
    altBoundary: d
  }), w = ct(l.placement), $ = Mi(l.placement), _ = !$, b = d1(w), k = kR(b), T = l.modifiersData.popperOffsets, M = l.rects.reference, H = l.rects.popper, x = typeof g == "function" ? g(Object.assign({}, l.rects, {
    placement: l.placement
  })) : g, P = typeof x == "number" ? {
    mainAxis: x,
    altAxis: x
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, x), Z = l.modifiersData.offset ? l.modifiersData.offset[l.placement] : null, F = {
    x: 0,
    y: 0
  };
  if (T) {
    if (i) {
      var el, al = b === "y" ? Xn : Qn, ll = b === "y" ? Se : Ce, Y = b === "y" ? "height" : "width", Q = T[b], dl = Q + v[al], zl = Q - v[ll], Xl = f ? -H[Y] / 2 : 0, sn = $ === Ti ? M[Y] : H[Y], Jl = $ === Ti ? -H[Y] : -M[Y], rn = l.elements.arrow, vn = f && rn ? a1(rn) : {
        width: 0,
        height: 0
      }, en = l.modifiersData["arrow#persistent"] ? l.modifiersData["arrow#persistent"].padding : ty(), kn = en[al], re = en[ll], Mn = us(0, M[Y], vn[Y]), oe = _ ? M[Y] / 2 - Xl - Mn - kn - P.mainAxis : sn - Mn - kn - P.mainAxis, yn = _ ? -M[Y] / 2 + Xl + Mn + re + P.mainAxis : Jl + Mn + re + P.mainAxis, ae = l.elements.arrow && Us(l.elements.arrow), $t = ae ? b === "y" ? ae.clientTop || 0 : ae.clientLeft || 0 : 0, Ve = (el = Z == null ? void 0 : Z[b]) != null ? el : 0, bt = Q + oe - Ve - $t, je = Q + yn - Ve, de = us(f ? qr(dl, bt) : dl, Q, f ? Iu(zl, je) : zl);
      T[b] = de, F[b] = de - Q;
    }
    if (r) {
      var ke, Ue = b === "x" ? Xn : Qn, wt = b === "x" ? Se : Ce, Pn = T[k], Gn = k === "y" ? "height" : "width", le = Pn + v[Ue], Kn = Pn - v[wt], Me = [Xn, Qn].indexOf(w) !== -1, We = (ke = Z == null ? void 0 : Z[k]) != null ? ke : 0, Ge = Me ? le : Pn - M[Gn] - H[Gn] - We + P.altAxis, Ke = Me ? Pn + M[Gn] + H[Gn] - We - P.altAxis : Kn, Ye = f && Me ? XI(Ge, Pn, Ke) : us(f ? Ge : le, Pn, f ? Ke : Kn);
      T[k] = Ye, F[k] = Ye - Pn;
    }
    l.modifiersData[t] = F;
  }
}
const AR = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: MR,
  requiresIfExists: ["offset"]
};
function xR(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function ER(e) {
  return e === ie(e) || !we(e) ? c1(e) : xR(e);
}
function IR(e) {
  var l = e.getBoundingClientRect(), n = Oi(l.width) / e.offsetWidth || 1, t = Oi(l.height) / e.offsetHeight || 1;
  return n !== 1 || t !== 1;
}
function RR(e, l, n) {
  n === void 0 && (n = !1);
  var t = we(l), u = we(l) && IR(l), i = du(l), s = ki(e, u, n), r = {
    scrollLeft: 0,
    scrollTop: 0
  }, o = {
    x: 0,
    y: 0
  };
  return (t || !t && !n) && ((yt(l) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  p1(i)) && (r = ER(l)), we(l) ? (o = ki(l, !0), o.x += l.clientLeft, o.y += l.clientTop) : i && (o.x = h1(i))), {
    x: s.left + r.scrollLeft - o.x,
    y: s.top + r.scrollTop - o.y,
    width: s.width,
    height: s.height
  };
}
function DR(e) {
  var l = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), t = [];
  e.forEach(function(i) {
    l.set(i.name, i);
  });
  function u(i) {
    n.add(i.name);
    var s = [].concat(i.requires || [], i.requiresIfExists || []);
    s.forEach(function(r) {
      if (!n.has(r)) {
        var o = l.get(r);
        o && u(o);
      }
    }), t.push(i);
  }
  return e.forEach(function(i) {
    n.has(i.name) || u(i);
  }), t;
}
function NR(e) {
  var l = DR(e);
  return KI.reduce(function(n, t) {
    return n.concat(l.filter(function(u) {
      return u.phase === t;
    }));
  }, []);
}
function LR(e) {
  var l;
  return function() {
    return l || (l = new Promise(function(n) {
      Promise.resolve().then(function() {
        l = void 0, n(e());
      });
    })), l;
  };
}
function PR(e) {
  var l = e.reduce(function(n, t) {
    var u = n[t.name];
    return n[t.name] = u ? Object.assign({}, u, t, {
      options: Object.assign({}, u.options, t.options),
      data: Object.assign({}, u.data, t.data)
    }) : t, n;
  }, {});
  return Object.keys(l).map(function(n) {
    return l[n];
  });
}
var pg = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function fg() {
  for (var e = arguments.length, l = new Array(e), n = 0; n < e; n++)
    l[n] = arguments[n];
  return !l.some(function(t) {
    return !(t && typeof t.getBoundingClientRect == "function");
  });
}
function BR(e) {
  e === void 0 && (e = {});
  var l = e, n = l.defaultModifiers, t = n === void 0 ? [] : n, u = l.defaultOptions, i = u === void 0 ? pg : u;
  return function(r, o, a) {
    a === void 0 && (a = i);
    var d = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, pg, i),
      modifiersData: {},
      elements: {
        reference: r,
        popper: o
      },
      attributes: {},
      styles: {}
    }, h = [], p = !1, f = {
      state: d,
      setOptions: function(w) {
        var $ = typeof w == "function" ? w(d.options) : w;
        g(), d.options = Object.assign({}, i, d.options, $), d.scrollParents = {
          reference: Hu(r) ? is(r) : r.contextElement ? is(r.contextElement) : [],
          popper: is(o)
        };
        var _ = NR(PR([].concat(t, d.options.modifiers)));
        return d.orderedModifiers = _.filter(function(b) {
          return b.enabled;
        }), m(), f.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!p) {
          var w = d.elements, $ = w.reference, _ = w.popper;
          if (fg($, _)) {
            d.rects = {
              reference: RR($, Us(_), d.options.strategy === "fixed"),
              popper: a1(_)
            }, d.reset = !1, d.placement = d.options.placement, d.orderedModifiers.forEach(function(P) {
              return d.modifiersData[P.name] = Object.assign({}, P.data);
            });
            for (var b = 0; b < d.orderedModifiers.length; b++) {
              if (d.reset === !0) {
                d.reset = !1, b = -1;
                continue;
              }
              var k = d.orderedModifiers[b], T = k.fn, M = k.options, H = M === void 0 ? {} : M, x = k.name;
              typeof T == "function" && (d = T({
                state: d,
                options: H,
                name: x,
                instance: f
              }) || d);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: LR(function() {
        return new Promise(function(v) {
          f.forceUpdate(), v(d);
        });
      }),
      destroy: function() {
        g(), p = !0;
      }
    };
    if (!fg(r, o))
      return f;
    f.setOptions(a).then(function(v) {
      !p && a.onFirstUpdate && a.onFirstUpdate(v);
    });
    function m() {
      d.orderedModifiers.forEach(function(v) {
        var w = v.name, $ = v.options, _ = $ === void 0 ? {} : $, b = v.effect;
        if (typeof b == "function") {
          var k = b({
            state: d,
            name: w,
            instance: f,
            options: _
          }), T = function() {
          };
          h.push(k || T);
        }
      });
    }
    function g() {
      h.forEach(function(v) {
        return v();
      }), h = [];
    }
    return f;
  };
}
var FR = [oR, OR, sR, ly, CR, $R, AR, eR, wR], HR = /* @__PURE__ */ BR({
  defaultModifiers: FR
}), zR = "tippy-box", oy = "tippy-content", VR = "tippy-backdrop", ay = "tippy-arrow", dy = "tippy-svg-arrow", yu = {
  passive: !0,
  capture: !0
}, cy = function() {
  return document.body;
};
function jR(e, l) {
  return {}.hasOwnProperty.call(e, l);
}
function Ld(e, l, n) {
  if (Array.isArray(e)) {
    var t = e[l];
    return t ?? (Array.isArray(n) ? n[l] : n);
  }
  return e;
}
function f1(e, l) {
  var n = {}.toString.call(e);
  return n.indexOf("[object") === 0 && n.indexOf(l + "]") > -1;
}
function hy(e, l) {
  return typeof e == "function" ? e.apply(void 0, l) : e;
}
function mg(e, l) {
  if (l === 0)
    return e;
  var n;
  return function(t) {
    clearTimeout(n), n = setTimeout(function() {
      e(t);
    }, l);
  };
}
function UR(e, l) {
  var n = Object.assign({}, e);
  return l.forEach(function(t) {
    delete n[t];
  }), n;
}
function WR(e) {
  return e.split(/\s+/).filter(Boolean);
}
function ni(e) {
  return [].concat(e);
}
function gg(e, l) {
  e.indexOf(l) === -1 && e.push(l);
}
function GR(e) {
  return e.filter(function(l, n) {
    return e.indexOf(l) === n;
  });
}
function KR(e) {
  return e.split("-")[0];
}
function Jr(e) {
  return [].slice.call(e);
}
function vg(e) {
  return Object.keys(e).reduce(function(l, n) {
    return e[n] !== void 0 && (l[n] = e[n]), l;
  }, {});
}
function ss() {
  return document.createElement("div");
}
function Rs(e) {
  return ["Element", "Fragment"].some(function(l) {
    return f1(e, l);
  });
}
function YR(e) {
  return f1(e, "NodeList");
}
function qR(e) {
  return f1(e, "MouseEvent");
}
function JR(e) {
  return !!(e && e._tippy && e._tippy.reference === e);
}
function ZR(e) {
  return Rs(e) ? [e] : YR(e) ? Jr(e) : Array.isArray(e) ? e : Jr(document.querySelectorAll(e));
}
function Pd(e, l) {
  e.forEach(function(n) {
    n && (n.style.transitionDuration = l + "ms");
  });
}
function yg(e, l) {
  e.forEach(function(n) {
    n && n.setAttribute("data-state", l);
  });
}
function XR(e) {
  var l, n = ni(e), t = n[0];
  return t != null && (l = t.ownerDocument) != null && l.body ? t.ownerDocument : document;
}
function QR(e, l) {
  var n = l.clientX, t = l.clientY;
  return e.every(function(u) {
    var i = u.popperRect, s = u.popperState, r = u.props, o = r.interactiveBorder, a = KR(s.placement), d = s.modifiersData.offset;
    if (!d)
      return !0;
    var h = a === "bottom" ? d.top.y : 0, p = a === "top" ? d.bottom.y : 0, f = a === "right" ? d.left.x : 0, m = a === "left" ? d.right.x : 0, g = i.top - t + h > o, v = t - i.bottom - p > o, w = i.left - n + f > o, $ = n - i.right - m > o;
    return g || v || w || $;
  });
}
function Bd(e, l, n) {
  var t = l + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(u) {
    e[t](u, n);
  });
}
function $g(e, l) {
  for (var n = l; n; ) {
    var t;
    if (e.contains(n))
      return !0;
    n = n.getRootNode == null || (t = n.getRootNode()) == null ? void 0 : t.host;
  }
  return !1;
}
var lt = {
  isTouch: !1
}, bg = 0;
function lD() {
  lt.isTouch || (lt.isTouch = !0, window.performance && document.addEventListener("mousemove", py));
}
function py() {
  var e = performance.now();
  e - bg < 20 && (lt.isTouch = !1, document.removeEventListener("mousemove", py)), bg = e;
}
function nD() {
  var e = document.activeElement;
  if (JR(e)) {
    var l = e._tippy;
    e.blur && !l.state.isVisible && e.blur();
  }
}
function eD() {
  document.addEventListener("touchstart", lD, yu), window.addEventListener("blur", nD);
}
var tD = typeof window < "u" && typeof document < "u", uD = tD ? (
  // @ts-ignore
  !!window.msCrypto
) : !1;
function Ju(e) {
  var l = e === "destroy" ? "n already-" : " ";
  return [e + "() was called on a" + l + "destroyed instance. This is a no-op but", "indicates a potential memory leak."].join(" ");
}
function wg(e) {
  var l = /[ \t]{2,}/g, n = /^[ \t]*/gm;
  return e.replace(l, " ").replace(n, "").trim();
}
function iD(e) {
  return wg(`
  %ctippy.js

  %c` + wg(e) + `

  %c👷‍ This is a development-only message. It will be removed in production.
  `);
}
function fy(e) {
  return [
    iD(e),
    // title
    "color: #00C584; font-size: 1.3em; font-weight: bold;",
    // message
    "line-height: 1.5",
    // footer
    "color: #a6a095;"
  ];
}
var Ds;
process.env.NODE_ENV !== "production" && sD();
function sD() {
  Ds = /* @__PURE__ */ new Set();
}
function Ot(e, l) {
  if (e && !Ds.has(l)) {
    var n;
    Ds.add(l), (n = console).warn.apply(n, fy(l));
  }
}
function Qh(e, l) {
  if (e && !Ds.has(l)) {
    var n;
    Ds.add(l), (n = console).error.apply(n, fy(l));
  }
}
function rD(e) {
  var l = !e, n = Object.prototype.toString.call(e) === "[object Object]" && !e.addEventListener;
  Qh(l, ["tippy() was passed", "`" + String(e) + "`", "as its targets (first) argument. Valid types are: String, Element,", "Element[], or NodeList."].join(" ")), Qh(n, ["tippy() was passed a plain object which is not supported as an argument", "for virtual positioning. Use props.getReferenceClientRect instead."].join(" "));
}
var my = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, oD = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, ee = Object.assign({
  appendTo: cy,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, my, oD), aD = Object.keys(ee), dD = function(l) {
  process.env.NODE_ENV !== "production" && vy(l, []);
  var n = Object.keys(l);
  n.forEach(function(t) {
    ee[t] = l[t];
  });
};
function gy(e) {
  var l = e.plugins || [], n = l.reduce(function(t, u) {
    var i = u.name, s = u.defaultValue;
    if (i) {
      var r;
      t[i] = e[i] !== void 0 ? e[i] : (r = ee[i]) != null ? r : s;
    }
    return t;
  }, {});
  return Object.assign({}, e, n);
}
function cD(e, l) {
  var n = l ? Object.keys(gy(Object.assign({}, ee, {
    plugins: l
  }))) : aD, t = n.reduce(function(u, i) {
    var s = (e.getAttribute("data-tippy-" + i) || "").trim();
    if (!s)
      return u;
    if (i === "content")
      u[i] = s;
    else
      try {
        u[i] = JSON.parse(s);
      } catch {
        u[i] = s;
      }
    return u;
  }, {});
  return t;
}
function _g(e, l) {
  var n = Object.assign({}, l, {
    content: hy(l.content, [e])
  }, l.ignoreAttributes ? {} : cD(e, l.plugins));
  return n.aria = Object.assign({}, ee.aria, n.aria), n.aria = {
    expanded: n.aria.expanded === "auto" ? l.interactive : n.aria.expanded,
    content: n.aria.content === "auto" ? l.interactive ? null : "describedby" : n.aria.content
  }, n;
}
function vy(e, l) {
  e === void 0 && (e = {}), l === void 0 && (l = []);
  var n = Object.keys(e);
  n.forEach(function(t) {
    var u = UR(ee, Object.keys(my)), i = !jR(u, t);
    i && (i = l.filter(function(s) {
      return s.name === t;
    }).length === 0), Ot(i, ["`" + t + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", "a plugin, forgot to pass it in an array as props.plugins.", `

`, `All props: https://atomiks.github.io/tippyjs/v6/all-props/
`, "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"].join(" "));
  });
}
var hD = function() {
  return "innerHTML";
};
function lp(e, l) {
  e[hD()] = l;
}
function Sg(e) {
  var l = ss();
  return e === !0 ? l.className = ay : (l.className = dy, Rs(e) ? l.appendChild(e) : lp(l, e)), l;
}
function Cg(e, l) {
  Rs(l.content) ? (lp(e, ""), e.appendChild(l.content)) : typeof l.content != "function" && (l.allowHTML ? lp(e, l.content) : e.textContent = l.content);
}
function np(e) {
  var l = e.firstElementChild, n = Jr(l.children);
  return {
    box: l,
    content: n.find(function(t) {
      return t.classList.contains(oy);
    }),
    arrow: n.find(function(t) {
      return t.classList.contains(ay) || t.classList.contains(dy);
    }),
    backdrop: n.find(function(t) {
      return t.classList.contains(VR);
    })
  };
}
function yy(e) {
  var l = ss(), n = ss();
  n.className = zR, n.setAttribute("data-state", "hidden"), n.setAttribute("tabindex", "-1");
  var t = ss();
  t.className = oy, t.setAttribute("data-state", "hidden"), Cg(t, e.props), l.appendChild(n), n.appendChild(t), u(e.props, e.props);
  function u(i, s) {
    var r = np(l), o = r.box, a = r.content, d = r.arrow;
    s.theme ? o.setAttribute("data-theme", s.theme) : o.removeAttribute("data-theme"), typeof s.animation == "string" ? o.setAttribute("data-animation", s.animation) : o.removeAttribute("data-animation"), s.inertia ? o.setAttribute("data-inertia", "") : o.removeAttribute("data-inertia"), o.style.maxWidth = typeof s.maxWidth == "number" ? s.maxWidth + "px" : s.maxWidth, s.role ? o.setAttribute("role", s.role) : o.removeAttribute("role"), (i.content !== s.content || i.allowHTML !== s.allowHTML) && Cg(a, e.props), s.arrow ? d ? i.arrow !== s.arrow && (o.removeChild(d), o.appendChild(Sg(s.arrow))) : o.appendChild(Sg(s.arrow)) : d && o.removeChild(d);
  }
  return {
    popper: l,
    onUpdate: u
  };
}
yy.$$tippy = !0;
var pD = 1, or = [], Fd = [];
function fD(e, l) {
  var n = _g(e, Object.assign({}, ee, gy(vg(l)))), t, u, i, s = !1, r = !1, o = !1, a = !1, d, h, p, f = [], m = mg(bt, n.interactiveDebounce), g, v = pD++, w = null, $ = GR(n.plugins), _ = {
    // Is the instance currently enabled?
    isEnabled: !0,
    // Is the tippy currently showing and not transitioning out?
    isVisible: !1,
    // Has the instance been destroyed?
    isDestroyed: !1,
    // Is the tippy currently mounted to the DOM?
    isMounted: !1,
    // Has the tippy finished transitioning in?
    isShown: !1
  }, b = {
    // properties
    id: v,
    reference: e,
    popper: ss(),
    popperInstance: w,
    props: n,
    state: _,
    plugins: $,
    // methods
    clearDelayTimeouts: Ge,
    setProps: Ke,
    setContent: Ye,
    show: C,
    hide: N,
    hideWithInteractivity: D,
    enable: Me,
    disable: We,
    unmount: W,
    destroy: yl
  };
  if (!n.render)
    return process.env.NODE_ENV !== "production" && Qh(!0, "render() function has not been supplied."), b;
  var k = n.render(b), T = k.popper, M = k.onUpdate;
  T.setAttribute("data-tippy-root", ""), T.id = "tippy-" + b.id, b.popper = T, e._tippy = b, T._tippy = b;
  var H = $.map(function(E) {
    return E.fn(b);
  }), x = e.hasAttribute("aria-expanded");
  return ae(), Xl(), Q(), dl("onCreate", [b]), n.showOnCreate && le(), T.addEventListener("mouseenter", function() {
    b.props.interactive && b.state.isVisible && b.clearDelayTimeouts();
  }), T.addEventListener("mouseleave", function() {
    b.props.interactive && b.props.trigger.indexOf("mouseenter") >= 0 && al().addEventListener("mousemove", m);
  }), b;
  function P() {
    var E = b.props.touch;
    return Array.isArray(E) ? E : [E, 0];
  }
  function Z() {
    return P()[0] === "hold";
  }
  function F() {
    var E;
    return !!((E = b.props.render) != null && E.$$tippy);
  }
  function el() {
    return g || e;
  }
  function al() {
    var E = el().parentNode;
    return E ? XR(E) : document;
  }
  function ll() {
    return np(T);
  }
  function Y(E) {
    return b.state.isMounted && !b.state.isVisible || lt.isTouch || d && d.type === "focus" ? 0 : Ld(b.props.delay, E ? 0 : 1, ee.delay);
  }
  function Q(E) {
    E === void 0 && (E = !1), T.style.pointerEvents = b.props.interactive && !E ? "" : "none", T.style.zIndex = "" + b.props.zIndex;
  }
  function dl(E, G, il) {
    if (il === void 0 && (il = !0), H.forEach(function(Tl) {
      Tl[E] && Tl[E].apply(Tl, G);
    }), il) {
      var wl;
      (wl = b.props)[E].apply(wl, G);
    }
  }
  function zl() {
    var E = b.props.aria;
    if (E.content) {
      var G = "aria-" + E.content, il = T.id, wl = ni(b.props.triggerTarget || e);
      wl.forEach(function(Tl) {
        var $n = Tl.getAttribute(G);
        if (b.state.isVisible)
          Tl.setAttribute(G, $n ? $n + " " + il : il);
        else {
          var ce = $n && $n.replace(il, "").trim();
          ce ? Tl.setAttribute(G, ce) : Tl.removeAttribute(G);
        }
      });
    }
  }
  function Xl() {
    if (!(x || !b.props.aria.expanded)) {
      var E = ni(b.props.triggerTarget || e);
      E.forEach(function(G) {
        b.props.interactive ? G.setAttribute("aria-expanded", b.state.isVisible && G === el() ? "true" : "false") : G.removeAttribute("aria-expanded");
      });
    }
  }
  function sn() {
    al().removeEventListener("mousemove", m), or = or.filter(function(E) {
      return E !== m;
    });
  }
  function Jl(E) {
    if (!(lt.isTouch && (o || E.type === "mousedown"))) {
      var G = E.composedPath && E.composedPath()[0] || E.target;
      if (!(b.props.interactive && $g(T, G))) {
        if (ni(b.props.triggerTarget || e).some(function(il) {
          return $g(il, G);
        })) {
          if (lt.isTouch || b.state.isVisible && b.props.trigger.indexOf("click") >= 0)
            return;
        } else
          dl("onClickOutside", [b, E]);
        b.props.hideOnClick === !0 && (b.clearDelayTimeouts(), b.hide(), r = !0, setTimeout(function() {
          r = !1;
        }), b.state.isMounted || kn());
      }
    }
  }
  function rn() {
    o = !0;
  }
  function vn() {
    o = !1;
  }
  function en() {
    var E = al();
    E.addEventListener("mousedown", Jl, !0), E.addEventListener("touchend", Jl, yu), E.addEventListener("touchstart", vn, yu), E.addEventListener("touchmove", rn, yu);
  }
  function kn() {
    var E = al();
    E.removeEventListener("mousedown", Jl, !0), E.removeEventListener("touchend", Jl, yu), E.removeEventListener("touchstart", vn, yu), E.removeEventListener("touchmove", rn, yu);
  }
  function re(E, G) {
    oe(E, function() {
      !b.state.isVisible && T.parentNode && T.parentNode.contains(T) && G();
    });
  }
  function Mn(E, G) {
    oe(E, G);
  }
  function oe(E, G) {
    var il = ll().box;
    function wl(Tl) {
      Tl.target === il && (Bd(il, "remove", wl), G());
    }
    if (E === 0)
      return G();
    Bd(il, "remove", h), Bd(il, "add", wl), h = wl;
  }
  function yn(E, G, il) {
    il === void 0 && (il = !1);
    var wl = ni(b.props.triggerTarget || e);
    wl.forEach(function(Tl) {
      Tl.addEventListener(E, G, il), f.push({
        node: Tl,
        eventType: E,
        handler: G,
        options: il
      });
    });
  }
  function ae() {
    Z() && (yn("touchstart", Ve, {
      passive: !0
    }), yn("touchend", je, {
      passive: !0
    })), WR(b.props.trigger).forEach(function(E) {
      if (E !== "manual")
        switch (yn(E, Ve), E) {
          case "mouseenter":
            yn("mouseleave", je);
            break;
          case "focus":
            yn(uD ? "focusout" : "blur", de);
            break;
          case "focusin":
            yn("focusout", de);
            break;
        }
    });
  }
  function $t() {
    f.forEach(function(E) {
      var G = E.node, il = E.eventType, wl = E.handler, Tl = E.options;
      G.removeEventListener(il, wl, Tl);
    }), f = [];
  }
  function Ve(E) {
    var G, il = !1;
    if (!(!b.state.isEnabled || ke(E) || r)) {
      var wl = ((G = d) == null ? void 0 : G.type) === "focus";
      d = E, g = E.currentTarget, Xl(), !b.state.isVisible && qR(E) && or.forEach(function(Tl) {
        return Tl(E);
      }), E.type === "click" && (b.props.trigger.indexOf("mouseenter") < 0 || s) && b.props.hideOnClick !== !1 && b.state.isVisible ? il = !0 : le(E), E.type === "click" && (s = !il), il && !wl && Kn(E);
    }
  }
  function bt(E) {
    var G = E.target, il = el().contains(G) || T.contains(G);
    if (!(E.type === "mousemove" && il)) {
      var wl = Gn().concat(T).map(function(Tl) {
        var $n, ce = Tl._tippy, Uu = ($n = ce.popperInstance) == null ? void 0 : $n.state;
        return Uu ? {
          popperRect: Tl.getBoundingClientRect(),
          popperState: Uu,
          props: n
        } : null;
      }).filter(Boolean);
      QR(wl, E) && (sn(), Kn(E));
    }
  }
  function je(E) {
    var G = ke(E) || b.props.trigger.indexOf("click") >= 0 && s;
    if (!G) {
      if (b.props.interactive) {
        b.hideWithInteractivity(E);
        return;
      }
      Kn(E);
    }
  }
  function de(E) {
    b.props.trigger.indexOf("focusin") < 0 && E.target !== el() || b.props.interactive && E.relatedTarget && T.contains(E.relatedTarget) || Kn(E);
  }
  function ke(E) {
    return lt.isTouch ? Z() !== E.type.indexOf("touch") >= 0 : !1;
  }
  function Ue() {
    wt();
    var E = b.props, G = E.popperOptions, il = E.placement, wl = E.offset, Tl = E.getReferenceClientRect, $n = E.moveTransition, ce = F() ? np(T).arrow : null, Uu = Tl ? {
      getBoundingClientRect: Tl,
      contextElement: Tl.contextElement || el()
    } : e, k1 = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(Ws) {
        var Wu = Ws.state;
        if (F()) {
          var Fy = ll(), ba = Fy.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(Gs) {
            Gs === "placement" ? ba.setAttribute("data-placement", Wu.placement) : Wu.attributes.popper["data-popper-" + Gs] ? ba.setAttribute("data-" + Gs, "") : ba.removeAttribute("data-" + Gs);
          }), Wu.attributes.popper = {};
        }
      }
    }, cu = [{
      name: "offset",
      options: {
        offset: wl
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !$n
      }
    }, k1];
    F() && ce && cu.push({
      name: "arrow",
      options: {
        element: ce,
        padding: 3
      }
    }), cu.push.apply(cu, (G == null ? void 0 : G.modifiers) || []), b.popperInstance = HR(Uu, T, Object.assign({}, G, {
      placement: il,
      onFirstUpdate: p,
      modifiers: cu
    }));
  }
  function wt() {
    b.popperInstance && (b.popperInstance.destroy(), b.popperInstance = null);
  }
  function Pn() {
    var E = b.props.appendTo, G, il = el();
    b.props.interactive && E === cy || E === "parent" ? G = il.parentNode : G = hy(E, [il]), G.contains(T) || G.appendChild(T), b.state.isMounted = !0, Ue(), process.env.NODE_ENV !== "production" && Ot(b.props.interactive && E === ee.appendTo && il.nextElementSibling !== T, ["Interactive tippy element may not be accessible via keyboard", "navigation because it is not directly after the reference element", "in the DOM source order.", `

`, "Using a wrapper <div> or <span> tag around the reference element", "solves this by creating a new parentNode context.", `

`, "Specifying `appendTo: document.body` silences this warning, but it", "assumes you are using a focus management solution to handle", "keyboard navigation.", `

`, "See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity"].join(" "));
  }
  function Gn() {
    return Jr(T.querySelectorAll("[data-tippy-root]"));
  }
  function le(E) {
    b.clearDelayTimeouts(), E && dl("onTrigger", [b, E]), en();
    var G = Y(!0), il = P(), wl = il[0], Tl = il[1];
    lt.isTouch && wl === "hold" && Tl && (G = Tl), G ? t = setTimeout(function() {
      b.show();
    }, G) : b.show();
  }
  function Kn(E) {
    if (b.clearDelayTimeouts(), dl("onUntrigger", [b, E]), !b.state.isVisible) {
      kn();
      return;
    }
    if (!(b.props.trigger.indexOf("mouseenter") >= 0 && b.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(E.type) >= 0 && s)) {
      var G = Y(!1);
      G ? u = setTimeout(function() {
        b.state.isVisible && b.hide();
      }, G) : i = requestAnimationFrame(function() {
        b.hide();
      });
    }
  }
  function Me() {
    b.state.isEnabled = !0;
  }
  function We() {
    b.hide(), b.state.isEnabled = !1;
  }
  function Ge() {
    clearTimeout(t), clearTimeout(u), cancelAnimationFrame(i);
  }
  function Ke(E) {
    if (process.env.NODE_ENV !== "production" && Ot(b.state.isDestroyed, Ju("setProps")), !b.state.isDestroyed) {
      dl("onBeforeUpdate", [b, E]), $t();
      var G = b.props, il = _g(e, Object.assign({}, G, vg(E), {
        ignoreAttributes: !0
      }));
      b.props = il, ae(), G.interactiveDebounce !== il.interactiveDebounce && (sn(), m = mg(bt, il.interactiveDebounce)), G.triggerTarget && !il.triggerTarget ? ni(G.triggerTarget).forEach(function(wl) {
        wl.removeAttribute("aria-expanded");
      }) : il.triggerTarget && e.removeAttribute("aria-expanded"), Xl(), Q(), M && M(G, il), b.popperInstance && (Ue(), Gn().forEach(function(wl) {
        requestAnimationFrame(wl._tippy.popperInstance.forceUpdate);
      })), dl("onAfterUpdate", [b, E]);
    }
  }
  function Ye(E) {
    b.setProps({
      content: E
    });
  }
  function C() {
    process.env.NODE_ENV !== "production" && Ot(b.state.isDestroyed, Ju("show"));
    var E = b.state.isVisible, G = b.state.isDestroyed, il = !b.state.isEnabled, wl = lt.isTouch && !b.props.touch, Tl = Ld(b.props.duration, 0, ee.duration);
    if (!(E || G || il || wl) && !el().hasAttribute("disabled") && (dl("onShow", [b], !1), b.props.onShow(b) !== !1)) {
      if (b.state.isVisible = !0, F() && (T.style.visibility = "visible"), Q(), en(), b.state.isMounted || (T.style.transition = "none"), F()) {
        var $n = ll(), ce = $n.box, Uu = $n.content;
        Pd([ce, Uu], 0);
      }
      p = function() {
        var cu;
        if (!(!b.state.isVisible || a)) {
          if (a = !0, T.offsetHeight, T.style.transition = b.props.moveTransition, F() && b.props.animation) {
            var $a = ll(), Ws = $a.box, Wu = $a.content;
            Pd([Ws, Wu], Tl), yg([Ws, Wu], "visible");
          }
          zl(), Xl(), gg(Fd, b), (cu = b.popperInstance) == null || cu.forceUpdate(), dl("onMount", [b]), b.props.animation && F() && Mn(Tl, function() {
            b.state.isShown = !0, dl("onShown", [b]);
          });
        }
      }, Pn();
    }
  }
  function N() {
    process.env.NODE_ENV !== "production" && Ot(b.state.isDestroyed, Ju("hide"));
    var E = !b.state.isVisible, G = b.state.isDestroyed, il = !b.state.isEnabled, wl = Ld(b.props.duration, 1, ee.duration);
    if (!(E || G || il) && (dl("onHide", [b], !1), b.props.onHide(b) !== !1)) {
      if (b.state.isVisible = !1, b.state.isShown = !1, a = !1, s = !1, F() && (T.style.visibility = "hidden"), sn(), kn(), Q(!0), F()) {
        var Tl = ll(), $n = Tl.box, ce = Tl.content;
        b.props.animation && (Pd([$n, ce], wl), yg([$n, ce], "hidden"));
      }
      zl(), Xl(), b.props.animation ? F() && re(wl, b.unmount) : b.unmount();
    }
  }
  function D(E) {
    process.env.NODE_ENV !== "production" && Ot(b.state.isDestroyed, Ju("hideWithInteractivity")), al().addEventListener("mousemove", m), gg(or, m), m(E);
  }
  function W() {
    process.env.NODE_ENV !== "production" && Ot(b.state.isDestroyed, Ju("unmount")), b.state.isVisible && b.hide(), b.state.isMounted && (wt(), Gn().forEach(function(E) {
      E._tippy.unmount();
    }), T.parentNode && T.parentNode.removeChild(T), Fd = Fd.filter(function(E) {
      return E !== b;
    }), b.state.isMounted = !1, dl("onHidden", [b]));
  }
  function yl() {
    process.env.NODE_ENV !== "production" && Ot(b.state.isDestroyed, Ju("destroy")), !b.state.isDestroyed && (b.clearDelayTimeouts(), b.unmount(), $t(), delete e._tippy, b.state.isDestroyed = !0, dl("onDestroy", [b]));
  }
}
function Li(e, l) {
  l === void 0 && (l = {});
  var n = ee.plugins.concat(l.plugins || []);
  process.env.NODE_ENV !== "production" && (rD(e), vy(l, n)), eD();
  var t = Object.assign({}, l, {
    plugins: n
  }), u = ZR(e);
  if (process.env.NODE_ENV !== "production") {
    var i = Rs(t.content), s = u.length > 1;
    Ot(i && s, ["tippy() was passed an Element as the `content` prop, but more than", "one tippy instance was created by this invocation. This means the", "content element will only be appended to the last tippy instance.", `

`, "Instead, pass the .innerHTML of the element, or use a function that", "returns a cloned version of the element instead.", `

`, `1) content: element.innerHTML
`, "2) content: () => element.cloneNode(true)"].join(" "));
  }
  var r = u.reduce(function(o, a) {
    var d = a && fD(a, t);
    return d && o.push(d), o;
  }, []);
  return Rs(e) ? r[0] : r;
}
Li.defaultProps = ee;
Li.setDefaultProps = dD;
Li.currentInput = lt;
Object.assign({}, ly, {
  effect: function(l) {
    var n = l.state, t = {
      popper: {
        position: n.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(n.elements.popper.style, t.popper), n.styles = t, n.elements.arrow && Object.assign(n.elements.arrow.style, t.arrow);
  }
});
Li.setDefaultProps({
  render: yy
});
class mD {
  constructor({ editor: l, element: n, view: t, tippyOptions: u = {}, updateDelay: i = 250, shouldShow: s }) {
    this.preventHide = !1, this.shouldShow = ({ view: r, state: o, from: a, to: d }) => {
      const { doc: h, selection: p } = o, { empty: f } = p, m = !h.textBetween(a, d).length && e1(o.selection), g = this.element.contains(document.activeElement);
      return !(!(r.hasFocus() || g) || f || m || !this.editor.isEditable);
    }, this.mousedownHandler = () => {
      this.preventHide = !0;
    }, this.dragstartHandler = () => {
      this.hide();
    }, this.focusHandler = () => {
      setTimeout(() => this.update(this.editor.view));
    }, this.blurHandler = ({ event: r }) => {
      var o;
      if (this.preventHide) {
        this.preventHide = !1;
        return;
      }
      r != null && r.relatedTarget && (!((o = this.element.parentNode) === null || o === void 0) && o.contains(r.relatedTarget)) || this.hide();
    }, this.tippyBlurHandler = (r) => {
      this.blurHandler({ event: r });
    }, this.handleDebouncedUpdate = (r, o) => {
      const a = !(o != null && o.selection.eq(r.state.selection)), d = !(o != null && o.doc.eq(r.state.doc));
      !a && !d || (this.updateDebounceTimer && clearTimeout(this.updateDebounceTimer), this.updateDebounceTimer = window.setTimeout(() => {
        this.updateHandler(r, a, d, o);
      }, this.updateDelay));
    }, this.updateHandler = (r, o, a, d) => {
      var h, p, f;
      const { state: m, composing: g } = r, { selection: v } = m;
      if (g || !o && !a)
        return;
      this.createTooltip();
      const { ranges: $ } = v, _ = Math.min(...$.map((T) => T.$from.pos)), b = Math.max(...$.map((T) => T.$to.pos));
      if (!((h = this.shouldShow) === null || h === void 0 ? void 0 : h.call(this, {
        editor: this.editor,
        view: r,
        state: m,
        oldState: d,
        from: _,
        to: b
      }))) {
        this.hide();
        return;
      }
      (p = this.tippy) === null || p === void 0 || p.setProps({
        getReferenceClientRect: ((f = this.tippyOptions) === null || f === void 0 ? void 0 : f.getReferenceClientRect) || (() => {
          if (iI(m.selection)) {
            let T = r.nodeDOM(_);
            const M = T.dataset.nodeViewWrapper ? T : T.querySelector("[data-node-view-wrapper]");
            if (M && (T = M.firstChild), T)
              return T.getBoundingClientRect();
          }
          return J4(r, _, b);
        })
      }), this.show();
    }, this.editor = l, this.element = n, this.view = t, this.updateDelay = i, s && (this.shouldShow = s), this.element.addEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.addEventListener("dragstart", this.dragstartHandler), this.editor.on("focus", this.focusHandler), this.editor.on("blur", this.blurHandler), this.tippyOptions = u, this.element.remove(), this.element.style.visibility = "visible";
  }
  createTooltip() {
    const { element: l } = this.editor.options, n = !!l.parentElement;
    this.tippy || !n || (this.tippy = Li(l, {
      duration: 0,
      getReferenceClientRect: null,
      content: this.element,
      interactive: !0,
      trigger: "manual",
      placement: "top",
      hideOnClick: "toggle",
      ...this.tippyOptions
    }), this.tippy.popper.firstChild && this.tippy.popper.firstChild.addEventListener("blur", this.tippyBlurHandler));
  }
  update(l, n) {
    const { state: t } = l, u = t.selection.$from.pos !== t.selection.$to.pos;
    if (this.updateDelay > 0 && u) {
      this.handleDebouncedUpdate(l, n);
      return;
    }
    const i = !(n != null && n.selection.eq(l.state.selection)), s = !(n != null && n.doc.eq(l.state.doc));
    this.updateHandler(l, i, s, n);
  }
  show() {
    var l;
    (l = this.tippy) === null || l === void 0 || l.show();
  }
  hide() {
    var l;
    (l = this.tippy) === null || l === void 0 || l.hide();
  }
  destroy() {
    var l, n;
    !((l = this.tippy) === null || l === void 0) && l.popper.firstChild && this.tippy.popper.firstChild.removeEventListener("blur", this.tippyBlurHandler), (n = this.tippy) === null || n === void 0 || n.destroy(), this.element.removeEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.removeEventListener("dragstart", this.dragstartHandler), this.editor.off("focus", this.focusHandler), this.editor.off("blur", this.blurHandler);
  }
}
const $y = (e) => new On({
  key: typeof e.pluginKey == "string" ? new se(e.pluginKey) : e.pluginKey,
  view: (l) => new mD({ view: l, ...e })
});
mn.create({
  name: "bubbleMenu",
  addOptions() {
    return {
      element: null,
      tippyOptions: {},
      pluginKey: "bubbleMenu",
      updateDelay: void 0,
      shouldShow: null
    };
  },
  addProseMirrorPlugins() {
    return this.options.element ? [
      $y({
        pluginKey: this.options.pluginKey,
        editor: this.editor,
        element: this.options.element,
        tippyOptions: this.options.tippyOptions,
        updateDelay: this.options.updateDelay,
        shouldShow: this.options.shouldShow
      })
    ] : [];
  }
});
class gD {
  constructor({ editor: l, element: n, view: t, tippyOptions: u = {}, shouldShow: i }) {
    this.preventHide = !1, this.shouldShow = ({ view: s, state: r }) => {
      const { selection: o } = r, { $anchor: a, empty: d } = o, h = a.depth === 1, p = a.parent.isTextblock && !a.parent.type.spec.code && !a.parent.textContent;
      return !(!s.hasFocus() || !d || !h || !p || !this.editor.isEditable);
    }, this.mousedownHandler = () => {
      this.preventHide = !0;
    }, this.focusHandler = () => {
      setTimeout(() => this.update(this.editor.view));
    }, this.blurHandler = ({ event: s }) => {
      var r;
      if (this.preventHide) {
        this.preventHide = !1;
        return;
      }
      s != null && s.relatedTarget && (!((r = this.element.parentNode) === null || r === void 0) && r.contains(s.relatedTarget)) || this.hide();
    }, this.tippyBlurHandler = (s) => {
      this.blurHandler({ event: s });
    }, this.editor = l, this.element = n, this.view = t, i && (this.shouldShow = i), this.element.addEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.editor.on("focus", this.focusHandler), this.editor.on("blur", this.blurHandler), this.tippyOptions = u, this.element.remove(), this.element.style.visibility = "visible";
  }
  createTooltip() {
    const { element: l } = this.editor.options, n = !!l.parentElement;
    this.tippy || !n || (this.tippy = Li(l, {
      duration: 0,
      getReferenceClientRect: null,
      content: this.element,
      interactive: !0,
      trigger: "manual",
      placement: "right",
      hideOnClick: "toggle",
      ...this.tippyOptions
    }), this.tippy.popper.firstChild && this.tippy.popper.firstChild.addEventListener("blur", this.tippyBlurHandler));
  }
  update(l, n) {
    var t, u, i;
    const { state: s } = l, { doc: r, selection: o } = s, { from: a, to: d } = o;
    if (n && n.doc.eq(r) && n.selection.eq(o))
      return;
    if (this.createTooltip(), !((t = this.shouldShow) === null || t === void 0 ? void 0 : t.call(this, {
      editor: this.editor,
      view: l,
      state: s,
      oldState: n
    }))) {
      this.hide();
      return;
    }
    (u = this.tippy) === null || u === void 0 || u.setProps({
      getReferenceClientRect: ((i = this.tippyOptions) === null || i === void 0 ? void 0 : i.getReferenceClientRect) || (() => J4(l, a, d))
    }), this.show();
  }
  show() {
    var l;
    (l = this.tippy) === null || l === void 0 || l.show();
  }
  hide() {
    var l;
    (l = this.tippy) === null || l === void 0 || l.hide();
  }
  destroy() {
    var l, n;
    !((l = this.tippy) === null || l === void 0) && l.popper.firstChild && this.tippy.popper.firstChild.removeEventListener("blur", this.tippyBlurHandler), (n = this.tippy) === null || n === void 0 || n.destroy(), this.element.removeEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.editor.off("focus", this.focusHandler), this.editor.off("blur", this.blurHandler);
  }
}
const by = (e) => new On({
  key: typeof e.pluginKey == "string" ? new se(e.pluginKey) : e.pluginKey,
  view: (l) => new gD({ view: l, ...e })
});
mn.create({
  name: "floatingMenu",
  addOptions() {
    return {
      element: null,
      tippyOptions: {},
      pluginKey: "floatingMenu",
      shouldShow: null
    };
  },
  addProseMirrorPlugins() {
    return this.options.element ? [
      by({
        pluginKey: this.options.pluginKey,
        editor: this.editor,
        element: this.options.element,
        tippyOptions: this.options.tippyOptions,
        shouldShow: this.options.shouldShow
      })
    ] : [];
  }
});
K({
  name: "BubbleMenu",
  props: {
    pluginKey: {
      type: [String, Object],
      default: "bubbleMenu"
    },
    editor: {
      type: Object,
      required: !0
    },
    updateDelay: {
      type: Number,
      default: void 0
    },
    tippyOptions: {
      type: Object,
      default: () => ({})
    },
    shouldShow: {
      type: Function,
      default: null
    }
  },
  setup(e, { slots: l }) {
    const n = J(null);
    return xi(() => {
      const { updateDelay: t, editor: u, pluginKey: i, shouldShow: s, tippyOptions: r } = e;
      u.registerPlugin($y({
        updateDelay: t,
        editor: u,
        element: n.value,
        pluginKey: i,
        shouldShow: s,
        tippyOptions: r
      }));
    }), Eo(() => {
      const { pluginKey: t, editor: u } = e;
      u.unregisterPlugin(t);
    }), () => {
      var t;
      return ye("div", { ref: n }, (t = l.default) === null || t === void 0 ? void 0 : t.call(l));
    };
  }
});
function Tg(e) {
  return n5((l, n) => ({
    get() {
      return l(), e;
    },
    set(t) {
      e = t, requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          n();
        });
      });
    }
  }));
}
class vD extends DI {
  constructor(l = {}) {
    return super(l), this.vueRenderers = fl(/* @__PURE__ */ new Map()), this.contentComponent = null, this.reactiveState = Tg(this.view.state), this.reactiveExtensionStorage = Tg(this.extensionStorage), this.on("transaction", () => {
      this.reactiveState.value = this.view.state, this.reactiveExtensionStorage.value = this.extensionStorage;
    }), l5(this);
  }
  get state() {
    return this.reactiveState ? this.reactiveState.value : this.view.state;
  }
  get storage() {
    return this.reactiveExtensionStorage ? this.reactiveExtensionStorage.value : super.storage;
  }
  /**
   * Register a ProseMirror plugin.
   */
  registerPlugin(l, n) {
    super.registerPlugin(l, n), this.reactiveState.value = this.view.state;
  }
  /**
   * Unregister a ProseMirror plugin.
   */
  unregisterPlugin(l) {
    super.unregisterPlugin(l), this.reactiveState.value = this.view.state;
  }
}
const yD = K({
  name: "EditorContent",
  props: {
    editor: {
      default: null,
      type: Object
    }
  },
  setup(e) {
    const l = J(), n = Wg();
    return xo(() => {
      const t = e.editor;
      t && t.options.element && l.value && rl(() => {
        if (!l.value || !t.options.element.firstChild)
          return;
        const u = c(l.value);
        l.value.append(...t.options.element.childNodes), t.contentComponent = n.ctx._, t.setOptions({
          element: u
        }), t.createNodeViews();
      });
    }), Eo(() => {
      const t = e.editor;
      if (!t || (t.isDestroyed || t.view.setProps({
        nodeViews: {}
      }), t.contentComponent = null, !t.options.element.firstChild))
        return;
      const u = document.createElement("div");
      u.append(...t.options.element.childNodes), t.setOptions({
        element: u
      });
    }), { rootEl: l };
  },
  render() {
    const e = [];
    return this.editor && this.editor.vueRenderers.forEach((l) => {
      const n = ye(Wp, {
        to: l.teleportElement,
        key: l.id
      }, ye(l.component, {
        ref: l.id,
        ...l.props
      }));
      e.push(n);
    }), ye("div", {
      ref: (l) => {
        this.rootEl = l;
      }
    }, ...e);
  }
});
K({
  name: "FloatingMenu",
  props: {
    pluginKey: {
      // TODO: TypeScript breaks :(
      // type: [String, Object as PropType<Exclude<FloatingMenuPluginProps['pluginKey'], string>>],
      type: null,
      default: "floatingMenu"
    },
    editor: {
      type: Object,
      required: !0
    },
    tippyOptions: {
      type: Object,
      default: () => ({})
    },
    shouldShow: {
      type: Function,
      default: null
    }
  },
  setup(e, { slots: l }) {
    const n = J(null);
    return xi(() => {
      const { pluginKey: t, editor: u, tippyOptions: i, shouldShow: s } = e;
      u.registerPlugin(by({
        pluginKey: t,
        editor: u,
        element: n.value,
        tippyOptions: i,
        shouldShow: s
      }));
    }), Eo(() => {
      const { pluginKey: t, editor: u } = e;
      u.unregisterPlugin(t);
    }), () => {
      var t;
      return ye("div", { ref: n }, (t = l.default) === null || t === void 0 ? void 0 : t.call(l));
    };
  }
});
K({
  name: "NodeViewContent",
  props: {
    as: {
      type: String,
      default: "div"
    }
  },
  render() {
    return ye(this.as, {
      style: {
        whiteSpace: "pre-wrap"
      },
      "data-node-view-content": ""
    });
  }
});
K({
  name: "NodeViewWrapper",
  props: {
    as: {
      type: String,
      default: "div"
    }
  },
  inject: ["onDragStart", "decorationClasses"],
  render() {
    var e, l;
    return ye(this.as, {
      // @ts-ignore
      class: this.decorationClasses,
      style: {
        whiteSpace: "normal"
      },
      "data-node-view-wrapper": "",
      // @ts-ignore (https://github.com/vuejs/vue-next/issues/3031)
      onDragstart: this.onDragStart
    }, (l = (e = this.$slots).default) === null || l === void 0 ? void 0 : l.call(e));
  }
});
const $D = (e = {}) => {
  const l = Qy();
  return xi(() => {
    l.value = new vD(e);
  }), Eo(() => {
    var n;
    (n = l.value) === null || n === void 0 || n.destroy();
  }), l;
}, bD = /^\s*>\s$/, wD = gn.create({
  name: "blockquote",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  group: "block",
  defining: !0,
  parseHTML() {
    return [
      { tag: "blockquote" }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["blockquote", ql(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setBlockquote: () => ({ commands: e }) => e.wrapIn(this.name),
      toggleBlockquote: () => ({ commands: e }) => e.toggleWrap(this.name),
      unsetBlockquote: () => ({ commands: e }) => e.lift(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-b": () => this.editor.commands.toggleBlockquote()
    };
  },
  addInputRules() {
    return [
      xs({
        find: bD,
        type: this.type
      })
    ];
  }
}), _D = /(?:^|\s)((?:\*\*)((?:[^*]+))(?:\*\*))$/, SD = /(?:^|\s)((?:\*\*)((?:[^*]+))(?:\*\*))/g, CD = /(?:^|\s)((?:__)((?:[^__]+))(?:__))$/, TD = /(?:^|\s)((?:__)((?:[^__]+))(?:__))/g, OD = ue.create({
  name: "bold",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "strong"
      },
      {
        tag: "b",
        getAttrs: (e) => e.style.fontWeight !== "normal" && null
      },
      {
        style: "font-weight",
        getAttrs: (e) => /^(bold(er)?|[5-9]\d{2,})$/.test(e) && null
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["strong", ql(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setBold: () => ({ commands: e }) => e.setMark(this.name),
      toggleBold: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetBold: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-b": () => this.editor.commands.toggleBold(),
      "Mod-B": () => this.editor.commands.toggleBold()
    };
  },
  addInputRules() {
    return [
      Ci({
        find: _D,
        type: this.type
      }),
      Ci({
        find: CD,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Fu({
        find: SD,
        type: this.type
      }),
      Fu({
        find: TD,
        type: this.type
      })
    ];
  }
}), kD = gn.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["li", ql(this.options.HTMLAttributes, e), 0];
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), Og = ue.create({
  name: "textStyle",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "span",
        getAttrs: (e) => e.hasAttribute("style") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["span", ql(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      removeEmptyTextStyle: () => ({ state: e, commands: l }) => {
        const n = Vs(e, this.type);
        return Object.entries(n).some(([, u]) => !!u) ? !0 : l.unsetMark(this.name);
      }
    };
  }
}), kg = /^\s*([-+*])\s$/, MD = gn.create({
  name: "bulletList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [
      { tag: "ul" }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["ul", ql(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      toggleBulletList: () => ({ commands: e, chain: l }) => this.options.keepAttributes ? l().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(kD.name, this.editor.getAttributes(Og.name)).run() : e.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-8": () => this.editor.commands.toggleBulletList()
    };
  },
  addInputRules() {
    let e = xs({
      find: kg,
      type: this.type
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (e = xs({
      find: kg,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: () => this.editor.getAttributes(Og.name),
      editor: this.editor
    })), [
      e
    ];
  }
}), AD = /(?:^|\s)((?:`)((?:[^`]+))(?:`))$/, xD = /(?:^|\s)((?:`)((?:[^`]+))(?:`))/g, ED = ue.create({
  name: "code",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  excludes: "_",
  code: !0,
  exitable: !0,
  parseHTML() {
    return [
      { tag: "code" }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["code", ql(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setCode: () => ({ commands: e }) => e.setMark(this.name),
      toggleCode: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetCode: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-e": () => this.editor.commands.toggleCode()
    };
  },
  addInputRules() {
    return [
      Ci({
        find: AD,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Fu({
        find: xD,
        type: this.type
      })
    ];
  }
}), ID = /^```([a-z]+)?[\s\n]$/, RD = /^~~~([a-z]+)?[\s\n]$/, DD = gn.create({
  name: "codeBlock",
  addOptions() {
    return {
      languageClassPrefix: "language-",
      exitOnTripleEnter: !0,
      exitOnArrowDown: !0,
      HTMLAttributes: {}
    };
  },
  content: "text*",
  marks: "",
  group: "block",
  code: !0,
  defining: !0,
  addAttributes() {
    return {
      language: {
        default: null,
        parseHTML: (e) => {
          var l;
          const { languageClassPrefix: n } = this.options, i = [...((l = e.firstElementChild) === null || l === void 0 ? void 0 : l.classList) || []].filter((s) => s.startsWith(n)).map((s) => s.replace(n, ""))[0];
          return i || null;
        },
        rendered: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "pre",
        preserveWhitespace: "full"
      }
    ];
  },
  renderHTML({ node: e, HTMLAttributes: l }) {
    return [
      "pre",
      ql(this.options.HTMLAttributes, l),
      [
        "code",
        {
          class: e.attrs.language ? this.options.languageClassPrefix + e.attrs.language : null
        },
        0
      ]
    ];
  },
  addCommands() {
    return {
      setCodeBlock: (e) => ({ commands: l }) => l.setNode(this.name, e),
      toggleCodeBlock: (e) => ({ commands: l }) => l.toggleNode(this.name, "paragraph", e)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-c": () => this.editor.commands.toggleCodeBlock(),
      // remove code block when at start of document or code block is empty
      Backspace: () => {
        const { empty: e, $anchor: l } = this.editor.state.selection, n = l.pos === 1;
        return !e || l.parent.type.name !== this.name ? !1 : n || !l.parent.textContent.length ? this.editor.commands.clearNodes() : !1;
      },
      // exit node on triple enter
      Enter: ({ editor: e }) => {
        if (!this.options.exitOnTripleEnter)
          return !1;
        const { state: l } = e, { selection: n } = l, { $from: t, empty: u } = n;
        if (!u || t.parent.type !== this.type)
          return !1;
        const i = t.parentOffset === t.parent.nodeSize - 2, s = t.parent.textContent.endsWith(`

`);
        return !i || !s ? !1 : e.chain().command(({ tr: r }) => (r.delete(t.pos - 2, t.pos), !0)).exitCode().run();
      },
      // exit node on arrow down
      ArrowDown: ({ editor: e }) => {
        if (!this.options.exitOnArrowDown)
          return !1;
        const { state: l } = e, { selection: n, doc: t } = l, { $from: u, empty: i } = n;
        if (!i || u.parent.type !== this.type || !(u.parentOffset === u.parent.nodeSize - 2))
          return !1;
        const r = u.after();
        return r === void 0 || t.nodeAt(r) ? !1 : e.commands.exitCode();
      }
    };
  },
  addInputRules() {
    return [
      Jh({
        find: ID,
        type: this.type,
        getAttributes: (e) => ({
          language: e[1]
        })
      }),
      Jh({
        find: RD,
        type: this.type,
        getAttributes: (e) => ({
          language: e[1]
        })
      })
    ];
  },
  addProseMirrorPlugins() {
    return [
      // this plugin creates a code block for pasted content from VS Code
      // we can also detect the copied code language
      new On({
        key: new se("codeBlockVSCodeHandler"),
        props: {
          handlePaste: (e, l) => {
            if (!l.clipboardData || this.editor.isActive(this.type.name))
              return !1;
            const n = l.clipboardData.getData("text/plain"), t = l.clipboardData.getData("vscode-editor-data"), u = t ? JSON.parse(t) : void 0, i = u == null ? void 0 : u.mode;
            if (!n || !i)
              return !1;
            const { tr: s } = e.state;
            return s.replaceSelectionWith(this.type.create({ language: i })), s.setSelection(Cl.near(s.doc.resolve(Math.max(0, s.selection.from - 2)))), s.insertText(n.replace(/\r\n?/g, `
`)), s.setMeta("paste", !0), e.dispatch(s), !0;
          }
        }
      })
    ];
  }
}), ND = gn.create({
  name: "doc",
  topNode: !0,
  content: "block+"
});
function LD(e = {}) {
  return new On({
    view(l) {
      return new PD(l, e);
    }
  });
}
class PD {
  constructor(l, n) {
    var t;
    this.editorView = l, this.cursorPos = null, this.element = null, this.timeout = -1, this.width = (t = n.width) !== null && t !== void 0 ? t : 1, this.color = n.color === !1 ? void 0 : n.color || "black", this.class = n.class, this.handlers = ["dragover", "dragend", "drop", "dragleave"].map((u) => {
      let i = (s) => {
        this[u](s);
      };
      return l.dom.addEventListener(u, i), { name: u, handler: i };
    });
  }
  destroy() {
    this.handlers.forEach(({ name: l, handler: n }) => this.editorView.dom.removeEventListener(l, n));
  }
  update(l, n) {
    this.cursorPos != null && n.doc != l.state.doc && (this.cursorPos > l.state.doc.content.size ? this.setCursor(null) : this.updateOverlay());
  }
  setCursor(l) {
    l != this.cursorPos && (this.cursorPos = l, l == null ? (this.element.parentNode.removeChild(this.element), this.element = null) : this.updateOverlay());
  }
  updateOverlay() {
    let l = this.editorView.state.doc.resolve(this.cursorPos), n = !l.parent.inlineContent, t;
    if (n) {
      let r = l.nodeBefore, o = l.nodeAfter;
      if (r || o) {
        let a = this.editorView.nodeDOM(this.cursorPos - (r ? r.nodeSize : 0));
        if (a) {
          let d = a.getBoundingClientRect(), h = r ? d.bottom : d.top;
          r && o && (h = (h + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2), t = { left: d.left, right: d.right, top: h - this.width / 2, bottom: h + this.width / 2 };
        }
      }
    }
    if (!t) {
      let r = this.editorView.coordsAtPos(this.cursorPos);
      t = { left: r.left - this.width / 2, right: r.left + this.width / 2, top: r.top, bottom: r.bottom };
    }
    let u = this.editorView.dom.offsetParent;
    this.element || (this.element = u.appendChild(document.createElement("div")), this.class && (this.element.className = this.class), this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;", this.color && (this.element.style.backgroundColor = this.color)), this.element.classList.toggle("prosemirror-dropcursor-block", n), this.element.classList.toggle("prosemirror-dropcursor-inline", !n);
    let i, s;
    if (!u || u == document.body && getComputedStyle(u).position == "static")
      i = -pageXOffset, s = -pageYOffset;
    else {
      let r = u.getBoundingClientRect();
      i = r.left - u.scrollLeft, s = r.top - u.scrollTop;
    }
    this.element.style.left = t.left - i + "px", this.element.style.top = t.top - s + "px", this.element.style.width = t.right - t.left + "px", this.element.style.height = t.bottom - t.top + "px";
  }
  scheduleRemoval(l) {
    clearTimeout(this.timeout), this.timeout = setTimeout(() => this.setCursor(null), l);
  }
  dragover(l) {
    if (!this.editorView.editable)
      return;
    let n = this.editorView.posAtCoords({ left: l.clientX, top: l.clientY }), t = n && n.inside >= 0 && this.editorView.state.doc.nodeAt(n.inside), u = t && t.type.spec.disableDropCursor, i = typeof u == "function" ? u(this.editorView, n, l) : u;
    if (n && !i) {
      let s = n.pos;
      if (this.editorView.dragging && this.editorView.dragging.slice) {
        let r = Kv(this.editorView.state.doc, s, this.editorView.dragging.slice);
        r != null && (s = r);
      }
      this.setCursor(s), this.scheduleRemoval(5e3);
    }
  }
  dragend() {
    this.scheduleRemoval(20);
  }
  drop() {
    this.scheduleRemoval(20);
  }
  dragleave(l) {
    (l.target == this.editorView.dom || !this.editorView.dom.contains(l.relatedTarget)) && this.setCursor(null);
  }
}
const BD = mn.create({
  name: "dropCursor",
  addOptions() {
    return {
      color: "currentColor",
      width: 1,
      class: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      LD(this.options)
    ];
  }
});
class ln extends xl {
  /**
  Create a gap cursor.
  */
  constructor(l) {
    super(l, l);
  }
  map(l, n) {
    let t = l.resolve(n.map(this.head));
    return ln.valid(t) ? new ln(t) : xl.near(t);
  }
  content() {
    return nl.empty;
  }
  eq(l) {
    return l instanceof ln && l.head == this.head;
  }
  toJSON() {
    return { type: "gapcursor", pos: this.head };
  }
  /**
  @internal
  */
  static fromJSON(l, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for GapCursor.fromJSON");
    return new ln(l.resolve(n.pos));
  }
  /**
  @internal
  */
  getBookmark() {
    return new m1(this.anchor);
  }
  /**
  @internal
  */
  static valid(l) {
    let n = l.parent;
    if (n.isTextblock || !FD(l) || !HD(l))
      return !1;
    let t = n.type.spec.allowGapCursor;
    if (t != null)
      return t;
    let u = n.contentMatchAt(l.index()).defaultType;
    return u && u.isTextblock;
  }
  /**
  @internal
  */
  static findGapCursorFrom(l, n, t = !1) {
    l:
      for (; ; ) {
        if (!t && ln.valid(l))
          return l;
        let u = l.pos, i = null;
        for (let s = l.depth; ; s--) {
          let r = l.node(s);
          if (n > 0 ? l.indexAfter(s) < r.childCount : l.index(s) > 0) {
            i = r.child(n > 0 ? l.indexAfter(s) : l.index(s) - 1);
            break;
          } else if (s == 0)
            return null;
          u += n;
          let o = l.doc.resolve(u);
          if (ln.valid(o))
            return o;
        }
        for (; ; ) {
          let s = n > 0 ? i.firstChild : i.lastChild;
          if (!s) {
            if (i.isAtom && !i.isText && !pl.isSelectable(i)) {
              l = l.doc.resolve(u + i.nodeSize * n), t = !1;
              continue l;
            }
            break;
          }
          i = s, u += n;
          let r = l.doc.resolve(u);
          if (ln.valid(r))
            return r;
        }
        return null;
      }
  }
}
ln.prototype.visible = !1;
ln.findFrom = ln.findGapCursorFrom;
xl.jsonID("gapcursor", ln);
class m1 {
  constructor(l) {
    this.pos = l;
  }
  map(l) {
    return new m1(l.map(this.pos));
  }
  resolve(l) {
    let n = l.resolve(this.pos);
    return ln.valid(n) ? new ln(n) : xl.near(n);
  }
}
function FD(e) {
  for (let l = e.depth; l >= 0; l--) {
    let n = e.index(l), t = e.node(l);
    if (n == 0) {
      if (t.type.spec.isolating)
        return !0;
      continue;
    }
    for (let u = t.child(n - 1); ; u = u.lastChild) {
      if (u.childCount == 0 && !u.inlineContent || u.isAtom || u.type.spec.isolating)
        return !0;
      if (u.inlineContent)
        return !1;
    }
  }
  return !0;
}
function HD(e) {
  for (let l = e.depth; l >= 0; l--) {
    let n = e.indexAfter(l), t = e.node(l);
    if (n == t.childCount) {
      if (t.type.spec.isolating)
        return !0;
      continue;
    }
    for (let u = t.child(n); ; u = u.firstChild) {
      if (u.childCount == 0 && !u.inlineContent || u.isAtom || u.type.spec.isolating)
        return !0;
      if (u.inlineContent)
        return !1;
    }
  }
  return !0;
}
function zD() {
  return new On({
    props: {
      decorations: WD,
      createSelectionBetween(e, l, n) {
        return l.pos == n.pos && ln.valid(n) ? new ln(n) : null;
      },
      handleClick: jD,
      handleKeyDown: VD,
      handleDOMEvents: { beforeinput: UD }
    }
  });
}
const VD = D4({
  ArrowLeft: ar("horiz", -1),
  ArrowRight: ar("horiz", 1),
  ArrowUp: ar("vert", -1),
  ArrowDown: ar("vert", 1)
});
function ar(e, l) {
  const n = e == "vert" ? l > 0 ? "down" : "up" : l > 0 ? "right" : "left";
  return function(t, u, i) {
    let s = t.selection, r = l > 0 ? s.$to : s.$from, o = s.empty;
    if (s instanceof Cl) {
      if (!i.endOfTextblock(n) || r.depth == 0)
        return !1;
      o = !1, r = t.doc.resolve(l > 0 ? r.after() : r.before());
    }
    let a = ln.findGapCursorFrom(r, l, o);
    return a ? (u && u(t.tr.setSelection(new ln(a))), !0) : !1;
  };
}
function jD(e, l, n) {
  if (!e || !e.editable)
    return !1;
  let t = e.state.doc.resolve(l);
  if (!ln.valid(t))
    return !1;
  let u = e.posAtCoords({ left: n.clientX, top: n.clientY });
  return u && u.inside > -1 && pl.isSelectable(e.state.doc.nodeAt(u.inside)) ? !1 : (e.dispatch(e.state.tr.setSelection(new ln(t))), !0);
}
function UD(e, l) {
  if (l.inputType != "insertCompositionText" || !(e.state.selection instanceof ln))
    return !1;
  let { $from: n } = e.state.selection, t = n.parent.contentMatchAt(n.index()).findWrapping(e.state.schema.nodes.text);
  if (!t)
    return !1;
  let u = j.empty;
  for (let s = t.length - 1; s >= 0; s--)
    u = j.from(t[s].createAndFill(null, u));
  let i = e.state.tr.replace(n.pos, n.pos, new nl(u, 0, 0));
  return i.setSelection(Cl.near(i.doc.resolve(n.pos + 1))), e.dispatch(i), !1;
}
function WD(e) {
  if (!(e.selection instanceof ln))
    return null;
  let l = document.createElement("div");
  return l.className = "ProseMirror-gapcursor", un.create(e.doc, [ve.widget(e.selection.head, l, { key: "gapcursor" })]);
}
const GD = mn.create({
  name: "gapCursor",
  addProseMirrorPlugins() {
    return [
      zD()
    ];
  },
  extendNodeSchema(e) {
    var l;
    const n = {
      name: e.name,
      options: e.options,
      storage: e.storage
    };
    return {
      allowGapCursor: (l = Ol(sl(e, "allowGapCursor", n))) !== null && l !== void 0 ? l : null
    };
  }
}), KD = gn.create({
  name: "hardBreak",
  addOptions() {
    return {
      keepMarks: !0,
      HTMLAttributes: {}
    };
  },
  inline: !0,
  group: "inline",
  selectable: !1,
  parseHTML() {
    return [
      { tag: "br" }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["br", ql(this.options.HTMLAttributes, e)];
  },
  renderText() {
    return `
`;
  },
  addCommands() {
    return {
      setHardBreak: () => ({ commands: e, chain: l, state: n, editor: t }) => e.first([
        () => e.exitCode(),
        () => e.command(() => {
          const { selection: u, storedMarks: i } = n;
          if (u.$from.parent.type.spec.isolating)
            return !1;
          const { keepMarks: s } = this.options, { splittableMarks: r } = t.extensionManager, o = i || u.$to.parentOffset && u.$from.marks();
          return l().insertContent({ type: this.name }).command(({ tr: a, dispatch: d }) => {
            if (d && o && s) {
              const h = o.filter((p) => r.includes(p.type.name));
              a.ensureMarks(h);
            }
            return !0;
          }).run();
        })
      ])
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Enter": () => this.editor.commands.setHardBreak(),
      "Shift-Enter": () => this.editor.commands.setHardBreak()
    };
  }
}), YD = gn.create({
  name: "heading",
  addOptions() {
    return {
      levels: [1, 2, 3, 4, 5, 6],
      HTMLAttributes: {}
    };
  },
  content: "inline*",
  group: "block",
  defining: !0,
  addAttributes() {
    return {
      level: {
        default: 1,
        rendered: !1
      }
    };
  },
  parseHTML() {
    return this.options.levels.map((e) => ({
      tag: `h${e}`,
      attrs: { level: e }
    }));
  },
  renderHTML({ node: e, HTMLAttributes: l }) {
    return [`h${this.options.levels.includes(e.attrs.level) ? e.attrs.level : this.options.levels[0]}`, ql(this.options.HTMLAttributes, l), 0];
  },
  addCommands() {
    return {
      setHeading: (e) => ({ commands: l }) => this.options.levels.includes(e.level) ? l.setNode(this.name, e) : !1,
      toggleHeading: (e) => ({ commands: l }) => this.options.levels.includes(e.level) ? l.toggleNode(this.name, "paragraph", e) : !1
    };
  },
  addKeyboardShortcuts() {
    return this.options.levels.reduce((e, l) => ({
      ...e,
      [`Mod-Alt-${l}`]: () => this.editor.commands.toggleHeading({ level: l })
    }), {});
  },
  addInputRules() {
    return this.options.levels.map((e) => Jh({
      find: new RegExp(`^(#{1,${e}})\\s$`),
      type: this.type,
      getAttributes: {
        level: e
      }
    }));
  }
});
var Zr = 200, pn = function() {
};
pn.prototype.append = function(l) {
  return l.length ? (l = pn.from(l), !this.length && l || l.length < Zr && this.leafAppend(l) || this.length < Zr && l.leafPrepend(this) || this.appendInner(l)) : this;
};
pn.prototype.prepend = function(l) {
  return l.length ? pn.from(l).append(this) : this;
};
pn.prototype.appendInner = function(l) {
  return new qD(this, l);
};
pn.prototype.slice = function(l, n) {
  return l === void 0 && (l = 0), n === void 0 && (n = this.length), l >= n ? pn.empty : this.sliceInner(Math.max(0, l), Math.min(this.length, n));
};
pn.prototype.get = function(l) {
  if (!(l < 0 || l >= this.length))
    return this.getInner(l);
};
pn.prototype.forEach = function(l, n, t) {
  n === void 0 && (n = 0), t === void 0 && (t = this.length), n <= t ? this.forEachInner(l, n, t, 0) : this.forEachInvertedInner(l, n, t, 0);
};
pn.prototype.map = function(l, n, t) {
  n === void 0 && (n = 0), t === void 0 && (t = this.length);
  var u = [];
  return this.forEach(function(i, s) {
    return u.push(l(i, s));
  }, n, t), u;
};
pn.from = function(l) {
  return l instanceof pn ? l : l && l.length ? new wy(l) : pn.empty;
};
var wy = /* @__PURE__ */ function(e) {
  function l(t) {
    e.call(this), this.values = t;
  }
  e && (l.__proto__ = e), l.prototype = Object.create(e && e.prototype), l.prototype.constructor = l;
  var n = { length: { configurable: !0 }, depth: { configurable: !0 } };
  return l.prototype.flatten = function() {
    return this.values;
  }, l.prototype.sliceInner = function(u, i) {
    return u == 0 && i == this.length ? this : new l(this.values.slice(u, i));
  }, l.prototype.getInner = function(u) {
    return this.values[u];
  }, l.prototype.forEachInner = function(u, i, s, r) {
    for (var o = i; o < s; o++)
      if (u(this.values[o], r + o) === !1)
        return !1;
  }, l.prototype.forEachInvertedInner = function(u, i, s, r) {
    for (var o = i - 1; o >= s; o--)
      if (u(this.values[o], r + o) === !1)
        return !1;
  }, l.prototype.leafAppend = function(u) {
    if (this.length + u.length <= Zr)
      return new l(this.values.concat(u.flatten()));
  }, l.prototype.leafPrepend = function(u) {
    if (this.length + u.length <= Zr)
      return new l(u.flatten().concat(this.values));
  }, n.length.get = function() {
    return this.values.length;
  }, n.depth.get = function() {
    return 0;
  }, Object.defineProperties(l.prototype, n), l;
}(pn);
pn.empty = new wy([]);
var qD = /* @__PURE__ */ function(e) {
  function l(n, t) {
    e.call(this), this.left = n, this.right = t, this.length = n.length + t.length, this.depth = Math.max(n.depth, t.depth) + 1;
  }
  return e && (l.__proto__ = e), l.prototype = Object.create(e && e.prototype), l.prototype.constructor = l, l.prototype.flatten = function() {
    return this.left.flatten().concat(this.right.flatten());
  }, l.prototype.getInner = function(t) {
    return t < this.left.length ? this.left.get(t) : this.right.get(t - this.left.length);
  }, l.prototype.forEachInner = function(t, u, i, s) {
    var r = this.left.length;
    if (u < r && this.left.forEachInner(t, u, Math.min(i, r), s) === !1 || i > r && this.right.forEachInner(t, Math.max(u - r, 0), Math.min(this.length, i) - r, s + r) === !1)
      return !1;
  }, l.prototype.forEachInvertedInner = function(t, u, i, s) {
    var r = this.left.length;
    if (u > r && this.right.forEachInvertedInner(t, u - r, Math.max(i, r) - r, s + r) === !1 || i < r && this.left.forEachInvertedInner(t, Math.min(u, r), i, s) === !1)
      return !1;
  }, l.prototype.sliceInner = function(t, u) {
    if (t == 0 && u == this.length)
      return this;
    var i = this.left.length;
    return u <= i ? this.left.slice(t, u) : t >= i ? this.right.slice(t - i, u - i) : this.left.slice(t, i).append(this.right.slice(0, u - i));
  }, l.prototype.leafAppend = function(t) {
    var u = this.right.leafAppend(t);
    if (u)
      return new l(this.left, u);
  }, l.prototype.leafPrepend = function(t) {
    var u = this.left.leafPrepend(t);
    if (u)
      return new l(u, this.right);
  }, l.prototype.appendInner = function(t) {
    return this.left.depth >= Math.max(this.right.depth, t.depth) + 1 ? new l(this.left, new l(this.right, t)) : new l(this, t);
  }, l;
}(pn);
const JD = 500;
class Re {
  constructor(l, n) {
    this.items = l, this.eventCount = n;
  }
  // Pop the latest event off the branch's history and apply it
  // to a document transform.
  popEvent(l, n) {
    if (this.eventCount == 0)
      return null;
    let t = this.items.length;
    for (; ; t--)
      if (this.items.get(t - 1).selection) {
        --t;
        break;
      }
    let u, i;
    n && (u = this.remapping(t, this.items.length), i = u.maps.length);
    let s = l.tr, r, o, a = [], d = [];
    return this.items.forEach((h, p) => {
      if (!h.step) {
        u || (u = this.remapping(t, p + 1), i = u.maps.length), i--, d.push(h);
        return;
      }
      if (u) {
        d.push(new qe(h.map));
        let f = h.step.map(u.slice(i)), m;
        f && s.maybeStep(f).doc && (m = s.mapping.maps[s.mapping.maps.length - 1], a.push(new qe(m, void 0, void 0, a.length + d.length))), i--, m && u.appendMap(m, i);
      } else
        s.maybeStep(h.step);
      if (h.selection)
        return r = u ? h.selection.map(u.slice(i)) : h.selection, o = new Re(this.items.slice(0, t).append(d.reverse().concat(a)), this.eventCount - 1), !1;
    }, this.items.length, 0), { remaining: o, transform: s, selection: r };
  }
  // Create a new branch with the given transform added.
  addTransform(l, n, t, u) {
    let i = [], s = this.eventCount, r = this.items, o = !u && r.length ? r.get(r.length - 1) : null;
    for (let d = 0; d < l.steps.length; d++) {
      let h = l.steps[d].invert(l.docs[d]), p = new qe(l.mapping.maps[d], h, n), f;
      (f = o && o.merge(p)) && (p = f, d ? i.pop() : r = r.slice(0, r.length - 1)), i.push(p), n && (s++, n = void 0), u || (o = p);
    }
    let a = s - t.depth;
    return a > XD && (r = ZD(r, a), s -= a), new Re(r.append(i), s);
  }
  remapping(l, n) {
    let t = new di();
    return this.items.forEach((u, i) => {
      let s = u.mirrorOffset != null && i - u.mirrorOffset >= l ? t.maps.length - u.mirrorOffset : void 0;
      t.appendMap(u.map, s);
    }, l, n), t;
  }
  addMaps(l) {
    return this.eventCount == 0 ? this : new Re(this.items.append(l.map((n) => new qe(n))), this.eventCount);
  }
  // When the collab module receives remote changes, the history has
  // to know about those, so that it can adjust the steps that were
  // rebased on top of the remote changes, and include the position
  // maps for the remote changes in its array of items.
  rebased(l, n) {
    if (!this.eventCount)
      return this;
    let t = [], u = Math.max(0, this.items.length - n), i = l.mapping, s = l.steps.length, r = this.eventCount;
    this.items.forEach((p) => {
      p.selection && r--;
    }, u);
    let o = n;
    this.items.forEach((p) => {
      let f = i.getMirror(--o);
      if (f == null)
        return;
      s = Math.min(s, f);
      let m = i.maps[f];
      if (p.step) {
        let g = l.steps[f].invert(l.docs[f]), v = p.selection && p.selection.map(i.slice(o + 1, f));
        v && r++, t.push(new qe(m, g, v));
      } else
        t.push(new qe(m));
    }, u);
    let a = [];
    for (let p = n; p < s; p++)
      a.push(new qe(i.maps[p]));
    let d = this.items.slice(0, u).append(a).append(t), h = new Re(d, r);
    return h.emptyItemCount() > JD && (h = h.compress(this.items.length - t.length)), h;
  }
  emptyItemCount() {
    let l = 0;
    return this.items.forEach((n) => {
      n.step || l++;
    }), l;
  }
  // Compressing a branch means rewriting it to push the air (map-only
  // items) out. During collaboration, these naturally accumulate
  // because each remote change adds one. The `upto` argument is used
  // to ensure that only the items below a given level are compressed,
  // because `rebased` relies on a clean, untouched set of items in
  // order to associate old items with rebased steps.
  compress(l = this.items.length) {
    let n = this.remapping(0, l), t = n.maps.length, u = [], i = 0;
    return this.items.forEach((s, r) => {
      if (r >= l)
        u.push(s), s.selection && i++;
      else if (s.step) {
        let o = s.step.map(n.slice(t)), a = o && o.getMap();
        if (t--, a && n.appendMap(a, t), o) {
          let d = s.selection && s.selection.map(n.slice(t));
          d && i++;
          let h = new qe(a.invert(), o, d), p, f = u.length - 1;
          (p = u.length && u[f].merge(h)) ? u[f] = p : u.push(h);
        }
      } else
        s.map && t--;
    }, this.items.length, 0), new Re(pn.from(u.reverse()), i);
  }
}
Re.empty = new Re(pn.empty, 0);
function ZD(e, l) {
  let n;
  return e.forEach((t, u) => {
    if (t.selection && l-- == 0)
      return n = u, !1;
  }), e.slice(n);
}
class qe {
  constructor(l, n, t, u) {
    this.map = l, this.step = n, this.selection = t, this.mirrorOffset = u;
  }
  merge(l) {
    if (this.step && l.step && !l.selection) {
      let n = l.step.merge(this.step);
      if (n)
        return new qe(n.getMap().invert(), n, this.selection);
    }
  }
}
class zt {
  constructor(l, n, t, u, i) {
    this.done = l, this.undone = n, this.prevRanges = t, this.prevTime = u, this.prevComposition = i;
  }
}
const XD = 20;
function QD(e, l, n, t) {
  let u = n.getMeta(nu), i;
  if (u)
    return u.historyState;
  n.getMeta(nN) && (e = new zt(e.done, e.undone, null, 0, -1));
  let s = n.getMeta("appendedTransaction");
  if (n.steps.length == 0)
    return e;
  if (s && s.getMeta(nu))
    return s.getMeta(nu).redo ? new zt(e.done.addTransform(n, void 0, t, _r(l)), e.undone, Mg(n.mapping.maps[n.steps.length - 1]), e.prevTime, e.prevComposition) : new zt(e.done, e.undone.addTransform(n, void 0, t, _r(l)), null, e.prevTime, e.prevComposition);
  if (n.getMeta("addToHistory") !== !1 && !(s && s.getMeta("addToHistory") === !1)) {
    let r = n.getMeta("composition"), o = e.prevTime == 0 || !s && e.prevComposition != r && (e.prevTime < (n.time || 0) - t.newGroupDelay || !lN(n, e.prevRanges)), a = s ? Hd(e.prevRanges, n.mapping) : Mg(n.mapping.maps[n.steps.length - 1]);
    return new zt(e.done.addTransform(n, o ? l.selection.getBookmark() : void 0, t, _r(l)), Re.empty, a, n.time, r ?? e.prevComposition);
  } else
    return (i = n.getMeta("rebased")) ? new zt(e.done.rebased(n, i), e.undone.rebased(n, i), Hd(e.prevRanges, n.mapping), e.prevTime, e.prevComposition) : new zt(e.done.addMaps(n.mapping.maps), e.undone.addMaps(n.mapping.maps), Hd(e.prevRanges, n.mapping), e.prevTime, e.prevComposition);
}
function lN(e, l) {
  if (!l)
    return !1;
  if (!e.docChanged)
    return !0;
  let n = !1;
  return e.mapping.maps[0].forEach((t, u) => {
    for (let i = 0; i < l.length; i += 2)
      t <= l[i + 1] && u >= l[i] && (n = !0);
  }), n;
}
function Mg(e) {
  let l = [];
  return e.forEach((n, t, u, i) => l.push(u, i)), l;
}
function Hd(e, l) {
  if (!e)
    return null;
  let n = [];
  for (let t = 0; t < e.length; t += 2) {
    let u = l.map(e[t], 1), i = l.map(e[t + 1], -1);
    u <= i && n.push(u, i);
  }
  return n;
}
function _y(e, l, n, t) {
  let u = _r(l), i = nu.get(l).spec.config, s = (t ? e.undone : e.done).popEvent(l, u);
  if (!s)
    return;
  let r = s.selection.resolve(s.transform.doc), o = (t ? e.done : e.undone).addTransform(s.transform, l.selection.getBookmark(), i, u), a = new zt(t ? o : s.remaining, t ? s.remaining : o, null, 0, -1);
  n(s.transform.setSelection(r).setMeta(nu, { redo: t, historyState: a }).scrollIntoView());
}
let zd = !1, Ag = null;
function _r(e) {
  let l = e.plugins;
  if (Ag != l) {
    zd = !1, Ag = l;
    for (let n = 0; n < l.length; n++)
      if (l[n].spec.historyPreserveItems) {
        zd = !0;
        break;
      }
  }
  return zd;
}
const nu = new se("history"), nN = new se("closeHistory");
function eN(e = {}) {
  return e = {
    depth: e.depth || 100,
    newGroupDelay: e.newGroupDelay || 500
  }, new On({
    key: nu,
    state: {
      init() {
        return new zt(Re.empty, Re.empty, null, 0, -1);
      },
      apply(l, n, t) {
        return QD(n, t, l, e);
      }
    },
    config: e,
    props: {
      handleDOMEvents: {
        beforeinput(l, n) {
          let t = n.inputType, u = t == "historyUndo" ? Sy : t == "historyRedo" ? Cy : null;
          return u ? (n.preventDefault(), u(l.state, l.dispatch)) : !1;
        }
      }
    }
  });
}
const Sy = (e, l) => {
  let n = nu.getState(e);
  return !n || n.done.eventCount == 0 ? !1 : (l && _y(n, e, l, !1), !0);
}, Cy = (e, l) => {
  let n = nu.getState(e);
  return !n || n.undone.eventCount == 0 ? !1 : (l && _y(n, e, l, !0), !0);
}, tN = mn.create({
  name: "history",
  addOptions() {
    return {
      depth: 100,
      newGroupDelay: 500
    };
  },
  addCommands() {
    return {
      undo: () => ({ state: e, dispatch: l }) => Sy(e, l),
      redo: () => ({ state: e, dispatch: l }) => Cy(e, l)
    };
  },
  addProseMirrorPlugins() {
    return [
      eN(this.options)
    ];
  },
  addKeyboardShortcuts() {
    return {
      "Mod-z": () => this.editor.commands.undo(),
      "Shift-Mod-z": () => this.editor.commands.redo(),
      "Mod-y": () => this.editor.commands.redo(),
      // Russian keyboard layouts
      "Mod-я": () => this.editor.commands.undo(),
      "Shift-Mod-я": () => this.editor.commands.redo()
    };
  }
}), uN = gn.create({
  name: "horizontalRule",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  parseHTML() {
    return [{ tag: "hr" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["hr", ql(this.options.HTMLAttributes, e)];
  },
  addCommands() {
    return {
      setHorizontalRule: () => ({ chain: e, state: l }) => {
        const { $to: n } = l.selection, t = e();
        return n.parentOffset === 0 ? t.insertContentAt(Math.max(n.pos - 2, 0), { type: this.name }) : t.insertContent({ type: this.name }), t.command(({ tr: u, dispatch: i }) => {
          var s;
          if (i) {
            const { $to: r } = u.selection, o = r.end();
            if (r.nodeAfter)
              r.nodeAfter.isTextblock ? u.setSelection(Cl.create(u.doc, r.pos + 1)) : r.nodeAfter.isBlock ? u.setSelection(pl.create(u.doc, r.pos)) : u.setSelection(Cl.create(u.doc, r.pos));
            else {
              const a = (s = r.parent.type.contentMatch.defaultType) === null || s === void 0 ? void 0 : s.create();
              a && (u.insert(o, a), u.setSelection(Cl.create(u.doc, o + 1)));
            }
            u.scrollIntoView();
          }
          return !0;
        }).run();
      }
    };
  },
  addInputRules() {
    return [
      Z4({
        find: /^(?:---|—-|___\s|\*\*\*\s)$/,
        type: this.type
      })
    ];
  }
}), iN = /(?:^|\s)((?:\*)((?:[^*]+))(?:\*))$/, sN = /(?:^|\s)((?:\*)((?:[^*]+))(?:\*))/g, rN = /(?:^|\s)((?:_)((?:[^_]+))(?:_))$/, oN = /(?:^|\s)((?:_)((?:[^_]+))(?:_))/g, aN = ue.create({
  name: "italic",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "em"
      },
      {
        tag: "i",
        getAttrs: (e) => e.style.fontStyle !== "normal" && null
      },
      {
        style: "font-style=italic"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["em", ql(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setItalic: () => ({ commands: e }) => e.setMark(this.name),
      toggleItalic: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetItalic: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-i": () => this.editor.commands.toggleItalic(),
      "Mod-I": () => this.editor.commands.toggleItalic()
    };
  },
  addInputRules() {
    return [
      Ci({
        find: iN,
        type: this.type
      }),
      Ci({
        find: rN,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Fu({
        find: sN,
        type: this.type
      }),
      Fu({
        find: oN,
        type: this.type
      })
    ];
  }
}), dN = gn.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["li", ql(this.options.HTMLAttributes, e), 0];
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), cN = gn.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["li", ql(this.options.HTMLAttributes, e), 0];
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), xg = ue.create({
  name: "textStyle",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "span",
        getAttrs: (e) => e.hasAttribute("style") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["span", ql(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      removeEmptyTextStyle: () => ({ state: e, commands: l }) => {
        const n = Vs(e, this.type);
        return Object.entries(n).some(([, u]) => !!u) ? !0 : l.unsetMark(this.name);
      }
    };
  }
}), Eg = /^(\d+)\.\s$/, hN = gn.create({
  name: "orderedList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  addAttributes() {
    return {
      start: {
        default: 1,
        parseHTML: (e) => e.hasAttribute("start") ? parseInt(e.getAttribute("start") || "", 10) : 1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "ol"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    const { start: l, ...n } = e;
    return l === 1 ? ["ol", ql(this.options.HTMLAttributes, n), 0] : ["ol", ql(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      toggleOrderedList: () => ({ commands: e, chain: l }) => this.options.keepAttributes ? l().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(cN.name, this.editor.getAttributes(xg.name)).run() : e.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-7": () => this.editor.commands.toggleOrderedList()
    };
  },
  addInputRules() {
    let e = xs({
      find: Eg,
      type: this.type,
      getAttributes: (l) => ({ start: +l[1] }),
      joinPredicate: (l, n) => n.childCount + n.attrs.start === +l[1]
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (e = xs({
      find: Eg,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: (l) => ({ start: +l[1], ...this.editor.getAttributes(xg.name) }),
      joinPredicate: (l, n) => n.childCount + n.attrs.start === +l[1],
      editor: this.editor
    })), [
      e
    ];
  }
}), pN = gn.create({
  name: "paragraph",
  priority: 1e3,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  content: "inline*",
  parseHTML() {
    return [
      { tag: "p" }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["p", ql(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setParagraph: () => ({ commands: e }) => e.setNode(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-0": () => this.editor.commands.setParagraph()
    };
  }
}), fN = /(?:^|\s)((?:~~)((?:[^~]+))(?:~~))$/, mN = /(?:^|\s)((?:~~)((?:[^~]+))(?:~~))/g, gN = ue.create({
  name: "strike",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "s"
      },
      {
        tag: "del"
      },
      {
        tag: "strike"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (e) => e.includes("line-through") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["s", ql(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setStrike: () => ({ commands: e }) => e.setMark(this.name),
      toggleStrike: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetStrike: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    const e = {};
    return u1() ? e["Mod-Shift-s"] = () => this.editor.commands.toggleStrike() : e["Ctrl-Shift-s"] = () => this.editor.commands.toggleStrike(), e;
  },
  addInputRules() {
    return [
      Ci({
        find: fN,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Fu({
        find: mN,
        type: this.type
      })
    ];
  }
}), vN = gn.create({
  name: "text",
  group: "inline"
}), yN = mn.create({
  name: "starterKit",
  addExtensions() {
    var e, l, n, t, u, i, s, r, o, a, d, h, p, f, m, g, v, w;
    const $ = [];
    return this.options.blockquote !== !1 && $.push(wD.configure((e = this.options) === null || e === void 0 ? void 0 : e.blockquote)), this.options.bold !== !1 && $.push(OD.configure((l = this.options) === null || l === void 0 ? void 0 : l.bold)), this.options.bulletList !== !1 && $.push(MD.configure((n = this.options) === null || n === void 0 ? void 0 : n.bulletList)), this.options.code !== !1 && $.push(ED.configure((t = this.options) === null || t === void 0 ? void 0 : t.code)), this.options.codeBlock !== !1 && $.push(DD.configure((u = this.options) === null || u === void 0 ? void 0 : u.codeBlock)), this.options.document !== !1 && $.push(ND.configure((i = this.options) === null || i === void 0 ? void 0 : i.document)), this.options.dropcursor !== !1 && $.push(BD.configure((s = this.options) === null || s === void 0 ? void 0 : s.dropcursor)), this.options.gapcursor !== !1 && $.push(GD.configure((r = this.options) === null || r === void 0 ? void 0 : r.gapcursor)), this.options.hardBreak !== !1 && $.push(KD.configure((o = this.options) === null || o === void 0 ? void 0 : o.hardBreak)), this.options.heading !== !1 && $.push(YD.configure((a = this.options) === null || a === void 0 ? void 0 : a.heading)), this.options.history !== !1 && $.push(tN.configure((d = this.options) === null || d === void 0 ? void 0 : d.history)), this.options.horizontalRule !== !1 && $.push(uN.configure((h = this.options) === null || h === void 0 ? void 0 : h.horizontalRule)), this.options.italic !== !1 && $.push(aN.configure((p = this.options) === null || p === void 0 ? void 0 : p.italic)), this.options.listItem !== !1 && $.push(dN.configure((f = this.options) === null || f === void 0 ? void 0 : f.listItem)), this.options.orderedList !== !1 && $.push(hN.configure((m = this.options) === null || m === void 0 ? void 0 : m.orderedList)), this.options.paragraph !== !1 && $.push(pN.configure((g = this.options) === null || g === void 0 ? void 0 : g.paragraph)), this.options.strike !== !1 && $.push(gN.configure((v = this.options) === null || v === void 0 ? void 0 : v.strike)), this.options.text !== !1 && $.push(vN.configure((w = this.options) === null || w === void 0 ? void 0 : w.text)), $;
  }
}), $N = ue.create({
  name: "underline",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "u"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (e) => e.includes("underline") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["u", ql(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setUnderline: () => ({ commands: e }) => e.setMark(this.name),
      toggleUnderline: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetUnderline: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-u": () => this.editor.commands.toggleUnderline(),
      "Mod-U": () => this.editor.commands.toggleUnderline()
    };
  }
}), bN = mn.create({
  name: "textAlign",
  addOptions() {
    return {
      types: [],
      alignments: ["left", "center", "right", "justify"],
      defaultAlignment: "left"
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          textAlign: {
            default: this.options.defaultAlignment,
            parseHTML: (e) => e.style.textAlign || this.options.defaultAlignment,
            renderHTML: (e) => e.textAlign === this.options.defaultAlignment ? {} : { style: `text-align: ${e.textAlign}` }
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setTextAlign: (e) => ({ commands: l }) => this.options.alignments.includes(e) ? this.options.types.every((n) => l.updateAttributes(n, { textAlign: e })) : !1,
      unsetTextAlign: () => ({ commands: e }) => this.options.types.every((l) => e.resetAttributes(l, "textAlign"))
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-l": () => this.editor.commands.setTextAlign("left"),
      "Mod-Shift-e": () => this.editor.commands.setTextAlign("center"),
      "Mod-Shift-r": () => this.editor.commands.setTextAlign("right"),
      "Mod-Shift-j": () => this.editor.commands.setTextAlign("justify")
    };
  }
}), wN = ue.create({
  name: "textStyle",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "span",
        getAttrs: (e) => e.hasAttribute("style") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["span", ql(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      removeEmptyTextStyle: () => ({ state: e, commands: l }) => {
        const n = Vs(e, this.type);
        return Object.entries(n).some(([, u]) => !!u) ? !0 : l.unsetMark(this.name);
      }
    };
  }
}), _N = /(?:^|\s)(!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\))$/, SN = gn.create({
  name: "image",
  addOptions() {
    return {
      inline: !1,
      allowBase64: !1,
      HTMLAttributes: {}
    };
  },
  inline() {
    return this.options.inline;
  },
  group() {
    return this.options.inline ? "inline" : "block";
  },
  draggable: !0,
  addAttributes() {
    return {
      src: {
        default: null
      },
      alt: {
        default: null
      },
      title: {
        default: null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: this.options.allowBase64 ? "img[src]" : 'img[src]:not([src^="data:"])'
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["img", ql(this.options.HTMLAttributes, e)];
  },
  addCommands() {
    return {
      setImage: (e) => ({ commands: l }) => l.insertContent({
        type: this.name,
        attrs: e
      })
    };
  },
  addInputRules() {
    return [
      Z4({
        find: _N,
        type: this.type,
        getAttributes: (e) => {
          const [, , l, n, t] = e;
          return { src: n, alt: l, title: t };
        }
      })
    ];
  }
}), CN = "aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4vianca6w0s2x0a2z0ure5ba0by2idu3namex3narepublic11d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2ntley5rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0cast4mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dabur3d1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3nlop4pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2o0dyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0ardian6cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6logistics9properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3ncaster6d0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2psy3ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rckmsd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2tura4vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9dnavy5lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0america6xi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0stone5umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0a1b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp2w2ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5mögensberater2ung14sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2olterskluwer11odside6rk0s2ld3w2s1tc1f3xbox3erox4finity6ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2", TN = "ελ1υ2бг1ел3дети4ею2католик6ом3мкд2он1сква6онлайн5рг3рус2ф2сайт3рб3укр3қаз3հայ3ישראל5קום3ابوظبي5رامكو5لاردن4بحرين5جزائر5سعودية6عليان5مغرب5مارات5یران5بارت2زار4يتك3ھارت5تونس4سودان3رية5شبكة4عراق2ب2مان4فلسطين6قطر3كاثوليك6وم3مصر2ليسيا5وريتانيا7قع4همراه5پاکستان7ڀارت4कॉम3नेट3भारत0म्3ोत5संगठन5বাংলা5ভারত2ৰত4ਭਾਰਤ4ભારત4ଭାରତ4இந்தியா6லங்கை6சிங்கப்பூர்11భారత్5ಭಾರತ4ഭാരതം5ලංකා4คอม3ไทย3ລາວ3გე2みんな3アマゾン4クラウド4グーグル4コム2ストア3セール3ファッション6ポイント4世界2中信1国1國1文网3亚马逊3企业2佛山2信息2健康2八卦2公司1益2台湾1灣2商城1店1标2嘉里0大酒店5在线2大拿2天主教3娱乐2家電2广东2微博2慈善2我爱你3手机2招聘2政务1府2新加坡2闻2时尚2書籍2机构2淡马锡3游戏2澳門2点看2移动2组织机构4网址1店1站1络2联通2谷歌2购物2通販2集团2電訊盈科4飞利浦3食品2餐厅2香格里拉3港2닷넷1컴2삼성2한국2", Ai = (e, l) => {
  for (const n in l)
    e[n] = l[n];
  return e;
}, ep = "numeric", tp = "ascii", up = "alpha", Sr = "asciinumeric", dr = "alphanumeric", ip = "domain", Ty = "emoji", ON = "scheme", kN = "slashscheme", Ig = "whitespace";
function MN(e, l) {
  return e in l || (l[e] = []), l[e];
}
function Tu(e, l, n) {
  l[ep] && (l[Sr] = !0, l[dr] = !0), l[tp] && (l[Sr] = !0, l[up] = !0), l[Sr] && (l[dr] = !0), l[up] && (l[dr] = !0), l[dr] && (l[ip] = !0), l[Ty] && (l[ip] = !0);
  for (const t in l) {
    const u = MN(t, n);
    u.indexOf(e) < 0 && u.push(e);
  }
}
function AN(e, l) {
  const n = {};
  for (const t in l)
    l[t].indexOf(e) >= 0 && (n[t] = !0);
  return n;
}
function Yn(e) {
  e === void 0 && (e = null), this.j = {}, this.jr = [], this.jd = null, this.t = e;
}
Yn.groups = {};
Yn.prototype = {
  accepts() {
    return !!this.t;
  },
  /**
   * Follow an existing transition from the given input to the next state.
   * Does not mutate.
   * @param {string} input character or token type to transition on
   * @returns {?State<T>} the next state, if any
   */
  go(e) {
    const l = this, n = l.j[e];
    if (n)
      return n;
    for (let t = 0; t < l.jr.length; t++) {
      const u = l.jr[t][0], i = l.jr[t][1];
      if (i && u.test(e))
        return i;
    }
    return l.jd;
  },
  /**
   * Whether the state has a transition for the given input. Set the second
   * argument to true to only look for an exact match (and not a default or
   * regular-expression-based transition)
   * @param {string} input
   * @param {boolean} exactOnly
   */
  has(e, l) {
    return l === void 0 && (l = !1), l ? e in this.j : !!this.go(e);
  },
  /**
   * Short for "transition all"; create a transition from the array of items
   * in the given list to the same final resulting state.
   * @param {string | string[]} inputs Group of inputs to transition on
   * @param {Transition<T> | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   */
  ta(e, l, n, t) {
    for (let u = 0; u < e.length; u++)
      this.tt(e[u], l, n, t);
  },
  /**
   * Short for "take regexp transition"; defines a transition for this state
   * when it encounters a token which matches the given regular expression
   * @param {RegExp} regexp Regular expression transition (populate first)
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  tr(e, l, n, t) {
    t = t || Yn.groups;
    let u;
    return l && l.j ? u = l : (u = new Yn(l), n && t && Tu(l, n, t)), this.jr.push([e, u]), u;
  },
  /**
   * Short for "take transitions", will take as many sequential transitions as
   * the length of the given input and returns the
   * resulting final state.
   * @param {string | string[]} input
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  ts(e, l, n, t) {
    let u = this;
    const i = e.length;
    if (!i)
      return u;
    for (let s = 0; s < i - 1; s++)
      u = u.tt(e[s]);
    return u.tt(e[i - 1], l, n, t);
  },
  /**
   * Short for "take transition", this is a method for building/working with
   * state machines.
   *
   * If a state already exists for the given input, returns it.
   *
   * If a token is specified, that state will emit that token when reached by
   * the linkify engine.
   *
   * If no state exists, it will be initialized with some default transitions
   * that resemble existing default transitions.
   *
   * If a state is given for the second argument, that state will be
   * transitioned to on the given input regardless of what that input
   * previously did.
   *
   * Specify a token group flags to define groups that this token belongs to.
   * The token will be added to corresponding entires in the given groups
   * object.
   *
   * @param {string} input character, token type to transition on
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of groups
   * @returns {State<T>} taken after the given input
   */
  tt(e, l, n, t) {
    t = t || Yn.groups;
    const u = this;
    if (l && l.j)
      return u.j[e] = l, l;
    const i = l;
    let s, r = u.go(e);
    if (r ? (s = new Yn(), Ai(s.j, r.j), s.jr.push.apply(s.jr, r.jr), s.jd = r.jd, s.t = r.t) : s = new Yn(), i) {
      if (t)
        if (s.t && typeof s.t == "string") {
          const o = Ai(AN(s.t, t), n);
          Tu(i, o, t);
        } else
          n && Tu(i, n, t);
      s.t = i;
    }
    return u.j[e] = s, s;
  }
};
const Al = (e, l, n, t, u) => e.ta(l, n, t, u), he = (e, l, n, t, u) => e.tr(l, n, t, u), Rg = (e, l, n, t, u) => e.ts(l, n, t, u), q = (e, l, n, t, u) => e.tt(l, n, t, u), Ct = "WORD", sp = "UWORD", Ns = "LOCALHOST", rp = "TLD", op = "UTLD", Cr = "SCHEME", ei = "SLASH_SCHEME", g1 = "NUM", Oy = "WS", v1 = "NL", rs = "OPENBRACE", as = "CLOSEBRACE", Xr = "OPENBRACKET", Qr = "CLOSEBRACKET", lo = "OPENPAREN", no = "CLOSEPAREN", eo = "OPENANGLEBRACKET", to = "CLOSEANGLEBRACKET", uo = "FULLWIDTHLEFTPAREN", io = "FULLWIDTHRIGHTPAREN", so = "LEFTCORNERBRACKET", ro = "RIGHTCORNERBRACKET", oo = "LEFTWHITECORNERBRACKET", ao = "RIGHTWHITECORNERBRACKET", co = "FULLWIDTHLESSTHAN", ho = "FULLWIDTHGREATERTHAN", po = "AMPERSAND", fo = "APOSTROPHE", mo = "ASTERISK", Vt = "AT", go = "BACKSLASH", vo = "BACKTICK", yo = "CARET", Kt = "COLON", y1 = "COMMA", $o = "DOLLAR", Je = "DOT", bo = "EQUALS", $1 = "EXCLAMATION", Ze = "HYPHEN", wo = "PERCENT", _o = "PIPE", So = "PLUS", Co = "POUND", To = "QUERY", b1 = "QUOTE", w1 = "SEMI", Xe = "SLASH", ds = "TILDE", Oo = "UNDERSCORE", ky = "EMOJI", ko = "SYM";
var My = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  WORD: Ct,
  UWORD: sp,
  LOCALHOST: Ns,
  TLD: rp,
  UTLD: op,
  SCHEME: Cr,
  SLASH_SCHEME: ei,
  NUM: g1,
  WS: Oy,
  NL: v1,
  OPENBRACE: rs,
  CLOSEBRACE: as,
  OPENBRACKET: Xr,
  CLOSEBRACKET: Qr,
  OPENPAREN: lo,
  CLOSEPAREN: no,
  OPENANGLEBRACKET: eo,
  CLOSEANGLEBRACKET: to,
  FULLWIDTHLEFTPAREN: uo,
  FULLWIDTHRIGHTPAREN: io,
  LEFTCORNERBRACKET: so,
  RIGHTCORNERBRACKET: ro,
  LEFTWHITECORNERBRACKET: oo,
  RIGHTWHITECORNERBRACKET: ao,
  FULLWIDTHLESSTHAN: co,
  FULLWIDTHGREATERTHAN: ho,
  AMPERSAND: po,
  APOSTROPHE: fo,
  ASTERISK: mo,
  AT: Vt,
  BACKSLASH: go,
  BACKTICK: vo,
  CARET: yo,
  COLON: Kt,
  COMMA: y1,
  DOLLAR: $o,
  DOT: Je,
  EQUALS: bo,
  EXCLAMATION: $1,
  HYPHEN: Ze,
  PERCENT: wo,
  PIPE: _o,
  PLUS: So,
  POUND: Co,
  QUERY: To,
  QUOTE: b1,
  SEMI: w1,
  SLASH: Xe,
  TILDE: ds,
  UNDERSCORE: Oo,
  EMOJI: ky,
  SYM: ko
});
const Zu = /[a-z]/, Vd = new RegExp("\\p{L}", "u"), jd = new RegExp("\\p{Emoji}", "u"), Ud = /\d/, Dg = /\s/, Ng = `
`, xN = "️", EN = "‍";
let cr = null, hr = null;
function IN(e) {
  e === void 0 && (e = []);
  const l = {};
  Yn.groups = l;
  const n = new Yn();
  cr == null && (cr = Lg(CN)), hr == null && (hr = Lg(TN)), q(n, "'", fo), q(n, "{", rs), q(n, "}", as), q(n, "[", Xr), q(n, "]", Qr), q(n, "(", lo), q(n, ")", no), q(n, "<", eo), q(n, ">", to), q(n, "（", uo), q(n, "）", io), q(n, "「", so), q(n, "」", ro), q(n, "『", oo), q(n, "』", ao), q(n, "＜", co), q(n, "＞", ho), q(n, "&", po), q(n, "*", mo), q(n, "@", Vt), q(n, "`", vo), q(n, "^", yo), q(n, ":", Kt), q(n, ",", y1), q(n, "$", $o), q(n, ".", Je), q(n, "=", bo), q(n, "!", $1), q(n, "-", Ze), q(n, "%", wo), q(n, "|", _o), q(n, "+", So), q(n, "#", Co), q(n, "?", To), q(n, '"', b1), q(n, "/", Xe), q(n, ";", w1), q(n, "~", ds), q(n, "_", Oo), q(n, "\\", go);
  const t = he(n, Ud, g1, {
    [ep]: !0
  });
  he(t, Ud, t);
  const u = he(n, Zu, Ct, {
    [tp]: !0
  });
  he(u, Zu, u);
  const i = he(n, Vd, sp, {
    [up]: !0
  });
  he(i, Zu), he(i, Vd, i);
  const s = he(n, Dg, Oy, {
    [Ig]: !0
  });
  q(n, Ng, v1, {
    [Ig]: !0
  }), q(s, Ng), he(s, Dg, s);
  const r = he(n, jd, ky, {
    [Ty]: !0
  });
  he(r, jd, r), q(r, xN, r);
  const o = q(r, EN);
  he(o, jd, r);
  const a = [[Zu, u]], d = [[Zu, null], [Vd, i]];
  for (let h = 0; h < cr.length; h++)
    Lt(n, cr[h], rp, Ct, a);
  for (let h = 0; h < hr.length; h++)
    Lt(n, hr[h], op, sp, d);
  Tu(rp, {
    tld: !0,
    ascii: !0
  }, l), Tu(op, {
    utld: !0,
    alpha: !0
  }, l), Lt(n, "file", Cr, Ct, a), Lt(n, "mailto", Cr, Ct, a), Lt(n, "http", ei, Ct, a), Lt(n, "https", ei, Ct, a), Lt(n, "ftp", ei, Ct, a), Lt(n, "ftps", ei, Ct, a), Tu(Cr, {
    scheme: !0,
    ascii: !0
  }, l), Tu(ei, {
    slashscheme: !0,
    ascii: !0
  }, l), e = e.sort((h, p) => h[0] > p[0] ? 1 : -1);
  for (let h = 0; h < e.length; h++) {
    const p = e[h][0], m = e[h][1] ? {
      [ON]: !0
    } : {
      [kN]: !0
    };
    p.indexOf("-") >= 0 ? m[ip] = !0 : Zu.test(p) ? Ud.test(p) ? m[Sr] = !0 : m[tp] = !0 : m[ep] = !0, Rg(n, p, p, m);
  }
  return Rg(n, "localhost", Ns, {
    ascii: !0
  }), n.jd = new Yn(ko), {
    start: n,
    tokens: Ai({
      groups: l
    }, My)
  };
}
function RN(e, l) {
  const n = DN(l.replace(/[A-Z]/g, (r) => r.toLowerCase())), t = n.length, u = [];
  let i = 0, s = 0;
  for (; s < t; ) {
    let r = e, o = null, a = 0, d = null, h = -1, p = -1;
    for (; s < t && (o = r.go(n[s])); )
      r = o, r.accepts() ? (h = 0, p = 0, d = r) : h >= 0 && (h += n[s].length, p++), a += n[s].length, i += n[s].length, s++;
    i -= h, s -= p, a -= h, u.push({
      t: d.t,
      // token type/name
      v: l.slice(i - a, i),
      // string value
      s: i - a,
      // start index
      e: i
      // end index (excluding)
    });
  }
  return u;
}
function DN(e) {
  const l = [], n = e.length;
  let t = 0;
  for (; t < n; ) {
    let u = e.charCodeAt(t), i, s = u < 55296 || u > 56319 || t + 1 === n || (i = e.charCodeAt(t + 1)) < 56320 || i > 57343 ? e[t] : e.slice(t, t + 2);
    l.push(s), t += s.length;
  }
  return l;
}
function Lt(e, l, n, t, u) {
  let i;
  const s = l.length;
  for (let r = 0; r < s - 1; r++) {
    const o = l[r];
    e.j[o] ? i = e.j[o] : (i = new Yn(t), i.jr = u.slice(), e.j[o] = i), e = i;
  }
  return i = new Yn(n), i.jr = u.slice(), e.j[l[s - 1]] = i, i;
}
function Lg(e) {
  const l = [], n = [];
  let t = 0, u = "0123456789";
  for (; t < e.length; ) {
    let i = 0;
    for (; u.indexOf(e[t + i]) >= 0; )
      i++;
    if (i > 0) {
      l.push(n.join(""));
      for (let s = parseInt(e.substring(t, t + i), 10); s > 0; s--)
        n.pop();
      t += i;
    } else
      n.push(e[t]), t++;
  }
  return l;
}
const Ls = {
  defaultProtocol: "http",
  events: null,
  format: Pg,
  formatHref: Pg,
  nl2br: !1,
  tagName: "a",
  target: null,
  rel: null,
  validate: !0,
  truncate: 1 / 0,
  className: null,
  attributes: null,
  ignoreTags: [],
  render: null
};
function _1(e, l) {
  l === void 0 && (l = null);
  let n = Ai({}, Ls);
  e && (n = Ai(n, e instanceof _1 ? e.o : e));
  const t = n.ignoreTags, u = [];
  for (let i = 0; i < t.length; i++)
    u.push(t[i].toUpperCase());
  this.o = n, l && (this.defaultRender = l), this.ignoreTags = u;
}
_1.prototype = {
  o: Ls,
  /**
   * @type string[]
   */
  ignoreTags: [],
  /**
   * @param {IntermediateRepresentation} ir
   * @returns {any}
   */
  defaultRender(e) {
    return e;
  },
  /**
   * Returns true or false based on whether a token should be displayed as a
   * link based on the user options.
   * @param {MultiToken} token
   * @returns {boolean}
   */
  check(e) {
    return this.get("validate", e.toString(), e);
  },
  // Private methods
  /**
   * Resolve an option's value based on the value of the option and the given
   * params. If operator and token are specified and the target option is
   * callable, automatically calls the function with the given argument.
   * @template {keyof Opts} K
   * @param {K} key Name of option to use
   * @param {string} [operator] will be passed to the target option if it's a
   * function. If not specified, RAW function value gets returned
   * @param {MultiToken} [token] The token from linkify.tokenize
   * @returns {Opts[K] | any}
   */
  get(e, l, n) {
    const t = l != null;
    let u = this.o[e];
    return u && (typeof u == "object" ? (u = n.t in u ? u[n.t] : Ls[e], typeof u == "function" && t && (u = u(l, n))) : typeof u == "function" && t && (u = u(l, n.t, n)), u);
  },
  /**
   * @template {keyof Opts} L
   * @param {L} key Name of options object to use
   * @param {string} [operator]
   * @param {MultiToken} [token]
   * @returns {Opts[L] | any}
   */
  getObj(e, l, n) {
    let t = this.o[e];
    return typeof t == "function" && l != null && (t = t(l, n.t, n)), t;
  },
  /**
   * Convert the given token to a rendered element that may be added to the
   * calling-interface's DOM
   * @param {MultiToken} token Token to render to an HTML element
   * @returns {any} Render result; e.g., HTML string, DOM element, React
   *   Component, etc.
   */
  render(e) {
    const l = e.render(this);
    return (this.get("render", null, e) || this.defaultRender)(l, e.t, e);
  }
};
function Pg(e) {
  return e;
}
function Ay(e, l) {
  this.t = "token", this.v = e, this.tk = l;
}
Ay.prototype = {
  isLink: !1,
  /**
   * Return the string this token represents.
   * @return {string}
   */
  toString() {
    return this.v;
  },
  /**
   * What should the value for this token be in the `href` HTML attribute?
   * Returns the `.toString` value by default.
   * @param {string} [scheme]
   * @return {string}
  */
  toHref(e) {
    return this.toString();
  },
  /**
   * @param {Options} options Formatting options
   * @returns {string}
   */
  toFormattedString(e) {
    const l = this.toString(), n = e.get("truncate", l, this), t = e.get("format", l, this);
    return n && t.length > n ? t.substring(0, n) + "…" : t;
  },
  /**
   *
   * @param {Options} options
   * @returns {string}
   */
  toFormattedHref(e) {
    return e.get("formatHref", this.toHref(e.get("defaultProtocol")), this);
  },
  /**
   * The start index of this token in the original input string
   * @returns {number}
   */
  startIndex() {
    return this.tk[0].s;
  },
  /**
   * The end index of this token in the original input string (up to this
   * index but not including it)
   * @returns {number}
   */
  endIndex() {
    return this.tk[this.tk.length - 1].e;
  },
  /**
  	Returns an object  of relevant values for this token, which includes keys
  	* type - Kind of token ('url', 'email', etc.)
  	* value - Original text
  	* href - The value that should be added to the anchor tag's href
  		attribute
  		@method toObject
  	@param {string} [protocol] `'http'` by default
  */
  toObject(e) {
    return e === void 0 && (e = Ls.defaultProtocol), {
      type: this.t,
      value: this.toString(),
      isLink: this.isLink,
      href: this.toHref(e),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   *
   * @param {Options} options Formatting option
   */
  toFormattedObject(e) {
    return {
      type: this.t,
      value: this.toFormattedString(e),
      isLink: this.isLink,
      href: this.toFormattedHref(e),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   * Whether this token should be rendered as a link according to the given options
   * @param {Options} options
   * @returns {boolean}
   */
  validate(e) {
    return e.get("validate", this.toString(), this);
  },
  /**
   * Return an object that represents how this link should be rendered.
   * @param {Options} options Formattinng options
   */
  render(e) {
    const l = this, n = this.toHref(e.get("defaultProtocol")), t = e.get("formatHref", n, this), u = e.get("tagName", n, l), i = this.toFormattedString(e), s = {}, r = e.get("className", n, l), o = e.get("target", n, l), a = e.get("rel", n, l), d = e.getObj("attributes", n, l), h = e.getObj("events", n, l);
    return s.href = t, r && (s.class = r), o && (s.target = o), a && (s.rel = a), d && Ai(s, d), {
      tagName: u,
      attributes: s,
      content: i,
      eventListeners: h
    };
  }
};
function va(e, l) {
  class n extends Ay {
    constructor(u, i) {
      super(u, i), this.t = e;
    }
  }
  for (const t in l)
    n.prototype[t] = l[t];
  return n.t = e, n;
}
const Bg = va("email", {
  isLink: !0,
  toHref() {
    return "mailto:" + this.toString();
  }
}), Fg = va("text"), NN = va("nl"), pr = va("url", {
  isLink: !0,
  /**
  	Lowercases relevant parts of the domain and adds the protocol if
  	required. Note that this will not escape unsafe HTML characters in the
  	URL.
  		@param {string} [scheme] default scheme (e.g., 'https')
  	@return {string} the full href
  */
  toHref(e) {
    return e === void 0 && (e = Ls.defaultProtocol), this.hasProtocol() ? this.v : `${e}://${this.v}`;
  },
  /**
   * Check whether this URL token has a protocol
   * @return {boolean}
   */
  hasProtocol() {
    const e = this.tk;
    return e.length >= 2 && e[0].t !== Ns && e[1].t === Kt;
  }
}), pe = (e) => new Yn(e);
function LN(e) {
  let {
    groups: l
  } = e;
  const n = l.domain.concat([po, mo, Vt, go, vo, yo, $o, bo, Ze, g1, wo, _o, So, Co, Xe, ko, ds, Oo]), t = [fo, Kt, y1, Je, $1, To, b1, w1, eo, to, rs, as, Qr, Xr, lo, no, uo, io, so, ro, oo, ao, co, ho], u = [po, fo, mo, go, vo, yo, $o, bo, Ze, rs, as, wo, _o, So, Co, To, Xe, ko, ds, Oo], i = pe(), s = q(i, ds);
  Al(s, u, s), Al(s, l.domain, s);
  const r = pe(), o = pe(), a = pe();
  Al(i, l.domain, r), Al(i, l.scheme, o), Al(i, l.slashscheme, a), Al(r, u, s), Al(r, l.domain, r);
  const d = q(r, Vt);
  q(s, Vt, d), q(o, Vt, d), q(a, Vt, d);
  const h = q(s, Je);
  Al(h, u, s), Al(h, l.domain, s);
  const p = pe();
  Al(d, l.domain, p), Al(p, l.domain, p);
  const f = q(p, Je);
  Al(f, l.domain, p);
  const m = pe(Bg);
  Al(f, l.tld, m), Al(f, l.utld, m), q(d, Ns, m);
  const g = q(p, Ze);
  Al(g, l.domain, p), Al(m, l.domain, p), q(m, Je, f), q(m, Ze, g);
  const v = q(m, Kt);
  Al(v, l.numeric, Bg);
  const w = q(r, Ze), $ = q(r, Je);
  Al(w, l.domain, r), Al($, u, s), Al($, l.domain, r);
  const _ = pe(pr);
  Al($, l.tld, _), Al($, l.utld, _), Al(_, l.domain, r), Al(_, u, s), q(_, Je, $), q(_, Ze, w), q(_, Vt, d);
  const b = q(_, Kt), k = pe(pr);
  Al(b, l.numeric, k);
  const T = pe(pr), M = pe();
  Al(T, n, T), Al(T, t, M), Al(M, n, T), Al(M, t, M), q(_, Xe, T), q(k, Xe, T);
  const H = q(o, Kt), x = q(a, Kt), P = q(x, Xe), Z = q(P, Xe);
  Al(o, l.domain, r), q(o, Je, $), q(o, Ze, w), Al(a, l.domain, r), q(a, Je, $), q(a, Ze, w), Al(H, l.domain, T), q(H, Xe, T), Al(Z, l.domain, T), Al(Z, n, T), q(Z, Xe, T);
  const F = [
    [rs, as],
    // {}
    [Xr, Qr],
    // []
    [lo, no],
    // ()
    [eo, to],
    // <>
    [uo, io],
    // （）
    [so, ro],
    // 「」
    [oo, ao],
    // 『』
    [co, ho]
    // ＜＞
  ];
  for (let el = 0; el < F.length; el++) {
    const [al, ll] = F[el], Y = q(T, al);
    q(M, al, Y), q(Y, ll, T);
    const Q = pe(pr);
    Al(Y, n, Q);
    const dl = pe();
    Al(Y, t), Al(Q, n, Q), Al(Q, t, dl), Al(dl, n, Q), Al(dl, t, dl), q(Q, ll, T), q(dl, ll, T);
  }
  return q(i, Ns, _), q(i, v1, NN), {
    start: i,
    tokens: My
  };
}
function PN(e, l, n) {
  let t = n.length, u = 0, i = [], s = [];
  for (; u < t; ) {
    let r = e, o = null, a = null, d = 0, h = null, p = -1;
    for (; u < t && !(o = r.go(n[u].t)); )
      s.push(n[u++]);
    for (; u < t && (a = o || r.go(n[u].t)); )
      o = null, r = a, r.accepts() ? (p = 0, h = r) : p >= 0 && p++, u++, d++;
    if (p < 0)
      u -= d, u < t && (s.push(n[u]), u++);
    else {
      s.length > 0 && (i.push(Wd(Fg, l, s)), s = []), u -= p, d -= p;
      const f = h.t, m = n.slice(u - d, u);
      i.push(Wd(f, l, m));
    }
  }
  return s.length > 0 && i.push(Wd(Fg, l, s)), i;
}
function Wd(e, l, n) {
  const t = n[0].s, u = n[n.length - 1].e, i = l.slice(t, u);
  return new e(i, n);
}
const BN = typeof console < "u" && console && console.warn || (() => {
}), FN = "until manual call of linkify.init(). Register all schemes and plugins before invoking linkify the first time.", Zl = {
  scanner: null,
  parser: null,
  tokenQueue: [],
  pluginQueue: [],
  customSchemes: [],
  initialized: !1
};
function HN() {
  Yn.groups = {}, Zl.scanner = null, Zl.parser = null, Zl.tokenQueue = [], Zl.pluginQueue = [], Zl.customSchemes = [], Zl.initialized = !1;
}
function Hg(e, l) {
  if (l === void 0 && (l = !1), Zl.initialized && BN(`linkifyjs: already initialized - will not register custom scheme "${e}" ${FN}`), !/^[0-9a-z]+(-[0-9a-z]+)*$/.test(e))
    throw new Error(`linkifyjs: incorrect scheme format.
1. Must only contain digits, lowercase ASCII letters or "-"
2. Cannot start or end with "-"
3. "-" cannot repeat`);
  Zl.customSchemes.push([e, l]);
}
function zN() {
  Zl.scanner = IN(Zl.customSchemes);
  for (let e = 0; e < Zl.tokenQueue.length; e++)
    Zl.tokenQueue[e][1]({
      scanner: Zl.scanner
    });
  Zl.parser = LN(Zl.scanner.tokens);
  for (let e = 0; e < Zl.pluginQueue.length; e++)
    Zl.pluginQueue[e][1]({
      scanner: Zl.scanner,
      parser: Zl.parser
    });
  Zl.initialized = !0;
}
function VN(e) {
  return Zl.initialized || zN(), PN(Zl.parser.start, e, RN(Zl.scanner.start, e));
}
function S1(e, l, n) {
  if (l === void 0 && (l = null), n === void 0 && (n = null), l && typeof l == "object") {
    if (n)
      throw Error(`linkifyjs: Invalid link type ${l}; must be a string`);
    n = l, l = null;
  }
  const t = new _1(n), u = VN(e), i = [];
  for (let s = 0; s < u.length; s++) {
    const r = u[s];
    r.isLink && (!l || r.t === l) && t.check(r) && i.push(r.toFormattedObject(t));
  }
  return i;
}
function jN(e) {
  return new On({
    key: new se("autolink"),
    appendTransaction: (l, n, t) => {
      const u = l.some((a) => a.docChanged) && !n.doc.eq(t.doc), i = l.some((a) => a.getMeta("preventAutolink"));
      if (!u || i)
        return;
      const { tr: s } = t, r = KE(n.doc, [...l]);
      if (eI(r).forEach(({ newRange: a }) => {
        const d = qE(t.doc, a, (f) => f.isTextblock);
        let h, p;
        if (d.length > 1 ? (h = d[0], p = t.doc.textBetween(h.pos, h.pos + h.node.nodeSize, void 0, " ")) : d.length && t.doc.textBetween(a.from, a.to, " ", " ").endsWith(" ") && (h = d[0], p = t.doc.textBetween(h.pos, a.to, void 0, " ")), h && p) {
          const f = p.split(" ").filter((v) => v !== "");
          if (f.length <= 0)
            return !1;
          const m = f[f.length - 1], g = h.pos + p.lastIndexOf(m);
          if (!m)
            return !1;
          S1(m).filter((v) => v.isLink).map((v) => ({
            ...v,
            from: g + v.start + 1,
            to: g + v.end + 1
          })).filter((v) => t.schema.marks.code ? !t.doc.rangeHasMark(v.from, v.to, t.schema.marks.code) : !0).filter((v) => e.validate ? e.validate(v.value) : !0).forEach((v) => {
            s1(v.from, v.to, t.doc).some((w) => w.mark.type === e.type) || s.addMark(v.from, v.to, e.type.create({
              href: v.href
            }));
          });
        }
      }), !!s.steps.length)
        return s;
    }
  });
}
function UN(e) {
  return new On({
    key: new se("handleClickLink"),
    props: {
      handleClick: (l, n, t) => {
        var u, i;
        if (t.button !== 0)
          return !1;
        let s = t.target;
        const r = [];
        for (; s.nodeName !== "DIV"; )
          r.push(s), s = s.parentNode;
        if (!r.find((p) => p.nodeName === "A"))
          return !1;
        const o = q4(l.state, e.type.name), a = t.target, d = (u = a == null ? void 0 : a.href) !== null && u !== void 0 ? u : o.href, h = (i = a == null ? void 0 : a.target) !== null && i !== void 0 ? i : o.target;
        return a && d ? (window.open(d, h), !0) : !1;
      }
    }
  });
}
function WN(e) {
  return new On({
    key: new se("handlePasteLink"),
    props: {
      handlePaste: (l, n, t) => {
        const { state: u } = l, { selection: i } = u, { empty: s } = i;
        if (s)
          return !1;
        let r = "";
        t.content.forEach((a) => {
          r += a.textContent;
        });
        const o = S1(r).find((a) => a.isLink && a.value === r);
        return !r || !o ? !1 : (e.editor.commands.setMark(e.type, {
          href: o.href
        }), !0);
      }
    }
  });
}
const GN = ue.create({
  name: "link",
  priority: 1e3,
  keepOnSplit: !1,
  onCreate() {
    this.options.protocols.forEach((e) => {
      if (typeof e == "string") {
        Hg(e);
        return;
      }
      Hg(e.scheme, e.optionalSlashes);
    });
  },
  onDestroy() {
    HN();
  },
  inclusive() {
    return this.options.autolink;
  },
  addOptions() {
    return {
      openOnClick: !0,
      linkOnPaste: !0,
      autolink: !0,
      protocols: [],
      HTMLAttributes: {
        target: "_blank",
        rel: "noopener noreferrer nofollow",
        class: null
      },
      validate: void 0
    };
  },
  addAttributes() {
    return {
      href: {
        default: null
      },
      target: {
        default: this.options.HTMLAttributes.target
      },
      rel: {
        default: this.options.HTMLAttributes.rel
      },
      class: {
        default: this.options.HTMLAttributes.class
      }
    };
  },
  parseHTML() {
    return [{ tag: 'a[href]:not([href *= "javascript:" i])' }];
  },
  renderHTML({ HTMLAttributes: e }) {
    var l;
    return !((l = e.href) === null || l === void 0) && l.startsWith("javascript:") ? ["a", ql(this.options.HTMLAttributes, { ...e, href: "" }), 0] : ["a", ql(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setLink: (e) => ({ chain: l }) => l().setMark(this.name, e).setMeta("preventAutolink", !0).run(),
      toggleLink: (e) => ({ chain: l }) => l().toggleMark(this.name, e, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run(),
      unsetLink: () => ({ chain: e }) => e().unsetMark(this.name, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run()
    };
  },
  addPasteRules() {
    return [
      Fu({
        find: (e, l) => {
          var n;
          const t = (n = l == null ? void 0 : l.clipboardData) === null || n === void 0 ? void 0 : n.getData("text/html"), u = [];
          if (t) {
            const i = new DOMParser().parseFromString(t, "text/html"), s = i.querySelectorAll("a");
            s.length && [...s].forEach((r) => u.push({
              text: r.innerText,
              data: {
                href: r.getAttribute("href")
              },
              // get the index of the anchor inside the text
              // and add the length of the anchor text
              index: i.body.innerText.indexOf(r.innerText) + r.innerText.length
            }));
          }
          if (e) {
            const i = S1(e).filter((s) => s.isLink);
            i.length && i.forEach((s) => u.push({
              text: s.value,
              data: {
                href: s.href
              },
              index: s.start
            }));
          }
          return u;
        },
        type: this.type,
        getAttributes: (e) => {
          var l;
          return {
            href: (l = e.data) === null || l === void 0 ? void 0 : l.href
          };
        }
      })
    ];
  },
  addProseMirrorPlugins() {
    const e = [];
    return this.options.autolink && e.push(jN({
      type: this.type,
      validate: this.options.validate
    })), this.options.openOnClick && e.push(UN({
      type: this.type
    })), this.options.linkOnPaste && e.push(WN({
      editor: this.editor,
      type: this.type
    })), e;
  }
}), KN = mn.create({
  name: "color",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          color: {
            default: null,
            parseHTML: (e) => {
              var l;
              return (l = e.style.color) === null || l === void 0 ? void 0 : l.replace(/['"]+/g, "");
            },
            renderHTML: (e) => e.color ? {
              style: `color: ${e.color}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setColor: (e) => ({ chain: l }) => l().setMark("textStyle", { color: e }).run(),
      unsetColor: () => ({ chain: e }) => e().setMark("textStyle", { color: null }).removeEmptyTextStyle().run()
    };
  }
}), YN = /^(https?:\/\/)?(www\.|music\.)?(youtube\.com|youtu\.be)\/(?!channel\/)(?!@)(.+)?$/, qN = /^(https?:\/\/)?(www\.|music\.)?(youtube\.com|youtu\.be)\/(?!channel\/)(?!@)(.+)?$/g, xy = (e) => e.match(YN), zg = (e) => e ? "https://www.youtube-nocookie.com/embed/" : "https://www.youtube.com/embed/", JN = (e) => {
  const { url: l, allowFullscreen: n, autoplay: t, ccLanguage: u, ccLoadPolicy: i, controls: s, disableKBcontrols: r, enableIFrameApi: o, endTime: a, interfaceLanguage: d, ivLoadPolicy: h, loop: p, modestBranding: f, nocookie: m, origin: g, playlist: v, progressBarColor: w, startAt: $ } = e;
  if (!xy(l))
    return null;
  if (l.includes("/embed/"))
    return l;
  if (l.includes("youtu.be")) {
    const M = l.split("/").pop();
    return M ? `${zg(m)}${M}` : null;
  }
  const b = /(?:v=|shorts\/)([-\w]+)/gm.exec(l);
  if (!b || !b[1])
    return null;
  let k = `${zg(m)}${b[1]}`;
  const T = [];
  return n === !1 && T.push("fs=0"), t && T.push("autoplay=1"), u && T.push(`cc_lang_pref=${u}`), i && T.push("cc_load_policy=1"), s || T.push("controls=0"), r && T.push("disablekb=1"), o && T.push("enablejsapi=1"), a && T.push(`end=${a}`), d && T.push(`hl=${d}`), h && T.push(`iv_load_policy=${h}`), p && T.push("loop=1"), f && T.push("modestbranding=1"), g && T.push(`origin=${g}`), v && T.push(`playlist=${v}`), $ && T.push(`start=${$}`), w && T.push(`color=${w}`), T.length && (k += `?${T.join("&")}`), k;
}, ZN = gn.create({
  name: "youtube",
  addOptions() {
    return {
      addPasteHandler: !0,
      allowFullscreen: !0,
      autoplay: !1,
      ccLanguage: void 0,
      ccLoadPolicy: void 0,
      controls: !0,
      disableKBcontrols: !1,
      enableIFrameApi: !1,
      endTime: 0,
      height: 480,
      interfaceLanguage: void 0,
      ivLoadPolicy: 0,
      loop: !1,
      modestBranding: !1,
      HTMLAttributes: {},
      inline: !1,
      nocookie: !1,
      origin: "",
      playlist: "",
      progressBarColor: void 0,
      width: 640
    };
  },
  inline() {
    return this.options.inline;
  },
  group() {
    return this.options.inline ? "inline" : "block";
  },
  draggable: !0,
  addAttributes() {
    return {
      src: {
        default: null
      },
      start: {
        default: 0
      },
      width: {
        default: this.options.width
      },
      height: {
        default: this.options.height
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "div[data-youtube-video] iframe"
      }
    ];
  },
  addCommands() {
    return {
      setYoutubeVideo: (e) => ({ commands: l }) => xy(e.src) ? l.insertContent({
        type: this.name,
        attrs: e
      }) : !1
    };
  },
  addPasteRules() {
    return this.options.addPasteHandler ? [
      NI({
        find: qN,
        type: this.type,
        getAttributes: (e) => ({ src: e.input })
      })
    ] : [];
  },
  renderHTML({ HTMLAttributes: e }) {
    const l = JN({
      url: e.src,
      allowFullscreen: this.options.allowFullscreen,
      autoplay: this.options.autoplay,
      ccLanguage: this.options.ccLanguage,
      ccLoadPolicy: this.options.ccLoadPolicy,
      controls: this.options.controls,
      disableKBcontrols: this.options.disableKBcontrols,
      enableIFrameApi: this.options.enableIFrameApi,
      endTime: this.options.endTime,
      interfaceLanguage: this.options.interfaceLanguage,
      ivLoadPolicy: this.options.ivLoadPolicy,
      loop: this.options.loop,
      modestBranding: this.options.modestBranding,
      nocookie: this.options.nocookie,
      origin: this.options.origin,
      playlist: this.options.playlist,
      progressBarColor: this.options.progressBarColor,
      startAt: e.start || 0
    });
    return e.src = l, [
      "div",
      { "data-youtube-video": "" },
      [
        "iframe",
        ql(this.options.HTMLAttributes, {
          width: this.options.width,
          height: this.options.height,
          allowfullscreen: this.options.allowFullscreen,
          autoplay: this.options.autoplay,
          ccLanguage: this.options.ccLanguage,
          ccLoadPolicy: this.options.ccLoadPolicy,
          disableKBcontrols: this.options.disableKBcontrols,
          enableIFrameApi: this.options.enableIFrameApi,
          endTime: this.options.endTime,
          interfaceLanguage: this.options.interfaceLanguage,
          ivLoadPolicy: this.options.ivLoadPolicy,
          loop: this.options.loop,
          modestBranding: this.options.modestBranding,
          origin: this.options.origin,
          playlist: this.options.playlist,
          progressBarColor: this.options.progressBarColor
        }, e)
      ]
    ];
  }
}), XN = mn.create({
  name: "background",
  addOptions: () => ({
    types: ["textStyle"]
  }),
  addGlobalAttributes() {
    return [{
      types: this.options.types,
      attributes: {
        background: {
          default: null,
          renderHTML: (e) => e.background ? {
            style: `background: ${e.background}`
          } : {},
          parseHTML: (e) => e.style.background
        }
      }
    }];
  },
  addCommands() {
    return {
      setTextBackground: (e) => ({
        chain: l
      }) => l().setMark("textStyle", {
        background: e
      }).run(),
      getTextBackground: () => () => this.editor.getAttributes("textStyle").background ?? "",
      unsetTextBackground: () => ({
        chain: e
      }) => e().setMark("textStyle", {
        background: null
      }).removeEmptyTextStyle().run()
    };
  }
});
class ap extends Gl {
  constructor(n, t) {
    super(n, t);
    S(this, "state", fl({
      ...this.sharedState,
      image: []
    }));
    S(this, "editor", $D({
      content: this.vModel,
      extensions: [yN, $N, SN.configure({
        allowBase64: !0
      }), GN.configure({
        openOnClick: !1
      }), bN.configure({
        types: ["heading", "paragraph"]
      }), KN.configure({
        types: ["textStyle"]
      }), wN, XN, ZN],
      onCreate: ({
        editor: n
      }) => {
        !this.sanitizeHtml(this.vModel).length && this.vModelJson && n.commands.setContent(this.vModelJson, !0);
      },
      onFocus: () => {
        this.state.isFocus = !0, this.state.hasBeenFocus = !0;
      },
      onBlur: () => {
        this.state.isFocus = !1;
      },
      onUpdate: ({
        editor: n
      }) => {
        this.vModel = n.getHTML(), this.vModelJson = n.getJSON();
      }
    }));
    this.emit = t;
  }
  get hasValue() {
    return this.sanitizeHtml(this.vModel).length > 0;
  }
  get vModelJson() {
    return this.props.json;
  }
  set vModelJson(n) {
    this.emit("update:json", n);
  }
  sanitizeHtml(n) {
    return (n == null ? void 0 : n.replace(/<[^>]+>/g, "").trim()) ?? "";
  }
  async setLinkAsync() {
    var u;
    const {
      value: n,
      confirm: t
    } = await Zs({
      title: this.lang.ORION_EDITOR__LINK_URL
    });
    t && n && ((u = this.editor.value) == null || u.chain().focus().setLink({
      href: n
    }).run());
  }
  async promptImageAsync() {
    var u;
    const {
      confirm: n,
      value: t
    } = await Zs({
      title: this.lang.ORION_EDITOR__ADD_PICTURE,
      prompt: {
        type: "upload",
        value: this.state.image,
        fieldProps: {
          fileMaxSize: this.props.imgMaxSize / 1e3,
          fileTypes: this.props.imgFileTypes
        }
      }
    });
    if (n && (t != null && t.length))
      try {
        const i = await this.imageToBase64(t[0]);
        i && ((u = this.editor.value) == null || u.chain().focus().setImage({
          src: i
        }).run()), this.state.image.length = 0;
      } catch (i) {
        Dr.danger(i);
      }
  }
  imageToBase64(n) {
    return new Promise((t, u) => {
      if (this.props.imgMaxSize && n.size / 1e3 > this.props.imgMaxSize) {
        u(this.lang.ORION_EDITOR__PICTURE_TOO_HEAVY.replace("$fileName", n.name).replace("$imgMaxSize", this.props.imgMaxSize.toString()));
        return;
      }
      const i = new FileReader();
      i.addEventListener("load", () => {
        t(i.result);
      }, !1), i.readAsDataURL(n);
    });
  }
  async promptImageUrlAsync() {
    var u;
    const {
      confirm: n,
      value: t
    } = await Zs({
      title: this.lang.ORION_EDITOR__ADD_PICTURE,
      prompt: {
        fieldProps: {
          label: this.lang.ORION_EDITOR__ADD_PICTURE_LABEL
        }
      }
    });
    n && (t != null && t.length) && ((u = this.editor.value) == null || u.chain().focus().setImage({
      src: t
    }).run());
  }
  async promptYouTubeAsync() {
    var u;
    const {
      confirm: n,
      value: t
    } = await Zs({
      title: this.lang.ORION_EDITOR__YOUTUBE,
      prompt: {
        fieldProps: {
          label: this.lang.ORION_EDITOR__ADD_YOUTUBE_LABEL
        }
      }
    });
    n && (t != null && t.length) && ((u = this.editor.value) == null || u.chain().focus().setYoutubeVideo({
      src: t
    }).run());
  }
}
S(ap, "props", {
  ...Gl.props,
  // @doc props/json the json format of the editor value
  // @doc/fr props/json valeur de l'éditeur au format JSON
  json: {
    type: Object,
    default: void 0
  },
  // @doc props/placeholder place holder
  // @doc/fr props/placeholder placeholder
  placeholder: {
    type: String,
    default: void 0
  },
  // @doc props/disableFeatures disable some editor's features
  // @doc/fr props/disableFeatures désactive des fonctions de l'éditeur
  disableFeatures: {
    type: Array,
    default: () => []
  },
  // @doc props/imgMaxSize maximum size of the imported image
  // @doc/fr props/imgMaxSize taille maximum d'une image importée
  imgMaxSize: {
    type: Number,
    default: 1500
  },
  // @doc props/imgFileTypes authorized image file formats
  // @doc/fr props/imgFileTypes type de fichier autorisé pour les images
  imgFileTypes: {
    type: Array,
    default: () => ["image/jpeg", "image/png", "image/gif"]
  }
});
const QN = {
  class: "orion-editor__toolbar"
}, lL = /* @__PURE__ */ K({
  __name: "OrionEditor",
  props: ap.props,
  emits: ["focus", "blur", "input", "change", "update:modelValue", "clear", "update:json"],
  setup(e, {
    expose: l,
    emit: n
  }) {
    const t = n, u = e, i = new ap(u, t);
    return l(i.publicInstance), (s, r) => {
      const o = Bl("v-dropdown"), a = Ei("tooltip");
      return c(i).editor.value ? (y(), O("div", {
        key: 0,
        class: z(["orion-editor", {
          "orion-editor--error": c(i).showError,
          "orion-editor--warning": c(i).showWarning,
          "orion-editor--success": c(i).showSuccess,
          "orion-editor--focused": c(i).isFocus
        }])
      }, [A("div", QN, [s.disableFeatures.includes("Undo") ? I("", !0) : vl((y(), L(c(bl), {
        key: 0,
        size: "sm",
        "prefix-icon": "undo",
        onClick: r[0] || (r[0] = (d) => {
          var h;
          return (h = c(i).editor.value) == null ? void 0 : h.chain().focus().undo().run();
        })
      }, null, 512)), [[a, c(i).lang.UNDO]]), s.disableFeatures.includes("Redo") ? I("", !0) : vl((y(), L(c(bl), {
        key: 1,
        size: "sm",
        "prefix-icon": "redo",
        onClick: r[1] || (r[1] = (d) => {
          var h;
          return (h = c(i).editor.value) == null ? void 0 : h.chain().focus().redo().run();
        })
      }, null, 512)), [[a, c(i).lang.REDO]]), s.disableFeatures.includes("FontSize") ? I("", !0) : (y(), L(o, {
        key: 2,
        theme: "orion-editor-toolbar"
      }, {
        popper: U(() => [R(c(bl), {
          size: "xs",
          class: z({
            active: c(i).editor.value.isActive("heading", {
              level: 1
            })
          }),
          onClick: r[2] || (r[2] = (d) => {
            var h;
            return (h = c(i).editor.value) == null ? void 0 : h.chain().focus().toggleHeading({
              level: 1
            }).run();
          })
        }, {
          default: U(() => [$l(B(c(i).lang.ORION_EDITOR__TITLE_1), 1)]),
          _: 1
        }, 8, ["class"]), R(c(bl), {
          size: "xs",
          class: z({
            active: c(i).editor.value.isActive("heading", {
              level: 2
            })
          }),
          onClick: r[3] || (r[3] = (d) => {
            var h;
            return (h = c(i).editor.value) == null ? void 0 : h.chain().focus().toggleHeading({
              level: 2
            }).run();
          })
        }, {
          default: U(() => [$l(B(c(i).lang.ORION_EDITOR__TITLE_2), 1)]),
          _: 1
        }, 8, ["class"]), R(c(bl), {
          size: "xs",
          class: z({
            active: c(i).editor.value.isActive("heading", {
              level: 3
            })
          }),
          onClick: r[4] || (r[4] = (d) => {
            var h;
            return (h = c(i).editor.value) == null ? void 0 : h.chain().focus().toggleHeading({
              level: 3
            }).run();
          })
        }, {
          default: U(() => [$l(B(c(i).lang.ORION_EDITOR__TITLE_3), 1)]),
          _: 1
        }, 8, ["class"]), R(c(bl), {
          size: "xs",
          class: z({
            active: c(i).editor.value.isActive("paragraph")
          }),
          onClick: r[5] || (r[5] = (d) => {
            var h;
            return (h = c(i).editor.value) == null ? void 0 : h.chain().focus().setParagraph().run();
          })
        }, {
          default: U(() => [$l(B(c(i).lang.ORION_EDITOR__REGULAR_TEXT), 1)]),
          _: 1
        }, 8, ["class"])]),
        default: U(() => [vl(R(c(bl), {
          size: "sm",
          "prefix-icon": "font"
        }, null, 512), [[a, c(i).lang.ORION_EDITOR__FONT_SIZE]])]),
        _: 1
      })), s.disableFeatures.includes("TextColor") ? I("", !0) : (y(), L(o, {
        key: 3,
        theme: "orion-editor-toolbar"
      }, {
        popper: U(() => {
          var d;
          return [R(c(fh), {
            "hide-rgba": "",
            "start-value": (d = c(i).editor.value) == null ? void 0 : d.getAttributes("textStyle").color,
            onPicked: r[6] || (r[6] = (h) => {
              var p;
              return (p = c(i).editor.value) == null ? void 0 : p.commands.setColor(h == null ? void 0 : h.hex);
            })
          }, null, 8, ["start-value"]), R(c(bl), {
            style: {
              border: "none"
            },
            size: "xs",
            block: "",
            nude: "",
            onClick: r[7] || (r[7] = (h) => {
              var p;
              return (p = c(i).editor.value) == null ? void 0 : p.commands.unsetColor();
            })
          }, {
            default: U(() => [$l(B(c(i).lang.RESET), 1)]),
            _: 1
          })];
        }),
        default: U(() => [vl(R(c(bl), {
          size: "sm",
          "prefix-icon": "swatches_palette",
          class: z({
            active: c(i).editor.value.isActive("textColor")
          })
        }, null, 8, ["class"]), [[a, c(i).lang.ORION_EDITOR__TEXT_COLOR]])]),
        _: 1
      })), s.disableFeatures.includes("BackgroundColor") ? I("", !0) : (y(), L(o, {
        key: 4,
        theme: "orion-editor-toolbar"
      }, {
        popper: U(() => {
          var d;
          return [R(c(fh), {
            "hide-rgba": "",
            "start-value": (d = c(i).editor.value) == null ? void 0 : d.commands.getTextBackground(),
            onPicked: r[8] || (r[8] = (h) => {
              var p;
              return (p = c(i).editor.value) == null ? void 0 : p.commands.setTextBackground(h == null ? void 0 : h.hex);
            })
          }, null, 8, ["start-value"]), R(c(bl), {
            style: {
              border: "none"
            },
            size: "xs",
            block: "",
            nude: "",
            onBlur: r[9] || (r[9] = kl(() => {
            }, ["stop"])),
            onClick: r[10] || (r[10] = (h) => {
              var p;
              return (p = c(i).editor.value) == null ? void 0 : p.commands.unsetTextBackground();
            })
          }, {
            default: U(() => [$l(B(c(i).lang.RESET), 1)]),
            _: 1
          })];
        }),
        default: U(() => [vl(R(c(bl), {
          size: "sm",
          "prefix-icon": "rainbow",
          class: z({
            active: c(i).editor.value.isActive("textBackground")
          })
        }, null, 8, ["class"]), [[a, c(i).lang.ORION_EDITOR__BACKGROUND_COLOR]])]),
        _: 1
      })), s.disableFeatures.includes("Bold") ? I("", !0) : vl((y(), L(c(bl), {
        key: 5,
        size: "sm",
        "prefix-icon": "bold",
        class: z({
          active: c(i).editor.value.isActive("bold")
        }),
        onClick: r[11] || (r[11] = (d) => {
          var h;
          return (h = c(i).editor.value) == null ? void 0 : h.chain().focus().toggleBold().run();
        })
      }, null, 8, ["class"])), [[a, c(i).lang.ORION_EDITOR__BOLD]]), s.disableFeatures.includes("Italic") ? I("", !0) : vl((y(), L(c(bl), {
        key: 6,
        size: "sm",
        "prefix-icon": "italic",
        class: z({
          active: c(i).editor.value.isActive("italic")
        }),
        onClick: r[12] || (r[12] = (d) => {
          var h;
          return (h = c(i).editor.value) == null ? void 0 : h.chain().focus().toggleItalic().run();
        })
      }, null, 8, ["class"])), [[a, c(i).lang.ORION_EDITOR__ITALIC]]), s.disableFeatures.includes("Underline") ? I("", !0) : vl((y(), L(c(bl), {
        key: 7,
        size: "sm",
        "prefix-icon": "underline",
        class: z({
          active: c(i).editor.value.isActive("underline")
        }),
        onClick: r[13] || (r[13] = (d) => {
          var h;
          return (h = c(i).editor.value) == null ? void 0 : h.chain().focus().toggleUnderline().run();
        })
      }, null, 8, ["class"])), [[a, c(i).lang.ORION_EDITOR__UNDERLINE]]), s.disableFeatures.includes("TextAlign") ? I("", !0) : (y(), L(o, {
        key: 8,
        theme: "orion-editor-toolbar"
      }, {
        popper: U(() => [R(c(bl), {
          size: "xs",
          class: z({
            active: c(i).editor.value.isActive({
              textAlign: "left"
            })
          }),
          onClick: r[14] || (r[14] = (d) => {
            var h;
            return (h = c(i).editor.value) == null ? void 0 : h.chain().focus().setTextAlign("left").run();
          })
        }, {
          default: U(() => [$l(B(c(i).lang.ORION_EDITOR__ALIGN_LEFT), 1)]),
          _: 1
        }, 8, ["class"]), R(c(bl), {
          size: "xs",
          class: z({
            active: c(i).editor.value.isActive({
              textAlign: "center"
            })
          }),
          onClick: r[15] || (r[15] = (d) => {
            var h;
            return (h = c(i).editor.value) == null ? void 0 : h.chain().focus().setTextAlign("center").run();
          })
        }, {
          default: U(() => [$l(B(c(i).lang.ORION_EDITOR__ALIGN_CENTER), 1)]),
          _: 1
        }, 8, ["class"]), R(c(bl), {
          size: "xs",
          class: z({
            active: c(i).editor.value.isActive({
              textAlign: "right"
            })
          }),
          onClick: r[16] || (r[16] = (d) => {
            var h;
            return (h = c(i).editor.value) == null ? void 0 : h.chain().focus().setTextAlign("right").run();
          })
        }, {
          default: U(() => [$l(B(c(i).lang.ORION_EDITOR__ALIGN_RIGHT), 1)]),
          _: 1
        }, 8, ["class"])]),
        default: U(() => [vl(R(c(bl), {
          size: "sm",
          "prefix-icon": "text_align_center"
        }, null, 512), [[a, c(i).lang.ORION_EDITOR__ALIGN]])]),
        _: 1
      })), s.disableFeatures.includes("BulletList") ? I("", !0) : vl((y(), L(c(bl), {
        key: 9,
        size: "sm",
        "prefix-icon": "list_unordered",
        class: z({
          active: c(i).editor.value.isActive("bulletList")
        }),
        onClick: r[17] || (r[17] = (d) => {
          var h;
          return (h = c(i).editor.value) == null ? void 0 : h.chain().focus().toggleBulletList().run();
        })
      }, null, 8, ["class"])), [[a, c(i).lang.ORION_EDITOR__UNORDERED_LIST]]), s.disableFeatures.includes("Link") ? I("", !0) : vl((y(), L(c(bl), {
        key: 10,
        size: "sm",
        "prefix-icon": "link",
        class: z({
          active: c(i).editor.value.isActive("link")
        }),
        onClick: r[18] || (r[18] = (d) => c(i).setLinkAsync())
      }, null, 8, ["class"])), [[a, c(i).lang.ORION_EDITOR__LINK]]), !s.disableFeatures.includes("Link") && c(i).editor.value.isActive("link") ? vl((y(), L(c(bl), {
        key: 11,
        size: "sm",
        "prefix-icon": "link_break",
        onClick: r[19] || (r[19] = (d) => {
          var h;
          return (h = c(i).editor.value) == null ? void 0 : h.chain().focus().unsetLink().run();
        })
      }, null, 512)), [[a, c(i).lang.ORION_EDITOR__UNLINK]]) : I("", !0), s.disableFeatures.includes("ImageUrl") ? I("", !0) : vl((y(), L(c(bl), {
        key: 12,
        size: "sm",
        "prefix-icon": "image_01",
        onClick: r[20] || (r[20] = (d) => c(i).promptImageUrlAsync())
      }, null, 512)), [[a, c(i).lang.ORION_EDITOR__PICTURE_URL]]), s.disableFeatures.includes("ImageBase64") ? I("", !0) : vl((y(), L(c(bl), {
        key: 13,
        size: "sm",
        "prefix-icon": "camera",
        onClick: r[21] || (r[21] = (d) => c(i).promptImageAsync())
      }, null, 512)), [[a, c(i).lang.ORION_EDITOR__PICTURE]]), s.disableFeatures.includes("YouTube") ? I("", !0) : vl((y(), L(c(bl), {
        key: 14,
        size: "sm",
        "prefix-icon": "play",
        onClick: r[22] || (r[22] = (d) => c(i).promptYouTubeAsync())
      }, null, 512)), [[a, c(i).lang.ORION_EDITOR__YOUTUBE]])]), R(c(yD), {
        ref: c(i)._input,
        class: "orion-editor__content",
        editor: c(i).editor.value
      }, null, 8, ["editor"])], 2)) : I("", !0);
    };
  }
}), Gd = {
  install(e, l = "o") {
    e.component(`${tl(l)}Editor`, lL);
  }
};
class dp extends gl {
  constructor(l) {
    super(l), Pl(() => this.props.visible, (n) => {
      n ? document.body.classList.add("orion-body--footer-fixed-visible") : document.body.classList.remove("orion-body--footer-fixed-visible");
    });
  }
  onMounted() {
    this.props.visible && document.body.classList.add("orion-body--footer-fixed-visible");
  }
  onUnmounted() {
    document.body.classList.remove("orion-body--footer-fixed-visible");
  }
  get withNavItems() {
    var l;
    return !!((l = this.document) != null && l.getElementsByClassName("orion-nav-tabs").length);
  }
}
S(dp, "props", {
  // @doc props/visible if set, displays the footer
  // @doc/fr props/visible si défini, affiche le composant
  visible: Boolean,
  // @doc props/title title of the footer
  // @doc props/title titre du pied de page
  title: {
    type: String,
    default: void 0
  }
});
const nL = {
  key: 0,
  class: "orion-footer-fixed__title"
}, Ey = /* @__PURE__ */ K({
  __name: "OrionFooterFixed",
  props: dp.props,
  setup(e, {
    expose: l
  }) {
    const n = e, t = new dp(n);
    return l(t.publicInstance), (u, i) => (y(), O("footer", {
      class: z(["orion-footer-fixed", [{
        "orion-footer-fixed--visible": c(t).props.visible
      }, {
        "orion-footer-fixed--without-nav": !c(t).withNavItems
      }]])
    }, [c(t).props.title ? (y(), O("h4", nL, B(c(t).props.title), 1)) : I("", !0), A("div", null, [V(u.$slots, "default")])], 2));
  }
}), Kd = {
  install(e, l = "o") {
    e.component(`${tl(l)}FooterFixed`, Ey);
  }
};
class cp extends gl {
  constructor(n) {
    super(n);
    S(this, "_el", J());
    S(this, "_slider", J());
    S(this, "_previewContainer", J());
    S(this, "_previewValues", J([]));
    S(this, "dnd", Cf());
    S(this, "throttledHandleScrollWhileDragging", ws(() => this.handleScrollWhileDragging(), 100));
    S(this, "debouncedObserverCallback", Be(() => this.setShadows(), 17));
    S(this, "state", fl({
      mutationObserver: null,
      resizeObserver: null,
      width: 0,
      sliderScrollWidth: 0,
      showLeftShadow: !1,
      showRightShadow: !1,
      dragScrollRight: 0,
      dragScrollLeft: 0,
      dragScrollTop: 0,
      dragScrollBottom: 0,
      dragInterval: null,
      elements: [],
      pourcentage: 0,
      visibilityValues: [],
      useNaturalScroll: !1
    }));
    S(this, "windowResizeHandler", Be(async () => {
      this.getElementInPreviewSize(), this.getVisibility();
    }, 17));
    S(this, "handleScrollEnd", Be(() => this.state.useNaturalScroll = !1, 100));
    S(this, "handleWheel", ws((n) => {
      this.state.useNaturalScroll || this._el.value !== void 0 && this._slider.value && (this.state.width - this.state.sliderScrollWidth >= 0 || (this._el.value.scrollHeight <= this._el.value.offsetHeight && (this._slider.value.scrollLeft += n.deltaY + n.deltaX, n.preventDefault()), this.handleShadows(), this.getVisibility()));
    }, 8, {
      leading: !1
    }));
    xi(async () => {
      var t;
      this.setShadows(), this.state.mutationObserver = new MutationObserver(this.debouncedObserverCallback), this.state.mutationObserver.observe(this._el.value, {
        childList: !0,
        subtree: !0,
        attributeFilter: ["class", "id", "style"]
      }), this.state.resizeObserver = new ResizeObserver(this.debouncedObserverCallback), this.state.resizeObserver.observe(this._el.value), rl(() => this.getElements()), this.getElementInPreviewSize(), setTimeout(() => this.getVisibility(), 200), (t = this.window) == null || t.addEventListener("resize", this.debouncedWindowResizeHandler.bind(this));
    }), Ao(() => {
      var t;
      (t = this.window) == null || t.removeEventListener("resize", this.debouncedWindowResizeHandler.bind(this));
    }), Pl(() => this.state.dragScrollRight, () => {
      this.throttledHandleScrollWhileDragging();
    }), Pl(() => this.state.dragScrollLeft, () => {
      this.throttledHandleScrollWhileDragging();
    }), Pl(() => this.state.dragScrollTop, () => {
      this.throttledHandleScrollWhileDragging();
    }), Pl(() => this.state.dragScrollBottom, () => {
      this.throttledHandleScrollWhileDragging();
    });
  }
  get shadowColor() {
    return this.props.shadowColor;
  }
  get dropShadow() {
    return this.props.dropShadow;
  }
  get showLeftShadow() {
    return this.state.showLeftShadow;
  }
  get showRightShadow() {
    return this.state.showRightShadow;
  }
  get scrollLeft() {
    var n;
    return Math.round(((n = this._slider.value) == null ? void 0 : n.scrollLeft) ?? 0);
  }
  get maxScrollLeft() {
    return this.state.sliderScrollWidth - this.state.width;
  }
  get pourcentage() {
    return this.state.pourcentage;
  }
  get visibilityValues() {
    return this.state.visibilityValues;
  }
  get elements() {
    return this.state.elements;
  }
  setShadows() {
    var t, u, i;
    const n = (t = this._el) == null ? void 0 : t.value;
    (u = this._slider) != null && u.value && (this.state.width = Math.round((n == null ? void 0 : n.getBoundingClientRect().width) ?? 0), this.state.sliderScrollWidth = Math.round(((i = this._slider.value) == null ? void 0 : i.scrollWidth) ?? 0), this.handleShadows());
  }
  slide(n) {
    var s;
    if (!this._slider.value)
      return;
    const t = this._slider.value.scrollLeft;
    if (this._slider.value.style.scrollBehavior = "smooth", this._el.value === void 0)
      return;
    const u = +(((s = getComputedStyle(this._el.value, ":before").width) == null ? void 0 : s.replace("px", "")) ?? 0);
    if (typeof this.props.scrollStep == "function" && Number.isFinite(this.props.scrollStep())) {
      const r = this.props.scrollStep(), o = r - u, a = t % r;
      let d = Math.ceil(t / r);
      n === "right" ? (a === 0 || a >= o) && d++ : a <= o && d--;
      const h = d * r - u;
      this._slider.value.scrollLeft = h;
    } else if (typeof this.props.scrollStep == "function" && Il(this.props.scrollStep())) {
      const r = this.props.scrollStep();
      let o = 0;
      if (n === "right")
        for (const d of r) {
          if (d.offsetLeft > t + u)
            break;
          o++;
        }
      else
        for (const d of r.reverse()) {
          if (d.offsetLeft < t + u)
            break;
          o++;
        }
      const a = r[o];
      this._slider.value.scrollLeft = a.offsetLeft - u;
    } else
      this._slider.value.scrollLeft = n === "left" ? 0 : this.state.sliderScrollWidth + 10;
    rl(() => {
      this._slider.value && (this._slider.value.style.scrollBehavior = "unset");
    });
    const i = setInterval(this.debouncedObserverCallback, 17);
    setTimeout(() => {
      clearInterval(i), this.getVisibility();
    }, 400);
  }
  handleScrollWhileDragging() {
    clearInterval(this.state.dragInterval), (this.state.dragScrollRight || this.state.dragScrollLeft || this.state.dragScrollTop || this.state.dragScrollBottom) && (this.state.dragInterval = setInterval(() => {
      var r, o, a, d;
      const t = (r = this._el.value) == null ? void 0 : r.getBoundingClientRect().right, u = (o = this._el.value) == null ? void 0 : o.getBoundingClientRect().left;
      if (!this.window || t === void 0 || u === void 0)
        return;
      if (t > this.window.innerWidth || u < 0)
        this.state.dragScrollRight <= 100 && this.window.scrollBy({
          left: (100 - this.state.dragScrollRight) / 5
        }), this.state.dragScrollLeft <= 100 && this.window.scrollBy({
          left: -(100 - this.state.dragScrollLeft) / 5
        });
      else {
        if (!this._slider.value)
          return;
        this.state.dragScrollRight <= 100 && (this._slider.value.scrollLeft += (100 - this.state.dragScrollRight) / 5), this.state.dragScrollLeft <= 100 && (this._slider.value.scrollLeft -= (100 - this.state.dragScrollLeft) / 5);
      }
      const i = (a = this._el.value) == null ? void 0 : a.getBoundingClientRect().top, s = (d = this._el.value) == null ? void 0 : d.getBoundingClientRect().bottom;
      i === void 0 || s === void 0 || this._el.value === void 0 || (i < 0 || s > this.window.innerHeight ? (this.state.dragScrollTop <= 100 && this.window.scrollBy({
        top: -(100 - this.state.dragScrollTop) / 5
      }), this.state.dragScrollBottom <= 100 && this.window.scrollBy({
        top: (100 - this.state.dragScrollBottom) / 5
      })) : (this.state.dragScrollTop <= 100 && (this._el.value.scrollTop -= (100 - this.state.dragScrollTop) / 5), this.state.dragScrollBottom <= 100 && (this._el.value.scrollTop += (100 - this.state.dragScrollBottom) / 5)));
    }, 17)), this.handleShadows(), this.getVisibility();
  }
  resetDragScroll() {
    clearInterval(this.state.dragInterval), this.state.dragScrollRight = 0, this.state.dragScrollLeft = 0, this.state.dragScrollTop = 0, this.state.dragScrollBottom = 0;
  }
  handleDragScroll(n) {
    if (!this.window)
      return;
    if (!this.dnd.registry.isDragging) {
      this.handleShadows();
      return;
    }
    if (n.preventDefault(), this.handleShadows(), this._el.value === void 0)
      return;
    const t = this.window.innerWidth, u = this._el.value.getBoundingClientRect().right, i = u > t ? t : u, s = this._el.value.getBoundingClientRect().left, r = s < 0 ? 0 : s, o = Math.round(this.dnd.registry.cursor.x ?? 0);
    this.state.dragScrollRight = i - o, this.state.dragScrollLeft = Math.abs(r - o);
    const a = this.window.innerHeight, d = this._el.value.getBoundingClientRect().top, h = d < 0 ? 0 : d, p = this._el.value.getBoundingClientRect().bottom, f = p > a ? a : p, m = Math.round(this.dnd.registry.cursor.y ?? 0);
    this.state.dragScrollTop = Math.abs(h - m), this.state.dragScrollBottom = f - m;
  }
  handleScroll(n) {
    n.target !== this._slider.value && (this.state.useNaturalScroll = !0, this.handleScrollEnd());
  }
  debouncedWindowResizeHandler() {
    this.windowResizeHandler();
  }
  handleShadows() {
    this.state.showLeftShadow = this.scrollLeft - this.props.tolerance > 0, this.state.showRightShadow = this.scrollLeft + this.props.tolerance < this.maxScrollLeft;
  }
  getElements() {
    this.props.targets && Object.assign(this.state.elements, this.props.targets());
  }
  getElementInPreviewSize() {
    var u, i, s;
    const n = (u = this._previewContainer.value) == null ? void 0 : u.clientWidth, t = (s = (i = this._slider.value) == null ? void 0 : i.firstElementChild) == null ? void 0 : s.clientWidth;
    n && t && (this.state.pourcentage = n * 100 / t / 100);
  }
  getVisibility() {
    this._slider.value && (this.state.visibilityValues.length = 0, this.state.elements.forEach((n) => {
      if (!this._slider.value)
        return;
      const t = n.getBoundingClientRect(), u = this._slider.value.getBoundingClientRect();
      let i = 100, s = !1;
      if (t.x < u.x || this.showLeftShadow && t.x < u.x + 40) {
        const r = this.showLeftShadow ? 40 : 0, o = u.x + r - t.x;
        i = (t.width - o) * 100 / t.width, s = !0;
      } else if (t.x > u.right)
        i = 0, s = !1;
      else if (t.right > u.right || this.showRightShadow && t.right > u.right - 40) {
        const r = this.showRightShadow ? 40 : 0, o = t.right - u.right + r;
        i = (t.width - o) * 100 / t.width, s = !1;
      }
      this.state.visibilityValues.push({
        visibility: i,
        isHidingLeft: s
      });
    }));
  }
  scrollTo(n) {
    n.scrollIntoView({
      behavior: "smooth",
      block: "nearest"
    }), setTimeout(() => this.getVisibility(), 500);
  }
}
S(cp, "props", {
  // @doc props/shadowColor the color of the shadow on the extremities of the scroll
  // @doc/fr props/shadowColor couleur de l'ombre aux extrémités du composant
  shadowColor: {
    type: String,
    default: "grey-lighter"
  },
  // @doc props/dropShadow if set, hides the shadow on the extremities of the scroll
  // @doc/fr props/dropShadow si défini, masque l'ombre aux extrémités du composant
  dropShadow: {
    type: Boolean,
    default: !1
  },
  // @doc props/tolerance set the scroll tolerance that trigger the shadow's display
  // @doc/fr props/tolerance défini la tolérence pour le déclenchement de l'apparition ou de la disparation de l'ombre
  tolerance: {
    type: Number,
    default: 1
  },
  // @doc props/scrollStep defines the targets of the scroll step
  // @doc/fr props/scrollStep défini le pas du scroll, ou un tableau d'éléments dans le DOM pour le calculer automatiquement
  scrollStep: {
    type: Function,
    default: null
  },
  // eslint-disable-next-line max-len
  // @doc props/targets if set, shows a preview of the items contained is the scroll. The function must return an array of DOM elements which are in the scroll area.
  // @doc/fr props/targets si défini, affiche un aperçu des éléments contenus dans le scroll. Cette fonction doit renvoyer un tableau d'éléments du DOM.
  targets: {
    type: Function,
    default: void 0
  },
  // @doc props/hideButton if set, hides the buttons to slide left or right
  // @doc/fr props/hideButton si défini, masque les bouttons permettant de glisser vers gauche ou vers la droite.
  hideButton: Boolean
});
const eL = {
  key: 0,
  class: "orion-horizontal-scroll__button orion-horizontal-scroll__button--left"
}, tL = {
  key: 1,
  class: "orion-horizontal-scroll__button orion-horizontal-scroll__button--right"
}, uL = {
  key: 0,
  class: "orion-horizontal-scroll__preview"
}, iL = {
  key: 0,
  class: "orion-horizontal-scroll__preview-container"
}, sL = ["onClick"], Iy = /* @__PURE__ */ K({
  __name: "OrionHorizontalScroll",
  props: cp.props,
  setup(e) {
    const l = e, n = new cp(l);
    return (t, u) => (y(), O(hl, null, [A("div", {
      ref: c(n)._el,
      class: z(["orion-horizontal-scroll", [{
        "orion-horizontal-scroll--show-left-shadow": c(n).showLeftShadow
      }, {
        "orion-horizontal-scroll--show-right-shadow": c(n).showRightShadow
      }, `orion-horizontal-scroll--${c(n).shadowColor}`, {
        "orion-horizontal-scroll--drop-shadow": c(n).dropShadow
      }]]),
      onTouchmove: u[4] || (u[4] = (i) => c(n).handleDragScroll(i)),
      onMousemove: u[5] || (u[5] = (i) => c(n).handleDragScroll(i)),
      onTouchend: u[6] || (u[6] = (i) => c(n).resetDragScroll()),
      onMouseup: u[7] || (u[7] = (i) => c(n).resetDragScroll())
    }, [c(n).showLeftShadow && !t.hideButton ? (y(), O("div", eL, [R(c(Ml), {
      button: c(n).dropShadow ? "default" : void 0,
      icon: "chevron_left",
      onClick: u[0] || (u[0] = (i) => c(n).slide("left"))
    }, null, 8, ["button"])])) : I("", !0), c(n).showRightShadow && !t.hideButton ? (y(), O("div", tL, [R(c(Ml), {
      button: c(n).dropShadow ? "default" : void 0,
      icon: "chevron_right",
      onClick: u[1] || (u[1] = (i) => c(n).slide("right"))
    }, null, 8, ["button"])])) : I("", !0), A("div", {
      id: "slider",
      ref: c(n)._slider,
      class: "orion-horizontal-scroll__slider",
      onWheel: u[2] || (u[2] = (i) => c(n).handleWheel(i)),
      onScrollCapture: u[3] || (u[3] = (i) => c(n).handleScroll(i))
    }, [V(t.$slots, "default")], 544)], 34), t.targets ? (y(), O("div", uL, [A("span", {
      class: "orion-horizontal-scroll__preview-legend",
      onClick: u[8] || (u[8] = (i) => c(n).slide("left"))
    }, B(c(n).lang.ORION_HORIZONTAL_SCROLL__LEFT.toLowerCase()), 1), A("div", {
      ref: c(n)._previewContainer,
      class: "orion-horizontal-scroll__preview-visible"
    }, [A("span", null, B(c(n).lang.ORION_HORIZONTAL_SCROLL__VISIBLE.toLowerCase()), 1), c(n).visibilityValues.length ? (y(), O("div", iL, [(y(!0), O(hl, null, Sl(c(n).elements, (i, s) => (y(), O("div", {
      key: s,
      class: "orion-horizontal-scroll__preview-path",
      style: Wl({
        width: `calc(${i.getBoundingClientRect().width} * ${c(n).pourcentage}px)`,
        background: c(n).visibilityValues[s].isHidingLeft ? `linear-gradient(
								to left,
								var(--info) ${c(n).visibilityValues[s].visibility}%,
								var(--grey) 0%
							)` : `linear-gradient(
								to right,
								var(--info) ${c(n).visibilityValues[s].visibility}%,
								var(--grey) 0%
							)`
      }),
      onClick: (r) => c(n).scrollTo(i)
    }, null, 12, sL))), 128))])) : I("", !0)], 512), A("span", {
      class: "orion-horizontal-scroll__preview-legend",
      onClick: u[9] || (u[9] = (i) => c(n).slide("right"))
    }, B(c(n).lang.ORION_HORIZONTAL_SCROLL__RIGHT.toLowerCase()), 1)])) : I("", !0)], 64));
  }
}), Yd = {
  install(e, l = "o") {
    e.component(`${tl(l)}HorizontalScroll`, Iy);
  }
};
class hp extends gl {
  constructor(l) {
    super(l);
  }
}
S(hp, "props", {
  ..._l.icon(),
  // @doc props/center centers the content
  // @doc/fr props/center centre le contenu
  center: Boolean,
  // @doc props/title title of the section
  // @doc/fr props/title titre de la section
  title: {
    type: String,
    default: void 0
  }
});
const rL = {
  class: "orion-icon-section__content"
}, oL = {
  key: 0,
  class: "orion-icon-section__title"
}, aL = {
  key: 1,
  class: "orion-icon-section__description"
}, dL = /* @__PURE__ */ K({
  __name: "OrionIconSection",
  props: hp.props,
  setup(e, {
    expose: l
  }) {
    const n = e, t = new hp(n);
    return l(t.publicInstance), (u, i) => (y(), O("div", {
      class: z(["orion-icon-section", {
        "orion-icon-section--center": c(t).props.center
      }])
    }, [c(t).props.icon || c(t).props.fontIcon ? (y(), L(c(Ml), ml({
      key: 0,
      class: "orion-icon-section__icon"
    }, {
      icon: u.icon,
      fontIcon: u.fontIcon
    }), null, 16)) : I("", !0), A("div", rL, [c(t).props.title ? (y(), O("h6", oL, B(c(t).props.title), 1)) : I("", !0), u.$slots.default ? (y(), O("div", aL, [V(u.$slots, "default")])) : I("", !0)])], 2));
  }
}), qd = {
  install(e, l = "o") {
    e.component(`${tl(l)}IconSection`, dL);
  }
};
class ya extends gl {
  get itemsToDisplay() {
    var l;
    return (l = this.items) == null ? void 0 : l.filter((n) => typeof n.if == "function" ? n.if() : n.if !== !1);
  }
  constructor(l) {
    super(l);
  }
  itemIs(l) {
    return l.line ? "hr" : l.to ? "router-link" : l.tag ? l.tag : "span";
  }
  itemData(l) {
    if (l.line)
      return {
        class: []
      };
    {
      const n = {
        class: [this.baseClass]
      };
      return l.line || (n.class = [`${this.baseClass}__item`], l.to && (n.to = l.to)), l.root && n.class.push(`${this.baseClass}__item--root`), l.always && n.class.push(`${this.baseClass}__item--always`), l.reload && n.class.push("nav-reload"), l.class && n.class.push(l.class), l.sectionTitle && n.class.push(`${this.baseClass}__item--section-title`), l.activeWhenExact && n.class.push("active-when-exact"), n;
    }
  }
  handleClick(l, n) {
    n.metaKey || n.ctrlKey || (l.callback && l.callback(l, n), l.to && this.router.push(l.to));
  }
  checkIfReloadIsNeeded(l) {
    var t, u, i;
    const n = l.target;
    (t = n.classList) != null && t.contains("nav-reload") && ((u = n.classList) != null && u.contains("router-link-exact-active")) && !l.ctrlKey && !l.metaKey && ((i = this.window) == null || i.location.reload());
  }
}
class pp extends ya {
  constructor(n) {
    super(n);
    S(this, "baseClass", "orion-nav-main");
  }
  get items() {
    var n;
    return this.props.item.replace ? [] : ((n = this.props.item) == null ? void 0 : n.children) ?? [];
  }
  get expand() {
    return this.props.item.expand;
  }
}
S(pp, "props", {
  item: {
    type: Object,
    required: !0
  }
});
const cL = {
  key: 1,
  class: "orion-nav-main-item__children"
}, fp = /* @__PURE__ */ K({
  __name: "OrionNavMainItem",
  props: pp.props,
  emits: ["click-label"],
  setup(e, {
    expose: l
  }) {
    const n = e, t = new pp(n);
    return l(t.publicInstance), (u, i) => {
      var r;
      const s = Bl("orion-nav-main-item", !0);
      return y(), O("div", {
        class: z(u.item.wrapperClass)
      }, [u.item ? (y(), L(Vn(c(t).itemIs(u.item)), ml({
        key: 0
      }, c(t).itemData(u.item), {
        onClick: i[0] || (i[0] = kl((o) => u.$emit("click-label", [u.item, o]), ["stop"]))
      }), {
        default: U(() => {
          var o;
          return [u.item.icon || u.item.fontIcon ? (y(), L(c(Ml), ml({
            key: 0,
            class: "orion-nav-main__item-main-icon"
          }, u.item), null, 16)) : I("", !0), V(u.$slots, "prepend", Rl(jl({
            item: u.item
          }))), V(u.$slots, "default", Rl(jl({
            item: u.item
          })), () => [$l(B(u.item.label), 1)]), V(u.$slots, "append", Rl(jl({
            item: u.item
          }))), u.item.children && u.item.replace || u.item.showCarret ? (y(), L(c(Ml), {
            key: 1,
            class: "icon--children-indicator",
            icon: "chevron_right"
          })) : I("", !0), u.item.children && !u.item.replace ? (y(), L(c(Ml), {
            key: 2,
            class: "icon--collapse",
            icon: (o = u.item) != null && o.expand ? "caret_down_sm" : "caret_right_sm"
          }, null, 8, ["icon"])) : I("", !0)];
        }),
        _: 3
      }, 16)) : I("", !0), c(t).itemsToDisplay.length ? vl((y(), O("div", cL, [(y(!0), O(hl, null, Sl(c(t).itemsToDisplay, (o, a) => (y(), L(s, {
        key: `main_${a}_${c(t).getUid()}`,
        "data-index": a,
        item: o,
        onClickLabel: i[1] || (i[1] = (d) => c(t).handleClick(...d))
      }, {
        prepend: U(() => [V(u.$slots, "prepend", Rl(jl({
          item: o
        })))]),
        default: U(() => [V(u.$slots, "default", Rl(jl({
          item: o
        })), () => [$l(B(o.label), 1)])]),
        append: U(() => [V(u.$slots, "append", Rl(jl({
          item: o
        })))]),
        _: 2
      }, 1032, ["data-index", "item"]))), 128))], 512)), [[cn, (r = u.item) == null ? void 0 : r.expand]]) : I("", !0)], 2);
    };
  }
}), Jd = {
  install(e, l = "o") {
    e.component(`${tl(l)}NavMainItem`, fp);
  }
};
class mp extends ya {
  constructor(n) {
    super(n);
    S(this, "_el", J());
    S(this, "_wrapper", J());
    S(this, "_children", J());
    S(this, "baseClass", "orion-nav-main");
    S(this, "state", fl({
      menuHistory: []
    }));
  }
  get items() {
    return this.props.items;
  }
  get itemsToDisplay() {
    var t;
    let n = (t = this.state.menuHistory.slice(-1)[0]) == null ? void 0 : t.filter((u) => typeof u.if == "function" ? !u.always && u.if() : !u.always && u.if !== !1);
    if (this.state.menuHistory.length > 1) {
      let u = n.find((s) => !!s.backLabel);
      const i = !!u;
      u ? u.label = u.backLabel : u = {
        label: this.lang.BACK
      }, u.icon = "chevron_left", u.callback = this.goBack.bind(this), i || n.unshift(u);
    }
    return n = nb(this.props.items.filter((u) => typeof u.if == "function" ? u.always && u.if() : u.always && u.if !== !1), n), n;
  }
  get itemsToDisplayTop() {
    var n, t;
    return (t = (n = this.props.navTop) == null ? void 0 : n.items) == null ? void 0 : t.filter((u) => typeof u.if == "function" ? u.if() : u.if !== !1);
  }
  async onBeforeMount() {
    this.state.menuHistory.push(this.props.items);
  }
  onMounted() {
    this.findActiveItem(), this.Bus.on("navMain.refresh", this.findActiveItem.bind(this));
  }
  onUnmounted() {
    this.Bus.off("navMain.refresh", this.findActiveItem.bind(this));
  }
  goBack() {
    this.state.menuHistory.length > 1 && this.state.menuHistory.splice(this.state.menuHistory.length - 1, 1);
  }
  handleClick(n, t) {
    n.children && (n.replace ? this.state.menuHistory.push(n.children) : n.expand = !n.expand), n.root && this.state.menuHistory.splice(1), super.handleClick(n, t);
  }
  itemIsActive(n) {
    var i;
    const t = n.to, u = this.router.currentRoute.value;
    return t === ((i = this.window) == null ? void 0 : i.location.pathname) || typeof t == "object" && (t == null ? void 0 : t.name) === (u == null ? void 0 : u.name);
  }
  async findActiveItem() {
    var u;
    const t = await ((i) => {
      let s;
      const r = (o, a) => {
        for (const d of o)
          a && !d.line && (d.parent = a), this.itemIsActive(d) && !s ? s = d : d.children && r(d.children, d);
      };
      return r(i, null), s;
    })(this.props.items);
    if ((u = t == null ? void 0 : t.parent) != null && u.replace) {
      const i = t.parent.children;
      this.state.menuHistory.push(i);
    } else
      t != null && t.parent && (t.parent.expand = !0);
    this.ui.update();
  }
}
S(mp, "props", {
  ..._l.nav(),
  navTop: {
    type: Object,
    default: void 0
  }
});
const hL = /* @__PURE__ */ A("hr", null, null, -1), C1 = /* @__PURE__ */ K({
  __name: "OrionNavMain",
  props: mp.props,
  setup(e, {
    expose: l
  }) {
    const n = e, t = new mp(n);
    return l(t.publicInstance), (u, i) => {
      var s;
      return y(), O("nav", {
        ref: c(t)._el,
        class: z(c(t).baseClass),
        onMouseup: i[1] || (i[1] = (r) => c(t).checkIfReloadIsNeeded(r))
      }, [A("div", {
        ref: c(t)._wrapper,
        class: "orion-nav-main__wrapper"
      }, [(y(), O("div", {
        key: c(t).ui.token,
        ref: c(t)._children,
        class: "orion-nav-main__children"
      }, [(y(!0), O(hl, null, Sl(c(t).itemsToDisplay, (r, o) => (y(), L(c(fp), {
        key: `main_${o}_${c(t).getUid()}`,
        "data-index": o,
        item: r,
        onClickLabel: i[0] || (i[0] = (a) => c(t).handleClick(...a))
      }, {
        prepend: U(({
          item: a
        }) => [V(u.$slots, "prepend", Rl(jl({
          item: a
        })))]),
        default: U(({
          item: a
        }) => [V(u.$slots, "default", Rl(jl({
          item: a
        })), () => [$l(B(a.label), 1)])]),
        append: U(({
          item: a
        }) => [V(u.$slots, "append", Rl(jl({
          item: a
        })))]),
        _: 2
      }, 1032, ["data-index", "item"]))), 128)), u.navTop && ((s = c(t).itemsToDisplayTop) != null && s.length) ? (y(), O(hl, {
        key: 0
      }, [hL, (y(!0), O(hl, null, Sl(c(t).itemsToDisplayTop, (r, o) => (y(), L(c(fp), ml({
        key: "top" + o
      }, {
        item: r
      }, {
        onClick: kl((a) => c(t).handleClick(r, a), ["prevent"])
      }), null, 16, ["onClick"]))), 128))], 64)) : I("", !0)]))], 512)], 34);
    };
  }
}), Zd = {
  install(e, l = "o") {
    e.component(`${tl(l)}NavMain`, C1);
  }
};
class gp extends ya {
  constructor(n) {
    super(n);
    S(this, "_el", J());
    S(this, "baseClass", "orion-nav-top");
    S(this, "scrollSpy", ws(() => {
      this.handleScroll();
    }, 100));
    S(this, "state", fl({
      isSticky: !1
    }));
  }
  get isSticky() {
    return this.state.isSticky;
  }
  get items() {
    return this.props.items;
  }
  onMounted() {
    var n;
    (n = this.window) == null || n.addEventListener("scroll", this.scrollSpy);
  }
  handleScroll() {
    this.window && (this.window.scrollY > 80 || this.responsive.onTabletLandscape && this.window.scrollY > 140 ? this.state.isSticky = !0 : this.state.isSticky = !1);
  }
}
S(gp, "props", {
  ..._l.nav()
});
const pL = {
  key: 0,
  class: "orion-nav-top__slot-left"
}, fL = {
  class: "orion-nav-top__item-label"
}, mL = {
  key: 1,
  class: "orion-nav-top__slot-additional"
}, gL = {
  key: 1,
  class: "orion-nav-top__slot-right"
}, Ry = /* @__PURE__ */ K({
  __name: "OrionNavTop",
  props: gp.props,
  setup(e, {
    expose: l
  }) {
    const n = e, t = new gp(n);
    return l(t.publicInstance), (u, i) => (y(), O("header", {
      id: "nav-top",
      ref: c(t)._el,
      class: z([c(t).baseClass, {
        "orion-nav-top--overlay": c(t).isSticky
      }])
    }, [u.$slots["nav-top-left"] ? (y(), O("div", pL, [V(u.$slots, "nav-top-left")])) : I("", !0), A("nav", null, [c(t).itemsToDisplay.length ? (y(!0), O(hl, {
      key: 0
    }, Sl(c(t).itemsToDisplay, (s, r) => (y(), L(Vn(c(t).itemIs(s)), ml({
      key: r
    }, c(t).itemData(s), {
      onClick: kl((o) => c(t).handleClick(s, o), ["prevent"])
    }), {
      default: U(() => [A("span", fL, B(s.label), 1), s.icon || s.fontIcon ? (y(), L(c(Ml), Rl(ml({
        key: 0
      }, s)), null, 16)) : I("", !0)]),
      _: 2
    }, 1040, ["onClick"]))), 128)) : I("", !0), u.$slots["nav-top-additional"] ? (y(), O("div", mL, [V(u.$slots, "nav-top-additional")])) : I("", !0)]), u.$slots["nav-top-right"] ? (y(), O("div", gL, [V(u.$slots, "nav-top-right", {
      class: "orion-nav-top__slot-right"
    })])) : I("", !0)], 2));
  }
}), Xd = {
  install(e, l = "o") {
    e.component(`${tl(l)}NavTop`, Ry);
  }
};
class vp extends gl {
  constructor(l, n) {
    super(l);
    const t = qw();
    Pl(t, () => n == null ? void 0 : n.close());
  }
}
S(vp, "props", {
  navMain: {
    type: Object,
    default: void 0
  },
  navTop: {
    type: Object,
    default: void 0
  }
});
const Dy = /* @__PURE__ */ K({
  __name: "OrionNavAside",
  props: vp.props,
  setup(e, {
    expose: l
  }) {
    const n = Tn("_aside"), t = e, u = new vp(t, n);
    return l(u.publicInstance), (i, s) => c(u).props.navMain ? (y(), L(c(C1), ml({
      key: 0,
      class: "orion-nav-main--aside",
      items: c(u).props.navMain.items
    }, {
      navTop: c(u).props.navTop
    }), null, 16, ["items"])) : I("", !0);
  }
}), Qd = {
  install(e, l = "o") {
    e.component(`${tl(l)}NavAside`, Dy);
  }
};
class yp extends ya {
  constructor(n) {
    super(n);
    S(this, "_el", J());
    S(this, "_navAside", J());
    S(this, "baseClass", "orion-nav-tabs");
  }
  get items() {
    return this.props.items;
  }
  onMounted() {
    this.Bus.on("navAside:show", this.openAsideNav), this.Bus.on("navAside:hide", this.closeAsideNav);
  }
  onUnmounted() {
    this.Bus.off("navAside:show", this.openAsideNav), this.Bus.off("navAside:hide", this.closeAsideNav);
  }
  openAsideNav() {
    var n;
    (n = this._navAside.value) == null || n.open();
  }
  closeAsideNav() {
    var n;
    (n = this._navAside.value) == null || n.close();
  }
}
S(yp, "props", {
  ..._l.nav(),
  navAside: {
    type: Object,
    default: void 0
  }
});
const vL = {
  class: "orion-nav-aside__footer"
}, Ny = /* @__PURE__ */ K({
  __name: "OrionNavTabs",
  props: yp.props,
  setup(e, {
    expose: l
  }) {
    const n = e, t = new yp(n);
    return l(t.publicInstance), (u, i) => (y(), O("nav", {
      ref: c(t)._el,
      class: z(c(t).baseClass)
    }, [c(t).itemsToDisplay.length ? (y(!0), O(hl, {
      key: 0
    }, Sl(c(t).itemsToDisplay, (s, r) => (y(), L(Vn(c(t).itemIs(s)), ml({
      key: r
    }, c(t).itemData(s), {
      onClick: kl((o) => c(t).handleClick(s, o), ["prevent"])
    }), {
      default: U(() => [s.icon || s.fontIcon ? (y(), L(c(Ml), Rl(ml({
        key: 0
      }, s)), null, 16)) : I("", !0), $l(" " + B(s.label), 1)]),
      _: 2
    }, 1040, ["onClick"]))), 128)) : I("", !0), u.navAside ? (y(), O("span", {
      key: 1,
      class: "orion-nav-tabs__item",
      onClickCapture: i[0] || (i[0] = (s) => c(t).openAsideNav())
    }, [R(c(Ml), {
      icon: "bar_right"
    }), $l(" " + B(c(t).lang.MENU), 1)], 32)) : I("", !0), u.navAside ? (y(), L(c(_f), {
      key: 2,
      ref: c(t)._navAside,
      options: {
        size: "xs"
      }
    }, {
      footer: U(({
        close: s
      }) => [A("div", vL, [R(c(bl), {
        "suffix-icon": "chevron_right",
        outline: "",
        onClick: (r) => s()
      }, {
        default: U(() => [$l(B(c(t).lang.CLOSE_MENU), 1)]),
        _: 2
      }, 1032, ["onClick"])])]),
      default: U(() => [R(c(Dy), Rl(jl(u.navAside)), null, 16)]),
      _: 1
    }, 512)) : I("", !0)], 2));
  }
}), lc = {
  install(e, l = "o") {
    e.component(`${tl(l)}NavTabs`, Ny);
  }
};
class $p extends gl {
  constructor(n) {
    super(n);
    S(this, "_main", J());
  }
  onMounted() {
    this._main.value && El({
      targets: this._main.value,
      opacity: [0, 1],
      duration: 600,
      delay: 1e3,
      easing: "easeInOutQuad",
      complete: () => {
        var n;
        (n = this._main.value) == null || n.removeAttribute("style");
      }
    });
  }
}
S($p, "props", {
  // @doc props/navMain these props will be applied to the layout's `<o-nav-main>` component
  // @doc/fr props/navMain ces props seront passées au composant `<o-nav-main>` du layout
  navMain: {
    type: Object,
    default: void 0
  },
  // @doc props/navTop these props will be applied to the layout's `<o-nav-top>` component
  // @doc/fr props/navTop ces props seront passées au composant `<o-nav-top>` du layout
  navTop: {
    type: Object,
    default: void 0
  },
  // @doc props/navTabs these props will be applied to the layout's `<o-nav-tabs>` component
  // @doc/fr props/navTabs ces props seront passées au composant `<o-nav-tabs>` du layout
  navTabs: {
    type: Object,
    default: void 0
  }
});
const yL = {
  id: "layout"
}, $L = {
  key: 2,
  id: "footer"
}, bL = /* @__PURE__ */ K({
  __name: "OrionLayout",
  props: $p.props,
  setup(e, {
    expose: l
  }) {
    const n = e, t = new $p(n);
    return l(t.publicInstance), (u, i) => (y(), O("div", yL, [c(t).responsive.onTabletLandscape && c(t).props.navMain ? (y(), L(c(C1), Rl(ml({
      key: 0
    }, c(t).props.navMain)), {
      prepend: U(({
        item: s
      }) => [V(u.$slots, "nav-main-item-prepend", Rl(jl({
        item: s
      })))]),
      default: U(({
        item: s
      }) => [$l(B(s.label), 1)]),
      append: U(({
        item: s
      }) => [V(u.$slots, "nav-main-item-append", Rl(jl({
        item: s
      })))]),
      _: 3
    }, 16)) : (y(), L(c(Ny), Rl(ml({
      key: 1
    }, c(t).props.navTabs)), null, 16)), R(c(Ry), Rl(jl(c(t).props.navTop)), e5({
      _: 2
    }, [u.$slots["nav-top-left"] ? {
      name: "nav-top-left",
      fn: U(() => [V(u.$slots, "nav-top-left")]),
      key: "0"
    } : void 0, u.$slots["nav-top-additional"] ? {
      name: "nav-top-additional",
      fn: U(() => [V(u.$slots, "nav-top-additional")]),
      key: "1"
    } : void 0, u.$slots["nav-top-right"] ? {
      name: "nav-top-right",
      fn: U(() => [V(u.$slots, "nav-top-right")]),
      key: "2"
    } : void 0]), 1040), A("main", {
      id: "main",
      ref: c(t)._main
    }, [V(u.$slots, "default")], 512), u.$slots.footer ? (y(), O("footer", $L, [V(u.$slots, "footer")])) : I("", !0)]));
  }
}), nc = {
  install(e, l = "o") {
    e.component(`${tl(l)}Layout`, bL);
  }
};
class bp extends gl {
  get index() {
    return this.props.bindRouter && this.router.currentRoute.value.query[this.props.bindRouter] ? Number(this.router.currentRoute.value.query[this.props.bindRouter]) : this.props.modelValue;
  }
  set index(l) {
    l < 1 || l > this.pagesLength || isNaN(l) || l === this.index || (this.emit("update:modelValue", l), this.emit("paginate", l), this.props.bindRouter && this.props.bindRouter.length && this.router.push({
      ...this.router.currentRoute.value,
      query: {
        ...this.router.currentRoute.value.query,
        [this.props.bindRouter]: l
      }
    }));
  }
  get pagesArray() {
    const l = [];
    if (this.props.modelValue < 6) {
      for (let n = 1; n <= (this.pagesLength < 6 ? this.pagesLength : 5); n++)
        l.push(n);
      this.pagesLength > 5 && (l.push("..."), l.push(this.pagesLength));
    } else if (this.props.modelValue > this.pagesLength - 5) {
      l.push(1), l.push("...");
      const n = this.pagesLength - 4;
      for (let t = n; t <= this.pagesLength; t++)
        l.push(t);
    } else {
      l.push(1), l.push("...");
      const n = this.props.modelValue - 2;
      for (let t = n; t <= this.props.modelValue + 2; t++)
        l.push(t);
      l.push("..."), l.push(this.pagesLength);
    }
    return l;
  }
  get pagesLength() {
    return Math.ceil(this.props.total / this.props.size);
  }
  constructor(l, n) {
    super(l), this.emit = n;
  }
  isActive(l) {
    return this.props.bindRouter && this.router.currentRoute.value.query[this.props.bindRouter] ? Number(this.router.currentRoute.value.query[this.props.bindRouter]) === l : l === this.index;
  }
}
S(bp, "props", {
  // @doc props/modelValue active page index
  // @doc/fr props/modelValue index de la page active
  modelValue: {
    type: Number,
    required: !0
  },
  // @doc props/size number of elements to display on each page
  // @doc/fr props/size nombre d'éléments à afficher sur chaque page
  size: {
    type: Number,
    required: !0
  },
  // @doc props/total total number of element which are paginated
  // @doc/fr props/total nombre total d'éléments
  total: {
    type: Number,
    required: !0
  },
  // eslint-disable-next-line max-len
  // @doc props/bindRouter the key used in the url query to get the current active page (ex: ...url/my-list?**page**=2 • *bindRouter = **page***)
  // eslint-disable-next-line max-len
  // @doc/fr props/bindRouter représente la clé utilisée dans l'url pour déterminer la page active actuelle (ex: ...url/my-list?**page**=2 • *bindRouter = **page***)
  bindRouter: {
    type: String,
    default: void 0
  }
});
const wL = {
  class: "orion-paginate"
}, _L = {
  class: "orion-paginate__wrapper"
}, wp = /* @__PURE__ */ K({
  __name: "OrionPaginate",
  props: bp.props,
  emits: ["update:modelValue", "paginate"],
  setup(e, {
    expose: l,
    emit: n
  }) {
    const t = n, u = e, i = new bp(u, t);
    return l(i.publicInstance), (s, r) => (y(), O("div", wL, [R(c(bl), {
      nude: "",
      class: "orion-paginate__prev",
      "prefix-icon": "chevron_left",
      onClick: r[0] || (r[0] = (o) => c(i).index -= 1)
    }), A("div", _L, [(y(!0), O(hl, null, Sl(c(i).pagesArray, (o, a) => (y(), L(c(bl), {
      key: a,
      class: z([[{
        "orion-paginate__index-active": c(i).isActive(Number(o))
      }, {
        "orion-paginate__ellipsis": o === "..."
      }], "orion-paginate__index"]),
      color: c(i).isActive(Number(o)) ? "info" : "default",
      disabled: o === "...",
      nude: "",
      onClick: (d) => c(i).index = Number(o)
    }, {
      default: U(() => [$l(B(o), 1)]),
      _: 2
    }, 1032, ["class", "color", "disabled", "onClick"]))), 128))]), R(c(bl), {
      nude: "",
      class: "orion-paginate__next",
      "suffix-icon": "chevron_right",
      onClick: r[1] || (r[1] = (o) => c(i).index += 1)
    })]));
  }
}), ec = {
  install(e, l = "o") {
    e.component(`${tl(l)}Paginate`, wp);
  }
};
class _p extends gl {
  get computedLayout() {
    return this.responsive.onPhone ? "grid" : this.props.layout;
  }
  get itemType() {
    return this.props.itemType ?? this.lang.ORION_LIST__ITEM_TYPE;
  }
  get itemAdjective() {
    return this.props.itemAdjective ?? this.lang.ORION_LIST__ITEM_ADJECTIVE;
  }
  get computedItemType() {
    return Ae(this.itemType, this.selected.length, !1);
  }
  get computedItemAdjective() {
    return jt() === "fr" ? Ae(this.itemAdjective, this.selected.length, !1) : this.itemAdjective;
  }
  get listToDisplay() {
    return this.props.useAutoPagination ? this.props.list.slice(this.page.size * (this.page.index - 1), this.page.size * this.page.index) : this.props.list;
  }
  get page() {
    return this.props.page;
  }
  set page(l) {
    this.emit("update:page", l);
  }
  get selected() {
    return this.props.selected;
  }
  set selected(l) {
    this.emit("update:selected", l);
  }
  constructor(l, n) {
    super(l), this.emit = n;
  }
  async onBeforeMount() {
    In(this.page) && this.emit("update:page", {
      size: 20,
      index: 1
    });
  }
  clearSelection() {
    this.selected.length = 0, this.emit("clear-selection");
  }
  handleOnPaginate() {
    this.emit("update:page", this.page), this.emit("paginate", this.page.index);
  }
  listItemIsSelected(l) {
    return this.selected.map((n) => n[this.props.trackKey]).includes(l[this.props.trackKey]);
  }
}
S(_p, "props", {
  // @doc props/useAutoPagination use OrionList's pagination system. Useful if you pass the full list in props
  // @doc/fr props/useAutoPagination utilise le système de pagination d'OrionList. Utile si vous pasez la liste compl!te en props
  useAutoPagination: Boolean,
  // @doc props/usePaginationTop displays pagination at the top of the list
  // @doc/fr props/usePaginationTop affiche une pagination en haut de la liste
  usePaginationTop: {
    type: Boolean,
    default: !0
  },
  // @doc props/usePaginationBottom displays pagination at the bottom of the list
  // @doc/fr props/usePaginationBottom affiche une pagination en bas de la liste
  usePaginationBottom: {
    type: Boolean,
    default: !0
  },
  // @doc props/useFooterSelected displays a footer when any items of the list are selected (useful for batch action on selected items)
  // eslint-disable-next-line max-len
  // @doc/fr props/useFooterSelected affiche un pied de page quand des éléments de la liste sont sélectionnés (utile en cas d'action groupée sur les éléments sélectionnés)
  useFooterSelected: {
    type: Boolean,
    default: !0
  },
  // @doc props/list items of the list
  // @doc/fr props/list élements de la liste
  list: {
    type: Array,
    default: () => []
  },
  // @doc props/selected array of the selected items
  // @doc/fr props/selected tableau contenant les élements sélectionnés
  selected: {
    type: Array,
    default: () => []
  },
  // @doc props/total total number of items in the list
  // @doc/fr props/total nombre total d'éléments dans la liste
  total: {
    type: Number,
    default: 0
  },
  // @doc props/page configuration of the list's pagination (size: number of items per page, index: current page)
  // @doc/fr props/page configuration de la pagination de la liste (size: nombre d'éléments par page, index: page actuelle)
  page: {
    type: Object,
    default: () => ({
      size: 20,
      index: 1
    })
  },
  // @doc props/trackKey determine the `key` used for the v-for in the list loop
  // @doc/fr props/trackKey détermine la `key` utilisée pour le v-for dans la boucle de la liste
  trackKey: {
    type: String,
    default: "id"
  },
  // @doc props/layout layout of the list
  // @doc/fr props/layout disposition de la liste
  layout: {
    type: String,
    default: "grid",
    validator: (l) => ["grid", "row"].includes(l)
  },
  // @doc props/gridClass class applied to the list when the layout is `grid`
  // @doc/fr props/gridClass classe appliquée à la liste quand la disposition est sous forme de `grid`
  gridClass: {
    type: String,
    default: "row row--grid"
  },
  // @doc props/cellClass class applied to the list's cells when the layout is `grid`
  // @doc/fr props/cellClass classe appliquée aux cellules de la liste quand la disposition est sous forme de `grid`
  cellClass: {
    type: String,
    default: "col-sm-6 col-lg-4 col-xl-3"
  },
  // @doc props/itemType item type of the list (to customize the selection footer)
  // @doc/fr props/itemType type d'élément de la liste (pour personnaliser le footer de sélection)
  // @doc props/itemType/default depends on the selected language
  itemType: {
    type: String,
    default: void 0
  },
  // @doc props/itemAdjective the adjective used for the item selection (to customize the selection footer)
  // @doc/fr props/itemAdjective l'adjectif utilisé pour les élements sélectionnés (pour personnaliser le footer de sélection)
  // @doc props/itemAdjective/default depends on the selected language
  itemAdjective: {
    type: String,
    default: void 0
  },
  // eslint-disable-next-line max-len
  // @doc props/bindRouter the key used in the url query to bind the current page to the pagination component (ex: ...url/my-list?**page**=2 • *bindRouter = **page***)
  // eslint-disable-next-line max-len
  // @doc/fr props/bindRouter représente la clé utilisée dans l'url pour binder la page courante au composant de pagination (ex: ...url/my-list?**page**=2 • *bindRouter = **page***)
  bindRouter: {
    type: String,
    default: void 0
  }
});
const SL = {
  class: "orion-list"
}, CL = {
  class: "orion-list__cell"
}, TL = {
  class: "orion-footer-selected__qty"
}, OL = {
  class: "orion-footer-selected__qty-number"
}, kL = {
  class: "orion-footer-selected__qty-text"
}, ML = /* @__PURE__ */ A("br", null, null, -1), AL = {
  class: "orion-footer-selected__actions"
}, xL = /* @__PURE__ */ K({
  __name: "OrionList",
  props: _p.props,
  emits: ["update:page", "update:selected", "clear-selection", "paginate"],
  setup(e, {
    expose: l,
    emit: n
  }) {
    const t = n, u = e, i = new _p(u, t);
    return l(i.publicInstance), (s, r) => (y(), O("div", SL, [c(i).props.usePaginationTop && c(i).page && c(i).props.total ? (y(), L(c(wp), {
      key: 0,
      modelValue: c(i).page.index,
      "onUpdate:modelValue": r[0] || (r[0] = (o) => c(i).page.index = o),
      size: c(i).page.size,
      total: c(i).props.total,
      "bind-router": s.bindRouter,
      onPaginate: r[1] || (r[1] = (o) => c(i).handleOnPaginate())
    }, null, 8, ["modelValue", "size", "total", "bind-router"])) : I("", !0), c(i).computedLayout === "grid" ? (y(), O("div", {
      key: 1,
      class: z(s.gridClass)
    }, [(y(!0), O(hl, null, Sl(c(i).listToDisplay, (o, a) => (y(), O("div", {
      key: o[s.trackKey],
      class: z(s.cellClass)
    }, [A("div", CL, [V(s.$slots, "default", Rl(jl({
      item: o,
      index: a,
      selected: c(i).listItemIsSelected(o)
    })))])], 2))), 128))], 2)) : c(i).computedLayout === "row" ? (y(!0), O(hl, {
      key: 2
    }, Sl(c(i).listToDisplay, (o, a) => (y(), O("div", {
      key: o[s.trackKey],
      class: "orion-list__row"
    }, [V(s.$slots, "default", Rl(jl({
      item: o,
      index: a,
      selected: c(i).listItemIsSelected(o)
    })))]))), 128)) : I("", !0), s.usePaginationBottom && c(i).page && c(i).props.total ? (y(), L(c(wp), {
      key: 3,
      modelValue: c(i).page.index,
      "onUpdate:modelValue": r[2] || (r[2] = (o) => c(i).page.index = o),
      size: c(i).page.size,
      total: c(i).props.total,
      "bind-router": s.bindRouter,
      onPaginate: r[3] || (r[3] = (o) => c(i).handleOnPaginate())
    }, null, 8, ["modelValue", "size", "total", "bind-router"])) : I("", !0), R(c(Ey), {
      class: "orion-footer-selected",
      visible: s.useFooterSelected && !!c(i).selected.length
    }, {
      default: U(() => [A("div", TL, [A("span", OL, B(c(i).selected.length), 1), A("span", kL, [$l(B(c(i).computedItemType), 1), ML, $l(" " + B(c(i).computedItemAdjective), 1)])]), A("div", AL, [V(s.$slots, "footer-selected-actions")]), A("span", {
        class: "orion-footer-selected__close",
        onClick: r[4] || (r[4] = (o) => c(i).clearSelection())
      })]),
      _: 3
    }, 8, ["visible"])]));
  }
}), tc = {
  install(e, l = "o") {
    e.component(`${tl(l)}List`, xL);
  }
};
class Sp extends gl {
  constructor(n, t) {
    super(n);
    S(this, "_inputs", J());
    S(this, "tutu", J(""));
    S(this, "state", fl({
      code: {},
      validated: !1
    }));
    this.emits = t;
  }
  get code() {
    return this.state.code;
  }
  set code(n) {
    this.state.code = n;
  }
  get readableCode() {
    let n = "";
    return Object.values(this.code).forEach((t) => n += t), n;
  }
  get publicInstance() {
    return {
      ...super.publicInstance,
      reset: this.reset.bind(this),
      focus: this.focus.bind(this),
      code: () => this.code,
      readableCode: () => this.readableCode
    };
  }
  onMounted() {
    this.props.value && this.splitCodeFromString(this.props.value, 1);
  }
  splitCodeFromString(n, t) {
    const u = n.split("");
    for (let i = 0; i < this.props.size; i++)
      this.state.code[i + 1] = u[i];
    this._inputs.value && (n.length >= this.props.size ? (this._inputs.value[t - 1].blur(), this.validate()) : this._inputs.value[this.props.size - 1].focus());
  }
  handleInput(n, t) {
    this._inputs.value && (n.length > 1 ? this.splitCodeFromString(n, t) : n && (t < this.props.size ? this._inputs.value[t].focus() : t === this.props.size && (this.state.validated || (this.validate(), this.state.validated = !this.state.validated), this._inputs.value[t - 1].blur())));
  }
  handleDelete(n) {
    this._inputs.value && (this.state.validated = !1, !this.code[n] && n > 1 && this._inputs.value[n - 2].focus());
  }
  validate() {
    this.emits("filled", this.readableCode);
  }
  reset() {
    Object.keys(this.code).forEach((n) => this.state.code[Number(n)] = ""), this.state.validated = !1, this.focus();
  }
  focus() {
    this._inputs.value && this._inputs.value[0].focus();
  }
}
S(Sp, "props", {
  // @doc props/readonly if set, the code will be on read-only mode
  // @doc/fr props/readonly si défini, le code sera en mode read-only
  readonly: Boolean,
  // @doc props/size defines the size of the code
  // @doc/fr props/size définit la taille du code
  size: {
    type: Number,
    default: 4
  },
  // @doc props/dataType defines the type of the code
  // @doc/fr props/dataType definit le type du code
  dataType: {
    type: String,
    default: "text"
  },
  // @doc props/value the string value of the code, if it is prefilled
  // @doc/fr props/value valeur du code sous forme de chaîne de caractères, s'il est pré-rempli
  value: {
    type: String,
    default: void 0
  }
});
const EL = {
  class: "orion-otp"
}, IL = /* @__PURE__ */ K({
  __name: "OrionOtp",
  props: Sp.props,
  emits: ["filled"],
  setup(e, {
    expose: l,
    emit: n
  }) {
    const t = n, u = e, i = new Sp(u, t);
    return l(i.publicInstance), (s, r) => (y(), O("div", EL, [(y(!0), O(hl, null, Sl(s.size, (o) => (y(), L(Di, {
      ref_for: !0,
      ref: c(i)._inputs,
      key: o,
      modelValue: c(i).code[o],
      "onUpdate:modelValue": (a) => c(i).code[o] = a,
      "select-on-focus": "",
      pattern: s.dataType !== "text" ? "[0-9]*" : void 0,
      type: "text",
      onkeypress: s.dataType !== "text" ? "return /[0-9]/i.test(event.key)" : void 0,
      readonly: s.readonly,
      autocomplete: "one-time-code",
      class: "orion-otp__input",
      onInput: (a) => c(i).handleInput(a, o),
      onKeydown: Fn((a) => c(i).handleDelete(o), ["delete"])
    }, null, 8, ["modelValue", "onUpdate:modelValue", "pattern", "onkeypress", "readonly", "onInput", "onKeydown"]))), 128))]));
  }
}), uc = {
  install(e, l = "o") {
    e.component(`${tl(l)}Otp`, IL);
  }
};
class Cp extends gl {
  constructor(l) {
    super(l);
  }
}
S(Cp, "props", {
  // @doc props/stickySubactions make the subactions div sticky when scrolling for easy access
  // @doc/fr props/stickySubactions rend les actions secondaires sticky lors du scroll pour y faciliter l'accès
  stickySubactions: Boolean,
  // @doc props/titleEllipsis adds an ellipsis on the title if the title is too long
  // @doc/fr props/titleEllipsis ajoute une ellipse au niveau du titre s'il est trop long
  titleEllipsis: Boolean,
  // @doc props/subtitleEllipsis adds an ellipsis on the subtitle if it is too long
  // @doc/fr props/subtitleEllipsis aajoute une ellipse au niveau du sous-titre s'il est trop long
  subtitleEllipsis: Boolean,
  // @doc props/title title of the page
  // @doc/fr props/title titre de la page
  title: {
    type: String,
    default: void 0
  },
  // @doc props/subtitle subtitle of the page
  // @doc/fr props/subtitle sous-titre de la page
  subtitle: {
    type: String,
    default: void 0
  }
});
const RL = {
  class: "orion-page"
}, DL = {
  class: "orion-page__title-subtitle"
}, NL = {
  key: 0,
  class: "orion-page__actions"
}, LL = {
  class: "orion-page__content"
}, PL = /* @__PURE__ */ K({
  __name: "OrionPage",
  props: Cp.props,
  setup(e, {
    expose: l
  }) {
    const n = e, t = new Cp(n);
    return l(t.publicInstance), (u, i) => (y(), O("div", RL, [c(t).props.title || u.$slots.actions ? (y(), O("div", {
      key: 0,
      class: z(["orion-page__header", {
        "orion-page__header--unwrap": c(t).props.titleEllipsis
      }])
    }, [A("div", DL, [c(t).props.title ? (y(), O("h1", {
      key: 0,
      class: z(["orion-page__title", {
        "orion-page__title--ellipsis": c(t).props.titleEllipsis
      }])
    }, B(c(t).props.title), 3)) : I("", !0), c(t).props.subtitle ? (y(), O("h3", {
      key: 1,
      class: z(["orion-page__subtitle", {
        "orion-page__subtitle--ellipsis": c(t).props.subtitleEllipsis
      }])
    }, B(c(t).props.subtitle), 3)) : I("", !0)]), u.$slots.actions ? (y(), O("div", NL, [V(u.$slots, "actions")])) : I("", !0)], 2)) : I("", !0), u.$slots.subactions ? (y(), O("div", {
      key: 1,
      class: z(["orion-page__subactions", {
        "orion-page__subactions--sticky": c(t).props.stickySubactions
      }])
    }, [V(u.$slots, "subactions")], 2)) : I("", !0), A("div", LL, [V(u.$slots, "default")])]));
  }
}), ic = {
  install(e, l = "o") {
    e.component(`${tl(l)}Page`, PL);
  }
};
class Tp extends Gl {
  constructor(n, t) {
    super(n, t);
    S(this, "state", fl({
      ...this.sharedState,
      reveal: !1,
      validPassword: !1,
      placementToolTip: "auto"
    }));
  }
  get isValidCustom() {
    var n;
    return typeof this.props.passwordToConfirm == "string" && ((n = this.props.passwordToConfirm) != null && n.length) ? this.props.passwordToConfirm === this.vModel : Ut().check(this.vModel, "password");
  }
  get showState() {
    return super.showState || this.props.passwordTooltip && this.state.hasBeenFocus;
  }
  get tooltipValidationMessages() {
    return this.props.passwordToConfirm !== void 0 ? [{
      message: this.lang.ORION_PASSWORD__VALIDATION_PASWWORD_CONFIRMATION,
      valid: this.isValid.value
    }] : [{
      message: this.lang.ORION_PASSWORD__VALIDATION_HAS_LOWERCASE,
      valid: Ut().check(this.vModel, "hasLowercase")
    }, {
      message: this.lang.ORION_PASSWORD__VALIDATION_HAS_UPPERCASE,
      valid: Ut().check(this.vModel, "hasUppercase")
    }, {
      message: this.lang.ORION_PASSWORD__VALIDATION_HAS_NUMBER,
      valid: Ut().check(this.vModel, "hasNumber")
    }, {
      message: this.lang.ORION_PASSWORD__VALIDATION_LENGTH,
      valid: Ut().check(this.vModel, "length:8,60")
    }];
  }
  get placementToolTip() {
    return this.state.placementToolTip;
  }
  get reveal() {
    return this.state.reveal;
  }
  onMounted() {
    super.onMounted(), this.window && this.window.innerWidth < 600 && (this.state.placementToolTip = "top");
  }
  toggleReveal() {
    this.state.reveal = !this.state.reveal;
  }
}
S(Tp, "props", {
  ...Gl.props,
  // @doc props/passwordTooltip shows the tooltip with the password's rules
  // @doc/fr props/passwordTooltip affiche la une tooltip avec les règles à respecter
  passwordTooltip: Boolean,
  // @doc props/passwordToConfirm if specified, checks the match with the password value
  // @doc/fr props/passwordToConfirm si spécifié, vérifie la correspondance avec le champ de mot de passe dans le cas d'une confirmation
  passwordToConfirm: {
    type: [String, Boolean],
    default: void 0
  },
  // @doc props/type type of the input
  // @doc/fr props/type type du champ
  type: {
    type: String,
    default: "password"
  }
});
const BL = ["type", "disabled", "readonly"], FL = ["innerHTML"], HL = {
  class: "orion-password-popover--password-check"
}, zL = /* @__PURE__ */ K({
  __name: "OrionPassword",
  props: Tp.props,
  emits: ["focus", "blur", "input", "change", "update:modelValue", "clear"],
  setup(e, {
    expose: l,
    emit: n
  }) {
    const t = n, u = e, i = new Tp(u, t);
    return l(i.publicInstance), (s, r) => {
      const o = Bl("v-dropdown");
      return y(), L(o, {
        placement: c(i).placementToolTip,
        triggers: [],
        shown: c(i).isFocus,
        "auto-hide": !1,
        disabled: !s.passwordTooltip
      }, {
        popper: U(() => [A("div", HL, [(y(!0), O(hl, null, Sl(c(i).tooltipValidationMessages, (a, d) => (y(), O("div", {
          key: d,
          class: z(["password-check-line", a.valid ? "text--success" : "text--warning"])
        }, [R(c(Ml), {
          icon: a.valid ? "check" : "triangle_warning"
        }, null, 8, ["icon"]), A("span", null, B(a.message), 1)], 2))), 128))])]),
        default: U(() => [R(c(Dt), ml(c(i).orionFieldBinding, {
          onClear: r[6] || (r[6] = (a) => c(i).clear())
        }), {
          "icon-suffix": U(() => [R(c(Ml), {
            class: "orion-input__reveal",
            icon: c(i).reveal ? "hide" : "show",
            ripple: "default",
            onClick: r[5] || (r[5] = (a) => c(i).toggleReveal())
          }, null, 8, ["icon"])]),
          default: U(() => {
            var a;
            return [vl(A("input", ml({
              ref: c(i)._input,
              "onUpdate:modelValue": r[0] || (r[0] = (d) => c(i).vModel = d),
              class: "orion-input__input",
              type: c(i).reveal ? "text" : "password",
              disabled: s.disabled,
              readonly: s.readonly
            }, s.$attrs, {
              onInput: r[1] || (r[1] = (d) => c(i).handleInput(d)),
              onChange: r[2] || (r[2] = (d) => c(i).handleChange()),
              onFocus: r[3] || (r[3] = (d) => c(i).handleFocus(d)),
              onBlur: r[4] || (r[4] = (d) => c(i).handleBlur(d))
            }), null, 16, BL), [[Kg, c(i).vModel]]), c(i).showState && (c(i).showError || c(i).showWarning) && ((a = c(i).validationHtmlMessages) != null && a.length) ? (y(), O("div", {
              key: 0,
              class: "orion-input__error-message",
              innerHTML: c(i).validationHtmlMessages
            }, null, 8, FL)) : I("", !0)];
          }),
          _: 1
        }, 16)]),
        _: 1
      }, 8, ["placement", "shown", "disabled"]);
    };
  }
}), sc = {
  install(e, l = "o") {
    e.component(`${tl(l)}Password`, zL);
  }
};
class Op extends Gl {
  constructor(n, t) {
    super(n, t);
    S(this, "bus", Ri());
    S(this, "fetchSearchDebounce", Be((n) => {
      this.fetchSearchAsync(n);
    }, this.props.donetyping));
    S(this, "state", fl({
      ...this.sharedState,
      valueToSearch: void 0,
      lastValue: void 0,
      indexNav: -1,
      isFetching: !1,
      fetchResult: []
    }));
    S(this, "_popover", J());
    S(this, "_popoverinner", J());
    S(this, "_optionscontainer", J());
    S(this, "_autocomplete", J());
    S(this, "_optionssearchinput", J());
    S(this, "_items", J([]));
    S(this, "isArray", Il);
    S(this, "get", $s);
    this.emit = t, this.bus.on("*", (u, i) => this.emit(u, i)), Pl(() => this.isObjectType, () => {
      this.checkProps();
    });
  }
  get autocompleteValue() {
    var n;
    return (this.state.isFocus || (n = this.props.prefillSearch) != null && n.length) && !this.props.modelValue ? this.state.isFocus ? this.state.valueToSearch ?? this.props.prefillSearch : this.props.prefillSearch : this.state.isFocus ? this.state.valueToSearch : this.valueDisplay(this.vModel).display;
  }
  set autocompleteValue(n) {
    this.valueToSearch = n;
  }
  get valueToSearch() {
    return this.state.valueToSearch;
  }
  set valueToSearch(n) {
    this.state.valueToSearch = n, n != null && n.length || this.emit("fetch-search-clear"), this.props.fetchUrl || this.props.customFetch ? this.fetchSearchDebounce(n) : rl(this.animate.bind(this)), this.props.autocomplete && !this.props.multiple && !(n != null && n.length) && this.clear();
  }
  get indexNav() {
    return this.state.indexNav;
  }
  set indexNav(n) {
    this.state.indexNav = n;
  }
  get isFetching() {
    return this.state.isFetching;
  }
  get optionsDisplay() {
    return this._items.value.length = 0, this.props.fetchUrl || this.props.customFetch ? this.fetchOptions : (this.props.searchable || this.props.autocomplete) && !Fc(this.state.valueToSearch) ? this.props.customSearch ? this.props.options.filter((n) => {
      var t, u;
      return (u = (t = this.props).customSearch) == null ? void 0 : u.call(t, n, this.state.valueToSearch);
    }) : this.props.options.filter((n) => {
      if (!this.state.valueToSearch)
        return !0;
      const t = this.itemIsObject(n) && this.props.displayKey ? n[this.props.displayKey] : n;
      return this.normalizeString(t).indexOf(this.normalizeString(this.state.valueToSearch)) !== -1;
    }) : this.props.options;
  }
  get fetchOptions() {
    return this.state.fetchResult.length ? this.state.fetchResult : this.props.fetchInitialOptions;
  }
  get hasValue() {
    return this.vModel !== "" && (!this.props.multiple && !In(this.vModel) || this.props.multiple && Il(this.vModel) && !!this.vModel.length);
  }
  get labelIsFloating() {
    var n;
    return this.hasValue || this.props.forceLabelFloating || this.props.autocomplete && this.state.isFocus || !!((n = this.props.prefillSearch) != null && n.length);
  }
  get isObjectType() {
    return !Il(this.vModel) && En(this.vModel) || Il(this.vModel) && En(this.vModel[0]) || Il(this.props.options) && En(this.props.options[0]) || Il(this.fetchOptions) && En(this.fetchOptions[0]);
  }
  get showPopover() {
    return !this.props.autocomplete && this.state.isFocus || this.props.autocomplete && this.state.isFocus && (!!this.optionsDisplay.length || this.state.isFetching) || this.props.autocomplete && this.responsive.onPhone && this.state.isFocus;
  }
  get showPopoverSearch() {
    return this.props.autocomplete && !this.responsive.onPhone ? !1 : this.props.autocomplete && this.responsive.onPhone || this.props.fetchUrl || this.props.customFetch || this.props.searchable && this.props.options.length > 1;
  }
  get publicInstance() {
    return {
      ...super.publicInstance,
      getSearchTerm: () => this.state.valueToSearch,
      setSearchTerm: (n) => this.state.valueToSearch = n
    };
  }
  async onBeforeMount() {
    this.handleFieldEvents(), this.checkProps();
  }
  checkProps() {
    this.props.multiple && !In(this.vModel) && !Il(this.vModel) && Dn.error(`orion-select - prop "multiple" on orion-select requires a v-model of type Array, type ${tl(typeof this.vModel)} detected`), this.isObjectType && !this.props.trackKey && Dn.error('orion-select - items of prop "options" are of type Object but the prop "track-key" is missing');
  }
  itemMatchOption(n, t) {
    return this.isObjectType && this.itemIsObject(n) ? this.props.valueKey ? In(t) ? !1 : t === n[this.props.valueKey] : !In(t) && this.itemIsObject(t) ? t[this.props.trackKey] === n[this.props.trackKey] : !1 : t === n;
  }
  async fetchSearchAsync(n) {
    var t;
    if (!(!In(n) && this.props.fetchMinSearch && n.length && n.length < this.props.fetchMinSearch)) {
      if (this.state.isFetching = !0, this.emit("fetch-start", n), this.props.fetchUrl) {
        const u = {};
        u[this.props.fetchKey] = (t = this.state.valueToSearch) == null ? void 0 : t.trim();
        const i = new URL(this.props.fetchUrl);
        this.props.fetchMethod === "GET" && (i.search = new URLSearchParams(u).toString());
        const s = await fetch(i, {
          method: this.props.fetchMethod,
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "Cache-Control": "no-cache"
          },
          body: this.props.fetchMethod === "POST" ? JSON.stringify(u) : void 0
        });
        this.state.fetchResult = await s.json();
      } else
        this.props.customFetch && (this.state.fetchResult = await this.props.customFetch(n));
      this.state.isFetching = !1, this.emit("fetch-end", this.state.fetchResult), rl(this.animate.bind(this));
    }
  }
  handleFieldEvents() {
    this.bus.on("select", (n) => {
      n && this.itemIsObject(n) && this.props.valueKey ? this.emitValue(n[this.props.valueKey]) : this.emitValue(n), this.props.autocomplete && rl(() => {
        var t;
        this.state.valueToSearch = this.valueDisplay(this.vModel).display, (t = this._autocomplete.value) == null || t.blur();
      });
    }), this.bus.on("add", (n) => {
      let t = Er(this.vModel);
      Il(t) || (t = []), t.push(this.props.valueKey && this.itemIsObject(n) ? n[this.props.valueKey] : n), this.props.autocomplete && (this.state.valueToSearch = void 0), this.emitValue(t);
    }), this.bus.on("remove", (n) => {
      let t = Er(this.vModel), u;
      this.props.valueKey && this.itemIsObject(n) && (n = n[this.props.valueKey]), t != null && t.length ? (this.isObjectType && !this.props.valueKey ? u = t.findIndex((i) => this.itemIsObject(i) && this.itemIsObject(n) && i[this.props.trackKey] === n[this.props.trackKey]) : u = t.findIndex((i) => i === n), u > -1 ? t.splice(u, 1) : Dr.danger(this.lang.ORION_SELECT__REMOVE_VALUE_ERROR)) : t = [], this.emitValue(t);
    });
  }
  emitValue(n) {
    this.state.lastValue = n, this.vModel = n;
  }
  animate() {
    this.props.options.length > 30 ? this._items.value.forEach((n) => n.style.opacity = "1") : El({
      targets: this._items.value.filter((n) => !!n),
      opacity: [0, 1],
      translateY: ["-0.5rem", 0],
      easing: "easeOutSine",
      duration: 450,
      delay: El.stagger(30),
      update: (n) => {
        n.animatables.filter((t) => t.target.classList.contains("disabled")).forEach((t) => {
          Number(t.target.style.opacity) > 0.5 && (t.target.style.opacity = "0.5");
        });
      },
      complete: (n) => {
        n.animatables.forEach((t) => t.target.removeAttribute("style"));
      }
    });
  }
  itemIsObject(n) {
    return En(n);
  }
  valueDisplay(n) {
    const u = (this.props.fetchUrl || this.props.customFetch ? this.fetchOptions : this.props.options).find((i) => this.itemIsObject(i) && this.props.valueKey && i[this.props.valueKey] === n);
    return this.props.valueKey && this.props.displayKey ? u && this.itemIsObject(u) && u[this.props.displayKey] ? {
      display: u[this.props.displayKey],
      item: u
    } : {
      display: n,
      item: n
    } : this.props.displayKey ? n && this.itemIsObject(n) && n[this.props.displayKey] ? {
      display: n[this.props.displayKey],
      item: n
    } : {
      display: n,
      item: u
    } : n && this.props.valueKey ? {
      display: u[this.props.valueKey],
      item: u
    } : {
      display: n,
      item: n
    };
  }
  optionIsSelected(n) {
    let t = !1;
    return this.props.multiple ? Il(this.vModel) && (t = this.vModel.findIndex((i) => this.itemMatchOption(n, i)) > -1) : t = this.itemMatchOption(n, this.vModel), t;
  }
  handlePopoverShow() {
    S3(this._popover, () => this.handleBlur(void 0, !0)), Il(this._items.value) && (this.state.indexNav = this._items.value.findIndex((n) => n.classList.contains("selected")), this.animate()), rl(() => {
      var n, t;
      (this.props.searchable || this.props.fetchUrl || this.props.autocomplete && this.responsive.onPhone) && ((n = this._optionssearchinput.value) == null || n.focus()), this.props.multiple && this.hasValue && ((t = this._autocomplete.value) == null || t.focus());
    });
  }
  handleBlur(n, t) {
    var u;
    if (n != null && n.relatedTarget && (u = n.relatedTarget.parentElement) != null && u.classList.contains("orion-select__popover-search-input"))
      return !1;
    this.state.hasBeenFocus = !0, this.state.indexNav = -1, (!this.responsive.onPhone || t) && (this.state.isFocus = !1), this.blur();
  }
  handleKeydown(n) {
    const t = this._popoverinner.value, u = this._optionscontainer.value;
    if (!u || !t)
      return;
    if (this.state.indexNav === -1)
      return this.state.indexNav = 0, t.scrollTop = 0, !1;
    const i = t.getBoundingClientRect(), s = i.bottom, r = i.top;
    n === "down" && this.state.indexNav < this.optionsDisplay.length - 1 ? this.state.indexNav++ : n === "up" && this.state.indexNav > 0 && this.state.indexNav--;
    const o = u.children[this.state.indexNav].getBoundingClientRect(), a = o.bottom, d = o.top;
    n === "down" && a > s ? t.scrollTop = t.scrollTop + (a - s) : n === "up" && d < r && (t.scrollTop = t.scrollTop - (r - d));
  }
  handleScroll() {
    var n;
    this.responsive.onPhone && ((n = this._optionssearchinput.value) == null || n.blur());
  }
  handleTabEvent() {
    var n;
    this.emit("input-keydown-tab"), (this.props.searchable || this.props.fetchUrl) && ((n = this._input.value) == null || n.focus());
  }
  selectItem(n) {
    this.props.readonly || this.props.disabledKey && $s(n, this.props.disabledKey, !1) || (this.props.multiple ? this.optionIsSelected(n) ? this.bus.emit("remove", n) : this.bus.emit("add", n) : (this.bus.emit("select", n), this.handleBlur(void 0, !0)));
  }
  selectItemFromEnter() {
    var n;
    if (this.state.indexNav >= 0 && this.state.indexNav < this.optionsDisplay.length) {
      const t = this.optionsDisplay[this.state.indexNav];
      this.selectItem(t), this.state.isFocus && !this.props.multiple && this.handleBlur();
    }
    this.responsive.onPhone && ((n = this._optionssearchinput.value) == null || n.blur());
  }
  resetIndex() {
    this.state.indexNav = -1;
  }
  removeIndex(n) {
    if (Il(this.vModel)) {
      const t = this.vModel[n];
      this.bus.emit("remove", t);
    }
  }
  markedSearch(n) {
    return !this.state.valueToSearch || !n ? n : X(n).mark(this.state.valueToSearch);
  }
  normalizeString(n) {
    return n.toLowerCase().normalize("NFD").replace(new RegExp("\\p{Diacritic}", "gu"), "");
  }
}
S(Op, "props", {
  ...Gl.props,
  // @doc props/autocomplete adds the possibility to write in the select field
  // @doc/fr props/autocomplete permet à l'utilisateur d'écrire dans le champ
  autocomplete: Boolean,
  // @doc props/searchable adds a search tooltip
  // @doc/fr props/searchable ajoute un champ de recherche
  searchable: Boolean,
  // @doc props/multiple defines if multiple values can be select in the select
  // @doc/fr props/multiple définit si plusieurs valeurs peuvent être sélectionnées
  multiple: Boolean,
  // @doc props/options options of the select
  // @doc/fr props/options options du select
  options: {
    type: Array,
    default: () => []
  },
  // @doc props/trackKey unique key item
  // @doc/fr props/trackKey clé unique qui va différencier les options
  trackKey: {
    type: String,
    default: "id"
  },
  // @doc props/displayKey key used to display the value in the field
  // @doc/fr props/displayKey clé qui sera affiché au niveau du champ
  displayKey: {
    type: String,
    default: void 0
  },
  // @doc props/valueKey key used as field value
  // @doc/fr props/valueKey clé qui réprésente la valeur d'un élément
  valueKey: {
    type: String,
    default: void 0
  },
  // @doc props/disabledKey disables the selection of the value
  // @doc/fr props/disabledKey empêche la sélection d'un élément s'il possède cette clé
  disabledKey: {
    type: String,
    default: void 0
  },
  // @doc props/customSearch allows you to custom the search function
  // @doc/fr props/customSearch permet de personnaliser la fonction de recherche
  customSearch: {
    type: Function,
    default: void 0
  },
  // @doc props/fetchMethod Method used to fetch the options
  // @doc/fr props/fetchMethod Méthode utilisée pour récupérer les options
  fetchMethod: {
    type: String,
    default: "GET",
    validator: (n) => ["GET", "POST"].includes(n)
  },
  // @doc props/fetchUrl URL to fetch the options
  // @doc/fr props/fetchUrl URL pour récupérer les options
  fetchUrl: {
    type: String,
    default: void 0
  },
  // @doc props/fetchKey key used to pass the research field value as a parameter to fetch the options
  // @doc/fr props/fetchKey clé utilisée pour passer la valeur du champ de recherche comme paramètre pour récupérer les options
  fetchKey: {
    type: String,
    default: "search"
  },
  // @doc props/fetchMinSearch minimum number of caracters to trigger the fetch
  // @doc/fr props/fetchMinSearch nombre de caractères nécessaire pour déclencher l'appel pour récupérer les options
  fetchMinSearch: {
    type: Number,
    default: 1
  },
  // @doc props/fetchInitialOptions initial options before first fetch (when using fetch mecanism)
  // @doc/fr props/fetchInitialOptions options intiales avant le premier fetch (lors de l'utilisation du mécanisme de fetch des options)
  fetchInitialOptions: {
    type: Array,
    default: () => []
  },
  // @doc props/customFetch allows you to custom the fetch function
  // @doc/fr props/customFetch permet de personnaliser la fonction de récupération des options
  customFetch: {
    type: Function,
    default: void 0
  },
  // @doc props/donetyping the duration to trigger the fetch
  // @doc/fr props/donetyping indique après combien de temps après la dernière frappe, la fonction de récupération des options est appelée
  donetyping: {
    type: Number,
    default: 600
  },
  // @doc props/prefillSearch prefill the search field
  // @doc/fr props/prefillSearch pré-rempli le champ de recherche
  prefillSearch: {
    type: String,
    default: void 0
  }
});
const VL = ["tabindex"], jL = {
  key: 0
}, UL = ["onMousedown"], WL = ["innerHTML"], GL = {
  key: 1,
  class: "orion-select__popover-item orion-select__popover-item--noresult"
}, KL = ["onMousedown"], YL = ["innerHTML"], qL = {
  key: 3,
  class: "orion-select__popover-actions"
}, Ly = /* @__PURE__ */ K({
  __name: "OrionSelect",
  props: Op.props,
  emits: ["focus", "blur", "input", "input-keydown-tab", "change", "update:modelValue", "clear", "add", "remove", "select", "fetch-start", "fetch-end", "fetch-search-clear"],
  setup(e, {
    expose: l,
    emit: n
  }) {
    const t = n, u = e, i = new Op(u, t);
    return l(i.publicInstance), (s, r) => {
      const o = Bl("v-dropdown");
      return y(), L(o, {
        ref: c(i)._popover,
        placement: "bottom-start",
        theme: c(i).showPopoverSearch ? "orion-select-searchable" : "orion-select",
        "positioning-disabled": c(i).responsive.onPhone,
        triggers: [],
        shown: c(i).showPopover,
        "auto-hide": !1,
        onApplyShow: r[23] || (r[23] = (a) => c(i).handlePopoverShow())
      }, {
        popper: U(() => [A("div", {
          ref: c(i)._popoverinner,
          class: z(["orion-select__popover", {
            "orion-select-multiple__popover": c(i).props.multiple
          }]),
          onTouchmove: r[21] || (r[21] = kl((a) => c(i).handleScroll(), ["stop"])),
          onScroll: r[22] || (r[22] = kl(() => {
          }, ["stop"]))
        }, [c(i).showPopoverSearch ? (y(), L(c(Di), {
          key: 0,
          ref: c(i)._optionssearchinput,
          modelValue: c(i).valueToSearch,
          "onUpdate:modelValue": r[10] || (r[10] = (a) => c(i).valueToSearch = a),
          label: c(i).lang.SEARCH,
          class: "orion-select__popover-search-input",
          size: "xs",
          "suffix-icon": "search_magnifying_glass",
          enterkeyhint: "search",
          onKeydown: [r[11] || (r[11] = Fn(kl((a) => c(i).handleKeydown("down"), ["prevent", "stop"]), ["down"])), r[12] || (r[12] = Fn(kl((a) => c(i).handleKeydown("up"), ["prevent", "stop"]), ["up"])), r[13] || (r[13] = Fn(kl((a) => c(i).selectItemFromEnter(), ["stop"]), ["enter"])), r[14] || (r[14] = Fn(kl((a) => c(i).handleTabEvent(), ["prevent", "stop"]), ["tab"])), r[15] || (r[15] = Fn(kl((a) => c(i).handleBlur(), ["stop"]), ["esc"]))],
          onBlur: r[16] || (r[16] = (a) => c(i).handleBlur()),
          onInput: r[17] || (r[17] = (a) => c(i).resetIndex())
        }, null, 8, ["modelValue", "label"])) : I("", !0), V(s.$slots, "before-options", {
          options: c(i).optionsDisplay
        }), c(i).optionsDisplay.length === 0 ? (y(), O("div", GL, B(s.fetchUrl ? c(i).lang.ENTER_YOUR_SEARCH_TERM : c(i).lang.NO_RESULT), 1)) : (y(), O("div", {
          key: 2,
          ref: c(i)._optionscontainer,
          onMousemove: r[18] || (r[18] = (a) => c(i).indexNav = -1),
          onTouchmove: r[19] || (r[19] = (a) => c(i).indexNav = -1)
        }, [(y(!0), O(hl, null, Sl(c(i).optionsDisplay, (a, d) => (y(), O("div", {
          key: d,
          ref_for: !0,
          ref: (h) => {
            h && c(i)._items.value.push(h);
          },
          class: z(["orion-select__popover-item", {
            selected: c(i).optionIsSelected(a),
            hover: c(i).indexNav === d,
            disabled: !!c(i).props.disabledKey && !!c(i).get(a, c(i).props.disabledKey, !1)
          }]),
          onMousedown: kl((h) => c(i).selectItem(a), ["prevent"])
        }, [V(s.$slots, "option", {
          item: a,
          index: d,
          markedSearch: c(i).markedSearch.bind(c(i))
        }, () => [A("span", {
          innerHTML: c(i).itemIsObject(a) && c(i).props.displayKey ? c(i).markedSearch(a[c(i).props.displayKey]) : c(i).markedSearch(a)
        }, null, 8, YL)]), s.multiple ? (y(), O(hl, {
          key: 0
        }, [R(c(Ml), {
          icon: "check",
          class: "icon--selected orion-select__icon--internal"
        }), R(c(Ml), {
          icon: "trash_full",
          class: "icon--delete orion-select__icon--internal"
        })], 64)) : I("", !0)], 42, KL))), 128))], 544)), V(s.$slots, "after-options", {
          options: c(i).optionsDisplay
        }), c(i).responsive.onPhone && s.multiple ? (y(), O("div", qL, [R(c(bl), {
          outline: "",
          onClick: r[20] || (r[20] = (a) => c(i).handleBlur(void 0, !0))
        }, {
          default: U(() => [$l(B(c(i).lang.CLOSE_ACTION), 1)]),
          _: 1
        })])) : I("", !0), R(c(te), {
          class: "orion-select__popover-loader",
          size: "sm",
          color: "info",
          visible: c(i).isFetching,
          message: c(i).lang.LOADING_RESULTS
        }, null, 8, ["visible", "message"])], 34)]),
        default: U(() => [R(c(Dt), ml(c(i).orionFieldBinding, {
          "label-is-floating": c(i).labelIsFloating,
          class: ["orion-select", [{
            "orion-select--multiple": c(i).props.multiple
          }, s.$attrs.class]],
          onClear: r[9] || (r[9] = (a) => c(i).clear())
        }), {
          "icon-suffix": U(() => [vl(R(c(Ml), {
            class: z(["orion-input__icon orion-select__carret orion-select__icon--internal", {
              open: c(i).isFocus
            }]),
            icon: "chevron_down",
            loading: c(i).isFetching
          }, null, 8, ["class", "loading"]), [[cn, !c(i).props.autocomplete && (!c(i).props.clearable || c(i).props.clearable && !c(i).hasValue)]])]),
          default: U(() => {
            var a, d;
            return [A("div", {
              ref: c(i)._input,
              class: "orion-input__input",
              tabindex: c(i).props.disabled ? void 0 : 0,
              onFocus: r[3] || (r[3] = (h) => c(i).handleFocus(h)),
              onBlur: r[4] || (r[4] = (h) => c(i).handleBlur(h)),
              onKeydown: [r[5] || (r[5] = Fn((h) => c(i).handleBlur(), ["esc"])), r[6] || (r[6] = Fn(kl((h) => c(i).handleKeydown("down"), ["prevent"]), ["down"])), r[7] || (r[7] = Fn(kl((h) => c(i).handleKeydown("up"), ["prevent"]), ["up"])), r[8] || (r[8] = Fn((h) => c(i).selectItemFromEnter(), ["enter"]))]
            }, [s.multiple && c(i).isArray(c(i).vModel) && ((a = c(i).vModel) != null && a.length) ? (y(), O("div", jL, [(y(!0), O(hl, null, Sl(c(i).vModel, (h, p) => (y(), O("span", {
              key: Number(p),
              class: "orion-select__selected-item"
            }, [c(i).valueDisplay() ? V(s.$slots, "value", Rl(ml({
              key: 0
            }, c(i).valueDisplay(h))), () => [$l(B(c(i).valueDisplay(h).display), 1)]) : I("", !0), !c(i).props.readonly && !c(i).props.disabled ? (y(), O("span", {
              key: 1,
              class: "orion-select__selected-item-remove",
              onMousedown: kl((f) => c(i).removeIndex(p), ["prevent"])
            }, " × ", 40, UL)) : I("", !0)]))), 128))])) : !c(i).props.multiple && !c(i).isArray(c(i).vModel) && c(i).valueDisplay() ? V(s.$slots, "value", Rl(ml({
              key: 1
            }, c(i).valueDisplay(c(i).vModel))), () => [$l(B(c(i).valueDisplay(c(i).vModel).display), 1)]) : I("", !0), c(i).props.autocomplete && (!c(i).props.multiple || c(i).props.multiple && !c(i).hasValue || c(i).props.multiple && c(i).hasValue && c(i).isFocus) ? vl((y(), O("input", {
              key: 2,
              ref: c(i)._autocomplete,
              "onUpdate:modelValue": r[0] || (r[0] = (h) => c(i).autocompleteValue = h),
              type: "text",
              class: z(["orion-input__input orion-select__autocomplete", {
                "orion-select__autocomplete--single": !c(i).props.multiple,
                "orion-select__autocomplete--multiple": c(i).props.multiple
              }]),
              onFocus: r[1] || (r[1] = (h) => c(i).handleFocus(h)),
              onBlur: r[2] || (r[2] = (h) => c(i).handleBlur(h))
            }, null, 34)), [[cs, c(i).autocompleteValue]]) : I("", !0)], 40, VL), c(i).showState && (c(i).showError || c(i).showWarning) && ((d = c(i).validationHtmlMessages) != null && d.length) ? (y(), O("div", {
              key: 0,
              class: "orion-input__error-message",
              innerHTML: c(i).validationHtmlMessages
            }, null, 8, WL)) : I("", !0)];
          }),
          _: 3
        }, 16, ["label-is-floating", "class"])]),
        _: 3
      }, 8, ["theme", "positioning-disabled", "shown"]);
    };
  }
}), rc = {
  install(e, l = "o") {
    e.component(`${tl(l)}Select`, Ly);
  }
};
(function() {
  var e = this;
  function l(C, N) {
    var D = C.split("."), W = e;
    D[0] in W || !W.execScript || W.execScript("var " + D[0]);
    for (var yl; D.length && (yl = D.shift()); )
      D.length || N === void 0 ? W[yl] ? W = W[yl] : W = W[yl] = {} : W[yl] = N;
  }
  function n(C, N) {
    function D() {
    }
    D.prototype = N.prototype, C.M = N.prototype, C.prototype = new D(), C.prototype.constructor = C, C.N = function(W, yl, E) {
      for (var G = Array(arguments.length - 2), il = 2; il < arguments.length; il++)
        G[il - 2] = arguments[il];
      return N.prototype[yl].apply(W, G);
    };
  }
  function t(C, N) {
    C != null && this.a.apply(this, arguments);
  }
  t.prototype.b = "", t.prototype.set = function(C) {
    this.b = "" + C;
  }, t.prototype.a = function(C, N, D) {
    if (this.b += String(C), N != null)
      for (var W = 1; W < arguments.length; W++)
        this.b += arguments[W];
    return this;
  };
  function u(C) {
    C.b = "";
  }
  t.prototype.toString = function() {
    return this.b;
  };
  function i(C, N) {
    C.sort(N || s);
  }
  function s(C, N) {
    return C > N ? 1 : C < N ? -1 : 0;
  }
  function r(C) {
    var N = [], D = 0, W;
    for (W in C)
      N[D++] = C[W];
    return N;
  }
  function o(C, N) {
    this.b = C, this.a = {};
    for (var D = 0; D < N.length; D++) {
      var W = N[D];
      this.a[W.b] = W;
    }
  }
  function a(C) {
    return C = r(C.a), i(C, function(N, D) {
      return N.b - D.b;
    }), C;
  }
  function d(C, N) {
    switch (this.b = C, this.g = !!N.v, this.a = N.c, this.i = N.type, this.h = !1, this.a) {
      case f:
      case m:
      case g:
      case v:
      case w:
      case p:
      case h:
        this.h = !0;
    }
    this.f = N.defaultValue;
  }
  var h = 1, p = 2, f = 3, m = 4, g = 6, v = 16, w = 18;
  function $() {
    this.a = {}, this.f = this.j().a, this.b = this.g = null;
  }
  $.prototype.set = function(C, N) {
    H(this, C.b, N);
  };
  function _(C, N) {
    for (var D = a(C.j()), W = 0; W < D.length; W++) {
      var yl = D[W], E = yl.b;
      if (N.a[E] != null) {
        C.b && delete C.b[yl.b];
        var G = yl.a == 11 || yl.a == 10;
        if (yl.g)
          for (var yl = b(N, E) || [], il = 0; il < yl.length; il++) {
            var wl = C, Tl = E, $n = G ? yl[il].clone() : yl[il];
            wl.a[Tl] || (wl.a[Tl] = []), wl.a[Tl].push($n), wl.b && delete wl.b[Tl];
          }
        else
          yl = b(N, E), G ? (G = b(C, E)) ? _(G, yl) : H(C, E, yl.clone()) : H(C, E, yl);
      }
    }
  }
  $.prototype.clone = function() {
    var C = new this.constructor();
    return C != this && (C.a = {}, C.b && (C.b = {}), _(C, this)), C;
  };
  function b(C, N) {
    var D = C.a[N];
    if (D == null)
      return null;
    if (C.g) {
      if (!(N in C.b)) {
        var W = C.g, yl = C.f[N];
        if (D != null)
          if (yl.g) {
            for (var E = [], G = 0; G < D.length; G++)
              E[G] = W.b(yl, D[G]);
            D = E;
          } else
            D = W.b(yl, D);
        return C.b[N] = D;
      }
      return C.b[N];
    }
    return D;
  }
  function k(C, N, D) {
    var W = b(C, N);
    return C.f[N].g ? W[D || 0] : W;
  }
  function T(C, N) {
    var D;
    if (C.a[N] != null)
      D = k(C, N, void 0);
    else
      l: {
        if (D = C.f[N], D.f === void 0) {
          var W = D.i;
          if (W === Boolean)
            D.f = !1;
          else if (W === Number)
            D.f = 0;
          else if (W === String)
            D.f = D.h ? "0" : "";
          else {
            D = new W();
            break l;
          }
        }
        D = D.f;
      }
    return D;
  }
  function M(C, N) {
    return C.f[N].g ? C.a[N] != null ? C.a[N].length : 0 : C.a[N] != null ? 1 : 0;
  }
  function H(C, N, D) {
    C.a[N] = D, C.b && (C.b[N] = D);
  }
  function x(C, N) {
    var D = [], W;
    for (W in N)
      W != 0 && D.push(new d(W, N[W]));
    return new o(C, D);
  }
  function P() {
    $.call(this);
  }
  n(P, $);
  var Z = null;
  function F() {
    $.call(this);
  }
  n(F, $);
  var el = null;
  function al() {
    $.call(this);
  }
  n(al, $);
  var ll = null;
  P.prototype.j = function() {
    var C = Z;
    return C || (Z = C = x(P, { 0: { name: "NumberFormat", I: "i18n.phonenumbers.NumberFormat" }, 1: { name: "pattern", required: !0, c: 9, type: String }, 2: { name: "format", required: !0, c: 9, type: String }, 3: { name: "leading_digits_pattern", v: !0, c: 9, type: String }, 4: { name: "national_prefix_formatting_rule", c: 9, type: String }, 6: { name: "national_prefix_optional_when_formatting", c: 8, defaultValue: !1, type: Boolean }, 5: { name: "domestic_carrier_code_formatting_rule", c: 9, type: String } })), C;
  }, P.j = P.prototype.j, F.prototype.j = function() {
    var C = el;
    return C || (el = C = x(F, { 0: { name: "PhoneNumberDesc", I: "i18n.phonenumbers.PhoneNumberDesc" }, 2: { name: "national_number_pattern", c: 9, type: String }, 9: { name: "possible_length", v: !0, c: 5, type: Number }, 10: { name: "possible_length_local_only", v: !0, c: 5, type: Number }, 6: { name: "example_number", c: 9, type: String } })), C;
  }, F.j = F.prototype.j, al.prototype.j = function() {
    var C = ll;
    return C || (ll = C = x(al, {
      0: { name: "PhoneMetadata", I: "i18n.phonenumbers.PhoneMetadata" },
      1: { name: "general_desc", c: 11, type: F },
      2: { name: "fixed_line", c: 11, type: F },
      3: { name: "mobile", c: 11, type: F },
      4: { name: "toll_free", c: 11, type: F },
      5: { name: "premium_rate", c: 11, type: F },
      6: { name: "shared_cost", c: 11, type: F },
      7: { name: "personal_number", c: 11, type: F },
      8: { name: "voip", c: 11, type: F },
      21: { name: "pager", c: 11, type: F },
      25: { name: "uan", c: 11, type: F },
      27: { name: "emergency", c: 11, type: F },
      28: { name: "voicemail", c: 11, type: F },
      29: { name: "short_code", c: 11, type: F },
      30: { name: "standard_rate", c: 11, type: F },
      31: { name: "carrier_specific", c: 11, type: F },
      33: { name: "sms_services", c: 11, type: F },
      24: { name: "no_international_dialling", c: 11, type: F },
      9: { name: "id", required: !0, c: 9, type: String },
      10: { name: "country_code", c: 5, type: Number },
      11: { name: "international_prefix", c: 9, type: String },
      17: { name: "preferred_international_prefix", c: 9, type: String },
      12: { name: "national_prefix", c: 9, type: String },
      13: { name: "preferred_extn_prefix", c: 9, type: String },
      15: {
        name: "national_prefix_for_parsing",
        c: 9,
        type: String
      },
      16: { name: "national_prefix_transform_rule", c: 9, type: String },
      18: { name: "same_mobile_and_fixed_line_pattern", c: 8, defaultValue: !1, type: Boolean },
      19: { name: "number_format", v: !0, c: 11, type: P },
      20: { name: "intl_number_format", v: !0, c: 11, type: P },
      22: { name: "main_country_for_code", c: 8, defaultValue: !1, type: Boolean },
      23: { name: "leading_digits", c: 9, type: String },
      26: { name: "leading_zero_possible", c: 8, defaultValue: !1, type: Boolean }
    })), C;
  }, al.j = al.prototype.j;
  function Y() {
  }
  Y.prototype.a = function(C) {
    throw new C.b(), Error("Unimplemented");
  }, Y.prototype.b = function(C, N) {
    if (C.a == 11 || C.a == 10)
      return N instanceof $ ? N : this.a(C.i.prototype.j(), N);
    if (C.a == 14) {
      if (typeof N == "string" && Q.test(N)) {
        var D = Number(N);
        if (0 < D)
          return D;
      }
      return N;
    }
    if (!C.h)
      return N;
    if (D = C.i, D === String) {
      if (typeof N == "number")
        return String(N);
    } else if (D === Number && typeof N == "string" && (N === "Infinity" || N === "-Infinity" || N === "NaN" || Q.test(N)))
      return Number(N);
    return N;
  };
  var Q = /^-?[0-9]+$/;
  function dl() {
  }
  n(dl, Y), dl.prototype.a = function(C, N) {
    var D = new C.b();
    return D.g = this, D.a = N, D.b = {}, D;
  };
  function zl() {
  }
  n(zl, dl), zl.prototype.b = function(C, N) {
    return C.a == 8 ? !!N : Y.prototype.b.apply(this, arguments);
  }, zl.prototype.a = function(C, N) {
    return zl.M.a.call(this, C, N);
  };
  var Xl = {
    1: "US AG AI AS BB BM BS CA DM DO GD GU JM KN KY LC MP MS PR SX TC TT VC VG VI".split(" "),
    7: ["RU", "KZ"],
    20: ["EG"],
    27: ["ZA"],
    30: ["GR"],
    31: ["NL"],
    32: ["BE"],
    33: ["FR"],
    34: ["ES"],
    36: ["HU"],
    39: ["IT", "VA"],
    40: ["RO"],
    41: ["CH"],
    43: ["AT"],
    44: ["GB", "GG", "IM", "JE"],
    45: ["DK"],
    46: ["SE"],
    47: ["NO", "SJ"],
    48: ["PL"],
    49: ["DE"],
    51: ["PE"],
    52: ["MX"],
    53: ["CU"],
    54: ["AR"],
    55: ["BR"],
    56: ["CL"],
    57: ["CO"],
    58: ["VE"],
    60: ["MY"],
    61: ["AU", "CC", "CX"],
    62: ["ID"],
    63: ["PH"],
    64: ["NZ"],
    65: ["SG"],
    66: ["TH"],
    81: ["JP"],
    82: ["KR"],
    84: ["VN"],
    86: ["CN"],
    90: ["TR"],
    91: ["IN"],
    92: ["PK"],
    93: ["AF"],
    94: ["LK"],
    95: ["MM"],
    98: ["IR"],
    211: ["SS"],
    212: ["MA", "EH"],
    213: ["DZ"],
    216: ["TN"],
    218: ["LY"],
    220: ["GM"],
    221: ["SN"],
    222: ["MR"],
    223: ["ML"],
    224: ["GN"],
    225: ["CI"],
    226: ["BF"],
    227: ["NE"],
    228: ["TG"],
    229: ["BJ"],
    230: ["MU"],
    231: ["LR"],
    232: ["SL"],
    233: ["GH"],
    234: ["NG"],
    235: ["TD"],
    236: ["CF"],
    237: ["CM"],
    238: ["CV"],
    239: ["ST"],
    240: ["GQ"],
    241: ["GA"],
    242: ["CG"],
    243: ["CD"],
    244: ["AO"],
    245: ["GW"],
    246: ["IO"],
    247: ["AC"],
    248: ["SC"],
    249: ["SD"],
    250: ["RW"],
    251: ["ET"],
    252: ["SO"],
    253: ["DJ"],
    254: ["KE"],
    255: ["TZ"],
    256: ["UG"],
    257: ["BI"],
    258: ["MZ"],
    260: ["ZM"],
    261: ["MG"],
    262: ["RE", "YT"],
    263: ["ZW"],
    264: ["NA"],
    265: ["MW"],
    266: ["LS"],
    267: ["BW"],
    268: ["SZ"],
    269: ["KM"],
    290: ["SH", "TA"],
    291: ["ER"],
    297: ["AW"],
    298: ["FO"],
    299: ["GL"],
    350: ["GI"],
    351: ["PT"],
    352: ["LU"],
    353: ["IE"],
    354: ["IS"],
    355: ["AL"],
    356: ["MT"],
    357: ["CY"],
    358: ["FI", "AX"],
    359: ["BG"],
    370: ["LT"],
    371: ["LV"],
    372: ["EE"],
    373: ["MD"],
    374: ["AM"],
    375: ["BY"],
    376: ["AD"],
    377: ["MC"],
    378: ["SM"],
    380: ["UA"],
    381: ["RS"],
    382: ["ME"],
    383: ["XK"],
    385: ["HR"],
    386: ["SI"],
    387: ["BA"],
    389: ["MK"],
    420: ["CZ"],
    421: ["SK"],
    423: ["LI"],
    500: ["FK"],
    501: ["BZ"],
    502: ["GT"],
    503: ["SV"],
    504: ["HN"],
    505: ["NI"],
    506: ["CR"],
    507: ["PA"],
    508: ["PM"],
    509: ["HT"],
    590: ["GP", "BL", "MF"],
    591: ["BO"],
    592: ["GY"],
    593: ["EC"],
    594: ["GF"],
    595: ["PY"],
    596: ["MQ"],
    597: ["SR"],
    598: ["UY"],
    599: ["CW", "BQ"],
    670: ["TL"],
    672: ["NF"],
    673: ["BN"],
    674: ["NR"],
    675: ["PG"],
    676: ["TO"],
    677: ["SB"],
    678: ["VU"],
    679: ["FJ"],
    680: ["PW"],
    681: ["WF"],
    682: ["CK"],
    683: ["NU"],
    685: ["WS"],
    686: ["KI"],
    687: ["NC"],
    688: ["TV"],
    689: ["PF"],
    690: ["TK"],
    691: ["FM"],
    692: ["MH"],
    800: ["001"],
    808: ["001"],
    850: ["KP"],
    852: ["HK"],
    853: ["MO"],
    855: ["KH"],
    856: ["LA"],
    870: ["001"],
    878: ["001"],
    880: ["BD"],
    881: ["001"],
    882: ["001"],
    883: ["001"],
    886: ["TW"],
    888: ["001"],
    960: ["MV"],
    961: ["LB"],
    962: ["JO"],
    963: ["SY"],
    964: ["IQ"],
    965: ["KW"],
    966: ["SA"],
    967: ["YE"],
    968: ["OM"],
    970: ["PS"],
    971: ["AE"],
    972: ["IL"],
    973: ["BH"],
    974: ["QA"],
    975: ["BT"],
    976: ["MN"],
    977: ["NP"],
    979: ["001"],
    992: ["TJ"],
    993: ["TM"],
    994: ["AZ"],
    995: ["GE"],
    996: ["KG"],
    998: ["UZ"]
  }, sn = {
    800: [null, [
      null,
      null,
      "\\d{8}",
      null,
      null,
      null,
      null,
      null,
      null,
      [8]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "\\d{8}", null, null, null, "12345678"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "001", 800, null, null, null, null, null, null, null, 1, [[null, "(\\d{4})(\\d{4})", "$1 $2"]], null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    808: [null, [null, null, "\\d{8}", null, null, null, null, null, null, [8]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      "\\d{8}",
      null,
      null,
      null,
      "12345678"
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "001", 808, null, null, null, null, null, null, null, 1, [[null, "(\\d{4})(\\d{4})", "$1 $2"]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    870: [null, [
      null,
      null,
      "[35-7]\\d{8}",
      null,
      null,
      null,
      null,
      null,
      null,
      [9]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "(?:[356]\\d|7[6-8])\\d{7}", null, null, null, "301234567"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "001", 870, null, null, null, null, null, null, null, null, [[null, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]], null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    878: [null, [null, null, "10\\d{10}", null, null, null, null, null, null, [12]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "10\\d{10}", null, null, null, "101234567890"], "001", 878, null, null, null, null, null, null, null, 1, [[null, "(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    881: [null, [
      null,
      null,
      "[67]\\d{8}",
      null,
      null,
      null,
      null,
      null,
      null,
      [9]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "[67]\\d{8}", null, null, null, "612345678"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "001", 881, null, null, null, null, null, null, null, null, [[
      null,
      "(\\d)(\\d{3})(\\d{5})",
      "$1 $2 $3",
      ["[67]"]
    ]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    882: [null, [null, null, "[13]\\d{6}(?:\\d{2,5})?|1\\d{7}", null, null, null, null, null, null, [7, 8, 9, 10, 11, 12]], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      "3(?:(?:(?:2|7\\d{3})\\d|37)\\d\\d|4(?:2|7\\d{3}))\\d{4}",
      null,
      null,
      null,
      "3421234",
      null,
      null,
      [7, 9, 10, 12]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "(?:1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])|6\\d{1,6})|3(?:45|9\\d{3})\\d{3})\\d{4}", null, null, null, "390123456789"], "001", 882, null, null, null, null, null, null, null, null, [[null, "(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], [
      null,
      "(\\d{2})(\\d{2})(\\d{4})",
      "$1 $2 $3",
      ["1"]
    ], [null, "(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], [null, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"]], [null, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["34[57]"]], [null, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], [null, "(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[13]"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [
      null,
      null,
      "348[57]\\d{7}",
      null,
      null,
      null,
      "34851234567",
      null,
      null,
      [11]
    ]],
    883: [
      null,
      [null, null, "51\\d{7}(?:\\d{3})?", null, null, null, null, null, null, [9, 12]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "51[013]0\\d{8}|5100\\d{5}", null, null, null, "510012345"],
      "001",
      883,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      1,
      [[null, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], [null, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["510"]], [null, "(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["5"]]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    888: [null, [
      null,
      null,
      "\\d{11}",
      null,
      null,
      null,
      null,
      null,
      null,
      [11]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "001", 888, null, null, null, null, null, null, null, 1, [[null, "(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "\\d{11}", null, null, null, "12345678901"], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    979: [null, [null, null, "\\d{9}", null, null, null, null, null, null, [9]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "\\d{9}", null, null, null, "123456789"], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "001", 979, null, null, null, null, null, null, null, 1, [[null, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3"]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    AC: [null, [
      null,
      null,
      "(?:[01589]\\d|[46])\\d{4}",
      null,
      null,
      null,
      null,
      null,
      null,
      [5, 6]
    ], [null, null, "6[2-467]\\d{3}", null, null, null, "62889", null, null, [5]], [null, null, "4\\d{4}", null, null, null, "40123", null, null, [5]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "AC", 247, "00", null, null, null, null, null, null, null, null, null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "[01589]\\d{5}", null, null, null, "542011", null, null, [6]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    AD: [null, [null, null, "(?:1|6\\d)\\d{7}|[136-9]\\d{5}", null, null, null, null, null, null, [6, 8, 9]], [null, null, "[78]\\d{5}", null, null, null, "712345", null, null, [6]], [null, null, "690\\d{6}|[36]\\d{5}", null, null, null, "312345", null, null, [6, 9]], [
      null,
      null,
      "180[02]\\d{4}",
      null,
      null,
      null,
      "18001234",
      null,
      null,
      [8]
    ], [null, null, "[19]\\d{5}", null, null, null, "912345", null, null, [6]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "AD", 376, "00", null, null, null, null, null, null, null, [[null, "(\\d{3})(\\d{3})", "$1 $2", ["[136-9]"]], [null, "(\\d{4})(\\d{4})", "$1 $2", ["1"]], [null, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [
      null,
      null,
      "1800\\d{4}",
      null,
      null,
      null,
      null,
      null,
      null,
      [8]
    ], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    AE: [
      null,
      [null, null, "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", null, null, null, null, null, null, [5, 6, 7, 8, 9, 10, 11, 12]],
      [null, null, "[2-4679][2-8]\\d{6}", null, null, null, "22345678", null, null, [8], [7]],
      [null, null, "5[024-68]\\d{7}", null, null, null, "501234567", null, null, [9]],
      [null, null, "400\\d{6}|800\\d{2,9}", null, null, null, "800123456"],
      [
        null,
        null,
        "900[02]\\d{5}",
        null,
        null,
        null,
        "900234567",
        null,
        null,
        [9]
      ],
      [null, null, "700[05]\\d{5}", null, null, null, "700012345", null, null, [9]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "AE",
      971,
      "00",
      "0",
      null,
      null,
      "0",
      null,
      null,
      null,
      [[null, "(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], [null, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], [null, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], [null, "(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "600[25]\\d{5}", null, null, null, "600212345", null, null, [9]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    AF: [
      null,
      [null, null, "[2-7]\\d{8}", null, null, null, null, null, null, [9], [7]],
      [null, null, "(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}", null, null, null, "234567890", null, null, null, [7]],
      [null, null, "7(?:[014-9]\\d|2[89]|3[01])\\d{6}", null, null, null, "701234567"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "AF",
      93,
      "00",
      "0",
      null,
      null,
      "0",
      null,
      null,
      null,
      [[null, "(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]], [null, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]],
      [[null, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]],
      [
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        [-1]
      ],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    AG: [null, [null, null, "(?:268|[58]\\d\\d|900)\\d{7}", null, null, null, null, null, null, [10], [7]], [null, null, "268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}", null, null, null, "2684601234", null, null, null, [7]], [
      null,
      null,
      "268(?:464|7(?:1[3-9]|2\\d|3[246]|64|[78][0-689]))\\d{4}",
      null,
      null,
      null,
      "2684641234",
      null,
      null,
      null,
      [7]
    ], [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002123456"], [null, null, "900[2-9]\\d{6}", null, null, null, "9002123456"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"], [null, null, "26848[01]\\d{4}", null, null, null, "2684801234", null, null, null, [7]], "AG", 1, "011", "1", null, null, "1", null, null, null, null, null, [null, null, "26840[69]\\d{4}", null, null, null, "2684061234", null, null, null, [7]], null, "268", [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    AI: [
      null,
      [null, null, "(?:264|[58]\\d\\d|900)\\d{7}", null, null, null, null, null, null, [10], [7]],
      [null, null, "2644(?:6[12]|9[78])\\d{4}", null, null, null, "2644612345", null, null, null, [7]],
      [null, null, "264(?:235|476|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}", null, null, null, "2642351234", null, null, null, [7]],
      [
        null,
        null,
        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
        null,
        null,
        null,
        "8002123456"
      ],
      [null, null, "900[2-9]\\d{6}", null, null, null, "9002123456"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "AI",
      1,
      "011",
      "1",
      null,
      null,
      "1",
      null,
      null,
      null,
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      "264",
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    AL: [null, [null, null, "(?:(?:[2-58]|6\\d)\\d\\d|700)\\d{5}|(?:8\\d{2,3}|900)\\d{3}", null, null, null, null, null, null, [6, 7, 8, 9], [5]], [null, null, "(?:[2358](?:[16-9]\\d[2-9]|[2-5][2-9]\\d)|4(?:[2-57-9][2-9]|6\\d)\\d)\\d{4}", null, null, null, "22345678", null, null, [8], [5, 6, 7]], [null, null, "6(?:[689][2-9]|7[2-6])\\d{6}", null, null, null, "662123456", null, null, [9]], [null, null, "800\\d{4}", null, null, null, "8001234", null, null, [7]], [
      null,
      null,
      "900[1-9]\\d\\d",
      null,
      null,
      null,
      "900123",
      null,
      null,
      [6]
    ], [null, null, "808[1-9]\\d\\d", null, null, null, "808123", null, null, [6]], [null, null, "700[2-9]\\d{4}", null, null, null, "70021234", null, null, [8]], [null, null, null, null, null, null, null, null, null, [-1]], "AL", 355, "00", "0", null, null, "0", null, null, null, [[null, "(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], [null, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], [null, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], [null, "(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], [
      null,
      "(\\d{2})(\\d{3})(\\d{4})",
      "$1 $2 $3",
      ["6"],
      "0$1"
    ]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    AM: [null, [null, null, "(?:[1-489]\\d|55|60|77)\\d{6}", null, null, null, null, null, null, [8], [5, 6]], [
      null,
      null,
      "(?:(?:1[0-2]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}",
      null,
      null,
      null,
      "10123456",
      null,
      null,
      null,
      [5, 6]
    ], [null, null, "(?:4[1349]|55|77|88|9[13-9])\\d{6}", null, null, null, "77123456"], [null, null, "800\\d{5}", null, null, null, "80012345"], [null, null, "90[016]\\d{5}", null, null, null, "90012345"], [null, null, "80[1-4]\\d{5}", null, null, null, "80112345"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|90)\\d{4}", null, null, null, "60271234"], "AM", 374, "00", "0", null, null, "0", null, null, null, [
      [null, "(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"],
      [null, "(\\d{3})(\\d{5})", "$1 $2", ["[23]"], "(0$1)"],
      [null, "(\\d{2})(\\d{6})", "$1 $2", ["[4-7]|88|9[13-9]"], "0$1"],
      [null, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]"], "0 $1"]
    ], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    AO: [
      null,
      [null, null, "[29]\\d{8}", null, null, null, null, null, null, [9]],
      [
        null,
        null,
        "2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}",
        null,
        null,
        null,
        "222123456"
      ],
      [null, null, "9[1-49]\\d{7}", null, null, null, "923123456"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "AO",
      244,
      "00",
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [[null, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    AR: [
      null,
      [null, null, "(?:11|(?:[2368]|9\\d)\\d)\\d{8}", null, null, null, null, null, null, [10, 11], [6, 7, 8]],
      [
        null,
        null,
        "11\\d{8}|(?:2(?:2(?:[013]\\d|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:[07]\\d|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|6[013-9])|4(?:7[3-8]|9\\d)|6(?:[01346]\\d|2[24-6]|5[15-8])|80\\d|9(?:[012789]\\d|3[1-6]|4[02-9]|5[234]|6[2-46]))|3(?:3(?:2[79]|6\\d|8[2578])|4(?:0[0124-9]|[1-357]\\d|4[24-7]|6[02-9]|8[0-79]|9[1236-8])|5(?:[138]\\d|2[1245]|4[1-9]|6[2-4]|7[1-6])|6[24]\\d|7(?:[069]\\d|1[1568]|2[013-9]|3[145]|4[0-35-9]|5[14-8]|7[2-57]|8[0-24-9])|8(?:[01578]\\d|2[15-7]|3[0-24-9]|4[13-6]|6[1-357-9]|9[124]))|670\\d)\\d{6}",
        null,
        null,
        null,
        "1123456789",
        null,
        null,
        [10],
        [6, 7, 8]
      ],
      [
        null,
        null,
        "675\\d{7}|9(?:11[2-9]\\d{7}|(?:2(?:2[013]|3[067]|49|6[01346]|80|9[147-9])|3(?:36|4[1-358]|5[138]|6[24]|7[069]|8[013578]))[2-9]\\d{6}|(?:2(?:2(?:02|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8])|47[3-578]|6(?:2[24-6]|4[6-8]|5[15-8])|9(?:0[1-3]|2\\d|3[1-6]|4[02568]|5[2-4]|6[2-46]|72|8[23]))|3(?:3(?:2[79]|8[2578])|4(?:0[0-24-9]|4[24-7]|6[02-9]|7[126]|9[1-36-8])|5(?:2[1245]|3[237]|4[1-46-9]|6[2-4]|7[1-6]|8[2-5])|7(?:1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:2[15-7]|3[2578]|4[13-6]|5[4-8]|6[1-357-9]|9[124])))[2-9]\\d{5})",
        null,
        null,
        null,
        "91123456789",
        null,
        null,
        null,
        [6, 7, 8]
      ],
      [null, null, "800\\d{7}", null, null, null, "8001234567", null, null, [10]],
      [null, null, "60[04579]\\d{7}", null, null, null, "6001234567", null, null, [10]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "AR",
      54,
      "00",
      "0",
      null,
      null,
      "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))?15)?",
      "9$1",
      null,
      null,
      [[null, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], [null, "(\\d{2})(\\d{4})", "$1-$2", ["[2-9]"], "$1"], [null, "(\\d{3})(\\d{4})", "$1-$2", ["[2-9]"], "$1"], [null, "(\\d{4})(\\d{4})", "$1-$2", ["[2-9]"], "$1"], [null, "(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["911"], "0$1"], [null, "(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", [
        "9(?:2[2-4689]|3[3-8])",
        "9(?:2(?:2[013]|3[067]|49|6[01346]|8|9[147-9])|3(?:36|4[1-358]|5[138]|6|7[069]|8[013578]))",
        "9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[4-6]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))",
        "9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1-39])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))"
      ], "0$1"], [null, "(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9[23]"], "0$1"], [null, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["11"], "0$1", null, 1], [null, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", [
        "2(?:2[013]|3[067]|49|6[01346]|8|9[147-9])|3(?:36|4[1-358]|5[138]|6|7[069]|8[013578])",
        "2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[4-6]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))",
        "2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1-39])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))"
      ], "0$1", null, 1], [null, "(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", null, 1], [null, "(\\d{3})", "$1", ["1[0-2]|911"], "$1"]],
      [
        [null, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"],
        [null, "(\\d)(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3-$4", ["911"]],
        [
          null,
          "(\\d)(\\d{3})(\\d{3})(\\d{4})",
          "$1 $2 $3-$4",
          ["9(?:2[2-4689]|3[3-8])", "9(?:2(?:2[013]|3[067]|49|6[01346]|8|9[147-9])|3(?:36|4[1-358]|5[138]|6|7[069]|8[013578]))", "9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[4-6]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))", "9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1-39])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))"]
        ],
        [null, "(\\d)(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3-$4", ["9[23]"]],
        [null, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["11"], "0$1", null, 1],
        [
          null,
          "(\\d{3})(\\d{3})(\\d{4})",
          "$1 $2-$3",
          ["2(?:2[013]|3[067]|49|6[01346]|8|9[147-9])|3(?:36|4[1-358]|5[138]|6|7[069]|8[013578])", "2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[4-6]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))", "2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1-39])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))"],
          "0$1",
          null,
          1
        ],
        [null, "(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", null, 1]
      ],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, "810\\d{7}", null, null, null, null, null, null, [10]],
      [null, null, "810\\d{7}", null, null, null, "8101234567", null, null, [10]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    AS: [
      null,
      [null, null, "(?:[58]\\d\\d|684|900)\\d{7}", null, null, null, null, null, null, [10], [7]],
      [
        null,
        null,
        "6846(?:22|33|44|55|77|88|9[19])\\d{4}",
        null,
        null,
        null,
        "6846221234",
        null,
        null,
        null,
        [7]
      ],
      [null, null, "684(?:2(?:5[2468]|72)|7(?:3[13]|70))\\d{4}", null, null, null, "6847331234", null, null, null, [7]],
      [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002123456"],
      [null, null, "900[2-9]\\d{6}", null, null, null, "9002123456"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "AS",
      1,
      "011",
      "1",
      null,
      null,
      "1",
      null,
      null,
      null,
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      "684",
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    AT: [null, [null, null, "[1-35-9]\\d{8,12}|4(?:[0-24-9]\\d{4,11}|3(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7}))|[1-35-8]\\d{7}|[1-35-7]\\d{6}|[135-7]\\d{5}|[15]\\d{4}|1\\d{3}", null, null, null, null, null, null, [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [3]], [
      null,
      null,
      "(?:1(?:11|[2-9]\\d{2,10})|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-8]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|7(?:2[1-8]|3[25]|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{3,9}|4(?:(?:2[1-8]|35|7[1368]|8[2457])\\d{3,9}|63\\d{2,9})|5(?:12\\d{2,9}|(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])\\d{3,9})|6(?:(?:13|2[1-47]|4[135-8]|5[468])\\d{3,9}|62\\d{2,9}))\\d|(?:316|732)\\d{3}",
      null,
      null,
      null,
      "1234567890",
      null,
      null,
      null,
      [3]
    ], [
      null,
      null,
      "6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}",
      null,
      null,
      null,
      "664123456",
      null,
      null,
      [7, 8, 9, 10, 11, 12, 13]
    ], [null, null, "800\\d{6,10}", null, null, null, "800123456", null, null, [9, 10, 11, 12, 13]], [null, null, "9(?:0[01]|3[019])\\d{6,10}", null, null, null, "900123456", null, null, [9, 10, 11, 12, 13]], [null, null, "8(?:10|2[018])\\d{6,10}|828\\d{5}", null, null, null, "810123456", null, null, [8, 9, 10, 11, 12, 13]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}", null, null, null, "780123456", null, null, [
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13
    ]], "AT", 43, "00", "0", null, null, "0", null, null, null, [[null, "(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], [null, "(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], [null, "(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], [null, "(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], [null, "(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], [null, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], [null, "(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    AU: [null, [null, null, "1\\d{4,9}|(?:[2-478]\\d\\d|550)\\d{6}", null, null, null, null, null, null, [5, 6, 7, 8, 9, 10]], [
      null,
      null,
      "(?:[237]\\d{5}|8(?:51(?:0(?:0[03-9]|[1247]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-6])|1(?:1[69]|[23]\\d|4[0-4]))|(?:[6-8]\\d{3}|9(?:[02-9]\\d\\d|1(?:[0-57-9]\\d|6[0135-9])))\\d))\\d{3}",
      null,
      null,
      null,
      "212345678",
      null,
      null,
      [9],
      [8]
    ], [null, null, "4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[6-9]|7[02-9]|8[0-2457-9]|9[017-9])\\d{6}", null, null, null, "412345678", null, null, [9]], [null, null, "180(?:0\\d{3}|2)\\d{3}", null, null, null, "1800123456", null, null, [7, 10]], [null, null, "190[0-26]\\d{6}", null, null, null, "1900123456", null, null, [10]], [null, null, "13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}", null, null, null, "1300123456", null, null, [6, 8, 10]], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      "(?:14(?:5\\d|71)|550\\d)\\d{5}",
      null,
      null,
      null,
      "550123456",
      null,
      null,
      [9]
    ], "AU", 61, "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "0", null, null, "0", null, "0011", null, [[null, "(\\d{3})(\\d{3})", "$1 $2", ["19"]], [null, "(\\d{4})(\\d{3,4})", "$1 $2", ["19"]], [null, "(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], [null, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["13"]], [null, "(\\d{3})(\\d{4})", "$1 $2", ["180", "1802"]], [null, "(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], [null, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], [
      null,
      "(\\d{3})(\\d{3})(\\d{3})",
      "$1 $2 $3",
      ["14|[45]"],
      "0$1"
    ], [null, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], [[null, "(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], [null, "(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], [null, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], [null, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|[45]"], "0$1"], [null, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], [null, null, "16\\d{3,7}", null, null, null, "1612345", null, null, [5, 6, 7, 8, 9]], 1, null, [
      null,
      null,
      "1[38]00\\d{6}|1(?:345[0-4]|802)\\d{3}|13\\d{4}",
      null,
      null,
      null,
      null,
      null,
      null,
      [6, 7, 8, 10]
    ], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    AW: [
      null,
      [null, null, "(?:[25-79]\\d\\d|800)\\d{4}", null, null, null, null, null, null, [7]],
      [null, null, "5(?:2\\d|8[1-9])\\d{4}", null, null, null, "5212345"],
      [null, null, "(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}", null, null, null, "5601234"],
      [
        null,
        null,
        "800\\d{4}",
        null,
        null,
        null,
        "8001234"
      ],
      [null, null, "900\\d{4}", null, null, null, "9001234"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "(?:28\\d|501)\\d{4}", null, null, null, "5011234"],
      "AW",
      297,
      "00",
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [[null, "(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    AX: [null, [null, null, "(?:(?:[1247]\\d|3[0-46-9]|[56]0)\\d\\d|800)\\d{4,6}|(?:[1-47]\\d|50)\\d{4,5}|2\\d{4}", null, null, null, null, null, null, [5, 6, 7, 8, 9, 10]], [null, null, "18[1-8]\\d{3,6}", null, null, null, "181234567", null, null, [6, 7, 8, 9]], [null, null, "(?:4[0-8]|50)\\d{4,8}", null, null, null, "412345678", null, null, [6, 7, 8, 9, 10]], [null, null, "800\\d{4,6}", null, null, null, "800123456", null, null, [7, 8, 9]], [
      null,
      null,
      "[67]00\\d{5,6}",
      null,
      null,
      null,
      "600123456",
      null,
      null,
      [8, 9]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "AX", 358, "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "0", null, null, "0", null, "00", null, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, "18", [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      "(?:10|[23][09])\\d{4,8}|60(?:[12]\\d{5,6}|6\\d{7})|7(?:(?:1|3\\d)\\d{7}|5[03-9]\\d{3,7})|20[2-59]\\d\\d",
      null,
      null,
      null,
      "10112345"
    ], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    AZ: [null, [null, null, "(?:(?:(?:[12457]\\d|60|88)\\d|365)\\d{3}|900200)\\d{3}", null, null, null, null, null, null, [9], [7]], [null, null, "(?:(?:1[28]\\d|2(?:[045]2|1[24]|2[2-4]|33|6[23]))\\d\\d|365(?:[0-46-9]\\d|5[0-35-9]))\\d{4}", null, null, null, "123123456", null, null, null, [7]], [null, null, "(?:36554|(?:4[04]|5[015]|60|7[07])\\d{3})\\d{4}", null, null, null, "401234567"], [null, null, "88\\d{7}", null, null, null, "881234567"], [
      null,
      null,
      "900200\\d{3}",
      null,
      null,
      null,
      "900200123"
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "AZ", 994, "00", "0", null, null, "0", null, null, null, [[null, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3"], [null, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[12]|365", "[12]|365", "[12]|365(?:[0-46-9]|5[0-35-9])"], "(0$1)"], [null, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], [
      null,
      "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
      "$1 $2 $3 $4",
      ["[3-8]"],
      "0$1"
    ]], [[null, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[12]|365", "[12]|365", "[12]|365(?:[0-46-9]|5[0-35-9])"], "(0$1)"], [null, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], [null, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[3-8]"], "0$1"]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ]],
    BA: [
      null,
      [null, null, "(?:[3589]\\d|49|6\\d\\d?|70)\\d{6}", null, null, null, null, null, null, [8, 9], [6]],
      [null, null, "(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}", null, null, null, "30212345", null, null, [8], [6]],
      [null, null, "6(?:0(?:3\\d|40)|[1-356]\\d|44[0-6]|71[137])\\d{5}", null, null, null, "61123456"],
      [null, null, "8[08]\\d{6}", null, null, null, "80123456", null, null, [8]],
      [
        null,
        null,
        "9[0246]\\d{6}",
        null,
        null,
        null,
        "90123456",
        null,
        null,
        [8]
      ],
      [null, null, "8[12]\\d{6}", null, null, null, "82123456", null, null, [8]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "BA",
      387,
      "00",
      "0",
      null,
      null,
      "0",
      null,
      null,
      null,
      [[null, "(\\d{3})(\\d{3})", "$1-$2", ["[2-9]"]], [null, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]"], "0$1"], [null, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-356]|[7-9]"], "0$1"], [null, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]],
      [[null, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]"], "0$1"], [null, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-356]|[7-9]"], "0$1"], [null, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "70(?:3[0146]|[56]0)\\d{4}", null, null, null, "70341234", null, null, [8]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    BB: [null, [
      null,
      null,
      "(?:246|[58]\\d\\d|900)\\d{7}",
      null,
      null,
      null,
      null,
      null,
      null,
      [10],
      [7]
    ], [null, null, "246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}", null, null, null, "2464123456", null, null, null, [7]], [null, null, "246(?:2(?:[356]\\d|4[0-57-9]|8[0-79])|45\\d|69[5-7]|8(?:[2-5]\\d|83))\\d{4}", null, null, null, "2462501234", null, null, null, [7]], [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002123456"], [
      null,
      null,
      "(?:246976|900[2-9]\\d\\d)\\d{4}",
      null,
      null,
      null,
      "9002123456",
      null,
      null,
      null,
      [7]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"], [null, null, "24631\\d{5}", null, null, null, "2463101234", null, null, null, [7]], "BB", 1, "011", "1", null, null, "1", null, null, null, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, "246", [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      "246(?:292|367|4(?:1[7-9]|3[01]|44|67)|7(?:36|53))\\d{4}",
      null,
      null,
      null,
      "2464301234",
      null,
      null,
      null,
      [7]
    ], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    BD: [
      null,
      [null, null, "[13469]\\d{9}|8[0-79]\\d{7,8}|[2-7]\\d{8}|[2-9]\\d{7}|[3-689]\\d{6}|[57-9]\\d{5}", null, null, null, null, null, null, [6, 7, 8, 9, 10]],
      [
        null,
        null,
        "(?:(?:2(?:[45]\\d{3}|7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|[13][1-6]|2[0157-9]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[01367]|7[15]|8[0146-9]))|7(?:02|21\\d|[3-589]1|6[12]|72[24])\\d|8(?:(?:[01]|217|3[12])\\d|4[12]|[5-7](?:1\\d|2)))\\d|3(?:(?:0(?:2[348]\\d|3[2-6])|(?:1(?:2[5-7]|[5-7])|3(?:1|24)|[5-7]1)\\d)\\d|2(?:1\\d\\d|2(?:[35]\\d\\d|4))|4(?:1\\d\\d|2(?:[25]\\d\\d|[47]))|8(?:1\\d\\d|2(?:(?:2\\d|4)\\d|3)))|4(?:0(?:2(?:[09]\\d|7)|33\\d\\d)|(?:1\\d|4(?:2[2-46]|5[25])|8(?:23|54))\\d\\d|2(?:1\\d\\d|2(?:[25]|[67]\\d\\d))|3(?:1\\d\\d(?:\\d{2})?|(?:2[236-9]|32)\\d\\d)|525|6(?:(?:[18]|2[3-6]|62)\\d\\d|5(?:[38]|[5-7]\\d\\d))|9(?:(?:[18]|2[2-5])\\d\\d|53\\d\\d?))|5(?:(?:02[03489]|1|22[2457]|32[35-79]|42[46]|[58]26|724)\\d\\d|6(?:(?:[18]|53)\\d\\d|2))|6(?:(?:(?:[04]2[34]|32[3478]|52[47]|[78]2[2-5]|92[2-6])\\d|6(?:[18]\\d|6(?:2(?:2|[34]\\d)|5[245]\\d)))\\d|2(?:(?:2[2-5]|8)\\d\\d|5(?:[3-5]\\d\\d|7)))|9(?:[24]1\\d\\d|[35]1))\\d{3}|(?:3(?:0(?:2[02-9]\\d|3[56])|(?:22[1-5]|32[2-6]|422)\\d|529)|(?:4(?:22[2-8]|32[02-9]|(?:[48][18]|71)\\d|5(?:1\\d|23)|6(?:2[467]|5[3-57]))|5(?:[2-47-9]1\\d|5(?:1\\d|26))|6(?:0(?:1\\d|24)|[3-589]1\\d|665[35])|81|9(?:[024]2|1\\d|81))\\d|732)\\d{3}|(?:4[46]23|5(?:222|32[37]))\\d{3}",
        null,
        null,
        null,
        "27111234"
      ],
      [null, null, "(?:1[13-9]\\d|(?:3[78]|44)[02-9]|6(?:44|6[02-9]))\\d{7}", null, null, null, "1812345678", null, null, [10]],
      [null, null, "80[03]\\d{7}", null, null, null, "8001234567", null, null, [10]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "96(?:0[469]|1[0-47]|3[389]|6[69]|7[78])\\d{6}", null, null, null, "9604123456", null, null, [10]],
      "BD",
      880,
      "00",
      "0",
      null,
      null,
      "0",
      null,
      null,
      null,
      [[null, "(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-7]|[459]1"], "0$1"], [null, "(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[2-5]1|[67]|8[013-9])|4(?:[235]1|4[01346-9]|6[168]|7|[89][18])|5(?:[2-578]1|6[128]|9)|6(?:[0389]1|28|4[14]|5|6[01346-9])|7(?:[2-589]|61)|8(?:0[014-9]|[12]|[3-7]1)|9(?:[24]1|[358])"], "0$1"], [null, "(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]"], "0$1"], [null, "(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        [-1]
      ],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    BE: [null, [null, null, "4\\d{8}|[1-9]\\d{7}", null, null, null, null, null, null, [8, 9]], [null, null, "(?:(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|9[2-4])\\d|8(?:0[2-8]|[1-79]\\d))\\d{5}", null, null, null, "12345678", null, null, [8]], [null, null, "4(?:5[56]|6[0135-8]|[79]\\d|8[3-9])\\d{6}", null, null, null, "470123456", null, null, [9]], [
      null,
      null,
      "800[1-9]\\d{4}",
      null,
      null,
      null,
      "80012345",
      null,
      null,
      [8]
    ], [null, null, "(?:70(?:2[0-57]|3[0457]|44|69|7[0579])|90(?:0[0-35-8]|1[36]|2[0-3568]|3[0135689]|4[2-68]|5[1-68]|6[0-378]|7[23568]|9[34679]))\\d{4}", null, null, null, "90012345", null, null, [8]], [null, null, "7879\\d{4}", null, null, null, "78791234", null, null, [8]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "BE", 32, "00", "0", null, null, "0", null, null, null, [[null, "(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[23]|4[23]|9[2-4]"], "0$1"], [
      null,
      "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
      "$1 $2 $3 $4",
      ["[15-7]|8(?:0[2-8]|[1-79])"],
      "0$1"
    ], [null, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"], [null, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "78(?:0[57]|1[0458]|2[25]|3[5-8]|48|[56]0|7[078])\\d{4}", null, null, null, "78102345", null, null, [8]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    BF: [null, [null, null, "[25-7]\\d{7}", null, null, null, null, null, null, [8]], [null, null, "2(?:0(?:49|5[23]|6[56]|9[016-9])|4(?:4[569]|5[4-6]|6[56]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}", null, null, null, "20491234"], [null, null, "(?:5[124-8]|[67]\\d)\\d{6}", null, null, null, "70123456"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], "BF", 226, "00", null, null, null, null, null, null, null, [[null, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[25-7]"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    BG: [
      null,
      [null, null, "[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", null, null, null, null, null, null, [6, 7, 8, 9], [4, 5]],
      [
        null,
        null,
        "(?:(?:[236]\\d|5[1-9]|8[1-6]|9[1-7])\\d|4(?:[124-7]\\d|3[1-6])|7(?:0[1-9]|[1-9]\\d))\\d{4,5}|2\\d{5}",
        null,
        null,
        null,
        "2123456",
        null,
        null,
        [6, 7, 8],
        [4, 5]
      ],
      [null, null, "(?:4(?:3[07-9]|8\\d)|(?:8[7-9]\\d|9(?:8\\d|9[69]))\\d)\\d{5}", null, null, null, "48123456", null, null, [8, 9]],
      [null, null, "800\\d{5}", null, null, null, "80012345", null, null, [8]],
      [null, null, "90\\d{6}", null, null, null, "90123456", null, null, [8]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "700\\d{5}", null, null, null, "70012345", null, null, [8]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "BG",
      359,
      "00",
      "0",
      null,
      null,
      "0",
      null,
      null,
      null,
      [[null, "(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], [null, "(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], [null, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], [null, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], [null, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|70[1-9]"], "0$1"], [null, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["7|80"], "0$1"], [null, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], [
        null,
        "(\\d{3})(\\d{3})(\\d{3})",
        "$1 $2 $3",
        ["9"],
        "0$1"
      ]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    BH: [null, [null, null, "[136-9]\\d{7}", null, null, null, null, null, null, [8]], [null, null, "(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|7[7-9])|9[69][69])|7(?:1(?:11|78)|7\\d\\d))\\d{4}", null, null, null, "17001234"], [
      null,
      null,
      "(?:3(?:[1-4679]\\d|5[013-69]|8[0-47-9])\\d|6(?:3(?:00|33|6[16])|6(?:3[03-9]|[69]\\d|7[0-6])))\\d{4}",
      null,
      null,
      null,
      "36001234"
    ], [null, null, "80\\d{6}", null, null, null, "80123456"], [null, null, "(?:87|9[014578])\\d{6}", null, null, null, "90123456"], [null, null, "84\\d{6}", null, null, null, "84123456"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "BH", 973, "00", null, null, null, null, null, null, null, [[null, "(\\d{4})(\\d{4})", "$1 $2", ["[1367]|8[047]|9[014578]"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    BI: [null, [null, null, "(?:[267]\\d|31)\\d{6}", null, null, null, null, null, null, [8]], [null, null, "22\\d{6}", null, null, null, "22201234"], [null, null, "(?:29|31|6[189]|7[125-9])\\d{6}", null, null, null, "79561234"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], "BI", 257, "00", null, null, null, null, null, null, null, [[null, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[23]|6[189]|7[125-9]"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    BJ: [null, [
      null,
      null,
      "[2689]\\d{7}",
      null,
      null,
      null,
      null,
      null,
      null,
      [8]
    ], [null, null, "2(?:02|1[037]|2[45]|3[68])\\d{5}", null, null, null, "20211234"], [null, null, "(?:6\\d|9[03-9])\\d{6}", null, null, null, "90011234"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "857[58]\\d{4}", null, null, null, "85751234"], "BJ", 229, "00", null, null, null, null, null, null, null, [[
      null,
      "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
      "$1 $2 $3 $4",
      ["[2689]"]
    ]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "81\\d{6}", null, null, null, "81123456"], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    BL: [null, [null, null, "(?:590|69\\d)\\d{6}", null, null, null, null, null, null, [9]], [null, null, "590(?:2[7-9]|5[12]|87)\\d{4}", null, null, null, "590271234"], [null, null, "69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}", null, null, null, "690001234"], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "BL", 590, "00", "0", null, null, "0", null, null, null, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ]],
    BM: [null, [null, null, "(?:441|[58]\\d\\d|900)\\d{7}", null, null, null, null, null, null, [10], [7]], [null, null, "441(?:2(?:02|23|[3479]\\d|61)|[46]\\d\\d|5(?:4\\d|60|89)|824)\\d{4}", null, null, null, "4412345678", null, null, null, [7]], [null, null, "441(?:[37]\\d|5[0-39])\\d{5}", null, null, null, "4413701234", null, null, null, [7]], [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002123456"], [null, null, "900[2-9]\\d{6}", null, null, null, "9002123456"], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"], [null, null, null, null, null, null, null, null, null, [-1]], "BM", 1, "011", "1", null, null, "1", null, null, null, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, "441", [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    BN: [
      null,
      [
        null,
        null,
        "[2-578]\\d{6}",
        null,
        null,
        null,
        null,
        null,
        null,
        [7]
      ],
      [null, null, "(?:2(?:[013-9]\\d|2[0-7])|[3-5]\\d\\d)\\d{4}", null, null, null, "2345678"],
      [null, null, "(?:22[89]|[78]\\d\\d)\\d{4}", null, null, null, "7123456"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "BN",
      673,
      "00",
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [[null, "(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    BO: [null, [null, null, "(?:[2-467]\\d{3}|80017)\\d{4}", null, null, null, null, null, null, [8, 9], [7]], [
      null,
      null,
      "(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}",
      null,
      null,
      null,
      "22123456",
      null,
      null,
      [8],
      [7]
    ], [null, null, "[67]\\d{7}", null, null, null, "71234567", null, null, [8]], [null, null, "80017\\d{4}", null, null, null, "800171234", null, null, [9]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "BO", 591, "00(?:1\\d)?", "0", null, null, "0(1\\d)?", null, null, null, [
      [null, "(\\d)(\\d{7})", "$1 $2", ["[2-4]"], null, "0$CC $1"],
      [null, "(\\d{8})", "$1", ["[67]"], null, "0$CC $1"],
      [null, "(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"], null, "0$CC $1"]
    ], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    BQ: [
      null,
      [null, null, "(?:[34]1|7\\d)\\d{5}", null, null, null, null, null, null, [7]],
      [
        null,
        null,
        "(?:318[023]|41(?:6[023]|70)|7(?:1[578]|50)\\d)\\d{3}",
        null,
        null,
        null,
        "7151234"
      ],
      [null, null, "(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}", null, null, null, "3181234"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "BQ",
      599,
      "00",
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      "[347]",
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    BR: [
      null,
      [null, null, "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-24679]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", null, null, null, null, null, null, [8, 9, 10, 11]],
      [null, null, "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}", null, null, null, "1123456789", null, null, [10], [8]],
      [
        null,
        null,
        "(?:[189][1-9]|2[12478])(?:7|9\\d)\\d{7}|(?:3[1-578]|[46][1-9]|5[13-5]|7[13-579])(?:[6-9]|9\\d)\\d{7}",
        null,
        null,
        null,
        "11961234567",
        null,
        null,
        [10, 11],
        [8]
      ],
      [null, null, "800\\d{6,7}", null, null, null, "800123456", null, null, [9, 10]],
      [null, null, "(?:300|[59]00\\d?)\\d{6}", null, null, null, "300123456", null, null, [9, 10]],
      [null, null, "(?:300\\d(?:\\d{2})?|4(?:0(?:0\\d|20)|370))\\d{4}", null, null, null, "40041234", null, null, [8, 10]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "BR",
      55,
      "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
      "0",
      null,
      null,
      "0(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
      "$2",
      null,
      null,
      [[null, "(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "300|4(?:0(?:0|20)|370)"]], [null, "(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["[3589]00"], "0$1"], [null, "(\\d{3,5})", "$1", ["1[125689]"]], [null, "(\\d{4})(\\d{4})", "$1-$2", ["[2-9](?:0[1-9]|[1-9])"]], [null, "(\\d{5})(\\d{4})", "$1-$2", ["9(?:0[1-9]|[1-9])"]], [null, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["[1-9][1-9]"], "($1)", "0 $CC ($1)"], [null, "(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[1-9][1-9]9"], "($1)", "0 $CC ($1)"]],
      [[
        null,
        "(\\d{4})(\\d{4})",
        "$1-$2",
        ["300|4(?:0[02]|37)", "300|4(?:0(?:0|20)|370)"]
      ], [null, "(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["[3589]00"], "0$1"], [null, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["[1-9][1-9]"], "($1)", "0 $CC ($1)"], [null, "(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[1-9][1-9]9"], "($1)", "0 $CC ($1)"]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, "(?:300\\d|40(?:0\\d|20))\\d{4}", null, null, null, null, null, null, [8]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        [-1]
      ]
    ],
    BS: [null, [null, null, "(?:242|[58]\\d\\d|900)\\d{7}", null, null, null, null, null, null, [10], [7]], [null, null, "242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-4]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}", null, null, null, "2423456789", null, null, null, [7]], [
      null,
      null,
      "242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|[89]9))\\d{4}",
      null,
      null,
      null,
      "2423591234",
      null,
      null,
      null,
      [7]
    ], [null, null, "(?:242300|8(?:00|33|44|55|66|77|88)[2-9]\\d\\d)\\d{4}", null, null, null, "8002123456", null, null, null, [7]], [null, null, "900[2-9]\\d{6}", null, null, null, "9002123456"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"], [null, null, null, null, null, null, null, null, null, [-1]], "BS", 1, "011", "1", null, null, "1", null, null, null, null, null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], null, "242", [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "242225[0-46-9]\\d{3}", null, null, null, "2422250123"], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    BT: [null, [null, null, "[17]\\d{7}|[2-8]\\d{6}", null, null, null, null, null, null, [7, 8], [6]], [null, null, "(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}", null, null, null, "2345678", null, null, [7], [6]], [null, null, "(?:1[67]|77)\\d{6}", null, null, null, "17123456", null, null, [8]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "BT", 975, "00", null, null, null, null, null, null, null, [[null, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[23568]|4[5-7]|7[246]"]], [null, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    BW: [null, [null, null, "(?:(?:[2-6]|7\\d)\\d|90)\\d{5}", null, null, null, null, null, null, [7, 8]], [null, null, "(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[01])|4(?:6[03]|7[1267]|9[0-5])|5(?:3[0389]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[067]))\\d{4}", null, null, null, "2401234", null, null, [7]], [
      null,
      null,
      "7(?:[1-6]\\d{3}|7(?:[014-8]\\d\\d|200))\\d{3}",
      null,
      null,
      null,
      "71123456",
      null,
      null,
      [8]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "90\\d{5}", null, null, null, "9012345", null, null, [7]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "79(?:1(?:[01]\\d|20)|2[0-2]\\d)\\d{3}", null, null, null, "79101234", null, null, [8]], "BW", 267, "00", null, null, null, null, null, null, null, [[null, "(\\d{3})(\\d{4})", "$1 $2", ["[2-6]"]], [null, "(\\d{2})(\\d{5})", "$1 $2", ["90"]], [
      null,
      "(\\d{2})(\\d{3})(\\d{3})",
      "$1 $2 $3",
      ["7"]
    ]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    BY: [
      null,
      [null, null, "(?:(?:[12]|8[0-7]\\d)\\d|33|44|902)\\d{7}|8(?:[05-79]\\d|1[0-489])\\d{7}|8[0-79]\\d{5,7}|8\\d{5}", null, null, null, null, null, null, [6, 7, 8, 9, 10, 11], [5]],
      [
        null,
        null,
        "(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}",
        null,
        null,
        null,
        "152450911",
        null,
        null,
        [9],
        [5, 6, 7]
      ],
      [null, null, "(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}", null, null, null, "294911911", null, null, [9]],
      [null, null, "8(?:0[013]|20\\d)\\d{7}|800\\d{3,6}", null, null, null, "8011234567"],
      [null, null, "(?:810|902)\\d{7}", null, null, null, "9021234567", null, null, [10]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "249\\d{6}", null, null, null, "249123456", null, null, [9]],
      "BY",
      375,
      "810",
      "8",
      null,
      null,
      "0|80?",
      null,
      "8~10",
      null,
      [[null, "(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], [null, "(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], [null, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:5[24]|6[235]|7[467])|2(?:1[246]|2[25]|3[26])", "1(?:5[24]|6(?:2|3[04-9]|5[0346-9])|7(?:[46]|7[37-9]))|2(?:1[246]|2[25]|3[26])"], "8 0$1"], [null, "(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:[56]|7[179])|2[1-3]", "1(?:[56]|7(?:1[3-9]|7|9[2-7]))|2[1-3]"], "8 0$1"], [
        null,
        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
        "$1 $2-$3-$4",
        ["[1-4]"],
        "8 0$1"
      ], [null, "(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, "(?:8(?:0[013]|10|20\\d)|902)\\d{7}|800\\d{3,6}"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    BZ: [null, [null, null, "(?:0800\\d|[2-8])\\d{6}", null, null, null, null, null, null, [7, 11]], [
      null,
      null,
      "(?:2(?:[02]\\d|36)|[3-58][02]\\d|7(?:[02]\\d|32))\\d{4}",
      null,
      null,
      null,
      "2221234",
      null,
      null,
      [7]
    ], [null, null, "6[0-35-7]\\d{5}", null, null, null, "6221234", null, null, [7]], [null, null, "0800\\d{7}", null, null, null, "08001234123", null, null, [11]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "BZ", 501, "00", null, null, null, null, null, null, null, [[null, "(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], [
      null,
      "(\\d)(\\d{3})(\\d{4})(\\d{3})",
      "$1-$2-$3-$4",
      ["0"]
    ]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    CA: [null, [null, null, "(?:[2-8]\\d|90)\\d{8}", null, null, null, null, null, null, [10], [7]], [
      null,
      null,
      "(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|65)|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:04|13|39|47)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",
      null,
      null,
      null,
      "5062345678",
      null,
      null,
      null,
      [7]
    ], [null, null, "(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|65)|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:04|13|39|47)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}", null, null, null, "5062345678", null, null, null, [7]], [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002123456"], [null, null, "900[2-9]\\d{6}", null, null, null, "9002123456"], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      "(?:5(?:00|2[12]|33|44|66|77|88)|622)[2-9]\\d{6}",
      null,
      null,
      null,
      "5002345678"
    ], [null, null, "600[2-9]\\d{6}", null, null, null, "6002012345"], "CA", 1, "011", "1", null, null, "1", null, null, 1, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    CC: [null, [null, null, "1\\d{5,9}|(?:[48]\\d\\d|550)\\d{6}", null, null, null, null, null, null, [6, 7, 8, 9, 10]], [
      null,
      null,
      "8(?:51(?:0(?:02|31|60)|118)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",
      null,
      null,
      null,
      "891621234",
      null,
      null,
      [9],
      [8]
    ], [null, null, "4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[6-9]|7[02-9]|8[0-2457-9]|9[017-9])\\d{6}", null, null, null, "412345678", null, null, [9]], [null, null, "180(?:0\\d{3}|2)\\d{3}", null, null, null, "1800123456", null, null, [7, 10]], [null, null, "190[0-26]\\d{6}", null, null, null, "1900123456", null, null, [10]], [null, null, "13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}", null, null, null, "1300123456", null, null, [6, 8, 10]], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      "(?:14(?:5\\d|71)|550\\d)\\d{5}",
      null,
      null,
      null,
      "550123456",
      null,
      null,
      [9]
    ], "CC", 61, "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "0", null, null, "0|([59]\\d{7})$", "8$1", "0011", null, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    CD: [null, [null, null, "[189]\\d{8}|[1-68]\\d{6}", null, null, null, null, null, null, [7, 9]], [
      null,
      null,
      "12\\d{7}|[1-6]\\d{6}",
      null,
      null,
      null,
      "1234567"
    ], [null, null, "(?:8(?:[0-2459]\\d\\d|8)|9[017-9]\\d\\d)\\d{5}", null, null, null, "991234567"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "CD", 243, "00", "0", null, null, "0", null, null, null, [[null, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], [
      null,
      "(\\d{2})(\\d{5})",
      "$1 $2",
      ["[1-6]"],
      "0$1"
    ], [null, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [null, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    CF: [
      null,
      [null, null, "(?:[27]\\d{3}|8776)\\d{4}", null, null, null, null, null, null, [8]],
      [null, null, "2[12]\\d{6}", null, null, null, "21612345"],
      [null, null, "7[0257]\\d{6}", null, null, null, "70012345"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "8776\\d{4}", null, null, null, "87761234"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "CF",
      236,
      "00",
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [[null, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        [-1]
      ],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    CG: [null, [null, null, "(?:(?:0\\d|80)\\d|222)\\d{6}", null, null, null, null, null, null, [9]], [null, null, "222[1-589]\\d{5}", null, null, null, "222123456"], [null, null, "0[14-6]\\d{7}", null, null, null, "061234567"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "80(?:0\\d\\d|11[0-4])\\d{4}", null, null, null, "800123456"], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "CG", 242, "00", null, null, null, null, null, null, null, [[null, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["801"]], [null, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]], [null, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    CH: [
      null,
      [null, null, "8\\d{11}|[2-9]\\d{8}", null, null, null, null, null, null, [9, 12]],
      [null, null, "(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}", null, null, null, "212345678", null, null, [9]],
      [null, null, "7[35-9]\\d{7}", null, null, null, "781234567", null, null, [9]],
      [null, null, "800\\d{6}", null, null, null, "800123456", null, null, [9]],
      [null, null, "90[016]\\d{6}", null, null, null, "900123456", null, null, [9]],
      [
        null,
        null,
        "84[0248]\\d{6}",
        null,
        null,
        null,
        "840123456",
        null,
        null,
        [9]
      ],
      [null, null, "878\\d{6}", null, null, null, "878123456", null, null, [9]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "CH",
      41,
      "00",
      "0",
      null,
      null,
      "0",
      null,
      null,
      null,
      [[null, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]|[89]1"], "0$1"], [null, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|9"], "0$1"], [null, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]],
      null,
      [null, null, "74[0248]\\d{6}", null, null, null, "740123456", null, null, [9]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "5[18]\\d{7}", null, null, null, "581234567", null, null, [9]],
      null,
      null,
      [null, null, "860\\d{9}", null, null, null, "860123456789", null, null, [12]]
    ],
    CI: [null, [null, null, "[02-8]\\d{7}", null, null, null, null, null, null, [8]], [null, null, "(?:2(?:0[023]|1[02357]|[23][045]|4[03-5])|3(?:0[06]|1[069]|[2-4][07]|5[09]|6[08]))\\d{5}", null, null, null, "21234567"], [null, null, "(?:[07][1-9]|[45]\\d|6[014-9]|8[4-9])\\d{6}", null, null, null, "01234567"], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "CI", 225, "00", null, null, null, null, null, null, null, [[null, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[02-8]"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    CK: [null, [null, null, "[2-8]\\d{4}", null, null, null, null, null, null, [5]], [null, null, "(?:2\\d|3[13-7]|4[1-5])\\d{3}", null, null, null, "21234"], [null, null, "[5-8]\\d{4}", null, null, null, "71234"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], "CK", 682, "00", null, null, null, null, null, null, null, [[null, "(\\d{2})(\\d{3})", "$1 $2", ["[2-8]"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    CL: [null, [null, null, "(?:1230|[2-57-9]\\d|6\\d{1,3})\\d{7}", null, null, null, null, null, null, [9, 10, 11]], [
      null,
      null,
      "(?:2(?:1962|(?:2\\d\\d|32[0-46-8])\\d)|(?:(?:3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|9[2-9])\\d|8(?:0[1-9]|[1-9]\\d))\\d\\d)\\d{4}",
      null,
      null,
      null,
      "221234567",
      null,
      null,
      [9]
    ], [null, null, "(?:2(?:1962|(?:2\\d\\d|32[0-46-8])\\d)|(?:(?:3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|9[2-9])\\d|8(?:0[1-9]|[1-9]\\d))\\d\\d)\\d{4}", null, null, null, "221234567", null, null, [9]], [null, null, "(?:1230\\d|800)\\d{6}", null, null, null, "800123456", null, null, [9, 11]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "600\\d{7,8}", null, null, null, "6001234567", null, null, [10, 11]], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      "44\\d{7}",
      null,
      null,
      null,
      "441234567",
      null,
      null,
      [9]
    ], "CL", 56, "(?:0|1(?:1[0-69]|2[0-57]|5[13-58]|69|7[0167]|8[018]))0", null, null, null, null, null, null, 1, [[null, "(\\d{4})", "$1", ["1(?:[03-58]|[29]1)"]], [null, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2(?:2|32)", "2(?:2|32[0-46-8])"], "($1)"], [null, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], [null, "(\\d{5})(\\d{4})", "$1 $2", ["2"], "($1)"], [null, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], [
      null,
      "(\\d{2})(\\d{3})(\\d{4})",
      "$1 $2 $3",
      ["44"]
    ], [null, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[68]00"]], [null, "(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["600"]], [null, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], [[null, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2(?:2|32)", "2(?:2|32[0-46-8])"], "($1)"], [null, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], [null, "(\\d{5})(\\d{4})", "$1 $2", ["2"], "($1)"], [null, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], [
      null,
      "(\\d{2})(\\d{3})(\\d{4})",
      "$1 $2 $3",
      ["44"]
    ], [null, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[68]00"]], [null, "(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["600"]], [null, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, "600\\d{7,8}", null, null, null, null, null, null, [10, 11]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    CM: [null, [
      null,
      null,
      "(?:[26]\\d\\d|88)\\d{6}",
      null,
      null,
      null,
      null,
      null,
      null,
      [8, 9]
    ], [null, null, "2(?:22|33|4[23])\\d{6}", null, null, null, "222123456", null, null, [9]], [null, null, "6[5-9]\\d{7}", null, null, null, "671234567", null, null, [9]], [null, null, "88\\d{6}", null, null, null, "88012345", null, null, [8]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "CM", 237, "00", null, null, null, null, null, null, null, [[
      null,
      "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
      "$1 $2 $3 $4",
      ["88"]
    ], [null, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    CN: [null, [
      null,
      null,
      "(?:(?:(?:1[03-68]|2\\d)\\d\\d|[3-79])\\d|8[0-57-9])\\d{7}|[1-579]\\d{10}|8[0-57-9]\\d{8,9}|[1-79]\\d{9}|[1-9]\\d{7}|[12]\\d{6}",
      null,
      null,
      null,
      null,
      null,
      null,
      [7, 8, 9, 10, 11, 12],
      [5, 6]
    ], [
      null,
      null,
      "21(?:100\\d{2}|95\\d{3,4}|\\d{8,10})|(?:10|2[02-57-9]|3(?:11|7[179])|4(?:[15]1|3[1-35])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:31|5[457]|6[09]|91)|8(?:[57]1|98))(?:100\\d{2}|95\\d{3,4}|\\d{8})|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|3[3-9]|5[2-9]|6[4789]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-4689]|6[2368]|9[02-9])|8(?:078|1[236-8]|2[5-7]|3\\d|5[1-9]|7[02-9]|8[3678]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100\\d{2}|95\\d{3,4}|\\d{7})",
      null,
      null,
      null,
      "1012345678",
      null,
      null,
      null,
      [5, 6]
    ], [null, null, "1(?:[38]\\d{3}|4[57]\\d{2}|5[0-35-9]\\d{2}|6[267]\\d{2}|7(?:[0-35-8]\\d{2}|40[0-5])|9[189]\\d{2})\\d{6}", null, null, null, "13123456789", null, null, [11]], [null, null, "(?:10)?800\\d{7}", null, null, null, "8001234567", null, null, [10, 12]], [null, null, "16[08]\\d{5}", null, null, null, "16812345", null, null, [8]], [
      null,
      null,
      "400\\d{7}|950\\d{7,8}|(?:10|2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[4789]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[3678]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}",
      null,
      null,
      null,
      "4001234567",
      null,
      null,
      [7, 8, 9, 10, 11],
      [5, 6]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "CN", 86, "(?:1(?:[12]\\d{3}|79\\d{2}|9[0-7]\\d{2}))?00", "0", null, null, "0|(1(?:[12]\\d{3}|79\\d{2}|9[0-7]\\d{2}))", null, "00", null, [
      [null, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[48]00"]],
      [null, "(\\d{5,6})", "$1", ["100|95"]],
      [null, "(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2\\d)[19]", "(?:10|2\\d)(?:10|9[56])", "(?:10|2\\d)(?:100|9[56])"], "0$1", "$CC $1"],
      [null, "(\\d{3})(\\d{5,6})", "$1 $2", ["[3-9]", "[3-9]\\d\\d[19]", "[3-9]\\d\\d(?:10|9[56])"], "0$1", "$CC $1"],
      [null, "(\\d{3,4})(\\d{4})", "$1 $2", ["[2-9]"]],
      [null, "(\\d{2})(\\d{4})(\\d{4,6})", "$1 $2 $3", ["21"], "0$1", "$CC $1", 1],
      [null, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10[1-9]|2[02-9]", "10[1-9]|2[02-9]", "10(?:[1-79]|8(?:0[1-9]|[1-9]))|2[02-9]"], "0$1", "$CC $1", 1],
      [
        null,
        "(\\d{3})(\\d{3})(\\d{4})",
        "$1 $2 $3",
        ["3(?:1[02-9]|35|49|5|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|[35][2-9]|6[47-9]|7|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[04-9]|4[3-6]|6[2368])|8(?:1[236-8]|2[5-7]|3|5[1-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])"],
        "0$1",
        "$CC $1",
        1
      ],
      [null, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["3(?:11|7[179])|4(?:[15]1|3[1-35])|5(?:1|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[457]|6[09])|8(?:[57]1|98)"], "0$1", "$CC $1", 1],
      [null, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["807", "8078"], "0$1", "$CC $1", 1],
      [null, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1(?:[3-57-9]|6[267])"], null, "$CC $1"],
      [null, "(\\d{5})(\\d{3})(\\d{4})", "$1 $2 $3", ["108", "1080", "10800"]],
      [null, "(\\d{3})(\\d{7,8})", "$1 $2", ["950"]]
    ], [
      [
        null,
        "(\\d{3})(\\d{3})(\\d{4})",
        "$1 $2 $3",
        ["[48]00"]
      ],
      [null, "(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2\\d)[19]", "(?:10|2\\d)(?:10|9[56])", "(?:10|2\\d)(?:100|9[56])"], "0$1", "$CC $1"],
      [null, "(\\d{3})(\\d{5,6})", "$1 $2", ["[3-9]", "[3-9]\\d\\d[19]", "[3-9]\\d\\d(?:10|9[56])"], "0$1", "$CC $1"],
      [null, "(\\d{2})(\\d{4})(\\d{4,6})", "$1 $2 $3", ["21"], "0$1", "$CC $1", 1],
      [null, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10[1-9]|2[02-9]", "10[1-9]|2[02-9]", "10(?:[1-79]|8(?:0[1-9]|[1-9]))|2[02-9]"], "0$1", "$CC $1", 1],
      [
        null,
        "(\\d{3})(\\d{3})(\\d{4})",
        "$1 $2 $3",
        ["3(?:1[02-9]|35|49|5|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|[35][2-9]|6[47-9]|7|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[04-9]|4[3-6]|6[2368])|8(?:1[236-8]|2[5-7]|3|5[1-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])"],
        "0$1",
        "$CC $1",
        1
      ],
      [null, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["3(?:11|7[179])|4(?:[15]1|3[1-35])|5(?:1|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[457]|6[09])|8(?:[57]1|98)"], "0$1", "$CC $1", 1],
      [null, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["807", "8078"], "0$1", "$CC $1", 1],
      [null, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1(?:[3-57-9]|6[267])"], null, "$CC $1"],
      [null, "(\\d{5})(\\d{3})(\\d{4})", "$1 $2 $3", ["108", "1080", "10800"]],
      [null, "(\\d{3})(\\d{7,8})", "$1 $2", ["950"]]
    ], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, "(?:4|(?:10)?8)00\\d{7}|950\\d{7,8}", null, null, null, null, null, null, [10, 11, 12]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ]],
    CO: [null, [null, null, "(?:1\\d|3)\\d{9}|[124-8]\\d{7}", null, null, null, null, null, null, [8, 10, 11], [7]], [null, null, "[124-8][2-9]\\d{6}", null, null, null, "12345678", null, null, [8], [7]], [null, null, "3(?:0[0-5]|1\\d|2[0-3]|5[01])\\d{7}", null, null, null, "3211234567", null, null, [10]], [null, null, "1800\\d{7}", null, null, null, "18001234567", null, null, [11]], [null, null, "19(?:0[01]|4[78])\\d{7}", null, null, null, "19001234567", null, null, [11]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "CO", 57, "00(?:4(?:[14]4|56)|[579])", "0", null, null, "0([3579]|4(?:[14]4|56))?", null, null, null, [[null, "(\\d)(\\d{7})", "$1 $2", ["1(?:[2-79]|8[2-9])|[24-8]"], "($1)", "0$CC $1"], [null, "(\\d{3})(\\d{7})", "$1 $2", ["3"], null, "0$CC $1"], [null, "(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1(?:80|9)", "1(?:800|9)"], "0$1"]], [[null, "(\\d)(\\d{7})", "$1 $2", ["1(?:[2-79]|8[2-9])|[24-8]"], "($1)", "0$CC $1"], [
      null,
      "(\\d{3})(\\d{7})",
      "$1 $2",
      ["3"],
      null,
      "0$CC $1"
    ], [null, "(\\d)(\\d{3})(\\d{7})", "$1 $2 $3", ["1(?:80|9)", "1(?:800|9)"]]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    CR: [
      null,
      [null, null, "(?:8\\d|90)\\d{8}|[24-8]\\d{7}", null, null, null, null, null, null, [8, 10]],
      [
        null,
        null,
        "2(?:[024-7]\\d\\d|1(?:0[7-9]|[1-9]\\d))\\d{4}",
        null,
        null,
        null,
        "22123456",
        null,
        null,
        [8]
      ],
      [null, null, "(?:(?:5(?:0[01]|7[0-3])|(?:7[0-3]|8[3-9])\\d)\\d\\d|6(?:[0-4]\\d{3}|500[01]))\\d{3}", null, null, null, "83123456", null, null, [8]],
      [null, null, "800\\d{7}", null, null, null, "8001234567", null, null, [10]],
      [null, null, "90[059]\\d{7}", null, null, null, "9001234567", null, null, [10]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "(?:210[0-6]|4\\d{3}|5100)\\d{4}", null, null, null, "40001234", null, null, [8]],
      "CR",
      506,
      "00",
      null,
      null,
      null,
      "(19(?:0[0-2468]|1[09]|20|66|77|99))",
      null,
      null,
      null,
      [[null, "(\\d{4})(\\d{4})", "$1 $2", ["[24-7]|8[3-9]"], null, "$CC $1"], [null, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"], null, "$CC $1"]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    CU: [
      null,
      [
        null,
        null,
        "[2-57]\\d{7}|[2-47]\\d{6}|[34]\\d{5}",
        null,
        null,
        null,
        null,
        null,
        null,
        [6, 7, 8],
        [4, 5]
      ],
      [null, null, "(?:2[1-4]|7\\d)\\d{5,6}|(?:3[1-3]|4[1-35-8])\\d{6}|3[23]\\d{4,5}|4[12578]\\d{5}|4[78]\\d{4}", null, null, null, "71234567", null, null, null, [4, 5]],
      [null, null, "5\\d{7}", null, null, null, "51234567", null, null, [8]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "CU",
      53,
      "119",
      "0",
      null,
      null,
      "0",
      null,
      null,
      null,
      [[null, "(\\d{2})(\\d{4,6})", "$1 $2", ["[2-4]"], "(0$1)"], [null, "(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], [null, "(\\d)(\\d{7})", "$1 $2", ["5"], "0$1"]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    CV: [null, [null, null, "[2-59]\\d{6}", null, null, null, null, null, null, [7]], [
      null,
      null,
      "2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}",
      null,
      null,
      null,
      "2211234"
    ], [null, null, "(?:[34][36]|5[1-389]|9\\d)\\d{5}", null, null, null, "9911234"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "CV", 238, "0", null, null, null, null, null, null, null, [[
      null,
      "(\\d{3})(\\d{2})(\\d{2})",
      "$1 $2 $3",
      ["[2-59]"]
    ]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    CW: [null, [null, null, "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", null, null, null, null, null, null, [7, 8]], [null, null, "9(?:(?:[48]\\d|50)\\d|7(?:2[0-24]|[34]\\d|6[35-7]|77|8[7-9]))\\d{4}", null, null, null, "94151234"], [
      null,
      null,
      "9(?:5(?:[12467]\\d|3[01])|6(?:[15-9]\\d|3[01]))\\d{4}",
      null,
      null,
      null,
      "95181234"
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "60[0-2]\\d{4}", null, null, null, "6001234", null, null, [7]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "CW", 599, "00", null, null, null, null, null, null, null, [[null, "(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], [null, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], null, [
      null,
      null,
      "955\\d{5}",
      null,
      null,
      null,
      "95581234",
      null,
      null,
      [8]
    ], 1, "[69]", [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    CX: [
      null,
      [null, null, "1\\d{5,9}|(?:[48]\\d\\d|550)\\d{6}", null, null, null, null, null, null, [6, 7, 8, 9, 10]],
      [null, null, "8(?:51(?:0(?:01|30|59)|117)|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", null, null, null, "891641234", null, null, [9], [8]],
      [
        null,
        null,
        "4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[6-9]|7[02-9]|8[0-2457-9]|9[017-9])\\d{6}",
        null,
        null,
        null,
        "412345678",
        null,
        null,
        [9]
      ],
      [null, null, "180(?:0\\d{3}|2)\\d{3}", null, null, null, "1800123456", null, null, [7, 10]],
      [null, null, "190[0-26]\\d{6}", null, null, null, "1900123456", null, null, [10]],
      [null, null, "13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}", null, null, null, "1300123456", null, null, [6, 8, 10]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "(?:14(?:5\\d|71)|550\\d)\\d{5}", null, null, null, "550123456", null, null, [9]],
      "CX",
      61,
      "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
      "0",
      null,
      null,
      "0|([59]\\d{7})$",
      "8$1",
      "0011",
      null,
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    CY: [
      null,
      [null, null, "(?:[279]\\d|[58]0)\\d{6}", null, null, null, null, null, null, [8]],
      [null, null, "2[2-6]\\d{6}", null, null, null, "22345678"],
      [null, null, "9[4-79]\\d{6}", null, null, null, "96123456"],
      [
        null,
        null,
        "800\\d{5}",
        null,
        null,
        null,
        "80001234"
      ],
      [null, null, "90[09]\\d{5}", null, null, null, "90012345"],
      [null, null, "80[1-9]\\d{5}", null, null, null, "80112345"],
      [null, null, "700\\d{5}", null, null, null, "70012345"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "CY",
      357,
      "00",
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [[null, "(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "(?:50|77)\\d{6}", null, null, null, "77123456"],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    CZ: [
      null,
      [null, null, "(?:[2-578]\\d|60|9\\d{1,4})\\d{7}", null, null, null, null, null, null, [9, 10, 11, 12]],
      [null, null, "(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}", null, null, null, "212345678", null, null, [9]],
      [null, null, "(?:60[1-8]|7(?:0[2-5]|[2379]\\d))\\d{6}", null, null, null, "601123456", null, null, [9]],
      [null, null, "800\\d{6}", null, null, null, "800123456", null, null, [9]],
      [null, null, "9(?:0[05689]|76)\\d{6}", null, null, null, "900123456", null, null, [9]],
      [
        null,
        null,
        "8[134]\\d{7}",
        null,
        null,
        null,
        "811234567",
        null,
        null,
        [9]
      ],
      [null, null, "70[01]\\d{6}", null, null, null, "700123456", null, null, [9]],
      [null, null, "9[17]0\\d{6}", null, null, null, "910123456", null, null, [9]],
      "CZ",
      420,
      "00",
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [[null, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], [null, "(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9[36]"]], [null, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["96"]]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "9(?:5\\d|7[2-4])\\d{6}", null, null, null, "972123456", null, null, [9]],
      null,
      null,
      [null, null, "9(?:3\\d{9}|6\\d{7,10})", null, null, null, "93123456789"]
    ],
    DE: [null, [
      null,
      null,
      "(?:1|[235-9]\\d{11}|4(?:[0-8]\\d{2,10}|9(?:[05]\\d{7}|[46][1-8]\\d{2,6})))\\d{3}|[1-35-9]\\d{6,13}|49(?:(?:[0-25]\\d|3[1-689])\\d{4,8}|4[1-8]\\d{4}|6[0-8]\\d{3,4}|7[1-7]\\d{5,8})|497[0-7]\\d{4}|49(?:[0-2579]\\d|[34][1-9])\\d{3}|[1-9]\\d{5}|[13468]\\d{4}",
      null,
      null,
      null,
      null,
      null,
      null,
      [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      [3]
    ], [
      null,
      null,
      "(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-3589]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|[29]\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{4,12}|3(?:(?:[03569]\\d|4[0-79]|7[1-7]|8[1-8])\\d{4,12}|2\\d{9})|4(?:(?:[02-48]\\d|1[02-9]|5[0-6]|6[0-8]|7[0-79])\\d{4,12}|9(?:[0-37]\\d{4,9}|[4-6]\\d{4,10}))|(?:2(?:0[1-389]|1[124]|2[18]|3[14]|[4-9]1)|3(?:0\\d?|[35-9][15]|4[015])|4(?:0\\d?|[2-9]1)|[57][1-9]1|[68](?:[1-8]1|9\\d?)|9(?:06|[1-9]1))\\d{3}",
      null,
      null,
      null,
      "30123456",
      null,
      null,
      [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      [3, 4]
    ], [null, null, "1(?:5[0-25-9]\\d{8}|(?:6[023]|7\\d)\\d{7,8})", null, null, null, "15123456789", null, null, [10, 11]], [null, null, "800\\d{7,12}", null, null, null, "8001234567890", null, null, [10, 11, 12, 13, 14, 15]], [null, null, "(?:137[7-9]|900(?:[135]|9\\d))\\d{6}", null, null, null, "9001234567", null, null, [10, 11]], [null, null, "1(?:3(?:7[1-6]\\d\\d|8)|80\\d{1,7})\\d{4}", null, null, null, "18012345", null, null, [7, 8, 9, 10, 11, 12, 13, 14]], [
      null,
      null,
      "700\\d{8}",
      null,
      null,
      null,
      "70012345678",
      null,
      null,
      [11]
    ], [null, null, null, null, null, null, null, null, null, [-1]], "DE", 49, "00", "0", null, null, "0", null, null, null, [[null, "(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], [null, "(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14]|[4-9]1)|3(?:[35-9][15]|4[015])|(?:4[2-9]|[57][1-9]|[68][1-8])1|9(?:06|[1-9]1)", "2(?:0[1-389]|1(?:[14]|2[0-8])|2[18]|3[14]|[4-9]1)|3(?:[35-9][15]|4[015])|(?:4[2-9]|[57][1-9]|[68][1-8])1|9(?:06|[1-9]1)"], "0$1"], [
      null,
      "(\\d{3})(\\d{4})",
      "$1 $2",
      ["138"],
      "0$1"
    ], [
      null,
      "(\\d{4})(\\d{3,11})",
      "$1 $2",
      ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|7(?:0[2-8]|[1-9])|8(?:0[2-9]|[1-8])|9(?:0[7-9]|[1-9])", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|[46][1246]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|3[1357]|4[13578]|6[1246]|7[1356]|9[1346])|5(?:0[14]|2[1-3589]|3[1357]|[49][1246]|6[1-4]|7[13468]|8[13568])|6(?:0[1356]|2[1-489]|3[124-6]|4[1347]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|3[1357]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|4[1347]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|3[1357]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|7(?:0[2-8]|[1-9])|8(?:0[2-9]|[1-8])|9(?:0[7-9]|[1-9])"],
      "0$1"
    ], [null, "(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], [null, "(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], [null, "(\\d{5})(\\d{3,10})", "$1 $2", ["3"], "0$1"], [null, "(\\d{3})(\\d{7,8})", "$1 $2", ["1(?:6[02-489]|7)"], "0$1"], [null, "(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], [null, "(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], [null, "(\\d{5})(\\d{6})", "$1 $2", ["15[0568]"], "0$1"], [null, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], [null, "(\\d{3})(\\d{8})", "$1 $2", [
      "18[2-579]",
      "18[2-579]",
      "18(?:[2-479]|5(?:0[1-9]|[1-9]))"
    ], "0$1"], [null, "(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], [null, "(\\d{5})(\\d{6})", "$1 $2", ["18"], "0$1"], [null, "(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], [null, "(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15[013-68]"], "0$1"], [null, "(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15"], "0$1"]], null, [null, null, "16(?:4\\d{1,10}|[89]\\d{1,11})", null, null, null, "16412345", null, null, [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]], null, null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, "18(?:1\\d{5,11}|[2-9]\\d{8})", null, null, null, "18500123456", null, null, [8, 9, 10, 11, 12, 13, 14]], null, null, [null, null, "1(?:5(?:(?:[03-68]00|113)\\d|2\\d55|7\\d99|9\\d33)|(?:6(?:013|255|399)|7(?:(?:[015]1|[69]3)3|[2-4]55|[78]99))\\d?)\\d{7}", null, null, null, "177991234567", null, null, [12, 13]]],
    DJ: [null, [null, null, "(?:2\\d|77)\\d{6}", null, null, null, null, null, null, [8]], [null, null, "2(?:1[2-5]|7[45])\\d{5}", null, null, null, "21360003"], [null, null, "77\\d{6}", null, null, null, "77831001"], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "DJ", 253, "00", null, null, null, null, null, null, null, [[null, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    DK: [null, [null, null, "[2-9]\\d{7}", null, null, null, null, null, null, [8]], [null, null, "(?:[2-7]\\d|8[126-9]|9[1-36-9])\\d{6}", null, null, null, "32123456"], [null, null, "(?:[2-7]\\d|8[126-9]|9[1-36-9])\\d{6}", null, null, null, "32123456"], [null, null, "80\\d{6}", null, null, null, "80123456"], [null, null, "90\\d{6}", null, null, null, "90123456"], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], "DK", 45, "00", null, null, null, null, null, null, 1, [[null, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    DM: [
      null,
      [
        null,
        null,
        "(?:[58]\\d\\d|767|900)\\d{7}",
        null,
        null,
        null,
        null,
        null,
        null,
        [10],
        [7]
      ],
      [null, null, "767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4]|70[1-3])\\d{4}", null, null, null, "7674201234", null, null, null, [7]],
      [null, null, "767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-7])\\d{4}", null, null, null, "7672251234", null, null, null, [7]],
      [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002123456"],
      [null, null, "900[2-9]\\d{6}", null, null, null, "9002123456"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "DM",
      1,
      "011",
      "1",
      null,
      null,
      "1",
      null,
      null,
      null,
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      "767",
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    DO: [
      null,
      [null, null, "(?:[58]\\d\\d|900)\\d{7}", null, null, null, null, null, null, [10], [7]],
      [
        null,
        null,
        "8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}",
        null,
        null,
        null,
        "8092345678",
        null,
        null,
        null,
        [7]
      ],
      [null, null, "8[024]9[2-9]\\d{6}", null, null, null, "8092345678", null, null, null, [7]],
      [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002123456"],
      [null, null, "900[2-9]\\d{6}", null, null, null, "9002123456"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "DO",
      1,
      "011",
      "1",
      null,
      null,
      "1",
      null,
      null,
      null,
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      "8[024]9",
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    DZ: [null, [null, null, "(?:[1-4]|[5-79]\\d|80)\\d{7}", null, null, null, null, null, null, [8, 9]], [null, null, "(?:(?:1\\d|2[013-79]|3[0-8]|4[0135689])\\d|9619)\\d{5}", null, null, null, "12345678"], [
      null,
      null,
      "(?:(?:5[4-6]|7[7-9])\\d|6(?:[569]\\d|7[0-6]))\\d{6}",
      null,
      null,
      null,
      "551234567",
      null,
      null,
      [9]
    ], [null, null, "800\\d{6}", null, null, null, "800123456", null, null, [9]], [null, null, "80[3-689]1\\d{5}", null, null, null, "808123456", null, null, [9]], [null, null, "80[12]1\\d{5}", null, null, null, "801123456", null, null, [9]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "98[23]\\d{6}", null, null, null, "983123456", null, null, [9]], "DZ", 213, "00", "0", null, null, "0", null, null, null, [[null, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], [
      null,
      "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
      "$1 $2 $3 $4",
      ["[5-8]"],
      "0$1"
    ], [null, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    EC: [null, [null, null, "1800\\d{6,7}|(?:[2-7]|9\\d)\\d{7}", null, null, null, null, null, null, [8, 9, 10, 11], [7]], [
      null,
      null,
      "[2-7][2-7]\\d{6}",
      null,
      null,
      null,
      "22123456",
      null,
      null,
      [8],
      [7]
    ], [null, null, "9(?:(?:39|[57][89]|[89]\\d)\\d|6(?:[0-27-9]\\d|30))\\d{5}", null, null, null, "991234567", null, null, [9]], [null, null, "1800\\d{6,7}", null, null, null, "18001234567", null, null, [10, 11]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "[2-7]890\\d{4}", null, null, null, "28901234", null, null, [8]], "EC", 593, "00", "0", null, null, "0", null, null, null, [[
      null,
      "(\\d{3})(\\d{4})",
      "$1-$2",
      ["[2-7]"]
    ], [null, "(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)"], [null, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], [null, "(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], [[null, "(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-7]"]], [null, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], [null, "(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    EE: [
      null,
      [null, null, "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d\\d|900)\\d{4}", null, null, null, null, null, null, [7, 8, 10]],
      [null, null, "(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}", null, null, null, "3212345", null, null, [7]],
      [null, null, "(?:5\\d|8[1-4])\\d{6}|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}", null, null, null, "51234567", null, null, [7, 8]],
      [null, null, "800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}", null, null, null, "80012345"],
      [null, null, "(?:40\\d\\d|900)\\d{4}", null, null, null, "9001234", null, null, [7, 8]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "70[0-2]\\d{5}", null, null, null, "70012345", null, null, [8]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "EE",
      372,
      "00",
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [[null, "(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]"]], [null, "(\\d{4})(\\d{3,4})", "$1 $2", [
        "[45]|8(?:00|[1-4])",
        "[45]|8(?:00[1-9]|[1-4])"
      ]], [null, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], [null, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["80"]]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, "800[2-9]\\d{3}", null, null, null, null, null, null, [7]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    EG: [null, [null, null, "(?:[189]\\d?|[24-6])\\d{8}|[13]\\d{7}", null, null, null, null, null, null, [8, 9, 10], [6, 7]], [
      null,
      null,
      "(?:1(?:3[23]|5\\d?)|(?:2[2-4]|3)\\d|4(?:0[2-5]|[578][23]|64)|5(?:0[2-7]|5\\d|7[23])|6[24-689]3|8(?:2[2-57]|4[26]|6[237]|8[2-4])|9(?:2[27]|3[24]|52|6[2356]|7[2-4]))\\d{6}",
      null,
      null,
      null,
      "234567890",
      null,
      null,
      [8, 9],
      [6, 7]
    ], [null, null, "1[0-25]\\d{8}", null, null, null, "1001234567", null, null, [10]], [null, null, "800\\d{7}", null, null, null, "8001234567", null, null, [10]], [null, null, "900\\d{7}", null, null, null, "9001234567", null, null, [10]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "EG", 20, "00", "0", null, null, "0", null, null, null, [
      [null, "(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"],
      [null, "(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"],
      [null, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[189]"], "0$1"]
    ], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    EH: [null, [null, null, "[5-8]\\d{8}", null, null, null, null, null, null, [9]], [null, null, "528[89]\\d{5}", null, null, null, "528812345"], [
      null,
      null,
      "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:0[067]|6[1267]|7[017]))\\d{6}",
      null,
      null,
      null,
      "650123456"
    ], [null, null, "80\\d{7}", null, null, null, "801234567"], [null, null, "89\\d{7}", null, null, null, "891234567"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "5924[01]\\d{4}", null, null, null, "592401234"], "EH", 212, "00", "0", null, null, "0", null, null, null, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, "528[89]", [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    ER: [null, [null, null, "[178]\\d{6}", null, null, null, null, null, null, [7], [6]], [null, null, "(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}", null, null, null, "8370362", null, null, null, [6]], [null, null, "(?:17[1-3]|7\\d\\d)\\d{4}", null, null, null, "7123456"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "ER", 291, "00", "0", null, null, "0", null, null, null, [[null, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    ES: [null, [
      null,
      null,
      "(?:51|[6-9]\\d)\\d{7}",
      null,
      null,
      null,
      null,
      null,
      null,
      [9]
    ], [null, null, "(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])\\d{4}|9(?:(?:(?:[135]\\d|[28][0-8]|4[1-9])\\d\\d|7(?:[124-9]\\d\\d|3(?:[0-8]\\d|9[1-9])))\\d\\d|6(?:[0-8]\\d{4}|9(?:0(?:[0-57-9]\\d\\d|6(?:0[0-8]|1[1-9]|[2-9]\\d))|[1-9]\\d{3}))))\\d\\d", null, null, null, "810123456"], [null, null, "(?:(?:6\\d|7[1-48])\\d{5}|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d", null, null, null, "612345678"], [null, null, "[89]00\\d{6}", null, null, null, "800123456"], [
      null,
      null,
      "80[367]\\d{6}",
      null,
      null,
      null,
      "803123456"
    ], [null, null, "90[12]\\d{6}", null, null, null, "901123456"], [null, null, "70\\d{7}", null, null, null, "701234567"], [null, null, null, null, null, null, null, null, null, [-1]], "ES", 34, "00", null, null, null, null, null, null, null, [[null, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], [null, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[568]|7[0-48]|9(?:0[12]|[1-8])"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      "51\\d{7}",
      null,
      null,
      null,
      "511234567"
    ], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    ET: [null, [null, null, "(?:11|[2-59]\\d)\\d{7}", null, null, null, null, null, null, [9], [7]], [
      null,
      null,
      "(?:11(?:1(?:1[124]|2[2-57]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8])|5(?:1[578]|44|5[0-4])|6(?:18|2[69]|39|4[5-7]|5[1-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}",
      null,
      null,
      null,
      "111112345",
      null,
      null,
      null,
      [7]
    ], [null, null, "9\\d{8}", null, null, null, "911234567"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "ET", 251, "00", "0", null, null, "0", null, null, null, [[null, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-59]"], "0$1"]], null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    FI: [
      null,
      [null, null, "(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}|[1-35689]\\d{4}", null, null, null, null, null, null, [5, 6, 7, 8, 9, 10]],
      [null, null, "(?:1[3-79][1-8]|[235689][1-8]\\d)\\d{2,6}", null, null, null, "131234567", null, null, [5, 6, 7, 8, 9]],
      [
        null,
        null,
        "(?:4[0-8]|50)\\d{4,8}",
        null,
        null,
        null,
        "412345678",
        null,
        null,
        [6, 7, 8, 9, 10]
      ],
      [null, null, "800\\d{4,6}", null, null, null, "800123456", null, null, [7, 8, 9]],
      [null, null, "[67]00\\d{5,6}", null, null, null, "600123456", null, null, [8, 9]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "FI",
      358,
      "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
      "0",
      null,
      null,
      "0",
      null,
      "00",
      null,
      [[null, "(\\d{5})", "$1", ["7"], "0$1"], [
        null,
        "(\\d)(\\d{4,9})",
        "$1 $2",
        ["[2568][1-8]|3(?:0[1-9]|[1-9])|9"],
        "0$1"
      ], [null, "(\\d{2})(\\d{4,8})", "$1 $2", ["1(?:0[1-9]|[3-79][1-8]|8)|2(?:0[1-9]|9)|[45]|7[135]"], "0$1"], [null, "(\\d{3})(\\d{3,7})", "$1 $2", ["(?:1|20)0|[36-8]"], "0$1"]],
      [[null, "(\\d)(\\d{4,9})", "$1 $2", ["[2568][1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"], [null, "(\\d{2})(\\d{4,8})", "$1 $2", ["1(?:0[1-9]|[3-79][1-8]|8)|2(?:0[1-9]|9)|[45]|7[135]"], "0$1"], [null, "(\\d{3})(\\d{3,7})", "$1 $2", ["(?:1|20)0|[36-8]"], "0$1"]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      1,
      "1[03-79]|[2-9]",
      [null, null, "[13]00\\d{3,7}|20(?:0\\d{3,7}|(?:2[023]|9[89])\\d{1,6})|60(?:[12]\\d{5,6}|6\\d{7})|7(?:(?:1|3\\d)\\d{7}|5[03-9]\\d{3,7})"],
      [null, null, "(?:10|[23][09])\\d{4,8}|60(?:[12]\\d{5,6}|6\\d{7})|7(?:(?:1|3\\d)\\d{7}|5[03-9]\\d{3,7})|20[2-59]\\d\\d", null, null, null, "10112345"],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    FJ: [null, [null, null, "(?:(?:0800\\d|[235-9])\\d|45)\\d{5}", null, null, null, null, null, null, [7, 11]], [null, null, "(?:(?:3[0-5]|8[58])\\d|6(?:03|[25-7]\\d))\\d{4}", null, null, null, "3212345", null, null, [7]], [null, null, "(?:[279]\\d|45|5[01568]|8[034679])\\d{5}", null, null, null, "7012345", null, null, [7]], [
      null,
      null,
      "0800\\d{7}",
      null,
      null,
      null,
      "08001234567",
      null,
      null,
      [11]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "FJ", 679, "0(?:0|52)", null, null, null, null, null, "00", null, [[null, "(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], [null, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    FK: [null, [null, null, "[2-7]\\d{4}", null, null, null, null, null, null, [5]], [null, null, "[2-47]\\d{4}", null, null, null, "31234"], [null, null, "[56]\\d{4}", null, null, null, "51234"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], "FK", 500, "00", null, null, null, null, null, null, null, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    FM: [null, [null, null, "[39]\\d{6}", null, null, null, null, null, null, [7]], [
      null,
      null,
      "(?:3[2357]0[1-9]|9[2-6]\\d\\d)\\d{3}",
      null,
      null,
      null,
      "3201234"
    ], [null, null, "(?:3[2357]0[1-9]|9[2-7]\\d\\d)\\d{3}", null, null, null, "3501234"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "FM", 691, "00", null, null, null, null, null, null, null, [[null, "(\\d{3})(\\d{4})", "$1 $2", ["3(?:20|[357])|9", "3(?:20[1-9]|[357])|9"]]], null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    FO: [null, [null, null, "(?:[2-8]\\d|90)\\d{4}", null, null, null, null, null, null, [6]], [null, null, "(?:20|[34]\\d|8[19])\\d{4}", null, null, null, "201234"], [null, null, "(?:[27][1-9]|5\\d)\\d{4}", null, null, null, "211234"], [null, null, "80[257-9]\\d{3}", null, null, null, "802123"], [
      null,
      null,
      "90(?:[13-5][15-7]|2[125-7]|99)\\d\\d",
      null,
      null,
      null,
      "901123"
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "(?:6[0-36]|88)\\d{4}", null, null, null, "601234"], "FO", 298, "00", null, null, null, "(10(?:01|[12]0|88))", null, null, null, [[null, "(\\d{6})", "$1", ["[2-9]"], null, "$CC $1"]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ]],
    FR: [
      null,
      [null, null, "[1-9]\\d{8}", null, null, null, null, null, null, [9]],
      [null, null, "[1-5]\\d{8}", null, null, null, "123456789"],
      [null, null, "(?:6\\d\\d|7(?:00|[3-9]\\d))\\d{6}", null, null, null, "612345678"],
      [null, null, "80[0-5]\\d{6}", null, null, null, "801234567"],
      [null, null, "8[129]\\d{7}", null, null, null, "891123456"],
      [null, null, "884\\d{6}", null, null, null, "884012345"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "9\\d{8}", null, null, null, "912345678"],
      "FR",
      33,
      "00",
      "0",
      null,
      null,
      "0",
      null,
      null,
      null,
      [[null, "(\\d{3})(\\d{3})", "$1 $2", ["11"]], [null, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"], [null, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"]],
      [[null, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"], [null, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [
        null,
        null,
        "80[6-9]\\d{6}",
        null,
        null,
        null,
        "806123456"
      ],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    GA: [null, [null, null, "(?:0\\d|[2-7])\\d{6}", null, null, null, null, null, null, [7, 8]], [null, null, "01\\d{6}", null, null, null, "01441234", null, null, [8]], [null, null, "(?:0[2-7]|[2-7])\\d{6}", null, null, null, "06031234"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], "GA", 241, "00", null, null, null, null, null, null, null, [[null, "(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], [null, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    GB: [null, [
      null,
      null,
      "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
      null,
      null,
      null,
      null,
      null,
      null,
      [7, 9, 10],
      [4, 5, 6, 8]
    ], [
      null,
      null,
      "(?:1(?:1(?:3[0-58]|4[0-5]|5[0-26-9]|6[0-4]|[78][0-49])|2(?:0[024-9]|1[0-7]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)|3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))|2(?:0[01378]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d)\\d{6}|1(?:(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d|7(?:(?:26(?:6[13-9]|7[0-7])|442\\d|50(?:2[0-3]|[3-68]2|76))\\d|6888[2-46-8]))\\d\\d",
      null,
      null,
      null,
      "1212345678",
      null,
      null,
      [9, 10],
      [4, 5, 6, 7, 8]
    ], [null, null, "7(?:(?:[1-3]\\d\\d|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|8(?:[014-9]\\d|[23][0-8]))\\d|4(?:[0-46-9]\\d\\d|5(?:[0-689]\\d|7[0-57-9]))|7(?:0(?:0[01]|[1-9]\\d)|(?:[1-7]\\d|8[02-9]|9[0-689])\\d)|9(?:(?:[024-9]\\d|3[0-689])\\d|1(?:[02-9]\\d|1[028])))\\d{5}", null, null, null, "7400123456", null, null, [10]], [null, null, "80[08]\\d{7}|800\\d{6}|8001111", null, null, null, "8001234567"], [
      null,
      null,
      "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",
      null,
      null,
      null,
      "9012345678",
      null,
      null,
      [7, 10]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "70\\d{8}", null, null, null, "7012345678", null, null, [10]], [null, null, "56\\d{8}", null, null, null, "5612345678", null, null, [10]], "GB", 44, "00", "0", " x", null, "0", null, null, null, [[null, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], [null, "(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], [null, "(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], [
      null,
      "(\\d{4})(\\d{5,6})",
      "$1 $2",
      ["1(?:[2-79][02-9]|8)", "1(?:[24][02-9]|3(?:[02-79]|8[0-46-9])|5(?:[04-9]|2[024-9]|3[014-689])|6(?:[02-8]|9[0-24578])|7(?:[02-57-9]|6[013-9])|8|9(?:[0235-9]|4[2-9]))", "1(?:[24][02-9]|3(?:[02-79]|8(?:[0-4689]|7[0-24-9]))|5(?:[04-9]|2(?:[025-9]|4[013-9])|3(?:[014-68]|9[0-37-9]))|6(?:[02-8]|9(?:[0-2458]|7[0-25689]))|7(?:[02-57-9]|6(?:[013-79]|8[0-25689]))|8|9(?:[0235-9]|4(?:[2-57-9]|6[0-689])))"],
      "0$1"
    ], [null, "(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|7|94)"], "0$1"], [
      null,
      "(\\d{2})(\\d{4})(\\d{4})",
      "$1 $2 $3",
      ["[25]|7(?:0|6[024-9])", "[25]|7(?:0|6(?:[04-9]|2[356]))"],
      "0$1"
    ], [null, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"], [null, "(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"]], null, [null, null, "76(?:0[0-2]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}", null, null, null, "7640123456", null, null, [10]], 1, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "(?:3[0347]|55)\\d{8}", null, null, null, "5512345678", null, null, [10]], null, null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ]],
    GD: [null, [null, null, "(?:473|[58]\\d\\d|900)\\d{7}", null, null, null, null, null, null, [10], [7]], [null, null, "473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-49]|5[5-79]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}", null, null, null, "4732691234", null, null, null, [7]], [null, null, "473(?:4(?:0[2-79]|1[04-9]|2[0-5]|58)|5(?:2[01]|3[3-8])|901)\\d{4}", null, null, null, "4734031234", null, null, null, [7]], [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002123456"], [
      null,
      null,
      "900[2-9]\\d{6}",
      null,
      null,
      null,
      "9002123456"
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"], [null, null, null, null, null, null, null, null, null, [-1]], "GD", 1, "011", "1", null, null, "1", null, null, null, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, "473", [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    GE: [null, [null, null, "(?:[3-57]\\d\\d|800)\\d{6}", null, null, null, null, null, null, [9], [6]], [null, null, "(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}", null, null, null, "322123456", null, null, null, [6]], [null, null, "(?:5(?:[14]4|5[0157-9]|68|7[0147-9]|9[1-35-9])|790)\\d{6}", null, null, null, "555123456"], [null, null, "800\\d{6}", null, null, null, "800123456"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, "706\\d{6}", null, null, null, "706123456"], "GE", 995, "00", "0", null, null, "0", null, null, null, [[null, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"], [null, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5|79"]], [null, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, "706\\d{6}"], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ]],
    GF: [null, [null, null, "[56]94\\d{6}", null, null, null, null, null, null, [9]], [null, null, "594(?:[023]\\d|1[01]|4[03-9]|5[6-9]|6[0-3]|80|9[014])\\d{4}", null, null, null, "594101234"], [null, null, "694(?:[0-249]\\d|3[0-48])\\d{4}", null, null, null, "694201234"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], "GF", 594, "00", "0", null, null, "0", null, null, null, [[null, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[56]"], "0$1"]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    GG: [null, [null, null, "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", null, null, null, null, null, null, [7, 9, 10], [6]], [
      null,
      null,
      "1481[25-9]\\d{5}",
      null,
      null,
      null,
      "1481256789",
      null,
      null,
      [10],
      [6]
    ], [null, null, "7(?:(?:781|839)\\d|911[17])\\d{5}", null, null, null, "7781123456", null, null, [10]], [null, null, "80[08]\\d{7}|800\\d{6}|8001111", null, null, null, "8001234567"], [null, null, "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", null, null, null, "9012345678", null, null, [7, 10]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "70\\d{8}", null, null, null, "7012345678", null, null, [10]], [
      null,
      null,
      "56\\d{8}",
      null,
      null,
      null,
      "5612345678",
      null,
      null,
      [10]
    ], "GG", 44, "00", "0", null, null, "0|([25-9]\\d{5})$", "1481$1", null, null, null, null, [null, null, "76(?:0[0-2]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}", null, null, null, "7640123456", null, null, [10]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "(?:3[0347]|55)\\d{8}", null, null, null, "5512345678", null, null, [10]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    GH: [null, [
      null,
      null,
      "(?:[235]\\d{3}|800)\\d{5}",
      null,
      null,
      null,
      null,
      null,
      null,
      [8, 9],
      [7]
    ], [null, null, "3(?:0(?:[237]\\d|80)|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}", null, null, null, "302345678", null, null, [9], [7]], [null, null, "(?:2[0346-8]\\d|5(?:[0457]\\d|6[01]))\\d{6}", null, null, null, "231234567", null, null, [9]], [null, null, "800\\d{5}", null, null, null, "80012345", null, null, [8]], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "GH", 233, "00", "0", null, null, "0", null, null, null, [[null, "(\\d{3})(\\d{4})", "$1 $2", ["[237]|80"]], [null, "(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], [null, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], [[null, "(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], [null, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [
      null,
      null,
      "800\\d{5}",
      null,
      null,
      null,
      null,
      null,
      null,
      [8]
    ], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    GI: [null, [null, null, "(?:[25]\\d\\d|629)\\d{5}", null, null, null, null, null, null, [8]], [null, null, "2(?:(?:00\\d|2(?:2[2457]|50))\\d|1(?:6[24-7]\\d|90[0-2]))\\d{3}", null, null, null, "20012345"], [null, null, "(?:5[46-8]\\d|629)\\d{5}", null, null, null, "57123456"], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "GI", 350, "00", null, null, null, null, null, null, null, [[null, "(\\d{3})(\\d{5})", "$1 $2", ["2"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    GL: [
      null,
      [null, null, "(?:19|[2-689]\\d)\\d{4}", null, null, null, null, null, null, [6]],
      [null, null, "(?:19|3[1-7]|6[14689]|8[14-79]|9\\d)\\d{4}", null, null, null, "321000"],
      [null, null, "(?:[25][1-9]|4[2-9])\\d{4}", null, null, null, "221234"],
      [null, null, "80\\d{4}", null, null, null, "801234"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "3[89]\\d{4}", null, null, null, "381234"],
      "GL",
      299,
      "00",
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [[null, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-689]"]]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    GM: [null, [null, null, "[2-9]\\d{6}", null, null, null, null, null, null, [7]], [
      null,
      null,
      "(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:54[0-7]|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}",
      null,
      null,
      null,
      "5661234"
    ], [null, null, "[23679]\\d{6}", null, null, null, "3012345"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "GM", 220, "00", null, null, null, null, null, null, null, [[null, "(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    GN: [null, [null, null, "(?:30|6\\d\\d|722)\\d{6}", null, null, null, null, null, null, [8, 9]], [null, null, "30(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])\\d{4}", null, null, null, "30241234", null, null, [8]], [null, null, "6[02356]\\d{7}", null, null, null, "601123456", null, null, [9]], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "722\\d{6}", null, null, null, "722123456", null, null, [9]], "GN", 224, "00", null, null, null, null, null, null, null, [[null, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], [null, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    GP: [null, [null, null, "(?:590|69\\d)\\d{6}", null, null, null, null, null, null, [9]], [null, null, "590(?:0[1-68]|1[0-2]|2[0-68]|3[1289]|4[0-24-9]|5[3-579]|6[0189]|7[08]|8[0-689]|9\\d)\\d{4}", null, null, null, "590201234"], [null, null, "69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}", null, null, null, "690001234"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "GP", 590, "00", "0", null, null, "0", null, null, null, [[null, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[56]"], "0$1"]], null, [null, null, null, null, null, null, null, null, null, [-1]], 1, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    GQ: [null, [null, null, "(?:222|(?:3\\d|55|[89]0)\\d)\\d{6}", null, null, null, null, null, null, [9]], [null, null, "3(?:3(?:[0-24-9]\\d[46]|3\\d[7-9])|5\\d\\d[7-9])\\d{4}", null, null, null, "333091234"], [null, null, "(?:222|55[015])\\d{6}", null, null, null, "222123456"], [null, null, "80\\d[1-9]\\d{5}", null, null, null, "800123456"], [null, null, "90\\d[1-9]\\d{5}", null, null, null, "900123456"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], "GQ", 240, "00", null, null, null, null, null, null, null, [[null, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], [null, "(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    GR: [null, [null, null, "(?:[268]\\d|[79]0)\\d{8}", null, null, null, null, null, null, [10]], [
      null,
      null,
      "2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}",
      null,
      null,
      null,
      "2123456789"
    ], [null, null, "6(?:8[57-9]|9\\d)\\d{7}", null, null, null, "6912345678"], [null, null, "800\\d{7}", null, null, null, "8001234567"], [null, null, "90[19]\\d{7}", null, null, null, "9091234567"], [null, null, "8(?:0[16]|12|25)\\d{7}", null, null, null, "8011234567"], [null, null, "70\\d{8}", null, null, null, "7012345678"], [null, null, null, null, null, null, null, null, null, [-1]], "GR", 30, "00", null, null, null, null, null, null, null, [[null, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], [
      null,
      "(\\d{3})(\\d{3})(\\d{4})",
      "$1 $2 $3",
      ["2[3-8]1|[689]"]
    ], [null, "(\\d{4})(\\d{6})", "$1 $2", ["2"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    GT: [null, [null, null, "(?:1\\d{3}|[2-7])\\d{7}", null, null, null, null, null, null, [8, 11]], [null, null, "[267][2-9]\\d{6}", null, null, null, "22456789", null, null, [8]], [
      null,
      null,
      "[3-5]\\d{7}",
      null,
      null,
      null,
      "51234567",
      null,
      null,
      [8]
    ], [null, null, "18[01]\\d{8}", null, null, null, "18001112222", null, null, [11]], [null, null, "19\\d{9}", null, null, null, "19001112222", null, null, [11]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "GT", 502, "00", null, null, null, null, null, null, null, [[null, "(\\d{4})(\\d{4})", "$1 $2", ["[2-7]"]], [null, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    GU: [null, [null, null, "(?:[58]\\d\\d|671|900)\\d{7}", null, null, null, null, null, null, [10], [7]], [
      null,
      null,
      "671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[0236-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}",
      null,
      null,
      null,
      "6713001234",
      null,
      null,
      null,
      [7]
    ], [null, null, "671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[0236-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}", null, null, null, "6713001234", null, null, null, [7]], [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002123456"], [null, null, "900[2-9]\\d{6}", null, null, null, "9002123456"], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"], [null, null, null, null, null, null, null, null, null, [-1]], "GU", 1, "011", "1", null, null, "1", null, null, 1, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, "671", [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    GW: [null, [
      null,
      null,
      "[49]\\d{8}|4\\d{6}",
      null,
      null,
      null,
      null,
      null,
      null,
      [7, 9]
    ], [null, null, "443\\d{6}", null, null, null, "443201234", null, null, [9]], [null, null, "9(?:5\\d|6[569]|77)\\d{6}", null, null, null, "955012345", null, null, [9]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "40\\d{5}", null, null, null, "4012345", null, null, [7]], "GW", 245, "00", null, null, null, null, null, null, null, [[
      null,
      "(\\d{3})(\\d{4})",
      "$1 $2",
      ["40"]
    ], [null, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    GY: [
      null,
      [null, null, "(?:(?:(?:[2-46]\\d|77)\\d|862)\\d|9008)\\d{3}", null, null, null, null, null, null, [7]],
      [
        null,
        null,
        "(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-24-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|77[1-57])\\d{4}",
        null,
        null,
        null,
        "2201234"
      ],
      [null, null, "6\\d{6}", null, null, null, "6091234"],
      [null, null, "(?:289|862)\\d{4}", null, null, null, "2891234"],
      [null, null, "9008\\d{3}", null, null, null, "9008123"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "GY",
      592,
      "001",
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [[null, "(\\d{3})(\\d{4})", "$1 $2", ["[2-46-9]"]]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    HK: [null, [null, null, "8[0-46-9]\\d{6,7}|9\\d{4}(?:\\d(?:\\d(?:\\d{4})?)?)?|(?:[235-79]\\d|46)\\d{6}", null, null, null, null, null, null, [5, 6, 7, 8, 9, 11]], [null, null, "(?:2(?:[13-8]\\d|2[013-9]|9[0-24-9])\\d|3(?:(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69])\\d|8(?:4[04]|9\\d))|58(?:0[1-8]|1[2-9]))\\d{4}", null, null, null, "21234567", null, null, [8]], [
      null,
      null,
      "(?:46(?:0[0-6]|10|4[0-57-9])|5(?:(?:[1-59][0-46-9]|6[0-4689])\\d|7(?:[0-2469]\\d|30))|6(?:(?:0[1-9]|[13-59]\\d|[68][0-57-9]|7[0-79])\\d|2(?:[0-57-9]\\d|6[01]))|707[1-5]|8480|9(?:(?:0[1-9]|1[02-9]|[358][0-8]|[467]\\d)\\d|2(?:[0-8]\\d|9[03-9])))\\d{4}",
      null,
      null,
      null,
      "51234567",
      null,
      null,
      [8]
    ], [null, null, "800\\d{6}", null, null, null, "800123456", null, null, [9]], [null, null, "900(?:[0-24-9]\\d{7}|3\\d{1,4})", null, null, null, "90012345678", null, null, [5, 6, 7, 8, 11]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, "8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}", null, null, null, "81123456", null, null, [8]], [null, null, null, null, null, null, null, null, null, [-1]], "HK", 852, "00(?:30|5[09]|[126-9]?)", null, null, null, null, null, "00", null, [[null, "(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], [null, "(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], [null, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], [null, "(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], null, [
      null,
      null,
      "7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}",
      null,
      null,
      null,
      "71123456",
      null,
      null,
      [8]
    ], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}", null, null, null, "30161234", null, null, [8]], null, null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ]],
    HN: [
      null,
      [null, null, "[237-9]\\d{7}", null, null, null, null, null, null, [8]],
      [null, null, "2(?:2(?:0[019]|1[1-36]|[23]\\d|4[04-6]|5[57]|64|7[0135689]|8[01346-9]|9[0-2])|4(?:07|2[3-59]|3[13-689]|4[0-68]|5[1-35])|5(?:08|16|4[03-5]|5\\d|6[4-6]|74|80)|6(?:[056]\\d|17|3[04]|4[0-378]|[78][0-8]|9[01])|7(?:6[46-9]|7[02-9]|8[034])|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}", null, null, null, "22123456"],
      [null, null, "[37-9]\\d{7}", null, null, null, "91234567"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "HN",
      504,
      "00",
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [[null, "(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        [-1]
      ]
    ],
    HR: [null, [null, null, "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", null, null, null, null, null, null, [6, 7, 8, 9]], [null, null, "1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}", null, null, null, "12345678", null, null, [8, 9], [6, 7]], [null, null, "9(?:(?:01|[12589]\\d)\\d|7(?:[0679]\\d|51))\\d{5}|98\\d{6}", null, null, null, "921234567", null, null, [8, 9]], [null, null, "80[01]\\d{4,6}", null, null, null, "800123456", null, null, [7, 8, 9]], [
      null,
      null,
      "6[01459]\\d{6}|6[01]\\d{4,5}",
      null,
      null,
      null,
      "611234",
      null,
      null,
      [6, 7, 8]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "7[45]\\d{6}", null, null, null, "74123456", null, null, [8]], [null, null, null, null, null, null, null, null, null, [-1]], "HR", 385, "00", "0", null, null, "0", null, null, null, [[null, "(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], [null, "(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], [null, "(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], [null, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-5]"], "0$1"], [
      null,
      "(\\d{2})(\\d{3})(\\d{3,4})",
      "$1 $2 $3",
      ["[67]"],
      "0$1"
    ], [null, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], [null, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "(?:62\\d?|72)\\d{6}", null, null, null, "62123456", null, null, [8, 9]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    HT: [
      null,
      [null, null, "[2-489]\\d{7}", null, null, null, null, null, null, [8]],
      [null, null, "2(?:2\\d|5[1-5]|81|9[149])\\d{5}", null, null, null, "22453300"],
      [null, null, "[34]\\d{7}", null, null, null, "34101234"],
      [null, null, "8\\d{7}", null, null, null, "80012345"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}", null, null, null, "98901234"],
      "HT",
      509,
      "00",
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [[null, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-489]"]]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    HU: [
      null,
      [null, null, "[2357]\\d{8}|[1-9]\\d{7}", null, null, null, null, null, null, [8, 9], [6, 7]],
      [null, null, "(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}", null, null, null, "12345678", null, null, [8], [6, 7]],
      [
        null,
        null,
        "(?:[257]0|3[01])\\d{7}",
        null,
        null,
        null,
        "201234567",
        null,
        null,
        [9]
      ],
      [null, null, "[48]0\\d{6}", null, null, null, "80123456", null, null, [8]],
      [null, null, "9[01]\\d{6}", null, null, null, "90123456", null, null, [8]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "21\\d{7}", null, null, null, "211234567", null, null, [9]],
      "HU",
      36,
      "00",
      "06",
      null,
      null,
      "06",
      null,
      null,
      null,
      [[null, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "($1)"], [null, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "($1)"]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, "[48]0\\d{6}", null, null, null, null, null, null, [8]],
      [null, null, "38\\d{7}", null, null, null, "381234567", null, null, [9]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    ID: [
      null,
      [null, null, "(?:[1-36]|8\\d{5})\\d{6}|[1-9]\\d{8,10}|[2-9]\\d{7}", null, null, null, null, null, null, [7, 8, 9, 10, 11, 12], [5, 6]],
      [
        null,
        null,
        "2(?:[124]\\d{7,8}|(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])\\d{5,8})|(?:3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}|6(?:1(?:[0-8]\\d{4,7}|9\\d{4,8})|(?:[25]\\d|3[1-69]|4[1-6])\\d{5,8})|2(?:1(?:14|500)|2\\d{3})\\d{3}",
        null,
        null,
        null,
        "218350123",
        null,
        null,
        [7, 8, 9, 10, 11],
        [5, 6]
      ],
      [null, null, "8[1-35-9]\\d{7,10}", null, null, null, "812345678", null, null, [9, 10, 11, 12]],
      [null, null, "(?:177\\d|800)\\d{5,7}", null, null, null, "8001234567", null, null, [8, 9, 10, 11]],
      [null, null, "809\\d{7}", null, null, null, "8091234567", null, null, [10]],
      [null, null, "804\\d{7}", null, null, null, "8041234567", null, null, [10]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "ID",
      62,
      "0(?:0[17-9]|10(?:00|1[67]))",
      "0",
      null,
      null,
      "0",
      null,
      null,
      null,
      [[null, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], [null, "(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], [null, "(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], [null, "(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], [null, "(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], [null, "(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], [null, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], [null, "(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], [
        null,
        "(\\d{3})(\\d{4})(\\d{4,5})",
        "$1-$2-$3",
        ["8"],
        "0$1"
      ]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, "8071\\d{6}", null, null, null, null, null, null, [10]],
      [null, null, "(?:1500|8071\\d{3})\\d{3}", null, null, null, "8071123456", null, null, [7, 10]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    IE: [
      null,
      [null, null, "[148]\\d{9}|[124-9]\\d{8}|[124-69]\\d{7}|[24-69]\\d{6}", null, null, null, null, null, null, [7, 8, 9, 10], [5, 6]],
      [
        null,
        null,
        "(?:1\\d{2,3}|2(?:[13]\\d\\d|[24-9])|4(?:0[24]|(?:(?:[1-469]|8[0-46-9])\\d|5)\\d|7)|5(?:0[45]|(?:1|[23679]\\d)\\d|8)|6(?:[237-9]|[4-6]\\d\\d)|7[14]\\d\\d|9(?:[04]\\d\\d|[35-9]))\\d{5}|[269]1\\d{6}",
        null,
        null,
        null,
        "2212345",
        null,
        null,
        null,
        [5, 6]
      ],
      [null, null, "8(?:22|[35-9]\\d)\\d{6}", null, null, null, "850123456", null, null, [9]],
      [null, null, "1800\\d{6}", null, null, null, "1800123456", null, null, [10]],
      [null, null, "15(?:1[2-8]|[2-8]0|9[089])\\d{6}", null, null, null, "1520123456", null, null, [10]],
      [null, null, "18[59]0\\d{6}", null, null, null, "1850123456", null, null, [10]],
      [null, null, "700\\d{6}", null, null, null, "700123456", null, null, [9]],
      [null, null, "76\\d{7}", null, null, null, "761234567", null, null, [9]],
      "IE",
      353,
      "00",
      "0",
      null,
      null,
      "0",
      null,
      null,
      null,
      [[null, "(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], [null, "(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], [null, "(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], [null, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], [null, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["76|8[235-9]"], "0$1"], [null, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"], [null, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], [
        null,
        "(\\d{2})(\\d{4})(\\d{4})",
        "$1 $2 $3",
        ["4"],
        "(0$1)"
      ], [null, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], [null, "(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, "18[59]0\\d{6}", null, null, null, null, null, null, [10]],
      [null, null, "818\\d{6}", null, null, null, "818123456", null, null, [9]],
      null,
      null,
      [null, null, "8[35-9]5\\d{7}", null, null, null, "8551234567", null, null, [10]]
    ],
    IL: [null, [
      null,
      null,
      "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
      null,
      null,
      null,
      null,
      null,
      null,
      [7, 8, 9, 10, 11, 12]
    ], [null, null, "(?:153\\d\\d?|[2-489])\\d{7}", null, null, null, "21234567", null, null, [8, 11, 12], [7]], [null, null, "5(?:(?:[0-489][2-9]|6\\d)\\d|5(?:01|2[2-5]|3[23]|4[45]|5[05689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}", null, null, null, "502345678", null, null, [9]], [null, null, "1(?:255|80[019]\\d{3})\\d{3}", null, null, null, "1800123456", null, null, [7, 10]], [null, null, "1(?:2(?:00\\d\\d|12)|9(?:0[01]|19)\\d\\d)\\d{4}", null, null, null, "1919123456", null, null, [8, 10]], [
      null,
      null,
      "1700\\d{6}",
      null,
      null,
      null,
      "1700123456",
      null,
      null,
      [10]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "7(?:(?:18|2[23]|3[237]|47|6[58]|7\\d|9[2357-9])\\d|8(?:2\\d|33|55|77|81))\\d{5}", null, null, null, "771234567", null, null, [9]], "IL", 972, "0(?:0|1[2-9])", "0", null, null, "0", null, null, null, [
      [null, "(\\d{4})(\\d{3})", "$1-$2", ["125"]],
      [null, "(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"],
      [null, "(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]],
      [null, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"],
      [null, "(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]],
      [null, "(\\d{4})(\\d{6})", "$1-$2", ["159"]],
      [null, "(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]],
      [null, "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["1"]]
    ], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, "1700\\d{6}", null, null, null, null, null, null, [10]], [null, null, "1599\\d{6}", null, null, null, "1599123456", null, null, [10]], null, null, [null, null, "151\\d{8,9}", null, null, null, "15112340000", null, null, [11, 12]]],
    IM: [null, [null, null, "(?:1624|(?:[3578]\\d|90)\\d\\d)\\d{6}", null, null, null, null, null, null, [10], [6]], [null, null, "1624[5-8]\\d{5}", null, null, null, "1624756789", null, null, null, [6]], [null, null, "7(?:4576|[59]24\\d|624[0-4689])\\d{5}", null, null, null, "7924123456"], [null, null, "808162\\d{4}", null, null, null, "8081624567"], [null, null, "(?:8(?:4(?:40[49]06|5624\\d)|7(?:0624|2299)\\d)|90[0167]624\\d)\\d{3}", null, null, null, "9016247890"], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      "70\\d{8}",
      null,
      null,
      null,
      "7012345678"
    ], [null, null, "56\\d{8}", null, null, null, "5612345678"], "IM", 44, "00", "0", null, null, "0|([5-8]\\d{5})$", "1624$1", null, null, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "(?:3(?:(?:08162|3\\d{4}|7(?:0624|2299))\\d|4(?:40[49]06|5624\\d))|55\\d{5})\\d{3}", null, null, null, "5512345678"], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    IN: [null, [
      null,
      null,
      "(?:00800|1\\d{0,5}|[2-9]\\d\\d)\\d{7}",
      null,
      null,
      null,
      null,
      null,
      null,
      [8, 9, 10, 11, 12, 13],
      [6, 7]
    ], [
      null,
      null,
      "(?:1(?:1[2-7]\\d\\d|2(?:[0-249][2-7]\\d|[35-8]\\d[2-7])|3(?:[0-25][2-7]\\d|[346-9]\\d[2-7])|4(?:[145][2-7]\\d|[236-9]\\d[2-7])|[59](?:[0235-9]\\d[2-7]|[14][2-7]\\d)|6(?:[014][2-7]\\d|[235-9]\\d[2-7])|7(?:(?:0[24]|[1257][2-7])\\d|[34689]\\d[2-7])|8(?:[01346][2-7]\\d|[257-9]\\d[2-7]))|2(?:[02][2-7]\\d\\d|1(?:[134689]\\d[2-7]|[257][2-7]\\d)|3(?:[013][2-7]\\d|[24-8]\\d[2-7])|4(?:[01][2-7]\\d|[2-8]\\d[2-7])|5(?:[0137][2-7]\\d|[25689]\\d[2-7])|6(?:[0158][2-7]\\d|[2-4679]\\d[2-7])|7(?:[13-79]\\d[2-7]|8[2-7]\\d)|8(?:(?:0[13468]|[1568][2-7])\\d|[2-479]\\d[2-7])|9(?:(?:0\\d|[14][2-7])\\d|[235-9]\\d[2-7]))|3(?:(?:01|1[79])\\d[2-7]|2(?:[1-5]\\d[2-7]|6[2-7]\\d)|3[2-7]\\d\\d|4(?:[13][2-7]\\d|2(?:[0189][2-7]|[2-7]\\d)|[5-8]\\d[2-7])|5(?:[125689]\\d[2-7]|[34][2-7]\\d)|6(?:[01489][2-7]\\d|[235-7]\\d[2-7])|7(?:[02-46][2-7]\\d|[157-9]\\d[2-7])|8(?:(?:0\\d|[159][2-7])\\d|[2-46-8]\\d[2-7]))|4(?:[04][2-7]\\d\\d|1(?:[14578]\\d[2-7]|[36][2-7]\\d)|2(?:(?:0[24]|[1-47][2-7])\\d|[5689]\\d[2-7])|3(?:[15][2-7]\\d|[2-467]\\d[2-7])|5(?:[12][2-7]\\d|[4-7]\\d[2-7])|6(?:[0-26-9][2-7]\\d|[35]\\d[2-7])|7(?:(?:[014-9][2-7]|2[2-8])\\d|3\\d[2-7])|8(?:[013-57][2-7]\\d|[2689]\\d[2-7])|9(?:[014-7][2-7]\\d|[2389]\\d[2-7]))|5(?:1(?:[025][2-7]\\d|[146-9]\\d[2-7])|2(?:[14-8]\\d[2-7]|2[2-7]\\d)|3(?:[1346]\\d[2-7]|[25][2-7]\\d)|4(?:[14-69]\\d[2-7]|[28][2-7]\\d)|5(?:(?:1[2-7]|2[1-7])\\d|[46]\\d[2-7])|6(?:[146-9]\\d[2-7]|[25][2-7]\\d)|7(?:1[2-7]\\d|[2-4]\\d[2-7])|8(?:1[2-7]\\d|[2-8]\\d[2-7])|9(?:[15][2-7]\\d|[246]\\d[2-7]))|6(?:1(?:[1358]\\d[2-7]|2[2-7]\\d)|2(?:1[2-7]\\d|[2457]\\d[2-7])|3(?:1[2-7]\\d|[2-4]\\d[2-7])|4(?:1[2-7]\\d|[235-7]\\d[2-7])|5(?:[17][2-7]\\d|[2-689]\\d[2-7])|6(?:[13][2-7]\\d|[24578]\\d[2-7])|7(?:1[2-7]\\d|[235689]\\d[2-7]|4(?:[0189][2-7]|[2-7]\\d))|8(?:0[2-7]\\d|[1-6]\\d[2-7]))|7(?:1(?:[013-9]\\d[2-7]|2[2-7]\\d)|2(?:[0235-9]\\d[2-7]|[14][2-7]\\d)|3(?:[134][2-7]\\d|[2679]\\d[2-7])|4(?:[1-35689]\\d[2-7]|[47][2-7]\\d)|5(?:[15][2-7]\\d|[2-46-9]\\d[2-7])|[67](?:[02-9]\\d[2-7]|1[2-7]\\d)|8(?:(?:[013-7]\\d|2[0-6])[2-7]|8(?:[0189][2-7]|[2-7]\\d))|9(?:[0189]\\d[2-7]|[2-7]\\d\\d))|8(?:0[2-7]\\d\\d|1(?:[1357-9]\\d[2-7]|6[2-7]\\d)|2(?:[014][2-7]\\d|[235-8]\\d[2-7])|3(?:[03-57-9]\\d[2-7]|[126][2-7]\\d)|(?:4[0-24-9]|5\\d)\\d[2-7]|6(?:[136][2-7]\\d|[2457-9]\\d[2-7])|7(?:[078][2-7]\\d|[1-6]\\d[2-7])|8(?:[1256]\\d[2-7]|[34][2-7]\\d)|9(?:1[2-7]\\d|[2-4]\\d[2-7])))\\d{5}",
      null,
      null,
      null,
      "7410410123",
      null,
      null,
      [10],
      [6, 7, 8]
    ], [
      null,
      null,
      "(?:6(?:(?:0(?:0[0-3569]|26|33)|2(?:[06]\\d|3[02589]|8[0-479]|9[0-79])|9(?:0[019]|13))\\d|1279|3(?:(?:0[0-79]|6[0-4679]|7[0-24-9]|[89]\\d)\\d|5(?:0[0-6]|[1-9]\\d)))|7(?:(?:0\\d\\d|19[0-5])\\d|2(?:(?:[0235-79]\\d|[14][017-9])\\d|8(?:[0-59]\\d|[6-8][089]))|3(?:(?:[05-8]\\d|3[017-9])\\d|1(?:[089]\\d|11|7[02-8])|2(?:[0-49][089]|[5-8]\\d)|4(?:[07-9]\\d|11)|9(?:[016-9]\\d|[2-5][089]))|4(?:0\\d\\d|1(?:[015-9]\\d|[2-4][089])|[29](?:[0-7][089]|[89]\\d)|3(?:[0-8][089]|9\\d)|[47](?:[089]\\d|11|7[02-8])|[56]\\d[089]|8(?:[0-24-7][089]|[389]\\d))|5(?:(?:[0346-8]\\d|5[017-9])\\d|1(?:[07-9]\\d|11)|2(?:[04-9]\\d|[1-3][089])|9(?:[0-6][089]|[7-9]\\d))|6(?:0(?:[0-47]\\d|[5689][089])|(?:1[0-257-9]|[6-9]\\d)\\d|2(?:[0-4]\\d|[5-9][089])|3(?:[02-8][089]|[19]\\d)|4\\d[089]|5(?:[0-367][089]|[4589]\\d))|7(?:0(?:0[02-9]|[13-7][089]|[289]\\d)|[1-9]\\d\\d)|8(?:[0-79]\\d\\d|8(?:[089]\\d|11|7[02-9]))|9(?:[089]\\d\\d|313|7(?:[02-8]\\d|9[07-9])))|8(?:0(?:(?:[01589]\\d|6[67])\\d|7(?:[02-8]\\d|9[04-9]))|1(?:[0-57-9]\\d\\d|6(?:[089]\\d|7[02-8]))|2(?:[014](?:[089]\\d|7[02-8])|[235-9]\\d\\d)|3(?:[03-57-9]\\d\\d|[126](?:[089]\\d|7[02-8]))|[45]\\d{3}|6(?:[02457-9]\\d\\d|[136](?:[089]\\d|7[02-8]))|7(?:(?:0[07-9]|[1-69]\\d)\\d|[78](?:[089]\\d|7[02-8]))|8(?:[0-25-9]\\d\\d|3(?:[089]\\d|7[02-8])|4(?:[0489]\\d|7[02-8]))|9(?:[02-9]\\d\\d|1(?:[0289]\\d|7[02-8])))|9\\d{4})\\d{5}",
      null,
      null,
      null,
      "8123456789",
      null,
      null,
      [10]
    ], [null, null, "(?:00800\\d|1(?:600|80[03]\\d{3}))\\d{6}|1800\\d{4,8}", null, null, null, "1800123456"], [null, null, "186[12]\\d{9}", null, null, null, "1861123456789", null, null, [13]], [null, null, "1860\\d{7}", null, null, null, "18603451234", null, null, [11]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "IN", 91, "00", "0", null, null, "0", null, null, null, [[null, "(\\d{8})", "$1", ["5[0236-8]"], null, null, 1], [
      null,
      "(\\d{4})(\\d{4,5})",
      "$1 $2",
      ["180", "1800"],
      null,
      null,
      1
    ], [null, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", null, 1], [
      null,
      "(\\d{3})(\\d{3})(\\d{4})",
      "$1 $2 $3",
      [
        "1(?:2[0-249]|3[0-25]|4[145]|[59][14]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1|9[15])|6(?:12|[2-4]1|5[17]|6[13]|7[14]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)",
        "1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6(?:0[2-7]|[1-9])|7[1257]|8(?:[06][2-7]|[1-57-9]))|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5(?:1|2[2-7])|[78]1|9[15])|6(?:12[2-7]|[2-4]1|5[17]|6[13]|7[14]|80)|7(?:12|(?:2[14]|5[15])[2-6]|3(?:1[2-7]|[34][2-6])|4[47][2-7]|61[346]|88[0-8])|8(?:(?:16|2[014]|3[126]|6[136])[2-7]|7(?:0[2-6]|[78][2-7])|8(?:3[2-7]|4[235-7])|91[3-7])",
        "1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6(?:0[2-7]|[1-9])|7[1257]|8(?:[06][2-7]|[1-57-9]))|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5(?:1|2[2-7])|[78]1|9[15])|6(?:12(?:[2-6]|7[0-8])|[2-4]1|5[17]|6[13]|7[14]|80)|7(?:12|(?:2[14]|5[15])[2-6]|3(?:1(?:[2-6]|71)|[34][2-6])|4[47](?:[2-6]|7[19])|61[346]|88(?:[01][2-7]|[2-7]|82))|8(?:(?:16|2[014]|3[126]|6[136])(?:[2-6]|7[19])|7(?:0[2-6]|[78](?:[2-6]|7[19]))|8(?:3(?:[2-6]|7[19])|4(?:[2356]|7[19]))|91(?:[3-6]|7[19]))"
      ],
      "0$1",
      null,
      1
    ], [
      null,
      "(\\d{4})(\\d{3})(\\d{3})",
      "$1 $2 $3",
      ["1(?:[23579]|4[236-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|[4-8])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[23579]|4[236-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|[4-8])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[23579]|4[236-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|[4-8])|7(?:1(?:[013-8]|9[6-9])|(?:28[6-8]|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7])[2-7]|3(?:179|(?:2[0-49]|9[2-57])[2-7]))|807(?:1|9[1-3])"],
      "0$1",
      null,
      1
    ], [null, "(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", null, 1], [null, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["14"], null, null, 1], [null, "(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], null, null, 1], [null, "(\\d{2})(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3 $4", ["0"], "0$1", null, 1], [null, "(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["1"], null, null, 1]], [[null, "(\\d{8})", "$1", ["5[0236-8]"], null, null, 1], [null, "(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], null, null, 1], [
      null,
      "(\\d{2})(\\d{4})(\\d{4})",
      "$1 $2 $3",
      ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"],
      "0$1",
      null,
      1
    ], [
      null,
      "(\\d{3})(\\d{3})(\\d{4})",
      "$1 $2 $3",
      [
        "1(?:2[0-249]|3[0-25]|4[145]|[59][14]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1|9[15])|6(?:12|[2-4]1|5[17]|6[13]|7[14]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)",
        "1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6(?:0[2-7]|[1-9])|7[1257]|8(?:[06][2-7]|[1-57-9]))|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5(?:1|2[2-7])|[78]1|9[15])|6(?:12[2-7]|[2-4]1|5[17]|6[13]|7[14]|80)|7(?:12|(?:2[14]|5[15])[2-6]|3(?:1[2-7]|[34][2-6])|4[47][2-7]|61[346]|88[0-8])|8(?:(?:16|2[014]|3[126]|6[136])[2-7]|7(?:0[2-6]|[78][2-7])|8(?:3[2-7]|4[235-7])|91[3-7])",
        "1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6(?:0[2-7]|[1-9])|7[1257]|8(?:[06][2-7]|[1-57-9]))|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5(?:1|2[2-7])|[78]1|9[15])|6(?:12(?:[2-6]|7[0-8])|[2-4]1|5[17]|6[13]|7[14]|80)|7(?:12|(?:2[14]|5[15])[2-6]|3(?:1(?:[2-6]|71)|[34][2-6])|4[47](?:[2-6]|7[19])|61[346]|88(?:[01][2-7]|[2-7]|82))|8(?:(?:16|2[014]|3[126]|6[136])(?:[2-6]|7[19])|7(?:0[2-6]|[78](?:[2-6]|7[19]))|8(?:3(?:[2-6]|7[19])|4(?:[2356]|7[19]))|91(?:[3-6]|7[19]))"
      ],
      "0$1",
      null,
      1
    ], [
      null,
      "(\\d{4})(\\d{3})(\\d{3})",
      "$1 $2 $3",
      ["1(?:[23579]|4[236-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|[4-8])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[23579]|4[236-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|[4-8])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[23579]|4[236-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|[4-8])|7(?:1(?:[013-8]|9[6-9])|(?:28[6-8]|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7])[2-7]|3(?:179|(?:2[0-49]|9[2-57])[2-7]))|807(?:1|9[1-3])"],
      "0$1",
      null,
      1
    ], [null, "(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", null, 1], [null, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["14"], null, null, 1], [null, "(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], null, null, 1], [null, "(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["1"], null, null, 1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, "(?:00800\\d|1(?:600|8(?:0[03]\\d\\d|6(?:0|[12]\\d\\d))\\d))\\d{6}|1800\\d{4,8}"], [
      null,
      null,
      "140\\d{7}",
      null,
      null,
      null,
      "1409305260",
      null,
      null,
      [10]
    ], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    IO: [
      null,
      [null, null, "3\\d{6}", null, null, null, null, null, null, [7]],
      [null, null, "37\\d{5}", null, null, null, "3709100"],
      [null, null, "38\\d{5}", null, null, null, "3801234"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "IO",
      246,
      "00",
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [[null, "(\\d{3})(\\d{4})", "$1 $2", ["3"]]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    IQ: [null, [null, null, "(?:1|[2-6]\\d?|7\\d\\d)\\d{7}", null, null, null, null, null, null, [8, 9, 10], [6, 7]], [
      null,
      null,
      "1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}",
      null,
      null,
      null,
      "12345678",
      null,
      null,
      [8, 9],
      [6, 7]
    ], [null, null, "7[3-9]\\d{8}", null, null, null, "7912345678", null, null, [10]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "IQ", 964, "00", "0", null, null, "0", null, null, null, [[null, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [
      null,
      "(\\d{2})(\\d{3})(\\d{3,4})",
      "$1 $2 $3",
      ["[2-6]"],
      "0$1"
    ], [null, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    IR: [null, [null, null, "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", null, null, null, null, null, null, [4, 5, 6, 7, 10], [8]], [
      null,
      null,
      "(?:(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])\\d{4}|94(?:(?:000|(?:11|2\\d)\\d|30[01])\\d|4(?:111|40\\d)))\\d{4}|(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[16]|[289]\\d?)\\d{3}",
      null,
      null,
      null,
      "2123456789",
      null,
      null,
      [6, 7, 10],
      [4, 5, 8]
    ], [null, null, "9(?:(?:0(?:[1-35]\\d|44)|(?:[13]\\d|2[0-2])\\d)\\d|9(?:(?:[01]\\d|44)\\d|510|8(?:1[01]|88)|9(?:0[013]|1[0134]|21|77|9[6-9])))\\d{5}", null, null, null, "9123456789", null, null, [10]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      "993\\d{7}",
      null,
      null,
      null,
      "9932123456",
      null,
      null,
      [10]
    ], "IR", 98, "00", "0", null, null, "0", null, null, null, [[null, "(\\d{4,5})", "$1", ["96"], "0$1"], [null, "(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], [null, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], [null, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [
      null,
      null,
      "9(?:4(?:11[1-7]|440)\\d{5}|6(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19]))",
      null,
      null,
      null,
      null,
      null,
      null,
      [4, 5, 10]
    ], [null, null, "96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])", null, null, null, "9601", null, null, [4, 5]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    IS: [
      null,
      [null, null, "(?:38\\d|[4-9])\\d{6}", null, null, null, null, null, null, [7, 9]],
      [
        null,
        null,
        "(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-245]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|87[23])\\d{4}",
        null,
        null,
        null,
        "4101234",
        null,
        null,
        [7]
      ],
      [null, null, "(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[027-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-8]\\d|9[0-3])|8(?:2[0-59]|[3469]\\d|5[1-9]|8[28]))\\d{4}", null, null, null, "6111234"],
      [null, null, "800\\d{4}", null, null, null, "8001234", null, null, [7]],
      [null, null, "90\\d{5}", null, null, null, "9011234", null, null, [7]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "49\\d{5}", null, null, null, "4921234", null, null, [7]],
      "IS",
      354,
      "00|1(?:0(?:01|[12]0)|100)",
      null,
      null,
      null,
      null,
      null,
      "00",
      null,
      [[null, "(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], [null, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "809\\d{4}", null, null, null, "8091234", null, null, [7]],
      null,
      null,
      [null, null, "(?:689|8(?:7[0189]|80)|95[48])\\d{4}", null, null, null, "6891234", null, null, [7]]
    ],
    IT: [null, [
      null,
      null,
      "0\\d{6}(?:\\d{4})?|3[0-8]\\d{9}|(?:[0138]\\d?|55)\\d{8}|[08]\\d{5}(?:\\d{2})?",
      null,
      null,
      null,
      null,
      null,
      null,
      [6, 7, 8, 9, 10, 11]
    ], [
      null,
      null,
      "0(?:(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d|6(?:[0-57-9]\\d\\d|6(?:[0-8]\\d|9[0-79])))\\d{1,6}",
      null,
      null,
      null,
      "0212345678"
    ], [null, null, "33\\d{9}|3[1-9]\\d{8}|3[2-9]\\d{7}", null, null, null, "3123456789", null, null, [9, 10, 11]], [null, null, "80(?:0\\d{3}|3)\\d{3}", null, null, null, "800123456", null, null, [6, 9]], [null, null, "(?:(?:0878|1(?:44|6[346])\\d)\\d\\d|89(?:2|(?:4[5-9]|(?:5[5-9]|9)\\d\\d)\\d))\\d{3}|89[45][0-4]\\d\\d", null, null, null, "899123456", null, null, [6, 8, 9, 10]], [null, null, "84(?:[08]\\d{3}|[17])\\d{3}", null, null, null, "848123456", null, null, [6, 9]], [
      null,
      null,
      "1(?:78\\d|99)\\d{6}",
      null,
      null,
      null,
      "1781234567",
      null,
      null,
      [9, 10]
    ], [null, null, "55\\d{8}", null, null, null, "5512345678", null, null, [10]], "IT", 39, "00", null, null, null, null, null, null, null, [[null, "(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], [null, "(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[245])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"]], [null, "(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], [null, "(\\d{4})(\\d{4})", "$1 $2", ["894"]], [null, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], [
      null,
      "(\\d{3})(\\d{3})(\\d{3,4})",
      "$1 $2 $3",
      ["1(?:44|[67]|99)|[38]"]
    ], [null, "(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]"]], [null, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["3"]], [null, "(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], [null, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], 1, null, [null, null, "848\\d{6}", null, null, null, null, null, null, [9]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    JE: [
      null,
      [null, null, "(?:1534|(?:[3578]\\d|90)\\d\\d)\\d{6}", null, null, null, null, null, null, [10], [6]],
      [null, null, "1534[0-24-8]\\d{5}", null, null, null, "1534456789", null, null, null, [6]],
      [null, null, "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}", null, null, null, "7797712345"],
      [null, null, "80(?:07(?:35|81)|8901)\\d{4}", null, null, null, "8007354567"],
      [null, null, "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}", null, null, null, "9018105678"],
      [
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        [-1]
      ],
      [null, null, "701511\\d{4}", null, null, null, "7015115678"],
      [null, null, "56\\d{8}", null, null, null, "5612345678"],
      "JE",
      44,
      "00",
      "0",
      null,
      null,
      "0|([0-24-8]\\d{5})$",
      "1534$1",
      null,
      null,
      null,
      null,
      [null, null, "76(?:0[0-2]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}", null, null, null, "7640123456"],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [
        null,
        null,
        "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}",
        null,
        null,
        null,
        "5512345678"
      ],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    JM: [null, [null, null, "(?:[58]\\d\\d|658|900)\\d{7}", null, null, null, null, null, null, [10], [7]], [null, null, "(?:658[2-9]\\d\\d|876(?:5(?:0[12]|1[0-468]|2[35]|63)|6(?:0[1-3579]|1[0237-9]|[23]\\d|40|5[06]|6[2-589]|7[05]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}", null, null, null, "8765230123", null, null, null, [7]], [
      null,
      null,
      "876(?:(?:2[14-9]|[348]\\d)\\d|5(?:0[3-9]|[2-57-9]\\d|6[0-24-9])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579]))\\d{4}",
      null,
      null,
      null,
      "8762101234",
      null,
      null,
      null,
      [7]
    ], [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002123456"], [null, null, "900[2-9]\\d{6}", null, null, null, "9002123456"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"], [null, null, null, null, null, null, null, null, null, [-1]], "JM", 1, "011", "1", null, null, "1", null, null, null, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, "658|876", [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    JO: [null, [null, null, "(?:(?:(?:[268]|7\\d)\\d|32|53)\\d|900)\\d{5}", null, null, null, null, null, null, [8, 9]], [
      null,
      null,
      "(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[57][023]|6[03])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2[05]0|3(?:00|33)|4(?:0[0-25]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:[029]0|7[08]))\\d{4}",
      null,
      null,
      null,
      "62001234",
      null,
      null,
      [8]
    ], [null, null, "7(?:55[0-49]|(?:7[025-9]|[89][0-25-9])\\d)\\d{5}", null, null, null, "790123456", null, null, [9]], [null, null, "80\\d{6}", null, null, null, "80012345", null, null, [8]], [null, null, "900\\d{5}", null, null, null, "90012345", null, null, [8]], [null, null, "85\\d{6}", null, null, null, "85012345", null, null, [8]], [null, null, "70\\d{7}", null, null, null, "700123456", null, null, [9]], [null, null, null, null, null, null, null, null, null, [-1]], "JO", 962, "00", "0", null, null, "0", null, null, null, [[
      null,
      "(\\d)(\\d{3})(\\d{4})",
      "$1 $2 $3",
      ["[2356]|87"],
      "(0$1)"
    ], [null, "(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], [null, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7[457-9]"], "0$1"], [null, "(\\d{2})(\\d{7})", "$1 $2", ["7"], "0$1"]], null, [null, null, "74(?:66|77)\\d{5}", null, null, null, "746612345", null, null, [9]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "8(?:10|8\\d)\\d{5}", null, null, null, "88101234", null, null, [8]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    JP: [
      null,
      [null, null, "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", null, null, null, null, null, null, [8, 9, 10, 11, 12, 13, 14, 15, 16, 17]],
      [null, null, "(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}", null, null, null, "312345678", null, null, [9]],
      [
        null,
        null,
        "[7-9]0[1-9]\\d{7}",
        null,
        null,
        null,
        "9012345678",
        null,
        null,
        [10]
      ],
      [null, null, "(?:00(?:(?:37|66)\\d{4,11}|777(?:[01]|(?:5|8\\d)\\d)|882[1245]\\d\\d)|(?:120|800\\d)\\d{4})\\d\\d", null, null, null, "120123456"],
      [null, null, "990\\d{6}", null, null, null, "990123456", null, null, [9]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "60\\d{7}", null, null, null, "601234567", null, null, [9]],
      [null, null, "50[1-9]\\d{7}", null, null, null, "5012345678", null, null, [10]],
      "JP",
      81,
      "010",
      "0",
      null,
      null,
      "0",
      null,
      null,
      null,
      [[null, "(\\d{4})(\\d{4})", "$1-$2", [
        "007",
        "0077",
        "00777",
        "00777[01]"
      ]], [null, "(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], [
        null,
        "(\\d{4})(\\d)(\\d{4})",
        "$1-$2-$3",
        ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:49|80|9[16])", "1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[78]|96)|477|51[24]|636)|9(?:496|802|9(?:1[23]|69))", "1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[78]|96[2457-9])|477|51[24]|636[2-57-9])|9(?:496|802|9(?:1[23]|69))"],
        "0$1"
      ], [
        null,
        "(\\d{3})(\\d{2})(\\d{4})",
        "$1-$2-$3",
        [
          "1(?:[2-46]|5[2-8]|7[2-689]|8[2-7]|9[1-578])|2(?:2[03-689]|3[3-58]|4[0-468]|5[04-8]|6[013-8]|7[06-9]|8[02-57-9]|9[13])|4(?:2[28]|3[689]|6[035-7]|7[05689]|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|[67]|8[14-7]|9[4-9])|7(?:2[15]|3[5-9]|4|6[135-8]|7[0-4689]|9[014-9])|8(?:2[49]|3[3-8]|4[5-8]|5[2-9]|6[35-9]|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9[3-7])",
          "1(?:[2-46]|5(?:[236-8]|[45][2-69])|7[2-689]|8[2-7]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|[67]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9[2-8])|3(?:[3-6][2-9]|7[2-6]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5[4-7]|6[2-9]|8[2-8]|9[236-9])|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3[34]|4[2-69]|[5-7]))",
          "1(?:[2-46]|5(?:[236-8]|[45][2-69])|7[2-689]|8[2-7]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|[67]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:20|[3578]|4[04-9]|6[56]))|3(?:[3-6][2-9]|7(?:[2-5]|6[0-59])|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))",
          "1(?:[2-46]|5(?:[236-8]|[45][2-69])|7[2-689]|8[2-7]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|[67]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:20|[3578]|4[04-9]|6(?:5[25]|60)))|3(?:[3-6][2-9]|7(?:[2-5]|6[0-59])|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))"
        ],
        "0$1"
      ], [null, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1|2(?:2[37]|5[5-9]|64|78|8[39]|91)|4(?:2[2689]|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93)", "1|2(?:2[37]|5(?:[57]|[68]0|9[19])|64|78|8[39]|917)|4(?:2(?:20|[68]|9[178])|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93[34])", "1|2(?:2[37]|5(?:[57]|[68]0|9(?:17|99))|64|78|8[39]|917)|4(?:2(?:20|[68]|9[178])|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93[34])"], "0$1"], [
        null,
        "(\\d{3})(\\d{2})(\\d{4})",
        "$1-$2-$3",
        ["2(?:[34]7|[56]9|74|9[14-79])|82|993"],
        "0$1"
      ], [null, "(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])"], "0$1"], [null, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["2[2-9]|4|7[235-9]|9[49]"], "0$1"], [null, "(\\d{4})(\\d{2})(\\d{3,4})", "$1-$2-$3", ["007"]], [null, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], [null, "(\\d{4})(\\d{2})(\\d{4})", "$1-$2-$3", ["008"]], [null, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[2579]|80"], "0$1"], [null, "(\\d{4})(\\d{3})(\\d{3,4})", "$1-$2-$3", ["0"]], [
        null,
        "(\\d{4})(\\d{4})(\\d{4,5})",
        "$1-$2-$3",
        ["0"]
      ], [null, "(\\d{4})(\\d{5})(\\d{5,6})", "$1-$2-$3", ["0"]], [null, "(\\d{4})(\\d{6})(\\d{6,7})", "$1-$2-$3", ["0"]]],
      [[null, "(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], [null, "(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", [
        "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:49|80|9[16])",
        "1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[78]|96)|477|51[24]|636)|9(?:496|802|9(?:1[23]|69))",
        "1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[78]|96[2457-9])|477|51[24]|636[2-57-9])|9(?:496|802|9(?:1[23]|69))"
      ], "0$1"], [
        null,
        "(\\d{3})(\\d{2})(\\d{4})",
        "$1-$2-$3",
        [
          "1(?:[2-46]|5[2-8]|7[2-689]|8[2-7]|9[1-578])|2(?:2[03-689]|3[3-58]|4[0-468]|5[04-8]|6[013-8]|7[06-9]|8[02-57-9]|9[13])|4(?:2[28]|3[689]|6[035-7]|7[05689]|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|[67]|8[14-7]|9[4-9])|7(?:2[15]|3[5-9]|4|6[135-8]|7[0-4689]|9[014-9])|8(?:2[49]|3[3-8]|4[5-8]|5[2-9]|6[35-9]|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9[3-7])",
          "1(?:[2-46]|5(?:[236-8]|[45][2-69])|7[2-689]|8[2-7]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|[67]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9[2-8])|3(?:[3-6][2-9]|7[2-6]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5[4-7]|6[2-9]|8[2-8]|9[236-9])|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3[34]|4[2-69]|[5-7]))",
          "1(?:[2-46]|5(?:[236-8]|[45][2-69])|7[2-689]|8[2-7]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|[67]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:20|[3578]|4[04-9]|6[56]))|3(?:[3-6][2-9]|7(?:[2-5]|6[0-59])|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))",
          "1(?:[2-46]|5(?:[236-8]|[45][2-69])|7[2-689]|8[2-7]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|[67]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:20|[3578]|4[04-9]|6(?:5[25]|60)))|3(?:[3-6][2-9]|7(?:[2-5]|6[0-59])|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))"
        ],
        "0$1"
      ], [null, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1|2(?:2[37]|5[5-9]|64|78|8[39]|91)|4(?:2[2689]|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93)", "1|2(?:2[37]|5(?:[57]|[68]0|9[19])|64|78|8[39]|917)|4(?:2(?:20|[68]|9[178])|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93[34])", "1|2(?:2[37]|5(?:[57]|[68]0|9(?:17|99))|64|78|8[39]|917)|4(?:2(?:20|[68]|9[178])|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93[34])"], "0$1"], [
        null,
        "(\\d{3})(\\d{2})(\\d{4})",
        "$1-$2-$3",
        ["2(?:[34]7|[56]9|74|9[14-79])|82|993"],
        "0$1"
      ], [null, "(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])"], "0$1"], [null, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["2[2-9]|4|7[235-9]|9[49]"], "0$1"], [null, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], [null, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[2579]|80"], "0$1"]],
      [null, null, "20\\d{8}", null, null, null, "2012345678", null, null, [10]],
      null,
      null,
      [null, null, "00(?:(?:37|66)\\d{4,11}|777(?:[01]|(?:5|8\\d)\\d)|882[1245]\\d\\d)\\d\\d"],
      [
        null,
        null,
        "570\\d{6}",
        null,
        null,
        null,
        "570123456",
        null,
        null,
        [9]
      ],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    KE: [null, [null, null, "(?:(?:2|80)0\\d?|[4-7]\\d\\d|900)\\d{6}|[4-6]\\d{6,7}", null, null, null, null, null, null, [7, 8, 9, 10]], [null, null, "20\\d{6,7}|(?:4[0-6]|5\\d|6[0-24-9])\\d{7}|(?:4[0245]|6[014-9])\\d{6}|5[1-79]\\d{5,6}|(?:4[245]|6[01457-9])\\d{5}", null, null, null, "202012345", null, null, [7, 8, 9]], [null, null, "7\\d{8}", null, null, null, "712123456", null, null, [9]], [
      null,
      null,
      "800[24-8]\\d{5,6}",
      null,
      null,
      null,
      "800223456",
      null,
      null,
      [9, 10]
    ], [null, null, "900[02-9]\\d{5}", null, null, null, "900223456", null, null, [9]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "KE", 254, "000", "0", null, null, "0", null, null, null, [[null, "(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], [null, "(\\d{3})(\\d{6})", "$1 $2", ["7"], "0$1"], [null, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    KG: [null, [null, null, "(?:[235-7]\\d|99)\\d{7}|800\\d{6,7}", null, null, null, null, null, null, [9, 10], [5, 6]], [
      null,
      null,
      "(?:3(?:1(?:[256]\\d|3[1-9]|47)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}",
      null,
      null,
      null,
      "312123456",
      null,
      null,
      [9],
      [5, 6]
    ], [null, null, "(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|7(?:[07]\\d|55)|99[69])\\d{6}", null, null, null, "700123456", null, null, [9]], [null, null, "800\\d{6,7}", null, null, null, "800123456"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "KG", 996, "00", "0", null, null, "0", null, null, null, [[
      null,
      "(\\d{3})(\\d{3})(\\d{3})",
      "$1 $2 $3",
      ["[25-79]|31[25]"],
      "0$1"
    ], [null, "(\\d{4})(\\d{5})", "$1 $2", ["3"], "0$1"], [null, "(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    KH: [null, [null, null, "1\\d{9}|[1-9]\\d{7,8}", null, null, null, null, null, null, [8, 9, 10], [6, 7]], [
      null,
      null,
      "(?:2(?:3(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)|[4-6](?:4[56]|[56]\\d)\\d)|(?:3[2-6]|4[2-4]|[5-7][2-5])(?:4[56]|[56]\\d)\\d)\\d{4}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])[236-9]\\d{5}",
      null,
      null,
      null,
      "23756789",
      null,
      null,
      [8, 9],
      [6, 7]
    ], [null, null, "(?:(?:(?:1[28]|9[67])\\d|8(?:[013-79]|8\\d))\\d|(?:2[3-6]|4[2-4]|[56][2-5])48|3(?:[18]\\d\\d|[2-6]48)|7(?:(?:[07-9]|[16]\\d)\\d|[2-5]48))\\d{5}|(?:1\\d|6[016-9]|9[0-57-9])\\d{6}", null, null, null, "91234567", null, null, [8, 9]], [null, null, "1800(?:1\\d|2[019])\\d{4}", null, null, null, "1800123456", null, null, [10]], [null, null, "1900(?:1\\d|2[09])\\d{4}", null, null, null, "1900123456", null, null, [10]], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], "KH", 855, "00[14-9]", "0", null, null, "0", null, null, null, [[null, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], [null, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    KI: [
      null,
      [null, null, "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", null, null, null, null, null, null, [5, 8]],
      [null, null, "(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}", null, null, null, "31234"],
      [null, null, "(?:6(?:200[01]|30[01]\\d)|7(?:200[01]|3(?:0[0-5]\\d|140)))\\d{3}", null, null, null, "72001234", null, null, [8]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "30(?:0[01]\\d\\d|12(?:11|20))\\d\\d", null, null, null, "30010000", null, null, [8]],
      "KI",
      686,
      "00",
      "0",
      null,
      null,
      "0",
      null,
      null,
      null,
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    KM: [
      null,
      [
        null,
        null,
        "[3478]\\d{6}",
        null,
        null,
        null,
        null,
        null,
        null,
        [7]
      ],
      [null, null, "7[4-7]\\d{5}", null, null, null, "7712345"],
      [null, null, "[34]\\d{6}", null, null, null, "3212345"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "8\\d{6}", null, null, null, "8001234"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "KM",
      269,
      "00",
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [[null, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    KN: [null, [null, null, "(?:[58]\\d\\d|900)\\d{7}", null, null, null, null, null, null, [10], [7]], [null, null, "869(?:2(?:29|36)|302|4(?:6[015-9]|70))\\d{4}", null, null, null, "8692361234", null, null, null, [7]], [
      null,
      null,
      "869(?:5(?:5[6-8]|6[5-7])|66\\d|76[02-7])\\d{4}",
      null,
      null,
      null,
      "8697652917",
      null,
      null,
      null,
      [7]
    ], [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002123456"], [null, null, "900[2-9]\\d{6}", null, null, null, "9002123456"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"], [null, null, null, null, null, null, null, null, null, [-1]], "KN", 1, "011", "1", null, null, "1", null, null, null, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, "869", [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    KP: [null, [null, null, "(?:(?:19\\d|2)\\d|85)\\d{6}", null, null, null, null, null, null, [8, 10], [6, 7]], [null, null, "(?:2\\d|85)\\d{6}", null, null, null, "21234567", null, null, [8], [6, 7]], [null, null, "19[1-3]\\d{7}", null, null, null, "1921234567", null, null, [10]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "KP", 850, "00|99", "0", null, null, "0", null, null, null, [[null, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [null, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], [null, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [
      null,
      null,
      "2(?:[0-24-9]\\d\\d|3(?:[0-79]\\d|8[02-9]))\\d{4}",
      null,
      null,
      null,
      null,
      null,
      null,
      [8]
    ], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    KR: [
      null,
      [null, null, "(?:00[1-9]\\d{2,4}|[12]|5\\d{3})\\d{7}|(?:(?:00|[13-6])\\d|70)\\d{8}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}", null, null, null, null, null, null, [5, 6, 8, 9, 10, 11, 12, 13, 14], [3, 7]],
      [null, null, "2[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])(?:1\\d{2,3}|[1-9]\\d{6,7})", null, null, null, "22123456", null, null, [5, 6, 8, 9, 10], [3, 7]],
      [
        null,
        null,
        "1[0-26-9]\\d{7,8}",
        null,
        null,
        null,
        "1000000000",
        null,
        null,
        [9, 10]
      ],
      [null, null, "(?:00(?:3(?:08|68\\d)|798\\d{1,3})|80\\d)\\d{6}", null, null, null, "801234567", null, null, [9, 11, 12, 13, 14]],
      [null, null, "60[2-9]\\d{6}", null, null, null, "602345678", null, null, [9]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "50\\d{8,9}", null, null, null, "5012345678", null, null, [10, 11]],
      [null, null, "70\\d{8}", null, null, null, "7012345678", null, null, [10]],
      "KR",
      82,
      "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
      "0",
      null,
      null,
      "0(8[1-46-8]|85\\d{2})?",
      null,
      null,
      null,
      [[null, "(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1", "0$CC-$1"], [null, "(\\d{4})(\\d{4})", "$1-$2", ["1(?:5[246-9]|6[046-8]|8[03579])", "1(?:5(?:22|44|66|77|88|99)|6(?:[07]0|44|6[16]|88)|8(?:00|33|55|77|99))"], "$1", "0$CC-$1"], [null, "(\\d{5})", "$1", ["1[016-9]1", "1[016-9]11", "1[016-9]114"], "0$1", "0$CC-$1"], [null, "(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2[1-9]"], "0$1", "0$CC-$1"], [null, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60[2-9]|80"], "0$1", "0$CC-$1"], [
        null,
        "(\\d{2})(\\d{3,4})(\\d{4})",
        "$1-$2-$3",
        ["1[0-25-9]|(?:3[1-3]|[46][1-4]|5[1-5])[1-9]"],
        "0$1",
        "0$CC-$1"
      ], [null, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]0"], "0$1", "0$CC-$1"], [null, "(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["50"], "0$1", "0$CC-$1"], [null, "(\\d{5})(\\d{3})(\\d{3})", "$1 $2 $3", ["003", "0030", "00308"], "$1", "0$CC-$1"], [null, "(\\d{5})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["00[37]", "00(?:36|79)", "00(?:36|79)8"], "$1", "0$CC-$1"], [null, "(\\d{5})(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["007", "0079", "00798"], "$1", "0$CC-$1"]],
      [[
        null,
        "(\\d{2})(\\d{3,4})",
        "$1-$2",
        ["(?:3[1-3]|[46][1-4]|5[1-5])1"],
        "0$1",
        "0$CC-$1"
      ], [null, "(\\d{4})(\\d{4})", "$1-$2", ["1(?:5[246-9]|6[046-8]|8[03579])", "1(?:5(?:22|44|66|77|88|99)|6(?:[07]0|44|6[16]|88)|8(?:00|33|55|77|99))"], "$1", "0$CC-$1"], [null, "(\\d{5})", "$1", ["1[016-9]1", "1[016-9]11", "1[016-9]114"], "0$1", "0$CC-$1"], [null, "(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2[1-9]"], "0$1", "0$CC-$1"], [null, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60[2-9]|80"], "0$1", "0$CC-$1"], [
        null,
        "(\\d{2})(\\d{3,4})(\\d{4})",
        "$1-$2-$3",
        ["1[0-25-9]|(?:3[1-3]|[46][1-4]|5[1-5])[1-9]"],
        "0$1",
        "0$CC-$1"
      ], [null, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]0"], "0$1", "0$CC-$1"], [null, "(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["50"], "0$1", "0$CC-$1"]],
      [null, null, "15\\d{7,8}", null, null, null, "1523456789", null, null, [9, 10]],
      null,
      null,
      [null, null, "00(?:3(?:08|68\\d)|798\\d{1,3})\\d{6}", null, null, null, null, null, null, [11, 12, 13, 14]],
      [
        null,
        null,
        "1(?:5(?:22|44|66|77|88|99)|6(?:00|44|6[16]|70|88)|8(?:00|33|55|77|99))\\d{4}",
        null,
        null,
        null,
        "15441234",
        null,
        null,
        [8]
      ],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    KW: [null, [null, null, "(?:18|[2569]\\d\\d)\\d{5}", null, null, null, null, null, null, [7, 8]], [null, null, "2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}", null, null, null, "22345678", null, null, [8]], [
      null,
      null,
      "(?:5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25]))|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|222|7(?:0[013-9]|[67]\\d)|9(?:[069]\\d|3[039]))|9(?:(?:0[09]|22|4[01479]|55|6[0679]|8[057-9]|9\\d)\\d|11[01]|7(?:02|[1-9]\\d)))\\d{4}",
      null,
      null,
      null,
      "50012345",
      null,
      null,
      [8]
    ], [null, null, "18\\d{5}", null, null, null, "1801234", null, null, [7]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "KW", 965, "00", null, null, null, null, null, null, null, [[null, "(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], [null, "(\\d{3})(\\d{5})", "$1 $2", ["[25]"]]], null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    KY: [
      null,
      [null, null, "(?:345|[58]\\d\\d|900)\\d{7}", null, null, null, null, null, null, [10], [7]],
      [null, null, "345(?:2(?:22|44)|444|6(?:23|38|40)|7(?:4[35-79]|6[6-9]|77)|8(?:00|1[45]|25|[48]8)|9(?:14|4[035-9]))\\d{4}", null, null, null, "3452221234", null, null, null, [7]],
      [
        null,
        null,
        "345(?:32[1-9]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|9(?:1[67]|2[2-9]|3[689]))\\d{4}",
        null,
        null,
        null,
        "3453231234",
        null,
        null,
        null,
        [7]
      ],
      [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002345678"],
      [null, null, "(?:345976|900[2-9]\\d\\d)\\d{4}", null, null, null, "9002345678"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "KY",
      1,
      "011",
      "1",
      null,
      null,
      "1",
      null,
      null,
      null,
      null,
      null,
      [null, null, "345849\\d{4}", null, null, null, "3458491234"],
      null,
      "345",
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    KZ: [null, [null, null, "(?:33622|(?:7\\d|80)\\d{3})\\d{5}", null, null, null, null, null, null, [10]], [
      null,
      null,
      "(?:33622|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9])|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-246-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59))))\\d{5}",
      null,
      null,
      null,
      "7123456789"
    ], [null, null, "7(?:0[0-2578]|47|6[02-4]|7[15-8]|85)\\d{7}", null, null, null, "7710009998"], [null, null, "800\\d{7}", null, null, null, "8001234567"], [null, null, "809\\d{7}", null, null, null, "8091234567"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "808\\d{7}", null, null, null, "8081234567"], [null, null, "751\\d{7}", null, null, null, "7511234567"], "KZ", 7, "810", "8", null, null, "8", null, "8~10", null, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, "33|7", [
      null,
      null,
      "751\\d{7}"
    ], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    LA: [null, [null, null, "(?:2\\d|3)\\d{8}|(?:[235-8]\\d|41)\\d{6}", null, null, null, null, null, null, [8, 9, 10], [6]], [null, null, "(?:2[13]|[35-7][14]|41|8[1468])\\d{6}", null, null, null, "21212862", null, null, [8], [6]], [null, null, "20(?:2[2389]|5[24-689]|7[6-8]|9[1-35-9])\\d{6}", null, null, null, "2023123456", null, null, [10]], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "LA", 856, "00", "0", null, null, "0", null, null, null, [[null, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], [null, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["3"], "0$1"], [null, "(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2"], "0$1"]], null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "30\\d{7}", null, null, null, "301234567", null, null, [9]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    LB: [
      null,
      [null, null, "[7-9]\\d{7}|[13-9]\\d{6}", null, null, null, null, null, null, [7, 8]],
      [null, null, "(?:(?:[14-69]\\d|8[02-9])\\d|7(?:[2-57]\\d|62|8[0-7]|9[04-9]))\\d{4}", null, null, null, "1123456", null, null, [7]],
      [null, null, "(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[89]|9[1-3]))\\d{5}", null, null, null, "71123456"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "9[01]\\d{6}", null, null, null, "90123456", null, null, [8]],
      [null, null, "80\\d{6}", null, null, null, "80123456", null, null, [8]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "LB",
      961,
      "00",
      "0",
      null,
      null,
      "0",
      null,
      null,
      null,
      [[null, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], [null, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"]]],
      null,
      [
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        [-1]
      ],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    LC: [null, [null, null, "(?:[58]\\d\\d|758|900)\\d{7}", null, null, null, null, null, null, [10], [7]], [null, null, "758(?:4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|638)\\d{4}", null, null, null, "7584305678", null, null, null, [7]], [
      null,
      null,
      "758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[01]))\\d{4}",
      null,
      null,
      null,
      "7582845678",
      null,
      null,
      null,
      [7]
    ], [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002123456"], [null, null, "900[2-9]\\d{6}", null, null, null, "9002123456"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"], [null, null, null, null, null, null, null, null, null, [-1]], "LC", 1, "011", "1", null, null, "1", null, null, null, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, "758", [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    LI: [null, [null, null, "(?:(?:[2378]|6\\d\\d)\\d|90)\\d{5}", null, null, null, null, null, null, [7, 9]], [null, null, "(?:2(?:01|1[27]|3\\d|6[02-578]|96)|3(?:7[0135-7]|8[048]|9[0269]))\\d{4}", null, null, null, "2345678", null, null, [7]], [null, null, "(?:6(?:5(?:09|1\\d|20)|6(?:0[0-6]|10|2[06-9]|39))\\d|7(?:[37-9]\\d|42|56))\\d{4}", null, null, null, "660234567"], [
      null,
      null,
      "80(?:02[28]|9\\d\\d)\\d\\d",
      null,
      null,
      null,
      "8002222",
      null,
      null,
      [7]
    ], [null, null, "90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d", null, null, null, "9002222", null, null, [7]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "LI", 423, "00", "0", null, null, "0|(10(?:01|20|66))", null, null, null, [[null, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[237-9]"], null, "$CC $1"], [
      null,
      "(\\d{3})(\\d{3})(\\d{3})",
      "$1 $2 $3",
      ["6[56]"],
      null,
      "$CC $1"
    ], [null, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], null, "$CC $1"]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "870(?:28|87)\\d\\d", null, null, null, "8702812", null, null, [7]], null, null, [null, null, "697(?:42|56|[78]\\d)\\d{4}", null, null, null, "697861234", null, null, [9]]],
    LK: [null, [null, null, "(?:[1-7]\\d|[89]1)\\d{7}", null, null, null, null, null, null, [9], [7]], [
      null,
      null,
      "(?:[189]1|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}",
      null,
      null,
      null,
      "112345678",
      null,
      null,
      null,
      [7]
    ], [null, null, "7[0-25-8]\\d{7}", null, null, null, "712345678"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "LK", 94, "00", "0", null, null, "0", null, null, null, [[null, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"], [
      null,
      "(\\d{2})(\\d{3})(\\d{4})",
      "$1 $2 $3",
      ["7"],
      "0$1"
    ]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "1973\\d{5}", null, null, null, "197312345"], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    LR: [null, [null, null, "(?:[25]\\d|33|77|88)\\d{7}|(?:2\\d|[45])\\d{6}", null, null, null, null, null, null, [7, 8, 9]], [null, null, "(?:2\\d{3}|33333)\\d{4}", null, null, null, "21234567", null, null, [8, 9]], [
      null,
      null,
      "(?:(?:(?:20|77|88)\\d|330|555)\\d|4[67])\\d{5}|5\\d{6}",
      null,
      null,
      null,
      "770123456",
      null,
      null,
      [7, 9]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "332(?:02|[34]\\d)\\d{4}", null, null, null, "332021234", null, null, [9]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "LR", 231, "00", "0", null, null, "0", null, null, null, [[null, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[45]"], "0$1"], [null, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], [
      null,
      "(\\d{2})(\\d{3})(\\d{4})",
      "$1 $2 $3",
      ["[23578]"],
      "0$1"
    ]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    LS: [
      null,
      [null, null, "(?:[256]\\d\\d|800)\\d{5}", null, null, null, null, null, null, [8]],
      [null, null, "2\\d{7}", null, null, null, "22123456"],
      [null, null, "[56]\\d{7}", null, null, null, "50123456"],
      [null, null, "800[256]\\d{4}", null, null, null, "80021234"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "LS",
      266,
      "00",
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [[null, "(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        [-1]
      ]
    ],
    LT: [
      null,
      [null, null, "(?:[3469]\\d|52|[78]0)\\d{6}", null, null, null, null, null, null, [8]],
      [null, null, "(?:3[1478]|4[124-6]|52)\\d{6}", null, null, null, "31234567"],
      [null, null, "6\\d{7}", null, null, null, "61234567"],
      [null, null, "800\\d{5}", null, null, null, "80012345"],
      [null, null, "9(?:0[0239]|10)\\d{5}", null, null, null, "90012345"],
      [null, null, "808\\d{5}", null, null, null, "80812345"],
      [null, null, "700\\d{5}", null, null, null, "70012345"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "LT",
      370,
      "00",
      "8",
      null,
      null,
      "[08]",
      null,
      null,
      null,
      [[null, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-79]"], "(8-$1)", null, 1], [null, "(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(8-$1)", null, 1], [null, "(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(8-$1)", null, 1], [null, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "8 $1", null, 1]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "70[67]\\d{5}", null, null, null, "70712345"],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    LU: [
      null,
      [null, null, "[2457-9]\\d{3,10}|3(?:[0-46-9]\\d{2,9}|5(?:[013-9]\\d{1,8}|2\\d{1,3}))|6\\d{8}", null, null, null, null, null, null, [4, 5, 6, 7, 8, 9, 10, 11]],
      [null, null, "(?:(?:2[2-9]|[457]\\d)\\d|3(?:[0-46-9]\\d|5[013-9])|8(?:0[2-9]|[13-9]\\d)|9(?:0[89]|[2-579]\\d))\\d{1,8}", null, null, null, "27123456"],
      [null, null, "6(?:[269][18]|5[158]|7[189]|81)\\d{6}", null, null, null, "628123456", null, null, [9]],
      [
        null,
        null,
        "800\\d{5}",
        null,
        null,
        null,
        "80012345",
        null,
        null,
        [8]
      ],
      [null, null, "90[015]\\d{5}", null, null, null, "90012345", null, null, [8]],
      [null, null, "801\\d{5}", null, null, null, "80112345", null, null, [8]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "20(?:1\\d{5}|[2-689]\\d{1,7})", null, null, null, "20201234", null, null, [4, 5, 6, 7, 8, 9, 10]],
      "LU",
      352,
      "00",
      null,
      null,
      null,
      "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)",
      null,
      null,
      null,
      [
        [
          null,
          "(\\d{2})(\\d{3})",
          "$1 $2",
          ["2(?:0[2-689]|[2-9])|3(?:[0-46-9]|5[013-9])|[457]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"],
          null,
          "$CC $1"
        ],
        [null, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|3(?:[0-46-9]|5[013-9])|[457]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"], null, "$CC $1"],
        [null, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"], null, "$CC $1"],
        [null, "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:0[1-689]|[367]|4[3-8])"], null, "$CC $1"],
        [null, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"], null, "$CC $1"],
        [null, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20[2-689]"], null, "$CC $1"],
        [null, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"], null, "$CC $1"],
        [null, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:0[2-689]|[367]|4[3-8])"], null, "$CC $1"],
        [null, "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["2[2-9]|3(?:[0-46-9]|5[013-9])|[457]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"], null, "$CC $1"]
      ],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    LV: [
      null,
      [null, null, "(?:[268]\\d|90)\\d{6}", null, null, null, null, null, null, [8]],
      [null, null, "6\\d{7}", null, null, null, "63123456"],
      [null, null, "2\\d{7}", null, null, null, "21234567"],
      [null, null, "80\\d{6}", null, null, null, "80123456"],
      [null, null, "90\\d{6}", null, null, null, "90123456"],
      [null, null, "81\\d{6}", null, null, null, "81123456"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "LV",
      371,
      "00",
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [[null, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    LY: [null, [null, null, "(?:[2569]\\d|71)\\d{7}", null, null, null, null, null, null, [9], [7]], [
      null,
      null,
      "(?:2[13-5]|5[1347]|6[1-479]|71)\\d{7}",
      null,
      null,
      null,
      "212345678",
      null,
      null,
      null,
      [7]
    ], [null, null, "9[1-6]\\d{7}", null, null, null, "912345678"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "LY", 218, "00", "0", null, null, "0", null, null, null, [[null, "(\\d{2})(\\d{7})", "$1-$2", ["[25-79]"], "0$1"]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    MA: [null, [null, null, "[5-8]\\d{8}", null, null, null, null, null, null, [9]], [null, null, "5(?:2(?:[015-79]\\d|2[02-9]|3[2-57]|4[2-8]|8[235-7])|3(?:[0-48]\\d|[57][2-9]|6[2-8]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}", null, null, null, "520123456"], [null, null, "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:0[067]|6[1267]|7[017]))\\d{6}", null, null, null, "650123456"], [
      null,
      null,
      "80\\d{7}",
      null,
      null,
      null,
      "801234567"
    ], [null, null, "89\\d{7}", null, null, null, "891234567"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "5924[01]\\d{4}", null, null, null, "592401234"], "MA", 212, "00", "0", null, null, "0", null, null, null, [[null, "(\\d{3})(\\d{6})", "$1-$2", ["5(?:2[015-7]|3[0-4])|[67]"], "0$1"], [null, "(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-489]|3[5-9]|9)|892", "5(?:2(?:[2-48]|9[0-7])|3(?:[5-79]|8[0-7])|9)|892"], "0$1"], [
      null,
      "(\\d{5})(\\d{4})",
      "$1-$2",
      ["5[23]"],
      "0$1"
    ], [null, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5"], "0$1"], [null, "(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"]], null, [null, null, null, null, null, null, null, null, null, [-1]], 1, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    MC: [null, [null, null, "(?:(?:[349]|6\\d)\\d\\d|870)\\d{5}", null, null, null, null, null, null, [8, 9]], [
      null,
      null,
      "(?:870|9[2-47-9]\\d)\\d{5}",
      null,
      null,
      null,
      "99123456",
      null,
      null,
      [8]
    ], [null, null, "(?:(?:3|6\\d)\\d\\d|4(?:4\\d|5[1-9]))\\d{5}", null, null, null, "612345678"], [null, null, "90\\d{6}", null, null, null, "90123456", null, null, [8]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "MC", 377, "00", "0", null, null, "0", null, null, null, [[null, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["8"]], [
      null,
      "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
      "$1 $2 $3 $4",
      ["[39]"]
    ], [null, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], [null, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], [[null, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[39]"]], [null, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], [null, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [
      null,
      null,
      "870\\d{5}",
      null,
      null,
      null,
      null,
      null,
      null,
      [8]
    ], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    MD: [null, [null, null, "(?:[235-7]\\d|[89]0)\\d{6}", null, null, null, null, null, null, [8]], [null, null, "(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}", null, null, null, "22212345"], [null, null, "(?:562|6\\d\\d|7(?:[189]\\d|6[07]|7[457-9]))\\d{5}", null, null, null, "62112345"], [null, null, "800\\d{5}", null, null, null, "80012345"], [null, null, "90[056]\\d{5}", null, null, null, "90012345"], [
      null,
      null,
      "808\\d{5}",
      null,
      null,
      null,
      "80812345"
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "3[08]\\d{6}", null, null, null, "30123456"], "MD", 373, "00", "0", null, null, "0", null, null, null, [[null, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], [null, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"], [null, "(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      "803\\d{5}",
      null,
      null,
      null,
      "80312345"
    ], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    ME: [null, [null, null, "(?:20|[3-79]\\d|80\\d?)\\d{6}", null, null, null, null, null, null, [8, 9], [6]], [null, null, "(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:[01][2467]|2[2-467]))\\d{5}", null, null, null, "30234567", null, null, [8], [6]], [null, null, "6(?:00|3[024]|6[0-25]|[7-9]\\d)\\d{5}", null, null, null, "67622901", null, null, [8]], [null, null, "80(?:[0-2578]|9\\d)\\d{5}", null, null, null, "80080002"], [
      null,
      null,
      "9(?:4[1568]|5[178])\\d{5}",
      null,
      null,
      null,
      "94515151",
      null,
      null,
      [8]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "78[1-49]\\d{5}", null, null, null, "78108780", null, null, [8]], "ME", 382, "00", "0", null, null, "0", null, null, null, [[null, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      "77[1-9]\\d{5}",
      null,
      null,
      null,
      "77273012",
      null,
      null,
      [8]
    ], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    MF: [null, [null, null, "(?:590|69\\d)\\d{6}", null, null, null, null, null, null, [9]], [null, null, "590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}", null, null, null, "590271234"], [null, null, "69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}", null, null, null, "690001234"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], "MF", 590, "00", "0", null, null, "0", null, null, null, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    MG: [null, [null, null, "[23]\\d{8}", null, null, null, null, null, null, [9], [7]], [
      null,
      null,
      "20(?:(?:2\\d|4[47]|5[3467]|6[279]|8[268]|9[245])\\d|7(?:2[29]|[35]\\d))\\d{4}",
      null,
      null,
      null,
      "202123456",
      null,
      null,
      null,
      [7]
    ], [null, null, "3[2-49]\\d{7}", null, null, null, "321234567"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "22\\d{7}", null, null, null, "221234567"], "MG", 261, "00", "0", null, null, "0", null, null, null, [[null, "(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    MH: [null, [null, null, "(?:(?:[256]\\d|45)\\d|329)\\d{4}", null, null, null, null, null, null, [7]], [null, null, "(?:247|528|625)\\d{4}", null, null, null, "2471234"], [null, null, "(?:(?:23|54)5|329|45[56])\\d{4}", null, null, null, "2351234"], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "635\\d{4}", null, null, null, "6351234"], "MH", 692, "011", "1", null, null, "1", null, null, null, [[null, "(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ]],
    MK: [null, [null, null, "[2-578]\\d{7}", null, null, null, null, null, null, [8], [6, 7]], [null, null, "(?:2(?:[23]\\d|5[0-24578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}", null, null, null, "22012345", null, null, null, [6, 7]], [null, null, "7(?:(?:[0-25-8]\\d|3[2-4]|9[23])\\d|421)\\d{4}", null, null, null, "72345678"], [null, null, "800\\d{5}", null, null, null, "80012345"], [null, null, "5[02-9]\\d{6}", null, null, null, "50012345"], [
      null,
      null,
      "8(?:0[1-9]|[1-9]\\d)\\d{5}",
      null,
      null,
      null,
      "80123456"
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "MK", 389, "00", "0", null, null, "0", null, null, null, [[null, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [null, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], [null, "(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    ML: [null, [null, null, "(?:[246-9]\\d|50)\\d{6}", null, null, null, null, null, null, [8]], [null, null, "(?:2(?:0(?:2\\d|7[0-8])|1(?:2[67]|[4-689]\\d))|4(?:0[0-4]|4[1-39])\\d)\\d{4}", null, null, null, "20212345"], [null, null, "(?:2(?:079|17\\d)|(?:50|[679]\\d|8[239])\\d\\d)\\d{4}", null, null, null, "65012345"], [null, null, "80\\d{6}", null, null, null, "80012345"], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "ML", 223, "00", null, null, null, null, null, null, null, [[null, "(\\d{4})", "$1", ["67[057-9]|74[045]", "67(?:0[09]|[59]9|77|8[89])|74(?:0[02]|44|55)"]], [null, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-79]|8[0239]"]]], [[null, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-79]|8[0239]"]]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [
      null,
      null,
      "80\\d{6}"
    ], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    MM: [null, [null, null, "(?:1|[24-7]\\d)\\d{5,7}|8\\d{6,9}|9(?:[0-46-9]\\d{6,8}|5\\d{6})|2\\d{5}", null, null, null, null, null, null, [6, 7, 8, 9, 10], [5]], [
      null,
      null,
      "(?:1(?:(?:2\\d|3[56]|[89][0-6])\\d|4(?:2[2-469]|39|6[25]|7[01])|6)|2(?:2(?:00|8[34])|4(?:0\\d|2[246]|39|62|7[01])|51\\d\\d)|4(?:2(?:2\\d\\d|480)|3(?:20\\d|470|56)|420\\d|5470)|5(?:2(?:2\\d\\d?|470)|4(?:2(?:1|86)|470)|522\\d|7(?:20\\d|480)|[89](?:20\\d|470))|6(?:0(?:[23]|88\\d)|(?:124|42[04]|[56]2\\d)\\d|3(?:20\\d|470)|7(?:(?:3\\d|8[01459])\\d|4(?:39|[67]0)))|7(?:0470|1(?:20\\d?|470)|4(?:25\\d|470)|5(?:202|470|96\\d))|8(?:[13](?:2\\d\\d|470)|[25]2\\d\\d))\\d{4}|(?:(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4]))\\d|25\\d{2,3}|8(?:[135]2\\d\\d|2(?:2\\d\\d|320)))\\d{3}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:1[2-689]|2[2-8]|3[24]|4[24-7]|5[245]|6[23]))\\d{4}",
      null,
      null,
      null,
      "1234567",
      null,
      null,
      [6, 7, 8, 9],
      [5]
    ], [null, null, "(?:17[01]|9(?:2(?:[0-4]|(?:5\\d|6[0-5])\\d)|(?:3(?:[0-36]|4[069])|[68]9\\d|7(?:3|5[0-2]|[6-9]\\d))\\d|4(?:(?:0[0-4]|[1379]|[25]\\d|4[0-589])\\d|88)|5[0-6]|9(?:[089]|[5-7]\\d\\d))\\d)\\d{4}|9[69]1\\d{6}|9[68]\\d{6}", null, null, null, "92123456", null, null, [7, 8, 9, 10]], [null, null, "80080(?:[01][1-9]|2\\d)\\d{3}", null, null, null, "8008001234", null, null, [10]], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "(?:1(?:333|468)|2468)\\d{4}", null, null, null, "13331234", null, null, [8]], "MM", 95, "00", "0", null, null, "0", null, null, null, [[null, "(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], [null, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"], "0$1"], [null, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]"], "0$1"], [null, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], [
      null,
      "(\\d)(\\d{3})(\\d{4,6})",
      "$1 $2 $3",
      ["9(?:2[0-4]|[35-9]|4[137-9])"],
      "0$1"
    ], [null, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [null, "(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], [null, "(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], [null, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ]],
    MN: [null, [null, null, "[12]\\d{8,9}|[1257-9]\\d{7}", null, null, null, null, null, null, [8, 9, 10], [4, 5, 6]], [null, null, "(?:[12](?:1|2[1-37]|(?:3[2-8]|4[2-68]|5[1-4689])\\d?)|5[0568])\\d{6}|[12]2[1-3]\\d{5}", null, null, null, "50123456", null, null, null, [4, 5, 6]], [null, null, "(?:8(?:[05689]\\d|3[01])|9[013-9]\\d)\\d{5}", null, null, null, "88123456", null, null, [8]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "7[05-8]\\d{6}", null, null, null, "75123456", null, null, [8]], "MN", 976, "001", "0", null, null, "0", null, null, null, [[null, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], [null, "(\\d{4})(\\d{4})", "$1 $2", ["[57-9]"]], [null, "(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], [null, "(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], [
      null,
      "(\\d{5})(\\d{4,5})",
      "$1 $2",
      ["[12]"],
      "0$1"
    ]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    MO: [
      null,
      [null, null, "(?:28|[68]\\d)\\d{6}", null, null, null, null, null, null, [8]],
      [null, null, "(?:28[2-57-9]|8(?:11|[2-57-9]\\d))\\d{5}", null, null, null, "28212345"],
      [null, null, "6(?:[2356]\\d\\d|8(?:[02][5-9]|[1478]\\d|[356][0-4]))\\d{4}", null, null, null, "66123456"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "MO",
      853,
      "00",
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [[null, "(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        [-1]
      ],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    MP: [
      null,
      [null, null, "(?:[58]\\d\\d|(?:67|90)0)\\d{7}", null, null, null, null, null, null, [10], [7]],
      [null, null, "670(?:2(?:3[3-7]|56|8[5-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}", null, null, null, "6702345678", null, null, null, [7]],
      [
        null,
        null,
        "670(?:2(?:3[3-7]|56|8[5-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}",
        null,
        null,
        null,
        "6702345678",
        null,
        null,
        null,
        [7]
      ],
      [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002123456"],
      [null, null, "900[2-9]\\d{6}", null, null, null, "9002123456"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "MP",
      1,
      "011",
      "1",
      null,
      null,
      "1",
      null,
      null,
      1,
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      "670",
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    MQ: [null, [null, null, "(?:596|69\\d)\\d{6}", null, null, null, null, null, null, [9]], [null, null, "596(?:0[0-7]|10|2[7-9]|3[05-9]|4[0-46-8]|[5-7]\\d|8[09]|9[4-8])\\d{4}", null, null, null, "596301234"], [null, null, "69(?:6(?:[0-47-9]\\d|5[0-6]|6[0-4])|727)\\d{4}", null, null, null, "696201234"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "MQ", 596, "00", "0", null, null, "0", null, null, null, [[null, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[56]"], "0$1"]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    MR: [
      null,
      [null, null, "(?:[2-4]\\d\\d|800)\\d{5}", null, null, null, null, null, null, [8]],
      [null, null, "(?:25[08]|35\\d|45[1-7])\\d{5}", null, null, null, "35123456"],
      [null, null, "[2-4][0-46-9]\\d{6}", null, null, null, "22123456"],
      [null, null, "800\\d{5}", null, null, null, "80012345"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "MR",
      222,
      "00",
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [[null, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    MS: [
      null,
      [null, null, "(?:(?:[58]\\d\\d|900)\\d\\d|66449)\\d{5}", null, null, null, null, null, null, [10], [7]],
      [null, null, "664491\\d{4}", null, null, null, "6644912345", null, null, null, [7]],
      [
        null,
        null,
        "66449[2-6]\\d{4}",
        null,
        null,
        null,
        "6644923456",
        null,
        null,
        null,
        [7]
      ],
      [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002123456"],
      [null, null, "900[2-9]\\d{6}", null, null, null, "9002123456"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "MS",
      1,
      "011",
      "1",
      null,
      null,
      "1",
      null,
      null,
      null,
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      "664",
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    MT: [
      null,
      [null, null, "(?:(?:[2579]\\d\\d|800)\\d|3550)\\d{4}", null, null, null, null, null, null, [8]],
      [null, null, "2(?:0(?:[169]\\d|3[1-4])|[1-357]\\d\\d)\\d{4}", null, null, null, "21001234"],
      [null, null, "(?:7(?:210|[79]\\d\\d)|9(?:2(?:1[01]|31)|69[67]|8(?:1[1-3]|89|97)|9\\d\\d))\\d{4}", null, null, null, "96961234"],
      [
        null,
        null,
        "800[3467]\\d{4}",
        null,
        null,
        null,
        "80071234"
      ],
      [null, null, "5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}", null, null, null, "50037123"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "3550\\d{4}", null, null, null, "35501234"],
      "MT",
      356,
      "00",
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [[null, "(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]],
      null,
      [null, null, "7117\\d{4}", null, null, null, "71171234"],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "501\\d{5}", null, null, null, "50112345"],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    MU: [null, [null, null, "(?:[2-468]|5\\d)\\d{6}", null, null, null, null, null, null, [7, 8]], [null, null, "(?:2(?:[03478]\\d|1[0-7]|6[0-79])|4(?:[013568]\\d|2[4-7])|54(?:4\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}", null, null, null, "54480123"], [null, null, "5(?:(?:2[589]|7\\d|9[0-8])\\d|4(?:2[1-389]|[489]\\d|7[1-9])|8(?:[0-689]\\d|7[15-8]))\\d{4}", null, null, null, "52512345", null, null, [8]], [
      null,
      null,
      "80[0-2]\\d{4}",
      null,
      null,
      null,
      "8001234",
      null,
      null,
      [7]
    ], [null, null, "30\\d{5}", null, null, null, "3012345", null, null, [7]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "3(?:20|9\\d)\\d{4}", null, null, null, "3201234", null, null, [7]], "MU", 230, "0(?:0|[24-7]0|3[03])", null, null, null, null, null, "020", null, [[null, "(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8(?:0[0-2]|14|3[129])"]], [null, "(\\d{4})(\\d{4})", "$1 $2", ["5"]]], null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    MV: [
      null,
      [null, null, "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", null, null, null, null, null, null, [7, 10]],
      [null, null, "(?:3(?:0[0-3]|3[0-59])|6(?:[57][02468]|6[024-68]|8[024689]))\\d{4}", null, null, null, "6701234", null, null, [7]],
      [null, null, "(?:46[46]|(?:7[2-9]|9[14-9])\\d)\\d{4}", null, null, null, "7712345", null, null, [7]],
      [null, null, "800\\d{7}", null, null, null, "8001234567", null, null, [10]],
      [null, null, "900\\d{7}", null, null, null, "9001234567", null, null, [10]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "MV",
      960,
      "0(?:0|19)",
      null,
      null,
      null,
      null,
      null,
      "00",
      null,
      [[null, "(\\d{3})(\\d{4})", "$1-$2", ["[367]|4(?:00|[56])|9[14-9]"]], [null, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]],
      null,
      [
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        [-1]
      ],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "4[05]0\\d{4}", null, null, null, "4001234", null, null, [7]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    MW: [null, [null, null, "1\\d{6}(?:\\d{2})?|(?:[23]1|77|88|99)\\d{7}", null, null, null, null, null, null, [7, 9]], [null, null, "(?:1[2-9]|21\\d\\d)\\d{5}", null, null, null, "1234567"], [null, null, "(?:111|(?:77|88|99)\\d)\\d{6}", null, null, null, "991234567", null, null, [9]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "31\\d{7}", null, null, null, "310123456", null, null, [9]], "MW", 265, "00", "0", null, null, "0", null, null, null, [[null, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], [null, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], [null, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[17-9]"], "0$1"], [
      null,
      "(\\d{2})(\\d{3})(\\d{4})",
      "$1 $2 $3",
      ["3"],
      "0$1"
    ]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    MX: [null, [null, null, "(?:1\\d|[2-9])\\d{9}", null, null, null, null, null, null, [10, 11], [7, 8]], [
      null,
      null,
      "(?:2(?:0[01]|2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-7][1-9]|3[1-8]|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))\\d{7}",
      null,
      null,
      null,
      "2221234567",
      null,
      null,
      [10],
      [7, 8]
    ], [
      null,
      null,
      "1(?:2(?:2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-7][1-9]|3[1-8]|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))\\d{7}",
      null,
      null,
      null,
      "12221234567",
      null,
      null,
      [11]
    ], [null, null, "8(?:00|88)\\d{7}", null, null, null, "8001234567", null, null, [10]], [null, null, "900\\d{7}", null, null, null, "9001234567", null, null, [10]], [null, null, "300\\d{7}", null, null, null, "3001234567", null, null, [10]], [null, null, "500\\d{7}", null, null, null, "5001234567", null, null, [10]], [null, null, null, null, null, null, null, null, null, [-1]], "MX", 52, "0[09]", "01", null, null, "0[12]|04[45]([2-9]\\d{9})$", "1$1", "00", null, [[null, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"], "01 $1", null, 1], [
      null,
      "(\\d{3})(\\d{3})(\\d{4})",
      "$1 $2 $3",
      ["[2-9]"],
      "01 $1",
      null,
      1
    ], [null, "(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 $3 $4", ["1(?:33|5[56]|81)"], "044 $1"], [null, "(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 $3 $4", ["1"], "044 $1"]], [[null, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"], "01 $1", null, 1], [null, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"], "01 $1", null, 1], [null, "(\\d)(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3 $4", ["1(?:33|5[56]|81)"]], [null, "(\\d)(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    MY: [null, [null, null, "(?:1\\d\\d?|3\\d|[4-9])\\d{7}", null, null, null, null, null, null, [8, 9, 10], [6, 7]], [
      null,
      null,
      "(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}",
      null,
      null,
      null,
      "323856789",
      null,
      null,
      [8, 9],
      [6, 7]
    ], [null, null, "1(?:(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d))|(?:[23679][2-9]|59\\d)\\d)\\d|4(?:[235-9]\\d\\d|400)|8(?:(?:1[23]|[236]\\d|5[7-9]|7[016-9]|9[0-8])\\d|4(?:[06]\\d|7[0-4])|8(?:[01]\\d|[27][0-4])))\\d{4}", null, null, null, "123456789", null, null, [9, 10]], [null, null, "1[378]00\\d{6}", null, null, null, "1300123456", null, null, [10]], [null, null, "1600\\d{6}", null, null, null, "1600123456", null, null, [10]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "154(?:6(?:0\\d|1[0-3])|8(?:[25]1|4[0189]|7[0-4679]))\\d{4}", null, null, null, "1546012345", null, null, [10]], "MY", 60, "00", "0", null, null, "0", null, null, null, [[null, "(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], [null, "(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[0249]|[367][2-9]|8[1-9])|8"], "0$1"], [null, "(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], [
      null,
      "(\\d{3})(\\d{3})(\\d{4})",
      "$1-$2 $3",
      ["15"],
      "0$1"
    ], [null, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["11"], "0$1"], [null, "(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    MZ: [null, [null, null, "(?:2|8\\d)\\d{7}", null, null, null, null, null, null, [8, 9]], [
      null,
      null,
      "2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}",
      null,
      null,
      null,
      "21123456",
      null,
      null,
      [8]
    ], [null, null, "8[2-7]\\d{7}", null, null, null, "821234567", null, null, [9]], [null, null, "800\\d{6}", null, null, null, "800123456", null, null, [9]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "MZ", 258, "00", null, null, null, null, null, null, null, [[null, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-7]"]], [
      null,
      "(\\d{3})(\\d{3})(\\d{3})",
      "$1 $2 $3",
      ["8"]
    ]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    NA: [null, [null, null, "[68]\\d{7,8}", null, null, null, null, null, null, [8, 9]], [
      null,
      null,
      "6(?:1(?:[02-4]\\d\\d|17)|2(?:17|54\\d|69|70)|3(?:17|2[0237]\\d|34|6[289]|7[01]|81)|4(?:17|(?:27|41|5[25])\\d|69|7[01])|5(?:17|2[236-8]\\d|69|7[01])|6(?:17|26\\d|38|42|69|7[01])|7(?:17|(?:2[2-4]|30)\\d|6[89]|7[01]))\\d{4}|6(?:1(?:2[2-7]|3[01378]|4[0-4]|69|7[014])|25[0-46-8]|32\\d|4(?:2[0-27]|4[016]|5[0-357])|52[02-9]|62[56]|7(?:2[2-69]|3[013]))\\d{4}",
      null,
      null,
      null,
      "61221234"
    ], [null, null, "(?:60|8[1245])\\d{7}", null, null, null, "811234567", null, null, [9]], [null, null, "80\\d{7}", null, null, null, "800123456", null, null, [9]], [null, null, "8701\\d{5}", null, null, null, "870123456", null, null, [9]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "8(?:3\\d\\d|86)\\d{5}", null, null, null, "88612345"], "NA", 264, "00", "0", null, null, "0", null, null, null, [
      [null, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"],
      [null, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"],
      [null, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8[0-5]"], "0$1"],
      [null, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]
    ], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    NC: [null, [null, null, "[2-57-9]\\d{5}", null, null, null, null, null, null, [6]], [
      null,
      null,
      "(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}",
      null,
      null,
      null,
      "201234"
    ], [null, null, "(?:5[0-4]|[79]\\d|8[0-79])\\d{4}", null, null, null, "751234"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "36\\d{4}", null, null, null, "366711"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "NC", 687, "00", null, null, null, null, null, null, null, [[null, "(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[247-9]|3[0-6]|5[0-4]"]]], null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    NE: [null, [null, null, "[0289]\\d{7}", null, null, null, null, null, null, [8]], [null, null, "2(?:0(?:20|3[1-7]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}", null, null, null, "20201234"], [null, null, "(?:8[04589]|9\\d)\\d{6}", null, null, null, "93123456"], [
      null,
      null,
      "08\\d{6}",
      null,
      null,
      null,
      "08123456"
    ], [null, null, "09\\d{6}", null, null, null, "09123456"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "NE", 227, "00", null, null, null, null, null, null, null, [[null, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["09|2[01]|8[04589]|9"]], [null, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    NF: [null, [null, null, "[13]\\d{5}", null, null, null, null, null, null, [6], [5]], [null, null, "(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}", null, null, null, "106609", null, null, null, [5]], [null, null, "3[58]\\d{4}", null, null, null, "381234", null, null, null, [5]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "NF", 672, "00", null, null, null, null, null, null, null, [[null, "(\\d{2})(\\d{4})", "$1 $2", ["1"]], [null, "(\\d)(\\d{5})", "$1 $2", ["3"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    NG: [
      null,
      [null, null, "[78]\\d{10,13}|[7-9]\\d{9}|[1-9]\\d{7}|[124-7]\\d{6}", null, null, null, null, null, null, [7, 8, 10, 11, 12, 13, 14], [5, 6]],
      [null, null, "(?:(?:[1-356]\\d|4[02-8]|7[0-79]|8[2-9])\\d|9(?:0[3-9]|[1-9]\\d))\\d{5}|(?:[12]\\d|4[147]|5[14579]|6[1578]|7[0-3578])\\d{5}", null, null, null, "18040123", null, null, [7, 8], [5, 6]],
      [
        null,
        null,
        "(?:1(?:(?:7[34]|95)\\d|8(?:04|[124579]\\d|8[0-3]))|287[0-7]|3(?:18[1-8]|88[0-7]|9(?:6[1-5]|8[5-9]))|4(?:[28]8[0-2]|6(?:7[1-9]|8[02-47]))|5(?:2(?:7[7-9]|8\\d)|38[1-79]|48[0-7]|68[4-7])|6(?:2(?:7[7-9]|8\\d)|4(?:3[7-9]|[68][129]|7[04-69]|9[1-8])|58[0-2]|98[7-9])|7(?:0(?:[1-689]\\d|7[0-3])\\d\\d|38[0-7]|69[1-8]|78[2-4])|8(?:(?:0(?:1[01]|[2-9]\\d)|1(?:[0-8]\\d|9[01]))\\d\\d|28[3-9]|38[0-2]|4(?:2[12]|3[147-9]|5[346]|7[4-9]|8[014-689]|90)|58[1-8]|78[2-9]|88[5-7])|9(?:0[235-9]\\d\\d|8[07])\\d)\\d{4}",
        null,
        null,
        null,
        "8021234567",
        null,
        null,
        [8, 10],
        [6, 7]
      ],
      [null, null, "800\\d{7,11}", null, null, null, "80017591759", null, null, [10, 11, 12, 13, 14]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "NG",
      234,
      "009",
      "0",
      null,
      null,
      "0",
      null,
      null,
      null,
      [[null, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["78"], "0$1"], [
        null,
        "(\\d)(\\d{3})(\\d{3,4})",
        "$1 $2 $3",
        ["[12]|9(?:0[3-9]|[1-9])"],
        "0$1"
      ], [null, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[3-7]|8[2-9]"], "0$1"], [null, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], [null, "(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], [null, "(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "700\\d{7,11}", null, null, null, "7001234567", null, null, [10, 11, 12, 13, 14]],
      null,
      null,
      [
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        [-1]
      ]
    ],
    NI: [
      null,
      [null, null, "(?:1800|[25-8]\\d{3})\\d{4}", null, null, null, null, null, null, [8]],
      [null, null, "2\\d{7}", null, null, null, "21234567"],
      [null, null, "(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}", null, null, null, "81234567"],
      [null, null, "1800\\d{4}", null, null, null, "18001234"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "NI",
      505,
      "00",
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [[null, "(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    NL: [null, [
      null,
      null,
      "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8])|[89]\\d{0,3})\\d{6}|1\\d{4,5}",
      null,
      null,
      null,
      null,
      null,
      null,
      [5, 6, 7, 8, 9, 10]
    ], [null, null, "(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}", null, null, null, "101234567", null, null, [9]], [null, null, "6[1-58]\\d{7}", null, null, null, "612345678", null, null, [9]], [null, null, "800\\d{4,7}", null, null, null, "8001234", null, null, [7, 8, 9, 10]], [
      null,
      null,
      "90[069]\\d{4,7}",
      null,
      null,
      null,
      "9061234",
      null,
      null,
      [7, 8, 9, 10]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "(?:85|91)\\d{7}", null, null, null, "851234567", null, null, [9]], "NL", 31, "00", "0", null, null, "0", null, null, null, [[null, "(\\d{2})(\\d{3,4})", "$1 $2", ["14"]], [null, "(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], [null, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1[035]|2[0346]|3[03568]|4[0356]|5[0358]|[7-9]"], "0$1"], [
      null,
      "(\\d{3})(\\d{3})(\\d{3})",
      "$1 $2 $3",
      ["[1-5]"],
      "0$1"
    ], [null, "(\\d)(\\d{8})", "$1 $2", ["6[1-58]"], "0$1"], [null, "(\\d{2})(\\d{7})", "$1 $2", ["6"], "0$1"]], [[null, "(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], [null, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1[035]|2[0346]|3[03568]|4[0356]|5[0358]|[7-9]"], "0$1"], [null, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-5]"], "0$1"], [null, "(\\d)(\\d{8})", "$1 $2", ["6[1-58]"], "0$1"], [null, "(\\d{2})(\\d{7})", "$1 $2", ["6"], "0$1"]], [null, null, "66\\d{7}", null, null, null, "662345678", null, null, [9]], null, null, [
      null,
      null,
      "140(?:1(?:[035]|[16-8]\\d)|2(?:[0346]|[259]\\d)|3(?:[03568]|[124]\\d)|4(?:[0356]|[17-9]\\d)|5(?:[0358]|[124679]\\d)|7\\d|8[458])",
      null,
      null,
      null,
      null,
      null,
      null,
      [5, 6]
    ], [null, null, "140(?:1(?:[035]|[16-8]\\d)|2(?:[0346]|[259]\\d)|3(?:[03568]|[124]\\d)|4(?:[0356]|[17-9]\\d)|5(?:[0358]|[124679]\\d)|7\\d|8[458])|8[478]\\d{7}", null, null, null, "14020", null, null, [5, 6, 9]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    NO: [null, [null, null, "(?:0|[2-9]\\d{3})\\d{4}", null, null, null, null, null, null, [5, 8]], [null, null, "(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}", null, null, null, "21234567", null, null, [8]], [
      null,
      null,
      "(?:4[015-8]|5[89]|9\\d)\\d{6}",
      null,
      null,
      null,
      "40612345",
      null,
      null,
      [8]
    ], [null, null, "80[01]\\d{5}", null, null, null, "80012345", null, null, [8]], [null, null, "82[09]\\d{5}", null, null, null, "82012345", null, null, [8]], [null, null, "810(?:0[0-6]|[2-8]\\d)\\d{3}", null, null, null, "81021234", null, null, [8]], [null, null, "880\\d{5}", null, null, null, "88012345", null, null, [8]], [null, null, "85[0-5]\\d{5}", null, null, null, "85012345", null, null, [8]], "NO", 47, "00", null, null, null, null, null, null, null, [
      [null, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-7]"]],
      [null, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[489]"]]
    ], null, [null, null, null, null, null, null, null, null, null, [-1]], 1, "[02-689]|7[0-8]", [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "(?:0\\d|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}", null, null, null, "01234"], null, null, [null, null, "81[23]\\d{5}", null, null, null, "81212345", null, null, [8]]],
    NP: [null, [null, null, "9\\d{9}|[1-9]\\d{7}", null, null, null, null, null, null, [8, 10], [6, 7]], [
      null,
      null,
      "(?:1[0-6]\\d|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-79])[2-6])\\d{5}",
      null,
      null,
      null,
      "14567890",
      null,
      null,
      [8],
      [6, 7]
    ], [null, null, "9(?:6[0-3]|7[245]|8[0-24-68])\\d{7}", null, null, null, "9841234567", null, null, [10]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "NP", 977, "00", "0", null, null, "0", null, null, null, [[null, "(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], [
      null,
      "(\\d{2})(\\d{6})",
      "$1-$2",
      ["[1-8]|9(?:[1-579]|6[2-6])"],
      "0$1"
    ], [null, "(\\d{3})(\\d{7})", "$1-$2", ["9"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    NR: [null, [null, null, "(?:444|55\\d|888)\\d{4}", null, null, null, null, null, null, [7]], [null, null, "(?:444|888)\\d{4}", null, null, null, "4441234"], [
      null,
      null,
      "55[4-9]\\d{4}",
      null,
      null,
      null,
      "5551234"
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "NR", 674, "00", null, null, null, null, null, null, null, [[null, "(\\d{3})(\\d{4})", "$1 $2", ["[458]"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    NU: [null, [null, null, "(?:[47]|888\\d)\\d{3}", null, null, null, null, null, null, [4, 7]], [null, null, "[47]\\d{3}", null, null, null, "7012", null, null, [4]], [null, null, "888[4-9]\\d{3}", null, null, null, "8884012", null, null, [7]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], "NU", 683, "00", null, null, null, null, null, null, null, [[null, "(\\d{3})(\\d{4})", "$1 $2", ["8"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    NZ: [null, [
      null,
      null,
      "[28]\\d{7,9}|[346]\\d{7}|(?:508|[79]\\d)\\d{6,7}",
      null,
      null,
      null,
      null,
      null,
      null,
      [8, 9, 10],
      [7]
    ], [null, null, "(?:24099|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{3})\\d{3}", null, null, null, "32345678", null, null, [8], [7]], [null, null, "2(?:[0-28]\\d?|[79])\\d{7}|21\\d{6}", null, null, null, "211234567"], [null, null, "508\\d{6,7}|80\\d{6,8}", null, null, null, "800123456"], [null, null, "90\\d{6,7}", null, null, null, "900123456", null, null, [8, 9]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "70\\d{7}", null, null, null, "701234567", null, null, [9]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], "NZ", 64, "0(?:0|161)", "0", null, null, "0", null, "00", null, [[null, "(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], [null, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80|9"], "0$1"], [null, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[59]|80"], "0$1"], [null, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["2[028]"], "0$1"], [null, "(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["[278]"], "0$1"]], null, [null, null, "[28]6\\d{6,7}", null, null, null, "26123456", null, null, [8, 9]], null, null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    OM: [null, [null, null, "(?:[279]\\d{3}|500|8007\\d?)\\d{4}", null, null, null, null, null, null, [7, 8, 9]], [null, null, "2[2-6]\\d{6}", null, null, null, "23123456", null, null, [8]], [null, null, "(?:7[129]\\d|9(?:0[1-9]|[1-9]\\d))\\d{5}", null, null, null, "92123456", null, null, [8]], [null, null, "(?:500|8007\\d?)\\d{4}", null, null, null, "80071234"], [
      null,
      null,
      "900\\d{5}",
      null,
      null,
      null,
      "90012345",
      null,
      null,
      [8]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "OM", 968, "00", null, null, null, null, null, null, null, [[null, "(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], [null, "(\\d{2})(\\d{6})", "$1 $2", ["2"]], [null, "(\\d{4})(\\d{4})", "$1 $2", ["[79]"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    PA: [
      null,
      [null, null, "(?:[1-57-9]|6\\d)\\d{6}", null, null, null, null, null, null, [7, 8]],
      [
        null,
        null,
        "(?:1(?:0\\d|1[479]|2[37]|3[0137]|4[17]|5[05]|[68][58]|7[0167]|9[39])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[026-9])|3(?:[089]\\d|1[014-7]|2[0-35]|33|4[0-579]|55|6[068]|7[06-8])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[05]|7[0-24-9]|8[7-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}",
        null,
        null,
        null,
        "2001234",
        null,
        null,
        [7]
      ],
      [null, null, "(?:1[16]1|21[89]|6(?:[02-9]\\d|1[0-5])\\d|8(?:1[01]|7[23]))\\d{4}", null, null, null, "61234567"],
      [null, null, "800\\d{4}", null, null, null, "8001234", null, null, [7]],
      [null, null, "(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}", null, null, null, "8601234", null, null, [7]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "PA",
      507,
      "00",
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [[null, "(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], [null, "(\\d{4})(\\d{4})", "$1-$2", ["6"]]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    PE: [null, [null, null, "(?:[14-8]|9\\d)\\d{7}", null, null, null, null, null, null, [8, 9], [6, 7]], [
      null,
      null,
      "(?:1\\d|4[1-4]|5[1-46]|6[1-7]|7[2-46]|8[2-4])\\d{6}",
      null,
      null,
      null,
      "11234567",
      null,
      null,
      [8],
      [6, 7]
    ], [null, null, "9\\d{8}", null, null, null, "912345678", null, null, [9]], [null, null, "800\\d{5}", null, null, null, "80012345", null, null, [8]], [null, null, "805\\d{5}", null, null, null, "80512345", null, null, [8]], [null, null, "801\\d{5}", null, null, null, "80112345", null, null, [8]], [null, null, "80[24]\\d{5}", null, null, null, "80212345", null, null, [8]], [null, null, null, null, null, null, null, null, null, [-1]], "PE", 51, "19(?:1[124]|77|90)00", "0", " Anexo ", null, "0", null, null, null, [[
      null,
      "(\\d)(\\d{7})",
      "$1 $2",
      ["1"],
      "(0$1)"
    ], [null, "(\\d{2})(\\d{6})", "$1 $2", ["[4-7]|8[2-4]"], "(0$1)"], [null, "(\\d{3})(\\d{5})", "$1 $2", ["8"], "(0$1)"], [null, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    PF: [null, [null, null, "[48]\\d{7}|4\\d{5}", null, null, null, null, null, null, [6, 8]], [
      null,
      null,
      "4(?:[09][4-689]\\d|4)\\d{4}",
      null,
      null,
      null,
      "40412345"
    ], [null, null, "8[79]\\d{6}", null, null, null, "87123456", null, null, [8]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "PF", 689, "00", null, null, null, null, null, null, null, [[null, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], [
      null,
      "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
      "$1 $2 $3 $4",
      ["[48]"]
    ]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, "44\\d{4}", null, null, null, null, null, null, [6]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    PG: [null, [null, null, "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", null, null, null, null, null, null, [7, 8]], [null, null, "(?:(?:3[0-2]|4[257]|5[34]|9[78])\\d|64[1-9]|77(?:[0-24]\\d|30)|85[02-46-9])\\d{4}", null, null, null, "3123456"], [
      null,
      null,
      "(?:7(?:[0-689]\\d|75)|81\\d)\\d{5}",
      null,
      null,
      null,
      "70123456",
      null,
      null,
      [8]
    ], [null, null, "180\\d{4}", null, null, null, "1801234", null, null, [7]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "2(?:0[0-47]|7[568])\\d{4}", null, null, null, "2751234", null, null, [7]], "PG", 675, "00|140[1-3]", null, null, null, null, null, "00", null, [[null, "(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], [null, "(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    PH: [
      null,
      [null, null, "(?:1800\\d{2,4}|2|[89]\\d{4})\\d{5}|[3-8]\\d{8}|[28]\\d{7}", null, null, null, null, null, null, [6, 8, 9, 10, 11, 12, 13], [4, 5, 7]],
      [
        null,
        null,
        "(?:2\\d(?:\\d{2})?|(?:3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|8[2-8]\\d{7}",
        null,
        null,
        null,
        "21234567",
        null,
        null,
        [6, 8, 9, 10],
        [4, 5, 7]
      ],
      [null, null, "(?:81[37]|9(?:0[5-9]|1[024-9]|2[0-35-9]|3[02-9]|4[235-9]|5[056]|6[5-7]|7[3-79]|89|9[4-9]))\\d{7}", null, null, null, "9051234567", null, null, [10]],
      [null, null, "1800\\d{7,9}", null, null, null, "180012345678", null, null, [11, 12, 13]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "PH",
      63,
      "00",
      "0",
      null,
      null,
      "0",
      null,
      null,
      null,
      [[null, "(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], [null, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], [null, "(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|5(?:22|44)|642|8(?:62|8[245])", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], [
        null,
        "(\\d{2})(\\d{3})(\\d{4})",
        "$1 $2 $3",
        ["3[2-68]|4[2-9]|[5-7]|8[2-8]", "3(?:[23568]|4(?:[0-57-9]|6[02-8]))|4(?:2(?:[0-689]|7[0-8])|[3-8]|9(?:[0-246-9]|3[1-9]|5[0-57-9]))|[5-7]|8(?:[2-7]|8(?:[0-24-9]|3[0-35-9]))"],
        "(0$1)"
      ], [null, "(\\d{5})(\\d{4})", "$1 $2", ["[34]|88"], "(0$1)"], [null, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], [null, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], [null, "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    PK: [null, [
      null,
      null,
      "(?:122|[24-8]\\d{4,5}|9(?:[013-9]\\d{2,4}|2(?:[01]\\d\\d|2(?:[025-8]\\d|1[01]))\\d))\\d{6}|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
      null,
      null,
      null,
      null,
      null,
      null,
      [8, 9, 10, 11, 12],
      [5, 6, 7]
    ], [
      null,
      null,
      "2(?:(?:1[2-9]\\d|[25][2-9])\\d{6}|(?:3[2358]|4[2-4]|9[2-8])[2-9]\\d{5,6})|4(?:(?:[0146-9][2-9]|2[2-9]\\d)\\d{6}|5[3479][2-9]\\d{5,6})|5(?:(?:[1-35-7][2-9]|8[126]\\d)\\d{6}|4[2-467][2-9]\\d{5,6})|6(?:0[468][2-9]\\d{5,6}|[1-8][2-9]\\d{6})|7(?:[14][2-9]\\d{6}|2[236][2-9]\\d{5,6})|8(?:[16][2-9]\\d{6}|(?:2[2-689]|3[23578]|4[3478]|5[2356])[2-9]\\d{5,6})|9(?:1[2-9]\\d{6}|(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])[2-9]\\d{5,6})",
      null,
      null,
      null,
      "2123456789",
      null,
      null,
      [9, 10],
      [5, 6, 7, 8]
    ], [null, null, "3(?:[014]\\d|2[0-5]|3[0-7]|55|64)\\d{7}", null, null, null, "3012345678", null, null, [10]], [null, null, "800\\d{5}", null, null, null, "80012345", null, null, [8]], [null, null, "900\\d{5}", null, null, null, "90012345", null, null, [8]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "122\\d{6}", null, null, null, "122044444", null, null, [9]], [null, null, null, null, null, null, null, null, null, [-1]], "PK", 92, "00", "0", null, null, "0", null, null, null, [[
      null,
      "(\\d{3})(\\d{3})(\\d{2})",
      "$1 $2 $3",
      ["[89]0"],
      "0$1"
    ], [null, "(\\d{4})(\\d{5})", "$1 $2", ["1"]], [null, "(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], [
      null,
      "(\\d{3})(\\d{6,7})",
      "$1 $2",
      ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356]))[2-9]|9(?:2(?:2[2-9]|[3-8])|(?:3[27-9]|4[2-6]|6[3569])[2-9]|9(?:[25-7][2-9]|8))"],
      "(0$1)"
    ], [null, "(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], [null, "(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], [null, "(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], [null, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      "(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}",
      null,
      null,
      null,
      "21111825888",
      null,
      null,
      [11, 12]
    ], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    PL: [null, [null, null, "[1-9]\\d{6}(?:\\d{2})?|6\\d{5}(?:\\d{2})?", null, null, null, null, null, null, [6, 7, 8, 9]], [null, null, "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19\\d{3}", null, null, null, "123456789", null, null, [7, 9]], [
      null,
      null,
      "(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}",
      null,
      null,
      null,
      "512345678",
      null,
      null,
      [9]
    ], [null, null, "800\\d{6}", null, null, null, "800123456", null, null, [9]], [null, null, "70[01346-8]\\d{6}", null, null, null, "701234567", null, null, [9]], [null, null, "801\\d{6}", null, null, null, "801234567", null, null, [9]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "39\\d{7}", null, null, null, "391234567", null, null, [9]], "PL", 48, "00", null, null, null, null, null, null, null, [[null, "(\\d{5})", "$1", ["19"]], [null, "(\\d{3})(\\d{3})", "$1 $2", ["11|64"]], [
      null,
      "(\\d{2})(\\d{2})(\\d{3})",
      "$1 $2 $3",
      ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]
    ], [null, "(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], [null, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|2|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145]"]], [null, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[3-8]"]]], null, [null, null, "64\\d{4,7}", null, null, null, "641234567"], null, null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, "804\\d{6}", null, null, null, "804123456", null, null, [9]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    PM: [
      null,
      [null, null, "[45]\\d{5}", null, null, null, null, null, null, [6]],
      [null, null, "(?:4[1-3]|50)\\d{4}", null, null, null, "430123"],
      [null, null, "(?:4[02-4]|5[05])\\d{4}", null, null, null, "551234"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "PM",
      508,
      "00",
      "0",
      null,
      null,
      "0",
      null,
      null,
      null,
      [[null, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    PR: [null, [
      null,
      null,
      "(?:[589]\\d\\d|787)\\d{7}",
      null,
      null,
      null,
      null,
      null,
      null,
      [10],
      [7]
    ], [null, null, "(?:787|939)[2-9]\\d{6}", null, null, null, "7872345678", null, null, null, [7]], [null, null, "(?:787|939)[2-9]\\d{6}", null, null, null, "7872345678", null, null, null, [7]], [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002345678"], [null, null, "900[2-9]\\d{6}", null, null, null, "9002345678"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], "PR", 1, "011", "1", null, null, "1", null, null, 1, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, "787|939", [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    PS: [null, [null, null, "(?:(?:1\\d|5)\\d\\d|[2489]2)\\d{6}", null, null, null, null, null, null, [8, 9, 10], [7]], [
      null,
      null,
      "(?:22[2-47-9]|42[45]|82[01458]|92[369])\\d{5}",
      null,
      null,
      null,
      "22234567",
      null,
      null,
      [8],
      [7]
    ], [null, null, "5[69]\\d{7}", null, null, null, "599123456", null, null, [9]], [null, null, "1800\\d{6}", null, null, null, "1800123456", null, null, [10]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "1700\\d{6}", null, null, null, "1700123456", null, null, [10]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "PS", 970, "00", "0", null, null, "0", null, null, null, [[null, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], [
      null,
      "(\\d{3})(\\d{3})(\\d{3})",
      "$1 $2 $3",
      ["5"],
      "0$1"
    ], [null, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    PT: [
      null,
      [null, null, "(?:[26-9]\\d|30)\\d{7}", null, null, null, null, null, null, [9]],
      [null, null, "2(?:[12]\\d|[35][1-689]|4[1-59]|6[1-35689]|7[1-9]|8[1-69]|9[1256])\\d{6}", null, null, null, "212345678"],
      [null, null, "9(?:[1-36]\\d\\d|480)\\d{5}", null, null, null, "912345678"],
      [null, null, "80[02]\\d{6}", null, null, null, "800123456"],
      [null, null, "(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}", null, null, null, "760123456"],
      [null, null, "80(?:8\\d|9[1579])\\d{5}", null, null, null, "808123456"],
      [null, null, "884[0-4689]\\d{5}", null, null, null, "884123456"],
      [null, null, "30\\d{7}", null, null, null, "301234567"],
      "PT",
      351,
      "00",
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [
        [null, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]],
        [null, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"]]
      ],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "70(?:7\\d|8[17])\\d{5}", null, null, null, "707123456"],
      null,
      null,
      [null, null, "600\\d{6}", null, null, null, "600110000"]
    ],
    PW: [
      null,
      [null, null, "(?:[25-8]\\d\\d|345|488|900)\\d{4}", null, null, null, null, null, null, [7]],
      [
        null,
        null,
        "(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}",
        null,
        null,
        null,
        "2771234"
      ],
      [null, null, "(?:6[2-4689]0|77\\d|88[0-4])\\d{4}", null, null, null, "6201234"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "PW",
      680,
      "01[12]",
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [[null, "(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    PY: [null, [null, null, "(?:[2-46-9]\\d|5[0-8])\\d{7}|[2-9]\\d{5,7}", null, null, null, null, null, null, [6, 7, 8, 9], [5]], [
      null,
      null,
      "(?:2(?:1\\d|2[4-68]|7[15]|9[1-5])|5(?:[1-4]\\d|5[02-4])|6(?:1\\d|3[1-3]|44|7[1-46-8]))\\d{5,6}|3(?:(?:18|3[167]|4[2357]|51)\\d{5,6}|[289]\\d{5,7})|4(?:[1246-8]\\d{5,7}|(?:3[12]|5[13]|9[1-47])\\d{5,6})|7(?:[1-3]\\d{5,7}|(?:4[0-4]|6[1-578]|75|8[0-8])\\d{5,6})|8(?:[1-36]\\d{5,7}|58\\d{5,6})|[26]1\\d{5}",
      null,
      null,
      null,
      "212345678",
      null,
      null,
      [7, 8, 9],
      [5, 6]
    ], [null, null, "9(?:51|6[129]|[78][1-6]|9[1-5])\\d{6}", null, null, null, "961456789", null, null, [9]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "8700[0-4]\\d{4}", null, null, null, "870012345", null, null, [9]], "PY", 595, "00", "0", null, null, "0", null, null, null, [[
      null,
      "(\\d{3})(\\d{3,6})",
      "$1 $2",
      ["[2-9]0"],
      "0$1"
    ], [null, "(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], [null, "(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6[347]|7[46-8]|85"], "(0$1)"], [null, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], [null, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-7]|85"], "0$1"], [null, "(\\d{3})(\\d{6})", "$1 $2", ["9"], "0$1"], [null, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "[2-9]0\\d{4,7}", null, null, null, "201234567"], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    QA: [null, [null, null, "(?:(?:2|[3-7]\\d)\\d\\d|800)\\d{4}", null, null, null, null, null, null, [7, 8]], [null, null, "4[04]\\d{6}", null, null, null, "44123456", null, null, [8]], [null, null, "[35-7]\\d{7}", null, null, null, "33123456", null, null, [8]], [null, null, "800\\d{4}", null, null, null, "8001234", null, null, [7]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "QA", 974, "00", null, null, null, null, null, null, null, [[null, "(\\d{3})(\\d{4})", "$1 $2", ["2[126]|8"]], [null, "(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]], null, [null, null, "2(?:[12]\\d|61)\\d{4}", null, null, null, "2123456", null, null, [7]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    RE: [null, [null, null, "(?:26|[68]\\d)\\d{7}", null, null, null, null, null, null, [9]], [null, null, "262\\d{6}", null, null, null, "262161234"], [null, null, "69(?:2\\d\\d|3(?:0[0-46]|1[013]|2[0-2]|3[0-39]|4\\d|5[05]|6[0-26]|7[0-27]|8[0-38]|9[0-479]))\\d{4}", null, null, null, "692123456"], [null, null, "80\\d{7}", null, null, null, "801234567"], [null, null, "89[1-37-9]\\d{6}", null, null, null, "891123456"], [
      null,
      null,
      "8(?:1[019]|2[0156]|84|90)\\d{6}",
      null,
      null,
      null,
      "810123456"
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "RE", 262, "00", "0", null, null, "0", null, null, null, [[null, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[268]"], "0$1"]], null, [null, null, null, null, null, null, null, null, null, [-1]], 1, "262|69|8", [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    RO: [null, [
      null,
      null,
      "(?:[237]\\d|[89]0)\\d{7}|[23]\\d{5}",
      null,
      null,
      null,
      null,
      null,
      null,
      [6, 9]
    ], [null, null, "[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d", null, null, null, "211234567"], [null, null, "7(?:(?:[02-7]\\d|8[03-8]|99)\\d|1(?:[01]\\d|20))\\d{5}", null, null, null, "712034567", null, null, [9]], [null, null, "800\\d{6}", null, null, null, "800123456", null, null, [9]], [null, null, "90[036]\\d{6}", null, null, null, "900123456", null, null, [9]], [null, null, "801\\d{6}", null, null, null, "801123456", null, null, [9]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], "RO", 40, "00", "0", " int ", null, "0", null, null, null, [[null, "(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], [null, "(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], [null, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], [null, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[237-9]"], "0$1"]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      "37\\d{7}",
      null,
      null,
      null,
      "372123456",
      null,
      null,
      [9]
    ], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    RS: [null, [null, null, "[127]\\d{6,11}|3(?:[0-79]\\d{5,10}|8(?:[02-9]\\d{4,9}|1\\d{4,5}))|6\\d{7,9}|800\\d{3,9}|90\\d{4,8}|7\\d{5}", null, null, null, null, null, null, [6, 7, 8, 9, 10, 11, 12], [4, 5]], [null, null, "(?:1(?:[02-9][2-9]|1[1-9])\\d|2(?:[0-24-7][2-9]\\d|[389](?:0[2-9]|[2-9]\\d))|3(?:[0-8][2-9]\\d|9(?:0[2-9]|[2-9]\\d)))\\d{3,8}", null, null, null, "10234567", null, null, [7, 8, 9, 10, 11, 12], [
      4,
      5,
      6
    ]], [null, null, "6(?:[0-689]|7\\d)\\d{6,7}", null, null, null, "601234567", null, null, [8, 9, 10]], [null, null, "800\\d{3,9}", null, null, null, "80012345"], [null, null, "(?:78\\d|90[0169])\\d{3,7}", null, null, null, "90012345", null, null, [6, 7, 8, 9, 10]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "RS", 381, "00", "0", null, null, "0", null, null, null, [
      [null, "(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"],
      [null, "(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]
    ], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "7[06]\\d{4,10}", null, null, null, "700123456"], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    RU: [null, [null, null, "[347-9]\\d{9}", null, null, null, null, null, null, [10], [7]], [
      null,
      null,
      "(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}",
      null,
      null,
      null,
      "3011234567",
      null,
      null,
      null,
      [7]
    ], [null, null, "9\\d{9}", null, null, null, "9123456789"], [null, null, "80[04]\\d{7}", null, null, null, "8001234567"], [null, null, "80[39]\\d{7}", null, null, null, "8091234567"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "808\\d{7}", null, null, null, "8081234567"], [null, null, null, null, null, null, null, null, null, [-1]], "RU", 7, "810", "8", null, null, "8", null, "8~10", null, [[null, "(\\d{3})(\\d{2})(\\d{2})", "$1-$2-$3"], [
      null,
      "(\\d{3})(\\d{3})(\\d{4})",
      "$1 $2 $3",
      ["7"],
      "8 ($1)",
      null,
      1
    ], [null, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[3489]"], "8 ($1)", null, 1]], [[null, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", null, 1], [null, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[3489]"], "8 ($1)", null, 1]], [null, null, null, null, null, null, null, null, null, [-1]], 1, "3[04-689]|[489]", [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    RW: [
      null,
      [null, null, "(?:06|[27]\\d\\d|[89]00)\\d{6}", null, null, null, null, null, null, [8, 9]],
      [null, null, "(?:06|2[258]\\d)\\d{6}", null, null, null, "250123456"],
      [null, null, "7[238]\\d{7}", null, null, null, "720123456", null, null, [9]],
      [null, null, "800\\d{6}", null, null, null, "800123456", null, null, [9]],
      [null, null, "900\\d{6}", null, null, null, "900123456", null, null, [9]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "RW",
      250,
      "00",
      "0",
      null,
      null,
      "0",
      null,
      null,
      null,
      [[null, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], [null, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], [null, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    SA: [null, [
      null,
      null,
      "(?:(?:[15]|8\\d)\\d|92)\\d{7}",
      null,
      null,
      null,
      null,
      null,
      null,
      [9, 10],
      [7]
    ], [null, null, "1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}", null, null, null, "112345678", null, null, [9], [7]], [null, null, "5(?:[013-689]\\d|7[0-36-8])\\d{6}", null, null, null, "512345678", null, null, [9]], [null, null, "800\\d{7}", null, null, null, "8001234567", null, null, [10]], [null, null, "925\\d{6}", null, null, null, "925012345", null, null, [9]], [null, null, "920\\d{6}", null, null, null, "920012345", null, null, [9]], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], "SA", 966, "00", "0", null, null, "0", null, null, null, [[null, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [null, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], [null, "(\\d{4})(\\d{5})", "$1 $2", ["9"]], [null, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], [null, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      "811\\d{7}",
      null,
      null,
      null,
      "8110123456",
      null,
      null,
      [10]
    ], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    SB: [
      null,
      [null, null, "(?:[1-6]|[7-9]\\d\\d)\\d{4}", null, null, null, null, null, null, [5, 7]],
      [null, null, "(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}", null, null, null, "40123", null, null, [5]],
      [null, null, "(?:48|(?:(?:7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d)\\d{3}", null, null, null, "7421234"],
      [null, null, "1[38]\\d{3}", null, null, null, "18123", null, null, [5]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "5[12]\\d{3}", null, null, null, "51123", null, null, [5]],
      "SB",
      677,
      "0[01]",
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [[null, "(\\d{2})(\\d{5})", "$1 $2", ["7[1-9]|8[4-9]|9(?:1[2-9]|2[013-9]|3[0-2]|[46]|5[0-46-9]|7[0-689]|8[0-79]|9[0-8])"]]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        [-1]
      ],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    SC: [null, [null, null, "(?:(?:(?:[24]\\d|64)\\d|971)\\d|8000)\\d{3}", null, null, null, null, null, null, [7]], [null, null, "4[2-46]\\d{5}", null, null, null, "4217123"], [null, null, "2[5-8]\\d{5}", null, null, null, "2510123"], [null, null, "8000\\d{3}", null, null, null, "8000000"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, "(?:64\\d|971)\\d{4}", null, null, null, "6412345"], "SC", 248, "0(?:[02]|10?)", null, null, null, null, null, "00", null, [[null, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    SD: [
      null,
      [
        null,
        null,
        "[19]\\d{8}",
        null,
        null,
        null,
        null,
        null,
        null,
        [9]
      ],
      [null, null, "1(?:5\\d|8[35-7])\\d{6}", null, null, null, "151231234"],
      [null, null, "(?:1[0-2]|9[0-3569])\\d{7}", null, null, null, "911231234"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "SD",
      249,
      "00",
      "0",
      null,
      null,
      "0",
      null,
      null,
      null,
      [[null, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    SE: [
      null,
      [null, null, "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", null, null, null, null, null, null, [6, 7, 8, 9, 10, 12]],
      [
        null,
        null,
        "1(?:0[1-8]\\d{6}|(?:[13689]\\d|2[0-35]|4[0-4]|5[0-25-9]|7[13-6])\\d{5,6})|(?:2(?:[136]\\d|2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|[1356]\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01]))\\d{5,6}|4(?:[0246]\\d{5,7}|(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])\\d{5,6})|6(?:[03]\\d{5,7}|(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])\\d{5,6})|8\\d{6,8}|9(?:0[1-9]\\d{4,6}|(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8])\\d{5,6})|(?:[12][136]|3[356])\\d{5}",
        null,
        null,
        null,
        "8123456",
        null,
        null,
        [7, 8, 9]
      ],
      [null, null, "7[02369]\\d{7}", null, null, null, "701234567", null, null, [9]],
      [null, null, "20\\d{4,7}", null, null, null, "20123456", null, null, [6, 7, 8, 9]],
      [null, null, "649\\d{6}|9(?:00|39|44)[1-8]\\d{3,6}", null, null, null, "9001234567", null, null, [7, 8, 9, 10]],
      [null, null, "77[0-7]\\d{6}", null, null, null, "771234567", null, null, [9]],
      [null, null, "75[1-8]\\d{6}", null, null, null, "751234567", null, null, [9]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "SE",
      46,
      "00",
      "0",
      null,
      null,
      "0",
      null,
      null,
      null,
      [[null, "(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1"], [null, "(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1"], [null, "(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44)"], "0$1"], [null, "(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1"], [null, "(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1"], [
        null,
        "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
        "$1-$2 $3 $4",
        ["1[013689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"],
        "0$1"
      ], [null, "(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:0|39|44)"], "0$1"], [null, "(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1"], [null, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1"], [null, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["7"], "0$1"], [null, "(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1"], [
        null,
        "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
        "$1-$2 $3 $4 $5",
        ["[26]"],
        "0$1"
      ]],
      [[null, "(\\d{2})(\\d{2,3})(\\d{2})", "$1 $2 $3", ["20"]], [null, "(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"]], [null, "(\\d{3})(\\d{4})", "$1 $2", ["9(?:00|39|44)"]], [null, "(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], [null, "(\\d{3})(\\d{2,3})(\\d{2})", "$1 $2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"]], [
        null,
        "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["1[013689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"]
      ], [null, "(\\d{3})(\\d{2,3})(\\d{3})", "$1 $2 $3", ["9(?:0|39|44)"]], [null, "(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["8"]], [null, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"]], [null, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7"]], [null, "(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["9"]], [
        null,
        "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4 $5",
        ["[26]"]
      ]],
      [null, null, "74[02-9]\\d{6}", null, null, null, "740123456", null, null, [9]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, "(?:25[245]|67[3-68])\\d{9}", null, null, null, "254123456789", null, null, [12]]
    ],
    SG: [null, [null, null, "(?:1\\d{3}|[369]|7000|8(?:\\d{2})?)\\d{7}", null, null, null, null, null, null, [8, 10, 11]], [null, null, "6[1-9]\\d{6}", null, null, null, "61234567", null, null, [8]], [
      null,
      null,
      "(?:8[1-8]|9[0-8])\\d{6}",
      null,
      null,
      null,
      "81234567",
      null,
      null,
      [8]
    ], [null, null, "(?:18|8)00\\d{7}", null, null, null, "18001234567", null, null, [10, 11]], [null, null, "1900\\d{7}", null, null, null, "19001234567", null, null, [11]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "3[12]\\d{6}", null, null, null, "31234567", null, null, [8]], "SG", 65, "0[0-3]\\d", null, null, null, null, null, null, null, [[null, "(\\d{4})(\\d{4})", "$1 $2", ["[369]|8[1-8]"]], [
      null,
      "(\\d{3})(\\d{3})(\\d{4})",
      "$1 $2 $3",
      ["8"]
    ], [null, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1[89]"]], [null, "(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["70"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "7000\\d{7}", null, null, null, "70001234567", null, null, [11]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    SH: [null, [null, null, "(?:[256]\\d|8)\\d{3}", null, null, null, null, null, null, [4, 5]], [
      null,
      null,
      "2(?:[0-57-9]\\d|6[4-9])\\d\\d",
      null,
      null,
      null,
      "22158"
    ], [null, null, "[56]\\d{4}", null, null, null, "51234", null, null, [5]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "262\\d\\d", null, null, null, "26212", null, null, [5]], "SH", 290, "00", null, null, null, null, null, null, null, null, null, [null, null, null, null, null, null, null, null, null, [-1]], 1, "[256]", [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    SI: [null, [null, null, "[1-8]\\d{7}|90\\d{4,6}|8\\d{4,6}", null, null, null, null, null, null, [5, 6, 7, 8]], [null, null, "(?:[1-357][2-8]|4[24-8])\\d{6}", null, null, null, "12345678", null, null, [8], [7]], [null, null, "(?:(?:[37][01]|4[0139]|51)\\d\\d|6(?:[48]\\d\\d|5(?:1\\d|55|[67]0)|9(?:10|[69]\\d)))\\d{4}", null, null, null, "31234567", null, null, [8]], [
      null,
      null,
      "80\\d{4,6}",
      null,
      null,
      null,
      "80123456",
      null,
      null,
      [6, 7, 8]
    ], [null, null, "89[1-3]\\d{2,5}|90\\d{4,6}", null, null, null, "90123456"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "(?:59\\d\\d|8(?:1(?:[67]\\d|8[01389])|2(?:0\\d|2[0378]|8[0-2489])|3[389]\\d))\\d{4}", null, null, null, "59012345", null, null, [8]], "SI", 386, "00|10(?:22|66|88|99)", "0", null, null, "0", null, "00", null, [[null, "(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], [
      null,
      "(\\d)(\\d{3})(\\d{2})(\\d{2})",
      "$1 $2 $3 $4",
      ["[12]|[357][2-8]|4[24-8]"],
      "(0$1)"
    ], [null, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[3467]|51"], "0$1"], [null, "(\\d{3})(\\d{5})", "$1 $2", ["[58]"], "0$1"]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    SJ: [
      null,
      [null, null, "(?:0|(?:[4589]\\d|79)\\d\\d)\\d{4}", null, null, null, null, null, null, [5, 8]],
      [
        null,
        null,
        "79\\d{6}",
        null,
        null,
        null,
        "79123456",
        null,
        null,
        [8]
      ],
      [null, null, "(?:4[015-8]|5[89]|9\\d)\\d{6}", null, null, null, "41234567", null, null, [8]],
      [null, null, "80[01]\\d{5}", null, null, null, "80012345", null, null, [8]],
      [null, null, "82[09]\\d{5}", null, null, null, "82012345", null, null, [8]],
      [null, null, "810(?:0[0-6]|[2-8]\\d)\\d{3}", null, null, null, "81021234", null, null, [8]],
      [null, null, "880\\d{5}", null, null, null, "88012345", null, null, [8]],
      [null, null, "85[0-5]\\d{5}", null, null, null, "85012345", null, null, [8]],
      "SJ",
      47,
      "00",
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      "79",
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "(?:0\\d|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}", null, null, null, "01234"],
      null,
      null,
      [null, null, "81[23]\\d{5}", null, null, null, "81212345", null, null, [8]]
    ],
    SK: [
      null,
      [null, null, "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", null, null, null, null, null, null, [6, 7, 9]],
      [null, null, "(?:2(?:16|[2-9]\\d{3})|[3-5][1-8]\\d{3})\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d", null, null, null, "221234567"],
      [null, null, "9(?:0(?:[1-8]\\d|9[1-9])|(?:1[0-24-9]|[45]\\d)\\d)\\d{5}", null, null, null, "912123456", null, null, [9]],
      [null, null, "800\\d{6}", null, null, null, "800123456", null, null, [9]],
      [null, null, "9(?:00|[78]\\d)\\d{6}", null, null, null, "900123456", null, null, [9]],
      [null, null, "8[5-9]\\d{7}", null, null, null, "850123456", null, null, [9]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "6(?:02|5[0-4]|9[0-6])\\d{6}", null, null, null, "690123456", null, null, [9]],
      "SK",
      421,
      "00",
      "0",
      null,
      null,
      "0",
      null,
      null,
      null,
      [[null, "(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], [null, "(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], [null, "(\\d{4})(\\d{3})", "$1 $2", ["909", "9090"], "0$1"], [null, "(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], [null, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"], [null, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"]],
      [[null, "(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], [
        null,
        "(\\d{2})(\\d{2})(\\d{2,3})",
        "$1 $2 $3",
        ["[3-5][1-8]1", "[3-5][1-8]1[67]"],
        "0$1"
      ], [null, "(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], [null, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"], [null, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"]],
      [null, null, "9090\\d{3}", null, null, null, "9090123", null, null, [7]],
      null,
      null,
      [null, null, "(?:(?:602|8(?:00|[5-9]\\d))\\d{3}|9(?:0(?:0\\d{3}|90)|[78]\\d{4}))\\d{3}", null, null, null, null, null, null, [7, 9]],
      [null, null, "96\\d{7}", null, null, null, "961234567", null, null, [9]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    SL: [null, [null, null, "(?:[2-578]\\d|66|99)\\d{6}", null, null, null, null, null, null, [8], [6]], [null, null, "[235]2[2-4][2-9]\\d{4}", null, null, null, "22221234", null, null, null, [6]], [null, null, "(?:2[15]|3[013-5]|4[04]|5[05]|66|7[5-9]|8[08]|99)\\d{6}", null, null, null, "25123456"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], "SL", 232, "00", "0", null, null, "0", null, null, null, [[null, "(\\d{2})(\\d{6})", "$1 $2", ["[2-9]"], "(0$1)"]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    SM: [
      null,
      [null, null, "(?:0549|[5-7]\\d)\\d{6}", null, null, null, null, null, null, [
        8,
        10
      ], [6]],
      [null, null, "0549(?:8[0157-9]|9\\d)\\d{4}", null, null, null, "0549886377", null, null, [10], [6]],
      [null, null, "6[16]\\d{6}", null, null, null, "66661212", null, null, [8]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "7[178]\\d{6}", null, null, null, "71123456", null, null, [8]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "5[158]\\d{6}", null, null, null, "58001110", null, null, [8]],
      "SM",
      378,
      "00",
      null,
      null,
      null,
      "([89]\\d{5})$",
      "0549$1",
      null,
      null,
      [[null, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], [null, "(\\d{4})(\\d{6})", "$1 $2", ["0"]]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    SN: [null, [null, null, "(?:[378]\\d{4}|93330)\\d{4}", null, null, null, null, null, null, [9]], [
      null,
      null,
      "3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}",
      null,
      null,
      null,
      "301012345"
    ], [null, null, "7(?:[06-8]\\d|21|90)\\d{6}", null, null, null, "701234567"], [null, null, "800\\d{6}", null, null, null, "800123456"], [null, null, "88[4689]\\d{6}", null, null, null, "884123456"], [null, null, "81[02468]\\d{6}", null, null, null, "810123456"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "(?:3(?:392|9[01]\\d)\\d|93330)\\d{4}", null, null, null, "933301234"], "SN", 221, "00", null, null, null, null, null, null, null, [
      [null, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]],
      [null, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]
    ], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    SO: [
      null,
      [null, null, "[346-9]\\d{8}|[12679]\\d{7}|(?:[1-4]\\d|59)\\d{5}|[1348]\\d{5}", null, null, null, null, null, null, [6, 7, 8, 9]],
      [
        null,
        null,
        "(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|59)\\d{5}|(?:[134]\\d|8[125])\\d{4}",
        null,
        null,
        null,
        "4012345",
        null,
        null,
        [6, 7]
      ],
      [null, null, "(?:(?:15|(?:3[59]|4[89]|6[1-9]|79|8[08])\\d|9(?:0[67]|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:6\\d|7[1-9])\\d{6}", null, null, null, "71123456", null, null, [7, 8, 9]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "SO",
      252,
      "00",
      "0",
      null,
      null,
      "0",
      null,
      null,
      null,
      [[null, "(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], [null, "(\\d{6})", "$1", ["[134]"]], [null, "(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], [null, "(\\d)(\\d{7})", "$1 $2", ["24|[67]"]], [null, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79[0-8]|90"]], [null, "(\\d{2})(\\d{5,7})", "$1 $2", ["[12679]"]]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        [-1]
      ]
    ],
    SR: [
      null,
      [null, null, "(?:[2-5]|68|[78]\\d)\\d{5}", null, null, null, null, null, null, [6, 7]],
      [null, null, "(?:2[1-3]|3[0-7]|(?:4|68)\\d|5[2-58])\\d{4}", null, null, null, "211234"],
      [null, null, "(?:7[124-7]|8[125-9])\\d{5}", null, null, null, "7412345", null, null, [7]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "56\\d{4}", null, null, null, "561234", null, null, [6]],
      "SR",
      597,
      "00",
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [[null, "(\\d{3})(\\d{3})", "$1-$2", ["[2-4]|5[2-58]"]], [null, "(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["5"]], [null, "(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    SS: [
      null,
      [null, null, "[19]\\d{8}", null, null, null, null, null, null, [9]],
      [null, null, "18\\d{7}", null, null, null, "181234567"],
      [null, null, "(?:12|9[1257])\\d{7}", null, null, null, "977123456"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "SS",
      211,
      "00",
      "0",
      null,
      null,
      "0",
      null,
      null,
      null,
      [[
        null,
        "(\\d{3})(\\d{3})(\\d{3})",
        "$1 $2 $3",
        ["[19]"],
        "0$1"
      ]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    ST: [null, [null, null, "(?:22|9\\d)\\d{5}", null, null, null, null, null, null, [7]], [null, null, "22\\d{5}", null, null, null, "2221234"], [null, null, "9(?:0(?:0[5-9]|[1-9]\\d)|[89]\\d\\d)\\d{3}", null, null, null, "9812345"], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "ST", 239, "00", null, null, null, null, null, null, null, [[null, "(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ]],
    SV: [null, [null, null, "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?", null, null, null, null, null, null, [7, 8, 11]], [null, null, "2[1-6]\\d{6}", null, null, null, "21234567", null, null, [8]], [null, null, "[67]\\d{7}", null, null, null, "70123456", null, null, [8]], [null, null, "800\\d{4}(?:\\d{4})?", null, null, null, "8001234", null, null, [7, 11]], [null, null, "900\\d{4}(?:\\d{4})?", null, null, null, "9001234", null, null, [7, 11]], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], "SV", 503, "00", null, null, null, null, null, null, null, [[null, "(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], [null, "(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], [null, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ]],
    SX: [null, [null, null, "(?:(?:[58]\\d\\d|900)\\d|7215)\\d{6}", null, null, null, null, null, null, [10], [7]], [null, null, "7215(?:4[2-8]|8[239]|9[056])\\d{4}", null, null, null, "7215425678", null, null, null, [7]], [null, null, "7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}", null, null, null, "7215205678", null, null, null, [7]], [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002123456"], [null, null, "900[2-9]\\d{6}", null, null, null, "9002123456"], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",
      null,
      null,
      null,
      "5002345678"
    ], [null, null, null, null, null, null, null, null, null, [-1]], "SX", 1, "011", "1", null, null, "1", null, null, null, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, "721", [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    SY: [
      null,
      [null, null, "[1-39]\\d{8}|[1-5]\\d{7}", null, null, null, null, null, null, [8, 9], [6, 7]],
      [null, null, "(?:1[14]\\d|2(?:1\\d?|[235])|3(?:[13]\\d|4)|4[13]|5[1-3])\\d{6}|1[1-356]\\d{6}", null, null, null, "112345678", null, null, null, [6, 7]],
      [null, null, "9(?:22|[3-589]\\d|6[024-9])\\d{6}", null, null, null, "944567890", null, null, [9]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "SY",
      963,
      "00",
      "0",
      null,
      null,
      "0",
      null,
      null,
      null,
      [[null, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", null, 1], [null, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", null, 1]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    SZ: [null, [null, null, "(?:0800|(?:[237]\\d|900)\\d\\d)\\d{4}", null, null, null, null, null, null, [8, 9]], [
      null,
      null,
      "[23][2-5]\\d{6}",
      null,
      null,
      null,
      "22171234",
      null,
      null,
      [8]
    ], [null, null, "7[6-9]\\d{6}", null, null, null, "76123456", null, null, [8]], [null, null, "0800\\d{4}", null, null, null, "08001234", null, null, [8]], [null, null, "900\\d{6}", null, null, null, "900012345", null, null, [9]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "70\\d{6}", null, null, null, "70012345", null, null, [8]], "SZ", 268, "00", null, null, null, null, null, null, null, [[
      null,
      "(\\d{4})(\\d{4})",
      "$1 $2",
      ["[0237]"]
    ], [null, "(\\d{5})(\\d{4})", "$1 $2", ["9"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, "0800\\d{4}", null, null, null, null, null, null, [8]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    TA: [null, [null, null, "8\\d{3}", null, null, null, null, null, null, [4]], [null, null, "8\\d{3}", null, null, null, "8999"], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "TA", 290, "00", null, null, null, null, null, null, null, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, "8", [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    TC: [null, [null, null, "(?:[58]\\d\\d|649|900)\\d{7}", null, null, null, null, null, null, [10], [7]], [null, null, "649(?:712|9(?:4\\d|50))\\d{4}", null, null, null, "6497121234", null, null, null, [7]], [null, null, "649(?:2(?:3[129]|4[1-7])|3(?:3[1-389]|4[1-8])|4[34][1-3])\\d{4}", null, null, null, "6492311234", null, null, null, [7]], [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002345678"], [null, null, "900[2-9]\\d{6}", null, null, null, "9002345678"], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",
      null,
      null,
      null,
      "5002345678"
    ], [null, null, "64971[01]\\d{4}", null, null, null, "6497101234", null, null, null, [7]], "TC", 1, "011", "1", null, null, "1", null, null, null, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, "649", [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    TD: [null, [
      null,
      null,
      "(?:22|[69]\\d|77)\\d{6}",
      null,
      null,
      null,
      null,
      null,
      null,
      [8]
    ], [null, null, "22(?:[37-9]0|5[0-5]|6[89])\\d{4}", null, null, null, "22501234"], [null, null, "(?:6[023568]|77|9\\d)\\d{6}", null, null, null, "63012345"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "TD", 235, "00|16", null, null, null, null, null, "00", null, [[
      null,
      "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
      "$1 $2 $3 $4",
      ["[2679]"]
    ]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    TG: [null, [null, null, "[279]\\d{7}", null, null, null, null, null, null, [8]], [null, null, "2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}", null, null, null, "22212345"], [null, null, "(?:7[09]|9[0-36-9])\\d{6}", null, null, null, "90112345"], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "TG", 228, "00", null, null, null, null, null, null, null, [[null, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    TH: [null, [null, null, "(?:1\\d\\d?|[2-57]|[689]\\d)\\d{7}", null, null, null, null, null, null, [8, 9, 10]], [null, null, "(?:2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}", null, null, null, "21234567", null, null, [8]], [null, null, "(?:14|6[1-6]|[89]\\d)\\d{7}", null, null, null, "812345678", null, null, [9]], [null, null, "1800\\d{6}", null, null, null, "1800123456", null, null, [10]], [null, null, "1900\\d{6}", null, null, null, "1900123456", null, null, [10]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "6[08]\\d{7}", null, null, null, "601234567", null, null, [9]], "TH", 66, "00[1-9]", "0", null, null, "0", null, null, null, [[null, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [null, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["14|[3-9]"], "0$1"], [null, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    TJ: [null, [null, null, "(?:[3-59]\\d|77|88)\\d{7}", null, null, null, null, null, null, [9], [3, 5, 6, 7]], [null, null, "(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}", null, null, null, "372123456", null, null, null, [3, 5, 6, 7]], [null, null, "(?:41[18]|(?:5[05]|77|88|9[0-35-9])\\d)\\d{6}", null, null, null, "917123456"], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "TJ", 992, "810", "8", null, null, "8", null, "8~10", null, [[null, "(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])", "3(?:[1245]|3(?:1[0-689]|2))"], null, null, 1], [null, "(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["33"], null, null, 1], [
      null,
      "(\\d{2})(\\d{3})(\\d{4})",
      "$1 $2 $3",
      ["4[148]|[578]|9(?:[0235-9]|1[0-69])"],
      null,
      null,
      1
    ], [null, "(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[349]"], null, null, 1]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    TK: [null, [null, null, "[2-47]\\d{3,6}", null, null, null, null, null, null, [4, 5, 6, 7]], [null, null, "(?:2[2-4]|[34]\\d)\\d{2,5}", null, null, null, "3101"], [null, null, "7[2-4]\\d{2,5}", null, null, null, "7290"], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "TK", 690, "00", null, null, null, null, null, null, null, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ]],
    TL: [null, [null, null, "(?:[2-4]\\d|7\\d\\d?|[89]0)\\d{5}", null, null, null, null, null, null, [7, 8]], [null, null, "(?:2[1-5]|3[1-9]|4[1-4])\\d{5}", null, null, null, "2112345", null, null, [7]], [null, null, "7[3-8]\\d{6}", null, null, null, "77212345", null, null, [8]], [null, null, "80\\d{5}", null, null, null, "8012345", null, null, [7]], [null, null, "90\\d{5}", null, null, null, "9012345", null, null, [7]], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      "70\\d{5}",
      null,
      null,
      null,
      "7012345",
      null,
      null,
      [7]
    ], [null, null, null, null, null, null, null, null, null, [-1]], "TL", 670, "00", null, null, null, null, null, null, null, [[null, "(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], [null, "(\\d{4})(\\d{4})", "$1 $2", ["7"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    TM: [
      null,
      [
        null,
        null,
        "[1-6]\\d{7}",
        null,
        null,
        null,
        null,
        null,
        null,
        [8]
      ],
      [null, null, "(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}", null, null, null, "12345678"],
      [null, null, "6[1-9]\\d{6}", null, null, null, "66123456"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "TM",
      993,
      "810",
      "8",
      null,
      null,
      "8",
      null,
      "8~10",
      null,
      [[null, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], [null, "(\\d{2})(\\d{6})", "$1 $2", ["6"], "8 $1"], [null, "(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    TN: [
      null,
      [
        null,
        null,
        "[2-57-9]\\d{7}",
        null,
        null,
        null,
        null,
        null,
        null,
        [8]
      ],
      [null, null, "(?:(?:3[0-2]|7\\d)\\d{3}|81200)\\d{3}", null, null, null, "30010123"],
      [null, null, "(?:(?:[259]\\d|4[0-6])\\d\\d|3(?:001|1(?:[1-35]\\d|40)|240|(?:6[0-4]|91)\\d))\\d{4}", null, null, null, "20123456"],
      [null, null, "8010\\d{4}", null, null, null, "80101234"],
      [null, null, "88\\d{6}", null, null, null, "88123456"],
      [null, null, "8[12]10\\d{4}", null, null, null, "81101234"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "TN",
      216,
      "00",
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [[null, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    TO: [null, [null, null, "(?:(?:080|[56])0|[2-4]\\d|[78]\\d(?:\\d{2})?)\\d{3}", null, null, null, null, null, null, [5, 7]], [
      null,
      null,
      "(?:2\\d|3[1-8]|4[1-4]|[56]0|7[0149]|8[05])\\d{3}",
      null,
      null,
      null,
      "20123",
      null,
      null,
      [5]
    ], [null, null, "(?:7[578]|8[46-9])\\d{5}", null, null, null, "7715123", null, null, [7]], [null, null, "0800\\d{3}", null, null, null, "0800222", null, null, [7]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "TO", 676, "00", null, null, null, null, null, null, null, [[null, "(\\d{2})(\\d{3})", "$1-$2", ["[2-6]|7[014]|8[05]"]], [
      null,
      "(\\d{3})(\\d{4})",
      "$1 $2",
      ["7[578]|8"]
    ], [null, "(\\d{4})(\\d{3})", "$1 $2", ["0"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    TR: [
      null,
      [null, null, "(?:[2-58]\\d\\d|900)\\d{7}|4\\d{6}", null, null, null, null, null, null, [7, 10]],
      [
        null,
        null,
        "(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}",
        null,
        null,
        null,
        "2123456789",
        null,
        null,
        [10]
      ],
      [null, null, "5(?:(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d\\d|6161)\\d{5}", null, null, null, "5012345678", null, null, [10]],
      [null, null, "800\\d{7}", null, null, null, "8001234567", null, null, [10]],
      [null, null, "(?:8[89]8|900)\\d{7}", null, null, null, "9001234567", null, null, [10]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "592(?:21[12]|461)\\d{4}", null, null, null, "5922121234", null, null, [10]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "TR",
      90,
      "00",
      "0",
      null,
      null,
      "0",
      null,
      null,
      null,
      [[null, "(\\d{3})(\\d)(\\d{3})", "$1 $2 $3", ["444"], null, null, 1], [null, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-4]"], "(0$1)", null, 1], [null, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|[89]"], "0$1", null, 1], [null, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5"], "0$1", null, 1]],
      [[null, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-4]"], "(0$1)", null, 1], [null, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|[89]"], "0$1", null, 1], [
        null,
        "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["5"],
        "0$1",
        null,
        1
      ]],
      [null, null, "512\\d{7}", null, null, null, "5123456789", null, null, [10]],
      null,
      null,
      [null, null, "444\\d{4}", null, null, null, null, null, null, [7]],
      [null, null, "(?:444|850\\d{3})\\d{4}", null, null, null, "4441444"],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    TT: [
      null,
      [null, null, "(?:[58]\\d\\d|900)\\d{7}", null, null, null, null, null, null, [10], [7]],
      [
        null,
        null,
        "868(?:2(?:01|[23]\\d)|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}",
        null,
        null,
        null,
        "8682211234",
        null,
        null,
        null,
        [7]
      ],
      [null, null, "868(?:2(?:6[6-9]|[7-9]\\d)|[37](?:0[1-9]|1[02-9]|[2-9]\\d)|4[6-9]\\d|6(?:20|78|8\\d))\\d{4}", null, null, null, "8682911234", null, null, null, [7]],
      [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002345678"],
      [null, null, "900[2-9]\\d{6}", null, null, null, "9002345678"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "TT",
      1,
      "011",
      "1",
      null,
      null,
      "1",
      null,
      null,
      null,
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      "868",
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, "868619\\d{4}", null, null, null, "8686191234", null, null, null, [7]]
    ],
    TV: [
      null,
      [null, null, "(?:2|7\\d\\d|90)\\d{4}", null, null, null, null, null, null, [5, 6, 7]],
      [null, null, "2[02-9]\\d{3}", null, null, null, "20123", null, null, [5]],
      [
        null,
        null,
        "(?:7[01]\\d|90)\\d{4}",
        null,
        null,
        null,
        "901234",
        null,
        null,
        [6, 7]
      ],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "TV",
      688,
      "00",
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    TW: [null, [null, null, "(?:[24589]|7\\d)\\d{8}|[2-8]\\d{7}|2\\d{6}", null, null, null, null, null, null, [7, 8, 9, 10]], [null, null, "(?:(?:2[2-8]\\d|3[2-9]|4(?:[239]\\d|[78])|5[2-8]|6[235-79]|7[1-9])\\d\\d|8(?:2(?:3\\d|66)|[7-9]\\d\\d))\\d{4}|24\\d{6}", null, null, null, "221234567", null, null, [8, 9]], [null, null, "9[0-8]\\d{7}", null, null, null, "912345678", null, null, [9]], [null, null, "80[0-79]\\d{6}", null, null, null, "800123456", null, null, [9]], [
      null,
      null,
      "20(?:[013-9]\\d\\d|2)\\d{4}",
      null,
      null,
      null,
      "203123456",
      null,
      null,
      [7, 9]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "99\\d{7}", null, null, null, "990123456", null, null, [9]], [null, null, "70\\d{8}", null, null, null, "7012345678", null, null, [10]], "TW", 886, "0(?:0[25-79]|19)", "0", "#", null, "0", null, null, null, [[null, "(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], [null, "(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[25][2-8]|[346]|7[1-9]|8[27-9]"], "0$1"], [null, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[258]"], "0$1"], [
      null,
      "(\\d{3})(\\d{3})(\\d{3})",
      "$1 $2 $3",
      ["9"],
      "0$1"
    ], [null, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "50[0-46-9]\\d{6}", null, null, null, "500123456", null, null, [9]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    TZ: [null, [null, null, "(?:[26-8]\\d|41|90)\\d{7}", null, null, null, null, null, null, [9]], [null, null, "2[2-8]\\d{7}", null, null, null, "222345678"], [
      null,
      null,
      "(?:6[2-9]|7[13-9])\\d{7}",
      null,
      null,
      null,
      "621234567"
    ], [null, null, "80[08]\\d{6}", null, null, null, "800123456"], [null, null, "90\\d{7}", null, null, null, "900123456"], [null, null, "8(?:40|6[01])\\d{6}", null, null, null, "840123456"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "41\\d{7}", null, null, null, "412345678"], "TZ", 255, "00[056]", "0", null, null, "0", null, null, null, [[null, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], [null, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"], [
      null,
      "(\\d{3})(\\d{2})(\\d{4})",
      "$1 $2 $3",
      ["[89]"],
      "0$1"
    ]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, "(?:8(?:[04]0|6[01])|90\\d)\\d{6}"], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    UA: [null, [null, null, "[3-9]\\d{8}", null, null, null, null, null, null, [9], [5, 6, 7]], [null, null, "(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}", null, null, null, "311234567", null, null, null, [5, 6, 7]], [
      null,
      null,
      "(?:39|50|6[36-8]|7[1-3]|9[1-9])\\d{7}",
      null,
      null,
      null,
      "391234567"
    ], [null, null, "800\\d{6}", null, null, null, "800123456"], [null, null, "900[2-49]\\d{5}", null, null, null, "900212345"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "89[1-579]\\d{6}", null, null, null, "891234567"], "UA", 380, "00", "0", null, null, "0", null, "0~0", null, [[
      null,
      "(\\d{3})(\\d{3})(\\d{3})",
      "$1 $2 $3",
      ["(?:3[1-8]|4[136-8])2|5(?:[12457]2|6[24])|6(?:[12][29]|[49]2|5[24])|[89]0", "3(?:[1-46-8]2[013-9]|52)|4(?:[1378]2|62[013-9])|5(?:[12457]2|6[24])|6(?:[12][29]|[49]2|5[24])|[89]0"],
      "0$1"
    ], [null, "(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], [null, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-9]"], "0$1"]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ]],
    UG: [null, [null, null, "(?:(?:[29]0|[347]\\d)\\d|800)\\d{6}", null, null, null, null, null, null, [9], [5, 6, 7]], [null, null, "(?:20(?:(?:(?:[0147]\\d|5[0-4]|8[0-2])\\d|2(?:40|[5-9]\\d)|3(?:0[0-4]|[2367]\\d))\\d|6(?:00[0-2]|30[0-4]|[5-9]\\d\\d))|[34]\\d{5})\\d{3}", null, null, null, "312345678", null, null, null, [5, 6, 7]], [null, null, "7(?:(?:[0157-9]\\d|30|4[0-4])\\d|2(?:[03]\\d|60))\\d{5}", null, null, null, "712345678"], [null, null, "800[1-3]\\d{5}", null, null, null, "800123456"], [
      null,
      null,
      "90[1-3]\\d{6}",
      null,
      null,
      null,
      "901123456"
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "UG", 256, "00[057]", "0", null, null, "0", null, null, null, [[null, "(\\d{2})(\\d{7})", "$1 $2", ["3|4(?:[0-5]|6[0-36-9])"], "0$1"], [null, "(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], [null, "(\\d{3})(\\d{6})", "$1 $2", ["[247-9]"], "0$1"]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    US: [null, [null, null, "[2-9]\\d{9}", null, null, null, null, null, null, [10], [7]], [
      null,
      null,
      "(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[0135]|3[0-24679]|4[67]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[017]|6[0-279]|78|8[0-2])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|2[08]|3[0-28]|4[3578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[0179]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}",
      null,
      null,
      null,
      "2015550123",
      null,
      null,
      null,
      [7]
    ], [
      null,
      null,
      "(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[0135]|3[0-24679]|4[67]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[017]|6[0-279]|78|8[0-2])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|2[08]|3[0-28]|4[3578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[0179]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}",
      null,
      null,
      null,
      "2015550123",
      null,
      null,
      null,
      [7]
    ], [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002345678"], [null, null, "900[2-9]\\d{6}", null, null, null, "9002345678"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"], [null, null, null, null, null, null, null, null, null, [-1]], "US", 1, "011", "1", null, null, "1", null, null, 1, [[null, "(\\d{3})(\\d{4})", "$1-$2", ["[2-9]"]], [
      null,
      "(\\d{3})(\\d{3})(\\d{4})",
      "($1) $2-$3",
      ["[2-9]"],
      null,
      null,
      1
    ]], [[null, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-9]"]]], [null, null, null, null, null, null, null, null, null, [-1]], 1, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "710[2-9]\\d{6}", null, null, null, "7102123456"], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    UY: [null, [null, null, "(?:[249]\\d\\d|80)\\d{5}|9\\d{6}", null, null, null, null, null, null, [7, 8]], [null, null, "(?:2\\d|4[2-7])\\d{6}", null, null, null, "21231234", null, null, [8], [7]], [
      null,
      null,
      "9[1-9]\\d{6}",
      null,
      null,
      null,
      "94231234",
      null,
      null,
      [8]
    ], [null, null, "80[05]\\d{4}", null, null, null, "8001234", null, null, [7]], [null, null, "90[0-8]\\d{4}", null, null, null, "9001234", null, null, [7]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "UY", 598, "0(?:0|1[3-9]\\d)", "0", " int. ", null, "0", null, "00", null, [[null, "(\\d{3})(\\d{4})", "$1 $2", ["8|90"], "0$1"], [null, "(\\d{4})(\\d{4})", "$1 $2", ["[24]"]], [
      null,
      "(\\d{2})(\\d{3})(\\d{3})",
      "$1 $2 $3",
      ["9"],
      "0$1"
    ]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    UZ: [null, [null, null, "[679]\\d{8}", null, null, null, null, null, null, [9], [7]], [
      null,
      null,
      "(?:6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|6\\d\\d|7(?:[23]\\d|7[69])|9(?:22|4[1-8]|6[135]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|1[12]\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|6(?:22|3[12457]|4[13-8])|9(?:22|5[1-9])))\\d{5}",
      null,
      null,
      null,
      "669050123",
      null,
      null,
      null,
      [7]
    ], [
      null,
      null,
      "(?:6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079]))|9(?:2(?:1[1267]|3[01]|5\\d|7[0-4])|(?:5[67]|7\\d)\\d|6(?:2[0-26]|8\\d)))|7(?:0\\d{3}|1(?:13[01]|6(?:0[47]|1[67]|66)|71[3-69]|98\\d)|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|6(?:2(?:2[1245]|4[2-4])|39\\d|41[179]|5(?:[349]\\d|5[0-2])|7(?:0[017]|[13]\\d|22|44|55|67|88))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07])))|9[0-57-9]\\d{3})\\d{4}",
      null,
      null,
      null,
      "912345678"
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "UZ", 998, "810", "8", null, null, "8", null, "8~10", null, [[null, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[679]"], "8 $1"]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    VA: [null, [null, null, "0\\d{6}(?:\\d{4})?|3[0-8]\\d{9}|(?:[0138]\\d?|55)\\d{8}|[08]\\d{5}(?:\\d{2})?", null, null, null, null, null, null, [6, 7, 8, 9, 10, 11]], [null, null, "06698\\d{1,6}", null, null, null, "0669812345"], [null, null, "33\\d{9}|3[1-9]\\d{8}|3[2-9]\\d{7}", null, null, null, "3123456789", null, null, [9, 10, 11]], [
      null,
      null,
      "80(?:0\\d{3}|3)\\d{3}",
      null,
      null,
      null,
      "800123456",
      null,
      null,
      [6, 9]
    ], [null, null, "(?:(?:0878|1(?:44|6[346])\\d)\\d\\d|89(?:2|(?:4[5-9]|(?:5[5-9]|9)\\d\\d)\\d))\\d{3}|89[45][0-4]\\d\\d", null, null, null, "899123456", null, null, [6, 8, 9, 10]], [null, null, "84(?:[08]\\d{3}|[17])\\d{3}", null, null, null, "848123456", null, null, [6, 9]], [null, null, "1(?:78\\d|99)\\d{6}", null, null, null, "1781234567", null, null, [9, 10]], [null, null, "55\\d{8}", null, null, null, "5512345678", null, null, [10]], "VA", 39, "00", null, null, null, null, null, null, null, null, null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], null, "06698", [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    VC: [null, [null, null, "(?:[58]\\d\\d|784|900)\\d{7}", null, null, null, null, null, null, [10], [7]], [null, null, "784(?:266|3(?:6[6-9]|7\\d|8[0-24-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}", null, null, null, "7842661234", null, null, null, [7]], [
      null,
      null,
      "784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4]))\\d{4}",
      null,
      null,
      null,
      "7844301234",
      null,
      null,
      null,
      [7]
    ], [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002345678"], [null, null, "900[2-9]\\d{6}", null, null, null, "9002345678"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"], [null, null, null, null, null, null, null, null, null, [-1]], "VC", 1, "011", "1", null, null, "1", null, null, null, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, "784", [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    VE: [null, [null, null, "(?:(?:[24]\\d|50)\\d|[89]00)\\d{7}", null, null, null, null, null, null, [10], [7]], [null, null, "(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|50[01])\\d{7}", null, null, null, "2121234567", null, null, null, [7]], [null, null, "4(?:1[24-8]|2[46])\\d{7}", null, null, null, "4121234567"], [null, null, "800\\d{7}", null, null, null, "8001234567"], [
      null,
      null,
      "900\\d{7}",
      null,
      null,
      null,
      "9001234567"
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "VE", 58, "00", "0", null, null, "0", null, null, null, [[null, "(\\d{3})(\\d{7})", "$1-$2", ["[24589]"], "0$1", "$CC $1"]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ]],
    VG: [null, [null, null, "(?:284|[58]\\d\\d|900)\\d{7}", null, null, null, null, null, null, [10], [7]], [null, null, "284(?:(?:229|774|8(?:52|6[459]))\\d|4(?:22\\d|9(?:[45]\\d|6[0-5])))\\d{3}", null, null, null, "2842291234", null, null, null, [7]], [null, null, "284(?:(?:3(?:0[0-3]|4[0-7]|68|9[34])|54[0-57])\\d|4(?:(?:4[0-6]|68)\\d|9(?:6[6-9]|9\\d)))\\d{3}", null, null, null, "2843001234", null, null, null, [7]], [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002345678"], [
      null,
      null,
      "900[2-9]\\d{6}",
      null,
      null,
      null,
      "9002345678"
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"], [null, null, null, null, null, null, null, null, null, [-1]], "VG", 1, "011", "1", null, null, "1", null, null, null, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, "284", [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    VI: [
      null,
      [null, null, "(?:(?:34|90)0|[58]\\d\\d)\\d{7}", null, null, null, null, null, null, [10], [7]],
      [null, null, "340(?:2(?:01|2[06-8]|44|77)|3(?:32|44)|4(?:22|7[34])|5(?:1[34]|55)|6(?:26|4[23]|77|9[023])|7(?:1[2-57-9]|27|7\\d)|884|998)\\d{4}", null, null, null, "3406421234", null, null, null, [7]],
      [null, null, "340(?:2(?:01|2[06-8]|44|77)|3(?:32|44)|4(?:22|7[34])|5(?:1[34]|55)|6(?:26|4[23]|77|9[023])|7(?:1[2-57-9]|27|7\\d)|884|998)\\d{4}", null, null, null, "3406421234", null, null, null, [7]],
      [
        null,
        null,
        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
        null,
        null,
        null,
        "8002345678"
      ],
      [null, null, "900[2-9]\\d{6}", null, null, null, "9002345678"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "VI",
      1,
      "011",
      "1",
      null,
      null,
      "1",
      null,
      null,
      1,
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      "340",
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    VN: [null, [null, null, "[12]\\d{9}|[135-9]\\d{8}|(?:[16]\\d?|[78])\\d{6}", null, null, null, null, null, null, [7, 8, 9, 10]], [null, null, "2(?:0[3-9]|1[0-689]|2[0-25-9]|3[2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|8[2-7]|9[0-4679])\\d{7}", null, null, null, "2101234567", null, null, [10]], [null, null, "(?:(?:3\\d|7[06-9])\\d|5(?:2[238]|[689]\\d)|8(?:[1-58]\\d|6[5689]|9[689])|9(?:[0-8]\\d|9[013-9]))\\d{6}", null, null, null, "912345678", null, null, [9]], [
      null,
      null,
      "1800\\d{4,6}",
      null,
      null,
      null,
      "1800123456",
      null,
      null,
      [8, 9, 10]
    ], [null, null, "1900\\d{4,6}", null, null, null, "1900123456", null, null, [8, 9, 10]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "(?:67|99)2\\d{6}", null, null, null, "992012345", null, null, [9]], "VN", 84, "00", "0", null, null, "0", null, null, null, [[null, "(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", null, 1], [null, "(\\d{3})(\\d{4})", "$1 $2", ["[17]99"], "0$1", null, 1], [
      null,
      "(\\d{3})(\\d{4,5})",
      "$1 $2",
      ["69"],
      "0$1",
      null,
      1
    ], [null, "(\\d{4})(\\d{4,6})", "$1 $2", ["1"], null, null, 1], [null, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[69]"], "0$1", null, 1], [null, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[3578]"], "0$1", null, 1], [null, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", null, 1], [null, "(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", null, 1]], [[null, "(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", null, 1], [null, "(\\d{4})(\\d{4,6})", "$1 $2", ["1"], null, null, 1], [
      null,
      "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
      "$1 $2 $3 $4",
      ["[69]"],
      "0$1",
      null,
      1
    ], [null, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[3578]"], "0$1", null, 1], [null, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", null, 1], [null, "(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", null, 1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, "(?:[17]99|69\\d\\d?)\\d{4}", null, null, null, null, null, null, [7, 8]], [null, null, "(?:[17]99|69\\d\\d?|80\\d)\\d{4}", null, null, null, "1992000", null, null, [7, 8]], null, null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ]],
    VU: [null, [null, null, "(?:(?:[23]|(?:[57]\\d|90)\\d)\\d|[48]8)\\d{3}", null, null, null, null, null, null, [5, 7]], [null, null, "(?:(?:2[02-9]|88)\\d|3(?:[5-7]\\d|8[0-8])|48[4-9])\\d\\d", null, null, null, "22123", null, null, [5]], [null, null, "(?:5(?:[0-689]\\d|7[2-5])|7[013-7]\\d)\\d{4}", null, null, null, "5912345", null, null, [7]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, "90[1-9]\\d{4}", null, null, null, "9010123", null, null, [7]], "VU", 678, "00", null, null, null, null, null, null, null, [[null, "(\\d{3})(\\d{4})", "$1 $2", ["[579]"]]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "(?:3[03]|900\\d)\\d{3}", null, null, null, "30123"], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    WF: [
      null,
      [
        null,
        null,
        "(?:[45]0|68|72|8\\d)\\d{4}",
        null,
        null,
        null,
        null,
        null,
        null,
        [6]
      ],
      [null, null, "(?:50|68|72)\\d{4}", null, null, null, "501234"],
      [null, null, "(?:50|68|72|8[23])\\d{4}", null, null, null, "501234"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "WF",
      681,
      "00",
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [[null, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[4-8]"]]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, "[48]0\\d{4}", null, null, null, "401234"]
    ],
    WS: [
      null,
      [null, null, "(?:[2-6]|8\\d(?:\\d{4})?)\\d{4}|[78]\\d{6}", null, null, null, null, null, null, [5, 6, 7, 10]],
      [null, null, "(?:[2-5]\\d|6[1-9])\\d{3}", null, null, null, "22123", null, null, [5]],
      [null, null, "(?:7[25-7]|8(?:[3-7]|9\\d{3}))\\d{5}", null, null, null, "7212345", null, null, [7, 10]],
      [null, null, "800\\d{3}", null, null, null, "800123", null, null, [6]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "WS",
      685,
      "0",
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [[null, "(\\d{5})", "$1", ["[2-6]"]], [null, "(\\d{3})(\\d{3,7})", "$1 $2", ["8"]], [null, "(\\d{2})(\\d{5})", "$1 $2", ["7"]]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    XK: [null, [null, null, "(?:[23]\\d{2,3}|4\\d\\d|[89]00)\\d{5}", null, null, null, null, null, null, [8, 9]], [null, null, "(?:2[89]|39)0\\d{6}|[23][89]\\d{6}", null, null, null, "28012345"], [null, null, "4[3-79]\\d{6}", null, null, null, "43201234", null, null, [8]], [null, null, "800\\d{5}", null, null, null, "80001234", null, null, [8]], [
      null,
      null,
      "900\\d{5}",
      null,
      null,
      null,
      "90001234",
      null,
      null,
      [8]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "XK", 383, "00", "0", null, null, "0", null, null, null, [[null, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], [null, "(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], [null, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[23]"], "0$1"]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    YE: [null, [null, null, "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", null, null, null, null, null, null, [7, 8, 9], [6]], [null, null, "17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-68])\\d{5}", null, null, null, "1234567", null, null, [7, 8], [6]], [null, null, "7[0137]\\d{7}", null, null, null, "712345678", null, null, [9]], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "YE", 967, "00", "0", null, null, "0", null, null, null, [[null, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7[24-68]"], "0$1"], [null, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    YT: [null, [null, null, "(?:(?:26|63)9|80\\d)\\d{6}", null, null, null, null, null, null, [9]], [null, null, "269(?:0[67]|5[01]|6\\d|[78]0)\\d{4}", null, null, null, "269601234"], [null, null, "639(?:0[0-79]|1[019]|[267]\\d|3[09]|[45]0|9[04-79])\\d{4}", null, null, null, "639012345"], [null, null, "80\\d{7}", null, null, null, "801234567"], [null, null, null, null, null, null, null, null, null, [-1]], [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [-1]
    ], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], "YT", 262, "00", "0", null, null, "0", null, null, null, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, "269|63", [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]],
    ZA: [
      null,
      [null, null, "[1-9]\\d{8}|8\\d{4,7}", null, null, null, null, null, null, [5, 6, 7, 8, 9]],
      [
        null,
        null,
        "(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}",
        null,
        null,
        null,
        "101234567",
        null,
        null,
        [9]
      ],
      [null, null, "(?:6\\d|7[0-46-9]|8[1-5])\\d{7}|8[1-4]\\d{3,6}", null, null, null, "711234567"],
      [null, null, "80\\d{7}", null, null, null, "801234567", null, null, [9]],
      [null, null, "(?:86[2-9]|9[0-2]\\d)\\d{6}", null, null, null, "862345678", null, null, [9]],
      [null, null, "860\\d{6}", null, null, null, "860123456", null, null, [9]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "87\\d{7}", null, null, null, "871234567", null, null, [9]],
      "ZA",
      27,
      "00",
      "0",
      null,
      null,
      "0",
      null,
      null,
      null,
      [[null, "(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], [null, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], [null, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], [null, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "861\\d{6}", null, null, null, "861123456", null, null, [9]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    ZM: [
      null,
      [
        null,
        null,
        "(?:(?:21|76|9\\d)\\d|800)\\d{6}",
        null,
        null,
        null,
        null,
        null,
        null,
        [9],
        [6]
      ],
      [null, null, "21[1-8]\\d{6}", null, null, null, "211234567", null, null, null, [6]],
      [null, null, "(?:76|9[5-8])\\d{7}", null, null, null, "955123456"],
      [null, null, "800\\d{6}", null, null, null, "800123456"],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      "ZM",
      260,
      "00",
      "0",
      null,
      null,
      "0",
      null,
      null,
      null,
      [[null, "(\\d{3})(\\d{3})", "$1 $2"], [null, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], [null, "(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]],
      [[null, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], [null, "(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ],
    ZW: [
      null,
      [null, null, "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", null, null, null, null, null, null, [5, 6, 7, 8, 9, 10], [3, 4]],
      [
        null,
        null,
        "(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|(?:4\\d\\d|9[2-9])\\d\\d?|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}",
        null,
        null,
        null,
        "1312345",
        null,
        null,
        null,
        [3, 4]
      ],
      [null, null, "(?:7(?:1\\d|3[2-9]|7[1-9]|8[2-5])|8644)\\d{6}", null, null, null, "712345678", null, null, [9, 10]],
      [null, null, "80(?:[01]\\d|20|8[0-8])\\d{3}", null, null, null, "8001234", null, null, [7]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, null, null, null, null, null, null, null, [-1]],
      [null, null, "86(?:1[12]|30|55|77|8[368])\\d{6}", null, null, null, "8686123456", null, null, [10]],
      "ZW",
      263,
      "00",
      "0",
      null,
      null,
      "0",
      null,
      null,
      null,
      [[null, "(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], [null, "(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8|[78])|3(?:[09]8|17|3[78]|[78])|5[15][78]|6(?:[29]8|37|[68][78]|75)"], "0$1"], [null, "(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], [null, "(\\d{2})(\\d{7})", "$1 $2", ["2(?:[05-79]2|4)|(?:39|5[45]|6[15-8])2|8[13-59]", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], [null, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], [
        null,
        "(\\d{3})(\\d{3})(\\d{3,4})",
        "$1 $2 $3",
        ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"],
        "0$1"
      ], [null, "(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], [null, "(\\d{2})(\\d{3,5})", "$1 $2", ["[16]|2(?:[0-256]|9[0-79])|3(?:[09][0-79]|1[0-689]|[24-6]|3[0-69])|5[0-35-9]"], "0$1"], [null, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29|3|54"], "0$1"], [null, "(\\d{4})(\\d{3,5})", "$1 $2", ["[25]"], "0$1"]],
      null,
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        [-1]
      ],
      [null, null, null, null, null, null, null, null, null, [-1]],
      null,
      null,
      [null, null, null, null, null, null, null, null, null, [-1]]
    ]
  };
  function Jl() {
    this.a = {};
  }
  Jl.b = function() {
    return Jl.a ? Jl.a : Jl.a = new Jl();
  };
  var rn = { 0: "0", 1: "1", 2: "2", 3: "3", 4: "4", 5: "5", 6: "6", 7: "7", 8: "8", 9: "9", "０": "0", "１": "1", "２": "2", "３": "3", "４": "4", "５": "5", "６": "6", "７": "7", "８": "8", "９": "9", "٠": "0", "١": "1", "٢": "2", "٣": "3", "٤": "4", "٥": "5", "٦": "6", "٧": "7", "٨": "8", "٩": "9", "۰": "0", "۱": "1", "۲": "2", "۳": "3", "۴": "4", "۵": "5", "۶": "6", "۷": "7", "۸": "8", "۹": "9" }, vn = RegExp("[+＋]+"), en = RegExp("([0-9０-９٠-٩۰-۹])"), kn = /^\(?\$1\)?$/;
  function re(C) {
    return C.length == 0 || kn.test(C);
  }
  function Mn(C, N) {
    if (N == null)
      return null;
    N = N.toUpperCase();
    var D = C.a[N];
    if (D == null) {
      if (D = sn[N], D == null)
        return null;
      D = new zl().a(al.j(), D), C.a[N] = D;
    }
    return D;
  }
  function oe(C) {
    return C = Xl[C], C == null ? "ZZ" : C[0];
  }
  function yn(C) {
    this.H = RegExp(" "), this.C = "", this.m = new t(), this.w = "", this.i = new t(), this.u = new t(), this.l = !0, this.A = this.o = this.F = !1, this.G = Jl.b(), this.s = 0, this.b = new t(), this.B = !1, this.h = "", this.a = new t(), this.f = [], this.D = C, this.J = this.g = de(this, this.D);
  }
  var ae = new al();
  H(ae, 11, "NA");
  var $t = /\[([^\[\]])*\]/g, Ve = /\d(?=[^,}][^,}])/g, bt = RegExp("^[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～]*(\\$\\d[-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～]*)+$"), je = /[- ]/;
  function de(C, N) {
    var D;
    if (N != null && isNaN(N) && N.toUpperCase() in sn) {
      if (D = Mn(C.G, N), D == null)
        throw Error("Invalid region code: " + N);
      D = T(D, 10);
    } else
      D = 0;
    return D = Mn(C.G, oe(D)), D ?? ae;
  }
  function ke(C) {
    for (var N = C.f.length, D = 0; D < N; ++D) {
      var W = C.f[D], yl = T(W, 1);
      if (C.w == yl)
        return !1;
      var E;
      E = C;
      var G = W, il = T(G, 1);
      if (il.indexOf("|") != -1)
        E = !1;
      else {
        il = il.replace($t, "\\d"), il = il.replace(Ve, "\\d"), u(E.m);
        var wl;
        wl = E;
        var G = T(G, 2), Tl = "999999999999999".match(il)[0];
        Tl.length < wl.a.b.length ? wl = "" : (wl = Tl.replace(new RegExp(il, "g"), G), wl = wl.replace(RegExp("9", "g"), " ")), 0 < wl.length ? (E.m.a(wl), E = !0) : E = !1;
      }
      if (E)
        return C.w = yl, C.B = je.test(k(W, 4)), C.s = 0, !0;
    }
    return C.l = !1;
  }
  function Ue(C, N) {
    for (var D = [], W = N.length - 3, yl = C.f.length, E = 0; E < yl; ++E) {
      var G = C.f[E];
      M(G, 3) == 0 ? D.push(C.f[E]) : (G = k(G, 3, Math.min(W, M(G, 3) - 1)), N.search(G) == 0 && D.push(C.f[E]));
    }
    C.f = D;
  }
  yn.prototype.K = function() {
    this.C = "", u(this.i), u(this.u), u(this.m), this.s = 0, this.w = "", u(this.b), this.h = "", u(this.a), this.l = !0, this.A = this.o = this.F = !1, this.f = [], this.B = !1, this.g != this.J && (this.g = de(this, this.D));
  }, yn.prototype.L = function(C) {
    return this.C = wt(this, C);
  };
  function wt(C, N) {
    C.i.a(N);
    var D = N;
    if (en.test(D) || C.i.b.length == 1 && vn.test(D)) {
      var D = N, W;
      D == "+" ? (W = D, C.u.a(D)) : (W = rn[D], C.u.a(W), C.a.a(W)), N = W;
    } else
      C.l = !1, C.F = !0;
    if (!C.l) {
      if (!C.F) {
        if (Ge(C)) {
          if (Ke(C))
            return Pn(C);
        } else if (0 < C.h.length && (D = C.a.toString(), u(C.a), C.a.a(C.h), C.a.a(D), D = C.b.toString(), W = D.lastIndexOf(C.h), u(C.b), C.b.a(D.substring(0, W))), C.h != We(C))
          return C.b.a(" "), Pn(C);
      }
      return C.i.toString();
    }
    switch (C.u.b.length) {
      case 0:
      case 1:
      case 2:
        return C.i.toString();
      case 3:
        if (Ge(C))
          C.A = !0;
        else
          return C.h = We(C), Kn(C);
      default:
        return C.A ? (Ke(C) && (C.A = !1), C.b.toString() + C.a.toString()) : 0 < C.f.length ? (D = Ye(C, N), W = Gn(C), 0 < W.length ? W : (Ue(C, C.a.toString()), ke(C) ? Me(C) : C.l ? le(C, D) : C.i.toString())) : Kn(C);
    }
  }
  function Pn(C) {
    return C.l = !0, C.A = !1, C.f = [], C.s = 0, u(C.m), C.w = "", Kn(C);
  }
  function Gn(C) {
    for (var N = C.a.toString(), D = C.f.length, W = 0; W < D; ++W) {
      var yl = C.f[W], E = T(yl, 1);
      if (new RegExp("^(?:" + E + ")$").test(N))
        return C.B = je.test(k(yl, 4)), N = N.replace(new RegExp(E, "g"), k(yl, 2)), le(C, N);
    }
    return "";
  }
  function le(C, N) {
    var D = C.b.b.length;
    return C.B && 0 < D && C.b.toString().charAt(D - 1) != " " ? C.b + " " + N : C.b + N;
  }
  function Kn(C) {
    var N = C.a.toString();
    if (3 <= N.length) {
      for (var D = C.o && C.h.length == 0 && 0 < M(C.g, 20) ? b(C.g, 20) || [] : b(C.g, 19) || [], W = D.length, yl = 0; yl < W; ++yl) {
        var E = D[yl];
        0 < C.h.length && re(T(E, 4)) && !k(E, 6) && E.a[5] == null || (C.h.length != 0 || C.o || re(T(E, 4)) || k(E, 6)) && bt.test(T(E, 2)) && C.f.push(E);
      }
      return Ue(C, N), N = Gn(C), 0 < N.length ? N : ke(C) ? Me(C) : C.i.toString();
    }
    return le(C, N);
  }
  function Me(C) {
    var N = C.a.toString(), D = N.length;
    if (0 < D) {
      for (var W = "", yl = 0; yl < D; yl++)
        W = Ye(C, N.charAt(yl));
      return C.l ? le(C, W) : C.i.toString();
    }
    return C.b.toString();
  }
  function We(C) {
    var N = C.a.toString(), D = 0, W;
    return k(C.g, 10) != 1 ? W = !1 : (W = C.a.toString(), W = W.charAt(0) == "1" && W.charAt(1) != "0" && W.charAt(1) != "1"), W ? (D = 1, C.b.a("1").a(" "), C.o = !0) : C.g.a[15] != null && (W = new RegExp("^(?:" + k(C.g, 15) + ")"), W = N.match(W), W != null && W[0] != null && 0 < W[0].length && (C.o = !0, D = W[0].length, C.b.a(N.substring(0, D)))), u(C.a), C.a.a(N.substring(D)), N.substring(0, D);
  }
  function Ge(C) {
    var N = C.u.toString(), D = new RegExp("^(?:\\+|" + k(C.g, 11) + ")"), D = N.match(D);
    return D != null && D[0] != null && 0 < D[0].length ? (C.o = !0, D = D[0].length, u(C.a), C.a.a(N.substring(D)), u(C.b), C.b.a(N.substring(0, D)), N.charAt(0) != "+" && C.b.a(" "), !0) : !1;
  }
  function Ke(C) {
    if (C.a.b.length == 0)
      return !1;
    var N = new t(), D;
    l: {
      if (D = C.a.toString(), D.length != 0 && D.charAt(0) != "0") {
        for (var W, yl = D.length, E = 1; 3 >= E && E <= yl; ++E)
          if (W = parseInt(D.substring(0, E), 10), W in Xl) {
            N.a(D.substring(E)), D = W;
            break l;
          }
      }
      D = 0;
    }
    return D == 0 ? !1 : (u(C.a), C.a.a(N.toString()), N = oe(D), N == "001" ? C.g = Mn(C.G, "" + D) : N != C.D && (C.g = de(C, N)), C.b.a("" + D).a(" "), C.h = "", !0);
  }
  function Ye(C, N) {
    var D = C.m.toString();
    if (0 <= D.substring(C.s).search(C.H)) {
      var W = D.search(C.H), D = D.replace(C.H, N);
      return u(C.m), C.m.a(D), C.s = W, D.substring(0, C.s + 1);
    }
    return C.f.length == 1 && (C.l = !1), C.w = "", C.i.toString();
  }
  l("Cleave.AsYouTypeFormatter", yn), l("Cleave.AsYouTypeFormatter.prototype.inputDigit", yn.prototype.L), l("Cleave.AsYouTypeFormatter.prototype.clear", yn.prototype.K);
}).call(typeof mr == "object" && mr ? mr : window);
class kp extends Gl {
  constructor(n, t) {
    super(n, t);
    S(this, "_country", J());
    S(this, "_input", J());
    S(this, "countryList", Fi().countries);
    S(this, "state", fl({
      ...this.sharedState,
      country: Fi().getCountryByCode(this.lang.ORION_PHONE__DEFAULT_COUNTRY_CODE),
      phoneNumber: ""
    }));
    this.emit = t, Pl(() => {
      var u;
      return (u = this.vModel) == null ? void 0 : u.phoneNumber;
    }, (u) => {
      u && (this.state.phoneNumber = this.sanitizePhoneNumber());
    }), Pl(() => {
      var u;
      return (u = this.vModel) == null ? void 0 : u.phoneCountryCode;
    }, (u) => {
      var i;
      u && u !== ((i = this.state.country) == null ? void 0 : i.code) && (this.state.country = Fi().getCountryByCode(u));
    }), Pl(() => this.state.hasBeenFocus, (u) => {
      this._input.value && this._input.value.setHasBeenFocus(u);
    });
  }
  get isFrPhone() {
    var n;
    return ((n = this.vModel) == null ? void 0 : n.phoneCountryCode) === "FR" || this.props.phoneCountryCode === "FR";
  }
  get hasValue() {
    return !In(this.vModel) && !Fc(this.phoneNumberWithoutIndicatif) && !In(this.state.phoneNumber);
  }
  get country() {
    return this.state.country;
  }
  set country(n) {
    this.state.country = n, this.emit("update:phoneCountryCode", n == null ? void 0 : n.code), this.setVModel();
  }
  get phoneNumber() {
    return this.state.phoneNumber;
  }
  set phoneNumber(n) {
    this.state.phoneNumber = this.sanitizePhoneNumber(n), this.emit("update:phoneNumber", this.state.phoneNumber), this.setVModel();
  }
  get vModel() {
    return this.props.modelValue;
  }
  set vModel(n) {
    this.emit("update:modelValue", n), this.emit("input", n);
  }
  get cleaveOptions() {
    var n, t;
    return {
      phone: !0,
      phoneRegionCode: (n = this.state.country) == null ? void 0 : n.code,
      prefix: `+${((t = this.state.country) == null ? void 0 : t.areaCode) ?? "33"} `
    };
  }
  get phoneNumberWithoutIndicatif() {
    var n;
    return this.state.phoneNumber ? this.state.phoneNumber.replace("+" + ((n = this.state.country) == null ? void 0 : n.areaCode), "") : null;
  }
  get showWarning() {
    return this.isFrPhone && this.hasValue && !this.isValid.value && this.isFocus;
  }
  get isValidCustom() {
    return Ut().check(this.vModel, this.props.mobile ? "phone:mobile" : "phone");
  }
  get showState() {
    const n = this.props.validation;
    return this.props.inheritValidationState !== void 0 ? this.props.inheritValidationState : this.state.hasBeenFocus ? !!n || !!this.hasValue : (n == null ? void 0 : n.showStatus) ?? !1;
  }
  async onBeforeMount() {
    In(this.vModel) ? (this.state.phoneNumber = "", this.state.country = Fi().getCountryByCode(this.lang.ORION_PHONE__DEFAULT_COUNTRY_CODE)) : (this.vModel && (Fc(this.vModel.phoneCountryCode) || In(this.vModel.phoneCountryCode)) && (this.vModel.phoneCountryCode = this.lang.ORION_PHONE__DEFAULT_COUNTRY_CODE, this.vModel.phoneNumber = ""), this.vModel.phoneCountryCode && (this.state.phoneNumber = this.sanitizePhoneNumber(), this.state.country = Fi().getCountryByCode(this.vModel.phoneCountryCode)));
  }
  keydownGuard(n) {
    this.isFrPhone && this.state.phoneNumber === "+33" && n.key === "0" && n.preventDefault();
  }
  customSearch(n, t) {
    return `${n.name} +${n.areaCode}`.toLowerCase().indexOf(t.toLowerCase()) !== -1;
  }
  sanitizePhoneNumber(n) {
    var u;
    const t = n ?? ((u = this.vModel) == null ? void 0 : u.phoneNumber);
    return this.isFrPhone && t ? t.replace(/^(0|\+330)(\d+)/, "+33$2") : t ?? "";
  }
  setVModel() {
    var u, i;
    let n = this.state.phoneNumber, t = (u = this.state.country) == null ? void 0 : u.code;
    n === `+${(i = this.state.country) == null ? void 0 : i.areaCode}` && (n = this.props.clearToNull ? null : void 0, t = this.props.clearToNull ? null : void 0), this.vModel = {
      phoneNumber: n,
      phoneCountryCode: t
    };
  }
}
S(kp, "props", {
  ...Gl.props,
  // @doc props/mobile defines if the number is a mobile phone
  // @doc/fr props/mobile définit si le numéro correspond à un portable
  mobile: Boolean,
  // @doc props/type the type of the input
  // @doc/fr props/type type du champ
  type: {
    type: String,
    default: "tel"
  },
  // @doc props/phoneNumber the phoneNumber string, isolated from its parent object
  // @doc/fr props/phoneNumber le numéro de téléphone, isolé de son objet parent
  phoneNumber: {
    type: String,
    default: void 0
  },
  // @doc props/phoneCountryCode the country code string, isolated from its parent object
  // @doc/fr props/phoneCountryCode le code pays, isolé de son objet parent
  phoneCountryCode: {
    type: String,
    default: void 0
  }
});
const JL = {
  class: "orion-phone"
}, ZL = {
  class: "orion-input-group orion-input-group--phone"
}, XL = ["innerHTML"], QL = /* @__PURE__ */ K({
  __name: "OrionPhone",
  props: kp.props,
  emits: ["focus", "blur", "input", "change", "update:modelValue", "update:phoneNumber", "update:phoneCountryCode", "clear"],
  setup(e, {
    expose: l,
    emit: n
  }) {
    const t = n, u = e, i = new kp(u, t);
    return l(i.publicInstance), (s, r) => {
      var o;
      return y(), O("div", JL, [A("div", ZL, [R(c(Ly), {
        ref: c(i)._country,
        modelValue: c(i).country,
        "onUpdate:modelValue": r[0] || (r[0] = (a) => c(i).country = a),
        class: "orion-telephone--indicatif",
        "track-key": "code",
        "display-key": "areaCode",
        searchable: "",
        disabled: c(i).props.disabled,
        options: c(i).countryList,
        "custom-search": c(i).customSearch.bind(c(i)),
        onInputKeydownTab: r[1] || (r[1] = (a) => {
          var d;
          return (d = c(i)._input.value) == null ? void 0 : d.focus();
        })
      }, {
        value: U(({
          item: a
        }) => [$l(B(a != null ? a.code : ""), 1)]),
        option: U(({
          item: a
        }) => [$l(B(`${a.name} (+${a.areaCode})`), 1)]),
        _: 1
      }, 8, ["modelValue", "disabled", "options", "custom-search"]), R(c(Di), ml({
        ref: c(i)._input,
        modelValue: c(i).phoneNumber,
        "onUpdate:modelValue": r[2] || (r[2] = (a) => c(i).phoneNumber = a),
        type: "tel",
        cleave: c(i).cleaveOptions,
        class: {
          "orion-input--warning": c(i).showWarning
        },
        validation: c(i).isValid.value,
        "inherit-validation-state": c(i).showState
      }, {
        ...s.$attrs,
        label: c(i).props.label,
        disabled: c(i).props.disabled,
        clearable: c(i).props.clearable,
        required: c(i).isRequired
      }, {
        "force-label-floating": "",
        onKeydown: r[3] || (r[3] = (a) => c(i).keydownGuard(a)),
        onFocus: r[4] || (r[4] = (a) => c(i).handleFocus(a)),
        onBlur: r[5] || (r[5] = (a) => c(i).handleBlur(a))
      }), null, 16, ["modelValue", "cleave", "class", "validation", "inherit-validation-state"])]), c(i).showState && (c(i).showError || c(i).showWarning) && ((o = c(i).validationHtmlMessages) != null && o.length) ? (y(), O("div", {
        key: 0,
        class: "orion-input__error-message",
        innerHTML: c(i).validationHtmlMessages
      }, null, 8, XL)) : I("", !0)]);
    };
  }
}), oc = {
  install(e, l = "o") {
    e.component(`${tl(l)}Phone`, QL);
  }
};
class Mp extends gl {
  constructor(n, t) {
    super(n);
    S(this, "_popper", J());
    S(this, "_actions", J());
    S(this, "state", fl({
      isVisible: !1
    }));
    this.emit = t;
  }
  get title() {
    return this.props.title ?? this.lang.ORION_POP_CONFIRM__TITLE;
  }
  confirm() {
    this.state.isVisible && (this.emit("confirm"), this.close());
  }
  cancel(n) {
    this.state.isVisible && (this.emit("cancel"), n || this.close());
  }
  close() {
    var n;
    this.state.isVisible = !1, (n = this._popper.value) == null || n.hide();
  }
  handlePopoverShow() {
    this.state.isVisible = !0, setTimeout(() => {
      var n;
      (n = this._actions.value) != null && n.children && Array.from(this._actions.value.children).forEach((t) => {
        t.attributes.getNamedItem("autofocus") && t.focus();
      });
    }, 100);
  }
}
S(Mp, "props", {
  // @doc props/title title of the confirm popup
  // @doc/fr props/title titre de la popup de confirmation
  // @doc props/title/default depends on the selected language
  title: {
    type: String,
    default: void 0
  }
});
const lP = {
  class: "orion-pop-confirm__title"
}, nP = /* @__PURE__ */ K({
  __name: "OrionPopConfirm",
  props: Mp.props,
  emits: ["confirm", "cancel"],
  setup(e, {
    expose: l,
    emit: n
  }) {
    const t = n, u = e, i = new Mp(u, t);
    return l(i.publicInstance), (s, r) => {
      const o = Bl("v-dropdown");
      return y(), L(o, {
        ref: c(i)._popper,
        placement: "top",
        triggers: ["click"],
        theme: "orion-pop-confirm",
        onShow: r[3] || (r[3] = (a) => c(i).handlePopoverShow())
      }, {
        popper: U(() => [A("p", lP, [V(s.$slots, "content", {}, () => [R(c(Ml), {
          icon: "warning"
        }), $l(" " + B(c(i).title), 1)])]), A("div", {
          ref: c(i)._actions,
          class: "orion-pop-confirm__actions",
          onKeyup: r[2] || (r[2] = Fn((a) => c(i).cancel(), ["esc"]))
        }, [V(s.$slots, "actions", Rl(jl({
          close: c(i).close.bind(c(i)),
          confirm: c(i).confirm.bind(c(i)),
          cancel: c(i).cancel.bind(c(i))
        })), () => [R(c(bl), {
          color: "danger",
          outline: "",
          size: "xs",
          onClick: r[0] || (r[0] = (a) => c(i).cancel())
        }, {
          default: U(() => [$l(B(c(i).lang.CANCEL), 1)]),
          _: 1
        }), R(c(bl), {
          color: "success",
          autofocus: "",
          size: "xs",
          onClick: r[1] || (r[1] = (a) => c(i).confirm())
        }, {
          default: U(() => [$l(B(c(i).lang.CONFIRM), 1)]),
          _: 1
        })])], 544)]),
        default: U(() => [V(s.$slots, "default")]),
        _: 3
      }, 512);
    };
  }
}), ac = {
  install(e, l = "o") {
    e.component(`${tl(l)}PopConfirm`, nP);
  }
};
class Ap extends gl {
  constructor(l) {
    super(l);
  }
}
S(Ap, "props", {
  ..._l.color("info"),
  // @doc props/label label of the progress bar
  // @doc/fr props/label label de la barre de progression
  label: {
    type: String,
    default: void 0
  },
  // @doc props/width width of the progress bar
  // @doc/fr props/width épaisseur de la barre de progression
  width: {
    type: Number,
    default: 10
  },
  // @doc props/value value of the progress bar
  // @doc/fr props/value valeur de la barre de progression
  value: {
    type: Number,
    default: 0
  }
});
const eP = {
  class: "orion-progress-bar__label"
}, tP = /* @__PURE__ */ K({
  __name: "OrionProgressBar",
  props: Ap.props,
  setup(e, {
    expose: l
  }) {
    const n = e, t = new Ap(n);
    return l(t.publicInstance), (u, i) => (y(), O("div", {
      class: z(["orion-progress-bar", `orion-progress-bar--${c(t).props.color}`])
    }, [A("div", {
      class: "orion-progress-bar__path",
      style: Wl({
        height: `calc(${c(t).props.width}rem / 16)`,
        borderRadius: `calc(${c(t).props.width}rem / 16)`
      })
    }, [A("div", {
      class: "orion-progress-bar__value",
      style: Wl({
        width: c(t).props.value + "%",
        borderRadius: `calc(${c(t).props.width}rem / 16)`
      })
    }, [A("span", eP, [V(u.$slots, "default", {}, () => [$l(B(c(t).props.label), 1)])])], 4)], 4)], 2));
  }
}), dc = {
  install(e, l = "o") {
    e.component(`${tl(l)}ProgressBar`, tP);
  }
};
class xp extends gl {
  get coord() {
    return this.props.size / 2;
  }
  get radius() {
    return this.props.size / 2 - this.props.valueWidth;
  }
  get perimeter() {
    return this.radius * 2 * Math.PI;
  }
  get progress() {
    return this.perimeter - this.perimeter * this.props.value / 100;
  }
  constructor(l) {
    super(l);
  }
}
S(xp, "props", {
  ..._l.color("info"),
  // @doc props/label the label
  // @doc/fr props/label label du cercle
  label: {
    type: String,
    default: void 0
  },
  // @doc props/size size of the progress circle
  // @doc/fr props/size taille du cercle
  size: {
    type: Number,
    default: 50
  },
  // @doc props/value value of the progress circle
  // @doc/fr props/value valeur du cercle
  value: {
    type: Number,
    default: 0
  },
  // @doc props/pathWidth width of the path line
  // @doc/fr props/pathWidth épaisseur du cercle
  pathWidth: {
    type: Number,
    default: 2
  },
  // @doc props/valueWidth width of the value line
  // @doc/fr props/valueWidth épaisseur de la ligne qui représente la progression
  valueWidth: {
    type: Number,
    default: 4
  }
});
const uP = ["viewBox"], iP = ["cx", "cy", "r", "stroke-width"], sP = ["viewBox"], rP = ["cx", "cy", "r", "stroke-width", "stroke-dashoffset", "stroke-dasharray"], oP = {
  class: "orion-progress-circle__label"
}, aP = /* @__PURE__ */ K({
  __name: "OrionProgressCircle",
  props: xp.props,
  setup(e, {
    expose: l
  }) {
    const n = e, t = new xp(n);
    return l(t.publicInstance), (u, i) => (y(), O("div", {
      class: z(["orion-progress-circle", `orion-progress-circle--${u.color}`]),
      style: Wl({
        flex: `0 0 calc(${u.size}rem / 16)`,
        width: `calc(${u.size}rem / 16)`,
        height: `calc(${u.size}rem / 16)`,
        fontSize: `calc(${u.size}rem / 16)`
      })
    }, [(y(), O("svg", {
      class: "orion-progress-circle__path",
      viewBox: `0 0 ${u.size} ${u.size}`
    }, [A("circle", {
      cx: c(t).coord,
      cy: c(t).coord,
      r: c(t).radius,
      "stroke-width": u.pathWidth
    }, null, 8, iP)], 8, uP)), (y(), O("svg", {
      class: "orion-progress-circle__value",
      viewBox: `0 0 ${u.size} ${u.size}`
    }, [A("circle", {
      cx: c(t).coord,
      cy: c(t).coord,
      r: c(t).radius,
      "stroke-width": u.valueWidth,
      "stroke-dashoffset": c(t).progress,
      "stroke-dasharray": `${c(t).perimeter} ${c(t).perimeter}`
    }, null, 8, rP)], 8, sP)), A("span", oP, [V(u.$slots, "default", {}, () => [$l(B(u.label), 1)])])], 6));
  }
}), cc = {
  install(e, l = "o") {
    e.component(`${tl(l)}ProgressCircle`, aP);
  }
};
class Ep extends Gl {
  constructor(n, t) {
    super(n, t);
    S(this, "inputType", "radio");
  }
  get isValidCustom() {
    return this.props.required ? this.props.modelValue === this.props.inputValue : !0;
  }
  get isChecked() {
    return this.vModel === this.props.inputValue;
  }
  handleClick() {
    !this.props.disabled && !this.props.readonly && (this.state.hasBeenFocus = !0, this.vModel = this.props.inputValue, this.emit("input", this.props.inputValue));
  }
}
S(Ep, "props", {
  ...Gl.props,
  ..._l.color(),
  // @doc props/inline set the property `display` on `inline-flex` instead of `flex`
  // @doc/fr props/inline défini la propriété `display` à `inline-flex` à la place `flex`
  inline: Boolean,
  // @doc props/reverse displays the label first
  // @doc/fr props/reverse affiche en premier le label
  reverse: Boolean,
  // @doc props/inputValue value of the radio button
  // @doc/fr props/inputValue valeur du bouton radio
  inputValue: {
    type: [Array, Boolean, Number, Object, String],
    default: void 0
  },
  // @doc props/iconCheck the icon when the radio button is checked
  // @doc/fr props/iconCheck l'icône lorsque le bouton est coché
  iconCheck: {
    type: String,
    default: void 0
  },
  // @doc props/type type of the input
  // @doc/fr props/type type du champ
  type: {
    type: String,
    default: "radio"
  }
});
const dP = ["value", "checked"], cP = {
  class: "orion-radio__check-container"
}, hP = {
  key: 1,
  class: "orion-radio__check-marker"
}, pP = /* @__PURE__ */ K({
  __name: "OrionRadio",
  props: Ep.props,
  emits: ["focus", "blur", "input", "change", "update:modelValue", "clear"],
  setup(e, {
    expose: l,
    emit: n
  }) {
    const t = n, u = e, i = new Ep(u, t);
    return l(i.publicInstance), (s, r) => (y(), L(c(Dt), ml(c(i).orionFieldBinding, {
      "label-is-floating": !1,
      class: [`orion-radio--${c(i).props.color}`, {
        "orion-radio--checked": c(i).isChecked
      }, {
        "orion-radio--reverse": c(i).props.reverse
      }, {
        "orion-radio--inline": c(i).props.inline
      }],
      "input-type": "radio",
      onClick: r[1] || (r[1] = (o) => c(i).handleClick())
    }), {
      default: U(() => [s.label === void 0 ? V(s.$slots, "default", {
        key: 0
      }) : I("", !0), A("input", ml({
        ref: c(i)._input,
        class: "orion-radio__input",
        type: "radio",
        value: c(i).props.inputValue,
        checked: c(i).isChecked
      }, {
        ...s.$attrs,
        disabled: c(i).props.disabled
      }), null, 16, dP), A("span", cP, [c(i).props.iconCheck ? (y(), L(c(Ml), {
        key: 0,
        icon: c(i).props.iconCheck,
        onClick: r[0] || (r[0] = (o) => c(i).handleClick())
      }, null, 8, ["icon"])) : (y(), O("span", hP))])]),
      _: 3
    }, 16, ["class"]));
  }
}), hc = {
  install(e, l = "o") {
    e.component(`${tl(l)}Radio`, pP);
  }
};
class Ip extends gl {
  constructor(n, t) {
    super(n);
    S(this, "rate", J(this.props.modelValue));
    this.emit = t, this._uid = this.getUid();
  }
  get value() {
    return this.props.modelValue;
  }
  get icon() {
    return this.props.icon;
  }
  get color() {
    return this.props.color;
  }
  get fontIcon() {
    return this.props.fontIcon;
  }
  get numberOfRates() {
    return this.props.numberOfRates;
  }
  get rateRounded() {
    if (this.rate.value !== void 0)
      return Math.round(this.rate.value);
  }
  set rateRounded(n) {
    this.rate.value = n;
  }
  emitUpdate(n) {
    this.emit("input", n), this.emit("update:modelValue", n);
  }
  starColor(n) {
    const t = [];
    return this.props.modelValue !== void 0 && ((n <= this.props.modelValue || n - this.props.modelValue < 0.25) && t.push(`text--${this.props.color}`), n > this.props.modelValue && n - this.props.modelValue < 0.75 && n - this.props.modelValue > 0.25 && t.push(`half--${this.props.color}`)), t;
  }
}
S(Ip, "props", {
  // @doc props/disabled If set, make the component read-only.
  // @doc/fr props/disabled si défini, le composant sera en lecture seule
  disabled: Boolean,
  // @doc props/modelValue Value of the component
  // @doc/fr props/modelValue valeur du composant
  modelValue: {
    type: Number,
    default: void 0
  },
  // @doc props/icon Icon of the component
  // @doc/fr props/icon icône du composant
  icon: {
    type: String,
    default: "circle_check"
  },
  // @doc props/fontIcon Icon of the component, from the imported font
  // @doc/fr props/fontIcon icône du composant, s'il s'agit d'une librairie de police importée
  fontIcon: {
    type: String,
    default: void 0
  },
  // @doc props/numberOfRates The total number of rates
  // @doc/fr props/numberOfRates nombre total de votes
  numberOfRates: {
    type: Number,
    default: null
  },
  // @doc props/color The color of filled icons
  // @doc/fr props/color couleur des icônes
  color: {
    type: String,
    default: "warning"
  }
});
const fP = {
  class: "orion-rate__wrapper"
}, mP = ["id", "value", "name", "onInput"], gP = ["for"], vP = {
  key: 0,
  class: "orion-rate__number"
}, yP = /* @__PURE__ */ K({
  __name: "OrionRate",
  props: Ip.props,
  emits: ["input", "update:modelValue"],
  setup(e, {
    expose: l,
    emit: n
  }) {
    const t = n, u = e, i = new Ip(u, t);
    return l(i.publicInstance), (s, r) => (y(), O("div", {
      class: z(["orion-rate", `orion-rate--${c(i).color}`, {
        "orion-rate--disabled": s.disabled
      }])
    }, [A("div", fP, [s.disabled ? (y(), O(hl, {
      key: 0
    }, Sl(5, (o) => R(c(Ml), {
      key: o,
      class: z(["orion-rate__star", c(i).starColor(o)]),
      icon: c(i).fontIcon ? void 0 : c(i).icon,
      "font-icon": c(i).fontIcon
    }, null, 8, ["class", "icon", "font-icon"])), 64)) : (y(), O(hl, {
      key: 1
    }, Sl(5, (o) => (y(), O(hl, {
      key: `rate-${c(i)._uid}-${o}`
    }, [vl(A("input", {
      id: `rate-${c(i)._uid}-${o}`,
      "onUpdate:modelValue": r[0] || (r[0] = (a) => c(i).rateRounded = a),
      value: 6 - o,
      name: `rate-${c(i)._uid}-${o}`,
      type: "radio",
      onInput: (a) => c(i).emitUpdate(6 - o)
    }, null, 40, mP), [[t5, c(i).rateRounded]]), A("label", {
      for: `rate-${c(i)._uid}-${o}`,
      class: "orion-rate__star"
    }, [R(c(Ml), {
      icon: c(i).fontIcon ? void 0 : c(i).icon,
      "font-icon": c(i).fontIcon
    }, null, 8, ["icon", "font-icon"])], 8, gP)], 64))), 64))]), c(i).numberOfRates || s.$slots.default ? (y(), O("span", vP, [V(s.$slots, "default", Rl(jl({
      rateNumber: c(i).numberOfRates
    })), () => [$l("(" + B(c(i).numberOfRates) + ")", 1)])])) : I("", !0)], 2));
  }
}), pc = {
  install(e, l = "o") {
    e.component(`${tl(l)}Rate`, yP);
  }
};
class Rp extends gl {
  constructor(l) {
    super(l);
  }
}
S(Rp, "props", {
  // @doc props/selected adds a selected style on the sticker
  // @doc/fr props/selected ajoute le style `selected` sur le sticker
  selected: Boolean,
  // @doc props/muted adds a disabled style
  // @doc/fr props/muted ajoute un style `disabled`
  muted: Boolean,
  // @doc props/hideActions hides the sticker's actions
  // @doc/fr props/hideActions masque les actions du sticker
  hideActions: Boolean,
  // @doc props/selectedColor the color of the selected style
  // @doc/fr props/selectedColor la couleur du style `selected`
  selectedColor: {
    type: String,
    default: "info"
  },
  // @doc props/title title of the sticker
  // @doc/fr props/title titre du sticker
  title: {
    type: String,
    default: void 0
  },
  // @doc props/hoverElevation elevation level on mouse hover
  // @doc/fr props/hoverElevation niveau d'élévation au survol de la souris
  hoverElevation: {
    type: Number,
    default: 1
  }
});
const $P = {
  key: 0,
  class: "orion-sticker__thumbnail"
}, bP = {
  class: "orion-sticker__content"
}, wP = {
  key: 0,
  class: "orion-sticker__title"
}, _P = {
  key: 1,
  class: "orion-sticker__actions"
}, SP = /* @__PURE__ */ Ps('<div class="orion-sticker__selected"><svg class="marker" viewBox="0 0 90 90"><circle cx="105" cy="105" r="45"></circle></svg><svg class="check" viewBox="0 0 12 12"><polyline points="1.5 6 4.5 9 10.5 1"></polyline></svg></div>', 1), CP = /* @__PURE__ */ K({
  __name: "OrionSticker",
  props: Rp.props,
  setup(e, {
    expose: l
  }) {
    const n = e, t = new Rp(n);
    return l(t.publicInstance), (u, i) => (y(), O("div", {
      ref: c(t)._el,
      class: z(["orion-sticker", [`orion-sticker--selected-${c(t).props.selectedColor}`, {
        "orion-sticker--muted": c(t).props.muted
      }, {
        "orion-sticker--clickable": !!u.$attrs.onClick
      }, {
        "orion-sticker--selected": c(t).props.selected
      }, {
        "orion-sticker--no-elevation": u.hoverElevation <= 0
      }]]),
      style: Wl(`--hoverElevation: ${u.hoverElevation}`)
    }, [u.$slots.thumbnail ? (y(), O("div", $P, [V(u.$slots, "thumbnail")])) : I("", !0), A("div", bP, [c(t).props.title ? (y(), O("h4", wP, B(c(t).props.title), 1)) : I("", !0), V(u.$slots, "default")]), !c(t).props.hideActions && u.$slots.actions ? (y(), O("div", _P, [V(u.$slots, "actions")])) : I("", !0), SP], 6));
  }
}), fc = {
  install(e, l = "o") {
    e.component(`${tl(l)}Sticker`, CP);
  }
};
class Dp extends gl {
  constructor(n, t) {
    super(n);
    S(this, "_actions", J());
    S(this, "state", fl({
      offset: 0,
      offsetTriggerValue: 60,
      offsetOrigin: 0,
      actionsCount: 0,
      isTouch: !1,
      isSwiping: !1,
      touchStart: 0,
      touchStartY: 0,
      touchEnd: null,
      isClicked: !1
    }));
    this.slots = t;
  }
  get cssOffset() {
    let n = this.state.offset;
    return this.props.direction === "left" && !this.state.isSwiping && (n = -n), n + "px";
  }
  get actionsPosition() {
    return this.props.direction === "left" ? "right" : "left";
  }
  get isTouch() {
    return this.state.isTouch;
  }
  onMounted() {
    var n;
    (n = this.window) == null || n.addEventListener("touchstart", () => {
      this.state.isClicked || (this.state.offset = 0);
    }), this.setActionsCount();
  }
  onUpdated() {
    this.setActionsCount();
  }
  setActionsCount() {
    this.slots.actions && (this.state.actionsCount = this.slots.actions().length ?? 0, this.state.offset && !this.state.isSwiping && !this.state.isTouch && this.handleHover());
  }
  touchCallback() {
    this.state.isClicked = !0, setTimeout(() => {
      this.state.isClicked = !1;
    }, 50);
  }
  handleHover(n = !1) {
    var t;
    n ? this.state.offset = 0 : this.state.offset = ((t = this._actions.value) == null ? void 0 : t.getBoundingClientRect().width) ?? 0;
  }
  handleTouchStart(n) {
    this._actions.value && n !== null && (this.state.touchStart = n.touches[0].clientX, this.state.touchStartY = n.touches[0].clientY, this.state.offsetOrigin = this.props.direction === "right" ? this.state.offset : -this.state.offset);
  }
  handleTouchMove(n) {
    if (!this._actions.value)
      return;
    if (n.touches[0].clientY > this.state.touchStartY + 100 || n.touches[0].clientY < this.state.touchStartY - 100) {
      this.state.offset = 0;
      return;
    }
    this.state.isTouch = !0, this.state.isSwiping = !0;
    const t = this.state.offsetOrigin + n.touches[0].clientX - this.state.touchStart;
    this.props.direction === "right" && t < -this.state.offsetTriggerValue || this.props.direction === "right" && t > this._actions.value.getBoundingClientRect().width + 25 || this.props.direction === "left" && t > this.state.offsetTriggerValue || this.props.direction === "left" && t < -(this._actions.value.getBoundingClientRect().width + 25) || (this.state.offset = t);
  }
  handleTouchEnd() {
    this._actions.value && (this.state.isTouch = !1, this.state.offset = Math.abs(this.state.offset) > this.state.offsetTriggerValue && this.state.isSwiping || this.state.offset === 0 && !this.state.isSwiping ? this._actions.value.getBoundingClientRect().width : 0, this.state.isSwiping = !1);
  }
}
S(Dp, "props", {
  // @doc props/direction direction of the swipe animation
  // @doc/fr props/direction direction de l'animation du swipe
  direction: {
    type: String,
    default: "left",
    validator: (n) => ["left", "right"].includes(n)
  }
});
const TP = /* @__PURE__ */ K({
  __name: "OrionSwipe",
  props: Dp.props,
  setup(e, {
    expose: l
  }) {
    const n = Bs(), t = e, u = new Dp(t, n);
    return l(u.publicInstance), (i, s) => (y(), O("div", {
      class: "orion-swipe",
      onTouchstart: s[3] || (s[3] = (r) => c(u).touchCallback()),
      onMouseenter: s[4] || (s[4] = (r) => c(u).handleHover()),
      onMouseleave: s[5] || (s[5] = (r) => c(u).handleHover(!0))
    }, [i.$slots.actions ? (y(), O("div", {
      key: 0,
      ref: c(u)._actions,
      class: z(["orion-swipe__actions", `orion-swipe__actions--${c(u).actionsPosition}`])
    }, [V(i.$slots, "actions")], 2)) : I("", !0), A("div", {
      class: z(["orion-swipe__content", {
        "orion-swipe__content--swipe": c(u).isTouch
      }]),
      style: Wl(`transform: translate3d(${c(u).cssOffset}, 0, 0)`),
      onTouchstart: s[0] || (s[0] = (r) => c(u).handleTouchStart(r)),
      onTouchmove: s[1] || (s[1] = (r) => c(u).handleTouchMove(r)),
      onTouchend: s[2] || (s[2] = (r) => c(u).handleTouchEnd())
    }, [V(i.$slots, "default")], 38)], 32));
  }
}), mc = {
  install(e, l = "o") {
    e.component(`${tl(l)}Swipe`, TP);
  }
};
class Np extends gl {
  constructor(l) {
    super(l);
  }
}
S(Np, "props", {
  value: {
    type: String,
    default: void 0
  },
  panes: {
    type: Array,
    default: () => []
  },
  onTabClick: {
    type: Function,
    required: !0
  }
});
const Py = /* @__PURE__ */ K({
  __name: "OrionTabNav",
  props: Np.props,
  setup(e, {
    expose: l
  }) {
    const n = Tn("_tabs"), t = e, u = new Np(t);
    l(u.publicInstance);
    const i = () => {
      const s = u.props.panes.map((r) => {
        var m, g;
        const o = r.props.icon || r.props["font-icon"] ? R(Ml, {
          class: "orion-tab-nav__icon",
          icon: r.props.icon,
          fontIcon: r.props["font-icon"]
        }, null) : null, a = (m = r.children) != null && m.label ? (g = r.children) == null ? void 0 : g.label() : r.props.label, d = a ? R("span", {
          class: "orion-tab-nav__label"
        }, [a]) : null;
        let p = `orion-tab-nav__marker orion-tab-nav__marker--${r.props["marker-color"] ?? r.props.markerColor ?? "danger"}`;
        typeof r.props.marker == "number" && (p += " orion-tab-nav__marker--number");
        const f = tt(r.props.marker) ? R("span", {
          class: p
        }, [typeof r.props.marker == "number" ? r.props.marker : null]) : null;
        return R("div", {
          class: {
            "orion-tab-nav": !0,
            "orion-tab-nav--disabled": tt(r.props.disabled),
            "orion-tab-nav--active": u.props.value === r.props.name || (n == null ? void 0 : n.useRouter) && u.router.currentRoute.value.name === r.props.name
          },
          key: `orion-tab-${r.props.name}`,
          onClick: (v) => u.props.onTabClick(r.props, v)
        }, [R("div", {
          class: "orion-tab-nav__content"
        }, [[o, d, f]])]);
      });
      return R("div", {
        class: "orion-tab-nav-wrap"
      }, [s]);
    };
    return (s, r) => (y(), L(i));
  }
}), gc = {
  install(e, l = "o") {
    e.component(`${tl(l)}TabNav`, Py);
  }
};
class Lp extends gl {
  constructor(n, t) {
    super(n);
    S(this, "state", fl({
      hasBeenActive: !1
    }));
    this._tabs = t, Pl(() => this.active, (u) => {
      u ? this.state.hasBeenActive = u : this.props.lazy && (this.state.hasBeenActive = u);
    });
  }
  get shouldBeInDom() {
    return this.props.lazy || this.props.lazyOnce ? this.state.hasBeenActive : !0;
  }
  get active() {
    var n;
    return ((n = this._tabs) == null ? void 0 : n.getValue()) === this.props.name;
  }
  get publicInstance() {
    return {
      ...super.publicInstance,
      disabled: this.props.disabled,
      name: this.props.name
    };
  }
  onMounted() {
    var n;
    this.state.hasBeenActive = ((n = this._tabs) == null ? void 0 : n.getValue()) === this.props.name;
  }
}
S(Lp, "props", {
  ..._l.icon(),
  // @doc props/disabled disabled the pane
  // @doc/fr props/disabled désactive le panneau
  disabled: Boolean,
  // @doc props/lazy the content of the tab is mounted each time the tab becomes active
  // @doc/fr props/lazy le contenu de l'onglet est monté à chaque fois qu'il devient actif
  lazy: Boolean,
  // @doc props/lazyOnce the content of the tab is only mounted once, the first time the tab is active
  // @doc/fr props/lazyOnce le contenu de l'onglet est uniquement monté une fois, la première fois qu'il est actif
  lazyOnce: Boolean,
  // @doc props/name the name of the tab
  // @doc/fr props/name le nom de l'onglet
  name: {
    type: String,
    required: !0
  },
  // @doc props/label the label of the tab
  // @doc/fr props/label le label de l'onglet
  label: {
    type: String,
    default: void 0
  },
  // @doc props/marker adds a visual marker, can be used as a notification marker
  // @doc/fr props/marker ajoute un marqueur visuel, qui peut être utilisé comme marqueur de notification
  marker: {
    type: [Boolean, Number],
    default: void 0
  },
  // @doc props/markerColor the color of the marker
  // @doc/fr props/markerColor la couleur du marqueur
  markerColor: {
    type: String,
    default: "danger"
  }
});
const OP = {
  key: 0,
  class: "orion-tab-pane"
}, kP = {
  name: "OrionTabPane"
}, MP = /* @__PURE__ */ K({
  ...kP,
  props: Lp.props,
  setup(e, {
    expose: l
  }) {
    const n = Tn("_tabs"), t = e, u = new Lp(t, n);
    return l(u.publicInstance), (i, s) => c(u).shouldBeInDom ? vl((y(), O("div", OP, [V(i.$slots, "default")], 512)), [[cn, c(u).active]]) : I("", !0);
  }
}), vc = {
  install(e, l = "o") {
    e.component(`${tl(l)}TabPane`, MP);
  }
};
class Pp extends gl {
  constructor(n, t, u) {
    super(n);
    S(this, "_loader", J());
    S(this, "state", fl({
      panes: []
    }));
    this.slots = t, this.emit = u, Pl(() => this.content, () => this.calcPaneInstances());
  }
  get content() {
    var n, t;
    return (t = (n = this.slots).default) == null ? void 0 : t.call(n);
  }
  get panes() {
    return this.state.panes;
  }
  get publicInstance() {
    return {
      ...super.publicInstance,
      _loader: () => this._loader.value,
      panes: this.state.panes,
      getValue: () => this.props.modelValue,
      useRouter: this.props.useRouter
    };
  }
  onMounted() {
    this.calcPaneInstances();
  }
  onUpdated() {
    this.calcPaneInstances();
  }
  calcPaneInstances() {
    if (this.state.panes.length = 0, this.slots.default) {
      const n = this.slots.default().map((t) => typeof t.type == "symbol" && Il(t.children) ? t.children : t).flat().filter((t) => {
        let u = t.type;
        return u = u.name || u, u === "OrionTabPane";
      });
      this.state.panes.push(...n.map((t) => ({
        props: t.props,
        children: t.children
      })));
    }
  }
  onTabClick(n, t) {
    tt(n.disabled) || (this.props.useRouter && this.router.currentRoute.value.name !== n.name ? this.router.push({
      name: n.name
    }) : this.props.modelValue !== n.name && (this.emit("update:modelValue", n.name), this.emit("input", n.name)), this.emit("tab-click", n, t));
  }
}
S(Pp, "props", {
  // @doc props/useRouter connect the tabs to the router to bind active tab to current route and use `<router-view/>` component
  // @doc/fr props/useRouter connecte les tabs au router pour synchroniser la tab active avec la router actuelle et utiliser le composant `<router-view/>`
  useRouter: Boolean,
  // @doc props/routerViewName the name of the `<router-view/>` when using `use-router` prop
  // @doc/fr props/routerViewName le nom du `<router-view/>` lors de l'utilisation de la prop `use-router`
  routerViewName: {
    type: String,
    default: void 0
  },
  // @doc props/modelValue model value
  // @doc/fr props/modelValue modelValue du composant
  modelValue: {
    type: String,
    default: void 0
  },
  // @doc props/loader adds a loader on the tab
  // @doc/fr props/loader ajoute une icône de chargement sur l'onglet
  loader: {
    type: [String, Boolean],
    default: void 0
  }
});
const AP = /* @__PURE__ */ K({
  __name: "OrionTabs",
  props: Pp.props,
  emits: ["input", "tab-click", "update:modelValue"],
  setup(e, {
    expose: l,
    emit: n
  }) {
    const t = n, u = Bs(), i = e, s = new Pp(i, u, t);
    De("_tabs", s.publicInstance), l(s.publicInstance);
    const r = () => {
      const o = {
        value: s.props.modelValue,
        panes: s.panes,
        onTabClick: s.onTabClick.bind(s)
      }, a = R("div", {
        class: "orion-tabs__header"
      }, [R(Py, o, null)]), d = {
        ref: s._loader,
        message: typeof s.props.loader == "string" ? s.props.loader : void 0,
        visible: tt(s.props.loader),
        size: "sm"
      }, h = R("div", {
        class: "orion-tabs__content"
      }, [s.props.useRouter ? R(Gw, {
        name: s.props.routerViewName
      }, null) : u.default ? u.default() : null, R(te, d, null)]);
      return R("div", {
        class: "orion-tabs"
      }, [[a, h]]);
    };
    return (o, a) => (y(), L(r));
  }
}), yc = {
  install(e, l = "o") {
    e.component(`${tl(l)}Tabs`, AP);
  }
};
class Bp extends gl {
  constructor(l) {
    super(l);
  }
}
S(Bp, "props", {
  disabled: Boolean,
  scrollable: Boolean,
  value: {
    type: [String, Number],
    default: void 0
  },
  current: {
    type: [String, Number],
    default: void 0
  },
  panes: {
    type: Array,
    default: () => []
  },
  onPillClick: {
    type: Function,
    required: !0
  }
});
const By = /* @__PURE__ */ K({
  __name: "OrionTimelinePill",
  props: Bp.props,
  setup(e, {
    expose: l
  }) {
    const n = e, t = new Bp(n);
    l(t.publicInstance);
    const u = () => {
      const i = t.props.panes, s = !!i.filter((a) => {
        var d;
        return !!((d = a.children) != null && d.before);
      }).length, r = i.map((a, d) => {
        var _, b;
        const h = i.findIndex((k) => k.props.name === t.props.value), p = a.props.icon || a.props["font-icon"] ? R(Ml, {
          class: "orion-timeline-pill__icon",
          icon: a.props.icon,
          fontIcon: a.props["font-icon"]
        }, null) : null;
        let m = `orion-timeline-pill__marker orion-timeline-pill__marker--${a.props["marker-color"] ?? a.props.markerColor ?? "danger"}`;
        typeof a.props.marker == "number" && (m += " orion-timeline-pill__marker--number");
        const g = tt(a.props.marker) ? R("span", {
          class: m
        }, [typeof a.props.marker == "number" ? a.props.marker : null]) : null, v = (_ = a.children) != null && _.before ? R("div", {
          class: "orion-timeline-pill__before"
        }, [a.children.before()]) : s ? R("div", {
          class: "orion-timeline-pill__before"
        }, null) : null, w = (b = a.children) != null && b.after ? R("div", {
          class: "orion-timeline-pill__after"
        }, [a.children.after()]) : null, $ = t.props.value !== null && (t.props.current === a.props.name || tt(a.props.complete) || d <= h);
        return R("div", {
          class: "orion-timeline-pill-wrapper"
        }, [v, R("div", {
          class: "orion-timeline-pill"
        }, [R("div", {
          class: {
            "orion-timeline-pill__core": !0,
            "orion-timeline-pill__core--filled": d < h || tt(a.props.complete),
            "orion-timeline-pill__core--active": t.props.current === a.props.name,
            "orion-timeline-pill__core--disabled": tt(a.props.disabled),
            "orion-timeline-pill__core--clickable": $,
            "orion-timeline-pill__core--text": !!a.props.pill
          },
          key: `orion-timeline-${a.props.name}`,
          onClick: (k) => $ ? t.props.onPillClick(a.props, k) : null
        }, [p ?? R("span", {
          class: "orion-timeline-pill__core-text"
        }, [a.props.pill]), g]), R("div", {
          class: "orion-timeline-pill__separator"
        }, null)]), w]);
      }), o = () => [...document.querySelectorAll(".orion-timeline-pill-wrapper")];
      return t.props.scrollable ? R(Iy, {
        scrollStep: o
      }, {
        default: () => [R("div", {
          class: "orion-timeline__pills"
        }, [r])]
      }) : R("div", {
        class: "orion-timeline__pills"
      }, [r]);
    };
    return (i, s) => (y(), L(u));
  }
}), $c = {
  install(e, l = "o") {
    e.component(`${tl(l)}TimelinePill`, By);
  }
};
class Fp extends gl {
  constructor(n, t, u) {
    super(n);
    S(this, "_loader", J());
    S(this, "state", fl({
      current: this.props.modelValue,
      panes: []
    }));
    this.slots = t, this.emit = u, Pl(() => this.props.modelValue, (i) => {
      i && this.setOrigin(i);
    }), Pl(() => this.content, () => this.calcPaneInstances());
  }
  get content() {
    var n, t;
    return (t = (n = this.slots).default) == null ? void 0 : t.call(n);
  }
  get panes() {
    return this.state.panes;
  }
  get current() {
    return this.state.current;
  }
  get publicInstance() {
    return {
      ...super.publicInstance,
      _loader: () => this._loader.value,
      panes: this.state.panes,
      getValue: () => this.props.modelValue,
      getCurrent: () => this.state.current,
      setCurrent: this.setCurrent.bind(this)
    };
  }
  onMounted() {
    this.calcPaneInstances();
  }
  onUpdated() {
    this.calcPaneInstances();
  }
  calcPaneInstances() {
    if (this.state.panes.length = 0, this.slots.default) {
      const n = this.slots.default().map((t) => typeof t.type == "symbol" && Il(t.children) ? t.children : t).flat().filter((t) => {
        if (!t)
          return !1;
        let u = t.type;
        return u = u.name || u, u === "OrionTimelinePane";
      });
      this.state.panes.push(...n.map((t) => ({
        props: t.props,
        children: t.children
      })));
    }
  }
  onPillClick(n, t) {
    tt(n.disabled) || (this.setCurrent(n.name), this.emit("pill-click", n, t));
  }
  setCurrent(n) {
    this.state.current = n;
  }
  setOrigin(n) {
    this.emit("update:modelValue", n), this.emit("input", n), this.setCurrent(n);
  }
}
S(Fp, "props", {
  // @doc props/horizontal the orientation of the component
  // @doc/fr props/horizontal l'orientation du composant
  horizontal: Boolean,
  // @doc props/scrollable displays an horizontal scroll on the timeline pills if it does not fit in its container
  // @doc/fr props/scrollable affiche un scroll horizontal au niveau de la timeline si elle dépasse de son conteneur.
  scrollable: Boolean,
  // @doc props/modelValue the model value
  // @doc/fr props/modelValue le modelValue
  modelValue: {
    type: [String, Number],
    default: void 0
  },
  // @doc props/loader displays a loader on the timeline
  // @doc/fr props/loader affiche un loader sur la timeline
  loader: {
    type: [String, Boolean],
    default: void 0
  }
});
const xP = /* @__PURE__ */ K({
  __name: "OrionTimeline",
  props: Fp.props,
  emits: ["input", "pill-click", "update:modelValue"],
  setup(e, {
    expose: l,
    emit: n
  }) {
    const t = n, u = Bs(), i = e, s = new Fp(i, u, t);
    De("_timeline", s.publicInstance), l(s.publicInstance);
    const r = () => {
      const o = {
        value: s.props.modelValue,
        panes: s.panes,
        current: s.current,
        scrollable: s.props.scrollable,
        onPillClick: s.onPillClick.bind(s)
      }, a = R(By, o, null), d = {
        ref: s._loader,
        message: typeof s.props.loader == "string" ? s.props.loader : void 0,
        visible: tt(s.props.loader),
        size: "sm"
      }, h = R("div", {
        class: "orion-timeline__content"
      }, [u.default ? u.default() : null, R(te, d, null)]);
      return R("div", {
        class: {
          "orion-timeline": !0,
          "orion-timeline--horizontal": s.props.horizontal,
          "orion-timeline--vertical": !s.props.horizontal
        }
      }, [[a, h]]);
    };
    return (o, a) => (y(), L(r));
  }
}), bc = {
  install(e, l = "o") {
    e.component(`${tl(l)}Timeline`, xP);
  }
};
class Hp extends gl {
  constructor(n, t) {
    super(n);
    S(this, "state", fl({
      hasBeenActive: !1
    }));
    this._timeline = t, Pl(() => this.active, (u) => {
      u ? this.state.hasBeenActive = u : this.props.lazy && (this.state.hasBeenActive = u);
    });
  }
  get shouldBeInDom() {
    return this.props.lazy || this.props.lazyOnce ? this.state.hasBeenActive : !0;
  }
  get active() {
    var n;
    return ((n = this._timeline) == null ? void 0 : n.getCurrent()) === this.props.name;
  }
  get publicInstance() {
    return {
      ...super.publicInstance,
      disabled: this.props.disabled,
      name: this.props.name
    };
  }
  onMounted() {
    var n;
    this.state.hasBeenActive = ((n = this._timeline) == null ? void 0 : n.getCurrent()) === this.props.name;
  }
}
S(Hp, "props", {
  ..._l.icon(),
  // @doc props/disabled disables the pane
  // @doc/fr props/disabled désactive le panneau
  disabled: Boolean,
  // @doc props/lazy the content of the pane is only loaded when the tab is active
  // @doc/fr props/lazy le contenu du panneau est seulement chargé quand il est actif
  lazy: Boolean,
  // @doc props/lazyOnce the content of the pane is only loading once, the first time the pane is active
  // @doc/fr props/lazyOnce le contenu du panneau est seulement chargé une fois, la première fois que le panneau est actif
  lazyOnce: Boolean,
  // @doc props/complete adds a complete style and defines the pill as clickable
  // @doc/fr props/complete ajoute le style `complete` et permet de cliquer sur la vignette
  complete: {
    type: Boolean,
    default: void 0
  },
  // @doc props/name the name of the pane
  // @doc/fr props/name nom du panneau
  name: {
    type: [String, Number],
    required: !0
  },
  // @doc props/pill the content displayed on the pill
  // @doc/fr props/pill contenu affiché sur la vignette
  pill: {
    type: String,
    default: void 0
  },
  // @doc props/marker adds  visual marker which can be used as a notification marker
  // @doc/fr props/marker ajoute un marqueur visuel, qui peut être utilisé comme marqueur de notification
  marker: {
    type: [Boolean, Number],
    default: void 0
  },
  // @doc props/markerColor color of the marker
  // @doc/fr props/markerColor couleur du marqueur
  markerColor: {
    type: String,
    default: "danger"
  }
});
const EP = {
  key: 0,
  class: "orion-timeline-pane"
}, IP = {
  name: "OrionTimelinePane"
}, RP = /* @__PURE__ */ K({
  ...IP,
  props: Hp.props,
  setup(e, {
    expose: l
  }) {
    const n = Tn("_timeline"), t = e, u = new Hp(t, n);
    return l(u.publicInstance), (i, s) => c(u).shouldBeInDom ? vl((y(), O("div", EP, [V(i.$slots, "default")], 512)), [[cn, c(u).active]]) : I("", !0);
  }
}), wc = {
  install(e, l = "o") {
    e.component(`${tl(l)}TimelinePane`, RP);
  }
};
class zp extends Gl {
  constructor(n, t) {
    super(n, t);
    S(this, "inputType", "toggle");
    S(this, "state", fl({
      ...this.sharedState,
      margin: 2
    }));
  }
  get width() {
    switch (this.props.size) {
      case "xs":
        return 30;
      case "sm":
        return 37;
      case "md":
        return 45;
      case "lg":
        return 52;
      case "xl":
        return 60;
      default:
        return 45;
    }
  }
  get height() {
    return Math.round(this.width / 1.75);
  }
  get buttonRadius() {
    return this.height - this.state.margin * 2;
  }
  get distance() {
    return this.px(this.width - this.height + this.state.margin);
  }
  get isValidCustom() {
    if (this.props.required)
      return !!this.props.modelValue;
  }
  get coreStyle() {
    return {
      width: this.px(this.width),
      height: this.px(this.height),
      borderRadius: this.px(this.height)
    };
  }
  get buttonStyle() {
    const n = this.px(this.state.margin), t = this.vModel ? this.translate3d(this.distance, n) : this.translate3d(n, n);
    return {
      width: this.px(this.buttonRadius),
      height: this.px(this.buttonRadius),
      transform: t
    };
  }
  px(n) {
    return `calc(${n}rem / 16)`;
  }
  translate3d(n, t, u = "0") {
    return `translate3d(${n}, ${t}, ${u})`;
  }
  handleClick() {
    !this.props.disabled && !this.props.readonly && (this.state.hasBeenFocus = !0, this.vModel = !this.vModel);
  }
}
S(zp, "props", {
  ...Gl.props,
  ..._l.color(),
  // @doc props/inline set the property `display` on `inline-flex` instead of `flex`
  // @doc/fr props/inline défini la propriété `display` à `inline-flex` à la place `flex`
  inline: Boolean,
  // @doc props/reverse displays the label first
  // @doc/fr props/reverse affiche d'abord le label
  reverse: Boolean,
  // @doc props/value value of the toggle
  // @doc/fr props/value valeur du toggle
  value: Boolean,
  // @doc props/type type of the input
  // @doc/fr props/type type du champ
  type: {
    type: String,
    default: "toggle"
  }
});
const DP = ["checked"], NP = /* @__PURE__ */ K({
  __name: "OrionToggle",
  props: zp.props,
  emits: ["focus", "blur", "input", "change", "update:modelValue", "clear"],
  setup(e, {
    expose: l,
    emit: n
  }) {
    const t = n, u = e, i = new zp(u, t);
    return l(i.publicInstance), (s, r) => (y(), L(c(Dt), ml(c(i).orionFieldBinding, {
      "label-is-floating": !1,
      class: [`orion-toggle--${c(i).props.color}`, `orion-toggle--${c(i).props.size}`, {
        "orion-toggle--checked": c(i).vModel
      }, {
        "orion-toggle--reverse": c(i).props.reverse
      }, {
        "orion-toggle--inline": c(i).props.inline
      }],
      "input-type": "toggle",
      onClick: r[1] || (r[1] = (o) => c(i).handleClick())
    }), {
      default: U(() => [s.label === void 0 ? V(s.$slots, "default", {
        key: 0
      }) : I("", !0), vl(A("input", ml({
        ref: c(i)._input,
        "onUpdate:modelValue": r[0] || (r[0] = (o) => c(i).vModel = o),
        class: "orion-toggle__input",
        type: "checkbox",
        checked: c(i).vModel
      }, {
        ...s.$attrs,
        disabled: c(i).props.disabled
      }), null, 16, DP), [[u5, c(i).vModel]]), A("div", {
        class: "orion-toggle__core",
        style: Wl(c(i).coreStyle)
      }, [A("div", {
        class: "orion-toggle__core-button",
        style: Wl(c(i).buttonStyle)
      }, null, 4)], 4)]),
      _: 3
    }, 16, ["class"]));
  }
}), _c = {
  install(e, l = "o") {
    e.component(`${tl(l)}Toggle`, NP);
  }
};
class Vp extends gl {
  constructor(n, t) {
    super(n);
    S(this, "state", fl({
      steps: [],
      tourStep: [],
      currentIndex: -1,
      currentStepPublicInstance: void 0
    }));
    this.slots = t, Pl(() => this.content, () => this.calcStepInstances());
  }
  get content() {
    var n, t;
    return (t = (n = this.slots).default) == null ? void 0 : t.call(n);
  }
  get steps() {
    return this.state.steps;
  }
  get currentIndex() {
    return this.state.currentIndex;
  }
  get publicInstance() {
    return {
      ...super.publicInstance,
      steps: this.state.steps,
      getCurrentIndex: () => this.state.currentIndex,
      setCurrent: this.setCurrent.bind(this),
      setCurrentStepPublicInstance: this.setCurrentStepPublicInstance.bind(this),
      start: (n = 0) => this.start(n),
      stop: () => this.stop()
    };
  }
  onMounted() {
    this.calcStepInstances();
  }
  onUpdated() {
    this.calcStepInstances();
  }
  setCurrent(n) {
    this.state.currentIndex = n;
  }
  setCurrentStepPublicInstance(n) {
    this.state.currentStepPublicInstance = n;
  }
  calcStepInstances() {
    if (this.state.steps.length = 0, this.slots.default) {
      const n = this.slots.default().map((t) => typeof t.type == "symbol" && Il(t.children) ? t.children : t).flat().filter((t) => {
        if (!t)
          return !1;
        let u = t.type;
        return u = u.name || u, u === "OrionTourStep";
      });
      this.state.steps.push(...n.map((t) => ({
        props: t.props
      })));
    }
  }
  start(n = 0) {
    var t;
    this.setCurrent(n), (t = this.document) == null || t.documentElement.classList.add("ovf-h");
  }
  stop() {
    var n, t;
    this.props.callback && this.props.callback(), (n = this.state.currentStepPublicInstance) == null || n.stop(!0), (t = this.document) == null || t.documentElement.classList.remove("ovf-h"), this.setCurrent(-1);
  }
}
S(Vp, "props", {
  // @doc props/value current step index of the tour
  // @doc/fr props/value index courant du tour
  value: {
    type: Number,
    default: void 0
  },
  // @doc props/callback function executed when the tour is stopped
  // @doc/fr props/callback fonction exécutée quand le tour est arrêté
  callback: {
    type: Function,
    default: void 0
  }
});
const LP = /* @__PURE__ */ K({
  __name: "OrionTour",
  props: Vp.props,
  setup(e, {
    expose: l
  }) {
    const n = Bs(), t = e, u = new Vp(t, n);
    De("_tour", u.publicInstance), l(u.publicInstance);
    const i = () => {
      if (Number.isFinite(u.currentIndex) && u.currentIndex !== -1 && n.default) {
        const s = n.default().filter((o) => !!o.props), r = R("div", {
          class: "orion-tour__steps",
          key: u.getUid()
        }, [s.length ? s[u.currentIndex] : null]);
        return R("div", {
          class: "orion-tour"
        }, [R(Bl("orion-overlay"), {
          ref: "overlay",
          class: "orion-tour-overlay"
        }, null), r]);
      } else
        return R("div", {
          class: "orion-tour"
        }, null);
    };
    return (s, r) => (y(), L(i));
  }
}), Sc = {
  install(e, l = "o") {
    e.component(`${tl(l)}Tour`, LP);
  }
};
class jp extends gl {
  constructor(n, t) {
    super(n);
    S(this, "state", fl({
      bodyOverflowStyle: [],
      globalEscEvent: void 0
    }));
    S(this, "_el", J());
    S(this, "_stepHighlighter", J());
    S(this, "_stepTarget", J());
    S(this, "windowResizeHandler", Be(async () => {
      await this.getTarget(), this.calculateHighlighterPosition(), this.calculateTooltipPosition(), this.calculateOverlayPosition();
    }, 17));
    S(this, "overlayPanes", fl({
      top: null,
      bottom: null,
      left: null,
      right: null,
      global: null
    }));
    this._tour = t, Pl(() => this.currentIndex, async () => {
      this.currentIndex === -1 && await this.stop();
    }), Pl(() => n.target, () => {
      this.showTooltip();
    }), xi(() => {
      var u, i;
      (u = this._tour) == null || u.setCurrentStepPublicInstance(this.publicInstance), this.showTooltip(), (i = this.window) == null || i.addEventListener("resize", this.debouncedWindowResizeHandler.bind(this)), this.state.globalEscEvent = nn("keydown", (s) => {
        s.key === "Escape" && this.stop();
      }), this._stepTarget.value && this._el.value && (this.cleanup = b5(this._stepTarget.value, this._el.value, this.calculateTooltipPosition.bind(this)));
    }), Ao(() => {
      var u, i, s;
      (u = this.window) == null || u.removeEventListener("resize", this.debouncedWindowResizeHandler.bind(this)), (i = this._stepTarget.value) == null || i.removeEventListener("click", this.clickableTargetHandler.bind(this)), (s = this.cleanup) == null || s.call(this), this.state.globalEscEvent && nn(this.state.globalEscEvent);
    });
  }
  get steps() {
    var n;
    return (n = this._tour) == null ? void 0 : n.steps;
  }
  get publicInstance() {
    return {
      ...super.publicInstance,
      previous: () => this.goPreviousStep(),
      next: () => this.goNextStep(),
      stop: (n = !1) => this.stop(n)
    };
  }
  get currentIndex() {
    var n;
    return (n = this._tour) == null ? void 0 : n.getCurrentIndex();
  }
  get nextButtonLabel() {
    var n, t;
    return (n = this.props.next) != null && n.label ? (t = this.props.next) == null ? void 0 : t.label : this.lang.NEXT;
  }
  get previousButtonLabel() {
    var n, t;
    return (n = this.props.previous) != null && n.label ? (t = this.props.previous) == null ? void 0 : t.label : this.lang.PREVIOUS;
  }
  get endButtonLabel() {
    var n, t;
    return (n = this.props.end) != null && n.label ? (t = this.props.end) == null ? void 0 : t.label : this.lang.FINISH;
  }
  async getTarget() {
    let n;
    typeof this.props.target == "string" ? n = await this.waitFor(this.props.target) : typeof this.props.target == "function" && (n = await this.props.target()), this._stepTarget.value = n, this._stepTarget.value && !this.props.clickable && (this._stepTarget.value.style.pointerEvents = "none");
  }
  async clickableTargetHandler() {
    this.props.clickable && (typeof this.props.clickable == "function" && await this.props.clickable(), stop());
  }
  debouncedWindowResizeHandler() {
    this._stepTarget.value && this.windowResizeHandler();
  }
  async showTooltip() {
    var n;
    try {
      this.cleanPreviousStep(), this.props.target ? (await this.getTarget(), this._stepTarget.value ? ((n = this._stepTarget.value) == null || n.addEventListener("click", this.clickableTargetHandler.bind(this)), await this.calculateTooltipPosition(), this.addOverlay(), this.addHighlighter()) : this.showTimeoutModal()) : this.calculateTooltipPosition();
    } catch {
      this.showTimeoutModal();
    }
  }
  async calculateTooltipPosition() {
    if (this.props.target) {
      if (await this.getTarget(), this._stepTarget.value && this._el.value && this.window) {
        const n = this._stepTarget.value.getBoundingClientRect();
        (n.bottom > this.window.innerHeight - 60 || n.top < 50) && await this.scrollToTarget(this._stepTarget.value);
        const t = document.querySelector("#orion-tour-tooltip__arrow");
        if (!this._stepTarget.value || !this._el.value)
          return;
        const {
          x: u,
          y: i,
          middlewareData: s,
          placement: r
        } = await d2(this._stepTarget.value, this._el.value, {
          strategy: "fixed",
          middleware: [Qg(), l2({
            mainAxis: 10
          }), n2({
            padding: 16
          }), Xg({
            element: t,
            padding: 10
          })]
        }), o = r.split("-")[0], a = {
          top: "bottom",
          right: "left",
          bottom: "top",
          left: "right"
        }[o];
        if (this._el.value && (Object.assign(this._el.value.style, {
          left: `${u}px`,
          top: `${i}px`,
          opacity: "1"
        }), s.arrow && a && t)) {
          const {
            x: d,
            y: h
          } = s.arrow;
          Object.assign(t.style, {
            left: d != null ? `${d}px` : "",
            top: h != null ? `${h}px` : "",
            [a]: "-5px",
            display: "unset",
            transform: "rotate(45deg)"
          });
        }
      }
    } else
      rl(() => {
        var u;
        if (!this.window)
          return;
        const n = document.querySelector("#orion-tour-tooltip__arrow"), t = (u = this._el.value) == null ? void 0 : u.getBoundingClientRect();
        t && this._el.value && (Object.assign(this._el.value.style, {
          left: `${this.window.innerWidth / 2 - (t == null ? void 0 : t.width) / 2}px`,
          top: `${this.window.innerHeight / 2 - t.height / 2}px`,
          opacity: "1"
        }), Object.assign(n.style, {
          left: "0",
          top: "0",
          display: "none"
        }));
      });
  }
  addHighlighter() {
    this.document && (this._stepHighlighter.value = this.document.createElement("div"), this._stepHighlighter.value.classList.add("orion-tour-step-highlighter"), this.calculateHighlighterPosition(), this.document.body.appendChild(this._stepHighlighter.value));
  }
  removeHighlighter() {
    var n;
    if (this.document) {
      if (this._stepHighlighter.value) {
        this.document.body.removeChild(this._stepHighlighter.value);
        const t = this.document.body.getElementsByClassName("orion-tour-step-highlighter");
        for (; t[0]; )
          (n = t[0].parentNode) == null || n.removeChild(t[0]);
      }
      this._stepHighlighter.value = null;
    }
  }
  calculateHighlighterPosition() {
    var t;
    const n = (t = this._stepTarget.value) == null ? void 0 : t.getBoundingClientRect();
    this.window && n && this._stepHighlighter.value && (this._stepHighlighter.value.style.left = `${n.left - 4}px`, this._stepHighlighter.value.style.top = `${n.top + this.window.scrollY - 4}px`, this._stepHighlighter.value.style.width = `${n.width + 8}px`, this._stepHighlighter.value.style.height = `${n.height + 8}px`);
  }
  scrollToTarget(n) {
    if (n)
      return new Promise((t) => {
        if (!this.window)
          return;
        const u = this.getScrollableParent(n);
        if (!n || !u) {
          t(!0);
          return;
        }
        const i = {
          y: this.window.scrollY === 0 ? 0 : this.window.innerHeight + this.window.scrollY
        }, s = (n == null ? void 0 : n.getBoundingClientRect().bottom) > 50 ? (n == null ? void 0 : n.getBoundingClientRect().top) - 50 + this.window.scrollY : 0;
        El({
          targets: i,
          y: s,
          translateY: s,
          duration: 600,
          easing: "easeOutQuad",
          update: () => {
            n.scrollIntoView({
              block: "center"
            });
          },
          complete: () => {
            t(n.getBoundingClientRect()), this.calculateOverlayPosition();
          }
        });
      });
  }
  getScrollableParent(n) {
    return n == null ? null : n.scrollHeight > n.clientHeight ? n : n.parentNode ? this.getScrollableParent(n.parentNode) : null;
  }
  async goPreviousStep() {
    var n, t, u, i, s, r;
    this.cleanPreviousStep(), typeof ((n = this.props.previous) == null ? void 0 : n.callback) < "u" && await ((t = this.props.previous) == null ? void 0 : t.callback()), this.currentIndex && this.currentIndex > 0 && ((u = this._tour) == null || u.setCurrent(this.currentIndex - 1)), (i = this._tour) == null || i.setCurrentStepPublicInstance(this.publicInstance), typeof ((s = this.props.previous) == null ? void 0 : s.clean) < "u" && ((r = this.props.previous) == null || r.clean());
  }
  async goNextStep() {
    var n, t, u, i, s, r, o;
    this.cleanPreviousStep(), typeof ((n = this.props.next) == null ? void 0 : n.callback) < "u" && await ((t = this.props.next) == null ? void 0 : t.callback()), this.currentIndex !== -1 && this.currentIndex !== void 0 && this.steps && this.currentIndex < ((u = this.steps) == null ? void 0 : u.length) - 1 && ((i = this._tour) == null || i.setCurrent(this.currentIndex + 1), (s = this._tour) == null || s.setCurrentStepPublicInstance(this.publicInstance)), typeof ((r = this.props.next) == null ? void 0 : r.clean) < "u" && ((o = this.props.next) == null || o.clean());
  }
  cleanPreviousStep() {
    this.addOverlay(!0), this._stepTarget.value && (this.props.clickable || (this._stepTarget.value.style.pointerEvents = "auto"), this._stepTarget.value = null), this.removeHighlighter();
  }
  waitFor(n) {
    return new Promise((t, u) => {
      var s;
      let i = ((s = this.document) == null ? void 0 : s.getElementById(n)) ?? null;
      if (i)
        t(i);
      else {
        const r = setTimeout(() => {
          vr().hide(), u("Element not found"), clearInterval(o);
        }, this.props.timeout), o = setInterval(() => {
          var a;
          vr().show(this.lang.LOADING), i = ((a = this.document) == null ? void 0 : a.getElementById(n)) ?? null, i && (vr().hide(), clearInterval(o), clearTimeout(r), t(i));
        }, 50);
      }
    });
  }
  async showTimeoutModal() {
    const n = await tC(this.lang.ORION_TOUR__ELEMENT_NOT_FOUND_MESSAGE, {
      overlay: !1,
      zIndex: 99999,
      title: "Oops...",
      events: {
        queueHandled: async () => {
          n ? this.showTooltip() : await this.stop();
        }
      }
    });
  }
  async stop(n = !1) {
    var t, u, i;
    this.cleanPreviousStep(), this.removeOverlay(), typeof ((t = this.props.end) == null ? void 0 : t.callback) < "u" && !n && await ((u = this.props.end) == null ? void 0 : u.callback()), n || (i = this._tour) == null || i.stop();
  }
  addOverlay(n = !1) {
    n ? (this.removeOverlay(), this.removeHighlighter(), this.addOverlayPane("global"), this.overlayPanes.global && (this.overlayPanes.global.style.inset = "0")) : this._stepTarget.value && (this.removeOverlay("global"), ["top", "bottom", "right", "left"].forEach((t) => this.addOverlayPane(t)), this.calculateOverlayPosition());
  }
  removeOverlay(n = null) {
    var t;
    this.document && (n ? ((t = this.overlayPanes[n]) == null || t.remove(), this.overlayPanes[n] = null) : Array.from(this.document.getElementsByClassName("orion-tour-overlay")).forEach((u) => {
      u.remove(), this.overlayPanes[u.id] = null;
    }));
  }
  addOverlayPane(n) {
    if (!this.document)
      return;
    const t = this.document.createElement("div");
    t.id = n, t.className = "orion-tour-overlay", this.document.body.appendChild(t), this.overlayPanes[n] = t;
  }
  calculateOverlayPosition() {
    var t, u;
    const n = (u = (t = this._stepTarget) == null ? void 0 : t.value) == null ? void 0 : u.getBoundingClientRect();
    n && [{
      target: "top",
      coord: {
        left: Math.floor(n.left - 2) + "px",
        top: "0",
        height: Math.floor(n.top - 2) + "px",
        width: Math.ceil(n.width + 4) + "px"
      }
    }, {
      target: "bottom",
      coord: {
        left: Math.floor(n.left - 2) + "px",
        top: Math.floor(n.bottom + 2) + "px",
        bottom: "0",
        width: Math.ceil(n.width + 4) + "px"
      }
    }, {
      target: "right",
      coord: {
        left: Math.ceil(n.width + Math.floor(n.left) + 2) + "px",
        top: "0",
        bottom: "0",
        right: "0"
      }
    }, {
      target: "left",
      coord: {
        left: "0",
        top: "0",
        bottom: "0",
        width: Math.floor(n.left) - 2 + "px"
      }
    }].forEach((s) => {
      const r = this.overlayPanes[s.target];
      r && Object.assign(r.style, s.coord);
    });
  }
}
S(jp, "props", {
  // @doc props/title title of the step
  // @doc/fr props/title titre de l'étape
  title: {
    type: String,
    default: void 0
  },
  // eslint-disable-next-line max-len
  // @doc props/target possibility to target a DOM element. If it is a `string`, it must represent an `id` in the DOM. If `false`, no target will be selected
  // eslint-disable-next-line max-len
  // @doc/fr props/target Permet de cibler un élément dans le DOM. S'il s'agit d'une string, elle doit correspondre à l'id de cet élément. Si elle est définie à `false` l'étape se placera au centre de la page, sans cible.
  target: {
    type: [String, Function, Boolean],
    default: !1
  },
  // @doc props/next object which contains a label, and a callback and clean functions for the next step
  // @doc/fr props/next objet contenant un label, et des fonction `callback` et `clean` pour l'étape suivante
  next: {
    type: Object,
    default: void 0
  },
  // // @doc props/end object which contains a label, and a callback and clean functions for the final step
  // @doc/fr props/end objet contenant un label, et des fonction `callback` et `clean` pour l'étape finale
  end: {
    type: Object,
    default: void 0
  },
  // @doc props/previous object which contains a label, and a callback and clean functions for the previous step
  // @doc/fr props/previous objet contenant un label, et des fonction `callback` et `clean` pour l'étape précédente
  previous: {
    type: Object,
    default: void 0
  },
  // @doc props/timeout when a target can not be find in DOM, a modal appears after a certain time defined with this attribut
  // @doc/fr props/timeout quand la cible n'est pas trouvée dans le DOM, une modal appararaît après le temps spécifié
  timeout: {
    type: Number,
    default: 3e3
  },
  // @doc props/clickable if there is a target, it allows the user to click on the target (if the target is a button for example). It also ends the tour.
  // @doc/fr props/clickable s'il y a une cible, permet de clicker sur la cible  (si c'est un bouton par exemple). Cela met aussi fin au tour.
  clickable: {
    type: [Boolean, Function],
    default: void 0
  },
  // @doc props/closable defines if the step can be closable
  // @doc/fr props/closable définit si l'étape peut être fermée à l'aide de la croix
  closable: {
    type: Boolean,
    default: !0
  },
  // @doc props/hideFinish hides the Finish button
  // @doc/fr props/hideFinish masque le bouton pour terminer le tour
  hideFinish: {
    type: Boolean,
    default: !1
  },
  // @doc props/size the size of the step
  // @doc/fr props/size taille de l'étape
  size: {
    type: String,
    default: "md"
  }
});
const PP = /* @__PURE__ */ A("div", {
  id: "orion-tour-tooltip__arrow",
  class: "orion-tour-tooltip__arrow"
}, null, -1), BP = {
  class: "orion-tour-tooltip__title"
}, FP = {
  key: 0,
  class: "orion-tour-tooltip__counter"
}, HP = {
  class: "orion-tour-tooltip__actions"
}, zP = {
  name: "OrionTourStep"
}, VP = /* @__PURE__ */ K({
  ...zP,
  props: jp.props,
  setup(e, {
    expose: l
  }) {
    const n = Tn("_tour"), t = e, u = new jp(t, n);
    return l(u.publicInstance), (i, s) => {
      var r;
      return c(n) ? (y(), O("div", {
        key: 0,
        id: "tour-tooltip",
        ref: c(u)._el,
        class: z(["orion-tour-tooltip", [`orion-tour-tooltip--${c(u).props.size}`]])
      }, [c(u).props.closable ? (y(), O("span", {
        key: 0,
        class: "orion-tour-tooltip__close",
        onClick: s[0] || (s[0] = (o) => c(u).stop())
      })) : I("", !0), PP, A("div", BP, B(c(u).props.title), 1), A("div", {
        class: z(["orion-tour-tooltip__body", [`orion-tour-tooltip__body--${c(u).props.size}`]])
      }, [V(i.$slots, "default")], 2), A("div", {
        class: z(["orion-tour-tooltip__footer", [`orion-tour-tooltip__footer--${c(u).props.size}`]])
      }, [(r = c(u).steps) != null && r.length && c(u).currentIndex !== -1 && c(u).currentIndex !== void 0 ? (y(), O("div", FP, B(c(u).currentIndex + 1) + " / " + B(c(n).steps.length), 1)) : I("", !0), A("div", HP, [V(i.$slots, "actions", {
        next: c(u).goNextStep.bind(c(u)),
        previous: c(u).goPreviousStep.bind(c(u))
      }, () => [c(u).currentIndex !== void 0 && c(u).currentIndex > 0 ? (y(), L(c(bl), {
        key: 0,
        id: "previousButton",
        outline: "",
        size: "xs",
        onClick: s[1] || (s[1] = (o) => c(u).goPreviousStep())
      }, {
        default: U(() => [$l(B(c(u).previousButtonLabel), 1)]),
        _: 1
      })) : I("", !0), c(u).steps && c(u).currentIndex !== c(u).steps.length - 1 ? (y(), L(c(bl), {
        key: 1,
        id: "nextButton",
        color: "brand",
        size: "xs",
        onClick: s[2] || (s[2] = (o) => c(u).goNextStep())
      }, {
        default: U(() => [$l(B(c(u).nextButtonLabel), 1)]),
        _: 1
      })) : I("", !0)]), c(u).props.hideFinish ? I("", !0) : (y(), L(c(bl), {
        key: 0,
        id: "endButton",
        color: "info",
        size: "xs",
        onClick: s[3] || (s[3] = (o) => c(u).stop())
      }, {
        default: U(() => [$l(B(c(u).endButtonLabel), 1)]),
        _: 1
      }))])], 2)], 2)) : I("", !0);
    };
  }
}), Cc = {
  install(e, l = "o") {
    e.component(`${tl(l)}TourStep`, VP);
  }
};
class Up extends Gl {
  constructor(n, t) {
    super(n, t);
    S(this, "_input", J());
    S(this, "_bubble", J());
    S(this, "_illustration", J());
    S(this, "_filePreview", J([]));
    S(this, "uid", this.getUid());
    S(this, "imgFileType", ["image/jpeg", "image/png"]);
    S(this, "state", fl({
      ...this.sharedState,
      isDraggingOver: !1,
      dragCounter: 0
    }));
  }
  get isDraggingOver() {
    return this.state.isDraggingOver;
  }
  get label() {
    return (this.props.label ?? this.lang.ORION_UPLOAD__LABEL).replace("$fileMaxSize", this.props.fileMaxSize.toString()).replace("$format", this.props.fileTypes.map((n) => {
      var t;
      return (t = n.split("/")[1]) == null ? void 0 : t.toUpperCase();
    }).join(", "));
  }
  onBeforeUpdate() {
    this._filePreview.value.length = 0;
  }
  onMounted() {
    var n, t;
    this.vModel.forEach((u, i) => this.getFilePreview(u, i)), (n = this.window) == null || n.addEventListener("dragover", this.preventDrop.bind(this), !1), (t = this.window) == null || t.addEventListener("drop", this.preventDrop.bind(this), !1);
  }
  onUnmounted() {
    var n, t;
    (n = this.window) == null || n.removeEventListener("dragover", this.preventDrop.bind(this), !1), (t = this.window) == null || t.removeEventListener("drop", this.preventDrop.bind(this), !1);
  }
  fileIsValid(n) {
    return n.size / 1e6 > this.props.fileMaxSize ? (Dr.danger(this.lang.ERROR, this.lang.ORION_UPLOAD__FILE_TOO_HEAVY.replace("$fileMaxSize", this.props.fileMaxSize.toString())), !1) : n.type && this.props.fileTypes.includes(n.type) ? !0 : (Dr.danger(this.lang.ERROR, this.lang.ORION_UPLOAD__INVALID_FILE_TYPE), !1);
  }
  emitInput() {
    !this.props.multiple && this.vModel.length > 1 && this.vModel.splice(1, this.vModel.length), this.vModel.forEach((n, t) => this.getFilePreview(n, t)), this.emit("input", this.vModel);
  }
  preventDrop(n) {
    n.preventDefault();
  }
  getFilePreview(n, t) {
    if (!this.props.showPreview)
      return;
    const u = this._illustration.value ? 600 : 0;
    rl(() => {
      setTimeout(() => {
        if (this.imgFileType.includes(n.type)) {
          const i = new FileReader();
          i.addEventListener("load", () => {
            var r;
            const s = (r = this._filePreview.value[t]) == null ? void 0 : r.firstChild;
            s && (s.style.backgroundImage = `url(${i.result})`);
          }, !1), i.readAsDataURL(n);
        }
      }, u);
    });
  }
  clear() {
    this.vModel.length = 0, this.emit("input", []), this.emit("change", []), this.emit("clear");
  }
  setFilePreviewRef(n) {
    n && this._filePreview.value.push(n);
  }
  handleDragEnter(n) {
    n.preventDefault(), this.state.dragCounter++, this.state.isDraggingOver = !0;
  }
  handleDragLeave(n) {
    n.preventDefault(), this.state.dragCounter--, this.state.dragCounter === 0 && (this.state.isDraggingOver = !1);
  }
  handleDragOver(n) {
    var t, u;
    El({
      targets: this._bubble.value,
      scale: 1,
      translateX: n.x - ((t = n.target) == null ? void 0 : t.getBoundingClientRect().x),
      translateY: n.y - ((u = n.target) == null ? void 0 : u.getBoundingClientRect().y),
      easing: "easeOutSine",
      duration: 100
    });
  }
  handleChange() {
    var n, t;
    if (this.vModel.length = 0, (t = (n = this._input.value) == null ? void 0 : n.files) != null && t.length) {
      for (const u of this._input.value.files)
        this.fileIsValid(u) && this.vModel.push(u);
      this.emitInput();
    }
  }
  clickInput() {
    var n;
    (n = this._input.value) == null || n.click();
  }
  deleteFile(n) {
    this._filePreview.value.length = 0, this._input.value && (this._input.value.value = ""), this.vModel.splice(n, 1), this.emitInput();
  }
  handleDrop(n) {
    var t, u, i;
    if (this.props.multiple || (this.vModel.length = 0), n.preventDefault(), (t = n.dataTransfer) != null && t.items) {
      for (let s = 0; s < (this.props.multiple ? n.dataTransfer.items.length : 1); s++)
        if (n.dataTransfer.items[s].kind === "file") {
          const r = n.dataTransfer.items[s].getAsFile();
          r && this.fileIsValid(r) && this.vModel.push(r);
        }
    } else if ((i = (u = n.dataTransfer) == null ? void 0 : u.files) != null && i.length)
      for (let s = 0; s < (this.props.multiple ? n.dataTransfer.files.length : 1); s++)
        this.fileIsValid(n.dataTransfer.files[s]) && this.vModel.push(n.dataTransfer.files[s]);
    this.emitInput(), this.state.dragCounter = 0, this.state.isDraggingOver = !1;
  }
  animIllustration() {
    var n;
    !this._illustration.value || !this.document || El({
      targets: (n = this.document.getElementById(`file-${this.uid}`)) == null ? void 0 : n.getElementsByTagName("rect"),
      opacity: [0, 1],
      scale: [0, 1],
      duration: 400,
      easing: "easeOutQuad",
      delay: El.stagger(40)
    });
  }
}
S(Up, "props", {
  ...Gl.props,
  ..._l.vModel(() => []),
  // @doc props/multiple allows multiple files upload.
  // @doc/fr props/multiple permet le chargement de plusieurs fichiers.
  multiple: Boolean,
  // @doc props/showPreview shows a preview of the selected file
  // @doc/fr props/showPreview montre un apperçu du fichier chargé
  showPreview: {
    type: Boolean,
    default: !0
  },
  // @doc props/fileType defines the allowed types
  // @doc/fr props/fileType définit les types de fichiers autorisés
  fileTypes: {
    type: Array,
    default: () => ["image/jpeg", "image/png", "image/gif", "application/pdf"]
  },
  // @doc props/fileMaxSize the maximal size of the uploaded file (Mo)
  // @doc/fr props/fileMaxSize taille maximale d'un fichier (Mo)
  fileMaxSize: {
    type: Number,
    default: 4
  }
});
const jP = ["multiple", "accept"], UP = {
  class: "orion-upload__content"
}, WP = {
  class: "orion-upload__label"
}, GP = {
  class: "orion-upload__or"
}, KP = {
  class: "orion-upload__drag-over-indicator"
}, YP = {
  key: "filledFiles",
  class: "orion-upload__files-list"
}, qP = {
  key: 0,
  class: "orion-upload__files-list-item-preview"
}, JP = {
  key: 0,
  viewBox: "0 0 80 80",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}, ZP = /* @__PURE__ */ A("defs", null, [/* @__PURE__ */ A("linearGradient", {
  id: "linearGradient-1",
  x1: "27.21875%",
  y1: "0%",
  x2: "72.78125%",
  y2: "100%"
}, [/* @__PURE__ */ A("stop", {
  "stop-color": "#F883A8",
  offset: "0%"
}), /* @__PURE__ */ A("stop", {
  "stop-color": "#FA1E4A",
  offset: "100%"
})])], -1), XP = /* @__PURE__ */ A("g", {
  stroke: "none",
  "stroke-width": "1",
  fill: "none",
  "fill-rule": "evenodd"
}, [/* @__PURE__ */ A("rect", {
  stroke: "#717A8E",
  "stroke-width": "1",
  fill: "url(#linearGradient-1)",
  x: "14",
  y: "1",
  width: "52",
  height: "78",
  rx: "4"
}), /* @__PURE__ */ A("text", {
  "font-family": "SourceSansPro-Bold, Source Sans Pro",
  "font-size": "22",
  "font-weight": "bold",
  "line-spacing": "30",
  fill: "#FFFFFF"
}, [/* @__PURE__ */ A("tspan", {
  x: "20.695",
  y: "65"
}, "PDF")]), /* @__PURE__ */ A("g", {
  transform: "translate(24.000000, 5.000000)",
  stroke: "#FFFFFF",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5"
}, [/* @__PURE__ */ A("path", {
  id: "pdfPreviewPath",
  d: `M7.52752442,11.4211418 C5.94709274,8.87248676 9.72824303,6.52939779 10.716245,9.14354286 C12.4081054,
										13.6314314 15.1288251,25.7725617 8.99095586,34.0243098 C7.27866678,36.3237387 3.58480238,34.1461941 5.57194914,
										31.7503492 C11.3309605,25.095831 19.8088343,21.2883115 28.7157089,21.3556207 C31.8134293,21.4702283 31.6537147,
										25.7798384 28.8828521,25.4487497 C19.9165488,24.3008544 12.0162475,19.1107668 7.52752442,11.4211418 Z`
})])], -1), QP = [ZP, XP], lB = {
  class: "orion-upload__files-list-item-infos"
}, nB = {
  class: "orion-upload__files-list-item-name"
}, eB = /* @__PURE__ */ A("br", null, null, -1), tB = {
  class: "orion-upload__files-list-item-type"
}, uB = /* @__PURE__ */ A("br", null, null, -1), iB = {
  class: "orion-upload__files-list-item-size"
}, sB = {
  key: 2,
  class: "orion-upload__pending"
}, rB = /* @__PURE__ */ K({
  __name: "OrionUpload",
  props: Up.props,
  emits: ["focus", "blur", "input", "change", "update:modelValue", "clear"],
  setup(e, {
    expose: l,
    emit: n
  }) {
    const t = n, u = e, i = new Up(u, t);
    return l(i.publicInstance), (s, r) => (y(), O("div", {
      class: z(["orion-upload", {
        "orion-upload--drag-over": c(i).isDraggingOver
      }]),
      onMouseenter: r[2] || (r[2] = kl((o) => c(i).animIllustration(), ["prevent"])),
      onDragenter: r[3] || (r[3] = kl((o) => c(i).handleDragEnter(o), ["prevent"])),
      onDragleave: r[4] || (r[4] = kl((o) => c(i).handleDragLeave(o), ["prevent"])),
      onDragover: r[5] || (r[5] = kl((o) => c(i).handleDragOver(o), ["prevent"])),
      onDrop: r[6] || (r[6] = (o) => c(i).handleDrop(o))
    }, [A("input", {
      ref: c(i)._input,
      class: "orion-upload__input",
      type: "file",
      multiple: s.multiple,
      accept: s.fileTypes.join(","),
      onChange: r[0] || (r[0] = (o) => c(i).handleChange())
    }, null, 40, jP), R(Gg, {
      name: "scale",
      mode: "out-in"
    }, {
      default: U(() => {
        var o;
        return [(o = c(i).vModel) != null && o.length ? c(i).vModel.length ? (y(), O("div", YP, [(y(!0), O(hl, null, Sl(c(i).vModel, (a, d) => (y(), O("div", {
          key: d,
          ref_for: !0,
          ref: (h) => c(i).setFilePreviewRef(h),
          class: "orion-upload__files-list-item"
        }, [s.showPreview ? (y(), O("div", qP, [c(i).vModel.length === 1 && c(i).vModel[0].type === "application/pdf" ? (y(), O("svg", JP, QP)) : I("", !0)])) : I("", !0), A("div", lB, [A("span", nB, B(a.name), 1), eB, A("span", tB, B(a.type), 1), uB, A("span", iB, B(Math.floor(a.size / 1e3)) + " Ko", 1)]), R(c(Ml), {
          ripple: "danger",
          icon: "trash_full",
          class: "orion-upload__delete-file",
          onClick: (h) => c(i).deleteFile(d)
        }, null, 8, ["onClick"])]))), 128))])) : (y(), O("div", sB, [R(c(te), {
          visible: "",
          size: "sm",
          message: c(i).lang.ORION_UPLOAD__PROCESSING
        }, null, 8, ["message"])])) : (y(), O("div", {
          ref: c(i)._illustration,
          key: "emptyFiles",
          class: "orion-upload__wrapper"
        }, [A("div", UP, [A("div", WP, [V(s.$slots, "default", {}, () => [$l(B(c(i).label), 1)])]), A("div", GP, B(c(i).lang.OR), 1), A("div", KP, [R(c(Ml), {
          icon: "cloud_upload"
        })]), R(c(bl), {
          class: "orion-upload__button",
          color: "info",
          outline: "",
          onClick: r[1] || (r[1] = (a) => c(i).clickInput())
        }, {
          default: U(() => [$l(B(c(i).lang.ORION_UPLOAD__BUTTON), 1)]),
          _: 1
        })])], 512))];
      }),
      _: 3
    }), A("div", {
      ref: c(i)._bubble,
      class: "orion-upload__bubble"
    }, null, 512)], 34));
  }
}), Tc = {
  install(e, l = "o") {
    e.component(`${tl(l)}Upload`, rB);
  }
}, Oc = {
  install(e, l) {
    var n, t, u, i, s, r, o, a, d, h, p, f, m, g, v, w, $, _, b, k, T, M, H, x, P, Z, F, el, al, ll, Y, Q, dl, zl, Xl, sn, Jl, rn, vn, en, kn, re, Mn, oe, yn, ae, $t, Ve, bt, je, de, ke, Ue, wt, Pn, Gn, le, Kn, Me, We, Ge, Ke, Ye, C, N, D;
    (n = Ra.install) == null || n.call(Ra, e, l), (t = Da.install) == null || t.call(Da, e, l), (u = Na.install) == null || u.call(Na, e, l), (i = La.install) == null || i.call(La, e, l), (s = Pa.install) == null || s.call(Pa, e, l), (r = Ba.install) == null || r.call(Ba, e, l), (o = Fa.install) == null || o.call(Fa, e, l), (a = Ka.install) == null || a.call(Ka, e, l), (d = Ya.install) == null || d.call(Ya, e, l), (h = Ga.install) == null || h.call(Ga, e, l), (p = qa.install) == null || p.call(qa, e, l), (f = Ja.install) == null || f.call(Ja, e, l), (m = Za.install) == null || m.call(Za, e, l), (g = sd.install) == null || g.call(sd, e, l), (v = rd.install) == null || v.call(rd, e, l), (w = ad.install) == null || w.call(ad, e, l), ($ = od.install) == null || $.call(od, e, l), (_ = dd.install) == null || _.call(dd, e, l), (b = hd.install) == null || b.call(hd, e, l), (k = pd.install) == null || k.call(pd, e, l), (T = fd.install) == null || T.call(fd, e, l), (M = Gd.install) == null || M.call(Gd, e, l), (H = Ha.install) == null || H.call(Ha, e, l), (x = Kd.install) == null || x.call(Kd, e, l), (P = Yd.install) == null || P.call(Yd, e, l), (Z = Ea.install) == null || Z.call(Ea, e, l), (F = qd.install) == null || F.call(qd, e, l), (el = Ua.install) == null || el.call(Ua, e, l), (al = Xa.install) == null || al.call(Xa, e, l), (ll = cd.install) == null || ll.call(cd, e, l), (Y = nc.install) == null || Y.call(nc, e, l), (Q = tc.install) == null || Q.call(tc, e, l), (dl = Ia.install) == null || dl.call(Ia, e, l), (zl = Va.install) == null || zl.call(Va, e, l), (Xl = Qd.install) == null || Xl.call(Qd, e, l), (sn = Zd.install) == null || sn.call(Zd, e, l), (Jl = Jd.install) == null || Jl.call(Jd, e, l), (rn = lc.install) == null || rn.call(lc, e, l), (vn = Xd.install) == null || vn.call(Xd, e, l), (en = ja.install) == null || en.call(ja, e, l), (kn = uc.install) == null || kn.call(uc, e, l), (re = Aa.install) == null || re.call(Aa, e, l), (Mn = ic.install) == null || Mn.call(ic, e, l), (oe = ec.install) == null || oe.call(ec, e, l), (yn = sc.install) == null || yn.call(sc, e, l), (ae = oc.install) == null || ae.call(oc, e, l), ($t = ac.install) == null || $t.call(ac, e, l), (Ve = dc.install) == null || Ve.call(dc, e, l), (bt = cc.install) == null || bt.call(cc, e, l), (je = hc.install) == null || je.call(hc, e, l), (de = pc.install) == null || de.call(pc, e, l), (ke = za.install) == null || ke.call(za, e, l), (Ue = rc.install) == null || Ue.call(rc, e, l), (wt = fc.install) == null || wt.call(fc, e, l), (Pn = mc.install) == null || Pn.call(mc, e, l), (Gn = gc.install) == null || Gn.call(gc, e, l), (le = vc.install) == null || le.call(vc, e, l), (Kn = yc.install) == null || Kn.call(yc, e, l), (Me = Wa.install) == null || Me.call(Wa, e, l), (We = bc.install) == null || We.call(bc, e, l), (Ge = wc.install) == null || Ge.call(wc, e, l), (Ke = $c.install) == null || Ke.call($c, e, l), (Ye = _c.install) == null || Ye.call(_c, e, l), (C = Sc.install) == null || C.call(Sc, e, l), (N = Cc.install) == null || N.call(Cc, e, l), (D = Tc.install) == null || D.call(Tc, e, l);
  }
};
class oB {
  get app() {
    return this._app;
  }
  get appContext() {
    return this._app._context;
  }
  get appInstance() {
    return this._app._instance;
  }
  get appLang() {
    return jt();
  }
  get appConfig() {
    return this.config;
  }
  get appUse() {
    return this.config.use;
  }
  get appPrefix() {
    return this.config.prefix;
  }
  get appRouter() {
    return this.config.router;
  }
  get popableAnimationHooks() {
    return this.config.popableAnimationHooks ?? {};
  }
  init(l, n) {
    if (Dn.orion("•• START •• Orion initializer"), Dn.orion(`prefix | ${n.prefix}`), Dn.orion(`use    | ${n.use}`), !l)
      throw 'Parameter "app" is missing in Orion initializer';
    this._app = l, this.config = n, A6(n.lang), this.preventVuePrefixWarning(), this.appUse.includes("components") && (this._app.use(n6, {
      themes: {
        orion: {
          $extend: "dropdown",
          arrowPadding: 15
        },
        "orion-select": {
          $extend: "orion"
        },
        "orion-select-searchable": {
          $extend: "orion"
        },
        "orion-pop-confirm": {
          $extend: "orion"
        },
        "orion-editor-toolbar": {
          $extend: "orion",
          placement: "top",
          disposeTimeout: 100,
          handleResize: !1
        }
      }
    }), this.createPopableWrapper(), this.createMainOverlay(), this.createMainLoader(), this.registerGlobalComponents()), Lw(), Dw(), Dn.orion("••  END  •• Orion initializer");
  }
  preventVuePrefixWarning() {
    this._app.config.warnHandler = (l) => {
      l.includes("reserved prefixes");
    };
  }
  registerGlobalComponents() {
    var l;
    if (!this.appPrefix)
      throw 'key "prefix" is missing in config';
    (l = Oc.install) == null || l.call(Oc, this._app, this.appPrefix);
  }
  createPopableWrapper() {
    var n, t;
    const l = (n = Ul()) == null ? void 0 : n.createElement("div");
    l && (l.id = "orion-popable-wrapper", (t = Ul()) == null || t.body.appendChild(l));
  }
  createMainOverlay() {
    var n, t;
    const l = (n = Ul()) == null ? void 0 : n.createElement("div");
    if (l) {
      const u = R(O3, {
        global: !0
      });
      u.appContext = this.appContext, fi(u, l), (t = Ul()) == null || t.body.appendChild(u.el);
    }
  }
  createMainLoader() {
    var n, t;
    const l = (n = Ul()) == null ? void 0 : n.createElement("div");
    if (l) {
      const u = R(te, {
        global: !0,
        size: "lg"
      });
      u.appContext = this.appContext, fi(u, l), (t = Ul()) == null || t.body.appendChild(u.el);
    }
  }
}
const aB = new oB(), Fl = aB, AB = ["add_column", "add_minus_square", "add_plus_circle", "add_plus_square", "add_plus", "add_row", "add_to_queue", "airplay", "alarm", "archive", "arrow_circle_down_left", "arrow_circle_down_right", "arrow_circle_down", "arrow_circle_left", "arrow_circle_right", "arrow_circle_up_left", "arrow_circle_up_right", "arrow_circle_up", "arrow_down_left_lg", "arrow_down_left_md", "arrow_down_left_sm", "arrow_down_lg", "arrow_down_md", "arrow_down_right_lg", "arrow_down_right_md", "arrow_down_right_sm", "arrow_down_sm", "arrow_down_up", "arrow_left_lg", "arrow_left_md", "arrow_left_right", "arrow_left_sm", "arrow_reload_02", "arrow_right_lg", "arrow_right_md", "arrow_right_sm", "arrow_sub_down_left", "arrow_sub_down_right", "arrow_sub_left_down", "arrow_sub_left_up", "arrow_sub_right_down", "arrow_sub_right_up", "arrow_sub_up_left", "arrow_sub_up_right", "arrow_undo_down_left", "arrow_undo_down_right", "arrow_undo_up_left", "arrow_undo_up_right", "arrow_up_left_lg", "arrow_up_left_md", "arrow_up_left_sm", "arrow_up_lg", "arrow_up_md", "arrow_up_right_lg", "arrow_up_right_md", "arrow_up_right_sm", "arrow_up_sm", "arrows_reload_01", "bar_bottom", "bar_left", "bar_right", "bar_top", "bell_add", "bell_close", "bell_notification", "bell_off", "bell_remove", "bell_ring", "bell", "bold", "book_open", "book", "bookmark", "building_01", "building_02", "building_03", "building_04", "bulb", "calendar_add", "calendar_check", "calendar_close", "calendar_days", "calendar_event", "calendar_remove", "calendar_week", "calendar", "camera", "car_auto", "caret_circle_down", "caret_circle_left", "caret_circle_right", "caret_circle_up", "caret_down_md", "caret_down_sm", "caret_left_sm", "caret_right_sm", "caret_up_md", "caret_up_sm", "chart_bar_horizontal_01", "chart_bar_vertical_01", "chart_line", "chart_pie", "chat_add", "chat_check", "chat_circle_add", "chat_circle_check", "chat_circle_close", "chat_circle_dots", "chat_circle_remove", "chat_circle", "chat_close", "chat_conversation_circle", "chat_conversation", "chat_dots", "chat_remove", "chat", "check_all_big", "check_all", "check_big", "check", "checkbox_check", "checkbox_fill", "checkbox_unchecked", "chevron_down_duo", "chevron_down", "chevron_left_duo", "chevron_left_md", "chevron_left", "chevron_right_duo", "chevron_right_md", "chevron_right", "chevron_up_duo", "chevron_up", "chromecast", "circle_check", "circle_help", "circle_warning", "circle", "clock", "close_circle", "close_lg", "close_md", "close_sm", "close_square", "cloud_add", "cloud_check", "cloud_close", "cloud_download", "cloud_off", "cloud_remove", "cloud_upload", "cloud", "code", "coffe_to_go", "coffee", "columns", "combine_cells", "command", "compass", "cookie", "copy", "credit_card_01", "credit_card_02", "crop", "cupcake", "cylinder", "data", "delete_column", "delete_row", "desktop_tower", "desktop", "devices", "double_quotes_l", "double_quotes_r", "download_package", "download", "drag_horizontal", "drag_vertical", "dummy_circle_small", "dummy_circle", "dummy_square_small", "dummy_square", "edit_pencil_01", "edit_pencil_02", "edit_pencil_line_01", "edit_pencil_line_02", "exit", "expand", "external_link", "figma", "file_add", "file_blank", "file_check", "file_close", "file_code", "file_document", "file_download", "file_edit", "file_remove", "file_search", "file_upload", "files", "filter_off", "filter", "first_aid", "flag", "folder_add", "folder_check", "folder_close", "folder_code", "folder_document", "folder_download", "folder_edit", "folder_open", "folder_remove", "folder_search", "folder_upload", "folder", "folders", "font", "forward", "gift", "globe", "hamburger_lg", "hamburger_md", "handbag", "heading_h1", "heading_h2", "heading_h3", "heading_h4", "heading_h5", "heading_h6", "heading", "headphones", "heart_01", "heart_02", "help", "hide", "house_01", "house_02", "house_03", "house_add", "house_check", "house_close", "house_remove", "image_01", "image_02", "info", "instance", "italic", "keyboard", "label", "laptop", "layer", "layers", "leaf", "line_l", "line_m", "line_s", "line_xl", "link_break", "link_horizontal_off", "link_horizontal", "link_vertical", "link", "list_add", "list_check", "list_checklist", "list_ordered", "list_remove", "list_unordered", "loading", "lock_open", "lock", "log_out", "magnifying_glass_minus", "magnifying_glass_plus", "mail_open", "mail", "main_component", "map_pin", "map", "mention", "menu_alt_01", "menu_alt_02", "menu_alt_03", "menu_alt_04", "menu_alt_05", "menu_duo_lg", "menu_duo_md", "mobile_button", "mobile", "monitor_play", "monitor", "moon", "more_grid_big", "more_grid_small", "more_horizontal", "more_vertical", "mouse", "move_horizontal", "move_vertical", "move", "moving_desk", "navigation", "note_edit", "note_search", "note", "notebook", "octagon_check", "octagon_help", "octagon_warning", "octagon", "option", "paper_plane", "paperclip_attechment_horizontal", "paperclip_attechment_tilt", "paragraph", "path", "pause_circle", "pause", "phone", "planet", "play_circle", "play", "printer", "puzzle", "qr_code", "radio_fill", "radio_unchecked", "rainbow", "redo", "remove_minus_circle", "remove_minus", "rewind", "rows", "ruler", "save", "search_magnifying_glass", "select_multiple", "settings_future", "settings", "share_android", "share_ios_export", "shield_check", "shield_warning", "shield", "shopping_bag_01", "shopping_bag_02", "shopping_cart_01", "shopping_cart_02", "show", "shrink", "shuffle", "single_quotes_l", "single_quotes_r", "skip_back", "skip_forward", "slider_01", "slider_02", "slider_03", "sort_ascending", "sort_descending", "square_check", "square_help", "square_warning", "square", "star", "stop_circle", "stop_sign", "stop", "strikethrough", "suitcase", "sun", "swatches_palette", "swicht_left", "swicht_right", "table_add", "table_remove", "table", "tablet_button", "tablet", "tag", "terminal", "text_align_center", "text_align_justify", "text_align_left", "text_align_right", "text", "ticket_voucher", "timer_add", "timer_close", "timer_remove", "timer", "trash_empty", "trash_full", "trending_down", "trending_up", "triangle_check", "triangle_warning", "triangle", "underline", "undo", "unfold_less", "unfold_more", "user_01", "user_02", "user_03", "user_add", "user_card_id", "user_check", "user_circle", "user_close", "user_remove", "user_square", "user_voice", "users_group", "users", "volume_max", "volume_min", "volume_minus", "volume_off_02", "volume_off", "volume_plus", "warning", "water_drop", "wavy_check", "wavy_help", "wavy_warning", "wavy", "wifi_high", "wifi_low", "wifi_medium", "wifi_none", "wifi_off", "wifi_problem", "window_check", "window_close", "window_code_block", "window_sidebar", "window_terminal", "window"], xB = ["xl", "lg", "md", "sm", "xs"], EB = ["default", "brand", "success", "info", "warning", "danger", "pink", "inverse"], IB = ["brand-alt", "success-alt", "info-alt", "warning-alt", "danger-alt", "pink-alt"], RB = ["default", "brand", "success", "info", "warning", "danger", "pink", "inverse", "brand-alt", "success-alt", "info-alt", "warning-alt", "danger-alt", "pink-alt"], DB = ["grey-darker", "grey-dark", "grey", "grey-light", "grey-lighter"], NB = ["default", "brand", "success", "info", "warning", "danger", "pink", "inverse", "brand-alt", "success-alt", "info-alt", "warning-alt", "danger-alt", "pink-alt", "grey-darker", "grey-dark", "grey", "grey-light", "grey-lighter"], dB = {
  install(e, l) {
    Fl.init(e, {
      prefix: "o",
      use: ["components", "monkeyPatching"],
      lang: typeof navigator < "u" ? navigator.language.split("-")[0] : "en",
      ...l
    }), Fl.appUse.includes("monkeyPatching") && LS(), xw(e, Fl);
  }
}, LB = dB;
export {
  ul as $,
  Dw as A,
  T3 as B,
  $B as C,
  bB as D,
  wB as E,
  S3 as F,
  nn as G,
  _B as H,
  C3 as I,
  Nw as J,
  Lw as K,
  Dn as L,
  xB as M,
  EB as N,
  dB as O,
  IB as P,
  RB as Q,
  DB as R,
  NB as S,
  CB as T,
  TB as U,
  Hn as V,
  tC as W,
  Fi as X,
  Ul as Y,
  Cf as Z,
  Di as _,
  iv as a,
  vr as a0,
  zc as a1,
  tv as a2,
  X as a3,
  OB as a4,
  Dr as a5,
  Xu as a6,
  Ae as a7,
  an as a8,
  Zs as a9,
  b3 as aa,
  kB as ab,
  Xw as ac,
  Ut as ad,
  qn as ae,
  M6 as af,
  zL as b,
  Bk as c,
  Ly as d,
  QL as e,
  rB as f,
  LB as g,
  AB as h,
  jt as i,
  ft as j,
  fB as k,
  SB as l,
  Ma as m,
  mB as n,
  Fl as o,
  Bi as p,
  tt as q,
  pB as r,
  A6 as s,
  gB as t,
  vB as u,
  Iw as v,
  w3 as w,
  _3 as x,
  Rw as y,
  yB as z
};
